webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(620)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(979),
  /* scopeId */
  "data-v-19e4fb42",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isShowProductLineModel */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return focusEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return baseurl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return url; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return urlAssets; });
/* unused harmony export projpath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return wUrl; });

var tms_devlope = false;
var useSSL = !tms_devlope;
var defaultLang = 'zh_cn';
var isShowProductLineModel = true;

if (true) {}

var service_path = "/tms-server-web";
var service_openpl_path = "/open_api";

var Host = "http://10.255.33.140";
var ter_port = "8787";

var port_app = "8686";
var port_openpl = "9090";

var basePrefix = Host + ":" + ter_port;
var basePrefix_sub = Host + ":";
var bannerFileUrl = "";


if (!tms_devlope) {
  Host = (useSSL ? "https://" : "http://") + "tmsadmin.szzt.com.cn";
  ter_port = useSSL ? "7443" : "8686";
  port_app = ter_port;
  port_openpl = useSSL ? "9090" : "9090";
  basePrefix = Host + ":" + ter_port;
  basePrefix_sub = Host + ":";
  bannerFileUrl = Host + "/file-management" + service_path;
}

var focusEvent = function focusEvent(fn) {
  if (fn) fn();
};
var baseurl = basePrefix + service_path;
var url = basePrefix;

var distributedDeployment = false;

var urlAssets = {
  prefix: distributedDeployment ? 'http://172.16.7.49:22124/' : basePrefix + '/',
  apkUrl: distributedDeployment ? 'http://172.16.7.49:22125/appFile/fileupload' : basePrefix + '/tms-server-web/appFile/fileupload.do',
  fileUrl: distributedDeployment ? 'http://172.16.7.49:22125/file/fileupload' : basePrefix + '/tms-server-web/file/fileupload.do',
  xmlFileUrl: distributedDeployment ? 'http://172.16.7.49:22125/file/xmlUpload.do' : basePrefix + '/tms-server-web/file/xmlUpload.do',
  picUrl: distributedDeployment ? 'http://172.16.7.49:22125/upload/upload' : basePrefix + '/tms-server-web/upload/upload.do',
  picUrls: distributedDeployment ? 'http://172.16.7.49:22125/upload/upload' : 'https://tmsadmin.szzt.com.cn/file-management/tms-server-web/upload/upload.do',
  webUrl: distributedDeployment ? 'http://172.16.10.21:3314' : basePrefix,
  videoUrl: distributedDeployment ? 'http://172.16.10.21:3314' : basePrefix
};

var projpath = '';
if (!localStorage.setlang) {
  localStorage.system_lang = defaultLang;
}

var wUrl = {
  host: basePrefix_sub,
  port: ter_port,
  port_app: port_app,
  port_openpl: port_openpl,
  path: service_path,
  path_openpl: service_openpl_path,
  bannerFileUrl: bannerFileUrl
};

/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(659)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(1025),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/df.3a1978a.png";

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(627)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(397),
  /* template */
  __webpack_require__(986),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(603)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(957),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var city = [{
    "value": "110000",
    "label": "北京市",
    "children": [{
        "province": "北京市",
        "label": "北京市",
        "value": "110100"
    }] }, {
    "value": "120000",
    "label": "天津市",
    "children": [{
        "province": "天津市",
        "label": "天津市",
        "value": "120100"
    }] }, {
    "value": "130000",
    "label": "河北省",
    "children": [{
        "province": "河北省",
        "label": "石家庄市",
        "value": "130100"
    }, {
        "province": "河北省",
        "label": "唐山市",
        "value": "130200"
    }, {
        "province": "河北省",
        "label": "秦皇岛市",
        "value": "130300"
    }, {
        "province": "河北省",
        "label": "邯郸市",
        "value": "130400"
    }, {
        "province": "河北省",
        "label": "邢台市",
        "value": "130500"
    }, {
        "province": "河北省",
        "label": "保定市",
        "value": "130600"
    }, {
        "province": "河北省",
        "label": "张家口市",
        "value": "130700"
    }, {
        "province": "河北省",
        "label": "承德市",
        "value": "130800"
    }, {
        "province": "河北省",
        "label": "沧州市",
        "value": "130900"
    }, {
        "province": "河北省",
        "label": "廊坊市",
        "value": "131000"
    }, {
        "province": "河北省",
        "label": "衡水市",
        "value": "131100"
    }, {
        "province": "河北省",
        "label": "省直辖县级行政区划",
        "value": "139000"
    }] }, {
    "value": "140000",
    "label": "山西省",
    "children": [{
        "province": "山西省",
        "label": "太原市",
        "value": "140100"
    }, {
        "province": "山西省",
        "label": "大同市",
        "value": "140200"
    }, {
        "province": "山西省",
        "label": "阳泉市",
        "value": "140300"
    }, {
        "province": "山西省",
        "label": "长治市",
        "value": "140400"
    }, {
        "province": "山西省",
        "label": "晋城市",
        "value": "140500"
    }, {
        "province": "山西省",
        "label": "朔州市",
        "value": "140600"
    }, {
        "province": "山西省",
        "label": "晋中市",
        "value": "140700"
    }, {
        "province": "山西省",
        "label": "运城市",
        "value": "140800"
    }, {
        "province": "山西省",
        "label": "忻州市",
        "value": "140900"
    }, {
        "province": "山西省",
        "label": "临汾市",
        "value": "141000"
    }, {
        "province": "山西省",
        "label": "吕梁市",
        "value": "141100"
    }] }, {
    "value": "150000",
    "label": "内蒙古自治区",
    "children": [{
        "province": "内蒙古自治区",
        "label": "呼和浩特市",
        "value": "150100"
    }, {
        "province": "内蒙古自治区",
        "label": "包头市",
        "value": "150200"
    }, {
        "province": "内蒙古自治区",
        "label": "乌海市",
        "value": "150300"
    }, {
        "province": "内蒙古自治区",
        "label": "赤峰市",
        "value": "150400"
    }, {
        "province": "内蒙古自治区",
        "label": "通辽市",
        "value": "150500"
    }, {
        "province": "内蒙古自治区",
        "label": "鄂尔多斯市",
        "value": "150600"
    }, {
        "province": "内蒙古自治区",
        "label": "呼伦贝尔市",
        "value": "150700"
    }, {
        "province": "内蒙古自治区",
        "label": "巴彦淖尔市",
        "value": "150800"
    }, {
        "province": "内蒙古自治区",
        "label": "乌兰察布市",
        "value": "150900"
    }, {
        "province": "内蒙古自治区",
        "label": "兴安盟",
        "value": "152200"
    }, {
        "province": "内蒙古自治区",
        "label": "锡林郭勒盟",
        "value": "152500"
    }, {
        "province": "内蒙古自治区",
        "label": "阿拉善盟",
        "value": "152900"
    }] }, {
    "value": "210000",
    "label": "辽宁省",
    "children": [{
        "province": "辽宁省",
        "label": "沈阳市",
        "value": "210100"
    }, {
        "province": "辽宁省",
        "label": "大连市",
        "value": "210200"
    }, {
        "province": "辽宁省",
        "label": "鞍山市",
        "value": "210300"
    }, {
        "province": "辽宁省",
        "label": "抚顺市",
        "value": "210400"
    }, {
        "province": "辽宁省",
        "label": "本溪市",
        "value": "210500"
    }, {
        "province": "辽宁省",
        "label": "丹东市",
        "value": "210600"
    }, {
        "province": "辽宁省",
        "label": "锦州市",
        "value": "210700"
    }, {
        "province": "辽宁省",
        "label": "营口市",
        "value": "210800"
    }, {
        "province": "辽宁省",
        "label": "阜新市",
        "value": "210900"
    }, {
        "province": "辽宁省",
        "label": "辽阳市",
        "value": "211000"
    }, {
        "province": "辽宁省",
        "label": "盘锦市",
        "value": "211100"
    }, {
        "province": "辽宁省",
        "label": "铁岭市",
        "value": "211200"
    }, {
        "province": "辽宁省",
        "label": "朝阳市",
        "value": "211300"
    }, {
        "province": "辽宁省",
        "label": "葫芦岛市",
        "value": "211400"
    }] }, {
    "value": "220000",
    "label": "吉林省",
    "children": [{
        "province": "吉林省",
        "label": "长春市",
        "value": "220100"
    }, {
        "province": "吉林省",
        "label": "吉林市",
        "value": "220200"
    }, {
        "province": "吉林省",
        "label": "四平市",
        "value": "220300"
    }, {
        "province": "吉林省",
        "label": "辽源市",
        "value": "220400"
    }, {
        "province": "吉林省",
        "label": "通化市",
        "value": "220500"
    }, {
        "province": "吉林省",
        "label": "白山市",
        "value": "220600"
    }, {
        "province": "吉林省",
        "label": "松原市",
        "value": "220700"
    }, {
        "province": "吉林省",
        "label": "白城市",
        "value": "220800"
    }, {
        "province": "吉林省",
        "label": "延边朝鲜族自治州",
        "value": "222400"
    }] }, {
    "value": "230000",
    "label": "黑龙江省",
    "children": [{
        "province": "黑龙江省",
        "label": "哈尔滨市",
        "value": "230100"
    }, {
        "province": "黑龙江省",
        "label": "齐齐哈尔市",
        "value": "230200"
    }, {
        "province": "黑龙江省",
        "label": "鸡西市",
        "value": "230300"
    }, {
        "province": "黑龙江省",
        "label": "鹤岗市",
        "value": "230400"
    }, {
        "province": "黑龙江省",
        "label": "双鸭山市",
        "value": "230500"
    }, {
        "province": "黑龙江省",
        "label": "大庆市",
        "value": "230600"
    }, {
        "province": "黑龙江省",
        "label": "伊春市",
        "value": "230700"
    }, {
        "province": "黑龙江省",
        "label": "佳木斯市",
        "value": "230800"
    }, {
        "province": "黑龙江省",
        "label": "七台河市",
        "value": "230900"
    }, {
        "province": "黑龙江省",
        "label": "牡丹江市",
        "value": "231000"
    }, {
        "province": "黑龙江省",
        "label": "黑河市",
        "value": "231100"
    }, {
        "province": "黑龙江省",
        "label": "绥化市",
        "value": "231200"
    }, {
        "province": "黑龙江省",
        "label": "大兴安岭地区",
        "value": "232700"
    }] }, {
    "value": "310000",
    "label": "上海市",
    "children": [{
        "province": "上海市",
        "label": "上海市",
        "value": "310100"
    }] }, {
    "value": "320000",
    "label": "江苏省",
    "children": [{
        "province": "江苏省",
        "label": "南京市",
        "value": "320100"
    }, {
        "province": "江苏省",
        "label": "无锡市",
        "value": "320200"
    }, {
        "province": "江苏省",
        "label": "徐州市",
        "value": "320300"
    }, {
        "province": "江苏省",
        "label": "常州市",
        "value": "320400"
    }, {
        "province": "江苏省",
        "label": "苏州市",
        "value": "320500"
    }, {
        "province": "江苏省",
        "label": "南通市",
        "value": "320600"
    }, {
        "province": "江苏省",
        "label": "连云港市",
        "value": "320700"
    }, {
        "province": "江苏省",
        "label": "淮安市",
        "value": "320800"
    }, {
        "province": "江苏省",
        "label": "盐城市",
        "value": "320900"
    }, {
        "province": "江苏省",
        "label": "扬州市",
        "value": "321000"
    }, {
        "province": "江苏省",
        "label": "镇江市",
        "value": "321100"
    }, {
        "province": "江苏省",
        "label": "泰州市",
        "value": "321200"
    }, {
        "province": "江苏省",
        "label": "宿迁市",
        "value": "321300"
    }] }, {
    "value": "330000",
    "label": "浙江省",
    "children": [{
        "province": "浙江省",
        "label": "杭州市",
        "value": "330100"
    }, {
        "province": "浙江省",
        "label": "宁波市",
        "value": "330200"
    }, {
        "province": "浙江省",
        "label": "温州市",
        "value": "330300"
    }, {
        "province": "浙江省",
        "label": "嘉兴市",
        "value": "330400"
    }, {
        "province": "浙江省",
        "label": "湖州市",
        "value": "330500"
    }, {
        "province": "浙江省",
        "label": "绍兴市",
        "value": "330600"
    }, {
        "province": "浙江省",
        "label": "金华市",
        "value": "330700"
    }, {
        "province": "浙江省",
        "label": "衢州市",
        "value": "330800"
    }, {
        "province": "浙江省",
        "label": "舟山市",
        "value": "330900"
    }, {
        "province": "浙江省",
        "label": "台州市",
        "value": "331000"
    }, {
        "province": "浙江省",
        "label": "丽水市",
        "value": "331100"
    }] }, {
    "value": "340000",
    "label": "安徽省",
    "children": [{
        "province": "安徽省",
        "label": "合肥市",
        "value": "340100"
    }, {
        "province": "安徽省",
        "label": "芜湖市",
        "value": "340200"
    }, {
        "province": "安徽省",
        "label": "蚌埠市",
        "value": "340300"
    }, {
        "province": "安徽省",
        "label": "淮南市",
        "value": "340400"
    }, {
        "province": "安徽省",
        "label": "马鞍山市",
        "value": "340500"
    }, {
        "province": "安徽省",
        "label": "淮北市",
        "value": "340600"
    }, {
        "province": "安徽省",
        "label": "铜陵市",
        "value": "340700"
    }, {
        "province": "安徽省",
        "label": "安庆市",
        "value": "340800"
    }, {
        "province": "安徽省",
        "label": "黄山市",
        "value": "341000"
    }, {
        "province": "安徽省",
        "label": "滁州市",
        "value": "341100"
    }, {
        "province": "安徽省",
        "label": "阜阳市",
        "value": "341200"
    }, {
        "province": "安徽省",
        "label": "宿州市",
        "value": "341300"
    }, {
        "province": "安徽省",
        "label": "六安市",
        "value": "341500"
    }, {
        "province": "安徽省",
        "label": "亳州市",
        "value": "341600"
    }, {
        "province": "安徽省",
        "label": "池州市",
        "value": "341700"
    }, {
        "province": "安徽省",
        "label": "宣城市",
        "value": "341800"
    }] }, {
    "value": "350000",
    "label": "福建省",
    "children": [{
        "province": "福建省",
        "label": "福州市",
        "value": "350100"
    }, {
        "province": "福建省",
        "label": "厦门市",
        "value": "350200"
    }, {
        "province": "福建省",
        "label": "莆田市",
        "value": "350300"
    }, {
        "province": "福建省",
        "label": "三明市",
        "value": "350400"
    }, {
        "province": "福建省",
        "label": "泉州市",
        "value": "350500"
    }, {
        "province": "福建省",
        "label": "漳州市",
        "value": "350600"
    }, {
        "province": "福建省",
        "label": "南平市",
        "value": "350700"
    }, {
        "province": "福建省",
        "label": "龙岩市",
        "value": "350800"
    }, {
        "province": "福建省",
        "label": "宁德市",
        "value": "350900"
    }] }, {
    "value": "360000",
    "label": "江西省",
    "children": [{
        "province": "江西省",
        "label": "南昌市",
        "value": "360100"
    }, {
        "province": "江西省",
        "label": "景德镇市",
        "value": "360200"
    }, {
        "province": "江西省",
        "label": "萍乡市",
        "value": "360300"
    }, {
        "province": "江西省",
        "label": "九江市",
        "value": "360400"
    }, {
        "province": "江西省",
        "label": "新余市",
        "value": "360500"
    }, {
        "province": "江西省",
        "label": "鹰潭市",
        "value": "360600"
    }, {
        "province": "江西省",
        "label": "赣州市",
        "value": "360700"
    }, {
        "province": "江西省",
        "label": "吉安市",
        "value": "360800"
    }, {
        "province": "江西省",
        "label": "宜春市",
        "value": "360900"
    }, {
        "province": "江西省",
        "label": "抚州市",
        "value": "361000"
    }, {
        "province": "江西省",
        "label": "上饶市",
        "value": "361100"
    }] }, {
    "value": "370000",
    "label": "山东省",
    "children": [{
        "province": "山东省",
        "label": "济南市",
        "value": "370100"
    }, {
        "province": "山东省",
        "label": "青岛市",
        "value": "370200"
    }, {
        "province": "山东省",
        "label": "淄博市",
        "value": "370300"
    }, {
        "province": "山东省",
        "label": "枣庄市",
        "value": "370400"
    }, {
        "province": "山东省",
        "label": "东营市",
        "value": "370500"
    }, {
        "province": "山东省",
        "label": "烟台市",
        "value": "370600"
    }, {
        "province": "山东省",
        "label": "潍坊市",
        "value": "370700"
    }, {
        "province": "山东省",
        "label": "济宁市",
        "value": "370800"
    }, {
        "province": "山东省",
        "label": "泰安市",
        "value": "370900"
    }, {
        "province": "山东省",
        "label": "威海市",
        "value": "371000"
    }, {
        "province": "山东省",
        "label": "日照市",
        "value": "371100"
    }, {
        "province": "山东省",
        "label": "莱芜市",
        "value": "371200"
    }, {
        "province": "山东省",
        "label": "临沂市",
        "value": "371300"
    }, {
        "province": "山东省",
        "label": "德州市",
        "value": "371400"
    }, {
        "province": "山东省",
        "label": "聊城市",
        "value": "371500"
    }, {
        "province": "山东省",
        "label": "滨州市",
        "value": "371600"
    }, {
        "province": "山东省",
        "label": "菏泽市",
        "value": "371700"
    }] }, {
    "value": "410000",
    "label": "河南省",
    "children": [{
        "province": "河南省",
        "label": "郑州市",
        "value": "410100"
    }, {
        "province": "河南省",
        "label": "开封市",
        "value": "410200"
    }, {
        "province": "河南省",
        "label": "洛阳市",
        "value": "410300"
    }, {
        "province": "河南省",
        "label": "平顶山市",
        "value": "410400"
    }, {
        "province": "河南省",
        "label": "安阳市",
        "value": "410500"
    }, {
        "province": "河南省",
        "label": "鹤壁市",
        "value": "410600"
    }, {
        "province": "河南省",
        "label": "新乡市",
        "value": "410700"
    }, {
        "province": "河南省",
        "label": "焦作市",
        "value": "410800"
    }, {
        "province": "河南省",
        "label": "濮阳市",
        "value": "410900"
    }, {
        "province": "河南省",
        "label": "许昌市",
        "value": "411000"
    }, {
        "province": "河南省",
        "label": "漯河市",
        "value": "411100"
    }, {
        "province": "河南省",
        "label": "三门峡市",
        "value": "411200"
    }, {
        "province": "河南省",
        "label": "南阳市",
        "value": "411300"
    }, {
        "province": "河南省",
        "label": "商丘市",
        "value": "411400"
    }, {
        "province": "河南省",
        "label": "信阳市",
        "value": "411500"
    }, {
        "province": "河南省",
        "label": "周口市",
        "value": "411600"
    }, {
        "province": "河南省",
        "label": "驻马店市",
        "value": "411700"
    }, {
        "province": "河南省",
        "label": "省直辖县级行政区划",
        "value": "419000"
    }] }, {
    "value": "420000",
    "label": "湖北省",
    "children": [{
        "province": "湖北省",
        "label": "武汉市",
        "value": "420100"
    }, {
        "province": "湖北省",
        "label": "黄石市",
        "value": "420200"
    }, {
        "province": "湖北省",
        "label": "十堰市",
        "value": "420300"
    }, {
        "province": "湖北省",
        "label": "宜昌市",
        "value": "420500"
    }, {
        "province": "湖北省",
        "label": "襄阳市",
        "value": "420600"
    }, {
        "province": "湖北省",
        "label": "鄂州市",
        "value": "420700"
    }, {
        "province": "湖北省",
        "label": "荆门市",
        "value": "420800"
    }, {
        "province": "湖北省",
        "label": "孝感市",
        "value": "420900"
    }, {
        "province": "湖北省",
        "label": "荆州市",
        "value": "421000"
    }, {
        "province": "湖北省",
        "label": "黄冈市",
        "value": "421100"
    }, {
        "province": "湖北省",
        "label": "咸宁市",
        "value": "421200"
    }, {
        "province": "湖北省",
        "label": "随州市",
        "value": "421300"
    }, {
        "province": "湖北省",
        "label": "恩施土家族苗族自治州",
        "value": "422800"
    }, {
        "province": "湖北省",
        "label": "省直辖县级行政区划",
        "value": "429000"
    }] }, {
    "value": "430000",
    "label": "湖南省",
    "children": [{
        "province": "湖南省",
        "label": "长沙市",
        "value": "430100"
    }, {
        "province": "湖南省",
        "label": "株洲市",
        "value": "430200"
    }, {
        "province": "湖南省",
        "label": "湘潭市",
        "value": "430300"
    }, {
        "province": "湖南省",
        "label": "衡阳市",
        "value": "430400"
    }, {
        "province": "湖南省",
        "label": "邵阳市",
        "value": "430500"
    }, {
        "province": "湖南省",
        "label": "岳阳市",
        "value": "430600"
    }, {
        "province": "湖南省",
        "label": "常德市",
        "value": "430700"
    }, {
        "province": "湖南省",
        "label": "张家界市",
        "value": "430800"
    }, {
        "province": "湖南省",
        "label": "益阳市",
        "value": "430900"
    }, {
        "province": "湖南省",
        "label": "郴州市",
        "value": "431000"
    }, {
        "province": "湖南省",
        "label": "永州市",
        "value": "431100"
    }, {
        "province": "湖南省",
        "label": "怀化市",
        "value": "431200"
    }, {
        "province": "湖南省",
        "label": "娄底市",
        "value": "431300"
    }, {
        "province": "湖南省",
        "label": "湘西土家族苗族自治州",
        "value": "433100"
    }] }, {
    "value": "440000",
    "label": "广东省",
    "children": [{
        "province": "广东省",
        "label": "广州市",
        "value": "440100"
    }, {
        "province": "广东省",
        "label": "韶关市",
        "value": "440200"
    }, {
        "province": "广东省",
        "label": "深圳市",
        "value": "440300"
    }, {
        "province": "广东省",
        "label": "珠海市",
        "value": "440400"
    }, {
        "province": "广东省",
        "label": "汕头市",
        "value": "440500"
    }, {
        "province": "广东省",
        "label": "佛山市",
        "value": "440600"
    }, {
        "province": "广东省",
        "label": "江门市",
        "value": "440700"
    }, {
        "province": "广东省",
        "label": "湛江市",
        "value": "440800"
    }, {
        "province": "广东省",
        "label": "茂名市",
        "value": "440900"
    }, {
        "province": "广东省",
        "label": "肇庆市",
        "value": "441200"
    }, {
        "province": "广东省",
        "label": "惠州市",
        "value": "441300"
    }, {
        "province": "广东省",
        "label": "梅州市",
        "value": "441400"
    }, {
        "province": "广东省",
        "label": "汕尾市",
        "value": "441500"
    }, {
        "province": "广东省",
        "label": "河源市",
        "value": "441600"
    }, {
        "province": "广东省",
        "label": "阳江市",
        "value": "441700"
    }, {
        "province": "广东省",
        "label": "清远市",
        "value": "441800"
    }, {
        "province": "广东省",
        "label": "东莞市",
        "value": "441900"
    }, {
        "province": "广东省",
        "label": "中山市",
        "value": "442000"
    }, {
        "province": "广东省",
        "label": "潮州市",
        "value": "445100"
    }, {
        "province": "广东省",
        "label": "揭阳市",
        "value": "445200"
    }, {
        "province": "广东省",
        "label": "云浮市",
        "value": "445300"
    }] }, {
    "value": "450000",
    "label": "广西壮族自治区",
    "children": [{
        "province": "广西壮族自治区",
        "label": "南宁市",
        "value": "450100"
    }, {
        "province": "广西壮族自治区",
        "label": "柳州市",
        "value": "450200"
    }, {
        "province": "广西壮族自治区",
        "label": "桂林市",
        "value": "450300"
    }, {
        "province": "广西壮族自治区",
        "label": "梧州市",
        "value": "450400"
    }, {
        "province": "广西壮族自治区",
        "label": "北海市",
        "value": "450500"
    }, {
        "province": "广西壮族自治区",
        "label": "防城港市",
        "value": "450600"
    }, {
        "province": "广西壮族自治区",
        "label": "钦州市",
        "value": "450700"
    }, {
        "province": "广西壮族自治区",
        "label": "贵港市",
        "value": "450800"
    }, {
        "province": "广西壮族自治区",
        "label": "玉林市",
        "value": "450900"
    }, {
        "province": "广西壮族自治区",
        "label": "百色市",
        "value": "451000"
    }, {
        "province": "广西壮族自治区",
        "label": "贺州市",
        "value": "451100"
    }, {
        "province": "广西壮族自治区",
        "label": "河池市",
        "value": "451200"
    }, {
        "province": "广西壮族自治区",
        "label": "来宾市",
        "value": "451300"
    }, {
        "province": "广西壮族自治区",
        "label": "崇左市",
        "value": "451400"
    }] }, {
    "value": "460000",
    "label": "海南省",
    "children": [{
        "province": "海南省",
        "label": "海口市",
        "value": "460100"
    }, {
        "province": "海南省",
        "label": "三亚市",
        "value": "460200"
    }, {
        "province": "海南省",
        "label": "三沙市",
        "value": "460300"
    }, {
        "province": "海南省",
        "label": "儋州市",
        "value": "460400"
    }, {
        "province": "海南省",
        "label": "省直辖县级行政区划",
        "value": "469000"
    }] }, {
    "value": "500000",
    "label": "重庆市",
    "children": [{
        "province": "重庆市",
        "label": "重庆市",
        "value": "500100"
    }] }, {
    "value": "510000",
    "label": "四川省",
    "children": [{
        "province": "四川省",
        "label": "成都市",
        "value": "510100"
    }, {
        "province": "四川省",
        "label": "自贡市",
        "value": "510300"
    }, {
        "province": "四川省",
        "label": "攀枝花市",
        "value": "510400"
    }, {
        "province": "四川省",
        "label": "泸州市",
        "value": "510500"
    }, {
        "province": "四川省",
        "label": "德阳市",
        "value": "510600"
    }, {
        "province": "四川省",
        "label": "绵阳市",
        "value": "510700"
    }, {
        "province": "四川省",
        "label": "广元市",
        "value": "510800"
    }, {
        "province": "四川省",
        "label": "遂宁市",
        "value": "510900"
    }, {
        "province": "四川省",
        "label": "内江市",
        "value": "511000"
    }, {
        "province": "四川省",
        "label": "乐山市",
        "value": "511100"
    }, {
        "province": "四川省",
        "label": "南充市",
        "value": "511300"
    }, {
        "province": "四川省",
        "label": "眉山市",
        "value": "511400"
    }, {
        "province": "四川省",
        "label": "宜宾市",
        "value": "511500"
    }, {
        "province": "四川省",
        "label": "广安市",
        "value": "511600"
    }, {
        "province": "四川省",
        "label": "达州市",
        "value": "511700"
    }, {
        "province": "四川省",
        "label": "雅安市",
        "value": "511800"
    }, {
        "province": "四川省",
        "label": "巴中市",
        "value": "511900"
    }, {
        "province": "四川省",
        "label": "资阳市",
        "value": "512000"
    }, {
        "province": "四川省",
        "label": "阿坝藏族羌族自治州",
        "value": "513200"
    }, {
        "province": "四川省",
        "label": "甘孜藏族自治州",
        "value": "513300"
    }, {
        "province": "四川省",
        "label": "凉山彝族自治州",
        "value": "513400"
    }] }, {
    "value": "520000",
    "label": "贵州省",
    "children": [{
        "province": "贵州省",
        "label": "贵阳市",
        "value": "520100"
    }, {
        "province": "贵州省",
        "label": "六盘水市",
        "value": "520200"
    }, {
        "province": "贵州省",
        "label": "遵义市",
        "value": "520300"
    }, {
        "province": "贵州省",
        "label": "安顺市",
        "value": "520400"
    }, {
        "province": "贵州省",
        "label": "毕节市",
        "value": "520500"
    }, {
        "province": "贵州省",
        "label": "铜仁市",
        "value": "520600"
    }, {
        "province": "贵州省",
        "label": "黔西南布依族苗族自治州",
        "value": "522300"
    }, {
        "province": "贵州省",
        "label": "黔东南苗族侗族自治州",
        "value": "522600"
    }, {
        "province": "贵州省",
        "label": "黔南布依族苗族自治州",
        "value": "522700"
    }] }, {
    "value": "530000",
    "label": "云南省",
    "children": [{
        "province": "云南省",
        "label": "昆明市",
        "value": "530100"
    }, {
        "province": "云南省",
        "label": "曲靖市",
        "value": "530300"
    }, {
        "province": "云南省",
        "label": "玉溪市",
        "value": "530400"
    }, {
        "province": "云南省",
        "label": "保山市",
        "value": "530500"
    }, {
        "province": "云南省",
        "label": "昭通市",
        "value": "530600"
    }, {
        "province": "云南省",
        "label": "丽江市",
        "value": "530700"
    }, {
        "province": "云南省",
        "label": "普洱市",
        "value": "530800"
    }, {
        "province": "云南省",
        "label": "临沧市",
        "value": "530900"
    }, {
        "province": "云南省",
        "label": "楚雄彝族自治州",
        "value": "532300"
    }, {
        "province": "云南省",
        "label": "红河哈尼族彝族自治州",
        "value": "532500"
    }, {
        "province": "云南省",
        "label": "文山壮族苗族自治州",
        "value": "532600"
    }, {
        "province": "云南省",
        "label": "西双版纳傣族自治州",
        "value": "532800"
    }, {
        "province": "云南省",
        "label": "大理白族自治州",
        "value": "532900"
    }, {
        "province": "云南省",
        "label": "德宏傣族景颇族自治州",
        "value": "533100"
    }, {
        "province": "云南省",
        "label": "怒江傈僳族自治州",
        "value": "533300"
    }, {
        "province": "云南省",
        "label": "迪庆藏族自治州",
        "value": "533400"
    }] }, {
    "value": "540000",
    "label": "西藏自治区",
    "children": [{
        "province": "西藏自治区",
        "label": "拉萨市",
        "value": "540100"
    }, {
        "province": "西藏自治区",
        "label": "日喀则市",
        "value": "540200"
    }, {
        "province": "西藏自治区",
        "label": "昌都市",
        "value": "540300"
    }, {
        "province": "西藏自治区",
        "label": "林芝市",
        "value": "540400"
    }, {
        "province": "西藏自治区",
        "label": "山南市",
        "value": "540500"
    }, {
        "province": "西藏自治区",
        "label": "那曲地区",
        "value": "542400"
    }, {
        "province": "西藏自治区",
        "label": "阿里地区",
        "value": "542500"
    }] }, {
    "value": "610000",
    "label": "陕西省",
    "children": [{
        "province": "陕西省",
        "label": "西安市",
        "value": "610100"
    }, {
        "province": "陕西省",
        "label": "铜川市",
        "value": "610200"
    }, {
        "province": "陕西省",
        "label": "宝鸡市",
        "value": "610300"
    }, {
        "province": "陕西省",
        "label": "咸阳市",
        "value": "610400"
    }, {
        "province": "陕西省",
        "label": "渭南市",
        "value": "610500"
    }, {
        "province": "陕西省",
        "label": "延安市",
        "value": "610600"
    }, {
        "province": "陕西省",
        "label": "汉中市",
        "value": "610700"
    }, {
        "province": "陕西省",
        "label": "榆林市",
        "value": "610800"
    }, {
        "province": "陕西省",
        "label": "安康市",
        "value": "610900"
    }, {
        "province": "陕西省",
        "label": "商洛市",
        "value": "611000"
    }] }, {
    "value": "620000",
    "label": "甘肃省",
    "children": [{
        "province": "甘肃省",
        "label": "兰州市",
        "value": "620100"
    }, {
        "province": "甘肃省",
        "label": "嘉峪关市",
        "value": "620200"
    }, {
        "province": "甘肃省",
        "label": "金昌市",
        "value": "620300"
    }, {
        "province": "甘肃省",
        "label": "白银市",
        "value": "620400"
    }, {
        "province": "甘肃省",
        "label": "天水市",
        "value": "620500"
    }, {
        "province": "甘肃省",
        "label": "武威市",
        "value": "620600"
    }, {
        "province": "甘肃省",
        "label": "张掖市",
        "value": "620700"
    }, {
        "province": "甘肃省",
        "label": "平凉市",
        "value": "620800"
    }, {
        "province": "甘肃省",
        "label": "酒泉市",
        "value": "620900"
    }, {
        "province": "甘肃省",
        "label": "庆阳市",
        "value": "621000"
    }, {
        "province": "甘肃省",
        "label": "定西市",
        "value": "621100"
    }, {
        "province": "甘肃省",
        "label": "陇南市",
        "value": "621200"
    }, {
        "province": "甘肃省",
        "label": "临夏回族自治州",
        "value": "622900"
    }, {
        "province": "甘肃省",
        "label": "甘南藏族自治州",
        "value": "623000"
    }] }, {
    "value": "630000",
    "label": "青海省",
    "children": [{
        "province": "青海省",
        "label": "西宁市",
        "value": "630100"
    }, {
        "province": "青海省",
        "label": "海东市",
        "value": "630200"
    }, {
        "province": "青海省",
        "label": "海北藏族自治州",
        "value": "632200"
    }, {
        "province": "青海省",
        "label": "黄南藏族自治州",
        "value": "632300"
    }, {
        "province": "青海省",
        "label": "海南藏族自治州",
        "value": "632500"
    }, {
        "province": "青海省",
        "label": "果洛藏族自治州",
        "value": "632600"
    }, {
        "province": "青海省",
        "label": "玉树藏族自治州",
        "value": "632700"
    }, {
        "province": "青海省",
        "label": "海西蒙古族藏族自治州",
        "value": "632800"
    }] }, {
    "value": "640000",
    "label": "宁夏回族自治区",
    "children": [{
        "province": "宁夏回族自治区",
        "label": "银川市",
        "value": "640100"
    }, {
        "province": "宁夏回族自治区",
        "label": "石嘴山市",
        "value": "640200"
    }, {
        "province": "宁夏回族自治区",
        "label": "吴忠市",
        "value": "640300"
    }, {
        "province": "宁夏回族自治区",
        "label": "固原市",
        "value": "640400"
    }, {
        "province": "宁夏回族自治区",
        "label": "中卫市",
        "value": "640500"
    }] }, {
    "value": "650000",
    "label": "新疆维吾尔自治区",
    "children": [{
        "province": "新疆维吾尔自治区",
        "label": "乌鲁木齐市",
        "value": "650100"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "克拉玛依市",
        "value": "650200"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "吐鲁番市",
        "value": "650400"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "哈密市",
        "value": "650500"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "昌吉回族自治州",
        "value": "652300"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "博尔塔拉蒙古自治州",
        "value": "652700"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "巴音郭楞蒙古自治州",
        "value": "652800"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "阿克苏地区",
        "value": "652900"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "克孜勒苏柯尔克孜自治州",
        "value": "653000"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "喀什地区",
        "value": "653100"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "和田地区",
        "value": "653200"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "伊犁哈萨克自治州",
        "value": "654000"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "塔城地区",
        "value": "654200"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "阿勒泰地区",
        "value": "654300"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "自治区直辖县级行政区划",
        "value": "659000"
    }] }];
/* harmony default export */ __webpack_exports__["a"] = (city);

/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAYCAYAAAD6S912AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAxRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6ODRGQjIyMEM1ODU1MTFFNjg3NjRBRDUzMTFBNDI1MzYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6ODRGQjIyMEI1ODU1MTFFNjg3NjRBRDUzMTFBNDI1MzYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgV2luZG93cyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSI1RDAyMUZDN0NGRUMxN0E3NDkwQTI5NkE2OTEzQkI0MSIgc3RSZWY6ZG9jdW1lbnRJRD0iNUQwMjFGQzdDRkVDMTdBNzQ5MEEyOTZBNjkxM0JCNDEiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6ja5p4AAACAklEQVR42qyVT0gUURjAZ4bVhMWDEIKXBc0uCkIFkoGI4q0QpasUikinbkJ4CIUg0FMgrH8IOnhRRDp48KBiUVgEufgvWCJRWjtECYoJGTv+Pv1WXuO47cz2wc83vHnv5/fem++t7bquZUb7q1iUphlaoBrKoABsOIAUfIRpeD/esP3bnG+bQmTXaR7BXXCs7LEHL2AAaeqcENkdmmdQYUz6AWvwC6Ka7VWP+B08RPrhTIisiecJuOwZnJQMdHkivQIN8ABqjHEb0IY06SATSa+PTKIcHsMU3INNJsVlMrw0xlVJlrgKZZ9uQeMF+ySHEQNZwRDMyz4j/cJzty43E11ww9ET/dcBSBRCnWwN0ptIv/M8Bml9fwlqRVRvBYtKGEEq2zELP413JxlGreAhB9Kv2R0a/UUR/mz7fAq5hHxmyxAx+r5Jhm+scFGiWZYafYmIllHYKDaepUI2JcNP8NnKP+ZgRYRbsPAfhIuw6+htMQn7eci+wgwuN/NBv1Zp2Hiul8hphWA+0tJKhZCtwiiOtGWWHB0JmkH4E0Am29TH3J1Mh7eG4wGXPoxs2uz4S6gH1ANLOchm4Km30/b+pujtfU3vu9gFMtmeVhLY8r7wvbYYKDXaoXXujXXo9JNZ2e5BJizopWlKparu6z/0Dd8le5Z/m+aJXlM9yN5mG38swAAeBaRdL4f8WwAAAABJRU5ErkJggg=="

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon_yellow.a52d033.png";

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(396),
  /* template */
  __webpack_require__(1032),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAYCAYAAAD6S912AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAxRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6ODUxODRDNDE1ODU1MTFFNjg3NjRBRDUzMTFBNDI1MzYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6ODUxODRDNDA1ODU1MTFFNjg3NjRBRDUzMTFBNDI1MzYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgV2luZG93cyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSI1RDAyMUZDN0NGRUMxN0E3NDkwQTI5NkE2OTEzQkI0MSIgc3RSZWY6ZG9jdW1lbnRJRD0iNUQwMjFGQzdDRkVDMTdBNzQ5MEEyOTZBNjkxM0JCNDEiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz74PhXXAAACC0lEQVR42qyVTUhUURTH3xvHDxgKAhPaJH0IgkNggWgQobgrwmj2YUi4ajfgskAQchUIfhG0NYbBhQuRcZChmESwoXSCIYqJRhdRgVGBis/fyTNxez3HeTMe+M29nHfv/5177jtnbMdxLNNisViIoRduQRucgVqw4ScUYBXisByJRLbN/bYpiNhlhiG4AwGrtG3BM3iMaOE/QcRuMjyB88amr7AGvyCk0ba4hF/BA0RX/goi1sN8Bhpdi3MSgR5PRC/AdRiES8a6LNxGNFcTDocbNbKwx7FOwhXNaQ2k2JTOZrMLzJuhVdedlhThT0ierkL3IXmSyzgLcoIxWJQ8I/qB+X09btEG5OUBfftRFyBWB12SGkQ7Ef3CfBr29Hk9dIjQNcufXYRJRM8xzsM349mfCEOWf5MLeaTR/Tb8DUF+Pnl8CuWYfGavIWj4NiXCF1ZldkqjbDJ8maCWUaV2wphLhXyUCN/Be6t6S8AbEcxD8hgEl+B7QLvFc/hRhdhnmEPLKX7QKRWt1J5qEzmoEJR3tLQKFYi9hSk09iyz5HBkGEZh14eYpOkhezeKDncNj/s8+gRicdPxj6BeUBTSZYjNwYjbabv/U7R7tzPMauvyMklPHwHk3Q882xYLpUb7tc7dtg73vMSsUn2QDUltmqaoVNVdfaGneR7ZdfwbDMPapqKIvSy1fl+AAQCK+Z1aTjCxNQAAAABJRU5ErkJggg=="

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(733)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(369),
  /* template */
  __webpack_require__(1111),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAYCAYAAAD6S912AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAxRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6ODRGQjIyMDQ1ODU1MTFFNjg3NjRBRDUzMTFBNDI1MzYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6ODRGQjIyMDM1ODU1MTFFNjg3NjRBRDUzMTFBNDI1MzYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgV2luZG93cyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSI1RDAyMUZDN0NGRUMxN0E3NDkwQTI5NkE2OTEzQkI0MSIgc3RSZWY6ZG9jdW1lbnRJRD0iNUQwMjFGQzdDRkVDMTdBNzQ5MEEyOTZBNjkxM0JCNDEiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6gH0SvAAAB/klEQVR42qyVzUtUURTA3xtGCwYXQgZupA9dBUEJMiIhlq6KGOkv0FWLaCEELXUVKC6CojQEFy60hUm4cBERIlpIM2JlMATjROMswgRDBz+Y5+8wR7k933y8mQ785l7uu/fHufe9c8d2HMcyY922QzSdcBeuQD1UgQ07kIIoTMOnC46zb663TSGy6zSP4R4ErMKxDeMwiDR1SojsDs1TuGQs2oSvsAshzbbJJf4ID5EunwiR3aQ/Bedck+OSgW5PpJehHe7DVWPeGnQjjduJnGQSbnls6wDS8EPnTLAoQwKyi2GIGHOfQ58I5fDflHBmcvif4QHSKNI6+m8hrM/3oCOgb7SYTKIaWuVokIWR/qb/CrL6/Ay0iOiG5S8aYQTpRdo5+GM8aw7o2/Mb8kIGNLuMMX42yM9Pj0+hlJDPLAZBYywtGS5Y5UWtZnneGFsJahmVGzVGXyokIRl+1++s0ngHqyJMwvv/IPwAWwG9LV7D3wpkv2AWl3P8Qc+rtNwY00skVyGYpWaf6V3nN77AKI6sZZYcAys0Q3DoQybH1M/ajeMBdw2/8Ln1l8imzYF/hPqCHsFSCbJZeOIetN3/KXp7X6OZgYY8MjmeCAkk3Q88ry0mSo32aJ274xv0esly9UKG+eDy7YIkOMoaNBdaU1Co0tsQg0VoKzb/SIABAK64A/jL48Q0AAAAAElFTkSuQmCC"

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(651)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(479),
  /* template */
  __webpack_require__(1016),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return constantRouterMap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_vue__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_home_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_login_vue__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_index_StIndex_vue__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_index_StIndex_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_index_StIndex_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_404_vue__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_404_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_404_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_language_app_js__ = __webpack_require__(62);









var s = localStorage.getItem("system_lang") || 'zh_cn';

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var constantRouterMap = [{
  path: '/login',
  name: '',
  component: __WEBPACK_IMPORTED_MODULE_3__components_login_vue___default.a
}, {
  path: '/',
  name: '',
  component: __WEBPACK_IMPORTED_MODULE_2__components_home_vue___default.a,
  meta: { iconCls: 'fa fa-home fa-fw fz' },
  leaf: true,
  children: [{ path: '/', component: __WEBPACK_IMPORTED_MODULE_4__components_index_StIndex_vue___default.a, name: __WEBPACK_IMPORTED_MODULE_6__components_language_app_js__["a" /* default */][s]['menu']['home'], pm: "首页" }]
}, {
  path: '*',
  component: __WEBPACK_IMPORTED_MODULE_5__components_404_vue___default.a
}];

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: constantRouterMap
}));

/***/ }),
/* 59 */,
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./404.vue": 266,
	"./account/accMess.vue": 267,
	"./account/add.vue": 786,
	"./account/history.vue": 787,
	"./account/info.vue": 788,
	"./advert/advert-edit.vue": 789,
	"./advert/detail.vue": 790,
	"./advert/examine.vue": 791,
	"./advert/examine_detail.vue": 792,
	"./advert/list.vue": 793,
	"./advert/video/defaultDetail.vue": 794,
	"./advert/video/defaultEdit.vue": 795,
	"./advert/video/defaultList.vue": 796,
	"./advert/video/detail.vue": 797,
	"./advert/video/edit.vue": 798,
	"./advert/video/list.vue": 799,
	"./advert/video/vdetail.vue": 800,
	"./advert/video/vlist.vue": 801,
	"./apps/addAppToDistribute.vue": 802,
	"./apps/appDisplay.vue": 803,
	"./apps/appNewVersion.vue": 804,
	"./apps/appedit.vue": 805,
	"./apps/changePsp.vue": 806,
	"./apps/changePspDetail.vue": 807,
	"./apps/changePspEdit.vue": 808,
	"./apps/distributePush.vue": 809,
	"./apps/list.vue": 810,
	"./apps/pspDetail.vue": 811,
	"./apps/pspEdit.vue": 812,
	"./apps/pspList.vue": 813,
	"./apps/review.vue": 814,
	"./apps/slot.vue": 815,
	"./apps/terminalBind.vue": 816,
	"./apps/updatePsp.vue": 817,
	"./apps/updatePspDetail.vue": 818,
	"./apps/updatePspEdit.vue": 819,
	"./bulletin/bdialog.vue": 43,
	"./bulletin/blist.vue": 820,
	"./bulletin/vlist.vue": 821,
	"./config/role-add.vue": 822,
	"./config/role-update.vue": 823,
	"./config/roleManager.vue": 824,
	"./config/setting/detail.vue": 825,
	"./config/setting/edit.vue": 826,
	"./config/setting/list.vue": 827,
	"./config/sysSetting.vue": 828,
	"./data/adTypeManage.vue": 829,
	"./data/appTypeManage.vue": 830,
	"./data/channelDetail.vue": 831,
	"./data/channelManage.vue": 832,
	"./data/deviceNoManage.vue": 833,
	"./data/deviceTypeManage.vue": 834,
	"./data/firmManage.vue": 835,
	"./data/newChannel.vue": 836,
	"./data/newFirm.vue": 837,
	"./global/PushBindCm.vue": 838,
	"./global/PushHisCm.vue": 839,
	"./global/TernoAutoCtrl.vue": 18,
	"./global/breadcrumb.vue": 268,
	"./global/ciframe.vue": 840,
	"./global/cmpush.vue": 841,
	"./global/mcheckcode.vue": 842,
	"./global/mechanism_selector.vue": 2,
	"./global/paging.vue": 36,
	"./global/tagc.vue": 10,
	"./global/tyc.vue": 5,
	"./home.vue": 269,
	"./index/StIndex.vue": 270,
	"./index/index.vue": 843,
	"./index/ztMap.vue": 83,
	"./login.vue": 271,
	"./menu/menu-add.vue": 844,
	"./menu/menu-list.vue": 845,
	"./mission/Hisdetail.vue": 846,
	"./mission/Hislist.vue": 847,
	"./mission/detail.vue": 848,
	"./mission/list.vue": 849,
	"./nonintelligent/app/detail.vue": 850,
	"./nonintelligent/app/edit.vue": 851,
	"./nonintelligent/app/list.vue": 852,
	"./nonintelligent/app/verify.vue": 853,
	"./nonintelligent/app/vlist.vue": 854,
	"./nonintelligent/bsiness/detail.vue": 855,
	"./nonintelligent/bsiness/edit.vue": 856,
	"./nonintelligent/bsiness/list.vue": 857,
	"./nonintelligent/bsiness/setting.vue": 858,
	"./nonintelligent/device/detail.vue": 859,
	"./nonintelligent/device/edit.vue": 860,
	"./nonintelligent/device/list.vue": 861,
	"./nonintelligent/src/detail.vue": 862,
	"./nonintelligent/src/edit.vue": 863,
	"./nonintelligent/src/list.vue": 864,
	"./nonintelligent/src/verify.vue": 865,
	"./nonintelligent/src/vlist.vue": 866,
	"./openpl/detail.vue": 867,
	"./openpl/edit.vue": 868,
	"./openpl/list.vue": 869,
	"./param/sysSetting.vue": 870,
	"./risk/detail.vue": 871,
	"./risk/rail.vue": 872,
	"./risk/warn.vue": 873,
	"./risk/warnDetail.vue": 874,
	"./safe/authorizeDetail.vue": 875,
	"./safe/authorizeList.vue": 876,
	"./safe/cerUpload.vue": 877,
	"./safe/certDetail.vue": 878,
	"./safe/certNew.vue": 879,
	"./safe/certUpload.vue": 880,
	"./safe/certificate.vue": 881,
	"./safe/checkOnoff.vue": 882,
	"./safe/keyManagement.vue": 883,
	"./safe/keyManagement_detail.vue": 884,
	"./safe/keyManagement_edit.vue": 885,
	"./safe/keyManagement_new.vue": 886,
	"./safe/myCert.vue": 887,
	"./safe/number_21.vue": 888,
	"./safe/recordList.vue": 889,
	"./system/device/detail.vue": 890,
	"./system/device/edit.vue": 891,
	"./system/device/list.vue": 892,
	"./system/file/edit.vue": 893,
	"./system/file/list.vue": 894,
	"./system/file/verify.vue": 895,
	"./system/file/vlist.vue": 896,
	"./system/firmware/check.vue": 897,
	"./system/firmware/checkDetail.vue": 898,
	"./system/firmware/edit.vue": 899,
	"./system/firmware/manage.vue": 900,
	"./system/firmware/push.vue": 901,
	"./system/key/detail.vue": 902,
	"./system/key/edit.vue": 903,
	"./system/key/list.vue": 904,
	"./system/launch/check.vue": 905,
	"./system/launch/checkList.vue": 906,
	"./system/launch/detail.vue": 907,
	"./system/launch/edit.vue": 908,
	"./system/launch/list.vue": 909,
	"./system/launch/push.vue": 910,
	"./system/onoff/addAnimate.vue": 911,
	"./system/onoff/onOffAnimate.vue": 912,
	"./system/onoff/push.vue": 913,
	"./system/onoff/pushHistory.vue": 914,
	"./system/onoff/pushToTerminal.vue": 915,
	"./system/ptask/detail.vue": 916,
	"./system/ptask/edit.vue": 917,
	"./system/ptask/list.vue": 918,
	"./system/ptask/pushdia.vue": 57,
	"./system/reviewDetail.vue": 919,
	"./system/romEdit.vue": 920,
	"./system/romList.vue": 921,
	"./system/romOrder.vue": 922,
	"./system/romPush.vue": 923,
	"./system/romPushHistory.vue": 924,
	"./system/romReview.vue": 925,
	"./system/romUpload.vue": 926,
	"./system/stfile/checkList.vue": 927,
	"./system/stfile/detail.vue": 928,
	"./system/stfile/edit.vue": 929,
	"./system/stfile/list.vue": 930,
	"./system/stfile/verify.vue": 931,
	"./terminal/OtaList.vue": 932,
	"./terminal/add.vue": 933,
	"./terminal/appBind.vue": 934,
	"./terminal/appList.vue": 935,
	"./terminal/appLog.vue": 936,
	"./terminal/backups.vue": 937,
	"./terminal/details.vue": 938,
	"./terminal/devAct.vue": 939,
	"./terminal/dvlog.vue": 940,
	"./terminal/eqdia.vue": 84,
	"./terminal/list.vue": 941,
	"./terminal/map.vue": 272,
	"./terminal/ota.vue": 942,
	"./terminal/processInfo.vue": 273,
	"./terminal/scapture.vue": 943,
	"./terminal/terRisk.vue": 944,
	"./terminal/trDetail.vue": 945,
	"./terminal/trList.vue": 946,
	"./totalpages.vue": 947,
	"./trans/list.vue": 948
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60;

/***/ }),
/* 61 */,
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__en_js__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__zh_cn_js__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ko_js__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ru_js__ = __webpack_require__(515);






var locales = {
  en: __WEBPACK_IMPORTED_MODULE_0__en_js__["a" /* default */],
  zh_cn: __WEBPACK_IMPORTED_MODULE_1__zh_cn_js__["a" /* default */],
  ko: __WEBPACK_IMPORTED_MODULE_2__ko_js__["a" /* default */],
  ru: __WEBPACK_IMPORTED_MODULE_3__ru_js__["a" /* default */]
};
/* harmony default export */ __webpack_exports__["a"] = (locales);

/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(665)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(402),
  /* template */
  __webpack_require__(1033),
  /* scopeId */
  "data-v-49420d54",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(695)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(502),
  /* template */
  __webpack_require__(1068),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__url_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_language_app_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_en__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_zh_CN__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_zh_CN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_zh_CN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale_lang_ko__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale_lang_ko___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale_lang_ko__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_ru_RU__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_ru_RU___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_ru_RU__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_locale_lang_ja__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_locale_lang_ja___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_locale_lang_ja__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_locale__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui__);
















var req = {
  common: {
    changeLang: function changeLang(lang) {
      var localLang = null;

      if (!lang || lang === 'undefined') {
        var oldLang = localStorage.getItem("system_lang");
        if (oldLang !== null && oldLang !== "") {
          localLang = oldLang;
        } else {
          localLang = "zh_cn";
        }
      } else {
        localLang = lang;
      }
      localStorage.setItem("system_lang", localLang);
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].config.lang = localLang;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_5__components_language_app_js__["a" /* default */]).forEach(function (lang) {
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].locale(lang, __WEBPACK_IMPORTED_MODULE_5__components_language_app_js__["a" /* default */][lang]);
      });

      var cLang = localStorage.getItem("system_lang");
      switch (cLang) {
        case 'en':
          __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_en___default.a);
          break;
        case 'zh_cn':
          __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_zh_CN___default.a);
          break;
        case 'ko':
          __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale_lang_ko___default.a);
          break;
        case 'ru':
          __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_ru_RU___default.a);
          break;
      }
    }
  },

  advert: {
    list: function list(data) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__url_js__["a" /* baseurl */] + '/admanage/list.do', data).then(function (response) {
          resolve(response.data);
        });
      });
    }
  },
  order: {
    shutdownOrRestartTerminal: function shutdownOrRestartTerminal(data, successText, errText, callback) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__url_js__["a" /* baseurl */] + '/terminal/shutdownOrRestartTerminal.do', data).then(function (response) {
          if (callback) {
            callback(response.data);
          }

          if (response.data.status == 200) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_element_ui__["Message"])(response.data.message);
          } else {
            __WEBPACK_IMPORTED_MODULE_12_element_ui__["Message"].error(response.data.message);
          }

          resolve(response.data);
        }).catch(function () {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_element_ui__["Message"])(errText);
        });
      });
    },
    tranOrderToTerminal: function tranOrderToTerminal(data, successText, errText) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__url_js__["a" /* baseurl */] + '/terminal/tranOrderToTerminal.do', data).then(function (response) {

          var msg = response.data.message;
          if (response.data.status === 200) {
            __WEBPACK_IMPORTED_MODULE_12_element_ui__["Message"].success(msg);
          } else {
            __WEBPACK_IMPORTED_MODULE_12_element_ui__["Message"].error(msg);
          }
          resolve(response.data);
        }).catch(function () {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_element_ui__["Message"])(errText);
        });
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (req);

/***/ }),
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAQCAYAAAAMJL+VAAAAwUlEQVQ4T2M84K56R4zlvzIDDcCrP4x3GU96qF7gZf6vj818dumfDEyc/xi+3+Eky/rPfxkvoljAKvSbAWTol8s8cAOZOP+C2f++M5NsCYoFPLpfGHjNPjMwc/1j+HSSl+HTKT64gcIe7xje7hCizAKQbrmyRwzs0r8Y7lYokuVidBdgBBGf2SeG3+9YweqQw51qPkB3ASz8qRIH2AIYFOksQn+ol4pIjkUCGjDiYNQCgsl0NIiwBhEti+vXfxjvAADKkIp108Y5swAAAABJRU5ErkJggg=="

/***/ }),
/* 257 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAQCAYAAAAMJL+VAAACjElEQVQ4T7VUa0iTURh+jrEWOU0YUQwlI3NQ5JYFGSQOwpkUUnQjSJuSXUAItCjohx9RUCh46Y86yGlXUhCxTCViYqDC1ClFzhmIzamVobtbbifOZ+q3S01/dP588L3n5bmc93nJeOlDKrukgZ2IwD3uRkWTEYGHy05BvnsYk9o6vpRYVYas56PQD1mC7t47rcBZ0zu4TGZ4NBfdZLTwNnWZPyO++Cai9imhH7Qgt7QDY9O25ebVACh3bMajtBiQ6ipIj2WAkTZOOeeIqqiB1hyKhrO8EtKsTMjyLwSpCQcgZB3P3eKJdg5ZcLXibS9BehmNiRTj7hkFjhhaEUqNRr0rpEWzzvkg1o4IEbj6HpQ3DQCgnTzAkheqpFiEUtPzaRJJA3q/N2i2LOBgVzPvtZC1pkRoL+3kLaJYxoBkgwh5qduR3P2Gx40rKsC6KAmsNTo/gFn9e77OvHaLxNC1f0Rjl9nv0b0+Xx+xGQYoISRoGgJ/fG9pw8yrtkXQwgJslCeE7Rn55nIQw37VCv2wLWu7QOVy7/8HmKiuXZUCe58Rjv5BXoL0aAbWy7aGlTNJxW7C1XcHAagUsUhLisVP6xRmXrdDkqwAAxAmmc06O1+fNeKXj+JD3G70jK+Ek9XmnB6T35iyNNZeV4N9WaNVW4dNp45j5MBh7On3H9MOVyROpu6E1+7AGHefz8/s+TzktHwRbAFBDlhai7NTeNZjdx5gwWbHj3O5yH5pwt+CxljqbqixbUs02NgyIEmmGjXiRJS0Di8GTXnlCQ3FujIi4U8agX+tCrYFuJwUXDuxN0jN5faJXkIppaFYr3XZsS0QqMabrp4n008b6JLXQtbCEQm37JbuBqoxal94fgOw9abJSJkjFgAAAABJRU5ErkJggg=="

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/korea.74e98a2.png";

/***/ }),
/* 259 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAACFEAYAAABODmtvAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAAAZiS0dEAAAAAAAA+UO7fwAAAAlwSFlzAAAASAAAAEgARslrPgAAAzRJREFUeNrt2D9LFHAcx/HfXXcRhoYtgmAE0ZKKi9YTCHRo7d8S1NbSU6gnUBEECSVBOmRNbo4VKRG2JC4ODZnVFRYHYmHiNYRNDfFZ7obXa/tun+0N38rZjfPz5+dv3574On5s/Ni1awUA/mHx1MLowmijMdWcak41+/trA4sDMwMzBw9eOXN5+vJ0tdrugQB0puaT5lJzaWenjJfj5XgpggFAREAAiAgIABEBASAiIABEBASAiIAAEBEQACICAkBEQACICAgAEQEBICIgAEQEBICIgAAQERAAIgICQERAAIgICAARAQEgIiAARAQEgIiAABAREAAiAgJAREAAiAgIABEBASAiIABEBASAiIAAEBEQACICAkBEQACICAgAEQEBICIgAEQEBICIgAAQERAAIgICQERAAIjUVk+vjjfOtVr3mvfvPCsrK123uho9kxsb7R4GQGd5tf366rtHR4/u3bX3d9fXN19UKjcn70y/WR0cbPdAADpT19D+S99n19ZKKaUc8cICICQgAEQEBICIgAAQERAAIgICQERAAIgICAARAQEgIiAARAQEgIiAABAREAAiAgJAREAAiAgIABEBASAiIABEBASAiIAAEBEQACICAkBEQACICAgAEQEBICIgAEQEBICIgAAQERAAIgICQERAAIgICAARAQEgIiAARAQEgIiAABAREAAiAgJAREAAiAgIABEBASAiIABEaicO7/R8/lWtjvVvX3w+12jUx1pXKkNbW+0eBkBnWe6unvy2r15fnvtz1w4vVh7+WNzdvfB4+8vbL319pZT75X27ZwLQaZo3DvR2v1xbK6V8KMULC4CQgAAQERAAIgICQERAAIgICAARAQEgIiAARAQEgIiAABAREAAiAgJAREAAiAgIABEBASAiIABEBASAiIAAEBEQACICAkBEQACICAgAEQEBICIgAEQEBICIgAAQERAAIgICQERAAIgICAARAQEgIiAARAQEgIiAABAREAAiAgJAREAAiAgIABEBASAiIABEBASAiIAA8H9+th60HlT/dqP2bqw+UZ+Ynb1+qHekd2Rzs937AOhMn57WhmvDHz/u3b8BJPptbd3x+u0AAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMDEtMTZUMTY6MDA6MjgrMDg6MDBJewRuAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE4LTAxLTE2VDE2OjAwOjI4KzA4OjAwOCa80gAAAGN0RVh0c3ZnOmJhc2UtdXJpAGZpbGU6Ly8vaG9tZS9hZG1pbi9pY29uLWZvbnQvdG1wL2ljb25fZDRoYnFxcDVwY295d3JrOS8lRTQlQkYlODQlRTclQkQlOTclRTYlOTYlQUYuc3ZnM75BYwAAAABJRU5ErkJggg=="

/***/ }),
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(1055),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(703)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(330),
  /* template */
  __webpack_require__(1075),
  /* scopeId */
  "data-v-6e3fadf0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(671)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(1039),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(706)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(1079),
  /* scopeId */
  "data-v-76a875c9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(662)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(1028),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(649)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(1013),
  /* scopeId */
  "data-v-38937b40",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(654)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(399),
  /* template */
  __webpack_require__(1020),
  /* scopeId */
  "data-v-3e12edc4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(737)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(400),
  /* template */
  __webpack_require__(1116),
  /* scopeId */
  "data-v-adcf7436",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(681)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(403),
  /* template */
  __webpack_require__(1052),
  /* scopeId */
  "data-v-5bbf813a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(677)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(504),
  /* template */
  __webpack_require__(1048),
  /* scopeId */
  "data-v-59b1a0f0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(633)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(506),
  /* template */
  __webpack_require__(994),
  /* scopeId */
  "data-v-25d3c569",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_url__ = __webpack_require__(3);







var qs = __webpack_require__(90);
var dateFormat = __webpack_require__(88);
var now = new Date();
var timeStamp = dateFormat(now, 'yyyymmddHHMM');
var checkV = 'poss' + timeStamp;

var sha256 = __webpack_require__(59).sha256;

var checkValue = sha256(sha256(checkV + 'szzt@002197'));
var http = __WEBPACK_IMPORTED_MODULE_4_axios___default.a.create({
  baseURL: __WEBPACK_IMPORTED_MODULE_5__api_url__["a" /* baseurl */],
  timeout: 20000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },

  responseType: 'json',
  withCredentials: false,
  transformRequest: [function (data) {
    var options = {
      'condition': {},
      'pageNum': '',
      'numPerPage': '',
      'orderField': '',
      'orderDirection': 'desc',
      'pageFlag': '1',
      'timestamp': timeStamp,
      'checkvalue': checkValue
    };

    if (!data || (typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(data)) === undefined) {
      data = {};
    }

    if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(data.upload) !== undefined && data.upload === true) {
      var jsondata = {
        token: 'szzttmsinterface=='
      };
      var formElement = document.getElementById(data.formElement);
      var formData = new FormData(formElement);
      if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(data.uploadData) !== undefined && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(data.uploadData) === 'object') {
        for (var item in data.uploadData) {
          formData.set(item, data.uploadData[item]);
        }
      }
      if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(data.areaid) !== undefined && data.areaid !== '') {
        formData.append('areaid', data.areaid);
      }
      formData.append('jsondata', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(jsondata));
      return formData;
    }
    data.token = 'szzttmsinterface==';
    var nObj = void 0;
    if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(data.write) !== undefined && data.write === true) {
      nObj = data;
      delete data.write;
    } else {
      nObj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(options, data);
    }
    var request = {};
    request.jsondata = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(nObj);
    request = qs.stringify(request);
    return request;
  }],
  transformResponse: [function (data) {
    if (typeof data === 'string') {
      return JSON.parse(data);
    }
    return data;
  }]

});

var api = {
  commonQuery: function commonQuery(data, self, loading) {
    var api = this;
    http.post('/system/index/commonQuery', data).then(function (response) {
      var status = response.data.statusCode;
      if (status == '1') {
        console.log("处理失败");
      } else {
        self.setData(response.data.data);

        if ((typeof loading === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(loading)) !== undefined && loading === false) self.loading = false;
      }
    }).catch(function (error) {
      console.log(error);
    });
  }
};

var ztApi = {
  install: function install(Vue, options) {
    Vue.prototype.$ztApi = api;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (ztApi);

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_language_app_js__ = __webpack_require__(62);



var curLang = __WEBPACK_IMPORTED_MODULE_1__components_language_app_js__["a" /* default */][localStorage.system_lang];
var sha256 = __webpack_require__(59).sha256;

/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    Vue.prototype.$installType = { 0: curLang.app_autoInstall, 1: curLang.app_cantuins };
    Vue.prototype.$firmwareTypes = [{ label: 'KEY', vl: 'KEY' }, { label: 'FLASH', vl: 'FLASH' }, { label: 'KOS', vl: 'KOS' }, { label: 'RES', vl: 'RES' }, { label: 'KSP', vl: 'KSP' }, { label: 'HEX', vl: 'HEX' }];

    Vue.prototype.$gRow = 10;
    Vue.prototype.$gRows = [10, 50, 100];
    Vue.prototype.$legalSysPsw = function (ct) {
      return this.$strCheck(ct, '^\\w+$');
    };
    Vue.prototype.$strCheck = function (ct, rule) {
      var patt = new RegExp(rule);
      return patt.test(ct);
    };

    Vue.prototype.$sha256 = function (vl) {
      return sha256(sha256(vl + 'szzt@002197'));
    };

    Vue.prototype.$showConfirm = function (title, content, cfbtn, clbtn, type, sureCb, otherCb) {
      this.$confirm(content, title, {
        confirmButtonText: cfbtn,
        cancelButtonText: clbtn,
        type: type
      }).then(function () {
        if (sureCb) {
          sureCb();
        }
      }).catch(function () {
        if (otherCb) {
          otherCb();
        }
      });
    };
    Vue.prototype.$getWObj = function () {
      if (JSON) {
        if (!localStorage.wobj) {
          var obj = {
            editDataConfig: {
              pageType: 0,
              type: 0,
              data: ''
            },
            editAppConfig: {
              type: 0,
              data: ''
            },
            otaPushInfo: '',
            appBindInfo: '',
            missionInfo: '',
            animatePushInfo: '',
            info: '',
            pages: {
              appPage: 1,
              appMarketPage: 1,
              appMarketAddPage: 1,
              appMarketPushPage: 1,
              appMarketTerPage: 1,
              appVerifyPage: 1,
              missionListPage: 1,
              missionDetailPage: 1,
              dataChannelPage: 1,
              dataFirmPage: 1,
              firmwarePage: 1,
              firmwareCheckPage: 1 }
          };
          localStorage.wobj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj);
        }

        return JSON.parse(localStorage.wobj);
      }
    };
    Vue.prototype.$setWObj = function (key, vl) {
      if (JSON) {
        var obj = Vue.prototype.$getWObj();
        obj[key] = vl;
        localStorage.wobj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj);
      }
    };
    Vue.prototype.$cleanWObj = function () {
      localStorage.wobj = '';
    };
    Vue.prototype.$setWPage = function (prop, index) {
      var wobj = Vue.prototype.$getWObj();
      var pages = wobj.pages;
      pages[prop] = index;
      Vue.prototype.$setWObj('pages', pages);
    };
    Vue.prototype.$getWPage = function (prop) {
      var wobj = Vue.prototype.$getWObj();
      var index = wobj.pages[prop];

      return index;
    };
    Vue.prototype.$getProjFolder = function () {
      var rs = location.href;
      var urlpre = rs.substring(0, rs.indexOf('#'));
      return urlpre;
    };
    Vue.prototype.$plang = {
      en: {
        tip: 'Prompt',
        upTip: 'A file is being uploaded, and is it sure to leave the page',
        sure: 'Determine',
        cancel: 'Cancel'
      },
      ko: {
        tip: '팁',
        upTip: '파일 업로드 중 여부를 떠나 있는 건 이 페이지',
        sure: '확정',
        cancel: '취소'
      },
      ru: {
        tip: 'подсказки ',
        upTip: ' есть  в настоящее время  загрузить  файл  , чтобы определить, является ли  покинуть  эту страницу ',
        sure: 'Определения ',
        cancel: 'отменить '
      },
      zh_cn: {
        tip: '提示',
        upTip: '有文件正在上传, 是否确定离开此页面',
        sure: '确定',
        cancel: '取消'
      }
    };
  }
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_url_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);





/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    var addrPre = __WEBPACK_IMPORTED_MODULE_1__api_url_js__["e" /* wUrl */].host + __WEBPACK_IMPORTED_MODULE_1__api_url_js__["e" /* wUrl */].port + __WEBPACK_IMPORTED_MODULE_1__api_url_js__["e" /* wUrl */].path;
    var addrPre_openpl = __WEBPACK_IMPORTED_MODULE_1__api_url_js__["e" /* wUrl */].host + __WEBPACK_IMPORTED_MODULE_1__api_url_js__["e" /* wUrl */].port_openpl + __WEBPACK_IMPORTED_MODULE_1__api_url_js__["e" /* wUrl */].path_openpl;
    Vue.prototype.$addrPre = addrPre;
    var appUrlPre = __WEBPACK_IMPORTED_MODULE_1__api_url_js__["e" /* wUrl */].host + __WEBPACK_IMPORTED_MODULE_1__api_url_js__["e" /* wUrl */].port_app + __WEBPACK_IMPORTED_MODULE_1__api_url_js__["e" /* wUrl */].path;
    Vue.prototype.$appUrlTag = 1;
    Vue.prototype.$host = __WEBPACK_IMPORTED_MODULE_1__api_url_js__["e" /* wUrl */].host + __WEBPACK_IMPORTED_MODULE_1__api_url_js__["e" /* wUrl */].port;

    Vue.prototype.$imgUploadUrl = addrPre + '/upload/upload.do';
    Vue.prototype.$fileUploadUrl = addrPre + '/appFile/fileupload.do';
    Vue.prototype.$launchUlUrl = addrPre + '/launcher/fileupload.do';
    Vue.prototype.$fileUpImgloadUrl = addrPre + '/file/fileupload.do';
    Vue.prototype.$filePbCerUploadUrl = addrPre + '/sgn/fileupload.do';
    Vue.prototype.$fileExcelUlUrl = addrPre + '/import/terminalList.do';
    Vue.prototype.$urls = __WEBPACK_IMPORTED_MODULE_1__api_url_js__["b" /* urlAssets */];
    Vue.prototype.$videoUrl = addrPre + '/video/fileupload.do';
    Vue.prototype.$adUlUrl = __WEBPACK_IMPORTED_MODULE_1__api_url_js__["e" /* wUrl */].bannerFileUrl + '/bannerFile/upload.do';
    Vue.prototype.$mcTempUrl = addrPre + '/model/merchants.xlsx';
    Vue.prototype.$mcUploadUrl = addrPre + '/mechanism/import.do';
    Vue.prototype.$push_device_Url = addrPre + '/kmc/importTers.do';

    Vue.prototype.$delTerAct = function (ids, callback, error) {
      var path = '/terminalActivate/delete.do';
      var url = addrPre + path;
      var param = { ids: ids };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$pushActivate = function (data, callback, error) {
      var path = '/terminalActivate/activate.do';
      var url = addrPre + path;
      var data = data;

      jsonRqes(url, data, callback, error);
    };

    Vue.prototype.$terminalActivate = function (page, rows, terminalNo, mechId, callback, error) {
      var path = '/terminalActivate/list.do';
      var url = addrPre + path;
      var param = { page: page, rows: rows, terminalNo: terminalNo, mechId: mechId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$terActImport = function (fileNo, callback, error) {
      var path = '/terminalActivate/activateByImport.do';
      var url = addrPre + path;
      var param = { fileNo: fileNo };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$pspUninstImport = function (appId, fileNo, fileType, callback, error) {
      var path = '/pspUninstallApp/pushByImport.do';
      var url = addrPre + path;
      var param = { appId: appId, fileNo: fileNo, fileType: fileType };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$pushByImport = function (appId, fileNo, fileType, callback, error) {
      var path = '/pspChangeApp/pushByImport.do';
      var url = addrPre + path;
      var param = { appId: appId, fileNo: fileNo, fileType: fileType };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$mfaUnbind = function (userId, code, callback, error) {
      var path = '/user/unbindMfa.do';
      var url = addrPre + path;
      var param = { userId: userId, code: code };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$mfaBind = function (userId, code, callback, error) {
      var path = '/user/bindMfa.do';
      var url = addrPre + path;
      var param = { userId: userId, code: code };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$mfaQrcode = function (userId, callback, error) {
      var path = '/user/getQRCode.do';
      var url = addrPre + path;
      var param = { userId: userId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$mfaIdCheck = function (userId, password, callback, error) {
      var path = '/user/authentication.do';
      var url = addrPre + path;
      var param = { userId: userId, password: password };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$loginCodeCheck = function (userId, code, callback, error) {
      var path = '/user/checkCode.do';
      var url = addrPre + path;
      var param = { userId: userId, code: code };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$loaunScreen = function (terminalNo, lockScreenPwd, waitTime, status, callback, error) {
      var path = '/cmd/lockScreen.do';
      var url = addrPre + path;
      var param = { waitTime: waitTime, status: status, terminalNo: terminalNo, lockScreenPwd: lockScreenPwd };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$authLogin = function (userName, password, code, callback, error) {
      var path = '/user/auth.do';
      var url = addrPre + path;
      var param = { userName: userName, password: password, code: code };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$autoLaunchApp = function (terminalNo, packageName, callback, error) {
      var path = '/cmd/startingApp.do';
      var url = addrPre + path;
      var param = { terminalNo: terminalNo, packageName: packageName };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.getSCapture = function (page, rows, terminalNo, mechId, callback, error) {
      var path = '/screencap/list.do';
      var url = addrPre + path;
      var param = { page: page, rows: rows, terminalNo: terminalNo, mechId: mechId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.sCapture = function (terminalNo, callback, error) {
      var path = '/screencap/getTerScreenCAP.do';
      var url = addrPre + path;
      var param = { terminalNo: terminalNo };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$translist = function (page, rows, terminalNo, mechId, mcID, termID, type, trId, callback, error) {
      var path = '/trading/list.do';
      var url = addrPre + path;
      var param = { page: page, rows: rows, terminalNo: terminalNo, mechId: mechId, mcID: mcID, termID: termID, type: type, trId: trId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$delsCapture = function (ids, callback, error) {
      var path = '/screencap/delete.do';
      var url = addrPre + path;
      var param = { ids: ids };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$delTerLog = function (ids, callback, error) {
      var path = '/terminalLog/delete.do';
      var url = addrPre + path;
      var param = { ids: ids };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$getTerLog = function (code, page, rows, terminalNo, mechId, beginTime, endTime, callback, error) {
      var path = '/terminalLog/getTerLogList.do';
      var url = addrPre + path;
      var param = { code: code, page: page, rows: rows, terminalNo: terminalNo, mechId: mechId, beginTime: beginTime, endTime: endTime };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$delTerLog = function (ids, callback, error) {
      var path = '/terminalLog/delete.do';
      var url = addrPre + path;
      var param = { ids: ids };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$operateTerLog = function (type, logId, terminalNo, callback, error) {
      var path = '/terminalLog/getLogs.do';
      var url = addrPre + path;
      var param = { terminalNo: terminalNo, logId: logId, type: type };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$outputEq2Excel = function (terminalId, areaid, orderType, time_orderType, terminalName, terminal_status, beginTime, endTime) {
      var token = localStorage.user ? localStorage.user : '';
      var url = addrPre + ('/export/terminal_info.do?terminalId=' + terminalId + '&language=') + localStorage.system_lang + ('&areaid=' + areaid + '&orderType=' + orderType + '&time_orderType=' + time_orderType + '&terminalName=' + terminalName + '&terminal_status=' + terminal_status + '&beginTime=' + beginTime + '&endTime=' + endTime + '&token=' + token);

      window.open(url, '_blank');
    };

    Vue.prototype.$outputDevice = function (terminalNo, status, mechId) {
      var token = localStorage.user ? localStorage.user : '';
      var url = addrPre + ('/kmc/export.do?terminalNo=' + terminalNo + '&language=') + localStorage.system_lang + ('&status=' + status + '&mechId=' + mechId + '&token=' + token);

      window.open(url, '_blank');
    };

    Vue.prototype.$getCheckcode = function (callback, error) {
      var path = '/user/getCode.do';
      var url = addrPre + path;
      var param = {};
      getRqs(url, param, callback, error);
    };

    Vue.prototype.$getPublicKey = function (callback, error) {
      var path = '/user/getPublicKey.do';
      var url = addrPre + path;
      var param = {};
      getRqs(url, param, callback, error);
    };

    Vue.prototype.$checkVBInfo = function (callback, error) {
      var path = '/notice/getNoticeInfo.do';
      var url = addrPre + path;
      var param = {};
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$bulletin = function (page, rows, noticeName, callback, error) {
      var path = '/notice/list.do';
      var url = addrPre + path;
      var param = { noticeName: noticeName, page: page, rows: rows };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$addBulletin = function (noticeName, noticeInfo, callback, error) {
      var path = '/notice/add.do';
      var url = addrPre + path;
      var param = { noticeName: noticeName, noticeInfo: noticeInfo };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$bulletinDetail = function (id, callback, error) {
      var path = '/notice/detail.do';
      var url = addrPre + path;
      var param = { id: id };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$editBulletin = function (id, noticeName, noticeInfo, callback, error) {
      var path = '/notice/edit.do';
      var url = addrPre + path;
      var param = { id: id, noticeName: noticeName, noticeInfo: noticeInfo };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$delBulletin = function (ids, callback, error) {
      var path = '/notice/delete.do';
      var url = addrPre + path;
      var param = { ids: ids };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$udVerList = function (page, rows, callback, error) {
      var path = '/versionManage/list.do';
      var url = addrPre + path;
      var param = { page: page, rows: rows };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$addUdVer = function (version, date, desc, callback, error) {
      var path = '/versionManage/add.do';
      var url = addrPre + path;
      var param = { version: version, date: date, desc: desc };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$editUdVer = function (id, version, date, desc, callback, error) {
      var path = '/versionManage/edit.do';
      var url = addrPre + path;
      var param = { id: id, version: version, date: date, desc: desc };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$udVerDetail = function (id, callback, error) {
      var path = '/versionManage/detail.do';
      var url = addrPre + path;
      var param = { id: id };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$delUdVer = function (ids, callback, error) {
      var path = '/versionManage/delete.do';
      var url = addrPre + path;
      var param = { ids: ids };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$dvcmd = function (zl, type, packageName, terminalNo, callback, error) {
      var path = '/terminal/cmd.do';
      var url = addrPre + path;
      var param = { zl: zl, type: type, packageName: packageName, terminalNo: terminalNo };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$generateKey = function (userId, callback, error) {
      var path = '/user/resetAppKey.do';
      var url = addrPre + path;
      var param = { userId: userId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$passageList = function (page, rows, appName, isauthen, merchantid, callback, error) {
      var path = '/channel/listChannel.do';
      var url = addrPre_openpl + path;
      var param = { page: page, rows: rows, appName: appName, isAuthen: isauthen, merchantId: merchantid };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$delPassage = function (appId, callback, error) {
      var path = '/channel/deleteChannel.do';
      var url = addrPre_openpl + path;
      var param = { appId: appId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$passageDetail = function (appId, callback, error) {
      var path = '/channel/detailChannel.do';
      var url = addrPre_openpl + path;
      var param = { appId: appId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$editPassage = function (param, callback, error) {
      var path = '/channel/editChannel.do';
      var url = addrPre_openpl + path;
      var param = param;
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$addPassage = function (param, callback, error) {
      var path = '/channel/addChannel.do';
      var url = addrPre_openpl + path;
      var param = param;
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$indexSysFmCount = function (mechId, type, callback, error) {
      var path = '/statistics/terminalInfoCount.do';
      var url = addrPre + path;
      var param = { mechId: mechId, type: type };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$indexDvStCount = function (mechId, type, beginDate, endDate, callback, error) {
      var path = '/statistics/onlineStatusCount.do';
      var url = addrPre + path;
      var param = { mechId: mechId, type: type, beginDate: beginDate, endDate: endDate };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$keyblist = function (page, rows, distributorId, terminalNo, callback, error) {
      var path = '/terminalKey/getKeyBoard.do';
      var url = addrPre + path;
      var param = { page: page, rows: rows, distributorId: distributorId, terminalNo: terminalNo };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$pTaskList = function (page, rows, taskType, taskName, orderName, orderType, terminalNo, callback, error) {
      var path = '/task_manage/task_list.do';
      var url = addrPre + path;
      var param = { orderName: orderName, orderType: orderType, page: page, rows: rows, taskType: taskType, taskName: taskName, terminalNo: terminalNo };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$pTaskExport = function (taskId, terminalName, orderType, status) {
      var path = '/export/new_task.do';
      var url = addrPre + path + '?taskId=' + taskId + '&terminalName=' + terminalName + '&orderType=' + orderType + '&status=' + status + '&language=' + localStorage.system_lang;
      return url;
    };

    Vue.prototype.$pTaskPushList = function (page, rows, name, mechId, fileType, fileId, callback, error) {
      var path = '/fileManage/file_list.do';
      var url = addrPre + path;
      var param = { page: page, rows: rows, fileName: name, mechId: mechId, fileType: fileType, fileId: fileId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$pTaskAddTask = function (taskName, subTask, callback, error) {
      var path = '/task_manage/add_task.do';
      var url = addrPre + path;
      var param = { taskName: taskName, subTask: subTask };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$pTaskEditTask = function (taskId, taskName, subTask, callback, error) {
      var path = '/task_manage/edit_task.do';
      var url = addrPre + path;
      var param = { taskId: taskId, taskName: taskName, subTask: subTask };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$pTaskProgress = function (taskId, callback, error) {
      var path = '/task_manage/push_detail.do';
      var url = addrPre + path;
      var param = { taskId: taskId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$pTaskEdit = function (taskId, callback, error) {
      var path = '/task_manage/task_detail.do';
      var url = addrPre + path;
      var param = { taskId: taskId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$pTaskStatistics = function (taskId, callback, error) {
      var path = '/push_manage/status_count.do';
      var url = addrPre + path;
      var param = { taskId: taskId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$bwlBindAll = function (profileId, type, callback, error) {
      var path = '/profilesManage/updateType.do';
      var url = addrPre + path;
      var param = { profileId: profileId, type: type };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$bwlBindList = function (page, rows, mechId, terminalName, status, id, callback, error) {
      var path = '/profilesManage/terList.do';
      var url = addrPre + path;
      var param = { page: page, rows: rows, mechId: mechId, terminalName: terminalName, status: status, id: id };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$bwlBind = function (terminalIds, id, callback, error) {
      var path = '/profilesManage/addTers.do';
      var url = addrPre + path;
      var param = { terminalIds: terminalIds, id: id };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$bwlUnbind = function (ids, callback, error) {
      var path = '/profilesManage/delTers.do';
      var url = addrPre + path;
      var param = { ids: ids };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$getfile = function (page, rows, name, mechId, type, subType, status, orderName, orderType, callback, error) {
      var path = '/fileManage/list.do';
      var url = addrPre + path;
      var param = { orderType: orderType, orderName: orderName, page: page, rows: rows, name: name, mechId: mechId, type: type, subType: subType, status: status };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$addFile = function (fileName, fileVersion, hashCode, fileSize, fileUrl, fileType, subFileType, param1, mechId, memo, callback, error) {
      var path = '/fileManage/add.do';
      var url = addrPre + path;
      var param = { fileName: fileName, fileVersion: fileVersion, hashCode: hashCode, fileSize: fileSize, fileUrl: fileUrl, fileType: fileType, subFileType: subFileType, param1: param1, mechId: mechId, memo: memo };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$editFile = function (fileId, fileName, fileVersion, hashCode, fileSize, fileUrl, fileType, subFileType, param1, mechId, memo, callback, error) {
      var path = '/fileManage/edit.do';
      var url = addrPre + path;
      var param = { fileId: fileId, fileName: fileName, fileVersion: fileVersion, hashCode: hashCode, fileSize: fileSize, fileUrl: fileUrl, fileType: fileType, subFileType: subFileType, param1: param1, mechId: mechId, memo: memo };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$delfile = function (ids, callback, error) {
      var path = '/fileManage/delete.do';
      var url = addrPre + path;
      var param = { ids: ids };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$repushDSFailDv = function (terminalNo, configId, callback, error) {
      var path = '/terminalConfig/reConfig.do';
      var url = addrPre + path;
      var param = { terminalNo: terminalNo, configId: configId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$filePushTest = function (id, terminalNo, callback, error) {
      var path = '/fileManage/push_test.do';
      var url = addrPre + path;
      var param = { id: id, terminalNo: terminalNo };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$failTaskRepush = function (taskId, callback, error) {
      var path = '/task_manage/rePushAll.do';
      var url = addrPre + path;
      var param = { taskId: taskId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$appendPush = function (taskId, terminalNos, pushType, mechId, terminalName, fileNo, Terminalstatus, snBegin, snEnd, callback, error) {
      var path = '/task_manage/add_push.do';
      var url = addrPre + path;
      var param = { taskId: taskId, terminalNos: terminalNos, pushType: pushType, mechId: mechId, terminalName: terminalName, fileNo: fileNo, Terminalstatus: Terminalstatus, snBegin: snBegin, snEnd: snEnd };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$sysconfigPush = function (configId, terminalNos, pushType, mechId, terminalName, fileNo, snBegin, snEnd, callback, error) {
      var path = '/sysConfig/push.do';
      var url = addrPre + path;
      var param = { configId: configId, terminalNos: terminalNos, pushType: pushType, mechId: mechId, terminalName: terminalName, fileNo: fileNo, snBegin: snBegin, snEnd: snEnd };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$verifyFile = function (id, content, status, callback, error) {
      var path = '/fileManage/audit.do';
      var url = addrPre + path;
      var param = { id: id, content: content, status: status };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$filePush = function (fileId, autoOpen, installType, pushType, terminalNos, mechId, terminalStatus, terminalNo, fileNo, callback, error) {
      var path = '/push_manage/file_push.do';
      var url = addrPre + path;
      var param = { fileId: fileId, autoOpen: autoOpen, installType: installType, pushType: pushType, terminalNos: terminalNos, mechId: mechId, terminalStatus: terminalStatus, terminalNo: terminalNo, fileNo: fileNo };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$getFTPDetail = function (callback, error) {
      var path = '/ftpServer/detail.do';
      var url = addrPre + path;
      var param = {};
      jsonRqes(url, param, callback, error);
    };
    Vue.prototype.$addFTP = function (opeTime, ftpAddress, ftpPort, ftpUser, ftpPwd, ftpPath, updateTime, callback, error) {
      var path = '/ftpServer/add.do';
      var url = addrPre + path;
      var param = { opeTime: opeTime, ftpAddress: ftpAddress, ftpPort: ftpPort, ftpUser: ftpUser, ftpPwd: ftpPwd, ftpPath: ftpPath, updateTime: updateTime };
      jsonRqes(url, param, callback, error);
    };
    Vue.prototype.$editFTP = function (id, opeTime, ftpAddress, ftpPort, ftpUser, ftpPwd, ftpPath, updateTime, callback, error) {
      var path = '/ftpServer/edit.do';
      var url = addrPre + path;
      var param = { opeTime: opeTime, id: id, ftpAddress: ftpAddress, ftpPort: ftpPort, ftpUser: ftpUser, ftpPwd: ftpPwd, ftpPath: ftpPath, updateTime: updateTime };
      jsonRqes(url, param, callback, error);
    };
    Vue.prototype.$ftpfList = function (callback, error) {
      var path = '/ftpServer/file_list.do';
      var url = addrPre + path;
      var param = {};
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$getTcList = function (page, rows, name, orderName, orderType, callback, error) {
      var path = '/terminalConfig/list.do';
      var url = addrPre + path;
      var param = { orderType: orderType, orderName: orderName, page: page, rows: rows, name: name };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$addTc = function (configName, configDesc, params, callback, error) {
      var path = '/terminalConfig/add.do';
      var url = addrPre + path;
      var param = { configName: configName, configDesc: configDesc, param: params };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$editTc = function (id, configName, configDesc, params, callback, error) {
      var path = '/terminalConfig/edit.do';
      var url = addrPre + path;
      var param = { id: id, configName: configName, configDesc: configDesc, param: params };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$tcDetail = function (id, callback, error) {
      var path = '/terminalConfig/detail.do';
      var url = addrPre + path;
      var param = { id: id };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$delTc = function (ids, callback, error) {
      var path = '/terminalConfig/delete.do';
      var url = addrPre + path;
      var param = { ids: ids };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$tcBindDevice = function (terminalIds, configId, callback, error) {
      var path = '/terminalConfig/addTers.do';
      var url = addrPre + path;
      var param = { terminalIds: terminalIds, configId: configId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$tcDeviceBindList = function (page, rows, mechId, terminalName, status, configId, orderName, orderType, callback, error) {
      var path = '/terminalConfig/terList.do';
      var url = addrPre + path;
      var param = { orderType: orderType, orderName: orderName, page: page, rows: rows, mechId: mechId, terminalName: terminalName, status: status, configId: configId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$tcDelDevice = function (ids, callback, error) {
      var path = '/terminalConfig/deleteTers.do';
      var url = addrPre + path;
      var param = { ids: ids };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$moveByImport = function (param, callback, error) {
      var path = '/terminal/moveByImport.do';
      var url = addrPre + path;
      var param = param;
      getRqs(url, param, callback, error);
    };

    Vue.prototype.$device_push = function (data, callback, error) {
      var path = '/kmc/add.do';
      var url = addrPre + path;
      var param = data;
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$getKeyList = function (page, rows, name, callback, error) {
      var path = '/terminalKey/list.do';
      var url = addrPre + path;
      var param = { page: page, rows: rows, name: name };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$addKey = function (keyName, memo, updateTime, callback, error) {
      var path = '/terminalKey/add.do';
      var url = addrPre + path;
      var param = { keyName: keyName, memo: memo, updateTime: updateTime };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$editKey = function (id, keyName, memo, updateTime, callback, error) {
      var path = '/terminalKey/edit.do';
      var url = addrPre + path;
      var param = { id: id, keyName: keyName, memo: memo, updateTime: updateTime };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$keyDetail = function (id, callback, error) {
      var path = '/terminalKey/detail.do';
      var url = addrPre + path;
      var param = { id: id };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$delKey = function (ids, callback, error) {
      var path = '/terminalKey/delete.do';
      var url = addrPre + path;
      var param = { ids: ids };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$keyAddDevice = function (terminalIds, configId, callback, error) {
      var path = '/terminalKey/addTers.do';
      var url = addrPre + path;
      var param = { terminalIds: terminalIds, configId: configId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$keyDeviceBindList = function (page, rows, mechId, terminalName, status, configId, callback, error) {
      var path = '/terminalKey/terList.do';
      var url = addrPre + path;
      var param = { page: page, rows: rows, mechId: mechId, terminalName: terminalName, status: status, configId: configId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$keyDelDevice = function (ids, callback, error) {
      var path = '/terminalKey/deleteTers.do';
      var url = addrPre + path;
      var param = { ids: ids };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$getasList = function (page, rows, status, mechanismId, type, name, callback, error) {
      var path = '/resourceManage/list.do';
      var url = addrPre + path;
      var param = { status: status, mechanismId: mechanismId, type: type, page: page, rows: rows, name: name };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$assubmit = function (id, content, status, callback, error) {
      var path = '/resourceManage/audit.do';
      var url = addrPre + path;
      var param = { status: status, id: id, content: content };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$asTestPush = function (id, terminalNo, callback, error) {
      var path = '/resourceManage/push.do';
      var url = addrPre + path;
      var param = { id: id, terminalNo: terminalNo };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$addNonAs = function (name, version, md5, size, surl, categoryId, mechanismId, memo, type, callback, error) {
      var path = '/resourceManage/add.do';
      var url = addrPre + path;
      var param = { type: type, memo: memo, name: name, version: version, md5: md5, size: size, url: surl, categoryId: categoryId, mechanismId: mechanismId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$editNonAs = function (id, status, name, version, md5, size, surl, categoryId, mechanismId, memo, type, callback, error) {
      var path = '/resourceManage/edit.do';
      var url = addrPre + path;
      var param = { id: id, status: status, type: type, memo: memo, name: name, version: version, md5: md5, size: size, url: surl, categoryId: categoryId, mechanismId: mechanismId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$delNonieAs = function (ids, callback, error) {
      var path = '/resourceManage/delete.do';
      var url = addrPre + path;
      var param = { ids: ids };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$getNonItDv = function (page, rows, mechanismId, terminalNo, terminalStatus, activeStatus, orderName, orderType, snBegin, snEnd, callback, error) {
      var path = '/scanner/list.do';
      var url = addrPre + path;
      var param = { orderName: orderName, orderType: orderType, mechanismId: mechanismId, page: page, rows: rows, terminalNo: terminalNo, terminalStatus: terminalStatus, activeStatus: activeStatus, snBegin: snBegin, snEnd: snEnd };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$addNonDv = function (terminalNo, terminalName, manufId, mechanismId, address, terminalType, terminalModel, memo, callback, error) {
      var path = '/scanner/add.do';
      var url = addrPre + path;
      var param = { memo: memo, terminalModel: terminalModel, terminalType: terminalType, manufId: manufId, mechanismId: mechanismId, terminalName: terminalName, terminalNo: terminalNo, address: address };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$editNonDv = function (id, terminalNo, terminalName, manufId, mechanismId, address, terminalType, terminalModel, memo, callback, error) {
      var path = '/scanner/edit.do';
      var url = addrPre + path;
      var param = { id: id, memo: memo, terminalModel: terminalModel, terminalType: terminalType, manufId: manufId, mechanismId: mechanismId, terminalName: terminalName, terminalNo: terminalNo, address: address };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$delNonieDv = function (ids, callback, error) {
      var path = '/scanner/delete.do';
      var url = addrPre + path;
      var param = { ids: ids };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$noniteqDetail = function (id, callback, error) {
      var path = '/scanner/detail.do';
      var url = addrPre + path;
      var param = { id: id };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$getWarnList = function (page, rows, lockStatus, distributorId, terminalNo, event_type, orderName, orderType, callback, error) {
      var path = '/risk/listBywarning.do';
      var url = addrPre + path;
      var param = { orderType: orderType, orderName: orderName, lockStatus: lockStatus, page: page, rows: rows, distributorId: distributorId, terminalNo: terminalNo, event_type: event_type };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$getWarnDetail = function (id, callback, error) {
      var path = '/risk/getWarning.do';
      var url = addrPre + path;
      var param = { id: id };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$killwarn = function (id, callback, error) {
      var path = '/risk/operation.do';
      var url = addrPre + path;
      var param = { id: id };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$unlockDevice = function (terminalNo, callback, error) {
      var path = '/risk/unlock.do';
      var url = addrPre + path;
      var param = { terminalNo: terminalNo };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$lockDevice = function (terminalNo, callback, error) {
      var path = '/risk/locking.do';
      var url = addrPre + path;
      var param = { terminalNo: terminalNo };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$setFenceBind = function (riskId, terminalId, status, callback, error) {
      var path = '/risk/bindingTerminal.do';
      var url = addrPre + path;
      var param = { riskId: riskId, terminalId: terminalId, status: status };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$editConfigMenu = function (obj, callback, error) {
      var path = '/menu/editMenu.do';
      var url = addrPre + path;
      var param = { "menuId": obj.menuId, "menuName": obj.name, "url": obj.url, "menuIcon": obj.icon };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$terHisPath = function (terminalNo, callback, error) {
      var path = '/terminal/getTerminalTrack.do';
      var url = addrPre + path;
      var param = { terminalNo: terminalNo };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$editMenuPosition = function (subId, sortNo, callback, error) {
      var path = '/menu/editSort.do';
      var url = addrPre + path;
      var param = { subId: subId, sortNo: sortNo };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$gpFirm = function (distributorId, callback, error) {
      var path = '/manufacturers/category_list.do';
      var url = addrPre + path;
      var param = { distributorId: distributorId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$gpDvType = function (distributorId, callback, error) {
      var path = '/terminalType/category_list.do';
      var url = addrPre + path;
      var param = { distributorId: distributorId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$gpDvModel = function (distributorId, callback, error) {
      var path = '/terminalModel/category_list.do';
      var url = addrPre + path;
      var param = { distributorId: distributorId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$gpAppType = function (mechId, callback, error) {
      var path = '/appType/category_list.do';
      var url = addrPre + path;
      var param = { mechId: mechId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$gpAdType = function (callback, error) {
      var path = '/adType/category_list.do';
      var url = addrPre + path;
      var param = {};
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$mechGetTypes = function (id, callback, error) {
      var path = '/mechanism/baseInfo.do';
      var url = addrPre + path;
      var param = { id: id };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$acMcFindApptype = function (mechId, callback, error) {
      var path = '/appType/categoryByMech.do';
      var url = addrPre + path;
      var param = { mechId: mechId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$terBindApp = function (appId, terminalNo, callback, error) {
      var path = '/task_manage/ter_app_bind.do';
      var url = addrPre + path;
      var param = { appId: appId, terminalNo: terminalNo };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$getDvSetting = function (callback, error) {
      var path = '/sysConfig/getTerminalConfig.do';
      var url = addrPre + path;
      var param = {};
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$setDvSetting = function (id, value, callback, error) {
      var path = '/sysConfig/editTerminalConfig.do';
      var url = addrPre + path;
      var param = { id: id, value: value };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$logList = function (page, rows, beginTime, endTime, type, userName, content, orderName, orderType, callback, error) {
      var path = '/history/list.do';
      var url = addrPre + path;
      var param = { orderType: orderType, orderName: orderName, content: content, page: page, rows: rows, beginTime: beginTime, endTime: endTime, type: type, userName: userName };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$pushRepush = function (detailId, callback, error) {
      var path = '/task_manage/rePush.do';
      var url = addrPre + path;
      var param = { detailId: detailId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$pushHis = function (page, rows, pushType, pushName, callback, error) {
      var path = '/push_manage/history_task_list.do';
      var url = addrPre + path;
      var param = { page: page, rows: rows, pushType: pushType, pushName: pushName };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$pushHisDetail = function (page, rows, fileId, version, terminalName, status, taskType, callback, error) {
      var path = '/push_manage/history_detail_list.do';
      var url = addrPre + path;
      var param = { page: page, rows: rows, fileId: fileId, version: version, terminalName: terminalName, status: status, taskType: taskType };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$addPush = function (installType, autoOpen, objId, taskType, pushType, terminalNos, mechId, terminalStatus, terminalNo, fileNo, callback, error) {
      var path = '/push_manage/push.do';
      var url = addrPre + path;
      var param = { installType: installType, autoOpen: autoOpen, objId: objId, taskType: taskType, pushType: pushType, terminalNos: terminalNos, mechId: mechId, terminalStatus: terminalStatus, terminalNo: terminalNo, fileNo: fileNo };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$appBatchPush = function (appIds, installType, autoOpen, pushType, terminalNos, mechId, terminalStatus, terminalNo, fileNo, callback, error) {
      var path = '/push_manage/appsPush.do';
      var url = addrPre + path;
      var param = { appIds: appIds, installType: installType, autoOpen: autoOpen, pushType: pushType, terminalNos: terminalNos, mechId: mechId, terminalStatus: terminalStatus, terminalNo: terminalNo, fileNo: fileNo };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$isCoverPush = function (taskId, pushParam, isCover, callback, error) {
      var path = '/push_manage/confirm_push.do';
      var url = addrPre + path;
      var param = { taskId: taskId, pushParam: pushParam, isCover: isCover };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$pushDownCtrl = function (taskId, id, status, terminalNo, callback, error) {
      var path = '/push_manage/download_ctrl.do';
      var url = addrPre + path;
      var param = { taskId: taskId, id: id, status: status, terminalNo: terminalNo };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$pushList = function (page, rows, pushType, pushName, callback, error) {
      var path = '/push_manage/list.do';
      var url = addrPre + path;
      var param = { page: page, rows: rows, pushType: pushType, pushName: pushName };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$pushFileDetail = function (taskId, callback, error) {
      var path = '/push_manage/file_detail.do';
      var url = addrPre + path;
      var param = { taskId: taskId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$pushTaskDetail = function (orderName, orderType, terminalName, status, page, rows, taskId, callback, error) {
      var path = '/task_manage/detail_list.do';
      var url = addrPre + path;
      var param = { orderName: orderName, orderType: orderType, terminalName: terminalName, status: status, page: page, rows: rows, taskId: taskId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$pushFileDownCtrl = function (id, status, terminalNo, callback, error) {
      var path = '/task_manage/download_ctrl.do';
      var url = addrPre + path;
      var param = { id: id, status: status, terminalNo: terminalNo };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$pushDelTask = function (ids, callback, error) {
      var path = '/task_manage/del_terminal.do';
      var url = addrPre + path;
      var param = { ids: ids };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$pTaskDelall = function (taskIds, callback, error) {
      var path = '/task_manage/del_task.do';
      var url = addrPre + path;
      var param = { ids: taskIds };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$canPushTer = function (page, rows, fileMechId, mechId, terminalStatus, terminalNo, fileType, fileId, callback, error) {
      var path = '/push_manage/push_terList.do';
      var url = addrPre + path;
      var param = { fileId: fileId, fileType: fileType, page: page, rows: rows, fileMechId: fileMechId, mechId: mechId, terminalStatus: terminalStatus, terminalNo: terminalNo };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$pushedTerList = function (page, rows, fileId, callback, error) {
      var path = '/push_manage/success_list.do';
      var url = addrPre + path;
      var param = { page: page, rows: rows, fileId: fileId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$pushCallback = function (fileNo, status, progress, callback, error) {
      var path = '/terminalManagement/monitor/retStatus.do';
      var url = addrPre + path;
      var param = { fileNo: fileNo, status: status, progress: progress };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$launcherList = function (page, rows, launcherName, distributorId, orderName, orderType, status, callback, error) {
      var path = '/launcher/listLauncher.do';
      var url = addrPre + path;
      var param = { orderName: orderName, orderType: orderType, page: page, rows: rows, launcherName: launcherName, distributorId: distributorId, status: status };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$channelOrders = function (page, rows, orderNo, customerName, callback, error) {
      var path = '/support/listOrder.do';
      var url = addrPre + path;
      var param = { page: page, rows: rows, orderNo: orderNo, customerName: customerName };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$channelCers = function (page, rows, customerName, callback, error) {
      var path = '/support/list.do';
      var url = addrPre + path;
      var param = { page: page, rows: rows, customerName: customerName };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$fstTest = function (id, terminalNo, callback, error) {
      var path = '/profilesManage/push.do';
      var url = addrPre + path;
      var param = { id: id, terminalNo: terminalNo };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$fstList = function (page, rows, name, callback, error) {
      var path = '/profilesManage/list.do';
      var url = addrPre + path;
      var param = { page: page, rows: rows, name: name };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$fstHisList = function (page, rows, profilesId, callback, error) {
      var path = '/profilesManage/recordList.do';
      var url = addrPre + path;
      var param = { page: page, rows: rows, profilesId: profilesId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$fstVList = function (page, rows, callback, error) {
      var path = '/profilesManage/auditList.do';
      var url = addrPre + path;
      var param = { page: page, rows: rows };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$addFst = function (ftpFileName, updateType, id, name, version, flag, curl, key, md5, size, appPackage, memo, callback, error) {
      var path = '/profilesManage/add.do';
      var url = addrPre + path;
      var param = { ftpFileName: ftpFileName, updateType: updateType, id: id, name: name, version: version, flag: flag, url: curl, key: key, md5: md5, size: size, appPackage: appPackage, memo: memo };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$editFst = function (ftpFileName, updateType, id, profilesId, name, version, flag, curl, key, md5, size, appPackage, memo, callback, error) {
      var path = '/profilesManage/edit.do';
      var url = addrPre + path;
      var param = { ftpFileName: ftpFileName, updateType: updateType, id: id, name: name, profilesId: profilesId, version: version, flag: flag, url: curl, key: key, md5: md5, size: size, appPackage: appPackage, memo: memo };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$delFst = function (ids, callback, error) {
      var path = '/profilesManage/delete.do';
      var url = addrPre + path;
      var param = { ids: ids };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$delFstRecord = function (ids, callback, error) {
      var path = '/profilesManage/deleteRecord.do';
      var url = addrPre + path;
      var param = { ids: ids };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$getFstDetail = function (id, callback, error) {
      var path = '/profilesManage/detail.do';
      var url = addrPre + path;
      var param = { id: id };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$syscflist = function (page, rows, name, callback, error) {
      var path = '/sysConfig/configList.do';
      var url = addrPre + path;
      var param = { page: page, rows: rows, name: name };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$repushFailSyscf = function (rePushId, callback, error) {
      var path = '/sysConfig/rePush.do';
      var url = addrPre + path;
      var param = { rePushId: rePushId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$delSyscfBindDv = function (ids, callback, error) {
      var path = '/sysConfig/delDevice.do';
      var url = addrPre + path;
      var param = { ids: ids };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$syscfBindlist = function (configId, page, rows, terminalNo, mechId, callback, error) {
      var path = '/sysConfig/pushList.do';
      var url = addrPre + path;
      var param = { configId: configId, page: page, rows: rows, terminalNo: terminalNo, mechId: mechId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$addSyscf = function (configName, address, port, callback, error) {
      var path = '/sysConfig/addSysConfig.do';
      var url = addrPre + path;
      var param = { configName: configName, address: address, port: port };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$editSyscf = function (id, configName, address, port, callback, error) {
      var path = '/sysConfig/editSysConfig.do';
      var url = addrPre + path;
      var param = { id: id, configName: configName, address: address, port: port };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$syscfDetail = function (id, callback, error) {
      var path = '/sysConfig/configDetail.do';
      var url = addrPre + path;
      var param = { id: id };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$delSyscf = function (ids, callback, error) {
      var path = '/sysConfig/delSysConfig.do';
      var url = addrPre + path;
      var param = { ids: ids };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$verifyFst = function (id, content, status, callback, error) {
      var path = '/profilesManage/audit.do';
      var url = addrPre + path;
      var param = { id: id, content: content, status: status };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$mdOpQuery = function (terminalNo, callback, error) {
      var path = '/ter_cmd/modelLogs.do';
      var url = addrPre + path;
      var param = { terminalNo: terminalNo };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$funcOpQuery = function (terminalNo, modelName, callback, error) {
      var path = '/ter_cmd/methodLogs.do';
      var url = addrPre + path;
      var param = { terminalNo: terminalNo, modelName: modelName };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$unbindDevices = function (page, rows, areaid, riskId, terminal_status, terminal_no, callback, error) {
      var path = '/risk/terminal_list.do';
      var url = addrPre + path;
      var param = { areaid: areaid, page: page, rows: rows, riskId: riskId, terminal_status: terminal_status, terminal_no: terminal_no };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$tradeList = function (page, rows, terminalNo, mercId, callback, error) {
      var path = '/trading/list.do';
      var url = addrPre + path;
      var param = { terminalNo: terminalNo, page: page, rows: rows, mercId: mercId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$exportTrans = function (mcID, termID, type, trId, terminalNo) {
      var token = localStorage.user ? localStorage.user : '';
      var url = addrPre + ('/trading/export.do?mcID=' + mcID + '&language=') + localStorage.system_lang + ('&termID=' + termID + '&type=' + type + '&trId=' + trId + '&terminalNo=' + terminalNo + '&token=' + token);

      window.open(url, '_blank');
    };

    Vue.prototype.$videoList = function (distributorId, page, rows, videoName, status, callback, error) {
      var path = '/video/list.do';
      var url = addrPre + path;
      var param = { distributorId: distributorId, page: page, rows: rows, videoName: videoName, status: status };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$defaultVideoList = function (distributorId, page, rows, videoName, callback, error) {
      var path = '/video/listDefault.do';
      var url = addrPre + path;
      var param = { distributorId: distributorId, page: page, rows: rows, videoName: videoName };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$verifyVideo = function (videoId, status, refuseReason, callback, error) {
      var path = '/video/check.do';
      var url = addrPre + path;
      var param = { videoId: videoId, status: status, refuseReason: refuseReason };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$delVideo = function (videoId, callback, error) {
      var path = '/video/delete.do';
      var url = addrPre + path;
      var param = { videoId: videoId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$submitVideo = function (videoId, callback, error) {
      var path = '/video/subcheck.do';
      var url = addrPre + path;
      var param = { videoId: videoId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$addVideo = function (videoName, curl, duration, distributorId, size, hash, sTime, eTime, dimension, callback, error) {
      var path = '/video/add.do';
      var url = addrPre + path;
      var param = { videoName: videoName, url: curl, duration: duration, distributorId: distributorId, size: size, hash: hash, sTime: sTime, eTime: eTime, dimension: dimension };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$addDefaultVideo = function (videoName, curl, duration, distributorId, size, hash, dimension, callback, error) {
      var path = '/video/addDefault.do';
      var url = addrPre + path;
      var param = { videoName: videoName, url: curl, duration: duration, distributorId: distributorId, size: size, hash: hash, dimension: dimension };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$editVideo = function (videoId, videoName, curl, duration, size, hash, sTime, eTime, dimension, callback, error) {
      var path = '/video/edit.do';
      var url = addrPre + path;
      var param = { videoId: videoId, videoName: videoName, url: curl, duration: duration, size: size, hash: hash, sTime: sTime, eTime: eTime, dimension: dimension };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$pushRecords = function (page, rows, pushName, objectId, callback, error) {
      var path = '/push_task/push_record.do';
      var url = addrPre + path;
      var param = { page: page, rows: rows, pushName: pushName, objectId: objectId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$repush = function (pushType, opeTime, objectId, callback, error) {
      var path = '/push_task/re_push.do';
      var url = addrPre + path;
      var param = { pushType: pushType, opeTime: opeTime, objectId: objectId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$launchVerifyList = function (page, rows, distributorId, orderName, orderType, callback, error) {
      var path = '/launcher/listCheck.do';
      var url = addrPre + path;
      var param = { orderName: orderName, orderType: orderType, page: page, rows: rows, distributorId: distributorId };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$addLauncher = function (md5, launcherName, launcherDesc, launcherImg, launcherUrl, packageName, version, versionCode, appSize, distributorId, callback, error) {
      var path = '/launcher/addLauncher.do';
      var url = addrPre + path;
      var param = { md5: md5, launcherName: launcherName, launcherDesc: launcherDesc, launcherImg: launcherImg, launcherUrl: launcherUrl, packageName: packageName, version: version, versionCode: versionCode, appSize: appSize, distributorId: distributorId };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$editLauncher = function (md5, launcherName, launcherDesc, launcherImg, launcherUrl, packageName, version, versionCode, appSize, launcherId, callback, error) {
      var path = '/launcher/editLauncher.do';
      var url = addrPre + path;
      var param = { md5: md5, launcherName: launcherName, launcherDesc: launcherDesc, launcherImg: launcherImg, launcherUrl: launcherUrl, packageName: packageName, version: version, versionCode: versionCode, appSize: appSize, launcherId: launcherId };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$delLauncher = function (launcherId, status, callback, error) {
      var path = '/launcher/deleteLauncher.do';
      var url = addrPre + path;
      var param = { launcherId: launcherId, status: status };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$delLauncherHistory = function (versionId, callback, error) {
      var path = '/launcher/deleteVersion.do';
      var url = addrPre + path;
      var param = { versionId: versionId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$pushLauncher = function (launcherId, terminalNo, distributorId, callback, error) {
      var path = '/launcher/push.do';
      var url = addrPre + path;
      var param = { launcherId: launcherId, terminalNo: terminalNo, distributorId: distributorId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$resetLauncher = function (packageName, terminalNo, callback, error) {
      var path = '/launcher/reduction.do';
      var url = addrPre + path;
      var param = { packageName: packageName, terminalNo: terminalNo };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$getLauncherDevices = function (page, rows, launcherId, distributorId, packageName, callback, error) {
      var path = '/launcher/listTerminalBylauncher.do';
      var url = addrPre + path;
      var param = { page: page, rows: rows, launcherId: launcherId, distributorId: distributorId, packageName: packageName };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$submitLauncher = function (launcherId, callback, error) {
      var path = '/launcher/submitCheck.do';
      var url = addrPre + path;
      var param = { launcherId: launcherId };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$launcherHistory = function (launcherId, callback, error) {
      var path = '/launcher/listVersion.do';
      var url = addrPre + path;
      var param = { launcherId: launcherId };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$verifyLauncher = function (launcherId, refuseReason, status, versionCode, callback, error) {
      var path = '/launcher/check.do';
      var url = addrPre + path;
      var param = { launcherId: launcherId, refuseReason: refuseReason, status: status, versionCode: versionCode };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$updateLauncher = function (md5, launcherName, launcherDesc, launcherImg, launcherUrl, packageName, version, versionCode, appSize, launcherId, distributorId, callback, error) {
      var path = '/launcher/uploadVersion.do';
      var url = addrPre + path;
      var param = { md5: md5, launcherName: launcherName, launcherDesc: launcherDesc, launcherImg: launcherImg, launcherUrl: launcherUrl, packageName: packageName, version: version, versionCode: versionCode, appSize: appSize, launcherId: launcherId, distributorId: distributorId };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$pushLauncherList = function (page, rows, distributorId, terminal_no, terminal_status, terminal_runtime_status, launcherId, callback, error) {
      var path = '/launcher/listTerminalNolauncher.do';
      var url = addrPre + path;
      var param = { page: page, rows: rows, distributorId: distributorId, terminal_no: terminal_no, terminal_status: terminal_status, terminal_runtime_status: terminal_runtime_status, launcherId: launcherId };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$getChannelCer = function (distributorId, callback, error) {
      var path = '/support/listCertificate.do';
      var url = addrPre + path;
      jsonRqes(url, { distributorId: distributorId }, callback, error);
    };

    Vue.prototype.$getMcTypeInfo = function (mid, callback, error) {
      var path = '/mechanism/baseInfo.do';
      var url = addrPre + path;
      jsonRqes(url, { id: mid }, callback, error);
    };

    Vue.prototype.$importLineCer = function (id, distributorId, callback, error) {
      var path = '/support/importCertificate.do';
      var url = addrPre + path;
      jsonRqes(url, { distributorId: distributorId, id: id }, callback, error);
    };

    Vue.prototype.$delcer = function (id, callback, error) {
      var path = '/cer/deleteCertificate.do';
      var url = addrPre + path;
      jsonRqes(url, { id: id }, callback, error);
    };

    Vue.prototype.$importLineOrder = function (orderNo, distributorId, manufid, terminal_type, terminal_model, terminal_address, callback, error) {
      var path = '/support/importTerminalByOrder.do';
      var url = addrPre + path;
      jsonRqes(url, { manufid: manufid, terminal_type: terminal_type, terminal_model: terminal_model, terminal_address: terminal_address, distributorId: distributorId, orderNo: orderNo }, callback, error);
    };

    Vue.prototype.$uploadCer = function (cer_url, privkey_url, certificateId, certificateName, certificateDesc, distributorId, callback, error) {
      var path = '/cer/addCertificate.do';
      var url = addrPre + path;
      var param = { privkey_url: privkey_url, cer_url: cer_url, certificateId: certificateId, certificateName: certificateName, certificateDesc: certificateDesc, distributorId: distributorId };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$addAnimate = function (md5, animatName, animatType, position, animatUrl, size, speed, times, logoUrl, callback, error) {
      var path = '/boot_animat/makeAnimat.do';
      var url = addrPre + path;
      var param = { md5: md5, animatName: animatName, animatType: animatType, position: position, animatUrl: animatUrl, size: size, speed: speed, times: times, logoUrl: logoUrl };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$delAnimate = function (animatId, callback, error) {
      var path = '/boot_animat/delAnimat.do';
      var url = addrPre + path;
      jsonRqes(url, { animatId: animatId }, callback, error);
    };

    Vue.prototype.$pushAnimate = function (terminalNo, type, fileNo, memo, mechanismId, animatId, callback, error) {
      var path = '/boot_animat/addTerAnimat.do';
      var url = addrPre + path;
      var param = { terminalNo: terminalNo, type: type, fileNo: fileNo, memo: memo, mechanismId: mechanismId, animatId: animatId };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$getPushHistory = function (param, callback, error) {
      var path = '/push_manage/success_list.do';
      var url = addrPre + path;
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$pushAnimateHistory = function (animatId, callback, error) {
      var path = '/boot_animat/terAnimatList.do';
      var url = addrPre + path;
      jsonRqes(url, { animatId: animatId }, callback, error);
    };

    Vue.prototype.$delAnimatePushHis = function (mechanismId, animatId, callback, error) {
      var path = '/boot_animat/delTerAnimat.do';
      var url = addrPre + path;
      jsonRqes(url, { animatId: animatId, mechanismId: mechanismId }, callback, error);
    };

    Vue.prototype.$getChannelDevices = function (mechanismId, callback, error) {
      var path = '/terminal/terNums.do';
      var url = addrPre + path;
      var param = { mechanismId: mechanismId };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$animateList = function (rows, page, callback, error) {
      var path = '/boot_animat/animatList.do';
      var url = addrPre + path;
      jsonRqes(url, { rows: rows, page: page }, callback, error);
    };

    Vue.prototype.$getFirmList = function (rows, page, orderName, orderType, callback, error) {
      var path = '/manufacturers/list.do';
      var url = addrPre + path;
      var param = { rows: rows, page: page, orderName: orderName, orderType: orderType };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$deleteFirm = function (ids, callback, error) {
      var path = '/manufacturers/delete.do';
      var url = addrPre + path;
      jsonRqes(url, { ids: ids }, callback, error);
    };

    Vue.prototype.$addFirm = function (name, contacts, telephone, address, callback, error) {
      var path = '/manufacturers/add.do';
      var url = addrPre + path;

      jsonRqes(url, { name: name, contacts: contacts, telephone: telephone, address: address }, callback, error);
    };

    Vue.prototype.$editFirm = function (id, name, contacts, telephone, address, createTime, callback, error) {
      var path = '/manufacturers/edit.do';
      var url = addrPre + path;

      jsonRqes(url, { id: id, name: name, contacts: contacts, telephone: telephone, address: address, createTime: createTime }, callback, error);
    };

    Vue.prototype.$deviceType = function (rows, page, orderName, orderType, callback, error) {
      var path = '/terminalType/list.do';
      var url = addrPre + path;
      var param = { orderType: orderType, orderName: orderName, rows: rows, page: page };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$addDeviceType = function (name, callback, error) {
      var path = '/terminalType/add.do';
      var url = addrPre + path;
      jsonRqes(url, { name: name }, callback, error);
    };

    Vue.prototype.$editDeviceType = function (id, name, callback, error) {
      var path = '/terminalType/edit.do';
      var url = addrPre + path;
      jsonRqes(url, { id: id, name: name }, callback, error);
    };

    Vue.prototype.$delDeviceType = function (ids, callback, error) {
      var path = '/terminalType/delete.do';
      var url = addrPre + path;
      var param = { ids: ids };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$deviceNo = function (rows, page, orderName, orderType, callback, error) {
      var path = '/terminalModel/list.do';
      var url = addrPre + path;
      var param = { rows: rows, page: page, orderName: orderName, orderType: orderType };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$addDeviceNo = function (name, callback, error) {
      var path = '/terminalModel/add.do';
      var url = addrPre + path;
      jsonRqes(url, { name: name }, callback, error);
    };

    Vue.prototype.$delDeviceNo = function (ids, callback, error) {
      var path = '/terminalModel/delete.do';
      var url = addrPre + path;
      var param = { ids: ids };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$editDeviceNo = function (id, name, callback, error) {
      var path = '/terminalModel/edit.do';
      var url = addrPre + path;
      var param = { id: id, name: name };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$adTypeList = function (rows, page, orderName, orderType, callback, error) {
      var path = '/adType/list.do';
      var url = addrPre + path;
      var param = { orderType: orderType, orderName: orderName, rows: rows, page: page };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$addAdType = function (name, callback, error) {
      var path = '/adType/add.do';
      var url = addrPre + path;
      jsonRqes(url, { name: name }, callback, error);
    };

    Vue.prototype.$delAdType = function (ids, callback, error) {
      var path = '/adType/delete.do';
      var url = addrPre + path;
      var param = { ids: ids };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$editAdType = function (id, name, callback, error) {
      var path = '/adType/edit.do';
      var url = addrPre + path;
      var param = { id: id, name: name };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$pspList = function (data, callback, error) {
      var path = '/pspApp/list.do';
      var url = addrPre + path;
      var data = data;

      jsonRqes(url, data, callback, error);
    };

    Vue.prototype.$addPsp = function (data, callback, error) {
      var path = '/pspApp/add.do';
      var url = addrPre + path;
      var data = data;

      jsonRqes(url, data, callback, error);
    };

    Vue.prototype.$editPsp = function (data, callback, error) {
      var path = '/pspApp/edit.do';
      var url = addrPre + path;
      var data = data;

      jsonRqes(url, data, callback, error);
    };

    Vue.prototype.$delPsp = function (ids, callback, error) {
      var path = '/pspApp/delete.do';
      var url = addrPre + path;
      var param = { ids: ids };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$pspUpdateList = function (data, callback, error) {
      var path = '/pspApp/updateList.do';
      var url = addrPre + path;
      var data = data;

      jsonRqes(url, data, callback, error);
    };

    Vue.prototype.$pspUnList = function (data, callback, error) {
      var path = '/pspUninstallApp/list.do';
      var url = addrPre + path;
      var data = data;

      jsonRqes(url, data, callback, error);
    };

    Vue.prototype.$pspUnPush = function (data, callback, error) {
      var path = '/pspUninstallApp/push.do';
      var url = addrPre + path;
      var data = data;

      jsonRqes(url, data, callback, error);
    };

    Vue.prototype.$delUnPsp = function (ids, callback, error) {
      var path = '/pspUninstallApp/delete.do';
      var url = addrPre + path;
      var param = { ids: ids };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$delUnPspAll = function (data, callback, error) {
      var path = '/pspUninstallApp/delAll.do';
      var url = addrPre + path;
      var data = data;
      jsonRqes(url, data, callback, error);
    };

    Vue.prototype.$changePspList = function (data, callback, error) {
      var path = '/pspChangeApp/list.do';
      var url = addrPre + path;
      var data = data;

      jsonRqes(url, data, callback, error);
    };

    Vue.prototype.$changePspAdd = function (data, callback, error) {
      var path = '/pspChangeApp/add.do';
      var url = addrPre + path;
      var data = data;

      jsonRqes(url, data, callback, error);
    };

    Vue.prototype.$delChangePsp = function (ids, callback, error) {
      var path = '/pspChangeApp/delete.do';
      var url = addrPre + path;
      var param = { ids: ids };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$changePspDeviceList = function (data, callback, error) {
      var path = '/pspChangeApp/pushList.do';
      var url = addrPre + path;
      var data = data;
      jsonRqes(url, data, callback, error);
    };

    Vue.prototype.$changePspPush = function (data, callback, error) {
      var path = '/pspChangeApp/push.do';
      var url = addrPre + path;
      var data = data;
      jsonRqes(url, data, callback, error);
    };

    Vue.prototype.$changePspDel = function (ids, callback, error) {
      var path = '/pspChangeApp/deleteTask.do';
      var url = addrPre + path;
      var param = { ids: ids };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$changePspDelAll = function (data, callback, error) {
      var path = '/pspChangeApp/delAllTask.do';
      var url = addrPre + path;
      var data = data;
      jsonRqes(url, data, callback, error);
    };

    Vue.prototype.$appTypeList = function (rows, page, orderName, orderType, callback, error) {
      var path = '/appType/list.do';
      var url = addrPre + path;
      var param = { orderName: orderName, orderType: orderType, rows: rows, page: page };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$addAppType = function (name, callback, error) {
      var path = '/appType/add.do';
      var url = addrPre + path;
      jsonRqes(url, { name: name }, callback, error);
    };

    Vue.prototype.$delAppType = function (ids, callback, error) {
      var path = '/appType/delete.do';
      var url = addrPre + path;
      var param = { ids: ids };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$editAppType = function (id, name, callback, error) {
      var path = '/appType/edit.do';
      var url = addrPre + path;
      var param = { id: id, name: name };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$delTaskDevice = function (data, callback, error) {
      var path = '/task_manage/delAll.do';
      var url = addrPre + path;
      var data = data;
      jsonRqes(url, data, callback, error);
    };

    Vue.prototype.$missionList = function (rows, page, userId, mechId, taskName, callback, error) {
      var path = '/push_task/countList.do';
      var url = addrPre + path;
      var param = { rows: rows, page: page, userId: userId, mechId: mechId, taskName: taskName };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$pushTaskList = function (rows, page, terminalNo, taskType, fileName, callback, error) {
      var path = '/task_manage/ter_task_list.do';
      var url = addrPre + path;
      var param = { rows: rows, page: page, terminalNo: terminalNo, taskType: taskType, fileName: fileName };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$missionDetail = function (fileName, rows, page, pushName, terminalNo, status, mechanismId, callback, error) {
      var path = '/push_task/detailList.do';
      var url = addrPre + path;
      var param = { fileName: fileName, rows: rows, page: page, pushName: pushName, terminalNo: terminalNo, status: status, mechanismId: mechanismId };
      console.log(url, param);
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$missionPersent = function (fileNo, callback, error) {
      var path = '/terminalManagement/getProgress.do';
      var url = addrPre + path;
      var param = { fileNo: fileNo };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$delMission = function (ids, callback, error) {
      var path = '/push_task/delete.do';
      var url = addrPre + path;
      var param = { ids: ids };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$missionOperate = function (terminalNo, id, status, callback, error) {
      var path = '/push_task/download.do';
      var url = addrPre + path;

      var param = { id: id, status: status, terminalNo: terminalNo };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$getDvDevices = function (page, row, areaid, tNo, tStatus, tRunTimeStatus, orderType, time_orderType, snBegin, snEnd, callback, error) {
      var url = __WEBPACK_IMPORTED_MODULE_1__api_url_js__["e" /* wUrl */].host + __WEBPACK_IMPORTED_MODULE_1__api_url_js__["e" /* wUrl */].port + __WEBPACK_IMPORTED_MODULE_1__api_url_js__["e" /* wUrl */].path + '/terminal/list.do';
      var param = { time_orderType: time_orderType, orderType: orderType, page: page, rows: row, areaid: areaid, terminal_no: tNo, terminal_status: tStatus, terminal_runtime_status: tRunTimeStatus, snBegin: snBegin, snEnd: snEnd };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$get_device_list = function (page, row, secretKeyDownload, secretKeyExist, areaid, tNo, tStatus, tRunTimeStatus, orderType, time_orderType, callback, error) {
      var url = __WEBPACK_IMPORTED_MODULE_1__api_url_js__["e" /* wUrl */].host + __WEBPACK_IMPORTED_MODULE_1__api_url_js__["e" /* wUrl */].port + __WEBPACK_IMPORTED_MODULE_1__api_url_js__["e" /* wUrl */].path + '/kmc/terminalList.do';
      var param = { time_orderType: time_orderType, orderType: orderType, page: page, rows: row, secretKeyDownload: secretKeyDownload, secretKeyExist: secretKeyExist, areaid: areaid, terminalNo: tNo, status: tStatus, terminal_runtime_status: tRunTimeStatus };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$getDevices = function (page, row, areaid, tNo, tStatus, tRunTimeStatus, appId, callback, error) {
      var url = __WEBPACK_IMPORTED_MODULE_1__api_url_js__["e" /* wUrl */].host + __WEBPACK_IMPORTED_MODULE_1__api_url_js__["e" /* wUrl */].port + __WEBPACK_IMPORTED_MODULE_1__api_url_js__["e" /* wUrl */].path + '/appDistribute/terminalList.do';
      var param = { page: page, rows: row, areaid: areaid, terminal_no: tNo, terminal_status: tStatus, terminal_runtime_status: tRunTimeStatus, appId: appId };


      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$getDevices1 = function (page, row, areaid, tNo, tStatus, tRunTimeStatus, appId, callback, error) {
      var url = appUrlPre + '/appDistribute/getTerminalList.do';
      var param = { page: page, rows: row, areaid: areaid, terminal_no: tNo, terminal_status: tStatus, terminal_runtime_status: tRunTimeStatus, appId: appId };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$getTerInstallList = function (page, rows, distributorId, appName, terminalId, callback, error) {
      var url = appUrlPre + '/appDistribute/getTerminalAppList.do';
      var param = { page: page, rows: rows, distributorId: distributorId, terminalId: terminalId, appName: appName };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$parentChannel = function (page, rows, callback, error) {
      var path = '/mechanism/parent_list.do';
      var url = addrPre + path;
      var param = { page: page, rows: rows };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$getMcDetail = function (id, callback, error) {
      var path = '/mechanism/detail.do';
      var url = addrPre + path;
      var param = { id: id };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$getChannelList = function (rows, page, mechId, certType, mechanismName, callback, error) {
      var path = '/mechanism/list.do';
      var url = addrPre + path;
      var param = { mechId: mechId, rows: rows, page: page, certType: certType, mechanismName: mechanismName };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$deleteChannel = function (ids, callback, error) {
      var path = '/mechanism/delete.do';
      var url = addrPre + path;
      var param = { ids: ids };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$addChannel = function (certType, superId, mechanismGrade, mechanismName, mechanismAddre, completeName, mechanismCode, memo, callback, error) {
      var path = '/mechanism/add.do';
      var url = addrPre + path;
      var param = { certType: certType, mechanismName: mechanismName, mechanismAddre: mechanismAddre, memo: memo, completeName: completeName, mechanismCode: mechanismCode, superId: superId, mechanismGrade: mechanismGrade };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$editChannel = function (certType, id, mechanismName, superId, mechanismGrade, mechanismAddre, memo, completeName, mechanismCode, callback, error) {
      var path = '/mechanism/edit.do';
      var url = addrPre + path;
      var param = { certType: certType, id: id, mechanismName: mechanismName, superId: superId, mechanismGrade: mechanismGrade, mechanismAddre: mechanismAddre, memo: memo, completeName: completeName, mechanismCode: mechanismCode };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$getAppTypeList = function (rows, page, callback, error) {
      var path = '/appType/list.do';
      var url = addrPre + path;
      jsonRqes(url, { rows: rows, page: page }, callback, error);
    };

    Vue.prototype.$getDeviceTypeList = function (rows, page, callback, error) {
      var path = '/ terminalType /list.do';
      var url = addrPre + path;
      jsonRqes(url, { rows: rows, page: page }, callback, error);
    };

    Vue.prototype.$getDistributeAppList = function (appName, appCategoryId, rows, page, distributorId, callback, error) {
      var path = '/appDistribute/list.do';
      var url = addrPre + path;
      var param = { rows: rows, page: page, distributorId: distributorId, appName: appName, appCategoryId: appCategoryId };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$getDistributeAppList1 = function (appName, appCategoryId, rows, page, distributorId, orderName, orderType, callback, error) {
      var path = '/appDistribute/list.do';
      var url = appUrlPre + path;
      var param = { orderType: orderType, orderName: orderName, rows: rows, page: page, distributorId: distributorId, appName: appName, appCategoryId: appCategoryId };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$appDetail = function (appId, callback, error) {
      var path = '/app/detail.do';

      var url = appUrlPre + path;
      var param = { appId: appId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$appMkDetail = function (appId, callback, error) {
      var path = '/appDistribute/detail.do';
      var url = appUrlPre + path;
      var param = { appId: appId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$recommendHome = function (distributorId, appId, isHome, callback, error) {
      var path = '/appDistribute/isHome.do';
      var url = addrPre + path;
      var param = { distributorId: distributorId, appId: appId, isHome: isHome };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$recommendHome1 = function (distributorId, appId, isHome, callback, error) {
      var path = '/appDistribute/isHome.do';
      var url = appUrlPre + path;
      var param = { distributorId: distributorId, appId: appId, isHome: isHome };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$recommendClass = function (distributorId, appId, isType, callback, error) {
      var path = '/appDistribute/isType.do';
      var url = addrPre + path;
      var param = { distributorId: distributorId, appId: appId, isType: isType };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$recommendClass1 = function (distributorId, appId, isType, callback, error) {
      var path = '/appDistribute/isType.do';
      var url = appUrlPre + path;
      var param = { distributorId: distributorId, appId: appId, isType: isType };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$getAppBindDevices = function (rows, page, packageName, appId, distributorId, callback, error) {
      var path = '/appDistribute/getAppBindList.do';
      var url = addrPre + path;
      var param = { packageName: packageName, rows: rows, page: page, appId: appId, distributorId: distributorId };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$getAppBindDevices1 = function (rows, page, packageName, appId, distributorId, callback, error) {
      var path = '/appDistribute/getAppBindList.do';
      var url = appUrlPre + path;
      var param = { packageName: packageName, rows: rows, page: page, appId: appId, distributorId: distributorId };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$bindApp = function (status, terminalId, appId, callback, error) {
      var path = '/appDistribute/bindApp.do';
      var url = addrPre + path;
      var param = { status: status, terminalId: terminalId, appId: appId };
      console.log(url, param);
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$bindApp1 = function (distributorId, terminalNo, appId, callback, error) {
      var path = '/appDistribute/bindApp.do';
      var url = appUrlPre + path;
      var param = { distributorId: distributorId, terminalNo: terminalNo, appId: appId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$unbind = function (terminalNo, version, packageName, callback, error) {
      var path = '/appDistribute/unbind.do';
      var url = appUrlPre + path;
      var param = { version: version, terminalNo: terminalNo, packageName: packageName };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$addAppToDistributeList = function (appId, distributorId, callback, error) {
      var path = '/appDistribute/addApptoMarket.do';
      var url = addrPre + path;
      var param = { appId: appId, distributorId: distributorId };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$addAppToDistributeList1 = function (appId, distributorId, callback, error) {
      var path = '/appDistribute/addApptoMarket.do';
      var url = appUrlPre + path;
      var param = { appId: appId, distributorId: distributorId };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$appDistributeOnOff = function (distributorId, packageName, status, callback, error) {
      var path = '/appDistribute/editGoodsshelves.do';
      var url = addrPre + path;
      jsonRqes(url, { distributorId: distributorId, packageName: packageName, status: status }, callback, error);
    };

    Vue.prototype.$appDistributeOnOff1 = function (distributorId, packageName, status, callback, error) {
      var path = '/appDistribute/editGoodsshelves.do';
      var url = appUrlPre + path;
      jsonRqes(url, { distributorId: distributorId, packageName: packageName, status: status }, callback, error);
    };

    Vue.prototype.$getFirmwareList = function (rows, page, mechanismId, firmwareName, type, status, callback, error) {
      var path = '/firmwareInfo/list.do';
      var url = addrPre + path;
      var param = { mechanismId: mechanismId, rows: rows, page: page, firmwareName: firmwareName, type: type, status: status };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$uploadFirmware = function (md5, mechanismName, mechanismId, firmwareName, type, iurl, version, callback, error) {
      var path = '/firmwareInfo/add.do';
      var url = addrPre + path;
      var param = { md5: md5, mechanismName: mechanismName, mechanismId: mechanismId, firmwareName: firmwareName, type: type, url: iurl, version: version };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$editFirmware = function (md5, id, firmwareName, iurl, version, type, mechanismId, mechanismName, callback, error) {
      var path = '/firmwareInfo/edit.do';
      var url = addrPre + path;
      var param = { md5: md5, id: id, firmwareName: firmwareName, url: iurl, version: version, type: type, mechanismId: mechanismId, mechanismName: mechanismName };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$deleteFirmware = function (ids, callback, error) {
      var path = '/firmwareInfo/delete.do';
      var url = addrPre + path;
      var param = { ids: ids };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$checkFirmware = function (firmwareId, content, status, callback, error) {
      var path = '/firmwareInfo/add_audit.do';
      var url = addrPre + path;
      var param = { firmwareId: firmwareId, content: content, status: status };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$pushFirmware = function (fileNo, firmwareId, type, targetId, callback, error) {
      var path = '/firmwareInfo/push.do';
      var url = addrPre + path;
      var param = { fileNo: fileNo, firmwareId: firmwareId, type: type, targetId: targetId };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$getAppList = function (rows, page, distributorId, appCategoryId, appName, appStatus, callback, error) {
      var path = '/app/list.do';
      var url = addrPre + path;
      var param = { distributorId: distributorId, rows: rows, page: page, appCategoryId: appCategoryId, appName: appName, appStatus: appStatus };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$getAppList1 = function (rows, page, distributorId, appCategoryId, appName, appStatus, orderName, orderType, packageName, callback, error) {
      var path = '/app/list.do';
      var url = appUrlPre + path;
      var param = { orderType: orderType, orderName: orderName, distributorId: distributorId, rows: rows, page: page, appCategoryId: appCategoryId, appName: appName, appStatus: appStatus, packageName: packageName };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$getDAppList = function (rows, page, appCategoryId, appName, appStatus, distributorId, appId, callback, error) {
      var path = '/appDistribute/getAppDistributeList.do';
      var url = addrPre + path;
      var param = { rows: rows, page: page, appCategoryId: appCategoryId, appName: appName, appStatus: appStatus, distributorId: distributorId };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$getDAppList1 = function (rows, page, appCategoryId, appName, appStatus, distributorId, appId, callback, error) {
      var path = '/appDistribute/getAppDistributeList.do';
      var url = appUrlPre + path;
      var param = { rows: rows, page: page, appCategoryId: appCategoryId, appName: appName, appStatus: appStatus, distributorId: distributorId };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$getAppCheckList = function (rows, page, appCategoryId, appName, appStatus, callback, error) {
      var path = '/app/listByCheck.do';
      var url = addrPre + path;
      jsonRqes(url, { rows: rows, page: page, appCategoryId: appCategoryId, appName: appName, appStatus: appStatus }, callback, error);
    };

    Vue.prototype.$getAppCheckList1 = function (rows, page, appCategoryId, appName, appStatus, callback, error) {
      var path = '/app/listByCheck.do';
      var url = appUrlPre + path;
      jsonRqes(url, { rows: rows, page: page, appCategoryId: appCategoryId, appName: appName, appStatus: appStatus }, callback, error);
    };

    Vue.prototype.$uploadApp = function (md5, distributorId, versionCode, packageName, appSize, appUrl, bigIcon, smallIcon, appCategoryId, desc, installType, appName, appScreenShot, appVersion, callback, error) {
      var path = '/app/add.do';
      var url = addrPre + path;
      var param = { md5: md5, distributorId: distributorId, versionCode: versionCode, packageName: packageName, appSize: appSize, appUrl: appUrl, bigIcon: bigIcon, smallIcon: smallIcon, appCategoryId: appCategoryId, desc: desc, installType: installType, appName: appName, appScreenShot: appScreenShot, appVersion: appVersion };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$uploadApp1 = function (md5, distributorId, versionCode, packageName, appSize, appUrl, bigIcon, smallIcon, appCategoryId, desc, installType, appName, appScreenShot, appVersion, callback, error) {
      var path = '/app/add.do';
      var url = appUrlPre + path;
      var param = { md5: md5, distributorId: distributorId, versionCode: versionCode, packageName: packageName, appSize: appSize, appUrl: appUrl, bigIcon: bigIcon, smallIcon: smallIcon, appCategoryId: appCategoryId, desc: desc, installType: installType, appName: appName, appScreenShot: appScreenShot, appVersion: appVersion };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$updateApp = function (md5, appSize, packageName, versionCode, smallIcon, bigIcon, appScreenShot, updateDesc, appId, appUrl, appVersion, isUpdate, distributorId, appName, appType, appDesc, callback, error) {
      var path = '/appDistribute/updateApp.do';
      var url = addrPre + path;
      var param = { md5: md5, appSize: appSize, packageName: packageName, distributorId: distributorId, appName: appName, appType: appType, appDesc: appDesc, versionCode: versionCode, smallIcon: smallIcon, bigIcon: bigIcon, appScreenShot: appScreenShot, updateDesc: updateDesc, appId: appId, appUrl: appUrl, appVersion: appVersion, isUpdate: isUpdate };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$updateApp1 = function (md5, appSize, packageName, versionCode, smallIcon, bigIcon, appScreenShot, updateDesc, appId, appUrl, appVersion, isUpdate, distributorId, appName, appType, appDesc, callback, error) {
      var path = '/appDistribute/updateApp.do';
      var url = appUrlPre + path;
      var param = { md5: md5, appSize: appSize, packageName: packageName, distributorId: distributorId, appName: appName, appType: appType, appDesc: appDesc, versionCode: versionCode, smallIcon: smallIcon, bigIcon: bigIcon, appScreenShot: appScreenShot, updateDesc: updateDesc, appId: appId, appUrl: appUrl, appVersion: appVersion, isUpdate: isUpdate };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$editApp = function (md5, appSize, packageName, versionCode, id, appUrl, bigIcon, smallIcon, appCategoryId, desc, installType, appName, appScreenShot, appVersion, callback, error) {
      var path = '/app/edit.do';
      var url = addrPre + path;
      var param = { md5: md5, appSize: appSize, packageName: packageName, versionCode: versionCode, id: id, appUrl: appUrl, bigIcon: bigIcon, smallIcon: smallIcon, appCategoryId: appCategoryId, desc: desc, installType: installType, appName: appName, appScreenShot: appScreenShot, appVersion: appVersion };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$editApp1 = function (md5, distributorId, appSize, packageName, versionCode, applicationId, appUrl, bigIcon, smallIcon, appCategoryId, desc, installType, appName, appScreenShot, appVersion, callback, error) {
      var _param;

      var path = '/app/edit.do';
      var url = appUrlPre + path;
      var param = (_param = { md5: md5, distributorId: distributorId, applicationId: applicationId, appSize: appSize, packageName: packageName, versionCode: versionCode }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_param, 'applicationId', applicationId), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_param, 'appUrl', appUrl), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_param, 'bigIcon', bigIcon), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_param, 'smallIcon', smallIcon), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_param, 'appCategoryId', appCategoryId), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_param, 'desc', desc), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_param, 'installType', installType), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_param, 'appName', appName), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_param, 'appScreenShot', appScreenShot), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_param, 'appVersion', appVersion), _param);

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$getAppHistory = function (appName, packageName, callback, error) {
      var path = '/app/historyList.do';
      var url = addrPre + path;
      var param = { appName: appName, packageName: packageName };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$getAppHistory1 = function (distributorId, packageName, callback, error) {
      var path = '/app/historyList.do';
      var url = appUrlPre + path;
      var param = { distributorId: distributorId, packageName: packageName };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$deleteApp = function (ids, callback, error) {
      var path = '/app/delete.do';
      var url = addrPre + path;
      var param = { ids: ids };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$deleteApp1 = function (appid, callback, error) {
      var path = '/app/delete.do';
      var url = appUrlPre + path;
      var param = { appid: appid };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$deleteAppHis = function (applicationId, callback, error) {
      var path = '/app/deleteVersion.do';
      var url = appUrlPre + path;
      var param = { applicationId: applicationId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$submitVerifyApp = function (id, callback, error) {
      var path = '/app/submitCheck.do';
      var url = addrPre + path;
      var param = { id: id };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$submitVerifyApp1 = function (id, callback, error) {
      var path = '/app/submitCheck.do';
      var url = appUrlPre + path;
      var param = { id: id };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$verifyApp = function (token, appid, status, refuseReason, callback, error) {
      var path = '/app/check.do';
      var url = addrPre + path;
      var param = { token: token, appid: appid, status: status, refuseReason: refuseReason };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$verifyApp1 = function (distributorId, token, appid, status, refuseReason, callback, error) {
      var path = '/app/check.do';
      var url = appUrlPre + path;
      var param = { distributorId: distributorId, token: token, appid: appid, status: status, refuseReason: refuseReason };
      console.log(url, param);
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$verifyAppPush = function (distributorId, terminalNo, appId, callback, error) {
      var path = '/appDistribute/checkbind.do';
      var url = appUrlPre + path;
      var param = { distributorId: distributorId, appId: appId, terminalNo: terminalNo };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$getUsr = function (page, rows, nickName, phone, status, userId, roleId, orderName, orderType, callback, error) {
      var path = '/user/sub_account.do';
      var url = addrPre + path;
      var param = { orderName: orderName, orderType: orderType, page: page, rows: rows, nickName: nickName, phone: phone, status: status, userId: userId, roleId: roleId };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$isCer = function (distributorId, callback, error) {
      var path = '/app/isCertificate.do';
      var url = appUrlPre + path;
      var param = { distributorId: distributorId };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$activeList = function (page, rows, token, terminalNo, activationStatus, merchantId, callback, error) {
      var path = '/authorization/list.do';
      var url = addrPre + path;
      var param = { page: page, rows: rows, token: token, terminalNo: terminalNo, activationStatus: activationStatus, merchantId: merchantId };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$cerRightHistory = function (page, rows, token, opflag, callback, error) {
      var path = '/authorization/opRecording.do';
      var url = addrPre + path;
      var param = { page: page, rows: rows, token: token, opflag: opflag };

      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$cerRightHisOperate = function (id, certificateId, merchantId, operationType, pushType, callback, error) {
      var path = '/authorization/opAgain.do';
      var url = addrPre + path;
      var param = { id: id, certificateId: certificateId, merchantId: merchantId, operationType: operationType, pushType: pushType };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$cmOperate = function (zl, type, terminalNo, pushType, callback, error) {
      var path = '/cmd/doCommand.do';
      var url = addrPre + path;
      var param = { zl: zl, type: type, terminalNo: terminalNo, pushType: pushType };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$roleMgList = function (roleId, callback, error) {
      var path = '/role/getSubRoles.do';
      var url = addrPre + path;
      var param = { roleId: roleId };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$editRoleMgList = function (roleId, subRoleIds, callback, error) {
      var path = '/role/addSubRoles.do';
      var url = addrPre + path;
      var param = { roleId: roleId, subRoleIds: subRoleIds };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$editLogo = function (id, logo_address, callback, error) {
      var path = '/mechanism/updateLogoAddress.do';
      var url = addrPre + path;
      var param = { id: id, logo_address: logo_address };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$getVer = function (callback, error) {
      var path = '/versionManage/getVersion.do';
      var url = addrPre + path;
      var param = {};
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$fetchMacAddress = function (callback, error) {
      var path = '/versionManage/fetchMacAddress.do';
      var url = addrPre + path;
      var param = {};
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$activationLicense = function (license, callback, error) {
      var path = '/versionManage/activationLicense.do';
      var url = addrPre + path;
      var param = { license: license };
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$pushGlobalAction = function (param, callback, error) {
      var path = '/push_manage/push.do';
      var url = addrPre + path;
      jsonRqes(url, param, callback, error);
    };

    Vue.prototype.$confirmToPushAction = function (param, callback, error) {
      var path = '/push_manage/confirm_push.do';
      var url = addrPre + path;
      jsonRqes(url, param, callback, error);
    };

    var jsonRqes = function jsonRqes(url, param, callback, error) {
      var jsonType = 'application/json;charset=UTF-8';
      var formType = 'application/x-www-form-urlencoded';
      var cType = jsonType;
      var is7878 = url.indexOf(':7878') > 0;
      param.language = localStorage.system_lang;
      param.token = localStorage.user ? localStorage.user : '';
      cType = is7878 ? formType : jsonType;
      Vue.http.headers.post = { 'Content-Type': cType };
      Vue.http.post(url, param, { emulateJSON: false }).then(function (res) {
        var code = res.body.status;
        if (code === 600) {
          location.hash = "#/login";
        }

        if (callback) {
          callback(res.body);
        }
      }).catch(function (res) {
        if (error) {
          error();
        }
        console.log(res);
        var isBan = 0;

        var ar = url.split('tms-server-web/');
        if (ar.length > 1) {
          if (ar[1] === 'terminalManagement/getProgress.do') {
            isBan = 1;
          }
        }
        if (!isBan) {}
      });
    };

    var getRqs = function getRqs(url, param, callback, error) {
      param.token = localStorage.user ? localStorage.user : '';

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url, { headers: {}, params: param }).then(function (res) {
        if (callback) {
          callback(res.data);
        }
      }).then(function (res) {
        if (error) {
          error(res);
        }
      });
    };
  }
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_app__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_user__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_tmp__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_permission__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_ter__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__getters__ = __webpack_require__(518);










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    app: __WEBPACK_IMPORTED_MODULE_2__modules_app__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_3__modules_user__["a" /* default */],
    tmp: __WEBPACK_IMPORTED_MODULE_4__modules_tmp__["a" /* default */],
    permission: __WEBPACK_IMPORTED_MODULE_5__modules_permission__["a" /* default */],
    ter: __WEBPACK_IMPORTED_MODULE_6__modules_ter__["a" /* default */]
  },
  getters: __WEBPACK_IMPORTED_MODULE_7__getters__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 278 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 279 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 280 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 281 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 282 */,
/* 283 */,
/* 284 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(717)

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(1091),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_async_validator__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_src_mixins_emitter__ = __webpack_require__(98);





function noop() {}

function getPropByPath(obj, path) {
  var tempObj = obj;
  path = path.replace(/\[(\w+)\]/g, '.$1');
  path = path.replace(/^\./, '');

  var keyArr = path.split('.');
  var i = 0;

  for (var len = keyArr.length; i < len - 1; ++i) {
    var key = keyArr[i];
    if (key in tempObj) {
      tempObj = tempObj[key];
    } else {
      throw new Error('please transfer a valid prop path to form item!');
    }
  }
  return {
    o: tempObj,
    k: keyArr[i],
    v: tempObj[keyArr[i]]
  };
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ElFormItem',

  componentName: 'ElFormItem',

  mixins: [__WEBPACK_IMPORTED_MODULE_1_element_ui_src_mixins_emitter__["a" /* default */]],

  props: {
    label: String,
    labelWidth: String,
    prop: String,
    required: Boolean,
    rules: [Object, Array],
    error: String,
    validateStatus: String,
    showMessage: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    error: function error(value) {
      this.validateMessage = value;
      this.validateState = value ? 'error' : '';
    },
    validateStatus: function validateStatus(value) {
      this.validateState = value;
    }
  },
  computed: {
    labelStyle: function labelStyle() {
      var ret = {};
      if (this.form.labelPosition === 'top') return ret;
      var labelWidth = this.labelWidth || this.form.labelWidth;
      if (labelWidth) {
        ret.width = labelWidth;
      }
      return ret;
    },
    contentStyle: function contentStyle() {
      var ret = {};
      var label = this.label;
      if (this.form.labelPosition === 'top' || this.form.inline) return ret;
      if (!label && !this.labelWidth && this.isNested) return ret;
      var labelWidth = this.labelWidth || this.form.labelWidth;
      if (labelWidth) {
        ret.marginLeft = labelWidth;
      }
      return ret;
    },
    form: function form() {
      var parent = this.$parent;
      var parentName = parent.$options.componentName;
      while (parentName !== 'ElForm') {
        if (parentName === 'ElFormItem') {
          this.isNested = true;
        }
        parent = parent.$parent;
        parentName = parent.$options.componentName;
      }
      return parent;
    },

    fieldValue: {
      cache: false,
      get: function get() {
        var model = this.form.model;
        if (!model || !this.prop) {
          return;
        }

        var path = this.prop;
        if (path.indexOf(':') !== -1) {
          path = path.replace(/:/, '.');
        }

        return getPropByPath(model, path).v;
      }
    },
    isRequired: function isRequired() {
      var rules = this.getRules();
      var isRequired = false;

      if (rules && rules.length) {
        rules.every(function (rule) {
          if (rule.required) {
            isRequired = true;
            return false;
          }
          return true;
        });
      }
      return isRequired;
    }
  },
  data: function data() {
    return {
      validateState: '',
      validateMessage: '',
      validateDisabled: false,
      validator: {},
      isNested: false
    };
  },

  methods: {
    validate: function validate(trigger) {
      var _this = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

      this.validateDisabled = false;
      var rules = this.getFilteredRule(trigger);
      if ((!rules || rules.length === 0) && !this._props.hasOwnProperty('required')) {
        callback();
        return true;
      }

      this.validateState = 'validating';

      var descriptor = {};
      descriptor[this.prop] = rules;

      var validator = new __WEBPACK_IMPORTED_MODULE_0_async_validator__["default"](descriptor);
      var model = {};

      model[this.prop] = this.fieldValue;

      validator.validate(model, { firstFields: true }, function (errors, fields) {
        _this.validateState = !errors ? 'success' : 'error';
        _this.validateMessage = errors ? errors[0].message : '';

        callback(_this.validateMessage);
      });
    },
    resetField: function resetField() {
      this.validateState = '';
      this.validateMessage = '';

      var model = this.form.model;
      var value = this.fieldValue;
      var path = this.prop;
      if (path.indexOf(':') !== -1) {
        path = path.replace(/:/, '.');
      }

      var prop = getPropByPath(model, path);

      if (Array.isArray(value)) {
        this.validateDisabled = true;
        prop.o[prop.k] = [].concat(this.initialValue);
      } else {
        this.validateDisabled = true;
        prop.o[prop.k] = this.initialValue;
      }
    },
    getRules: function getRules() {
      var formRules = this.form.rules;
      var selfRules = this.rules;
      var requiredRule = this._props.hasOwnProperty('required') ? { required: !!this.required } : [];

      formRules = formRules ? formRules[this.prop] : [];

      return [].concat(selfRules || formRules || []).concat(requiredRule);
    },
    getFilteredRule: function getFilteredRule(trigger) {
      var rules = this.getRules();

      return rules.filter(function (rule) {
        return !rule.trigger || rule.trigger.indexOf(trigger) !== -1;
      });
    },
    onFieldBlur: function onFieldBlur() {
      this.validate('blur');
    },
    onFieldChange: function onFieldChange() {
      if (this.validateDisabled) {
        this.validateDisabled = false;
        return;
      }

      this.validate('change');
    }
  },
  mounted: function mounted() {
    if (this.prop) {
      this.dispatch('ElForm', 'el.form.addField', [this]);

      var initialValue = this.fieldValue;
      if (Array.isArray(initialValue)) {
        initialValue = [].concat(initialValue);
      }
      Object.defineProperty(this, 'initialValue', {
        value: initialValue
      });

      var rules = this.getRules();

      if (rules.length || this._props.hasOwnProperty('required')) {
        this.$on('el.form.blur', this.onFieldBlur);
        this.$on('el.form.change', this.onFieldChange);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.dispatch('ElForm', 'el.form.removeField', [this]);
  }
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_src_mixins_emitter__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calcTextareaHeight__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_src_utils_merge__ = __webpack_require__(326);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ElInput',

  componentName: 'ElInput',

  mixins: [__WEBPACK_IMPORTED_MODULE_0_element_ui_src_mixins_emitter__["a" /* default */]],

  data: function data() {
    return {
      currentValue: this.value,
      textareaCalcStyle: {}
    };
  },


  props: {
    value: [String, Number],
    placeholder: String,
    size: String,
    resize: String,
    readonly: Boolean,
    autofocus: Boolean,
    icon: String,
    disabled: Boolean,
    type: {
      type: String,
      default: 'text'
    },
    name: String,
    autosize: {
      type: [Boolean, Object],
      default: false
    },
    rows: {
      type: Number,
      default: 2
    },
    autoComplete: {
      type: String,
      default: 'off'
    },
    form: String,
    maxlength: Number,
    minlength: Number,
    max: {},
    min: {},
    step: {},
    validateEvent: {
      type: Boolean,
      default: true
    },
    onIconClick: Function
  },

  computed: {
    validating: function validating() {
      return this.$parent.validateState === 'validating';
    },
    textareaStyle: function textareaStyle() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_element_ui_src_utils_merge__["a" /* default */])({}, this.textareaCalcStyle, { resize: this.resize });
    }
  },

  watch: {
    'value': function value(val, oldValue) {
      this.setCurrentValue(val);
    }
  },

  methods: {
    handleBlur: function handleBlur(event) {
      this.$emit('blur', event);
      if (this.validateEvent) {
        this.dispatch('ElFormItem', 'el.form.blur', [this.currentValue]);
      }
    },
    inputSelect: function inputSelect() {
      this.$refs.input.select();
    },
    resizeTextarea: function resizeTextarea() {
      if (this.$isServer) return;
      var autosize = this.autosize,
          type = this.type;

      if (type !== 'textarea') return;
      if (!autosize) {
        this.textareaCalcStyle = {
          minHeight: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__calcTextareaHeight__["a" /* default */])(this.$refs.textarea).minHeight
        };
        return;
      }
      var minRows = autosize.minRows;
      var maxRows = autosize.maxRows;

      this.textareaCalcStyle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__calcTextareaHeight__["a" /* default */])(this.$refs.textarea, minRows, maxRows);
    },
    handleFocus: function handleFocus(event) {
      this.$emit('focus', event);
    },
    handleInput: function handleInput(event) {
      var value = event.target.value;
      this.$emit('input', value);
      this.setCurrentValue(value);
      this.$emit('change', value);
    },
    handleIconClick: function handleIconClick(event) {
      if (this.onIconClick) {
        this.onIconClick(event);
      }
      this.$emit('click', event);
    },
    setCurrentValue: function setCurrentValue(value) {
      var _this = this;

      if (value === this.currentValue) return;
      this.$nextTick(function (_) {
        _this.resizeTextarea();
      });
      this.currentValue = value;
      if (this.validateEvent) {
        this.dispatch('ElFormItem', 'el.form.change', [value]);
      }
    }
  },

  created: function created() {
    this.$on('inputSelect', this.inputSelect);
  },
  mounted: function mounted() {
    this.resizeTextarea();
  }
});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_daycaca__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_daycaca___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_daycaca__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_drag__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_drag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__lib_drag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_resize__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_resize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__lib_resize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_loading_gif__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_loading_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__lib_loading_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_helper__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__lib_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resize_bar_vue__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resize_bar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__resize_bar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rotate_bar_vue__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rotate_bar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__rotate_bar_vue__);










var CROPBOX_PERCENT = 75;
var isMobile = __WEBPACK_IMPORTED_MODULE_4__lib_helper___default.a.isMobile;
var areaWidth = window.innerWidth - 60;
var areaHeight = window.innerHeight - 110;
/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ResizeBar: __WEBPACK_IMPORTED_MODULE_5__resize_bar_vue___default.a,
    RotateBar: __WEBPACK_IMPORTED_MODULE_6__rotate_bar_vue___default.a
  },
  props: {
    ratio: {
      type: String,
      default: '1:1'
    },
    minWidth: {
      type: Number,
      default: 50
    },
    minHeight: {
      type: Number,
      default: 50
    },
    isResize: {
      type: [Boolean],
      default: false
    },
    isRotate: {
      type: [Boolean],
      default: true
    }
  },

  data: function data() {
    return {
      src: __WEBPACK_IMPORTED_MODULE_3__lib_loading_gif___default.a,
      width: 24,
      height: 24,
      initWidth: 24,
      initHeight: 24,
      left: 0,
      top: 0,
      cropCSS: {}
    };
  },


  methods: {
    setImage: function setImage(src, w, h) {
      this.src = src;
      if (!this.originSrc) {
        this.setOriginalSrc(this.src);
      }
      if (this.ratio.indexOf(':') > 0) {
        this.ratioW = this.ratio.split(':')[0];
        this.ratioH = this.ratio.split(':')[1];
        this.ratioVal = this.ratioW / this.ratioH;
      } else {
        this.ratioW = 1;
        this.ratioH = 1;
        this.ratioVal = this.ratio;
      }
      this.natrualWidth = w;
      this.natrualHeight = h;
      this.setLayout(w, h);
      var resizeBar = this.$refs.resizeBar;
      if (this.isResize) {
        resizeBar.setProgress(100);
      } else {
        resizeBar.setProgress(50);
      }
      return this.imgChangeRatio;
    },
    setOriginalSrc: function setOriginalSrc(src) {
      this.originSrc = src;
    },
    resizeImage: function resizeImage(progress) {
      var w = void 0,
          h = void 0;
      if (this.isResize) {
        w = this.natrualWidth * this.imgChangeRatio * progress;
        h = this.natrualHeight * this.imgChangeRatio * progress;
      } else {
        w = this.initWidth + progress * (this.natrualWidth - this.initWidth);
        h = this.initHeight + progress * (this.natrualHeight - this.initHeight);
      }
      if (w <= this.minWidth || h < this.minHeight) {
        return;
      }
      this.left += (this.width - w) / 2;
      this.top += (this.height - h) / 2;
      this.width = w;
      this.height = h;
      this.imgChangeRatio = this.width / this.natrualWidth;
    },
    rotateImage: function rotateImage(degress) {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_0_daycaca___default.a.rotate2(this.originSrc, degress, function (data, w, h) {
        _this.setImage(data, w, h);
      });
    },
    setLayout: function setLayout(w, h) {
      var H = areaHeight,
          W = areaWidth,
          width = w,
          height = h,
          marginLeft = 0,
          marginTop = 0;

      var R = width / height;
      var Rs = W / H;
      if (R > Rs) {
        height = H;
        width = H * R;
        marginLeft = (W - H * R) / 2;
      } else {
        width = H * R, height = H;
        marginLeft = (W - H * R) / 2;
      }
      this._setStyle(width, height, marginLeft, marginTop, R, true);
    },
    _setStyle: function _setStyle(w, h, ml, mt, r, isInit) {
      var $container = this.$el.querySelector('.g-crop-image-principal');
      if (!isInit) {
        this.marginLeft = this.marginLeft + (this.width - w) / 2;
        this.marginTop = this.marginTop + (this.height - h) / 2;
      }
      $container.style.cssText = 'width:' + w + 'px;height:' + h + 'px;margin-left:' + ml + 'px;' + 'margin-top:' + mt + 'px';
      this.setCropBox(w, h);
      if (this.isResize) {
        this.width = w;
        this.height = h;
      } else {
        if (r >= this.cropCSS.width / this.cropCSS.height) {
          this.height = this.cropCSS.height;
          this.width = this.height * r;
        } else {
          this.width = this.cropCSS.width;
          this.height = this.width / r;
        }
        this.initWidth = this.width;
        this.initHeight = this.height;
        this.left = (w - this.width) / 2;
        this.top = (h - this.height) / 2;
      }
      this.imgChangeRatio = this.width / this.natrualWidth;
    },
    setCropBox: function setCropBox(w, h, r) {
      if (this.isResize) {
        return;
      }
      var $selectCropBox = this.__find('.crop-box');
      var $wrap = this.$el;
      var imageWidth = w,
          imageHeight = h,
          ratioW = this.ratioW,
          ratioH = this.ratioH;
      var cropWidth = imageWidth;
      if (areaWidth < w) {
        cropWidth = areaWidth;
      }
      var baseCropWidth = cropWidth / 100 * CROPBOX_PERCENT;
      var CSSObj = {
        width: baseCropWidth,
        height: baseCropWidth / ratioW * ratioH
      };
      CSSObj.left = (imageWidth - baseCropWidth) / 2;
      CSSObj.top = (imageHeight - CSSObj.height) / 2;
      $selectCropBox.style.cssText = __WEBPACK_IMPORTED_MODULE_4__lib_helper___default.a.setCssText(CSSObj);
      if (CSSObj.height > imageHeight) {
        var baseCropHeight = imageHeight / 100 * CROPBOX_PERCENT;
        CSSObj.height = baseCropHeight;
        CSSObj.width = CSSObj.height * ratioW / ratioH;
        CSSObj.left = (imageWidth - CSSObj.width) / 2, CSSObj.top = (imageHeight - CSSObj.height) / 2, $selectCropBox.style.cssText = __WEBPACK_IMPORTED_MODULE_4__lib_helper___default.a.setCssText(CSSObj);
      };
      this.cropCSS = CSSObj;
    },
    getCropData: function getCropData() {
      if (this.isResize) {
        return {
          imgChangeRatio: this.imgChangeRatio,
          x: 0,
          y: 0,
          w: this.natrualWidth,
          h: this.natrualHeight
        };
      }
      return {
        x: (this.cropCSS.left - this.left) / this.imgChangeRatio,
        y: (this.cropCSS.top - this.top) / this.imgChangeRatio,
        w: this.cropCSS.width / this.imgChangeRatio,
        h: this.cropCSS.height / this.imgChangeRatio
      };
    },
    getCropImage: function getCropImage() {
      return this.$refs['crop-image'];
    },
    __find: function __find(str) {
      var dq = this.$el;
      return dq.querySelector(str);
    },
    resize: function resize(e) {
      e.stopPropagation();
      if (!this.ratio.indexOf(':')) {
        return;
      }
      var $el = e.target.parentElement;
      var $container = this.__find('.g-crop-image-principal');
      if (this._$container) {
        this._$container = container;
      }
      var self = this;
      var coor = {
        x: __WEBPACK_IMPORTED_MODULE_4__lib_helper___default.a.isMobile ? e.touches[0].clientX : e.clientX,
        y: __WEBPACK_IMPORTED_MODULE_4__lib_helper___default.a.isMobile ? e.touches[0].clientY : e.clientY,
        w: $el.offsetWidth,
        h: $el.offsetHeight
      };
      this.el = $el;
      this.container = $container;
      var maxCoor = this._getMaxCropAreaWidth();
      var move = function move(ev) {
        var newCropStyle = __WEBPACK_IMPORTED_MODULE_2__lib_resize___default()(ev, self.el, $container, coor, self.ratioVal);
        if (newCropStyle && (newCropStyle.width <= maxCoor.maxWidth || newCropStyle.height <= maxCoor.maxHeight)) {
          self.cropCSS.width = newCropStyle.width;
          self.cropCSS.height = newCropStyle.height;
        }
      };
      var end = function end(ev) {
        this.el = null;
        if (__WEBPACK_IMPORTED_MODULE_4__lib_helper___default.a.isMobile) {
          document.removeEventListener('touchmove', move, false);
          document.removeEventListener('touchend', end, false);
        }
        document.removeEventListener('mousemove', move, false);
        document.removeEventListener('mouseup', end, false);
      };
      if (__WEBPACK_IMPORTED_MODULE_4__lib_helper___default.a.isMobile) {
        document.addEventListener('touchmove', move, false);
        document.addEventListener('touchend', end, false);
      }
      document.addEventListener('mousemove', move, false);
      document.addEventListener('mouseup', end, false);
    },
    _getMaxCropAreaWidth: function _getMaxCropAreaWidth() {
      var $cropBox = this.__find('.crop-box');
      if (this.width > this.height) {
        return {
          maxWidth: this.height * this.ratioW / this.ratioH,
          maxHeight: this.height
        };
      }
      return {
        maxWidth: this.width,
        maxHeight: this.width * this.ratioH / this.ratioW
      };
    },
    drag: function drag(e) {
      e.preventDefault();
      var $el = this.__find('.image-wrap');
      this.el = $el;
      var $cropBox = this.__find('.crop-box');
      var $container = e.currentTarget;
      var self = this;
      var isMobile = __WEBPACK_IMPORTED_MODULE_4__lib_helper___default.a.isMobile;
      var coor = {
        x: (isMobile ? e.touches[0]['clientX'] : e.clientX) - $el.offsetLeft,
        y: (isMobile ? e.touches[0]['clientY'] : e.clientY) - $el.offsetTop,
        maxLeft: $cropBox.offsetLeft,
        maxTop: $cropBox.offsetTop,
        minLeft: $cropBox.offsetWidth + $cropBox.offsetLeft - $el.offsetWidth,
        minTop: $cropBox.offsetHeight + $cropBox.offsetTop - $el.offsetHeight
      };
      var move = function move(ev) {
        var newCropStyle = __WEBPACK_IMPORTED_MODULE_1__lib_drag___default()(ev, self.el, coor);
        if (newCropStyle) {
          self.left = newCropStyle.left;
          self.top = newCropStyle.top;
        }
      };
      var stopMove = function stopMove(ev) {
        self.el = null;
        if (isMobile) {
          document.removeEventListener('touchmove', move, false);
          document.removeEventListener('touchend', stopMove, false);
          return;
        }
        document.removeEventListener('mousemove', move, false);
        document.removeEventListener('mouseup', stopMove, false);
      };
      if (isMobile) {
        document.addEventListener('touchmove', move, false);
        document.addEventListener('touchend', stopMove, false);
        return;
      }
      document.addEventListener('mousemove', move, false);
      document.addEventListener('mouseup', stopMove, false);
    }
  }

});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_helper__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lib_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_drag__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_drag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__lib_drag__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    minProgress: {
      type: [Number, String],
      default: 0
    }

  },
  data: function data() {
    return {
      progress: 100,
      left: 100
    };
  },


  methods: {
    setProgress: function setProgress(num) {
      this.left = num;
    },
    drag: function drag(e) {
      e.preventDefault();
      e.stopPropagation();
      var $el = e.target;
      this.el = $el;
      var $container = this.$el.parentElement;
      var self = this;
      var isMobile = __WEBPACK_IMPORTED_MODULE_0__lib_helper___default.a.isMobile;
      var width = 200;
      var coor = {
        x: (isMobile ? e.touches[0]['clientX'] : e.clientX) - $el.offsetLeft,
        y: (isMobile ? e.touches[0]['clientY'] : e.clientY) - $el.offsetTop,
        maxLeft: width,
        maxTop: parseInt($container.style.height) - parseInt($el.style.height),
        minLeft: 0,
        minTop: 0
      };
      var move = function move(ev) {
        var newCoor = __WEBPACK_IMPORTED_MODULE_1__lib_drag___default()(ev, self.el, coor);
        if (newCoor) {
          if (newCoor.left / width < self.minProgress) {
            return;
          }
          self.progress = (newCoor.left - width / 2) / width;
          self.left = newCoor.left / width * 100;

          self.$emit('resize', self.progress);
        }
      };
      var stopMove = function stopMove(ev) {
        self.el = null;
        if (isMobile) {
          document.removeEventListener('touchmove', move, false);
          document.removeEventListener('touchend', stopMove, false);
          return;
        }
        document.removeEventListener('mousemove', move, false);
        document.removeEventListener('mouseup', stopMove, false);
      };
      if (isMobile) {
        document.addEventListener('touchmove', move, false);
        document.addEventListener('touchend', stopMove, false);
        return;
      }
      document.addEventListener('mousemove', move, false);
      document.addEventListener('mouseup', stopMove, false);
    }
  }

});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      rotateDegree: 0
    };
  },


  methods: {
    rotateRight: function rotateRight() {
      this.rotateDegree += 90;
      this.$emit('rotate', this.rotateDegree);
    },
    rotateLeft: function rotateLeft() {
      this.rotateDegree -= 90;
      this.$emit('rotate', this.rotateDegree);
    }
  }
});

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_image_xhr__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_image_xhr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_image_xhr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_daycaca__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_daycaca___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_daycaca__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_loading_gif__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_loading_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__lib_loading_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__props__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__props___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__props__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__crop_vue__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__crop_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__crop_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__resize_bar_vue__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__resize_bar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__resize_bar_vue__);













var overflowVal = '';
/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Crop: __WEBPACK_IMPORTED_MODULE_8__crop_vue___default.a,
    ResizeBar: __WEBPACK_IMPORTED_MODULE_9__resize_bar_vue___default.a
  },
  props: __WEBPACK_IMPORTED_MODULE_7__props___default.a,
  data: function data() {
    return {
      files: [],
      hasImage: false,
      options: this.props,
      uploading: false,
      image: {
        src: __WEBPACK_IMPORTED_MODULE_6__lib_loading_gif___default.a,
        width: 24,
        height: 24,
        minProgress: 0.05
      }
    };
  },


  computed: {
    name: function name() {
      if (this.multiple) {
        return this.inputOfFile + '[]';
      }
      return this.inputOfFile;
    }
  },

  methods: {
    __dispatch: function __dispatch(name, res, data) {
      this.$emit && this.$emit(name, res, data);
    },
    __find: function __find(el) {
      return this.$el.querySelector(el);
    },
    dragover: function dragover() {
      this.$el.classList.add('is-dragover');
    },
    dragleave: function dragleave() {
      var element = this.$refs.container;
      this.$el.classList.remove('is-dragover');
    },
    change: function change(e) {
      var _this = this;

      var fileVal = e.target.value.replace(/C:\\fakepath\\/i, "");
      var fileExt = fileVal.substring(fileVal.lastIndexOf(".") + 1);
      var extensionsArr = this.extensions.split(',');
      if (extensionsArr.length > 1) {
        var reg = new RegExp('^[' + extensionsArr.join('|') + ']+$', 'i');
        if (!reg.test(fileExt)) {
          return this.__dispatch('errorhandle', 'TYPE ERROR');
        }
      }
      if (e.target.files[0].size > this.maxFileSize) {
        var formatSize;
        if (parseInt(this.maxFileSize / 1024 / 1024) > 0) {
          formatSize = (this.maxFileSize / 1024 / 1024).toFixed(2) + 'MB';
        } else if (parseInt(this.maxFileSize / 1024) > 0) {
          formatSize = (this.maxFileSize / 1024).toFixed(2) + 'kB';
        } else {
          formatSize = options.maxFileSize.toFixed(2) + 'Byte';
        }
        console.warn('FILE IS TOO LARGER MAX FILE IS ' + formatSize);
        return this.__dispatch('errorhandle', 'FILE IS TOO LARGER MAX FILE IS ' + formatSize);
      }

      if (this.multipleSize > 0 && e.target.files.length > this.multipleSize) {
        console.warn('FILE NUM IS LARGER THAN ' + this.multipleSize);
        return this.__dispatch('errorhandle', 'FILE NUM OVERLOAD');
      }

      this.files = e.target.files;
      if (this.crop || this.resize) {
        this.__showImage();
        return;
      }
      var file = this.files.length > 1 ? this.files : this.files[0];
      this.__dispatch('imagechanged', file);
      if (this.compress && this.files[0]['type'] !== 'image/png' && this.files[0]['type'] !== 'image/gif') {
        __WEBPACK_IMPORTED_MODULE_5_daycaca___default.a.compress(file, 100 - this.compress, function (code) {
          _this.tryAjaxUpload('', true, code);
        });
      } else {
        this.tryAjaxUpload();
      }
    },
    __showImage: function __showImage() {
      this.hasImage = true;
      this.__readFiles();
    },
    __readFiles: function __readFiles() {
      var reader = new FileReader();
      var self = this;
      reader.onload = function (e) {
        var src = e.target.result;
        overflowVal = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        self.__initImage(src);
      };
      reader.readAsDataURL(this.files[0]);
    },
    __initImage: function __initImage(src) {
      var pic = new Image();
      var self = this;
      pic.src = src;
      var cropBox = this.$refs.cropBox;
      pic.onload = function () {
        self.image.minProgress = self.minWidth / pic.naturalWidth;
        __WEBPACK_IMPORTED_MODULE_5_daycaca___default.a.init(src, function (src) {
          self.imgChangeRatio = cropBox.setImage(src, pic.naturalWidth, pic.naturalHeight);
        });
      };
    },
    resizeImage: function resizeImage(progress) {
      var cropBox = this.$refs.cropBox;
      cropBox.resizeImage(progress);
    },
    doRotate: function doRotate(e) {
      var self = this;
      var cropBox = this.$refs.cropBox;
      var targetImage = cropBox.getCropImage();
      this.data.compress = 100 - this.compress;
      return __WEBPACK_IMPORTED_MODULE_5_daycaca___default.a.rotate(targetImage, 1, function (src) {
        self.__initImage(src);
      });
    },
    doReverseRotate: function doReverseRotate(e) {
      var self = this;
      var cropBox = this.$refs.cropBox;
      var targetImage = cropBox.getCropImage();
      this.data.compress = 100 - this.compress;
      return __WEBPACK_IMPORTED_MODULE_5_daycaca___default.a.rotate(targetImage, -1, function (src) {
        self.__initImage(src);
      });
    },
    doCrop: function doCrop(e) {
      var _this2 = this;

      this.__setData('crop');
      var cropBox = this.$refs.cropBox;
      var upload = this.__setUpload(e.target);
      if (this.crop === 'local') {
        var targetImage = cropBox.getCropImage();
        this.data.compress = 100 - this.compress;
        return __WEBPACK_IMPORTED_MODULE_5_daycaca___default.a.crop(targetImage, this.data, function (code) {
          upload(code);
          _this2.__dispatch('imagechanged', code);
        });
      }
      upload();
    },
    doResize: function doResize(e) {
      var _this3 = this;

      this.__setData('resize');
      var cropBox = this.$refs.cropBox;
      var upload = this.__setUpload(e.target);
      if (this.resize === 'local') {
        var targetImage = cropBox.getCropImage();
        this.data.compress = 100 - this.compress;
        return __WEBPACK_IMPORTED_MODULE_5_daycaca___default.a.resize(targetImage, this.data, function (code) {
          upload(code);
          _this3.__dispatch('imagechanged', code);
        });
      }
      upload();
    },
    __setData: function __setData(type) {
      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(this.data) !== 'object') {
        this.data = {};
      }
      this.data["request"] = type;
      var cropBox = this.$refs.cropBox;
      var newCSSObj = cropBox.getCropData();
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(newCSSObj)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var k = _step.value;

          this.data[k] = newCSSObj[k];
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (this.maxWidth) {
        this.data['maxWidth'] = this.maxWidth;
      }
      if (this.maxHeight) {
        this.data['maxHeight'] = this.maxHeight;
      }
      if (this.minWidth) {
        this.data['minWidth'] = this.minWidth;
      }
      if (this.minHeight) {
        this.data['minHeight'] = this.minHeight;
      }
      if (this.fixedWidth) {
        this.data['fixedWidth'] = this.fixedWidth;
      }
      if (this.fixedHeight) {
        this.data['fixedHeight'] = this.fixedHeight;
      }
    },
    __setUpload: function __setUpload(btn) {
      var _this4 = this;

      btn.value = btn.value + '...';
      btn.disabled = true;
      var upload = function upload(code) {
        _this4.tryAjaxUpload(function () {
          btn.value = btn.value.replace('...', '');
          btn.disabled = false;
        }, code ? true : false, code);
      };
      return upload;
    },
    cancel: function cancel() {
      this.hasImage = false;
      document.body.style.overflow = overflowVal;
      this.files = '';
      var cropBox = this.$refs.cropBox;
      cropBox.setOriginalSrc(null);
      this.$input.value = '';
    },
    tryAjaxUpload: function tryAjaxUpload(callback, isBinary, base64Code) {
      var self = this;
      this.__dispatch('imageuploading', this.files[0]);
      var done = function done(res) {
        if (typeof callback === 'function') {
          callback();
        }
        self.uploading = false;
        self.cancel();
        self.__dispatch('imageuploaded', res, self.data);
      };
      var errorUpload = function errorUpload(err) {
        self.__dispatch('errorhandle', err);
      };
      if (!this.isXhr) {
        if (this.crop) {
          this.hasImage = false;
        }
        console.log(base64Code);
        return done({
          src: base64Code
        });
      }
      var data = void 0;
      if (isBinary) {
        data = {
          type: this.files[0]['type'],
          filename: this.files[0]['name'],
          filed: this.inputOfFile,
          base64Code: base64Code
        };
        if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(this.data) === 'object') {
          data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.data, data);
        }
      } else {
        data = new FormData();
        for (var i = 0; i < this.files.length; i++) {
          data.append(this.name, this.files[i]);
        }
        if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(this.data) === 'object') {
          for (var k in this.data) {
            if (this.data[k] !== undefined) {
              data.append(k, this.data[k]);
            }
          }
        }
      }
      __WEBPACK_IMPORTED_MODULE_4_core_image_xhr___default()('POST', this.url, this.headers, data, done, errorUpload, isBinary, this.credentials);
    }
  },
  mounted: function mounted() {
    this.$input = this.__find('input');
  }
});

/***/ }),
/* 333 */
/***/ (function(module, exports) {



/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qrcodejs2__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qrcodejs2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_qrcodejs2__);






var md5 = __webpack_require__(53);

/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		MechanismSelector: __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue___default.a
	},
	props: {
		tmcid: String
	},
	name: 'info',
	data: function data() {
		var that = this;
		return {
			dld: false,
			mfafm: { psw: '', code: '' },
			qrres: '',
			brow: '',
			active: 0,
			isbind: false,
			isunbind: false,
			orderType: '',
			orderName: '',
			mechanismData: {
				placeholder: that.$t('lin_global.place_areaid'),
				callback: function callback(value) {
					that.value2 = value;
					that.statusChange(value);
				}
			},
			focusEvent: __WEBPACK_IMPORTED_MODULE_1__api_url__["c" /* focusEvent */],
			loading: true,
			currentPage: 1,
			pageSize: 10,
			totalRecords: 0,
			arrdata: [],
			roleId: '',
			nickName: '',
			roleList: [],
			value2: '',
			areaList1: []
		};
	},
	created: function created() {},
	mounted: function mounted() {
		var _this = this;
		setTimeout(function () {
			_this.getData(1, '', '', '');
			_this.getRole();
			_this.getAd1();
		}, 2000);
	},

	methods: {
		closeUnbind: function closeUnbind() {
			this.isunbind = false;
			this.mfafm.code = '';
		},
		bindRqs: function bindRqs() {
			var _this2 = this;

			if (!this.mfafm.code) {
				this.$message.error(this.$t('app_inputNumber'));
				return;
			}
			this.dld = true;
			this.$mfaBind(this.brow.userid, this.mfafm.code, function (res) {
				_this2.dld = false;
				if (res.status == 200) {
					_this2.closeBind();
					var _this = _this2;
					setTimeout(function () {
						_this.getData(1, '', '', '');
						_this.getRole();
						_this.getAd1();
					}, 2000);
					_this2.$message.success(res.message);
				} else {
					_this2.$message.error(res.message);
				}
			}, function () {
				_this2.dld = false;
			});
		},
		closeBind: function closeBind() {
			this.isbind = false;
			this.dld = false;
			this.mfafm = { psw: '', code: '' };
		},
		bindOpen: function bindOpen() {
			var _this3 = this;

			this.$mfaQrcode(this.brow.userid, function (res) {
				_this3.qrres = res.data ? res.data.qrCode : '';
			}, '');
		},
		bindRow: function bindRow(row) {
			this.brow = row;
			this.isbind = true;
		},
		unbindRow: function unbindRow(row) {
			this.brow = row;
			this.isunbind = true;
		},
		unbindOpe: function unbindOpe() {
			var _this4 = this;

			if (!this.mfafm.code) {
				this.$message.error(this.$t('app_inputNumber'));
				return;
			}
			this.dld = true;
			this.$mfaUnbind(this.brow.userid, this.mfafm.code, function (res) {
				_this4.dld = false;
				if (res.status == 200) {
					_this4.closeUnbind();
					var _this = _this4;
					setTimeout(function () {
						_this.getData(1, '', '', '');
						_this.getRole();
						_this.getAd1();
					}, 2000);
					_this4.$message.success(res.message);
				} else {
					_this4.$message.error(res.message);
				}
			}, function () {
				_this4.dld = false;
			});
		},
		createQrcode: function createQrcode() {
			new __WEBPACK_IMPORTED_MODULE_3_qrcodejs2___default.a('mfaqrcode', {
				width: 150,
				height: 150,
				text: this.qrres });
		},
		nextOpe: function nextOpe(isnext) {
			if (isnext) {
				this.active = this.active + 1 > 2 ? this.active : this.active + 1;
			} else {
				this.active = this.active - 1 == -1 ? this.active : this.active - 1;
			}
		},
		stepClick: function stepClick(isnext) {
			var _this5 = this;

			if (this.active == 0) {
				if (!this.mfafm.psw) {
					this.$message.error(this.$t('lin_global.plePassTips'));
					return;
				} else {
					this.dld = true;
					this.$mfaIdCheck(this.brow.userid, md5(this.mfafm.psw), function (res) {
						_this5.dld = false;
						if (res.status == 200) {
							_this5.nextOpe(isnext);
						} else {
							_this5.$message.error(res.message);
						}
					}, '');
				}
			} else if (this.active == 1) {
				this.nextOpe(isnext);
			} else if (this.active == 2) {
				this.nextOpe(isnext);
			}

			switch (this.active) {
				case 2:
					this.$nextTick(function () {
						_this5.createQrcode();
					});
					break;
			}
		},
		sortChange: function sortChange(vl) {
			switch (vl.prop) {
				case 'userName':
					this.orderName = '1';
					break;
				case 'nickName':
					this.orderName = '2';
					break;
				case 'createTime':
					this.orderName = '3';
					break;
			}
			this.orderType = vl.order == 'descending' ? 'desc' : 'asc';
			this.getData(this.currentPage, this.roleId, this.nickName, this.value2);
		},

		getAd1: function getAd1() {
			var _this6 = this;

			var params = { page: 1, rows: 10000 };
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/mechanism/list.do', params).then(function (res) {
				console.log(res.data);
				var obj = {
					'mechanismname': _this6.$t('lin_global.all_mechanism'),
					'mechanismid': ''
				};
				_this6.areaList1 = res.data.data;

				_this6.areaList1.unshift(obj);
			});
		},
		statusChange: function statusChange() {
			this.getData(this.currentPage, this.roleId, this.nickName, this.value2);
		},

		getRole: function getRole() {
			var _this7 = this;

			var mechanismId = localStorage.getItem('mechanismId');
			var params = { page: 1, rows: 10000, distributorid: mechanismId };
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/role/list.do', params).then(function (res) {
				_this7.roleList = res.data.data;
			});
		},
		roleChange: function roleChange() {
			this.getData(1, this.roleId, this.nickName, this.value2);
		},
		handleIconClick: function handleIconClick() {
			this.getData(1, this.roleId, this.nickName, this.value2);
		},

		handleSizeChange: function handleSizeChange(val) {
			this.pageSize = val;
			this.getData(this.currentPage, this.roleId, this.nickName, this.value2);
		},
		handleCurrentChange: function handleCurrentChange(val) {
			this.currentPage = val;
			this.getData(this.currentPage, this.roleId, this.nickName, this.value2);
		},
		formatStatus: function formatStatus(row, column) {
			return row.userStatus == 0 ? this.$t('lin_global.jh') : row.userStatus == 1 ? this.$t('lin_global.dj') : '';
		},
		onCancel: function onCancel() {},
		add: function add() {
			if (this.tmcid) {
				this.$setWObj('tmcid', this.tmcid);
				this.$router.push({ path: '/channels/channel-detail/addaccount' });
			} else {
				this.$setWObj('tmcid', '');
				this.$router.push({ path: '/accMess/add' });
			}
		},
		editRow: function editRow(userid) {

			this.$router.push({ path: '/accMess/' + userid + '/add' });
		},
		deleteRow: function deleteRow(userid) {
			var _this8 = this;

			var params = { 'userid': userid };
			this.$confirm(this.$t('account.delete_tips'), this.$t('lin_btn.tips'), {
				confirmButtonText: this.$t('lin_btn.confirm'),
				cancelButtonText: this.$t('lin_btn.cancel'),
				type: 'warning'
			}).then(function () {
				__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/user/delete.do', params).then(function (res) {
					console.log("hhh");
					console.log(res.data);
					if (res.data.status == 200) {
						_this8.getData(_this8.currentPage, _this8.roleId, _this8.nickName, _this8.value2);
						_this8.$message.success(_this8.$t('lin_global.delete_success'));
					} else {
						_this8.$message.error(res.data.message);
					}
				});
			}).catch(function () {});
		},
		getData: function getData(page, a, b, c) {
			var _this9 = this;

			this.currentPage = page;
			var userid = localStorage.getItem('userId');

			var tmpmc = this.tmcid ? this.tmcid : '';

			var params = { orderType: this.orderType, orderName: this.orderName, "page": page, "rows": this.pageSize, "nickName": b, "phone": "", "status": "", "userId": userid, "roleId": a, "distributorId": tmpmc ? tmpmc : c };
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/user/sub_account.do', params).then(function (res) {
				if (res.data.status == 200) {
					_this9.arrdata = res.data.data;
					_this9.totalRecords = res.data.total;
					_this9.loading = false;
				} else {
					_this9.$message.error(res.data.message);
				}
			});
		}
	}
});

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue__);


var md5 = __webpack_require__(53);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue___default.a
  },
  data: function data() {
    var _this = this;

    var validatePass = function validatePass(rule, value, callback) {
      if (value === "") {
        callback(new Error(_this.$t("lin_global.plePassTips")));
      } else {
        if (_this.formPwd.checkPass !== "") {
          _this.$refs.formPwd.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = function validatePass2(rule, value, callback) {
      var reg = /^((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\W_])).{8,}$/;
      if (value === "") {
        callback(new Error(_this.$t("lin_global.plePassTipsAgain")));
      } else if (value !== _this.formPwd.pass) {
        callback(new Error(_this.$t("lin_global.pwdDisfault")));
      } else if (!reg.test(value)) {
        callback(new Error(_this.$t("app_pswtip")));
      } else {
        callback();
      }
    };
    var phoneCheck = function phoneCheck(rule, value, callback) {
      if (!_this.isLegalMobile(value)) {
        callback(new Error(_this.$t("lin_global.unfitPhone")));
      } else {
        callback();
      }
    };

    var that = this;
    return {
      mechanismData: {
        value: null,
        placeholder: that.$t("lin_global.place_areaid"),
        callback: function callback(value) {
          that.form.mechanismId = value;
        }
      },
      mechanismDataUpdate: "",
      dialogFormVisible: false,
      formLabelWidth: "100px",
      mcid: "",
      ip1: "",
      ip2: "",
      ip3: "",
      ip4: "",
      formPwd: {
        oldPass: "",
        pass: "",
        checkPass: ""
      },
      loading: true,
      rules2: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }]
      },
      form: {
        nickName: "",
        userName: "",
        phoneNum: "",
        password: "",
        password1: "",
        roleid: "",
        userType: 1,
        mechanismId: "",
        userStatus: 0,
        token: localStorage.getItem("user")
      },
      formEdit: {
        nickName: "",
        userName: "",
        phoneNum: "",
        userType: 1,
        roleid: "",
        mechanismId: "",
        userStatus: 0,
        userid: this.$route.params.id
      },
      isEdit: false,
      rules: {
        nickName: [{
          required: true,
          message: this.$t("lin_global.nickNameTips")
        }],
        password: [{
          required: true,
          message: this.$t("lin_global.passWordTips")
        }],
        password1: [{
          required: true,
          message: this.$t("lin_global.comfirmPass")
        }],
        userName: [{
          required: true,
          message: this.$t("lin_global.userNameTips")
        }],
        phoneNum: [{
          required: true,
          message: this.$t("lin_global.phoneNumTips")
        }],
        roleid: [{
          required: true,
          message: this.$t("lin_global.roleidTips")
        }],
        mechanismId: [{
          required: true,
          message: this.$t("lin_global.mechanismIdTips")
        }],
        userStatus: [{
          required: true,
          message: this.$t("lin_global.userStatusTips")
        }]
      },
      areaList: [],
      roleList: []
    };
  },
  created: function created() {

    this.mcid = this.$getWObj().tmcid;
    if (this.mcid) {
      this.form.mechanismId = this.mcid;
    }

    this.getAd();
    this.getRole();
    if (this.$route.params.id) {
      this.isEdit = true;

      this.getInfo();
    } else {
      this.isEdit = false;
    }
  },

  props: {
    tMechanismId: String
  },
  computed: {
    showut: function showut() {
      var type = localStorage.userType;
      if (type == 0) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    isLegalMobile: function isLegalMobile(tel) {
      var sMobile = tel;
      var regex = "^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\\d{8}$";
      var re = new RegExp(regex, "g");
      if (!re.test(sMobile)) {
        return false;
      } else {
        return true;
      }
    },

    chang: function chang() {
      this.dialogFormVisible = true;
    },
    submitForm: function submitForm(formName) {
      var _this2 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          var params = {
            userId: _this2.$route.params.id,
            password: md5(_this2.formPwd.checkPass)
          };


          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + "/user/resetPass.do", params).then(function (res) {
            if (res.data.status == 200) {
              _this2.dialogFormVisible = false;
              _this2.$message.success(res.data.message);
            } else {
              _this2.dialogFormVisible = false;
              _this2.$message.error(res.data.message);
            }
          });
        } else {
          return false;
        }
      });
    },
    isLeggalipNum: function isLeggalipNum(num) {
      if (!num) {
        return true;
      }

      var rule = /^[0-9]\d*$/;
      if (rule.test(num)) {
        if (parseInt(num) > 255) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },

    addInfo: function addInfo() {
      var _this3 = this;

      if (!this.isLeggalipNum(this.ip1) || !this.isLeggalipNum(this.ip2) || !this.isLeggalipNum(this.ip3) || !this.isLeggalipNum(this.ip4)) {
        this.$message.error("IP" + this.$t("app_illegal"));
        return;
      }

      var params = this.form;


      if (this.form.password !== this.form.password1) {
        this.$message.error(this.$t("lin_global.pwdDisfault"));
        return;
      }

      var ip1 = this.ip1 ? this.ip1 : "*";
      var ip2 = this.ip2 ? this.ip2 : "*";
      var ip3 = this.ip3 ? this.ip3 : "*";
      var ip4 = this.ip4 ? this.ip4 : "*";
      params.limitIp = ip1 + "," + ip2 + "," + ip3 + "," + ip4;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + "/user/addUser.do", params).then(function (res) {
        if (res.data.status == 200) {
          _this3.$message.success(res.data.message);
          _this3.$router.go(-1);
        } else {
          _this3.$message.error(res.data.message);
        }
      });
    },
    onSubmitEdit: function onSubmitEdit() {
      var _this4 = this;

      if (!this.isLeggalipNum(this.ip1) || !this.isLeggalipNum(this.ip2) || !this.isLeggalipNum(this.ip3) || !this.isLeggalipNum(this.ip4)) {
        this.$message.error("IP" + this.$t("app_illegal"));
        return;
      }

      var params = this.formEdit;


      var ip1 = this.ip1 ? this.ip1 : "*";
      var ip2 = this.ip2 ? this.ip2 : "*";
      var ip3 = this.ip3 ? this.ip3 : "*";
      var ip4 = this.ip4 ? this.ip4 : "*";
      params.limitIp = ip1 + "," + ip2 + "," + ip3 + "," + ip4;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + "/user/editUser.do", params).then(function (res) {
        if (res.data.status == 200) {
          _this4.$message.success(res.data.message);
          _this4.$router.go(-1);
        } else {
          _this4.$message.error(res.data.message);
        }
      });
    },
    getInfo: function getInfo() {
      var _this5 = this;

      var userId = this.$route.params.id;
      var params = { userId: userId };
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + "/user/getUserById.do", params).then(function (res) {
        if (res.data.status == 200) {
          var dataip = res.data.data.limitIp;
          if (dataip) {
            var arr = dataip.split(".");
            _this5.ip1 = arr[0] == "*" ? "" : arr[0];
            _this5.ip2 = arr[1] == "*" ? "" : arr[1];
            _this5.ip3 = arr[2] == "*" ? "" : arr[2];
            _this5.ip4 = arr[3] == "*" ? "" : arr[3];
          }

          _this5.formEdit.nickName = res.data.data.nickName;
          _this5.formEdit.userName = res.data.data.userName;
          _this5.formEdit.phoneNum = res.data.data.phoneNum;
          _this5.formEdit.roleid = res.data.data.roleid;
          _this5.formEdit.mechanismId = res.data.data.mechanismId;
          _this5.formEdit.userType = res.data.data.userType;

          var that = _this5;
          _this5.mechanismDataUpdate = {
            value: res.data.data.mechanismName,
            callback: function callback(value) {
              that.formEdit.mechanismId = value;
            }
          };

          _this5.formEdit.userStatus = res.data.data.userStatus;
          _this5.loading = false;
        }
      });
    },
    onSubmit: function onSubmit() {
      var _this6 = this;

      this.$refs["addForm"].validate(function (valid) {
        if (valid) {
          _this6.addInfo();
        } else {
          _this6.$message.error(_this6.$t("lin_global.refs"));
          return false;
        }
      });
    },
    getAd: function getAd() {
      var _this7 = this;

      var params = { page: 1, rows: 10000 };
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + "/mechanism/list.do", params).then(function (res) {
        _this7.areaList = res.data.data;
      });
    },
    getRole: function getRole() {
      var _this8 = this;

      this.$roleMgList("", function (res) {
        _this8.loading = false;
        if (res.status === 200) {
          _this8.roleList = res.data;
        } else {
          _this8.$message.error(res.message);
        }
      }, function (error) {
        _this8.loading = false;
        _this8.$message.error(_this8.$t("app_rqsError"));
      });
    },
    onCancel: function onCancel() {
      this.$router.go(-1);
    }
  }
});

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {
      cerDialogVisible: false,
      cerTipDialogVisible: false,
      dvLoading: 0,
      orderType: '',
      orderName: '',
      appId: "",
      stModel: [{ label: this.$t("app_online"), vl: "1" }, { label: this.$t("app_offline"), vl: "2" }, { label: this.$t("app_new"), vl: "0" }],
      channels: [],
      srchValue: "",
      channelId: "",
      cerTipMsg: "",
      status: "",
      dvIndex: 1,
      dialogVisible: 0,
      mechanismId: window.localStorage["mechanismId"],
      tableData: [],
      dvTableData: [],
      appTypeValue: "",
      appStatus: [{ label: this.$t("app_prePushVerify"), value: "0" }, { label: this.$t("app_preVerify"), value: "1" }, { label: this.$t("app_verifyPass"), value: "2" }, { label: this.$t("app_verifyNotPass"), value: "3" }],
      appStatusValue: "",
      total: 0,
      dvTotal: 0,
      loading: 0,
      appType: "",
      queryKey: "",
      queryType: '',
      queryAccount: '',
      queryContent: ''
    };
  },

  computed: {
    index: function index() {
      return this.$getWPage("appPage");
    },
    getDvStatus: function getDvStatus(value) {
      switch (value) {
        case "0":
          return this.$t("app_prePushVerify");
        case "1":
          return this.$t("app_preVerify");
        case "2":
          return this.$t("app_verifyPass");
        case "3":
          return this.$t("app_verifyNotPass");
      }
    }
  },
  methods: {
    sortChange: function sortChange(vl) {
      switch (vl.prop) {
        case 'userNickName':
          this.orderName = '1';
          break;
        case 'userName':
          this.orderName = '2';
          break;
        case 'createTime':
          this.orderName = '3';
          break;
      }
      this.orderType = vl.order == 'descending' ? 'desc' : 'asc';
      this.getAppList();
    },
    pushCreateCer: function pushCreateCer() {
      this.$router.push({ path: "/certificate/new" });
    },
    pushUploadCer: function pushUploadCer() {
      this.$router.push({ path: "/certificate/upload" });
    },
    bindOperate: function bindOperate(row) {
      var _this = this;

      this.dvLoading = 1;
      if (this.$appUrlTag === 0) {
        this.$bindApp("0", row.terminalNo, this.appId, function (res) {
          if (res.status === 200) {
            _this.$message.success(_this.$t("app_tipViewTask"));
          } else {
            _this.$message.error(res.message);
          }
          _this.dvLoading = 0;
        }, function () {
          _this.dvLoading = 0;
        });
      } else {
        this.$bindApp1(localStorage.mechanismId, row.terminalNo, this.appId, function (res) {
          if (res.status === 200) {
            _this.$message.success(_this.$t("app_tipViewTask"));
          } else {
            _this.$message.error(res.message);
          }
          _this.dvLoading = 0;
        }, function () {
          _this.dvLoading = 0;
        });
      }
    },
    getChannels: function getChannels() {
      var _this2 = this;

      this.$getChannelList(10000, 1, '', '', '', function (res) {
        if (res.status === 200) {
          _this2.channels = res.data;
        } else {
          _this2.$message.error(res.message);
        }
      }, function () {
        _this2.$message.error(_this2.$t("app_rqsError"));
      });
    },
    getStatus: function getStatus(value) {
      switch (value) {
        case "0":
          return { vl: this.$t("app_prePushVerify"), style: "color:#8492A6;" };
        case "1":
          return { vl: this.$t("app_preVerify"), style: "color:#F7BA2A;" };
        case "2":
          return { vl: this.$t("app_verifyPass"), style: "color:#13CE66;" };
        case "3":
          return { vl: this.$t("app_verifyNotPass"), style: "color:#FF4949;" };
      }
    },
    srchDevice: function srchDevice() {
      this.getDevices();
    },
    selectDvChange: function selectDvChange(vl) {
      this.getDevices();
    },
    pageDvSized: function pageDvSized(val) {
      this.$gRow = val;
      this.getDevices();
    },
    getDevices: function getDevices() {
      var _this3 = this;

      var vl = this.srchValue ? this.srchValue : "";
      var channel = this.channelId ? this.channelId : "";
      var status = this.status ? this.status : "";
      var appId = this.appId ? this.appId : "";
      this.dvLoading = 1;
      if (this.$appUrlTag === 0) {
        this.$getDevices(this.dvIndex, this.$gRow, channel, vl, status, "", appId, function (res) {
          _this3.dvLoading = 0;
          if (res.data) {
            _this3.dvTableData = res.data;
            _this3.dvTotal = res.total;
          }
        }, function () {
          _this3.dvLoading = 0;
        });
      } else {
        this.$getDevices1(this.dvIndex, this.$gRow, localStorage.mechanismId, vl, status, "", appId, function (res) {
          console.log("dv", res);
          _this3.dvLoading = 0;
          if (res.data) {
            _this3.dvTableData = res.data;
            _this3.dvTotal = res.total;
          }
        }, function () {
          _this3.dvLoading = 0;
        });
      }
    },
    pushApp: function pushApp(row) {

      this.$setWObj("pushList", { data: row, type: "1" });
      this.$router.push({ path: "/appList/pushapp" });
    },
    query: function query() {
      this.getAppList();
    },
    selectChange: function selectChange(vl) {
      this.getAppList();
    },
    reset: function reset() {
      this.queryKey = "";
      this.appType = "";
      this.getAppList();
    },
    pageSelect: function pageSelect(index) {
      this.$setWPage("appPage", index);
      this.getAppList();
    },
    pageDvSelect: function pageDvSelect(index) {
      this.dvIndex = index;
      this.getDevices();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getAppList();
    },
    deleteApp: function deleteApp(obj) {
      var _this4 = this;

      this.$showConfirm(this.$t("app_tip"), this.$t("app_tipMkDel"), this.$t("app_sure"), this.$t("app_cancel"), "warning", function () {
        if (_this4.$appUrlTag === 0) {
          _this4.$deleteApp(obj.applicationid, function (res) {
            if (res.status === 200) {
              _this4.getAppList();
            } else {
              _this4.$message(res.message);
            }
          }, "");
        } else {
          _this4.$deleteApp1(obj.applicationid, function (res) {
            if (res.status === 200) {
              _this4.getAppList();
            } else {
              _this4.$message(res.message);
            }
          }, "");
        }
      }, "");
    },
    submitApp: function submitApp(obj) {
      var _this5 = this;

      this.$showConfirm(this.$t("app_tip"), this.$t("app_tipVerify"), this.$t("app_sure"), this.$t("app_cancel"), "warning", function () {
        _this5.loading = 1;
        if (_this5.$appUrlTag === 0) {
          _this5.$submitVerifyApp(obj.applicationid, function (res) {
            _this5.loading = 0;
            if (res.status === 200) {
              _this5.getAppList();
            } else {
              _this5.$message.error(res.message);
            }
          }, function () {
            _this5.loading = 0;
          });
        } else {
          _this5.$submitVerifyApp1(obj.applicationid, function (res) {
            _this5.loading = 0;
            if (res.status === 200) {
              _this5.getAppList();
            } else {
              _this5.$message.error(res.message);
            }
          }, function () {
            _this5.loading = 0;
          });
        }
      }, "");
    },
    cellClick: function cellClick(row, ev, col) {},
    jumpToUpload: function jumpToUpload() {
      var _this6 = this;

      this.loading = 1;
      this.$isCer(this.mechanismId, function (res) {
        _this6.loading = 0;

        if (!res.data) {
          _this6.$setWObj("editAppConfig", { type: 0 });
          _this6.$router.push({ name: _this6.$t("menu.appManageSub.uploadApp") });
        } else {
          _this6.cerTipMsg = res.message;
          var vl = localStorage.cerType;
          if (vl === "0") {
            _this6.cerDialogVisible = true;
          } else {
            _this6.cerTipDialogVisible = true;
          }
        }
      }, function () {});
    },
    getAppList: function getAppList() {
      var _this7 = this;

      this.loading = 1;
      var type = this.queryType ? this.queryType : "";
      var name = this.queryAccount ? this.queryAccount : "";
      var ct = this.queryContent ? this.queryContent : "";

      this.$logList(this.$getWPage("appPage"), this.$gRow, '', '', type, name, ct, this.orderName, this.orderType, function (res) {
        console.log(res);
        _this7.loading = 0;
        if (res.status === 200) {
          _this7.total = res.total;
          _this7.tableData = res.data;
        } else {
          _this7.$message(res.message);
        }
      }, function () {
        _this7.loading = 0;
        _this7.$message.error(_this7.$t("app_rqsError"));
      });
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return "";
      }
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format("YYYY-MM-DD HH:mm:ss");
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    }
  },
  mounted: function mounted() {
    this.getAppList();
  },
  destroyed: function destroyed() {}
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qrcodejs2__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qrcodejs2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qrcodejs2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_url__ = __webpack_require__(3);


var md5 = __webpack_require__(53);



__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.withCredentials = true;
/* harmony default export */ __webpack_exports__["default"] = ({
  name: "info",

  data: function data() {
    var _this = this;

    var validatePass = function validatePass(rule, value, callback) {
      if (value === "") {
        callback(new Error(_this.$t("lin_global.plePassTips")));
      } else {
        if (_this.formPwd.checkPass !== "") {
          _this.$refs.formPwd.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = function validatePass2(rule, value, callback) {
      var reg = /^((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\W_])).{8,}$/;
      if (value === "") {
        callback(new Error(_this.$t("lin_global.plePassTipsAgain")));
      } else if (value !== _this.formPwd.pass) {
        callback(new Error(_this.$t("lin_global.pwdDisfault")));
      } else if (!reg.test(value)) {
        callback(new Error(_this.$t("app_pswtip")));
      } else {
        callback();
      }
    };
    return {
      dld: false,
      mfafm: { psw: '', code: '' },
      qrres: '',
      brow: '',
      active: 0,
      isbind: false,
      isunbind: false,
      loading: 0,
      isEditNick: false,
      dialogFormVisible: false,
      formLabelWidth: "14.5%",
      formPwd: {
        oldPass: "",
        pass: "",
        checkPass: ""
      },
      rules2: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }]
      },
      userinfo: {},
      nick: "",
      phone: ""
    };
  },
  created: function created() {
    if (localStorage.getItem("userId")) {
      this.getUserInfo();
    } else {
      this.getInfo();
    }
  },

  computed: {
    certTypeName: function certTypeName() {
      var name = "--";
      if (this.userinfo.certType == 0) {
        name = this.$t("lin_global.ziguan");
      } else if (this.userinfo.certType == 1) {
        name = this.$t("lin_global.daiguan");
      } else {
        name = this.$t("app_cerMgCustomer");
      }
      return name;
    }
  },
  mounted: function mounted() {},

  methods: {
    createQrcode: function createQrcode() {
      new __WEBPACK_IMPORTED_MODULE_0_qrcodejs2___default.a('mfaqrcode', {
        width: 150,
        height: 150,
        text: this.qrres });
    },
    unbindOpe: function unbindOpe() {
      var _this2 = this;

      if (!this.mfafm.code) {
        this.$message.error(this.$t('app_inputNumber'));
        return;
      }
      this.dld = true;
      this.$mfaUnbind(this.brow.userid, this.mfafm.code, function (res) {
        _this2.dld = false;
        if (res.status == 200) {
          _this2.closeUnbind();
          if (localStorage.getItem("userId")) {
            _this2.getUserInfo();
          } else {
            _this2.getInfo();
          }
          _this2.$message.success(res.message);
        } else {
          _this2.$message.error(res.message);
        }
      }, function () {
        _this2.dld = false;
      });
    },
    closeUnbind: function closeUnbind() {
      this.isunbind = false;
      this.mfafm.code = '';
    },
    bindRqs: function bindRqs() {
      var _this3 = this;

      if (!this.mfafm.code) {
        this.$message.error(this.$t('app_inputNumber'));
        return;
      }
      this.dld = true;
      this.$mfaBind(this.brow.userid, this.mfafm.code, function (res) {
        _this3.dld = false;
        if (res.status == 200) {
          _this3.closeBind();
          if (localStorage.getItem("userId")) {
            _this3.getUserInfo();
          } else {
            _this3.getInfo();
          }
          _this3.$message.success(res.message);
        } else {
          _this3.$message.error(res.message);
        }
      }, function () {
        _this3.dld = false;
      });
    },
    nextOpe: function nextOpe(isnext) {
      if (isnext) {
        this.active = this.active + 1 > 2 ? this.active : this.active + 1;
      } else {
        this.active = this.active - 1 == -1 ? this.active : this.active - 1;
      }
    },
    stepClick: function stepClick(isnext) {
      var _this4 = this;

      if (this.active == 0) {
        if (!this.mfafm.psw) {
          this.$message.error(this.$t('lin_global.plePassTips'));
          return;
        } else {
          this.dld = true;
          this.$mfaIdCheck(this.brow.userid, md5(this.mfafm.psw), function (res) {
            _this4.dld = false;
            if (res.status == 200) {
              _this4.nextOpe(isnext);
            } else {
              _this4.$message.error(res.message);
            }
          }, '');
        }
      } else if (this.active == 1) {
        this.nextOpe(isnext);
      } else if (this.active == 2) {
        this.nextOpe(isnext);
      }

      switch (this.active) {
        case 2:
          this.$nextTick(function () {
            _this4.createQrcode();
          });
          break;
      }
    },
    bindOpen: function bindOpen() {
      var _this5 = this;

      this.$mfaQrcode(this.brow.userid, function (res) {
        _this5.qrres = res.data ? res.data.qrCode : '';
      }, '');
    },
    closeBind: function closeBind() {
      this.isbind = false;
      this.dld = false;
      this.mfafm = { psw: '', code: '' };
    },
    mfaClick: function mfaClick() {
      this.brow = this.userinfo;
      if (this.userinfo.bindMfa == 1) {
        this.isunbind = true;
      } else {
        this.isbind = true;
      }
    },
    isLegalMobile: function isLegalMobile(tel) {
      var sMobile = tel;
      var regex = "^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\\d{8}$";
      var re = new RegExp(regex, "g");
      if (!re.test(sMobile)) {
        return false;
      } else {
        return true;
      }
    },
    cancelNick: function cancelNick() {
      this.isEditNick = false;
    },
    saveNick: function saveNick() {
      var _this6 = this;

      if (!this.nick) {
        this.$message.error(this.$t("lin_global.nickNameTips"));
        return;
      }

      if (!this.phone) {
        this.$message.error(this.$t("app_phoneIllegal"));
        return;
      }
      this.loading = 1;
      var userId = localStorage.getItem("userId");
      var params = { userId: userId, nickName: this.nick, phone: this.phone };
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + "/user/updateNickName.do", params).then(function (res) {
        _this6.loading = 0;
        if (res.data.status == 200) {
          _this6.$message.success(res.data.message);
          _this6.userinfo.nickName = _this6.nick;
          _this6.userinfo.phoneNum = _this6.phone;
          _this6.$store.dispatch("setNick", _this6.nick);
          _this6.nick = "";
          _this6.phone = "";
          _this6.isEditNick = false;
        } else {
          _this6.$message.error(res.data.message);
        }
      });
    },
    submitForm: function submitForm(formName) {
      var _this7 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          var userId = localStorage.getItem("userId");
          var params = {
            userId: userId,

            oldPwd: md5(_this7.formPwd.oldPass),
            newPwd: md5(_this7.formPwd.checkPass)
          };

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + "/user/updatePassword.do", params).then(function (res) {
            if (res.data.status == 200) {
              _this7.dialogFormVisible = false;
              _this7.$message.success(res.data.message);
            } else {
              _this7.dialogFormVisible = false;
              _this7.$message.error(res.data.message);
            }
          });
        } else {
          return false;
        }
      });
    },

    onCancel: function onCancel() {},
    edit: function edit(userid, nickname) {
      this.isEditNick = true;
      this.nick = this.userinfo.nickName;
      this.phone = this.userinfo.phoneNum;
    },
    getUserInfo: function getUserInfo() {
      var _this8 = this;

      var userId = localStorage.getItem("userId");
      var params = { userId: userId };
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + "/user/getUserById.do", params).then(function (res) {
        _this8.userinfo = res.data.data;
      });
    },
    getInfo: function getInfo() {
      var _this9 = this;

      var user = localStorage.getItem("user");
      var params = { token: user };
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + "/user/getUser.do", params).then(function (res) {

        _this9.userinfo = res.data.data;

        localStorage.setItem("userId", res.data.data.userid);
        localStorage.setItem("mechanismId", res.data.data.mechanismId);
      });
    }
  }
});

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_core_image_upload__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_core_image_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_core_image_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_global_paging_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_global_paging_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_global_paging_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_6__components_global_mechanism_selector_vue___default.a,
    'vue-core-image-upload': __WEBPACK_IMPORTED_MODULE_4_vue_core_image_upload___default.a,
    paging: __WEBPACK_IMPORTED_MODULE_5__components_global_paging_vue___default.a
  },
  data: function data() {
    var that = this;
    return {
      isscale: true,
      mechanismData: '',
      pagingData: {
        total: null,
        pageSize: 5,
        currentPage: 1
      },
      pickerOptions0: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      pickerOptions1: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },

      errorTip: '',
      croppa: {},
      dfImg: '',
      ratio: '12:5',
      imageUrl: __WEBPACK_IMPORTED_MODULE_3__api_url__["d" /* url */],
      choiceAppVisible: false,

      isCreateType: true,
      temPreview: null,
      editRules: {
        ad_title: [{ required: true, message: this.$t('app_adnamenotnull'), trigger: 'blur' }],
        ad_url: [{ required: true, message: this.$t('mao_global.tip.notBlank'), trigger: 'blur' }],
        ad_channel: [{ required: true, message: this.$t('app_plslchannel'), trigger: 'blur' }],
        ad_position: [{ required: true, message: this.$t('app_plslplpos'), trigger: 'blur' }],
        ad_type: [{ required: true, message: this.$t('app_plsltype'), trigger: 'blur' }],
        ad_imgUrl: [{ required: true, message: this.$t('app_uploadPic'), trigger: 'blur' }]

      },

      channelList: '',
      tmp_appName: '',
      appName: '',
      appList: null,
      adTypeList: null,
      adUlld: false,
      sForm: {
        ad_id: this.$route.params.id,
        ad_imgUrl: null,
        ad_title: null,
        ad_type: '',
        ad_url: null,
        ad_Urltype: '0',
        ad_start_date: null,
        ad_start_end: null,
        ad_content: null,
        ad_position: '0',
        ad_playTimes: '',
        ad_channel: ''
      },
      pAction: {
        handleSizeChange: function handleSizeChange(v) {
          that.pagingData['pageSize'] = v;
          that.pagingData['currentPage'] = 1;
          that.getAppList();
        },
        handleCurrentChange: function handleCurrentChange(v) {
          that.pagingData['currentPage'] = v;

          console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(that.pagingData, null, 4));
          that.getAppList();
        }
      }
    };
  },

  computed: {
    psize: function psize() {
      if (this.sForm.ad_position == 0) {
        return '150';
      } else {
        return '490';
      }
    },
    isShowPP: function isShowPP() {
      return this.sForm.ad_imgUrl ? this.sForm.ad_imgUrl : false;
    },
    sizeTip: function sizeTip() {
      var ps = this.sForm.ad_position;
      var w = this.$t('app_csulpicbsis');
      if (!ps) return '';
      if (ps === '0') {
        return w + '720*300';
      } else if (ps === '1') {
        return w + '720*980';
      }
    },
    imgUploadUrl: function imgUploadUrl() {
      return this.$imgUploadUrl;
    }
  },
  mounted: function mounted() {

    if (this.$route.path.search('edit') != -1) {
      this.isscale = false;
    }

    if (!this.sForm.ad_id) {
      this.sForm.ad_id = '0';
    }
    var that = this;

    that.fetchData();
  },

  watch: {
    choiceAppVisible: function choiceAppVisible(val) {
      var that = this;
      that.tmp_appName = '';

      that.getAppList();
    },
    'sForm.ad_start_date': function sFormAd_start_date(val) {

      var that = this;
      if (val) {
        if (that.sForm.ad_start_end) {
          if (new Date(val).getTime() > new Date(that.sForm.ad_start_end).getTime()) {
            that.sForm.ad_start_end = '';
          }
        }
        that.pickerOptions1 = {
          disabledDate: function disabledDate(time) {
            var vl = time.getTime() < new Date(val).getTime() + 8.64e7;
            return vl;
          }
        };
      }
    },
    'sForm.ad_Urltype': function sFormAd_Urltype(val) {
      var that = this;
      that.sForm.ad_url = '';

      that.tmp_appName = '';
    },
    'sForm.ad_position': function sFormAd_position(val) {
      var that = this;
      if (val === '0') {
        that.ratio = '12:5';
      } else if (val === '1') {
        that.ratio = '34:49';
      } else {
        that.ratio = '12:5';
      }
    }
  },
  methods: {
    getImgName: function getImgName() {
      var arr = this.sForm.ad_imgUrl.split('/');
      return arr[arr.length - 1];
    },
    scaleChange: function scaleChange() {
      this.sForm.ad_imgUrl = '';
    },
    hBlur: function hBlur() {
      this.$refs['sForm'].validate(function (valid) {
        if (valid) {} else {
          return false;
        }
      });
    },
    uploadRqs: function uploadRqs(file, type) {
      var _this = this;
      this.adUlld = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$adUlUrl, {
        file: file,
        flix: type
      }).then(function (res) {
        _this.adUlld = false;
        if (res.data.status == 200) {
          _this.sForm.ad_imgUrl = res.data.data;
          _this.hBlur();
        } else {
          _this.$message.error(res.data.message);
          _this.sForm.ad_imgUrl = '';
        }
      }).catch(function (res) {
        _this.adUlld = false;
        _this.sForm.ad_imgUrl = '';
        _this.$message.error(this.$t('app_picUlError'));
      });
    },
    upload: function upload() {
      var _this2 = this;

      var _this = this;
      if (!this.croppa.hasImage()) {
        this.$message(this.$t('app_uploadPic'));
        return;
      }
      this.croppa.generateBlob(function (blob) {
        _this2.blobToDataURL(blob, function (img) {
          _this.uploadRqs(img, blob.type.replace('image/', ''));
        });
      });
    },
    upload1: function upload1(file) {
      var _this = this;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function (event) {
        var img_base64 = this.result;
        _this.uploadRqs(img_base64, file.type.replace('image/', ''));
      };
      return false;
    },
    blobToDataURL: function blobToDataURL(blob, callback) {
      var a = new FileReader();
      a.onload = function (e) {
        callback(e.target.result);
      };
      a.readAsDataURL(blob);
    },
    imageuploaded: function imageuploaded(res) {
      if (res.status !== 200) {
        this.$message.error(res.message);
      } else {
        this.sForm.ad_imgUrl = res.data;
      }
    },
    choiceAppRecord: function choiceAppRecord(v) {
      var that = this;
      setTimeout(function () {
        that.appName = v['appName'];
        that.sForm.ad_url = v['applicationid'];
        that.choiceAppVisible = false;
      }, 300);
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).format('YYYY-MM-DD');
    },
    getAppListByName: function getAppListByName() {
      var that = this;
      that.pagingData['currentPage'] = 1;

      that.getAppList(that.tmp_appName);
    },
    getAppList: function getAppList(name) {
      var _this3 = this;

      var that = this;
      var aName = that.tmp_appName || '';


      this.$getDistributeAppList1(aName, '', that.pagingData.pageSize, that.pagingData.currentPage, localStorage.mechanismId, '', '', function (res) {
        if (res.status === 200) {
          that.appList = res.data;
          if (res.total) that.pagingData['total'] = res.total;
        } else {
          _this3.$message.error(res.message);
        }
      }, function () {});
    },
    resetImg: function resetImg() {
      var that = this;
      that.sForm.ad_imgUrl = null;
      that.isCreateType = true;
    },
    OnUploadSuccess: function OnUploadSuccess(res, file) {
      if (res.status !== 200) {
        this.$message.error(res.message);
      } else {
        this.sForm.ad_imgUrl = res.data;
        this.temPreview = URL.createObjectURL(file.raw);
      }
    },
    baseEditAdvert: function baseEditAdvert(url, msg) {
      var that = this;

      function FormatDate(fmt, date) {
        var o = {
          "M+": date.getMonth() + 1,
          "d+": date.getDate(),
          "h+": date.getHours(),
          "m+": date.getMinutes(),
          "s+": date.getSeconds(),
          "q+": Math.floor((date.getMonth() + 3) / 3),
          "S": date.getMilliseconds() };
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o) {
          if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }return fmt;
      }

      this.$refs['sForm'].validate(function (result) {

        if (result) {
          var getFormatDate = function getFormatDate(arg) {
            if (arg == undefined || arg == '') {
              return '';
            }

            var re = arg + '';
            if (re.length < 2) {
              re = '0' + re;
            }

            return re;
          };

          var addDate = function addDate(date, days) {
            if (days == undefined || days == '') {
              days = 1;
            }
            var date = new Date(date);
            date.setDate(date.getDate() + days);
            var month = date.getMonth() + 1;
            var day = date.getDate();
            return date.getFullYear() + '-' + getFormatDate(month) + '-' + getFormatDate(day);
          };

          if (!that.sForm.ad_imgUrl || that.sForm.ad_imgUrl === "") {
            that.$message.error(this.$t('app_spic'));
            return;
          }

          if (!that.sForm.ad_start_date || that.sForm.ad_start_date === "") {
            that.$message.error(this.$t('app_slsttime'));
            return;
          } else {
            that.sForm.ad_start_date = FormatDate('yyyy-MM-dd', new Date(that.sForm.ad_start_date));
          }

          if (!that.sForm.ad_start_end || that.sForm.ad_start_end === "") {
            that.$message.error(this.$t('app_slendtime'));
            return;
          } else {
            that.sForm.ad_start_end = FormatDate('yyyy-MM-dd', new Date(that.sForm.ad_start_end));
          }

          console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(that.sForm, null, 2));

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__api_url__["a" /* baseurl */] + '/admanage/' + url, that.sForm).then(function (res) {
            if (res.data && res.data.status && res.data.status === 200) {
              that.$message(msg);
              that.$router.push({ path: "/advert-list" });
            }
          });
        }
      }.bind(that));
    },
    updateAdvert: function updateAdvert() {
      var that = this;
      that.baseEditAdvert('edit.do', this.$t('app_updateSuccess'));
    },
    createAdvert: function createAdvert() {
      var that = this;

      that.baseEditAdvert('add.do', this.$t('app_addsc'));
    },
    cancelEdit: function cancelEdit() {
      var that = this;
      that.$router.push({ path: "/advert-list" });
    },
    fetchChannel: function fetchChannel() {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__api_url__["a" /* baseurl */] + '/mechanism/list.do', { 'page': 1, rows: 10000 }).then(function (res) {
        that.channelList = res.data.data;
      });
    },
    fetchData: function fetchData() {
      var _this4 = this;

      var that = this;
      if (that.sForm.ad_id === '0') {
        that.isCreateType = false;
        that.mechanismData = {
          value: '',
          callback: function callback(value) {
            that.sForm.ad_channel = value;
          }
        };
      } else {

        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__api_url__["a" /* baseurl */] + '/advertisement/detail.do', { 'id': that.sForm.ad_id }).then(function (res) {

          var obj = res.data.data;

          if (!obj) return;
          that.dfImg = that.imageUrl + obj['adImgurl'];

          that.sForm = {
            ad_id: obj['adId'],
            ad_imgUrl: obj['adImgurl'],
            ad_status: obj['adStatus'],
            ad_title: obj['adTitle'],
            ad_type: obj['adType'],
            ad_url: obj['adUrl'],
            ad_Urltype: obj['adUrltype'],
            ad_start_date: obj['adStartDate'].split(' ')[0],
            ad_start_end: obj['adStartEnd'].split(' ')[0],
            ad_content: obj['adContent'],
            ad_position: obj['adPosition'],
            ad_playTimes: obj['adPlayTimes'] || '',
            ad_channel: obj['pMechanism'] ? obj['pMechanism']['mechanismid'] : '' };

          that.mechanismData = {
            value: obj['pMechanism'] ? obj['pMechanism']['mechanismname'] : '',
            callback: function callback(value) {
              that.sForm.ad_channel = value;
            }
          };

          that.appName = obj.appName;

          if (obj['reFuseReason']) {
            that.errorTip = _this4.$t('mao_global.tip.notPassExamine') + ":" + obj['reFuseReason'];
          }

          if (that.sForm.ad_Urltype == '1' && obj.appId) {
            var appData = {
              appName: obj.appName,
              applicationid: obj.appId
            };

            that.choiceAppRecord(appData);
          }
        });
      }

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__api_url__["a" /* baseurl */] + '/adType/list.do', { 'page': 1, rows: 10000 }).then(function (res) {
        that.adTypeList = res.data.data;
      });
    }
  }
});

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_core_image_upload__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_core_image_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_core_image_upload__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'vue-core-image-upload': __WEBPACK_IMPORTED_MODULE_4_vue_core_image_upload___default.a
  },
  data: function data() {
    return {
      errorTip: '',

      ratio: '24:1',
      imageUrl: __WEBPACK_IMPORTED_MODULE_3__api_url__["d" /* url */],
      choiceAppVisible: false,

      isCreateType: true,
      temPreview: null,
      editRules: {
        ad_title: [{ required: true, message: this.$t('app_adnamenotnull'), trigger: 'blur' }],
        ad_url: [{ required: true, message: this.$t('mao_global.tip.notBlank'), trigger: 'blur' }],
        ad_channel: [{ required: true, message: this.$t('app_plslchannel'), trigger: 'blur' }]
      },

      channelList: '',
      tmp_appName: '',
      appName: '',
      appList: null,
      adTypeList: null,
      sForm: {
        ad_id: this.$route.params.id,
        ad_imgUrl: null,
        ad_title: null,
        ad_type: '',
        ad_url: null,
        ad_Urltype: '0',
        ad_start_date: null,
        ad_start_end: null,
        ad_content: null,
        ad_position: '0',
        ad_playTimes: '',
        ad_channel: ''
      }
    };
  },

  computed: {
    imgUploadUrl: function imgUploadUrl() {
      return this.$imgUploadUrl;
    }
  },
  mounted: function mounted() {
    var that = this;
    that.fetchChannel();
    that.fetchData();
  },

  methods: {
    jumpToUpdate: function jumpToUpdate() {
      var that = this;
      that.$router.push({ path: '/advert-list/edit/' + that.sForm.ad_id });
    },
    imageuploaded: function imageuploaded(res) {
      if (res.status !== 200) {
        this.$message.error(res.message);
      } else {
        this.sForm.ad_imgUrl = res.data;
      }
    },
    choiceAppRecord: function choiceAppRecord(v) {
      var that = this;

      setTimeout(function () {
        that.appName = v['appName'];
        that.sForm.ad_url = v['applicationid'];

        that.choiceAppVisible = false;
      }, 300);
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).format('YYYY-MM-DD');
    },
    getAppListByName: function getAppListByName() {
      var that = this;
      that.getAppList(that.tmp_appName);
    },
    getAppList: function getAppList(name) {
      var that = this;

      var aName = '';
      if (name && name !== '') aName = name;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__api_url__["a" /* baseurl */] + '/app/list.do', { 'page': 1, rows: 15, appName: aName, appCategoryId: '', appStatus: '2' }).then(function (res) {
        that.appList = res.data.data;
      });
    },
    dateFormat2: function dateFormat2(date) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).format('YYYY-MM-DD');
    },
    cancelEdit: function cancelEdit() {
      var that = this;
      that.$router.push({ path: "/advert-list" });
    },
    fetchChannel: function fetchChannel() {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__api_url__["a" /* baseurl */] + '/mechanism/list.do', { 'page': 1, rows: 10000 }).then(function (res) {
        that.channelList = res.data.data;
      });
    },
    fetchData: function fetchData() {
      var _this = this;

      var that = this;

      if (that.sForm.ad_id === '0') {
        that.isCreateType = false;
      } else {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__api_url__["a" /* baseurl */] + '/advertisement/detail.do', { 'id': that.sForm.ad_id }).then(function (res) {
          var obj = res.data.data;
          console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj, null, 2));
          that.sForm = {
            ad_id: obj['adId'],
            ad_imgUrl: obj['adImgurl'],
            ad_status: obj['adStatus'],
            ad_title: obj['adTitle'],
            ad_type: obj['adType'],
            ad_url: obj['adUrl'],
            ad_Urltype: obj['adUrltype'],
            ad_start_date: obj['adStartDate'],
            ad_start_end: obj['adStartEnd'],
            ad_content: obj['adContent'],
            ad_position: obj['adPosition'],
            ad_playTimes: obj['adPlayTimes'] || '',
            ad_channel: obj['pMechanism'] ? obj['pMechanism']['mechanismid'] : '',
            ad_channel_name: obj['pMechanism'] ? obj['pMechanism']['mechanismname'] : '' };

          if (obj['reFuseReason']) {
            that.errorTip = _this.$t('mao_global.tip.notPassExamine') + ":" + obj['reFuseReason'];
          }

          if (that.sForm.ad_Urltype == '1') {
            var appData = {
              appName: obj.appName
            };

            that.choiceAppRecord(appData);
          }
        });
      }

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__api_url__["a" /* baseurl */] + '/adType/list.do', { 'page': 1, rows: 10000 }).then(function (res) {
        that.adTypeList = res.data.data;
      });
    }
  }
});

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_paging_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_paging_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_paging_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    paging: __WEBPACK_IMPORTED_MODULE_3__components_global_paging_vue___default.a
  },
  data: function data() {
    var that = this;
    return {
      isAble: '1',

      refuse_reason: '',
      imageUrl: __WEBPACK_IMPORTED_MODULE_2__api_url__["d" /* url */],
      pagingData: {
        total: 0,
        pageSize: 10,
        currentPage: 1
      },
      pAction: {
        handleSizeChange: function handleSizeChange(v) {
          that.filterParam['rows'] = v;
          that.filterParam['page'] = 1;
          that.fetchData();
        },
        handleCurrentChange: function handleCurrentChange(v) {
          that.filterParam['page'] = v;
          that.fetchData();
        }
      },
      dialogFormVisible: false,
      adTypeList: null,
      resultData: null,
      sbForm: {
        ad_id: null,
        ad_status: null,
        refuse_reason: null,
        token: null
      },
      editorForm: {},
      tableData: [],

      searchForm: {}
    };
  },

  computed: {},
  mounted: function mounted() {
    var that = this;
    that.fetchData(true);
    that.fetchTypeList();
  },

  methods: {
    dateFormat2: function dateFormat2(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD');
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD');
    },
    sbIsAble: function sbIsAble() {
      var _this = this;

      var that = this;

      var data = {
        ad_id: that.editorForm['adId'],
        ad_status: 2,
        refuse_reason: ''
      };

      if (that.isAble === '0') {
        if (!that.refuse_reason || that.refuse_reason === "") {
          that.$message.error(this.$t('mao_global.tip.groundsForRefusal'));
          return false;
        }

        data['refuse_reason'] = that.refuse_reason;
        data['ad_status'] = 3;
      }

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/admanage/examine.do', data).then(function (res) {
        that.$message(_this.$t('app_vlsuccess'));
        that.fetchData();
        that.dialogFormVisible = false;
        that.$router.push({ path: '/examine-list' });
      });
    },
    jump: function jump(url) {
      var that = this;

      that.$router.push({ path: url });
    },
    cellClick: function cellClick(v, url) {
      var that = this;
      if (url) {
        that.$router.push({ path: '/examine-list/' + v.adId });
      }
    },
    fetchTypeList: function fetchTypeList() {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/adType/list.do', { 'page': 1, rows: 10000 }).then(function (res) {
        that.adTypeList = res.data.data;
        that.loading = false;
      });
    },
    handleSizeChange: function handleSizeChange() {},
    handleCurrentChange: function handleCurrentChange() {},
    handleSelectionChange: function handleSelectionChange() {},
    pagingFetch: function pagingFetch() {},
    searchFetch: function searchFetch() {},
    initFilterParams: function initFilterParams() {
      var that = this;
      that.filterParam = { page: 1, rows: 20, ad_title: '', ad_type: '', distributorId: localStorage.getItem('mechanismId'), ad_position: '', ad_status: '1' };
      return that.filterParam;
    },
    recordDetail: function recordDetail() {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/advertisement/detail.do', { 'id': that.sForm.ad_id }).then(function (res) {
        var obj = res.data.data;
        that.sForm = {
          ad_id: obj['adId'],
          ad_imgUrl: obj['adImgurl'],
          ad_title: obj['adTitle'],
          ad_type: obj['adType'],
          ad_url: obj['adUrl'],
          ad_Urltype: obj['adUrltype'],
          ad_start_date: obj['adStartDate'],
          ad_start_end: obj['adStartEnd'],
          ad_content: obj['adContent'],
          ad_position: obj['adPosition'],
          ad_playTimes: obj['adPlayTimes'] || '' };
      });
    },
    fetchData: function fetchData(bool) {

      var that = this;

      if (bool) that.initFilterParams();

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/admanage/list.do', that.filterParam).then(function (res) {
        if (res.data && res.data.status && res.data.status === 200) {
          that.resultData = res.data.data;

          if (res.data.total) that.pagingData['total'] = res.data.total;
        }
      });
    }
  }
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_url__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isAble: '1',
      adId: this.$route.params.id,
      editorForm: {},
      adTypeList: [],
      loading: true,
      imageUrl: __WEBPACK_IMPORTED_MODULE_2__api_url__["d" /* url */],

      refuse_reason: ''
    };
  },

  computed: {},
  mounted: function mounted() {
    var that = this;

    that.fetchData();

    that.fetchTypeList();
  },

  methods: {
    sbIsAble: function sbIsAble() {
      var _this = this;

      var that = this;

      var data = {
        ad_id: that.editorForm['adId'],
        ad_status: 2,
        refuse_reason: ''
      };

      if (that.isAble === '0') {
        if (!that.refuse_reason || that.refuse_reason === "") {
          that.$message.error(this.$t('mao_global.tip.groundsForRefusal'));
          return false;
        }

        data['refuse_reason'] = that.refuse_reason;
        data['ad_status'] = 3;
      }

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/admanage/examine.do', data).then(function (res) {
        that.$message(_this.$t('app_vlsuccess'));
        that.fetchData();
        that.dialogFormVisible = false;
        that.$router.push({ path: '/examine-list' });
      });
    },
    dateFormat2: function dateFormat2(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD');
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD');
    },
    fetchTypeList: function fetchTypeList() {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/adType/list.do', { 'page': 1, rows: 10000 }).then(function (res) {
        that.adTypeList = res.data.data;
      });
    },
    fetchData: function fetchData() {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/advertisement/detail.do', { 'id': that.adId }).then(function (res) {
        that.editorForm = res.data.data;
      });
    }
  }
});

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_paging_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_paging_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_paging_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    paging: __WEBPACK_IMPORTED_MODULE_3__components_global_paging_vue___default.a
  },
  data: function data() {
    var that = this;
    return {
      batchRecord: null,
      loading: true,
      adTypeList: null,
      listStatus: '',
      pagingData: {
        total: 5,
        pageSize: 20,
        currentPage: 1
      },
      stArray: [{ label: this.$t('lin_global.all_status'), value: '' }, { label: this.$t('advert.waitOne'), value: '0' }, { label: this.$t('advert.waitTwo'), value: '1' }, { label: this.$t('advert.pass'), value: '2' }, { label: this.$t('advert.notPass'), value: '3' }, { label: this.$t('app_ustart'), value: '4' }, { label: this.$t('app_outofdate'), value: '5' }],
      resultData: [],

      filterParam: { page: 1, rows: 20, ad_title: '', distributorId: localStorage.getItem('mechanismId'), ad_type: '-1', ad_position: '-1', ad_status: '' },
      pAction: {
        handleSizeChange: function handleSizeChange(v) {
          that.filterParam['rows'] = v;
          that.filterParam['page'] = 1;
          that.fetchData();
        },
        handleCurrentChange: function handleCurrentChange(v) {
          that.filterParam['page'] = v;
          that.fetchData();
        }
      }
    };
  },
  mounted: function mounted() {
    var that = this;

    that.fetchData(true);

    that.fetchTypeList();
  },

  methods: {
    statusChange: function statusChange() {
      this.fetchData(false);
    },
    cellClick: function cellClick(row, event) {
      var that = this;
      if (event.target.className == 'el-checkbox__original' || event.target.className == 'el-checkbox__inner') {
        return false;
      } else {
        that.$router.push({ path: '/advert-list/detail/' + row.adId });
      }
    },
    batchDelete: function batchDelete() {
      var that = this;
      if (!that.batchRecord || that.batchRecord.length < 1) {
        that.$message("没有选中记录");
        return false;
      }

      var tmp = "";
      var len = that.batchRecord.length;
      for (var i = 0; i < len; i++) {
        var o = that.batchRecord[i];
        tmp += o['adId'] + ",";
      }

      tmp = tmp.substr(0, tmp.length - 1);

      that.deleteRecord(tmp);
    },
    sbIsAble: function sbIsAble(id) {
      var _this = this;

      var that = this;

      var data = {
        ad_id: id,
        ad_status: 1,
        refuse_reason: ''
      };
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/admanage/examine.do', data).then(function (res) {
        that.$message(_this.$t('app_opsuccess'));
        that.fetchData();
      });
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('YYYY-MM-DD');
    },
    fetchTypeList: function fetchTypeList() {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/adType/list.do', { 'page': 1, rows: 10000 }).then(function (res) {
        that.adTypeList = res.data.data;
        that.loading = false;
      });
    },
    jump: function jump(url) {
      this.$router.push({ path: url });
    },
    deleteRecord: function deleteRecord(id) {
      var _this2 = this;

      var that = this;

      that.$confirm(this.$t('mao_global.tip.confirmDelete'), this.$t('mao_global.tip.text'), {
        confirmButtonText: this.$t('mao_global.btn.ok'),
        cancelButtonText: this.$t('mao_global.btn.cancel'),
        type: 'warning'
      }).then(function () {
        var param = { "ad_id": id };
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/admanage/delete.do', param).then(function (res) {
          if (res.data && res.data.status && res.data.status === 200) {
            that.$message(_this2.$t('app_opsuccess'));
            that.fetchData(true);
          }
        });
      }).catch(function () {});
    },
    jumpToEdit: function jumpToEdit(data) {
      var that = this;
      that.$router.push({ path: '/advert-list/edit/' + data.adId });
    },
    handleSelectionChange: function handleSelectionChange(v) {
      var that = this;
      that.batchRecord = v;
    },
    resetSearchForm: function resetSearchForm() {
      var that = this;
      that.filterParam['ad_title'] = '';
      that.filterParam['ad_type'] = '-1';
      that.filterParam['ad_position'] = '-1';

      var that = this;
      that.fetchData(true);
    },
    searchFetch: function searchFetch() {
      var that = this;
      that.fetchData();
    },
    initFilterParams: function initFilterParams() {
      var that = this;
      that.filterParam = { page: 1, rows: 20, ad_title: '', distributorId: localStorage.getItem('mechanismId'), ad_type: '-1', ad_position: '-1', ad_status: '' };
      return that.filterParam;
    },
    setFilterParams: function setFilterParams() {},
    fetchData: function fetchData(bool) {

      var that = this;

      if (bool) that.initFilterParams();

      var smf = {
        page: that.filterParam['page'],
        rows: that.filterParam['rows'],
        ad_title: that.filterParam['ad_title'],
        ad_type: that.filterParam['ad_type'],
        ad_position: that.filterParam['ad_position'],
        distributorId: localStorage.getItem('mechanismId'),
        ad_status: this.listStatus
      };

      if (smf['ad_type'] === '-1') smf['ad_type'] = '';
      if (smf['ad_position'] === '-1') smf['ad_position'] = '';

      that.req.advert.list(smf).then(function (res) {
        if (res.data && res.status && res.status === 200) {
          that.resultData = res.data;

          if (res.total) that.pagingData['total'] = res.total;
        }
      });
    },
    adPosSelectChange: function adPosSelectChange(vl) {
      var that = this;
      that.fetchData();
    },
    adTypeSelectChange: function adTypeSelectChange(vl) {
      var that = this;
      that.fetchData();
    }
  }
});

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_df_png__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_df_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_df_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__);


var _methods;




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var that = this;
    return {
      dLoading: false,
      srchValue: '',
      reason: '',
      config: '',
      captures: [],
      loading: 0,
      dialogVisible: false,
      notPassDialog: false,
      index: 1,
      tableData: [],
      playUrl: '',
      total: 0,
      status: '',
      mech: '',
      stModel: [{ label: '在线', vl: '1' }, { label: '离线', vl: '2' }],
      mechanismData: {
        callback: function callback(value) {
          that.mech = value;
          that.selectChange(value);
        }
      }
    };
  },

  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default.a
  },
  computed: {
    showUploadNew: function showUploadNew() {
      console.log('ccc', this.config.data);
      if (this.config.data) {
        if (this.config.data.isoperation === 0 && this.config.data.appStatus === '2') {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  methods: (_methods = {
    makeCreateTime: function makeCreateTime(ts) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(ts).format('YYYY-MM-DD hh:mm:ss');
    },
    timeLimit: function timeLimit(row) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(row.sTime).format('YYYY-MM-DD') + '~' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(row.eTime).format('YYYY-MM-DD');
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'makeCreateTime', function makeCreateTime(ts) {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(ts).format('YYYY-MM-DD hh:mm:ss');
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'bindOperate', function bindOperate(row) {
    var _this = this;

    this.dLoading = 1;
    this.$pushLauncher(this.config.launcherid, row.terminalNo, localStorage.mechanismId, function (res) {
      _this.dLoading = 0;
      if (res.status === 200) {
        _this.$message.success(_this.$t('app_tipViewTask'));
        _this.notPassDialog = false;
      } else {
        _this.$message.error(res.message);
      }
    }, function (error) {
      _this.dLoading = 0;
      _this.$message.error(_this.$t('app_rqsError'));
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'verify', function verify(vl) {
    var _this2 = this;

    if (vl === '2') {
      this.$confirm(this.$t('app_srpassvf') + '?', this.$t('app_tip'), {
        confirmButtonText: this.$t('app_sure'),
        cancelButtonText: this.$t('app_cancel'),
        type: 'warning'
      }).then(function () {
        _this2.verifyRqs(vl);
      }).catch(function () {});
    } else if (vl === '3') {
      this.notPassDialog = true;
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'verifyRqs', function verifyRqs(vl) {
    var _this3 = this;

    this.loading = 1;
    this.$verifyVideo(this.config.videoid, vl, this.reason, function (res) {
      _this3.loading = 0;
      if (res.status === 200) {
        _this3.$message.success(res.message);
        _this3.$router.go(-1);
      } else {
        _this3.$message.error(res.message);
      }
    }, function () {
      _this3.$message.error(_this3.$t('app_rqsError'));
      _this3.loading = 0;
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'srchDevice', function srchDevice() {
    this.getDevices();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'selectChange', function selectChange(vl) {
    this.getDevices();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'pageSelect', function pageSelect(index) {
    this.index = index;
    this.getDevices();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'pageSized', function pageSized(val) {
    this.$gRow = val;
    this.getDevices();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'getDevices', function getDevices() {
    var _this4 = this;

    var vl = this.srchValue ? this.srchValue : '';
    var channel = this.channelId ? this.channelId : '';
    var status = this.status ? this.status : '';
    var mc = this.mech;
    this.loading = 1;
    this.$pushLauncherList(this.index, this.$gRow, mc, vl, status, '', this.config.launcherid, '', function (res) {
      console.log('dv', res);
      _this4.loading = 0;
      if (res.data) {
        _this4.tableData = res.data;
        _this4.total = res.total;
      }
    }, function () {
      _this4.loading = 0;
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'setInstallType', function setInstallType(type) {
    return this.$installType[type];
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'dateFormat', function dateFormat(row, column) {
    var date = row[column.property];
    if (date === undefined) {
      return '';
    }
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD hh:mm:ss');
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'selectChange', function selectChange(vl) {
    this.getDevices();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'pageSelect', function pageSelect(index) {
    this.index = index;
    this.getDevices();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'pageSized', function pageSized(val) {
    this.$gRow = val;
    this.getDevices();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'deleteAppHis', function deleteAppHis(row) {
    var _this5 = this;

    if (row.applicationid) {
      this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
        confirmButtonText: this.$t('app_sure'),
        cancelButtonText: this.$t('app_cancel'),
        type: 'warning'
      }).then(function () {
        _this5.loading = 1;
        if (_this5.$appUrlTag === 0) {
          _this5.$deleteApp(row.applicationid, function (res) {
            _this5.loading = 0;
            if (res.status === 200) {
              _this5.getAppHistory();
            } else {
              _this5.$message.error(res.message);
            }
          }, function () {
            _this5.loading = 0;
          });
        } else {
          _this5.$deleteAppHis(row.applicationid, function (res) {
            _this5.loading = 0;
            if (res.status === 200) {
              _this5.getAppHistory();
            } else {
              _this5.$message.error(res.message);
            }
          }, function () {
            _this5.loading = 0;
          });
        }
      }).catch(function () {});
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'imgFullUrl', function imgFullUrl(path) {
    if (path) {
      return this.$urls.prefix + path;
    } else {
      return '';
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'getAppHistory', function getAppHistory() {
    var _this6 = this;

    if (!this.config.data.appName) {
      return;
    }

    this.loading = 1;
    if (this.$appUrlTag === 0) {
      this.$getAppHistory(this.config.data.appName, this.config.data.packagename, function (res) {
        _this6.loading = 0;
        if (res.status === 200) {
          _this6.tableData = res.data;
        } else {
          _this6.$message.error(res.message);
        }
      }, function () {
        _this6.loading = 0;
      });
    } else {

      this.$getAppHistory1(localStorage.mechanismId, this.config.data.packagename, function (res) {

        console.log('his', res);
        _this6.loading = 0;
        if (res.status === 200) {
          _this6.tableData = res.data;
        } else {
          _this6.$message.error(res.message);
        }
      }, function () {
        _this6.loading = 0;
      });
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'uploadNew', function uploadNew() {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'init', function init() {
    this.config = this.$getWObj().viewDefaultVideo;
    console.log(this.config);
    this.playUrl = this.$host + this.config.url;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'setCapturesArr', function setCapturesArr(strs) {
    if (strs) {
      var arr = strs.split(',');
      this.captures = arr;
    }
  }), _methods),
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue__);


var tCheck = function tCheck(rule, value, callback) {
  if (!window.self.form.sTime || !window.self.form.eTime) {

    callback(new Error(window.self.$t('app_select') + window.self.$t('app_tofvalis')));
  } else {
    callback();
  }
};


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue___default.a
  },
  data: function data() {
    var that = this;
    return {
      tipColor: { color: '#13CE66' },
      ulinfo: {
        tip: this.$t('app_ulNormalSt'),
        index: 0,
        icons: ['el-icon-upload', 'el-icon-circle-check', 'el-icon-close']
      },
      mechanismData: '',
      editInfo: '',
      mechs: [],
      loading: 0,
      isUpload: true,
      fileList: [],
      times: [],
      form: {
        videoName: '',
        url: '',
        duration: '',
        size: '',
        hash: '',
        sTime: '',
        eTime: '',
        dimension: ''
      },
      rules: {
        'videoName': [{
          required: true,
          message: this.$t('lin_global.notBlankName')
        }],
        'time': [{
          required: true,
          message: this.$t('app_sllimit'),
          validator: tCheck
        }],
        'type': [{
          required: true,
          message: this.$t('lin_global.qxzlx')
        }],
        'mechanism': [{
          required: true,
          message: this.$t('app_selectChannel')
        }],
        'url': [{
          required: true,
          message: this.$t('app_plsUpl')
        }]
      },
      areaList: [],
      fwVersionInputVisable: true
    };
  },
  mounted: function mounted() {
    var isEdit = this.$route.path === '/video-list/edit-video';
    this.isUpload = !isEdit;
    window.self = this;
    var mVl = '';
    if (!this.isUpload) {
      var obj = this.$getWObj().editVideo.data;
      if (obj) {
        this.editInfo = obj;
        this.fillData();
      }
      mVl = obj.mechanismId;
    }
    this.mechanismData = {
      value: mVl,
      placeholder: this.$t('lin_global.place_areaid'),
      optValue: true,
      callback: function callback(value) {
        this.form.mechanism = value;
      }
    };
  },

  computed: {
    reason: function reason() {
      if (!this.editInfo) {
        return '';
      }
      var rs = this.editInfo.refuseReason;
      return rs ? this.$t('app_banReason') + ':' + rs : this.$t('app_banReason') + ':' + this.$t('app_noInput');
    },
    stHolder: function stHolder() {
      var tip = this.$t('app_slsttime');
      if (this.form.stTime) tip = '';
      return tip;
    },
    endHolder: function endHolder() {
      var tip = this.$t('app_slendtime');
      if (this.form.endTime) tip = '';
      return tip;
    },
    fileUploadUrl: function fileUploadUrl() {
      return this.$urls.fileUrl;
    },
    typeHolder: function typeHolder() {
      if (this.isUpload) {
        return this.$t('app_select');
      } else {
        return '';
      }
    }
  },
  methods: {
    rowDel: function rowDel(item) {
      var findex;
      this.times.forEach(function (vl, index) {
        if (vl.id === item.id) {
          findex = index;
        }
      });
      this.times.splice(findex, 1);
    },
    addInput: function addInput() {
      var index = this.times.length === 0 ? 0 : this.times.length;
      this.times.push({ id: index, vl: '' });
    },
    fillData: function fillData() {
      this.ulinfo.index = 1;
      var fileName = this.editInfo.url.split('/');
      fileName = fileName.length > 0 ? fileName[fileName.length - 1] : '';

      this.form.videoName = this.editInfo.videoname;
      this.form.url = this.editInfo.url;
      this.form.sTime = this.editInfo.sTime;
      this.form.eTime = this.editInfo.eTime;
      this.form.duration = this.editInfo.duration;
      this.form.size = this.editInfo.size;
      this.form.hash = this.editInfo.hash;
      this.form.dimension = this.editInfo.dimension;
      this.form.fileName = fileName;
      this.fileList = [{ name: fileName }];
      var _this = this;
    },
    hBlur: function hBlur(name) {
      this.$refs['addForm'].validate(function (valid) {
        if (valid) {} else {
          return false;
        }
      });
    },
    fileUploadSuccess: function fileUploadSuccess(res, file) {
      window[this.$route.path] = '';
      console.log('file', res);
      this.ulinfo.tip = res.message;
      if (res.status === 200) {
        this.form.url = res.url;
        this.form.dimension = res.dimension;
        this.form.duration = res.duration;
        this.form.hash = res.hash;
        this.form.size = res.size;
        this.form.fileName = file.name;

        this.fileList = [{ name: file.name }];
        this.hBlur();

        this.ulinfo.index = 1;
        this.tipColor = { color: '#13CE66' };
      } else {
        this.ulinfo.index = 2;
        this.tipColor = { color: '#FF4949' };
        if (this.config.type !== 1) {
          this.fileList = [];
        } else {
          this.fileList = [{ name: file.name }];
        }
        this.$message.error(this.$t('app_onlyApk'));
      }
    },
    fileBeforeUpload: function fileBeforeUpload(file) {
      console.log(file);
      window[this.$route.path] = 1;
      return 1;
    },

    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$refs['addForm'].validate(function (valid) {
        if (valid) {
          _this2.loading = 1;
          var isUpload = !_this2.editInfo;

          var mid = localStorage.mechanismId;

          if (isUpload) {
            _this2.$addDefaultVideo(_this2.form.videoName, _this2.form.url, _this2.form.duration, mid, _this2.form.size, _this2.form.hash, _this2.form.dimension, function (res) {
              _this2.loading = 0;
              if (res.status === 200) {
                _this2.$message.success(res.message);
                _this2.$router.go(-1);
              } else {
                _this2.$message(res.message);
              }
            }, function () {
              _this2.loading = 0;
              _this2.$message(_this2.$t('app_rqsError'));
            });
          } else {
            _this2.loading = 0;
            _this2.$editVideo(_this2.editInfo.videoid, _this2.form.videoName, _this2.form.url, _this2.form.duration, _this2.form.size, _this2.form.hash, _this2.form.sTime, _this2.form.eTime, _this2.form.dimension, function (res) {
              _this2.loading = 0;
              if (res.status === 200) {
                _this2.$router.go(-1);
                _this2.$message.success(res.message);
              } else {
                _this2.$message.error(res.message);
              }
            }, function () {
              _this2.loading = 0;
            });
          }
        } else {
          return false;
        }
      });
    },
    onCancel: function onCancel() {
      this.$router.go(-1);
    },
    selectTypeChange: function selectTypeChange(value) {
      if (value === 'KSP' || value === 'KOS') {
        this.fwVersionInputVisable = true;
      } else {
        this.form.version = '';
        this.fwVersionInputVisable = false;
      }
      console.log('select value: ' + value);
    }
  }
});

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      usrType: localStorage.userType,
      sNum: 0,
      mechanismId: window.localStorage['mechanismId'],
      loading: 0,
      queryKey: '',
      appType: '',
      appTypes: [],
      tableData: [],
      multipleSelection: [],
      total: 0,
      page: 1,
      dialogTopMgVisible: 0,
      dialogConfig: { tip: '', data: '', type: '' }
    };
  },

  components: {},
  computed: {
    index: function index() {
      var page = this.$getWPage('videoListPage');
      page = page ? page : 1;
      return page;
    }
  },
  methods: {
    submitVideo: function submitVideo(row) {
      var _this = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_tipVerify'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this.loading = 1;
        _this.$submitVideo(row.videoid, function (res) {
          _this.loading = 0;
          if (res.status === 200) {
            _this.$message.success(res.message);
            _this.getList();
          } else {
            _this.$message.error(res.message);
          }
        }, function (error) {
          _this.loading = 0;
        });
      }, '');
    },
    editVideo: function editVideo(row) {
      this.$setWObj('editVideo', { type: 1, data: row });
      this.$router.push({ path: 'video-list/edit-video' });
    },
    deleteVideo: function deleteVideo(row) {
      var _this2 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this2.loading = 1;
        _this2.$delVideo(row.videoid, function (res) {
          _this2.loading = 0;
          if (res.status === 200) {
            _this2.$message.success(res.message);
            _this2.getList();
          } else {
            _this2.$message.error(res.message);
          }
        }, function (error) {
          _this2.loading = 0;
        });
      }, '');
    },
    getStatus: function getStatus(value) {
      if (!value) return '';
      switch (value.status) {
        case 0:
          return { vl: this.$t('app_prePushVerify'), style: 'color:#8492A6;' };
        case 1:
          return { vl: this.$t('app_preVerify'), style: 'color:#F7BA2A;' };
        case 2:
          return { vl: this.$t('app_verifyPass'), style: 'color:#13CE66;' };
        case 3:
          return { vl: this.$t('app_verifyNotPass'), style: 'color:#FF4949;' };
      }
    },
    timeLimit: function timeLimit(row) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(row.sTime).format('YYYY-MM-DD') + ' ~ ' + __WEBPACK_IMPORTED_MODULE_0_moment___default()(row.eTime).format('YYYY-MM-DD');
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    },
    query: function query() {
      this.getList();
    },
    reset: function reset() {
      this.queryKey = '';
      this.appType = '';
      this.getList();
    },
    selectChange: function selectChange(vl) {
      this.getList();
    },
    getTypeList: function getTypeList() {
      var _this3 = this;

      this.$getAppTypeList(100000000, 1, function (res) {
        if (res.status === 200) {
          _this3.appTypes = res.data;
        } else {
          _this3.$message(res.message);
        }
      }, '');
    },
    cellClick: function cellClick(row, ev, col) {
      if (col.label && col.label !== this.$t('app_operate') && col.label !== this.$t('app_classIntrol') && col.label !== this.$t('app_homeIntrol')) {
        this.$setWObj('viewDefaultVideo', row);
        this.$router.push({ path: '/video-list/default/view-video' });
      }
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('YYYY-MM-DD HH:mm:ss');
    },
    pageSelect: function pageSelect(index) {
      this.$setWPage('videoListPage', index);
      this.getList();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getList();
    },
    toggleSelection: function toggleSelection(rows) {
      var _this4 = this;

      if (rows) {
        rows.forEach(function (row) {
          _this4.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    processRecommend: function processRecommend(yes) {
      var _this5 = this;

      this.dialogTopMgVisible = 0;
      var config = this.dialogConfig;
      switch (config.type) {
        case 'class':
          this.loading = 1;
          var typeId = config.data.appCategoryId;

          var vl = yes ? '0' : '1';
          if (this.$appUrlTag === 0) {
            this.$recommendClass(this.mechanismId, config.data.applicationid, vl, function (res) {
              _this5.loading = 0;
              if (res.status === 200) {
                var tm = config.data;
                tm.isType = vl;
                _this5.tableData[config.index] = tm;
              } else {
                _this5.$message.error(res.message);
              }
            }, function () {
              _this5.loading = 0;
            });
          } else {
            this.$recommendClass1(this.mechanismId, config.data.applicationid, vl, function (res) {
              _this5.loading = 0;
              if (res.status === 200) {
                var tm = config.data;
                tm.isType = vl;
                _this5.tableData[config.index] = tm;
              } else {
                _this5.$message.error(res.message);
              }
            }, function () {
              _this5.loading = 0;
            });
          }

          break;
        case 'home':
          this.loading = 1;

          var vl = yes ? '0' : '1';
          if (this.$appUrlTag === 0) {
            this.$recommendHome(this.mechanismId, config.data.applicationid, vl, function (res) {
              _this5.loading = 0;
              if (res.status !== 200) {
                _this5.$message.error(res.message);
              } else {
                var tm = config.data;
                tm.isHome = vl;
                _this5.tableData[config.index] = tm;
              }
            }, function () {
              _this5.loading = 0;
            });
          } else {
            this.$recommendHome1(this.mechanismId, config.data.applicationid, vl, function (res) {
              _this5.loading = 0;
              if (res.status !== 200) {
                _this5.$message.error(res.message);
              } else {
                var tm = config.data;
                tm.isHome = vl;
                _this5.tableData[config.index] = tm;
              }
            }, function () {
              _this5.loading = 0;
            });
          }

          break;
      }
    },
    classRecommend: function classRecommend(row, scope) {
      this.dialogTopMgVisible = 1;
      this.dialogConfig = { type: 'class', data: row, tip: this.$t('app_isIntroClass'), index: scope.$index };
    },
    homeRecommend: function homeRecommend(row, scope) {
      this.dialogTopMgVisible = 1;
      this.dialogConfig = { type: 'home', data: row, tip: this.$t('app_isIntroHome'), index: scope.$index };
    },
    undercarriage: function undercarriage(row) {
      var _this6 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_isOffShelf'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this6.loading = 1;
        if (_this6.$appUrlTag === 0) {
          _this6.$appDistributeOnOff(_this6.mechanismId, row.packagename, '1', function (res) {
            if (res.status === 200) {
              _this6.getList();
            } else {
              _this6.$message.error(res.message);
            }
            _this6.loading = 0;
          }, function () {
            _this6.loading = 0;
          });
        } else {
          _this6.$appDistributeOnOff1(_this6.mechanismId, row.packagename, '1', function (res) {
            if (res.status === 200) {
              _this6.getList();
            } else {
              _this6.$message.error(res.message);
            }
            _this6.loading = 0;
          }, function () {
            _this6.loading = 0;
          });
        }
      }, '');
    },
    allUndercarriage: function allUndercarriage() {
      var _this7 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_srmuldel'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        var ids = '';
        _this7.multipleSelection.forEach(function (vl) {
          ids += vl.videoid + ',';
        });
        ids = ids.substring(0, ids.length - 1);

        if (!ids) {
          _this7.$message(_this7.$t('app_chooseOneMust'));
          return;
        }
        _this7.loading = 1;
        _this7.$delVideo(ids, function (res) {
          _this7.loading = 0;
          if (res.status === 200) {
            _this7.$message.success(res.message);
            _this7.getList();
          } else {
            _this7.$message.error(res.message);
          }
        }, function (error) {
          _this7.loading = 0;
        });
      }, '');
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.sNum = val.length;
      this.multipleSelection = val;
    },
    addVideo: function addVideo() {
      this.$router.push({ path: '/video-list/default/add-video' });
    },
    bindOperate: function bindOperate(obj) {
      this.$setWObj('appBindInfo', { data: obj, type: 1 });

      this.$router.push({ path: '/default/view-video' });
    },
    selected: function selected(rows) {},
    getList: function getList() {
      var _this8 = this;

      this.loading = 1;
      var sName = this.queryKey ? this.queryKey : '';
      var sCid = this.appType ? this.appType : '';

      this.$defaultVideoList(window.localStorage['mechanismId'], this.index, this.$gRow, sName, function (res) {
        console.log(res);
        _this8.loading = 0;
        if (res.status === 200) {
          _this8.total = res.total;
          _this8.tableData = res.data;
        } else {
          _this8.$message.error(res.message);
        }
      }, function () {
        _this8.loading = 0;
      });
    }
  },
  mounted: function mounted() {
    this.getList();
  }
});

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_df_png__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_df_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_df_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__);


var _methods;




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var that = this;
    return {
      dLoading: false,
      srchValue: '',
      reason: '',
      config: '',
      captures: [],
      loading: 0,
      dialogVisible: false,
      notPassDialog: false,
      index: 1,
      tableData: [],
      playUrl: '',
      total: 0,
      status: '',
      mech: '',
      stModel: [{ label: '在线', vl: '1' }, { label: '离线', vl: '2' }],
      mechanismData: {
        callback: function callback(value) {
          that.mech = value;
          that.selectChange(value);
        }
      }
    };
  },

  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default.a
  },
  computed: {
    showUploadNew: function showUploadNew() {
      console.log('ccc', this.config.data);
      if (this.config.data) {
        if (this.config.data.isoperation === 0 && this.config.data.appStatus === '2') {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  methods: (_methods = {
    timeLimit: function timeLimit(row) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(row.sTime).format('YYYY-MM-DD') + '~' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(row.eTime).format('YYYY-MM-DD');
    },
    makeCreateTime: function makeCreateTime(ts) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(ts).format('YYYY-MM-DD hh:mm:ss');
    },
    bindOperate: function bindOperate(row) {
      var _this = this;

      this.dLoading = 1;
      this.$pushLauncher(this.config.launcherid, row.terminalNo, localStorage.mechanismId, function (res) {
        _this.dLoading = 0;
        if (res.status === 200) {
          _this.$message.success(_this.$t('app_tipViewTask'));
          _this.notPassDialog = false;
        } else {
          _this.$message.error(res.message);
        }
      }, function (error) {
        _this.dLoading = 0;
        _this.$message.error(_this.$t('app_rqsError'));
      });
    },
    verify: function verify(vl) {
      var _this2 = this;

      if (vl === '2') {
        this.$confirm(this.$t('app_srpassvf') + '?', this.$t('app_tip'), {
          confirmButtonText: this.$t('app_sure'),
          cancelButtonText: this.$t('app_cancel'),
          type: 'warning'
        }).then(function () {
          _this2.verifyRqs(vl);
        }).catch(function () {});
      } else if (vl === '3') {
        this.notPassDialog = true;
      }
    },
    verifyRqs: function verifyRqs(vl) {
      var _this3 = this;

      this.loading = 1;
      this.$verifyVideo(this.config.videoid, vl, this.reason, function (res) {
        _this3.loading = 0;
        if (res.status === 200) {
          _this3.$message.success(res.message);
          _this3.$router.go(-1);
        } else {
          _this3.$message.error(res.message);
        }
      }, function () {
        _this3.$message.error(_this3.$t('app_rqsError'));
        _this3.loading = 0;
      });
    },
    srchDevice: function srchDevice() {
      this.getDevices();
    },
    selectChange: function selectChange(vl) {
      this.getDevices();
    },
    pageSelect: function pageSelect(index) {
      this.index = index;
      this.getDevices();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getDevices();
    },
    getDevices: function getDevices() {
      var _this4 = this;

      var vl = this.srchValue ? this.srchValue : '';
      var channel = this.channelId ? this.channelId : '';
      var status = this.status ? this.status : '';
      var mc = this.mech;
      this.loading = 1;
      this.$pushLauncherList(this.index, this.$gRow, mc, vl, status, '', this.config.launcherid, '', function (res) {
        console.log('dv', res);
        _this4.loading = 0;
        if (res.data) {
          _this4.tableData = res.data;
          _this4.total = res.total;
        }
      }, function () {
        _this4.loading = 0;
      });
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD hh:mm:ss');
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'selectChange', function selectChange(vl) {
    this.getDevices();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'pageSelect', function pageSelect(index) {
    this.index = index;
    this.getDevices();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'pageSized', function pageSized(val) {
    this.$gRow = val;
    this.getDevices();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'deleteAppHis', function deleteAppHis(row) {
    var _this5 = this;

    if (row.applicationid) {
      this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
        confirmButtonText: this.$t('app_sure'),
        cancelButtonText: this.$t('app_cancel'),
        type: 'warning'
      }).then(function () {
        _this5.loading = 1;
        if (_this5.$appUrlTag === 0) {
          _this5.$deleteApp(row.applicationid, function (res) {
            _this5.loading = 0;
            if (res.status === 200) {
              _this5.getAppHistory();
            } else {
              _this5.$message.error(res.message);
            }
          }, function () {
            _this5.loading = 0;
          });
        } else {
          _this5.$deleteAppHis(row.applicationid, function (res) {
            _this5.loading = 0;
            if (res.status === 200) {
              _this5.getAppHistory();
            } else {
              _this5.$message.error(res.message);
            }
          }, function () {
            _this5.loading = 0;
          });
        }
      }).catch(function () {});
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'imgFullUrl', function imgFullUrl(path) {
    if (path) {
      return this.$urls.prefix + path;
    } else {
      return '';
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'getAppHistory', function getAppHistory() {
    var _this6 = this;

    if (!this.config.data.appName) {
      return;
    }

    this.loading = 1;
    if (this.$appUrlTag === 0) {
      this.$getAppHistory(this.config.data.appName, this.config.data.packagename, function (res) {
        _this6.loading = 0;
        if (res.status === 200) {
          _this6.tableData = res.data;
        } else {
          _this6.$message.error(res.message);
        }
      }, function () {
        _this6.loading = 0;
      });
    } else {

      this.$getAppHistory1(localStorage.mechanismId, this.config.data.packagename, function (res) {

        console.log('his', res);
        _this6.loading = 0;
        if (res.status === 200) {
          _this6.tableData = res.data;
        } else {
          _this6.$message.error(res.message);
        }
      }, function () {
        _this6.loading = 0;
      });
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'uploadNew', function uploadNew() {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'init', function init() {
    this.config = this.$getWObj().viewVideo;
    console.log(this.config);
    this.playUrl = this.$host + this.config.url;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'setCapturesArr', function setCapturesArr(strs) {
    if (strs) {
      var arr = strs.split(',');
      this.captures = arr;
    }
  }), _methods),
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue__);


var tCheck = function tCheck(rule, value, callback) {
  if (!window.self.form.sTime || !window.self.form.eTime) {

    callback(new Error(window.self.$t('app_select') + window.self.$t('app_tofvalis')));
  } else {
    callback();
  }
};


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue___default.a
  },
  data: function data() {
    var that = this;
    return {
      tipColor: { color: '#13CE66' },
      ulinfo: {
        tip: this.$t('app_ulNormalSt'),
        index: 0,
        icons: ['el-icon-upload', 'el-icon-circle-check', 'el-icon-close']
      },
      mechanismData: '',
      uData: '',
      editInfo: '',
      mechs: [],
      loading: 0,
      isUpload: true,
      fileList: [],
      times: [],
      form: {
        videoName: '',
        url: '',
        duration: '',
        size: '',
        hash: '',
        sTime: '',
        eTime: '',
        dimension: ''
      },
      rules: {
        'videoName': [{
          required: true,
          message: this.$t('lin_global.notBlankName')
        }],
        'time': [{
          required: true,
          message: this.$t('app_sllimit'),
          validator: tCheck
        }],
        'type': [{
          required: true,
          message: this.$t('lin_global.qxzlx')
        }],
        'mechanism': [{
          required: true,
          message: this.$t('app_selectChannel')
        }],
        'url': [{
          required: true,
          message: this.$t('app_plsUpl')
        }]
      },
      areaList: [],
      fwVersionInputVisable: true
    };
  },
  mounted: function mounted() {
    var isEdit = this.$route.path === '/video-list/edit-video';
    this.isUpload = !isEdit;
    window.self = this;
    var mVl = '';
    if (!this.isUpload) {
      var obj = this.$getWObj().editVideo.data;
      if (obj) {
        this.editInfo = obj;
        this.fillData();
      }
      mVl = obj.mechanismId;
    }
    this.mechanismData = {
      value: mVl,
      placeholder: this.$t('lin_global.place_areaid'),
      optValue: true,
      callback: function callback(value) {
        this.form.mechanism = value;
      }
    };
  },

  computed: {
    reason: function reason() {
      if (!this.editInfo) {
        return '';
      }
      var rs = this.editInfo.refuseReason;
      return rs ? this.$t('app_banReason') + ':' + rs : this.$t('app_banReason') + ':' + this.$t('app_noInput');
    },
    stHolder: function stHolder() {
      var tip = this.$t('app_slsttime');
      if (this.form.stTime) tip = '';
      return tip;
    },
    endHolder: function endHolder() {
      var tip = this.$t('app_slendtime');
      if (this.form.endTime) tip = '';
      return tip;
    },
    fileUploadUrl: function fileUploadUrl() {
      return this.$urls.fileUrl;
    },
    typeHolder: function typeHolder() {
      if (this.isUpload) {
        return this.$t('app_select');
      } else {
        return '';
      }
    }
  },
  methods: {
    sClick: function sClick(vl) {
      if (this.form.eTime) {
        this.timeCp(0);
      }
    },
    eClick: function eClick(vl) {
      if (this.form.sTime) {
        this.timeCp(1);
      }
    },
    timeCp: function timeCp(w) {
      var ill = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.form.eTime).isBefore(this.form.sTime);
      if (ill && w === 0) {
        this.$message.error(this.$t('app_sttcanlateendtime'));
        this.form.sTime = '';
      } else if (ill && w === 1) {
        this.$message.error(this.$t('app_etcanelsttime'));
        this.form.eTime = '';
      }
    },
    rowDel: function rowDel(item) {
      var findex;
      this.times.forEach(function (vl, index) {
        if (vl.id === item.id) {
          findex = index;
        }
      });
      this.times.splice(findex, 1);
    },
    addInput: function addInput() {
      var index = this.times.length === 0 ? 0 : this.times.length;
      this.times.push({ id: index, vl: '' });
    },
    fillData: function fillData() {
      this.ulinfo.index = 1;
      var fileName = this.editInfo.url.split('/');
      fileName = fileName.length > 0 ? fileName[fileName.length - 1] : '';

      this.form.videoName = this.editInfo.videoname;
      this.form.url = this.editInfo.url;
      this.form.sTime = this.editInfo.sTime;
      this.form.eTime = this.editInfo.eTime;
      this.form.duration = this.editInfo.duration;
      this.form.size = this.editInfo.size;
      this.form.hash = this.editInfo.hash;
      this.form.dimension = this.editInfo.dimension;
      this.form.fileName = fileName;
      this.fileList = [{ name: fileName }];
      var _this = this;
    },
    hBlur: function hBlur(name) {
      this.$refs['addForm'].validate(function (valid) {
        if (valid) {} else {
          return false;
        }
      });
    },
    fileUploadSuccess: function fileUploadSuccess(res, file) {
      window[this.$route.path] = '';
      console.log('file', res);
      this.ulinfo.tip = res.message;
      if (res.status === 200) {
        this.form.url = res.url;
        this.form.dimension = res.dimension;
        this.form.duration = res.duration;
        this.form.hash = res.hash;
        this.form.size = res.size;
        this.form.fileName = file.name;

        this.fileList = [{ name: file.name }];
        this.hBlur();

        this.ulinfo.index = 1;
        this.tipColor = { color: '#13CE66' };
      } else {
        this.ulinfo.index = 2;
        this.tipColor = { color: '#FF4949' };
        if (this.config.type !== 1) {
          this.fileList = [];
        } else {
          this.fileList = [{ name: file.name }];
        }
        this.$message.error(this.$t('app_onlyApk'));
      }
    },
    fileBeforeUpload: function fileBeforeUpload(file) {
      console.log(file);
      window[this.$route.path] = 1;
      return 1;
    },

    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$refs['addForm'].validate(function (valid) {
        if (valid) {
          _this2.loading = 1;
          var isUpload = !_this2.editInfo;
          var st = __WEBPACK_IMPORTED_MODULE_0_moment___default()(_this2.form.sTime).format('YYYY-MM-DD');
          var et = __WEBPACK_IMPORTED_MODULE_0_moment___default()(_this2.form.eTime).format('YYYY-MM-DD');
          var mid = localStorage.mechanismId;

          if (isUpload) {
            _this2.$addVideo(_this2.form.videoName, _this2.form.url, _this2.form.duration, mid, _this2.form.size, _this2.form.hash, st, et, _this2.form.dimension, function (res) {
              _this2.loading = 0;
              if (res.status === 200) {
                _this2.$message.success(res.message);
                _this2.$router.go(-1);
              } else {
                _this2.$message(res.message);
              }
            }, function () {
              _this2.loading = 0;
              _this2.$message(_this2.$t('app_rqsError'));
            });
          } else {
            _this2.loading = 0;
            _this2.$editVideo(_this2.editInfo.videoid, _this2.form.videoName, _this2.form.url, _this2.form.duration, _this2.form.size, _this2.form.hash, _this2.form.sTime, _this2.form.eTime, _this2.form.dimension, function (res) {
              _this2.loading = 0;
              if (res.status === 200) {
                _this2.$router.go(-1);
                _this2.$message.success(res.message);
              } else {
                _this2.$message.error(res.message);
              }
            }, function () {
              _this2.loading = 0;
            });
          }
        } else {
          return false;
        }
      });
    },
    onCancel: function onCancel() {
      this.$router.go(-1);
    },
    selectTypeChange: function selectTypeChange(value) {
      if (value === 'KSP' || value === 'KOS') {
        this.fwVersionInputVisable = true;
      } else {
        this.form.version = '';
        this.fwVersionInputVisable = false;
      }
      console.log('select value: ' + value);
    }
  }
});

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      usrType: localStorage.userType,
      sNum: 0,
      mechanismId: window.localStorage['mechanismId'],
      loading: 0,
      queryKey: '',
      appType: '',
      appTypes: [],
      tableData: [],
      multipleSelection: [],
      total: 0,
      page: 1,
      dialogTopMgVisible: 0,
      dialogConfig: { tip: '', data: '', type: '' }
    };
  },

  components: {},
  computed: {
    index: function index() {
      var page = this.$getWPage('videoListPage');
      page = page ? page : 1;
      return page;
    }
  },
  methods: {
    submitVideo: function submitVideo(row) {
      var _this = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_tipVerify'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this.loading = 1;
        _this.$submitVideo(row.videoid, function (res) {
          _this.loading = 0;
          if (res.status === 200) {
            _this.$message.success(res.message);
            _this.getList();
          } else {
            _this.$message.error(res.message);
          }
        }, function (error) {
          _this.loading = 0;
        });
      }, '');
    },
    editVideo: function editVideo(row) {
      this.$setWObj('editVideo', { type: 1, data: row });
      this.$router.push({ path: 'video-list/edit-video' });
    },
    deleteVideo: function deleteVideo(row) {
      var _this2 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this2.loading = 1;
        _this2.$delVideo(row.videoid, function (res) {
          _this2.loading = 0;
          if (res.status === 200) {
            _this2.$message.success(res.message);
            _this2.getList();
          } else {
            _this2.$message.error(res.message);
          }
        }, function (error) {
          _this2.loading = 0;
        });
      }, '');
    },
    getStatus: function getStatus(value) {
      if (!value) return '';
      switch (value.status) {
        case 0:
          return { vl: this.$t('app_prePushVerify'), style: 'color:#8492A6;' };
        case 1:
          return { vl: this.$t('app_preVerify'), style: 'color:#F7BA2A;' };
        case 2:
          return { vl: this.$t('app_verifyPass'), style: 'color:#13CE66;' };
        case 3:
          return { vl: this.$t('app_verifyNotPass'), style: 'color:#FF4949;' };
        case 4:
          return { vl: this.$t('app_ustart'), style: 'color:gray;' };
        case 5:
          return { vl: this.$t('app_outofdate'), style: 'color:gray;' };
      }
    },
    timeLimit: function timeLimit(row) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(row.sTime).format('YYYY-MM-DD') + ' ~ ' + __WEBPACK_IMPORTED_MODULE_0_moment___default()(row.eTime).format('YYYY-MM-DD');
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    },
    query: function query() {
      this.getList();
    },
    reset: function reset() {
      this.queryKey = '';
      this.appType = '';
      this.getList();
    },
    selectChange: function selectChange(vl) {
      this.getList();
    },
    getTypeList: function getTypeList() {
      var _this3 = this;

      this.$getAppTypeList(100000000, 1, function (res) {
        if (res.status === 200) {
          _this3.appTypes = res.data;
        } else {
          _this3.$message(res.message);
        }
      }, '');
    },
    cellClick: function cellClick(row, ev, col) {
      if (col.label && col.label !== this.$t('app_operate') && col.label !== this.$t('app_classIntrol') && col.label !== this.$t('app_homeIntrol')) {
        switch (row.status) {
          case 0:
          case 3:
            this.$setWObj('editVideo', { type: 1, data: row });
            this.$router.push({ path: 'video-list/edit-video' });
            break;
          case 1:
          case 2:
            this.$setWObj('viewVideo', row);
            this.$router.push({ path: '/video-list/detail' });
            break;
        }
      }
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('YYYY-MM-DD HH:mm:ss');
    },
    pageSelect: function pageSelect(index) {
      this.$setWPage('videoListPage', index);
      this.getList();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getList();
    },
    toggleSelection: function toggleSelection(rows) {
      var _this4 = this;

      if (rows) {
        rows.forEach(function (row) {
          _this4.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    processRecommend: function processRecommend(yes) {
      var _this5 = this;

      this.dialogTopMgVisible = 0;
      var config = this.dialogConfig;
      switch (config.type) {
        case 'class':
          this.loading = 1;
          var typeId = config.data.appCategoryId;

          var vl = yes ? '0' : '1';
          if (this.$appUrlTag === 0) {
            this.$recommendClass(this.mechanismId, config.data.applicationid, vl, function (res) {
              _this5.loading = 0;
              if (res.status === 200) {
                var tm = config.data;
                tm.isType = vl;
                _this5.tableData[config.index] = tm;
              } else {
                _this5.$message.error(res.message);
              }
            }, function () {
              _this5.loading = 0;
            });
          } else {
            this.$recommendClass1(this.mechanismId, config.data.applicationid, vl, function (res) {
              _this5.loading = 0;
              if (res.status === 200) {
                var tm = config.data;
                tm.isType = vl;
                _this5.tableData[config.index] = tm;
              } else {
                _this5.$message.error(res.message);
              }
            }, function () {
              _this5.loading = 0;
            });
          }

          break;
        case 'home':
          this.loading = 1;

          var vl = yes ? '0' : '1';
          if (this.$appUrlTag === 0) {
            this.$recommendHome(this.mechanismId, config.data.applicationid, vl, function (res) {
              _this5.loading = 0;
              if (res.status !== 200) {
                _this5.$message.error(res.message);
              } else {
                var tm = config.data;
                tm.isHome = vl;
                _this5.tableData[config.index] = tm;
              }
            }, function () {
              _this5.loading = 0;
            });
          } else {
            this.$recommendHome1(this.mechanismId, config.data.applicationid, vl, function (res) {
              _this5.loading = 0;
              if (res.status !== 200) {
                _this5.$message.error(res.message);
              } else {
                var tm = config.data;
                tm.isHome = vl;
                _this5.tableData[config.index] = tm;
              }
            }, function () {
              _this5.loading = 0;
            });
          }

          break;
      }
    },
    classRecommend: function classRecommend(row, scope) {
      this.dialogTopMgVisible = 1;
      this.dialogConfig = { type: 'class', data: row, tip: this.$t('app_isIntroClass'), index: scope.$index };
    },
    homeRecommend: function homeRecommend(row, scope) {
      this.dialogTopMgVisible = 1;
      this.dialogConfig = { type: 'home', data: row, tip: this.$t('app_isIntroHome'), index: scope.$index };
    },
    undercarriage: function undercarriage(row) {
      var _this6 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_isOffShelf'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this6.loading = 1;
        if (_this6.$appUrlTag === 0) {
          _this6.$appDistributeOnOff(_this6.mechanismId, row.packagename, '1', function (res) {
            if (res.status === 200) {
              _this6.getList();
            } else {
              _this6.$message.error(res.message);
            }
            _this6.loading = 0;
          }, function () {
            _this6.loading = 0;
          });
        } else {
          _this6.$appDistributeOnOff1(_this6.mechanismId, row.packagename, '1', function (res) {
            if (res.status === 200) {
              _this6.getList();
            } else {
              _this6.$message.error(res.message);
            }
            _this6.loading = 0;
          }, function () {
            _this6.loading = 0;
          });
        }
      }, '');
    },
    allUndercarriage: function allUndercarriage() {
      var _this7 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_srmuldel'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        var ids = '';
        _this7.multipleSelection.forEach(function (vl) {
          ids += vl.videoid + ',';
        });
        ids = ids.substring(0, ids.length - 1);

        if (!ids) {
          _this7.$message(_this7.$t('app_chooseOneMust'));
          return;
        }
        _this7.loading = 1;
        _this7.$delVideo(ids, function (res) {
          _this7.loading = 0;
          if (res.status === 200) {
            _this7.$message.success(res.message);
            _this7.getList();
          } else {
            _this7.$message.error(res.message);
          }
        }, function (error) {
          _this7.loading = 0;
        });
      }, '');
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.sNum = val.length;
      this.multipleSelection = val;
    },
    addVideo: function addVideo() {
      this.$setWObj('editVideo', { type: 0, data: '' });
      this.$router.push({ path: 'video-list/add-video' });
    },
    goDefault: function goDefault() {
      this.$router.push({ path: '/video-list/default' });
    },
    selected: function selected(rows) {},
    getList: function getList() {
      var _this8 = this;

      this.loading = 1;
      var sName = this.queryKey ? this.queryKey : '';
      var sCid = this.appType ? this.appType : '';

      this.$videoList(window.localStorage['mechanismId'], this.index, this.$gRow, sName, '', function (res) {
        console.log(res);
        _this8.loading = 0;
        if (res.status === 200) {
          _this8.total = res.total;
          _this8.tableData = res.data;
        } else {
          _this8.$message.error(res.message);
        }
      }, function () {
        _this8.loading = 0;
      });
    }
  },
  mounted: function mounted() {
    this.getList();
  }
});

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_df_png__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_df_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_df_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__);


var _methods;




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var that = this;
    return {
      dLoading: false,
      srchValue: '',
      reason: '',
      config: '',
      captures: [],
      loading: 0,
      dialogVisible: false,
      notPassDialog: false,
      index: 1,
      tableData: [],
      playUrl: '',
      total: 0,
      status: '',
      mech: '',
      stModel: [{ label: '在线', vl: '1' }, { label: '离线', vl: '2' }],
      mechanismData: {
        callback: function callback(value) {
          that.mech = value;
          that.selectChange(value);
        }
      }
    };
  },

  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default.a
  },
  computed: {
    showUploadNew: function showUploadNew() {
      console.log('ccc', this.config.data);
      if (this.config.data) {
        if (this.config.data.isoperation === 0 && this.config.data.appStatus === '2') {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  methods: (_methods = {
    timeLimit: function timeLimit(row) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(row.sTime).format('YYYY-MM-DD') + '~' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(row.eTime).format('YYYY-MM-DD');
    },
    makeCreateTime: function makeCreateTime(ts) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(ts).format('YYYY-MM-DD hh:mm:ss');
    },
    bindOperate: function bindOperate(row) {
      var _this = this;

      this.dLoading = 1;
      this.$pushLauncher(this.config.launcherid, row.terminalNo, localStorage.mechanismId, function (res) {
        _this.dLoading = 0;
        if (res.status === 200) {
          _this.$message.success(_this.$t('app_tipViewTask'));
          _this.notPassDialog = false;
        } else {
          _this.$message.error(res.message);
        }
      }, function (error) {
        _this.dLoading = 0;
        _this.$message.error(_this.$t('app_rqsError'));
      });
    },
    verify: function verify(vl) {
      var _this2 = this;

      if (vl === '2') {
        this.$confirm(this.$t('app_srpassvf') + '?', this.$t('app_tip'), {
          confirmButtonText: this.$t('app_sure'),
          cancelButtonText: this.$t('app_cancel'),
          type: 'warning'
        }).then(function () {
          _this2.verifyRqs(vl);
        }).catch(function () {});
      } else if (vl === '3') {
        this.notPassDialog = true;
      }
    },
    verifyRqs: function verifyRqs(vl) {
      var _this3 = this;

      this.loading = 1;
      this.$verifyVideo(this.config.videoid, vl, this.reason, function (res) {
        _this3.loading = 0;
        if (res.status === 200) {
          _this3.$message.success(res.message);
          _this3.$router.go(-1);
        } else {
          _this3.$message.error(res.message);
        }
      }, function () {
        _this3.$message.error(_this3.$t('app_rqsError'));
        _this3.loading = 0;
      });
    },
    srchDevice: function srchDevice() {
      this.getDevices();
    },
    selectChange: function selectChange(vl) {
      this.getDevices();
    },
    pageSelect: function pageSelect(index) {
      this.index = index;
      this.getDevices();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getDevices();
    },
    getDevices: function getDevices() {
      var _this4 = this;

      var vl = this.srchValue ? this.srchValue : '';
      var channel = this.channelId ? this.channelId : '';
      var status = this.status ? this.status : '';
      var mc = this.mech;
      this.loading = 1;
      this.$pushLauncherList(this.index, this.$gRow, mc, vl, status, '', this.config.launcherid, '', function (res) {

        _this4.loading = 0;
        if (res.data) {
          _this4.tableData = res.data;
          _this4.total = res.total;
        }
      }, function () {
        _this4.loading = 0;
      });
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD hh:mm:ss');
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'selectChange', function selectChange(vl) {
    this.getDevices();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'pageSelect', function pageSelect(index) {
    this.index = index;
    this.getDevices();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'pageSized', function pageSized(val) {
    this.$gRow = val;
    this.getDevices();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'deleteAppHis', function deleteAppHis(row) {
    var _this5 = this;

    if (row.applicationid) {
      this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
        confirmButtonText: this.$t('app_sure'),
        cancelButtonText: this.$t('app_cancel'),
        type: 'warning'
      }).then(function () {
        _this5.loading = 1;
        if (_this5.$appUrlTag === 0) {
          _this5.$deleteApp(row.applicationid, function (res) {
            _this5.loading = 0;
            if (res.status === 200) {
              _this5.getAppHistory();
            } else {
              _this5.$message.error(res.message);
            }
          }, function () {
            _this5.loading = 0;
          });
        } else {
          _this5.$deleteAppHis(row.applicationid, function (res) {
            _this5.loading = 0;
            if (res.status === 200) {
              _this5.getAppHistory();
            } else {
              _this5.$message.error(res.message);
            }
          }, function () {
            _this5.loading = 0;
          });
        }
      }).catch(function () {});
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'imgFullUrl', function imgFullUrl(path) {
    if (path) {
      return this.$urls.prefix + path;
    } else {
      return '';
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'getAppHistory', function getAppHistory() {
    var _this6 = this;

    if (!this.config.data.appName) {
      return;
    }

    this.loading = 1;
    if (this.$appUrlTag === 0) {
      this.$getAppHistory(this.config.data.appName, this.config.data.packagename, function (res) {
        _this6.loading = 0;
        if (res.status === 200) {
          _this6.tableData = res.data;
        } else {
          _this6.$message.error(res.message);
        }
      }, function () {
        _this6.loading = 0;
      });
    } else {

      this.$getAppHistory1(localStorage.mechanismId, this.config.data.packagename, function (res) {

        console.log('his', res);
        _this6.loading = 0;
        if (res.status === 200) {
          _this6.tableData = res.data;
        } else {
          _this6.$message.error(res.message);
        }
      }, function () {
        _this6.loading = 0;
      });
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'uploadNew', function uploadNew() {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'init', function init() {
    this.config = this.$getWObj().verifyVideo;
    console.log(this.config);
    this.playUrl = this.$host + this.config.url;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'setCapturesArr', function setCapturesArr(strs) {
    if (strs) {
      var arr = strs.split(',');
      this.captures = arr;
    }
  }), _methods),
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      usrType: localStorage.userType,
      sNum: 0,
      mechanismId: window.localStorage['mechanismId'],
      loading: 0,
      queryKey: '',
      appType: '',
      appTypes: [],
      tableData: [],
      multipleSelection: [],
      total: 0,
      page: 1,
      dialogTopMgVisible: 0,
      dialogConfig: { tip: '', data: '', type: '' }
    };
  },

  components: {},
  computed: {
    index: function index() {
      var page = this.$getWPage('videoListPage');
      page = page ? page : 1;
      return page;
    }
  },
  methods: {
    submitVideo: function submitVideo(row) {
      var _this = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_tipVerify'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this.loading = 1;
        _this.$submitVideo(row.videoid, function (res) {
          _this.loading = 0;
          if (res.status === 200) {
            _this.$message.success(res.message);
            _this.getList();
          } else {
            _this.$message.error(res.message);
          }
        }, function (error) {
          _this.loading = 0;
        });
      }, '');
    },
    editVideo: function editVideo(row) {
      this.$setWObj('editVideo', { type: 1, data: row });
      this.$router.push({ path: 'video-list/edit-video' });
    },
    deleteVideo: function deleteVideo(row) {
      var _this2 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this2.loading = 1;
        _this2.$delVideo(row.videoid, function (res) {
          _this2.loading = 0;
          if (res.status === 200) {
            _this2.$message.success(res.message);
            _this2.getList();
          } else {
            _this2.$message.error(res.message);
          }
        }, function (error) {
          _this2.loading = 0;
        });
      }, '');
    },
    getStatus: function getStatus(value) {
      if (!value) return '';
      switch (value.status) {
        case 0:
          return { vl: this.$t('app_prePushVerify'), style: 'color:#8492A6;' };
        case 1:
          return { vl: this.$t('app_preVerify'), style: 'color:#F7BA2A;' };
        case 2:
          return { vl: this.$t('app_verifyPass'), style: 'color:#13CE66;' };
        case 3:
          return { vl: this.$t('app_verifyNotPass'), style: 'color:#FF4949;' };
      }
    },
    timeLimit: function timeLimit(row) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(row.sTime).format('YYYY-MM-DD') + ' ~ ' + __WEBPACK_IMPORTED_MODULE_0_moment___default()(row.eTime).format('YYYY-MM-DD');
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    },
    query: function query() {
      this.getList();
    },
    reset: function reset() {
      this.queryKey = '';
      this.appType = '';
      this.getList();
    },
    selectChange: function selectChange(vl) {
      this.getList();
    },
    getTypeList: function getTypeList() {
      var _this3 = this;

      this.$getAppTypeList(100000000, 1, function (res) {
        if (res.status === 200) {
          _this3.appTypes = res.data;
        } else {
          _this3.$message(res.message);
        }
      }, '');
    },
    cellClick: function cellClick(row, ev, col) {
      this.$setWObj('verifyVideo', row);
      this.$router.push({ path: '/video-verify/verify' });
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('YYYY-MM-DD HH:mm:ss');
    },
    pageSelect: function pageSelect(index) {
      this.$setWPage('videoListPage', index);
      this.getList();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getList();
    },
    toggleSelection: function toggleSelection(rows) {
      var _this4 = this;

      if (rows) {
        rows.forEach(function (row) {
          _this4.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    processRecommend: function processRecommend(yes) {
      var _this5 = this;

      this.dialogTopMgVisible = 0;
      var config = this.dialogConfig;
      switch (config.type) {
        case 'class':
          this.loading = 1;
          var typeId = config.data.appCategoryId;

          var vl = yes ? '0' : '1';
          if (this.$appUrlTag === 0) {
            this.$recommendClass(this.mechanismId, config.data.applicationid, vl, function (res) {
              _this5.loading = 0;
              if (res.status === 200) {
                var tm = config.data;
                tm.isType = vl;
                _this5.tableData[config.index] = tm;
              } else {
                _this5.$message.error(res.message);
              }
            }, function () {
              _this5.loading = 0;
            });
          } else {
            this.$recommendClass1(this.mechanismId, config.data.applicationid, vl, function (res) {
              _this5.loading = 0;
              if (res.status === 200) {
                var tm = config.data;
                tm.isType = vl;
                _this5.tableData[config.index] = tm;
              } else {
                _this5.$message.error(res.message);
              }
            }, function () {
              _this5.loading = 0;
            });
          }

          break;
        case 'home':
          this.loading = 1;

          var vl = yes ? '0' : '1';
          if (this.$appUrlTag === 0) {
            this.$recommendHome(this.mechanismId, config.data.applicationid, vl, function (res) {
              _this5.loading = 0;
              if (res.status !== 200) {
                _this5.$message.error(res.message);
              } else {
                var tm = config.data;
                tm.isHome = vl;
                _this5.tableData[config.index] = tm;
              }
            }, function () {
              _this5.loading = 0;
            });
          } else {
            this.$recommendHome1(this.mechanismId, config.data.applicationid, vl, function (res) {
              _this5.loading = 0;
              if (res.status !== 200) {
                _this5.$message.error(res.message);
              } else {
                var tm = config.data;
                tm.isHome = vl;
                _this5.tableData[config.index] = tm;
              }
            }, function () {
              _this5.loading = 0;
            });
          }

          break;
      }
    },
    classRecommend: function classRecommend(row, scope) {
      this.dialogTopMgVisible = 1;
      this.dialogConfig = { type: 'class', data: row, tip: this.$t('app_isIntroClass'), index: scope.$index };
    },
    homeRecommend: function homeRecommend(row, scope) {
      this.dialogTopMgVisible = 1;
      this.dialogConfig = { type: 'home', data: row, tip: this.$t('app_isIntroHome'), index: scope.$index };
    },
    undercarriage: function undercarriage(row) {
      var _this6 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_isOffShelf'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this6.loading = 1;
        if (_this6.$appUrlTag === 0) {
          _this6.$appDistributeOnOff(_this6.mechanismId, row.packagename, '1', function (res) {
            if (res.status === 200) {
              _this6.getList();
            } else {
              _this6.$message.error(res.message);
            }
            _this6.loading = 0;
          }, function () {
            _this6.loading = 0;
          });
        } else {
          _this6.$appDistributeOnOff1(_this6.mechanismId, row.packagename, '1', function (res) {
            if (res.status === 200) {
              _this6.getList();
            } else {
              _this6.$message.error(res.message);
            }
            _this6.loading = 0;
          }, function () {
            _this6.loading = 0;
          });
        }
      }, '');
    },
    allUndercarriage: function allUndercarriage() {
      var _this7 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_isOffApp'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        var ids = '';
        _this7.multipleSelection.forEach(function (vl) {
          ids += vl.packagename + ',';
        });
        ids = ids.substring(0, ids.length - 1);

        if (!ids) {
          _this7.$message(_this7.$t('app_chooseOneMust'));
          return;
        }
        _this7.loading = 1;
        if (_this7.$appUrlTag === 0) {
          _this7.$appDistributeOnOff(_this7.mechanismId, ids, '1', function (res) {
            if (res.status === 200) {
              _this7.getList();
            } else {
              _this7.$message.error(res.message);
            }
            _this7.loading = 0;
          }, function () {
            _this7.loading = 0;
          });
        } else {
          _this7.$appDistributeOnOff1(_this7.mechanismId, ids, '1', function (res) {
            if (res.status === 200) {
              _this7.getList();
            } else {
              _this7.$message.error(res.message);
            }
            _this7.loading = 0;
          }, function () {
            _this7.loading = 0;
          });
        }
      }, '');
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.sNum = val.length;
      this.multipleSelection = val;
    },
    addVideo: function addVideo() {
      this.$setWObj('editVideo', { type: 0, data: '' });
      this.$router.push({ path: 'video-list/add-video' });
    },
    selected: function selected(rows) {},
    getList: function getList() {
      var _this8 = this;

      this.loading = 1;
      var sName = this.queryKey ? this.queryKey : '';
      var sCid = this.appType ? this.appType : '';

      this.$videoList(this.mechanismId, this.index, this.$gRow, sName, '1', function (res) {
        console.log(res);
        _this8.loading = 0;
        if (res.status === 200) {
          _this8.total = res.total;
          _this8.tableData = res.data;
        } else {
          _this8.$message.error(res.message);
        }
      }, function () {
        _this8.loading = 0;
      });
    }
  },
  mounted: function mounted() {
    this.getList();
  }
});

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      mechanismData: '',
      sNum: 0,
      loading: 0,
      rcm: {},
      checked: false,
      mechanismId: window.localStorage['mechanismId'],
      mechId: '',
      queryKey: '',
      appType: '',
      appTypes: [],
      row: this.$gRow,
      total: 0,
      tableData: [],
      selected: [],
      recommends: [{ name: 'a', vl: false }, { name: 'b', vl: false }, { name: 'c', vl: false }],
      recommendVl: false
    };
  },

  computed: {
    index: function index() {
      return this.$getWPage('appMarketAddPage');
    }
  },
  watch: {
    'recommendVl': 'selectAll'
  },
  components: { MechanismSelector: __WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue___default.a },
  methods: {
    selectAll: function selectAll(vl) {
      if (vl) {
        var arr = [];
        this.recommends.forEach(function (vl) {
          vl.vl = true;
          arr.push(vl);
        });
        this.recommends = arr;
      } else {
        var uArr = [];
        this.recommends.forEach(function (vl) {
          vl.vl = false;
          uArr.push(vl);
        });
        this.recommends = uArr;
      }
    },
    saveRecommend: function saveRecommend() {
      console.log(this.recommends);
    },
    addReq: function addReq(id, mId) {
      var _this2 = this;

      this.loading = 1;
      if (this.$appUrlTag === 0) {
        this.$addAppToDistributeList(id, mId, function (res) {
          _this2.loading = 0;
          _this2.$message(res.message);
          _this2.getAppList();
        }, function () {
          _this2.loading = 0;
        });
      } else {
        this.$addAppToDistributeList1(id, mId, function (res) {
          _this2.loading = 0;
          _this2.$message(res.message);
          _this2.getAppList();
        }, function () {
          _this2.loading = 0;
        });
      }
    },
    handleSelectionChange: function handleSelectionChange(list) {
      this.sNum = list.length;
      this.selected = list;
    },
    addAppToMyList: function addAppToMyList(row) {
      this.addReq(row.applicationid, this.mechanismId);
    },
    appRecommend: function appRecommend(row) {},
    query: function query() {
      this.getAppList();
    },
    pageSelect: function pageSelect(index) {
      this.$setWPage('appMarketAddPage', index);
      this.getAppList(index);
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getAppList();
    },
    reset: function reset() {
      this.queryKey = '';
      this.appType = '';
      this.getAppList();
    },
    selectChange: function selectChange(vl) {
      this.getAppList();
    },
    getTypeList: function getTypeList(mcid) {
      var _this3 = this;

      var mc = mcid ? mcid : '';
      this.$gpAppType(mcid, function (res) {
        if (res.data.length > 0) {
          _this3.appTypes = res.data[0].children;
        }
      });
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('YYYY-MM-DD HH:mm:ss');
    },
    getAppList: function getAppList(isAppType) {
      var _this4 = this;

      this.loading = 1;
      var type = this.appType.length > 0 ? this.appType[0] : '';
      var name = this.queryKey ? this.queryKey : '';
      var mcid = this.mechId ? this.mechId : this.mechanismId;
      if (isAppType) {
        this.getTypeList(mcid);
      }

      if (this.$appUrlTag === 0) {

        this.$getDAppList(this.$gRow, this.$getWPage('appMarketAddPage'), type, name, '2', mcid, '', function (res) {
          _this4.loading = 0;
          if (res.status === 200) {
            _this4.total = res.total;
            _this4.tableData = res.data;
          } else {
            _this4.$message(res.message);
          }
        }, function (res) {
          _this4.loading = 0;
          _this4.$message.error(_this4.$t('app_rqsError'));
        });
      } else {
        this.$getDAppList1(this.$gRow, this.$getWPage('appMarketAddPage'), type, name, '2', mcid, '', function (res) {
          _this4.loading = 0;
          if (res.status === 200) {
            _this4.total = res.total;
            _this4.tableData = res.data;
          } else {
            _this4.$message(res.message);
          }
        }, function (res) {
          _this4.loading = 0;
          _this4.$message.error(_this4.$t('app_rqsError'));
        });
      }
    },
    multiAdd: function multiAdd() {
      var ids = '';
      var arr = this.selected;
      if (arr.length < 1) {
        this.$message(this.$t('app_chooseOneMust'));
        return;
      }
      arr.forEach(function (vl) {
        ids += vl.applicationid + ',';
      });
      ids = ids.substring(0, ids.length - 1);

      this.addReq(ids, this.mechanismId);
    },
    toggleSelection: function toggleSelection(rows) {
      var _this5 = this;

      if (rows) {
        rows.forEach(function (row) {
          _this5.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    },
    close: function close() {
      this.$appstore.commit('showAddApp', 0);
    },
    popRecommend: function popRecommend() {}
  },
  mounted: function mounted() {
    var _this = this;
    this.mechanismData = {
      callback: function callback(value) {
        _this.mechId = value;
        _this.getAppList(true);
      }
    };
    this.getAppList(true);
  }
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_df_png__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_df_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_df_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_tyc__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_tyc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_global_tyc__);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      total: 0,
      queryKey: '',
      sNum: 0,
      page: 1,
      tableData1: [],
      tableData: [],
      list: [],
      pushedList: false,
      tqobj: '',
      dobj: '',
      vSt: '',
      config: '',
      captures: [],
      loading: 0,
      iconUrl: ''
    };
  },

  components: {
    tyc: __WEBPACK_IMPORTED_MODULE_2__components_global_tyc___default.a
  },
  computed: {
    avtStyle: function avtStyle() {
      var url = this.iconUrl ? this.imgFullUrl(this.iconUrl) : __webpack_require__(6);

      return 'background-size: cover;background-position: center center;width:100%;height:100%;background-image: url(' + url + ')';
    },
    showUploadNew: function showUploadNew() {

      if (this.config.data) {
        if (this.config.data.isoperation === 0 && this.config.data.appStatus === '2') {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  methods: {
    pushApp: function pushApp(row) {
      this.$router.push({ path: '/task/ptask/new', query: { mode: 2, fname: row.appName, ftype: '7', fid: row.versionid } });
    },
    pageSized1: function pageSized1(val) {
      this.$gRow = val;
      this.getBinds();
    },
    query: function query() {},
    refreshBind: function refreshBind() {
      this.getBinds();
    },
    handleSelectionChange: function handleSelectionChange(list) {
      this.sNum = list.length;
      this.list = list;
    },
    mulDelAppPush: function mulDelAppPush() {
      var _this2 = this;

      var title = this.$t('app_isUnbindApp');
      this.$showConfirm(this.$t('app_tip'), title, this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        var tNos = '';
        var pkg = _this2.config.data.packagename;
        _this2.list.forEach(function (vl) {
          tNos += vl.terminalNo + ',';
        });
        tNos = tNos.substring(0, tNos.length - 1);

        if (!tNos) {
          _this2.$message($t('app_oneDeviceMust'));
          return;
        }
        _this2.appDelRqs(tNos, pkg);
      }, '');
    },
    appDelRqs: function appDelRqs(nos, pkg) {
      var _this3 = this;

      var ns = nos ? nos : '';
      var p = pkg ? pkg : '';
      console.log('unbf');
      this.$unbind(ns, this.config.data.appVersion, p, function (res) {
        _this3.loading = 0;
        _this3.$message(res.message);
        if (res.status === 200) {

          _this3.getBinds();
        }
      }, function () {
        _this3.loading = 0;
      });
    },
    delAppPush: function delAppPush(row) {
      var _this4 = this;

      var title = this.$t('app_isUnbindApp');

      this.$showConfirm(this.$t('app_tip'), title, this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {

        _this4.appDelRqs(row.terminalNo, _this4.config.data.packagename);
      }, '');
    },
    getBinds: function getBinds() {
      var _this5 = this;

      var id = this.config.data.appdevid;
      if (!id) return;
      this.loading = 1;
      this.$pushedTerList(this.page, this.$gRow, id, function (res) {
        _this5.loading = 0;
        if (res.status === 200) {
          console.log(res);
          _this5.tableData1 = res.data;
          _this5.total = res.total;
        } else {
          _this5.$message.error(res.message);
        }
      }, function () {
        _this5.loading = 0;
      });
    },
    allUnbind: function allUnbind() {
      var _this6 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_srrecovsysdf') + 'launcher?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        var tNos = '';
        _this6.list.forEach(function (vl) {
          tNos += vl.terminalNo + ',';
        });
        tNos = tNos.substring(0, tNos.length - 1);

        if (!tNos) {
          _this6.$message($t('app_oneDeviceMust'));
          return;
        }
        _this6.unbindReq(tNos, _this6.detail.packageName);
      }, '');
    },
    downOldApp: function downOldApp(row) {
      window.open(this.$host + row.appUrl);
    },
    deleteApp: function deleteApp(obj) {
      var _this7 = this;

      this.$showConfirm(this.$t("app_tip"), this.$t("app_tipMkDel"), this.$t("app_sure"), this.$t("app_cancel"), "warning", function () {
        _this7.$deleteAppHis(obj.versionid, function (res) {
          if (res.status === 200) {
            if (_this7.config.data.appVersion == obj.appVersion) {
              _this7.$message.success(res.message);
              _this7.$router.replace({ path: '/appList' });
            }
            _this7.getDetail();
          } else {
            _this7.$message(res.message);
          }
        }, "");
      }, "");
    },
    submitApp: function submitApp(obj) {
      var _this8 = this;

      this.$showConfirm(this.$t("app_tip"), this.$t("app_tipVerify"), this.$t("app_sure"), this.$t("app_cancel"), "warning", function () {
        _this8.loading = 1;
        _this8.$submitVerifyApp1(obj.applicationid, function (res) {
          _this8.loading = 0;
          if (res.status === 200) {
            _this8.getDetail();
          } else {
            _this8.$message.error(res.message);
          }
        }, function () {
          _this8.loading = 0;
        });
      }, "");
    },
    verifyFm: function verifyFm(row) {
      console.log('row', row.appStatus, this.vSt);
      return this.vSt[row.appStatus];
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('YYYY-MM-DD hh:mm:ss');
    },
    selectChange: function selectChange(vl) {
      this.getDevices();
    },
    pageSelect: function pageSelect(index) {
      this.index = index;
      this.getDevices();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getDevices();
    },
    deleteAppHis: function deleteAppHis(row) {
      var _this9 = this;

      if (row.applicationid) {
        this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
          confirmButtonText: this.$t('app_sure'),
          cancelButtonText: this.$t('app_cancel'),
          type: 'warning'
        }).then(function () {
          _this9.loading = 1;
          if (_this9.$appUrlTag === 0) {
            _this9.$deleteApp(row.applicationid, function (res) {
              _this9.loading = 0;
              if (res.status === 200) {
                _this9.getAppHistory();
              } else {
                _this9.$message.error(res.message);
              }
            }, function () {
              _this9.loading = 0;
            });
          } else {
            _this9.$deleteAppHis(row.applicationid, function (res) {
              _this9.loading = 0;
              if (res.status === 200) {
                _this9.getAppHistory();
              } else {
                _this9.$message.error(res.message);
              }
            }, function () {
              _this9.loading = 0;
            });
          }
        }).catch(function () {});
      }
    },
    imgFullUrl: function imgFullUrl(path) {
      if (path) {
        return this.$urls.prefix + path;
      } else {
        return '';
      }
    },
    getAppHistory: function getAppHistory() {
      var _this10 = this;

      if (!this.config.data.appName) {
        return;
      }

      this.loading = 1;
      if (this.$appUrlTag === 0) {
        this.$getAppHistory(this.config.data.appName, this.config.data.packagename, function (res) {
          _this10.loading = 0;
          if (res.status === 200) {
            _this10.tableData = res.data;
          } else {
            _this10.$message.error(res.message);
          }
        }, function () {
          _this10.loading = 0;
        });
      } else {
        var mech = this.dobj.mech;
        this.$getAppHistory1(mech, this.config.data.packagename, function (res) {

          console.log('his', res);
          _this10.loading = 0;
          if (res.status === 200) {
            _this10.tableData = res.data;
          } else {
            _this10.$message.error(res.message);
          }
        }, function () {
          _this10.loading = 0;
        });
      }
    },
    uploadNew: function uploadNew() {

      this.$setWObj("appUlNew", this.config);
      this.$router.push({ path: '/applist/newversion' });
    },
    getDetail: function getDetail() {
      var _this11 = this;

      if (this.dobj.isMk) {
        this.loading = 1;
        this.$appMkDetail(this.dobj.appid, function (res) {
          _this11.loading = 0;
          if (res.status === 200) {
            _this11.config = { data: res.data };
            _this11.iconUrl = _this11.config.data.appBigIcon;
            _this11.setCapturesArr(_this11.config.data.appScreenShot);
          } else {
            _this11.$message.error(res.message);
          }
        }, function () {
          _this11.loading = 0;
        });
      } else {
        this.loading = 1;
        this.$appDetail(this.dobj.appid, function (res) {
          _this11.loading = 0;
          if (res.status === 200) {
            _this11.config = { data: res.data };
            _this11.iconUrl = _this11.config.data.appBigIcon;
            _this11.setCapturesArr(_this11.config.data.appScreenShot);
            _this11.getAppHistory();
            _this11.getBinds();
          } else {
            _this11.$message.error(res.message);
          }
        }, function () {
          _this11.loading = 0;
        });
      }
    },
    setCapturesArr: function setCapturesArr(strs) {
      if (strs) {
        var arr = strs.split(',');
        this.captures = arr;
      }
    }
  },
  mounted: function mounted() {
    var _this12 = this;

    var _this = this;
    this.tqobj = {
      keys: ['appVSt'],
      callback: function callback(datas) {
        _this12.vSt = datas[0];
      }
    };

    this.dobj = this.$getWObj().appDisplay;

    this.getDetail();
  }
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		var that = this;
		return {
			mechanismData: {
				callback: function callback(value) {
					that.getTypeList(value);
					that.distributorId = value;
				}
			},
			ulinfo: {
				tip: this.$t('app_ulAppState_2'),
				index: 0,
				icons: ['el-icon-upload', 'el-icon-circle-check fs-icon', 'el-icon-close fs-icon']
			},
			distributorId: '',
			updateType: false,
			installType: 0,
			installTypes: [{
				label: this.$t('app_autoInstall'),
				value: 0
			}],
			fileList: [],
			fileSize: 0,
			tableData: [],
			md5: '',
			checkDesc: '',
			radio: '1',
			smImageUrl: '',
			smImageUrlValue: '',
			bgImageUrl: '',
			bgImageUrlValue: '',
			appUrl: '',
			dialogVisible: false,
			appTypes: [],
			appTypeValue: '',
			appName: '',
			version: '',
			verTag: '',
			spackage: '',
			appDesc: '',
			appDesc1: '',
			loading: 0,
			loading1: 0,
			loadingBig: 0,
			loadingSm: 0,
			config: {},
			cp0: '',
			cp0Value: '',
			cp1: '',
			cp1Value: '',
			cp2: '',
			cp2Value: '',
			cp3: '',
			cp3Value: '',
			cp4: '',
			cp4Value: '',
			captures: []
		};
	},

	components: {
		MechanismSelector: __WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue___default.a
	},
	computed: {
		imgUploadUrl: function imgUploadUrl() {
			return this.$urls.picUrl;
		},
		fileUploadUrl: function fileUploadUrl() {
			var vl = "https://tmsadmin.szzt.com.cn/file-management/tms-server-web/appFile/fileupload.do" + '?distributorId=' + localStorage.mechanismId + '&language=' + localStorage.system_lang;
			return vl;
		},
		imgPre: function imgPre() {
			return this.$host;
		}
	},
	methods: {
		hBlur: function hBlur(name) {
			this.$refs[name].validate(function (valid) {
				if (valid) {} else {
					return false;
				}
			});
		},
		tipBf: function tipBf() {
			this.loading1 = 1;
			return 1;
		},
		makeAppPath: function makeAppPath(url) {
			var path = url;
			if (!path) {
				if (this.config.data) {
					path = this.config.data.appUrl;
				} else {
					return '';
				}
			}
			var arr = path.split('/');
			return arr[arr.length - 1];
		},
		dateFormat: function dateFormat(row, column) {
			var date = row[column.property];
			if (date === undefined) {
				return '';
			}
			return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('YYYY-MM-DD');
		},
		deleteCapture0: function deleteCapture0() {
			this.cp0 = '';
			this.cp0Value = '';
		},
		deleteCapture1: function deleteCapture1() {
			this.cp1 = '';
			this.cp1Value = '';
		},
		deleteCapture2: function deleteCapture2() {
			this.cp2 = '';
			this.cp2Value = '';
		},
		deleteCapture3: function deleteCapture3() {
			this.cp3 = '';
			this.cp3Value = '';
		},
		deleteCapture4: function deleteCapture4() {
			this.cp4 = '';
			this.cp4Value = '';
		},
		imgFullUrl: function imgFullUrl(path) {
			if (path) {
				return this.$urls.prefix + path;
			} else {
				return '';
			}
		},
		handleSmAvatarSuccess: function handleSmAvatarSuccess(res, file) {
			this.loadingSm = 0;
			if (res.status !== 200) {
				this.$message.error(res.message);
			} else {
				this.smImageUrlValue = res.data;
				this.smImageUrl = URL.createObjectURL(file.raw);
			}
		},
		handleBgAvatarSuccess: function handleBgAvatarSuccess(res, file) {
			this.loadingBig = 0;
			if (res.status !== 200) {
				this.$message.error(res.message);
			} else {
				this.bgImageUrlValue = res.data;
				this.bgImageUrl = URL.createObjectURL(file.raw);
			}
		},
		handleAvatarSuccessCp0: function handleAvatarSuccessCp0(res, file) {
			this.loading1 = 0;
			if (res.status !== 200) {
				this.$message.error(res.message);
			} else {
				this.cp0Value = res.data;
				this.cp0 = this.imgFullUrl(res.data);
			}
		},
		handleAvatarSuccessCp1: function handleAvatarSuccessCp1(res, file) {
			this.loading1 = 0;
			if (res.status !== 200) {
				this.$message.error(res.message);
			} else {
				this.cp1Value = res.data;
				this.cp1 = URL.createObjectURL(file.raw);
			}
		},
		handleAvatarSuccessCp2: function handleAvatarSuccessCp2(res, file) {
			this.loading1 = 0;
			if (res.status !== 200) {
				this.$message.error(res.message);
			} else {
				this.cp2Value = res.data;
				this.cp2 = URL.createObjectURL(file.raw);
			}
		},
		handleAvatarSuccessCp3: function handleAvatarSuccessCp3(res, file) {
			this.loading1 = 0;
			if (res.status !== 200) {
				this.$message.error(res.message);
			} else {
				this.cp3Value = res.data;
				this.cp3 = URL.createObjectURL(file.raw);
			}
		},
		handleAvatarSuccessCp4: function handleAvatarSuccessCp4(res, file) {
			this.loading1 = 0;
			if (res.status !== 200) {
				this.$message.error(res.message);
			} else {
				this.cp4Value = res.data;
				this.cp4 = URL.createObjectURL(file.raw);
			}
		},
		beforeSmAvatarUpload: function beforeSmAvatarUpload(file) {
			var size = file.size / 1024;
			if (size > 100) {
				this.$message.error(this.$t('app_fileOver') + '100k');
				return false;
			}
			this.loadingSm = 1;
			return true;
		},
		beforeBgAvatarUpload: function beforeBgAvatarUpload(file) {
			var size = file.size / 1024;
			if (size > 200) {
				this.$message.error(this.$t('app_fileOver') + '200k');
				return false;
			}
			this.loadingBig = 1;
			return true;
		},
		handleRemove: function handleRemove(file, fileList) {},
		check: function check(callback) {

			if (this.distributorId && this.version && this.appDesc && this.appDesc1 && this.appTypeValue && this.appName && this.appUrl) {
					callback();
				} else {
				this.$message(this.$t('app_inputCp'));
			}
		},
		makeCapture: function makeCapture() {
			var str = '';
			if (this.cp0Value) {
				str += this.cp0Value + ',';
			}
			if (this.cp1Value) {
				str += this.cp1Value + ',';
			}
			if (this.cp2Value) {
				str += this.cp2Value + ',';
			}
			if (this.cp3Value) {
				str += this.cp3Value + ',';
			}
			if (this.cp4Value) {
				str += this.cp4Value + ',';
			}
			return str.substring(0, str.length - 1);
		},
		uploadApp: function uploadApp() {
			var _this = this;

			if (window[this.$route.path]) {
				this.$message.error(this.$t('app_appLoding'));
				return;
			}
			this.check(function () {
				_this.loading = 1;
				var updateVl = _this.updateType ? '0' : '1';
				if (_this.$appUrl === 0) {
					_this.$updateApp(_this.md5, _this.fileSize, _this.spackage, _this.verTag, _this.smImageUrlValue, _this.bgImageUrlValue, _this.makeCapture(), _this.appDesc, _this.config.data.applicationid, _this.appUrl, _this.version, updateVl, _this.distributorId, _this.appName, _this.appTypeValue[0], _this.appDesc1, function (res) {
						_this.loading = 0;
						if (res.status === 200) {
							_this.$message(res.message);
							_this.$router.go(-1);
						} else {
							_this.$message(res.message);
						}
					}, function () {
						_this.loading = 0;
					});
				} else {
					_this.$updateApp1(_this.md5, _this.fileSize, _this.spackage, _this.verTag, _this.smImageUrlValue, _this.bgImageUrlValue, _this.makeCapture(), _this.appDesc, _this.config.data.applicationid, _this.appUrl, _this.version, updateVl, _this.distributorId, _this.appName, _this.appTypeValue[0], _this.appDesc1, function (res) {
						_this.loading = 0;
						if (res.status === 200) {
							_this.$message(res.message);
							_this.$setWObj("appDisplay", {
								appid: res.data.appId,
								mech: res.data.distributorId
							});
							_this.$router.go(-1);
						} else {
							_this.$message(res.message);
						}
					}, function () {
						_this.loading = 0;
					});
				}
			});
		},
		fileUploadSuccess: function fileUploadSuccess(res, file) {
			window[this.$route.path] = '';

			this.ulinfo.tip = res.message;
			if (res.status === 200) {
				console.log(res);
				this.appUrl = res.fileUrl;
				this.fileSize = res.appSize;
				this.verTag = res.versionCode;
				this.version = res.appVersion;
				this.spackage = res.packageName;
				this.md5 = res.md5;
				this.fileList = [{
					name: file.name
				}];
				this.ulinfo.index = 1;
			} else {
				this.ulinfo.index = 2;
				this.spackage = '';
				this.version = '';
				this.verTag = '';
				if (!this.config.data.appUrl) {
					this.fileList = [];
				} else {
					this.fileList = [];
				}
				this.$message.error(res.message);
			}
		},
		fileBeforeUpload: function fileBeforeUpload(file) {
			if (file) {
				var ar = file.name.split('.');
				var type = ar[ar.length - 1];
				if (type === 'apk' || type === 'hap') {
					var limit = 500000;
					if (file.size / 1000 > limit) {
						this.$message.error(this.$t('app_fileOver') + '500M');
						return false;
					}
					window[this.$route.path] = 1;
					return true;
				} else {
					this.$message.error(this.$t('app_onlyApk_2'));
					return false;
				}
			} else {
				this.$message.error(this.$t('app_onlyApk_2'));
				return false;
			}
		},
		setCapturesIn: function setCapturesIn(strs) {
			var _this2 = this;

			if (strs) {
				var arr = strs.split(',');
				arr.forEach(function (value, index, array) {
					switch (index) {
						case 0:
							_this2.cp0Value = value;
							_this2.cp0 = _this2.imgFullUrl(value);
							break;
						case 1:
							_this2.cp1Value = value;
							_this2.cp1 = _this2.imgFullUrl(value);
							break;
						case 2:
							_this2.cp2Value = value;
							_this2.cp2 = _this2.imgFullUrl(value);
							break;
						case 3:
							_this2.cp3Value = value;
							_this2.cp3 = _this2.imgFullUrl(value);
							break;
						case 4:
							_this2.cp4Value = value;
							_this2.cp4 = _this2.imgFullUrl(value);
							break;
					}
				});
			}
		},
		setCapturesArr: function setCapturesArr(strs) {
			if (strs) {
				var arr = strs.split(',');
				this.captures = arr;
			}
		},
		fillEdit: function fillEdit() {
			var data = this.config.data;
			console.log(data);

			this.appDesc1 = data.appDesc;
			this.appName = data.appName;

			this.appTypeValue = data.appCategoryId.split(',');
			this.smImageUrl = this.imgFullUrl(data.appSmallIcon);
			this.smImageUrlValue = data.appSmallIcon;
			this.bgImageUrl = this.imgFullUrl(data.appBigIcon);
			this.bgImageUrlValue = data.appBigIcon;

			this.ulinfo.index = 0;
			this.setCapturesIn(data.appScreenShot);
		},
		getTypeList: function getTypeList(mcid) {
			var _this3 = this;

			var mc = mcid ? mcid : '';
			this.$gpAppType(mc, function (res) {
				if (res.data.length > 0) {
					_this3.appTypes = res.data[0].children;
				}
			});
		},
		cancel: function cancel() {
			this.$router.go(-1);
		},
		init: function init() {
			this.config = this.$getWObj().appUlNew;
			console.log(this.config);

			this.fillEdit();
		}
	},
	mounted: function mounted() {
		this.init();
	}
});

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_global_tyc__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_global_tyc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_global_tyc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_tagc__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_tagc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_global_tagc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		tyc: __WEBPACK_IMPORTED_MODULE_1__components_global_tyc___default.a,
		tagc: __WEBPACK_IMPORTED_MODULE_2__components_global_tagc___default.a,
		MechanismSelector: __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default.a
	},
	data: function data() {
		var _this2 = this;

		var dstCheck = function dstCheck(rule, value, callback) {
			if (!value) {
				callback(new Error(_this2.$t('app_select')));
			} else {
				callback();
			}
		};
		var tagCheck = function tagCheck(rule, value, callback) {
			if (!value) {
				callback(new Error(_this2.$t('noVerTag')));
			} else {
				callback();
			}
		};
		var that = this;
		return {
			mechanismData: {
				callback: function callback(value) {
					if (!value) that.form.distributorId = '';
					that.getTypeList(value);
					that.form.appTypeValue = '';
					that.form.appUrl = '';
					that.form.distributorId = value == 1 ? '' : value;
				}
			},
			mechanismData1: {
				callback: function callback(value) {
					that.channelId = value;
					that.getDevices();
				}
			},
			tqobj: '',
			ulinfo: {
				tip: this.$t('app_ulAppState_2'),
				index: 0,
				icons: ['el-icon-upload', 'el-icon-circle-check fs-icon', 'el-icon-close fs-icon']
			},
			mechanismId: window.localStorage['mechanismId'],
			status: '',
			tipColor: {
				color: '#13CE66'
			},
			stModel: '',
			channels: [],
			channelId: '',
			rules: {
				appName: [{
					required: true,
					message: this.$t('app_inputName'),
					trigger: 'blur'
				}],
				version: [{
					required: true,
					message: this.$t('app_inputVer'),
					trigger: 'blur'
				}],
				verTag: [{
					required: true,
					message: this.$t('app_inputVerTag'),
					trigger: 'blur',
					validator: tagCheck
				}],
				packageName: [{
					required: true,
					message: this.$t('app_inputPkg'),
					trigger: 'blur'
				}],
				appDesc: [{
					required: true,
					message: this.$t('app_inputIntrol'),
					trigger: 'blur'
				}],
				distributorId: [{
					required: true,
					message: this.$t('app_select'),
					trigger: 'blur'
				}],
				appTypeValue: [{
					required: true,
					message: this.$t('app_select'),
					trigger: 'blur',
					validator: dstCheck
				}],
				appUrl: [{
					required: true,
					message: this.$t('app_ulApp'),
					trigger: 'blur'
				}]
			},
			form: {
				appName: '',
				version: '',
				verTag: '',
				packageName: '',
				appDesc: '',
				installType: 0,
				appTypeValue: '',
				appUrl: '',
				smImageUrlValue: '',
				bgImageUrlValue: '',
				caps: '',
				md5: '',
				distributorId: ''
			},
			showPic: {
				value: 0,
				data: ''
			},
			srchValue: '',
			installTypes: [{
				label: this.$t('app_autoInstall'),
				value: 0
			}],
			fileSize: 0,
			tableData: [],
			checkDesc: '',
			radio: '1',
			smImageUrl: '',
			bgImageUrl: '',
			dialogVisible: false,
			appTypes: [],
			loading: 0,
			loading1: 0,
			loadingBig: 0,
			loadingSm: 0,
			config: {},
			cp0: '',
			cp1: '',
			cp2: '',
			cp3: '',
			cp4: '',
			captures: [],
			fileList: [],
			isUpload: 0,
			index: 1,
			total: 0
		};
	},

	computed: {
		bIcon: function bIcon() {
			if (this.config.data) {
				return this.config.data.appBigIcon ? this.imgFullUrl(this.config.data.appBigIcon) : __webpack_require__(6);
			} else {
				return '';
			}
		},
		sIcon: function sIcon() {
			if (this.config.data) {
				return this.config.data.appSmallIcon ? this.imgFullUrl(this.config.data.appSmallIcon) : __webpack_require__(6);
			} else {
				return '';
			}
		},
		showUploadNew: function showUploadNew() {
			if (this.config.data) {
				if (this.config.data.isUpload === '0') {
					return true;
				} else {
					return false;
				}
			} else {
				return false;
			}
		},
		isShowUpdateDesc: function isShowUpdateDesc() {
			if (this.config.data) {
				if (this.config.data.updatedesc) {
					return true;
				} else {
					return false;
				}
			} else {
				return false;
			}
		},
		updateDescContent: function updateDescContent() {
			var vl = this.config.data ? this.config.data.updatedesc : '';

			return vl;
		},
		prdes: function prdes() {
			return this.config.data ? this.config.data.appDesc : '';
		},
		uData: function uData() {
			return {
				token: 1234
			};
		},
		imgUploadUrl: function imgUploadUrl() {
			return this.$urls.picUrls;
		},
		fileUploadUrl: function fileUploadUrl() {
			var vl = "https://tmsadmin.szzt.com.cn/file-management/tms-server-web/appFile/fileupload.do" + '?distributorId=' + this.form.distributorId + '&language=' + localStorage.system_lang;
			return vl;
		},
		reason: function reason() {
			if (!this.config.data) {
				return '';
			}
			var rs = this.config.data.refuseReason;
			return rs ? this.$t('app_banReason') + ':' + rs : this.$t('app_banReason') + ':' + this.$t('app_noInput');
		},
		isShowReason: function isShowReason() {
			if (this.config) {
				if (this.config.data) {
					if (this.config.data.appStatus === '3') {
						return 1;
					} else {
						return 0;
					}
				} else {
					return 0;
				}
			} else {
				return 0;
			}
		}
	},
	methods: {
		fileFmProcess: function fileFmProcess(file) {
			if (file) {
				var size = file.size / 1024;
				if (size == 0) {
					this.$message.error(this.$t('mao_global.tip.notBlank'));
					return false;
				}

				var ar = file.name.split('.');
				var type = ar[ar.length - 1];
				type = type.toLowerCase();
				if (type === 'jpg' || type === 'png' || type === 'gif') {
					return true;
				} else {
					this.$message.error(this.$t('app_onlypicfm'));
					return false;
				}
			} else {
				this.$message.error(this.$t('app_onlypicfm'));
				return false;
			}
		},
		editApp: function editApp(row) {},
		selectChange: function selectChange(vl) {
			this.getDevices();
		},
		getChannels: function getChannels() {
			var _this3 = this;

			var _this = this;
			this.$getChannelList(10000, 1, '', '', '', function (res) {
				if (res.status === 200) {
					_this.channels = res.data;
				} else {
					_this3.$message.error(res.message);
				}
			}, function () {
				_this3.$message.error(_this3.$t('app_rqsError'));
			});
		},
		getStatus: function getStatus(value) {
			switch (value) {
				case '0':
					return this.$t('app_prePushVerify');
				case '1':
					return this.$t('app_preVerify');
				case '2':
					return this.$t('app_verifyPass');
				case '3':
					return this.$t('app_verifyNotPass');
			}
		},
		pageSelect: function pageSelect(index) {
			this.index = index;
			this.getDevices();
		},
		pageSized: function pageSized(val) {
			this.$gRow = val;
			this.getDevices();
		},
		hBlur: function hBlur(name) {
			this.form.caps = this.makeCapture();
			this.$refs[name].validate(function (valid) {
				if (valid) {} else {
					return false;
				}
			});
		},
		showBigPic: function showBigPic() {
			this.showPic = {
				value: 1,
				data: this.imgFullUrl(this.config.data.appBigIcon)
			};
		},
		showScreenShot: function showScreenShot(path) {
			this.showPic = {
				value: 1,
				data: this.imgFullUrl(path)
			};
		},
		pushInstall: function pushInstall() {
			this.dialogVisible = true;
		},
		makeAppPath: function makeAppPath(url) {
			var path = url;
			if (!path) {
				if (this.config.data) {
					path = this.config.data.appUrl;
					if (!path) {
						return '';
					}
				} else {
					return '';
				}
			}
			var arr = path.split('/');
			return arr[arr.length - 1];
		},
		deleteAppHis: function deleteAppHis(row) {
			var _this4 = this;

			if (row.applicationid) {
				this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
					confirmButtonText: this.$t('app_sure'),
					cancelButtonText: this.$t('app_cancel'),
					type: 'warning'
				}).then(function () {
					_this4.loading = 1;
					if (_this4.$appUrlTag === 0) {
						_this4.$deleteApp(row.applicationid, function (res) {
							_this4.loading = 0;
							if (res.status === 200) {
								_this4.getAppHistory();
							} else {
								_this4.$message.error(res.message);
							}
						}, function () {
							_this4.loading = 0;
						});
					} else {
						_this4.$deleteApp1(row.applicationid, function (res) {
							_this4.loading = 0;
							if (res.status === 200) {
								_this4.getAppHistory();
							} else {
								_this4.$message.error(res.message);
							}
						}, function () {
							_this4.loading = 0;
						});
					}
				}).catch(function () {});
			}
		},
		dateFormat: function dateFormat(row, column) {
			var date = row[column.property];
			if (date === undefined) {
				return '';
			}
			return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('YYYY-MM-DD hh:mm:ss');
		},
		deleteCapture0: function deleteCapture0() {
			this.cp0 = '';
			this.cp0Value = '';
		},
		deleteCapture1: function deleteCapture1() {
			this.cp1 = '';
			this.cp1Value = '';
		},
		deleteCapture2: function deleteCapture2() {
			this.cp2 = '';
			this.cp2Value = '';
		},
		deleteCapture3: function deleteCapture3() {
			this.cp3 = '';
			this.cp3Value = '';
		},
		deleteCapture4: function deleteCapture4() {
			this.cp4 = '';
			this.cp4Value = '';
		},
		imgFullUrl: function imgFullUrl(path) {
			if (path) {
				return this.$urls.prefix + path;
			} else {
				return '';
			}
		},
		close: function close() {
			this.$router.go(-1);
		},
		isShowCommon: function isShowCommon(isShow) {
			if (isShow && (this.config.type === 2 || this.config.type === 3)) {
				return 1;
			} else if (!isShow && this.config.type !== 2 && this.config.type !== 3) {
				return 1;
			} else {
				return 0;
			}
		},
		tipBf: function tipBf(file) {
			if (this.fileFmProcess(file)) {
				this.loading1 = 1;
				return true;
			} else {
				return false;
			}
		},
		handleSmAvatarSuccess: function handleSmAvatarSuccess(res, file) {
			this.loadingSm = 0;
			if (res.status !== 200) {
				this.$message.error(res.message);
			} else {
				this.form.smImageUrlValue = res.data;
				this.smImageUrl = URL.createObjectURL(file.raw);
				this.hBlur('form');
			}
		},
		handleBgAvatarSuccess: function handleBgAvatarSuccess(res, file) {
			this.loadingBig = 0;
			if (res.status !== 200) {
				this.$message.error(res.message);
			} else {
				this.form.bgImageUrlValue = res.data;
				this.bgImageUrl = URL.createObjectURL(file.raw);
				this.hBlur('form');
			}
		},
		handleAvatarSuccessCp0: function handleAvatarSuccessCp0(res, file) {
			this.loading1 = 0;

			if (res.status !== 200) {
				this.$message.error(res.message);
			} else {
				this.cp0Value = res.data;
				this.cp0 = URL.createObjectURL(file.raw);
				this.hBlur('form');
			}
		},
		handleAvatarSuccessCp1: function handleAvatarSuccessCp1(res, file) {
			this.loading1 = 0;
			if (res.status !== 200) {
				this.$message.error(res.message);
			} else {
				this.cp1Value = res.data;
				this.cp1 = URL.createObjectURL(file.raw);
				this.hBlur('form');
			}
		},
		handleAvatarSuccessCp2: function handleAvatarSuccessCp2(res, file) {
			this.loading1 = 0;
			if (res.status !== 200) {
				this.$message.error(res.message);
			} else {
				this.cp2Value = res.data;
				this.cp2 = URL.createObjectURL(file.raw);
				this.hBlur('form');
			}
		},
		handleAvatarSuccessCp3: function handleAvatarSuccessCp3(res, file) {
			this.loading1 = 0;
			if (res.status !== 200) {
				this.$message.error(res.message);
			} else {
				this.cp3Value = res.data;
				this.cp3 = URL.createObjectURL(file.raw);
				this.hBlur('form');
			}
		},
		handleAvatarSuccessCp4: function handleAvatarSuccessCp4(res, file) {
			this.loading1 = 0;
			if (res.status !== 200) {
				this.$message.error(res.message);
			} else {
				this.cp4Value = res.data;
				this.cp4 = URL.createObjectURL(file.raw);
				this.hBlur('form');
			}
		},
		beforeSmAvatarUpload: function beforeSmAvatarUpload(file) {
			var size = file.size / 1024;
			if (size > 100) {
				this.$message.error(this.$t('app_fileOver') + '100k');
				return false;
			}
			if (this.fileFmProcess(file)) {
				this.loadingSm = 1;
				return true;
			} else {
				return false;
			}
		},
		beforeBgAvatarUpload: function beforeBgAvatarUpload(file) {
			var size = file.size / 1024;
			if (size > 200) {
				this.$message.error(this.$t('app_fileOver') + '200k');
				return false;
			}

			if (this.fileFmProcess(file)) {
				this.loadingBig = 1;
				return true;
			} else {
				return false;
			}
		},
		handleRemove: function handleRemove(file, fileList) {},
		makeCapture: function makeCapture() {
			var str = '';
			if (this.cp0Value) {
				str += this.cp0Value + ',';
			}
			if (this.cp1Value) {
				str += this.cp1Value + ',';
			}
			if (this.cp2Value) {
				str += this.cp2Value + ',';
			}
			if (this.cp3Value) {
				str += this.cp3Value + ',';
			}
			if (this.cp4Value) {
				str += this.cp4Value + ',';
			}
			return str.substring(0, str.length - 1);
		},
		uploadApp: function uploadApp(formName) {
			var _this5 = this;

			if (window[this.$route.path]) {
				this.$message.error(this.$t('app_appLoding'));
				return;
			}

			this.form.caps = this.makeCapture();
			this.$refs[formName].validate(function (valid) {
				if (valid) {
					_this5.loading = 1;
					if (_this5.config.type === 1) {

						var atvl = _this5.form.appTypeValue;

						_this5.$editApp1(_this5.form.md5, _this5.form.distributorId, _this5.fileSize, _this5.form.packageName, _this5.form.verTag, _this5.config.data.applicationid, _this5.form.appUrl, _this5.form.bgImageUrlValue, _this5.form.smImageUrlValue, atvl, _this5.form.appDesc, 0, _this5.form.appName, _this5.form.caps, _this5.form.version, function (res) {
							console.log(res);
							_this5.loading = 0;
							if (res.status === 200) {
								_this5.$router.go(-1);
							} else {
								_this5.$message(res.message);
							}
						}, function () {
							_this5.loading = 0;
							_this5.$message(_this5.$t('app_rqsError'));
						});
					} else {
						var atvl = _this5.form.appTypeValue;

						_this5.$uploadApp1(_this5.form.md5, _this5.form.distributorId, _this5.form.verTag, _this5.form.packageName, _this5.fileSize, _this5.form.appUrl, _this5.form.bgImageUrlValue, _this5.form.smImageUrlValue, atvl, _this5.form.appDesc, 0, _this5.form.appName, _this5.form.caps, _this5.form.version, function (res) {
							_this5.loading = 0;
							if (res.status === 200) {
								_this5.$setWObj("appDisplay", {
									appid: res.data.appId,
									mech: res.data.distributorId
								});
								_this5.$router.push({
									path: '/applist/display'
								});
							} else {
								_this5.$message(res.message);
							}
						}, function () {
							_this5.loading = 0;
							_this5.$message(_this5.$t('app_rqsError'));
						});
					}
				} else {
					return false;
				}
			});
		},
		fileUploadSuccess: function fileUploadSuccess(res, file) {
			window[this.$route.path] = '';

			this.ulinfo.tip = res.message;
			if (res.status === 200) {
				this.form.appUrl = res.fileUrl;
				this.form.verTag = res.versionCode;
				this.form.version = res.appVersion;
				this.form.packageName = res.packageName;
				this.form.md5 = res.md5;
				this.fileSize = res.appSize;
				this.fileList = [{
					name: file.name
				}];
				this.hBlur('form');
				this.ulinfo.index = 1;
				this.tipColor = {
					color: '#13CE66'
				};
			} else {
				this.ulinfo.index = 2;
				this.form.version = '';
				this.form.verTag = '';
				this.form.packageName = '';
				if (this.config.type !== 1) {
					this.fileList = [];
				} else {
					this.fileList = [{
						name: this.makeAppPath(this.config.data.appUrl)
					}];
				}
				this.$message.error(res.message);
				this.tipColor = {
					color: '#FF4949'
				};
			}
		},
		fileBeforeUpload: function fileBeforeUpload(file) {
			if (file) {
				var ar = file.name.split('.');
				var type = ar[ar.length - 1];
				if (type === 'apk' || type === 'hap') {
					var limit = 500000;
					if (file.size / 1000 > limit) {
						this.$message.error(this.$t('app_fileOver') + '500M');
						return false;
					}
					window[this.$route.path] = 1;
					return true;
				} else {
					this.$message.error(this.$t('app_onlyApk_2'));
					return false;
				}
			} else {
				this.$message.error(this.$t('app_onlyApk_2'));
				return false;
			}
		},
		setCapturesIn: function setCapturesIn(strs) {
			var _this6 = this;

			if (strs) {
				var arr = strs.split(',');

				arr.forEach(function (value, index, array) {
					switch (index) {
						case 0:
							_this6.cp0 = _this6.imgFullUrl(value);
							_this6.cp0Value = value;
							break;
						case 1:
							_this6.cp1 = _this6.imgFullUrl(value);
							_this6.cp1Value = value;
							break;
						case 2:
							_this6.cp2 = _this6.imgFullUrl(value);
							_this6.cp2Value = value;
							break;
						case 3:
							_this6.cp3 = _this6.imgFullUrl(value);
							_this6.cp3Value = value;
							break;
						case 4:
							_this6.cp4 = _this6.imgFullUrl(value);
							_this6.cp4Value = value;
							break;
					}
				});
			}
		},
		setCapturesArr: function setCapturesArr(strs) {
			if (strs) {
				var arr = strs.split(',');
				this.captures = arr;
			}
		},
		fillEdit: function fillEdit() {
			var data = this.config.data;
			this.form.version = data.appVersion;
			this.form.appDesc = data.appDesc;
			this.form.appName = data.appName;
			this.form.verTag = data.versioncode;
			this.form.packageName = data.packagename;
			this.form.appTypeValue = data.appCategoryId.split(',').length > 1 ? data.appCategoryId.split(',')[1] : '';
			this.smImageUrl = this.imgFullUrl(data.appSmallIcon);
			this.form.smImageUrlValue = data.appSmallIcon;
			this.bgImageUrl = this.imgFullUrl(data.appBigIcon);
			this.form.bgImageUrlValue = data.appBigIcon;
			this.form.appUrl = data.appUrl;
			this.form.distributorId = data.distributorId;
			var _this = this;
			this.getTypeList(data.distributorId);
			this.mechanismData = {
				value: data.distributorName,
				callback: function callback(value) {
					if (!value) _this.form.distributorId = '';
					_this.getTypeList(value);
					_this.form.appTypeValue = '';
					_this.form.appUrl = '';
					_this.form.distributorId = value == 1 ? '' : value;
				}
			};
			this.fileList = [{
				name: this.makeAppPath(data.appUrl)
			}];
			this.setCapturesIn(data.appScreenShot);
			this.fileSize = data.appSize;
		},
		getTypeList: function getTypeList(mcid) {
			var _this7 = this;

			var mc = mcid ? mcid : '';


			this.$acMcFindApptype(mc, function (res) {
				if (res.status === 200) {
					_this7.appTypes = res.data;
				} else {
					_this7.$message(res.message);
				}
			}, '');
		},
		cancel: function cancel() {
			this.$router.go(-1);
		},
		verifyPre: function verifyPre() {
			var _this8 = this;

			this.$confirm(this.$t('app_isSubmitToCheck'), this.$t('app_tip'), {
				confirmButtonText: this.$t('app_sure'),
				cancelButtonText: this.$t('app_cancel'),
				type: 'warning'
			}).then(function () {
				_this8.verify();
			}).catch(function () {});
		},
		verify: function verify() {
			var _this9 = this;

			this.loading = 1;
			var id = this.config.data.applicationid;
			var passValue = this.radio === '1' ? '2' : '3';
			var desc = this.checkDesc;
			if (this.$appUrlTag === 0) {
				this.$verifyApp(localStorage.user, id, passValue, desc, function (res) {
					_this9.loading = 0;
					if (res.status === 200) {
						_this9.$router.go(-1);
					} else {
						_this9.$message.error(res.message);
					}
				}, function () {
					_this9.loading = 0;
					_this9.$message.error(_this9.$t('app_rqsError'));
				});
			} else {
				this.$verifyApp1(this.mechanismId, localStorage.user, id, passValue, desc, function (res) {
					_this9.loading = 0;
					if (res.status === 200) {
						_this9.$router.go(-1);
					} else {
						_this9.$message.error(res.message);
					}
				}, function () {
					_this9.loading = 0;
					_this9.$message.error(_this9.$t('app_rqsError'));
				});
			}
		},
		getAppHistory: function getAppHistory() {
			var _this10 = this;

			if (!this.config.data.appName) {
				return;
			}
			console.log('pkg', this.config.data);
			this.loading = 1;
			if (this.$appUrlTag === 0) {
				this.$getAppHistory(this.config.data.appName, this.config.data.packagename, function (res) {
					console.log('reslist', res);
					_this10.loading = 0;
					if (res.status === 200) {
						_this10.tableData = res.data;
					} else {
						_this10.$message.error(res.message);
					}
				}, function () {
					_this10.loading = 0;
				});
			} else {
				this.$getAppHistory1(this.mechanismId, this.config.data.packagename, function (res) {
					console.log('reslist', res);
					_this10.loading = 0;
					if (res.status === 200) {
						_this10.tableData = res.data;
					} else {
						_this10.$message.error(res.message);
					}
				}, function () {
					_this10.loading = 0;
				});
			}
		},
		uploadNew: function uploadNew() {

			this.$router.push({
				name: this.$t('menu.appManageSub.uploadNew')
			});
		},
		setInstallType: function setInstallType(type) {
			return this.$installType[type];
		},
		init: function init() {
			this.config = this.$getWObj().editAppConfig;
			console.log('config', this.config);

			switch (this.config.type) {
				case 0:
					break;
				case 1:
					this.fillEdit();
					break;
				case 2:
					this.setCapturesArr(this.config.data.appScreenShot);
					this.getAppHistory();
					break;
				case 3:
					this.getChannels();
					this.getDevices();
					this.setCapturesArr(this.config.data.appScreenShot);
					break;
			}
		},
		getDevices: function getDevices() {
			var _this11 = this;

			var vl = this.srchValue ? this.srchValue : '';
			var channel = this.channelId ? this.channelId : '';
			var status = this.status ? this.status : '';
			this.loading = 1;
			if (this.$appUrlTag === 0) {
				this.$getDevices(this.index, this.$gRow, channel, vl, status, '', this.config.data.applicationid, function (res) {
					console.log('dv', res);
					_this11.loading = 0;
					if (res.data) {
						_this11.tableData = res.data;
						_this11.total = res.total;
					}
				}, function () {
					_this11.loading = 0;
				});
			} else {
				this.$getDevices1(this.index, this.$gRow, channel, vl, status, '', this.config.data.applicationid, function (res) {
					console.log('dv', res);
					_this11.loading = 0;
					if (res.data) {
						_this11.tableData = res.data;
						_this11.total = res.total;
					}
				}, function () {
					_this11.loading = 0;
				});
			}
		},
		bindOperate: function bindOperate(row) {
			this.bind(row.terminalId, row.terminalNo, row.manufId);
		},
		bind: function bind(tId, tNo, mId) {
			var _this12 = this;

			this.loading = 1;
			if (this.$appUrlTag === 0) {
				this.$bindApp('0', tId, this.config.data.applicationid, function (res) {
					if (res.status === 200) {
						_this12.$message.success(res.message);
					} else {
						_this12.$message.error(res.message);
					}
					_this12.loading = 0;
				}, function () {
					_this12.loading = 0;
				});
			} else {
				this.$verifyAppPush(mId, tNo, this.config.data.applicationid, function (res) {
					if (res.status === 200) {
						_this12.$message.success(res.message);
					} else {
						_this12.$message.error(res.message);
					}
					_this12.loading = 0;
				}, function () {
					_this12.loading = 0;
				});
			}
		},
		srchDevice: function srchDevice() {
			this.getDevices();
		}
	},
	mounted: function mounted() {
		var _this13 = this;

		this.tqobj = {
			keys: ['terminalTypes'],
			callback: function callback(data) {
				_this13.stModel = data[0];
				_this13.status = '1';
				_this13.init();
			}
		};
	}
});

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_tyc__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_tyc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_global_tyc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_tagc__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_tagc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_tagc__);







/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		MechanismSelector: __WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue___default.a,
		tyc: __WEBPACK_IMPORTED_MODULE_2__components_global_tyc___default.a,
		tagc: __WEBPACK_IMPORTED_MODULE_3__components_global_tagc___default.a
	},
	data: function data() {
		var that = this;
		return {
			cmtStatusArr: [],
			activeName: this.$t('psp_app_manage'),
			mechanismData: {
				value: null,
				placeholder: that.$t('lin_global.place_areaid'),
				callback: function callback(value) {
					that.mech = value;
					that.getCmDv();
				}
			},

			isNon: false,
			mech: "",
			deviceList: [],
			deviceTotal: 0,
			select_device: [],
			tqobj: '',
			device_loading: false,
			mechanismDatas: {
				value: null,
				placeholder: that.$t('lin_global.place_areaid'),
				callback: function callback(value) {
					that.uninsatll_form.mechId = value;
					that.getUnstallList();
				}
			},

			sstatus: {
				'0': this.$t('app_new'),
				'1': this.$t('app_enable')
			},
			uninstallData: [],
			uninstallTotal: 0,
			uninsatll_form: {
				page: 1,
				rows: 10,
				terminalNo: "",
				mechId: ""
			},
			orderName: '',
			orderType: '',
			appvst: '',
			pkg: '',
			cerDialogVisible: false,
			cerTipDialogVisible: false,
			dvLoading: 0,
			appId: "",
			stModel: [{
				label: this.$t("app_online"),
				vl: "1"
			}, {
				label: this.$t("app_offline"),
				vl: "2"
			}, {
				label: this.$t("app_new"),
				vl: "0"
			}],
			channels: [],
			sNum: 0,
			cleanMode: false,
			multipleSelection: [],
			tempSelect: [],
			srchValue: "",
			channelId: "",
			cerTipMsg: "",
			status: "",
			index: 1,
			dvIndex: 1,
			dialogVisible: 0,
			mechanismId: window.localStorage["mechanismId"],
			mechId: '',
			tableData: [],
			dvTableData: [],
			appTypes: [],
			appTypeValue: "",

			appvStatus: [{
				label: this.$t("app_prePushVerify"),
				value: "0"
			}, {
				label: this.$t("app_preVerify"),
				value: "1"
			}, {
				label: this.$t("app_verifyPass"),
				value: "2"
			}, {
				label: this.$t("app_verifyNotPass"),
				value: "3"
			}],
			sstatusAr: [{
				vl: '',
				lb: this.$t('app_all')
			}, {
				vl: '0',
				lb: this.$t('app_new')
			}, {
				vl: '1',
				lb: this.$t('app_enable')
			}],

			appStatusValue: "",
			total: 0,
			dvTotal: 0,
			loading: 0,
			appType: "",
			queryKey: "",
			appName: "",
			show_push: false,
			select_form: {
				page: 1,
				rows: 20,
				areaid: "",
				snBegin: "",
				snEnd: "",
				terminal_status: "",
				terminal_no: ""
			}
		};
	},

	methods: {
		handleSelectionChangeDevice: function handleSelectionChangeDevice(val) {
			this.select_device = val;
		},
		open_push: function open_push() {
			this.show_push = true;
			this.getCmDv();
		},
		handleClose: function handleClose() {
			this.show_push = false;
			this.select_form = {
				page: 1,
				rows: 20,
				areaid: "",
				snBegin: "",
				snEnd: "",
				terminal_status: "",
				terminal_no: ""
			};
			var that = this;
			that.mech = "";
			this.mechanismData = {
				value: null,
				placeholder: that.$t('lin_global.place_areaid'),
				callback: function callback(value) {
					that.mech = value;
					that.getCmDv();
				}
			};
		},
		bcPush: function bcPush() {
			var _this2 = this;

			var terminalNo_list = [];
			var mechId_list = [];
			var mechName_list = [];
			this.select_device.forEach(function (obj) {
				terminalNo_list.push(obj.terminalNo);
				mechId_list.push(obj.mechanismId);
				mechName_list.push(obj.mechName);
			});

			var tip = this.$t('app_surepsxdv').replace('{num}', this.select_device.length);

			this.$showConfirm(this.$t('app_tip'), tip + ' ?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
				var sub_form = {
					terminalNo: String(terminalNo_list),
					mechId: String(mechId_list),
					mechName: String(mechName_list)
				};
				_this2.device_loading = true;
				_this2.$pspUnPush(sub_form, function (res) {
					_this2.device_loading = false;
					if (res.status === 200) {
						_this2.$message.success(res.message);
						_this2.show_push = false;
						_this2.getUnstallList();
					} else {
						_this2.$message.error(res.message);
					}
				}, function () {
					_this2.device_loading = false;
				});
			}, '');
		},
		pushAll: function pushAll() {
			var _this3 = this;

			this.$showConfirm(this.$t('app_tip'), this.$t('app_ispushalldv') + ' ?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
				_this3.select_form.areaid = _this3.mech;
				console.log(_this3.select_form);
				console.log("推送全部");
			}, '');
		},
		pushed: function pushed(row) {
			var _this4 = this;

			this.$showConfirm(this.$t('app_tip'), this.$t('app_srpush') + ' ' + row.terminalNo + ' ?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
				console.log(row);
				var sub_form = {
					terminalNo: row.terminalNo,
					mechId: row.mechanismId,
					mechName: row.mechName
				};
				_this4.device_loading = true;
				_this4.$pspUnPush(sub_form, function (res) {
					_this4.device_loading = false;
					if (res.status === 200) {
						_this4.$message.success(res.message);
						_this4.show_push = false;
						_this4.getUnstallList();
					} else {
						_this4.$message.error(res.message);
					}
				}, function () {
					_this4.device_loading = false;
				});
			}, '');
		},
		pageSizedDevice: function pageSizedDevice(vl) {
			this.select_form.rows = vl;
			this.getCmDv();
		},
		pageSelectDevice: function pageSelectDevice(vl) {
			this.select_form.page = vl;
			this.getCmDv();
		},
		getCmDv: function getCmDv() {
			var _this = this;
			var typeKey = 'terminalTypes';
			this.tqobj = {
				keys: [typeKey],
				callback: function callback(data) {
					_this.cmtStatusArr = data[0];
				}
			};
			this.get_device_list();
		},
		mkDvSt: function mkDvSt(row) {
			return this.sstatus[row.terminalStatus];
		},
		get_device_list: function get_device_list() {
			var _this5 = this;

			this.device_loading = true;
			this.$getNonItDv(this.select_form.page, this.select_form.rows, this.mech, this.select_form.terminal_no, this.select_form.terminal_status, "", '', '', this.select_form.snBegin, this.select_form.snEnd, function (res) {
				_this5.device_loading = 0;
				if (res.status === 200) {
					_this5.deviceList = res.data;
					_this5.deviceTotal = res.total;
				} else {
					_this5.$message.error(res.message);
				}
			}, function () {
				_this5.device_loading = 0;
			});
		},
		handleClick: function handleClick(tab, event) {
			this.getAppList();
			this.getUnstallList();
		},
		batchDeleteRow: function batchDeleteRow() {
			var _this6 = this;

			this.$confirm(this.$t('terminal.list.delete_tips'), this.$t('lin_btn.tips'), {
				confirmButtonText: this.$t('lin_btn.confirm'),
				cancelButtonText: this.$t('lin_btn.cancel'),
				type: 'warning'
			}).then(function () {
				var ids = [];
				for (var i = 0; i < _this6.multipleSelection.length; i++) {
					ids.push(_this6.multipleSelection[i].id);
				}
				_this6.$delUnPsp(String(ids), function (res) {
					if (res.status === 200) {
						_this6.$message.success(res.message);
						_this6.getUnstallList();
					} else {
						_this6.$message.error(res.message);
					}
				}, "");
			}).catch(function () {});
		},
		delete_all: function delete_all() {
			var _this7 = this;

			this.$confirm(this.$t('del_allData'), this.$t('lin_btn.tips'), {
				confirmButtonText: this.$t('lin_btn.confirm'),
				cancelButtonText: this.$t('lin_btn.cancel'),
				type: 'warning'
			}).then(function () {
				console.log(_this7.uninsatll_form);
				var sub_form = {
					terminalNo: _this7.uninsatll_form.terminalNo,
					mechId: _this7.uninsatll_form.mechId
				};
				_this7.$delUnPspAll(sub_form, function (res) {
					if (res.status === 200) {
						_this7.$message.success(res.message);
						_this7.uninsatll_form = {
							page: 1,
							rows: 20,
							terminalNo: "",
							mechId: ""
						};
						var that = _this7;
						_this7.mechanismDatas = {
							value: null,
							placeholder: that.$t('lin_global.place_areaid'),
							callback: function callback(value) {
								that.uninsatll_form.mechId = value;
								that.getUnstallList();
							}
						};
						_this7.getUnstallList();
					} else {
						_this7.$message.error(res.message);
					}
				}, "");
			}).catch(function () {});
		},
		jumpToAdd: function jumpToAdd() {
			this.$setWObj("editChangePSPConfig", {
				type: 0 });
			this.$router.push({
				path: 'changePsp/add'
			});
		},
		editApp: function editApp(row) {
			this.$setWObj("editChangePSPConfig", {
				data: row,
				type: 1 });
			this.$router.push({
				path: 'changePsp/edit'
			});
		},
		handleSelectionChange: function handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		query: function query() {
			this.getAppList();
		},
		reset: function reset() {
			this.appName = "";
			this.getAppList();
		},
		pageSelect: function pageSelect(index) {
			this.index = index;
			this.getAppList();
		},
		pageSized: function pageSized(val) {
			this.$gRow = val;
			this.getAppList();
		},
		pageSelectUn: function pageSelectUn(index) {
			this.uninsatll_form.page = index;
			this.getUnstallList();
		},
		pageSizedUn: function pageSizedUn(val) {
			this.uninsatll_form.rows = val;
			this.getUnstallList();
		},
		deleteApp: function deleteApp(obj) {
			var _this8 = this;

			this.$showConfirm(this.$t("app_tip"), this.$t("app_tipMkDel"), this.$t("app_sure"), this.$t("app_cancel"), "warning", function () {
				_this8.$delPsp(obj.id, function (res) {
					if (res.status === 200) {
						_this8.$message.success(res.message);
						_this8.getAppList();
					} else {
						_this8.$message.error(res.message);
					}
				}, "");
			}, "");
		},
		deleteApps: function deleteApps(obj) {
			var _this9 = this;

			this.$showConfirm(this.$t("app_tip"), this.$t("app_tipMkDel"), this.$t("app_sure"), this.$t("app_cancel"), "warning", function () {
				_this9.$delChangePsp(obj.id, function (res) {
					if (res.status === 200) {
						_this9.$message.success(res.message);
						_this9.getAppList();
					} else {
						_this9.$message.error(res.message);
					}
				}, "");
			}, "");
		},
		cellClick: function cellClick(row, ev, col) {
			var label = col.label;
			if (!label) return;
			if (label === this.$t("app_operate")) {
				return;
			} else {
				this.$setWObj("changePspDetail", {
					data: row,
					type: 2
				});
				this.$router.push({
					path: 'changePsp/detail'
				});
			}
		},
		getAppList: function getAppList() {
			var _this10 = this;

			this.loading = 1;
			this.$changePspList({
				page: this.index,
				rows: this.$gRow,
				fileType: 1,
				appName: this.appName
			}, function (res) {
				console.log(res);
				_this10.loading = 0;
				if (res.status === 200) {
					_this10.total = res.total;
					_this10.tableData = res.data;
				} else {
					_this10.$message(res.message);
				}
			}, function () {
				_this10.loading = 0;
				_this10.$message.error(_this10.$t("app_rqsError"));
			});
		},
		getUnstallList: function getUnstallList() {
			var _this11 = this;

			console.log(this.uninsatll_form);

			this.$pspUnList(this.uninsatll_form, function (res) {
				console.log(res);
				_this11.loading = 0;
				if (res.status === 200) {
					_this11.uninstallTotal = res.total;
					_this11.uninstallData = res.data;
				} else {
					_this11.$message(res.message);
				}
			}, function () {
				_this11.$message.error(_this11.$t("app_rqsError"));
			});
		},
		dateFormat: function dateFormat(row, column) {
			var date = row[column.property];
			if (date === undefined) {
				return "";
			}
			return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format("YYYY-MM-DD HH:mm:ss");
		}
	},
	mounted: function mounted() {
		this.getAppList();
	},
	destroyed: function destroyed() {}
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_df_png__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_df_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_df_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_global_tyc__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_global_tyc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_global_tyc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_global_tagc__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_global_tagc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_global_tagc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_url__ = __webpack_require__(3);










/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		MechanismSelector: __WEBPACK_IMPORTED_MODULE_5__components_global_mechanism_selector_vue___default.a,
		tyc: __WEBPACK_IMPORTED_MODULE_4__components_global_tyc___default.a,
		tagc: __WEBPACK_IMPORTED_MODULE_6__components_global_tagc___default.a
	},
	data: function data() {
		var _ref;

		var that = this;
		return _ref = {
			downTpl: __WEBPACK_IMPORTED_MODULE_7__api_url__["b" /* urlAssets */].prefix + 'tms-server-web/model/terminalNos.xlsx',
			uldata: '',
			formLabelWidth: '28.5%',
			pushImport: false,
			fileList: [],
			cmtStatusArr: [],
			mechanismData: {
				value: null,
				placeholder: that.$t('lin_global.place_areaid'),
				callback: function callback(value) {
					that.mech = value;
					that.getCmDv();
				}
			},
			multipleSelection: [],
			isNon: false,
			mech: "",
			deviceList: [],
			deviceTotal: 0,
			select_device: [],
			tqobj: '',
			device_loading: false,
			mechanismDatas: {
				value: null,
				placeholder: that.$t('lin_global.place_areaid'),
				callback: function callback(value) {
					that.uninsatll_form.mechId = value;
					that.getUnstallList();
				}
			},
			sstatus: {
				'0': this.$t('app_new'),
				'1': this.$t('app_enable')
			},
			sstatusAr: [{
				vl: '',
				lb: this.$t('app_all')
			}, {
				vl: '0',
				lb: this.$t('app_new')
			}, {
				vl: '1',
				lb: this.$t('app_enable')
			}],
			uninstallData: [],
			uninstallTotal: 0,
			uninsatll_form: {
				page: 1,
				rows: 10,
				terminalNo: "",
				mechId: "",
				appId: ""
			},
			show_push: false,
			select_form: {
				page: 1,
				rows: 20,
				areaid: "",
				snBegin: "",
				snEnd: "",
				terminal_status: "",
				terminal_no: ""
			},

			total: 0,
			queryKey: '',
			terminalNo: "",
			sNum: 0,
			page: 1,
			tableData1: [],
			tableData: [],
			list: [],
			pushedList: false
		}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'tqobj', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'dobj', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'vSt', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'config', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'captures', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'loading', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'iconUrl', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'app_detail', {}), _ref;
	},

	computed: {
		avtStyle: function avtStyle() {
			var url = this.iconUrl ? this.imgFullUrl(this.iconUrl) : __webpack_require__(6);

			return 'background-size: cover;background-position: center center;width:100%;height:100%;background-image: url(' + url + ')';
		}
	},
	methods: {
		beforeRemove: function beforeRemove() {
			this.fileList = [];
			this.uldata = '';
		},
		srcBefore: function srcBefore(file) {
			if (this.uldata.fileNo) {
				return false;
			}

			var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
			var extension = testmsg === "xls";
			var extension2 = testmsg === "xlsx";
			if (!extension && !extension2) {
				this.$message({
					message: this.$t("IncorrectaFormat"),
					type: "warning"
				});
			}
			return extension || extension2;
		},
		srcSuccess: function srcSuccess(res, file) {
			window[this.$route.path] = '';

			if (res.status === 200) {
				this.uldata = res.data;

				this.$message.success(res.message);
			} else {
				this.$message.error(res.message);
			}
		},
		ulError: function ulError() {
			window[this.$route.path] = '';
		},
		ulurl: function ulurl() {
			var url = this.$fileExcelUlUrl + '?token=' + localStorage.user + '&language=' + localStorage.system_lang;

			return url;
		},
		submitUpload: function submitUpload() {
			var _this2 = this;

			this.loading = true;
			this.$pushByImport(this.app_detail.id, this.uldata.fileNo, '2', function (res) {
				_this2.loading = false;
				if (res.status === 200) {
					_this2.$message.success(res.message);
				} else {
					_this2.$message.error(res.message);
				}
			}, function () {
				_this2.loading = false;
			});
			this.fileList = [];
			this.uldata = '';
			this.getUnstallList();
			this.pushImport = false;
		},
		open_import: function open_import() {
			this.pushImport = true;
		},
		closeImport: function closeImport() {
			this.pushImport = false;
			this.fileList = [];
			this.uldata = '';
		},
		addTer: function addTer() {
			this.pushImport = true;
		},
		handleSelectionChange: function handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		handleSelectionChangeDevice: function handleSelectionChangeDevice(val) {
			this.select_device = val;
		},
		open_push: function open_push() {
			this.show_push = true;
			this.getCmDv();
		},
		handleClose: function handleClose() {
			this.show_push = false;
			this.select_form = {
				page: 1,
				rows: 20,
				areaid: "",
				snBegin: "",
				snEnd: "",
				terminal_status: "",
				terminal_no: ""
			};
			var that = this;
			that.mech = "";
			this.mechanismData = {
				value: null,
				placeholder: that.$t('lin_global.place_areaid'),
				callback: function callback(value) {
					that.mech = value;
					that.getCmDv();
				}
			};
		},
		bcPush: function bcPush() {
			var _this3 = this;

			var terminalNo_list = [];
			var mechId_list = [];
			var mechName_list = [];
			this.select_device.forEach(function (obj) {
				terminalNo_list.push(obj.terminalNo);
				mechId_list.push(obj.mechanismId);
				mechName_list.push(obj.mechName);
			});

			var tip = this.$t('app_surepsxdv').replace('{num}', this.select_device.length);

			this.$showConfirm(this.$t('app_tip'), tip + ' ?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
				var sub_form = {
					appId: _this3.app_detail.id,
					terminalNo: String(terminalNo_list),
					mechId: String(mechId_list),
					mechName: String(mechName_list),
					fileType: 1
				};
				_this3.device_loading = true;
				_this3.$changePspPush(sub_form, function (res) {
					_this3.device_loading = false;
					if (res.status === 200) {
						_this3.$message.success(res.message);
						_this3.show_push = false;
						_this3.getUnstallList();
					} else {
						_this3.$message.error(res.message);
					}
				}, function () {
					_this3.device_loading = false;
				});
			}, '');
		},
		pushAll: function pushAll() {
			var _this4 = this;

			this.$showConfirm(this.$t('app_tip'), this.$t('app_ispushalldv') + ' ?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
				_this4.select_form.areaid = _this4.mech;
				console.log(_this4.select_form);
				console.log("推送全部");
			}, '');
		},
		pushed: function pushed(row) {
			var _this5 = this;

			this.$showConfirm(this.$t('app_tip'), this.$t('app_srpush') + ' ' + row.terminalNo + ' ?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
				console.log(row);
				var sub_form = {
					appId: _this5.app_detail.id,
					terminalNo: row.terminalNo,
					mechId: row.mechanismId,
					mechName: row.mechName,
					fileType: 1
				};
				_this5.device_loading = true;
				_this5.$changePspPush(sub_form, function (res) {
					_this5.device_loading = false;
					if (res.status === 200) {
						_this5.$message.success(res.message);
						_this5.show_push = false;
						_this5.getUnstallList();
					} else {
						_this5.$message.error(res.message);
					}
				}, function () {
					_this5.device_loading = false;
				});
			}, '');
		},
		pageSizedDevice: function pageSizedDevice(vl) {
			this.select_form.rows = vl;
			this.getCmDv();
		},
		pageSelectDevice: function pageSelectDevice(vl) {
			this.select_form.page = vl;
			this.getCmDv();
		},
		pageSelectUn: function pageSelectUn(index) {
			this.uninsatll_form.page = index;
			this.getUnstallList();
		},
		pageSizedUn: function pageSizedUn(val) {
			this.uninsatll_form.rows = val;
			this.getUnstallList();
		},
		getCmDv: function getCmDv() {
			var _this = this;
			var typeKey = 'terminalTypes';
			this.tqobj = {
				keys: [typeKey],
				callback: function callback(data) {
					_this.cmtStatusArr = data[0];
				}
			};
			this.get_device_list();
		},
		mkDvSt: function mkDvSt(row) {
			return this.sstatus[row.terminalStatus];
		},
		get_device_list: function get_device_list() {
			var _this6 = this;

			this.device_loading = true;
			this.$getNonItDv(this.select_form.page, this.select_form.rows, this.mech, this.select_form.terminal_no, this.select_form.terminal_status, "", '', '', this.select_form.snBegin, this.select_form.snEnd, function (res) {
				_this6.device_loading = 0;
				if (res.status === 200) {
					_this6.deviceList = res.data;
					_this6.deviceTotal = res.total;
				} else {
					_this6.$message.error(res.message);
				}
			}, function () {
				_this6.device_loading = 0;
			});
		},
		deleteApps: function deleteApps(obj) {
			var _this7 = this;

			this.$showConfirm(this.$t("app_tip"), this.$t("terminal.list.delete_tips"), this.$t("app_sure"), this.$t("app_cancel"), "warning", function () {
				_this7.$changePspDel(obj.id, function (res) {
					if (res.status === 200) {
						_this7.$message.success(res.message);
						_this7.getUnstallList();
					} else {
						_this7.$message.error(res.message);
					}
				}, "");
			}, "");
		},
		batchDeleteRow: function batchDeleteRow() {
			var _this8 = this;

			this.$confirm(this.$t('terminal.list.delete_tips'), this.$t('lin_btn.tips'), {
				confirmButtonText: this.$t('lin_btn.confirm'),
				cancelButtonText: this.$t('lin_btn.cancel'),
				type: 'warning'
			}).then(function () {
				var ids = [];
				for (var i = 0; i < _this8.multipleSelection.length; i++) {
					ids.push(_this8.multipleSelection[i].id);
				}
				_this8.$changePspDel(String(ids), function (res) {
					if (res.status === 200) {
						_this8.$message.success(res.message);
						_this8.getUnstallList();
					} else {
						_this8.$message.error(res.message);
					}
				}, "");
			}).catch(function () {});
		},
		delete_all: function delete_all() {
			var _this9 = this;

			this.$confirm(this.$t('del_allData'), this.$t('lin_btn.tips'), {
				confirmButtonText: this.$t('lin_btn.confirm'),
				cancelButtonText: this.$t('lin_btn.cancel'),
				type: 'warning'
			}).then(function () {
				var sub_form = {
					appId: _this9.app_detail.id,
					terminalNo: _this9.uninsatll_form.terminalNo,
					mechId: _this9.uninsatll_form.mechId
				};
				_this9.$changePspDelAll(sub_form, function (res) {
					if (res.status === 200) {
						_this9.$message.success(res.message);
						_this9.uninsatll_form = {
							page: 1,
							rows: 20,
							terminalNo: "",
							mechId: "",
							appId: _this9.app_detail.id
						};
						var that = _this9;
						_this9.mechanismDatas = {
							value: null,
							placeholder: that.$t('lin_global.place_areaid'),
							callback: function callback(value) {
								that.uninsatll_form.mechId = value;
								that.getUnstallList();
							}
						};
						_this9.getUnstallList();
					} else {
						_this9.$message.error(res.message);
					}
				}, "");
			}).catch(function () {});
		},
		getUnstallList: function getUnstallList() {
			var _this10 = this;

			this.$changePspDeviceList(this.uninsatll_form, function (res) {
				_this10.loading = 0;
				if (res.status === 200) {
					_this10.uninstallTotal = res.total;
					_this10.uninstallData = res.data;
				} else {
					_this10.$message(res.message);
				}
			}, function () {
				_this10.$message.error(_this10.$t("app_rqsError"));
			});
		}
	},
	created: function created() {
		this.config = this.$getWObj().changePspDetail;
		this.app_detail = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.config.data));
		this.uninsatll_form.appId = this.app_detail.id;
		if (this.config.type == 1) {
			this.show_push = true;
			this.get_device_list();
		}
		console.log(this.app_detail);
		this.getUnstallList();
	}
});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_tyc__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_tyc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_global_tyc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_tagc__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_tagc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_tagc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_global_mechanism_selector_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		tyc: __WEBPACK_IMPORTED_MODULE_2__components_global_tyc___default.a,
		tagc: __WEBPACK_IMPORTED_MODULE_3__components_global_tagc___default.a,
		MechanismSelector: __WEBPACK_IMPORTED_MODULE_4__components_global_mechanism_selector_vue___default.a
	},
	data: function data() {
		var _this2 = this;

		var dstCheck = function dstCheck(rule, value, callback) {
			if (!value) {
				callback(new Error(_this2.$t('app_select')));
			} else {
				callback();
			}
		};
		var tagCheck = function tagCheck(rule, value, callback) {
			if (!value) {
				callback(new Error(_this2.$t('noVerTag')));
			} else {
				callback();
			}
		};
		var that = this;
		return {
			tqobj: '',
			ulinfo: {
				tip: this.$t('app_ulAppState_2'),
				index: 0,
				icons: ['el-icon-upload', 'el-icon-circle-check fs-icon', 'el-icon-close fs-icon']
			},
			mechanismId: window.localStorage['mechanismId'],
			status: '',

			stModel: '',
			channels: [],
			channelId: '',
			rules: {
				appId: [{
					required: true,
					message: this.$t('app_input'),
					trigger: 'blur'
				}],
				appName: [{
					required: true,
					message: this.$t('app_inputName'),
					trigger: 'blur'
				}],
				appVersion: [{
					required: true,
					message: this.$t('app_inputVer'),
					trigger: 'blur'
				}],
				verTag: [{
					required: true,
					message: this.$t('app_inputVerTag'),
					trigger: 'blur',
					validator: tagCheck
				}],
				packageName: [{
					required: true,
					message: this.$t('app_inputPkg'),
					trigger: 'blur'
				}],
				memo: [{
					required: true,
					message: this.$t('app_inputIntrol'),
					trigger: 'blur'
				}],
				distributorId: [{
					required: true,
					message: this.$t('app_select'),
					trigger: 'blur'
				}],
				appTypeValue: [{
					required: true,
					message: this.$t('app_select'),
					trigger: 'blur',
					validator: dstCheck
				}]
			},
			upinfo_1: true,
			upinfo_2: true,
			upinfo_3: true,
			tipColor_1: {
				color: '#13CE66'
			},
			tipColor_2: {
				color: '#13CE66'
			},
			tipColor_3: {
				color: '#13CE66'
			},
			form: {
				appName: '',
				appVersion: '',
				fileType: 1,
				pspAppUrl: '',
				pspAppSize: "",
				pspAppHash: '',
				cer1Url: "",
				cer1Size: "",
				cer1Hash: "",
				cer2Url: "",
				cer2Size: "",
				cer2Hash: ""
			},
			showPic: {
				value: 0,
				data: ''
			},
			srchValue: '',
			installTypes: [{
				label: this.$t('app_autoInstall'),
				value: 0
			}],
			fileSize: 0,
			tableData: [],
			checkDesc: '',
			radio: '1',
			smImageUrl: '',
			bgImageUrl: '',
			dialogVisible: false,
			appTypes: [],
			loading: 0,
			loading1: 0,
			loadingBig: 0,
			loadingSm: 0,
			config: {},
			cp0: '',
			cp1: '',
			cp2: '',
			cp3: '',
			cp4: '',
			captures: [],
			fileList: [],
			fileLists: [],
			fileListss: [],
			isUpload: 0,
			index: 1,
			total: 0,
			file_id: 0
		};
	},

	computed: {
		uData: function uData() {
			return {
				token: 1234
			};
		},
		fileUploadUrl: function fileUploadUrl() {
			var vl = this.$urls.webUrl + "/tms-server-web/file/fileupload.do";
			return vl;
		}
	},
	created: function created() {
		this.init();
	},

	methods: {
		editApp: function editApp(row) {},
		getChannels: function getChannels() {
			var _this3 = this;

			var _this = this;
			this.$getChannelList(10000, 1, '', '', '', function (res) {
				if (res.status === 200) {
					_this.channels = res.data;
				} else {
					_this3.$message.error(res.message);
				}
			}, function () {
				_this3.$message.error(_this3.$t('app_rqsError'));
			});
		},
		getStatus: function getStatus(value) {
			switch (value) {
				case '0':
					return this.$t('app_prePushVerify');
				case '1':
					return this.$t('app_preVerify');
				case '2':
					return this.$t('app_verifyPass');
				case '3':
					return this.$t('app_verifyNotPass');
			}
		},
		hBlur: function hBlur(name) {
			this.$refs[name].validate(function (valid) {
				if (valid) {} else {
					return false;
				}
			});
		},
		dateFormat: function dateFormat(row, column) {
			var date = row[column.property];
			if (date === undefined) {
				return '';
			}
			return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD hh:mm:ss');
		},
		deleteCapture0: function deleteCapture0() {
			this.cp0 = '';
			this.cp0Value = '';
		},
		deleteCapture1: function deleteCapture1() {
			this.cp1 = '';
			this.cp1Value = '';
		},
		deleteCapture2: function deleteCapture2() {
			this.cp2 = '';
			this.cp2Value = '';
		},
		deleteCapture3: function deleteCapture3() {
			this.cp3 = '';
			this.cp3Value = '';
		},
		deleteCapture4: function deleteCapture4() {
			this.cp4 = '';
			this.cp4Value = '';
		},
		imgFullUrl: function imgFullUrl(path) {
			if (path) {
				return this.$urls.prefix + path;
			} else {
				return '';
			}
		},
		close: function close() {
			this.$router.go(-1);
		},
		isShowCommon: function isShowCommon(isShow) {
			if (isShow && (this.config.type === 2 || this.config.type === 3)) {
				return 1;
			} else if (!isShow && this.config.type !== 2 && this.config.type !== 3) {
				return 1;
			} else {
				return 0;
			}
		},
		uploadApp: function uploadApp(formName) {
			var _this4 = this;

			this.$refs[formName].validate(function (valid) {
				if (valid) {
					_this4.loading = 1;
					if (_this4.config.type === 1) {
						_this4.$editPsp(_this4.form, function (res) {
							console.log(res);
							_this4.loading = 0;
							if (res.status === 200) {
								_this4.$router.go(-1);
							} else {
								_this4.$message(res.message);
							}
						}, function () {
							_this4.loading = 0;
							_this4.$message(_this4.$t('app_rqsError'));
						});
					} else {
						_this4.$changePspAdd(_this4.form, function (res) {
							console.log(res);
							_this4.loading = 0;
							if (res.status === 200) {
								_this4.$message.success(res.message);

								_this4.$setWObj("changePspDetail", {
									data: res.data,
									type: 1
								});
								_this4.$router.push({
									path: '/changePsp/detail'
								});
							} else {
								_this4.$message(res.message);
							}
						}, function () {
							_this4.loading = 0;
							_this4.$message(_this4.$t('app_rqsError'));
						});
					}
				} else {
					return false;
				}
			});
		},
		fileUploadSuccess: function fileUploadSuccess(res, file) {
			if (res.status === 200) {
				this.form.pspAppUrl = res.fileUrl;
				this.form.pspAppSize = res.appSize;
				this.form.pspAppHash = res.md5;
				this.fileList = [{
					name: file.name
				}];
				this.upinfo_1 = false;
				this.tipColor_1 = {
					color: '#13CE66'
				};
			} else {
				this.upinfo_1 = true;
				this.form.pspAppUrl = "";
				this.form.pspAppSize = "";
				this.form.pspAppHash = "";
				this.fileList = [];
				this.$message.error(res.message);
				this.tipColor_1 = {
					color: '#FF4949'
				};
			}
		},
		fileUploadSuccesss: function fileUploadSuccesss(res, file) {
			if (res.status === 200) {
				this.form.cer1Url = res.fileUrl;
				this.form.cer1Size = res.appSize;
				this.form.cer1Hash = res.md5;
				this.fileLists = [{
					name: file.name
				}];
				this.upinfo_2 = false;
				this.tipColor_2 = {
					color: '#13CE66'
				};
			} else {
				this.upinfo_2 = true;
				this.form.cer1Url = "";
				this.form.cer1Size = "";
				this.form.cer1Hash = "";
				this.fileLists = [];
				this.$message.error(res.message);
				this.tipColor_2 = {
					color: '#FF4949'
				};
			}
		},
		fileUploadSuccessss: function fileUploadSuccessss(res, file) {
			if (res.status === 200) {
				this.form.cer2Url = res.fileUrl;
				this.form.cer2Size = res.appSize;
				this.form.cer2Hash = res.md5;
				this.fileListss = [{
					name: file.name
				}];
				this.upinfo_3 = false;
				this.tipColor_3 = {
					color: '#13CE66'
				};
			} else {
				this.upinfo_3 = true;
				this.form.cer2Url = "";
				this.form.cer2Size = "";
				this.form.cer2Hash = "";
				this.fileListss = [];
				this.$message.error(res.message);
				this.tipColor_3 = {
					color: '#FF4949'
				};
			}
		},
		fileBeforeUpload: function fileBeforeUpload(file) {},
		handleRemove_1: function handleRemove_1(file, fileList) {
			this.fileList = [];
			this.upinfo_1 = true;
			this.form.pspAppUrl = "";
			this.form.pspAppSize = "";
			this.form.pspAppHash = "";
		},
		handleRemove_2: function handleRemove_2(file, fileList) {
			this.fileLists = [];
			this.upinfo_2 = true;
			this.form.cer1Url = "";
			this.form.cer1Size = "";
			this.form.cer1Hash = "";
		},
		handleRemove_3: function handleRemove_3(file, fileList) {
			this.fileListss = [];
			this.upinfo_3 = true;
			this.form.cer2Url = "";
			this.form.cer2Size = "";
			this.form.cer2Hash = "";
		},
		handleRemoves: function handleRemoves(file, fileList) {
			if (this.fileLists.length > 1) {
				for (var i = 0; i < this.fileLists.length; i++) {
					if (file.uid == this.fileLists[i].uid) {
						if (i == 0) {
							this.form.cer1Url = this.form.cer1Url.split(",")[1];
							this.form.cer1Size = this.form.cer1Size.split(",")[1];
							this.form.cer1Hash = this.form.cer1Hash.split(",")[1];
						} else {
							this.form.cer1Url = this.form.cer1Url.split(",")[0];
							this.form.cer1Size = this.form.cer1Size.split(",")[0];
							this.form.cer1Hash = this.form.cer1Hash.split(",")[0];
						}
					}
				}
				this.fileLists = fileList;
			} else {
				this.form.cer1Url = "";
				this.form.cer1Size = "";
				this.form.cer1Hash = "";
				this.fileLists = [];
			}

			console.log(this.form);
			console.log(this.fileLists);
		},
		fillEdit: function fillEdit() {
			var data = this.config.data;
			this.form = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.config.data));
			this.fileList = [{
				name: this.form.pspAppUrl
			}];
			this.fileLists = this.form.cer1Url ? [{
				name: this.form.cer1Url
			}] : [];
			this.fileListss = this.form.cer2Url ? [{
				name: this.form.cer2Url
			}] : [];
			this.upinfo_1 = false;
			this.tipColor_1 = {
				color: '#13CE66'
			};
			this.upinfo_2 = this.form.cer1Url ? false : true;
			this.tipColor_2 = {
				color: '#13CE66'
			};
			this.upinfo_3 = this.form.cer2Url ? false : true;
			this.tipColor_3 = {
				color: '#13CE66'
			};

			console.log(this.fileLists);
		},
		cancel: function cancel() {
			this.$router.go(-1);
		},
		init: function init() {
			this.config = this.$getWObj().editChangePSPConfig;
			console.log('config', this.config);

			switch (this.config.type) {
				case 0:
					break;
				case 1:
					this.fillEdit();
					break;
			}
		}
	},
	mounted: function mounted() {}
});

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      mechanismId: window.localStorage['mechanismId'],
      tableData: [],
      info: '',
      total: 0,
      row: this.$gRow,
      page: 1,
      list: [],
      sNum: 0,
      raw: ''
    };
  },

  components: {},
  computed: {
    avt: function avt() {
      var url = this.info.appBigIcon ? this.$urls.prefix + this.info.appBigIcon : __webpack_require__(6);
      return url;
    },
    avtStyle: function avtStyle() {
      return 'background-size: cover;background-position: center center;width:100%;height:100%;background-image: url(' + this.avt + ')';
    },
    index: function index() {
      return this.$getWPage('appMarketPushPage');
    }
  },
  methods: {
    updateDv: function updateDv(row) {
      var _this = this;

      this.loading = 1;
      var cId = this.info.appdevid ? this.info.appdevid : this.info.applicationid;
      if (this.$appUrlTag === 0) {
        this.$bindApp('0', row.terminialId, cId, function (res) {
          _this.loading = 0;
          _this.$message(res.message);
          if (res.status === 200) {
            _this.getBinds(_this.page);
          }
        }, function () {
          _this.loading = 0;
        });
      } else {
        this.$bindApp1(this.mechanismId, row.terminalNo, cId, function (res) {
          _this.loading = 0;
          _this.$message(res.message);
          if (res.status === 200) {
            _this.getBinds(_this.page);
          }
        }, function () {
          _this.loading = 0;
        });
      }
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    },
    handleSelectionChange: function handleSelectionChange(list) {
      this.sNum = list.length;
      this.list = list;
    },
    allUnbind: function allUnbind() {
      var _this2 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_isUnbindApp'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        var ids = '';
        var tNos = '';
        _this2.list.forEach(function (vl) {
          ids += vl.terminialId + ',';
          tNos += vl.terminalNo + ',';
        });
        ids = ids.substring(0, ids.length - 1);
        tNos = tNos.substring(0, tNos.length - 1);

        if (!ids && !tNos) {
          _this2.$message($t('app_oneDeviceMust'));
          return;
        }
        _this2.unbindReq(ids, _this2.info.applicationid, tNos, _this2.info.packagename);
      }, '');
    },
    bindOperate: function bindOperate(row) {
      var _this3 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_isUnbindApp'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this3.unbindReq(row.terminialId, _this3.info.applicationid, row.terminalNo, _this3.info.packagename);
      }, '');
    },
    unbindReq: function unbindReq(tId, aId, tNo, pkg) {
      var _this4 = this;

      this.loading = 1;
      if (this.$appUrlTag === 0) {
        this.$bindApp('1', tId, aId, function (res) {
          _this4.loading = 0;
          if (res.status === 200) {
            _this4.getBinds(_this4.page);
          } else {
            _this4.$message.error(res.message);
          }
        }, function () {
          _this4.loading = 0;
        });
      } else {

        this.$unbind(tNo, pkg, function (res) {
          _this4.loading = 0;
          if (res.status === 200) {

            _this4.getBinds(_this4.page);
          } else {
            _this4.$message.error(res.message);
          }
        }, function () {
          _this4.loading = 0;
        });
      }
    },
    addBind: function addBind() {
      console.log(this.info);
      if (this.raw.type === 0) {
        this.$router.push({ path: 'terminalbind' });
      } else {
        this.$router.push({ path: 'terminal-bind' });
      }
    },
    getBinds: function getBinds(page) {
      var _this5 = this;

      this.loading = 1;
      if (this.$appUrlTag === 0) {
        var cId = this.info.appdevid ? this.info.appdevid : this.info.applicationid;
        consolelog('iiif', this.info);
        this.$getAppBindDevices(this.$gRow, 1, this.info.packagename, cId, this.mechanismId, function (res) {
          _this5.loading = 0;
          if (res.status === 200) {
            console.log(res);
            _this5.tableData = res.data;
            _this5.total = res.total;
            _this5.page = page;
          } else {
            _this5.$message.error(res.message);
          }
        }, function () {
          _this5.loading = 0;
        });
      } else {
        var cId = this.info.appdevid ? this.info.appdevid : this.info.applicationid;
        this.$getAppBindDevices1(this.$gRow, 1, this.info.packagename, cId, this.mechanismId, function (res) {
          _this5.loading = 0;
          if (res.status === 200) {
            console.log(res);
            _this5.tableData = res.data;
            _this5.total = res.total;
            _this5.page = page;
          } else {
            _this5.$message.error(res.message);
          }
        }, function () {
          _this5.loading = 0;
        });
      }
    },
    pageSelect: function pageSelect(index) {
      this.getBinds(index);
      this.$setWPage('appMarketPushPage', index);
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getBinds(this.index);
    }
  },
  mounted: function mounted() {
    var obj = this.$getWObj().appBindInfo;
    this.info = obj.data;
    this.raw = obj;
    this.getBinds(this.page);
  }
});

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		MechanismSelector: __WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue___default.a
	},
	data: function data() {
		return {
			mechanismData: '',
			orderName: '',
			orderType: '',
			appvst: '',
			pkg: '',
			cerDialogVisible: false,
			cerTipDialogVisible: false,
			dvLoading: 0,
			appId: "",
			stModel: [{
				label: this.$t("app_online"),
				vl: "1"
			}, {
				label: this.$t("app_offline"),
				vl: "2"
			}, {
				label: this.$t("app_new"),
				vl: "0"
			}],
			channels: [],
			sNum: 0,
			cleanMode: false,
			multipleSelection: [],
			tempSelect: [],
			srchValue: "",
			channelId: "",
			cerTipMsg: "",
			status: "",
			dvIndex: 1,
			dialogVisible: 0,
			mechanismId: window.localStorage["mechanismId"],
			mechId: '',
			tableData: [],
			dvTableData: [],
			appTypes: [],
			appTypeValue: "",

			appvStatus: [{
				label: this.$t("app_prePushVerify"),
				value: "0"
			}, {
				label: this.$t("app_preVerify"),
				value: "1"
			}, {
				label: this.$t("app_verifyPass"),
				value: "2"
			}, {
				label: this.$t("app_verifyNotPass"),
				value: "3"
			}],

			appStatusValue: "",
			total: 0,
			dvTotal: 0,
			loading: 0,
			appType: "",
			queryKey: ""
		};
	},

	computed: {
		index: function index() {
			return this.$getWPage("appPage");
		}
	},
	methods: {
		sortChange: function sortChange(vl) {
			switch (vl.prop) {
				case 'appName':
					this.orderName = '1';
					break;
				case 'createTime':
					this.orderName = '2';
					break;
			}
			this.orderType = vl.order == 'descending' ? 'desc' : 'asc';
			this.getAppList();
		},
		editApp: function editApp(row) {
			this.$setWObj("editAppConfig", {
				data: row,
				type: 1
			});
			this.$router.push({
				path: '/applist/edit'
			});
		},
		toggleSelection: function toggleSelection(rows) {
			var _this2 = this;

			if (rows) {
				rows.forEach(function (row) {
					_this2.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		handleSelectionChange: function handleSelectionChange(val) {

			this.sNum = val.length;
			this.tempSelect = val;

			if (val.length > 5) {
				this.$message(this.$t('app_pushnumcantfive'));
				return;
			}

			if (!this.selectedAppLegal()) {
				this.$message(this.$t('app_selectedappshoupass'));
				return;
			}
		},
		selectedAppLegal: function selectedAppLegal() {
			var ishit = false;
			this.tempSelect.forEach(function (vl) {
				if (vl.appStatus != '2') {
					ishit = true;
					return true;
				}
			});
			return !ishit;
		},
		batchPush: function batchPush() {

			if (this.tempSelect.length > 5) {
				this.$message(this.$t('app_pushnumcantfive'));
			} else if (!this.selectedAppLegal()) {
				this.$message(this.$t('app_selectedappshoupass'));
			} else {
				this.$setWObj("pushList", {
					data: this.tempSelect,
					type: "1"
				});
				this.$router.push({
					path: "/appList/pushapp"
				});
			}
		},
		pushCreateCer: function pushCreateCer() {
			this.$router.push({
				path: "/certificate/new"
			});
		},
		pushUploadCer: function pushUploadCer() {
			this.$router.push({
				path: "/certificate/upload"
			});
		},
		bindOperate: function bindOperate(row) {
			var _this3 = this;

			this.dvLoading = 1;
			if (this.$appUrlTag === 0) {
				this.$bindApp("0", row.terminalNo, this.appId, function (res) {
					if (res.status === 200) {
						_this3.$message.success(_this3.$t("app_tipViewTask"));
					} else {
						_this3.$message.error(res.message);
					}
					_this3.dvLoading = 0;
				}, function () {
					_this3.dvLoading = 0;
				});
			} else {
				this.$bindApp1(this.mechanismId, row.terminalNo, this.appId, function (res) {
					if (res.status === 200) {
						_this3.$message.success(_this3.$t("app_tipViewTask"));
					} else {
						_this3.$message.error(res.message);
					}
					_this3.dvLoading = 0;
				}, function () {
					_this3.dvLoading = 0;
				});
			}
		},
		getChannels: function getChannels() {
			var _this4 = this;

			this.$getChannelList(10000, 1, '', '', '', function (res) {
				if (res.status === 200) {
					_this4.channels = res.data;
				} else {
					_this4.$message.error(res.message);
				}
			}, function () {
				_this4.$message.error(_this4.$t("app_rqsError"));
			});
		},
		getStatus: function getStatus(value) {
			switch (value) {
				case "0":
					return {
						vl: this.$t("app_prePushVerify"), style: "color:#8492A6;"
					};
				case "1":
					return {
						vl: this.$t("app_preVerify"), style: "color:#F7BA2A;"
					};
				case "2":
					return {
						vl: this.$t("app_verifyPass"), style: "color:#13CE66;"
					};
				case "3":
					return {
						vl: this.$t("app_verifyNotPass"), style: "color:#FF4949;"
					};
			}
		},
		srchDevice: function srchDevice() {
			this.getDevices();
		},
		selectDvChange: function selectDvChange(vl) {
			this.getDevices();
		},
		pageDvSized: function pageDvSized(val) {
			this.$gRow = val;
			this.getDevices();
		},
		getDevices: function getDevices() {
			var _this5 = this;

			var vl = this.srchValue ? this.srchValue : "";
			var channel = this.channelId ? this.channelId : "";
			var status = this.status ? this.status : "";
			var appId = this.appId ? this.appId : "";
			this.dvLoading = 1;
			if (this.$appUrlTag === 0) {
				this.$getDevices(this.dvIndex, this.$gRow, channel, vl, status, "", appId, function (res) {
					_this5.dvLoading = 0;
					if (res.data) {
						_this5.dvTableData = res.data;
						_this5.dvTotal = res.total;
					}
				}, function () {
					_this5.dvLoading = 0;
				});
			} else {
				this.$getDevices1(this.dvIndex, this.$gRow, this.mechanismId, vl, status, "", appId, function (res) {
					console.log("dv", res);
					_this5.dvLoading = 0;
					if (res.data) {
						_this5.dvTableData = res.data;
						_this5.dvTotal = res.total;
					}
				}, function () {
					_this5.dvLoading = 0;
				});
			}
		},
		pushApp: function pushApp(row) {

			this.$setWObj("pushList", {
				data: row,
				type: "1"
			});
			this.$router.push({
				path: "/appList/pushapp"
			});
		},
		query: function query() {
			this.getAppList();
		},
		selectChange: function selectChange(vl) {
			this.getAppList();
		},
		reset: function reset() {
			this.queryKey = "";
			this.appType = "";
			this.getAppList();
		},
		pageSelect: function pageSelect(index) {
			this.$setWPage("appPage", index);
			this.getAppList();
		},
		pageDvSelect: function pageDvSelect(index) {
			this.dvIndex = index;
			this.getDevices();
		},
		pageSized: function pageSized(val) {
			this.$gRow = val;
			this.getAppList();
		},
		deleteApp: function deleteApp(obj) {
			var _this6 = this;

			this.$showConfirm(this.$t("app_tip"), this.$t("app_tipMkDel"), this.$t("app_sure"), this.$t("app_cancel"), "warning", function () {
				if (_this6.$appUrlTag === 0) {
					_this6.$deleteApp(obj.applicationid, function (res) {
						if (res.status === 200) {
							_this6.getAppList();
						} else {
							_this6.$message(res.message);
						}
					}, "");
				} else {
					_this6.$deleteApp1(obj.applicationid, function (res) {
						if (res.status === 200) {
							_this6.getAppList();
						} else {
							_this6.$message(res.message);
						}
					}, "");
				}
			}, "");
		},
		submitApp: function submitApp(obj) {
			var _this7 = this;

			this.$showConfirm(this.$t("app_tip"), this.$t("app_tipVerify"), this.$t("app_sure"), this.$t("app_cancel"), "warning", function () {
				_this7.loading = 1;
				if (_this7.$appUrlTag === 0) {
					_this7.$submitVerifyApp(obj.applicationid, function (res) {
						_this7.loading = 0;
						if (res.status === 200) {
							_this7.getAppList();
						} else {
							_this7.$message.error(res.message);
						}
					}, function () {
						_this7.loading = 0;
					});
				} else {
					_this7.$submitVerifyApp1(obj.applicationid, function (res) {
						_this7.loading = 0;
						if (res.status === 200) {
							_this7.getAppList();
						} else {
							_this7.$message.error(res.message);
						}
					}, function () {
						_this7.loading = 0;
					});
				}
			}, "");
		},
		cellClick: function cellClick(row, ev, col) {
			var label = col.label;
			if (!label) return;
			if (label === this.$t("app_operate")) {
				return;
			} else {

					this.$setWObj("appDisplay", {
						appid: row.applicationid,
						mech: row.distributorId
					});
					this.$router.push({
						path: '/applist/display'
					});
				}
		},
		jumpToUpload: function jumpToUpload() {
			var _this8 = this;

			if (localStorage.cerType === '2') {
				this.$setWObj("editAppConfig", {
					type: 0
				});
				this.$router.push({
					path: '/appList/upload'
				});
				return;
			}

			this.loading = 1;
			this.$isCer(this.mechanismId, function (res) {
				_this8.loading = 0;

				if (!res.data) {
					_this8.$setWObj("editAppConfig", {
						type: 0
					});
					_this8.$router.push({
						path: 'appList/upload'
					});
				} else {
					_this8.cerTipMsg = res.message;
					var vl = localStorage.cerType;
					if (vl === "0") {
						_this8.cerDialogVisible = true;
					} else {
						_this8.cerTipDialogVisible = true;
					}
				}
			}, function () {});
		},
		getAppList: function getAppList(isRfType) {
			var _this9 = this;

			this.loading = 1;
			var type = this.appType.length > 0 ? this.appType[0] : "";
			var name = this.queryKey ? this.queryKey : "";
			var mcId = this.mechId ? this.mechId : '';

			if (isRfType) {
				var _this = this;
				this.$gpAppType(mcId, function (res) {
					if (res.data.length > 0) {
						_this.appTypes = res.data[0].children;
					}
				});
			}

			var appvst = this.appvst;
			this.$getAppList1(this.$gRow, this.$getWPage("appPage"), mcId, type, name, appvst, this.orderName, this.orderType, this.pkg ? this.pkg : '', function (res) {
				console.log(res);
				_this9.loading = 0;
				if (res.status === 200) {
					_this9.total = res.total;
					_this9.tableData = res.data;
				} else {
					_this9.$message(res.message);
				}
			}, function () {
				_this9.loading = 0;
				_this9.$message.error(_this9.$t("app_rqsError"));
			});
		},
		dateFormat: function dateFormat(row, column) {
			var date = row[column.property];
			if (date === undefined) {
				return "";
			}
			return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format("YYYY-MM-DD HH:mm:ss");
		},
		setInstallType: function setInstallType(type) {
			return this.$installType[type];
		}
	},
	mounted: function mounted() {
		var _this = this;
		this.mechanismData = {
			callback: function callback(value) {
				_this.mechId = value;
				_this.getAppList(true);
			}
		};

		this.getAppList(true);
	},
	destroyed: function destroyed() {}
});

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_df_png__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_df_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_df_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_tyc__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_tyc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_tyc__);






/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			total: 0,
			queryKey: '',
			terminalNo: "",
			sNum: 0,
			page: 1,
			tableData1: [],
			tableData: [],
			list: [],
			pushedList: false,
			tqobj: '',
			dobj: '',
			vSt: '',
			config: '',
			captures: [],
			loading: 0,
			iconUrl: '',
			app_detail: {}
		};
	},

	components: {
		tyc: __WEBPACK_IMPORTED_MODULE_3__components_global_tyc___default.a
	},
	computed: {
		avtStyle: function avtStyle() {
			var url = this.iconUrl ? this.imgFullUrl(this.iconUrl) : __webpack_require__(6);

			return 'background-size: cover;background-position: center center;width:100%;height:100%;background-image: url(' + url + ')';
		}
	},
	methods: {
		dateFormat: function dateFormat(row, column) {
			var date = row[column.property];
			if (date === undefined) {
				return "";
			}
			return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format("YYYY-MM-DD HH:mm:ss");
		},
		pageSelect: function pageSelect(index) {
			this.$setWPage("appPage", index);
			this.getAppList();
		},
		pageSized: function pageSized(val) {
			this.$gRow = val;
			this.getAppList();
		},
		getAppList: function getAppList() {
			var _this = this;

			this.loading = 1;
			this.$pspUpdateList({
				page: this.$getWPage("appPage"),
				rows: this.$gRow,
				fileId: this.app_detail.id,
				terminalNo: this.terminalNo
			}, function (res) {
				_this.loading = 0;
				if (res.status === 200) {
					_this.total = res.total;
					_this.tableData = res.data;
				} else {
					_this.$message.error(res.message);
				}
			}, function () {
				_this.loading = 0;
			});
		}
	},
	created: function created() {
		this.config = this.$getWObj().pspDetail;
		this.app_detail = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.config.data));
		console.log(this.app_detail);
		this.getAppList();
	}
});

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_tyc__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_tyc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_global_tyc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_tagc__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_tagc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_tagc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_global_mechanism_selector_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		tyc: __WEBPACK_IMPORTED_MODULE_2__components_global_tyc___default.a,
		tagc: __WEBPACK_IMPORTED_MODULE_3__components_global_tagc___default.a,
		MechanismSelector: __WEBPACK_IMPORTED_MODULE_4__components_global_mechanism_selector_vue___default.a
	},
	data: function data() {
		var _this2 = this;

		var dstCheck = function dstCheck(rule, value, callback) {
			if (!value) {
				callback(new Error(_this2.$t('app_select')));
			} else {
				callback();
			}
		};
		var tagCheck = function tagCheck(rule, value, callback) {
			if (!value) {
				callback(new Error(_this2.$t('noVerTag')));
			} else {
				callback();
			}
		};
		var that = this;
		return {
			mechanismData1: {
				callback: function callback(value) {
					that.channelId = value;
					that.getDevices();
				}
			},
			tqobj: '',
			ulinfo: {
				tip: this.$t('app_ulAppState_2'),
				index: 0,
				icons: ['el-icon-upload', 'el-icon-circle-check fs-icon', 'el-icon-close fs-icon']
			},
			mechanismId: window.localStorage['mechanismId'],
			status: '',

			stModel: '',
			channels: [],
			channelId: '',
			sysType_list: [{
				label: "RTOS",
				value: "0"
			}, {
				label: "Linux",
				value: "1"
			}, {
				label: "LiteOS",
				value: "2"
			}],
			rules: {
				appId: [{
					required: true,
					message: this.$t('app_input'),
					trigger: 'blur'
				}],
				fileName: [{
					required: true,
					message: this.$t('app_inputName'),
					trigger: 'blur'
				}],
				sysType: [{
					required: true,
					message: this.$t('app_select'),
					trigger: 'change'
				}],
				appVersion: [{
					required: true,
					message: this.$t('app_inputVer'),
					trigger: 'blur'
				}],
				verTag: [{
					required: true,
					message: this.$t('app_inputVerTag'),
					trigger: 'blur',
					validator: tagCheck
				}],
				packageName: [{
					required: true,
					message: this.$t('app_inputPkg'),
					trigger: 'blur'
				}],
				memo: [{
					required: true,
					message: this.$t('app_inputIntrol'),
					trigger: 'blur'
				}],
				distributorId: [{
					required: true,
					message: this.$t('app_select'),
					trigger: 'blur'
				}],
				appTypeValue: [{
					required: true,
					message: this.$t('app_select'),
					trigger: 'blur',
					validator: dstCheck
				}],
				appUrl: [{
					required: true,
					message: this.$t('app_ulApp'),
					trigger: 'blur'
				}]
			},
			upinfo_1: true,
			upinfo_2: true,
			upinfo_3: true,
			tipColor_1: {
				color: '#13CE66'
			},
			tipColor_2: {
				color: '#13CE66'
			},
			tipColor_3: {
				color: '#13CE66'
			},
			form: {
				fileName: '',
				memo: '',
				appUrl: '',
				appSize: "",
				appHash: '',
				cerUrl: "",
				cerSize: "",
				cerHash: "",
				cerUrl1: "",
				cerSize1: "",
				cerHash1: "",
				sysType: ""
			},
			showPic: {
				value: 0,
				data: ''
			},
			srchValue: '',
			installTypes: [{
				label: this.$t('app_autoInstall'),
				value: 0
			}],
			fileSize: 0,
			tableData: [],
			checkDesc: '',
			radio: '1',
			smImageUrl: '',
			bgImageUrl: '',
			dialogVisible: false,
			appTypes: [],
			loading: 0,
			loading1: 0,
			loadingBig: 0,
			loadingSm: 0,
			config: {},
			cp0: '',
			cp1: '',
			cp2: '',
			cp3: '',
			cp4: '',
			captures: [],
			fileList: [],
			fileLists: [],
			fileListss: [],
			isUpload: 0,
			index: 1,
			total: 0,
			file_id: 0
		};
	},

	computed: {
		uData: function uData() {
			return {
				token: 1234
			};
		},
		fileUploadUrl: function fileUploadUrl() {
			var vl = this.$urls.webUrl + "/tms-server-web/file/fileupload.do";
			return vl;
		}
	},
	created: function created() {
		this.init();
	},

	methods: {
		editApp: function editApp(row) {},
		selectChange: function selectChange(vl) {
			this.getDevices();
		},
		getChannels: function getChannels() {
			var _this3 = this;

			var _this = this;
			this.$getChannelList(10000, 1, '', '', '', function (res) {
				if (res.status === 200) {
					_this.channels = res.data;
				} else {
					_this3.$message.error(res.message);
				}
			}, function () {
				_this3.$message.error(_this3.$t('app_rqsError'));
			});
		},
		getStatus: function getStatus(value) {
			switch (value) {
				case '0':
					return this.$t('app_prePushVerify');
				case '1':
					return this.$t('app_preVerify');
				case '2':
					return this.$t('app_verifyPass');
				case '3':
					return this.$t('app_verifyNotPass');
			}
		},
		pageSelect: function pageSelect(index) {
			this.index = index;
			this.getDevices();
		},
		pageSized: function pageSized(val) {
			this.$gRow = val;
			this.getDevices();
		},
		hBlur: function hBlur(name) {
			this.$refs[name].validate(function (valid) {
				if (valid) {} else {
					return false;
				}
			});
		},
		dateFormat: function dateFormat(row, column) {
			var date = row[column.property];
			if (date === undefined) {
				return '';
			}
			return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD hh:mm:ss');
		},
		deleteCapture0: function deleteCapture0() {
			this.cp0 = '';
			this.cp0Value = '';
		},
		deleteCapture1: function deleteCapture1() {
			this.cp1 = '';
			this.cp1Value = '';
		},
		deleteCapture2: function deleteCapture2() {
			this.cp2 = '';
			this.cp2Value = '';
		},
		deleteCapture3: function deleteCapture3() {
			this.cp3 = '';
			this.cp3Value = '';
		},
		deleteCapture4: function deleteCapture4() {
			this.cp4 = '';
			this.cp4Value = '';
		},
		imgFullUrl: function imgFullUrl(path) {
			if (path) {
				return this.$urls.prefix + path;
			} else {
				return '';
			}
		},
		close: function close() {
			this.$router.go(-1);
		},
		isShowCommon: function isShowCommon(isShow) {
			if (isShow && (this.config.type === 2 || this.config.type === 3)) {
				return 1;
			} else if (!isShow && this.config.type !== 2 && this.config.type !== 3) {
				return 1;
			} else {
				return 0;
			}
		},
		uploadApp: function uploadApp(formName) {
			var _this4 = this;

			this.$refs[formName].validate(function (valid) {
				if (valid) {
					_this4.loading = 1;
					if (_this4.config.type === 1) {
						_this4.$editPsp(_this4.form, function (res) {
							console.log(res);
							_this4.loading = 0;
							if (res.status === 200) {
								_this4.$router.go(-1);
							} else {
								_this4.$message(res.message);
							}
						}, function () {
							_this4.loading = 0;
							_this4.$message(_this4.$t('app_rqsError'));
						});
					} else {
						_this4.$addPsp(_this4.form, function (res) {
							console.log(res);
							_this4.loading = 0;
							if (res.status === 200) {
								_this4.$router.go(-1);
							} else {
								_this4.$message(res.message);
							}
						}, function () {
							_this4.loading = 0;
							_this4.$message(_this4.$t('app_rqsError'));
						});
					}
				} else {
					return false;
				}
			});
		},
		fileUploadSuccess: function fileUploadSuccess(res, file) {
			if (res.status === 200) {
				this.form.appUrl = res.fileUrl;
				this.form.appSize = res.appSize;
				this.form.appHash = res.md5;
				this.fileList = [{
					name: file.name
				}];
				this.upinfo_1 = false;
				this.tipColor_1 = {
					color: '#13CE66'
				};
			} else {
				this.upinfo_1 = true;
				this.form.appUrl = "";
				this.form.appSize = "";
				this.form.appHash = "";
				this.fileList = [];
				this.$message.error(res.message);
				this.tipColor_1 = {
					color: '#FF4949'
				};
			}
		},
		fileUploadSuccesss: function fileUploadSuccesss(res, file) {
			if (res.status === 200) {
				this.form.cerUrl = res.fileUrl;
				this.form.cerSize = res.appSize;
				this.form.cerHash = res.md5;
				this.fileLists = [{
					name: file.name
				}];
				this.upinfo_2 = false;
				this.tipColor_2 = {
					color: '#13CE66'
				};
			} else {
				this.upinfo_2 = true;
				this.form.cerUrl = "";
				this.form.cerSize = "";
				this.form.cerHash = "";
				this.fileLists = [];
				this.$message.error(res.message);
				this.tipColor_2 = {
					color: '#FF4949'
				};
			}
		},
		fileUploadSuccessss: function fileUploadSuccessss(res, file) {
			if (res.status === 200) {
				this.form.cerUrl1 = res.fileUrl;
				this.form.cerSize1 = res.appSize;
				this.form.cerHash1 = res.md5;
				this.fileListss = [{
					name: file.name
				}];
				this.upinfo_3 = false;
				this.tipColor_3 = {
					color: '#13CE66'
				};
			} else {
				this.upinfo_3 = true;
				this.form.cerUrl1 = "";
				this.form.cerSize1 = "";
				this.form.cerHash1 = "";
				this.fileListss = [];
				this.$message.error(res.message);
				this.tipColor_3 = {
					color: '#FF4949'
				};
			}
		},
		fileBeforeUpload: function fileBeforeUpload(file) {},
		handleRemove_1: function handleRemove_1(file, fileList) {
			this.fileList = [];
			this.upinfo_1 = true;
			this.form.appUrl = "";
			this.form.appSize = "";
			this.form.appHash = "";
		},
		handleRemove_2: function handleRemove_2(file, fileList) {
			this.fileLists = [];
			this.upinfo_2 = true;
			this.form.cerUrl = "";
			this.form.cerSize = "";
			this.form.cerHash = "";
		},
		handleRemove_3: function handleRemove_3(file, fileList) {
			this.fileListss = [];
			this.upinfo_3 = true;
			this.form.cerUrl1 = "";
			this.form.cerSize1 = "";
			this.form.cerHash1 = "";
		},
		handleRemoves: function handleRemoves(file, fileList) {
			if (this.fileLists.length > 1) {
				for (var i = 0; i < this.fileLists.length; i++) {
					if (file.uid == this.fileLists[i].uid) {
						if (i == 0) {
							this.form.cerUrl = this.form.cerUrl.split(",")[1];
							this.form.cerSize = this.form.cerSize.split(",")[1];
							this.form.cerHash = this.form.cerHash.split(",")[1];
						} else {
							this.form.cerUrl = this.form.cerUrl.split(",")[0];
							this.form.cerSize = this.form.cerSize.split(",")[0];
							this.form.cerHash = this.form.cerHash.split(",")[0];
						}
					}
				}
				this.fileLists = fileList;
			} else {
				this.form.cerUrl = "";
				this.form.cerSize = "";
				this.form.cerHash = "";
				this.fileLists = [];
			}

			console.log(this.form);
			console.log(this.fileLists);
		},
		fillEdit: function fillEdit() {
			var data = this.config.data;
			this.form = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.config.data));
			this.fileList = [{
				name: this.form.appUrl
			}];
			this.fileLists = this.form.cerUrl ? [{
				name: this.form.cerUrl
			}] : [];
			this.fileListss = this.form.cerUrl1 ? [{
				name: this.form.cerUrl1
			}] : [];
			this.upinfo_1 = false;
			this.tipColor_1 = {
				color: '#13CE66'
			};
			this.upinfo_2 = this.form.cerUrl ? false : true;
			this.tipColor_2 = {
				color: '#13CE66'
			};
			this.upinfo_3 = this.form.cerUrl1 ? false : true;
			this.tipColor_3 = {
				color: '#13CE66'
			};

			console.log(this.fileLists);
		},
		cancel: function cancel() {
			this.$router.go(-1);
		},
		verify: function verify() {
			var _this5 = this;

			this.loading = 1;
			var id = this.config.data.applicationid;
			var passValue = this.radio === '1' ? '2' : '3';
			var desc = this.checkDesc;
			if (this.$appUrlTag === 0) {
				this.$verifyApp(localStorage.user, id, passValue, desc, function (res) {
					_this5.loading = 0;
					if (res.status === 200) {
						_this5.$router.go(-1);
					} else {
						_this5.$message.error(res.message);
					}
				}, function () {
					_this5.loading = 0;
					_this5.$message.error(_this5.$t('app_rqsError'));
				});
			} else {
				this.$verifyApp1(this.mechanismId, localStorage.user, id, passValue, desc, function (res) {
					_this5.loading = 0;
					if (res.status === 200) {
						_this5.$router.go(-1);
					} else {
						_this5.$message.error(res.message);
					}
				}, function () {
					_this5.loading = 0;
					_this5.$message.error(_this5.$t('app_rqsError'));
				});
			}
		},
		init: function init() {
			this.config = this.$getWObj().editPSPConfig;
			console.log('config', this.config);

			switch (this.config.type) {
				case 0:
					break;
				case 1:
					this.fillEdit();
					break;
			}
		},
		getDevices: function getDevices() {
			var _this6 = this;

			var vl = this.srchValue ? this.srchValue : '';
			var channel = this.channelId ? this.channelId : '';
			var status = this.status ? this.status : '';
			this.loading = 1;
			if (this.$appUrlTag === 0) {
				this.$getDevices(this.index, this.$gRow, channel, vl, status, '', this.config.data.applicationid, function (res) {
					console.log('dv', res);
					_this6.loading = 0;
					if (res.data) {
						_this6.tableData = res.data;
						_this6.total = res.total;
					}
				}, function () {
					_this6.loading = 0;
				});
			} else {
				this.$getDevices1(this.index, this.$gRow, channel, vl, status, '', this.config.data.applicationid, function (res) {
					console.log('dv', res);
					_this6.loading = 0;
					if (res.data) {
						_this6.tableData = res.data;
						_this6.total = res.total;
					}
				}, function () {
					_this6.loading = 0;
				});
			}
		},
		bindOperate: function bindOperate(row) {
			this.bind(row.terminalId, row.terminalNo, row.manufId);
		},
		bind: function bind(tId, tNo, mId) {
			var _this7 = this;

			this.loading = 1;
			if (this.$appUrlTag === 0) {
				this.$bindApp('0', tId, this.config.data.applicationid, function (res) {
					if (res.status === 200) {
						_this7.$message.success(res.message);
					} else {
						_this7.$message.error(res.message);
					}
					_this7.loading = 0;
				}, function () {
					_this7.loading = 0;
				});
			} else {
				this.$verifyAppPush(mId, tNo, this.config.data.applicationid, function (res) {
					if (res.status === 200) {
						_this7.$message.success(res.message);
					} else {
						_this7.$message.error(res.message);
					}
					_this7.loading = 0;
				}, function () {
					_this7.loading = 0;
				});
			}
		},
		srchDevice: function srchDevice() {
			this.getDevices();
		}
	},
	mounted: function mounted() {}
});

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_tyc__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_tyc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_global_tyc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_tagc__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_tagc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_tagc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_url__ = __webpack_require__(3);








/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		MechanismSelector: __WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue___default.a,
		tyc: __WEBPACK_IMPORTED_MODULE_2__components_global_tyc___default.a,
		tagc: __WEBPACK_IMPORTED_MODULE_3__components_global_tagc___default.a
	},
	data: function data() {
		var that = this;
		return {
			downTpl: __WEBPACK_IMPORTED_MODULE_4__api_url__["b" /* urlAssets */].prefix + 'tms-server-web/model/terminalNos.xlsx',
			uldata: '',
			formLabelWidth: '28.5%',
			pushImport: false,
			fileList: [],
			cmtStatusArr: [],
			activeName: this.$t('psp_app_manage'),
			mechanismData: {
				value: null,
				placeholder: that.$t('lin_global.place_areaid'),
				callback: function callback(value) {
					that.mech = value;
					that.getCmDv();
				}
			},

			isNon: false,
			mech: "",
			deviceList: [],
			deviceTotal: 0,
			select_device: [],
			tqobj: '',
			device_loading: false,
			mechanismDatas: {
				value: null,
				placeholder: that.$t('lin_global.place_areaid'),
				callback: function callback(value) {
					that.uninsatll_form.mechId = value;
					that.getUnstallList();
				}
			},

			sstatus: {
				'0': this.$t('app_new'),
				'1': this.$t('app_enable')
			},
			uninstallData: [],
			uninstallTotal: 0,
			uninsatll_form: {
				page: 1,
				rows: 10,
				terminalNo: "",
				mechId: ""
			},
			orderName: '',
			orderType: '',
			appvst: '',
			pkg: '',
			cerDialogVisible: false,
			cerTipDialogVisible: false,
			dvLoading: 0,
			appId: "",
			stModel: [{
				label: this.$t("app_online"),
				vl: "1"
			}, {
				label: this.$t("app_offline"),
				vl: "2"
			}, {
				label: this.$t("app_new"),
				vl: "0"
			}],
			channels: [],
			sNum: 0,
			cleanMode: false,
			multipleSelection: [],
			tempSelect: [],
			srchValue: "",
			channelId: "",
			cerTipMsg: "",
			status: "",
			dvIndex: 1,
			dialogVisible: 0,
			mechanismId: window.localStorage["mechanismId"],
			mechId: '',
			tableData: [],
			dvTableData: [],
			appTypes: [],
			appTypeValue: "",

			appvStatus: [{
				label: this.$t("app_prePushVerify"),
				value: "0"
			}, {
				label: this.$t("app_preVerify"),
				value: "1"
			}, {
				label: this.$t("app_verifyPass"),
				value: "2"
			}, {
				label: this.$t("app_verifyNotPass"),
				value: "3"
			}],
			sstatusAr: [{
				vl: '',
				lb: this.$t('app_all')
			}, {
				vl: '0',
				lb: this.$t('app_new')
			}, {
				vl: '1',
				lb: this.$t('app_enable')
			}],

			appStatusValue: "",
			total: 0,
			dvTotal: 0,
			loading: 0,
			appType: "",
			queryKey: "",
			fileName: "",
			show_push: false,
			select_form: {
				page: 1,
				rows: 20,
				areaid: "",
				snBegin: "",
				snEnd: "",
				terminal_status: "",
				terminal_no: ""
			}
		};
	},

	computed: {
		index: function index() {
			return this.$getWPage("appPage");
		}
	},
	methods: {
		beforeRemove: function beforeRemove() {
			this.fileList = [];
			this.uldata = '';
		},
		srcBefore: function srcBefore(file) {
			if (this.uldata.fileNo) {
				return false;
			}

			var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
			var extension = testmsg === "xls";
			var extension2 = testmsg === "xlsx";
			if (!extension && !extension2) {
				this.$message({
					message: this.$t("IncorrectaFormat"),
					type: "warning"
				});
			}
			return extension || extension2;
		},
		srcSuccess: function srcSuccess(res, file) {
			window[this.$route.path] = '';

			if (res.status === 200) {
				this.uldata = res.data;

				this.$message.success(res.message);
			} else {
				this.$message.error(res.message);
			}
		},
		ulError: function ulError() {
			window[this.$route.path] = '';
		},
		ulurl: function ulurl() {
			var url = this.$fileExcelUlUrl + '?token=' + localStorage.user + '&language=' + localStorage.system_lang;

			return url;
		},
		submitUpload: function submitUpload() {
			var _this2 = this;

			this.loading = true;
			this.$pspUninstImport('', this.uldata.fileNo, '', function (res) {
				_this2.loading = false;
				if (res.status === 200) {
					_this2.$message.success(res.message);
				} else {
					_this2.$message.error(res.message);
				}
			}, function () {
				_this2.loading = false;
			});
			this.fileList = [];
			this.uldata = '';
			this.getAppList();
			this.pushImport = false;
		},
		open_import: function open_import() {
			this.pushImport = true;
		},
		closeImport: function closeImport() {
			this.pushImport = false;
			this.fileList = [];
			this.uldata = '';
		},
		addTer: function addTer() {
			this.pushImport = true;
		},
		handleSelectionChangeDevice: function handleSelectionChangeDevice(val) {
			this.select_device = val;
		},
		open_push: function open_push() {
			this.show_push = true;
			this.getCmDv();
		},
		handleClose: function handleClose() {
			this.show_push = false;
			this.select_form = {
				page: 1,
				rows: 20,
				areaid: "",
				snBegin: "",
				snEnd: "",
				terminal_status: "",
				terminal_no: ""
			};
			var that = this;
			that.mech = "";
			this.mechanismData = {
				value: null,
				placeholder: that.$t('lin_global.place_areaid'),
				callback: function callback(value) {
					that.mech = value;
					that.getCmDv();
				}
			};
		},
		bcPush: function bcPush() {
			var _this3 = this;

			var terminalNo_list = [];
			var mechId_list = [];
			var mechName_list = [];
			this.select_device.forEach(function (obj) {
				terminalNo_list.push(obj.terminalNo);
				mechId_list.push(obj.mechanismId);
				mechName_list.push(obj.mechName);
			});

			var tip = this.$t('app_surepsxdv').replace('{num}', this.select_device.length);

			this.$showConfirm(this.$t('app_tip'), tip + ' ?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
				var sub_form = {
					terminalNo: String(terminalNo_list),
					mechId: String(mechId_list),
					mechName: String(mechName_list)
				};
				_this3.device_loading = true;
				_this3.$pspUnPush(sub_form, function (res) {
					_this3.device_loading = false;
					if (res.status === 200) {
						_this3.$message.success(res.message);
						_this3.show_push = false;
						_this3.getUnstallList();
					} else {
						_this3.$message.error(res.message);
					}
				}, function () {
					_this3.device_loading = false;
				});
			}, '');
		},
		pushAll: function pushAll() {
			var _this4 = this;

			this.$showConfirm(this.$t('app_tip'), this.$t('app_ispushalldv') + ' ?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
				_this4.select_form.areaid = _this4.mech;
				console.log(_this4.select_form);
				console.log("推送全部");
			}, '');
		},
		pushed: function pushed(row) {
			var _this5 = this;

			this.$showConfirm(this.$t('app_tip'), this.$t('app_srpush') + ' ' + row.terminalNo + ' ?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
				console.log(row);
				var sub_form = {
					terminalNo: row.terminalNo,
					mechId: row.mechanismId,
					mechName: row.mechName
				};
				_this5.device_loading = true;
				_this5.$pspUnPush(sub_form, function (res) {
					_this5.device_loading = false;
					if (res.status === 200) {
						_this5.$message.success(res.message);
						_this5.show_push = false;
						_this5.getUnstallList();
					} else {
						_this5.$message.error(res.message);
					}
				}, function () {
					_this5.device_loading = false;
				});
			}, '');
		},
		pageSizedDevice: function pageSizedDevice(vl) {
			this.select_form.rows = vl;
			this.getCmDv();
		},
		pageSelectDevice: function pageSelectDevice(vl) {
			this.select_form.page = vl;
			this.getCmDv();
		},
		getCmDv: function getCmDv() {
			var _this = this;
			var typeKey = 'terminalTypes';
			this.tqobj = {
				keys: [typeKey],
				callback: function callback(data) {
					_this.cmtStatusArr = data[0];
				}
			};
			this.get_device_list();
		},
		mkDvSt: function mkDvSt(row) {
			return this.sstatus[row.terminalStatus];
		},
		get_device_list: function get_device_list() {
			var _this6 = this;

			this.device_loading = true;
			this.$getNonItDv(this.select_form.page, this.select_form.rows, this.mech, this.select_form.terminal_no, this.select_form.terminal_status, "", '', '', this.select_form.snBegin, this.select_form.snEnd, function (res) {
				_this6.device_loading = 0;
				if (res.status === 200) {
					_this6.deviceList = res.data;
					_this6.deviceTotal = res.total;
				} else {
					_this6.$message.error(res.message);
				}
			}, function () {
				_this6.device_loading = 0;
			});
		},
		handleClick: function handleClick(tab, event) {
			this.getAppList();
			this.getUnstallList();
		},
		batchDeleteRow: function batchDeleteRow() {
			var _this7 = this;

			this.$confirm(this.$t('terminal.list.delete_tips'), this.$t('lin_btn.tips'), {
				confirmButtonText: this.$t('lin_btn.confirm'),
				cancelButtonText: this.$t('lin_btn.cancel'),
				type: 'warning'
			}).then(function () {
				var ids = [];
				for (var i = 0; i < _this7.multipleSelection.length; i++) {
					ids.push(_this7.multipleSelection[i].id);
				}
				_this7.$delUnPsp(String(ids), function (res) {
					if (res.status === 200) {
						_this7.$message.success(res.message);
						_this7.getUnstallList();
					} else {
						_this7.$message.error(res.message);
					}
				}, "");
			}).catch(function () {});
		},
		delete_all: function delete_all() {
			var _this8 = this;

			this.$confirm(this.$t('del_allData'), this.$t('lin_btn.tips'), {
				confirmButtonText: this.$t('lin_btn.confirm'),
				cancelButtonText: this.$t('lin_btn.cancel'),
				type: 'warning'
			}).then(function () {
				console.log(_this8.uninsatll_form);
				var sub_form = {
					terminalNo: _this8.uninsatll_form.terminalNo,
					mechId: _this8.uninsatll_form.mechId
				};
				_this8.$delUnPspAll(sub_form, function (res) {
					if (res.status === 200) {
						_this8.$message.success(res.message);
						_this8.uninsatll_form = {
							page: 1,
							rows: 20,
							terminalNo: "",
							mechId: ""
						};
						var that = _this8;
						_this8.mechanismDatas = {
							value: null,
							placeholder: that.$t('lin_global.place_areaid'),
							callback: function callback(value) {
								that.uninsatll_form.mechId = value;
								that.getUnstallList();
							}
						};
						_this8.getUnstallList();
					} else {
						_this8.$message.error(res.message);
					}
				}, "");
			}).catch(function () {});
		},
		jumpToAdd: function jumpToAdd() {
			this.$setWObj("editPSPConfig", {
				type: 0 });
			this.$router.push({
				path: 'pspList/add'
			});
		},
		editApp: function editApp(row) {
			this.$setWObj("editPSPConfig", {
				data: row,
				type: 1 });
			this.$router.push({
				path: 'pspList/edit'
			});
		},
		handleSelectionChange: function handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		query: function query() {
			this.getAppList();
		},
		reset: function reset() {
			this.fileName = "";
			this.getAppList();
		},
		pageSelect: function pageSelect(index) {
			this.$setWPage("appPage", index);
			this.getAppList();
		},
		pageSized: function pageSized(val) {
			this.$gRow = val;
			this.getAppList();
		},
		pageSelectUn: function pageSelectUn(index) {
			this.uninsatll_form.page = index;
			this.getUnstallList();
		},
		pageSizedUn: function pageSizedUn(val) {
			this.uninsatll_form.rows = val;
			this.getUnstallList();
		},
		deleteApp: function deleteApp(obj) {
			var _this9 = this;

			this.$showConfirm(this.$t("app_tip"), this.$t("app_tipMkDel"), this.$t("app_sure"), this.$t("app_cancel"), "warning", function () {
				_this9.$delPsp(obj.id, function (res) {
					if (res.status === 200) {
						_this9.$message.success(res.message);
						_this9.getAppList();
					} else {
						_this9.$message.error(res.message);
					}
				}, "");
			}, "");
		},
		deleteApps: function deleteApps(obj) {
			var _this10 = this;

			this.$showConfirm(this.$t("app_tip"), this.$t("terminal.list.delete_tips"), this.$t("app_sure"), this.$t("app_cancel"), "warning", function () {
				_this10.$delUnPsp(obj.id, function (res) {
					if (res.status === 200) {
						_this10.$message.success(res.message);
						_this10.getUnstallList();
					} else {
						_this10.$message.error(res.message);
					}
				}, "");
			}, "");
		},
		cellClick: function cellClick(row, ev, col) {
			var label = col.label;
			if (!label) return;
			if (label === this.$t("app_operate")) {
				return;
			} else {
				this.$setWObj("pspDetail", {
					data: row
				});
				this.$router.push({
					path: 'pspList/detail'
				});
			}
		},
		getAppList: function getAppList() {
			var _this11 = this;

			this.loading = 1;
			this.$pspList({
				page: this.$getWPage("appPage"),
				rows: this.$gRow,
				fileName: this.fileName
			}, function (res) {
				console.log(res);
				_this11.loading = 0;
				if (res.status === 200) {
					_this11.total = res.total;
					_this11.tableData = res.data;
				} else {
					_this11.$message(res.message);
				}
			}, function () {
				_this11.loading = 0;
				_this11.$message.error(_this11.$t("app_rqsError"));
			});
		},
		getUnstallList: function getUnstallList() {
			var _this12 = this;

			console.log(this.uninsatll_form);

			this.$pspUnList(this.uninsatll_form, function (res) {
				console.log(res);
				_this12.loading = 0;
				if (res.status === 200) {
					_this12.uninstallTotal = res.total;
					_this12.uninstallData = res.data;
				} else {
					_this12.$message(res.message);
				}
			}, function () {
				_this12.$message.error(_this12.$t("app_rqsError"));
			});
		},
		dateFormat: function dateFormat(row, column) {
			var date = row[column.property];
			if (date === undefined) {
				return "";
			}
			return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format("YYYY-MM-DD HH:mm:ss");
		}
	},
	mounted: function mounted() {
		this.getAppList();
		this.getUnstallList();
	},
	destroyed: function destroyed() {}
});

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      orderName: '',
      orderType: '',
      mechanismId: window.localStorage['mechanismId'],
      tableData: [],
      appTypes: [],
      appTypeValue: '',
      appStatus: [{ label: this.$t('app_prePushVerify'), value: '0' }, { label: this.$t('app_preVerify'), value: '1' }, { label: this.$t('app_verifyPass'), value: '2' }, { label: this.$t('app_verifyNotPass'), value: '3' }],
      appStatusValue: '',
      row: this.$gRow,
      total: 0,
      index: 1,
      loading: 0
    };
  },

  computed: {
    index: function index() {
      return this.$getWPage('appVerifyPage');
    }
  },
  methods: {
    sortChange: function sortChange(vl) {
      switch (vl.prop) {
        case 'appName':
          this.orderName = '1';
          break;
        case 'createTime':
          this.orderName = '2';
          break;
      }
      this.orderType = vl.order == 'descending' ? 'desc' : 'asc';
      this.getAppList(this.index);
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    },
    getStatus: function getStatus(value) {
      switch (value) {
        case '0':
          return this.$t('app_prePushVerify');
        case '1':
          return this.$t('app_preVerify');
        case '2':
          return this.$t('app_verifyPass');
        case '3':
          return this.$t('app_verifyNotPass');
      }
    },
    pageSelect: function pageSelect(index) {
      this.getAppList(index);
      this.$setWPage('appVerifyPage', index);
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getAppList(this.index);
    },
    cellClick: function cellClick(row) {
      var cf = { type: 3, data: row };
      this.$setWObj('editAppConfig', cf);
      this.$router.push({ path: '/appView/verify' });
    },
    getAppList: function getAppList(index) {
      var _this = this;

      this.loading = 1;
      var mc = '';
      this.$getAppList1(this.$gRow, index, mc, '', '', '1', this.orderName, this.orderType, '', function (res) {
        _this.loading = 0;
        if (res.status === 200) {
          _this.total = res.total;
          _this.index = index;
          _this.tableData = res.data;
        } else {
          _this.$message(res.message);
        }
      }, function () {
        _this.loading = 0;
        _this.$message.error(_this.$t('app_rqsError'));
      });
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('YYYY-MM-DD HH:mm:ss');
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.getAppList(this.index);
    this.$getAppTypeList(100000000, 1, function (res) {
      if (res.status === 200) {
        _this2.appTypes = res.data;
      } else {
        _this2.$message(res.message);
      }
    }, '');
  }
});

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isAdmin: this.$getWObj().login.userType == 0,
      mechanismData: '',
      orderName: '',
      orderType: '',
      sNum: 0,
      mechanismId: window.localStorage['mechanismId'],
      mechId: window.localStorage['mechanismId'],
      loading: 0,
      queryKey: '',
      appType: '',
      appTypes: [],
      tableData: [],
      multipleSelection: [],
      total: 0,
      page: 1,
      dialogTopMgVisible: 0,
      dialogConfig: { tip: '', data: '', type: '' },
      selectAll: {}
    };
  },

  components: { MechanismSelector: __WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue___default.a },
  computed: {
    index: function index() {
      return this.$getWPage('appMarketPage');
    }
  },
  methods: {
    sortChange: function sortChange(vl) {
      switch (vl.prop) {
        case 'appName':
          this.orderName = '1';
          break;
        case 'createTime':
          this.orderName = '2';
          break;
      }
      this.orderType = vl.order == 'descending' ? 'desc' : 'asc';
      this.getList();
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    },
    query: function query() {
      this.getList();
    },
    reset: function reset() {
      this.queryKey = '';
      this.appType = '';
      this.getList();
    },
    selectChange: function selectChange(vl) {
      this.getList();
    },
    getTypeList: function getTypeList(mcid) {
      var _this2 = this;

      this.$gpAppType(mcid, function (res) {
        if (res.data.length > 0) {
          _this2.appTypes = res.data[0].children;
        }
      }, '');
    },
    cellClick: function cellClick(row, ev, col) {
      if (col.label && col.label !== this.$t('app_operate') && col.label !== this.$t('app_classIntrol') && col.label !== this.$t('app_homeIntrol')) {
        this.$setWObj("appDisplay", { appid: row.applicationid, isMk: true });

        this.$router.push({ path: '/appSlot/view' });
      }
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('YYYY-MM-DD HH:mm:ss');
    },
    pageSelect: function pageSelect(index) {
      this.$setWPage('appMarketPage', index);
      this.getList();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getList();
    },
    toggleSelection: function toggleSelection(rows) {
      var _this3 = this;

      if (rows) {
        rows.forEach(function (row) {
          _this3.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    processRecommend: function processRecommend(yes) {
      var _this4 = this;

      this.dialogTopMgVisible = 0;
      var config = this.dialogConfig;
      switch (config.type) {
        case 'class':
          this.loading = 1;
          var typeId = config.data.appCategoryId;

          var vl = yes ? '0' : '1';
          if (this.$appUrlTag === 0) {
            this.$recommendClass(this.mechanismId, config.data.applicationid, vl, function (res) {
              _this4.loading = 0;
              if (res.status === 200) {
                var tm = config.data;
                tm.isType = vl;
                _this4.tableData[config.index] = tm;
              } else {
                _this4.$message.error(res.message);
              }
            }, function () {
              _this4.loading = 0;
            });
          } else {
            this.$recommendClass1(this.mechanismId, config.data.applicationid, vl, function (res) {
              _this4.loading = 0;
              if (res.status === 200) {
                var tm = config.data;
                tm.isType = vl;
                _this4.tableData[config.index] = tm;
              } else {
                _this4.$message.error(res.message);
              }
            }, function () {
              _this4.loading = 0;
            });
          }

          break;
        case 'home':
          this.loading = 1;

          var vl = yes ? '0' : '1';
          if (this.$appUrlTag === 0) {
            this.$recommendHome(this.mechanismId, config.data.applicationid, vl, function (res) {
              _this4.loading = 0;
              if (res.status !== 200) {
                _this4.$message.error(res.message);
              } else {
                var tm = config.data;
                tm.isHome = vl;
                _this4.tableData[config.index] = tm;
              }
            }, function () {
              _this4.loading = 0;
            });
          } else {
            this.$recommendHome1(this.mechanismId, config.data.applicationid, vl, function (res) {
              _this4.loading = 0;
              if (res.status !== 200) {
                _this4.$message.error(res.message);
              } else {
                var tm = config.data;
                tm.isHome = vl;
                _this4.tableData[config.index] = tm;
              }
            }, function () {
              _this4.loading = 0;
            });
          }

          break;
      }
    },
    classRecommend: function classRecommend(row, scope) {
      this.dialogTopMgVisible = 1;
      this.dialogConfig = { type: 'class', data: row, tip: this.$t('app_isIntroClass'), index: scope.$index };
    },
    homeRecommend: function homeRecommend(row, scope) {
      this.dialogTopMgVisible = 1;
      this.dialogConfig = { type: 'home', data: row, tip: this.$t('app_isIntroHome'), index: scope.$index };
    },
    undercarriage: function undercarriage(row) {
      var _this5 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_isOffShelf'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this5.loading = 1;
        if (_this5.$appUrlTag === 0) {
          _this5.$appDistributeOnOff(_this5.mechanismId, row.packagename, '1', function (res) {
            if (res.status === 200) {
              _this5.getList();
            } else {
              _this5.$message.error(res.message);
            }
            _this5.loading = 0;
          }, function () {
            _this5.loading = 0;
          });
        } else {
          _this5.$appDistributeOnOff1(_this5.mechanismId, row.packagename, '1', function (res) {
            if (res.status === 200) {
              _this5.getList();
            } else {
              _this5.$message.error(res.message);
            }
            _this5.loading = 0;
          }, function () {
            _this5.loading = 0;
          });
        }
      }, '');
    },
    allUndercarriage: function allUndercarriage() {
      var _this6 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_isOffApp'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        var ids = '';
        _this6.multipleSelection.forEach(function (vl) {
          ids += vl.packagename + ',';
        });
        ids = ids.substring(0, ids.length - 1);

        if (!ids) {
          _this6.$message(_this6.$t('app_chooseOneMust'));
          return;
        }
        _this6.loading = 1;
        if (_this6.$appUrlTag === 0) {
          _this6.$appDistributeOnOff(_this6.mechanismId, ids, '1', function (res) {
            if (res.status === 200) {
              _this6.getList();
            } else {
              _this6.$message.error(res.message);
            }
            _this6.loading = 0;
          }, function () {
            _this6.loading = 0;
          });
        } else {
          _this6.$appDistributeOnOff1(_this6.mechanismId, ids, '1', function (res) {
            if (res.status === 200) {
              _this6.getList();
            } else {
              _this6.$message.error(res.message);
            }
            _this6.loading = 0;
          }, function () {
            _this6.loading = 0;
          });
        }
      }, '');
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.sNum = val.length;
      this.multipleSelection = val;
    },
    showAddApp: function showAddApp() {
      this.$router.push({ path: '/appSlot/distribute-add' });
    },
    bindOperate: function bindOperate(obj) {
      this.$setWObj('pushList', { data: obj, type: '1' });
      this.$router.push({ path: '/appslot/distribute-push' });
    },
    selected: function selected(rows) {},
    getList: function getList(isGetType) {
      var _this7 = this;

      this.loading = 1;
      var sName = this.queryKey ? this.queryKey : '';
      var sCid = this.appType.length > 0 ? this.appType[0] : '';

      var mcid = this.mechId ? this.mechId : this.mechanismId;

      if (isGetType) {
        this.getTypeList(mcid);
      }

      this.$getDistributeAppList1(sName, sCid, this.$gRow, this.$getWPage('appMarketPage'), mcid, this.orderName, this.orderType, function (res) {
        console.log(res);
        _this7.loading = 0;
        if (res.status === 200) {
          _this7.total = res.total;
          _this7.tableData = res.data;
        } else {
          _this7.$message.error(res.message);
        }
      }, function () {
        _this7.loading = 0;
      });
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.mechanismData = {
      callback: function callback(value) {
        _this.mechId = value;
        _this.getList(true);
      }
    };
    this.getList(true);
  }
});

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var that = this;
    return {
      mechanismData: {
        callback: function callback(value) {
          that.channelId = value;
          that.selectChange(value);
        }
      },
      sNum: 0,
      status: '',
      iNo: '',
      row: this.$gRow,
      selected: [],
      info: '',
      launcherBind: '',
      tableData: [],
      multipleSelection: [],
      channels: [],
      channelId: '',
      loading: 0,
      total: 0,
      index: 1
    };
  },

  components: { MechanismSelector: __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default.a },
  computed: {
    stModel: function stModel() {
      var app = [{ label: this.$t('app_online'), vl: '1' }, { label: this.$t('app_offline'), vl: '2' }, { label: this.$t('app_new'), vl: '0' }];

      return app;
    },
    isLauncher: function isLauncher() {
      if (this.launcherBind) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    pageSelect: function pageSelect(index) {
      this.index = index;
      if (this.isLauncher) {
        this.getLauncherDevices();
      } else {
        this.getDevices();
      }
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      if (this.isLauncher) {
        this.getLauncherDevices();
      } else {
        this.getDevices();
      }
    },
    selectChange: function selectChange(vl) {
      if (this.isLauncher) {
        this.getLauncherDevices();
      } else {
        this.getDevices();
      }
    },
    selectStChange: function selectStChange(vl) {
      if (this.isLauncher) {
        this.getLauncherDevices();
      } else {
        this.getDevices();
      }
    },
    srch: function srch() {
      if (this.isLauncher) {
        this.getLauncherDevices();
      } else {
        this.getDevices();
      }
    },
    handleSelectionChange: function handleSelectionChange(list) {
      this.sNum = list.length;
      this.selected = list;
    },
    multiBind: function multiBind() {
      var _this = this;

      var ids = '';
      var tNo = '';
      var tmid = '';
      this.selected.forEach(function (vl) {
        ids += vl.terminalId + ',';
        tNo += vl.terminalNo + ',';
        tmid += vl.manufId + ',';
      });
      ids = ids.substring(0, ids.length - 1);
      tNo = tNo.substring(0, tNo.length - 1);
      tmid = tmid.substring(0, tmid.length - 1);

      if (this.isLauncher) {
        if (!tNo) {
          this.$message(this.$t('app_oneDeviceMust'));
          return;
        }
        this.loading = 1;
        this.$pushLauncher(this.launcherBind.launcherid, tNo, localStorage.mechanismId, function (res) {
          _this.loading = 0;
          if (res.status === 200) {
            _this.$message.success(_this.$t('app_tipViewTask'));
            _this.getLauncherDevices();
          } else {
            _this.$message.error(res.message);
          }
        }, function (error) {
          _this.loading = 0;
          _this.$message.error(_this.$('app_rqsError'));
        });
      } else {
        if (!ids && !tNo) {
          this.$message(this.$t('app_oneDeviceMust'));
          return;
        }

        this.bind(ids, tNo, tmid);
      }
    },
    bindOperate: function bindOperate(row) {
      var _this2 = this;

      if (this.isLauncher) {
        this.loading = 1;
        this.$pushLauncher(this.launcherBind.launcherid, row.terminalNo, localStorage.mechanismId, function (res) {
          _this2.loading = 0;
          if (res.status === 200) {
            _this2.$message.success(_this2.$t('app_tipViewTask'));
            _this2.getLauncherDevices();
          } else {
            _this2.$message.error(res.message);
          }
        }, function (error) {
          _this2.loading = 0;
          _this2.$message.error(_this2.$('app_rqsError'));
        });
      } else {
        this.bind(row.terminalId, row.terminalNo, row.manufId);
      }
    },
    getChannels: function getChannels() {
      var _this3 = this;

      this.$getChannelList(10000, 1, '', '', '', function (res) {
        if (res.status === 200) {
          _this3.channels = res.data;
        } else {
          _this3.$message.error(res.message);
        }
      }, function () {
        _this3.$message.error(_this3.$t('app_rqsError'));
      });
    },
    getDevices: function getDevices() {
      var _this4 = this;

      var channel = this.channelId;
      var terminalNo = this.iNo ? this.iNo : '';
      var status = this.status ? this.status : '';
      this.loading = 1;

      console.log('iifff iddd', this.info);
      var cId = this.info.appdevid ? this.info.appdevid : this.info.applicationid;

      if (this.$appUrlTag === 0) {
        this.$getDevices(this.index, this.$gRow, channel, terminalNo, status, '', cId, function (res) {
          _this4.loading = 0;
          if (res.data) {
            _this4.total = res.total;
            _this4.tableData = res.data;
          }
        }, function () {
          _this4.loading = 0;
        });
      } else {
        this.$getDevices1(this.index, this.$gRow, channel, terminalNo, status, '', cId, function (res) {
          _this4.loading = 0;
          if (res.data) {
            _this4.total = res.total;
            _this4.tableData = res.data;
          }
        }, function () {
          _this4.loading = 0;
        });
      }
    },
    getLauncherDevices: function getLauncherDevices() {
      var _this5 = this;

      var channel = this.channelId;
      var terminalNo = this.iNo ? this.iNo : '';
      var status = this.status ? this.status : '';
      this.loading = 1;
      this.$pushLauncherList(this.index, this.$gRow, channel, terminalNo, status, '', this.launcherBind.launcherid, '', function (res) {
        _this5.loading = 0;
        if (res.data) {
          _this5.total = res.total;
          _this5.tableData = res.data;
        }
      }, function () {
        _this5.loading = 0;
      });
    },
    bind: function bind(tId, tNo, tmid) {
      var _this6 = this;

      var vl = tId ? tId : '';
      this.loading = 1;

      var cId = this.info.appdevid ? this.info.appdevid : this.info.applicationid;

      if (this.$appUrlTag === 0) {
        this.$bindApp('0', vl, cId, function (res) {
          if (res.status === 200) {
            _this6.$message.success(_this6.$t('app_tipViewTask'));
          } else {
            _this6.$message.error(res.message);
          }
          _this6.loading = 0;
        }, function () {
          _this6.loading = 0;
        });
      } else {
        this.$bindApp1(tmid, tNo, cId, function (res) {
          if (res.status === 200) {
            _this6.$message.success(_this6.$t('app_tipViewTask'));
          } else {
            _this6.$message.error(res.message);
          }
          _this6.loading = 0;
        }, function () {
          _this6.loading = 0;
        });
      }
    }
  },
  mounted: function mounted() {
    var isLauncher = this.$route.path === '/launch-push/launch-push-ter';
    var obj = this.$getWObj().appBindInfo;
    if (!isLauncher) {
      this.info = obj.data;
      this.getChannels();
      this.getDevices();
      this.launcherBind = '';
    } else {
      this.launcherBind = this.$getWObj().launcherBind;
      this.getLauncherDevices();
    }
  }
});

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_tyc__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_tyc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_global_tyc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_tagc__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_tagc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_tagc__);







/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		MechanismSelector: __WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue___default.a,
		tyc: __WEBPACK_IMPORTED_MODULE_2__components_global_tyc___default.a,
		tagc: __WEBPACK_IMPORTED_MODULE_3__components_global_tagc___default.a
	},
	data: function data() {
		var that = this;
		return {
			cmtStatusArr: [],
			activeName: this.$t('psp_app_manage'),
			mechanismData: {
				value: null,
				placeholder: that.$t('lin_global.place_areaid'),
				callback: function callback(value) {
					that.mech = value;
					that.getCmDv();
				}
			},

			isNon: false,
			mech: "",
			deviceList: [],
			deviceTotal: 0,
			select_device: [],
			tqobj: '',
			device_loading: false,
			mechanismDatas: {
				value: null,
				placeholder: that.$t('lin_global.place_areaid'),
				callback: function callback(value) {
					that.uninsatll_form.mechId = value;
					that.getUnstallList();
				}
			},

			sstatus: {
				'0': this.$t('app_new'),
				'1': this.$t('app_enable')
			},
			uninstallData: [],
			uninstallTotal: 0,
			uninsatll_form: {
				page: 1,
				rows: 10,
				terminalNo: "",
				mechId: ""
			},
			orderName: '',
			orderType: '',
			appvst: '',
			pkg: '',
			cerDialogVisible: false,
			cerTipDialogVisible: false,
			dvLoading: 0,
			appId: "",
			stModel: [{
				label: this.$t("app_online"),
				vl: "1"
			}, {
				label: this.$t("app_offline"),
				vl: "2"
			}, {
				label: this.$t("app_new"),
				vl: "0"
			}],
			channels: [],
			sNum: 0,
			cleanMode: false,
			multipleSelection: [],
			tempSelect: [],
			srchValue: "",
			channelId: "",
			cerTipMsg: "",
			status: "",
			index: 1,
			dvIndex: 1,
			dialogVisible: 0,
			mechanismId: window.localStorage["mechanismId"],
			mechId: '',
			tableData: [],
			dvTableData: [],
			appTypes: [],
			appTypeValue: "",

			appvStatus: [{
				label: this.$t("app_prePushVerify"),
				value: "0"
			}, {
				label: this.$t("app_preVerify"),
				value: "1"
			}, {
				label: this.$t("app_verifyPass"),
				value: "2"
			}, {
				label: this.$t("app_verifyNotPass"),
				value: "3"
			}],
			sstatusAr: [{
				vl: '',
				lb: this.$t('app_all')
			}, {
				vl: '0',
				lb: this.$t('app_new')
			}, {
				vl: '1',
				lb: this.$t('app_enable')
			}],

			appStatusValue: "",
			total: 0,
			dvTotal: 0,
			loading: 0,
			appType: "",
			queryKey: "",
			appName: "",
			show_push: false,
			select_form: {
				page: 1,
				rows: 20,
				areaid: "",
				snBegin: "",
				snEnd: "",
				terminal_status: "",
				terminal_no: ""
			}
		};
	},

	methods: {
		handleSelectionChangeDevice: function handleSelectionChangeDevice(val) {
			this.select_device = val;
		},
		open_push: function open_push() {
			this.show_push = true;
			this.getCmDv();
		},
		handleClose: function handleClose() {
			this.show_push = false;
			this.select_form = {
				page: 1,
				rows: 20,
				areaid: "",
				snBegin: "",
				snEnd: "",
				terminal_status: "",
				terminal_no: ""
			};
			var that = this;
			that.mech = "";
			this.mechanismData = {
				value: null,
				placeholder: that.$t('lin_global.place_areaid'),
				callback: function callback(value) {
					that.mech = value;
					that.getCmDv();
				}
			};
		},
		bcPush: function bcPush() {
			var _this2 = this;

			var terminalNo_list = [];
			var mechId_list = [];
			var mechName_list = [];
			this.select_device.forEach(function (obj) {
				terminalNo_list.push(obj.terminalNo);
				mechId_list.push(obj.mechanismId);
				mechName_list.push(obj.mechName);
			});

			var tip = this.$t('app_surepsxdv').replace('{num}', this.select_device.length);

			this.$showConfirm(this.$t('app_tip'), tip + ' ?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
				var sub_form = {
					terminalNo: String(terminalNo_list),
					mechId: String(mechId_list),
					mechName: String(mechName_list)
				};
				_this2.device_loading = true;
				_this2.$pspUnPush(sub_form, function (res) {
					_this2.device_loading = false;
					if (res.status === 200) {
						_this2.$message.success(res.message);
						_this2.show_push = false;
						_this2.getUnstallList();
					} else {
						_this2.$message.error(res.message);
					}
				}, function () {
					_this2.device_loading = false;
				});
			}, '');
		},
		pushAll: function pushAll() {
			var _this3 = this;

			this.$showConfirm(this.$t('app_tip'), this.$t('app_ispushalldv') + ' ?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
				_this3.select_form.areaid = _this3.mech;
				console.log(_this3.select_form);
				console.log("推送全部");
			}, '');
		},
		pushed: function pushed(row) {
			var _this4 = this;

			this.$showConfirm(this.$t('app_tip'), this.$t('app_srpush') + ' ' + row.terminalNo + ' ?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
				console.log(row);
				var sub_form = {
					terminalNo: row.terminalNo,
					mechId: row.mechanismId,
					mechName: row.mechName
				};
				_this4.device_loading = true;
				_this4.$pspUnPush(sub_form, function (res) {
					_this4.device_loading = false;
					if (res.status === 200) {
						_this4.$message.success(res.message);
						_this4.show_push = false;
						_this4.getUnstallList();
					} else {
						_this4.$message.error(res.message);
					}
				}, function () {
					_this4.device_loading = false;
				});
			}, '');
		},
		pageSizedDevice: function pageSizedDevice(vl) {
			this.select_form.rows = vl;
			this.getCmDv();
		},
		pageSelectDevice: function pageSelectDevice(vl) {
			this.select_form.page = vl;
			this.getCmDv();
		},
		getCmDv: function getCmDv() {
			var _this = this;
			var typeKey = 'terminalTypes';
			this.tqobj = {
				keys: [typeKey],
				callback: function callback(data) {
					_this.cmtStatusArr = data[0];
				}
			};
			this.get_device_list();
		},
		mkDvSt: function mkDvSt(row) {
			return this.sstatus[row.terminalStatus];
		},
		get_device_list: function get_device_list() {
			var _this5 = this;

			this.device_loading = true;
			this.$getNonItDv(this.select_form.page, this.select_form.rows, this.mech, this.select_form.terminal_no, this.select_form.terminal_status, "", '', '', this.select_form.snBegin, this.select_form.snEnd, function (res) {
				_this5.device_loading = 0;
				if (res.status === 200) {
					_this5.deviceList = res.data;
					_this5.deviceTotal = res.total;
				} else {
					_this5.$message.error(res.message);
				}
			}, function () {
				_this5.device_loading = 0;
			});
		},
		handleClick: function handleClick(tab, event) {
			this.getAppList();
			this.getUnstallList();
		},
		batchDeleteRow: function batchDeleteRow() {
			var _this6 = this;

			this.$confirm(this.$t('terminal.list.delete_tips'), this.$t('lin_btn.tips'), {
				confirmButtonText: this.$t('lin_btn.confirm'),
				cancelButtonText: this.$t('lin_btn.cancel'),
				type: 'warning'
			}).then(function () {
				var ids = [];
				for (var i = 0; i < _this6.multipleSelection.length; i++) {
					ids.push(_this6.multipleSelection[i].id);
				}
				_this6.$delUnPsp(String(ids), function (res) {
					if (res.status === 200) {
						_this6.$message.success(res.message);
						_this6.getUnstallList();
					} else {
						_this6.$message.error(res.message);
					}
				}, "");
			}).catch(function () {});
		},
		delete_all: function delete_all() {
			var _this7 = this;

			this.$confirm(this.$t('del_allData'), this.$t('lin_btn.tips'), {
				confirmButtonText: this.$t('lin_btn.confirm'),
				cancelButtonText: this.$t('lin_btn.cancel'),
				type: 'warning'
			}).then(function () {
				console.log(_this7.uninsatll_form);
				var sub_form = {
					terminalNo: _this7.uninsatll_form.terminalNo,
					mechId: _this7.uninsatll_form.mechId
				};
				_this7.$delUnPspAll(sub_form, function (res) {
					if (res.status === 200) {
						_this7.$message.success(res.message);
						_this7.uninsatll_form = {
							page: 1,
							rows: 20,
							terminalNo: "",
							mechId: ""
						};
						var that = _this7;
						_this7.mechanismDatas = {
							value: null,
							placeholder: that.$t('lin_global.place_areaid'),
							callback: function callback(value) {
								that.uninsatll_form.mechId = value;
								that.getUnstallList();
							}
						};
						_this7.getUnstallList();
					} else {
						_this7.$message.error(res.message);
					}
				}, "");
			}).catch(function () {});
		},
		jumpToAdd: function jumpToAdd() {
			this.$setWObj("editUpdatePSPConfig", {
				type: 0 });
			this.$router.push({
				path: 'updatePsp/add'
			});
		},
		editApp: function editApp(row) {
			this.$setWObj("editUpdatePSPConfig", {
				data: row,
				type: 1 });
			this.$router.push({
				path: 'updatePsp/edit'
			});
		},
		handleSelectionChange: function handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		query: function query() {
			this.getAppList();
		},
		reset: function reset() {
			this.appName = "";
			this.getAppList();
		},
		pageSelect: function pageSelect(index) {
			this.index = index;
			this.getAppList();
		},
		pageSized: function pageSized(val) {
			this.$gRow = val;
			this.getAppList();
		},
		pageSelectUn: function pageSelectUn(index) {
			this.uninsatll_form.page = index;
			this.getUnstallList();
		},
		pageSizedUn: function pageSizedUn(val) {
			this.uninsatll_form.rows = val;
			this.getUnstallList();
		},
		deleteApp: function deleteApp(obj) {
			var _this8 = this;

			this.$showConfirm(this.$t("app_tip"), this.$t("app_tipMkDel"), this.$t("app_sure"), this.$t("app_cancel"), "warning", function () {
				_this8.$delPsp(obj.id, function (res) {
					if (res.status === 200) {
						_this8.$message.success(res.message);
						_this8.getAppList();
					} else {
						_this8.$message.error(res.message);
					}
				}, "");
			}, "");
		},
		deleteApps: function deleteApps(obj) {
			var _this9 = this;

			this.$showConfirm(this.$t("app_tip"), this.$t("app_tipMkDel"), this.$t("app_sure"), this.$t("app_cancel"), "warning", function () {
				_this9.$delChangePsp(obj.id, function (res) {
					if (res.status === 200) {
						_this9.$message.success(res.message);
						_this9.getAppList();
					} else {
						_this9.$message.error(res.message);
					}
				}, "");
			}, "");
		},
		cellClick: function cellClick(row, ev, col) {
			var label = col.label;
			if (!label) return;
			if (label === this.$t("app_operate")) {
				return;
			} else {
				this.$setWObj("updatePspDetail", {
					data: row,
					type: 2
				});
				this.$router.push({
					path: 'updatePsp/detail'
				});
			}
		},
		getAppList: function getAppList() {
			var _this10 = this;

			this.loading = 1;
			this.$changePspList({
				page: this.index,
				rows: this.$gRow,
				fileType: 2,
				appName: this.appName
			}, function (res) {
				console.log(res);
				_this10.loading = 0;
				if (res.status === 200) {
					_this10.total = res.total;
					_this10.tableData = res.data;
				} else {
					_this10.$message(res.message);
				}
			}, function () {
				_this10.loading = 0;
				_this10.$message.error(_this10.$t("app_rqsError"));
			});
		},
		getUnstallList: function getUnstallList() {
			var _this11 = this;

			console.log(this.uninsatll_form);

			this.$pspUnList(this.uninsatll_form, function (res) {
				console.log(res);
				_this11.loading = 0;
				if (res.status === 200) {
					_this11.uninstallTotal = res.total;
					_this11.uninstallData = res.data;
				} else {
					_this11.$message(res.message);
				}
			}, function () {
				_this11.$message.error(_this11.$t("app_rqsError"));
			});
		},
		dateFormat: function dateFormat(row, column) {
			var date = row[column.property];
			if (date === undefined) {
				return "";
			}
			return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format("YYYY-MM-DD HH:mm:ss");
		}
	},
	mounted: function mounted() {
		this.getAppList();
	},
	destroyed: function destroyed() {}
});

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_df_png__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_df_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_df_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_global_tyc__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_global_tyc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_global_tyc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_global_tagc__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_global_tagc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_global_tagc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_url__ = __webpack_require__(3);










/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		MechanismSelector: __WEBPACK_IMPORTED_MODULE_5__components_global_mechanism_selector_vue___default.a,
		tyc: __WEBPACK_IMPORTED_MODULE_4__components_global_tyc___default.a,
		tagc: __WEBPACK_IMPORTED_MODULE_6__components_global_tagc___default.a
	},
	data: function data() {
		var _ref;

		var that = this;
		return _ref = {
			downTpl: __WEBPACK_IMPORTED_MODULE_7__api_url__["b" /* urlAssets */].prefix + 'tms-server-web/model/terminalNos.xlsx',
			uldata: '',
			formLabelWidth: '28.5%',
			pushImport: false,
			fileList: [],
			cmtStatusArr: [],
			mechanismData: {
				value: null,
				placeholder: that.$t('lin_global.place_areaid'),
				callback: function callback(value) {
					that.mech = value;
					that.getCmDv();
				}
			},
			multipleSelection: [],
			isNon: false,
			mech: "",
			deviceList: [],
			deviceTotal: 0,
			select_device: [],
			tqobj: '',
			device_loading: false,
			mechanismDatas: {
				value: null,
				placeholder: that.$t('lin_global.place_areaid'),
				callback: function callback(value) {
					that.uninsatll_form.mechId = value;
					that.getUnstallList();
				}
			},
			sstatus: {
				'0': this.$t('app_new'),
				'1': this.$t('app_enable')
			},
			sstatusAr: [{
				vl: '',
				lb: this.$t('app_all')
			}, {
				vl: '0',
				lb: this.$t('app_new')
			}, {
				vl: '1',
				lb: this.$t('app_enable')
			}],
			uninstallData: [],
			uninstallTotal: 0,
			uninsatll_form: {
				page: 1,
				rows: 10,
				terminalNo: "",
				mechId: "",
				appId: ""
			},
			show_push: false,
			select_form: {
				page: 1,
				rows: 20,
				areaid: "",
				snBegin: "",
				snEnd: "",
				terminal_status: "",
				terminal_no: ""
			},

			total: 0,
			queryKey: '',
			terminalNo: "",
			sNum: 0,
			page: 1,
			tableData1: [],
			tableData: [],
			list: [],
			pushedList: false
		}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'tqobj', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'dobj', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'vSt', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'config', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'captures', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'loading', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'iconUrl', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'app_detail', {}), _ref;
	},

	computed: {
		avtStyle: function avtStyle() {
			var url = this.iconUrl ? this.imgFullUrl(this.iconUrl) : __webpack_require__(6);

			return 'background-size: cover;background-position: center center;width:100%;height:100%;background-image: url(' + url + ')';
		}
	},
	methods: {
		beforeRemove: function beforeRemove() {
			this.fileList = [];
			this.uldata = '';
		},
		srcBefore: function srcBefore(file) {
			if (this.uldata.fileNo) {
				return false;
			}

			var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
			var extension = testmsg === "xls";
			var extension2 = testmsg === "xlsx";
			if (!extension && !extension2) {
				this.$message({
					message: this.$t("IncorrectaFormat"),
					type: "warning"
				});
			}
			return extension || extension2;
		},
		srcSuccess: function srcSuccess(res, file) {
			window[this.$route.path] = '';

			if (res.status === 200) {
				this.uldata = res.data;

				this.$message.success(res.message);
			} else {
				this.$message.error(res.message);
			}
		},
		ulError: function ulError() {
			window[this.$route.path] = '';
		},
		ulurl: function ulurl() {
			var url = this.$fileExcelUlUrl + '?token=' + localStorage.user + '&language=' + localStorage.system_lang;

			return url;
		},
		submitUpload: function submitUpload() {
			var _this2 = this;

			this.loading = true;
			this.$pushByImport(this.app_detail.id, this.uldata.fileNo, '1', function (res) {
				_this2.loading = false;
				if (res.status === 200) {
					_this2.$message.success(res.message);
				} else {
					_this2.$message.error(res.message);
				}
			}, function () {
				_this2.loading = false;
			});
			this.fileList = [];
			this.uldata = '';
			this.getUnstallList();
			this.pushImport = false;
		},
		open_import: function open_import() {
			this.pushImport = true;
		},
		closeImport: function closeImport() {
			this.pushImport = false;
			this.fileList = [];
			this.uldata = '';
		},
		addTer: function addTer() {
			this.pushImport = true;
		},
		handleSelectionChange: function handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		handleSelectionChangeDevice: function handleSelectionChangeDevice(val) {
			this.select_device = val;
		},
		open_push: function open_push() {
			this.show_push = true;
			this.getCmDv();
		},
		handleClose: function handleClose() {
			this.show_push = false;
			this.select_form = {
				page: 1,
				rows: 20,
				areaid: "",
				snBegin: "",
				snEnd: "",
				terminal_status: "",
				terminal_no: ""
			};
			var that = this;
			that.mech = "";
			this.mechanismData = {
				value: null,
				placeholder: that.$t('lin_global.place_areaid'),
				callback: function callback(value) {
					that.mech = value;
					that.getCmDv();
				}
			};
		},
		bcPush: function bcPush() {
			var _this3 = this;

			var terminalNo_list = [];
			var mechId_list = [];
			var mechName_list = [];
			this.select_device.forEach(function (obj) {
				terminalNo_list.push(obj.terminalNo);
				mechId_list.push(obj.mechanismId);
				mechName_list.push(obj.mechName);
			});

			var tip = this.$t('app_surepsxdv').replace('{num}', this.select_device.length);

			this.$showConfirm(this.$t('app_tip'), tip + ' ?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
				var sub_form = {
					appId: _this3.app_detail.id,
					terminalNo: String(terminalNo_list),
					mechId: String(mechId_list),
					mechName: String(mechName_list),
					fileType: 2
				};
				_this3.device_loading = true;
				_this3.$changePspPush(sub_form, function (res) {
					_this3.device_loading = false;
					if (res.status === 200) {
						_this3.$message.success(res.message);
						_this3.show_push = false;
						_this3.getUnstallList();
					} else {
						_this3.$message.error(res.message);
					}
				}, function () {
					_this3.device_loading = false;
				});
			}, '');
		},
		pushAll: function pushAll() {
			var _this4 = this;

			this.$showConfirm(this.$t('app_tip'), this.$t('app_ispushalldv') + ' ?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
				_this4.select_form.areaid = _this4.mech;
				console.log(_this4.select_form);
				console.log("推送全部");
			}, '');
		},
		pushed: function pushed(row) {
			var _this5 = this;

			this.$showConfirm(this.$t('app_tip'), this.$t('app_srpush') + ' ' + row.terminalNo + ' ?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
				console.log(row);
				var sub_form = {
					appId: _this5.app_detail.id,
					terminalNo: row.terminalNo,
					mechId: row.mechanismId,
					mechName: row.mechName,
					fileType: 2
				};
				_this5.device_loading = true;
				_this5.$changePspPush(sub_form, function (res) {
					_this5.device_loading = false;
					if (res.status === 200) {
						_this5.$message.success(res.message);
						_this5.show_push = false;
						_this5.getUnstallList();
					} else {
						_this5.$message.error(res.message);
					}
				}, function () {
					_this5.device_loading = false;
				});
			}, '');
		},
		pageSizedDevice: function pageSizedDevice(vl) {
			this.select_form.rows = vl;
			this.getCmDv();
		},
		pageSelectDevice: function pageSelectDevice(vl) {
			this.select_form.page = vl;
			this.getCmDv();
		},
		pageSelectUn: function pageSelectUn(index) {
			this.uninsatll_form.page = index;
			this.getUnstallList();
		},
		pageSizedUn: function pageSizedUn(val) {
			this.uninsatll_form.rows = val;
			this.getUnstallList();
		},
		getCmDv: function getCmDv() {
			var _this = this;
			var typeKey = 'terminalTypes';
			this.tqobj = {
				keys: [typeKey],
				callback: function callback(data) {
					_this.cmtStatusArr = data[0];
				}
			};
			this.get_device_list();
		},
		mkDvSt: function mkDvSt(row) {
			return this.sstatus[row.terminalStatus];
		},
		get_device_list: function get_device_list() {
			var _this6 = this;

			this.device_loading = true;
			this.$getNonItDv(this.select_form.page, this.select_form.rows, this.mech, this.select_form.terminal_no, this.select_form.terminal_status, "", '', '', this.select_form.snBegin, this.select_form.snEnd, function (res) {
				_this6.device_loading = 0;
				if (res.status === 200) {
					_this6.deviceList = res.data;
					_this6.deviceTotal = res.total;
				} else {
					_this6.$message.error(res.message);
				}
			}, function () {
				_this6.device_loading = 0;
			});
		},
		deleteApps: function deleteApps(obj) {
			var _this7 = this;

			this.$showConfirm(this.$t("app_tip"), this.$t("terminal.list.delete_tips"), this.$t("app_sure"), this.$t("app_cancel"), "warning", function () {
				_this7.$changePspDel(obj.id, function (res) {
					if (res.status === 200) {
						_this7.$message.success(res.message);
						_this7.getUnstallList();
					} else {
						_this7.$message.error(res.message);
					}
				}, "");
			}, "");
		},
		batchDeleteRow: function batchDeleteRow() {
			var _this8 = this;

			this.$confirm(this.$t('terminal.list.delete_tips'), this.$t('lin_btn.tips'), {
				confirmButtonText: this.$t('lin_btn.confirm'),
				cancelButtonText: this.$t('lin_btn.cancel'),
				type: 'warning'
			}).then(function () {
				var ids = [];
				for (var i = 0; i < _this8.multipleSelection.length; i++) {
					ids.push(_this8.multipleSelection[i].id);
				}
				_this8.$changePspDel(String(ids), function (res) {
					if (res.status === 200) {
						_this8.$message.success(res.message);
						_this8.getUnstallList();
					} else {
						_this8.$message.error(res.message);
					}
				}, "");
			}).catch(function () {});
		},
		delete_all: function delete_all() {
			var _this9 = this;

			this.$confirm(this.$t('del_allData'), this.$t('lin_btn.tips'), {
				confirmButtonText: this.$t('lin_btn.confirm'),
				cancelButtonText: this.$t('lin_btn.cancel'),
				type: 'warning'
			}).then(function () {
				var sub_form = {
					appId: _this9.app_detail.id,
					terminalNo: _this9.uninsatll_form.terminalNo,
					mechId: _this9.uninsatll_form.mechId
				};
				_this9.$changePspDelAll(sub_form, function (res) {
					if (res.status === 200) {
						_this9.$message.success(res.message);
						_this9.uninsatll_form = {
							page: 1,
							rows: 20,
							terminalNo: "",
							mechId: "",
							appId: _this9.app_detail.id
						};
						var that = _this9;
						_this9.mechanismDatas = {
							value: null,
							placeholder: that.$t('lin_global.place_areaid'),
							callback: function callback(value) {
								that.uninsatll_form.mechId = value;
								that.getUnstallList();
							}
						};
						_this9.getUnstallList();
					} else {
						_this9.$message.error(res.message);
					}
				}, "");
			}).catch(function () {});
		},
		getUnstallList: function getUnstallList() {
			var _this10 = this;

			this.$changePspDeviceList(this.uninsatll_form, function (res) {
				_this10.loading = 0;
				if (res.status === 200) {
					_this10.uninstallTotal = res.total;
					_this10.uninstallData = res.data;
				} else {
					_this10.$message(res.message);
				}
			}, function () {
				_this10.$message.error(_this10.$t("app_rqsError"));
			});
		}
	},
	created: function created() {
		this.config = this.$getWObj().updatePspDetail;
		this.app_detail = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.config.data));
		this.uninsatll_form.appId = this.app_detail.id;
		if (this.config.type == 1) {
			this.show_push = true;
			this.get_device_list();
		}
		console.log(this.app_detail);
		this.getUnstallList();
	}
});

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_tyc__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_tyc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_global_tyc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_tagc__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_tagc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_tagc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_global_mechanism_selector_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		tyc: __WEBPACK_IMPORTED_MODULE_2__components_global_tyc___default.a,
		tagc: __WEBPACK_IMPORTED_MODULE_3__components_global_tagc___default.a,
		MechanismSelector: __WEBPACK_IMPORTED_MODULE_4__components_global_mechanism_selector_vue___default.a
	},
	data: function data() {
		var _this2 = this;

		var dstCheck = function dstCheck(rule, value, callback) {
			if (!value) {
				callback(new Error(_this2.$t('app_select')));
			} else {
				callback();
			}
		};
		var tagCheck = function tagCheck(rule, value, callback) {
			if (!value) {
				callback(new Error(_this2.$t('noVerTag')));
			} else {
				callback();
			}
		};
		var that = this;
		return {
			tqobj: '',
			ulinfo: {
				tip: this.$t('app_ulAppState_2'),
				index: 0,
				icons: ['el-icon-upload', 'el-icon-circle-check fs-icon', 'el-icon-close fs-icon']
			},
			mechanismId: window.localStorage['mechanismId'],
			status: '',

			stModel: '',
			channels: [],
			channelId: '',
			rules: {
				appId: [{
					required: true,
					message: this.$t('app_input'),
					trigger: 'blur'
				}],
				appName: [{
					required: true,
					message: this.$t('app_inputName'),
					trigger: 'blur'
				}],
				appVersion: [{
					required: true,
					message: this.$t('app_inputVer'),
					trigger: 'blur'
				}],
				verTag: [{
					required: true,
					message: this.$t('app_inputVerTag'),
					trigger: 'blur',
					validator: tagCheck
				}],
				packageName: [{
					required: true,
					message: this.$t('app_inputPkg'),
					trigger: 'blur'
				}],
				memo: [{
					required: true,
					message: this.$t('app_inputIntrol'),
					trigger: 'blur'
				}],
				distributorId: [{
					required: true,
					message: this.$t('app_select'),
					trigger: 'blur'
				}],
				appTypeValue: [{
					required: true,
					message: this.$t('app_select'),
					trigger: 'blur',
					validator: dstCheck
				}]
			},
			upinfo_1: true,
			upinfo_2: true,
			upinfo_3: true,
			tipColor_1: {
				color: '#13CE66'
			},
			tipColor_2: {
				color: '#13CE66'
			},
			tipColor_3: {
				color: '#13CE66'
			},
			form: {
				appName: '',
				appVersion: '',
				fileType: 2,
				pspAppUrl: '',
				pspAppSize: "",
				pspAppHash: '',
				cer1Url: "",
				cer1Size: "",
				cer1Hash: "",
				cer2Url: "",
				cer2Size: "",
				cer2Hash: ""
			},
			showPic: {
				value: 0,
				data: ''
			},
			srchValue: '',
			installTypes: [{
				label: this.$t('app_autoInstall'),
				value: 0
			}],
			fileSize: 0,
			tableData: [],
			checkDesc: '',
			radio: '1',
			smImageUrl: '',
			bgImageUrl: '',
			dialogVisible: false,
			appTypes: [],
			loading: 0,
			loading1: 0,
			loadingBig: 0,
			loadingSm: 0,
			config: {},
			cp0: '',
			cp1: '',
			cp2: '',
			cp3: '',
			cp4: '',
			captures: [],
			fileList: [],
			fileLists: [],
			fileListss: [],
			isUpload: 0,
			index: 1,
			total: 0,
			file_id: 0
		};
	},

	computed: {
		uData: function uData() {
			return {
				token: 1234
			};
		},
		fileUploadUrl: function fileUploadUrl() {
			var vl = this.$urls.webUrl + "/tms-server-web/file/fileupload.do";
			return vl;
		}
	},
	created: function created() {
		this.init();
	},

	methods: {
		editApp: function editApp(row) {},
		getChannels: function getChannels() {
			var _this3 = this;

			var _this = this;
			this.$getChannelList(10000, 1, '', '', '', function (res) {
				if (res.status === 200) {
					_this.channels = res.data;
				} else {
					_this3.$message.error(res.message);
				}
			}, function () {
				_this3.$message.error(_this3.$t('app_rqsError'));
			});
		},
		getStatus: function getStatus(value) {
			switch (value) {
				case '0':
					return this.$t('app_prePushVerify');
				case '1':
					return this.$t('app_preVerify');
				case '2':
					return this.$t('app_verifyPass');
				case '3':
					return this.$t('app_verifyNotPass');
			}
		},
		hBlur: function hBlur(name) {
			this.$refs[name].validate(function (valid) {
				if (valid) {} else {
					return false;
				}
			});
		},
		dateFormat: function dateFormat(row, column) {
			var date = row[column.property];
			if (date === undefined) {
				return '';
			}
			return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD hh:mm:ss');
		},
		deleteCapture0: function deleteCapture0() {
			this.cp0 = '';
			this.cp0Value = '';
		},
		deleteCapture1: function deleteCapture1() {
			this.cp1 = '';
			this.cp1Value = '';
		},
		deleteCapture2: function deleteCapture2() {
			this.cp2 = '';
			this.cp2Value = '';
		},
		deleteCapture3: function deleteCapture3() {
			this.cp3 = '';
			this.cp3Value = '';
		},
		deleteCapture4: function deleteCapture4() {
			this.cp4 = '';
			this.cp4Value = '';
		},
		imgFullUrl: function imgFullUrl(path) {
			if (path) {
				return this.$urls.prefix + path;
			} else {
				return '';
			}
		},
		close: function close() {
			this.$router.go(-1);
		},
		isShowCommon: function isShowCommon(isShow) {
			if (isShow && (this.config.type === 2 || this.config.type === 3)) {
				return 1;
			} else if (!isShow && this.config.type !== 2 && this.config.type !== 3) {
				return 1;
			} else {
				return 0;
			}
		},
		uploadApp: function uploadApp(formName) {
			var _this4 = this;

			this.$refs[formName].validate(function (valid) {
				if (valid) {
					_this4.loading = 1;
					if (_this4.config.type === 1) {
						_this4.$editPsp(_this4.form, function (res) {
							console.log(res);
							_this4.loading = 0;
							if (res.status === 200) {
								_this4.$router.go(-1);
							} else {
								_this4.$message(res.message);
							}
						}, function () {
							_this4.loading = 0;
							_this4.$message(_this4.$t('app_rqsError'));
						});
					} else {
						_this4.$changePspAdd(_this4.form, function (res) {
							console.log(res);
							_this4.loading = 0;
							if (res.status === 200) {
								_this4.$message.success(res.message);

								_this4.$setWObj("updatePspDetail", {
									data: res.data,
									type: 1
								});
								_this4.$router.push({
									path: '/updatePsp/detail'
								});
							} else {
								_this4.$message(res.message);
							}
						}, function () {
							_this4.loading = 0;
							_this4.$message(_this4.$t('app_rqsError'));
						});
					}
				} else {
					return false;
				}
			});
		},
		fileUploadSuccess: function fileUploadSuccess(res, file) {
			if (res.status === 200) {
				this.form.pspAppUrl = res.fileUrl;
				this.form.pspAppSize = res.appSize;
				this.form.pspAppHash = res.md5;
				this.fileList = [{
					name: file.name
				}];
				this.upinfo_1 = false;
				this.tipColor_1 = {
					color: '#13CE66'
				};
			} else {
				this.upinfo_1 = true;
				this.form.pspAppUrl = "";
				this.form.pspAppSize = "";
				this.form.pspAppHash = "";
				this.fileList = [];
				this.$message.error(res.message);
				this.tipColor_1 = {
					color: '#FF4949'
				};
			}
		},
		fileUploadSuccesss: function fileUploadSuccesss(res, file) {
			if (res.status === 200) {
				this.form.cer1Url = res.fileUrl;
				this.form.cer1Size = res.appSize;
				this.form.cer1Hash = res.md5;
				this.fileLists = [{
					name: file.name
				}];
				this.upinfo_2 = false;
				this.tipColor_2 = {
					color: '#13CE66'
				};
			} else {
				this.upinfo_2 = true;
				this.form.cer1Url = "";
				this.form.cer1Size = "";
				this.form.cer1Hash = "";
				this.fileLists = [];
				this.$message.error(res.message);
				this.tipColor_2 = {
					color: '#FF4949'
				};
			}
		},
		fileUploadSuccessss: function fileUploadSuccessss(res, file) {
			if (res.status === 200) {
				this.form.cer2Url = res.fileUrl;
				this.form.cer2Size = res.appSize;
				this.form.cer2Hash = res.md5;
				this.fileListss = [{
					name: file.name
				}];
				this.upinfo_3 = false;
				this.tipColor_3 = {
					color: '#13CE66'
				};
			} else {
				this.upinfo_3 = true;
				this.form.cer2Url = "";
				this.form.cer2Size = "";
				this.form.cer2Hash = "";
				this.fileListss = [];
				this.$message.error(res.message);
				this.tipColor_3 = {
					color: '#FF4949'
				};
			}
		},
		fileBeforeUpload: function fileBeforeUpload(file) {},
		handleRemove_1: function handleRemove_1(file, fileList) {
			this.fileList = [];
			this.upinfo_1 = true;
			this.form.pspAppUrl = "";
			this.form.pspAppSize = "";
			this.form.pspAppHash = "";
		},
		handleRemove_2: function handleRemove_2(file, fileList) {
			this.fileLists = [];
			this.upinfo_2 = true;
			this.form.cer1Url = "";
			this.form.cer1Size = "";
			this.form.cer1Hash = "";
		},
		handleRemove_3: function handleRemove_3(file, fileList) {
			this.fileListss = [];
			this.upinfo_3 = true;
			this.form.cer2Url = "";
			this.form.cer2Size = "";
			this.form.cer2Hash = "";
		},
		handleRemoves: function handleRemoves(file, fileList) {
			if (this.fileLists.length > 1) {
				for (var i = 0; i < this.fileLists.length; i++) {
					if (file.uid == this.fileLists[i].uid) {
						if (i == 0) {
							this.form.cer1Url = this.form.cer1Url.split(",")[1];
							this.form.cer1Size = this.form.cer1Size.split(",")[1];
							this.form.cer1Hash = this.form.cer1Hash.split(",")[1];
						} else {
							this.form.cer1Url = this.form.cer1Url.split(",")[0];
							this.form.cer1Size = this.form.cer1Size.split(",")[0];
							this.form.cer1Hash = this.form.cer1Hash.split(",")[0];
						}
					}
				}
				this.fileLists = fileList;
			} else {
				this.form.cer1Url = "";
				this.form.cer1Size = "";
				this.form.cer1Hash = "";
				this.fileLists = [];
			}

			console.log(this.form);
			console.log(this.fileLists);
		},
		fillEdit: function fillEdit() {
			var data = this.config.data;
			this.form = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.config.data));
			this.fileList = [{
				name: this.form.pspAppUrl
			}];
			this.fileLists = this.form.cer1Url ? [{
				name: this.form.cer1Url
			}] : [];
			this.fileListss = this.form.cer2Url ? [{
				name: this.form.cer2Url
			}] : [];
			this.upinfo_1 = false;
			this.tipColor_1 = {
				color: '#13CE66'
			};
			this.upinfo_2 = this.form.cer1Url ? false : true;
			this.tipColor_2 = {
				color: '#13CE66'
			};
			this.upinfo_3 = this.form.cer2Url ? false : true;
			this.tipColor_3 = {
				color: '#13CE66'
			};

			console.log(this.fileLists);
		},
		cancel: function cancel() {
			this.$router.go(-1);
		},
		init: function init() {
			this.config = this.$getWObj().editUpdatePSPConfig;
			console.log('config', this.config);

			switch (this.config.type) {
				case 0:
					break;
				case 1:
					this.fillEdit();
					break;
			}
		}
	},
	mounted: function mounted() {}
});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {
      pickerOptions0: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      info: {},
      loading: false,
      widthps: '22%',
      isNewVer: false,
      isNewBlt: false,
      isView: false,
      vform: {
        ver: '',
        date: '',
        content: ''
      },
      bform: {
        title: '',
        content: ''
      }
    };
  },

  props: ['config'],
  watch: {
    config: function config() {
      if (!this.config) return;
      if (this.config.type == 0) {
        this.isNewVer = true;
        if (this.config.edit) this.getVer();
      } else if (this.config.type == 1) {
        this.isNewBlt = true;
        if (this.config.edit) this.getBlt();
      } else {
        var config = this.config;
        if (config.vinfo) {
          this.info = config.vinfo;
        } else if (config.binfo) {
          this.info = config.binfo;
        }
        this.isView = true;
      }
    }
  },
  computed: {},
  methods: {
    getPre: function getPre() {
      var titles = [this.$t('app_verupdate'), this.$t('app_pltfblt')];
      var index = this.config.vinfo ? 0 : 1;
      return '【' + titles[index] + '】';
    },
    getVer: function getVer() {
      var _this = this;

      this.loading = true;
      this.$udVerDetail(this.config.id, function (res) {
        _this.loading = false;
        if (res.status === 200) {
          _this.vform.ver = res.data.version;
          _this.vform.date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(res.data.opetime);
          _this.vform.content = res.data.memo;
        } else {
          _this.$message(res.message);
        }
      }, function () {
        _this.loading = false;
        _this.$message.error(_this.$t('app_rqsError'));
      });
    },
    getBlt: function getBlt() {
      var _this2 = this;

      this.loading = true;
      this.$bulletinDetail(this.config.id, function (res) {
        _this2.loading = false;
        if (res.status === 200) {
          _this2.bform.title = res.data.noticeName;
          _this2.bform.content = res.data.noticeInfo;
        } else {
          _this2.$message(res.message);
        }
      }, function () {
        _this2.loading = false;
        _this2.$message.error(_this2.$t('app_rqsError'));
      });
    },
    submitVer: function submitVer() {
      var _this3 = this;

      if (!this.vform.date || !this.vform.ver || !this.vform.content) {
        this.$message(this.$t('app_inputCp'));
        return;
      }
      var date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.vform.date).format('YYYY-MM-DD');


      this.loading = true;
      if (this.config.edit) {
        this.$editUdVer(this.config.id, this.vform.ver, date, this.vform.content, function (res) {
          _this3.loading = false;
          if (res.status === 200) {
            _this3.$message.success(res.message);
            _this3.verClose();
          } else {
            _this3.$message(res.message);
          }
        }, function () {
          _this3.loading = false;
          _this3.$message.error(_this3.$t('app_rqsError'));
        });
      } else {
        this.$addUdVer(this.vform.ver, date, this.vform.content, function (res) {
          _this3.loading = false;
          if (res.status === 200) {
            _this3.$message.success(res.message);
            _this3.verClose();
          } else {
            _this3.$message(res.message);
          }
        }, function () {
          _this3.loading = false;
          _this3.$message.error(_this3.$t('app_rqsError'));
        });
      }
    },
    submitBlt: function submitBlt() {
      var _this4 = this;

      if (!this.bform.title || !this.bform.content) {
        this.$message(this.$t('app_inputCp'));
        return;
      }


      this.loading = true;
      if (this.config.edit) {
        this.$editBulletin(this.config.id, this.bform.title, this.bform.content, function (res) {
          _this4.loading = false;
          if (res.status === 200) {
            _this4.$message.success(res.message);
            _this4.bltClose();
          } else {
            _this4.$message(res.message);
          }
        }, function () {
          _this4.loading = false;
          _this4.$message.error(_this4.$t('app_rqsError'));
        });
      } else {
        this.$addBulletin(this.bform.title, this.bform.content, function (res) {
          _this4.loading = false;
          if (res.status === 200) {
            _this4.$message.success(res.message);
            _this4.bltClose();
          } else {
            _this4.$message(res.message);
          }
        }, function () {
          _this4.loading = false;
          _this4.$message.error(_this4.$t('app_rqsError'));
        });
      }
    },
    viewClose: function viewClose() {
      this.isView = false;
      var config = this.config;
      if (config.vinfo && config.binfo) {
        this.config.vinfo = '';
        this.info = config.binfo;
        this.isView = true;
      } else if (config.callback) {
        config.callback();
      }
    },
    verClose: function verClose() {
      this.isNewVer = false;
      this.vform = {};
      if (this.config.callback) {
        this.config.callback();
      }
    },
    bltClose: function bltClose() {
      this.isNewBlt = false;
      this.bform = {};
      if (this.config.callback) {
        this.config.callback();
      }
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bdialog__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bdialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__bdialog__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    bdialog: __WEBPACK_IMPORTED_MODULE_1__bdialog___default.a
  },
  data: function data() {
    var that = this;
    return {
      userType: this.$getWObj().login.userType,
      bconfig: '',
      orderName: '',
      orderType: '',

      total: 0,
      index: 1,
      dvTotal: 0,
      loading: 0,
      appType: '',
      queryKey: ''
    };
  },

  computed: {},
  methods: {
    sortChange: function sortChange(vl) {
      switch (vl.prop) {
        case 'createTime':
          this.orderName = '2';
          break;
      }
      this.orderType = vl.order == 'descending' ? 'desc' : 'asc';
      this.getList();
    },
    bindOperate: function bindOperate(row) {
      var _this2 = this;

      this.dvLoading = 1;
      if (this.$appUrlTag === 0) {
        this.$bindApp('0', row.terminalNo, this.appId, function (res) {
          if (res.status === 200) {
            _this2.$message.success(_this2.$t('app_tipViewTask'));
          } else {
            _this2.$message.error(res.message);
          }
          _this2.dvLoading = 0;
        }, function () {
          _this2.dvLoading = 0;
        });
      } else {
        this.$bindApp1(localStorage.mechanismId, row.terminalNo, this.appId, function (res) {
          if (res.status === 200) {
            _this2.$message.success(_this2.$t('app_tipViewTask'));
          } else {
            _this2.$message.error(res.message);
          }
          _this2.dvLoading = 0;
        }, function () {
          _this2.dvLoading = 0;
        });
      }
    },
    editBlt: function editBlt(row) {
      var _this = this;
      this.bconfig = {
        type: 1,
        edit: 1,
        id: row.id,
        vinfo: '',
        binfo: '',
        callback: function callback() {
          _this.getList();
        }
      };
    },
    query: function query() {
      this.getList();
    },
    selectChange: function selectChange(vl) {
      this.selectMid = vl;
      this.getList();
    },
    reset: function reset() {
      this.queryKey = '';
      this.appType = '';
      this.getList();
    },
    pageSelect: function pageSelect(index) {
      this.index = index;
      this.getList();
    },
    pageDvSelect: function pageDvSelect(index) {
      this.dvIndex = index;
      this.getDevices();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getList();
    },
    delBlt: function delBlt(obj) {
      var _this3 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this3.$delBulletin(obj.id, function (res) {
          if (res.status === 200) {
            _this3.getList();
            _this3.$message.success(res.message);
          } else {
            _this3.$message.error(res.message);
          }
        }, '');
      }, '');
    },
    submitApp: function submitApp(obj) {
      var _this4 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_tipVerify'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this4.loading = 1;
        _this4.$verifyFst(obj.recordId, '', '1', function (res) {
          _this4.loading = 0;
          if (res.status === 200) {
            _this4.getList();
            _this4.$message.success(res.message);
          } else {
            _this4.$message.error(res.message);
          }
        }, function () {
          _this4.loading = 0;
        });
      }, '');
    },
    cellClick: function cellClick(row, ev, col) {
      if (col.label && col.label === this.$t('app_operate')) {
        return;
      }

      this.bconfig = {
        type: 2,
        edit: false,
        vinfo: '',
        binfo: {
          title: row.noticeName,
          content: row.noticeInfo
        },
        callback: function callback() {}
      };
    },
    addBlt: function addBlt() {
      var _this = this;
      this.bconfig = {
        type: 1,
        edit: false,
        vinfo: '',
        binfo: '',
        callback: function callback() {
          _this.getList();
        }
      };
    },
    getList: function getList() {
      var _this5 = this;

      this.loading = 1;

      var name = this.queryKey ? this.queryKey : '';

      this.$bulletin(this.index, this.$gRow, name, function (res) {
        _this5.loading = 0;
        if (res.status === 200) {
          _this5.total = res.total;
          _this5.tableData = res.data;
        } else {
          _this5.$message(res.message);
        }
      }, function () {
        _this5.loading = 0;
        _this5.$message.error(_this5.$t('app_rqsError'));
      });
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('YYYY-MM-DD HH:mm:ss');
    }
  },
  mounted: function mounted() {

    this.getList();
  },
  destroyed: function destroyed() {}
});

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bdialog__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bdialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__bdialog__);


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    bdialog: __WEBPACK_IMPORTED_MODULE_0__bdialog___default.a
  },
  data: function data() {
    var that = this;
    return {
      userType: this.$getWObj().login.userType,
      bconfig: '',
      htmlexp: "",
      orderName: '',
      orderType: '',
      total: 0,
      index: 1,
      dvTotal: 0,
      loading: 0,
      appType: '',
      queryKey: ''
    };
  },

  computed: {},
  methods: {
    sortChange: function sortChange(vl) {
      switch (vl.prop) {
        case 'createTime':
          this.orderName = '2';
          break;
      }
      this.orderType = vl.order == 'descending' ? 'desc' : 'asc';
      this.getList();
    },
    editVer: function editVer(row) {
      var _this = this;
      this.bconfig = {
        type: 0,
        edit: true,
        id: row.id,
        vinfo: '',
        binfo: '',
        callback: function callback() {
          _this.getList();
        }
      };
    },
    query: function query() {
      this.getList();
    },
    selectChange: function selectChange(vl) {
      this.selectMid = vl;
      this.getList();
    },
    pageSelect: function pageSelect(index) {
      this.index = index;
      this.getList();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getList();
    },
    delVer: function delVer(obj) {
      var _this2 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this2.$delUdVer(obj.id, function (res) {
          if (res.status === 200) {
            _this2.getList();
            _this2.$message.success(res.message);
          } else {
            _this2.$message.error(res.message);
          }
        }, '');
      }, '');
    },
    addVer: function addVer() {
      var _this = this;
      this.bconfig = {
        type: 0,
        edit: false,
        vinfo: '',
        binfo: '',
        callback: function callback() {
          _this.getList();
        }
      };
    },
    getList: function getList() {
      var _this3 = this;

      this.loading = 1;


      this.$udVerList(this.index, this.$gRow, function (res) {

        _this3.loading = 0;
        if (res.status === 200) {
          _this3.total = res.total;
          _this3.tableData = res.data;
        } else {
          _this3.$message(res.message);
        }
      }, function () {
        _this3.loading = 0;
        _this3.$message.error(_this3.$t('app_rqsError'));
      });
    }
  },
  mounted: function mounted() {

    this.getList();
  },
  destroyed: function destroyed() {}
});

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      submitForm: {
        roleName: "",
        memo: "",
        token: localStorage.getItem('user'),
        menuId: "",
        subId: ""
      },
      planeMenuList: [],
      menuList: [],
      editRules: {
        roleName: [{ required: true, message: this.$t('menuConfig.role.notBlankName'), trigger: 'blur' }]
      },

      resultData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      alreadyCheckAll: false
    };
  },
  mounted: function mounted() {
    var that = this;
    that.fetchData();
  },

  methods: {
    resetForm: function resetForm() {
      var that = this;

      that.alreadyCheckAll = false;
      this.$refs.tree.setCheckedKeys([]);

      this.$refs['submitForm'].resetFields();
    },
    checkAll: function checkAll() {
      var that = this;
      if (that.resultData && that.resultData.length > 0) {
        that.alreadyCheckAll = !that.alreadyCheckAll;

        if (that.alreadyCheckAll == true) {
          var checkArray = [];
          for (var i = 0; i < that.resultData.length; i++) {
            checkArray.push(that.resultData[i]['menuId']);
          }

          if (checkArray.length > 0) {
            this.$refs.tree.setCheckedKeys(checkArray);
          }
        } else {
          this.$refs.tree.setCheckedKeys([]);
        }
      }
    },
    addRole: function addRole() {
      var that = this;

      this.$refs['submitForm'].validate(function (result) {
        var _this = this;

        if (result) {
          if (that.getCheckedKeysTwo() !== "") {
            that.submitForm.subId = that.getCheckedKeysTwo();
          }
          console.log('subId.........');
          console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(that.submitForm.subId, null, 2));

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/role/addRole.do', that.submitForm).then(function (res) {
            if (res.data && res.data.status && res.data.status === 200) {
              that.$message(_this.$t('menuConfig.role.addSuccess'));

              that.$router.push({ path: '/roleManager' });
            }
          });
        }
      }.bind(that));
    },
    getCheckedKeysTwo: function getCheckedKeysTwo() {

      var resultSubIdString = "";

      var copyPlaneMenuData = __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.extend(true, [], this.planeMenuList);

      var checkKeysList = this.$refs.tree.getCheckedKeys();

      console.log(checkKeysList);

      var getObjectByMenuId = function getObjectByMenuId(menuId) {
        var currentObj = null;

        var len = copyPlaneMenuData.length;

        for (var i = 0; i < len; i++) {
          var o = copyPlaneMenuData[i];
          if (o.menuId === menuId) {
            currentObj = o;
            break;
          }
        }

        return currentObj;
      };

      var getSubIdByMenuId = function getSubIdByMenuId(menuId) {
        var cObject = getObjectByMenuId(menuId);

        if (cObject) {
          resultSubIdString += cObject.subId + ",";
          copyPlaneMenuData = copyPlaneMenuData.filter(function (child) {
            if (menuId !== child.menuId) {
              return child;
            }
          });
          if (cObject.superId && cObject.superId !== "0") {
            getSubIdByMenuId(cObject.superId);
          }
        }
      };

      if (checkKeysList && checkKeysList.length > 0) {
        var leng = checkKeysList.length;
        for (var i = 0; i < leng; i++) {
          var selectMenuId = checkKeysList[i];
          getSubIdByMenuId(selectMenuId);
        }
      }

      return resultSubIdString.substring(0, resultSubIdString.length - 1);
    },
    fetchData: function fetchData() {
      var that = this;

      var re = [];
      var toPlaneMenuList = function toPlaneMenuList(data) {
        data.forEach(function (value) {
          var tmp = null;
          if (value.children) {
            var tChildNode = __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.extend(true, {}, value);
            delete tChildNode.children;
            re.push(tChildNode);
            tmp = toPlaneMenuList(value.children);
          } else {
            tmp = value;
          }
          if (tmp) re.push(tmp);
        });
      };

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/menu/getAllMenu.do', { token: localStorage.getItem('user') }).then(function (res) {
        if (res.data && res.data.status && res.data.status === 200) {
          that.resultData = res.data.data;

          toPlaneMenuList(that.resultData);

          that.planeMenuList = re;
        }
      });
    }
  }
});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      submitForm: {
        token: localStorage.getItem('user'),
        menuId: ""
      },
      planeMenuList: null,
      menuList: [],

      resultData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      }
    };
  },
  mounted: function mounted() {
    var that = this;
    that.fetchData();
  },

  methods: {
    updateRole: function updateRole() {
      var _this = this;

      var that = this;

      that.submitForm.subId = that.getCheckedKeysTwo();

      console.log('返回的subId拼接字符串:');
      console.log(that.submitForm.subId);

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/role/editRoleByRights.do', { roleId: this.$route.params.id, subId: that.submitForm.subId }).then(function (res) {
        if (res.data && res.data.status && res.data.status === 200) {
          that.$message(_this.$t('menuConfig.role.updateSuccess'));
          that.$router.push({ path: '/roleManager' });
        }
      });
    },
    getCheckedKeysTwo: function getCheckedKeysTwo() {

      var resultSubIdString = "";

      var copyPlaneMenuData = __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.extend(true, [], this.planeMenuList);

      var checkKeysList = this.$refs.tree.getCheckedKeys();

      var getObjectByMenuId = function getObjectByMenuId(menuId) {
        var currentObj = null;

        var len = copyPlaneMenuData.length;

        for (var i = 0; i < len; i++) {
          var o = copyPlaneMenuData[i];
          if (o.menuId === menuId) {
            currentObj = o;
            break;
          }
        }

        return currentObj;
      };

      var getSubIdByMenuId = function getSubIdByMenuId(menuId) {
        var cObject = getObjectByMenuId(menuId);

        if (cObject) {
          resultSubIdString += cObject.subId + ",";
          copyPlaneMenuData = copyPlaneMenuData.filter(function (child) {
            if (menuId !== child.menuId) {
              return child;
            }
          });
          if (cObject.superId && cObject.superId !== "0") {
            getSubIdByMenuId(cObject.superId);
          }
        }
      };

      if (checkKeysList && checkKeysList.length > 0) {
        var leng = checkKeysList.length;
        for (var i = 0; i < leng; i++) {
          var selectMenuId = checkKeysList[i];
          getSubIdByMenuId(selectMenuId);
        }
      }

      return resultSubIdString.substring(0, resultSubIdString.length - 1);
    },
    resetCheck: function resetCheck() {
      this.$refs.tree.setCheckedKeys([]);
    },
    fetchData: function fetchData() {
      var _this2 = this;

      var that = this;

      var re = [];
      var toPlaneMenuList = function toPlaneMenuList(data) {
        data.forEach(function (value) {
          var tmp = null;
          if (value.children) {
            var tChildNode = __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.extend(true, {}, value);
            delete tChildNode.children;
            re.push(tChildNode);
            tmp = toPlaneMenuList(value.children);
          } else {
            tmp = value;
          }
          if (tmp) re.push(tmp);
        });
      };

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/menu/getAllMenu.do', { token: localStorage.getItem('user') }).then(function (res) {
        if (res.data && res.data.status && res.data.status === 200) {
          that.resultData = res.data.data;
          toPlaneMenuList(that.resultData);

          that.planeMenuList = re;

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/role/selectMenuList.do', { roleId: _this2.$route.params.id }).then(function (res) {
            if (res.data && res.data.status && res.data.status === 200) {
              var checkArray = [];

              var selectedMenuDataList = res.data.data;

              var noParentArray = __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.extend(true, [], _this2.planeMenuList);

              noParentArray = noParentArray.filter(function (c) {
                if (c.menuStatus !== "1") return c;
              });

              var onArray = function onArray(mid) {
                var flag = null;
                var size = noParentArray.length;
                for (var i = 0; i < size; i++) {
                  if (noParentArray[i]['subId'] === mid) {
                    flag = noParentArray[i]['menuId'];
                    break;
                  } else {}
                }
                return flag;
              };

              var selectLength = selectedMenuDataList.length;
              for (var i = 0; i < selectLength; i++) {
                var menuId = onArray(selectedMenuDataList[i]['subId']);
                if (menuId) {
                  checkArray.push(menuId);
                }
              }

              console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(checkArray, null, 2));
              if (checkArray.length > 0) {
                _this2.$refs.tree.setCheckedKeys(checkArray);
              }
            }
          });
        }
      });
    }
  }
});

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_url__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      roleMultipleSelect: [],

      loading: false,

      roleAllot: false,

      roleSubList: [],

      dataList: [],

      roleRightNames: [],

      rights: [],

      currentPage: 1,

      totalRecords: 0,

      editInfoVisible: false,

      editInfoPreViewData: {
        roleId: null,
        roleName: null,
        memo: null
      },
      editRules: {
        roleName: [{ required: true, message: this.$t('menuConfig.role.notBlankName'), trigger: 'blur' }]
      },
      selectRoleId: null
    };
  },
  mounted: function mounted() {
    var that = this;
    that.fetchData(1);
  },

  methods: {
    toggleSelection: function toggleSelection(rows) {
      var _this2 = this;

      var r = rows.filter(function (v) {
        if (v.type === 1) return true;
      });

      if (r) {
        r.forEach(function (row) {
          _this2.$refs.multipleTable.toggleRowSelection(row);
        });
      }
    },
    savePermission: function savePermission() {

      var that = this;

      var subRoleIds = "";
      if (this.roleMultipleSelect) {
        this.roleMultipleSelect.forEach(function (item) {
          subRoleIds += item.roleId + ",";
        });
        subRoleIds = subRoleIds ? subRoleIds.substring(0, subRoleIds.length - 1) : "";
      }

      this.$editRoleMgList(this.selectRoleId, subRoleIds, function (res) {
        that.roleAllot = false;
      }, function (err) {});
    },
    handleSelectionChange: function handleSelectionChange(val) {
      console.log(val);
      this.roleMultipleSelect = val;
    },
    showRoleDialog: function showRoleDialog(row) {
      var _this3 = this;

      this.selectRoleId = row.roleid;
      this.$roleMgList(row.roleid, function (res) {
        _this3.loading = false;
        if (res.status === 200) {
          _this3.roleAllot = true;
          _this3.roleSubList = res.data;
          var _this = _this3;
          _this3.roleMultipleSelect = [];
          setTimeout(function () {
            _this.toggleSelection(_this3.roleSubList);
          }, 100);
        } else {
          _this3.$message.error(res.message);
        }
      }, function (error) {
        _this3.loading = false;
        _this3.$message.error(_this3.$t('app_rqsError'));
      });
    },
    jump: function jump(uri) {
      this.$router.push({ path: uri });
    },
    updateRoleInfo: function updateRoleInfo() {
      var _this4 = this;

      var that = this;
      that.editInfoVisible = false;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/role/editRole.do', that.editInfoPreViewData).then(function (res) {
        if (res.data && res.data.status && res.data.status === 200) {
          that.$message(_this4.$t('menuConfig.role.updateSuccess'));
          that.fetchData(1);
        }
      });
    },
    editRow: function editRow(record) {

      var that = this;

      that.editInfoPreViewData = {
        roleId: record.roleid,
        roleName: record.rolename,
        memo: record.memo
      };

      that.editInfoVisible = true;
    },
    deleteRow: function deleteRow(roleId, rolename, index) {
      var _this5 = this;

      var that = this;
      that.$confirm(this.$t('mao_global.tip.confirmDelete') + rolename + this.$t('mao_global.tip.notReset'), this.$t('mao_global.tip.text'), {
        confirmButtonText: this.$t('mao_global.btn.ok'),
        cancelButtonText: this.$t('mao_global.btn.cancel'),
        type: 'warning'
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/role/delete.do', { roleId: roleId }).then(function (res) {
          if (res.data && res.data.status && res.data.status === 200) {

            that.$message(_this5.$t('menuConfig.role.deleteSuccess'));

            that.fetchData(1);
          }
        });
      }).catch(function () {});
    },
    fetchData: function fetchData(page) {
      var that = this;
      var params = { "page": page, "rows": 100, distributorid: '' };
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/role/list.do', params).then(function (res) {
        if (res.data) {
          if (!res.data.status) return;
          if (res.data.status !== 200) return;

          var rights = [];
          res.data.data.forEach(function (vl) {
            rights.push(vl.roleRightsName.split(','));
          });
          console.log(rights);
          that.rights = rights;
          that.dataList = res.data.data;
          that.totalRecords = res.data.total;
          that.currentPage = page;
        }
      });
    },

    roleRightNamesHandler: function roleRightNamesHandler(names) {

      var roleRightNames = names.roleRightsName.split(',');
      return roleRightNames;
    }
  }
});

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_df_png__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_df_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_df_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_system_ptask_pushdia_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_system_ptask_pushdia_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_system_ptask_pushdia_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;
    return {
      mechanismData: {
        callback: function callback(value) {
          _this.mech = value;

          _this.getList();
        }
      },
      pconfig: {},
      cfid: '',
      mech: '',
      srchValue: '',
      detail: '',
      dialogVisible: false,
      bindSt: {
        '0': this.$t('app_fail'),
        '1': this.$t('app_success')
      },
      bindVl: '',
      config: '',
      captures: [],
      loading: 0,
      tableData: [],
      tags: [],
      page: 1,
      index: 1,
      hiss: [],
      pageTotal: 0
    };
  },

  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue___default.a, pushdia: __WEBPACK_IMPORTED_MODULE_3__components_system_ptask_pushdia_vue___default.a
  },
  computed: {
    showUploadNew: function showUploadNew() {
      if (this.config) {
        if (this.config.isoperate === 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  methods: {
    repushRow: function repushRow(row) {
      var _this2 = this;

      this.loading = true;
      this.$repushFailSyscf(row.id, function (res) {
        _this2.loading = false;
        if (res.status == 200) {
          _this2.$message.success(res.message);
        } else {
          _this2.$message.error(res.message);
        }
      }, function () {
        _this2.loading = false;
      });
    },
    editCf: function editCf() {
      this.$setWObj('keyEdit', { type: 1, data: this.config, isSetLc: true });
      this.$router.push({ path: '/keyrule/detail/edit' });
    },
    showBindSt: function showBindSt(row) {
      return this.bindSt[row.status];
    },
    bindOp: function bindOp(row) {
      var _this3 = this;

      this.loading = 1;
      this.$keyAddDevice(row.terminalId, this.config.id, function (res) {
        _this3.loading = 0;
        if (res.status === 200) {
          _this3.dialogVisible = false;
          _this3.getList();
        } else {
          _this3.$message.error(res.message);
        }
      }, function () {
        _this3.loading = 0;
        _this3.$message.error(_this3.$t('app_rqsError'));
      });
    },
    query: function query() {
      this.getList();
    },
    srchDevice: function srchDevice() {
      this.getDevices();
    },
    addTer: function addTer() {
      var _this = this;
      this.pconfig = {
        type: 1,
        configId: this.cfid,

        close: function close() {
          _this.pconfig = '';
          _this.getList();
        }
      };
    },
    deleteApp: function deleteApp(obj) {
      var _this4 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        console.log(obj);
        _this4.$delFstRecord(obj.id, function (res) {
          if (res.status === 200) {
            _this4.getList();
            _this4.$message.success(res.message);
          } else {
            _this4.$message.error(res.message);
          }
        }, '');
      }, '');
    },
    unbind: function unbind(row) {
      var _this5 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {

        _this5.$delSyscfBindDv(row.id, function (res) {
          if (res.status == 200) {
            _this5.getList();
            _this5.$message.success(res.message);
          } else {
            _this5.$message.error(res.message);
          }
        }, '');
      }, '');
    },
    editApp: function editApp(row) {
      this.$setWObj('filestEdit', { type: 1, data: row });
      this.$router.push({ path: '/keyrule/detail/edit' });
    },
    getList: function getList() {
      var _this6 = this;

      this.loading = 1;
      var mech = this.mech ? this.mech : '';
      var name = this.queryKey ? this.queryKey : '';


      this.$syscfBindlist(this.cfid, this.page, this.$gRow, name, mech, function (res) {
        _this6.loading = 0;
        if (res.status === 200) {
          _this6.pageTotal = res.total;
          _this6.hiss = res.data;
        } else {
          _this6.$message(res.message);
        }
      }, function () {
        _this6.loading = 0;
        _this6.$message.error(_this6.$t('app_rqsError'));
      });
    },
    getStatus: function getStatus(value) {
      if (!value) return '';
      switch (value) {
        case '0':
          return { vl: this.$t('app_prePushVerify'), style: 'color:#8492A6;' };
        case '1':
          return { vl: this.$t('app_preVerify'), style: 'color:#F7BA2A;' };
        case '2':
          return { vl: this.$t('app_verifyPass'), style: 'color:#13CE66;' };
        case '3':
          return { vl: this.$t('app_verifyNotPass'), style: 'color:#FF4949;' };
      }
    },
    getDetail: function getDetail() {
      var _this7 = this;

      this.loading = 1;
      this.$syscfDetail(this.cfid, function (res) {
        _this7.loading = 0;
        if (res.status === 200) {
          _this7.detail = res.data;
        } else {
          _this7.$message.error(res.message);
        }
      }, function () {
        _this7.loading = 0;
        _this7.$message.error(_this7.$t('app_rqsError'));
      });
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('YYYY-MM-DD hh:mm:ss');
    },
    selectChange: function selectChange(vl) {
      this.getList();
    },
    pageSelect: function pageSelect(index) {
      this.page = index;
      this.getList();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getList();
    },
    delHis: function delHis(row) {
      var _this8 = this;

      this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
        confirmButtonText: this.$t('app_sure'),
        cancelButtonText: this.$t('app_cancel'),
        type: 'warning'
      }).then(function () {
        _this8.loading = 1;

        _this8.$delLauncherHistory(row.versionid, function (res) {
          _this8.loading = 0;
          if (res.status === 200) {

            _this8.$message.success(res.message);
          } else {
            _this8.$message.error(res.message);
          }
        }, function () {
          _this8.loading = 0;
        });
      }).catch(function () {});
    },
    imgFullUrl: function imgFullUrl(path) {
      if (path) {
        return this.$urls.prefix + path;
      } else {
        return '';
      }
    },
    uploadNew: function uploadNew() {
      var obj = { type: 2, data: this.config };
      var key = 'launcherEdit';
      this.$setWObj(key, obj);
      this.$router.push({ path: '/launch-newver' });
    }
  },
  mounted: function mounted() {
    this.cfid = this.$route.query.id;
    this.getDetail();
    this.getList();
  }
});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    var phoneCheck = function phoneCheck(rule, value, callback) {
      if (!_this.isLegalMobile(value)) {
        callback(new Error(_this.$t('app_phoneIllegal')));
      } else {
        callback();
      }
    };
    return {
      cfid: -1,
      fatherList: [],
      form: {
        name: '',
        addr: '',
        port: ''
      },
      rules: {
        name: [{ required: true, message: this.$t('app_input'), trigger: 'blur' }],
        addr: [{ required: true, message: this.$t('app_input'), trigger: 'blur' }],
        port: [{ required: true, message: this.$t('app_input'), trigger: 'blur' }]
      }
    };
  },

  methods: {
    getDetail: function getDetail() {
      var _this2 = this;

      this.$syscfDetail(this.cfid, function (res) {
        if (res.status == 200) {
          _this2.fillData(res.data);
        } else {
          _this2.$message(res.message);
        }
      }, function () {});
    },
    isLegalMobile: function isLegalMobile(tel) {
      var sMobile = tel;
      var regex = "^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\\d{8}$";
      var re = new RegExp(regex, 'g');
      if (!re.test(sMobile)) {
        return false;
      } else {
        return true;
      }
    },
    newform: function newform() {
      var _this3 = this;

      this.loading = 1;
      var form = this.form;
      this.$addSyscf(form.name, form.addr, form.port, function (res) {
        _this3.loading = 0;
        if (res.status === 200) {
          _this3.$router.go(-1);
        } else {
          _this3.$message.error(res.message);
        }
      }, function () {
        _this3.loading = 0;
      });
    },
    editform: function editform() {
      var _this4 = this;

      this.loading = 1;
      var form = this.form;
      this.$editSyscf(parseInt(this.cfid), form.name, form.addr, form.port, function (res) {
        _this4.loading = 0;
        if (res.status == 200) {
          _this4.$router.go(-1);
        } else {
          _this4.$message.error(res.message);
        }
      }, function () {
        _this4.loading = 0;
      });
    },
    save: function save(name) {
      var _this5 = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          if (_this5.cfid == -1) {
            _this5.newform();
          } else {
            _this5.editform();
          }
        } else {
          return false;
        }
      });
    },
    cancel: function cancel() {
      this.$router.go(-1);
    },
    fillData: function fillData(data) {
      this.form.name = data.configName;
      this.form.addr = data.address;
      this.form.port = data.port;
    }
  },
  mounted: function mounted() {
    this.cfid = this.$route.query.id;

    if (this.cfid != -1) {
      this.getDetail();
    }
  }
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default.a
  },
  data: function data() {
    var that = this;
    return {
      mechanismData: {
        callback: function callback(value) {
          that.mech = value;
          that.selectChange(value);
        }
      },
      dvLoading: 0,
      appId: '',
      channels: [],
      srchValue: '',
      channelId: '',
      cerTipMsg: '',
      status: '',
      dvIndex: 1,
      dialogVisible: 0,
      mechanismId: window.localStorage['mechanismId'],
      selectMid: '',
      tableData: [],
      dvTableData: [],
      appTypes: [],
      configs: [],
      appTypeValue: '',
      appStatusValue: '',
      total: 0,
      index: 1,
      dvTotal: 0,
      loading: 0,
      appType: '',
      queryKey: ''
    };
  },

  computed: {
    getDvStatus: function getDvStatus(value) {
      switch (value) {
        case '0':
          return this.$t('app_prePushVerify');
        case '1':
          return this.$t('app_preVerify');
        case '2':
          return this.$t('app_verifyPass');
        case '3':
          return this.$t('app_verifyNotPass');
      }
    }
  },
  methods: {
    handleSelectionChange: function handleSelectionChange(val) {
      this.configs = val;
    },
    toAdd: function toAdd() {
      this.$router.push({ path: '/sysconfig/add', query: { id: -1 } });
    },
    batchDel: function batchDel() {
      var _this = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_srmuldel') + '?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        var ids = [];
        _this.configs.forEach(function (item) {
          ids.push(item.id);
        });
        _this.delRqs(ids.toString());
      }, '');
    },
    bindOperate: function bindOperate(row) {
      var _this2 = this;

      this.dvLoading = 1;
      if (this.$appUrlTag === 0) {
        this.$bindApp('0', row.terminalNo, this.appId, function (res) {
          if (res.status === 200) {
            _this2.$message.success(_this2.$t('app_tipViewTask'));
          } else {
            _this2.$message.error(res.message);
          }
          _this2.dvLoading = 0;
        }, function () {
          _this2.dvLoading = 0;
        });
      } else {
        this.$bindApp1(localStorage.mechanismId, row.terminalNo, this.appId, function (res) {
          if (res.status === 200) {
            _this2.$message.success(_this2.$t('app_tipViewTask'));
          } else {
            _this2.$message.error(res.message);
          }
          _this2.dvLoading = 0;
        }, function () {
          _this2.dvLoading = 0;
        });
      }
    },
    getChannels: function getChannels() {
      var _this3 = this;

      this.$getChannelList(10000, 1, '', '', '', function (res) {
        if (res.status === 200) {
          _this3.channels = res.data;
        } else {
          _this3.$message.error(res.message);
        }
      }, function () {
        _this3.$message.error(_this3.$t('app_rqsError'));
      });
    },
    getStatus: function getStatus(value) {
      if (!value) return '';
      switch (value) {
        case '0':
          return { vl: this.$t('app_prePushVerify'), style: 'color:#8492A6;' };
        case '1':
          return { vl: this.$t('app_preVerify'), style: 'color:#F7BA2A;' };
        case '2':
          return { vl: this.$t('app_verifyPass'), style: 'color:#13CE66;' };
        case '3':
          return { vl: this.$t('app_verifyNotPass'), style: 'color:#FF4949;' };
      }
    },
    srchDevice: function srchDevice() {
      this.getDevices();
    },
    selectDvChange: function selectDvChange(vl) {
      this.getDevices();
    },
    pageDvSized: function pageDvSized(val) {
      this.$gRow = val;
      this.getDevices();
    },
    getDevices: function getDevices() {
      var _this4 = this;

      var vl = this.srchValue ? this.srchValue : '';
      var channel = this.channelId ? this.channelId : '';
      var status = this.status ? this.status : '';
      var appId = this.appId ? this.appId : '';
      this.dvLoading = 1;
      if (this.$appUrlTag === 0) {
        this.$getDevices(this.dvIndex, this.$gRow, channel, vl, status, '', appId, function (res) {
          _this4.dvLoading = 0;
          if (res.data) {
            _this4.dvTableData = res.data;
            _this4.dvTotal = res.total;
          }
        }, function () {
          _this4.dvLoading = 0;
        });
      } else {

        this.$getDevices1(this.dvIndex, this.$gRow, localStorage.mechanismId, vl, status, '', appId, function (res) {
          console.log('dv', res);
          _this4.dvLoading = 0;
          if (res.data) {
            _this4.dvTableData = res.data;
            _this4.dvTotal = res.total;
          }
        }, function () {
          _this4.dvLoading = 0;
        });
      }
    },
    editApp: function editApp(row) {
      this.$router.push({ path: '/sysconfig/edit', query: { id: row.id } });
    },
    pushApp: function pushApp(row) {

      this.$setWObj('pushList', { type: '13', data: row });
      this.$router.push({ path: '/stfile/push' });
    },
    query: function query() {
      this.getList();
    },
    selectChange: function selectChange(vl) {
      this.selectMid = vl;
      this.getList();
    },
    reset: function reset() {
      this.queryKey = '';
      this.appType = '';
      this.getList();
    },
    pageSelect: function pageSelect(index) {
      this.index = index;
      this.getList();
    },
    pageDvSelect: function pageDvSelect(index) {
      this.dvIndex = index;
      this.getDevices();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getList();
    },
    delRqs: function delRqs(ids) {
      var _this5 = this;

      this.loading = true;
      this.$delSyscf(ids, function (res) {
        _this5.loading = false;
        if (res.status == 200) {
          _this5.getList();
          _this5.$message.success(res.message);
        } else {
          _this5.$message.error(res.message);
        }
      }, function () {
        _this5.loading = false;
      });
    },
    deleteApp: function deleteApp(obj) {
      var _this6 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this6.delRqs(obj.id);
      }, '');
    },
    submitApp: function submitApp(obj) {
      var _this7 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_tipVerify'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this7.loading = 1;
        _this7.$verifyFst(obj.recordId, '', '1', function (res) {
          _this7.loading = 0;
          if (res.status === 200) {
            _this7.getList();
            _this7.$message.success(res.message);
          } else {
            _this7.$message.error(res.message);
          }
        }, function () {
          _this7.loading = 0;
        });
      }, '');
    },
    cellClick: function cellClick(row, ev, col) {
      if (!col.label || col.label === this.$t('app_operate')) {
        return;
      }
      this.$router.push({ path: '/sysconfig/detail', query: { id: row.id } });
    },
    jumpToUpload: function jumpToUpload() {

      this.$setWObj('keyEdit', { type: 0 });
      this.$router.push({ path: '/keyrule/add' });
    },
    getList: function getList() {
      var _this8 = this;

      this.loading = 1;

      var name = this.queryKey ? this.queryKey : '';

      this.$syscflist(this.index, this.$gRow, name, function (res) {
        _this8.loading = 0;
        if (res.status == 200) {
          _this8.total = res.total;
          _this8.tableData = res.data;
        } else {
          _this8.$message(res.message);
        }
      }, function () {
        _this8.loading = 0;
        _this8.$message.error(_this8.$t('app_rqsError'));
      });
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD HH:mm:ss');
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    }
  },
  mounted: function mounted() {
    this.getList();
  },
  destroyed: function destroyed() {}
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_TernoAutoCtrl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_TernoAutoCtrl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_TernoAutoCtrl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__node_modules_element_ui_packages_form_src_form_item_vue__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__node_modules_element_ui_packages_form_src_form_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__node_modules_element_ui_packages_form_src_form_item_vue__);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ElFormItem: __WEBPACK_IMPORTED_MODULE_6__node_modules_element_ui_packages_form_src_form_item_vue___default.a,
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_5__components_global_mechanism_selector_vue___default.a, AutoTerno: __WEBPACK_IMPORTED_MODULE_4__global_TernoAutoCtrl___default.a
  },
  data: function data() {
    var that = this;
    return {
      raw: '',
      terminalConfigForm: {
        checkUpdateTime: 0,
        pushTime: 20,
        data: {
          get: ['l'],
          set: {
            hb: 10
          }
        }
      },
      mechanismData: {
        placeholder: that.$t('lin_global.place_areaid'),
        callback: function callback(value) {
          that.value1 = value;
        }
      },
      exInfo: '',
      devices: 0,
      srcList: [],
      isSubmit: false,
      logoCheck: false,
      oldLogo: '',
      loading: 0,
      logo: '',
      logoValue: '',
      activeName: 'second',
      isShow: false,
      options: [{
        value: '0',
        label: this.$t('lin_global.label_areaid')
      }, {
        value: '1',
        label: this.$t('lin_global.shebeibei')
      }, {
        value: '2',
        label: this.$t('app_fileImport')
      }],
      arrdata: [],
      currentPage: 1,
      pageSize: 10,
      totalRecords: 0,
      value: '0',
      value1: '',
      areaList1: [],
      setForm: {
        url: '',
        port: ''
      },
      url: '',
      port: '',
      rules: {
        'url': [{
          type: 'string',
          required: true,
          message: this.$t('lin_global.fwqdzbnwk')
        }],
        'port': [{
          type: 'string',
          required: true,
          message: this.$t('lin_global.fwqdkhbnwk')
        }]
      }
    };
  },

  computed: {
    imgUploadUrl: function imgUploadUrl() {
      return this.$urls.picUrl;
    },
    downUrl: function downUrl() {
      return this.$host + '/tms-server-web/model/terminalNos.xlsx';
    }
  },
  created: function created() {
    this.getData(1);
  },

  watch: {
    'terminalConfigForm.data.set.hb': function terminalConfigFormDataSetHb(val, old) {
      var that = this;
      if (that.terminalConfigForm.checkUpdateTime < val + 5) {
        that.terminalConfigForm.checkUpdateTime = val + 5;
      }
    }
  },
  methods: {
    saveTerminalConfig: function saveTerminalConfig() {
      var _this = this;

      var that = this;

      var value = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(that.terminalConfigForm, null, 4);
      if (this.raw) {
        this.loading = true;
        this.$setDvSetting(this.raw.id, value, function (res) {
          _this.loading = false;
          _this.$message.success(res.message);
        }, function (error) {
          _this.loading = false;
          _this.$message.error(_this.$t('app_rqsError'));
        });
      } else {
        this.$message.error('error');
      }
    },
    onDvInputChange: function onDvInputChange(vl) {
      this.value1 = vl;
    },
    pushType: function pushType(row) {
      switch (row.type) {
        case '0':
          return this.$t('app_distributor');
          break;
        case '1':
          return this.$t('app_dv');
          break;
        case '2':
          return this.$t('terminal.list.import_btn');
          break;
      }
    },
    srcBefore: function srcBefore(file) {
      window[this.$route.path] = 1;
    },
    srcSuccess: function srcSuccess(res, file) {
      window[this.$route.path] = '';
      console.log('exres', res);
      if (res.status === 200) {
        this.srcList = [{ name: file.name }];
        this.exInfo = res.data;
        this.exInfo.file = file.name;
        this.devices = res.data.terNums;
      } else {
        if (this.exInfo.file) {
          this.srcList = [{ name: this.exInfo.file }];
        } else {
          this.srcList = [];
        }
        this.$message.error(res.message);
      }
    },
    handleClick: function handleClick(tab, event) {},
    defaultLogo: function defaultLogo() {
      var _this2 = this;

      this.loading = 1;
      this.$editLogo(localStorage.mechanismId, '', function (res) {
        _this2.loading = 0;
        if (res.status === 200) {
          _this2.$message.success(res.message);
          _this2.$store.dispatch('setHomeLogo', 'null');
          localStorage.logo = 'null';
          _this2.oldLogo = 'null';
          _this2.cancelLogo();
        } else {
          _this2.$message.error(res.message);
        }
      }, function () {
        _this2.loading = 0;
        _this2.$message.error(_this2.$t('app_rqsError'));
      });
    },
    saveLogo: function saveLogo() {
      var _this3 = this;

      if (!this.logoValue) {
        this.$message(this.$t('app_uploadPic'));
        return;
      }

      var sizeVl = this.logoCheck ? 1 : 0;
      console.log(sizeVl);

      this.loading = 1;
      this.$editLogo(localStorage.mechanismId, this.logoValue, function (res) {
        _this3.loading = 0;
        if (res.status === 200) {
          _this3.$message.success(res.message);
          _this3.oldLogo = _this3.logoValue;
          localStorage.logo = _this3.oldLogo;
          _this3.cancelLogo();
        } else {
          _this3.$message.error(res.message);
        }
      }, function () {
        _this3.loading = 0;
        _this3.$message.error(_this3.$t('app_rqsError'));
      });
    },
    cancelLogo: function cancelLogo() {
      this.logo = '';
      this.logoValue = '';
      this.$store.dispatch('setHomeLogo', this.oldLogo);
    },
    handleBgAvatarSuccess: function handleBgAvatarSuccess(res, file) {
      this.loading = 0;
      if (res.status !== 200) {
        this.$message.error(res.message);
      } else {
        this.logoValue = res.data;
        this.logo = URL.createObjectURL(file.raw);
        this.$store.dispatch('setHomeLogo', res.data);
      }
    },
    beforeBgAvatarUpload: function beforeBgAvatarUpload(file) {
      var size = file.size / 1024;
      if (size > 200) {
        this.$message.error(this.$t('app_fileOver') + '200k');
        return false;
      }
      this.loading = 1;
      return true;
    },

    formatStatus: function formatStatus(row, column) {
      return row.type == 0 ? this.$t('lin_global.label_areaid') : row.userStatus == 1 ? this.$t('lin_global.shebeibei') : '';
    },

    getAd1: function getAd1() {
      var _this4 = this;

      var params = { page: 1, rows: 10000 };
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__api_url__["a" /* baseurl */] + '/mechanism/list.do', params).then(function (res) {
        var obj = {
          'mechanismname': _this4.$t('lin_global.all_mechanism'),
          'mechanismid': ''
        };
        _this4.areaList1 = res.data.data;

        _this4.areaList1.unshift(obj);
      });
    },
    onCreate: function onCreate() {},
    submitRow: function submitRow(type, config, mechId, terminalNo) {
      var _this5 = this;

      var id = '';
      if (type === "0") {
        id = mechId;
      } else {
        id = terminalNo;
      }
      var params = { targetType: type, targetId: id, conf: config };
      this.$confirm(this.$t('lin_global.wdct'), this.$t('lin_btn.tips'), {
        confirmButtonText: this.$t('lin_btn.confirm'),
        cancelButtonText: this.$t('lin_btn.cancel'),
        type: 'warning'
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__api_url__["a" /* baseurl */] + '/sysConfig/setTmsServerConf.do', params).then(function (res) {
          if (res.data.status == 200) {
            _this5.$message.success(res.data.message);
          } else {
            _this5.$message.error(res.data.message);
          }
        });
      });
    },
    onChange: function onChange(val) {
      this.value1 = '';
      if (val === '0') {
        this.isShow = false;
      } else {
        this.isShow = true;
      }
    },
    onSave: function onSave() {
      var _this6 = this;

      this.$refs['setForm'].validate(function (valid) {

        if (valid) {
          if (_this6.value === '2' && !_this6.exInfo) {
            _this6.$message.error(_this6.$t('app_plsUpl'));
            return;
          }
          var host = _this6.setForm.url + ':' + _this6.setForm.port;
          var fn = _this6.exInfo.fileNo ? _this6.exInfo.fileNo : '';
          var params = { fileNo: fn, targetType: _this6.value, targetId: _this6.value1, conf: host };
          _this6.$confirm(_this6.$t('lin_global.tuisongtips') + '【' + host + '】', _this6.$t('lin_btn.tips'), {
            confirmButtonText: _this6.$t('lin_btn.confirm'),
            cancelButtonText: _this6.$t('lin_btn.cancel'),
            type: 'warning'
          }).then(function () {
            _this6.isSubmit = true;
            _this6.loading = 1;
            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__api_url__["a" /* baseurl */] + '/sysConfig/setTmsServerConf.do', params).then(function (res) {
              if (res.data.status == 200) {
                _this6.loading = 0;
                _this6.$message.success(res.data.message);
                _this6.isSubmit = false;
              } else {
                _this6.loading = 0;
                _this6.$message.error(res.data.message);
                _this6.isSubmit = false;
              }
            });
          }).catch(function () {
            _this6.loading = 0;
          });
        } else {
          _this6.loading = 0;
          _this6.$message.error(_this6.$t('lin_global.refs'));
          return false;
        }
      });
    },

    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getData(this.currentPage);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.getData(this.currentPage);
    },
    getData: function getData(page) {
      var _this7 = this;

      this.currentPage = page;
      var params = { page: page, rows: this.pageSize };

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__api_url__["a" /* baseurl */] + '/sysConfig/terConfigCount.do', params).then(function (res) {
        console.log('his res', res.data);
        _this7.arrdata = res.data.data;
        _this7.totalRecords = res.data.total;
        for (var i = 0; i < res.data.data.length; i++) {
          if (res.data.data[i].failNum > 0) {
            res.data.data[i]['submit'] = true;
          } else {
            res.data.data[i]['submit'] = false;
          }
        }
      });
    }
  },
  mounted: function mounted() {
    var _this8 = this;

    this.oldLogo = localStorage.logo;

    this.$getDvSetting(function (res) {
      if (res.status === 200) {
        var data = res.data;
        if (data.length > 0) {
          data = data[0];
          _this8.raw = data;
          _this8.terminalConfigForm = JSON.parse(data.value);
        }
      } else {
        _this8.$message.error(res.message);
      }
    }, '');
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    var _this9 = this;

    if (this.logo) {
      this.$showConfirm('', this.$t('app_logoLvTip'), this.$t('app_yes'), this.$t('app_no'), 'warning', function () {
        next();
        _this9.$store.dispatch('setHomeLogo', _this9.oldLogo);
      }, function () {
        return false;
      });
    } else {
      next();
      this.$store.dispatch('setHomeLogo', this.oldLogo);
    }
  }
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      orderType: '',
      orderName: '',
      name: '',
      index: 1,
      total: 0,
      dialogFormVisible: 0,
      tableData: [],
      loading: 0,
      editData: '',
      row: this.$gRow
    };
  },

  methods: {
    sortChange: function sortChange(vl) {
      switch (vl.prop) {
        case 'adtypeName':
          this.orderName = '1';
          break;
      }
      this.orderType = vl.order == 'descending' ? 'desc' : 'asc';
      this.getList(this.index);
    },
    cancelEdit: function cancelEdit() {
      this.dialogFormVisible = false;
    },
    edit: function edit(row) {
      this.editData = row;
      this.dialogFormVisible = 1;
    },
    del: function del(row) {
      var _this = this;

      this.$showConfirm('', this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warnning', function () {
        var id = row.adtypeId;
        _this.loading = 1;
        _this.$delAdType(id, function (res) {
          _this.loading = 0;
          if (res.status === 200) {
            _this.getList(_this.index);
          } else {
            _this.$message.error(res.message);
          }
        }, function () {
          _this.loading = 0;
        });
      });
    },
    pageSelect: function pageSelect(index) {
      this.getList(index);
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getList(this.index);
    },
    open: function open() {
      if (this.editData) {
        this.name = this.editData.adtypeName;
      }
    },
    close: function close() {
      this.editData = '';
      this.name = '';
    },
    showInput: function showInput() {
      this.dialogFormVisible = 1;
    },
    newData: function newData() {
      var _this2 = this;

      var vl = this.name;
      if (vl) {
        this.loading = 1;
        this.$addAdType(vl, function (res) {
          _this2.loading = 0;
          console.log(res);
          if (res.status === 200) {
            _this2.getList(_this2.index);
          } else {
            _this2.$message.error(res.message);
          }
        }, function () {
          _this2.loading = 0;
        });
        this.dialogFormVisible = 0;
      } else {
        this.$message.error(this.$t('app_inputAName'));
      }
    },
    editRqs: function editRqs() {
      var _this3 = this;

      var vl = this.name;
      if (vl) {
        this.loading = 1;
        this.$editAdType(this.editData.adtypeId, vl, function (res) {
          _this3.loading = 0;
          if (res.status === 200) {
            _this3.getList(_this3.index);
          } else {
            _this3.$message.error(res.message);
          }
        }, function () {
          _this3.loading = 0;
        });
        this.dialogFormVisible = 0;
      } else {
        this.$message.error(this.$t('app_inputAName'));
      }
    },
    sure: function sure() {
      if (this.editData) {
        this.editRqs();
      } else {
        this.newData();
      }
    },
    getList: function getList(index) {
      var _this4 = this;

      this.loading = 1;
      this.$adTypeList(this.$gRow, index, this.orderName, this.orderType, function (res) {
        console.log('res', res);
        _this4.loading = 0;
        if (res.status === 200) {
          console.log('data', res.data);
          _this4.tableData = res.data;
          _this4.total = res.total;
          _this4.index = index;
        } else {
          _this4.$message.error(res.message);
        }
      }, function () {
        _this4.loading = 0;
      });
    }
  },
  mounted: function mounted() {
    this.getList(this.index);
  }
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      orderType: '',
      orderName: '',
      name: '',
      row: this.$gRow,
      index: 1,
      total: 0,
      dialogFormVisible: 0,
      tableData: [],
      loading: 0,
      editData: ''
    };
  },

  methods: {
    sortChange: function sortChange(vl) {

      switch (vl.prop) {
        case 'appClassifyName':
          this.orderName = '1';
          break;
      }
      this.orderType = vl.order == 'descending' ? 'desc' : 'asc';
      this.getList(this.index);
    },
    cancelEdit: function cancelEdit() {
      this.dialogFormVisible = false;
    },
    edit: function edit(row) {
      this.editData = row;
      this.dialogFormVisible = 1;
    },
    del: function del(row) {
      var _this = this;

      this.$showConfirm('', this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warnning', function () {
        var id = row.appClassifyId;
        _this.loading = 1;
        _this.$delAppType(id, function (res) {
          _this.loading = 0;
          if (res.status === 200) {
            _this.getList(_this.index);
          } else {
            _this.$message.error(res.message);
          }
        }, function () {
          _this.loading = 0;
        });
      });
    },
    pageSelect: function pageSelect(index) {
      this.getList(index);
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getList(this.index);
    },
    open: function open() {
      if (this.editData) {
        this.name = this.editData.appClassifyName;
      }
    },
    close: function close() {
      this.editData = '';
      this.name = '';
    },
    showInput: function showInput() {
      this.dialogFormVisible = 1;
    },
    newData: function newData() {
      var _this2 = this;

      var vl = this.name;
      if (vl) {
        this.loading = 1;
        this.$addAppType(vl, function (res) {
          _this2.loading = 0;
          console.log(res);
          if (res.status === 200) {
            _this2.getList(_this2.index);
          } else {
            _this2.$message.error(res.message);
          }
        }, function () {
          _this2.loading = 0;
        });
        this.dialogFormVisible = 0;
      } else {
        this.$message.error(this.$t('app_inputAName'));
      }
    },
    editRqs: function editRqs() {
      var _this3 = this;

      var vl = this.name;
      if (vl) {
        this.loading = 1;
        this.$editAppType(this.editData.appClassifyId, vl, function (res) {
          _this3.loading = 0;
          if (res.status === 200) {
            _this3.getList(_this3.index);
          } else {
            _this3.$message.error(res.message);
          }
        }, function () {
          _this3.loading = 0;
        });
        this.dialogFormVisible = 0;
      } else {
        this.$message.error(this.$t('app_inputAName'));
      }
    },
    sure: function sure() {
      if (this.editData) {
        this.editRqs();
      } else {
        this.newData();
      }
    },
    getList: function getList(index) {
      var _this4 = this;

      this.loading = 1;
      this.$appTypeList(this.$gRow, index, this.orderName, this.orderType, function (res) {
        console.log('res', res);
        _this4.loading = 0;
        if (res.status === 200) {
          console.log('data', res.data);
          _this4.tableData = res.data;
          _this4.total = res.total;
          _this4.index = index;
        } else {
          _this4.$message.error(res.message);
        }
      }, function () {
        _this4.loading = 0;
      });
    }
  },
  mounted: function mounted() {
    this.getList(this.index);
  },
  destroyed: function destroyed() {}
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__account_accMess__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__account_accMess___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__account_accMess__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_df_png__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_df_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_df_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_url__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ssub: __WEBPACK_IMPORTED_MODULE_0__account_accMess___default.a
  },
  data: function data() {
    return {
      sortNo: '',
      sortTime: '',
      iRules: {
        firm: [{ required: true, message: this.$t('terminal.add.place_manufid'), trigger: 'blur' }],
        type: [{ required: true, message: this.$t('terminal.add.place_type'), trigger: 'blur' }],
        no: [{ required: true, message: this.$t('terminal.add.place_model'), trigger: 'blur' }],
        address: [{ required: true, message: this.$t('app_input'), trigger: 'blur' }]
      },
      firms: [],
      dvTypes: [],
      models: [],
      premcid: '',
      addInfo: {
        firmarr: '',
        typearr: '',
        noarr: '',
        address: null,
        firm: null,
        type: null,
        no: null,
        sobj: []
      },
      isAddInfo: false,
      pageOrder: 1,
      pageOrderTotal: 0,
      pageOrders: [],
      orderselecet: [],
      cerEvent: '',

      pageCer: 1,
      pageCerTotal: 0,
      pageCers: [],
      cerselecet: '',
      orderEvent: '',
      cusEvent: '',

      dvPage: 1,
      dvTotal: 0,
      dvs: [],

      config: '',
      captures: [],
      loading: 0,
      showDvDia: false,
      showCerDia: false,
      cerTypes: [this.$t('app_cerMgSelf'), this.$t('app_cerMgOther'), this.$t('app_cerMgCustomer')],
      sData: [],
      info: '',
      cers: [],

      importTermVisible: false,

      exFileName: '',
      fileList: [],
      action: __WEBPACK_IMPORTED_MODULE_3__api_url__["a" /* baseurl */] + '/terminal/importTers.do' + "?language=" + localStorage.getItem("system_lang") + '&token=' + localStorage.user,
      importIsSubmit: false,
      importTemplate: __WEBPACK_IMPORTED_MODULE_3__api_url__["b" /* urlAssets */].prefix + 'tms-server-web/model/terminals.xlsx'
    };
  },

  computed: {
    numTip: function numTip() {
      var str = this.$t('app_lineimporttip');
      return str;
    },
    isShowModel: function isShowModel() {
      return localStorage.userType == 0;
    },
    avtStyle: function avtStyle() {
      var url = this.config.data.appBigIcon ? this.imgFullUrl(this.config.data.appBigIcon) : __webpack_require__(6);

      return 'background-size: cover;background-position: center center;width:100%;height:100%;background-image: url(' + url + ')';
    },
    showUploadNew: function showUploadNew() {

      return true;
    }
  },
  methods: {
    sortChange: function sortChange(vl) {
      switch (vl.prop) {
        case 'terminalNo':
          this.sortNo = vl.order == 'descending' ? 'desc' : 'asc';
          this.sortTime = '';
          break;
        case 'terminalCreateTime':
          this.sortTime = vl.order == 'descending' ? 'desc' : 'asc';
          this.sortNo = '';
          break;
      }
      this.getDvs();
    },
    delCer: function delCer() {
      var _this2 = this;

      this.$confirm(this.$t('lin_global.confirmDelete'), this.$t('app_tip'), {
        confirmButtonText: this.$t('app_sure'),
        cancelButtonText: this.$t('app_cancel'),
        type: 'warning'
      }).then(function () {
        var data = _this2.cers[0];

        _this2.loading = 1;
        _this2.$delcer(data.certificateId, function (res) {
          _this2.loading = 0;
          if (res.status === 200) {
            _this2.cerList();
          } else {
            _this2.$message.error(res.message);
          }
        }, function () {
          _this2.loading = 0;
        });
      }).catch(function () {});
    },
    handleAvatarScucess: function handleAvatarScucess(res, file) {

      this.exCancel();

      if (res.status == 200) {
        this.$notify({
          title: this.$t('terminal.list.notify_title'),
          message: res.message,
          type: 'success',
          duration: 6000
        });

        var _this = this;
        setTimeout(function () {
          _this.getDvs();
        }, 800);
      } else {
        this.$notify.error({
          title: this.$t('terminal.list.notify_title'),
          message: res.message,
          duration: 6000
        });
      }
    },
    importCus: function importCus() {
      var _this3 = this;

      console.log(this.info);
      this.loading = 1;
      this.$importLineCer(this.cerselecet.id, this.info.mechanismid, function (res) {
        _this3.loading = 0;
        if (res.status === 200) {
          _this3.$message.success(res.message);
          _this3.cerList();
          _this3.showCerDia = false;
        } else {
          _this3.$message.error(res.message);
        }
      }, function () {
        _this3.loading = 0;
      });
    },
    importOrder: function importOrder() {
      var _this4 = this;

      this.addInfo.firm = this.addInfo.firmarr ? this.addInfo.firmarr : '';
      this.addInfo.type = this.addInfo.typearr ? this.addInfo.typearr : '';
      this.addInfo.no = this.addInfo.noarr ? this.addInfo.noarr : '';

      this.$refs['iform'].validate(function (valid) {
        if (valid) {
          var nos = '';
          _this4.orderselecet.forEach(function (vl) {
            nos += vl.orderNo + ',';
          });
          nos = nos.substring(0, nos.length - 1);

          var mc = _this4.info.mechanismid;
          mc = mc ? mc : '';
          _this4.loading = 1;

          _this4.$importLineOrder(nos, mc, _this4.addInfo.firm, _this4.addInfo.type, _this4.addInfo.no, _this4.addInfo.address, function (res) {
            _this4.loading = 0;
            if (res.status === 200) {
              _this4.$message.success(res.message);
              _this4.isAddInfo = false;
              _this4.getDvs();
            } else {
              _this4.$message.error(res.message);
            }
          }, function () {
            _this4.loading = 0;
          });
        } else {
          return false;
        }
      });
    },
    pageCerChange: function pageCerChange(index) {
      this.pageCer = index;
      this.getCerList();
    },
    queryCers: function queryCers() {
      this.getCerList();
    },
    submitUpload: function submitUpload() {

      this.$refs.upload.submit();
    },
    selectedCer: function selectedCer(vl) {
      this.cerselecet = vl;
    },
    pageOrderChange: function pageOrderChange(index) {
      this.pageOrder = index;
      this.getOrderList();
    },
    getCerType: function getCerType(vl) {
      var data = [this.$t('app_cerMgSelf'), this.$t('app_cerMgOther'), this.$t('app_cerMgCustomer')];
      return data[0];
    },
    dvChange: function dvChange(index) {
      this.dvPage = index;
      this.getDvs();
    },
    cerList: function cerList() {
      var _this5 = this;

      this.loading = 1;
      this.$getChannelCer(this.info.mechanismid, function (res) {
        _this5.loading = 0;
        if (res.status === 200) {
          if (res.data) {
            _this5.cers = [res.data];
          } else {
            _this5.cers = [];
          }
        } else {
          _this5.$message.error(res.message);
        }
      }, function () {
        _this5.loading = 0;
      });
    },
    queryOrder: function queryOrder() {
      this.getOrderList();
    },
    getOrderList: function getOrderList() {
      var _this6 = this;

      this.loading = 1;
      var orderNo = this.orderEvent;
      var customerName = this.cusEvent;
      this.$channelOrders(this.pageOrder, this.$gRow, orderNo, customerName, function (res) {
        _this6.loading = 0;
        if (res.status === 200) {
          _this6.pageOrders = res.data;
          _this6.pageOrderTotal = res.total;
        } else {
          _this6.$message.error(res.message);
        }
      }, function () {
        _this6.loading = 0;
      });
    },
    getCerList: function getCerList() {
      var _this7 = this;

      this.loading = 1;
      var customerName = this.cerEvent;
      this.$channelCers(this.pageCer, this.$gRow, customerName, function (res) {
        _this7.loading = 0;
        if (res.status === 200) {
          _this7.pageCers = res.data;
          _this7.pageCerTotal = res.total;
        } else {
          _this7.$message.error(res.message);
        }
      }, function () {
        _this7.loading = 0;
      });
    },
    rmFile: function rmFile(file) {},
    beforeUpload: function beforeUpload(file) {
      this.exFileName = file.name;
    },
    exCancel: function exCancel() {
      this.importTermVisible = false;
      this.file = '';


      if (this.exFileName) {
        this.$router.push({ path: '/' });
        this.$router.go(-1);
      }
    },
    orderSelected: function orderSelected(list) {
      this.orderselecet = list;
    },
    handleSelectionChange: function handleSelectionChange(list) {
      this.sData = list;
    },
    lineImportDv: function lineImportDv() {
      this.showDvDia = true;
    },
    importDvFile: function importDvFile() {

      this.importTermVisible = true;
    },
    lineImportCer: function lineImportCer() {
      this.showCerDia = true;
    },
    uploadCer: function uploadCer() {
      this.$setWObj('cnUploadId', this.info.mechanismid);
      this.$router.push({ path: '/certificate/upload' });
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    },
    dateFormat: function dateFormat(row, column) {},
    selectChange: function selectChange(vl) {
      this.getDevices();
    },
    pageSelect: function pageSelect(index) {
      this.index = index;
      this.getDevices();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;

      this.getOrderList();
      this.init();
    },
    deleteAppHis: function deleteAppHis(row) {
      var _this8 = this;

      if (row.applicationid) {
        this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
          confirmButtonText: this.$t('app_sure'),
          cancelButtonText: this.$t('app_cancel'),
          type: 'warning'
        }).then(function () {
          _this8.loading = 1;
          if (_this8.$appUrlTag === 0) {
            _this8.$deleteApp(row.applicationid, function (res) {
              _this8.loading = 0;
              if (res.status === 200) {
                _this8.getAppHistory();
              } else {
                _this8.$message.error(res.message);
              }
            }, function () {
              _this8.loading = 0;
            });
          } else {
            _this8.$deleteAppHis(row.applicationid, function (res) {
              _this8.loading = 0;
              if (res.status === 200) {
                _this8.getAppHistory();
              } else {
                _this8.$message.error(res.message);
              }
            }, function () {
              _this8.loading = 0;
            });
          }
        }).catch(function () {});
      }
    },
    imgFullUrl: function imgFullUrl(path) {
      if (path) {
        return this.$urls.prefix + path;
      } else {
        return '';
      }
    },
    getAppHistory: function getAppHistory() {
      var _this9 = this;

      if (!this.config.data.appName) {
        return;
      }

      this.loading = 1;
      if (this.$appUrlTag === 0) {
        this.$getAppHistory(this.config.data.appName, this.config.data.packagename, function (res) {
          _this9.loading = 0;
          if (res.status === 200) {
            _this9.tableData = res.data;
          } else {
            _this9.$message.error(res.message);
          }
        }, function () {
          _this9.loading = 0;
        });
      } else {

        this.$getAppHistory1(localStorage.mechanismId, this.config.data.packagename, function (res) {

          console.log('his', res);
          _this9.loading = 0;
          if (res.status === 200) {
            _this9.tableData = res.data;
          } else {
            _this9.$message.error(res.message);
          }
        }, function () {
          _this9.loading = 0;
        });
      }
    },
    uploadNew: function uploadNew() {
      this.$router.push({ path: '/applist/newversion' });
    },
    setCapturesArr: function setCapturesArr(strs) {
      if (strs) {
        var arr = strs.split(',');
        this.captures = arr;
      }
    },
    getDvs: function getDvs() {
      var _this10 = this;

      var mcid = this.info.mechanismid;
      mcid = mcid ? mcid : '';
      this.loading = 1;
      this.$getDvDevices(this.dvPage, this.$gRow, mcid, '', '', '', this.sortNo, this.sortTime, '', '', function (res) {

        _this10.loading = 0;
        if (res.status === 200) {
          _this10.dvs = res.data;
          _this10.dvTotal = res.total;
        } else {
          _this10.$message.error(res.message);
        }
      }, function () {
        _this10.loading = 0;
      });
    },
    init: function init() {
      var _this11 = this;

      var _this = this;
      setTimeout(function () {
        _this11.getDvs();
      }, 100);
      setTimeout(function () {
        _this11.getOrderList();
      }, 300);
      setTimeout(function () {
        _this11.getCerList();
      }, 300);

      this.cerList();

      var mc = this.info.mechanismid;

      this.$mechGetTypes(mc, function (res) {
        if (res.status == 200) {
          _this11.models = res.data.models;
          _this11.dvTypes = res.data.types;
          _this11.firms = res.data.manufactures;
        }
      }, '');
    }
  },
  mounted: function mounted() {
    var data = this.$getWObj().appChannelDetail;

    this.premcid = data.mechanismid;
    this.info = data;
    this.init();
  }
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      fileName: '',
      fileList: [],
      isImp: false,
      tableData: [],
      mType: [{ tt: this.$t('app_cerMgSelf'), vl: '0' }, { tt: this.$t('app_cerMgOther'), vl: '1' }],
      mVal: '',
      queryKey: '',
      loading: 0,
      total: 0,
      page: 1,
      mcobjs: []
    };
  },

  computed: {
    getFName: function getFName() {
      return this.fileName ? this.fileName : this.$t('app_impmctip');
    }
  },
  methods: {
    getNewestList: function getNewestList() {
      if (this.mcobjs.length == 0) {
        this.getList();
      } else {
        var mid = this.mcobjs[this.mcobjs.length - 1].mechanismid;
        mid = mid == 0 ? '' : mid;
        this.getList(mid);
      }
    },
    saveStore: function saveStore() {
      this.$store.dispatch('setMCPath', this.mcobjs);
    },
    getStore: function getStore() {
      if (this.$store.getters.isRcMcpath) {
        this.mcobjs = this.$store.getters.mcpath;
        if (this.mcobjs.length == 0) {
          this.getList();
          return;
        }
        this.getNewestList();
      } else {
        this.getList();
      }
    },
    backTo: function backTo() {
      this.mcobjs.pop();
      if (this.mcobjs.length == 0) {
        this.getList();
        return;
      }

      this.getNewestList();
    },
    pushMc: function pushMc(row) {
      var mid = row.mechanismid;
      this.mcobjs.push(row);
      this.getList(mid);
    },
    toDetail: function toDetail(row) {
      this.saveStore();
      this.$setWObj("appChannelDetail", row);
      this.$router.push({ path: "/channels/channel-detail" });
    },
    makesp: function makesp(level) {
      var ivl = 20;
      var ilv = parseInt(level);
      return "margin-left:" + ivl * ilv + 'px;';
    },
    ulurl: function ulurl() {
      var url = this.$mcUploadUrl + '?token=' + localStorage.user + '&language=' + localStorage.system_lang;

      return url;
    },
    uploadChange: function uploadChange(file) {
      if (this.isImp) {
        this.fileName = file.name;
      } else {
        this.fileName = '';
      }
    },
    uploadSuccess: function uploadSuccess(res, flie) {
      if (res.status == 200) {
        this.$notify({
          title: this.$t('terminal.list.notify_title'),
          message: res.message,
          type: 'success',
          duration: 6000
        });
        this.impClose();

        this.getNewestList();
      } else {
        this.$notify.error({
          title: this.$t('terminal.list.notify_title'),
          message: res.message,
          duration: 6000
        });
      }
    },
    channelUpload: function channelUpload() {
      this.$refs.upload.submit();
    },
    downTemp: function downTemp() {
      window.open(this.$mcTempUrl);
    },
    impClose: function impClose() {
      this.$refs.upload.clearFiles();
      this.isImp = false;
      this.fileName = '';
    },
    importChannel: function importChannel() {
      this.isImp = true;
    },
    query: function query() {
      this.getNewestList();
    },
    cellClick: function cellClick(row, ev, col) {
      var label = col.label;
      if (!label) return;
      if (label === this.$t("app_operate")) {
        return;
      } else {
        this.queryKey = '';
        this.pushMc(row);
      }
    },
    selectChange: function selectChange() {
      this.getNewestList();
    },
    pageSelect: function pageSelect(index) {
      this.page = index;

      this.getNewestList();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;

      this.getNewestList();
    },
    editChannel: function editChannel(row) {
      this.saveStore();
      this.$setWObj('editDataConfig', { type: 1, pageType: 0, data: row });

      this.$router.push({ path: '/channels/editchannel' });
    },
    deleteChannel: function deleteChannel(row) {
      var _this = this;

      this.$showConfirm('', this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warnning', function () {
        _this.loading = 1;
        _this.$deleteChannel(row.mechanismid, function (res) {
          _this.loading = 0;
          if (res.status === 200) {
            _this.getNewestList();
          } else {
            _this.$message.error(res.message);
          }
        }, function () {
          _this.loading = 0;
        });
      });
    },
    addChannel: function addChannel() {
      this.saveStore();
      this.$setWObj('editDataConfig', { type: 0 });

      this.$router.push({ path: '/channels/newchannel' });
    },
    getList: function getList(mcid) {
      var _this2 = this;

      this.loading = 1;

      var type = this.mVal ? this.mVal : '';
      var name = this.queryKey ? this.queryKey : '';
      var mid = mcid ? mcid : '';

      this.$getChannelList(this.$gRow, this.page, mid, type, name, function (res) {
        _this2.loading = 0;

        _this2.$getMcTypeInfo(res.data.mechanismid, function (res) {}, '');

        if (res.status === 200) {
          _this2.total = res.total;
          _this2.tableData = res.data;
        } else {
          _this2.$message(res.message);
        }
      }, function () {
        _this2.loading = 0;
      });
    }
  },
  mounted: function mounted() {

    this.getStore();
  }
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      orderName: '',
      orderType: '',
      name: '',
      row: this.$gRow,
      index: 1,
      total: 0,
      dialogFormVisible: 0,
      tableData: [],
      loading: 0,
      editData: ''
    };
  },

  methods: {
    sortChange: function sortChange(vl) {
      switch (vl.prop) {
        case 'modelName':
          this.orderName = '1';
          break;
      }
      this.orderType = vl.order == 'descending' ? 'desc' : 'asc';
      this.getList(this.index);
    },
    cancelEdit: function cancelEdit() {
      this.dialogFormVisible = false;
    },
    edit: function edit(row) {
      this.editData = row;
      this.dialogFormVisible = 1;
    },
    del: function del(row) {
      var _this = this;

      this.$showConfirm('', this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warnning', function () {
        var id = row.modelId;
        _this.loading = 1;
        _this.$delDeviceNo(id, function (res) {
          _this.loading = 0;
          if (res.status === 200) {
            _this.getList(_this.index);
          } else {
            _this.$message.error(res.message);
          }
        }, function () {
          _this.loading = 0;
        });
      });
    },
    pageSelect: function pageSelect(index) {
      this.getList(index);
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getList(this.index);
    },
    open: function open() {
      if (this.editData) {
        this.name = this.editData.modelName;
      }
    },
    close: function close() {
      this.editData = '';
      this.name = '';
    },
    showInput: function showInput() {
      this.dialogFormVisible = 1;
    },
    newData: function newData() {
      var _this2 = this;

      var vl = this.name;
      if (vl) {
        this.loading = 1;
        this.$addDeviceNo(vl, function (res) {
          _this2.loading = 0;
          console.log(res);
          if (res.status === 200) {
            _this2.getList(_this2.index);
          } else {
            _this2.$message.error(res.message);
          }
        }, function () {
          _this2.loading = 0;
        });
        this.dialogFormVisible = 0;
      } else {
        this.$message.error(this.$t('app_inputAName'));
      }
    },
    editRqs: function editRqs() {
      var _this3 = this;

      var vl = this.name;
      if (vl) {
        this.loading = 1;
        this.$editDeviceNo(this.editData.modelId, vl, function (res) {
          _this3.loading = 0;
          if (res.status === 200) {
            _this3.getList(_this3.index);
          } else {
            _this3.$message.error(res.message);
          }
        }, function () {
          _this3.loading = 0;
        });
        this.dialogFormVisible = 0;
      } else {
        this.$message.error(this.$t('app_inputAName'));
      }
    },
    sure: function sure() {
      if (this.editData) {
        this.editRqs();
      } else {
        this.newData();
      }
    },
    getList: function getList(index) {
      var _this4 = this;

      this.loading = 1;
      this.$deviceNo(this.$gRow, index, this.orderName, this.orderType, function (res) {
        console.log('res', res);
        _this4.loading = 0;
        if (res.status === 200) {
          console.log('data', res.data);
          _this4.tableData = res.data;
          _this4.total = res.total;
          _this4.index = index;
        } else {
          _this4.$message.error(res.message);
        }
      }, function () {
        _this4.loading = 0;
      });
    }
  },
  mounted: function mounted() {
    this.getList(this.index);
  }
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      orderName: '',
      orderType: '',
      name: '',
      row: this.$gRow,
      index: 1,
      total: 0,
      dialogFormVisible: 0,
      tableData: [],
      loading: 0,
      editData: ''
    };
  },

  methods: {
    sortChange: function sortChange(vl) {

      switch (vl.prop) {
        case 'typeName':
          this.orderName = '1';
          break;
      }
      this.orderType = vl.order == 'descending' ? 'desc' : 'asc';
      this.getList(this.index);
    },
    cancelEdit: function cancelEdit() {
      this.dialogFormVisible = false;
    },
    edit: function edit(row) {
      this.editData = row;
      this.dialogFormVisible = 1;
    },
    del: function del(row) {
      var _this = this;

      this.$showConfirm('', this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warnning', function () {
        var id = row.typeId;
        _this.loading = 1;
        _this.$delDeviceType(id, function (res) {
          _this.loading = 0;
          if (res.status === 200) {
            _this.getList(_this.index);
          } else {
            _this.$message.error(res.message);
          }
        }, function () {
          _this.loading = 0;
        });
      });
    },
    pageSelect: function pageSelect(index) {
      this.getList(index);
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getList(this.index);
    },
    open: function open() {
      if (this.editData) {
        this.name = this.editData.typeName;
      }
    },
    close: function close() {
      this.editData = '';
      this.name = '';
    },
    showInput: function showInput() {
      this.dialogFormVisible = 1;
    },
    newData: function newData() {
      var _this2 = this;

      var vl = this.name;
      if (vl) {
        this.loading = 1;
        this.$addDeviceType(vl, function (res) {
          _this2.loading = 0;
          console.log(_this2.loading);
          if (res.status === 200) {
            _this2.getList(_this2.index);
          } else {
            _this2.$message.error(res.message);
          }
        }, function () {
          _this2.loading = 0;
        });
        this.dialogFormVisible = 0;
      } else {
        this.$message.error(this.$t('app_inputAName'));
      }
    },
    editRqs: function editRqs() {
      var _this3 = this;

      var vl = this.name;
      if (vl) {
        this.loading = 1;
        this.$editDeviceType(this.editData.typeId, vl, function (res) {
          _this3.loading = 0;
          console.log(_this3.loading);
          if (res.status === 200) {
            _this3.getList(_this3.index);
          } else {
            _this3.$message.error(res.message);
          }
        }, function () {
          _this3.loading = 0;
        });
        this.dialogFormVisible = 0;
      } else {
        this.$message.error(this.$t('app_inputAName'));
      }
    },
    sure: function sure() {

      if (this.editData) {
        this.editRqs();
      } else {
        this.newData();
      }
    },
    getList: function getList(index) {
      var _this4 = this;

      this.loading = 1;
      this.$deviceType(this.$gRow, index, this.orderName, this.orderType, function (res) {
        _this4.loading = 0;
        if (res.status === 200) {
          _this4.tableData = res.data;
          _this4.total = res.total;
          _this4.index = index;
        } else {
          _this4.$message.error(res.message);
        }
      }, function () {
        _this4.loading = 0;
      });
    }
  },
  mounted: function mounted() {
    this.getList(this.index);
  }
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      orderName: '',
      orderType: '',
      tableData: [{}],
      loading: 0,
      row: this.$gRow,
      total: 0
    };
  },

  computed: {
    index: function index() {
      return this.$getWPage('dataFirmPage');
    }
  },
  methods: {
    sortChange: function sortChange(vl) {
      switch (vl.prop) {
        case 'name':
          this.orderName = '1';
          break;
      }
      this.orderType = vl.order == 'descending' ? 'desc' : 'asc';
      this.getList(this.index);
    },
    pageSelect: function pageSelect(index) {
      this.getList(index);
      this.$setWPage('dataFirmPage', index);
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getList(this.index);
    },
    addFirm: function addFirm() {
      this.$setWObj('editDataConfig', { type: 0, pageType: 1 });

      this.$router.push({ path: '/firms/newfirm' });
    },
    deleteFirm: function deleteFirm(row) {
      var _this = this;

      this.$showConfirm('', this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warnning', function () {
        _this.$deleteFirm(row.manufid, function (res) {
          if (res.status === 200) {
            _this.getList(_this.index);
          } else {
            _this.$message.error(res.message);
          }
        });
      });
    },
    editFirm: function editFirm(row) {
      this.$setWObj('editDataConfig', { type: 1, data: row });

      this.$router.push({ path: '/firms/editfirm' });
    },
    getList: function getList(index) {
      var _this2 = this;

      this.loading = 1;
      this.$getFirmList(this.$gRow, index, this.orderName, this.orderType, function (res) {
        _this2.loading = 0;
        if (res.status === 200) {
          _this2.tableData = res.data;
          _this2.index = index;
          _this2.total = res.total;
        } else {
          _this2.$message(res.message);
        }
      }, function () {
        _this2.loading = 0;
      });
    }
  },
  mounted: function mounted() {
    this.getList(this.index);
  },
  destroyed: function destroyed() {}
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default.a
  },
  data: function data() {
    var _this = this;

    var phoneCheck = function phoneCheck(rule, value, callback) {
      if (!_this.isLegalMobile(value)) {
        callback(new Error(_this.$t('app_phoneIllegal')));
      } else {
        callback();
      }
    };
    var ftCheck = function ftCheck(rule, value, callback) {
      if (!value) {
        callback(new Error(_this.$t('app_input')));
      } else {
        callback();
      }
    };
    var that = this;
    return {
      channel: {
        name: '',
        father: '',
        contact: '',
        tel: '',

        addr: '',
        config: {}
      },
      mechanismData: '',
      rightEnable: false,
      right: 0,
      radio: '0',
      fatherList: [],
      loading: 0,
      rules: {
        name: [{ required: true, message: this.$t('app_inputName'), trigger: 'blur' }],
        father: [{ required: true, message: this.$t('app_input'), trigger: 'blur', validator: ftCheck }],
        contact: [{ required: true, message: this.$t('app_inputContact'), trigger: 'blur' }],
        tel: [{ required: true, message: this.$t('app_inputTruePhone'), trigger: 'blur' }],
        addr: [{ required: true, message: this.$t('app_inputAddr'), trigger: 'blur' }]
      }
    };
  },

  methods: {
    cSelect: function cSelect(vl) {
      this.radio = vl.certType + '';
    },
    isLegalMobile: function isLegalMobile(tel) {
      var sMobile = tel;
      var regex = "^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\\d{8}$";
      var re = new RegExp(regex, 'g');
      if (!re.test(sMobile)) {
        return false;
      } else {
        return true;
      }
    },
    newChannel: function newChannel() {
      var _this2 = this;

      this.loading = 1;
      this.$addChannel(this.radio, this.channel.father.mechanismid, this.channel.father.mechanismgrade, this.channel.name, this.channel.addr, this.channel.contact, this.channel.tel, this.channel.father.mechanismname, function (res) {
        _this2.loading = 0;
        if (res.status === 200) {
          _this2.$router.go(-1);
        } else {
          _this2.$message.error(res.message);
        }
      }, function () {
        _this2.loading = 0;
      });
    },
    editChannel: function editChannel() {
      var _this3 = this;

      var that = this;
      var data = this.config.data;

      var fname = this.channel.father.mechanismname;
      fname = fname ? fname : '';
      var fid = this.channel.father.mechanismid;
      fid = fid ? fid : '';
      var fgrade = this.channel.father.mechanismgrade;
      fgrade = fgrade ? fgrade : '';

      this.loading = 1;
      this.$editChannel(this.radio, data.mechanismid, this.channel.name, fid, fgrade, this.channel.addr, fname, this.channel.contact, this.channel.tel, function (res) {
        _this3.loading = 0;
        if (res.status === 200) {
          _this3.$router.go(-1);
        } else {
          _this3.$message.error(res.message);
        }
      }, function () {
        _this3.loading = 0;
      });
    },
    save: function save(name) {
      var _this4 = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {

          if (_this4.config.type === 0) {
            _this4.newChannel();
          } else {
            _this4.editChannel();
          }
        } else {
          return false;
        }
      });
    },
    cancel: function cancel() {
      this.$router.go(-1);
    },
    getParents: function getParents() {
      var _this5 = this;

      this.$parentChannel(function (res) {
        if (res.status === 200) {
          console.log("memeo...");
          console.log(res.data);
          _this5.fatherList = res.data;
        } else {
          _this5.$message.error(res.message);
        }
      }, function () {});
    },
    fillData: function fillData(data) {

      var that = this;

      this.channel.name = data.mechanismname;
      this.channel.father = data.superid;
      this.channel.contact = data.completename;
      this.channel.tel = data.mechanismcode;
      this.channel.addr = data.mechanismaddre;

      that.radio = data.certType + '';
      this.channel.father = {
        mechanismgrade: (parseInt(data.mechanismgrade) - 1).toString(),
        mechanismid: data.superid,
        mechanismname: data.memo
      };
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    var that = this;
    this.right = localStorage.userType;

    this.config = this.$getWObj().editDataConfig;
    if (this.config.type === 1) {
      this.$getMcDetail(this.config.data.mechanismid, function (res) {
        var data = res.data;
        that.mechanismData = {
          value: data.memo,
          callback: function callback(value, obj) {
            that.channel.father = obj;
          }
        };

        _this6.fillData(data);
      }, '');
    } else {
      that.mechanismData = {
        callback: function callback(value, obj) {
          that.channel.father = obj;
        }
      };
    }
  }
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    var phoneCheck = function phoneCheck(rule, value, callback) {
      if (!_this.isLegalMobile(value)) {
        callback(new Error(_this.$t('app_phoneIllegal')));
      } else {
        callback();
      }
    };
    return {
      fatherList: [],
      firm: {
        name: '',
        father: '',
        contact: '',
        tel: '',
        addr: '',
        config: {}
      },
      rules: {
        name: [{ required: true, message: this.$t('app_inputName'), trigger: 'blur' }],
        contact: [{ required: true, message: this.$t('app_inputContact'), trigger: 'blur' }],
        tel: [{ required: true, message: this.$t('app_inputTruePhone'), trigger: 'blur' }],
        addr: [{ required: true, message: this.$t('app_inputAddr'), trigger: 'blur' }]
      }
    };
  },

  methods: {
    isLegalMobile: function isLegalMobile(tel) {
      var sMobile = tel;
      var regex = "^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\\d{8}$";
      var re = new RegExp(regex, 'g');
      if (!re.test(sMobile)) {
        return false;
      } else {
        return true;
      }
    },
    newfirm: function newfirm() {
      var _this2 = this;

      this.loading = 1;
      this.$addFirm(this.firm.name, this.firm.contact, this.firm.tel, this.firm.addr, function (res) {
        _this2.loading = 0;
        if (res.status === 200) {
          _this2.$router.go(-1);
        } else {
          _this2.$message.error(res.message);
        }
      }, function () {
        _this2.loading = 0;
      });
    },
    editfirm: function editfirm() {
      var _this3 = this;

      var data = this.config.data;

      this.loading = 1;
      this.$editFirm(data.manufid, this.firm.name, this.firm.contact, this.firm.tel, this.firm.addr, data.createtime, function (res) {
        _this3.loading = 0;
        if (res.status === 200) {
          _this3.$router.go(-1);
        } else {
          _this3.$message.error(res.message);
        }
      }, function () {
        _this3.loading = 0;
      });
    },
    save: function save(name) {
      var _this4 = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          if (_this4.config.type === 0) {
            _this4.newfirm();
          } else {
            _this4.editfirm();
          }
        } else {
          return false;
        }
      });
    },
    cancel: function cancel() {
      this.$router.go(-1);
    },
    fillData: function fillData(data) {
      console.log(data);
      this.firm.name = data.name;
      this.firm.contact = data.contacts;
      this.firm.tel = data.tel;
      this.firm.addr = data.address;
    }
  },
  mounted: function mounted() {
    this.config = this.$getWObj().editDataConfig;
    if (this.config.type === 1) {
      this.fillData(this.config.data);
    }
  }
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var that = this;
    return {
      mechanismData: {
        callback: function callback(value, obj) {
          that.selectMcObj = obj;
          that.channelId = value;
          that.selectChange1(value);
        }
      },
      dvStatus: {
        "": this.$t('lin_global.all_status'),
        '1': this.$t('app_online'),
        "2": this.$t('app_offline'),
        "0": this.$t('app_new'),
        "3": this.$t('app_sleep'),
        "4": this.$t('lin_btn.lock')
      },
      uldata: '',
      fileList: [],
      isMarket: false,
      srcList: [],
      downTpl: __WEBPACK_IMPORTED_MODULE_0__api_url__["b" /* urlAssets */].prefix + 'tms-server-web/model/terminalNos.xlsx',
      importTemplate: __WEBPACK_IMPORTED_MODULE_0__api_url__["b" /* urlAssets */].prefix + 'tms-server-web/import/terminalList.do',
      formLabelWidth: '28.5%',
      selectMcObj: '',
      sNum: 0,
      resAf: '',
      check1: false,
      check2: false,
      pushQs: false,
      pushQsNo: '',
      pushAll: false,
      pushAf: false,
      pushDone: false,
      pushImport: false,
      status: '',
      iNo: '',
      row: this.$gRow,
      selected: [],
      info: '',
      launcherBind: '',
      tableData1: [],
      multipleSelection: [],
      channels: [],
      channelId: '',
      loading: 0,
      total1: 0,
      index: 1
    };
  },

  components: { MechanismSelector: __WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue___default.a },
  computed: {
    fileName: function fileName() {
      console.log('dddd', this.info);
      switch (this.info.type) {
        case '4':
          return this.info.data.firmwareName;
          break;
        case '10':

          break;
        case '6':

          break;
        case '2':
          return this.info.data.name;
          break;
        case '1':
          return this.info.data.appName;
          break;
      }
    },
    surePushTip: function surePushTip() {
      return this.$t('app_psdonelftip').replace('{num}', this.pushAfNum);
    },
    pushAfNum: function pushAfNum() {
      return this.resAf ? this.resAf.data.nums : '';
    },
    fileUploadUrl: function fileUploadUrl() {
      return __WEBPACK_IMPORTED_MODULE_0__api_url__["a" /* baseurl */] + '/terminal/importTers.do' + "?language=" + localStorage.sys_lang + '&token=' + localStorage.user;
    },
    allMcName: function allMcName() {

      var mc = this.selectMcObj ? this.selectMcObj.name : this.$t('lin_global.all_mechanism');
      var sp = "   ，";
      var str = this.$t('app_ispushalldv') + '？' + this.$t('app_distributor') + '：' + mc + sp + this.$t('app_status') + '：' + this.dvStatus[this.status] + sp + this.$t('app_deviceNum') + '：' + this.total1;

      return str;
    },
    stModel: function stModel() {
      var app = [{ label: this.$t('lin_global.all_status'), vl: '' }, { label: this.$t('app_online'), vl: '1' }, { label: this.$t('app_offline'), vl: '2' }, { label: this.$t('app_new'), vl: '0' }, { label: this.$t('app_sleep'), vl: '3' }, { label: this.$t('lin_btn.lock'), vl: '4' }];

      return app;
    },
    isLauncher: function isLauncher() {
      if (this.launcherBind) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    surePush: function surePush() {
      this.pushQs = false;
      this.bindRqs('0', this.pushQsNo, this.check2, this.check1);
    },
    closeImport: function closeImport() {
      this.fileList = [];
      this.uldata = '';
    },
    handleRemove: function handleRemove() {},
    ulError: function ulError() {
      window[this.$route.path] = '';
    },
    srcSuccess: function srcSuccess(res, file) {
      window[this.$route.path] = '';


      if (res.status === 200) {
        this.fileList = [{ name: file.name }];
        this.uldata = res.data;
      } else {

        this.srcList = [];

        this.$message.error(res.message);
      }
    },
    srcBefore: function srcBefore(file) {
      window[this.$route.path] = 1;
    },
    submitUpload: function submitUpload() {
      this.bindRqs('2');
      this.pushImport = false;
    },
    jumpNow: function jumpNow() {
      this.$router.push({ path: '/task/ptask' });
    },
    skipPush: function skipPush() {},
    surePushAll: function surePushAll() {
      this.bindRqs('1', '');
    },
    surePushAf: function surePushAf() {
      this.bindRqs('1', '');
    },
    coverPush: function coverPush(cvParam) {
      var _this = this;

      this.loading = 1;
      this.$isCoverPush(this.resAf.data.taskId, this.resAf.data.pushParam, cvParam, function (res) {
        _this.loading = 0;
        if (res.status === 200) {
          _this.pushAf = false;
          _this.pushDone = true;
        } else {
          _this.$message.error(res.message);
        }
      }, function (error) {
        _this.loading = 0;
        _this.$message.error(_this.$('app_rqsError'));
      });
    },
    pageSelect1: function pageSelect1(index) {
      this.index = index;

      this.getDevices();
    },
    pageSized1: function pageSized1(val) {
      this.$gRow = val;

      this.getDevices();
    },
    selectChange1: function selectChange1(vl) {

      this.getDevices();
    },
    selectStChange: function selectStChange(vl) {

      this.getDevices();
    },
    srch: function srch() {

      this.getDevices();
    },
    handleSelectionChange1: function handleSelectionChange1(list) {
      this.sNum = list.length;
      this.selected = list;
    },
    multiBind: function multiBind() {
      var ids = '';
      var tNo = '';
      var tmid = '';
      this.selected.forEach(function (vl) {
        ids += vl.terminalId + ',';
        tNo += vl.terminalNo + ',';
        tmid += vl.manufId + ',';
      });
      ids = ids.substring(0, ids.length - 1);
      tNo = tNo.substring(0, tNo.length - 1);
      tmid = tmid.substring(0, tmid.length - 1);

      if (!tNo) {
        this.$message(this.$t('app_oneDeviceMust'));
        return;
      }

      if (this.info.type === '1' || this.info.type === '2') {
        this.pushQs = true;
        this.pushQsNo = tNo;
      } else {
        this.bindRqs('0', tNo);
      }
    },
    bindRqs: function bindRqs(pushType, tNos) {
      var _this2 = this;

      this.loading = 1;
      var terNos = '';
      var mecId = '';
      var terStatus = '';
      var terNo = '';
      var flNo = '';
      var objId = '';
      var auto = this.check1 ? '1' : '0';
      var install = this.check2 ? '1' : '0';
      switch (pushType) {
        case '0':
          terNos = tNos;
          break;
        case '1':
          mecId = this.channelId ? this.channelId : '';
          terStatus = this.status ? this.status : '';
          terNo = this.iNo ? this.iNo : '';
          break;
        case '2':
          flNo = this.uldata ? this.uldata.fileNo : '';
          break;
      }

      switch (this.info.type) {
        case '4':
        case '2':
          objId = this.info.data.id;
          break;
        case '10':
          objId = this.info.data.launcherid;
          break;
        case '6':
          objId = this.info.data.animatId;
          break;
        case '1':
          if (this.isMarket) {
            objId = this.info.data.applicationid;
          } else {
            objId = this.info.data.appdevid;
          }

          break;

      }

      this.$addPush(install, auto, objId, this.info.type, pushType, terNos, mecId, terStatus, terNo, flNo, function (res) {
        console.log('pushRqs', res);
        _this2.loading = 0;
        _this2.check1 = false;
        _this2.check2 = false;
        if (res.status === 200) {
          _this2.pushAll = false;

          _this2.getDevices();
          _this2.pushDone = true;
        } else if (res.status === 300) {
          _this2.pushAll = false;
          _this2.pushAf = true;
          _this2.resAf = res;
        } else {
          _this2.$message.error(res.message);
        }
      }, function (error) {
        _this2.loading = 0;
        _this2.$message.error(_this2.$('app_rqsError'));
      });
    },
    bindOperate1: function bindOperate1(row) {

      if (this.info.type === '1' || this.info.type === '2') {
        this.pushQs = true;
        this.pushQsNo = row.terminalNo;
      } else {

        this.bindRqs('0', row.terminalNo);
      }
    },
    getChannels: function getChannels() {
      var _this3 = this;

      this.$getChannelList(10000, 1, '', '', '', function (res) {
        if (res.status === 200) {
          _this3.channels = res.data;
        } else {
          _this3.$message.error(res.message);
        }
      }, function () {
        _this3.$message.error(_this3.$t('app_rqsError'));
      });
    },
    getDevices: function getDevices() {
      var _this4 = this;

      var channel = this.channelId ? this.channelId : '';
      var terminalNo = this.iNo ? this.iNo : '';
      var status = this.status ? this.status : '';


      var mFileId, fileId, fileType;

      switch (this.info.type) {
        case '4':
          mFileId = this.info.data.mechanismId;
          fileId = this.info.data.id;
          fileType = '';
          break;
        case '10':
          mFileId = this.info.data.distrabutorid;
          fileId = this.info.data.launcherid;
          fileType = '10';
          break;
        case '6':
          mFileId = '';
          fileId = this.info.data.animatId;
          fileType = '';
          break;
        case '2':
          mFileId = this.info.data.mechanismId;
          fileId = this.info.data.id;
          fileType = '';
          break;
        case '1':
          mFileId = '';

          if (this.isMarket) {
            fileId = this.info.data.applicationid;
          } else {
            fileId = this.info.data.appdevid;
          }
          fileType = '1';
          break;
      }

      this.loading = 1;
      this.$canPushTer(this.index, this.$gRow, mFileId, channel, status, terminalNo, fileType, fileId, function (res) {
        console.log('res', res);
        _this4.loading = 0;
        if (res.data) {
          _this4.total1 = res.total;
          _this4.tableData1 = res.data;
        }
      }, function () {
        _this4.loading = 0;
      });
    },
    bind: function bind(tId, tNo, tmid) {
      var _this5 = this;

      var vl = tId ? tId : '';
      this.loading = 1;

      var cId = this.info.appdevid ? this.info.appdevid : this.info.applicationid;

      if (this.$appUrlTag === 0) {
        this.$bindApp('0', vl, cId, function (res) {
          if (res.status === 200) {
            _this5.$message.success(_this5.$t('app_tipViewTask'));
          } else {
            _this5.$message.error(res.message);
          }
          _this5.loading = 0;
        }, function () {
          _this5.loading = 0;
        });
      } else {
        this.$bindApp1(tmid, tNo, cId, function (res) {
          if (res.status === 200) {
            _this5.$message.success(_this5.$t('app_tipViewTask'));
          } else {
            _this5.$message.error(res.message);
          }
          _this5.loading = 0;
        }, function () {
          _this5.loading = 0;
        });
      }
    }
  },
  mounted: function mounted() {
    alert('test');

    this.isMarket = this.$route.path === '/appSlot/terminal-bind';

    var obj = this.$getWObj().pushList;
    this.info = obj;
    console.log(obj);

    this.getDevices();
  }
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _ref;

    var that = this;
    return _ref = {
      batchSl: [],
      queryKey: '',
      mechanismId: window.localStorage['mechanismId'],
      tableData: [],
      info: '',
      total: 0,
      pushedList: false,
      row: this.$gRow,
      page: 1,
      list: [],
      isMarket: false,
      isAppBatch: false,
      sNum: 0,
      detail: '',
      playPlace: {
        '1': this.$t('app_on'),
        '2': this.$t('app_off'),
        '3': this.$t('app_onOff')
      },
      adType: { '1': this.$t('app_launchAnimate'), '2': this.$t('app_onLogo') },

      mechanismData: {
        callback: function callback(value, obj) {
          that.selectMcObj = obj;
          that.channelId = value;
          that.selectChange1(value);
        }
      },
      dvStatus: {
        "": this.$t('lin_global.all_status'),
        '1': this.$t('app_online'),
        "2": this.$t('app_offline'),
        "0": this.$t('app_new'),
        "3": this.$t('app_sleep'),
        "4": this.$t('lin_btn.lock')
      },
      uldata: '',
      fileList: [],
      srcList: [],
      downTpl: __WEBPACK_IMPORTED_MODULE_1__api_url__["b" /* urlAssets */].prefix + 'tms-server-web/model/terminalNos.xlsx',
      importTemplate: __WEBPACK_IMPORTED_MODULE_1__api_url__["b" /* urlAssets */].prefix + 'tms-server-web/import/terminalList.do',
      formLabelWidth: '28.5%',
      selectMcObj: '',
      sNum1: 0,
      resAf: '',
      check1: false,
      check2: false,
      pushQs: false,
      pushQsNo: '',
      pushAll: false,
      pushAf: false,
      pushDone: false,
      pushImport: false,
      status: '',
      iNo: '',
      selected: []
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'info', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'launcherBind', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'tableData1', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'multipleSelection', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'channels', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'channelId', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'loading', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'total1', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'index', 1), _ref;
  },

  components: { MechanismSelector: __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue___default.a },
  computed: {
    fileName: function fileName() {
      console.log('dddd', this.info);
      switch (this.info.type) {
        case '4':
          return this.info.data.firmwareName;
          break;
        case '10':

          break;
        case '6':

          break;
        case '2':
          return this.info.data.name;
          break;
        case '1':
          if (this.isAppBatch) {
            var appNames = '';
            this.info.data.forEach(function (vl) {
              appNames += vl.appName + ',';
            });
            appNames = appNames.substring(0, appNames.length - 1);
            return appNames;
          } else {
            return this.info.data.appName;
          }
          break;
      }
    },
    surePushTip: function surePushTip() {
      return this.$t('app_psdonelftip').replace('{num}', this.pushAfNum);
    },
    pushAfNum: function pushAfNum() {
      return this.resAf ? this.resAf.data.nums : '';
    },
    fileUploadUrl: function fileUploadUrl() {
      return __WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/terminal/importTers.do' + "?language=" + localStorage.sys_lang + '&token=' + localStorage.user;
    },
    allMcName: function allMcName() {

      var mc = this.selectMcObj ? this.selectMcObj.name : this.$t('lin_global.all_mechanism');
      var sp = "   ，";
      var str = this.$t('app_ispushalldv') + '？' + this.$t('app_distributor') + '：' + mc + sp + this.$t('app_status') + '：' + this.dvStatus[this.status] + sp + this.$t('app_deviceNum') + '：' + this.total1;

      return str;
    },
    stModel: function stModel() {
      var app = '';
      if (this.info.type == 14 || this.info.type == 15) {
        app = [{ vl: '', label: this.$t('app_all') }, { vl: '0', label: this.$t('app_new') }, { vl: '1', label: this.$t('app_on') }, { vl: '2', label: this.$t('app_sleep') }, { vl: '3', label: this.$t('app_fault') }];
      } else {
        app = [{ label: this.$t('lin_global.all_status'), vl: '' }, { label: this.$t('app_online'), vl: '1' }, { label: this.$t('app_offline'), vl: '2' }, { label: this.$t('app_new'), vl: '0' }, { label: this.$t('app_sleep'), vl: '3' }, { label: this.$t('lin_btn.lock'), vl: '4' }];
      }

      return app;
    },
    isLauncher: function isLauncher() {
      if (this.launcherBind) {
        return true;
      } else {
        return false;
      }
    },
    dfDelCt: function dfDelCt() {
      var dfstr = this.$t('app_del');
      if (this.info) {
        if (this.info.type === '1') {
          return this.$t('app_unbind');
        } else {
          return dfstr;
        }
      } else {
        return dfstr;
      }
    },
    cmType: function cmType() {
      var type = '';
      if (this.info.type === '2') {
        type = this.detail.fileType === '0' ? this.$t('app_ttPkg') : this.$t('app_dfPkg');
      } else if (this.info.type === '4') {
        type = this.detail ? this.detail.fileType : '';
      }
      return type;
    },
    avtStyle: function avtStyle() {
      return 'background-size: cdetachIndexge: url(' + this.avt + ')';
    },
    index: function index() {
      return this.$getWPage('appMarketPushPage');
    }
  },
  methods: {
    query: function query() {},
    batchTotal: function batchTotal(detachIndex, msl) {
      var num = 0;
      this.batchSl.forEach(function (arr, index) {
        if (index != detachIndex) {
          num += arr.length;
        }
      });
      return num + msl.length;
    },
    refreshBind: function refreshBind() {
      this.getBinds();
    },
    surePush: function surePush() {
      this.pushQs = false;
      this.bindRqs('0', this.pushQsNo, this.check2, this.check1);
    },
    closeImport: function closeImport() {
      this.fileList = [];
      this.uldata = '';
    },
    handleRemove: function handleRemove() {},
    ulError: function ulError() {
      window[this.$route.path] = '';
    },
    srcSuccess: function srcSuccess(res, file) {
      window[this.$route.path] = '';


      if (res.status === 200) {
        this.fileList = [{ name: file.name }];
        this.uldata = res.data;
      } else {

        this.srcList = [];

        this.$message.error(res.message);
      }
    },
    srcBefore: function srcBefore(file) {
      window[this.$route.path] = 1;
    },
    submitUpload: function submitUpload() {
      this.bindRqs('2');
      this.pushImport = false;
    },
    jumpNow: function jumpNow() {
      this.$router.push({ path: '/task/ptask' });
    },
    skipPush: function skipPush() {},
    surePushAll: function surePushAll() {
      this.bindRqs('1', '');
    },
    surePushAf: function surePushAf() {
      this.bindRqs('1', '');
    },
    coverPush: function coverPush(cvParam) {
      var _this2 = this;

      this.loading = 1;
      this.$isCoverPush(this.resAf.data.taskId, this.resAf.data.pushParam, cvParam, function (res) {
        _this2.loading = 0;
        if (res.status === 200) {
          _this2.pushAf = false;
          _this2.pushDone = true;
        } else {
          _this2.$message.error(res.message);
        }
      }, function (error) {
        _this2.loading = 0;
        _this2.$message.error(_this2.$('app_rqsError'));
      });
    },
    pageSelect1: function pageSelect1(index) {
      this.fillBatchsl();

      this.index = index;

      this.getDevices();
    },
    pageSized1: function pageSized1(val) {
      this.batchSl = [];

      this.$gRow = val;

      this.getDevices();
    },
    selectChange1: function selectChange1(vl) {

      this.getDevices();
    },
    selectStChange: function selectStChange(vl) {

      this.getDevices();
    },
    srch: function srch() {

      this.getDevices();
    },
    fillBatchsl: function fillBatchsl() {
      this.batchSl[this.index - 1] = this.selected;
    },
    handleSelectionChange1: function handleSelectionChange1(list) {
      this.sNum1 = this.batchTotal(this.index - 1, list);
      this.selected = list;
    },
    multiBind: function multiBind() {
      this.fillBatchsl();

      var ids = '';
      var tNo = '';
      var tmid = '';


      this.batchSl.forEach(function (arr) {
        arr.forEach(function (vl) {
          ids += vl.terminalId + ',';
          tNo += vl.terminalNo + ',';
          tmid += vl.manufId + ',';
        });
      });

      ids = ids.substring(0, ids.length - 1);
      tNo = tNo.substring(0, tNo.length - 1);
      tmid = tmid.substring(0, tmid.length - 1);

      if (!tNo) {
        this.$message(this.$t('app_oneDeviceMust'));
        return;
      }

      if (this.info.type === '1' || this.info.type === '2') {
        this.pushQs = true;
        this.pushQsNo = tNo;
      } else {
        this.bindRqs('0', tNo);
      }
    },
    bindRqs: function bindRqs(pushType, tNos) {
      var _this3 = this;

      this.loading = 1;
      var terNos = '';
      var mecId = '';
      var terStatus = '';
      var terNo = '';
      var flNo = '';
      var objId = '';
      var auto = this.check1 ? '1' : '0';
      var install = this.check2 ? '1' : '0';
      switch (pushType) {
        case '0':
          terNos = tNos;
          break;
        case '1':
          mecId = this.channelId ? this.channelId : '';
          terStatus = this.status ? this.status : '';
          terNo = this.iNo ? this.iNo : '';
          break;
        case '2':
          flNo = this.uldata ? this.uldata.fileNo : '';
          break;
      }

      switch (this.info.type) {
        case '13':
          objId = this.info.data.recordId;
          break;
        case '4':
        case '2':
        case '14':
        case '15':
          objId = this.info.data.id;
          break;
        case '10':
          objId = this.info.data.launcherid;
          break;
        case '6':
          objId = this.info.data.animatId;
          break;
        case '1':
          if (this.isMarket) {
            objId = this.info.data.applicationid;
          } else {
            objId = this.info.data.appdevid;
          }

          break;

      }

      if (this.isAppBatch) {
        var appids = '';
        this.info.data.forEach(function (vl) {
          appids += vl.appdevid + ',';
        });
        appids = appids.substring(0, appids.length - 1);
        this.$appBatchPush(appids, install, auto, pushType, terNos, mecId, terStatus, terNo, flNo, function (res) {
          console.log('pushRqs', res);
          _this3.loading = 0;
          _this3.check1 = false;
          _this3.check2 = false;
          if (res.status === 200) {
            _this3.pushAll = false;

            _this3.getDevices();
            _this3.pushDone = true;
          } else if (res.status === 300) {
            _this3.pushAll = false;
            _this3.pushAf = true;
            _this3.resAf = res;
          } else {
            _this3.$message.error(res.message);
          }
        }, function (error) {
          _this3.loading = 0;
          _this3.$message.error(_this3.$('app_rqsError'));
        });
      } else {
        this.$addPush(install, auto, objId, this.info.type, pushType, terNos, mecId, terStatus, terNo, flNo, function (res) {
          console.log('pushRqs', res);
          _this3.loading = 0;
          _this3.check1 = false;
          _this3.check2 = false;
          if (res.status === 200) {
            _this3.pushAll = false;

            _this3.getDevices();
            _this3.pushDone = true;
          } else if (res.status === 300) {
            _this3.pushAll = false;
            _this3.pushAf = true;
            _this3.resAf = res;
          } else {
            _this3.$message.error(res.message);
          }
        }, function (error) {
          _this3.loading = 0;
          _this3.$message.error(_this3.$('app_rqsError'));
        });
      }
    },
    bindOperate1: function bindOperate1(row) {

      if (this.info.type === '1' || this.info.type === '2') {
        this.pushQs = true;
        this.pushQsNo = row.terminalNo;
      } else {

        this.bindRqs('0', row.terminalNo);
      }
    },
    getChannels: function getChannels() {
      var _this4 = this;

      this.$getChannelList(10000, 1, '', '', '', function (res) {
        if (res.status === 200) {
          _this4.channels = res.data;
        } else {
          _this4.$message.error(res.message);
        }
      }, function () {
        _this4.$message.error(_this4.$t('app_rqsError'));
      });
    },
    getDevices: function getDevices() {
      var _this5 = this;

      var channel = this.channelId ? this.channelId : '';
      var terminalNo = this.iNo ? this.iNo : '';
      var status = this.status ? this.status : '';


      var mFileId, fileId, fileType;

      switch (this.info.type) {

        case '13':
          mFileId = localStorage.mechanismId;
          fileId = this.info.data.recordId;
          fileType = '13';
          break;
        case '4':
          mFileId = this.info.data.mechanismId;
          fileId = this.info.data.id;
          fileType = '';
          break;
        case '10':
          mFileId = this.info.data.distrabutorid;
          fileId = this.info.data.launcherid;
          fileType = '10';
          break;
        case '6':
          mFileId = '';
          fileId = this.info.data.animatId;
          fileType = '';
          break;
        case '2':
          mFileId = this.info.data.mechanismId;
          fileId = this.info.data.id;
          fileType = '';
          break;
        case '1':
          mFileId = '';

          if (this.isMarket) {
            fileId = this.info.data.applicationid;
          } else {
            fileId = this.info.data.appdevid;
          }
          fileType = '1';
          break;
      }

      if (this.info.type == 14 || this.info.type == 15) {
        this.loading = 1;
        this.$getNonItDv(this.index, this.$gRow, channel, terminalNo, status, '', '', '', '', '', function (res) {
          console.log('res', res);
          _this5.loading = 0;
          if (res.data) {
            _this5.total1 = res.total;
            _this5.tableData1 = res.data;

            var _this = _this5;
            var tsl = _this5.batchSl[_this5.index - 1];
            if (tsl) {
              var tm = [];
              tsl.forEach(function (vl) {
                res.data.forEach(function (vl1) {
                  if (vl.terminalNo == vl1.terminalNo) {
                    tm.push(vl1);
                  }
                });
              });
              setTimeout(function () {
                _this.toggleSelection(tm);
              }, 100);
            }
          }
        }, function () {
          _this5.loading = 0;
        });
      } else {
        this.loading = 1;
        this.$canPushTer(this.index, this.$gRow, mFileId, channel, status, terminalNo, fileType, fileId, function (res) {
          console.log('res', res);
          _this5.loading = 0;
          if (res.data) {
            _this5.total1 = res.total;
            _this5.tableData1 = res.data;

            var _this = _this5;
            var tsl = _this5.batchSl[_this5.index - 1];
            if (tsl) {
              var tm = [];
              tsl.forEach(function (vl) {
                res.data.forEach(function (vl1) {
                  if (vl.terminalNo == vl1.terminalNo) {
                    tm.push(vl1);
                  }
                });
              });
              setTimeout(function () {
                _this.toggleSelection(tm);
              }, 100);
            }
          }
        }, function () {
          _this5.loading = 0;
        });
      }
    },
    toggleSelection: function toggleSelection(rows) {
      var _this6 = this;

      if (rows) {
        rows.forEach(function (row) {
          _this6.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    bind: function bind(tId, tNo, tmid) {
      var _this7 = this;

      var vl = tId ? tId : '';
      this.loading = 1;

      var cId = this.info.appdevid ? this.info.appdevid : this.info.applicationid;

      if (this.$appUrlTag === 0) {
        this.$bindApp('0', vl, cId, function (res) {
          if (res.status === 200) {
            _this7.$message.success(_this7.$t('app_tipViewTask'));
          } else {
            _this7.$message.error(res.message);
          }
          _this7.loading = 0;
        }, function () {
          _this7.loading = 0;
        });
      } else {
        this.$bindApp1(tmid, tNo, cId, function (res) {
          if (res.status === 200) {
            _this7.$message.success(_this7.$t('app_tipViewTask'));
          } else {
            _this7.$message.error(res.message);
          }
          _this7.loading = 0;
        }, function () {
          _this7.loading = 0;
        });
      }
    },
    mulDelAppPush: function mulDelAppPush() {
      var _this8 = this;

      var title = this.$t('app_srdelpush');
      if (this.info.type == 1) {
        title = this.$t('app_isUnbindApp');
      }

      this.$showConfirm(this.$t('app_tip'), title, this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        console.log(_this8.list);
        var tNos = '';
        var pkg = _this8.detail.packageName;
        _this8.list.forEach(function (vl) {
          tNos += vl.terminalNo + ',';
        });
        tNos = tNos.substring(0, tNos.length - 1);

        if (!tNos) {
          _this8.$message($t('app_oneDeviceMust'));
          return;
        }
        _this8.appDelRqs(tNos, pkg);
      }, '');
    },
    delAppPush: function delAppPush(row) {
      var _this9 = this;

      var title = this.$t('app_srdelpush');
      if (this.info.type == 1) {
        title = this.$t('app_isUnbindApp');
      }
      this.$showConfirm(this.$t('app_tip'), title, this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        console.log(row, _this9.detail);
        _this9.appDelRqs(row.terminalNo, _this9.detail.packageName);
      }, '');
    },
    appDelRqs: function appDelRqs(nos, pkg) {
      var _this10 = this;

      var ns = nos ? nos : '';
      var p = pkg ? pkg : '';
      this.$unbind(ns, this.info.data.appVersion, p, function (res) {
        _this10.loading = 0;
        _this10.$message(res.message);
        if (res.status === 200) {
          _this10.getBinds();
        }
      }, function () {
        _this10.loading = 0;
      });
    },
    updateDv: function updateDv(row) {
      var _this11 = this;

      this.loading = 1;
      var cId = this.info.appdevid ? this.info.appdevid : this.info.applicationid;
      if (this.$appUrlTag === 0) {
        this.$bindApp('0', row.terminialId, cId, function (res) {
          _this11.loading = 0;
          _this11.$message(res.message);
          if (res.status === 200) {
            _this11.getBinds();
          }
        }, function () {
          _this11.loading = 0;
        });
      } else {
        this.$bindApp1(this.mechanismId, row.terminalNo, cId, function (res) {
          _this11.loading = 0;
          _this11.$message(res.message);
          if (res.status === 200) {
            _this11.getBinds();
          }
        }, function () {
          _this11.loading = 0;
        });
      }
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    },
    handleSelectionChange: function handleSelectionChange(list) {

      this.sNum = list.length;
      this.list = list;
    },
    allUnbind: function allUnbind() {
      var _this12 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_srrecovsysdf') + 'launcher?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        var tNos = '';

        _this12.list.forEach(function (vl) {
          tNos += vl.terminalNo + ',';
        });
        tNos = tNos.substring(0, tNos.length - 1);

        if (!tNos) {
          _this12.$message($t('app_oneDeviceMust'));
          return;
        }
        _this12.unbindReq(tNos, _this12.detail.packageName);
      }, '');
    },
    bindOperate: function bindOperate(row) {
      var _this13 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_srrecovsysdf') + 'launcher?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this13.unbindReq(row.terminalNo, _this13.detail.packageName);
      }, '');
    },
    unbindReq: function unbindReq(tNo, pkg) {
      var _this14 = this;

      var t = tNo ? tNo : '';
      var p = pkg ? pkg : '';
      this.loading = 1;
      this.$resetLauncher(p, t, function (res) {
        _this14.loading = 0;
        if (res.status === 200) {
          _this14.getBinds();
          _this14.$message(res.message);
        } else {
          _this14.$message(res.message);
        }
      }, function () {
        _this14.loading = 0;
        _this14.$message.error(_this14.$t('app_rqsError'));
      });
    },
    addBind: function addBind() {
      switch (this.info.type) {
        case '4':
          this.$router.push({ path: '/firmware/push/device' });
          break;
        case '10':
          this.$router.push({ path: '/launch-push/launch-push-ter' });
          break;
        case '6':
          this.$router.push({ path: '/animate-push/terminal' });
          break;
        case '2':
          this.$router.push({ path: '/romList/romPush/terminal' });
          break;
        case '1':
          if (this.isMarket) {
            this.$router.push({ path: '/appSlot/terminal-bind' });
          } else {
            this.$router.push({ path: '/appList/terminalbind' });
          }
          break;
      }
    },
    getBinds: function getBinds() {
      var _this15 = this;

      var id;
      switch (this.info.type) {
        case '15':
        case '14':
        case '4':
          id = this.info.data.id;
          break;
        case '10':
          id = this.info.data.launcherid;
          break;
        case '6':
          id = this.info.data.animatId;
          break;
        case '2':
          id = this.info.data.id;
          break;
        case '13':
          id = this.info.data.recordId;
          break;
        case '1':
          if (this.isMarket) {
            id = this.info.data.applicationid;
          } else {
            id = this.info.data.appdevid;
          }
          break;
      }
      if (!id) return;
      this.loading = 1;
      this.$pushedTerList(this.page, this.$gRow, id, function (res) {
        _this15.loading = 0;
        if (res.status === 200) {
          console.log(res);
          _this15.tableData = res.data;
          _this15.total = res.total;
        } else {
          _this15.$message.error(res.message);
        }
      }, function () {
        _this15.loading = 0;
      });
    },
    pageSelect: function pageSelect(index) {
      this.page = index;
      this.getBinds(index);
      this.$setWPage('appMarketPushPage', index);
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getBinds();
    },
    getDetail: function getDetail() {
      var _this16 = this;

      console.log(this.info, this.info.data.applicationid);

      var id, type;
      type = this.info.type;
      switch (this.info.type) {
        case '13':
          id = this.info.data.recordId;
          break;
        case '4':
        case '14':
        case '15':
          id = this.info.data.id;
          break;
        case '10':
          id = this.info.data.launcherid;
          break;
        case '6':
          id = this.info.data.animatId;
          break;
        case '2':
          id = this.info.data.id;
          break;
        case '1':
          if (this.isMarket) {
            id = this.info.data.applicationid;
          } else {
            id = this.info.data.appdevid;
          }
          break;
      }
      this.$pushFileDetail(id, type, function (res) {
        if (res.status === 200) {
          console.log(res);
          _this16.detail = res.data;
          console.log(_this16.detail);
          _this16.abc = res.data.fileType;
        } else {
          _this16.$message.error(res.message);
        }
      }, function () {});
    }
  },
  mounted: function mounted() {
    var _this17 = this;

    this.isMarket = this.$route.path === '/appslot/distribute-push';
    var gettype = Object.prototype.toString;
    var obj = this.$getWObj().pushList;
    this.isAppBatch = gettype.call(obj.data) == '[object Array]';
    this.info = obj;

    console.log('infooo', this.info);

    if (!this.isAppBatch) {
      setTimeout(function () {
        _this17.getBinds();
      }, 500);
      this.getDetail();
    }
    this.getDevices();
  }
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_url__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      vl: ''
    };
  },

  watch: {
    vl: function vl(_vl) {
      this.$emit('on-result-change', _vl);
    }
  },
  methods: {
    querySearch: function querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;

      cb(results);
    },
    createFilter: function createFilter(queryString) {
      return function (restaurant) {
        var strValue = restaurant.value.toLowerCase();
        var queryStr = queryString.toLowerCase();
        var boo = strValue.indexOf(queryStr) != -1;
        return boo;
      };
    },
    handleSelect: function handleSelect(item) {}
  },
  mounted: function mounted() {
    var _this = this;

    var params = { mechId: window.localStorage['mechanismId'] };
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/terminal/terminalNoList.do', params).then(function (res) {
      _this.restaurants = res.data.data;
    });
  },
  destroyed: function destroyed() {}
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      mbRouter: null,
      currentSelectName: null
    };
  },

  watch: {
    $route: function $route() {
      var that = this;
      that.initMbRouter(that.$route.matched);
    }
  },
  props: ['matched'],
  mounted: function mounted() {
    var that = this;
    that.initMbRouter(that.$route.matched);
  },

  methods: {
    initMbRouter: function initMbRouter(matched) {
      var that = this;

      that.mbRouter = matched;
      that.mbRouter = that.mbRouter.filter(function (r) {
        if (!r.name) {
          return false;
        } else {
          return true;
        }
      });

      var sl = that.mbRouter[that.mbRouter.length - 1];
      that.currentSelectName = sl.name;
    }
  }
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loading: true
    };
  },

  props: [],
  watch: {},
  computed: {
    gurl: function gurl() {
      return this.$store.getters.gIfurl;
    }
  },
  methods: {},
  mounted: function mounted() {
    var _this = this;
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function (e) {
      var iframe = document.getElementById("myiframe");
      if (iframe.attachEvent) {
        iframe.attachEvent("onload", function () {
          _this.loading = false;
        });
      } else {
        iframe.onload = function () {
          _this.loading = false;
        };
      }
    });
  },
  destroyed: function destroyed() {}
});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_tyc_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_tyc_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_tyc_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _ref;

    var that = this;
    return _ref = {
      isNon: false,
      tqobj: '',
      getftype: '',
      getstype: '',
      batchSl: [],
      queryKey: '',
      mechanismId: window.localStorage['mechanismId'],
      tableData: [],
      info: '',
      total: 0,
      pushedList: false,
      row: this.$gRow,
      page: 1,
      list: [],
      isMarket: false,
      isAppBatch: false,
      sNum: 0,
      detail: '',
      playPlace: {
        '1': this.$t('app_on'),
        '2': this.$t('app_off'),
        '3': this.$t('app_onOff')
      },
      adType: { '1': this.$t('app_launchAnimate'), '2': this.$t('app_onLogo') },

      mechanismData: {
        callback: function callback(value, obj) {
          that.selectMcObj = obj;
          that.channelId = value;
          that.selectChange1(value);
        }
      },
      dvStatus: '',
      dvsts: [],
      uldata: '',
      fileList: [],
      srcList: [],
      downTpl: __WEBPACK_IMPORTED_MODULE_1__api_url__["b" /* urlAssets */].prefix + 'tms-server-web/model/terminalNos.xlsx',
      importTemplate: __WEBPACK_IMPORTED_MODULE_1__api_url__["b" /* urlAssets */].prefix + 'tms-server-web/import/terminalList.do',
      formLabelWidth: '28.5%',
      selectMcObj: '',
      sNum1: 0,
      resAf: '',
      check1: false,
      check2: false,
      pushQs: false,
      pushQsNo: '',
      pushAll: false,
      pushAf: false,
      pushDone: false,
      pushImport: false,
      status: '',
      iNo: '',
      selected: []
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'info', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'launcherBind', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'tableData1', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'multipleSelection', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'channels', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'channelId', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'loading', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'total1', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'index', 1), _ref;
  },

  components: { MechanismSelector: __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue___default.a, tyc: __WEBPACK_IMPORTED_MODULE_3__components_global_tyc_vue___default.a },
  computed: {
    fileName: function fileName() {
      console.log('dddd', this.info);
      switch (this.info.type) {
        case '4':
          return this.info.data.firmwareName;
          break;
        case '10':

          break;
        case '6':

          break;
        case '2':
          return this.info.data.name;
          break;
        case '1':
          if (this.isAppBatch) {
            var appNames = '';
            this.info.data.forEach(function (vl) {
              appNames += vl.appName + ',';
            });
            appNames = appNames.substring(0, appNames.length - 1);
            return appNames;
          } else {
            return this.info.data.appName;
          }
          break;
      }
    },
    surePushTip: function surePushTip() {
      return this.$t('app_psdonelftip').replace('{num}', this.pushAfNum);
    },
    pushAfNum: function pushAfNum() {
      return this.resAf ? this.resAf.data.nums : '';
    },
    fileUploadUrl: function fileUploadUrl() {
      return __WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/terminal/importTers.do' + "?language=" + localStorage.sys_lang + '&token=' + localStorage.user;
    },
    allMcName: function allMcName() {

      var mc = this.selectMcObj ? this.selectMcObj.name : this.$t('lin_global.all_mechanism');
      var sp = "   ，";
      var str = this.$t('app_ispushalldv') + '？' + this.$t('app_distributor') + '：' + mc + sp + this.$t('app_status') + '：' + this.dvStatus[this.status] + sp + this.$t('app_deviceNum') + '：' + this.total1;

      return str;
    },
    stModel: function stModel() {
      var app = '';
      if (this.isNon) {

        app = [{ vl: '', lb: this.$t('lin_global.all_status') }, { vl: '0', lb: this.$t('app_new') }, { vl: '1', lb: this.$t('app_enable') }];
      } else {
        app = this.dvsts;
      }
      return app;
    },
    isLauncher: function isLauncher() {
      if (this.launcherBind) {
        return true;
      } else {
        return false;
      }
    },
    dfDelCt: function dfDelCt() {
      var dfstr = this.$t('app_del');
      if (this.info) {
        if (this.info.type === '1') {
          return this.$t('app_unbind');
        } else {
          return dfstr;
        }
      } else {
        return dfstr;
      }
    },
    cmType: function cmType() {
      var type = '';
      if (this.info.type === '2') {
        type = this.detail.fileType === '0' ? this.$t('app_ttPkg') : this.$t('app_dfPkg');
      } else if (this.info.type === '4') {
        type = this.detail ? this.detail.fileType : '';
      }
      return type;
    },
    avtStyle: function avtStyle() {
      return 'background-size: cdetachIndexge: url(' + this.avt + ')';
    },
    index: function index() {
      return this.$getWPage('appMarketPushPage');
    }
  },
  methods: {
    query: function query() {},
    batchTotal: function batchTotal(detachIndex, msl) {
      var num = 0;
      this.batchSl.forEach(function (arr, index) {
        if (index != detachIndex) {
          num += arr.length;
        }
      });
      return num + msl.length;
    },
    refreshBind: function refreshBind() {
      this.getBinds();
    },
    surePush: function surePush() {
      this.pushQs = false;
      this.bindRqs('0', this.pushQsNo, this.check2, this.check1);
    },
    closeImport: function closeImport() {
      this.fileList = [];
      this.uldata = '';
    },
    handleRemove: function handleRemove() {},
    ulError: function ulError() {
      window[this.$route.path] = '';
    },
    srcSuccess: function srcSuccess(res, file) {
      window[this.$route.path] = '';


      if (res.status === 200) {
        this.fileList = [{ name: file.name }];
        this.uldata = res.data;
      } else {

        this.srcList = [];

        this.$message.error(res.message);
      }
    },
    srcBefore: function srcBefore(file) {
      window[this.$route.path] = 1;
    },
    submitUpload: function submitUpload() {
      this.bindRqs('2');
      this.pushImport = false;
    },
    jumpNow: function jumpNow() {
      this.$router.push({ path: '/task/ptask' });
    },
    skipPush: function skipPush() {},
    surePushAll: function surePushAll() {
      this.bindRqs('1', '');
    },
    surePushAf: function surePushAf() {
      this.bindRqs('1', '');
    },
    coverPush: function coverPush(cvParam) {
      var _this2 = this;

      this.loading = 1;
      this.$isCoverPush(this.resAf.data.taskId, this.resAf.data.pushParam, cvParam, function (res) {
        _this2.loading = 0;
        if (res.status === 200) {
          _this2.pushAf = false;
          _this2.pushDone = true;
        } else {
          _this2.$message.error(res.message);
        }
      }, function (error) {
        _this2.loading = 0;
        _this2.$message.error(_this2.$('app_rqsError'));
      });
    },
    pageSelect1: function pageSelect1(index) {
      this.fillBatchsl();

      this.index = index;

      this.getDevices();
    },
    pageSized1: function pageSized1(val) {
      this.batchSl = [];

      this.$gRow = val;

      this.getDevices();
    },
    selectChange1: function selectChange1(vl) {

      this.getDevices();
    },
    selectStChange: function selectStChange(vl) {

      this.getDevices();
    },
    srch: function srch() {

      this.getDevices();
    },
    fillBatchsl: function fillBatchsl() {
      this.batchSl[this.index - 1] = this.selected;
    },
    handleSelectionChange1: function handleSelectionChange1(list) {
      this.sNum1 = this.batchTotal(this.index - 1, list);
      this.selected = list;
    },
    multiBind: function multiBind() {
      this.fillBatchsl();

      var ids = '';
      var tNo = '';
      var tmid = '';


      this.batchSl.forEach(function (arr) {
        arr.forEach(function (vl) {
          ids += vl.terminalId + ',';
          tNo += vl.terminalNo + ',';
          tmid += vl.manufId + ',';
        });
      });

      ids = ids.substring(0, ids.length - 1);
      tNo = tNo.substring(0, tNo.length - 1);
      tmid = tmid.substring(0, tmid.length - 1);

      if (!tNo) {
        this.$message(this.$t('app_oneDeviceMust'));
        return;
      }

      if (this.info.type === '1' || this.info.type === '2') {
        this.pushQs = true;
        this.pushQsNo = tNo;
      } else {
        this.bindRqs('0', tNo);
      }
    },
    bindRqs: function bindRqs(pushType, tNos) {
      var _this3 = this;

      this.loading = 1;
      var terNos = '';
      var mecId = '';
      var terStatus = '';
      var terNo = '';
      var flNo = '';
      var objId = '';
      var auto = this.check1 ? '1' : '0';
      var install = this.check2 ? '1' : '0';
      switch (pushType) {
        case '0':
          terNos = tNos;
          break;
        case '1':
          mecId = this.channelId ? this.channelId : '';
          terStatus = this.status ? this.status : '';
          terNo = this.iNo ? this.iNo : '';
          break;
        case '2':
          flNo = this.uldata ? this.uldata.fileNo : '';
          break;
      }

      switch (this.info.type) {
        case '13':
          objId = this.info.data.recordId;
          break;
        case '4':
        case '2':
        case '14':
        case '15':
          objId = this.info.data.id;
          break;
        case '10':
          objId = this.info.data.launcherid;
          break;
        case '6':
          objId = this.info.data.animatId;
          break;
        case '1':
          if (this.isMarket) {
            objId = this.info.data.applicationid;
          } else {
            objId = this.info.data.appdevid;
          }

          break;

      }

      this.$filePush(this.info.fileId, auto, install, pushType, terNos, mecId, terStatus, terNo, flNo, function (res) {
        console.log('pushRqs', res);
        _this3.loading = 0;
        _this3.check1 = false;
        _this3.check2 = false;
        if (res.status === 200) {
          _this3.pushAll = false;

          _this3.getDevices();
          _this3.pushDone = true;
        } else if (res.status === 300) {
          _this3.pushAll = false;
          _this3.pushAf = true;
          _this3.resAf = res;
        } else {
          _this3.$message.error(res.message);
        }
      }, function (error) {
        _this3.loading = 0;
        _this3.$message.error(_this3.$('app_rqsError'));
      });
    },
    bindOperate1: function bindOperate1(row) {

      if (this.info.type === '1' || this.info.type === '2') {
        this.pushQs = true;
        this.pushQsNo = row.terminalNo;
      } else {

        this.bindRqs('0', row.terminalNo);
      }
    },
    getChannels: function getChannels() {
      var _this4 = this;

      this.$getChannelList(10000, 1, '', '', '', function (res) {
        if (res.status === 200) {
          _this4.channels = res.data;
        } else {
          _this4.$message.error(res.message);
        }
      }, function () {
        _this4.$message.error(_this4.$t('app_rqsError'));
      });
    },
    getDevices: function getDevices() {
      var _this5 = this;

      var channel = this.channelId ? this.channelId : '';
      var terminalNo = this.iNo ? this.iNo : '';
      var status = this.status ? this.status : '';


      var mFileId, fileId, fileType;

      switch (this.info.fileType) {
        case '1':
        case '2':
        case '3':
        case '4':
        case '5':
          this.isNon = false;
          break;
        case '6':
          this.isNon = true;
          this.getNonDevices();
          return;
          break;
      }

      this.loading = 1;
      this.$canPushTer(this.index, this.$gRow, mFileId, channel, status, terminalNo, fileType, fileId, function (res) {
        console.log('res', res);
        _this5.loading = 0;
        if (res.data) {
          _this5.total1 = res.total;
          _this5.tableData1 = res.data;

          var _this = _this5;
          var tsl = _this5.batchSl[_this5.index - 1];
          if (tsl) {
            var tm = [];
            tsl.forEach(function (vl) {
              res.data.forEach(function (vl1) {
                if (vl.terminalNo == vl1.terminalNo) {
                  tm.push(vl1);
                }
              });
            });
            setTimeout(function () {
              _this.toggleSelection(tm);
            }, 100);
          }
        }
      }, function () {
        _this5.loading = 0;
      });
    },
    getNonDevices: function getNonDevices() {
      var _this6 = this;

      var channel = this.channelId ? this.channelId : '';
      var terminalNo = this.iNo ? this.iNo : '';
      var status = this.status ? this.status : '';


      this.loading = 1;
      this.$getNonItDv(this.index, this.$gRow, channel, terminalNo, status, '', '', '', '', '', function (res) {

        _this6.loading = 0;
        if (res.data) {
          _this6.tableData1 = res.data;
          _this6.total1 = res.total;
        }
      }, function () {
        _this6.loading = 0;
      });
    },
    toggleSelection: function toggleSelection(rows) {
      var _this7 = this;

      if (rows) {
        rows.forEach(function (row) {
          _this7.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    bind: function bind(tId, tNo, tmid) {
      var _this8 = this;

      var vl = tId ? tId : '';
      this.loading = 1;

      var cId = this.info.appdevid ? this.info.appdevid : this.info.applicationid;

      if (this.$appUrlTag === 0) {
        this.$bindApp('0', vl, cId, function (res) {
          if (res.status === 200) {
            _this8.$message.success(_this8.$t('app_tipViewTask'));
          } else {
            _this8.$message.error(res.message);
          }
          _this8.loading = 0;
        }, function () {
          _this8.loading = 0;
        });
      } else {
        this.$bindApp1(tmid, tNo, cId, function (res) {
          if (res.status === 200) {
            _this8.$message.success(_this8.$t('app_tipViewTask'));
          } else {
            _this8.$message.error(res.message);
          }
          _this8.loading = 0;
        }, function () {
          _this8.loading = 0;
        });
      }
    },
    mulDelAppPush: function mulDelAppPush() {
      var _this9 = this;

      var title = this.$t('app_srdelpush');
      if (this.info.type == 1) {
        title = this.$t('app_isUnbindApp');
      }

      this.$showConfirm(this.$t('app_tip'), title, this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        console.log(_this9.list);
        var tNos = '';
        var pkg = _this9.detail.packageName;
        _this9.list.forEach(function (vl) {
          tNos += vl.terminalNo + ',';
        });
        tNos = tNos.substring(0, tNos.length - 1);

        if (!tNos) {
          _this9.$message($t('app_oneDeviceMust'));
          return;
        }
        _this9.appDelRqs(tNos, pkg);
      }, '');
    },
    delAppPush: function delAppPush(row) {
      var _this10 = this;

      var title = this.$t('app_srdelpush');
      if (this.info.type == 1) {
        title = this.$t('app_isUnbindApp');
      }
      this.$showConfirm(this.$t('app_tip'), title, this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        console.log(row, _this10.detail);
        _this10.appDelRqs(row.terminalNo, _this10.detail.packageName);
      }, '');
    },
    appDelRqs: function appDelRqs(nos, pkg) {
      var _this11 = this;

      var ns = nos ? nos : '';
      var p = pkg ? pkg : '';
      this.$unbind(ns, this.info.data.appVersion, p, function (res) {
        _this11.loading = 0;
        _this11.$message(res.message);
        if (res.status === 200) {
          _this11.getBinds();
        }
      }, function () {
        _this11.loading = 0;
      });
    },
    updateDv: function updateDv(row) {
      var _this12 = this;

      this.loading = 1;
      var cId = this.info.appdevid ? this.info.appdevid : this.info.applicationid;
      if (this.$appUrlTag === 0) {
        this.$bindApp('0', row.terminialId, cId, function (res) {
          _this12.loading = 0;
          _this12.$message(res.message);
          if (res.status === 200) {
            _this12.getBinds();
          }
        }, function () {
          _this12.loading = 0;
        });
      } else {
        this.$bindApp1(this.mechanismId, row.terminalNo, cId, function (res) {
          _this12.loading = 0;
          _this12.$message(res.message);
          if (res.status === 200) {
            _this12.getBinds();
          }
        }, function () {
          _this12.loading = 0;
        });
      }
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    },
    handleSelectionChange: function handleSelectionChange(list) {

      this.sNum = list.length;
      this.list = list;
    },
    allUnbind: function allUnbind() {
      var _this13 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_srrecovsysdf') + 'launcher?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        var tNos = '';

        _this13.list.forEach(function (vl) {
          tNos += vl.terminalNo + ',';
        });
        tNos = tNos.substring(0, tNos.length - 1);

        if (!tNos) {
          _this13.$message($t('app_oneDeviceMust'));
          return;
        }
        _this13.unbindReq(tNos, _this13.detail.packageName);
      }, '');
    },
    bindOperate: function bindOperate(row) {
      var _this14 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_srrecovsysdf') + 'launcher?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this14.unbindReq(row.terminalNo, _this14.detail.packageName);
      }, '');
    },
    unbindReq: function unbindReq(tNo, pkg) {
      var _this15 = this;

      var t = tNo ? tNo : '';
      var p = pkg ? pkg : '';
      this.loading = 1;
      this.$resetLauncher(p, t, function (res) {
        _this15.loading = 0;
        if (res.status === 200) {
          _this15.getBinds();
          _this15.$message(res.message);
        } else {
          _this15.$message(res.message);
        }
      }, function () {
        _this15.loading = 0;
        _this15.$message.error(_this15.$t('app_rqsError'));
      });
    },
    addBind: function addBind() {
      switch (this.info.type) {
        case '4':
          this.$router.push({ path: '/firmware/push/device' });
          break;
        case '10':
          this.$router.push({ path: '/launch-push/launch-push-ter' });
          break;
        case '6':
          this.$router.push({ path: '/animate-push/terminal' });
          break;
        case '2':
          this.$router.push({ path: '/romList/romPush/terminal' });
          break;
        case '1':
          if (this.isMarket) {
            this.$router.push({ path: '/appSlot/terminal-bind' });
          } else {
            this.$router.push({ path: '/appList/terminalbind' });
          }
          break;
      }
    },
    getBinds: function getBinds() {
      var _this16 = this;

      var id = this.info.fileId;
      if (!id) return;
      this.loading = 1;
      this.$pushedTerList(this.page, this.$gRow, id, function (res) {
        _this16.loading = 0;
        if (res.status === 200) {
          console.log(res);
          _this16.tableData = res.data;
          _this16.total = res.total;
        } else {
          _this16.$message.error(res.message);
        }
      }, function () {
        _this16.loading = 0;
      });
    },
    pageSelect: function pageSelect(index) {
      this.page = index;
      this.getBinds(index);
      this.$setWPage('appMarketPushPage', index);
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getBinds();
    },
    getDetail: function getDetail() {
      var _this17 = this;

      return;

      console.log(this.info, this.info.data.applicationid);

      var id, type;
      type = this.info.type;
      switch (this.info.type) {
        case '13':
          id = this.info.data.recordId;
          break;
        case '4':
        case '14':
        case '15':
          id = this.info.data.id;
          break;
        case '10':
          id = this.info.data.launcherid;
          break;
        case '6':
          id = this.info.data.animatId;
          break;
        case '2':
          id = this.info.data.id;
          break;
        case '1':
          if (this.isMarket) {
            id = this.info.data.applicationid;
          } else {
            id = this.info.data.appdevid;
          }
          break;
      }
      this.$pushFileDetail(id, type, function (res) {
        if (res.status === 200) {
          console.log(res);
          _this17.detail = res.data;
          console.log(_this17.detail);
          _this17.abc = res.data.fileType;
        } else {
          _this17.$message.error(res.message);
        }
      }, function () {});
    }
  },
  mounted: function mounted() {
    var _this18 = this;

    this.tqobj = {
      keys: ['ftype', 'sftype', 'terminalType', 'terminalTypes'],
      callback: function callback(data) {
        _this18.getftype = data[0];
        _this18.getstype = data[1];
        _this18.dvStatus = data[2];
        _this18.dvsts = data[3];
      }
    };

    this.info = this.$getWObj().filePush;

    this.getDevices();

    setTimeout(function () {
      _this18.getBinds();
    }, 500);
    this.getDetail();
  }
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SIdentify',
  data: function data() {
    return {
      identifyCode: '',
      fontSizeMin: 25,
      fontSizeMax: 35,
      backgroundColorMin: 200,
      backgroundColorMax: 220,
      dotColorMin: 60,
      dotColorMax: 120,
      contentWidth: 110,
      contentHeight: 40
    };
  },

  watch: {
    data: function data(n, o) {
      this.setVal();
    }
  },
  props: ["data"],
  methods: {
    redraw: function redraw() {
      var _this = this;

      this.$getCheckcode(function (res) {
        _this.identifyCode = res.data.code;
        _this.drawPic();
        if (_this.data.callback) {
          _this.data.callback(res.data);
        }
      });
    },
    getList: function getList(name, callback) {
      this.$getChannelList(9999, 1, '', '', name, function (res) {
        if (callback) callback(res.data);
      }, '');
    },
    randomNum: function randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    randomColor: function randomColor(min, max) {
      var r = this.randomNum(min, max);
      var g = this.randomNum(min, max);
      var b = this.randomNum(min, max);
      return 'rgb(' + r + ',' + g + ',' + b + ')';
    },
    drawPic: function drawPic() {
      var canvas = document.getElementById('s-canvas');
      var ctx = canvas.getContext('2d');
      ctx.textBaseline = 'bottom';

      ctx.fillStyle = this.randomColor(this.backgroundColorMin, this.backgroundColorMax);
      ctx.fillRect(0, 0, this.contentWidth, this.contentHeight);

      for (var i = 0; i < this.identifyCode.length; i++) {
        this.drawText(ctx, this.identifyCode[i], i);
      }
      this.drawLine(ctx);
      this.drawDot(ctx);
    },
    drawText: function drawText(ctx, txt, i) {
      ctx.fillStyle = this.randomColor(50, 160);
      ctx.font = this.randomNum(this.fontSizeMin, this.fontSizeMax) + 'px SimHei';
      var x = (i + 1) * (this.contentWidth / (this.identifyCode.length + 1));
      var y = this.randomNum(this.fontSizeMax, this.contentHeight - 5);
      var deg = this.randomNum(-30, 30);

      ctx.translate(x, y);
      ctx.rotate(deg * Math.PI / 180);
      ctx.fillText(txt, 0, 0);

      ctx.rotate(-deg * Math.PI / 180);
      ctx.translate(-x, -y);
    },
    drawLine: function drawLine(ctx) {
      for (var i = 0; i < 4; i++) {
        ctx.strokeStyle = this.randomColor(100, 200);
        ctx.beginPath();
        ctx.moveTo(this.randomNum(0, this.contentWidth), this.randomNum(0, this.contentHeight));
        ctx.lineTo(this.randomNum(0, this.contentWidth), this.randomNum(0, this.contentHeight));
        ctx.stroke();
      }
    },
    drawDot: function drawDot(ctx) {
      for (var i = 0; i < 30; i++) {
        ctx.fillStyle = this.randomColor(0, 255);
        ctx.beginPath();
        ctx.arc(this.randomNum(0, this.contentWidth), this.randomNum(0, this.contentHeight), 1, 0, 2 * Math.PI);
        ctx.fill();
      }
    }
  },
  mounted: function mounted() {
    this.redraw();
  }
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'templateName',
	data: function data() {
		return {
			acVal: '',
			value1: "",
			parentId: null,
			areaList1: null,
			datas: [],
			cLock: false,
			isNoInput: true,
			tempWords: ''
		};
	},
	deactivated: function deactivated() {
		this.$destroy(true);
	},

	watch: {
		data: function data(n, o) {
			this.setVal();
		}
	},
	props: ["data", "classs", "mselect"],
	methods: {
		cChange: function cChange() {
			if (!this.acVal) {

				if (this.data.callback) {
					this.data.callback('');
					this.isNoInput = true;
				}
			}
		},
		querySearchAsync: function querySearchAsync(queryString, cb) {
			var _this2 = this;

			this.tempWords = queryString;
			if (this.isNoInput && queryString) {
				this.isNoInput = false;
			}
			if (!this.cLock) {
				this.cLock = true;
				var _this = this;
				setTimeout(function () {
					_this.cLock = false;
					_this.tempWords = _this.tempWords ? _this.tempWords : _this.$getWObj().login.mechanismName;
					if (_this.tempWords) {
						_this.getList(_this.tempWords, function (data) {
							cb(data);
						});
					} else {
						cb(_this2.datas);
						if (_this2.data.callback) {
							if (!_this2.isNoInput) {
								_this2.data.callback('');
								_this2.isNoInput = true;
							}
						}
					}
				}, 2000);
			}
		},
		handleSelect: function handleSelect(item) {

			if (this.data.callback && item) {
				if (item.mechanismid) {
					this.data.callback(item.mechanismid, item);
				} else {
					this.data.callback('', '');
				}
			} else {

				this.data.callback('', '');
			}
		},
		getList: function getList(name, callback) {
			this.$getChannelList(9999, 1, '', '', name, function (res) {
				if (callback) callback(res.data);
			}, '');
		},

		getAd1: function getAd1() {
			var _this3 = this;

			var that = this;
			var params = {
				token: localStorage.getItem('user'),
				language: localStorage.getItem("system_lang")
			};
			if (that.parentId) {
				params.parentId = that.parentId;
				console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params, null, 2));
			}
			axios.post(baseurl + '/mechanism/parent_list.do', params).then(function (res) {
				that.areaList1 = res.data.data;
				if (that.data.value) {
					that.value1 = that.data.value;
				}
				var comp = function comp(grade) {
					return function (a, b) {
						return Number(a[grade]) > Number(b[grade]) ? 1 : -1;
					};
				};
				that.areaList1 = that.areaList1.sort(comp('grade'));
				var mTreeSort = function mTreeSort(ttmp, data, id) {
					var forE = function forE(data, id) {
						for (var i = 0; i < data.length; i++) {
							var item = data[i];
							if (item.pid === id) {
								ttmp.push(item);
								forE(data, item.id);
							} else {
								continue;
							}
						}
					};
					forE(data, id);
					return ttmp;
				};
				var level = 0;
				if (that.areaList1 && that.areaList1.length > 0) {
					level = that.areaList1[0]['grade'];
				}
				var rrd = that.areaList1.filter(function (r) {
					return r['grade'] === level;
				});
				if (rrd.length > 0) {
					var ttmp = [];
					ttmp.push(rrd[0]);
					mTreeSort(ttmp, that.areaList1, rrd[0]['id']);
					that.areaList1 = ttmp;
					if (!that.mselect) {
						var obj = {
							'name': _this3.$t('lin_global.all_mechanism'),
							'id': ''
						};
						_this3.areaList1.unshift(obj);
					}
				}
			});
		},
		init: function init() {},
		setVal: function setVal() {
			var vl = this.data.value;
			vl = vl ? vl : '';
			this.acVal = vl;
		}
	},
	mounted: function mounted() {
		this.setVal();
	}
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      arraySizes: [20, 30, 30, 40],
      layout: "total, sizes, prev, pager, next"
    };
  },
  deactivated: function deactivated() {
    this.$destroy(true);
  },

  props: ['rdata', 'action', 'arraySize', 'layoutIn'],
  mounted: function mounted() {
    var that = this;

    if (that.arraySize) that.arraySizes = that.arraySize.replace("[", "").replace("]", "").split(",");
    if (that.layoutIn) that.layout = that.layoutIn;
  },

  methods: {
    handleSizeChange: function handleSizeChange(v) {
      this.action.handleSizeChange(v);
    },
    handleCurrentChange: function handleCurrentChange(v) {
      this.action.handleCurrentChange(v);
    }
  }
});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tyc__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tyc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tyc__);



/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		tyc: __WEBPACK_IMPORTED_MODULE_0__tyc___default.a
	},
	data: function data() {
		return {
			tqobj: '',
			terSt: '',
			terType: {
				'0': 'gray',
				'1': 'success',
				'2': 'danger',
				'3': 'warning',
				'4': 'danger'
			},
			nterSt: '',
			nterType: {
				'0': 'gray',
				'1': 'success'
			},
			openAuthSt: '',
			openAuthType: {
				'0': 'success',
				'1': 'danger'
			}
		};
	},

	props: ['tagobj'],
	watch: {
		tagobj: function tagobj() {}
	},
	computed: {},
	methods: {},
	mounted: function mounted() {
		var _this = this;

		this.tqobj = {
			keys: ['terminalType', 'nonTerType', 'openplAuth'],
			callback: function callback(data) {
				_this.terSt = data[0];
				_this.nterSt = data[1];
				_this.openAuthSt = data[2];
			}
		};
	}
});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      terminalTypes: [{ lb: this.$t('lin_global.all_status'), vl: '' }, { lb: this.$t('app_online'), vl: '1' }, { lb: this.$t('app_offline'), vl: '2' }, { lb: this.$t('app_new'), vl: '0' }, { lb: this.$t('app_sleep'), vl: '3' }],
      terminalType: {
        '': this.$t('lin_global.all_status'),
        '0': this.$t('app_new'),
        '1': this.$t('app_online'),
        '2': this.$t('app_offline'),
        '3': this.$t('app_sleep')
      },
      nonTerType: {
        '': this.$t('lin_global.all_status'),
        '0': this.$t('app_new'),
        '1': this.$t('app_enable')
      },
      nonTerTypes: [{ vl: '', lb: this.$t('lin_global.all_status') }, { vl: '0', lb: this.$t('app_new') }, { vl: '1', lb: this.$t('app_enable') }],
      openplAuth: {
        '': this.$t('lin_global.all_status'),
        '0': this.$t('app_open1'),
        '1': this.$t('app_close')
      },
      openplAuths: [{ vl: '', lb: this.$t('lin_global.all_status') }, { vl: '0', lb: this.$t('app_open1') }, { vl: '1', lb: this.$t('app_close') }],
      taskType: {
        "1": this.$t('terminal.details.app_install'),
        "2": this.$t('app_sysud'),

        "4": this.$t('app_fmwud'),
        "5": this.$t('app_advpush'),
        "6": this.$t('app_anmud'),
        "7": this.$t('app_anmud'),
        "8": this.$t('app_anmud'),
        "9": this.$t('app_anmud'),
        "10": 'launcher' + this.$t('app_update'),
        "11": this.$t('app_anmud'),
        "12": this.$t('app_appuninstall'),

        "14": this.$t('app_qcgunsrcps'),
        "15": this.$t('app_qcgunsrcps'),
        "16": 'cfg' + this.$t('lin_btn.send'),
        "18": 'linux' + this.$t('app_srcfileps')
      },
      taskTypeArr: [{ type: "", name: this.$t('taskTypeNames.ALL') }, { type: "1", name: this.$t('terminal.details.app_install') }, { type: "2", name: this.$t('app_sysud') }, { type: "4", name: this.$t('app_fmwud') }, { type: "5", name: this.$t('app_advpush') }, { type: "6", name: this.$t('app_anmud') }, { type: "10", name: 'launcher' + this.$t('app_update') }, { type: "12", name: this.$t('app_appuninstall') }, { type: "14", name: this.$t('app_qcgunsrcps') }, { type: "16", name: 'cfg' + this.$t('lin_btn.send') }, { type: "18", name: 'linux' + this.$t('app_srcfileps') }],
      taskTypeArr1: [{ type: "", name: this.$t('taskTypeNames.ALL') }, { type: "1", name: "OTA" }, { type: "2", name: this.$t('app_firmw') }, { type: "3", name: this.$t('app_animation') }, { type: "4", name: "launcher" }, { type: "5", name: 'cfg ' + this.$t('app_file') }, { type: "12", name: this.$t('app_rtosgunsrc') }, { type: "7", name: this.$t('app_app') }, { type: "8", name: 'linux ' + this.$t('app_app') }, { type: "9", name: this.$t('app_commpush') }, { type: "10", name: 'linux ' + this.$t('app_firmw') }, { type: "11", name: this.$t('app_filepush') }, { type: "6", name: this.$t('app_codegunsrc') }],
      taskTypeArr1_1: [{ type: "1", name: "OTA" }, { type: "2", name: this.$t('app_firmw') }, { type: "3", name: this.$t('app_animation') }, { type: "4", name: "launcher" }, { type: "5", name: 'cfg ' + this.$t('app_file') }, { type: "7", name: this.$t('app_app') }, { type: "8", name: 'linux ' + this.$t('app_app') }, { type: "9", name: this.$t('app_commpush') }, { type: "10", name: 'linux ' + this.$t('app_firmw') }, { type: "11", name: this.$t('app_filepush') }],
      taskTypeArr1_2: [{ type: "12", name: this.$t('app_rtosgunsrc') }, { type: "6", name: this.$t('app_codegunsrc') }],
      taskTypeArr2: [{ type: "", name: this.$t('taskTypeNames.ALL') }, { type: "1", name: this.$t('app_apppush') }, { type: "2", name: 'OTA' + this.$t('lin_btn.send') }, { type: "4", name: this.$t('app_fmwpush') }, { type: "6", name: this.$t('app_animatePush') }, { type: "10", name: 'launcher' + this.$t('lin_btn.send') }, { type: "14", name: this.$t('app_qcgunsrcps') }, { type: "15", name: this.$t('app_mstype15') }, { type: "16", name: 'cfg' + this.$t('lin_btn.send') }, { type: "18", name: 'linux ' + this.$t('app_app') }, { type: "19", name: this.$t('app_commpush') }, { type: '20', name: 'linux ' + this.$t('app_firmw') }, { type: '21', name: this.$t('app_filepush') }],
      taskType2: {
        "": this.$t('taskTypeNames.ALL'),
        "1": this.$t('app_apppush'),
        "2": 'OTA' + this.$t('lin_btn.send'),

        "4": this.$t('app_fmwpush'),

        "6": this.$t('app_animatePush'),
        "7": this.$t('app_animatePush'),
        "8": this.$t('app_animatePush'),
        "9": this.$t('app_animatePush'),
        "10": 'launcher' + this.$t('lin_btn.send'),
        "11": this.$t('app_wppush'),
        "12": this.$t('app_appuninstall'),

        "14": this.$t('app_qcgunsrcps'),
        "15": this.$t('app_mstype15'),
        "16": 'cfg' + this.$t('lin_btn.send'),
        "18": 'linux ' + this.$t('app_app'),
        "19": this.$t('app_commpush'),
        '20': 'linux ' + this.$t('app_firmw'),
        '21': this.$t('app_filepush')
      },
      comms: [{ lb: this.$t('app_dvrestart'), vl: 'CQ' }, { lb: this.$t('app_recvorgst'), vl: 'HFCCSZ' }, { lb: this.$t('app_recvanimt'), vl: 'HYDH' }, { lb: this.$t('app_recov') + 'launcher', vl: 'QCZM' }, { lb: this.$t('app_dvlock'), vl: 'SJ' }, { lb: this.$t('app_dvunlock'), vl: 'JS' }, { lb: this.$t('app_pusheddvlist'), vl: 'XZYY' }, { lb: this.$t('app_lcswitch'), vl: 'ZQ' }],
      comms1: [{ lb: this.$t('app_dvrestart'), vl: 'CQ' }, { lb: this.$t('app_recvorgst'), vl: 'HFCCSZ' }, { lb: this.$t('app_recvanimt'), vl: 'HYDH' }, { lb: this.$t('app_recov') + 'launcher', vl: 'QCZM' }, { lb: this.$t('app_dvlock'), vl: 'SJ' }, { lb: this.$t('app_dvunlock'), vl: 'JS' }, { lb: this.$t('app_pusheddvlist'), vl: 'XZYY' }, { lb: this.$t('app_lcswitch'), vl: 'ZQ' }, { lb: this.$t('terminal.details.open_abd'), vl: 'ADBCTL-OPEN' }, { lb: this.$t('terminal.details.close_abd'), vl: 'ADBCTL-CLOSE' }, { lb: this.$t('app_openCerCheck'), vl: 'YQCTL-OPEN' }, { lb: this.$t('app_closeCerCheck'), vl: 'YQCTL-CLOSE' }],
      comm: {
        'CQ': this.$t('app_dvrestart'),
        'HFCCSZ': this.$t('app_recvorgst'),
        'HYDH': this.$t('app_recvanimt'),
        'QCZM': this.$t('app_recov') + 'launcher',
        'SJ': this.$t('app_dvlock'),
        'JS': this.$t('app_dvunlock'),
        'XZYY': this.$t('app_pusheddvlist'),
        'ZQ': this.$t('app_lcswitch'),
        'ADBCTL-OPEN': this.$t('terminal.details.open_abd'),
        'ADBCTL-CLOSE': this.$t('terminal.details.close_abd'),
        'YQCTL-OPEN': this.$t('app_openCerCheck'),
        'YQCTL-CLOSE': this.$t('app_closeCerCheck')
      },
      appVSts: [{ label: this.$t("app_prePushVerify"), value: "0" }, { label: this.$t("app_preVerify"), value: "1" }, { label: this.$t("app_verifyPass"), value: "2" }, { label: this.$t("app_verifyNotPass"), value: "3" }],
      appVSt: {
        "0": this.$t("app_prePushVerify"),
        "1": this.$t("app_preVerify"),
        "2": this.$t("app_verifyPass"),
        "3": this.$t("app_verifyNotPass")
      },
      nolcft: [{ vl: '1', lb: 'OTA' }, { vl: '2', lb: this.$t('app_firmw') }, { vl: '3', lb: this.$t('app_animation') }, { vl: '5', lb: 'CFG' + this.$t('app_file') }, { vl: '11', lb: this.$t('app_rtosgunsrc') }, { vl: '7', lb: this.$t('app_app') }, { vl: '8', lb: 'linux ' + this.$t('app_app') }, { vl: '9', lb: 'linux ' + this.$t('app_firmw') }, { vl: '10', lb: this.$t('app_file') }, { vl: '6', lb: this.$t('app_codegunsrc') }],
      nolcft_1: [{ vl: '1', lb: 'OTA' }, { vl: '2', lb: this.$t('app_firmw') }, { vl: '3', lb: this.$t('app_animation') }, { vl: '5', lb: 'CFG' + this.$t('app_file') }, { vl: '7', lb: this.$t('app_app') }, { vl: '8', lb: 'linux ' + this.$t('app_app') }, { vl: '9', lb: 'linux ' + this.$t('app_firmw') }, { vl: '10', lb: this.$t('app_file') }],
      nolcft_2: [{ vl: '11', lb: this.$t('app_rtosgunsrc') }, { vl: '6', lb: this.$t('app_codegunsrc') }],
      ftypes: [{ vl: '1', lb: 'OTA' }, { vl: '2', lb: this.$t('app_firmw') }, { vl: '3', lb: this.$t('app_animation') }, { vl: '4', lb: 'launcher' }, { vl: '5', lb: 'CFG' + this.$t('app_file') }, { vl: '11', lb: this.$t('app_rtosgunsrc') }, { vl: '7', lb: this.$t('app_app') }, { vl: '8', lb: 'linux ' + this.$t('app_app') }, { vl: '9', lb: 'linux ' + this.$t('app_firmw') }, { vl: '10', lb: this.$t('app_file') }, { vl: '6', lb: this.$t('app_codegunsrc') }],
      ftype: {
        '1': 'OTA',
        '2': this.$t('app_firmw'),
        '3': this.$t('app_animation'),
        '4': 'launcher',
        '5': 'CFG' + this.$t('app_file'),
        '6': this.$t('app_codegunsrc'),
        '7': this.$t('app_app'),
        '8': 'linux ' + this.$t('app_app'),
        '9': 'linux ' + this.$t('app_firmw'),
        '10': this.$t('app_file'),
        '11': this.$t('app_rtosgunsrc')
      },
      sftype: {
        '1-0': 'OTA' + this.$t('app_ttPkg'),
        '1-1': 'OTA' + this.$t('app_partpkg'),
        '2-KSP': 'KSP' + this.$t('app_firmw'),
        "2-RES": 'RES' + this.$t('app_firmw'),
        '2-HEX': 'HEX' + this.$t('app_firmw'),
        '2-KOS': 'KOS' + this.$t('app_firmw'),
        '2-FLAS': 'FLAS' + this.$t('app_firmw'),
        '2-KEY': 'KEY' + this.$t('app_firmw'),
        '3-1': this.$t('terminal.details.kjdh'),
        '3-2': this.$t('terminal.details.gjdh'),
        '3-3': this.$t('app_launchAnimate'),
        '3-4': this.$t('app_onLogo'),
        '3-5': this.$t('app_deskwp'),
        '6-1': this.$t('app_codegunapp'),
        '6-2': this.$t('app_codegunsrc'),
        '9-1': this.$t('app_core'),
        '9-2': this.$t('app_filesys'),
        '9-3': 'H330S ' + this.$t('app_firmw'),
        '9-4': 'G510 ' + this.$t('app_firmw'),
        '9-5': 'Max32555 ' + this.$t('app_firmw'),
        '11-1': this.$t('app_rots_1'),
        '11-3': this.$t('app_rots_3'),
        '11-4': this.$t('app_rots_4'),
        '11-5': this.$t('app_rots_5')
      },
      sftypes1: [{ vl: '', lb: this.$t('app_allstyps') }, { vl: '1-0', lb: 'OTA' + this.$t('app_ttPkg') }, { vl: '1-1', lb: 'OTA' + this.$t('app_partpkg') }],
      sftypes2: [{ vl: '', lb: this.$t('app_allstyps') }, { vl: '2-KSP', lb: 'KSP' + this.$t('app_firmw') }, { vl: '2-RES', lb: 'RES' + this.$t('app_firmw') }, { vl: '2-HEX', lb: 'HEX' + this.$t('app_firmw') }, { vl: '2-KOS', lb: 'KOS' + this.$t('app_firmw') }, { vl: '2-FLAS', lb: 'FLAS' + this.$t('app_firmw') }, { vl: '2-KEY', lb: 'KEY' + this.$t('app_firmw') }],
      sftypes3: [{ vl: '', lb: this.$t('app_allstyps') }, { vl: '3-1', lb: this.$t('terminal.details.kjdh') }, { vl: '3-2', lb: this.$t('terminal.details.gjdh') }, { vl: '3-3', lb: this.$t('app_launchAnimate') }, { vl: '3-4', lb: this.$t('app_onLogo') }, { vl: '3-5', lb: this.$t('app_deskwp') }],
      sftypes5: [{ vl: '', lb: this.$t('app_allstyps') }],
      sftypes6: [{ vl: '', lb: this.$t('app_allstyps') }, { vl: '6-1', lb: this.$t('app_codegunapp') }, { vl: '6-2', lb: this.$t('app_codegunsrc') }],
      sftypes7: [{ vl: '', lb: this.$t('app_allstyps') }],
      sftypes9: [{ vl: '', lb: this.$t('app_allstyps') }, { vl: '9-1', lb: this.$t('app_core') }, { vl: '9-2', lb: this.$t('app_filesys') }, { vl: '9-3', lb: 'H330S ' + this.$t('app_firmw') }, { vl: '9-4', lb: 'G510 ' + this.$t('app_firmw') }, { vl: '9-5', lb: 'Max32555 ' + this.$t('app_firmw') }],
      sftypes11: [{ vl: '11-1', lb: this.$t('app_rots_1') }, { vl: '11-3', lb: this.$t('app_rots_3') }, { vl: '11-4', lb: this.$t('app_rots_4') }, { vl: '11-5', lb: this.$t('app_rots_5') }]
    };
  },

  props: ['tqobj'],
  watch: {
    tqobj: function tqobj() {
      var _this = this;

      var fn = [];
      var ar = this.tqobj.keys;
      ar.forEach(function (ckey) {
        fn.push(_this[ckey]);
      });
      this.tqobj.callback(fn);
    }
  },
  computed: {},
  methods: {},
  mounted: function mounted() {}
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_breadcrumb_vue__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_breadcrumb_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_breadcrumb_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_ptd_ptd1_png__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_ptd_ptd1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_ptd_ptd1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_ptd_ptd2_png__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_ptd_ptd2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_ptd_ptd2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_ptd_ptd3_png__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_ptd_ptd3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_ptd_ptd3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_bulletin_bdialog__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_bulletin_bdialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_bulletin_bdialog__);












/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    BreadCrumb: __WEBPACK_IMPORTED_MODULE_3__components_global_breadcrumb_vue___default.a, bdialog: __WEBPACK_IMPORTED_MODULE_7__components_bulletin_bdialog___default.a
  },
  data: function data() {
    return {
      token: '',
      bconfig: '',
      pushState: false,
      pic1: __WEBPACK_IMPORTED_MODULE_4__assets_images_ptd_ptd1_png___default.a,
      pic2: __WEBPACK_IMPORTED_MODULE_5__assets_images_ptd_ptd2_png___default.a,
      pic3: __WEBPACK_IMPORTED_MODULE_6__assets_images_ptd_ptd3_png___default.a
    };
  },

  watch: {
    mmatch: function mmatch() {
      console.log("改变了");
    }
  },
  computed: {
    menuList: function menuList() {
      return this.$store.getters.routes;
    },
    nickname: function nickname() {
      return this.$store.getters.nick;
    },

    currentNav: function currentNav() {
      var path = this.$route.path;
      var menu = path;
      if (path.indexOf('terList') !== -1) {
        menu = '/terList';
      }
      if (path.indexOf('accMess') !== -1) {
        menu = '/accMess';
      }
      if (path.indexOf('romList') !== -1) {
        menu = '/romList';
      }
      if (path.indexOf('romReview') !== -1) {
        menu = '/romReview';
      }
      if (path.indexOf('terOta') !== -1) {
        menu = '/terOta';
      }
      if (path.indexOf('rail') !== -1) {
        menu = '/rail';
      }
      if (path.indexOf('certificate') !== -1) {
        menu = '/certificate';
      }
      return menu;
    },
    imgLogo: function imgLogo() {
      return this.$store.getters.homeLogo;
    }
  },
  mounted: function mounted() {

    var that = this;
    this.token = localStorage.getItem('user');
    this.getInfo();
    this.getVBInfo();
  },
  methods: {
    getVBInfo: function getVBInfo() {
      var _this2 = this;

      this.loading = true;
      var _this = this;
      this.$checkVBInfo(function (res) {
        _this2.loading = false;
        if (res.status === 200) {
          if (res.data.length == 1) {
            var info = res.data[0];
            if (info.type == 0) {
              _this.bconfig = {
                type: 2,
                edit: false,
                vinfo: {
                  title: info.name,
                  content: info.info
                },
                binfo: '',
                callback: function callback() {}
              };
            } else {
              _this.bconfig = {
                type: 2,
                edit: false,
                vinfo: '',
                binfo: {
                  title: info.name,
                  content: info.info
                },
                callback: function callback() {}
              };
            }
          } else if (res.data.length == 2) {
            _this.bconfig = {
              type: 2,
              edit: false,
              vinfo: {
                title: res.data[0].name,
                content: res.data[0].info
              },
              binfo: {
                title: res.data[1].name,
                content: res.data[1].info
              },
              callback: function callback() {}
            };
          }
        } else {
          _this2.$message(res.message);
        }
      }, function () {
        _this2.loading = false;
        _this2.$message.error(_this2.$t('app_rqsError'));
      });
    },
    isShowNewPushTip: function isShowNewPushTip() {
      var tms_usr_npt_tip = localStorage.tms_usr_npt_tip;
      if (tms_usr_npt_tip && JSON) {
        var usrs = JSON.parse(tms_usr_npt_tip);
        var is = false;
        if (usrs) {
          is = usrs[localStorage.userId] ? true : false;
        }
        if (!is) {
          usrs[localStorage.userId] = '1';
          localStorage.tms_usr_npt_tip = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(usrs);
          this.pushState = true;
        }
      } else {
        var usrs = {};
        usrs[localStorage.userId] = '1';
        localStorage.tms_usr_npt_tip = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(usrs);
        this.pushState = true;
      }
    },
    handleOpen: function handleOpen(key, keyPath) {},
    handleClose: function handleClose(key, keyPath) {},
    handleSelect: function handleSelect(key, keyPath) {},
    handleCommand: function handleCommand(command) {
      var _this3 = this;

      if (command == 'o') {

        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/user/logout.do', { token: localStorage.getItem('user') }).then(function (res) {
          if (res.data.status === 200) {
            var lc = localStorage;
            lc.logo = '';
            lc.mechanismId = '';
            lc.user = '';
            lc.userId = '';
            lc.userType = '';
            lc.cerType = '';
            _this3.$router.push({ path: '/login' });
            location.reload(true);
          } else {
            _this3.$message.error(res.data.message);
          }
        });
      } else if (command == 'm') {
        this.$router.push({ path: '/accInfo' });
      }
    },

    getInfo: function getInfo() {
      var _this4 = this;

      console.log('[keyPath-optional');
      var user = localStorage.getItem('user');

      var params = { token: user };
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/user/getUser.do', params).then(function (res) {
        var params = { userId: res.data.data.userid };
        _this4.$setWObj('keyInfo', { key: res.data.data.appkey, secret: res.data.data.secretkey });

        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/user/getUserById.do', params).then(function (res) {
          _this4.$store.dispatch('setNick', res.data.data.nickName);
        });
      });
    }
  }
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_terminal_map__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_terminal_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_terminal_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_bulletin_bdialog__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_bulletin_bdialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_bulletin_bdialog__);








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var that = this;
    return {
      bconfig: '',
      bltData: [],
      rgDate: '',
      xArr: [],
      olArr: [],
      offArr: [],
      slArr: [],
      otArr: [],
      barType: '0',
      data1: '',
      mech1: '',
      sdate1: '',
      sdate2: '',
      loading1: false,
      loading2: false,
      loading3: false,
      mech3: '',
      data3: '',
      sdata3: [],
      pieTitle: this.$t('terminal.details.system_version'),
      resizeCt: 0,
      tabbar: 'day',
      tabpie: 'sys',
      tabmap: 'where',
      lbBtnCls: [{ class: 'lb-btn-sl', lb: this.$t('app_yesterday') }, { class: '', lb: this.$t('app_rc15d') }, { class: '', lb: this.$t('app_rc30d') }],
      lbBtnLastIndex: 0,
      ctBarDay: '',
      ctMap: '',
      ctPie: '',
      ctBarVt: '',
      mechanismData: {
        placeholder: that.$t('lin_global.place_areaid'),
        callback: function callback(value) {
          that.mech1 = value;
          that.getDvcList();
        }
      },
      mechanismData1: {
        placeholder: that.$t('lin_global.place_areaid'),
        callback: function callback(value) {}
      },
      mechanismData2: {
        placeholder: that.$t('lin_global.place_areaid'),
        callback: function callback(value) {
          that.mech3 = value;
          that.getSysList();
        }
      }
    };
  },

  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue___default.a, terMap: __WEBPACK_IMPORTED_MODULE_2__components_terminal_map___default.a, bdialog: __WEBPACK_IMPORTED_MODULE_3__components_bulletin_bdialog___default.a
  },
  computed: {},
  methods: {
    viewMoreBlt: function viewMoreBlt() {
      this.$router.push({ path: '/bulletin' });
    },
    clBltRow: function clBltRow() {
      var row = this.bltData[0];
      this.bconfig = {
        type: 2,
        edit: false,
        vinfo: '',
        binfo: {
          title: row.noticeName,
          content: row.noticeInfo
        },
        callback: function callback() {}
      };
    },
    genProcess: function genProcess(value) {
      var ps = (value / this.data3.total).toFixed(2);
      var st = 'float:left;display:inline-block;width:' + ps * 100 * 0.7 + '' + '%;background:rgb(75,157,237);height:14px;';
      return st;
    },
    getDvcList: function getDvcList() {
      var _this2 = this;

      this.loading1 = true;
      var mech = this.mech1 ? this.mech1 : '';
      var type = this.barType;
      var beginDate = this.sdate1;
      var endDate = this.sdate2;
      this.$indexDvStCount(mech, type, beginDate, endDate, function (res) {
        _this2.loading1 = false;
        if (res.status === 200) {
          _this2.data1 = res.data;
          if (_this2.data1) {
            var xarr = _this2.data1.time;
            _this2.xArr = xarr;
            _this2.olArr = res.data.online;
            _this2.offArr = res.data.offline;
            _this2.slArr = res.data.sleep;
            _this2.otArr = res.data.other;
            _this2.initSec1();
          } else {
            _this2.xArr = [];
            _this2.olArr = [];
            _this2.offArr = [];
            _this2.slArr = [];
            _this2.otArr = [];
            _this2.initSec1();
          }
        } else {
          _this2.$message.error(res.message);
        }
      }, function () {
        _this2.loading1 = false;
      });
    },
    getBulletin: function getBulletin() {
      var _this3 = this;

      this.loading2 = true;
      this.$bulletin(1, 10, '', function (res) {
        _this3.loading2 = false;
        if (res.status === 200) {
          _this3.bltData = res.data;
        } else {
          _this3.$message.error(res.message);
        }
      }, function () {
        _this3.loading2 = false;
      });
    },
    getSysList: function getSysList() {
      var _this4 = this;

      this.loading3 = true;
      var mech = this.mech3 ? this.mech3 : '';
      var type = '';
      switch (this.tabpie) {
        case 'sys':
          type = '0';
          break;
        case 'fm':
          type = '1';
          break;
        case 'launch':
          type = '2';
          break;
      }
      this.$indexSysFmCount(mech, type, function (res) {
        _this4.loading3 = false;
        if (res.status === 200) {
          _this4.data3 = res.data;
          if (res.data.list.length > 10) {
            _this4.sdata3 = res.data.list.slice(0, 10);
          } else {
            _this4.sdata3 = res.data.list;
          }
          _this4.initSec3();
        } else {
          _this4.$message.error(res.message);
        }
      }, function () {
        _this4.loading3 = false;
      });
    },
    barClick: function barClick() {},
    dateChange: function dateChange(vl) {
      if (vl) {
        this.gpBtnClick(-1);
        this.barType = '3';
        var arr = vl.split(' - ');
        this.sdate1 = arr[0];
        this.sdate2 = arr[1];
        this.getDvcList();
      } else {}
    },
    pieClick: function pieClick() {
      switch (this.tabpie) {
        case 'sys':
          this.pieTitle = this.$t('terminal.details.system_version');
          break;
        case 'fm':
          this.pieTitle = this.$t('terminal.details.hard_version');
          break;
        case 'launch':
          this.pieTitle = this.$t('terminal.details.launcher');
          break;
      }
      this.getSysList();
    },
    clearChats: function clearChats() {
      if (this.ctBarDay) {
        this.ctBarDay.dispose();
      }
      if (this.ctPie) {
        this.ctPie.dispose();
      }
    },
    initSec1: function initSec1() {
      if (this.ctBarDay) {
        this.ctBarDay.dispose();
        this.ctBarDay = '';
      }
      this.ctBarDay = echarts.init(document.getElementById('siday'));

      var datas = [this.$t('app_active1'), this.$t('app_sleep'), this.$t('app_offline'), this.$t('app_unuse')];
      var slobj = {};
      slobj[datas[3]] = false;

      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow' }
        },
        legend: {
          x: 'right',
          data: datas,
          selected: slobj
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          data: this.xArr
        }],
        yAxis: [{
          type: 'value'
        }],
        series: [{
          name: this.$t('app_active1'),
          type: 'bar',
          color: '#2CC7FD',
          stack: 'haha',
          data: this.olArr
        }, {
          name: this.$t('app_sleep'),
          type: 'bar',
          color: '#FFCB16',
          stack: 'haha',
          data: this.slArr
        }, {
          name: this.$t('app_offline'),
          type: 'bar',
          color: '#FF2424',
          stack: 'haha',
          data: this.offArr
        }, {
          name: this.$t('app_unuse'),
          type: 'bar',
          color: '#EAEAEA',
          stack: 'haha',
          data: this.otArr
        }]
      };
      this.ctBarDay.setOption(option);
    },
    initSec2: function initSec2() {
      if (this.ctMap) {
        this.ctMap.dispose();
        this.ctMap = '';
      }
      this.ctMap = echarts.init(document.getElementById('siHm'));

      var geoCoordMap = {
        "重庆金佛山国家级自然保护区": [107.159108, 28.951313],
        "未知1": [117.159108, 38.951313]
      };
      var convertData = function convertData(data) {
        var res = [];
        for (var i = 0; i < data.length; i++) {
          var geoCoord = geoCoordMap[data[i].name];
          if (geoCoord) {
            res.push(geoCoord.concat(data[i].value));
          }
        }
        return res;
      };

      var option = {
        backgroundColor: 'white',
        visualMap: {
          min: 0,
          max: 1,
          splitNumber: 10,
          inRange: {
            color: ['blue', '#eac736', '#d94e5d']
          },
          textStyle: {
            color: '#fff'
          }
        },
        geo: {
          map: 'china',
          label: {
            emphasis: {
              show: true
            }
          },
          roam: true,
          itemStyle: {
            normal: {
              areaColor: '#EFF2F7',
              borderColor: '#1D8CE0'
            },
            emphasis: {
              areaColor: '#D3DCE6'
            }
          }
        },
        series: [{
          name: 'AQI',
          type: 'heatmap',
          coordinateSystem: 'geo',
          data: convertData([{ name: "重庆金佛山国家级自然保护区", value: 0.2, cor: [0, 1] }, { name: "未知1", value: 1, cor: [0, 1] }])
        }]
      };

      this.ctMap.setOption(option);
    },
    initSec3: function initSec3() {
      if (this.ctPie) {
        this.ctPie.dispose();
        this.ctPie = '';
      }
      this.ctPie = echarts.init(document.getElementById('siPie'), 'macarons');
      var option = {
        title: {
          text: this.pieTitle,
          subtext: this.data3.total,
          left: 'center',
          top: '40%',
          padding: [24, 0],
          textStyle: {
            color: 'lightgray',
            fontSize: 14,
            align: 'center'
          },
          subtextStyle: {
            fontSize: 20,
            color: 'black',
            align: 'center'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: "{b} " + this.$t('app_nums') + " {c}" },
        legend: {
          orient: 'vertical',
          x: 'center',
          data: []
        },
        series: [{
          type: 'pie',
          radius: ['40%', '55%'],
          label: {
            normal: {
              formatter: '{per|{d}%}',
              backgroundColor: '#eee',
              borderColor: '#aaa',
              borderWidth: 1,
              borderRadius: 4,
              rich: {
                a: {
                  color: '#999',
                  lineHeight: 22,
                  align: 'center'
                },
                hr: {
                  borderColor: '#aaa',
                  width: '100%',
                  borderWidth: 0.5,
                  height: 0
                },
                b: {
                  fontSize: 16,
                  lineHeight: 33
                },
                per: {
                  color: '#eee',
                  backgroundColor: '#334455',
                  padding: [2, 4],
                  borderRadius: 2
                }
              }
            }
          },
          data: this.data3.list
        }]
      };
      this.ctPie.setOption(option);
    },
    initSec31: function initSec31() {
      if (this.ctBarVt) {
        this.ctBarVt.dispose();
        this.ctBarVt = '';
      }
      this.ctBarVt = echarts.init(document.getElementById('siBarVt'));

      var option = {
        color: ['#3398DB'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: "{b} <br> 合格率: {c}%"
        },
        grid: {
          left: '4%',
          right: '4%',
          bottom: '2%',
          containLabel: true
        },
        xAxis: {
          type: 'value'
        },
        yAxis: {
          type: 'category',
          data: ['湖北省', '湖南省', '河南省', '安徽省', '浙江省', '山东省', '广东省'],
          axisLabel: {
            show: true,
            interval: 0,
            rotate: 0,
            margin: 10,
            inside: false,
            textStyle: {
              fontWeight: '20'
            }
          }
        },
        series: [{
          type: 'bar',
          label: {
            normal: {
              show: true,

              formatter: function formatter(v) {
                var val = v.data;
                if (val == 0) {
                  return '';
                }
                return val;
              },
              color: '#fff'
            }
          },
          data: [22, 33, 44, 55, 66, 77, 88]
        }]
      };

      this.ctBarVt.setOption(option);
    },
    gpBtnClick: function gpBtnClick(index) {
      if (this.lbBtnLastIndex >= 0 && this.lbBtnLastIndex < this.lbBtnCls.length) {
        this.lbBtnCls[this.lbBtnLastIndex].class = '';
      }

      if (index < 0 || index >= this.lbBtnCls.length) {

        return;
      }

      this.rgDate = '';

      this.lbBtnCls[index].class = 'lb-btn-sl';
      this.lbBtnLastIndex = index;
      switch (index) {
        case 0:
          this.barType = '0';
          break;
        case 1:
          this.barType = '1';
          break;
        case 2:
          this.barType = '2';
          break;
      }
      this.getDvcList();
    },
    cmRqs: function cmRqs() {
      var _this5 = this;

      this.getDvcList();
      setTimeout(function () {
        _this5.getSysList();
      }, 300);
    }
  },
  destroyed: function destroyed() {
    this.clearChats();
  },
  mounted: function mounted() {

    this.cmRqs();

    this.getBulletin();

    var _this = this;
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).resize(function () {
        _this.resizeCt += 1;
        setTimeout(function () {
          _this.resizeCt -= 1;
          if (_this.resizeCt <= 0) {
            _this.resizeCt = 0;

            _this.cmRqs();
          }
        }, 1000);
      });
    });
  }
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_url__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      token: localStorage.getItem("user") | null,
      devData: null,
      taskData: null,
      infoData: null
    };
  },

  compted: {
    getRandTime: function getRandTime() {
      return new Date().getTime();
    }
  },
  methods: {
    jumpTerminal: function jumpTerminal(code) {
      if (code) {
        this.$store.dispatch('setParam', code);
      } else {
        this.$store.dispatch('setParam', null);
      }

      var url = "/terList";
      this.$router.push({ path: url });
    },
    jump: function jump(uri) {
      this.$router.push({ path: uri });
    },
    fetchData: function fetchData() {
      var that = this;
      that.fetchDevData();
      that.fetchTaskData();
      that.fetchInfoData();
    },
    fetchDevData: function fetchDevData() {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/home/terminalsStatus.do', { distributorId: localStorage.getItem('mechanismId'), token: that.token }).then(function (res) {
        if (res.data && res.data.status && res.data.status === 200) {
          that.devData = res.data.data;
        }
      });
    },
    fetchTaskData: function fetchTaskData() {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/home/taskStatus.do', { distributorId: localStorage.getItem('mechanismId'), token: that.token }).then(function (res) {
        if (res.data && res.data.status && res.data.status === 200) {
          that.taskData = res.data.data;
        }
      });
    },
    fetchInfoData: function fetchInfoData() {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/home/riskStatus.do', { distributorId: localStorage.getItem('mechanismId'), token: that.token }).then(function (res) {
        if (res.data && res.data.status && res.data.status === 200) {
          that.infoData = res.data.data;
        }
      });
    }
  },
  mounted: function mounted() {
    this.fetchData();
  }
});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animate_css__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_animate_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_url__ = __webpack_require__(3);






var iconRed = __webpack_require__(56);
var iconGreen = __webpack_require__(29);
var iconGray = __webpack_require__(42);
var iconYellow = __webpack_require__(35);
/* harmony default export */ __webpack_exports__["default"] = ({
	methods: {
		rqsPath: function rqsPath() {
			var _this = this;

			this.$terHisPath(this.mapdata1.sn, function (res) {

				_this.initPath(res.data);
			}, function (error) {});
		},
		showPolyLine: function showPolyLine(points, color, map) {
			var pLine = [];
			for (var i = 0; i < points.length; i++) {
				var obj = points[i];
				var lon = obj.longitude;
				var lat = obj.latitude;
				pLine.push(new AMap.LngLat(lon, lat));
				var marker = new AMap.Marker(new AMap.LngLat(lon, lat));

				if (i === 0) {
					var icon = new AMap.Icon(iconGreen, new AMap.Size(40, 40));
					marker.setIcon(icon);
				}

				marker.addEventListener('click', function (e) {
					var p = e.target;
					var point = new AMap.LngLat(p.getPosition().lng, p.getPosition().lat);
					var sobj = '';
					points.forEach(function (vl) {
						if (vl.latitude == point.lat && vl.longitude == point.lng) {
							sobj = vl;
						}
					});
					var mct = sobj.locatime + '<br/><br/>' + sobj.address;

					var infoWindow = new AMap.InfoWindow(mct, this.opts1);
					map.openInfoWindow(infoWindow, point);
				});

				map.add(marker);
			}

			var polyline = new AMap.Polyline(pLine, {
				strokeColor: color,
				strokeWeight: 6,
				strokeOpacity: 0.5
			});

			map.add(polyline);
		},
		initPath: function initPath(paths) {
			if (paths.length === 0) {
				var _map = new AMap.Map('allmap', {
					resizeEnable: true,
					viewMode: '3D',
					pinch: 45
				});
				AMap.plugin(['AMap.ControlBar', 'AMap.ToolBar'], function () {
					_map.addControl(new AMap.ControlBar({
						position: "RT" }));
					_map.addControl(new AMap.ToolBar({
						liteStyle: true,
						position: "RT",
						offset: [30, 110] }));
				});

				_map.setZoomAndCenter(15, [108.960679, 34.314287]);
				var size = new AMap.Size(20, 20);
				return;
			}

			var map = new AMap.Map('allmap', {});

			map.setZoomAndCenter(15, [paths[0].longitude, paths[0].latitude]);
			this.showPolyLine(paths, "red", map);
		},
		terminalAreaReport: function terminalAreaReport() {
			var map = new AMap.Map('allmap', {
				resizeEnable: true,
				viewMode: '3D',
				pinch: 45
			});

			AMap.plugin(['AMap.ControlBar', 'AMap.ToolBar'], function () {
				map.addControl(new AMap.ControlBar({
					position: "RT" }));
				map.addControl(new AMap.ToolBar({
					liteStyle: true,
					position: "RT",
					offset: [30, 110] }));
			});
			map.setZoomAndCenter(5, [108.960679, 34.314287]);

			var self = this;

			var tno = self.mapdata1.sn ? self.mapdata1.sn : '';
			var mc = self.mapdata1.areaid ? self.mapdata1.areaid : '';

			var params = {
				page: self.mapdata1.page,
				rows: self.mapdata1.rows,
				areaid: mc,
				terminal_no: tno,
				terminal_status: self.mapdata1.status,
				terminal_runtime_status: self.mapdata1.runStatus
			};

			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/terminal/list.do', params).then(function (response) {
				var status = response.data.status;
				if (status == 200) {
					self.mapdata = response.data.data;
					var carr = self.mapdata[0];

					if (carr && self.mapdata1.sn) {
						carr = carr.coordinate.split(',');

						var bd_lng = carr[0];
						var bd_lat = carr[1];
						var x_pi = Math.PI * 3000.0 / 180.0;
						var x = bd_lng - 0.0065,
						    y = bd_lat - 0.006;
						var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
						var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
						var gd_lng = z * Math.cos(theta);
						var gd_lat = z * Math.sin(theta);
						carr[0] = gd_lng;
						carr[1] = gd_lat;


						map.setZoomAndCenter(15, [carr[0], carr[1]]);
					} else {}

					for (var i = 0; i < self.mapdata.length; i++) {
						var rs = self.mapdata[i];
						var terminalStatus;
						var terminalRuntimeStatus;
						if (rs.terminalStatus === '1') {
							terminalStatus = self.$t('lin_global.online');
						} else if (rs.terminalStatus === '2') {
							terminalStatus = self.$t('lin_global.offline');
						} else if (rs.terminalStatus === '3') {
							terminalStatus = self.$t('app_sleep');
						}

						var text = '<span style="line-height:20px;font-size:14px;">' + self.$t('lin_global.label_no') + '：' + rs.terminalNo + '<br>' + self.$t('lin_global.label_name') + '：' + rs.terminalName + '<br>' + self.$t('lin_global.label_areaid_name') + '：' + rs.mechName + '<br>' + self.$t('lin_global.label_address') + '：' + rs.currentAddress + '<br>' + self.$t('lin_global.wlzt') + '：' + terminalStatus + '</br>' + '<br><a href="' + './#/terList/' + rs.terminalId + '/details" style="float:right;">' + self.$t('lin_global.ckxq') + '</a></span>';

						var online = false;
						var offline = false;
						var fault = false;
						var warn = false;

						if (rs.terminalStatus === '1') {
							online = true;
						}
						if (rs.terminalStatus === '2') {
							offline = true;
						}
						if (rs.terminalStatus === '3') {
							warn = true;
						}

						var $location = rs.coordinate;
						self.geocoder(map, $location, text, online, offline, fault, warn);
					}
				}
			});
		},
		geocoder: function geocoder(map, city, text, online, offline, fault, warn) {
			var bd_lng = city.split(',')[0];
			var bd_lat = city.split(',')[1];
			var x_pi = Math.PI * 3000.0 / 180.0;
			var x = Number(bd_lng - 0.0065),
			    y = Number(bd_lat - 0.006);
			var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
			var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
			var gd_lng = Number(z * Math.cos(theta));
			var gd_lat = Number(z * Math.sin(theta));


			var location = {};
			location.lng = gd_lng;
			location.lat = gd_lat;
			var marker = new AMap.Marker({
				position: [location.lng, location.lat]
			});
			var content = text;
			var pt = {
				lng: location.lng,
				lat: location.lat
			};
			var self = this;

			function ComplexCustomOverlay(point, text, mouseoverText, type) {
				this.type = type;
				this._point = point;
				this._text = text;
				this._overText = mouseoverText;
				if (type === 0) {
					this.bgc = '#20A0FF';
					this.bg = "url('" + iconGreen + "')";
					this.OffsetLeft = -4;
					this.OffsetTop = -5;
					this.zIndex = 90;
				}
				if (type === 1) {
					this.bgc = '#595959';
					this.bg = "url('" + iconGray + "')";
					this.OffsetLeft = -5;
					this.OffsetTop = -5;
					this.zIndex = 60;
				}
				if (type === 3) {
					this.bgc = 'yellow';
					this.bg = "url('" + iconYellow + "')";
					this.OffsetLeft = -5;
					this.OffsetTop = -5;
					this.zIndex = 80;
				}
				if (type === 2) {
					this.bgc = 'yellow';
					this.bg = "url('" + iconYellow + "')";
					this.OffsetLeft = -5;
					this.OffsetTop = -5;
					this.zIndex = 70;
				}
			}


			var txt = '';
			var mouseoverTxt = '12312312312';

			if (fault === true) {
				console.log("添加默认标点");
			} else if (warn === true) {
				var myCompOverlay3 = new ComplexCustomOverlay(pt, '', mouseoverTxt, 3);
				var icon = new AMap.Icon({
					size: new AMap.Size(20, 24),
					image: __webpack_require__(35),
					imageSize: new AMap.Size(20, 24)
				});
				marker = new AMap.Marker({
					icon: icon,
					position: [myCompOverlay3._point.lng, myCompOverlay3._point.lat],
					offset: [myCompOverlay3.OffsetLeft, myCompOverlay3.OffsetTop],
					zIndex: myCompOverlay3.zIndex
				});
				map.add(marker);
				marker.content = content;
				marker.on('click', function (e) {
					var infoWindow = new AMap.InfoWindow();
					infoWindow.setContent(content);
					infoWindow.open(map, e.target.getPosition());
				});
			} else if (offline === true) {
				var myCompOverlay1 = new ComplexCustomOverlay(pt, '', mouseoverTxt, 1);
				var icon = new AMap.Icon({
					size: new AMap.Size(20, 24),
					image: __webpack_require__(42),
					imageSize: new AMap.Size(20, 24)
				});
				marker = new AMap.Marker({
					icon: icon,
					position: [myCompOverlay1._point.lng, myCompOverlay1._point.lat],
					offset: [myCompOverlay1.OffsetLeft, myCompOverlay1.OffsetTop],
					zIndex: myCompOverlay1.zIndex
				});
				map.add(marker);
				marker.content = content;
				marker.on('click', function (e) {
					console.log(e);
					var infoWindow = new AMap.InfoWindow();
					infoWindow.setContent(content);
					infoWindow.open(map, e.target.getPosition());
				});
			} else if (online === true) {
				var myCompOverlay = new ComplexCustomOverlay(pt, '', mouseoverTxt, 0);
				var icon = new AMap.Icon({
					size: new AMap.Size(20, 24),
					image: __webpack_require__(29),
					imageSize: new AMap.Size(20, 24)
				});
				marker = new AMap.Marker({
					icon: icon,
					position: [myCompOverlay._point.lng, myCompOverlay._point.lat],
					offset: [myCompOverlay.OffsetLeft, myCompOverlay.OffsetTop],
					zIndex: myCompOverlay.zIndex
				});
				map.add(marker);
				marker.content = content;
				marker.on('click', function (e) {
					var infoWindow = new AMap.InfoWindow();
					infoWindow.setContent(content);
					infoWindow.open(map, e.target.getPosition());
				});
			}
		},
		get_lng_lat: function get_lng_lat(bd_lng, bd_lat) {
			var x_pi = Math.PI * 3000.0 / 180.0;
			var x = Number(bd_lng - 0.0065),
			    y = Number(bd_lat - 0.006);
			var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
			var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
			var gd_lng = Number(z * Math.cos(theta));
			var gd_lat = Number(z * Math.sin(theta));
			var result_form = {
				gd_lng: gd_lng,
				gd_lat: gd_lat
			};
			return result_form;
		},
		addClickHandler: function addClickHandler(content, marker) {
			marker.addEventListener('click', function (e) {
				this.openInfo(content, e);
			});
		},
		openInfo: function openInfo(content, e) {
			console.log(content);
		}
	},
	mounted: function mounted() {
		if (this.mode == 0) {
			this.terminalAreaReport();
		} else {
			this.rqsPath();
		}
	},

	watch: {
		'mapdata1.sn': function mapdata1Sn() {
			if (this.mode == 0) {
				this.terminalAreaReport();
			} else {
				this.rqsPath();
			}
		},
		'mapdata1.page': function mapdata1Page() {
			if (this.mode == 0) {
				this.terminalAreaReport();
			} else {
				this.rqsPath();
			}
		},
		'mapdata1.rows': function mapdata1Rows() {
			if (this.mode == 0) {
				this.terminalAreaReport();
			} else {
				this.rqsPath();
			}
		},
		'mapdata1.status': function mapdata1Status() {
			if (this.mode == 0) {
				this.terminalAreaReport();
			} else {
				this.rqsPath();
			}
		},
		'mapdata1.areaid': function mapdata1Areaid() {
			if (this.mode == 0) {

				this.terminalAreaReport();
			} else {
				this.rqsPath();
			}
		},
		'mapdata1.runStatus': function mapdata1RunStatus() {
			if (mode == 0) {
				this.terminalAreaReport();
			} else {
				this.rqsPath();
			}
		}
	},

	data: function data() {
		return {
			opts: {
				width: 250,
				height: 100,
				title: '',
				enableMessage: true
			},
			opts1: {
				width: 100,
				height: 50,
				title: '',
				enableMessage: true
			},
			mapdata: ''
		};
	},

	props: ['height', 'mapdata1', 'mode']
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_js_cookie__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jsencrypt__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jsencrypt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jsencrypt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_req_js__ = __webpack_require__(85);










__WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.withCredentials = true;
var md5 = __webpack_require__(53);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      licenseDialogVisible: false,
      licenseForm: {
        licenseKey: ''
      },
      macAddress: '',
      licenseRules: {
        licenseKey: [{ required: true, message: 'Please input the license key', trigger: 'blur' }]
      },
      tmpres: '',
      dld: false,
      code6: '',
      ischeck: false,
      formLabelWidth: '140px',
      isauth: false,
      aform: {
        usr: '',
        psw: '',
        code: '',
        igmd5: false,
        date: ''
      },
      codeObj: '',
      pbobj: '',
      langItem: {
        'zh_cn': { label: '中文', url: __webpack_require__(256) },
        'en': { label: 'English', url: __webpack_require__(257) },
        'ko': { label: '한국어', url: __webpack_require__(258) },
        'ru': { label: 'русский ', url: __webpack_require__(259) }
      },
      langs: [{
        value: 'zh_cn',
        label: '中文',
        url: __webpack_require__(256)
      }, {
        value: 'en',
        label: 'English',
        url: __webpack_require__(257)
      }, {
        value: 'ru',
        label: 'русский ',
        url: __webpack_require__(259)
      }, {
        value: 'ko',
        label: '한국어',
        url: __webpack_require__(258)
      }],
      options: [{
        value: 'zh_cn',
        label: this.$t('lin_global.china'),
        style: 'chinese'
      }, {
        value: 'en',
        label: this.$t('lin_global.english'),
        style: 'english'
      }, {
        value: 'ru',
        label: this.$t('lin_global.russia'),
        style: 'russia'
      }, {
        value: 'ko',
        label: this.$t('lin_global.korean'),
        style: 'korean'
      }],
      verTip: '',
      version: '',
      popover1: false,
      value: '',
      logining: false,
      loginForm: {
        account: '',
        checkPass: '',
        code: ''
      },
      loginRules: {
        account: [{ required: true, message: this.$t('lin_global.qsrzh'), trigger: 'blur' }],
        checkPass: [{ required: true, message: this.$t('lin_global.qsrmm'), trigger: 'blur' }],
        code: [{ required: true, message: this.$t('app_plsip'), trigger: 'blur' }]
      },
      checked: false
    };
  },

  components: {},
  mounted: function mounted() {
    var _this = this;

    this.recode();

    var heightWin = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(window).height();
    __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.loginBg').css("height", heightWin);

    this.$getPublicKey(function (res) {
      _this.pbobj = res.data;
    });

    this.$getVer(function (res) {
      console.log(res);
      if (res.status == 200) {
        _this.version = res.data.version;
        _this.verTip = res.data.memo;
        if (res.data.date) {
          _this.isauth = true;
          var tmp = _this.$getWObj().auth;
          _this.aform = tmp ? tmp : _this.aform;
          _this.aform.igmd5 = tmp ? true : false;
          _this.aform.date = res.data.date;
        }
      } else {
        _this.$message.error(_this.$t('app_not_auth'));
        setTimeout(function () {
          _this.licenseDialogVisible = true;
        }, 500);
      }
    }, function () {
      _this.$message.error(_this.$t('app_rqsError'));
    });

    if (localStorage.isRemember == 1) {
      this.loginForm.account = localStorage.rUsr;
      this.loginForm.checkPass = localStorage.rPsw;
      this.checked = localStorage.isRemember == 1 ? true : false;
    }
  },
  created: function created() {

    if (!localStorage.getItem("system_lang")) {
      this.value = "zh_cn";
    } else {
      this.value = localStorage.getItem("system_lang");
    }
  },

  computed: {
    langName: function langName() {
      return this.langItem[this.value].label;
    },
    langUrl: function langUrl() {
      return this.langItem[this.value].url;
    }
  },
  methods: {
    openLicenseDialog: function openLicenseDialog() {
      this.licenseDialogVisible = true;
    },
    activationLicense: function activationLicense() {
      var _this2 = this;

      this.$activationLicense(this.licenseForm.licenseKey, function (res) {
        console.log(res);
        if (res.status == 200) {
          _this2.$message.success('successfully!');
          setTimeout(function () {
            _this2.licenseDialogVisible = false;
            _this2.$router.go(0);
          }, 500);
        } else {
          _this2.$message.error(res.message);
        }
      }, function () {
        _this2.$message.error(_this2.$t('app_rqsError'));
      });
    },
    fetchMacAddress: function fetchMacAddress() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this3.$fetchMacAddress(function (res) {
                  console.log(res);
                  _this3.macAddress = res.data || 'Unable to fetch MAC address';
                  _this3.$message.success('MAC Address fetched successfully!');
                }, function () {
                  _this3.$message.error(_this3.$t('app_rqsError'));
                });

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    codeCheck: function codeCheck() {
      var _this4 = this;

      if (!this.code6) {
        this.$message.error(this.$t('app_inputNumber'));
        return;
      }
      this.dld = true;
      this.$loginCodeCheck(this.tmpres.user.userid, this.code6, function (res) {
        _this4.dld = false;
        if (res.status == 200) {
          _this4.closeDiaCk();
          localStorage.setItem('user', res.data.token);
          _this4.$router.push({ path: '/' });
        } else {
          _this4.$message.error(res.message);
        }
      }, function () {
        _this4.dld = false;
      });
    },
    closeDiaCk: function closeDiaCk() {
      this.ischeck = false;
      this.code6 = '';
    },
    authPswChange: function authPswChange() {
      this.aform.igmd5 = false;
    },
    submitForm: function submitForm(formName) {
      var _this5 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          var fm = _this5.aform;
          _this5.logining = true;
          _this5.$authLogin(fm.usr, fm.igmd5 ? fm.psw : md5(fm.psw), fm.code, function (res) {
            _this5.logining = false;
            if (res.status == 200) {
              _this5.aform.psw = md5(fm.psw);
              _this5.aform.igmd5 = true;
              _this5.$setWObj('auth', _this5.aform);
              _this5.closeDia();
            } else {
              _this5.$message.error(res.message);
            }
          }, function () {
            _this5.logining = false;
          });
        } else {
          return false;
        }
      });
    },
    closeDia: function closeDia() {
      this.isauth = false;
    },
    recode: function recode() {
      var _this6 = this;

      this.$getCheckcode(function (res) {
        _this6.codeObj = {};
        _this6.codeObj = res.data;
      });
    },
    pswChange: function pswChange() {
      localStorage.rPsw = '';
      localStorage.isRemember = '0';
      localStorage.rUsr = '';
    },
    langchange: function langchange(vl) {
      this.langEvent(vl);
    },
    langEvent: function langEvent(val) {
      localStorage.setItem("system_lang", val);
      __WEBPACK_IMPORTED_MODULE_9__api_req_js__["a" /* default */].common.changeLang(val);
      localStorage.setlang = '1';
      window.location.reload(true);
    },
    resolvingRouterData: function resolvingRouterData() {
      var roleList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      function rcom(name) {
        return __webpack_require__(60)("./" + name + '.vue');
      }
      function ge(roleList, data) {
        data.forEach(function (item) {
          var menu = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, item);
          menu.component = __webpack_require__(60)("./" + item.component + '.vue');
          if (!menu.meta) {
            menu.meta = {};
          }
          if (menu.superId !== 0) {
            menu.children = [];
            if (item.children) {
              ge(menu.children, item.children);
            }
          }

          roleList.push(menu);
        });
      }

      ge(roleList, data);
    },
    getUserRoe: function getUserRoe(token) {
      var _this7 = this;

      var that = this;
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_6__api_url__["a" /* baseurl */] + '/menu/menuList.do', { token: token }).then(function (res) {
        if (res.data.status === 200) {
          var roleList = res.data.data;

          var rrr = [];

          that.resolvingRouterData(rrr, roleList);

          that.$router.addRoutes(rrr);
          _this7.$store.dispatch('setRouters', rrr);
          __WEBPACK_IMPORTED_MODULE_7_js_cookie___default.a.set("roleList", "success");
        }
      });
    },

    handleSubmit: function handleSubmit() {
      var that = this;

      this.$refs['loginForm'].validate(function (result) {
        var _this8 = this;

        if (result) {
          var password = localStorage.isRemember == 1 ? this.loginForm.checkPass : md5(this.loginForm.checkPass);

          var timestamp = new Date().valueOf();

          var pparam = {
            "password": password,
            "loginTime": timestamp
          };
          var encrypt = new __WEBPACK_IMPORTED_MODULE_8_jsencrypt___default.a();
          encrypt.setPublicKey(this.pbobj.publicKey);
          var encryptData = encrypt.encrypt(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(pparam));

          this.logining = true;

          var params = {
            "userName": this.loginForm.account,
            "random": this.pbobj.random,
            "content": encryptData,
            "token": '',
            "code": this.loginForm.code,
            "codeId": this.codeObj.codeId
          };

          __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_6__api_url__["a" /* baseurl */] + '/user/login.do', params).then(function (res) {

            if (res.data.status !== 200) {
              _this8.$notify({
                title: _this8.$t('lin_global.error'),
                message: res.data.message,
                type: 'error'
              });
              _this8.logining = false;
              _this8.recode();
              if (res.data.status == 600) _this8.isauth = true;
            } else {

              localStorage.setItem('userId', res.data.user.userid);
              localStorage.setItem('mechanismId', res.data.user.mechanismId);
              localStorage.setItem('userType', res.data.user.userType);
              localStorage.setItem('logo', res.data.user.logoAddress);
              localStorage.setItem('cerType', res.data.user.cerType + '');
              _this8.$store.dispatch('setHomeLogo', localStorage.getItem('logo'));
              _this8.$cleanWObj();
              _this8.$setWObj('login', res.data.user);

              localStorage.setItem('loginTag', new Date().getTime() + '');
              _this8.logining = false;

              localStorage.isRemember = _this8.checked ? 1 : 0;
              if (_this8.checked) {
                localStorage.rUsr = _this8.loginForm.account;
                localStorage.rPsw = password;
              } else {
                localStorage.rUsr = '';
                localStorage.rPsw = '';
              }

              if (res.data.user.bindMfa == 1) {
                _this8.tmpres = res.data;
                _this8.ischeck = true;
              } else {
                localStorage.setItem('user', res.data.data);
                _this8.$router.push({ path: '/' });
              }
            }
          });
        }
      }.bind(that));
    }
  }
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_url__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {};
	},
	created: function created() {},

	methods: {
		onCreate: function onCreate() {}
	}
});

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_packages_input_src_input__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_packages_input_src_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_packages_input_src_input__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ElInput: __WEBPACK_IMPORTED_MODULE_3_element_ui_packages_input_src_input___default.a },
  data: function data() {
    return {
      submitForm: {
        name: '',
        url: '',
        icon: '',
        menuId: ''
      },
      menuPath: [{
        "name": "任务管理-正在推送任务",
        "path": "/mision-list"
      }, {
        "name": "任务管理-已完成任务",
        "path": "/mision-history"
      }, {
        "name": "设备管理-我的设备",
        "path": "/terList"
      }, {
        "name": "设备管理-终端备份",
        "path": "/terBackups"
      }, {
        "name": "设备管理-OTA锁定",
        "path": "/terOta"
      }, {
        "name": "设备管理-终端地图",
        "path": "/map"
      }, {
        "name": "设备管理-日志管理",
        "path": "/log"
      }, {
        "name": "广告管理-广告列表",
        "path": "/advert-list"
      }, {
        "name": "广告管理-广告审核",
        "path": "/examine-list"
      }, {
        "name": "广告管理-视频广告列表",
        "path": "/video-list"
      }, {
        "name": "广告管理-视频广告审核",
        "path": "/video-verify"
      }, {
        "name": "应用管理-应用列表",
        "path": "/appList"
      }, {
        "name": "应用管理-应用市场",
        "path": "/appSlot"
      }, {
        "name": "应用管理-应用审核",
        "path": "/appView"
      }, {
        "name": "数据管理-渠道商管理",
        "path": "/channels"
      }, {
        "name": "数据管理-厂商管理",
        "path": "/firms"
      }, {
        "name": "数据管理-设备类型管理",
        "path": "/devices"
      }, {
        "name": "数据管理-广告类型管理",
        "path": "/adtype"
      }, {
        "name": "数据管理-设备型号管理",
        "path": "/devices-no"
      }, {
        "name": "数据管理-应用类型管理",
        "path": "/apptype"
      }, {
        "name": "系统管理-OTA管理",
        "path": "/romList"
      }, {
        "name": "系统管理-OTA审核",
        "path": "/romReview"
      }, {
        "name": "系统管理-系统定制",
        "path": "/romOrder"
      }, {
        "name": "系统管理-开机动画定制",
        "path": "/romAnimate"
      }, {
        "name": "系统管理-固件管理",
        "path": "/firmwareManage"
      }, {
        "name": "系统管理-固件审核",
        "path": "/firmwareCheck"
      }, {
        "name": "系统管理-固件推送",
        "path": "/firmwarePush"
      }, {
        "name": "系统管理-launcher管理",
        "path": "/launch-list"
      }, {
        "name": "系统管理-launcher审核",
        "path": "/launch-check-list"
      }, {
        "name": "配置管理-角色管理",
        "path": "/roleManager"
      }, {
        "name": "配置管理-系统配置",
        "path": "/sysSetting"
      }, {
        "name": "配置管理-LOGO设置",
        "path": "/logoSetting"
      }, {
        "name": "菜单管理-菜单列表",
        "path": "/menuList"
      }, {
        "name": "风控管理-围栏设置",
        "path": "/accInfo"
      }, {
        "name": "风控管理-预警信息",
        "path": "/warn"
      }, {
        "name": "账号管理-账号信息",
        "path": "/accInfo"
      }, {
        "name": "账号管理-子账号管理",
        "path": "/accMess"
      }, {
        "name": "安全管理-我的证书",
        "path": "/certificate"
      }, {
        "name": "安全管理-证书管理",
        "path": "/certificate"
      }, {
        "name": "安全管理-远程授权",
        "path": "/remote"
      }],

      editMenuModelVisible: false,
      editSortModalVisible: false,

      modelTitle: this.$t('menuConfig.menu.addMenu2'),
      menuNameLangA: [],
      menuNameLangO: {},
      tempData: '',
      menuIndex: '',
      editMenuPosition: false,
      editMenuNameAndUrl: false,
      tipPath: '',
      editForm: {
        subId: '',
        menuId: '',
        menuName: '',
        superId: '0',
        url: '',
        uri: '',
        menuSortNo: '100',
        menuIcon: '',
        meta: '',
        token: localStorage.getItem("user") | null
      },
      editRules: {
        menuName: [{ required: true, message: this.$t('menuConfig.menu.notBlankName'), trigger: 'blur' }]
      },

      resultData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      token: localStorage.getItem("user") | null
    };
  },

  methods: {
    submitMenuEdit: function submitMenuEdit() {
      var _this = this;

      this.$editConfigMenu(this.submitForm, function (res) {
        if (res.status === 200) {
          _this.$message.success(res.message);
          _this.fetchData();
          _this.editMenuNameAndUrl = false;
        } else {
          _this.$message.error(res.message);
        }
      }, function () {});
    },
    refreshMenu: function refreshMenu() {
      localStorage.localMenuData = '';
      this.$router.push({ path: '/' });
      location.reload();
    },
    handleChange: function handleChange(vl) {
      var _this2 = this;

      this.$editMenuPosition(this.tempData.subId, this.menuIndex, function (res) {
        if (res.status === 200) {
          _this2.$message.success(res.message);
          _this2.fetchData();
          _this2.editMenuPosition = false;
        } else {
          _this2.$message.error(res.message);
        }
      }, function () {});
    },
    initListData: function initListData() {
      this.menuNameLangO = {
        en: 'List',
        zh_cn: '列表',
        ko: '목록',
        ru: 'список'
      };
    },
    deleteRecord: function deleteRecord(subId, menuName) {
      var that = this;

      that.$confirm(this.$t('mao_global.tip.confirmDelete') + '【' + menuName + '】' + this.$t('mao_global.tip.notReset'), this.$t('mao_global.tip.text'), {
        confirmButtonText: this.$t('mao_global.btn.ok'),
        cancelButtonText: this.$t('mao_global.btn.cancel'),
        type: 'warning'
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/menu/deleteMenu.do', { subId: subId, token: that.token }).then(function (res) {
          if (res.data && res.data.status && res.data.status === 200) {
            that.fetchData();
          }
        });
      }).catch(function () {});
    },
    submitEditForm: function submitEditForm() {
      var that = this;

      that.editForm.menuName = that.menuNameLangO;
      console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(that.editForm));


      var reqUri = __WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/menu/addMenu.do';
      var tipMsg = this.$t('app_addsc');

      if (that.modelTitle === this.$t('menuConfig.menu.editMenu')) {
        reqUri = __WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/menu/editMenu.do';
        tipMsg = this.$t('menuConfig.menu.editSuccess');
      }

      this.$refs['editForm'].validate(function (result) {
        if (result) {
          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(reqUri, that.editForm).then(function (res) {
            if (res.data && res.data.status && res.data.status === 200) {
              that.editMenuModelVisible = false;
              that.$message(tipMsg);
              that.fetchData();

              that.editForm = {
                subId: '',
                menuId: '',
                menuName: '',
                superId: '0',
                url: '',
                uri: '',
                menuSortNo: '100',
                menuIcon: '',
                meta: '',
                token: localStorage.getItem("user") | null
              };
            }
          });
        }
      }.bind(that));
    },
    openEditSortModal: function openEditSortModal() {
      var that = this;

      that.editSortModalVisible = true;
    },
    openEditModel: function openEditModel(type) {
      var parentId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var that = this;

      that.editMenuModelVisible = true;

      if (that.menuNameLangA.length < 1) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/menu/getLanguage.do').then(function (res) {
          if (res.data && res.data.status && res.data.status === 200) {
            that.menuNameLangA = res.data.data;
            that.menuNameLangA.forEach(function (it) {
              that.menuNameLangO[it] = "";
            });
          }
        });
      }

      switch (type) {
        case 'ADD':
          that.modelTitle = this.$t('menuConfig.menu.addMenu2');


          var sId = '';
          if (data && data.subId) {
            sId = data.subId;
          }
          that.editForm = { menuName: '', superId: '0' || "", subId: sId, url: '', menuSortNo: '', meta: '', menuIcon: '', token: localStorage.getItem("user") | null };
          break;
        case 'SORT':
          break;
        default:
          that.modelTitle = this.$t('menuConfig.menu.editMenu');
          console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data, null, 2));
          that.editForm = {
            menuId: data.menuId,
            menuName: data.menuName,
            superId: '0',
            url: data.url,
            subId: data.subId || "",
            meta: '',
            menuSortNo: data.menuSortNo,
            menuIcon: data.menuIcon || "",
            token: localStorage.getItem("user") | null
          };
          break;
      }
    },
    jump: function jump(uri) {
      this.$router.push({ path: uri });
    },
    fetchData: function fetchData() {
      var that = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/menu/menuList.do', { token: localStorage.getItem('user') }).then(function (res) {
        if (res.data && res.data.status && res.data.status === 200) {
          that.resultData = res.data.data;
        }
      });
    },
    append: function append(store, data) {
      store.append({ id: id++, label: 'testtest', children: [] }, data);
    },
    remove: function remove(store, data) {
      store.remove(data);
    },

    renderContent: function renderContent(createElement, _ref) {
      var node = _ref.node,
          data = _ref.data,
          store = _ref.store;

      var self = this;
      return createElement('span', [createElement('span', node.label), createElement('span', { attrs: {
          style: "float: right; margin-right: 20px"
        } }, [createElement('el-button', { attrs: {
          size: "mini"
        }, on: {
          click: function click() {
            store.append({ id: self.baseId++, label: 'testtest', children: [] }, data);
            self.openEditModel('ADD', data.menuId, data);
          }
        } }, self.$t('menuConfig.menu.addSubMenu')), createElement('el-button', { attrs: {
          size: "mini"
        },

        on: {
          click: function click() {
            self.menuIndex = data.menuSortNo;
            self.tempData = data;
            self.editMenuPosition = true;
          }
        } }, self.$t('mao_global.btn.sort')), createElement('el-button', { attrs: {
          size: "mini",
          type: ""
        },
        on: {
          click: function click() {
            console.log(data);
            self.submitForm.name = data.name;
            self.submitForm.icon = data.iconCls;
            self.submitForm.url = data.path;
            self.submitForm.menuId = data.menuId;
            self.editMenuNameAndUrl = true;
          }
        } }, self.$t('app_edit')), createElement('el-button', { attrs: {
          size: "mini",
          type: "danger"
        },
        on: {
          click: function click() {
            self.deleteRecord(data.subId, data.name);
          }
        } }, self.$t('mao_global.btn.delete'))])]);
    }
  },
  mounted: function mounted() {
    var that = this;
    that.fetchData();
  }
});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      sNum: 0,
      index: 1,
      refresh: 2000,
      multipleSelection: [],
      name: '',
      tContent: '',
      row: this.$gRow,
      total: 0,
      dialogFormVisible: 0,
      tableData: [],
      pInfo: [],
      loading: 0,
      editData: '',
      info: '',
      detail: '',
      statusNames: {
        '-1': this.$t('app_downFail'),
        '-2': this.$t('app_md5Fail'),
        '-3': this.$t('app_theNewgVer'),
        '-4': this.$t('app_fileFmIllegal'),
        '-5': this.$t('app_updateFail'),
        '-6': this.$t('app_usrCancelUpdate'),
        '-10': this.$t('app_uninsfail'),
        '0': this.$t('app_pushFail'),
        '1': this.$t('app_downloading'),
        '2': this.$t('app_downFinish'),
        '3': this.$t('app_success'),
        '6': this.$t('app_pause'),
        '7': this.$t('app_cancel'),
        '5': this.$t('app_success')
      },
      status: [{ vl: '-1', name: this.$t('app_downFail') }, { vl: '-2', name: this.$t('app_md5Fail') }, { vl: '-3', name: this.$t('app_newgVer') }, { vl: '-4', name: this.$t('app_fileFmIllegal') }, { vl: '-5', name: this.$t('app_updateFail') }, { vl: '-6', name: this.$t('app_usrCancelUpdate') }, { vl: '-10', name: this.$t('app_uninsfail') }, { vl: '0', name: this.$t('app_pushFail') }, { vl: '1', name: this.$t('app_downloading') }, { vl: '2', name: this.$t('app_downFinish') }, { vl: '3', name: this.$t('app_success') }, { vl: '6', name: this.$t('app_pause') }, { vl: '7', name: this.$t('app_cancel') }, { vl: '5', name: this.$t('app_success') }],
      statusVl: '',
      tName: ''
    };
  },

  computed: {},
  methods: {
    cellClick: function cellClick(row, ev, col) {

      return;

      if (col.label && col.label === this.$t('app_operate')) {
        return;
      }

      if (col.label === this.$t('app_deviceName') || col.label === this.$t('app_deviceNo')) {
        this.$router.push({
          path: '/terList/' + row.terminalId + '/details'
        });
      }
    },
    allDel: function allDel() {
      var _this = this;

      var hit = 0;
      this.multipleSelection.forEach(function (vl) {
        if (vl.status === '1' || vl.status === '1' || vl.status === '6') {
          hit = 1;
          return;
        }
      });
      if (hit) {
        this.$message.error(this.$t('app_cantDelTask'));
      } else {
        var ids = '';
        this.multipleSelection.forEach(function (vl) {
          ids += vl.id + ',';
        });
        ids = ids.substring(0, ids.length - 1);
        if (!ids) {
          this.$message(this.$t('app_oneRecordMust'));
          return;
        }
        this.loading = 1;
        this.$pushDelTask(ids, function (res) {
          _this.loading = 0;
          if (res.status === 200) {
            _this.getList();
          } else {
            _this.$message.error(res.message);
          }
        }, function () {
          _this.loading = 0;
        });
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.sNum = val.length;
      this.multipleSelection = val;
      if (this.multipleSelection.length > 0) {
        this.stopTimer();
      } else {
        this.updateTimer();
      }
    },
    query: function query() {
      this.getList();
    },
    selectChange: function selectChange(vl) {
      this.getList();
    },
    downOperate: function downOperate(vl, row) {
      var _this2 = this;

      console.log(row.terminalNo);
      this.loading = 1;
      this.$pushFileDownCtrl(row.id, vl + '', row.terminalNo, function (res) {
        console.log('opres', res);
        _this2.loading = 0;
        if (res.status === 200) {
          _this2.getList();
        } else {
          _this2.$message.error(res.message);
        }
      }, function () {
        _this2.loading = 0;
      });
    },
    getProcess: function getProcess(mIds) {
      var _this3 = this;

      if (!mIds) {
        this.stopTimer();
        return;
      }


      this.$missionPersent(mIds, function (res) {
        if (res.status === 200) {
          var temp = [];
          _this3.pInfo.forEach(function (vl, index) {
            var newData = vl;
            var data = res.data[index];
            if (data.result) {
              newData.value.progress = data.result.progress;
              newData.value.status = data.result.status;
            } else {
              _this3.getList();
            }
            temp.push(newData);
          });
          _this3.pInfo = temp;


          _this3.pInfo.forEach(function (vl, index) {
            _this3.tableData[vl.index] = vl.value;
          });
        } else {
          _this3.$message.error(res.message);
        }
      }, function () {});
    },
    processCore: function processCore() {
      var _this4 = this;

      var arr = this.tableData;
      this.pInfo = [];
      this.tableData.forEach(function (vl, index) {
        if (vl.taskStatus === '1' || vl.taskStatus === '2') {
          _this4.pInfo.push({ value: vl, index: index });
        }
      });
      var ids = '';
      this.pInfo.forEach(function (vl, index) {

        ids += vl.value.id + ',';
      });
      ids = ids.substring(0, ids.length - 1);
      this.getProcess(ids);
    },
    updateTimer: function updateTimer() {
      var _this5 = this;

      this.stopTimer();

      if (this.$route.path !== '/mission-detail') {
        return;
      }
      this.pTm = setInterval(function () {
        _this5.processCore();
      }, this.refresh);
    },
    stopTimer: function stopTimer() {
      clearInterval(this.pTm);
      clearTimeout(this.pTm);
    },
    showBtn: function showBtn(tag, st) {
      var vl = st;

      switch (vl) {
        case '-1':
        case '-2':
        case '-3':
        case '-4':
        case '-5':
        case '-6':
        case '3':
        case '2':
        case '0':
        case '7':
          if (tag === 0) {
            return 1;
          } else {
            return 0;
          }
          break;
        case '1':
          if (tag === 1 || tag === 3) {
            return 1;
          } else {
            return 0;
          }
          break;
        case '6':
          if (tag === 2 || tag === 3) {
            return 1;
          } else {
            return 0;
          }
          break;
      }
    },
    delRow: function delRow(row) {
      var _this6 = this;

      this.$showConfirm('', this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warnning', function () {
        var id = row.id;
        _this6.loading = 1;
        _this6.$pushDelTask(id, function (res) {
          _this6.loading = 0;
          if (res.status === 200) {
            _this6.getList();
          } else {
            _this6.$message.error(res.message);
          }
        }, function () {
          _this6.loading = 0;
        });
      });
    },
    pageSelect: function pageSelect(index) {
      this.index = index;
      this.getList();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getList();
    },
    getList: function getList() {
      var _this7 = this;

      var tNameVl = this.tName ? this.tName : '';
      var statusVl = this.statusVl ? this.statusVl : '';
      var content = this.tContent ? this.tContent : '';
      this.loading = 1;

      this.$pushHisDetail(this.index, this.$gRow, this.info.fileId, this.info.version, tNameVl, statusVl, this.info.taskType, function (res) {
        _this7.loading = 0;
        console.log(res);
        if (res.status === 200) {

          _this7.tableData = res.data;
          _this7.total = res.total;
        } else {
          _this7.$message.error(res.message);
        }
      }, function () {
        _this7.loading = 0;
      });
    },
    getDetail: function getDetail() {
      var _this8 = this;

      this.loading = true;
      this.$pushFileDetail(this.info.fileId, this.info.taskType, function (res) {
        _this8.loading = false;
        if (res.status === 200) {
          _this8.detail = res.data;
        } else {
          _this8.$message.error(res.message);
        }
      }, function () {
        _this8.loading = false;
      });
    }
  },
  mounted: function mounted() {
    this.info = this.$getWObj().missionInfo;

    this.getList();
    this.getDetail();
  },
  destroyed: function destroyed() {
    this.stopTimer();
  }
});

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_tyc_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_tyc_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_global_tyc_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    TemplateName: __WEBPACK_IMPORTED_MODULE_1__global_mechanism_selector_vue___default.a,
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default.a,
    tyc: __WEBPACK_IMPORTED_MODULE_2__components_global_tyc_vue___default.a
  },
  data: function data() {
    var that = this;
    return {
      mechanismData: {
        callback: function callback(value) {
          that.mech = value;
          that.selectChange(value);
        }
      },
      missionNames: '',
      missionList: '',
      pageTag: 'missionHisListPage',
      mechs: [],
      tqobj: '',
      taskType: '',
      name: '',
      row: this.$gRow,
      total: 0,
      dialogFormVisible: 0,
      tableData: [],
      loading: 0,
      editData: '',
      userId: '',
      missionName: '',
      mech: '',
      gBase: [],
      gSub: [],

      selectedMissionType: ""
    };
  },

  computed: {
    index: function index() {
      return this.$getWPage(this.pageTag);
    }
  },
  methods: {
    viewDetail: function viewDetail(row) {
      this.$setWObj('missionInfo', row);

      this.$router.push({ path: '/mission-history/detail' });
    },
    selectChange: function selectChange(vl) {
      this.mech = vl;
      this.getList();
    },
    query: function query() {
      console.log("selected type is " + this.missionName);
      this.getList();
    },
    cellClick: function cellClick(row, ev, col) {
      if (col.label && col.label === this.$t('app_operate')) {
        return;
      }
      this.viewDetail(row);
    },
    edit: function edit(row) {
      this.editData = row;
      this.dialogFormVisible = 1;
    },
    del: function del(row) {
      var _this2 = this;

      this.$showConfirm('', this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warnning', function () {
        var id = row.appClassifyId;
        _this2.loading = 1;
        _this2.$delAppType(id, function (res) {
          _this2.loading = 0;
          if (res.status === 200) {
            _this2.getList();
          } else {
            _this2.$message.error(res.message);
          }
        }, function () {
          _this2.loading = 0;
        });
      });
    },
    pageSelect: function pageSelect(index) {
      this.$setWPage(this.pageTag, index);
      this.getList();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getList();
    },
    open: function open() {
      if (this.editData) {
        this.name = this.editData.appClassifyName;
      }
    },
    close: function close() {
      this.editData = '';
      this.name = '';
    },
    showInput: function showInput() {
      this.dialogFormVisible = 1;
    },
    newData: function newData() {
      var _this3 = this;

      var vl = this.name;
      if (vl) {
        this.loading = 1;
        this.$addAppType(vl, function (res) {
          _this3.loading = 0;

          if (res.status === 200) {
            _this3.getList();
          } else {
            _this3.$message.error(res.message);
          }
        }, function () {
          _this3.loading = 0;
        });
        this.dialogFormVisible = 0;
      } else {
        this.$message.error(this.$t('app_inputAName'));
      }
    },
    editRqs: function editRqs() {
      var _this4 = this;

      var vl = this.name;
      if (vl) {
        this.loading = 1;
        this.$editAppType(this.editData.appClassifyId, vl, function (res) {
          _this4.loading = 0;
          if (res.status === 200) {
            _this4.getList();
          } else {
            _this4.$message.error(res.message);
          }
        }, function () {
          _this4.loading = 0;
        });
        this.dialogFormVisible = 0;
      } else {
        this.$message.error(this.$t('app_inputAName'));
      }
    },
    sure: function sure() {
      if (this.editData) {
        this.editRqs();
      } else {
        this.newData();
      }
    },
    getList: function getList() {
      var _this5 = this;

      this.loading = 1;
      var mId = this.mech ? this.mech : '';
      var type = this.taskType ? this.taskType : '';
      var mName = this.missionName != "0" ? this.missionName : '';
      var page = this.$getWPage(this.pageTag);
      page = page ? page : 1;
      this.$pushHis(page, this.$gRow, type, mName, function (res) {
        console.log('res', res);
        _this5.loading = 0;
        if (res.status === 200) {
          console.log('data', res.data);
          _this5.tableData = res.data;
          _this5.total = res.total;
        } else {
          _this5.$message.error(res.message);
        }
      }, function () {
        _this5.loading = 0;
      });
    }
  },
  mounted: function mounted() {

    var _this = this;
    this.tqobj = {
      keys: ['taskType', 'taskTypeArr'],
      callback: function callback(data) {
        _this.missionNames = data[0];
        _this.missionList = data[1];
      }
    };

    var user = localStorage['userId'];
    this.userId = user;
    this.getList();
  }
});

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default.a
  },
  data: function data() {
    var that = this;
    return {
      dLoading: false,
      tst: '',
      iNo: '',
      mechanismData: {
        callback: function callback(value) {
          that.mech = value;
          that.getCmDv();
        }
      },
      stModel: [{ label: this.$t('app_online'), vl: '1' }, { label: this.$t('app_offline'), vl: '2' }, { label: this.$t('app_sleep'), vl: '3' }],
      showDevice: false,
      mech: '',
      sNum: 0,
      index: 1,
      page: 1,
      refresh: 6000,
      multipleSelection: [],
      name: '',
      tContent: '',
      row: this.$gRow,
      total: 0,
      dvtotal: 0,
      dialogFormVisible: 0,
      tableData: [],
      tableDvData: [],
      pInfo: [],
      loading: 0,
      editData: '',
      info: '',
      detail: '',
      statusNames: {
        '-1': this.$t('app_downFail'),
        '-2': this.$t('app_md5Fail'),
        '-3': this.$t('app_theNewgVer'),
        '-4': this.$t('app_fileFmIllegal'),
        '-5': this.$t('app_updateFail'),
        '-6': this.$t('app_usrCancelUpdate'),
        '0': this.$t('app_pushFail'),
        '1': this.$t('app_downloading'),
        '2': this.$t('app_downFinish'),
        '3': this.$t('app_success'),
        '4': this.$t('app_waiting'),
        '5': this.$t('app_success'),
        '6': this.$t('app_pause'),
        '7': this.$t('app_ccdown'),
        '-7': this.$t('app_verror'),
        '-8': this.$t('app_insfail'),
        '-9': this.$t('app_checksignfail'),
        '-10': this.$t('app_uninsfail')
      },
      status: [{ vl: '-1', name: this.$t('app_downFail') }, { vl: '-2', name: this.$t('app_md5Fail') }, { vl: '-3', name: this.$t('app_newgVer') }, { vl: '-4', name: this.$t('app_fileFmIllegal') }, { vl: '-5', name: this.$t('app_updateFail') }, { vl: '-6', name: this.$t('app_usrCancelUpdate') }, { vl: '0', name: this.$t('app_pushFail') }, { vl: '1', name: this.$t('app_downloading') }, { vl: '2', name: this.$t('app_downFinish') }, { vl: '3', name: this.$t('app_success') }, { vl: '4', name: this.$t('app_waiting') }, { vl: '5', name: this.$t('app_success') }, { vl: '6', name: this.$t('app_pause') }, { vl: '7', name: this.$t('app_ccdown') }, { vl: '-7', name: this.$t('app_verror') }, { vl: '-8', name: this.$t('app_insfail') }, { vl: '-9', name: this.$t('app_checksignfail') }, { vl: '-10', name: this.$t('app_uninsfail') }],
      statusVl: '',
      tName: ''
    };
  },

  computed: {},
  methods: {
    tstChange: function tstChange() {
      this.getCmDv();
    },
    bindOperate: function bindOperate(row) {
      var _this2 = this;

      this.dLoading = 1;
      var mc = row.mechId;
      this.$appendPush(this.info.taskId, row.terminalNo, '1', mc, row.terminalNo, '', '', '', '', function (res) {
        _this2.dLoading = 0;
        if (res.status === 200) {
          _this2.$message.success(_this2.$t('app_tipViewTask'));
          _this2.notPassDialog = false;
          _this2.getList();
        } else {
          _this2.$message.error(res.message);
        }
      }, function (error) {
        _this2.dLoading = 0;
        _this2.$message.error(_this2.$t('app_rqsError'));
      });
    },
    srchDevice: function srchDevice() {
      this.getCmDv();
    },
    getCmDv: function getCmDv() {
      if (this.info.taskType == '14' || this.info.taskType == '14') {
        this.getNonDevices();
      } else {
        this.getDevices();
      }
    },
    getDevices: function getDevices() {
      var _this3 = this;

      var channel = this.mech ? this.mech : '';
      var terminalNo = this.iNo ? this.iNo : '';
      var status = this.tst ? this.tst : '';

      var mFileId, fileId, fileType;

      this.loading = 1;
      this.$canPushTer(this.page, this.$gRow, mFileId, channel, status, terminalNo, fileType, fileId, function (res) {
        console.log('res', res);
        _this3.loading = 0;
        if (res.data) {
          _this3.dvtotal = res.total;
          _this3.tableDvData = res.data;

          var _this = _this3;
          var tsl = _this3.batchSl[_this3.index - 1];
          if (tsl) {
            var tm = [];
            tsl.forEach(function (vl) {
              res.data.forEach(function (vl1) {
                if (vl.terminalNo == vl1.terminalNo) {
                  tm.push(vl1);
                }
              });
            });
            setTimeout(function () {
              _this.toggleSelection(tm);
            }, 100);
          }
        }
      }, function () {
        _this3.loading = 0;
      });
    },
    getNonDevices: function getNonDevices() {
      var _this4 = this;

      var channel = this.mech ? this.mech : '';
      var terminalNo = this.iNo ? this.iNo : '';
      var status = this.tst ? this.tst : '';


      var mFileId, fileId, fileType;

      this.loading = 1;
      this.$getNonItDv(this.page, this.$gRow, channel, terminalNo, status, '', '', '', '', '', function (res) {

        _this4.loading = 0;
        if (res.data) {
          _this4.tableDvData = res.data;
          _this4.dvtotal = res.total;
        }
      }, function () {
        _this4.loading = 0;
      });
    },
    refreshList: function refreshList() {
      this.getList();
    },
    repush: function repush(row) {
      var _this5 = this;

      this.$pushRepush(row.id, function (res) {
        _this5.loading = 0;
        if (res.status === 200) {
          _this5.$message.success(res.message);
        } else {
          _this5.$message.error(res.message);
        }
      }, function () {
        _this5.loading = 0;
      });
    },
    cellClick: function cellClick(row, ev, col) {
      if (col.label && col.label === this.$t('app_operate')) {
        return;
      }

      if (col.label === this.$t('app_deviceName') || col.label === this.$t('app_deviceNo')) {

        if (this.detail.fileType == 6) {
          this.$setWObj('ndObj', { data: row.terminalId });
          this.$router.push({ path: '/non-it-eq/device/detail' });
        } else {
          this.$router.push({
            path: '/terList/' + row.terminalId + '/details'
          });
        }
      }
    },
    allDel: function allDel() {
      var _this6 = this;

      var hit = 0;
      this.multipleSelection.forEach(function (vl) {
        if (vl.status === '1' || vl.status === '1' || vl.status === '6') {
          hit = 1;
          return;
        }
      });
      if (hit) {
        this.$message.error(this.$t('app_cantDelTask'));
      } else {
        var ids = '';
        this.multipleSelection.forEach(function (vl) {
          ids += vl.id + ',';
        });
        ids = ids.substring(0, ids.length - 1);
        if (!ids) {
          this.$message(this.$t('app_oneRecordMust'));
          return;
        }
        this.loading = 1;
        this.$pushDelTask(ids, function (res) {
          _this6.loading = 0;
          if (res.status === 200) {
            _this6.getList();
          } else {
            _this6.$message.error(res.message);
          }
        }, function () {
          _this6.loading = 0;
        });
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.sNum = val.length;
      this.multipleSelection = val;
      if (this.multipleSelection.length > 0) {
        this.stopTimer();
      } else {
        this.updateTimer();
      }
    },
    query: function query() {
      this.getList();
    },
    selectChange: function selectChange(vl) {
      this.getList();
    },
    downOperate: function downOperate(vl, row) {
      var _this7 = this;

      console.log(row.terminalNo);
      this.loading = 1;
      this.$pushFileDownCtrl(row.id, vl + '', row.terminalNo, function (res) {
        console.log('opres', res);
        _this7.loading = 0;
        if (res.status === 200) {
          _this7.getList();
        } else {
          _this7.$message.error(res.message);
        }
      }, function () {
        _this7.loading = 0;
      });
    },
    getProcess: function getProcess(mIds) {
      var _this8 = this;

      if (!mIds) {
        this.stopTimer();
        return;
      }


      this.$missionPersent(mIds, function (res) {
        if (res.status === 200) {
          var temp = [];
          _this8.pInfo.forEach(function (vl, index) {
            var newData = vl;
            var data = res.data[index];
            if (data.result) {
              newData.value.progress = data.result.progress;
              newData.value.status = data.result.status;
              newData.value.taskStatus = data.result.status;
              var st = data.result.status;
              if (st != 1 && st != 2 && st != 4) {
                _this8.getList();
              }
            } else {
              _this8.getList();
            }
            temp.push(newData);
          });
          _this8.pInfo = temp;


          _this8.pInfo.forEach(function (vl, index) {
            _this8.tableData[vl.index] = vl.value;
          });
        } else {
          _this8.$message.error(res.message);
        }
      }, function () {});
    },
    processCore: function processCore() {
      var _this9 = this;

      var arr = this.tableData;
      this.pInfo = [];
      this.tableData.forEach(function (vl, index) {
        if (vl.taskStatus === '1' || vl.taskStatus === '2' || vl.taskStatus === '4') {
          _this9.pInfo.push({ value: vl, index: index });
        }
      });
      var ids = '';
      this.pInfo.forEach(function (vl, index) {
        ids += vl.value.id + ',';
      });
      ids = ids.substring(0, ids.length - 1);
      this.getProcess(ids);
    },
    updateTimer: function updateTimer() {
      var _this10 = this;

      this.stopTimer();

      if (this.$route.path !== '/mission-detail') {
        return;
      }
      this.pTm = setInterval(function () {
        _this10.processCore();
      }, this.refresh);
    },
    stopTimer: function stopTimer() {
      clearInterval(this.pTm);
      clearTimeout(this.pTm);
    },
    showBtn: function showBtn(tag, st) {
      var vl = st;

      switch (vl) {
        case '-1':
        case '-2':
        case '-3':
        case '-4':
        case '-5':
        case '-6':
        case '-7':
        case '-8':
        case '-9':
        case '3':
        case '4':
        case '2':
        case '0':
        case '7':
          if (tag === 0) {
            return 1;
          } else if (tag === 4) {
            if (vl === '-1' || vl === '-2' || vl === '-5') {
              return 1;
            } else {
              return 0;
            }
          } else {
            return 0;
          }
          break;
        case '1':
          if (tag === 1 || tag === 3) {
            return 1;
          } else {
            return 0;
          }
          break;
        case '6':
          if (tag === 2) {
            return 1;
          } else {
            return 0;
          }
          break;
      }
    },
    delRow: function delRow(row) {
      var _this11 = this;

      this.$showConfirm('', this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warnning', function () {
        var id = row.id;
        _this11.loading = 1;
        _this11.$pushDelTask(id, function (res) {
          _this11.loading = 0;
          if (res.status === 200) {
            _this11.getList();
          } else {
            _this11.$message.error(res.message);
          }
        }, function () {
          _this11.loading = 0;
        });
      });
    },
    pageSelect: function pageSelect(index) {
      this.index = index;
      this.getList();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getCmDv();
    },
    pageDvSelect: function pageDvSelect(index) {
      this.page = index;
      this.getCmDv();
    },
    pageDvSized: function pageDvSized(val) {
      this.$gRow = val;
      this.getList();
    },
    getList: function getList() {
      var _this12 = this;

      var tNameVl = this.tName ? this.tName : '';
      var statusVl = this.statusVl ? this.statusVl : '';
      var content = this.tContent ? this.tContent : '';
      this.loading = 1;

      this.$pushTaskDetail(tNameVl, statusVl, this.index, this.$gRow, this.info.taskId, function (res) {
        _this12.loading = 0;
        if (res.status === 200) {
          _this12.tableData = res.data;
          _this12.total = res.total;
          _this12.updateTimer();
        } else {
          _this12.$message.error(res.message);
        }
      }, function () {
        _this12.loading = 0;
      });
    },
    getDetail: function getDetail() {
      var _this13 = this;

      this.loading = true;
      this.$pushFileDetail(this.info.fileId, this.info.taskType, function (res) {
        _this13.loading = false;
        if (res.status === 200) {
          _this13.detail = res.data;
        } else {
          _this13.$message.error(res.message);
        }
      }, function () {
        _this13.loading = false;
      });
    }
  },
  mounted: function mounted() {
    this.info = this.$getWObj().missionInfo;
    console.log('info', this.info);

    this.getCmDv();

    this.getList();
    this.getDetail();
  },
  destroyed: function destroyed() {
    this.stopTimer();
  }
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_tyc_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_tyc_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_global_tyc_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    TemplateName: __WEBPACK_IMPORTED_MODULE_1__global_mechanism_selector_vue___default.a,
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default.a,
    tyc: __WEBPACK_IMPORTED_MODULE_2__components_global_tyc_vue___default.a
  },
  data: function data() {
    var that = this;
    return {
      tqobj: '',
      mechanismData: {
        callback: function callback(value) {
          that.mech = value;
          that.selectChange(value);
        }
      },
      mechs: [],
      taskType: '',
      name: '',
      page: 1,
      row: this.$gRow,
      total: 0,
      dialogFormVisible: 0,
      tableData: [],
      loading: 0,
      editData: '',
      userId: '',
      missionName: '',
      mech: '',
      gBase: [],
      gSub: [],
      missionNames: '',
      missionList: '',
      selectedMissionType: ""
    };
  },

  computed: {
    index: function index() {
      return this.$getWPage('missionListPage');
    }
  },
  methods: {
    cancelPush: function cancelPush(row) {
      var _this2 = this;

      this.$showConfirm('', this.$t('app_iscancelPush'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this2.loading = 1;
        _this2.$pushDownCtrl(row.taskId, '', '3', '', function (res) {
          _this2.loading = 0;
          if (res.status === 200) {
            _this2.$message.success(res.message);
            _this2.getList();
          } else {
            _this2.$message.error(res.message);
          }
        }, function () {
          _this2.loading = 0;
        });
      });
    },
    viewDetail: function viewDetail(row) {
      this.$setWObj('missionInfo', row);
      this.$router.push({ path: "mission-detail" });
    },
    selectChange: function selectChange(vl) {
      this.mech = vl;
      this.getList();
    },
    query: function query() {
      console.log("selected type is " + this.missionName);
      this.getList();
    },
    cellClick: function cellClick(row, ev, col) {
      if (col.label && col.label === this.$t('app_operate')) {
        return;
      }

      this.$setWObj('missionInfo', row);
      this.$router.push({ path: "mission-detail" });
    },
    edit: function edit(row) {
      this.editData = row;
      this.dialogFormVisible = 1;
    },
    del: function del(row) {
      var _this3 = this;

      this.$showConfirm('', this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        var id = row.appClassifyId;
        _this3.loading = 1;
        _this3.$delAppType(id, function (res) {
          _this3.loading = 0;
          if (res.status === 200) {
            _this3.getList();
          } else {
            _this3.$message.error(res.message);
          }
        }, function () {
          _this3.loading = 0;
        });
      });
    },
    pageSelect: function pageSelect(index) {
      this.page = index;
      this.getList();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getList();
    },
    open: function open() {
      if (this.editData) {
        this.name = this.editData.appClassifyName;
      }
    },
    close: function close() {
      this.editData = '';
      this.name = '';
    },
    showInput: function showInput() {
      this.dialogFormVisible = 1;
    },
    newData: function newData() {
      var _this4 = this;

      var vl = this.name;
      if (vl) {
        this.loading = 1;
        this.$addAppType(vl, function (res) {
          _this4.loading = 0;

          if (res.status === 200) {
            _this4.getList();
          } else {
            _this4.$message.error(res.message);
          }
        }, function () {
          _this4.loading = 0;
        });
        this.dialogFormVisible = 0;
      } else {
        this.$message.error(this.$t('app_inputAName'));
      }
    },
    editRqs: function editRqs() {
      var _this5 = this;

      var vl = this.name;
      if (vl) {
        this.loading = 1;
        this.$editAppType(this.editData.appClassifyId, vl, function (res) {
          _this5.loading = 0;
          if (res.status === 200) {
            _this5.getList();
          } else {
            _this5.$message.error(res.message);
          }
        }, function () {
          _this5.loading = 0;
        });
        this.dialogFormVisible = 0;
      } else {
        this.$message.error(this.$t('app_inputAName'));
      }
    },
    sure: function sure() {
      if (this.editData) {
        this.editRqs();
      } else {
        this.newData();
      }
    },
    getList: function getList() {
      var _this6 = this;

      this.loading = 1;
      var mId = this.mech ? this.mech : '';
      var type = this.taskType ? this.taskType : '';
      var mName = this.missionName != "0" ? this.missionName : '';

      this.$pushList(this.page, this.$gRow, type, mName, function (res) {
        console.log('res', res);
        _this6.loading = 0;
        if (res.status === 200) {
          console.log('data', res.data);
          _this6.tableData = res.data;
          _this6.total = res.total;
        } else {
          _this6.$message.error(res.message);
        }
      }, function () {
        _this6.loading = 0;
      });
    }
  },
  mounted: function mounted() {

    var _this = this;
    this.tqobj = {
      keys: ['taskType', 'taskTypeArr'],
      callback: function callback(data) {
        _this.missionNames = data[0];
        _this.missionList = data[1];
      }
    };

    var user = localStorage['userId'];
    this.userId = user;
    this.getList();
  }
});

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_df_png__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_df_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_df_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__);


var _methods;




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var that = this;
    return {
      dLoading: false,
      srchValue: '',
      reason: '',
      config: '',
      captures: [],
      sstatus: {
        '0': this.$t('app_new'),
        '1': this.$t('app_on'),
        '2': this.$t('app_sleep'),
        '3': this.$t('app_fault')
      },
      sstatusAr: [{ vl: '', lb: this.$t('app_all') }, { vl: '0', lb: this.$t('app_new') }, { vl: '1', lb: this.$t('app_on') }, { vl: '2', lb: this.$t('app_sleep') }, { vl: '3', lb: this.$t('app_fault') }],
      loading: 0,
      dialogVisible: false,
      notPassDialog: false,
      index: 1,
      tableData: [],
      total: 0,
      status: '',
      tags: [],
      mech: '',
      stModel: [{ label: this.$t('app_online'), vl: '1' }, { label: this.$t('app_offline'), vl: '2' }, { label: this.$t('app_sleep'), vl: '3' }],
      mechanismData: {
        callback: function callback(value) {
          that.mech = value;
          that.selectChange(value);
        }
      }
    };
  },

  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default.a
  },
  computed: {
    showUploadNew: function showUploadNew() {
      console.log('ccc', this.config.data);
      if (this.config.data) {
        if (this.config.data.isoperation === 0 && this.config.data.appStatus === '2') {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  methods: (_methods = {
    push: function push() {
      this.$setWObj('pushList', { data: this.config, type: '14' });

      this.$router.push({ path: '/non-it-eq/app/detail/push' });
    },
    downf: function downf() {
      window.open(this.$host + this.config.url);
    },
    setSt: function setSt(row) {
      return this.sstatus[row.terminalStatus];
    },
    bindOperate: function bindOperate(row) {
      var _this = this;

      this.dLoading = 1;
      this.$asTestPush(this.config.id, row.terminalNo, function (res) {
        _this.dLoading = 0;
        if (res.status === 200) {
          _this.$message.success(_this.$t('app_tipViewTask'));
          _this.notPassDialog = false;
        } else {
          _this.$message.error(res.message);
        }
      }, function (error) {
        _this.dLoading = 0;
        _this.$message.error(_this.$t('app_rqsError'));
      });
    },
    verify: function verify(vl) {
      var _this2 = this;

      if (vl === '2') {
        this.$confirm(this.$t('app_srpassvf') + '?', this.$t('app_tip'), {
          confirmButtonText: this.$t('app_sure'),
          cancelButtonText: this.$t('app_cancel'),
          type: 'warning'
        }).then(function () {
          _this2.verifyRqs(vl);
        }).catch(function () {});
      } else if (vl === '3') {
        this.notPassDialog = true;
      }
    },
    verifyRqs: function verifyRqs(vl) {
      var _this3 = this;

      this.loading = 1;
      this.$assubmit(this.config.id, this.reason, vl, function (res) {
        _this3.loading = 0;
        if (res.status === 200) {
          _this3.$message.success(res.message);
          _this3.$router.go(-1);
        } else {
          _this3.$message.error(res.message);
        }
      }, function () {
        _this3.$message.error(_this3.$t('app_rqsError'));
        _this3.loading = 0;
      });
    },
    srchDevice: function srchDevice() {
      this.getDevices();
    },
    selectChange: function selectChange(vl) {
      this.getDevices();
    },
    pageSelect: function pageSelect(index) {
      this.index = index;
      this.getDevices();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getDevices();
    },
    getDevices: function getDevices() {
      var _this4 = this;

      var vl = this.srchValue ? this.srchValue : '';

      var status = this.status ? this.status : '';
      var mc = this.mech;

      this.loading = 1;
      this.$getNonItDv(this.index, this.$gRow, mc, '', status, '', '', '', '', '', function (res) {
        console.log('dv', res);
        _this4.loading = 0;
        if (res.data) {
          _this4.tableData = res.data;
          _this4.total = res.total;
        }
      }, function () {
        _this4.loading = 0;
      });
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD hh:mm:ss');
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'selectChange', function selectChange(vl) {
    this.getDevices();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'pageSelect', function pageSelect(index) {
    this.index = index;
    this.getDevices();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'pageSized', function pageSized(val) {
    this.$gRow = val;
    this.getDevices();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'deleteAppHis', function deleteAppHis(row) {
    var _this5 = this;

    if (row.applicationid) {
      this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
        confirmButtonText: this.$t('app_sure'),
        cancelButtonText: this.$t('app_cancel'),
        type: 'warning'
      }).then(function () {
        _this5.loading = 1;
        if (_this5.$appUrlTag === 0) {
          _this5.$deleteApp(row.applicationid, function (res) {
            _this5.loading = 0;
            if (res.status === 200) {
              _this5.getAppHistory();
            } else {
              _this5.$message.error(res.message);
            }
          }, function () {
            _this5.loading = 0;
          });
        } else {
          _this5.$deleteAppHis(row.applicationid, function (res) {
            _this5.loading = 0;
            if (res.status === 200) {
              _this5.getAppHistory();
            } else {
              _this5.$message.error(res.message);
            }
          }, function () {
            _this5.loading = 0;
          });
        }
      }).catch(function () {});
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'imgFullUrl', function imgFullUrl(path) {
    if (path) {
      return this.$urls.prefix + path;
    } else {
      return '';
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'getAppHistory', function getAppHistory() {
    var _this6 = this;

    if (!this.config.data.appName) {
      return;
    }

    this.loading = 1;
    if (this.$appUrlTag === 0) {
      this.$getAppHistory(this.config.data.appName, this.config.data.packagename, function (res) {
        _this6.loading = 0;
        if (res.status === 200) {
          _this6.tableData = res.data;
        } else {
          _this6.$message.error(res.message);
        }
      }, function () {
        _this6.loading = 0;
      });
    } else {

      this.$getAppHistory1(localStorage.mechanismId, this.config.data.packagename, function (res) {

        console.log('his', res);
        _this6.loading = 0;
        if (res.status === 200) {
          _this6.tableData = res.data;
        } else {
          _this6.$message.error(res.message);
        }
      }, function () {
        _this6.loading = 0;
      });
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'uploadNew', function uploadNew() {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'init', function init() {
    this.config = this.$getWObj().nappObj;
    console.log(this.$route, this.config);
  }), _methods),
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_tyc_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_tyc_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_tyc_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default.a,
    tyc: __WEBPACK_IMPORTED_MODULE_3__components_global_tyc_vue___default.a
  },
  data: function data() {
    var _this2 = this;

    var that = this;
    var tagCheck = function tagCheck(rule, value, callback) {
      if (!value) {
        callback(new Error(_this2.$t('noVerTag')));
      } else {
        callback();
      }
    };
    var versionCheck = function versionCheck(rule, value, callback) {

      if (_this2.udFileType == 0 && rule.field == 'preVersion') {
        callback();
        return;
      }

      var rg = /^\d+(\.\d+)+$/;
      if (!rg.test(value)) {
        callback(new Error(_this2.$t('lin_global.bbhgsbd')));
      } else {
        callback();
      }
    };
    return {
      tqobj: '',
      mechanismData: {
        callback: function callback(value) {

          that.form.mech = value;
          that.selectChange(value);
        }
      },
      action: '' + __WEBPACK_IMPORTED_MODULE_2__api_url__["b" /* urlAssets */].fileUrl,
      ulinfo: {
        tip: this.$t('app_ulNormalSt'),
        index: 0,
        icons: ['el-icon-upload', 'el-icon-circle-check', 'el-icon-close']
      },
      mechanismId: window.localStorage['mechanismId'],
      status: '',
      tipColor: { color: '#13CE66' },
      stModel: [{ label: this.$t('app_online'), vl: '1' }, { label: this.$t('app_offline'), vl: '2' }, { label: this.$t('app_new'), vl: '0' }],
      channels: [],
      cmtypes: [],
      isbase: false,
      sftypes1: [],
      sftypes2: [],
      sftypes3: [],
      sftypes5: [],
      sftypes6: [],
      sftypes7: [],
      sftypes9: [],
      sftypes10: [],
      updateType: false,
      ftypes: '',
      ftail: {
        '1': ['zip'],
        '2': ['kos', 'hex', 'ksp'],
        '3': ['zip', 'img', 'png'],
        '5': ['cfg'],
        '6': [],
        '9': ['zimge', 'gz', 'fls', 'lod', 'bin']
      },
      channelId: '',
      rules: {
        name: [{ required: true, message: this.$t('app_input'), trigger: 'blur' }],
        desc: [{ required: true, message: this.$t('app_input'), trigger: 'blur' }],
        ftype: [{ required: true, message: this.$t('app_select'), trigger: 'blur' }],
        stype: [{ required: true, message: this.$t('app_input'), trigger: 'blur' }],
        mech: [{ required: true, message: this.$t('app_select'), trigger: 'blur' }],
        url: [{ required: true, message: this.$t('app_select'), trigger: 'blur' }],
        ver: [{ required: true, message: this.$t('lin_global.verTips1'), trigger: 'blur', validator: versionCheck }],
        bver: [{ required: true, message: this.$t('lin_global.verTips1'), trigger: 'blur', validator: versionCheck }]
      },
      form: {
        name: '',
        fname: '',
        desc: '',
        ftype: '6',
        stype: '6-1',
        ver: '',
        url: '',
        md5: '',
        size: '',
        mech: '',
        bver: ''
      },
      showPic: { value: 0, data: '' },
      srchValue: '',
      installTypes: [{ label: this.$t('app_autoInstall'), value: 0 }],
      fileSize: 0,
      tableData: [],
      checkDesc: '',
      radio: '1',
      smImageUrl: '',
      bgImageUrl: '',
      dialogVisible: false,
      appTypes: [],
      loading: 0,
      loading1: 0,
      loadingBig: 0,
      loadingSm: 0,
      config: {},

      fileList: [],
      isUpload: 0,
      index: 1,
      total: 0
    };
  },

  computed: {
    isShowUpdateDesc: function isShowUpdateDesc() {
      if (this.config.data) {
        if (this.config.data.updatedesc) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    updateDescContent: function updateDescContent() {
      var vl = this.config.data ? this.config.data.updatedesc : '';

      return vl;
    },
    prdes: function prdes() {
      return this.config.data ? this.config.data.launcherDesc : '';
    },
    uData: function uData() {
      return { token: 1234 };
    },
    imgUploadUrl: function imgUploadUrl() {
      return this.$urls.picUrl;
    },
    fileUploadUrl: function fileUploadUrl() {

      return this.action;
    },
    reason: function reason() {
      if (!this.config.data) {
        return '';
      }
      var rs = this.config.data.auditContent;
      return rs ? this.$t('app_banReason') + ':' + rs : this.$t('app_banReason') + ':' + this.$t('app_noInput');
    },
    isShowReason: function isShowReason() {
      if (this.config) {
        if (this.config.data) {
          if (this.config.data.appStatus === '3') {
            return 1;
          } else {
            return 0;
          }
        } else {
          return 0;
        }
      } else {
        return 0;
      }
    }
  },
  methods: {
    jumpToTool: function jumpToTool() {
      window.open('https://tmsadmin.szzt.com.cn/szzt_utils/#/animationgen');
    },
    sfileTypeChange: function sfileTypeChange(vl) {
      if (vl == '1-1') {
        this.isbase = true;
      } else this.isbase = false;
    },
    fileTypeChange: function fileTypeChange(vl) {
      this.form.stype = '';
      if (!vl) {
        this.cmtypes = '';
      } else {
        this.cmtypes = this['sftypes' + vl];
      }
    },
    lcNew: function lcNew() {
      var _this3 = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this3.loading = 1;
          var form = _this3.form;
          _this3.$updateLauncher(_this3.form.md5, form.launcherName, form.launcherDesc, form.caps, form.appUrl, form.packageName, form.version, form.verTag, _this3.fileSize, _this3.config.data.launcherid, localStorage.mechanismId, function (res) {
            _this3.loading = 0;
            if (res.status === 200) {
              _this3.$message.success(res.message);
              _this3.$router.go(-2);
            } else {
              _this3.$message.error(res.message);
            }
          }, function () {
            _this3.loading = 0;
            _this3.$message(_this3.$t('app_rqsError'));
          });
        } else {
          return false;
        }
      });
    },
    selectChange: function selectChange(vl) {},
    getChannels: function getChannels() {
      var _this4 = this;

      this.$getChannelList(10000, 1, '', '', '', function (res) {
        if (res.status === 200) {
          _this4.channels = res.data;
        } else {
          _this4.$message.error(res.message);
        }
      }, function () {
        _this4.$message.error(_this4.$t('app_rqsError'));
      });
    },
    getStatus: function getStatus(value) {
      switch (value) {
        case '0':
          return this.$t('app_prePushVerify');
        case '1':
          return this.$t('app_preVerify');
        case '2':
          return this.$t('app_verifyPass');
        case '3':
          return this.$t('app_verifyNotPass');
      }
    },
    pageSelect: function pageSelect(index) {
      this.index = index;
      this.getDevices();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getDevices();
    },
    hBlur: function hBlur(name) {
      this.$refs[name].validate(function (valid) {
        if (valid) {} else {
          return false;
        }
      });
    },
    showBigPic: function showBigPic() {
      this.showPic = { value: 1, data: this.imgFullUrl(this.config.data.appBigIcon) };
    },
    showScreenShot: function showScreenShot(path) {
      this.showPic = { value: 1, data: this.imgFullUrl(path) };
    },
    pushInstall: function pushInstall() {
      this.dialogVisible = true;
    },
    makeAppPath: function makeAppPath(url) {
      var path = url;
      if (!path) {
        if (this.config.data) {
          path = this.config.data.appUrl;
          if (!path) {
            return '';
          }
        } else {
          return '';
        }
      }
      var arr = path.split('/');
      return arr[arr.length - 1];
    },
    deleteAppHis: function deleteAppHis(row) {
      var _this5 = this;

      if (row.applicationid) {
        this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
          confirmButtonText: this.$t('app_sure'),
          cancelButtonText: this.$t('app_cancel'),
          type: 'warning'
        }).then(function () {
          _this5.loading = 1;
          if (_this5.$appUrlTag === 0) {
            _this5.$deleteApp(row.applicationid, function (res) {
              _this5.loading = 0;
              if (res.status === 200) {
                _this5.getAppHistory();
              } else {
                _this5.$message.error(res.message);
              }
            }, function () {
              _this5.loading = 0;
            });
          } else {
            _this5.$deleteApp1(row.applicationid, function (res) {
              _this5.loading = 0;
              if (res.status === 200) {
                _this5.getAppHistory();
              } else {
                _this5.$message.error(res.message);
              }
            }, function () {
              _this5.loading = 0;
            });
          }
        }).catch(function () {});
      }
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD hh:mm:ss');
    },
    deleteCapture0: function deleteCapture0() {
      this.cp0 = '';
      this.cp0Value = '';
    },
    deleteCapture1: function deleteCapture1() {
      this.cp1 = '';
      this.cp1Value = '';
    },
    deleteCapture2: function deleteCapture2() {
      this.cp2 = '';
      this.cp2Value = '';
    },
    deleteCapture3: function deleteCapture3() {
      this.cp3 = '';
      this.cp3Value = '';
    },
    deleteCapture4: function deleteCapture4() {
      this.cp4 = '';
      this.cp4Value = '';
    },
    imgFullUrl: function imgFullUrl(path) {
      if (path) {
        return this.$urls.prefix + path;
      } else {
        return '';
      }
    },
    close: function close() {
      this.$router.go(-1);
    },
    isShowCommon: function isShowCommon(isShow) {
      if (isShow && (this.config.type === 2 || this.config.type === 3)) {
        return 1;
      } else if (!isShow && this.config.type !== 2 && this.config.type !== 3) {
        return 1;
      } else {
        return 0;
      }
    },
    tipBf: function tipBf() {
      this.loading1 = 1;
      return 1;
    },
    handleSmAvatarSuccess: function handleSmAvatarSuccess(res, file) {
      this.loadingSm = 0;
      if (res.status !== 200) {
        this.$message.error(res.message);
      } else {
        this.form.smImageUrlValue = res.data;
        this.smImageUrl = URL.createObjectURL(file.raw);
        this.hBlur('form');
      }
    },
    handleBgAvatarSuccess: function handleBgAvatarSuccess(res, file) {
      this.loadingBig = 0;
      if (res.status !== 200) {
        this.$message.error(res.message);
      } else {
        this.form.bgImageUrlValue = res.data;
        this.bgImageUrl = URL.createObjectURL(file.raw);
        this.hBlur('form');
      }
    },
    handleAvatarSuccessCp0: function handleAvatarSuccessCp0(res, file) {
      this.loading1 = 0;

      if (res.status !== 200) {
        this.$message.error(res.message);
      } else {
        this.cp0Value = res.data;
        this.cp0 = URL.createObjectURL(file.raw);
        this.hBlur('form');
      }
    },
    handleAvatarSuccessCp1: function handleAvatarSuccessCp1(res, file) {
      this.loading1 = 0;
      if (res.status !== 200) {
        this.$message.error(res.message);
      } else {
        this.cp1Value = res.data;
        this.cp1 = URL.createObjectURL(file.raw);
        this.hBlur('form');
      }
    },
    handleAvatarSuccessCp2: function handleAvatarSuccessCp2(res, file) {
      this.loading1 = 0;
      if (res.status !== 200) {
        this.$message.error(res.message);
      } else {
        this.cp2Value = res.data;
        this.cp2 = URL.createObjectURL(file.raw);
        this.hBlur('form');
      }
    },
    handleAvatarSuccessCp3: function handleAvatarSuccessCp3(res, file) {
      this.loading1 = 0;
      if (res.status !== 200) {
        this.$message.error(res.message);
      } else {
        this.cp3Value = res.data;
        this.cp3 = URL.createObjectURL(file.raw);
        this.hBlur('form');
      }
    },
    handleAvatarSuccessCp4: function handleAvatarSuccessCp4(res, file) {
      this.loading1 = 0;
      if (res.status !== 200) {
        this.$message.error(res.message);
      } else {
        this.cp4Value = res.data;
        this.cp4 = URL.createObjectURL(file.raw);
        this.hBlur('form');
      }
    },
    beforeSmAvatarUpload: function beforeSmAvatarUpload(file) {
      var size = file.size / 1024;
      if (size > 100) {
        this.$message.error(this.$t('app_fileOver') + '100k');
        return false;
      }
      this.loadingSm = 1;
      return true;
    },
    beforeBgAvatarUpload: function beforeBgAvatarUpload(file) {
      var size = file.size / 1024;
      if (size > 200) {
        this.$message.error(this.$t('app_fileOver') + '200k');
        return false;
      }
      this.loadingBig = 1;
      return true;
    },
    handleRemove: function handleRemove(file, fileList) {},
    uploadApp: function uploadApp(formName) {
      var _this6 = this;

      if (window[this.$route.path]) {
        this.$message.error(this.$t('app_appLoding'));
        return;
      }

      this.$refs[formName].validate(function (valid) {
        if (valid) {

          if (_this6.form.ftype == 6) {
            if (_this6.form.ver) {
              var rg = /^\d+(\.\d+)+$/;
              if (!rg.test(_this6.form.ver)) {
                _this6.$message.error(_this6.$t('lin_global.bbhgsbd'));
                return;
              }
            } else {
              _this6.$message.error(_this6.$t('app_inputCp'));
              return;
            }
          }

          if (_this6.form.stype == '1-1') {
            if (_this6.form.bver) {
              var rg = /^\d+(\.\d+)+$/;
              if (!rg.test(_this6.form.bver)) {
                _this6.$message.error(_this6.$t('lin_global.bbhgsbd'));
                return;
              }
            } else {
              _this6.$message.error(_this6.$t('app_inputCp'));
              return;
            }
          }

          if (_this6.form.ftype != 5 && _this6.form.ftype != 7 && _this6.form.ftype != 4) {
            if (!_this6.form.stype && _this6.form.ftype) {
              _this6.$message.error(_this6.$t('app_plsstype'));
            }
          }

          _this6.loading = 1;
          if (_this6.config.type === 1) {
            _this6.$editFile(_this6.config.data.fileId, _this6.form.name, _this6.form.ver, _this6.form.md5, _this6.form.size, _this6.form.url, _this6.form.ftype, _this6.form.stype, _this6.form.bver, _this6.form.mech, _this6.form.desc, function (res) {
              _this6.loading = 0;
              if (res.status === 200) {
                _this6.$message.success(res.message);
                _this6.$router.go(-1);
              } else {
                _this6.$message(res.message);
              }
            }, function () {
              _this6.loading = 0;
              _this6.$message(_this6.$t('app_rqsError'));
            });
          } else {
            _this6.$addFile(_this6.form.name, _this6.form.ver, _this6.form.md5, _this6.form.size, _this6.form.url, _this6.form.ftype, _this6.form.stype, _this6.form.bver, _this6.form.mech, _this6.form.desc, function (res) {
              _this6.loading = 0;
              if (res.status === 200) {
                _this6.$message.success(res.message);
                _this6.$router.go(-1);
              } else {
                _this6.$message.error(res.message);
              }
            }, function () {
              _this6.loading = 0;
              _this6.$message(_this6.$t('app_rqsError'));
            });
          }
        } else {
          return false;
        }
      });
    },
    fileUploadSuccess: function fileUploadSuccess(res, file) {
      window[this.$route.path] = '';
      console.log('file', res);
      this.ulinfo.tip = res.message;
      if (res.status === 200) {

        this.form.fname = file.name;
        this.form.url = res.fileUrl;
        this.form.size = res.appSize;
        this.form.md5 = res.md5;

        this.fileList = [{ name: file.name }];
        this.hBlur('form');
        this.ulinfo.index = 1;
        this.tipColor = { color: '#13CE66' };
      } else {
        this.ulinfo.index = 2;
        if (this.config.type !== 1) {
          this.fileList = [{}];
        } else {
          this.fileList = [{ name: this.makeAppPath(this.config.data.appUrl) }];
          this.fileList = [];
        }
        this.$message.error(res.message);
        this.tipColor = { color: '#FF4949' };
      }
    },
    fileBeforeUpload: function fileBeforeUpload(file) {

      console.log(file, this.form);
      var tail = file.name.split('.').pop();

      if (this.form.ftype && file) {
        var is = false;

        var tails = this.ftail[this.form.ftype];
        tails.forEach(function (vl) {
          if (vl == tail) is = true;
        });
        if (!is && tails.length > 0) {
          this.$message.error(this.$t('app_spfileis') + this.ftail[this.form.ftype].toString());
          return false;
        }
      } else {

        this.$message.error(this.$t('app_plsltype'));
        return false;
      }

      window[this.$route.path] = 1;
      var ar = file.name.split('.');
      var type = ar[ar.length - 1];
    },
    fillEdit: function fillEdit() {
      var data = this.config.data;
      this.form.name = data.fileName;
      this.form.desc = data.memo;
      this.form.ftype = data.fileType;
      this.form.ver = data.fileVersion;
      this.form.bver = data.param1;
      this.form.url = data.fileUrl;
      this.form.md5 = data.hashCode;
      this.form.size = data.fileSize;
      this.form.mech = data.mechId;
      this.mechanismData.value = data.mechId;

      this.cmtypes = this['sftypes' + data.fileType];
      console.log('pts', this.cmtypes);
      var ffname = data.fileUrl ? data.fileUrl.split('/').pop() : '';
      this.fileList = [{ name: ffname }];
      this.form.fname = ffname;

      var _this = this;
      setTimeout(function () {
        _this.form.stype = data.subFileType;
      }, 800);

      this.ulinfo.index = 1;
    },
    getTypeList: function getTypeList() {
      var _this7 = this;

      this.$getAppTypeList(100000000, 1, function (res) {
        if (res.status === 200) {
          console.log(res);
          _this7.appTypes = res.data;
        } else {
          _this7.$message(res.message);
        }
      }, '');
    },
    cancel: function cancel() {
      this.$router.go(-1);
    },
    verify: function verify() {
      var _this8 = this;

      this.loading = 1;
      var id = this.config.data.applicationid;
      var passValue = this.radio === '1' ? '2' : '3';
      var desc = this.checkDesc;
      if (this.$appUrlTag === 0) {
        this.$verifyApp(localStorage.user, id, passValue, desc, function (res) {
          _this8.loading = 0;
          if (res.status === 200) {
            _this8.$router.go(-1);
          } else {
            _this8.$message.error(res.message);
          }
        }, function () {
          _this8.loading = 0;
          _this8.$message.error(_this8.$t('app_rqsError'));
        });
      } else {
        this.$verifyApp1(this.mechanismId, localStorage.user, id, passValue, desc, function (res) {
          _this8.loading = 0;
          if (res.status === 200) {
            _this8.$router.go(-1);
          } else {
            _this8.$message.error(res.message);
          }
        }, function () {
          _this8.loading = 0;
          _this8.$message.error(_this8.$t('app_rqsError'));
        });
      }
    },
    getAppHistory: function getAppHistory() {
      var _this9 = this;

      if (!this.config.data.launcherName) {
        return;
      }
      console.log('pkg', this.config.data);
      this.loading = 1;
      if (this.$appUrlTag === 0) {
        this.$getAppHistory(this.config.data.launcherName, this.config.data.packagename, function (res) {
          console.log('reslist', res);
          _this9.loading = 0;
          if (res.status === 200) {
            _this9.tableData = res.data;
          } else {
            _this9.$message.error(res.message);
          }
        }, function () {
          _this9.loading = 0;
        });
      } else {
        this.$getAppHistory1(this.mechanismId, this.config.data.packagename, function (res) {
          console.log('reslist', res);
          _this9.loading = 0;
          if (res.status === 200) {
            _this9.tableData = res.data;
          } else {
            _this9.$message.error(res.message);
          }
        }, function () {
          _this9.loading = 0;
        });
      }
    },
    uploadNew: function uploadNew() {},
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    },
    init: function init() {
      this.config = this.$getWObj().fileEdit;
      console.log('config', this.config);

      switch (this.config.type) {
        case 0:
          break;
        case 1:
          this.fillEdit();
          break;
        case 2:
          break;
      }
    },
    getDevices: function getDevices() {
      var _this10 = this;

      var vl = this.srchValue ? this.srchValue : '';
      var channel = this.channelId ? this.channelId : '';
      var status = this.status ? this.status : '';
      this.loading = 1;
      if (this.$appUrlTag === 0) {
        this.$getDevices(this.index, this.$gRow, channel, vl, status, '', this.config.data.applicationid, function (res) {
          console.log('dv', res);
          _this10.loading = 0;
          if (res.data) {
            _this10.tableData = res.data;
            _this10.total = res.total;
          }
        }, function () {
          _this10.loading = 0;
        });
      } else {
        this.$getDevices1(this.index, this.$gRow, localStorage.mechanismId, vl, status, '', this.config.data.applicationid, function (res) {
          console.log('dv', res);
          _this10.loading = 0;
          if (res.data) {
            _this10.tableData = res.data;
            _this10.total = res.total;
          }
        }, function () {
          _this10.loading = 0;
        });
      }
    },
    bindOperate: function bindOperate(row) {
      this.bind(row.terminalId, row.terminalNo);
    },
    bind: function bind(tId, tNo) {
      var _this11 = this;

      this.loading = 1;
      if (this.$appUrlTag === 0) {
        this.$bindApp('0', tId, this.config.data.applicationid, function (res) {
          if (res.status === 200) {
            _this11.$message.success(_this11.$t('app_tipViewTask'));
          } else {
            _this11.$message.error(res.message);
          }
          _this11.loading = 0;
        }, function () {
          _this11.loading = 0;
        });
      } else {
        this.$verifyAppPush(localStorage.mechanismId, tNo, this.config.data.applicationid, function (res) {
          if (res.status === 200) {
            _this11.$message.success(_this11.$t('app_tipViewTask'));
          } else {
            _this11.$message.error(res.message);
          }
          _this11.loading = 0;
        }, function () {
          _this11.loading = 0;
        });
      }
    },
    srchDevice: function srchDevice() {
      this.getDevices();
    }
  },
  mounted: function mounted() {
    var _this12 = this;

    this.tqobj = {
      keys: ['ftypes', 'sftypes1', 'sftypes2', 'sftypes3', 'sftypes4', 'sftypes5', 'sftypes6', 'sftypes7', 'sftypes9'],
      callback: function callback(data) {
        _this12.ftypes = data[0];
        _this12.sftypes1 = data[1];
        _this12.sftypes2 = data[2];
        _this12.sftypes3 = data[3];
        _this12.sftypes4 = data[4];
        _this12.sftypes5 = data[5];
        _this12.sftypes6 = data[6];
        _this12.sftypes7 = data[7];
        _this12.sftypes9 = data[8];
      }
    };
    this.init();
  }
});

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_tyc_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_tyc_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_global_tyc_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var that = this;
    return {
      tqobj: '',
      mechanismData: {
        callback: function callback(value) {
          that.selectChange(value);
        }
      },
      listKey: 'launch-list',
      cerDialogVisible: false,
      cerTipDialogVisible: false,
      dvLoading: 0,
      index: 1,
      appId: '',
      stModel: [{ label: this.$t('app_online'), vl: '1' }, { label: this.$t('app_offline'), vl: '2' }, { label: this.$t('app_new'), vl: '0' }],
      channels: [],
      cmsts: [],
      srchValue: '',
      channelId: '',
      cerTipMsg: '',
      status: '',
      dvIndex: 1,
      ftype: '',
      sftype: '',
      dialogVisible: 0,
      mechanismId: window.localStorage['mechanismId'],
      selectMid: '',
      tableData: [],
      dvTableData: [],
      appTypes: [],
      appTypeValue: '',
      appStatus: [{ label: this.$t('app_prePushVerify'), value: '0' }, { label: this.$t('app_preVerify'), value: '1' }, { label: this.$t('app_verifyPass'), value: '2' }, { label: this.$t('app_verifyNotPass'), value: '3' }],
      appStatusValue: '',
      total: 0,
      dvTotal: 0,
      loading: 0,
      appType: '',
      queryKey: '',
      ftypes: '',
      getftype: '',
      sftypes1: [],
      sftypes2: [],
      sftypes3: [],
      sftypes5: [],
      sftypes6: [],
      sftypes7: [],
      sftypes9: [],
      sftypes10: [],
      getsftype: ''
    };
  },

  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default.a,
    tyc: __WEBPACK_IMPORTED_MODULE_2__components_global_tyc_vue___default.a
  },
  computed: {
    index: function index() {
      var vl = this.$getWPage(this.listKey);
      return vl ? vl : 1;
    },
    getDvStatus: function getDvStatus(value) {
      switch (value) {
        case '0':
          return this.$t('app_prePushVerify');
        case '1':
          return this.$t('app_preVerify');
        case '2':
          return this.$t('app_verifyPass');
        case '3':
          return this.$t('app_verifyNotPass');
      }
    }
  },
  methods: {
    fileTypeChange: function fileTypeChange(vl) {
      this.sftype = '';
      if (!vl) {
        this.cmsts = '';
      } else this.cmsts = this['sftypes' + vl];
      this.getList();
    },
    setft: function setft(row) {
      return this.getftype[row.fileType];
    },
    setsbt: function setsbt(row) {

      var vl = this.getsftype[row.subFileType];

      return vl;
    },
    pushCreateCer: function pushCreateCer() {
      this.$router.push({ path: "/certificate/new" });
    },
    pushUploadCer: function pushUploadCer() {
      this.$router.push({ path: "/certificate/upload" });
    },
    bindOperate: function bindOperate(row) {
      var _this = this;

      this.dvLoading = 1;
      if (this.$appUrlTag === 0) {
        this.$bindApp('0', row.terminalNo, this.appId, function (res) {
          if (res.status === 200) {
            _this.$message.success(_this.$t('app_tipViewTask'));
          } else {
            _this.$message.error(res.message);
          }
          _this.dvLoading = 0;
        }, function () {
          _this.dvLoading = 0;
        });
      } else {
        this.$bindApp1(localStorage.mechanismId, row.terminalNo, this.appId, function (res) {
          if (res.status === 200) {
            _this.$message.success(_this.$t('app_tipViewTask'));
          } else {
            _this.$message.error(res.message);
          }
          _this.dvLoading = 0;
        }, function () {
          _this.dvLoading = 0;
        });
      }
    },
    getChannels: function getChannels() {
      var _this2 = this;

      this.$getChannelList(10000, 1, '', '', '', function (res) {
        if (res.status === 200) {
          _this2.channels = res.data;
        } else {
          _this2.$message.error(res.message);
        }
      }, function () {
        _this2.$message.error(_this2.$t('app_rqsError'));
      });
    },
    getStatus: function getStatus(value) {
      if (!value) return '';
      switch (value) {
        case '0':
          return { vl: this.$t('app_prePushVerify'), style: 'color:#8492A6;' };
        case '1':
          return { vl: this.$t('app_preVerify'), style: 'color:#F7BA2A;' };
        case '2':
          return { vl: this.$t('app_verifyPass'), style: 'color:#13CE66;' };
        case '3':
          return { vl: this.$t('app_verifyNotPass'), style: 'color:#FF4949;' };
      }
    },
    srchDevice: function srchDevice() {
      this.getDevices();
    },
    selectDvChange: function selectDvChange(vl) {
      this.getDevices();
    },
    pageDvSized: function pageDvSized(val) {
      this.$gRow = val;
      this.getDevices();
    },
    getDevices: function getDevices() {
      var _this3 = this;

      var vl = this.srchValue ? this.srchValue : '';
      var channel = this.channelId ? this.channelId : '';
      var status = this.status ? this.status : '';
      var appId = this.appId ? this.appId : '';
      this.dvLoading = 1;
      if (this.$appUrlTag === 0) {
        this.$getDevices(this.dvIndex, this.$gRow, channel, vl, status, '', appId, function (res) {
          _this3.dvLoading = 0;
          if (res.data) {
            _this3.dvTableData = res.data;
            _this3.dvTotal = res.total;
          }
        }, function () {
          _this3.dvLoading = 0;
        });
      } else {

        this.$getDevices1(this.dvIndex, this.$gRow, localStorage.mechanismId, vl, status, '', appId, function (res) {
          console.log('dv', res);
          _this3.dvLoading = 0;
          if (res.data) {
            _this3.dvTableData = res.data;
            _this3.dvTotal = res.total;
          }
        }, function () {
          _this3.dvLoading = 0;
        });
      }
    },
    editApp: function editApp(row) {

      this.$setWObj('fileEdit', { type: 1, data: row });
      this.$router.push({ path: '/non-it-eq/app/edit', query: { data: row } });
    },
    pushApp: function pushApp(row) {
      this.$setWObj('filePush', row);

      this.$router.push({ path: '/non-it-eq/app/push' });
    },
    query: function query() {
      this.getList();
    },
    selectChange: function selectChange(vl) {
      this.selectMid = vl;
      this.getList();
    },
    reset: function reset() {
      this.queryKey = '';
      this.appType = '';
      this.getList();
    },
    pageSelect: function pageSelect(index) {
      this.index = index;
      this.getList();
    },
    pageDvSelect: function pageDvSelect(index) {
      this.dvIndex = index;
      this.getDevices();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getList();
    },
    deleteApp: function deleteApp(obj) {
      var _this4 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        console.log(obj);
        _this4.$delfile(obj.fileId, function (res) {
          if (res.status === 200) {
            _this4.getList();
            _this4.$message.success(res.message);
          } else {
            _this4.$message.error(res.message);
          }
        }, '');
      }, '');
    },
    submitApp: function submitApp(obj) {
      var _this5 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_tipVerify'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this5.loading = 1;
        _this5.$verifyFile(obj.fileId, '', '1', function (res) {
          _this5.loading = 0;
          if (res.status === 200) {
            _this5.getList();
            _this5.$message.success(res.message);
          } else {
            _this5.$message.error(res.message);
          }
        }, function () {
          _this5.loading = 0;
        });
      }, '');
    },
    cellClick: function cellClick(row, ev, col) {
      if (col.label && col.label === this.$t('app_operate')) {
        return;
      }
    },
    jumpToUpload: function jumpToUpload() {

      this.$setWObj('fileEdit', { type: 0 });

      this.$router.push({ path: '/non-it-eq/app/add' });
    },
    getList: function getList() {
      var _this6 = this;

      this.loading = 1;
      var mech = this.selectMid ? this.selectMid : '';
      var name = this.queryKey ? this.queryKey : '';
      var type = '6';
      var stype = '6-1';
      var st = '';

      this.$getfile(this.index, this.$gRow, name, mech, type, stype, st, '', '', function (res) {

        _this6.loading = 0;
        if (res.status === 200) {
          _this6.total = res.total;
          _this6.tableData = res.data;
        } else {
          _this6.$message(res.message);
        }
      }, function () {
        _this6.loading = 0;
        _this6.$message.error(_this6.$t('app_rqsError'));
      });
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD HH:mm:ss');
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    }
  },
  mounted: function mounted() {
    var _this7 = this;

    this.tqobj = {
      keys: ['ftypes', 'ftype', 'sftype', 'sftypes1', 'sftypes2', 'sftypes3', 'sftypes4', 'sftypes5', 'sftypes6', 'sftypes7', 'sftypes9'],
      callback: function callback(data) {
        _this7.ftypes = data[0];
        _this7.getftype = data[1];
        _this7.getsftype = data[2];
        _this7.sftypes1 = data[3];
        _this7.sftypes2 = data[4];
        _this7.sftypes3 = data[5];
        _this7.sftypes4 = data[6];
        _this7.sftypes5 = data[7];
        _this7.sftypes6 = data[8];
        _this7.sftypes7 = data[9];
        _this7.sftypes9 = data[10];
      }
    };

    this.getList();
  },
  destroyed: function destroyed() {}
});

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_df_png__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_df_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_df_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_global_tyc_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_global_tyc_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_global_tyc_vue__);


var _methods;





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var that = this;
    return {
      tqobj: '',
      getftype: '',
      getstype: '',
      dLoading: false,
      srchValue: '',
      reason: '',
      config: '',
      isNon: false,
      captures: [],
      loading: 0,
      dialogVisible: false,
      notPassDialog: false,
      index: 1,
      tableData: [],
      total: 0,
      status: '',
      mech: '',
      stModel: [{ label: this.$t('app_online'), vl: '1' }, { label: this.$t('app_offline'), vl: '2' }, { label: this.$t('app_sleep'), vl: '3' }],
      mechanismData: {
        callback: function callback(value) {
          that.mech = value;
          that.selectChange(value);
        }
      }
    };
  },

  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default.a, tyc: __WEBPACK_IMPORTED_MODULE_4__components_global_tyc_vue___default.a
  },
  computed: {
    showUploadNew: function showUploadNew() {
      console.log('ccc', this.config.data);
      if (this.config.data) {
        if (this.config.data.isoperation === 0 && this.config.data.appStatus === '2') {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  methods: (_methods = {
    openlink: function openlink() {
      window.open(this.$host + this.config.fileUrl);
    },
    bindOperate: function bindOperate(row) {
      var _this = this;

      this.dLoading = 1;
      this.$filePushTest(this.config.fileId, row.terminalNo, function (res) {
        _this.dLoading = 0;
        if (res.status === 200) {
          _this.$message.success(_this.$t('app_tipViewTask'));
          _this.notPassDialog = false;
        } else {
          _this.$message.error(res.message);
        }
      }, function (error) {
        _this.dLoading = 0;
        _this.$message.error(_this.$t('app_rqsError'));
      });
    },
    verify: function verify(vl) {
      var _this2 = this;

      if (vl === '2') {
        this.$confirm(this.$t('app_srpassvf') + '?', this.$t('app_tip'), {
          confirmButtonText: this.$t('app_sure'),
          cancelButtonText: this.$t('app_cancel'),
          type: 'warning'
        }).then(function () {
          _this2.verifyRqs(vl);
        }).catch(function () {});
      } else if (vl === '3') {
        this.notPassDialog = true;
      }
    },
    verifyRqs: function verifyRqs(vl) {
      var _this3 = this;

      this.loading = 1;
      this.$verifyFile(this.config.fileId, this.reason, vl, function (res) {
        _this3.loading = 0;
        if (res.status === 200) {
          _this3.$message.success(res.message);
          _this3.$router.go(-1);
        } else {
          _this3.$message.error(res.message);
        }
      }, function () {
        _this3.$message.error(_this3.$t('app_rqsError'));
        _this3.loading = 0;
      });
    },
    srchDevice: function srchDevice() {
      this.getDevices();
    },
    selectChange: function selectChange(vl) {
      this.getDevices();
    },
    pageSelect: function pageSelect(index) {
      this.index = index;
      this.getDevices();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getDevices();
    },
    getDevices: function getDevices() {
      var _this4 = this;

      var vl = this.srchValue ? this.srchValue : '';
      var channel = this.channelId ? this.channelId : '';
      var status = this.status ? this.status : '';
      var mc = this.mech;
      var fileMechId = '';
      var fileType = '';
      var fileId = '';
      this.loading = 1;
      this.$canPushTer(this.index, this.$gRow, fileMechId, mc, status, vl, fileType, fileId, function (res) {

        _this4.loading = 0;
        if (res.data) {
          _this4.tableData = res.data;
          _this4.total = res.total;
        }
      }, function () {
        _this4.loading = 0;
      });
    },
    getNonDevices: function getNonDevices() {
      var _this5 = this;

      var vl = this.srchValue ? this.srchValue : '';
      var channel = this.channelId ? this.channelId : '';
      var status = this.status ? this.status : '';
      var mc = this.mech;
      this.loading = 1;

      this.$getNonItDv(this.index, this.$gRow, mc, vl, status, '', '', '', '', '', function (res) {

        _this5.loading = 0;
        if (res.data) {
          _this5.tableData = res.data;
          _this5.total = res.total;
        }
      }, function () {
        _this5.loading = 0;
      });
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD hh:mm:ss');
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'selectChange', function selectChange(vl) {
    this.getDevices();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'pageSelect', function pageSelect(index) {
    this.index = index;
    this.getDevices();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'pageSized', function pageSized(val) {
    this.$gRow = val;
    this.getDevices();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'deleteAppHis', function deleteAppHis(row) {
    var _this6 = this;

    if (row.applicationid) {
      this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
        confirmButtonText: this.$t('app_sure'),
        cancelButtonText: this.$t('app_cancel'),
        type: 'warning'
      }).then(function () {
        _this6.loading = 1;
        if (_this6.$appUrlTag === 0) {
          _this6.$deleteApp(row.applicationid, function (res) {
            _this6.loading = 0;
            if (res.status === 200) {
              _this6.getAppHistory();
            } else {
              _this6.$message.error(res.message);
            }
          }, function () {
            _this6.loading = 0;
          });
        } else {
          _this6.$deleteAppHis(row.applicationid, function (res) {
            _this6.loading = 0;
            if (res.status === 200) {
              _this6.getAppHistory();
            } else {
              _this6.$message.error(res.message);
            }
          }, function () {
            _this6.loading = 0;
          });
        }
      }).catch(function () {});
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'imgFullUrl', function imgFullUrl(path) {
    if (path) {
      return this.$urls.prefix + path;
    } else {
      return '';
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'getAppHistory', function getAppHistory() {
    var _this7 = this;

    if (!this.config.data.appName) {
      return;
    }

    this.loading = 1;
    if (this.$appUrlTag === 0) {
      this.$getAppHistory(this.config.data.appName, this.config.data.packagename, function (res) {
        _this7.loading = 0;
        if (res.status === 200) {
          _this7.tableData = res.data;
        } else {
          _this7.$message.error(res.message);
        }
      }, function () {
        _this7.loading = 0;
      });
    } else {

      this.$getAppHistory1(localStorage.mechanismId, this.config.data.packagename, function (res) {

        console.log('his', res);
        _this7.loading = 0;
        if (res.status === 200) {
          _this7.tableData = res.data;
        } else {
          _this7.$message.error(res.message);
        }
      }, function () {
        _this7.loading = 0;
      });
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'uploadNew', function uploadNew() {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'init', function init() {
    this.config = this.$getWObj().fileDetail;
    console.log(this.config);

    switch (this.config.fileType) {
      case '1':
      case '2':
      case '3':
      case '4':
        this.getDevices();

        this.isNon = false;
        break;
      case '6':
        this.isNon = true;
        this.getNonDevices();
        break;
    }
  }), _methods),
  mounted: function mounted() {
    var _this8 = this;

    this.tqobj = {
      keys: ['ftype', 'sftype'],
      callback: function callback(data) {
        _this8.getftype = data[0];
        _this8.getstype = data[1];
      }
    };

    this.init();
  }
});

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_tyc_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_tyc_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_global_tyc_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default.a,
    tyc: __WEBPACK_IMPORTED_MODULE_2__components_global_tyc_vue___default.a
  },

  data: function data() {
    var that = this;
    return {
      tqobj: '',
      mechanismData: {
        callback: function callback(value) {
          that.selectChange(value);
        }
      },
      listKey: 'launch-list',
      cerDialogVisible: false,
      cerTipDialogVisible: false,
      dvLoading: 0,
      appId: '',
      stModel: [{ label: this.$t('app_online'), vl: '1' }, { label: this.$t('app_offline'), vl: '2' }, { label: this.$t('app_new'), vl: '0' }],
      channels: [],
      cmsts: [],
      srchValue: '',
      channelId: '',
      cerTipMsg: '',
      status: '',
      dvIndex: 1,
      ftype: '',
      sftype: '',
      dialogVisible: 0,
      mechanismId: window.localStorage['mechanismId'],
      selectMid: '',
      tableData: [],
      dvTableData: [],
      appTypes: [],
      appTypeValue: '',
      appStatus: [{ label: this.$t('app_prePushVerify'), value: '0' }, { label: this.$t('app_preVerify'), value: '1' }, { label: this.$t('app_verifyPass'), value: '2' }, { label: this.$t('app_verifyNotPass'), value: '3' }],
      appStatusValue: '',
      total: 0,
      dvTotal: 0,
      loading: 0,
      appType: '',
      queryKey: '',
      ftypes: '',
      getftype: '',
      sftypes1: [],
      sftypes2: [],
      sftypes3: [],
      sftypes5: [],
      sftypes6: [],
      sftypes7: [],
      sftypes9: [],
      sftypes10: [],
      getsftype: ''
    };
  },

  computed: {
    index: function index() {
      var vl = this.$getWPage(this.listKey);
      return vl ? vl : 1;
    },
    getDvStatus: function getDvStatus(value) {
      switch (value) {
        case '0':
          return this.$t('app_prePushVerify');
        case '1':
          return this.$t('app_preVerify');
        case '2':
          return this.$t('app_verifyPass');
        case '3':
          return this.$t('app_verifyNotPass');
      }
    }
  },
  methods: {
    fileTypeChange: function fileTypeChange(vl) {
      this.sftype = '';
      if (!vl) {
        this.cmsts = '';
      } else this.cmsts = this['sftypes' + vl];
      this.getList();
    },
    setft: function setft(row) {
      return this.getftype[row.fileType];
    },
    setsbt: function setsbt(row) {

      var vl = this.getsftype[row.subFileType];
      return vl;
    },
    pushCreateCer: function pushCreateCer() {
      this.$router.push({ path: "/certificate/new" });
    },
    pushUploadCer: function pushUploadCer() {
      this.$router.push({ path: "/certificate/upload" });
    },
    bindOperate: function bindOperate(row) {
      var _this = this;

      this.dvLoading = 1;
      if (this.$appUrlTag === 0) {
        this.$bindApp('0', row.terminalNo, this.appId, function (res) {
          if (res.status === 200) {
            _this.$message.success(_this.$t('app_tipViewTask'));
          } else {
            _this.$message.error(res.message);
          }
          _this.dvLoading = 0;
        }, function () {
          _this.dvLoading = 0;
        });
      } else {
        this.$bindApp1(localStorage.mechanismId, row.terminalNo, this.appId, function (res) {
          if (res.status === 200) {
            _this.$message.success(_this.$t('app_tipViewTask'));
          } else {
            _this.$message.error(res.message);
          }
          _this.dvLoading = 0;
        }, function () {
          _this.dvLoading = 0;
        });
      }
    },
    getChannels: function getChannels() {
      var _this2 = this;

      this.$getChannelList(10000, 1, '', '', '', function (res) {
        if (res.status === 200) {
          _this2.channels = res.data;
        } else {
          _this2.$message.error(res.message);
        }
      }, function () {
        _this2.$message.error(_this2.$t('app_rqsError'));
      });
    },
    getStatus: function getStatus(value) {
      if (!value) return '';
      switch (value) {
        case '0':
          return { vl: this.$t('app_prePushVerify'), style: 'color:#8492A6;' };
        case '1':
          return { vl: this.$t('app_preVerify'), style: 'color:#F7BA2A;' };
        case '2':
          return { vl: this.$t('app_verifyPass'), style: 'color:#13CE66;' };
        case '3':
          return { vl: this.$t('app_verifyNotPass'), style: 'color:#FF4949;' };
      }
    },
    srchDevice: function srchDevice() {
      this.getDevices();
    },
    selectDvChange: function selectDvChange(vl) {
      this.getDevices();
    },
    pageDvSized: function pageDvSized(val) {
      this.$gRow = val;
      this.getDevices();
    },
    getDevices: function getDevices() {
      var _this3 = this;

      var vl = this.srchValue ? this.srchValue : '';
      var channel = this.channelId ? this.channelId : '';
      var status = this.status ? this.status : '';
      var appId = this.appId ? this.appId : '';
      this.dvLoading = 1;
      if (this.$appUrlTag === 0) {
        this.$getDevices(this.dvIndex, this.$gRow, channel, vl, status, '', appId, function (res) {
          _this3.dvLoading = 0;
          if (res.data) {
            _this3.dvTableData = res.data;
            _this3.dvTotal = res.total;
          }
        }, function () {
          _this3.dvLoading = 0;
        });
      } else {

        this.$getDevices1(this.dvIndex, this.$gRow, localStorage.mechanismId, vl, status, '', appId, function (res) {
          console.log('dv', res);
          _this3.dvLoading = 0;
          if (res.data) {
            _this3.dvTableData = res.data;
            _this3.dvTotal = res.total;
          }
        }, function () {
          _this3.dvLoading = 0;
        });
      }
    },
    editApp: function editApp(row) {
      this.$setWObj('fileEdit', { type: 1, data: row });
      this.$router.push({ path: '/filemg/edit' });
    },
    pushApp: function pushApp(row) {

      this.$setWObj('pushList', { type: '10', data: row });
      this.$router.push({ path: '/launch-push' });
    },
    query: function query() {
      this.getList();
    },
    selectChange: function selectChange(vl) {
      this.selectMid = vl;
      this.getList();
    },
    reset: function reset() {
      this.queryKey = '';
      this.appType = '';
      this.getList();
    },
    pageSelect: function pageSelect(index) {
      this.$setWPage(this.listKey, index);
      this.getList();
    },
    pageDvSelect: function pageDvSelect(index) {
      this.dvIndex = index;
      this.getDevices();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getList();
    },
    deleteApp: function deleteApp(obj) {
      var _this4 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        console.log(obj);
        _this4.$delfile(obj.fileId, function (res) {
          if (res.status === 200) {
            _this4.getList();
            _this4.$message.success(res.message);
          } else {
            _this4.$message.error(res.message);
          }
        }, '');
      }, '');
    },
    submitApp: function submitApp(obj) {
      var _this5 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_tipVerify'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this5.loading = 1;
        _this5.$verifyFile(obj.fileId, '', '1', function (res) {
          _this5.loading = 0;
          if (res.status === 200) {
            _this5.getList();
            _this5.$message.success(res.message);
          } else {
            _this5.$message.error(res.message);
          }
        }, function () {
          _this5.loading = 0;
        });
      }, '');
    },
    cellClick: function cellClick(row, ev, col) {

      this.$setWObj('fileDetail', row);

      this.$router.push({ path: '/non-it-eq/app/verify' });
    },
    jumpToUpload: function jumpToUpload() {

      this.$setWObj('fileEdit', { type: 0 });
      this.$router.push({ path: '/filemg/add' });
    },
    getList: function getList() {
      var _this6 = this;

      this.loading = 1;
      var mech = this.selectMid ? this.selectMid : '';
      var name = this.queryKey ? this.queryKey : '';
      var type = '6';
      var stype = '6-1';
      var st = '1';

      this.$getfile(this.index, this.$gRow, name, mech, type, stype, st, '', '', function (res) {

        _this6.loading = 0;
        if (res.status === 200) {
          _this6.total = res.total;
          _this6.tableData = res.data;
        } else {
          _this6.$message(res.message);
        }
      }, function () {
        _this6.loading = 0;
        _this6.$message.error(_this6.$t('app_rqsError'));
      });
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD HH:mm:ss');
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    }
  },
  mounted: function mounted() {
    var _this7 = this;

    this.tqobj = {
      keys: ['ftypes', 'ftype', 'sftype', 'sftypes1', 'sftypes2', 'sftypes3', 'sftypes4', 'sftypes5', 'sftypes6', 'sftypes7', 'sftypes9'],
      callback: function callback(data) {
        _this7.ftypes = data[0];
        _this7.getftype = data[1];
        _this7.getsftype = data[2];
        _this7.sftypes1 = data[3];
        _this7.sftypes2 = data[4];
        _this7.sftypes3 = data[5];
        _this7.sftypes4 = data[6];
        _this7.sftypes5 = data[7];
        _this7.sftypes6 = data[8];
        _this7.sftypes7 = data[9];
        _this7.sftypes9 = data[10];
      }
    };

    this.getList();
  },
  destroyed: function destroyed() {}
});

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      config: '',
      captures: [],
      loading: 0
    };
  },

  computed: {
    avtStyle: function avtStyle() {},
    showUploadNew: function showUploadNew() {
      console.log('ccc', this.config.data);
      if (this.config.data) {
        if (this.config.data.isoperation === 0 && this.config.data.appStatus === '2') {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  methods: {
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('YYYY-MM-DD hh:mm:ss');
    },
    selectChange: function selectChange(vl) {
      this.getDevices();
    },
    pageSelect: function pageSelect(index) {
      this.index = index;
      this.getDevices();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getDevices();
    },
    deleteAppHis: function deleteAppHis(row) {
      var _this = this;

      if (row.applicationid) {
        this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
          confirmButtonText: this.$t('app_sure'),
          cancelButtonText: this.$t('app_cancel'),
          type: 'warning'
        }).then(function () {
          _this.loading = 1;
          if (_this.$appUrlTag === 0) {
            _this.$deleteApp(row.applicationid, function (res) {
              _this.loading = 0;
              if (res.status === 200) {
                _this.getAppHistory();
              } else {
                _this.$message.error(res.message);
              }
            }, function () {
              _this.loading = 0;
            });
          } else {
            _this.$deleteAppHis(row.applicationid, function (res) {
              _this.loading = 0;
              if (res.status === 200) {
                _this.getAppHistory();
              } else {
                _this.$message.error(res.message);
              }
            }, function () {
              _this.loading = 0;
            });
          }
        }).catch(function () {});
      }
    },
    imgFullUrl: function imgFullUrl(path) {
      if (path) {
        return this.$urls.prefix + path;
      } else {
        return '';
      }
    },
    getAppHistory: function getAppHistory() {
      var _this2 = this;

      if (!this.config.data.appName) {
        return;
      }

      this.loading = 1;
      if (this.$appUrlTag === 0) {
        this.$getAppHistory(this.config.data.appName, this.config.data.packagename, function (res) {
          _this2.loading = 0;
          if (res.status === 200) {
            _this2.tableData = res.data;
          } else {
            _this2.$message.error(res.message);
          }
        }, function () {
          _this2.loading = 0;
        });
      } else {

        this.$getAppHistory1(localStorage.mechanismId, this.config.data.packagename, function (res) {

          console.log('his', res);
          _this2.loading = 0;
          if (res.status === 200) {
            _this2.tableData = res.data;
          } else {
            _this2.$message.error(res.message);
          }
        }, function () {
          _this2.loading = 0;
        });
      }
    },
    uploadNew: function uploadNew() {
      this.$router.push({ path: '/applist/newversion' });
    },
    init: function init() {
      this.config = this.$getWObj().editAppConfig;
      this.setCapturesArr(this.config.data.appScreenShot);
      this.getAppHistory();
      console.log(this.config);
    },
    setCapturesArr: function setCapturesArr(strs) {
      if (strs) {
        var arr = strs.split(',');
        this.captures = arr;
      }
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      config: '',
      captures: [],
      loading: 0
    };
  },

  computed: {
    avtStyle: function avtStyle() {},
    showUploadNew: function showUploadNew() {
      console.log('ccc', this.config.data);
      if (this.config.data) {
        if (this.config.data.isoperation === 0 && this.config.data.appStatus === '2') {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  methods: {
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('YYYY-MM-DD hh:mm:ss');
    },
    selectChange: function selectChange(vl) {
      this.getDevices();
    },
    pageSelect: function pageSelect(index) {
      this.index = index;
      this.getDevices();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getDevices();
    },
    deleteAppHis: function deleteAppHis(row) {
      var _this = this;

      if (row.applicationid) {
        this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
          confirmButtonText: this.$t('app_sure'),
          cancelButtonText: this.$t('app_cancel'),
          type: 'warning'
        }).then(function () {
          _this.loading = 1;
          if (_this.$appUrlTag === 0) {
            _this.$deleteApp(row.applicationid, function (res) {
              _this.loading = 0;
              if (res.status === 200) {
                _this.getAppHistory();
              } else {
                _this.$message.error(res.message);
              }
            }, function () {
              _this.loading = 0;
            });
          } else {
            _this.$deleteAppHis(row.applicationid, function (res) {
              _this.loading = 0;
              if (res.status === 200) {
                _this.getAppHistory();
              } else {
                _this.$message.error(res.message);
              }
            }, function () {
              _this.loading = 0;
            });
          }
        }).catch(function () {});
      }
    },
    imgFullUrl: function imgFullUrl(path) {
      if (path) {
        return this.$urls.prefix + path;
      } else {
        return '';
      }
    },
    getAppHistory: function getAppHistory() {
      var _this2 = this;

      if (!this.config.data.appName) {
        return;
      }

      this.loading = 1;
      if (this.$appUrlTag === 0) {
        this.$getAppHistory(this.config.data.appName, this.config.data.packagename, function (res) {
          _this2.loading = 0;
          if (res.status === 200) {
            _this2.tableData = res.data;
          } else {
            _this2.$message.error(res.message);
          }
        }, function () {
          _this2.loading = 0;
        });
      } else {

        this.$getAppHistory1(localStorage.mechanismId, this.config.data.packagename, function (res) {

          console.log('his', res);
          _this2.loading = 0;
          if (res.status === 200) {
            _this2.tableData = res.data;
          } else {
            _this2.$message.error(res.message);
          }
        }, function () {
          _this2.loading = 0;
        });
      }
    },
    uploadNew: function uploadNew() {
      this.$router.push({ path: '/applist/newversion' });
    },
    init: function init() {
      this.config = this.$getWObj().editAppConfig;
      this.setCapturesArr(this.config.data.appScreenShot);
      this.getAppHistory();
      console.log(this.config);
    },
    setCapturesArr: function setCapturesArr(strs) {
      if (strs) {
        var arr = strs.split(',');
        this.captures = arr;
      }
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      config: '',
      captures: [],
      loading: 0
    };
  },

  computed: {
    avtStyle: function avtStyle() {},
    showUploadNew: function showUploadNew() {
      console.log('ccc', this.config.data);
      if (this.config.data) {
        if (this.config.data.isoperation === 0 && this.config.data.appStatus === '2') {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  methods: {
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('YYYY-MM-DD hh:mm:ss');
    },
    selectChange: function selectChange(vl) {
      this.getDevices();
    },
    pageSelect: function pageSelect(index) {
      this.index = index;
      this.getDevices();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getDevices();
    },
    deleteAppHis: function deleteAppHis(row) {
      var _this = this;

      if (row.applicationid) {
        this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
          confirmButtonText: this.$t('app_sure'),
          cancelButtonText: this.$t('app_cancel'),
          type: 'warning'
        }).then(function () {
          _this.loading = 1;
          if (_this.$appUrlTag === 0) {
            _this.$deleteApp(row.applicationid, function (res) {
              _this.loading = 0;
              if (res.status === 200) {
                _this.getAppHistory();
              } else {
                _this.$message.error(res.message);
              }
            }, function () {
              _this.loading = 0;
            });
          } else {
            _this.$deleteAppHis(row.applicationid, function (res) {
              _this.loading = 0;
              if (res.status === 200) {
                _this.getAppHistory();
              } else {
                _this.$message.error(res.message);
              }
            }, function () {
              _this.loading = 0;
            });
          }
        }).catch(function () {});
      }
    },
    imgFullUrl: function imgFullUrl(path) {
      if (path) {
        return this.$urls.prefix + path;
      } else {
        return '';
      }
    },
    getAppHistory: function getAppHistory() {
      var _this2 = this;

      if (!this.config.data.appName) {
        return;
      }

      this.loading = 1;
      if (this.$appUrlTag === 0) {
        this.$getAppHistory(this.config.data.appName, this.config.data.packagename, function (res) {
          _this2.loading = 0;
          if (res.status === 200) {
            _this2.tableData = res.data;
          } else {
            _this2.$message.error(res.message);
          }
        }, function () {
          _this2.loading = 0;
        });
      } else {

        this.$getAppHistory1(localStorage.mechanismId, this.config.data.packagename, function (res) {

          console.log('his', res);
          _this2.loading = 0;
          if (res.status === 200) {
            _this2.tableData = res.data;
          } else {
            _this2.$message.error(res.message);
          }
        }, function () {
          _this2.loading = 0;
        });
      }
    },
    uploadNew: function uploadNew() {
      this.$router.push({ path: '/applist/newversion' });
    },
    init: function init() {
      this.config = this.$getWObj().editAppConfig;
      this.setCapturesArr(this.config.data.appScreenShot);
      this.getAppHistory();
      console.log(this.config);
    },
    setCapturesArr: function setCapturesArr(strs) {
      if (strs) {
        var arr = strs.split(',');
        this.captures = arr;
      }
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      config: '',
      captures: [],
      loading: 0
    };
  },

  computed: {
    avtStyle: function avtStyle() {},
    showUploadNew: function showUploadNew() {
      console.log('ccc', this.config.data);
      if (this.config.data) {
        if (this.config.data.isoperation === 0 && this.config.data.appStatus === '2') {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  methods: {
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('YYYY-MM-DD hh:mm:ss');
    },
    selectChange: function selectChange(vl) {
      this.getDevices();
    },
    pageSelect: function pageSelect(index) {
      this.index = index;
      this.getDevices();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getDevices();
    },
    deleteAppHis: function deleteAppHis(row) {
      var _this = this;

      if (row.applicationid) {
        this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
          confirmButtonText: this.$t('app_sure'),
          cancelButtonText: this.$t('app_cancel'),
          type: 'warning'
        }).then(function () {
          _this.loading = 1;
          if (_this.$appUrlTag === 0) {
            _this.$deleteApp(row.applicationid, function (res) {
              _this.loading = 0;
              if (res.status === 200) {
                _this.getAppHistory();
              } else {
                _this.$message.error(res.message);
              }
            }, function () {
              _this.loading = 0;
            });
          } else {
            _this.$deleteAppHis(row.applicationid, function (res) {
              _this.loading = 0;
              if (res.status === 200) {
                _this.getAppHistory();
              } else {
                _this.$message.error(res.message);
              }
            }, function () {
              _this.loading = 0;
            });
          }
        }).catch(function () {});
      }
    },
    imgFullUrl: function imgFullUrl(path) {
      if (path) {
        return this.$urls.prefix + path;
      } else {
        return '';
      }
    },
    getAppHistory: function getAppHistory() {
      var _this2 = this;

      if (!this.config.data.appName) {
        return;
      }

      this.loading = 1;
      if (this.$appUrlTag === 0) {
        this.$getAppHistory(this.config.data.appName, this.config.data.packagename, function (res) {
          _this2.loading = 0;
          if (res.status === 200) {
            _this2.tableData = res.data;
          } else {
            _this2.$message.error(res.message);
          }
        }, function () {
          _this2.loading = 0;
        });
      } else {

        this.$getAppHistory1(localStorage.mechanismId, this.config.data.packagename, function (res) {

          console.log('his', res);
          _this2.loading = 0;
          if (res.status === 200) {
            _this2.tableData = res.data;
          } else {
            _this2.$message.error(res.message);
          }
        }, function () {
          _this2.loading = 0;
        });
      }
    },
    uploadNew: function uploadNew() {
      this.$router.push({ path: '/applist/newversion' });
    },
    init: function init() {
      this.config = this.$getWObj().editAppConfig;
      this.setCapturesArr(this.config.data.appScreenShot);
      this.getAppHistory();
      console.log(this.config);
    },
    setCapturesArr: function setCapturesArr(strs) {
      if (strs) {
        var arr = strs.split(',');
        this.captures = arr;
      }
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _methods;

/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		var that = this;
		return {
			sstatus: {
				'0': this.$t('app_new'),
				'1': this.$t('app_enable')
			},
			labelttw: "30%",
			dLoading: false,
			srchValue: '',
			reason: '',
			config: '',
			captures: [],
			loading: 0,
			dialogVisible: false,
			notPassDialog: false,
			index: 1,
			detail: '',
			tableData: [],
			total: 0,
			status: '',
			tags: [],
			mech: localStorage.mechanismId,
			stModel: [{
				label: this.$t('app_online'),
				vl: '1'
			}, {
				label: this.$t('app_offline'),
				vl: '2'
			}, {
				label: this.$t('app_sleep'),
				vl: '3'
			}],
			mechanismData: {
				callback: function callback(value) {
					that.mech = value;
					that.selectChange(value);
				}
			}
		};
	},

	components: {},
	computed: {
		showUploadNew: function showUploadNew() {
			console.log('ccc', this.config.data);
			if (this.config.data) {
				if (this.config.data.isoperation === 0 && this.config.data.appStatus === '2') {
					return true;
				} else {
					return false;
				}
			} else {
				return false;
			}
		}
	},
	methods: (_methods = {
		edit: function edit() {
			this.$router.push({
				path: '/non-it-eq/device/detail/edit',
				query: {
					data: this.detail
				}
			});
		},
		bindOperate: function bindOperate(row) {
			var _this = this;

			this.dLoading = 1;
			this.$fstTest(this.config.recordId, row.terminalNo, function (res) {
				_this.dLoading = 0;
				if (res.status === 200) {
					_this.$message.success(_this.$t('app_tipViewTask'));
					_this.notPassDialog = false;
				} else {
					_this.$message.error(res.message);
				}
			}, function (error) {
				_this.dLoading = 0;
				_this.$message.error(_this.$t('app_rqsError'));
			});
		},
		verify: function verify(vl) {
			var _this2 = this;

			if (vl === '2') {
				this.$confirm(this.$t('app_srpassvf') + '?', this.$t('app_tip'), {
					confirmButtonText: this.$t('app_sure'),
					cancelButtonText: this.$t('app_cancel'),
					type: 'warning'
				}).then(function () {
					_this2.verifyRqs(vl);
				}).catch(function () {});
			} else if (vl === '3') {
				this.notPassDialog = true;
			}
		},
		verifyRqs: function verifyRqs(vl) {
			var _this3 = this;

			this.loading = 1;
			this.$verifyFst(this.config.id, this.reason, vl, function (res) {
				_this3.loading = 0;
				if (res.status === 200) {
					_this3.$message.success(res.message);
					_this3.$router.go(-1);
				} else {
					_this3.$message.error(res.message);
				}
			}, function () {
				_this3.$message.error(_this3.$t('app_rqsError'));
				_this3.loading = 0;
			});
		},
		srchDevice: function srchDevice() {
			this.getDevices();
		},
		selectChange: function selectChange(vl) {
			this.getDevices();
		},
		pageSelect: function pageSelect(index) {
			this.index = index;
			this.getDevices();
		},
		pageSized: function pageSized(val) {
			this.$gRow = val;
			this.getDevices();
		},
		getDevices: function getDevices() {
			var _this4 = this;

			var vl = this.srchValue ? this.srchValue : '';

			var status = this.status ? this.status : '';
			var mc = this.mech;
			this.loading = 1;
			this.$getDvDevices(this.index, this.$gRow, mc, vl, status, '', '', '', '', '', function (res) {
				console.log('dv', res);
				_this4.loading = 0;
				if (res.data) {
					_this4.tableData = res.data;
					_this4.total = res.total;
				}
			}, function () {
				_this4.loading = 0;
			});
		},
		setInstallType: function setInstallType(type) {
			return this.$installType[type];
		},
		dateFormat: function dateFormat(row, column) {}
	}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'selectChange', function selectChange(vl) {
		this.getDevices();
	}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'pageSelect', function pageSelect(index) {
		this.index = index;
		this.getDevices();
	}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'pageSized', function pageSized(val) {
		this.$gRow = val;
		this.getDevices();
	}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'deleteAppHis', function deleteAppHis(row) {
		var _this5 = this;

		if (row.applicationid) {
			this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
				confirmButtonText: this.$t('app_sure'),
				cancelButtonText: this.$t('app_cancel'),
				type: 'warning'
			}).then(function () {
				_this5.loading = 1;
				if (_this5.$appUrlTag === 0) {
					_this5.$deleteApp(row.applicationid, function (res) {
						_this5.loading = 0;
						if (res.status === 200) {
							_this5.getAppHistory();
						} else {
							_this5.$message.error(res.message);
						}
					}, function () {
						_this5.loading = 0;
					});
				} else {
					_this5.$deleteAppHis(row.applicationid, function (res) {
						_this5.loading = 0;
						if (res.status === 200) {
							_this5.getAppHistory();
						} else {
							_this5.$message.error(res.message);
						}
					}, function () {
						_this5.loading = 0;
					});
				}
			}).catch(function () {});
		}
	}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'imgFullUrl', function imgFullUrl(path) {
		if (path) {
			return this.$urls.prefix + path;
		} else {
			return '';
		}
	}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'getAppHistory', function getAppHistory() {
		var _this6 = this;

		if (!this.config.data.appName) {
			return;
		}

		this.loading = 1;
		if (this.$appUrlTag === 0) {
			this.$getAppHistory(this.config.data.appName, this.config.data.packagename, function (res) {
				_this6.loading = 0;
				if (res.status === 200) {
					_this6.tableData = res.data;
				} else {
					_this6.$message.error(res.message);
				}
			}, function () {
				_this6.loading = 0;
			});
		} else {

			this.$getAppHistory1(localStorage.mechanismId, this.config.data.packagename, function (res) {

				console.log('his', res);
				_this6.loading = 0;
				if (res.status === 200) {
					_this6.tableData = res.data;
				} else {
					_this6.$message.error(res.message);
				}
			}, function () {
				_this6.loading = 0;
			});
		}
	}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'uploadNew', function uploadNew() {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'getdetail', function getdetail() {
		var _this7 = this;

		var did = this.$getWObj().ndObj.data;

		this.$noniteqDetail(did, function (res) {

			console.log('his', res);
			_this7.loading = 0;
			if (res.status === 200) {
				_this7.detail = res.data;
			} else {
				_this7.$message.error(res.message);
			}
		}, function () {
			_this7.loading = 0;
		});
	}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'init', function init() {
		this.getdetail();
	}), _methods),
	mounted: function mounted() {
		this.init();
	}
});

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this2 = this;

    var _this = this;
    var phoneCheck = function phoneCheck(rule, value, callback) {
      if (!_this2.isLegalMobile(value)) {
        callback(new Error(_this2.$t('app_phoneIllegal')));
      } else {
        callback();
      }
    };
    return {
      fatherList: [],
      info: '',
      mechanismData: '',
      firm: {
        name: '',
        no: '',
        mech: '',
        type: '',
        model: '',
        firm: '',
        addr: '',
        remark: ''
      },
      firms: [],
      loading: false,
      dvs: [],
      mds: [],
      rules: {
        name: [{ required: true, message: this.$t('mao_global.tip.pleaseInput'), trigger: 'blur' }],
        no: [{ required: true, message: this.$t('mao_global.tip.pleaseInput'), trigger: 'blur' }],
        mech: [{ required: true, message: this.$t('app_select'), trigger: 'blur' }],
        type: [{ required: true, message: this.$t('app_select'), trigger: 'blur' }],
        firm: [{ required: true, message: this.$t('app_select'), trigger: 'blur' }],
        model: [{ required: true, message: this.$t('app_select'), trigger: 'blur' }],
        addr: [{ required: true, message: this.$t('mao_global.tip.pleaseInput'), trigger: 'blur' }],
        remark: [{ required: true, message: this.$t('mao_global.tip.pleaseInput'), trigger: 'blur' }]
      }
    };
  },

  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default.a
  },
  methods: {
    mccallback: function mccallback(vl, notclear) {
      if (!notclear) {
        this.firm.firm = '';
        this.firm.type = '';
        this.firm.model = '';
      }
      this.getSlData(vl);
    },
    getSlData: function getSlData(value) {
      var _this3 = this;

      if (!value) {
        this.firms = [];
        this.dvs = [];
        this.mds = [];
        return;
      }
      this.$mechGetTypes(value, function (res) {
        if (res.status == 200) {
          _this3.mds = res.data.models;
          _this3.dvs = res.data.types;
          _this3.firms = res.data.manufactures;
        }
      }, '');
    },
    getDvNo: function getDvNo(index) {
      var _this4 = this;

      this.loading = 1;
      this.$deviceNo(99999, 1, '', '', function (res) {
        console.log('res', res);
        _this4.loading = 0;
        if (res.status === 200) {
          _this4.mds = res.data;
        } else {
          _this4.$message.error(res.message);
        }
      }, function () {
        _this4.loading = 0;
      });
    },
    getFirm: function getFirm() {
      var _this5 = this;

      this.loading = 1;
      this.$getFirmList(99999, 1, '', '', function (res) {
        _this5.loading = 0;
        if (res.status === 200) {
          _this5.firms = res.data;
        } else {
          _this5.$message.error(res.message);
        }
      }, function () {
        _this5.loading = 0;
      });
    },
    getDTypes: function getDTypes() {
      var _this6 = this;

      this.loading = 1;
      this.$deviceType(99999, 1, '', '', function (res) {
        _this6.loading = 0;
        if (res.status === 200) {
          _this6.dvs = res.data;
        } else {
          _this6.$message.error(res.message);
        }
      }, function () {
        _this6.loading = 0;
      });
    },
    isLegalMobile: function isLegalMobile(tel) {
      var sMobile = tel;
      var regex = "^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\\d{8}$";
      var re = new RegExp(regex, 'g');
      if (!re.test(sMobile)) {
        return false;
      } else {
        return true;
      }
    },
    newfirm: function newfirm() {
      var _this7 = this;

      this.loading = 1;
      this.$addNonDv(this.firm.no, this.firm.name, this.firm.firm, this.firm.mech, this.firm.addr, this.firm.type, this.firm.model, this.firm.remark, function (res) {
        _this7.loading = 0;
        if (res.status === 200) {
          _this7.$router.go(-1);
        } else {
          _this7.$message.error(res.message);
        }
      }, function () {
        _this7.loading = 0;
      });
    },
    editfirm: function editfirm() {
      var _this8 = this;

      var data = this.info;

      this.loading = 1;
      this.$editNonDv(data.id, this.firm.no, this.firm.name, this.firm.firm, this.firm.mech, this.firm.addr, this.firm.type, this.firm.model, this.firm.remark, function (res) {
        _this8.loading = 0;
        if (res.status === 200) {
          _this8.$router.go(-1);
        } else {
          _this8.$message.error(res.message);
        }
      }, function () {
        _this8.loading = 0;
      });
    },
    save: function save(name) {
      var _this9 = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          if (!_this9.info) {
            _this9.newfirm();
          } else {
            _this9.editfirm();
          }
        } else {
          return false;
        }
      });
    },
    cancel: function cancel() {
      this.$router.go(-1);
    },
    fillData: function fillData(data) {

      this.firm.name = data.terminalName;
      this.firm.no = data.terminalNo;
      this.firm.mech = data.mechanismId;
      this.firm.type = data.terminalType;
      this.firm.model = data.terminalModel;
      this.firm.firm = data.manufId;
      this.firm.addr = data.address;
      this.firm.remark = data.memo;
      this.mccallback(data.mechanismId, true);

      var _this = this;
      this.mechanismData = {
        value: data.mechName,
        placeholder: _this.$t('lin_global.place_areaid'),
        callback: function callback(value) {
          _this.firm.mech = value;
          _this.mccallback(value);
        }
      };
    }
  },
  mounted: function mounted() {

    var data = this.$route.query.data;
    this.info = data;
    var _this = this;
    if (data) {
      this.fillData(data);
    } else {
      this.mechanismData = {
        value: '',
        placeholder: _this.$t('lin_global.place_areaid'),
        callback: function callback(value) {
          _this.firm.mech = value;
          _this.mccallback(value);
        }
      };
    }
  }
});

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			orderName: '',
			orderType: '',
			sNum: 0,

			ssq: [""],
			srcList: [],
			status: [{
				label: '全部状态',
				value: ''
			}, {
				label: '正常',
				value: '1'
			}, {
				label: '异常',
				value: '2'
			}],
			sstatus: {
				'0': this.$t('app_new'),
				'1': this.$t('app_enable')
			},
			sstatusAr: [{
				vl: '',
				lb: this.$t('app_all')
			}, {
				vl: '0',
				lb: this.$t('app_new')
			}, {
				vl: '1',
				lb: this.$t('app_enable')
			}],
			dest_list: [{
				vl: '0',
				lb: this.$t('lin_global.normal')
			}, {
				vl: '1',
				lb: this.$t('app_selfDestroy')
			}],
			statusVl: '',
			activeStatus: "",
			ipDialog: false,
			mechanismId: '',
			loading: 0,
			mechanismData: '',
			queryKey: '',
			appType: '',
			appTypes: [],
			tableData: [],
			multipleSelection: [],
			total: 0,
			page: 1,
			dialogTopMgVisible: 0,
			dialogConfig: {
				tip: '',
				data: '',
				type: ''
			},
			selectAll: {}
		};
	},

	components: {
		MechanismSelector: __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default.a
	},
	computed: {
		fileUploadUrl: function fileUploadUrl() {
			return this.$addrPre + '/scanner/importTers.do' + "?language=" + localStorage.system_lang + '&token=' + localStorage.user;
		}
	},
	methods: {
		sortChange: function sortChange(vl) {
			switch (vl.prop) {
				case 'terminalName':
					this.orderName = '1';
					break;
				case 'terminalNo':
					this.orderName = '2';
					break;
				case 'updateTime':
					this.orderName = '3';
					break;
			}
			this.orderType = vl.order == 'descending' ? 'desc' : 'asc';
			this.getList();
		},
		srcBefore: function srcBefore(file) {
			var name = file.name;
			if (name) {
				window[this.$route.path] = 1;
				return true;
			} else {
				this.$message(this.$t('app_fileNameOnly') + 'part0.zip');
				return false;
			}
		},
		srcSuccess: function srcSuccess(res, file) {
			window[this.$route.path] = '';
			console.log(res);
			if (res.status === 200) {
				this.ipDialog = false;
				this.$message.success(res.message);
				this.srcList = [];
			} else {
				this.srcList = [];
				this.$message.error(res.message);
			}
		},
		downm: function downm() {
			window.open(this.$host + '/tms-server-web/model/terminal_scanner.xlsx');
		},
		importDv: function importDv() {
			this.ipDialog = true;
		},
		stChange: function stChange() {
			this.getList();
		},
		mkDvSt: function mkDvSt(row) {
			return this.sstatus[row.terminalStatus];
		},
		makeArea: function makeArea(row) {},
		handleChange: function handleChange() {
			this.getList();
		},
		setAddr: function setAddr(row) {},
		setInstallType: function setInstallType(type) {
			return this.$installType[type];
		},
		query: function query() {
			this.getList();
		},
		reset: function reset() {
			this.queryKey = '';
			this.appType = '';
			this.getList();
		},
		selectChange: function selectChange(vl) {
			this.getList();
		},
		cellClick: function cellClick(row, ev, col) {
			if (col.label && col.label !== this.$t('app_operate')) {
				this.detail(row);
			}
		},
		dateFormat: function dateFormat(row, column) {},
		pageSelect: function pageSelect(index) {
			this.page = index;
			this.getList();
		},
		pageSized: function pageSized(val) {
			this.$gRow = val;
			this.getList();
		},
		toggleSelection: function toggleSelection(rows) {
			var _this2 = this;

			if (rows) {
				rows.forEach(function (row) {
					_this2.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		bcdel: function bcdel() {
			var _this3 = this;

			this.$showConfirm(this.$t('app_tip'), "确定要删除这些数据？", this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
				var ids = '';
				_this3.multipleSelection.forEach(function (vl) {
					ids += vl.id + ',';
				});
				ids = ids.substring(0, ids.length - 1);
				if (!ids) {
					_this3.$message(_this3.$t('app_chooseOneMust'));
					return;
				}
				_this3.delRqs(ids);
			}, '');
		},
		handleSelectionChange: function handleSelectionChange(val) {
			this.sNum = val.length;
			this.multipleSelection = val;
		},
		del: function del(mid) {
			var _this4 = this;

			this.$showConfirm(this.$t('app_tip'), "确定删除此数据？", this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
				_this4.delRqs(mid);
			}, '');
		},
		delRqs: function delRqs(mid) {
			var _this5 = this;

			this.loading = 1;
			this.$delNonieDv(mid, function (res) {
				if (res.status === 200) {
					_this5.getList();
				} else {
					_this5.$message.error(res.message);
				}
				_this5.loading = 0;
			}, function () {
				_this5.loading = 0;
			});
		},
		detail: function detail(row) {
			this.$setWObj('ndObj', {
				data: row.id
			});
			this.$router.push({
				path: '/non-it-eq/device/detail'
			});
		},
		add: function add() {
			this.$router.push({
				path: '/non-it-eq/device/add'
			});
		},
		bindOperate: function bindOperate(obj) {
			this.$setWObj('pushList', {
				data: obj,
				type: '1'
			});
			this.$router.push({
				path: '/appslot/distribute-push'
			});
		},
		selected: function selected(rows) {},
		getList: function getList() {
			var _this6 = this;

			this.loading = 1;
			var no = this.queryKey ? this.queryKey : '';
			var mcid = this.mechanismId ? this.mechanismId : '';
			var status = this.statusVl;
			var activeStatus = this.activeStatus;

			this.$getNonItDv(this.page, this.$gRow, mcid, no, status, activeStatus, this.orderName, this.orderType, '', '', function (res) {
				console.log(res);
				_this6.loading = 0;
				if (res.status === 200) {
					_this6.total = res.total;
					_this6.tableData = res.data;
				} else {
					_this6.$message.error(res.message);
				}
			}, function () {
				_this6.loading = 0;
			});
		}
	},
	mounted: function mounted() {

		var mVl = '';
		var _this = this;
		this.mechanismData = {
			value: mVl,
			placeholder: this.$t('lin_global.place_areaid'),
			callback: function callback(value) {
				_this.mechanismId = value;
				_this.getList();
			}
		};

		this.getList();
	}
});

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_df_png__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_df_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_df_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__);


var _methods;




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var that = this;
    return {
      dLoading: false,
      srchValue: '',
      reason: '',
      config: '',
      captures: [],
      sstatus: {
        '0': this.$t('app_new'),
        '1': this.$t('app_on'),
        '2': this.$t('app_sleep'),
        '3': this.$t('app_fault')
      },
      sstatusAr: [{ vl: '', lb: this.$t('app_all') }, { vl: '0', lb: this.$t('app_new') }, { vl: '1', lb: this.$t('app_on') }, { vl: '2', lb: this.$t('app_sleep') }, { vl: '3', lb: this.$t('app_fault') }],
      loading: 0,
      dialogVisible: false,
      notPassDialog: false,
      index: 1,
      tableData: [],
      total: 0,
      status: '',
      tags: [],
      mech: '',
      stModel: [{ label: this.$t('app_online'), vl: '1' }, { label: this.$t('app_offline'), vl: '2' }, { label: this.$t('app_sleep'), vl: '3' }],
      mechanismData: {
        callback: function callback(value) {
          that.mech = value;
          that.selectChange(value);
        }
      }
    };
  },

  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default.a
  },
  computed: {
    showUploadNew: function showUploadNew() {
      console.log('ccc', this.config.data);
      if (this.config.data) {
        if (this.config.data.isoperation === 0 && this.config.data.appStatus === '2') {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  methods: (_methods = {
    push: function push() {
      this.$setWObj('pushList', { data: this.config, type: '15' });
      this.$router.push({ path: '/non-it-eq/src/detail/push' });
    },
    downf: function downf() {
      window.open(this.$host + this.config.url);
    },
    setSt: function setSt(row) {
      return this.sstatus[row.terminalStatus];
    },
    bindOperate: function bindOperate(row) {
      var _this = this;

      this.dLoading = 1;
      this.$asTestPush(this.config.id, row.terminalNo, function (res) {
        _this.dLoading = 0;
        if (res.status === 200) {
          _this.$message.success(_this.$t('app_tipViewTask'));
          _this.notPassDialog = false;
        } else {
          _this.$message.error(res.message);
        }
      }, function (error) {
        _this.dLoading = 0;
        _this.$message.error(_this.$t('app_rqsError'));
      });
    },
    verify: function verify(vl) {
      var _this2 = this;

      if (vl === '2') {
        this.$confirm(this.$t('app_srpassvf') + '?', this.$t('app_tip'), {
          confirmButtonText: this.$t('app_sure'),
          cancelButtonText: this.$t('app_cancel'),
          type: 'warning'
        }).then(function () {
          _this2.verifyRqs(vl);
        }).catch(function () {});
      } else if (vl === '3') {
        this.notPassDialog = true;
      }
    },
    verifyRqs: function verifyRqs(vl) {
      var _this3 = this;

      this.loading = 1;
      this.$assubmit(this.config.id, this.reason, vl, function (res) {
        _this3.loading = 0;
        if (res.status === 200) {
          _this3.$message.success(res.message);
          _this3.$router.go(-1);
        } else {
          _this3.$message.error(res.message);
        }
      }, function () {
        _this3.$message.error(_this3.$t('app_rqsError'));
        _this3.loading = 0;
      });
    },
    srchDevice: function srchDevice() {
      this.getDevices();
    },
    selectChange: function selectChange(vl) {
      this.getDevices();
    },
    pageSelect: function pageSelect(index) {
      this.index = index;
      this.getDevices();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getDevices();
    },
    getDevices: function getDevices() {
      var _this4 = this;

      var vl = this.srchValue ? this.srchValue : '';

      var status = this.status ? this.status : '';
      var mc = this.mech;

      this.loading = 1;
      this.$getNonItDv(this.index, this.$gRow, mc, '', status, '', '', '', '', '', function (res) {
        console.log('dv', res);
        _this4.loading = 0;
        if (res.data) {
          _this4.tableData = res.data;
          _this4.total = res.total;
        }
      }, function () {
        _this4.loading = 0;
      });
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD hh:mm:ss');
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'selectChange', function selectChange(vl) {
    this.getDevices();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'pageSelect', function pageSelect(index) {
    this.index = index;
    this.getDevices();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'pageSized', function pageSized(val) {
    this.$gRow = val;
    this.getDevices();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'deleteAppHis', function deleteAppHis(row) {
    var _this5 = this;

    if (row.applicationid) {
      this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
        confirmButtonText: this.$t('app_sure'),
        cancelButtonText: this.$t('app_cancel'),
        type: 'warning'
      }).then(function () {
        _this5.loading = 1;
        if (_this5.$appUrlTag === 0) {
          _this5.$deleteApp(row.applicationid, function (res) {
            _this5.loading = 0;
            if (res.status === 200) {
              _this5.getAppHistory();
            } else {
              _this5.$message.error(res.message);
            }
          }, function () {
            _this5.loading = 0;
          });
        } else {
          _this5.$deleteAppHis(row.applicationid, function (res) {
            _this5.loading = 0;
            if (res.status === 200) {
              _this5.getAppHistory();
            } else {
              _this5.$message.error(res.message);
            }
          }, function () {
            _this5.loading = 0;
          });
        }
      }).catch(function () {});
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'imgFullUrl', function imgFullUrl(path) {
    if (path) {
      return this.$urls.prefix + path;
    } else {
      return '';
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'getAppHistory', function getAppHistory() {
    var _this6 = this;

    if (!this.config.data.appName) {
      return;
    }

    this.loading = 1;
    if (this.$appUrlTag === 0) {
      this.$getAppHistory(this.config.data.appName, this.config.data.packagename, function (res) {
        _this6.loading = 0;
        if (res.status === 200) {
          _this6.tableData = res.data;
        } else {
          _this6.$message.error(res.message);
        }
      }, function () {
        _this6.loading = 0;
      });
    } else {

      this.$getAppHistory1(localStorage.mechanismId, this.config.data.packagename, function (res) {

        console.log('his', res);
        _this6.loading = 0;
        if (res.status === 200) {
          _this6.tableData = res.data;
        } else {
          _this6.$message.error(res.message);
        }
      }, function () {
        _this6.loading = 0;
      });
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'uploadNew', function uploadNew() {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'init', function init() {
    this.config = this.$getWObj().nsObj;
    console.log(this.$route, this.config);
  }), _methods),
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this2 = this;

    var _this = this;
    var phoneCheck = function phoneCheck(rule, value, callback) {
      if (!_this2.isLegalMobile(value)) {
        callback(new Error(_this2.$t('app_phoneIllegal')));
      } else {
        callback();
      }
    };
    return {
      fatherList: [],
      info: '',
      srcList: [],
      mechanismData: {
        placeholder: _this.$t('lin_global.place_areaid'),
        callback: function callback(value) {
          _this.firm.mech = value;
        }
      },
      firm: {
        name: '',
        desc: '',
        mech: '',
        cid: '',
        ver: '',
        md5: '',
        type: '2',
        size: '',
        url: ''
      },
      firms: [],
      loading: false,
      dvs: [],
      mds: [],
      rules: {
        name: [{ required: true, message: this.$t('mao_global.tip.pleaseInput'), trigger: 'blur' }],
        url: [{ required: true, message: this.$t('mao_global.tip.pleaseInput'), trigger: 'blur' }],
        desc: [{ required: true, message: this.$t('mao_global.tip.pleaseInput'), trigger: 'blur' }],
        mech: [{ required: true, message: this.$t('app_select'), trigger: 'blur' }],
        type: [{ required: true, message: this.$t('app_select'), trigger: 'blur' }],
        firm: [{ required: true, message: this.$t('app_select'), trigger: 'blur' }],
        model: [{ required: true, message: this.$t('app_select'), trigger: 'blur' }],
        ver: [{ required: true, message: this.$t('mao_global.tip.pleaseInput'), trigger: 'blur' }],
        remark: [{ required: true, message: this.$t('mao_global.tip.pleaseInput'), trigger: 'blur' }]
      }
    };
  },

  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default.a
  },
  computed: {
    reason: function reason() {
      if (!this.info) {
        return '';
      }

      var rs = this.info.refuseReason;
      return rs ? this.$t('app_banReason') + ':' + rs : this.$t('app_banReason') + ':' + this.$t('app_noInput');
    },
    fileUploadUrl: function fileUploadUrl() {
      return this.$urls.fileUrl;
    }
  },
  methods: {
    srcBefore: function srcBefore(file) {
      var name = file.name;
      if (name) {
        window[this.$route.path] = 1;
        return true;
      } else {
        this.$message(this.$t('app_fileNameOnly') + 'part0.zip');
        return false;
      }
    },
    srcSuccess: function srcSuccess(res, file) {
      window[this.$route.path] = '';
      console.log(res);
      if (res.status === 200) {
        this.firm.md5 = res.md5;
        this.srcList = [{ name: file.name }];
        this.firm.url = res.fileUrl;
        this.firm.size = res.appSize;
        this.hBlur('fm');
      } else {
        this.srcList = [];
      }
    },
    isLegalMobile: function isLegalMobile(tel) {
      var sMobile = tel;
      var regex = "^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\\d{8}$";
      var re = new RegExp(regex, 'g');
      if (!re.test(sMobile)) {
        return false;
      } else {
        return true;
      }
    },
    newfirm: function newfirm() {
      var _this3 = this;

      this.loading = 1;
      this.$addNonAs(this.firm.name, this.firm.ver, this.firm.md5, this.firm.size, this.firm.url, this.firm.cid, this.firm.mech, this.firm.desc, this.firm.type, function (res) {
        _this3.loading = 0;
        if (res.status === 200) {
          _this3.$router.go(-1);
        } else {
          _this3.$message.error(res.message);
        }
      }, function () {
        _this3.loading = 0;
      });
    },
    editfirm: function editfirm() {
      var _this4 = this;

      var data = this.info;

      this.loading = 1;
      this.$editNonAs(data.id, data.status, this.firm.name, this.firm.ver, this.firm.md5, this.firm.size, this.firm.url, '', this.firm.mech, this.firm.desc, this.firm.type, function (res) {
        _this4.loading = 0;
        if (res.status === 200) {
          _this4.$router.go(-1);
        } else {
          _this4.$message.error(res.message);
        }
      }, function () {
        _this4.loading = 0;
      });
    },
    save: function save(name) {
      var _this5 = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          if (!_this5.info) {
            _this5.newfirm();
          } else {
            _this5.editfirm();
          }
        } else {
          return false;
        }
      });
    },
    cancel: function cancel() {
      this.$router.go(-1);
    },
    fillData: function fillData(data) {
      console.log(data);
      this.firm.name = data.name;
      this.firm.desc = data.memo;
      this.firm.mech = data.mechanismId;
      this.firm.ver = data.version;
      this.firm.firm = data.manufId;
      this.firm.addr = data.address;
      this.firm.remark = data.memo;
      this.firm.md5 = data.hashCode;
      this.firm.size = data.size;
      this.firm.url = data.url;
      var ar = [];
      if (data.url) {
        ar = data.url.split('/');
        this.srcList = [{ name: ar[ar.length - 1] }];
      }

      var _this = this;
      this.mechanismData = {
        value: data.mechanismId,
        placeholder: this.$t('lin_global.place_areaid'),
        optValue: true,
        callback: function callback(value) {
          _this.firm.mech = value.id;
        }
      };
    }
  },
  mounted: function mounted() {

    var data = this.$route.query.data;
    this.info = data;
    if (data) {
      this.fillData(data);
    }
  }
});

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      sNum: 0,

      sstatusAr: [{ label: this.$t('app_allstatus'), value: '' }, { label: this.$t('app_prePushVerify'), value: '0' }, { label: this.$t('app_preVerify'), value: '1' }, { label: this.$t('app_verifyPass'), value: '2' }, { label: this.$t('app_verifyNotPass'), value: '3' }],
      statusVl: '',
      mechanismId: '',
      loading: 0,
      mechanismData: '',
      queryKey: '',
      appType: '',
      tableData: [],
      multipleSelection: [],
      total: 0,
      page: 1,
      dialogTopMgVisible: 0,
      dialogConfig: { tip: '', data: '', type: '' },
      selectAll: {}
    };
  },

  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default.a
  },
  computed: {},
  methods: {
    push: function push(row) {
      this.$setWObj('pushList', { data: row, type: '15' });
      this.$router.push({ path: '/non-it-eq/src/push' });
    },
    stchange: function stchange() {
      this.getList();
    },
    getStatus: function getStatus(value) {
      if (!value) return '';
      switch (value) {
        case '0':
          return { vl: this.$t('app_prePushVerify'), style: 'color:#8492A6;' };
        case '1':
          return { vl: this.$t('app_preVerify'), style: 'color:#F7BA2A;' };
        case '2':
          return { vl: this.$t('app_verifyPass'), style: 'color:#13CE66;' };
        case '3':
          return { vl: this.$t('app_verifyNotPass'), style: 'color:#FF4949;' };
      }
    },
    makeArea: function makeArea(row) {},
    handleChange: function handleChange() {
      this.getList();
    },
    setAddr: function setAddr(row) {},
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    },
    query: function query() {
      this.getList();
    },
    reset: function reset() {
      this.queryKey = '';
      this.appType = '';
      this.getList();
    },
    selectChange: function selectChange(vl) {
      this.getList();
    },
    cellClick: function cellClick(row, ev, col) {
      if (col.label && col.label !== this.$t('app_operate')) {
        if (row.status == 2) {
          this.detail(row);
        } else {
          this.edit(row);
        }
      }
    },
    dateFormat: function dateFormat(row, column) {},
    pageSelect: function pageSelect(index) {
      this.page = index;
      this.getList();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getList();
    },
    toggleSelection: function toggleSelection(rows) {
      var _this2 = this;

      if (rows) {
        rows.forEach(function (row) {
          _this2.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    bcdel: function bcdel() {
      var _this3 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t("app_tipAppEdit"), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        var ids = '';
        _this3.multipleSelection.forEach(function (vl) {
          ids += vl.dispenserId + ',';
        });
        ids = ids.substring(0, ids.length - 1);
        if (!ids) {
          _this3.$message(_this3.$t('app_chooseOneMust'));
          return;
        }
        _this3.delRqs(ids);
      }, '');
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.sNum = val.length;
      this.multipleSelection = val;
    },
    submit: function submit(id) {
      var _this4 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t("app_tipVerify"), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this4.loading = 1;
        _this4.$assubmit(id, '', '1', function (res) {
          if (res.status === 200) {
            _this4.getList();
          } else {
            _this4.$message.error(res.message);
          }
          _this4.loading = 0;
        }, function () {
          _this4.loading = 0;
        });
      }, '');
    },
    del: function del(mid) {
      var _this5 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t("app_tipAppEdit"), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this5.delRqs(mid);
      }, '');
    },
    delRqs: function delRqs(mid) {
      var _this6 = this;

      this.loading = 1;
      this.$delNonieAs(mid, function (res) {
        if (res.status === 200) {
          _this6.getList();
        } else {
          _this6.$message.error(res.message);
        }
        _this6.loading = 0;
      }, function () {
        _this6.loading = 0;
      });
    },
    detail: function detail(row) {
      this.$setWObj('nsObj', row);
      this.$router.push({ path: '/non-it-eq/src/detail' });
    },
    edit: function edit(row) {
      this.$router.push({ path: '/non-it-eq/src/edit', query: { data: row } });
    },
    add: function add() {
      this.$router.push({ path: '/non-it-eq/src/add' });
    },
    bindOperate: function bindOperate(obj) {
      this.$setWObj('pushList', { data: obj, type: '1' });
      this.$router.push({ path: '/appslot/distribute-push' });
    },
    selected: function selected(rows) {},
    getList: function getList() {
      var _this7 = this;

      this.loading = 1;
      var name = this.queryKey ? this.queryKey : '';

      var mech = this.mechanismId ? this.mechanismId : '';
      this.$getasList(this.page, this.$gRow, this.statusVl, mech, '2', name, function (res) {
        console.log(res);
        _this7.loading = 0;
        if (res.status === 200) {
          _this7.total = res.total;
          _this7.tableData = res.data;
        } else {
          _this7.$message.error(res.message);
        }
      }, function () {
        _this7.loading = 0;
      });
    }
  },
  mounted: function mounted() {

    var mVl = '';
    var _this = this;
    this.mechanismData = {
      value: mVl,
      placeholder: this.$t('lin_global.place_areaid'),
      optValue: true,
      callback: function callback(value) {
        _this.mechanismId = value.id;
        _this.getList();
      }
    };

    this.getList();
  }
});

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_df_png__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_df_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_df_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__);


var _methods;




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var that = this;
    return {
      dLoading: false,
      srchValue: '',
      reason: '',
      config: '',
      captures: [],
      sstatus: {
        '0': this.$t('app_new'),
        '1': this.$t('app_on'),
        '2': this.$t('app_sleep'),
        '3': this.$t('app_fault')
      },
      sstatusAr: [{ vl: '', lb: this.$t('app_all') }, { vl: '0', lb: this.$t('app_new') }, { vl: '1', lb: this.$t('app_on') }, { vl: '2', lb: this.$t('app_sleep') }, { vl: '3', lb: this.$t('app_fault') }],
      loading: 0,
      dialogVisible: false,
      notPassDialog: false,
      index: 1,
      tableData: [],
      total: 0,
      status: '',
      tags: [],
      mech: '',
      stModel: [{ label: this.$t('app_online'), vl: '1' }, { label: this.$t('app_offline'), vl: '2' }, { label: this.$t('app_sleep'), vl: '3' }],
      mechanismData: {
        callback: function callback(value) {
          that.mech = value;
          that.selectChange(value);
        }
      }
    };
  },

  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default.a
  },
  computed: {
    showUploadNew: function showUploadNew() {
      console.log('ccc', this.config.data);
      if (this.config.data) {
        if (this.config.data.isoperation === 0 && this.config.data.appStatus === '2') {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  methods: (_methods = {
    downf: function downf() {
      window.open(this.$host + this.config.url);
    },
    setSt: function setSt(row) {
      return this.sstatus[row.terminalStatus];
    },
    bindOperate: function bindOperate(row) {
      var _this = this;

      this.dLoading = 1;
      this.$asTestPush(this.config.id, row.terminalNo, function (res) {
        _this.dLoading = 0;
        if (res.status === 200) {
          _this.$message.success(_this.$t('app_tipViewTask'));
          _this.notPassDialog = false;
        } else {
          _this.$message.error(res.message);
        }
      }, function (error) {
        _this.dLoading = 0;
        _this.$message.error(_this.$t('app_rqsError'));
      });
    },
    verify: function verify(vl) {
      var _this2 = this;

      if (vl === '2') {
        this.$confirm(this.$t('app_srpassvf') + '?', this.$t('app_tip'), {
          confirmButtonText: this.$t('app_sure'),
          cancelButtonText: this.$t('app_cancel'),
          type: 'warning'
        }).then(function () {
          _this2.verifyRqs(vl);
        }).catch(function () {});
      } else if (vl === '3') {
        this.notPassDialog = true;
      }
    },
    verifyRqs: function verifyRqs(vl) {
      var _this3 = this;

      this.loading = 1;
      this.$assubmit(this.config.id, this.reason, vl, function (res) {
        _this3.loading = 0;
        if (res.status === 200) {
          _this3.$message.success(res.message);
          _this3.$router.go(-1);
        } else {
          _this3.$message.error(res.message);
        }
      }, function () {
        _this3.$message.error(_this3.$t('app_rqsError'));
        _this3.loading = 0;
      });
    },
    srchDevice: function srchDevice() {
      this.getDevices();
    },
    selectChange: function selectChange(vl) {
      this.getDevices();
    },
    pageSelect: function pageSelect(index) {
      this.index = index;
      this.getDevices();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getDevices();
    },
    getDevices: function getDevices() {
      var _this4 = this;

      var vl = this.srchValue ? this.srchValue : '';

      var status = this.status ? this.status : '';
      var mc = this.mech;

      this.loading = 1;
      this.$getNonItDv(this.index, this.$gRow, mc, '', status, '', '', '', '', '', function (res) {
        console.log('dv', res);
        _this4.loading = 0;
        if (res.data) {
          _this4.tableData = res.data;
          _this4.total = res.total;
        }
      }, function () {
        _this4.loading = 0;
      });
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD hh:mm:ss');
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'selectChange', function selectChange(vl) {
    this.getDevices();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'pageSelect', function pageSelect(index) {
    this.index = index;
    this.getDevices();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'pageSized', function pageSized(val) {
    this.$gRow = val;
    this.getDevices();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'deleteAppHis', function deleteAppHis(row) {
    var _this5 = this;

    if (row.applicationid) {
      this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
        confirmButtonText: this.$t('app_sure'),
        cancelButtonText: this.$t('app_cancel'),
        type: 'warning'
      }).then(function () {
        _this5.loading = 1;
        if (_this5.$appUrlTag === 0) {
          _this5.$deleteApp(row.applicationid, function (res) {
            _this5.loading = 0;
            if (res.status === 200) {
              _this5.getAppHistory();
            } else {
              _this5.$message.error(res.message);
            }
          }, function () {
            _this5.loading = 0;
          });
        } else {
          _this5.$deleteAppHis(row.applicationid, function (res) {
            _this5.loading = 0;
            if (res.status === 200) {
              _this5.getAppHistory();
            } else {
              _this5.$message.error(res.message);
            }
          }, function () {
            _this5.loading = 0;
          });
        }
      }).catch(function () {});
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'imgFullUrl', function imgFullUrl(path) {
    if (path) {
      return this.$urls.prefix + path;
    } else {
      return '';
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'getAppHistory', function getAppHistory() {
    var _this6 = this;

    if (!this.config.data.appName) {
      return;
    }

    this.loading = 1;
    if (this.$appUrlTag === 0) {
      this.$getAppHistory(this.config.data.appName, this.config.data.packagename, function (res) {
        _this6.loading = 0;
        if (res.status === 200) {
          _this6.tableData = res.data;
        } else {
          _this6.$message.error(res.message);
        }
      }, function () {
        _this6.loading = 0;
      });
    } else {

      this.$getAppHistory1(localStorage.mechanismId, this.config.data.packagename, function (res) {

        console.log('his', res);
        _this6.loading = 0;
        if (res.status === 200) {
          _this6.tableData = res.data;
        } else {
          _this6.$message.error(res.message);
        }
      }, function () {
        _this6.loading = 0;
      });
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'uploadNew', function uploadNew() {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'init', function init() {
    this.config = this.$route.query;
    console.log(this.$route, this.config);
    this.getDevices();
  }), _methods),
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default.a
  },
  data: function data() {
    var that = this;
    return {
      mechanismData: {
        callback: function callback(value) {
          that.mech = value;
          that.selectChange(value);
        }
      },
      listKey: 'launch-list',
      cerDialogVisible: false,
      cerTipDialogVisible: false,
      dvLoading: 0,
      appId: '',
      stModel: [{ label: this.$t('app_online'), vl: '1' }, { label: this.$t('app_offline'), vl: '2' }, { label: this.$t('app_new'), vl: '0' }],
      channels: [],
      srchValue: '',
      channelId: '',
      cerTipMsg: '',
      status: '',
      dvIndex: 1,
      dialogVisible: 0,
      mechanismId: window.localStorage['mechanismId'],
      selectMid: '',
      tableData: [],
      dvTableData: [],
      appTypes: [],
      appTypeValue: '',
      appStatus: [{ label: this.$t('app_prePushVerify'), value: '0' }, { label: this.$t('app_preVerify'), value: '1' }, { label: this.$t('app_verifyPass'), value: '2' }, { label: this.$t('app_verifyNotPass'), value: '3' }],
      appStatusValue: '',
      total: 0,
      dvTotal: 0,
      loading: 0,
      appType: '',
      index: 1,
      queryKey: ''
    };
  },

  computed: {
    getDvStatus: function getDvStatus(value) {
      switch (value) {
        case '0':
          return this.$t('app_prePushVerify');
        case '1':
          return this.$t('app_preVerify');
        case '2':
          return this.$t('app_verifyPass');
        case '3':
          return this.$t('app_verifyNotPass');
      }
    }
  },
  methods: {
    pushCreateCer: function pushCreateCer() {
      this.$router.push({ path: "/certificate/new" });
    },
    pushUploadCer: function pushUploadCer() {
      this.$router.push({ path: "/certificate/upload" });
    },
    bindOperate: function bindOperate(row) {
      var _this = this;

      this.dvLoading = 1;
      if (this.$appUrlTag === 0) {
        this.$bindApp('0', row.terminalNo, this.appId, function (res) {
          if (res.status === 200) {
            _this.$message.success(_this.$t('app_tipViewTask'));
          } else {
            _this.$message.error(res.message);
          }
          _this.dvLoading = 0;
        }, function () {
          _this.dvLoading = 0;
        });
      } else {
        this.$bindApp1(localStorage.mechanismId, row.terminalNo, this.appId, function (res) {
          if (res.status === 200) {
            _this.$message.success(_this.$t('app_tipViewTask'));
          } else {
            _this.$message.error(res.message);
          }
          _this.dvLoading = 0;
        }, function () {
          _this.dvLoading = 0;
        });
      }
    },
    getChannels: function getChannels() {
      var _this2 = this;

      this.$getChannelList(10000, 1, '', '', '', function (res) {
        if (res.status === 200) {
          _this2.channels = res.data;
        } else {
          _this2.$message.error(res.message);
        }
      }, function () {
        _this2.$message.error(_this2.$t('app_rqsError'));
      });
    },
    getStatus: function getStatus(value) {
      if (!value) return '';
      switch (value) {
        case '0':
          return { vl: this.$t('app_prePushVerify'), style: 'color:#8492A6;' };
        case '1':
          return { vl: this.$t('app_preVerify'), style: 'color:#F7BA2A;' };
        case '2':
          return { vl: this.$t('app_verifyPass'), style: 'color:#13CE66;' };
        case '3':
          return { vl: this.$t('app_verifyNotPass'), style: 'color:#FF4949;' };
      }
    },
    srchDevice: function srchDevice() {
      this.getDevices();
    },
    selectDvChange: function selectDvChange(vl) {
      this.getDevices();
    },
    pageDvSized: function pageDvSized(val) {
      this.$gRow = val;
      this.getDevices();
    },
    getDevices: function getDevices() {
      var _this3 = this;

      var vl = this.srchValue ? this.srchValue : '';
      var channel = this.channelId ? this.channelId : '';
      var status = this.status ? this.status : '';
      var appId = this.appId ? this.appId : '';
      this.dvLoading = 1;
      if (this.$appUrlTag === 0) {
        this.$getDevices(this.dvIndex, this.$gRow, channel, vl, status, '', appId, function (res) {
          _this3.dvLoading = 0;
          if (res.status === 200) {
            _this3.dvTableData = res.data;
            _this3.dvTotal = res.total;
          }
        }, function () {
          _this3.dvLoading = 0;
        });
      } else {

        this.$getDevices1(this.dvIndex, this.$gRow, localStorage.mechanismId, vl, status, '', appId, function (res) {
          console.log('dv', res);
          _this3.dvLoading = 0;
          if (res.data) {
            _this3.dvTableData = res.data;
            _this3.dvTotal = res.total;
          }
        }, function () {
          _this3.dvLoading = 0;
        });
      }
    },
    editApp: function editApp(row) {
      this.$setWObj('launcherEdit', { type: 1, data: row });
      this.$router.push({ path: '/launch-edit' });
    },
    pushApp: function pushApp(row) {
      this.$router.push({ path: '/launch-push' });
    },
    query: function query() {
      this.getList();
    },
    selectChange: function selectChange(vl) {
      this.selectMid = vl;
      this.getList();
    },
    reset: function reset() {
      this.queryKey = '';
      this.appType = '';
      this.getList();
    },
    pageSelect: function pageSelect(index) {
      this.index = index;
      this.getList();
    },
    pageDvSelect: function pageDvSelect(index) {
      this.dvIndex = index;
      this.getDevices();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getList();
    },
    deleteApp: function deleteApp(obj) {
      var _this4 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        console.log(obj);
        _this4.$delLauncher(obj.launcherid, obj.status, function (res) {
          if (res.status === 200) {
            _this4.getList();
            _this4.$message.success(res.message);
          } else {
            _this4.$message.error(res.message);
          }
        }, '');
      }, '');
    },
    submitApp: function submitApp(obj) {
      var _this5 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_tipVerify'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this5.loading = 1;
        _this5.$submitLauncher(obj.launcherid, function (res) {
          _this5.loading = 0;
          if (res.status === 200) {
            _this5.getList();
            _this5.$message.success(res.message);
          } else {
            _this5.$message.error(res.message);
          }
        }, function () {
          _this5.loading = 0;
        });
      }, '');
    },
    cellClick: function cellClick(row, ev, col) {
      this.$router.push({ path: '/non-it-eq/src/verify', query: row });
    },
    jumpToUpload: function jumpToUpload() {

      this.$setWObj('launcherEdit', { type: 0 });
      this.$router.push({ path: '/addlaunch' });
    },
    getList: function getList() {
      var _this6 = this;

      this.loading = 1;
      var name = this.queryKey ? this.queryKey : '';

      var mech = '';
      this.$getasList(this.dvIndex, this.$gRow, '1', mech, '2', name, function (res) {
        console.log(res);
        _this6.loading = 0;
        if (res.status === 200) {
          _this6.total = res.total;
          _this6.tableData = res.data;
        } else {
          _this6.$message.error(res.message);
        }
      }, function () {
        _this6.loading = 0;
      });
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD HH:mm:ss');
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    }
  },
  mounted: function mounted() {
    this.getList();
  },
  destroyed: function destroyed() {}
});

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_tagc__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_tagc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_tagc__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default.a, tagc: __WEBPACK_IMPORTED_MODULE_3__components_global_tagc___default.a
  },
  data: function data() {
    var that = this;
    return {

      detail: {},
      appid: '',
      loading: false,
      labelttw: "34%"

    };
  },
  mounted: function mounted() {

    var appid = this.$getWObj().passageEdit;
    if (appid) {
      this.appid = appid;
      this.getDetail();
    }
  },

  methods: {
    getDetail: function getDetail() {
      var _this = this;

      this.loading = 1;
      this.$passageDetail(this.appid, function (res) {
        _this.loading = 0;
        if (res.code === 200) {
          _this.detail = res.data;
        } else {
          _this.$message(res.message);
        }
      }, function () {
        _this.loading = 0;
        _this.$message.error(_this.$t('app_rqsError'));
      });
    },
    goEdit: function goEdit() {
      this.$router.push({ path: '/openpl/passage/detail/edit' });
    },
    selectChange: function selectChange() {}
  }
});

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default.a
  },
  data: function data() {
    var _this2 = this;

    var phoneCheck = function phoneCheck(rule, value, callback) {
      if (!_this2.isLegalMobile(value)) {
        callback(new Error(_this2.$t('app_phoneIllegal')));
      } else {
        callback();
      }
    };
    var that = this;
    return {
      loading: false,
      appid: '',
      detail: '',

      dynamicTags: [],
      inputVisible: false,
      inputValue: '',
      dynamicTags_ip: [],
      inputVisible_ip: false,
      inputValue_ip: '',
      mechanismData: "",
      firm: {
        name: '',
        mech: '',
        callback: '',
        authst: '0'
      },
      radioVl: '',
      rules: {
        name: [{ required: true, message: this.$t('app_input'), trigger: 'blur' }],
        callback: [{ required: true, message: this.$t('app_input'), trigger: 'blur' }],

        mech: [{ required: true, message: this.$t('app_select'), trigger: 'blur' }]
      }
    };
  },

  methods: {
    getDetail: function getDetail() {
      var _this3 = this;

      this.loading = 1;
      var _this = this;
      this.$passageDetail(this.appid, function (res) {
        _this3.loading = 0;
        if (res.code === 200) {
          _this3.detail = res.data;

          var data = res.data;
          _this3.mechanismData = {
            value: data.merchantName,
            callback: function callback(value) {
              _this.firm.mech = value;
            }
          };

          _this3.firm.name = data.appname;
          _this3.firm.callback = data.callbackurl;
          _this3.firm.mech = data.merchantid;
          _this3.firm.authst = data.isauthen + '';
          _this3.dynamicTags = data.packageName ? data.packageName : [];
          _this3.dynamicTags_ip = data.limitIp ? data.limitIp : [];
        } else {
          _this3.$message(res.message);
        }
      }, function () {
        _this3.loading = 0;
        _this3.$message.error(_this3.$t('app_rqsError'));
      });
    },
    handleCloseIP: function handleCloseIP(tag) {
      this.dynamicTags_ip.splice(this.dynamicTags_ip.indexOf(tag), 1);
    },
    showInputIP: function showInputIP() {
      var _this4 = this;

      this.inputVisible_ip = true;
      this.$nextTick(function (_) {
        _this4.$refs.saveTagInput_ip.$refs.input.focus();
      });
    },
    handleInputConfirmIP: function handleInputConfirmIP() {
      var inputValue = this.inputValue_ip;
      if (inputValue) {
        this.dynamicTags_ip.push(inputValue);
      }
      this.inputVisible_ip = false;
      this.inputValue_ip = '';
    },
    handleClose: function handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    showInput: function showInput() {
      var _this5 = this;

      this.inputVisible = true;
      this.$nextTick(function (_) {
        _this5.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm: function handleInputConfirm() {
      var inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    isLegalMobile: function isLegalMobile(tel) {
      var sMobile = tel;
      var regex = "^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\\d{8}$";
      var re = new RegExp(regex, 'g');
      if (!re.test(sMobile)) {
        return false;
      } else {
        return true;
      }
    },
    newfirm: function newfirm() {
      var _this6 = this;

      this.loading = 1;

      var param = {
        "appName": this.firm.name,
        "isAuthen": this.firm.authst,
        "merchantId": this.firm.mech,
        "callbackUrl": this.firm.callback,
        "encryptType": "MD5",
        "appownerType": "",
        "limitIp": this.dynamicTags_ip,
        "packageNames": this.dynamicTags
      };
      this.$addPassage(param, function (res) {
        _this6.loading = 0;
        if (res.code === 200) {
          _this6.$router.go(-1);
        } else {
          _this6.$message.error(res.message);
        }
      }, function () {
        _this6.loading = 0;
      });
    },
    editfirm: function editfirm() {
      var _this7 = this;

      this.loading = 1;
      var param = {
        "appId": this.appid,
        "appName": this.firm.name,
        "isAuthen": this.firm.authst,
        "merchantId": this.firm.mech,
        "callbackUrl": this.firm.callback,
        "encryptType": "MD5",
        "appownerType": "",
        "limitIp": this.dynamicTags_ip,
        "packageNames": this.dynamicTags
      };
      this.$editPassage(param, function (res) {
        _this7.loading = 0;
        if (res.code === 200) {
          _this7.$router.go(-1);
        } else {
          _this7.$message.error(res.message);
        }
      }, function () {
        _this7.loading = 0;
      });
    },
    save: function save(name) {
      var _this8 = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          if (!_this8.appid) {
            _this8.newfirm();
          } else {
            _this8.editfirm();
          }
        } else {
          return false;
        }
      });
    },
    cancel: function cancel() {
      this.$router.go(-1);
    },
    fillData: function fillData() {
      var _this = this;
      var data = this.detail;
      this.mechanismData = {
        placeholder: this.$t('lin_global.place_areaid'),
        value: data.merchantid,
        callback: function callback(value) {
          _this.firm.mech = value;
        }
      };

      this.firm.name = data.appname;
      this.firm.callback = data.callbackurl;
      this.firm.mech = data.merchantid;
      this.firm.authst = data.isauthen + '';
      this.dynamicTags = data.packageName ? data.packageName : [];
      this.dynamicTags_ip = data.limitIp ? data.limitIp : [];
    }
  },
  mounted: function mounted() {
    var appid = this.$getWObj().passageEdit;
    if (appid) {
      this.appid = appid;
      this.getDetail();
    } else {
      var _this = this;
      this.mechanismData = {
        callback: function callback(value) {
          _this.firm.mech = value;
        }
      };
    }
  }
});

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_tagc_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_tagc_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_global_tagc_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_tyc_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_tyc_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_tyc_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default.a, tagc: __WEBPACK_IMPORTED_MODULE_2__components_global_tagc_vue___default.a, tyc: __WEBPACK_IMPORTED_MODULE_3__components_global_tyc_vue___default.a
  },
  data: function data() {
    var that = this;
    return {
      isShowSec: false,
      mechanismData: {
        callback: function callback(value) {
          that.mech = value;
          that.getList();
        }
      },
      gloading: false,
      keyInfo: '',
      listKey: 'launch-list',
      cerDialogVisible: false,
      cerTipDialogVisible: false,
      dvLoading: 0,
      appId: '',
      tqobj: '',
      authSts: [],
      stModel: [{ label: this.$t('app_online'), vl: '1' }, { label: this.$t('app_offline'), vl: '2' }, { label: this.$t('app_new'), vl: '0' }],
      channels: [],
      mech: '',
      srchValue: '',
      channelId: '',
      cerTipMsg: '',
      status: '',
      dvIndex: 1,
      dialogVisible: 0,
      mechanismId: window.localStorage['mechanismId'],
      selectMid: '',
      tableData: [],
      dvTableData: [],
      appTypes: [],
      appTypeValue: '',
      appStatus: [{ label: this.$t('app_prePushVerify'), value: '0' }, { label: this.$t('app_preVerify'), value: '1' }, { label: this.$t('app_verifyPass'), value: '2' }, { label: this.$t('app_verifyNotPass'), value: '3' }],
      appStatusValue: '',
      total: 0,
      dvTotal: 0,
      loading: 0,
      appType: '',
      queryKey: ''
    };
  },

  computed: {
    showkeylb: function showkeylb() {
      if (this.isShowSec) {
        return this.$t('app_hide');
      } else {
        return this.$t('app_view');
      }
    },
    index: function index() {
      var vl = this.$getWPage(this.listKey);
      return vl ? vl : 1;
    },
    getDvStatus: function getDvStatus(value) {
      switch (value) {
        case '0':
          return this.$t('app_prePushVerify');
        case '1':
          return this.$t('app_preVerify');
        case '2':
          return this.$t('app_verifyPass');
        case '3':
          return this.$t('app_verifyNotPass');
      }
    }
  },
  methods: {
    showclick: function showclick() {
      this.isShowSec = !this.isShowSec;
    },
    generateKey: function generateKey() {
      var _this = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_gentip'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this.gloading = 1;
        var id = localStorage.userId;
        _this.$generateKey(id, function (res) {
          _this.gloading = 0;
          var secret = res.data;
          _this.$setWObj('keyInfo', { key: _this.keyInfo.key, secret: secret });
          _this.keyInfo.secret = secret;
          _this.$message(res.message);
        }, function () {
          _this.gloading = 0;
          _this.$message.error(_this.$t('app_rqsError'));
        });
      }, '');
    },
    pushCreateCer: function pushCreateCer() {
      this.$router.push({ path: "/certificate/new" });
    },
    pushUploadCer: function pushUploadCer() {
      this.$router.push({ path: "/certificate/upload" });
    },
    bindOperate: function bindOperate(row) {
      var _this2 = this;

      this.dvLoading = 1;
      if (this.$appUrlTag === 0) {
        this.$bindApp('0', row.terminalNo, this.appId, function (res) {
          if (res.status === 200) {
            _this2.$message.success(_this2.$t('app_tipViewTask'));
          } else {
            _this2.$message.error(res.message);
          }
          _this2.dvLoading = 0;
        }, function () {
          _this2.dvLoading = 0;
        });
      } else {
        this.$bindApp1(localStorage.mechanismId, row.terminalNo, this.appId, function (res) {
          if (res.status === 200) {
            _this2.$message.success(_this2.$t('app_tipViewTask'));
          } else {
            _this2.$message.error(res.message);
          }
          _this2.dvLoading = 0;
        }, function () {
          _this2.dvLoading = 0;
        });
      }
    },
    getChannels: function getChannels() {
      var _this3 = this;

      this.$getChannelList(10000, 1, '', '', '', function (res) {
        if (res.status === 200) {
          _this3.channels = res.data;
        } else {
          _this3.$message.error(res.message);
        }
      }, function () {
        _this3.$message.error(_this3.$t('app_rqsError'));
      });
    },
    getStatus: function getStatus(value) {
      if (!value) return '';
      switch (value) {
        case '0':
          return { vl: this.$t('app_prePushVerify'), style: 'color:#8492A6;' };
        case '1':
          return { vl: this.$t('app_preVerify'), style: 'color:#F7BA2A;' };
        case '2':
          return { vl: this.$t('app_verifyPass'), style: 'color:#13CE66;' };
        case '3':
          return { vl: this.$t('app_verifyNotPass'), style: 'color:#FF4949;' };
      }
    },
    srchDevice: function srchDevice() {
      this.getDevices();
    },
    selectDvChange: function selectDvChange(vl) {
      this.getDevices();
    },
    pageDvSized: function pageDvSized(val) {
      this.$gRow = val;
      this.getDevices();
    },
    getDevices: function getDevices() {
      var _this4 = this;

      var vl = this.srchValue ? this.srchValue : '';
      var channel = this.channelId ? this.channelId : '';
      var status = this.status ? this.status : '';
      var appId = this.appId ? this.appId : '';
      this.dvLoading = 1;
      if (this.$appUrlTag === 0) {
        this.$getDevices(this.dvIndex, this.$gRow, channel, vl, status, '', appId, function (res) {
          _this4.dvLoading = 0;
          if (res.data) {
            _this4.dvTableData = res.data;
            _this4.dvTotal = res.total;
          }
        }, function () {
          _this4.dvLoading = 0;
        });
      } else {

        this.$getDevices1(this.dvIndex, this.$gRow, localStorage.mechanismId, vl, status, '', appId, function (res) {
          console.log('dv', res);
          _this4.dvLoading = 0;
          if (res.data) {
            _this4.dvTableData = res.data;
            _this4.dvTotal = res.total;
          }
        }, function () {
          _this4.dvLoading = 0;
        });
      }
    },
    editApp: function editApp(row) {

      this.$setWObj('passageEdit', row.appid);
      this.$router.push({ path: '/openpl/passage/edit' });
    },
    pushApp: function pushApp(row) {

      this.$setWObj('pushList', { type: '10', data: row });
      this.$router.push({ path: '/launch-push' });
    },
    query: function query() {
      this.getList();
    },
    selectChange: function selectChange(vl) {
      this.selectMid = vl;
      this.getList();
    },
    reset: function reset() {
      this.queryKey = '';
      this.appType = '';
      this.getList();
    },
    pageSelect: function pageSelect(index) {
      this.$setWPage(this.listKey, index);
      this.getList();
    },
    pageDvSelect: function pageDvSelect(index) {
      this.dvIndex = index;
      this.getDevices();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getList();
    },
    deleteApp: function deleteApp(obj) {
      var _this5 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {

        _this5.$delPassage(obj.appid, function (res) {
          if (res.code === 200) {
            _this5.getList();
            _this5.$message.success(res.message);
          } else {
            _this5.$message.error(res.message);
          }
        }, '');
      }, '');
    },
    submitApp: function submitApp(obj) {
      var _this6 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_tipVerify'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this6.loading = 1;
        _this6.$submitLauncher(obj.launcherid, function (res) {
          _this6.loading = 0;
          if (res.status === 200) {
            _this6.getList();
            _this6.$message.success(res.message);
          } else {
            _this6.$message.error(res.message);
          }
        }, function () {
          _this6.loading = 0;
        });
      }, '');
    },
    cellClick: function cellClick(row, ev, col) {

      if (col.label && col.label === this.$t('app_operate')) {
        return;
      }

      this.$setWObj('passageEdit', row.appid);
      this.$router.push({ path: '/openpl/passage/detail' });
    },
    jumpToUpload: function jumpToUpload() {

      this.$setWObj('passageEdit', '');
      this.$router.push({ path: '/openpl/passage/add' });
    },
    getList: function getList() {
      var _this7 = this;

      this.loading = 1;
      var isauth = this.selectMid ? this.selectMid : '';
      var name = this.queryKey ? this.queryKey : '';
      var mech = this.mech;

      this.$passageList(this.index, this.$gRow, name, isauth, mech, function (res) {
        _this7.loading = 0;
        if (res.code === 200) {
          _this7.total = res.total;
          _this7.tableData = res.data;
        } else {
          _this7.$message(res.message);
        }
      }, function () {
        _this7.loading = 0;
        _this7.$message.error(_this7.$t('app_rqsError'));
      });
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD HH:mm:ss');
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    }
  },
  mounted: function mounted() {
    var _this8 = this;

    this.tqobj = {
      keys: ['openplAuths'],
      callback: function callback(data) {
        _this8.authSts = data[0];
      }
    };

    this.getList();


    this.keyInfo = this.$getWObj().keyInfo;
  },
  destroyed: function destroyed() {}
});

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_TernoAutoCtrl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_TernoAutoCtrl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_TernoAutoCtrl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__node_modules_element_ui_packages_form_src_form_item_vue__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__node_modules_element_ui_packages_form_src_form_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__node_modules_element_ui_packages_form_src_form_item_vue__);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ElFormItem: __WEBPACK_IMPORTED_MODULE_6__node_modules_element_ui_packages_form_src_form_item_vue___default.a,
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_5__components_global_mechanism_selector_vue___default.a, AutoTerno: __WEBPACK_IMPORTED_MODULE_4__global_TernoAutoCtrl___default.a
  },
  data: function data() {
    var that = this;
    return {
      raw: '',
      terminalConfigForm: {
        checkUpdateTime: 0,
        pushTime: 20,
        data: {
          get: ['l'],
          set: {
            hb: 10
          }
        }
      },
      mechanismData: {
        placeholder: that.$t('lin_global.place_areaid'),
        callback: function callback(value) {
          that.value1 = value;
        }
      },
      exInfo: '',
      devices: 0,
      srcList: [],
      isSubmit: false,
      logoCheck: false,
      oldLogo: '',
      loading: 0,
      logo: '',
      logoValue: '',
      activeName: 'first',
      isShow: false,
      options: [{
        value: '0',
        label: this.$t('lin_global.label_areaid')
      }, {
        value: '1',
        label: this.$t('lin_global.shebeibei')
      }, {
        value: '2',
        label: this.$t('app_fileImport')
      }],
      arrdata: [],
      currentPage: 1,
      pageSize: 10,
      totalRecords: 0,
      value: '0',
      value1: '',
      areaList1: [],
      setForm: {
        url: '',
        port: ''
      },
      url: '',
      port: '',
      rules: {
        'url': [{
          type: 'string',
          required: true,
          message: this.$t('lin_global.fwqdzbnwk')
        }],
        'port': [{
          type: 'string',
          required: true,
          message: this.$t('lin_global.fwqdkhbnwk')
        }]
      }
    };
  },

  computed: {
    imgUploadUrl: function imgUploadUrl() {
      return this.$urls.picUrl;
    },
    downUrl: function downUrl() {
      return this.$host + '/tms-server-web/model/terminalNos.xlsx';
    }
  },
  created: function created() {
    this.getData(1);
  },

  watch: {
    'terminalConfigForm.data.set.hb': function terminalConfigFormDataSetHb(val, old) {
      var that = this;
      if (that.terminalConfigForm.checkUpdateTime < val + 5) {
        that.terminalConfigForm.checkUpdateTime = val + 5;
      }
    }
  },
  methods: {
    saveTerminalConfig: function saveTerminalConfig() {
      var _this = this;

      var that = this;

      var value = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(that.terminalConfigForm, null, 4);
      if (this.raw) {
        this.loading = true;
        this.$setDvSetting(this.raw.id, value, function (res) {
          _this.loading = false;
          _this.$message.success(res.message);
        }, function (error) {
          _this.loading = false;
          _this.$message.error(_this.$t('app_rqsError'));
        });
      } else {
        this.$message.error('error');
      }
    },
    onDvInputChange: function onDvInputChange(vl) {
      this.value1 = vl;
    },
    pushType: function pushType(row) {
      switch (row.type) {
        case '0':
          return this.$t('app_distributor');
          break;
        case '1':
          return this.$t('app_dv');
          break;
        case '2':
          return this.$t('terminal.list.import_btn');
          break;
      }
    },
    srcBefore: function srcBefore(file) {
      window[this.$route.path] = 1;
    },
    srcSuccess: function srcSuccess(res, file) {
      window[this.$route.path] = '';
      console.log('exres', res);
      if (res.status === 200) {
        this.srcList = [{ name: file.name }];
        this.exInfo = res.data;
        this.exInfo.file = file.name;
        this.devices = res.data.terNums;
      } else {
        if (this.exInfo.file) {
          this.srcList = [{ name: this.exInfo.file }];
        } else {
          this.srcList = [];
        }
        this.$message.error(res.message);
      }
    },
    handleClick: function handleClick(tab, event) {},
    defaultLogo: function defaultLogo() {
      var _this2 = this;

      this.loading = 1;
      this.$editLogo(localStorage.mechanismId, '', function (res) {
        _this2.loading = 0;
        if (res.status === 200) {
          _this2.$message.success(res.message);
          _this2.$store.dispatch('setHomeLogo', 'null');
          localStorage.logo = 'null';
          _this2.oldLogo = 'null';
          _this2.cancelLogo();
        } else {
          _this2.$message.error(res.message);
        }
      }, function () {
        _this2.loading = 0;
        _this2.$message.error(_this2.$t('app_rqsError'));
      });
    },
    saveLogo: function saveLogo() {
      var _this3 = this;

      if (!this.logoValue) {
        this.$message(this.$t('app_uploadPic'));
        return;
      }

      var sizeVl = this.logoCheck ? 1 : 0;
      console.log(sizeVl);

      this.loading = 1;
      this.$editLogo(localStorage.mechanismId, this.logoValue, function (res) {
        _this3.loading = 0;
        if (res.status === 200) {
          _this3.$message.success(res.message);
          _this3.oldLogo = _this3.logoValue;
          localStorage.logo = _this3.oldLogo;
          _this3.cancelLogo();
        } else {
          _this3.$message.error(res.message);
        }
      }, function () {
        _this3.loading = 0;
        _this3.$message.error(_this3.$t('app_rqsError'));
      });
    },
    cancelLogo: function cancelLogo() {
      this.logo = '';
      this.logoValue = '';
      this.$store.dispatch('setHomeLogo', this.oldLogo);
    },
    handleBgAvatarSuccess: function handleBgAvatarSuccess(res, file) {
      this.loading = 0;
      if (res.status !== 200) {
        this.$message.error(res.message);
      } else {
        this.logoValue = res.data;
        this.logo = URL.createObjectURL(file.raw);
        this.$store.dispatch('setHomeLogo', res.data);
      }
    },
    beforeBgAvatarUpload: function beforeBgAvatarUpload(file) {
      var size = file.size / 1024;
      if (size > 200) {
        this.$message.error(this.$t('app_fileOver') + '200k');
        return false;
      }
      this.loading = 1;
      return true;
    },

    formatStatus: function formatStatus(row, column) {
      return row.type == 0 ? this.$t('lin_global.label_areaid') : row.userStatus == 1 ? this.$t('lin_global.shebeibei') : '';
    },

    getAd1: function getAd1() {
      var _this4 = this;

      var params = { page: 1, rows: 10000 };
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__api_url__["a" /* baseurl */] + '/mechanism/list.do', params).then(function (res) {
        var obj = {
          'mechanismname': _this4.$t('lin_global.all_mechanism'),
          'mechanismid': ''
        };
        _this4.areaList1 = res.data.data;

        _this4.areaList1.unshift(obj);
      });
    },
    onCreate: function onCreate() {},
    submitRow: function submitRow(type, config, mechId, terminalNo) {
      var _this5 = this;

      var id = '';
      if (type === "0") {
        id = mechId;
      } else {
        id = terminalNo;
      }
      var params = { targetType: type, targetId: id, conf: config };
      this.$confirm(this.$t('lin_global.wdct'), this.$t('lin_btn.tips'), {
        confirmButtonText: this.$t('lin_btn.confirm'),
        cancelButtonText: this.$t('lin_btn.cancel'),
        type: 'warning'
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__api_url__["a" /* baseurl */] + '/sysConfig/setTmsServerConf.do', params).then(function (res) {
          if (res.data.status == 200) {
            _this5.$message.success(res.data.message);
          } else {
            _this5.$message.error(res.data.message);
          }
        });
      });
    },
    onChange: function onChange(val) {
      this.value1 = '';
      if (val === '0') {
        this.isShow = false;
      } else {
        this.isShow = true;
      }
    },
    onSave: function onSave() {
      var _this6 = this;

      this.$refs['setForm'].validate(function (valid) {

        if (valid) {
          if (_this6.value === '2' && !_this6.exInfo) {
            _this6.$message.error(_this6.$t('app_plsUpl'));
            return;
          }
          var host = _this6.setForm.url + ':' + _this6.setForm.port;
          var fn = _this6.exInfo.fileNo ? _this6.exInfo.fileNo : '';
          var params = { fileNo: fn, targetType: _this6.value, targetId: _this6.value1, conf: host };
          _this6.$confirm(_this6.$t('lin_global.tuisongtips') + host, _this6.$t('lin_btn.tips'), {
            confirmButtonText: _this6.$t('lin_btn.confirm'),
            cancelButtonText: _this6.$t('lin_btn.cancel'),
            type: 'warning'
          }).then(function () {
            _this6.isSubmit = true;
            _this6.loading = 1;
            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__api_url__["a" /* baseurl */] + '/sysConfig/setTmsServerConf.do', params).then(function (res) {
              if (res.data.status == 200) {
                _this6.loading = 0;
                _this6.$message.success(res.data.message);
                _this6.isSubmit = false;
              } else {
                _this6.loading = 0;
                _this6.$message.error(res.data.message);
                _this6.isSubmit = false;
              }
            });
          }).catch(function () {
            _this6.loading = 0;
          });
        } else {
          _this6.loading = 0;
          _this6.$message.error(_this6.$t('lin_global.refs'));
          return false;
        }
      });
    },

    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getData(this.currentPage);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.getData(this.currentPage);
    },
    getData: function getData(page) {
      var _this7 = this;

      this.currentPage = page;
      var params = { page: page, rows: this.pageSize };

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__api_url__["a" /* baseurl */] + '/sysConfig/terConfigCount.do', params).then(function (res) {
        console.log('his res', res.data);
        _this7.arrdata = res.data.data;
        _this7.totalRecords = res.data.total;
        for (var i = 0; i < res.data.data.length; i++) {
          if (res.data.data[i].failNum > 0) {
            res.data.data[i]['submit'] = true;
          } else {
            res.data.data[i]['submit'] = false;
          }
        }
      });
    }
  },
  mounted: function mounted() {
    var _this8 = this;

    this.oldLogo = localStorage.logo;

    this.$getDvSetting(function (res) {
      if (res.status === 200) {
        var data = res.data;
        if (data.length > 0) {
          data = data[0];
          _this8.raw = data;
          _this8.terminalConfigForm = JSON.parse(data.value);
        }
      } else {
        _this8.$message.error(res.message);
      }
    }, '');
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    var _this9 = this;

    if (this.logo) {
      this.$showConfirm('', this.$t('app_logoLvTip'), this.$t('app_yes'), this.$t('app_no'), 'warning', function () {
        next();
        _this9.$store.dispatch('setHomeLogo', _this9.oldLogo);
      }, function () {
        return false;
      });
    } else {
      next();
      this.$store.dispatch('setHomeLogo', this.oldLogo);
    }
  }
});

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__city_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_global_tyc_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_global_tyc_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_global_tyc_vue__);









/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		MechanismSelector: __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default.a, tyc: __WEBPACK_IMPORTED_MODULE_5__components_global_tyc_vue___default.a
	},
	data: function data() {
		var _ref;

		var that = this;
		return _ref = {
			mechanismData: {
				callback: function callback(value) {
					that.lMech = value;
					that.getList(this.currentPage);
				}
			},
			mechanismData1: {
				callback: function callback(value) {
					that.value1 = value;
					that.statusChange();
				}
			},
			selVl: '',
			tqobj: '',
			tstatus: '',
			tstVl: '',
			queryKey: '',
			form: {
				name: '',
				desc: '',
				city: '',
				radius: ''
			},
			isProv: false,
			wtype: '1',
			lMech: '',
			showEdit: false,
			options2: __WEBPACK_IMPORTED_MODULE_4__city_js__["a" /* default */],
			focusEvent: __WEBPACK_IMPORTED_MODULE_2__api_url__["c" /* focusEvent */],
			input1: '',
			value1: '',
			areaList1: [],
			dialogFormVisible: false,
			dialogTopMgVisible: false,
			ifshow: true,
			ifShow: true,
			riskId: this.$route.params.id,
			riskInfo: {},
			areaList: [],
			radius: '',
			citys: '',
			currentPage: 1,
			pageSize: 10,
			totalRecords: 0,
			currentPage1: 1,
			pageSize1: 10,
			totalRecords1: 0
		}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'form', {
			controllerName: '',
			controllerDesc: '',
			messageId: '',
			controlType: ''
		}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'params', {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'arrdata', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'arrdata1', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'multipleSelection', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'multipleSelection1', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'orderType', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'orderName', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'riskType', {
			'0': this.$t('lin_global.jwd'),
			'1': this.$t('lin_global.city'),
			'2': this.$t('lin_global.shengfen')

		}), _ref;
	},
	created: function created() {

		this.getDetail();
		this.getAd();
		this.getList(1);
		this.getData(1, '', '');
		this.getAd1();
	},
	mounted: function mounted() {

		var _this = this;
		this.tqobj = {
			keys: ['terminalTypes'],
			callback: function callback(data) {
				_this.tstatus = data[0];
				console.log('fff', _this.tstatus);
			}
		};
	},

	methods: {
		closeBindAlert: function closeBindAlert() {
			var _this = this;
			this.mechanismData1 = {
				callback: function callback(value) {
					_this.value1 = value;
					_this.statusChange();
				}
			};
			this.value1 = '';
			this.tstVl = '';
			this.input1 = '';
			this.dialogTopMgVisible = false;
		},
		bindRqs: function bindRqs(id, isForce) {
			var _this2 = this;

			var params = { riskId: this.riskId, terminalId: id, status: '0', force: isForce ? '1' : '0' };
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/risk/bindingTerminal.do', params).then(function (res) {
				if (res.data.status == '200') {
					_this2.$message.success(_this2.$t('lin_global.bdcg'));
					_this2.getList(_this2.currentPage);
					_this2.closeBindAlert();
				} else if (res.data.status == 300) {
					_this2.$showConfirm(_this2.$t("app_tip"), res.data.message, _this2.$t("app_sure"), _this2.$t("app_cancel"), "warning", function () {
						_this2.bindRqs(id, true);
					}, "");
				} else {
					_this2.$message.error(res.data.message);
				}
			});
		},
		sortChange: function sortChange(a) {
			switch (a.prop) {
				case 'terminalName':
					this.orderName = '1';
					break;
				case 'terminalNo':
					this.orderName = '2';
					break;
				case 'bindingtime':
					this.orderName = '3';
					break;
			}
			this.orderType = a.order == 'descending' ? 'desc' : 'asc';
			this.getList(this.currentPage);
		},
		query: function query() {
			this.getList(this.currentPage);
		},
		submit2: function submit2() {
			var _this3 = this;

			this.params = {
				id: this.riskId
			};
			if (this.wtype == '0') {
				this.params.radius = this.form.radius;
				this.params.controllerName = this.form.name;
				this.params.controllerDesc = this.form.desc;
				this.params.messageId = this.form.messageId;
				this.params.controlType = this.wtype;

				if (isNaN(Number(this.form.radius)) || Number(this.form.radius) <= 0.5) {
					this.$message.error(this.$t('app_rdneedmore') + '0.5');
					return;
				}
			} else {
				var cname = '';
				var tmpsub = [];
				if (!this.isProv) {
					var fcode = this.form.city[0];
					var scode = this.form.city.length == 2 ? this.form.city[1] : '';
					__WEBPACK_IMPORTED_MODULE_4__city_js__["a" /* default */].forEach(function (item) {
						if (item.value == fcode) {
							item.children.forEach(function (sitem) {
								if (sitem.value == scode) {
									cname = sitem.province == sitem.label ? sitem.label : sitem.province + sitem.label;
									return;
								}
							});
						}
					});
				} else {
					this.wtype = '2';
					__WEBPACK_IMPORTED_MODULE_4__city_js__["a" /* default */].forEach(function (item) {
						if (item.value == _this3.selVl) {
							cname = item.label;
							return;
						}
					});
				}
				this.params.city = cname + ',' + (this.isProv ? this.selVl : this.form.city.toString());


				this.params.controllerName = this.form.name;
				this.params.controllerDesc = this.form.desc;
				this.params.messageId = this.form.messageId;
				this.params.controlType = this.wtype;
			}

			if (!this.params.city && (this.wtype == '1' && this.wtype == '2' || this.form.controlType == 'undefined')) {
				this.$message(this.$t('lin_global.risk_city'));
				return;
			}

			if (typeof this.params.city !== 'string') {
				this.params.city = this.riskInfo.city;
			}

			var params = this.params;
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/risk/editRisk.do', params).then(function (res) {
				if (res.data.status == 200) {

					_this3.form.city = '';
					_this3.params.city = '';

					_this3.showEdit = false;
					_this3.$message.success(res.data.message);

					_this3.getDetail();
				} else {
					_this3.showEdit = false;
					_this3.$message.error(res.data.message);
				}
			});
		},

		selEvent2: function selEvent2(val) {
			return;
		},
		hasValue: function hasValue(result, v, name) {
			if (!v[name] || v[name] === "") {
				return true;
			}
			return result.some(function (re) {
				return v[name] === re;
			});
		},
		batchUnBind: function batchUnBind() {
			var _this4 = this;

			this.$confirm(this.$t('lin_global.sfjxpljb'), this.$t('lin_btn.tips'), {
				confirmButtonText: this.$t('lin_btn.confirm'),
				cancelButtonText: this.$t('lin_btn.cancel'),
				type: 'warning'
			}).then(function () {
				var ids = [];
				if (_this4.multipleSelection.length === 0) {
					_this4.$message.error(_this4.$t('lin_global.qxzyjbdzd'));
					return false;
				}
				for (var i = 0; i < _this4.multipleSelection.length; i++) {
					ids.push(_this4.multipleSelection[i].terminalid);
				}
				var rq = ids.join(',');
				var params = { riskId: _this4.riskId, terminalId: rq, status: '1' };
				__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/risk/bindingTerminal.do', params).then(function (res) {
					if (res.data.status == '200') {
						_this4.$message.success(_this4.$t('lin_global.jbcg'));
						_this4.getList(1);
						_this4.dialogTopMgVisible = false;
					} else {
						_this4.$message.error(res.data.message);
					}
				});
			}).catch(function () {});
		},

		unBind: function unBind(id) {
			var _this5 = this;

			var params = { riskId: this.riskId, terminalId: id, status: '1' };
			this.$confirm(this.$t('lin_global.sfjbczd'), this.$t('lin_btn.tips'), {
				confirmButtonText: this.$t('lin_btn.confirm'),
				cancelButtonText: this.$t('lin_btn.cancel'),
				type: 'warning'
			}).then(function () {
				__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/risk/bindingTerminal.do', params).then(function (res) {
					if (res.data.status == '200') {
						_this5.$message.success(_this5.$t('lin_global.jbcg'));
						_this5.getList(1);
						_this5.dialogTopMgVisible = false;
					} else {
						_this5.$message.error(res.data.message);
					}
				});
			});
		},
		batchBindRow: function batchBindRow() {
			var _this6 = this;

			if (this.multipleSelection1.length === 0) {
				this.$message.error(this.$t('lin_global.qxzybddzd'));
				return false;
			} else {
				this.$confirm(this.$t('lin_global.sfjxplbd'), this.$t('lin_btn.tips'), {
					confirmButtonText: this.$t('lin_btn.confirm'),
					cancelButtonText: this.$t('lin_btn.cancel'),
					type: 'warning'
				}).then(function () {
					var ids = [];

					for (var i = 0; i < _this6.multipleSelection1.length; i++) {
						ids.push(_this6.multipleSelection1[i].terminalId);
					}
					var rq = ids.join(',');
					_this6.bindRqs(rq);
				});
			}
		},
		bindRow: function bindRow(id, isForce) {
			var _this7 = this;

			this.$confirm(this.$t('lin_global.sfbdczd'), this.$t('lin_btn.tips'), {
				confirmButtonText: this.$t('lin_btn.confirm'),
				cancelButtonText: this.$t('lin_btn.cancel'),
				type: 'warning'
			}).then(function () {
				_this7.bindRqs(id);
			});
		},
		getData: function getData(page, no, areaid) {
			var _this8 = this;

			var tNo = this.input1 ? this.input1 : '';

			this.currentPage1 = page;
			var status = this.tstVl;

			this.$unbindDevices(page, this.pageSize1, areaid, this.riskId, status, tNo, function (res) {
				if (res.status === 200) {
					_this8.arrdata1 = res.data;
					_this8.totalRecords1 = res.total;
				} else {
					_this8.$message.error(res.message);
				}
			}, function (error) {
				_this8.$message.error(_this8.$t('app_rqsError'));
			});
		},
		statusChange: function statusChange() {
			this.getData(1, this.input1, this.value1);
		},
		handleIconClick: function handleIconClick() {
			this.getData(1, this.input1, this.value1);
		},

		getAd1: function getAd1() {
			var _this9 = this;

			var params = { page: 1, rows: 10000 };
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/mechanism/list.do', params).then(function (res) {
				var obj = {
					'mechanismname': _this9.$t('lin_global.all_mechanism'),
					'mechanismid': ''
				};
				_this9.areaList1 = res.data.data;

				_this9.areaList1.unshift(obj);
			});
		},
		addBind: function addBind() {
			this.dialogTopMgVisible = true;
			this.statusChange();
		},
		submit: function submit() {
			var _this10 = this;

			this.params = {};
			if (this.form.controlType == '0') {
				this.params.id = this.riskId;
				this.params.radius = this.radius;
				this.params.controllerName = this.form.controllerName;
				this.params.controllerDesc = this.form.controllerDesc;
				this.params.messageId = this.form.messageId;
				this.params.controlType = this.form.controlType;
			} else {
				this.params.id = this.riskId;
				this.params.city = this.citys;
				this.params.controllerName = this.form.controllerName;
				this.params.controllerDesc = this.form.controllerDesc;
				this.params.messageId = this.form.messageId;
				this.params.controlType = this.form.controlType;
			}

			var params = this.params;
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/risk/editRisk.do', params).then(function (res) {
				if (res.data.status == 200) {
					_this10.dialogFormVisible = false;
					_this10.$message.success(res.data.message);
					_this10.getDetail();
				} else {
					_this10.dialogFormVisible = false;
					_this10.$message.error(res.data.message);
				}
			});
		},
		change: function change() {},
		handleSelectionChange: function handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		handleSelectionChange1: function handleSelectionChange1(val) {
			this.multipleSelection1 = val;
		},

		onCancel: function onCancel() {
			this.dialogFormVisible = false;
		},
		getAd: function getAd() {
			var _this11 = this;

			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/risk/getMessageInform.do', {}).then(function (res) {
				_this11.areaList = res.data.data;
			});
		},
		handleSizeChange: function handleSizeChange(val) {
			this.pageSize = val;
			this.getList(this.currentPage);
		},
		handleCurrentChange: function handleCurrentChange(val) {
			this.currentPage = val;
			this.getList(this.currentPage);
		},
		handleSizeChange1: function handleSizeChange1(val) {
			this.pageSize1 = val;
			this.getData(this.currentPage1, this.input1, this.value1);
		},
		handleCurrentChange1: function handleCurrentChange1(val) {
			this.currentPage1 = val;
			this.getData(this.currentPage1, this.input1, this.value1);
		},
		getList: function getList(page) {
			var _this12 = this;

			this.currentPage = page;
			var tno = this.queryKey;
			var mech = this.lMech;

			var params = { orderName: this.orderName, orderType: this.orderType, riskId: this.riskId, page: page, rows: this.pageSize, terminalNo: tno, mechanismId: mech };
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/risk/getByIdTerminalRisk.do', params).then(function (res) {
				_this12.arrdata = res.data.data;
				_this12.totalRecords = res.data.total;
			});
		},
		getDetail: function getDetail() {
			var _this13 = this;

			var params = { riskId: this.riskId };
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/risk/getByIdRisk.do', params).then(function (res) {
				_this13.riskInfo = res.data.data;
				_this13.form.name = res.data.data.controlName;
				_this13.form.desc = res.data.data.controlDesc;
				_this13.wtype = res.data.data.controlType;
				_this13.form.messageId = res.data.data.messageid;
				if (res.data.data.controlType == '0') {
					_this13.form.radius = res.data.data.radius;
				} else {

					var arr = res.data.data.city.split(',');
					if (arr.length == 3) {
						var city = [];
						city.push(arr[1]);
						city.push(arr[2]);
						_this13.form.city = city;
						_this13.isProv = false;
					} else {
						_this13.selVl = arr[1];
						_this13.isProv = true;
					}
					if (_this13.isProv) _this13.wtype = '1';
				}
			});
		},

		edit: function edit() {
			this.dialogFormVisible = true;
		}
	}
});

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__city_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_global_tyc_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_global_tyc_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_global_tyc_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__citys_js__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_timers__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_global_mechanism_selector_vue__);











/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    tyc: __WEBPACK_IMPORTED_MODULE_4__components_global_tyc_vue___default.a, MechanismSelector: __WEBPACK_IMPORTED_MODULE_7__components_global_mechanism_selector_vue___default.a
  },
  data: function data() {
    var _this = this;
    return {
      mechanismData: {
        callback: function callback(value) {
          _this.value1 = value;
          _this.statusChange();
        }
      },
      stvl: '',
      sttyps: [],
      tqobj: '',
      rules: {
        name: [{ required: true, message: ' ', trigger: 'blur' }]
      },
      isProv: false,
      orderType: '',
      orderName: '',
      sel: [],
      sel2: [],
      selVl: '',
      selVl2: '',
      options: JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_3__city_js__["a" /* default */])),
      options2: JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_3__city_js__["a" /* default */])),
      focusEvent: __WEBPACK_IMPORTED_MODULE_2__api_url__["c" /* focusEvent */],
      riskId: '',
      radius: '',
      citys: '',
      radius2: '',
      citys2: '',
      input1: '',
      value1: '',
      areaList1: [],
      ifshow: true,
      distributorId: '',
      ifshow2: true,
      dialogFormVisible: false,
      dialogFormVisible2: false,
      dialogTopMgVisible: false,
      currentPage: 1,
      pageSize: 10,
      totalRecords: 0,
      currentPage1: 1,
      pageSize1: 10,
      totalRecords1: 0,
      areaList: [],
      arrdata1: [],
      tableData2: [],
      form: {
        controllerName: '',
        controllerDesc: '',
        messageId: '',
        controlType: '0'
      },
      form2: {
        controllerName: '',
        controllerDesc: '',
        messageId: '',
        controlType: ''
      },
      params: {},
      multipleSelection1: []

    };
  },
  mounted: function mounted() {
    var _this2 = this;

    this.tqobj = {
      keys: ['terminalTypes'],
      callback: function callback(data) {
        console.log('ddd', data[0]);
        _this2.sttyps = data[0];
      }
    };
  },
  created: function created() {

    this.distributorId = localStorage.mechanismId;
    this.getData(1, '', '');
    this.getAd();
    this.getData1(1, '', '');
  },

  methods: {
    closeBindAlert: function closeBindAlert() {
      var _this = this;
      this.mechanismData = {
        callback: function callback(value) {
          _this.value1 = value;
          _this.statusChange();
        }
      };
      this.value1 = '';
      this.stvl = '';
      this.input1 = '';
      this.dialogTopMgVisible = false;
    },
    cbChange: function cbChange() {},
    cbChange1: function cbChange1() {},
    sortChange: function sortChange(vl) {

      switch (vl.prop) {
        case 'controlName':
          this.orderName = '1';
          break;
        case 'createTime':
          this.orderName = '2';
          break;
      }
      this.orderType = vl.order == 'descending' ? 'desc' : 'asc';
      this.getData(this.currentPage, '', '');
    },

    cityFormat: function cityFormat(row) {
      if (row.city) {
        var value = row.city.split(',')[0];
        return value;
      }
    },
    hasValue: function hasValue(result, v, name) {
      if (!v[name] || v[name] === "") {
        return true;
      }
      return result.some(function (re) {
        return v[name] === re;
      });
    },
    selEvent: function selEvent(val) {
      var _this3 = this;

      return;
      var result = val.toString().split(',');
      var arr = this.options.filter(function (v) {
        if (_this3.hasValue(result, v, "value")) {
          if (v.children && v.children.length > 0) {
            v.children = v.children.filter(function (child) {
              if (_this3.hasValue(result, child, "value")) {
                return child;
              }
              return false;
            });
            return v;
          } else {
            return v;
          }
        }
      });

      if (arr[0].value === "110000" || arr[0].value === "120000" || arr[0].value === "310000" || arr[0].value === "500000") {
        this.citys = arr[0].label + "," + arr[0].value + "," + arr[0].children[0].value;
      } else {
        this.citys = arr[0].label + arr[0].children[0].label + "," + arr[0].value + "," + arr[0].children[0].value;
      }
    },
    selEvent2: function selEvent2(val) {
      var _this4 = this;

      return;
      var result = val.toString().split(',');
      var arr = this.options2.filter(function (v) {
        if (_this4.hasValue(result, v, "value")) {
          if (v.children && v.children.length > 0) {
            v.children = v.children.filter(function (child) {
              if (_this4.hasValue(result, child, "value")) {
                return child;
              }
              return false;
            });
            return v;
          } else {
            return v;
          }
        }
      });

      if (arr[0].value === "110000" || arr[0].value === "120000" || arr[0].value === "310000" || arr[0].value === "500000") {
        this.citys2 = arr[0].label + "," + arr[0].value + "," + arr[0].children[0].value;
      } else {
        this.citys2 = arr[0].label + arr[0].children[0].label + "," + arr[0].value + "," + arr[0].children[0].value;
      }
    },
    getAd1: function getAd1() {},
    getData1: function getData1(page, no, areaid) {
      var _this5 = this;

      this.currentPage1 = page;
      var stvl = this.stvl ? this.stvl : '';
      var params = {
        page: page,
        rows: this.pageSize1,
        areaid: areaid,
        terminal_no: no,
        terminal_status: stvl,
        terminal_runtime_status: ''
      };

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/terminal/list.do', params).then(function (res) {
        _this5.arrdata1 = res.data.data;
        _this5.totalRecords1 = res.data.total;
      }).catch(function (error) {});
    },
    statusChange: function statusChange() {
      this.getData1(1, this.input1, this.value1);
    },
    handleIconClick: function handleIconClick() {
      this.getData1(1, this.input1, this.value1);
    },

    deleteRow: function deleteRow(id) {
      var _this6 = this;

      var params = { "riskId": id };
      this.$confirm(this.$t('lin_global.qdxysccwl'), this.$t('lin_btn.tips'), {
        confirmButtonText: this.$t('lin_btn.confirm'),
        cancelButtonText: this.$t('lin_btn.cancel'),
        type: 'warning'
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/risk/deleteController.do', params).then(function (res) {
          console.log("打印看看删除返回信息");
          console.log(res.data);
          if (res.data.status == 200) {
            _this6.$message.success(_this6.$t('lin_global.delete_success'));
            _this6.getData(1, '', '');
          } else {
            _this6.$message.error(res.data.message);
          }
        });
      }).catch(function () {});
    },
    binderRow: function binderRow(id) {
      this.riskId = id;
      this.statusChange();
      this.dialogTopMgVisible = true;
    },
    editRow: function editRow(id) {
      this.dialogFormVisible2 = true;
      this.riskId = id;

      this.getDetail();
    },
    change2: function change2() {
      if (this.form2.controlType == '0') {
        this.ifshow2 = true;
      } else {
        this.ifshow2 = false;
      }
    },
    handleSizeChange1: function handleSizeChange1(val) {
      this.pageSize1 = val;
      this.getData1(this.currentPage1, '', '');
    },
    handleCurrentChange1: function handleCurrentChange1(val) {
      this.currentPage1 = val;
      this.getData1(this.currentPage1, '', this.value1);
    },
    handleSelectionChange1: function handleSelectionChange1(val) {
      this.multipleSelection1 = val;
    },
    bindRqs: function bindRqs(id, isForce) {
      var _this7 = this;

      var params = { riskId: this.riskId, terminalId: id, status: '0', force: isForce ? '1' : '0' };
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/risk/bindingTerminal.do', params).then(function (res) {
        if (res.data.status == '200') {
          _this7.$message.success(_this7.$t('lin_global.bdcg'));
          _this7.getList();
          _this7.closeBindAlert();
        } else if (res.data.status == 300) {
          _this7.$showConfirm(_this7.$t("app_tip"), res.data.message, _this7.$t("app_sure"), _this7.$t("app_cancel"), "warning", function () {
            _this7.bindRqs(id, true);
          }, "");
        } else {
          _this7.$message.error(res.data.message);
        }
      });
    },
    bindRow: function bindRow(id, isForce) {
      var _this8 = this;

      this.$confirm(this.$t('lin_global.sfbdczd'), this.$t('lin_btn.tips'), {
        confirmButtonText: this.$t('lin_btn.confirm'),
        cancelButtonText: this.$t('lin_btn.cancel'),
        type: 'warning'
      }).then(function () {
        _this8.bindRqs(id);
      });
    },
    batchBindRow: function batchBindRow() {
      var _this9 = this;

      if (this.multipleSelection1.length === 0) {
        this.$message.error(this.$t('lin_global.qxzybddzd'));
        return false;
      } else {
        this.$confirm(this.$t('lin_global.sfjxplbd'), this.$t('lin_btn.tips'), {
          confirmButtonText: this.$t('lin_btn.confirm'),
          cancelButtonText: this.$t('lin_btn.cancel'),
          type: 'warning'
        }).then(function () {
          var ids = [];

          for (var i = 0; i < _this9.multipleSelection1.length; i++) {
            ids.push(_this9.multipleSelection1[i].terminalId);
          }
          var rq = ids.join(',');
          _this9.bindRqs(rq);
        }).catch(function () {});
      }
    },

    submit2: function submit2() {
      var _this10 = this;

      this.params = {};

      if (!this.form2.controllerName) {
        this.$message.error(this.$t('app_inputName'));
        return;
      }

      if (!this.form2.controllerDesc) {
        this.$message.error(this.$t('app_inputIntrol'));
        return;
      }

      if (this.form2.controlType == '0') {
        this.params.id = this.riskId;
        this.params.radius = this.radius2;
        this.params.controllerName = this.form2.controllerName;
        this.params.controllerDesc = this.form2.controllerDesc;
        this.params.messageId = this.form2.messageId;
        this.params.controlType = this.form2.controlType;

        if (isNaN(Number(this.radius2)) || Number(this.radius2) <= 0.5) {
          this.$message.error(this.$t('app_rdneedmore') + '0.5');
          return;
        }
      } else {
        this.params.id = this.riskId;


        var fcode = this.sel2[0];
        var scode = this.sel2.length == 2 ? this.sel2[1] : '';
        var cname = '';
        var tmpsub = [];
        if (!this.isProv) {
          __WEBPACK_IMPORTED_MODULE_3__city_js__["a" /* default */].forEach(function (item) {
            if (item.value == fcode) {
              item.children.forEach(function (sitem) {
                if (sitem.value == scode) {
                  cname = sitem.province == sitem.label ? sitem.label : sitem.province + sitem.label;
                  return;
                }
              });
            }
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_3__city_js__["a" /* default */].forEach(function (item) {
            if (item.value == _this10.selVl2) {
              cname = item.label;
              return;
            }
          });
        }
        this.params.city = cname + ',' + (this.isProv ? this.selVl2 : this.sel2.toString());

        this.params.controllerName = this.form2.controllerName;
        this.params.controllerDesc = this.form2.controllerDesc;
        this.params.messageId = this.form2.messageId;
        this.params.controlType = this.form2.controlType;
      }

      if (this.params.city == ',' && this.form2.controlType == 1) {
        this.$message(this.$t('lin_global.risk_city'));
        return;
      }
      var params = this.params;
      params.controlType = this.isProv ? '2' : this.form2.controlType;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/risk/editRisk.do', params).then(function (res) {
        if (res.data.status == 200) {

          _this10.citys2 = '';
          _this10.params.city = '';

          _this10.dialogFormVisible2 = false;
          _this10.$message.success(res.data.message);
          _this10.getData(1, '', '');
        } else {
          _this10.dialogFormVisible2 = false;
          _this10.$message.error(res.data.message);
        }
      });
    },
    getDetail: function getDetail() {
      var _this11 = this;

      var params = { riskId: this.riskId };
      this.sel2 = [];
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/risk/getByIdRisk.do', params).then(function (res) {
        _this11.form2.controllerName = res.data.data.controlName;
        _this11.form2.controllerDesc = res.data.data.controlDesc;
        _this11.form2.messageId = res.data.data.messageid;
        if (res.data.data.controlType == '0') {
          _this11.ifShow2 = true;
          _this11.ifshow2 = true;
          _this11.form2.controlType = '0';
          _this11.radius2 = res.data.data.radius;
        } else {
          _this11.ifShow2 = false;
          _this11.ifshow2 = false;
          _this11.form2.controlType = '1';

          var arr = res.data.data.city.split(',');
          arr.shift();
          if (arr.length == 2) {
            _this11.sel2 = arr;
            _this11.isProv = false;
          } else {
            _this11.selVl2 = arr[0];
            _this11.isProv = true;
          }
        }
      });
    },
    submit: function submit() {
      var _this12 = this;

      this.params = {};

      if (!this.form.controllerName) {
        this.$message.error(this.$t('app_inputName'));
        return;
      }

      if (!this.form.controllerDesc) {
        this.$message.error(this.$t('app_inputIntrol'));
        return;
      }

      if (this.form.controlType == '0') {

        this.params.radius = this.radius;
        this.params.controllerName = this.form.controllerName;
        this.params.controllerDesc = this.form.controllerDesc;
        this.params.messageId = this.form.messageId;
        this.params.controlType = this.form.controlType;

        if (isNaN(Number(this.radius)) || Number(this.radius) <= 0.5) {
          this.$message.error(this.$t('app_rdneedmore') + '0.5');
          return;
        }
      } else {

        if (this.sel.length == 0 && !this.isProv || !this.selVl && this.isProv) {
          this.$message.error(this.$t('lin_global.risk_city'));
          return;
        }

        var fcode = this.sel[0];
        var scode = this.sel.length == 2 ? this.sel[1] : '';
        var cname = '';
        var tmpsub = [];
        if (!this.isProv) {
          __WEBPACK_IMPORTED_MODULE_3__city_js__["a" /* default */].forEach(function (item) {
            if (item.value == fcode) {
              item.children.forEach(function (sitem) {
                if (sitem.value == scode) {
                  cname = sitem.province == sitem.label ? sitem.label : sitem.province + sitem.label;
                  return;
                }
              });
            }
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_3__city_js__["a" /* default */].forEach(function (item) {
            if (item.value == _this12.selVl) {
              cname = item.label;
              return;
            }
          });
        }
        this.params.city = cname + ',' + (this.isProv ? this.selVl : this.sel.toString());

        this.params.controllerName = this.form.controllerName;
        this.params.controllerDesc = this.form.controllerDesc;
        this.params.messageId = this.form.messageId;
        this.params.controlType = this.form.controlType;
      }

      var params = this.params;
      params.distributorId = this.distributorId;
      params.controlType = this.isProv ? '2' : this.form.controlType;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/risk/addRisk.do', params).then(function (res) {
        _this12.cleanForm();
        if (res.data.status == 200) {
          _this12.dialogFormVisible = false;
          _this12.$message.success(res.data.message);
          _this12.getData(1, '', '');
        } else {
          _this12.dialogFormVisible = false;
          _this12.$message.error(res.data.message);
        }
      });
    },
    onCancel: function onCancel() {
      this.dialogFormVisible = false;
      this.cleanForm();
    },
    cleanForm: function cleanForm() {
      this.form.controllerName = '';
      this.form.controllerDesc = '';
      this.form.messageId = '';
      this.sel = [];
      this.selVl = '';
      this.radius = '';
      this.form.controlType = '0';
    },
    cleanForm2: function cleanForm2() {
      this.form2.controllerName = '';
      this.form2.controllerDesc = '';
      this.form2.messageId = '';
      this.sel2 = [];
      this.selVl2 = '';
      this.radius = '';
      this.form2.controlType = '0';
    },

    onCancel2: function onCancel2() {
      this.dialogFormVisible2 = false;
      this.cleanForm2();
    },
    change: function change() {
      if (this.form.controlType == '0') {
        this.ifshow = true;
      } else {
        this.ifshow = false;
      }
    },
    getAd: function getAd() {
      var _this13 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/risk/getMessageInform.do', {}).then(function (res) {
        _this13.areaList = res.data.data;
      });
    },
    add: function add() {
      this.sel = [];
      this.dialogFormVisible = true;
    },
    linkDetail: function linkDetail(row) {
      this.$router.push({ path: '/rail/' + row.id + '/detail' });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getData(this.currentPage, '', '');
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.getData(this.currentPage, '', '');
    },
    getData: function getData(page, no, areaid) {
      var _this14 = this;

      this.currentPage = page;
      var params2 = { orderName: this.orderName, orderType: this.orderType, page: page, rows: this.pageSize, controllerName: '', messageId: '', terminalId: '', distributorId: this.distributorId };

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/risk/listController.do', params2).then(function (res) {
        _this14.tableData2 = res.data.data;
        _this14.totalRecords = res.data.total;
      });
    }
  }
});

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		MechanismSelector: __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue___default.a
	},
	data: function data() {
		var that = this;
		return {
			orderName: '',
			orderType: '',
			mechanismData: {
				callback: function callback(value) {
					that.value1 = value;
					that.statusChange(value);
				}
			},
			focusEvent: __WEBPACK_IMPORTED_MODULE_1__api_url__["c" /* focusEvent */],

			input1: '',
			value1: '',
			currentPage: 1,
			pageSize: 10,
			totalRecords: 0,
			tableData2: [],
			queryVl: '',
			warnVl: '',
			dvVl: '',
			warnTypes: [{ vl: '', label: this.$t('app_alltyps') }, { vl: '0', label: this.$t('app_bglock') }, { vl: '1', label: this.$t('lin_global.ccwl') }],
			getWarnTypes: {
				'0': this.$t('app_bglock'),
				'1': this.$t('lin_global.ccwl')
			},
			getDvTypes: {

				'0': this.$t('app_request'),
				'1': this.$t('app_unrequest'),
				'2': this.$t('app_unlocked')
			},
			dvTypes: [{ vl: '', label: this.$t('lin_global.all_status') }, { vl: '0', label: this.$t('app_request') }, { vl: '1', label: this.$t('app_unrequest') }, { vl: '2', label: this.$t('app_unlocked') }]

		};
	},
	created: function created() {
		this.getList();
	},

	methods: {
		sortChange: function sortChange(vl) {
			switch (vl.prop) {
				case 'terminalNo':
					this.orderName = '1';
					break;
				case 'timeNow':
					this.orderName = '2';
					break;
			}
			this.orderType = vl.order == 'descending' ? 'desc' : 'asc';
			this.getList();
		},
		handleIconClick: function handleIconClick() {
			this.getList();
		},
		getList: function getList() {
			var _this = this;

			this.loading = 1;
			var tNo = this.queryVl ? this.queryVl : '';
			var type = this.warnVl ? this.warnVl : '';
			var st = this.dvVl ? this.dvVl : '';

			this.$getWarnList(this.currentPage, this.$gRow, st, localStorage.mechanismId, tNo, type, this.orderName, this.orderType, function (res) {
				_this.loading = 0;
				if (res.status === 200) {
					_this.totalRecords = res.total;
					_this.tableData2 = res.data;
				} else {
					_this.$message.error(res.message);
				}
			}, function () {
				_this.loading = 0;
			});
		},
		cellClick: function cellClick(row, ev, col) {
			var label = col.label;
			if (!label) return;

			this.$setWObj('warnDetail', row);
			this.$router.push({ path: '/warnlist/unlock' });
		},


		handleSizeChange: function handleSizeChange(val) {
			this.$gRows = val;
			this.getList();
		},
		handleCurrentChange: function handleCurrentChange(val) {

			this.currentPage = val;
			this.getList();
		},
		formatStatus: function formatStatus(row, column) {
			return this.getWarnTypes[row.eventType];
		},
		formatStatus1: function formatStatus1(row, column) {
			return this.getDvTypes[row.status];
		}

	}
});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_url__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isTipUnlock: false,
      getWarnTypes: {
        '0': this.$t('app_bglock'),
        '1': this.$t('lin_global.ccwl')
      },
      getDvTypes: {
        '0': this.$t('app_request'),
        '1': this.$t('app_unrequest')
      },
      detail: '',
      loading: false,
      ahref: '',
      isUnbind: false,
      certinfo: {},
      info: '',
      warnTypes: [{ vl: '0', label: this.$t('') }],
      dvTypes: []
    };
  },
  created: function created() {
    this.info = this.$getWObj().warnDetail;
    this.getDetail();
  },

  computed: {
    mkunlocktip: function mkunlocktip() {
      return this.$t('app_unldvwftip').replace('{wl}', this.detail.riskName);
    },
    unbindColor: function unbindColor() {
      if (this.isUnbind) {
        return 'success';
      } else {
        return '';
      }
    }
  },
  methods: {
    unlockBf: function unlockBf() {
      if (this.detail.riskName) {
        this.isTipUnlock = true;
      } else {
        this.unlockReq();
      }
    },
    uniSubmit: function uniSubmit(is) {
      if (is) {
        this.isTipUnlock = false;
        var _this = this;
        this.setUnbind(function () {
          _this.unlockReq();
        });
      } else {
        this.unlockReq();
      }
    },
    disStrProcess: function disStrProcess(dis) {
      if (dis) {
        return this.$t('lin_global.ccwl') + dis + 'KM';
      } else {
        return '';
      }
    },
    getDetail: function getDetail() {
      var _this2 = this;

      this.loading = 1;
      this.$getWarnDetail(this.info.id, function (res) {
        console.log(res);
        _this2.loading = 0;
        if (res.status === 200) {
          _this2.detail = res.data;
        } else {
          _this2.$message.error(res.message);
        }
      }, function () {
        _this2.loading = 0;
      });
    },
    unlockReq: function unlockReq() {
      var _this3 = this;

      this.loading = true;
      this.$killwarn(this.detail.id, function (res) {
        _this3.loading = false;
        if (res.status === 200) {
          _this3.$message.success(res.message);
          _this3.$router.go(-1);
        } else {
          _this3.$message.error(res.message);
        }
      }, function () {
        _this3.loading = false;
      });
    },
    setUnbind: function setUnbind(cb) {
      var _this4 = this;

      this.loading = true;
      this.$setFenceBind(this.detail.riskId, this.detail.terminalId, '1', function (res) {
        if (cb) {
          cb();
        }
        _this4.loading = false;
        if (res.status === 200) {
          _this4.$message.success(res.message);
          _this4.getDetail();
        } else {
          _this4.$message.error(res.message);
        }
      }, function () {
        if (cb) {
          cb();
        }
        _this4.loading = false;
      });
    },
    uploadCer: function uploadCer() {
      this.$setWObj('safeCerType', 0);
      this.$router.push({ path: '/certificate/mycer/upload' });
    }
  }
});

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_url__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			currentPage: 1,
			pageSize: 10,
			totalRecords: 0,
			certinfo: {},
			arrdata: [],
			authDetail: {},
			status_list: [{
				vl: "0"
			}, {
				vl: '1',
				lb: this.$t('auth_status_list.status_1')
			}, {
				vl: '2',
				lb: this.$t('auth_status_list.status_2')
			}, {
				vl: '3',
				lb: this.$t('auth_status_list.status_3')
			}, {
				vl: '4',
				lb: this.$t('auth_status_list.status_4')
			}, {
				vl: '5',
				lb: this.$t('auth_status_list.status_5')
			}, {
				vl: '6',
				lb: this.$t('auth_status_list.status_6')
			}]
		};
	},
	created: function created() {
		this.getDetail();
		this.getList(1);
	},

	methods: {
		getList: function getList(page) {
			var _this = this;

			this.currentPage = page;
			console.log(this.$route.query);
			var params = {
				terminalNo: this.$route.query.terminalNo,
				page: page,
				rows: this.pageSize
			};

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/terminal_auth/authorizationDetail.do', params).then(function (res) {
				console.log("数据别表");
				if (res.data.status == 200) {
					_this.authDetail = res.data.data;
					_this.arrdata = _this.authDetail.dataList;
				} else {
					_this.$message.error(res.data.message);
				}
			});
		},

		formatListStatus: function formatListStatus(row, column) {
			var result = row.status ? this.status_list[row.status].lb : "";
			return result;
		},
		formatStatus: function formatStatus(status) {
			return status == "1" ? this.$t('lin_global.normal') : this.$t('app_selfDestroy');
		},
		handleSizeChange: function handleSizeChange(val) {
			this.pageSize = val;
			this.getList(this.currentPage);
		},
		handleCurrentChange: function handleCurrentChange(val) {
			this.currentPage = val;
			this.getList(this.currentPage);
		},
		getDetail: function getDetail() {
			var _this2 = this;

			var certId = this.$route.params.id;
			var params = {
				certificateId: certId
			};
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/cer/getById.do', params).then(function (res) {
				console.log(res.data);
				if (res.data.status == 200) {
					_this2.certinfo = res.data.data;
				}
			});
		}
	}
});

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__city_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_TernoAutoCtrl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_TernoAutoCtrl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_TernoAutoCtrl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_global_mechanism_selector_vue__);









/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		AutoTerno: __WEBPACK_IMPORTED_MODULE_4__global_TernoAutoCtrl___default.a,
		MechanismSelector: __WEBPACK_IMPORTED_MODULE_5__components_global_mechanism_selector_vue___default.a
	},
	data: function data() {
		var that = this;
		return {
			orderName: '',
			orderType: '',
			mechanismData: {
				callback: function callback(value) {
					that.select_form.merchantId = value;
					that.query();
				}
			},
			select_form: {
				terminalNo: "",
				onlineStatus: "",
				status: "",
				merchantId: ""
			},
			mech: '',
			net_list: [{
				vl: "0",
				lb: this.$t('lin_global.new_add'),
				type: "gray"
			}, {
				vl: '1',
				lb: this.$t('lin_global.online'),
				type: "success"
			}, {
				vl: '2',
				lb: this.$t('lin_global.offline'),
				type: "danger"
			}, {
				vl: '3',
				lb: this.$t('app_sleep'),
				type: "",
				color: "#FECC0B"
			}],
			dest_list: [{
				vl: '1',
				lb: this.$t('lin_global.normal')
			}, {
				vl: '2',
				lb: this.$t('app_selfDestroy')
			}],
			ctype: '',
			queryKey: '',
			ahref: '',
			form: {
				pushType: '2',
				terminalNo: '',
				type: '',
				zl: 'XZZS',
				certificateId: ''
			},
			rules: {
				'terminalNo': [{
					required: true,
					message: this.$t('lin_global.quorter')
				}]
			},
			type: [{
				typename: this.$t('lin_global.label_areaid'),
				typeid: '2'
			}, {
				typename: this.$t('lin_global.shebei'),
				typeid: '1'
			}],
			sel: [],
			sel2: [],
			options: __WEBPACK_IMPORTED_MODULE_3__city_js__["a" /* default */],
			focusEvent: __WEBPACK_IMPORTED_MODULE_2__api_url__["c" /* focusEvent */],
			riskId: '',
			radius: '',
			citys: '',
			radius2: '',
			citys2: '',
			input1: '',
			value1: '',
			areaList1: [],
			ifshow: true,
			ifshow2: true,
			dialogFormVisible: false,
			dialogFormVisible2: false,
			dialogTopMgVisible: false,
			currentPage: 1,
			pageSize: 10,
			totalRecords: 0,
			currentPage1: 1,
			pageSize1: 10,
			totalRecords1: 0,
			areaList: [],
			arrdata1: [],
			tableData2: [],
			xiafaVisible: false,
			zhengshu: '',
			qudaoshangxinxi: '',
			qudaoshangid: '',
			zhengshutype: '',
			isShow: true,
			isSubmit: false,
			restaurants: [],
			loading: true
		};
	},
	created: function created() {
		this.getData(1);
	},

	methods: {
		query: function query() {
			this.getData(this.currentPage);
		},
		onDvInputChange: function onDvInputChange(vl) {

			this.form.terminalNo = vl;
		},

		rowClick: function rowClick(row, ev, col) {
			if (!col.label || col.label === this.$t('app_operate')) {
				return;
			}

			this.$router.push({
				path: '/authorization-detail',
				query: {
					terminalNo: row.terminalNo
				}
			});
		},
		querySearch: function querySearch(queryString, cb) {
			var restaurants = this.restaurants;
			var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;

			cb(results);
		},
		createFilter: function createFilter(queryString) {
			return function (restaurant) {
				var boo = restaurant.value.indexOf(queryString) === 0;
				return boo;
			};
		},

		getNoList: function getNoList() {
			var _this = this;

			var params = {
				mechId: this.qudaoshangid
			};
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/terminal/terminalNoList.do', params).then(function (res) {
				console.log('r', res.data.data);
				_this.restaurants = res.data.data;
			});
		},
		changeType: function changeType() {
			this.form.terminalNo = '';
			if (this.form.pushType == '2') {
				this.isShow = true;
			} else {
				this.isShow = false;
			}
		},
		formatNetwork: function formatNetwork(row, column) {
			var result = row.terminalStatus ? this.net_list[row.terminalStatus] : {
				vl: "",
				lb: "",
				type: ""
			};
			return result;
		},

		formatStatus: function formatStatus(row, column) {
			return row.status == "1" ? this.$t('lin_global.normal') : this.$t('app_selfDestroy');
		},
		cityFormat: function cityFormat(row) {
			if (row.city) {
				var value = row.city.split(',')[0];
				return value;
			}
		},
		hasValue: function hasValue(result, v, name) {
			if (!v[name] || v[name] === "") {
				return true;
			}
			return result.some(function (re) {
				return v[name] === re;
			});
		},
		selEvent: function selEvent(val) {
			var _this2 = this;

			var result = val.toString().split(',');
			var arr = this.options.filter(function (v) {
				if (_this2.hasValue(result, v, "value")) {
					if (v.children && v.children.length > 0) {
						v.children = v.children.filter(function (child) {
							if (_this2.hasValue(result, child, "value")) {
								return child;
							}
							return false;
						});
						return v;
					} else {
						return v;
					}
				}
			});

			if (arr[0].value === "110000" || arr[0].value === "120000" || arr[0].value === "310000" || arr[0].value === "500000") {
				this.citys = arr[0].label + "," + arr[0].value + "," + arr[0].children[0].value;
			} else {
				this.citys = arr[0].label + arr[0].children[0].label + "," + arr[0].value + "," + arr[0].children[0].value;
			}
		},
		selEvent2: function selEvent2(val) {
			var _this3 = this;

			var result = val.toString().split(',');
			var arr = this.options.filter(function (v) {
				if (_this3.hasValue(result, v, "value")) {
					if (v.children && v.children.length > 0) {
						v.children = v.children.filter(function (child) {
							if (_this3.hasValue(result, child, "value")) {
								return child;
							}
							return false;
						});
						return v;
					} else {
						return v;
					}
				}
			});

			if (arr[0].value === "110000" || arr[0].value === "120000" || arr[0].value === "310000" || arr[0].value === "500000") {
				this.citys2 = arr[0].label + "," + arr[0].value + "," + arr[0].children[0].value;
			} else {
				this.citys2 = arr[0].label + arr[0].children[0].label + "," + arr[0].value + "," + arr[0].children[0].value;
			}
		},
		getAd1: function getAd1() {
			var params = {
				page: 1,
				rows: 10000
			};
		},
		getData1: function getData1(page, no, areaid) {
			var _this4 = this;

			this.currentPage1 = page;
			var params = {
				page: page,
				rows: this.pageSize1,
				areaid: areaid,
				terminal_no: no,
				terminal_status: '',
				terminal_runtime_status: ''
			};

			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/terminal/list.do', params).then(function (res) {
				_this4.arrdata1 = res.data.data;
				_this4.totalRecords1 = res.data.total;
			}).catch(function (error) {});
		},
		statusChange: function statusChange() {
			this.getData1(1, this.input1, this.value1);
		},
		handleIconClick: function handleIconClick() {
			this.getData1(1, this.input1, this.value1);
		},

		actRow: function actRow(row) {
			var _this5 = this;

			console.log(row);
			var params = {
				terminalNo: row.terminalNo
			};
			this.$confirm(this.$t('app_isActive'), this.$t('lin_btn.tips'), {
				confirmButtonText: this.$t('lin_btn.confirm'),
				cancelButtonText: this.$t('lin_btn.cancel'),
				type: 'warning'
			}).then(function () {
				__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/terminal_auth/authentication.do', params).then(function (res) {
					if (res.data.status == 200) {
						_this5.$message.success(res.data.message);
						_this5.getData(1);
					} else {
						_this5.$message.error(res.data.message);
					}
				});
			}).catch(function () {});
		},
		deleteRow: function deleteRow(id) {
			var _this6 = this;

			var params = {
				id: id
			};
			this.$confirm(this.$t('lin_global.confirmDelete'), this.$t('lin_btn.tips'), {
				confirmButtonText: this.$t('lin_btn.confirm'),
				cancelButtonText: this.$t('lin_btn.cancel'),
				type: 'warning'
			}).then(function () {
				__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/cer/deleteCertificate.do', params).then(function (res) {
					if (res.data.status == 200) {
						_this6.$message.success(_this6.$t('lin_global.delete_success'));
						_this6.getData(1);
					} else {
						_this6.$message.error(res.data.message);
					}
				});
			}).catch(function () {});
		},
		getDetail: function getDetail() {
			var _this7 = this;

			var params = {
				riskId: this.riskId
			};
			this.sel2 = [];
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/risk/getByIdRisk.do', params).then(function (res) {
				_this7.form2.controllerName = res.data.data.controlName;
				_this7.form2.controllerDesc = res.data.data.controlDesc;
				_this7.form2.messageId = res.data.data.messageid;
				if (res.data.data.controlType == '0') {
					_this7.ifShow2 = true;
					_this7.ifshow2 = true;
					_this7.form2.controlType = '0';
					_this7.radius2 = res.data.data.radius;
				} else {
					_this7.ifShow2 = false;
					_this7.ifshow2 = false;
					_this7.form2.controlType = '1';
					_this7.citys2 = res.data.data.city;
					var arr = res.data.data.city.split(',');

					_this7.sel2.push(arr[1]);
					_this7.sel2.push(arr[2]);
				}
			});
		},
		submit: function submit() {
			var _this8 = this;

			this.params = {};
			if (this.form.controlType == '0') {
				this.params.radius = this.radius;
				this.params.controllerName = this.form.controllerName;
				this.params.controllerDesc = this.form.controllerDesc;
				this.params.messageId = this.form.messageId;
				this.params.controlType = this.form.controlType;
			} else {
				this.params.city = this.citys;
				this.params.controllerName = this.form.controllerName;
				this.params.controllerDesc = this.form.controllerDesc;
				this.params.messageId = this.form.messageId;
				this.params.controlType = this.form.controlType;
			}

			var params = this.params;
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/risk/addRisk.do', params).then(function (res) {
				if (res.data.status == 200) {
					_this8.dialogFormVisible = false;
					_this8.$message.success(res.data.message);
					_this8.getData(1);
				} else {
					_this8.dialogFormVisible = false;
					_this8.$message.error(res.data.message);
				}
			});
		},
		onCancel: function onCancel() {
			this.dialogFormVisible = false;
		},
		onCancel2: function onCancel2() {
			this.dialogFormVisible2 = false;
		},
		change: function change() {
			if (this.form.controlType == '0') {
				this.ifshow = true;
			} else {
				this.ifshow = false;
			}
		},
		getAd: function getAd() {
			var _this9 = this;

			var params = {
				page: 1,
				rows: 10000,
				mechId: this.qudaoshangid
			};
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/mechanism/list.do', params).then(function (res) {
				_this9.areaList = res.data.data;
			});
		},
		uploadCer: function uploadCer() {
			this.$setWObj('safeCerType', 1);
			this.$router.push({
				path: '/certificate/upload'
			});
		},

		add: function add() {
			this.$router.push({
				path: '/certificate/new'
			});
		},
		upload: function upload() {
			this.$router.push({
				path: '/certificate/upload'
			});
		},
		linkDetail: function linkDetail(row) {
			this.$router.push({
				path: '/rail/' + row.id + '/detail'
			});
		},
		handleSizeChange: function handleSizeChange(val) {
			this.pageSize = val;
			this.getData(this.currentPage);
		},
		handleCurrentChange: function handleCurrentChange(val) {
			this.currentPage = val;
			this.getData(this.currentPage);
		},
		getData: function getData(page) {
			var _this10 = this;

			this.currentPage = page;
			var params2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
				page: page,
				rows: this.pageSize
			}, this.select_form);
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/terminal_auth/terminalList.do', params2).then(function (res) {
				console.log(res.data);
				if (res.data.status == 200) {
					_this10.tableData2 = res.data.data;
					_this10.totalRecords = res.data.total;
					_this10.loading = false;
				} else {
					_this10.loading = false;
				}
			});
		}
	}
});

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		MechanismSelector: __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default.a
	},
	data: function data() {
		var _this = this;

		var itemCheck = function itemCheck(rule, value, callback) {
			if (!_this.form.item) {
				callback(new Error(_this.$t('app_select')));
			} else {
				callback();
			}
		};
		var that = this;
		return {
			mechanismData: {
				placeholder: that.$t('lin_global.place_areaid'),
				callback: function callback(value) {
					that.cer.mech = value;
				}
			},
			uploadType: 0,
			srcList: [],
			loading: 0,
			mechanismId: window.localStorage['mechanismId'],
			dNo: '',
			info: '',
			pushType: [{
				label: this.$t('app_distributor'),
				vl: 0
			}, {
				label: this.$t('app_dv'),
				vl: 1
			}],
			tableData: [],
			fatherList: [],
			mechs: [],
			finalMcId: '',
			cer: {
				name: '',
				mark: '',
				curl: '',
				purl: '',
				mech: ''
			},
			form: {
				item: '',
				pushType: 0,
				mechanism: ''
			},
			rules: {
				name: [{
					required: true,
					message: this.$t('app_input'),
					trigger: 'blur'
				}],
				mark: [{
					required: false,
					message: this.$t('app_input'),
					trigger: 'blur'
				}],
				mech: [{
					required: true,
					message: this.$t('app_selectChannel'),
					trigger: 'blur'
				}],
				curl: [{
					required: true,
					message: this.$t('app_plsUlPbCer'),
					trigger: 'blur'
				}]
			}
		};
	},
	destroyed: function destroyed() {
		this.$setWObj('cnUploadId', '');
	},

	computed: {
		fileUploadUrl: function fileUploadUrl() {
			var vl = "https://tmsadmin.szzt.com.cn/file-management/tms-server-web/sgn/fileupload.do";
			return vl;
		}
	},
	methods: {
		removeFile: function removeFile() {
			this.cer.curl = '';
			this.cer.purl = '';
			this.srcList = [];
			this.hBlur('cer');
		},
		hBlur: function hBlur(name) {
			this.$refs[name].validate(function (valid) {
				if (valid) {} else {
					return false;
				}
			});
		},
		cancel: function cancel() {
			this.$router.go(-1);
		},
		cerBefore: function cerBefore(file) {
			window[this.$route.path] = 1;
		},
		cerSuccess: function cerSuccess(res, file) {
			window[this.$route.path] = '';
			if (res.status === 200) {
				this.cer.curl = res.cer_url;
				this.cer.purl = res.privkey_url;
				this.srcList = [{
					name: file.name
				}];
				this.hBlur('cer');
			} else {
				this.$message.error(res.message);
				this.srcList = [];
			}
		},
		submit: function submit() {
			var _this2 = this;

			this.$refs['cer'].validate(function (valid) {
				if (valid) {

					var fmech = '';
					if (_this2.uploadType === 1) {
						if (!_this2.cer.mech) {
							_this2.$message(_this2.$t('app_plslchannel'));
							return;
						}
						fmech = _this2.cer.mech;
					} else {
						fmech = _this2.finalMcId;
					}

					_this2.loading = 1;
					var purl = _this2.cer.purl ? _this2.cer.purl : '';
					var curl = _this2.cer.curl ? _this2.cer.curl : '';
					_this2.$uploadCer(curl, purl, _this2.cer.id, _this2.cer.name, _this2.cer.mark, fmech, function (res) {
						_this2.loading = 0;
						if (res.status === 200) {
							_this2.$message.success(res.message);
							_this2.$router.go(-1);
						} else {
							_this2.$message.error(res.message);
						}
					}, function () {
						_this2.loading = 0;
					});
				} else {
					return false;
				}
			});
		},
		fwChange: function fwChange(vl) {}
	},
	mounted: function mounted() {

		this.uploadType = this.$getWObj().safeCerType;

		var outId = this.$getWObj().cnUploadId;
		if (outId) {
			this.finalMcId = outId;
		} else {
			this.finalMcId = localStorage.mechanismId;
		}
	}
});

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_url__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      currentPage: 1,
      pageSize: 10,
      totalRecords: 0,
      certinfo: {},
      arrdata: []
    };
  },
  created: function created() {
    this.getDetail();
    this.getList(1);
  },

  methods: {
    getList: function getList(page) {
      var _this = this;

      this.currentPage = page;
      var params = { certificateId: this.$route.params.id, page: page, rows: this.pageSize, opflag: '3,4' };
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/authorization/opRecording.do', params).then(function (res) {
        console.log("数据别表");
        console.log(res.data);
        if (res.data.status == 200) {
          _this.arrdata = res.data.data;
          _this.totalRecords = res.data.total;
        } else {
          _this.$message.error(res.data.message);
        }
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getList(this.currentPage);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.getList(this.currentPage);
    },
    resXiafa: function resXiafa(a, b, c, d, e) {
      var _this2 = this;

      var params = {
        id: a,
        merchantId: b,
        operationType: c,
        pushType: d,
        certificateId: e
      };
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/authorization/opAgain.do', params).then(function (res) {
        if (res.data.status == 200) {
          _this2.$message.success(res.data.message);
          _this2.getList(1);
        } else {
          _this2.$message.error(res.data.message);
        }
      });
    },
    getDetail: function getDetail() {
      var _this3 = this;

      var certId = this.$route.params.id;
      var params = { certificateId: certId };
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/cer/getById.do', params).then(function (res) {
        console.log(res.data);
        if (res.data.status == 200) {
          _this3.certinfo = res.data.data;
        }
      });
    }
  }
});

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    showsManufacturerCert: function showsManufacturerCert() {
      return localStorage.userType === '0';
    }
  },
  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue___default.a
  },
  data: function data() {
    var _this = this;

    var emailCheck = function emailCheck(rule, value, callback) {
      var rg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
      if (!rg.test(value)) {
        callback(new Error(_this.$t('lin_global.srgsbzq')));
      } else {
        callback();
      }
    };
    var numCheck = function numCheck(rule, value, callback) {
      var rg = /^([1-9]\d*|0)(\.\d*[1-9])?$/;
      if (!rg.test(value)) {
        callback(new Error(_this.$t('lin_global.srgsbzq')));
      } else {
        callback();
      }
    };
    var zimuCheck = function zimuCheck(rule, value, callback) {
      var rg = /^[A-Za-z]+$/;
      if (!rg.test(value)) {
        callback(new Error(_this.$t('lin_global.srgsbzq')));
      } else {
        callback();
      }
    };
    var that = this;
    return {
      mechanismData: {
        placeholder: that.$t('lin_global.place_areaid'),
        callback: function callback(value) {
          that.form.distributorId = value;
        }
      },
      isSubmit: false,
      dialogFormVisible: false,
      formLabelWidth: '100px',
      loading: true,
      form: {
        certificateName: '',
        certificateDesc: '',
        distributorId: '',
        country: '',
        province: '',
        city: '',
        company: '',
        email: '',
        termTime: '',
        certificateType: '1'
      },

      rules: {
        'certificateName': [{
          required: true,
          message: this.$t('lin_global.notNull')
        }],
        'distributorId': [{
          required: true,
          message: this.$t('lin_global.notNull')
        }],
        'country': [{
          required: true,
          message: this.$t('lin_global.notNull')
        }, {
          validator: zimuCheck, trigger: 'blur'
        }],
        'province': [{
          required: true,
          message: this.$t('lin_global.notNull')
        }, {
          validator: zimuCheck, trigger: 'blur'
        }],
        'city': [{
          required: true,
          message: this.$t('lin_global.notNull')
        }, {
          validator: zimuCheck, trigger: 'blur'
        }],
        'company': [{
          required: true,
          message: this.$t('lin_global.notNull')
        }, {
          validator: zimuCheck, trigger: 'blur'
        }],
        'email': [{
          required: true,
          message: this.$t('lin_global.notNull')
        }, {
          validator: emailCheck, trigger: 'blur'
        }],
        'termTime': [{
          required: true,
          message: this.$t('lin_global.notNull')
        }, {
          validator: numCheck, trigger: 'blur'
        }]
      },
      areaList: [],
      roleList: []
    };
  },
  created: function created() {
    this.getRole();
  },

  methods: {
    isLegalMobile: function isLegalMobile(tel) {
      var sMobile = tel;
      var regex = "^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\\d{8}$";
      var re = new RegExp(regex, 'g');
      if (!re.test(sMobile)) {
        return false;
      } else {
        return true;
      }
    },

    chang: function chang() {
      this.dialogFormVisible = true;
    },
    submitForm: function submitForm(formName) {
      var _this2 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          var params = {
            userId: _this2.$route.params.id,
            oldPwd: _this2.$sha256(_this2.formPwd.oldPass),
            newPwd: _this2.$sha256(_this2.formPwd.checkPass)
          };

          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/user/updatePassword.do', params).then(function (res) {
            if (res.data.status == 200) {
              _this2.dialogFormVisible = false;
              _this2.$message.success(res.data.message);
            } else {
              _this2.dialogFormVisible = false;
              _this2.$message.error(res.data.message);
            }
          });
        } else {
          return false;
        }
      });
    },


    addInfo: function addInfo() {
      var _this3 = this;

      if (this.form.certificateType == 2) {
        this.form.distributorId = "";
      }
      var params = this.form;

      this.isSubmit = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/cer/add.do', params).then(function (res) {
        if (res.data.status == 200) {
          _this3.$message.success(res.data.message);
          _this3.isSubmit = false;
          _this3.$router.go(-1);
        } else {
          _this3.isSubmit = false;
          _this3.$message.error(res.data.message);
        }
      });
    },

    onSubmit: function onSubmit() {
      var _this4 = this;

      this.$refs['addForm'].validate(function (valid) {
        if (valid) {
          _this4.addInfo();
        } else {
          _this4.$message.error(_this4.$t('lin_global.refs'));
          return false;
        }
      });
    },
    getAd: function getAd() {
      var _this5 = this;

      var params = { page: 1, rows: 10000 };
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/mechanism/list.do', params).then(function (res) {
        _this5.areaList = res.data.data;
      });
    },
    getRole: function getRole() {
      var _this6 = this;

      var mechanismId = localStorage.getItem('mechanismId');
      var params = { page: 1, rows: 10000, distributorid: mechanismId };
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/role/list.do', params).then(function (res) {
        _this6.roleList = res.data.data;
      });
    },
    onCancel: function onCancel() {
      this.$router.go(-1);
    }
  }
});

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_url__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__city_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_TernoAutoCtrl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_TernoAutoCtrl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_TernoAutoCtrl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_global_mechanism_selector_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		AutoTerno: __WEBPACK_IMPORTED_MODULE_3__global_TernoAutoCtrl___default.a,
		MechanismSelector: __WEBPACK_IMPORTED_MODULE_4__components_global_mechanism_selector_vue___default.a
	},
	data: function data() {
		var that = this;
		return {
			orderName: '',
			orderType: '',
			mechanismData: {
				callback: function callback(value) {
					that.mech = value;
					that.query();
				}
			},
			mech: '',
			ctyps: [{
				vl: '',
				lb: this.$t('lin_global.allType')
			}, {
				vl: '1',
				lb: this.$t('lin_global.khzss')
			}, {
				vl: '2',
				lb: this.$t('lin_global.cszss')
			}],
			ctype: '',
			queryKey: '',
			ahref: '',
			form: {
				pushType: '2',
				terminalNo: '',
				type: '',
				zl: 'XZZS',
				certificateId: ''
			},
			rules: {
				'terminalNo': [{
					required: true,
					message: this.$t('lin_global.quorter')
				}]
			},
			type: [{
				typename: this.$t('lin_global.label_areaid'),
				typeid: '2'
			}, {
				typename: this.$t('lin_global.shebei'),
				typeid: '1'
			}],
			sel: [],
			sel2: [],
			options: __WEBPACK_IMPORTED_MODULE_2__city_js__["a" /* default */],
			focusEvent: __WEBPACK_IMPORTED_MODULE_1__api_url__["c" /* focusEvent */],
			riskId: '',
			radius: '',
			citys: '',
			radius2: '',
			citys2: '',
			input1: '',
			value1: '',
			areaList1: [],
			ifshow: true,
			ifshow2: true,
			dialogFormVisible: false,
			dialogFormVisible2: false,
			dialogTopMgVisible: false,
			currentPage: 1,
			pageSize: 10,
			totalRecords: 0,
			currentPage1: 1,
			pageSize1: 10,
			totalRecords1: 0,
			areaList: [],
			arrdata1: [],
			tableData2: [],
			xiafaVisible: false,
			zhengshu: '',
			qudaoshangxinxi: '',
			qudaoshangid: '',
			zhengshutype: '',
			isShow: true,
			isSubmit: false,
			restaurants: [],
			loading: true
		};
	},
	created: function created() {
		this.getData(1);
		this.getData1(1, '', '');
		this.getAd1();
	},

	computed: {
		isCreate: function isCreate() {
			return localStorage.userType === '0';
		},
		isCerUpload: function isCerUpload() {
			return true;
		}
	},
	methods: {
		sortChange: function sortChange(vl) {
			switch (vl.prop) {
				case 'certificateName':
					this.orderName = '1';
					break;
				case 'createTime':
					this.orderName = '2';
					break;
			}
			this.orderType = vl.order == 'descending' ? 'desc' : 'asc';
			this.getData(this.currentPage);
		},
		query: function query() {
			this.getData(this.currentPage);
		},
		onDvInputChange: function onDvInputChange(vl) {

			this.form.terminalNo = vl;
		},

		rowClick: function rowClick(row) {
			this.$router.push({
				path: '/certificate/' + row.certificateId + '/detail'
			});
		},
		querySearch: function querySearch(queryString, cb) {
			var restaurants = this.restaurants;
			var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;

			cb(results);
		},
		createFilter: function createFilter(queryString) {
			return function (restaurant) {
				var boo = restaurant.value.indexOf(queryString) === 0;
				return boo;
			};
		},

		getNoList: function getNoList() {
			var _this = this;

			var params = {
				mechId: this.qudaoshangid
			};
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/terminal/terminalNoList.do', params).then(function (res) {
				console.log('r', res.data.data);
				_this.restaurants = res.data.data;
			});
		},
		xiafaSubmit: function xiafaSubmit() {
			var _this2 = this;

			var params = this.form;


			this.$refs['addForm'].validate(function (valid) {
				if (valid) {
					_this2.isSubmit = true;
					__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/cmd/doCommand.do', params).then(function (res) {
						if (res.data.status == 200) {
							_this2.$message(res.data.message);
							_this2.isSubmit = false;
							_this2.xiafaVisible = false;
						} else {
							_this2.isSubmit = false;
							_this2.$message.error(res.data.message);
						}
					});
				} else {
					_this2.$message.error(_this2.$t('lin_global.refs'));
					return false;
				}
			});
		},
		changeType: function changeType() {
			this.form.terminalNo = '';
			if (this.form.pushType == '2') {
				this.isShow = true;
			} else {
				this.isShow = false;
			}
		},
		formatStatus: function formatStatus(row, column) {
			return row.certificateType == "2" ? this.$t('lin_global.cszss') : row.certificateType == "1" ? this.$t('lin_global.khzss') : '';
		},
		cityFormat: function cityFormat(row) {
			if (row.city) {
				var value = row.city.split(',')[0];
				return value;
			}
		},
		hasValue: function hasValue(result, v, name) {
			if (!v[name] || v[name] === "") {
				return true;
			}
			return result.some(function (re) {
				return v[name] === re;
			});
		},
		selEvent: function selEvent(val) {
			var _this3 = this;

			var result = val.toString().split(',');
			var arr = this.options.filter(function (v) {
				if (_this3.hasValue(result, v, "value")) {
					if (v.children && v.children.length > 0) {
						v.children = v.children.filter(function (child) {
							if (_this3.hasValue(result, child, "value")) {
								return child;
							}
							return false;
						});
						return v;
					} else {
						return v;
					}
				}
			});

			if (arr[0].value === "110000" || arr[0].value === "120000" || arr[0].value === "310000" || arr[0].value === "500000") {
				this.citys = arr[0].label + "," + arr[0].value + "," + arr[0].children[0].value;
			} else {
				this.citys = arr[0].label + arr[0].children[0].label + "," + arr[0].value + "," + arr[0].children[0].value;
			}
		},
		selEvent2: function selEvent2(val) {
			var _this4 = this;

			var result = val.toString().split(',');
			var arr = this.options.filter(function (v) {
				if (_this4.hasValue(result, v, "value")) {
					if (v.children && v.children.length > 0) {
						v.children = v.children.filter(function (child) {
							if (_this4.hasValue(result, child, "value")) {
								return child;
							}
							return false;
						});
						return v;
					} else {
						return v;
					}
				}
			});

			if (arr[0].value === "110000" || arr[0].value === "120000" || arr[0].value === "310000" || arr[0].value === "500000") {
				this.citys2 = arr[0].label + "," + arr[0].value + "," + arr[0].children[0].value;
			} else {
				this.citys2 = arr[0].label + arr[0].children[0].label + "," + arr[0].value + "," + arr[0].children[0].value;
			}
		},
		getAd1: function getAd1() {
			var params = {
				page: 1,
				rows: 10000
			};
		},
		getData1: function getData1(page, no, areaid) {
			var _this5 = this;

			this.currentPage1 = page;
			var params = {
				page: page,
				rows: this.pageSize1,
				areaid: areaid,
				terminal_no: no,
				terminal_status: '',
				terminal_runtime_status: ''
			};

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/terminal/list.do', params).then(function (res) {
				_this5.arrdata1 = res.data.data;
				_this5.totalRecords1 = res.data.total;
			}).catch(function (error) {});
		},
		statusChange: function statusChange() {
			this.getData1(1, this.input1, this.value1);
		},
		handleIconClick: function handleIconClick() {
			this.getData1(1, this.input1, this.value1);
		},

		deleteRow: function deleteRow(id) {
			var _this6 = this;

			var params = {
				id: id
			};
			this.$confirm(this.$t('lin_global.confirmDelete'), this.$t('lin_btn.tips'), {
				confirmButtonText: this.$t('lin_btn.confirm'),
				cancelButtonText: this.$t('lin_btn.cancel'),
				type: 'warning'
			}).then(function () {
				__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/cer/deleteCertificate.do', params).then(function (res) {
					if (res.data.status == 200) {
						_this6.$message.success(_this6.$t('lin_global.delete_success'));
						_this6.getData(1);
					} else {
						_this6.$message.error(res.data.message);
					}
				});
			}).catch(function () {});
		},
		xiafaRow: function xiafaRow(name, type, id, idname, zhid, row) {
			console.log('row url : ' + row.url);

			this.xiafaVisible = true;
			this.qudaoshangxinxi = idname;
			this.zhengshu = name;
			this.qudaoshangid = id;
			this.form.type = type;
			this.form.certificateId = zhid;
			this.form.terminalNo = '';
			this.form.pushType = '2';
			this.form.url = row.url;
			this.getAd();
			this.getNoList();
		},
		importRow: function importRow(url) {
			var href = __WEBPACK_IMPORTED_MODULE_1__api_url__["b" /* urlAssets */].prefix + url;
			console.log('download url is: ' + href);
			window.open(href);
		},
		change2: function change2() {
			if (this.form2.controlType == '0') {
				this.ifshow2 = true;
			} else {
				this.ifshow2 = false;
			}
		},
		handleSizeChange1: function handleSizeChange1(val) {
			this.pageSize1 = val;
			this.getData1(this.currentPage1);
		},
		handleCurrentChange1: function handleCurrentChange1(val) {
			this.currentPage1 = val;
			this.getData1(this.currentPage1);
		},
		handleSelectionChange1: function handleSelectionChange1(val) {
			this.multipleSelection1 = val;
		},
		bindRow: function bindRow(id) {
			var _this7 = this;

			var params = {
				riskId: this.riskId,
				terminalId: id,
				status: '0'
			};
			this.$confirm(this.$t('lin_global.sfbdczd'), this.$t('lin_btn.tips'), {
				confirmButtonText: this.$t('lin_btn.confirm'),
				cancelButtonText: this.$t('lin_btn.cancel'),
				type: 'warning'
			}).then(function () {
				__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/risk/bindingTerminal.do', params).then(function (res) {
					if (res.data.status == '200') {
						_this7.$message.success(_this7.$t('lin_global.bdcg'));

						_this7.dialogTopMgVisible = false;
					} else {
						_this7.$message.error(res.data.message);
					}
				});
			});
		},
		batchBindRow: function batchBindRow() {
			var _this8 = this;

			if (this.multipleSelection1.length === 0) {
				this.$message.error(this.$t('lin_global.qxzybddzd'));
				return false;
			} else {
				this.$confirm(this.$t('lin_global.sfjxplbd'), this.$t('lin_btn.tips'), {
					confirmButtonText: this.$t('lin_btn.confirm'),
					cancelButtonText: this.$t('lin_btn.cancel'),
					type: 'warning'
				}).then(function () {
					var ids = [];

					for (var i = 0; i < _this8.multipleSelection1.length; i++) {
						ids.push(_this8.multipleSelection1[i].terminalId);
					}
					var rq = ids.join(',');
					var params = {
						riskId: _this8.riskId,
						terminalId: rq,
						status: '0'
					};
					__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/risk/bindingTerminal.do', params).then(function (res) {
						if (res.data.status == '200') {
							_this8.$message.success(_this8.$t('lin_global.bdcg'));

							_this8.dialogTopMgVisible = false;
						} else {
							_this8.$message.error(res.data.message);
						}
					});
				}).catch(function () {});
			}
		},

		submit2: function submit2() {
			var _this9 = this;

			this.params = {};
			if (this.form2.controlType == '0') {
				this.params.id = this.riskId;
				this.params.radius = this.radius2;
				this.params.controllerName = this.form2.controllerName;
				this.params.controllerDesc = this.form2.controllerDesc;
				this.params.messageId = this.form2.messageId;
				this.params.controlType = this.form2.controlType;
			} else {
				this.params.id = this.riskId;
				this.params.city = this.citys2;
				this.params.controllerName = this.form2.controllerName;
				this.params.controllerDesc = this.form2.controllerDesc;
				this.params.messageId = this.form2.messageId;
				this.params.controlType = this.form2.controlType;
			}

			var params = this.params;
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/risk/editRisk.do', params).then(function (res) {
				if (res.data.status == 200) {
					_this9.dialogFormVisible2 = false;
					_this9.$message.success(res.data.message);
					_this9.getData(1, '', '');
				} else {
					_this9.dialogFormVisible2 = false;
					_this9.$message.error(res.data.message);
				}
			});
		},
		getDetail: function getDetail() {
			var _this10 = this;

			var params = {
				riskId: this.riskId
			};
			this.sel2 = [];
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/risk/getByIdRisk.do', params).then(function (res) {
				_this10.form2.controllerName = res.data.data.controlName;
				_this10.form2.controllerDesc = res.data.data.controlDesc;
				_this10.form2.messageId = res.data.data.messageid;
				if (res.data.data.controlType == '0') {
					_this10.ifShow2 = true;
					_this10.ifshow2 = true;
					_this10.form2.controlType = '0';
					_this10.radius2 = res.data.data.radius;
				} else {
					_this10.ifShow2 = false;
					_this10.ifshow2 = false;
					_this10.form2.controlType = '1';
					_this10.citys2 = res.data.data.city;
					var arr = res.data.data.city.split(',');

					_this10.sel2.push(arr[1]);
					_this10.sel2.push(arr[2]);
				}
			});
		},
		submit: function submit() {
			var _this11 = this;

			this.params = {};
			if (this.form.controlType == '0') {
				this.params.radius = this.radius;
				this.params.controllerName = this.form.controllerName;
				this.params.controllerDesc = this.form.controllerDesc;
				this.params.messageId = this.form.messageId;
				this.params.controlType = this.form.controlType;
			} else {
				this.params.city = this.citys;
				this.params.controllerName = this.form.controllerName;
				this.params.controllerDesc = this.form.controllerDesc;
				this.params.messageId = this.form.messageId;
				this.params.controlType = this.form.controlType;
			}

			var params = this.params;
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/risk/addRisk.do', params).then(function (res) {
				if (res.data.status == 200) {
					_this11.dialogFormVisible = false;
					_this11.$message.success(res.data.message);
					_this11.getData(1);
				} else {
					_this11.dialogFormVisible = false;
					_this11.$message.error(res.data.message);
				}
			});
		},
		onCancel: function onCancel() {
			this.dialogFormVisible = false;
		},
		onCancel2: function onCancel2() {
			this.dialogFormVisible2 = false;
		},
		change: function change() {
			if (this.form.controlType == '0') {
				this.ifshow = true;
			} else {
				this.ifshow = false;
			}
		},
		getAd: function getAd() {
			var _this12 = this;

			var params = {
				page: 1,
				rows: 10000,
				mechId: this.qudaoshangid
			};
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/mechanism/list.do', params).then(function (res) {
				_this12.areaList = res.data.data;
			});
		},
		uploadCer: function uploadCer() {
			this.$setWObj('safeCerType', 1);
			this.$router.push({
				path: '/certificate/upload'
			});
		},

		add: function add() {
			this.$router.push({
				path: '/certificate/new'
			});
		},
		upload: function upload() {
			this.$router.push({
				path: '/certificate/upload'
			});
		},
		linkDetail: function linkDetail(row) {
			this.$router.push({
				path: '/rail/' + row.id + '/detail'
			});
		},
		handleSizeChange: function handleSizeChange(val) {
			this.pageSize = val;
			this.getData(this.currentPage);
		},
		handleCurrentChange: function handleCurrentChange(val) {
			this.currentPage = val;
			this.getData(this.currentPage);
		},
		getData: function getData(page) {
			var _this13 = this;

			this.currentPage = page;
			var params2 = {
				page: page,
				rows: this.pageSize,
				certType: this.ctype,
				userMechId: this.mech,
				certName: this.queryKey,
				orderName: this.orderName,
				orderType: this.orderType
			};

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/cer/listCertificate.do', params2).then(function (res) {
				if (res.data.status == 200) {
					_this13.tableData2 = res.data.data;
					_this13.totalRecords = res.data.total;
					_this13.loading = false;
				} else {
					_this13.loading = false;
				}
			});
		}
	}
});

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    var phoneCheck = function phoneCheck(rule, value, callback) {
      if (0) {
        callback(new Error(_this.$t('app_phoneIllegal')));
      } else {
        callback();
      }
    };
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
      tableData: [],
      index: 1,
      row: this.$gRow,
      devices: 0,
      token: localStorage['user'],
      type: 2,
      types: [{ label: '渠道商', vl: 2 }, { label: '设备', vl: 1 }],
      radio: '1',
      mech: '',
      mechs: [],
      fatherList: [],
      form: {
        distributor: '',
        ofCheck: '',
        dvNo: ''
      },
      rules: {
        distributor: [{ required: true, message: this.$t('app_selectChannel'), trigger: 'blur' }],
        dvNo: [{ required: true, message: this.$t('app_input'), trigger: 'blur' }]
      }
    }, 'index', 1);
  },

  methods: {
    hisOperate: function hisOperate(is, row) {
      var _this2 = this;

      var otype = is ? '0' : '1';
      console.log(row);
      this.$showConfirm(this.$t('app_tip'), this.$t('app_isOperate'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this2.$cerRightHisOperate(row.id, '', row.merchantId, otype, row.pushtype, function (res) {
          _this2.loading = 0;

          if (res.status === 200) {
            _this2.$message.success(res.message);
            _this2.getHis();
          } else {
            _this2.$message.error(res.message);
          }
        }, function () {
          _this2.loading = 0;
          _this2.$message.error(_this2.$t('app_rqsError'));
        });
      }, '');
    },
    pageSelect: function pageSelect(index) {
      this.index = index;
      this.getHis();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getHis();
    },
    selectMc: function selectMc(vl) {
      this.getDevices(vl);
    },
    getDevices: function getDevices(mId) {
      var _this3 = this;

      this.$getChannelDevices(mId, function (res) {
        console.log('dvs', res);
        if (res.status === 200) {
          _this3.devices = res.data.nums;
        } else {
          _this3.$message.error(res.message);
        }
      }, function () {});
    },
    btn: function btn() {
      var _this4 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_isActive'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        var ids = '';
        _this4.multipleSelection.forEach(function (vl) {
          ids += vl.packagename + ',';
        });
        ids = ids.substring(0, ids.length - 1);

        if (!ids) {
          _this4.$message(_this4.$t('app_chooseOneMust'));
          return;
        }
        _this4.loading = 1;
        if (_this4.$appUrlTag === 0) {
          _this4.$appDistributeOnOff(_this4.mechanismId, ids, '1', function (res) {
            if (res.status === 200) {
              _this4.getHis();
            } else {
              _this4.$message.error(res.message);
            }
            _this4.loading = 0;
          }, function () {
            _this4.loading = 0;
          });
        } else {
          _this4.$appDistributeOnOff1(_this4.mechanismId, ids, '1', function (res) {
            if (res.status === 200) {
              _this4.getHis();
            } else {
              _this4.$message.error(res.message);
            }
            _this4.loading = 0;
          }, function () {
            _this4.loading = 0;
          });
        }
      }, '');
    },
    save: function save() {
      var _this5 = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {

          _this5.loading = 1;
          var type = _this5.radio === '1' ? '1' : '0';
          var tNo = _this5.type === 1 ? _this5.form.dvNo : _this5.form.distributor;
          _this5.$cmOperate('YQCTL', type, tNo, _this5.type, function (res) {
            _this5.loading = 0;
            if (res.status === 200) {

              _this5.$message(res.message);
            } else {
              _this5.$message.error(res.message);
            }
          }, function () {
            _this5.loading = 0;
            _this5.$message.error(_this5.$t('app_rqsError'));
          });
        } else {
          return false;
        }
      });
    },
    getHis: function getHis() {
      var _this6 = this;

      this.loading = 1;
      var flag = '0,1';
      this.$cerRightHistory(this.index, this.$gRow, this.token, flag, function (res) {
        _this6.loading = 0;
        if (res.status === 200) {
          console.log('his', res);
          _this6.tableData = res.data;
          _this6.total = res.total;
        } else {
          _this6.$message.error(res.message);
        }
      }, function () {
        _this6.loading = 0;
        _this6.$message.error(_this6.$t('app_rqsError'));
      });
    }
  },
  mounted: function mounted() {
    var _this7 = this;

    this.getHis();

    this.$getChannelList(999, 1, '', '', '', function (res) {
      if (res.status === 200) {
        console.log(res);
        _this7.mechs = res.data;
      } else {
        _this7.$message.error(res.message);
      }
    }, function () {
      _this7.$message.error(_this7.$t('app_rqsError'));
    });
  }
});

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__city_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_TernoAutoCtrl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_TernoAutoCtrl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_TernoAutoCtrl__);







/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		AutoTerno: __WEBPACK_IMPORTED_MODULE_3__global_TernoAutoCtrl___default.a
	},
	data: function data() {
		var that = this;
		return {
			tableData2: [],
			delete_list: [],
			pageSize: 10,
			currentPage: 0,
			totalRecords: 0,
			pushdev: false,
			push_list: [],
			ttpage: 20,
			tableData: [],
			total: 0,
			page: 1,
			isNon: false,
			pushImport: false,
			fileList: [],
			uldata: '',
			snum: 0,
			downTpl: __WEBPACK_IMPORTED_MODULE_1__api_url__["b" /* urlAssets */].prefix + 'tms-server-web/model/terminalNos.xlsx',
			importTemplate: __WEBPACK_IMPORTED_MODULE_1__api_url__["b" /* urlAssets */].prefix + 'tms-server-web/import/terminalList.do',
			formLabelWidth: '28.5%',

			mechanismData: {
				callback: function callback(value) {
					that.select_form.mechId = value;
				}
			},
			mechanismData_2: {
				callback: function callback(value) {
					that.form.mechId = value;
					that.get_device_list();
				}
			},
			mech: '',
			ctyps: [{
				vl: '0',
				lb: this.$t('app_status_update')
			}, {
				vl: '1',
				lb: this.$t('app_status_updated')
			}, {
				vl: '2',
				lb: this.$t('app_status_exist')
			}, {
				vl: '3',
				lb: this.$t('app_status_fail')
			}],
			ctype: '',
			queryKey: '',
			ahref: '',
			select_form: {
				secretName: ""
			},
			focusEvent: __WEBPACK_IMPORTED_MODULE_1__api_url__["c" /* focusEvent */],
			loading: true,
			keyType_list: [{
				id: 0,
				label: "PIN",
				value: 0
			}, {
				id: 1,
				label: "MAC",
				value: 1
			}, {
				id: 2,
				label: "TD",
				value: 2
			}, {
				id: 3,
				label: "MAIN",
				value: 3
			}, {
				id: 4,
				label: "PTK",
				value: 4
			}, {
				id: 5,
				label: "CBC_TD",
				value: 130
			}, {
				id: 6,
				label: "CBC_PIN",
				value: 128
			}, {
				id: 7,
				label: "CBC_MAC",
				value: 129
			}],
			An_list: [{
				id: 0,
				label: "MODE_3DES",
				value: 1
			}, {
				id: 1,
				label: "MODE_SM4",
				value: 2
			}, {
				id: 2,
				label: "MODE_AES",
				value: 3
			}, {
				id: 3,
				label: "MODE_DUKPT_DES",
				value: 8193
			}, {
				id: 4,
				label: "MODE_DUKPT_SM4",
				value: 8194
			}, {
				id: 5,
				label: "MODE_FIXED_DES",
				value: 16385
			}, {
				id: 6,
				label: "MODE_FIXED_SM4",
				value: 16386
			}]
		};
	},
	created: function created() {
		this.getData();
	},

	methods: {
		get_key_type: function get_key_type(index) {
			var result = "";
			for (var i = 0; i < this.keyType_list.length; i++) {
				if (index == this.keyType_list[i].value) {
					result = this.keyType_list[i].label;
				}
			}
			return result;
		},
		get_an: function get_an(index) {
			var result = "";
			for (var i = 0; i < this.An_list.length; i++) {
				if (index == this.An_list[i].value) {
					result = this.An_list[i].label;
				}
			}
			return result;
		},
		cellClick: function cellClick(row, ev, col) {
			if (!col.label || col.label === this.$t('app_operate')) {
				return;
			}

			this.$router.push({
				path: '/keyManagement/detail',
				query: {
					kid: row.id,
					kName: row.secretName
				}
			});
		},
		open_add: function open_add() {
			this.$router.push({
				path: '/keyManagement/add'
			});
		},
		query: function query() {
			this.getData();
		},
		handleDevice: function handleDevice(val) {
			this.delete_list = val;
			console.log(this.delete_list);
		},
		delete_select: function delete_select() {
			var _this = this;

			var terminal_list = [];
			for (var i = 0; i < this.delete_list.length; i++) {
				terminal_list.push(this.delete_list[i].id);
			}
			this.$confirm(this.$t('lin_global.confirmDelete'), this.$t('lin_btn.tips'), {
				confirmButtonText: this.$t('lin_btn.confirm'),
				cancelButtonText: this.$t('lin_btn.cancel'),
				type: 'warning'
			}).then(function () {
				__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/secret/delete.do', {
					id: String(terminal_list)
				}).then(function (res) {
					if (res.data.status == 200) {
						_this.$message.success(_this.$t('lin_global.delete_success'));
						_this.getData();
					} else {
						_this.$message.error(res.data.message);
					}
				});
			});
		},
		deleteRow: function deleteRow(id) {
			var _this2 = this;

			this.$confirm(this.$t('lin_global.confirmDelete'), this.$t('lin_btn.tips'), {
				confirmButtonText: this.$t('lin_btn.confirm'),
				cancelButtonText: this.$t('lin_btn.cancel'),
				type: 'warning'
			}).then(function () {
				__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/secret/delete.do', {
					id: id
				}).then(function (res) {
					if (res.data.status == 200) {
						_this2.$message.success(_this2.$t('lin_global.delete_success'));
						_this2.getData();
					} else {
						_this2.$message.error(res.data.message);
					}
				});
			}).catch(function () {});
		},
		editRow: function editRow(data) {
			console.log(data);
			this.$router.push({
				path: '/keyManagement/edit',
				query: {
					data: data

				}
			});
		},

		handleSizeChange: function handleSizeChange(val) {
			this.pageSize = val;
			this.getData();
		},

		handleCurrentChange: function handleCurrentChange(val) {
			this.currentPage = val;
			this.getData();
		},

		getData: function getData() {
			var _this3 = this;

			var data = {
				page: this.currentPage,
				rows: this.pageSize,
				secretName: this.select_form.secretName
			};
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/secret/pageList.do', data).then(function (res) {
				if (res.data.status == 200) {
					_this3.tableData2 = res.data.data;
					_this3.totalRecords = res.data.total;
					_this3.loading = false;
				} else {
					_this3.loading = false;
				}
			});
		}
	}
});

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_tyc__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_tyc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_tyc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_global_tagc__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_global_tagc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_global_tagc__);








/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		var that = this;
		return {
			delete_device_list: [],
			ttpage: 20,
			total_2: 0,
			page_2: 1,
			pushdev: false,
			push_list: [],
			tableData_2: [],
			mechanismData_2: {
				callback: function callback(value) {
					that.form.mechId = value;
					that.get_device_list();
				}
			},
			cmtStatusArr: [{
				vl: "1",
				lb: "在线"
			}, {
				vl: "2",
				lb: "离线"
			}, {
				vl: "0",
				lb: "新增"
			}, {
				vl: "3",
				lb: "休眠"
			}],
			key_detail: {
				id: "",
				secretName: ""
			},
			select_form: {
				terminalNo: ""
			},
			form: {
				terminalNo: '',
				cmtStatus: "",
				mechId: ''

			},
			orderType: '',
			orderName: '',
			tty: '',
			mech: '',
			mech1: '',
			srchValue: '',
			delete_list: [],
			info: '',
			bindVl: '',
			config: '',
			captures: [],
			loading: 0,
			tableData: [],
			tags: [],
			page: 1,
			index: 1,
			hiss: [],
			total: 0
		};
	},

	components: {
		tyc: __WEBPACK_IMPORTED_MODULE_3__components_global_tyc___default.a,
		MechanismSelector: __WEBPACK_IMPORTED_MODULE_4__components_global_mechanism_selector_vue___default.a,
		tagc: __WEBPACK_IMPORTED_MODULE_5__components_global_tagc___default.a
	},
	created: function created() {
		this.key_detail.id = this.$route.query.kid;
		this.key_detail.secretName = this.$route.query.kName;
		this.getList();
	},

	methods: {
		open_add: function open_add() {
			this.pushdev = true;
			this.get_device_list();
		},
		pageSized: function pageSized(vl) {
			this.ttpage = vl;
			this.get_device_list();
		},
		pageSelect: function pageSelect(vl) {
			this.page_2 = vl;
			this.get_device_list();
		},
		handleSelectionChange: function handleSelectionChange(vl) {
			this.push_list = vl;
		},
		pushed: function pushed(row) {
			var _this = this;

			this.$showConfirm(this.$t('app_tip'), this.$t('app_srpush') + ' ?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
				__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/secret/addTerminal.do', {
					terminalNo: row.terminalNo,
					secretId: _this.key_detail.id
				}).then(function (res) {
					if (res.status === 200) {
						_this.$message.success(res.data.message);
						_this.handleClose();
						_this.getList();
					} else {
						_this.$message.error(res.message);
					}
				});
			}, '');
		},
		bcPush: function bcPush() {
			var _this2 = this;

			var terminal_list = [];
			for (var i = 0; i < this.push_list.length; i++) {
				terminal_list.push(this.push_list[i].terminalNo);
			}
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/secret/addTerminal.do', {
				terminalNo: String(terminal_list),
				secretId: this.key_detail.id
			}).then(function (res) {
				if (res.status === 200) {
					_this2.$message.success(res.data.message);
					_this2.handleClose();
					_this2.getList();
				} else {
					_this2.$message.error(res.message);
				}
			});
		},
		handleClose: function handleClose() {
			this.pushdev = false;
			this.form = {
				terminalNo: '',
				cmtStatus: "",
				mechId: ''
			};
			var that = this;
			this.mechanismData_2 = {
				callback: function callback(value) {
					that.form.mechId = value;
					that.get_device_list();
				}
			};
		},
		handleDevice: function handleDevice(val) {
			this.delete_device_list = val;
		},
		delete_device: function delete_device() {
			var _this3 = this;

			var terminal_list = [];
			for (var i = 0; i < this.delete_device_list.length; i++) {
				terminal_list.push(this.delete_device_list[i].id);
			}
			this.$confirm(this.$t('lin_global.confirmDelete'), this.$t('lin_btn.tips'), {
				confirmButtonText: this.$t('lin_btn.confirm'),
				cancelButtonText: this.$t('lin_btn.cancel'),
				type: 'warning'
			}).then(function () {
				__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/secret/deletedTerminal.do', {
					id: String(terminal_list)
				}).then(function (res) {
					if (res.data.status == 200) {
						_this3.$message.success(_this3.$t('lin_global.delete_success'));
						_this3.getList();
					} else {
						_this3.$message.error(res.data.message);
					}
				});
			});
		},
		deleteRow: function deleteRow(id) {
			var _this4 = this;

			this.$confirm(this.$t('lin_global.confirmDelete'), this.$t('lin_btn.tips'), {
				confirmButtonText: this.$t('lin_btn.confirm'),
				cancelButtonText: this.$t('lin_btn.cancel'),
				type: 'warning'
			}).then(function () {
				__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/secret/deletedTerminal.do', {
					id: id
				}).then(function (res) {
					if (res.data.status == 200) {
						_this4.$message.success(_this4.$t('lin_global.delete_success'));
						_this4.getList();
					} else {
						_this4.$message.error(res.data.message);
					}
				});
			}).catch(function () {});
		},
		get_device_list: function get_device_list() {
			var _this5 = this;

			this.loading = true;
			var mc = this.form.mechId;
			var tno = this.form.terminalNo;
			var tstatus = this.form.cmtStatus;
			this.$getDvDevices(this.page_2, this.ttpage, mc, tno, tstatus, "", '', '', '', '', function (res) {
				_this5.loading = 0;
				if (res.status === 200) {
					_this5.tableData_2 = res.data;
					_this5.total_2 = res.total;
				} else {
					_this5.$message.error(res.message);
				}
			}, function () {
				_this5.loading = 0;
			});
		},
		getList: function getList() {
			var _this6 = this;

			var add_form = {
				page: this.page,
				rows: this.$gRow,
				secretId: this.key_detail.id,
				terminalNo: this.select_form.terminalNo
			};
			this.loading = 1;
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/secret/terminalList.do', add_form).then(function (res) {
				if (res.data.status == 200) {
					_this6.tableData = res.data.data;
					_this6.total = res.data.total;
					_this6.loading = false;
				} else {
					_this6.loading = false;
				}
			});
		},
		pageChange: function pageChange(vl) {
			this.page = vl;
			this.getList();
		},
		pageSize: function pageSize(val) {
			this.$gRow = val;
			this.getList();
		}
	}
});

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_url__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			keyType_list: [{
				id: 0,
				label: "PIN",
				value: 0
			}, {
				id: 1,
				label: "MAC",
				value: 1
			}, {
				id: 2,
				label: "TD",
				value: 2
			}, {
				id: 3,
				label: "MAIN",
				value: 3
			}, {
				id: 4,
				label: "PTK",
				value: 4
			}, {
				id: 5,
				label: "CBC_TD",
				value: 130
			}, {
				id: 6,
				label: "CBC_PIN",
				value: 128
			}, {
				id: 7,
				label: "CBC_MAC",
				value: 129
			}],
			keyIndex_list: [{
				id: 0,
				label: "-1",
				value: -1
			}, {
				id: 1,
				label: "0",
				value: 0
			}, {
				id: 2,
				label: "1",
				value: 1
			}, {
				id: 3,
				label: "2",
				value: 2
			}, {
				id: 4,
				label: "3",
				value: 3
			}, {
				id: 5,
				label: "4",
				value: 4
			}, {
				id: 6,
				label: "5",
				value: 5
			}, {
				id: 7,
				label: "6",
				value: 6
			}, {
				id: 8,
				label: "7",
				value: 7
			}, {
				id: 9,
				label: "8",
				value: 8
			}],
			keyDown_list: [{
				id: 1,
				label: "0",
				value: 0
			}, {
				id: 2,
				label: "1",
				value: 1
			}, {
				id: 3,
				label: "2",
				value: 2
			}, {
				id: 4,
				label: "3",
				value: 3
			}, {
				id: 5,
				label: "4",
				value: 4
			}, {
				id: 6,
				label: "5",
				value: 5
			}, {
				id: 7,
				label: "6",
				value: 6
			}, {
				id: 8,
				label: "7",
				value: 7
			}, {
				id: 9,
				label: "8",
				value: 8
			}],
			An_list: [{
				id: 0,
				label: "MODE_3DES",
				value: 1
			}, {
				id: 1,
				label: "MODE_SM4",
				value: 2
			}, {
				id: 2,
				label: "MODE_AES",
				value: 3
			}, {
				id: 3,
				label: "MODE_DUKPT_DES",
				value: 8193
			}, {
				id: 4,
				label: "MODE_DUKPT_SM4",
				value: 8194
			}, {
				id: 5,
				label: "MODE_FIXED_DES",
				value: 16385
			}, {
				id: 6,
				label: "MODE_FIXED_SM4",
				value: 16386
			}],
			show_bdk: true,
			key_detail: {},
			show_edit: false,

			loading: 0,
			cer: {
				name: '',
				mark: '',
				curl: '',
				purl: '',
				mech: ''
			},
			form: {
				secretName: '',
				keyType: "",
				encryptionIndex: "",
				downloadIndex: "",
				algorithmModel: "",
				component1: "",
				component2: ""
			},
			rules: {
				secretName: [{
					required: true,
					message: this.$t('app_input'),
					trigger: 'blur'
				}],
				mech: [{
					required: true,
					message: this.$t('app_selectChannel'),
					trigger: 'blur'
				}],
				curl: [{
					required: true,
					message: this.$t('app_plsUlPbCer'),
					trigger: 'blur'
				}]
			}
		};
	},
	created: function created() {
		this.form = this.$route.query.data;
	},

	methods: {
		is_hidden: function is_hidden() {
			this.show_bdk = false;
		},
		cancel: function cancel() {
			this.$router.go(-1);
		},
		submit: function submit() {
			var _this = this;

			this.$refs['cer'].validate(function (valid) {
				if (valid) {
					console.log("通过校验");
					console.log(_this.form);
					__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/secret/edit.do', _this.form).then(function (res) {
						if (res.data.status == 200) {
							_this.$message.success("编辑成功");
							_this.$router.go(-1);
							_this.loading = false;
						} else {
							_this.loading = false;
						}
					});
				} else {
					return false;
				}
			});
		}
	}
});

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_url__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			keyType_list: [{
				id: 0,
				label: "PIN",
				value: 0
			}, {
				id: 1,
				label: "MAC",
				value: 1
			}, {
				id: 2,
				label: "TD",
				value: 2
			}, {
				id: 3,
				label: "MAIN",
				value: 3
			}, {
				id: 4,
				label: "PTK",
				value: 4
			}, {
				id: 5,
				label: "CBC_TD",
				value: 130
			}, {
				id: 6,
				label: "CBC_PIN",
				value: 128
			}, {
				id: 7,
				label: "CBC_MAC",
				value: 129
			}],
			keyIndex_list: [{
				id: 0,
				label: "-1",
				value: -1
			}, {
				id: 1,
				label: "0",
				value: 0
			}, {
				id: 2,
				label: "1",
				value: 1
			}, {
				id: 3,
				label: "2",
				value: 2
			}, {
				id: 4,
				label: "3",
				value: 3
			}, {
				id: 5,
				label: "4",
				value: 4
			}, {
				id: 6,
				label: "5",
				value: 5
			}, {
				id: 7,
				label: "6",
				value: 6
			}, {
				id: 8,
				label: "7",
				value: 7
			}, {
				id: 9,
				label: "8",
				value: 8
			}],
			keyDown_list: [{
				id: 1,
				label: "0",
				value: 0
			}, {
				id: 2,
				label: "1",
				value: 1
			}, {
				id: 3,
				label: "2",
				value: 2
			}, {
				id: 4,
				label: "3",
				value: 3
			}, {
				id: 5,
				label: "4",
				value: 4
			}, {
				id: 6,
				label: "5",
				value: 5
			}, {
				id: 7,
				label: "6",
				value: 6
			}, {
				id: 8,
				label: "7",
				value: 7
			}, {
				id: 9,
				label: "8",
				value: 8
			}],
			An_list: [{
				id: 0,
				label: "MODE_3DES",
				value: 1
			}, {
				id: 1,
				label: "MODE_SM4",
				value: 2
			}, {
				id: 2,
				label: "MODE_AES",
				value: 3
			}, {
				id: 3,
				label: "MODE_DUKPT_DES",
				value: 8193
			}, {
				id: 4,
				label: "MODE_DUKPT_SM4",
				value: 8194
			}, {
				id: 5,
				label: "MODE_FIXED_DES",
				value: 16385
			}, {
				id: 6,
				label: "MODE_FIXED_SM4",
				value: 16386
			}],
			show_bdk: true,
			key_detail: {},
			show_edit: false,

			loading: 0,
			cer: {
				name: '',
				mark: '',
				curl: '',
				purl: '',
				mech: ''
			},
			form: {
				secretName: '',
				keyType: "",
				encryptionIndex: "",
				downloadIndex: "",
				algorithmModel: "",
				component1: "",
				component2: ""
			},
			rules: {
				secretName: [{
					required: true,
					message: this.$t('app_input'),
					trigger: 'blur'
				}],
				mech: [{
					required: true,
					message: this.$t('app_selectChannel'),
					trigger: 'blur'
				}],
				curl: [{
					required: true,
					message: this.$t('app_plsUlPbCer'),
					trigger: 'blur'
				}]
			}
		};
	},
	created: function created() {},

	methods: {
		is_hidden: function is_hidden() {
			this.show_bdk = false;
		},
		cancel: function cancel() {
			this.$router.go(-1);
		},
		submit: function submit() {
			var _this = this;

			this.$refs['cer'].validate(function (valid) {
				if (valid) {
					console.log("通过校验");
					console.log(_this.form);
					__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/secret/add.do', _this.form).then(function (res) {
						if (res.data.status == 200) {
							_this.$message.success("添加成功");
							_this.$router.go(-1);
							_this.loading = false;
						} else {
							_this.loading = false;
						}
					});
				} else {
					return false;
				}
			});
		}
	}
});

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_url__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      ahref: '',
      certinfo: {}

    };
  },
  created: function created() {
    this.getDetail();
  },

  methods: {
    uploadCer: function uploadCer() {
      this.$setWObj('safeCerType', 0);
      this.$router.push({ path: '/mycer/upload' });
    },

    getDetail: function getDetail() {
      var _this = this;

      var mechanismId = localStorage.getItem('mechanismId');;
      var params = { distributorId: mechanismId };
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/cer/getByDistributorId.do', params).then(function (res) {
        if (res.data.status == 200) {
          _this.certinfo = res.data.data;

          _this.ahref = __WEBPACK_IMPORTED_MODULE_1__api_url__["b" /* urlAssets */].prefix + res.data.data.url;
        }
      });
    }
  }
});

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__city_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_TernoAutoCtrl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_TernoAutoCtrl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_TernoAutoCtrl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_global_tagc__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_global_tagc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_global_tagc__);









/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		AutoTerno: __WEBPACK_IMPORTED_MODULE_3__global_TernoAutoCtrl___default.a,
		MechanismSelector: __WEBPACK_IMPORTED_MODULE_4__components_global_mechanism_selector_vue___default.a,
		tagc: __WEBPACK_IMPORTED_MODULE_5__components_global_tagc___default.a
	},
	data: function data() {
		var that = this;
		return {
			pushdev: false,
			push_list: [],
			id_list: [],
			ttpage: 20,
			tableData: [],
			total: 0,
			page: 1,
			cmtStatusArr: [{
				vl: "1",
				lb: this.$t('app_online')
			}, {
				vl: "2",
				lb: this.$t('app_offline')
			}, {
				vl: "0",
				lb: this.$t('app_new')
			}, {
				vl: "3",
				lb: this.$t('app_sleep')
			}],
			secretKeyDownload_list: [{
				vl: "0",
				lb: this.$t('app_no')
			}, {
				vl: "1",
				lb: this.$t('app_yes')
			}],
			secretKeyExist_list: [{
				vl: "0",
				lb: this.$t('app_no')
			}, {
				vl: "1",
				lb: this.$t('app_yes')
			}],
			isNon: false,
			pushImport: false,
			fileList: [],
			uldata: '',
			snum: 0,
			downTpl: __WEBPACK_IMPORTED_MODULE_1__api_url__["b" /* urlAssets */].prefix + 'tms-server-web/model/kmc_terminalNos.xlsx',
			importTemplate: __WEBPACK_IMPORTED_MODULE_1__api_url__["b" /* urlAssets */].prefix + 'tms-server-web/import/terminalList.do',
			formLabelWidth: '28.5%',

			mechanismData: {
				callback: function callback(value) {
					that.select_form.mechId = value;
				}
			},
			mechanismData_2: {
				callback: function callback(value) {
					that.form.mechId = value;
					that.get_device_list();
				}
			},
			mech: '',
			ctyps: [{
				vl: '0',
				lb: this.$t('app_status_update')
			}, {
				vl: '1',
				lb: this.$t('app_status_updated')
			}, {
				vl: '2',
				lb: this.$t('app_status_exist')
			}, {
				vl: '3',
				lb: this.$t('app_status_fail')
			}],
			ctype: '',
			queryKey: '',
			ahref: '',
			form: {
				terminalNo: '',
				cmtStatus: "",
				mechId: '',
				secretKeyDownload: "",
				secretKeyExist: ""

			},
			select_form: {
				terminalNo: "",
				status: "",
				mechId: ""
			},
			rules: {
				'terminalNo': [{
					required: true,
					message: this.$t('lin_global.quorter')
				}]
			},
			type: [{
				typename: this.$t('lin_global.label_areaid'),
				typeid: '2'
			}, {
				typename: this.$t('lin_global.shebei'),
				typeid: '1'
			}],
			sel: [],
			sel2: [],
			options: __WEBPACK_IMPORTED_MODULE_2__city_js__["a" /* default */],
			focusEvent: __WEBPACK_IMPORTED_MODULE_1__api_url__["c" /* focusEvent */],
			riskId: '',
			radius: '',
			citys: '',
			radius2: '',
			citys2: '',
			input1: '',
			value1: '',
			areaList1: [],
			dialogFormVisible: false,
			dialogFormVisible2: false,
			dialogTopMgVisible: false,
			currentPage: 1,
			pageSize: 10,
			totalRecords: 0,
			currentPage1: 1,
			areaList: [],
			arrdata1: [],
			tableData2: [],
			xiafaVisible: false,
			zhengshu: '',
			qudaoshangxinxi: '',
			qudaoshangid: '',
			zhengshutype: '',
			isShow: true,
			isSubmit: false,
			loading: true

		};
	},
	created: function created() {
		this.getData();
	},

	computed: {
		isCreate: function isCreate() {
			return localStorage.userType === '0';
		},
		isCerUpload: function isCerUpload() {
			return true;
		}
	},
	methods: {
		ulurl: function ulurl() {
			var url = this.$push_device_Url + '?token=' + localStorage.user + '&language=' + localStorage.system_lang;

			return url;
		},
		submitUpload: function submitUpload() {
			this.$refs.upload.submit();
		},
		open_import: function open_import() {
			this.pushImport = true;
		},
		closeImport: function closeImport() {
			this.pushImport = false;
			this.fileList = [];
			this.uldata = '';
		},
		push_device: function push_device() {
			this.$outputDevice(this.select_form.terminalNo, this.select_form.status, this.select_form.mechId);
		},
		batchDelete: function batchDelete() {
			var _this = this;

			var temp_list = [];
			for (var i = 0; i < this.id_list.length; i++) {
				temp_list.push(this.id_list[i].id);
			}
			this.$confirm(this.$t('lin_global.confirmDelete'), this.$t('lin_btn.tips'), {
				confirmButtonText: this.$t('lin_btn.confirm'),
				cancelButtonText: this.$t('lin_btn.cancel'),
				type: 'warning'
			}).then(function () {
				__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/kmc/delete.do', {
					id: String(temp_list)
				}).then(function (res) {
					if (res.data.status == 200) {
						_this.$message.success(_this.$t('lin_global.delete_success'));
						_this.getData();
					} else {
						_this.$message.error(res.data.message);
					}
				});
			}).catch(function () {});
		},
		srcBefore: function srcBefore(file) {
			window[this.$route.path] = 1;
		},
		srcSuccess: function srcSuccess(res, file) {
			window[this.$route.path] = '';


			if (res.status === 200) {
				this.$message.success(res.message);
				this.closeImport();
			} else {

				this.$message.error(res.message);
			}
		},
		ulError: function ulError() {
			window[this.$route.path] = '';
		},
		open_add: function open_add() {
			this.pushdev = true;
			this.get_device_list();
		},
		pageSized: function pageSized(vl) {
			this.ttpage = vl;
			this.get_device_list();
		},
		pageSelect: function pageSelect(vl) {
			this.page = vl;
			this.get_device_list();
		},
		fileImport: function fileImport() {},
		pushed: function pushed(row) {
			var _this2 = this;

			this.$showConfirm(this.$t('app_tip'), this.$t('app_srpush') + ' ?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
				_this2.$device_push({
					terminalNo: row.terminalNo
				}, function (res) {
					_this2.loading = false;
					if (res.status === 200) {
						_this2.$message.success(res.message);
						_this2.handleClose();
					} else {
						_this2.$message.error(res.message);
					}
				}, function () {
					_this2.loading = false;
				});
			}, '');
		},
		bcPush: function bcPush() {
			var _this3 = this;

			var terminal_list = [];
			for (var i = 0; i < this.push_list.length; i++) {
				terminal_list.push(this.push_list[i].terminalNo);
			}
			this.$device_push({
				terminalNo: String(terminal_list)
			}, function (res) {
				_this3.loading = false;
				if (res.status === 200) {
					_this3.$message.success(res.message);
					_this3.handleClose();
				} else {
					_this3.$message.error(res.message);
				}
			}, function () {
				_this3.loading = false;
			});
		},
		pushAll: function pushAll() {
			this.$showConfirm(this.$t('app_tip'), this.$t('app_ispushalldv') + ' ?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {}, '');
		},
		get_device_list: function get_device_list() {
			var _this4 = this;

			this.loading = true;
			var mc = this.form.mechId;
			var tno = this.form.terminalNo;
			var tstatus = this.form.cmtStatus;

			this.$get_device_list(this.page, this.ttpage, this.form.secretKeyDownload, this.form.secretKeyExist, mc, tno, tstatus, '', '', '', function (res) {
				_this4.loading = 0;
				if (res.status === 200) {
					_this4.tableData = res.data;
					_this4.total = res.total;
				} else {
					_this4.$message.error(res.message);
				}
			}, function () {
				_this4.loading = 0;
			});
		},
		handleSelectionChange_1: function handleSelectionChange_1(vl) {
			this.id_list = vl;
		},
		handleSelectionChange: function handleSelectionChange(vl) {
			this.push_list = vl;
		},
		handleClose: function handleClose() {
			this.pushdev = false;
			this.form = {
				terminalNo: '',
				cmtStatus: "",
				mechId: '',
				secretKeyDownload: "",
				secretKeyExist: ""
			};
			var that = this;
			this.mechanismData_2 = {
				callback: function callback(value) {
					that.form.mechId = value;
					that.get_device_list();
				}
			};
			this.getData();
		},
		query: function query() {
			this.getData();
		},
		deleteRow: function deleteRow(id) {
			var _this5 = this;

			this.$confirm(this.$t('lin_global.confirmDelete'), this.$t('lin_btn.tips'), {
				confirmButtonText: this.$t('lin_btn.confirm'),
				cancelButtonText: this.$t('lin_btn.cancel'),
				type: 'warning'
			}).then(function () {
				__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/kmc/delete.do', {
					id: id
				}).then(function (res) {
					if (res.data.status == 200) {
						_this5.$message.success(_this5.$t('lin_global.delete_success'));
						_this5.getData();
					} else {
						_this5.$message.error(res.data.message);
					}
				});
			}).catch(function () {});
		},


		handleSizeChange: function handleSizeChange(val) {
			this.pageSize = val;
			this.getData();
		},

		handleCurrentChange: function handleCurrentChange(val) {
			this.currentPage = val;
			this.getData();
		},

		getData: function getData() {
			var _this6 = this;

			var data = {
				page: this.currentPage,
				rows: this.pageSize,
				terminalNo: this.select_form.terminalNo,
				status: this.select_form.status,
				mechId: this.select_form.mechId
			};
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/kmc/pageList.do', data).then(function (res) {
				if (res.data.status == 200) {
					_this6.tableData2 = res.data.data;
					_this6.totalRecords = res.data.total;
					_this6.loading = false;
				} else {
					_this6.loading = false;
				}
			});
		}
	}
});

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__city_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_TernoAutoCtrl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_TernoAutoCtrl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_TernoAutoCtrl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_global_mechanism_selector_vue__);









/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		AutoTerno: __WEBPACK_IMPORTED_MODULE_4__global_TernoAutoCtrl___default.a,
		MechanismSelector: __WEBPACK_IMPORTED_MODULE_5__components_global_mechanism_selector_vue___default.a
	},
	data: function data() {
		var that = this;
		return {
			orderName: '',
			orderType: '',
			mechanismData: {
				callback: function callback(value) {
					that.select_form.merchantId = value;
					that.query();
				}
			},
			select_form: {
				terminalNo: "",
				onlineStatus: "",
				status: "",
				merchantId: ""
			},
			mech: '',
			net_list: [{
				vl: "0",
				lb: this.$t('lin_global.new_add'),
				type: "gray"
			}, {
				vl: '1',
				lb: this.$t('lin_global.online'),
				type: "success"
			}, {
				vl: '2',
				lb: this.$t('lin_global.offline'),
				type: "danger"
			}, {
				vl: '3',
				lb: this.$t('app_sleep'),
				type: "",
				color: "#FECC0B"
			}],
			status_list: [{
				vl: "0"
			}, {
				vl: '1',
				lb: this.$t('auth_status_list.status_1')
			}, {
				vl: '2',
				lb: this.$t('auth_status_list.status_2')
			}, {
				vl: '3',
				lb: this.$t('auth_status_list.status_3')
			}, {
				vl: '4',
				lb: this.$t('auth_status_list.status_4')
			}, {
				vl: '5',
				lb: this.$t('auth_status_list.status_5')
			}, {
				vl: '6',
				lb: this.$t('auth_status_list.status_6')
			}],
			dest_list: [{
				vl: '1',
				lb: this.$t('lin_global.normal')
			}, {
				vl: '2',
				lb: this.$t('app_selfDestroy')
			}],
			ctype: '',
			queryKey: '',
			ahref: '',
			form: {
				pushType: '2',
				terminalNo: '',
				type: '',
				zl: 'XZZS',
				certificateId: ''
			},
			rules: {
				'terminalNo': [{
					required: true,
					message: this.$t('lin_global.quorter')
				}]
			},
			type: [{
				typename: this.$t('lin_global.label_areaid'),
				typeid: '2'
			}, {
				typename: this.$t('lin_global.shebei'),
				typeid: '1'
			}],
			sel: [],
			sel2: [],
			options: __WEBPACK_IMPORTED_MODULE_3__city_js__["a" /* default */],
			focusEvent: __WEBPACK_IMPORTED_MODULE_2__api_url__["c" /* focusEvent */],
			riskId: '',
			radius: '',
			citys: '',
			radius2: '',
			citys2: '',
			input1: '',
			value1: '',
			areaList1: [],
			ifshow: true,
			ifshow2: true,
			dialogFormVisible: false,
			dialogFormVisible2: false,
			dialogTopMgVisible: false,
			currentPage: 1,
			pageSize: 10,
			totalRecords: 0,
			currentPage1: 1,
			pageSize1: 10,
			totalRecords1: 0,
			areaList: [],
			arrdata1: [],
			tableData2: [],
			xiafaVisible: false,
			zhengshu: '',
			qudaoshangxinxi: '',
			qudaoshangid: '',
			zhengshutype: '',
			isShow: true,
			isSubmit: false,
			restaurants: [],
			loading: true
		};
	},
	created: function created() {
		this.getData(1);
	},

	methods: {
		query: function query() {
			this.getData(this.currentPage);
		},
		onDvInputChange: function onDvInputChange(vl) {

			this.form.terminalNo = vl;
		},

		rowClick: function rowClick(row, ev, col) {
			if (!col.label || col.label === this.$t('app_operate')) {
				return;
			}

			this.$router.push({
				path: '/authorization-detail',
				query: {
					terminalNo: row.terminalNo
				}
			});
		},
		querySearch: function querySearch(queryString, cb) {
			var restaurants = this.restaurants;
			var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;

			cb(results);
		},
		createFilter: function createFilter(queryString) {
			return function (restaurant) {
				var boo = restaurant.value.indexOf(queryString) === 0;
				return boo;
			};
		},

		getNoList: function getNoList() {
			var _this = this;

			var params = {
				mechId: this.qudaoshangid
			};
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/terminal/terminalNoList.do', params).then(function (res) {
				console.log('r', res.data.data);
				_this.restaurants = res.data.data;
			});
		},
		changeType: function changeType() {
			this.form.terminalNo = '';
			if (this.form.pushType == '2') {
				this.isShow = true;
			} else {
				this.isShow = false;
			}
		},
		formatNetwork: function formatNetwork(row, column) {
			var result = row.terminalStatus ? this.net_list[row.terminalStatus] : {
				vl: "",
				lb: "",
				type: ""
			};
			return result;
		},

		formatStatus: function formatStatus(row, column) {
			var result = row.status ? this.status_list[row.status].lb : "";
			return result;
		},
		cityFormat: function cityFormat(row) {
			if (row.city) {
				var value = row.city.split(',')[0];
				return value;
			}
		},
		hasValue: function hasValue(result, v, name) {
			if (!v[name] || v[name] === "") {
				return true;
			}
			return result.some(function (re) {
				return v[name] === re;
			});
		},
		selEvent: function selEvent(val) {
			var _this2 = this;

			var result = val.toString().split(',');
			var arr = this.options.filter(function (v) {
				if (_this2.hasValue(result, v, "value")) {
					if (v.children && v.children.length > 0) {
						v.children = v.children.filter(function (child) {
							if (_this2.hasValue(result, child, "value")) {
								return child;
							}
							return false;
						});
						return v;
					} else {
						return v;
					}
				}
			});

			if (arr[0].value === "110000" || arr[0].value === "120000" || arr[0].value === "310000" || arr[0].value === "500000") {
				this.citys = arr[0].label + "," + arr[0].value + "," + arr[0].children[0].value;
			} else {
				this.citys = arr[0].label + arr[0].children[0].label + "," + arr[0].value + "," + arr[0].children[0].value;
			}
		},
		selEvent2: function selEvent2(val) {
			var _this3 = this;

			var result = val.toString().split(',');
			var arr = this.options.filter(function (v) {
				if (_this3.hasValue(result, v, "value")) {
					if (v.children && v.children.length > 0) {
						v.children = v.children.filter(function (child) {
							if (_this3.hasValue(result, child, "value")) {
								return child;
							}
							return false;
						});
						return v;
					} else {
						return v;
					}
				}
			});

			if (arr[0].value === "110000" || arr[0].value === "120000" || arr[0].value === "310000" || arr[0].value === "500000") {
				this.citys2 = arr[0].label + "," + arr[0].value + "," + arr[0].children[0].value;
			} else {
				this.citys2 = arr[0].label + arr[0].children[0].label + "," + arr[0].value + "," + arr[0].children[0].value;
			}
		},
		getAd1: function getAd1() {
			var params = {
				page: 1,
				rows: 10000
			};
		},
		getData1: function getData1(page, no, areaid) {
			var _this4 = this;

			this.currentPage1 = page;
			var params = {
				page: page,
				rows: this.pageSize1,
				areaid: areaid,
				terminal_no: no,
				terminal_status: '',
				terminal_runtime_status: ''
			};

			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/terminal/list.do', params).then(function (res) {
				_this4.arrdata1 = res.data.data;
				_this4.totalRecords1 = res.data.total;
			}).catch(function (error) {});
		},
		statusChange: function statusChange() {
			this.getData1(1, this.input1, this.value1);
		},
		handleIconClick: function handleIconClick() {
			this.getData1(1, this.input1, this.value1);
		},

		actRow: function actRow(row) {
			var _this5 = this;

			console.log(row);
			var params = {
				terminalNo: row.terminalNo
			};
			this.$confirm(this.$t('app_isActive'), this.$t('lin_btn.tips'), {
				confirmButtonText: this.$t('lin_btn.confirm'),
				cancelButtonText: this.$t('lin_btn.cancel'),
				type: 'warning'
			}).then(function () {
				__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/terminal_auth/authentication.do', params).then(function (res) {
					if (res.data.status == 200) {
						_this5.$message.success(_this5.$t('lin_global.delete_success'));
						_this5.getData(1);
					} else {
						_this5.$message.error(res.data.message);
					}
				});
			}).catch(function () {});
		},
		deleteRow: function deleteRow(id) {
			var _this6 = this;

			var params = {
				id: id
			};
			this.$confirm(this.$t('lin_global.confirmDelete'), this.$t('lin_btn.tips'), {
				confirmButtonText: this.$t('lin_btn.confirm'),
				cancelButtonText: this.$t('lin_btn.cancel'),
				type: 'warning'
			}).then(function () {
				__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/cer/deleteCertificate.do', params).then(function (res) {
					if (res.data.status == 200) {
						_this6.$message.success(_this6.$t('lin_global.delete_success'));
						_this6.getData(1);
					} else {
						_this6.$message.error(res.data.message);
					}
				});
			}).catch(function () {});
		},
		submit: function submit() {
			var _this7 = this;

			this.params = {};
			if (this.form.controlType == '0') {
				this.params.radius = this.radius;
				this.params.controllerName = this.form.controllerName;
				this.params.controllerDesc = this.form.controllerDesc;
				this.params.messageId = this.form.messageId;
				this.params.controlType = this.form.controlType;
			} else {
				this.params.city = this.citys;
				this.params.controllerName = this.form.controllerName;
				this.params.controllerDesc = this.form.controllerDesc;
				this.params.messageId = this.form.messageId;
				this.params.controlType = this.form.controlType;
			}

			var params = this.params;
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/risk/addRisk.do', params).then(function (res) {
				if (res.data.status == 200) {
					_this7.dialogFormVisible = false;
					_this7.$message.success(res.data.message);
					_this7.getData(1);
				} else {
					_this7.dialogFormVisible = false;
					_this7.$message.error(res.data.message);
				}
			});
		},
		onCancel: function onCancel() {
			this.dialogFormVisible = false;
		},
		onCancel2: function onCancel2() {
			this.dialogFormVisible2 = false;
		},
		change: function change() {
			if (this.form.controlType == '0') {
				this.ifshow = true;
			} else {
				this.ifshow = false;
			}
		},
		getAd: function getAd() {
			var _this8 = this;

			var params = {
				page: 1,
				rows: 10000,
				mechId: this.qudaoshangid
			};
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/mechanism/list.do', params).then(function (res) {
				_this8.areaList = res.data.data;
			});
		},
		uploadCer: function uploadCer() {
			this.$setWObj('safeCerType', 1);
			this.$router.push({
				path: '/certificate/upload'
			});
		},

		add: function add() {
			this.$router.push({
				path: '/certificate/new'
			});
		},
		upload: function upload() {
			this.$router.push({
				path: '/certificate/upload'
			});
		},
		linkDetail: function linkDetail(row) {
			this.$router.push({
				path: '/rail/' + row.id + '/detail'
			});
		},
		handleSizeChange: function handleSizeChange(val) {
			this.pageSize = val;
			this.getData(this.currentPage);
		},
		handleCurrentChange: function handleCurrentChange(val) {
			this.currentPage = val;
			this.getData(this.currentPage);
		},
		getData: function getData(page) {
			var _this9 = this;

			this.currentPage = page;
			var params2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
				page: page,
				rows: this.pageSize
			}, this.select_form);
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/terminal_auth/getActivationList.do', params2).then(function (res) {
				console.log(res.data);
				if (res.data.status == 200) {
					_this9.tableData2 = res.data.data;
					_this9.totalRecords = res.data.total;
					_this9.loading = false;
				} else {
					_this9.loading = false;
				}
			});
		}
	}
});

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_global_tyc__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_global_tyc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_global_tyc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_df_png__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_df_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_df_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_timers__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_timers__);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;
    return {
      orderName: '',
      orderType: '',
      stModel: [],
      status: '',
      tqobj: '',
      rfDuration: 10,
      detailId: '',
      mechanismData: {
        callback: function callback(value) {
          _this.mech = value;

          _this.getList();
        }
      },
      dtGroup: [],
      mechanismData1: {
        callback: function callback(value) {
          _this.mech1 = value;

          _this.getDevices();
        }
      },
      mech: '',
      mech1: '',
      srchValue: '',
      multipleSelection: [],
      detail: '',
      dialogVisible: false,
      mapType: {
        '0': this.$t('app_bdmap'),
        '1': 'Google' + this.$t('app_map')
      },
      ctrlType: {
        '0': this.$t('app_close'),
        '1': this.$t('app_open1')
      },
      bindSt: {
        '0': this.$t('app_waitupdate'),
        '1': this.$t('app_updateSuccess'),
        '2': this.$t('app_updateFail'),
        '3': this.$t('app_downFinish'),
        '4': this.$t('app_md5Fail')
      },
      bindSts: [{ vl: '', lb: this.$t('app_allstatus') }, { vl: '0', lb: this.$t('app_waitupdate') }, { vl: '1', lb: this.$t('app_updateSuccess') }, { vl: '2', lb: this.$t('app_updateFail') }, { vl: '3', lb: this.$t('app_downFinish') }, { vl: '4', lb: this.$t('app_md5Fail') }],
      bindVl: '',
      config: '',
      captures: [],
      loading: 0,
      tableData: [],
      tags: [],
      page: 1,
      index: 1,
      hiss: [],
      pageTotal: 0
    };
  },

  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default.a, tyc: __WEBPACK_IMPORTED_MODULE_1__components_global_tyc___default.a
  },
  computed: {
    showUploadNew: function showUploadNew() {
      if (this.config) {
        if (this.config.isoperate === 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  methods: {
    repush: function repush(row) {
      var _this2 = this;

      this.loading = 1;
      this.$repushDSFailDv(row.terminalNo, this.config.id, function (res) {
        _this2.loading = 0;
        if (res.status == 200) {
          _this2.getList();
        } else {
          _this2.$message.error(res.message);
        }
      }, function () {
        _this2.loading = 0;
        _this2.$message.error(_this2.$t('app_rqsError'));
      });
    },
    sortChange: function sortChange(vl) {
      switch (vl.prop) {
        case 'terminalName':
          this.orderName = '1';
          break;
        case 'terminalNo':
          this.orderName = '2';
          break;
        case 'opeTime':
          this.orderName = '3';
          break;
      }
      this.orderType = vl.order == 'descending' ? 'desc' : 'asc';
      this.getList();
    },
    closeDia: function closeDia() {

      this.status = '';
      this.srchValue = '';
      this.mech1 = '';
      var _this = this;
      this.mechanismData1 = {
        callback: function callback(value) {
          _this.mech1 = value;
          _this.getDevices();
        }
      };
      this.getDevices();
    },
    cycleRq: function cycleRq() {
      if (this.$route.path == '/dvconfig/detail') {
        this.getList();
        var _this = this;
        setTimeout(function () {
          _this.cycleRq();
        }, this.rfDuration * 1000);
      }
    },
    stcolor: function stcolor(st) {
      var colortst = 'color: ';
      var cv = '';
      switch (st) {
        case '1':
          cv = 'green';
          break;
        case '2':
          cv = 'red';
          break;
        default:
          cv = 'gray';
          break;
      }

      return colortst + cv;
    },
    pageChange: function pageChange(vl) {
      this.page = vl;
      this.getList();
    },
    bcbind: function bcbind() {
      var arr = [];
      this.multipleSelection.forEach(function (item) {
        arr.push(item.terminalId);
      });

      this.bindRqs(arr.toString());
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    editCf: function editCf() {
      this.$setWObj('dvconfigEdit', this.detailId);
      this.$router.push({ path: '/dvconfig/detail/edit' });
    },
    showBindSt: function showBindSt(row) {
      return this.bindSt[row.useStatus];
    },
    bindOp: function bindOp(row) {

      this.bindRqs(row.terminalId);
    },
    bindRqs: function bindRqs(id) {
      var _this3 = this;

      this.loading = 1;
      this.$tcBindDevice(id, this.config.id, function (res) {
        _this3.loading = 0;
        if (res.status === 200) {
          _this3.dialogVisible = false;

          _this3.getList();
          _this3.closeDia();
        } else {
          _this3.$message.error(res.message);
        }
      }, function () {
        _this3.loading = 0;
        _this3.$message.error(_this3.$t('app_rqsError'));
      });
    },
    query: function query() {
      this.getList();
    },
    srchDevice: function srchDevice() {
      this.getDevices();
    },
    getDevices: function getDevices() {
      var _this4 = this;

      var vl = this.srchValue ? this.srchValue : '';
      var channel = this.mech1 ? this.mech1 : '';
      var status = this.status ? this.status : '';
      this.loading = 1;
      this.$getDvDevices(this.index, this.$gRow, channel, vl, status, '', '', '', '', '', function (res) {
        console.log('dv', res);
        _this4.loading = 0;
        if (res.data) {
          _this4.tableData = res.data;
          _this4.total = res.total;
        }
      }, function () {
        _this4.loading = 0;
      });
    },
    addTer: function addTer() {
      this.dialogVisible = true;
    },
    deleteApp: function deleteApp(obj) {
      var _this5 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        console.log(obj);
        _this5.$delFstRecord(obj.id, function (res) {
          if (res.status === 200) {
            _this5.getList();
            _this5.$message.success(res.message);
          } else {
            _this5.$message.error(res.message);
          }
        }, '');
      }, '');
    },
    unbind: function unbind(row) {
      var _this6 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {

        _this6.$tcDelDevice(row.id, function (res) {
          if (res.status === 200) {
            _this6.getList();
            _this6.$message.success(res.message);
          } else {
            _this6.$message.error(res.message);
          }
        }, '');
      }, '');
    },
    editApp: function editApp(row) {
      this.$setWObj('filestEdit', { type: 1, data: row });
      this.$router.push({ path: '/stfile/detail/edit' });
    },
    pushApp: function pushApp(row) {
      this.$setWObj('pushList', { type: '13', data: row });
      this.$router.push({ path: '/stfile/detail/push' });
    },
    getList: function getList() {
      var _this7 = this;

      var mech = this.mech;
      var name = this.queryKey ? this.queryKey : '';
      var status = this.bindVl;

      this.$tcDeviceBindList(this.page, this.$gRow, mech, name, status, this.config.id, this.orderName, this.orderType, function (res) {

        _this7.loading = 0;
        if (res.status === 200) {
          _this7.pageTotal = res.total;
          _this7.hiss = res.data;
        } else {
          _this7.$message(res.message);
        }
      }, function () {
        _this7.loading = 0;
        _this7.$message.error(_this7.$t('app_rqsError'));
      });
    },
    getStatus: function getStatus(value) {
      if (!value) return '';
      switch (value) {
        case '0':
          return { vl: this.$t('app_prePushVerify'), style: 'color:#8492A6;' };
        case '1':
          return { vl: this.$t('app_preVerify'), style: 'color:#F7BA2A;' };
        case '2':
          return { vl: this.$t('app_verifyPass'), style: 'color:#13CE66;' };
        case '3':
          return { vl: this.$t('app_verifyNotPass'), style: 'color:#FF4949;' };
      }
    },
    getDetail: function getDetail() {
      var _this8 = this;

      this.loading = 1;

      this.$tcDetail(this.detailId, function (res) {
        _this8.loading = 0;
        if (res.status === 200) {
          _this8.config = res.data;
          _this8.config.param = JSON.parse(_this8.config.param1);
          _this8.init();
        } else {
          _this8.$message.error(res.message);
        }
      }, function () {
        _this8.loading = 0;
        _this8.$message.error(_this8.$t('app_rqsError'));
      });
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('YYYY-MM-DD hh:mm:ss');
    },
    selectChange: function selectChange(vl) {
      this.getList();
    },
    pageSelect: function pageSelect(index) {
      this.index = index;
      this.getDevices();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getDevices();
    },
    delHis: function delHis(row) {
      var _this9 = this;

      this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
        confirmButtonText: this.$t('app_sure'),
        cancelButtonText: this.$t('app_cancel'),
        type: 'warning'
      }).then(function () {
        _this9.loading = 1;
        _this9.$delLauncherHistory(row.versionid, function (res) {
          _this9.loading = 0;
          if (res.status === 200) {
            _this9.getHistory();
            _this9.$message.success(res.message);
          } else {
            _this9.$message.error(res.message);
          }
        }, function () {
          _this9.loading = 0;
        });
      }).catch(function () {});
    },
    imgFullUrl: function imgFullUrl(path) {
      if (path) {
        return this.$urls.prefix + path;
      } else {
        return '';
      }
    },
    uploadNew: function uploadNew() {
      var obj = { type: 2, data: this.config };
      var key = 'launcherEdit';
      this.$setWObj(key, obj);
      this.$router.push({ path: '/launch-newver' });
    },
    init: function init() {
      var pms = [];
      var data = this.config.param;
      var callType = data.callType;
      var pwd = data.pwd;
      var mapType = data.mapType;
      var isHttps = data.isHttps;
      var ops_authIp = data.ops_authIp;
      var ops_authPort = data.ops_authPort;
      var tms_callbackIp = data.tms_callbackIp;
      var tms_callbackPort = data.tms_callbackPort;
      if (callType) {
        pms.push({ tt: this.$t('app_callfunc'), vl: this.ctrlType[callType] });
      }
      if (pwd) {
        pms.push({ tt: this.$t('app_stmgpsw'), vl: pwd });
      }
      if (mapType) {
        pms.push({ tt: this.$t('app_mapsl'), vl: this.mapType[mapType] });
      }
      if (isHttps) {
        pms.push({ tt: 'API' + this.$t('app_protocal'), vl: isHttps == 0 ? 'HTTP' : 'HTTPS' });
      }
      if (ops_authIp && ops_authPort) {
        pms.push({ tt: this.$t('app_rgsvpm'), vl: ops_authIp + ':' + ops_authPort });
      }
      if (tms_callbackIp && tms_callbackPort) {
        pms.push({ tt: this.$t('app_bgntpm'), vl: tms_callbackIp + ':' + tms_callbackPort });
      }
      var result = [];
      for (var i = 0; i < pms.length; i += 3) {
        result.push(pms.slice(i, i + 3));
      }
      this.dtGroup = result;


      this.getDevices();
      this.cycleRq();
    }
  },
  mounted: function mounted() {
    var _this10 = this;

    this.tqobj = {
      keys: ['terminalTypes'],
      callback: function callback(data) {
        _this10.stModel = data[0];
      }
    };
    this.detailId = this.$getWObj().dvconfigDetail;
    this.getDetail();
  }
});

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    var phoneCheck = function phoneCheck(rule, value, callback) {
      if (!_this.isLegalMobile(value)) {
        callback(new Error(_this.$t('app_phoneIllegal')));
      } else {
        callback();
      }
    };
    return {
      detailId: '',
      loading: false,
      fatherList: [],
      form: {
        name: '',
        desc: '',
        ispsw: false,
        psw: '',
        iscall: false,
        callvl: '',
        ismap: false,
        map: '',

        ishttp: false,
        http: '',
        isauth: false,
        aip: '',
        aport: '',
        isnotify: false,
        nip: '',
        nport: '',
        isstore: false,
        sip: '',
        sport: ''
      },
      rules: {
        name: [{ required: true, message: this.$t('app_input'), trigger: 'blur' }],
        desc: [{ required: true, message: this.$t('app_input'), trigger: 'blur' }],
        psw: [{ required: true, message: this.$t('app_input'), trigger: 'blur' }],
        cfpsw: [{ required: true, message: this.$t('app_input'), trigger: 'blur' }]
      }
    };
  },

  methods: {
    getDetail: function getDetail() {
      var _this2 = this;

      this.loading = 1;
      this.$tcDetail(this.detailId, function (res) {
        _this2.loading = 0;
        if (res.status === 200) {
          _this2.config = res.data;
          _this2.config.param = JSON.parse(_this2.config.param1);
          _this2.fillData();
        } else {
          _this2.$message.error(res.message);
        }
      }, function () {
        _this2.loading = 0;
        _this2.$message.error(_this2.$t('app_rqsError'));
      });
    },
    isLegalMobile: function isLegalMobile(tel) {
      var sMobile = tel;
      var regex = "^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\\d{8}$";
      var re = new RegExp(regex, 'g');
      if (!re.test(sMobile)) {
        return false;
      } else {
        return true;
      }
    },
    newform: function newform() {
      var _this3 = this;

      console.log(this.form);
      return;
      this.loading = 1;
      this.$addTc(this.form.psw, this.form.name, this.form.desc, this.form.map, this.form.wifi, function (res) {
        _this3.loading = 0;
        if (res.status === 200) {
          _this3.$router.go(-1);
        } else {
          _this3.$message.error(res.message);
        }
      }, function () {
        _this3.loading = 0;
      });
    },
    editform: function editform() {
      var _this4 = this;

      this.loading = 1;
      var data = this.config;
      var configName = '';
      var configDesc = '';
      var param = {};
      var fm = this.form;

      if (fm.iscall && fm.callvl) {
        param.callType = fm.callvl;
      }
      if (fm.ispsw && fm.psw) {
        param.pwd = fm.psw;
      }
      if (fm.ismap && fm.map) {
        param.mapType = fm.map;
      }
      if (fm.ishttp && fm.http) {
        param.isHttps = fm.http;
      }
      if (fm.isauth && fm.aip && fm.aport) {
        param.ops_authIp = fm.aip;
        param.ops_authPort = fm.aport;
      }
      if (fm.isnotify && fm.nip && fm.nport) {
        param.tms_callbackIp = fm.nip;
        param.tms_callbackPort = fm.nport;
      }
      if (fm.isstore && fm.sip && fm.sport) {
        param.appStoreIp = fm.sip;
        param.appStorePort = fm.sport;
      }

      if (!this.detailId) {
        this.$addTc(fm.name, fm.desc, param, function (res) {
          _this4.loading = 0;
          if (res.status === 200) {
            _this4.setDetailLc(fm, param);
            _this4.$setWObj('sdjumpId', res.data.id);
            _this4.$router.go(-1);
          } else {
            _this4.$message.error(res.message);
          }
        }, function () {
          _this4.loading = 0;
        });
      } else {
        this.$editTc(data.id, fm.name, fm.desc, param, function (res) {
          _this4.loading = 0;
          if (res.status === 200) {
            _this4.setDetailLc(fm, param);
            _this4.$router.go(-1);
          } else {
            _this4.$message.error(res.message);
          }
        }, function () {
          _this4.loading = 0;
        });
      }
    },
    setDetailLc: function setDetailLc(fm, param) {},
    save: function save(name) {
      var _this5 = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          if (_this5.form.iscall && !_this5.form.callvl) {
            _this5.$message(_this5.$t('app_inputCp'));
            return;
          }
          if (!_this5.form.psw && _this5.form.ispsw) {
            _this5.$message(_this5.$t('app_inputCp'));
            return;
          }
          if (!_this5.form.map && _this5.form.ismap) {
            _this5.$message(_this5.$t('app_inputCp'));
            return;
          }
          if (!_this5.form.http && _this5.form.ishttp) {
            _this5.$message(_this5.$t('app_inputCp'));
            return;
          }
          if ((!_this5.form.aip || !_this5.form.aport) && _this5.form.isauth) {
            _this5.$message(_this5.$t('app_inputCp'));
            return;
          }
          if ((!_this5.form.nip || !_this5.form.nport) && _this5.form.isnotify) {
            _this5.$message(_this5.$t('app_inputCp'));
            return;
          }
          if ((!_this5.form.sip || !_this5.form.sport) && _this5.form.isstore) {
            _this5.$message(_this5.$t('app_inputCp'));
            return;
          }
          _this5.editform();
        } else {
          return false;
        }
      });
    },
    cancel: function cancel() {
      this.$router.go(-1);
    },
    fillData: function fillData() {
      var data = this.config;
      var cfjs = JSON.parse(data.param1);
      this.form.name = data.configName;
      this.form.desc = data.configDesc;

      this.form.ispsw = cfjs.pwd ? true : false;
      this.form.psw = cfjs.pwd;

      this.form.ismap = cfjs.mapType ? true : false;
      this.form.map = cfjs.mapType;
      this.form.iscall = cfjs.callType ? true : false;
      this.form.callvl = cfjs.callType;
      this.form.ishttp = cfjs.isHttps ? true : false;
      this.form.http = cfjs.isHttps;
      this.form.isauth = cfjs.ops_authIp && cfjs.ops_authPort ? true : false;
      this.form.aip = cfjs.ops_authIp;
      this.form.aport = cfjs.ops_authPort;
      this.form.isnotify = cfjs.tms_callbackIp && cfjs.tms_callbackPort ? true : false;
      this.form.nip = cfjs.tms_callbackIp;
      this.form.nport = cfjs.tms_callbackPort;

      this.form.isstore = cfjs.appStoreIp && cfjs.appStorePort ? true : false;
      this.form.sip = cfjs.appStoreIp;
      this.form.sport = cfjs.appStorePort;
    }
  },
  mounted: function mounted() {

    this.detailId = this.$getWObj().dvconfigEdit;
    if (this.detailId) {
      this.getDetail();
    }
  }
});

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default.a
  },
  data: function data() {
    var that = this;
    return {
      orderName: '',
      orderType: '',
      mechanismData: {
        callback: function callback(value) {
          that.mech = value;
          that.selectChange(value);
        }
      },
      listKey: 'launch-list',

      dvLoading: 0,
      appId: '',
      stModel: [{ label: this.$t('app_online'), vl: '1' }, { label: this.$t('app_offline'), vl: '2' }, { label: this.$t('app_new'), vl: '0' }],
      channels: [],
      srchValue: '',
      channelId: '',
      cerTipMsg: '',
      status: '',
      dvIndex: 1,
      dialogVisible: 0,
      mechanismId: window.localStorage['mechanismId'],
      selectMid: '',
      tableData: [],
      dvTableData: [],
      appTypes: [],
      appTypeValue: '',
      appStatus: [{ label: this.$t('app_prePushVerify'), value: '0' }, { label: this.$t('app_preVerify'), value: '1' }, { label: this.$t('app_verifyPass'), value: '2' }, { label: this.$t('app_verifyNotPass'), value: '3' }],
      appStatusValue: '',
      total: 0,
      index: 1,
      dvTotal: 0,
      loading: 0,
      appType: '',
      queryKey: ''
    };
  },

  computed: {
    getDvStatus: function getDvStatus(value) {
      switch (value) {
        case '0':
          return this.$t('app_prePushVerify');
        case '1':
          return this.$t('app_preVerify');
        case '2':
          return this.$t('app_verifyPass');
        case '3':
          return this.$t('app_verifyNotPass');
      }
    }
  },
  methods: {
    sortChange: function sortChange(vl) {
      switch (vl.prop) {
        case 'createTime':
          this.orderName = '2';
          break;
      }
      this.orderType = vl.order == 'descending' ? 'desc' : 'asc';
      this.getList();
    },
    pushCreateCer: function pushCreateCer() {
      this.$router.push({ path: "/certificate/new" });
    },
    pushUploadCer: function pushUploadCer() {
      this.$router.push({ path: "/certificate/upload" });
    },
    bindOperate: function bindOperate(row) {
      var _this = this;

      this.dvLoading = 1;
      if (this.$appUrlTag === 0) {
        this.$bindApp('0', row.terminalNo, this.appId, function (res) {
          if (res.status === 200) {
            _this.$message.success(_this.$t('app_tipViewTask'));
          } else {
            _this.$message.error(res.message);
          }
          _this.dvLoading = 0;
        }, function () {
          _this.dvLoading = 0;
        });
      } else {
        this.$bindApp1(localStorage.mechanismId, row.terminalNo, this.appId, function (res) {
          if (res.status === 200) {
            _this.$message.success(_this.$t('app_tipViewTask'));
          } else {
            _this.$message.error(res.message);
          }
          _this.dvLoading = 0;
        }, function () {
          _this.dvLoading = 0;
        });
      }
    },
    getChannels: function getChannels() {
      var _this2 = this;

      this.$getChannelList(10000, 1, '', '', '', function (res) {
        if (res.status === 200) {
          _this2.channels = res.data;
        } else {
          _this2.$message.error(res.message);
        }
      }, function () {
        _this2.$message.error(_this2.$t('app_rqsError'));
      });
    },
    getStatus: function getStatus(value) {
      if (!value) return '';
      switch (value) {
        case '0':
          return { vl: this.$t('app_prePushVerify'), style: 'color:#8492A6;' };
        case '1':
          return { vl: this.$t('app_preVerify'), style: 'color:#F7BA2A;' };
        case '2':
          return { vl: this.$t('app_verifyPass'), style: 'color:#13CE66;' };
        case '3':
          return { vl: this.$t('app_verifyNotPass'), style: 'color:#FF4949;' };
      }
    },
    srchDevice: function srchDevice() {
      this.getDevices();
    },
    selectDvChange: function selectDvChange(vl) {
      this.getDevices();
    },
    pageDvSized: function pageDvSized(val) {
      this.$gRow = val;
      this.getDevices();
    },
    getDevices: function getDevices() {
      var _this3 = this;

      var vl = this.srchValue ? this.srchValue : '';
      var channel = this.channelId ? this.channelId : '';
      var status = this.status ? this.status : '';
      var appId = this.appId ? this.appId : '';
      this.dvLoading = 1;
      if (this.$appUrlTag === 0) {
        this.$getDevices(this.dvIndex, this.$gRow, channel, vl, status, '', appId, function (res) {
          _this3.dvLoading = 0;
          if (res.data) {
            _this3.dvTableData = res.data;
            _this3.dvTotal = res.total;
          }
        }, function () {
          _this3.dvLoading = 0;
        });
      } else {

        this.$getDevices1(this.dvIndex, this.$gRow, localStorage.mechanismId, vl, status, '', appId, function (res) {
          console.log('dv', res);
          _this3.dvLoading = 0;
          if (res.data) {
            _this3.dvTableData = res.data;
            _this3.dvTotal = res.total;
          }
        }, function () {
          _this3.dvLoading = 0;
        });
      }
    },
    editApp: function editApp(row) {
      this.$setWObj('dvconfigEdit', row.id);
      this.$router.push({ path: '/dvconfig/edit' });
    },
    pushApp: function pushApp(row) {

      this.$setWObj('pushList', { type: '13', data: row });
      this.$router.push({ path: '/stfile/push' });
    },
    query: function query() {
      this.getList();
    },
    selectChange: function selectChange(vl) {
      this.selectMid = vl;
      this.getList();
    },
    reset: function reset() {
      this.queryKey = '';
      this.appType = '';
      this.getList();
    },
    pageSelect: function pageSelect(index) {
      this.index = index;
      this.getList();
    },
    pageDvSelect: function pageDvSelect(index) {
      this.dvIndex = index;
      this.getDevices();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getList();
    },
    deleteApp: function deleteApp(obj) {
      var _this4 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this4.$delTc(obj.id, function (res) {
          if (res.status === 200) {
            _this4.getList();
            _this4.$message.success(res.message);
          } else {
            _this4.$message.error(res.message);
          }
        }, '');
      }, '');
    },
    submitApp: function submitApp(obj) {
      var _this5 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_tipVerify'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this5.loading = 1;
        _this5.$verifyFst(obj.recordId, '', '1', function (res) {
          _this5.loading = 0;
          if (res.status === 200) {
            _this5.getList();
            _this5.$message.success(res.message);
          } else {
            _this5.$message.error(res.message);
          }
        }, function () {
          _this5.loading = 0;
        });
      }, '');
    },
    cellClick: function cellClick(row, ev, col) {
      if (col.label && col.label === this.$t('app_operate')) {
        return;
      }

      this.$setWObj('dvconfigDetail', row.id);
      this.$router.push({ path: '/dvconfig/detail' });
    },
    jumpToUpload: function jumpToUpload() {

      this.$setWObj('dvconfigEdit', '');
      this.$router.push({ path: '/dvconfig/add' });
    },
    getList: function getList() {
      var _this6 = this;

      this.loading = 1;

      var name = this.queryKey ? this.queryKey : '';

      this.$getTcList(this.index, this.$gRow, name, this.orderName, this.orderType, function (res) {

        _this6.loading = 0;
        if (res.status === 200) {
          _this6.total = res.total;
          _this6.tableData = res.data;
        } else {
          _this6.$message(res.message);
        }
      }, function () {
        _this6.loading = 0;
        _this6.$message.error(_this6.$t('app_rqsError'));
      });
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD HH:mm:ss');
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    }
  },
  mounted: function mounted() {
    var jid = this.$getWObj().sdjumpId;
    if (jid) {
      this.$setWObj('dvconfigDetail', jid);
      this.$router.push({ path: '/dvconfig/detail' });
      this.$setWObj('sdjumpId', '');
    }

    this.getList();
  },
  destroyed: function destroyed() {}
});

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_tyc__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_tyc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_tyc__);






/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		MechanismSelector: __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default.a,
		tyc: __WEBPACK_IMPORTED_MODULE_3__components_global_tyc___default.a
	},
	data: function data() {
		var _this2 = this;

		var that = this;
		var tagCheck = function tagCheck(rule, value, callback) {
			if (!value) {
				callback(new Error(_this2.$t('noVerTag')));
			} else {
				callback();
			}
		};
		var versionCheck = function versionCheck(rule, value, callback) {

			if (_this2.udFileType == 0 && rule.field == 'preVersion') {
				callback();
				return;
			}

			var rg = /^\d+(\.\d+)+$/;
			if (!rg.test(value)) {
				callback(new Error(_this2.$t('lin_global.bbhgsbd')));
			} else {
				callback();
			}
		};
		return {
			fileUploadUrl: "",
			tqobj: '',
			mechanismData: '',
			action: '' + __WEBPACK_IMPORTED_MODULE_2__api_url__["b" /* urlAssets */].fileUrl,
			ulinfo: {
				tip: this.$t('app_ulNormalSt'),
				index: 0,
				icons: ['el-icon-upload', 'el-icon-circle-check', 'el-icon-close']
			},
			mechanismId: window.localStorage['mechanismId'],
			status: '',
			tipColor: {
				color: '#13CE66'
			},
			stModel: [{
				label: this.$t('app_online'),
				vl: '1'
			}, {
				label: this.$t('app_offline'),
				vl: '2'
			}, {
				label: this.$t('app_new'),
				vl: '0'
			}],
			channels: [],
			cmtypes: [],
			isbase: false,
			sftypes1: [],
			sftypes2: [],
			sftypes3: [],
			sftypes5: [],
			sftypes6: [],
			sftypes7: [],
			sftypes9: [],
			sftypes10: [],
			sftypes11: [],
			updateType: false,
			ftypes: '',
			ftypes_1: '',
			ftypes_2: '',
			ftail: {
				'1': ['zip'],
				'2': ['kos', 'hex', 'ksp', 'key', 'res', 'zip', 'rar'],
				'3': ['zip', 'img', 'png'],
				'5': ['cfg'],
				'6': ['ini', 'bin', 'rle', 'img', 'bz2', 'ksp', 'gz'],
				'7': [],
				'8': ['bz2'],
				'9': ['zimge', 'gz', 'fls', 'lod', 'bin'],
				'10': [],
				'11': ['ini', 'bin', 'rle', 'img', 'bz2', 'ksp', 'gz']
			},
			channelId: '',
			rules: {
				name: [{
					required: true,
					message: this.$t('app_input'),
					trigger: 'blur'
				}],
				desc: [{
					required: true,
					message: this.$t('app_input'),
					trigger: 'blur'
				}],
				ftype: [{
					required: true,
					message: this.$t('app_select'),
					trigger: 'blur'
				}],
				stype: [{
					required: true,
					message: this.$t('app_input'),
					trigger: 'blur'
				}],
				mech: [{
					required: true,
					message: this.$t('app_select'),
					trigger: 'blur'
				}],
				url: [{
					required: true,
					message: this.$t('app_select'),
					trigger: 'blur'
				}],
				ver: [{
					required: true,
					message: this.$t('app_input'),
					trigger: 'blur'
				}],
				bver: [{
					required: true,
					message: this.$t('lin_global.verTips1'),
					trigger: 'blur',
					validator: versionCheck
				}]
			},
			form: {
				name: '',
				fname: '',
				dtype: 1,
				desc: '',
				ftype: '',
				stype: '',
				ver: '',
				url: '',
				md5: '',
				size: '',
				mech: '',
				bver: ''
			},
			showPic: {
				value: 0,
				data: ''
			},
			srchValue: '',
			installTypes: [{
				label: this.$t('app_autoInstall'),
				value: 0
			}],
			fileSize: 0,
			tableData: [],
			checkDesc: '',
			radio: '1',
			smImageUrl: '',
			bgImageUrl: '',
			dialogVisible: false,
			appTypes: [],
			loading: 0,
			loading1: 0,
			loadingBig: 0,
			loadingSm: 0,
			config: {},

			fileList: [],
			isUpload: 0,
			index: 1,
			total: 0
		};
	},

	computed: {
		isShowUpdateDesc: function isShowUpdateDesc() {
			if (this.config.data) {
				if (this.config.data.updatedesc) {
					return true;
				} else {
					return false;
				}
			} else {
				return false;
			}
		},
		updateDescContent: function updateDescContent() {
			var vl = this.config.data ? this.config.data.updatedesc : '';

			return vl;
		},
		prdes: function prdes() {
			return this.config.data ? this.config.data.launcherDesc : '';
		},
		uData: function uData() {
			var result = {};
			if (this.form.ftype == 11) {
				result = {
					token: 1234,
					name: this.form.stype
				};
			} else {
				result = {
					token: 1234
				};
			}
			return result;
		},
		imgUploadUrl: function imgUploadUrl() {
			return this.$urls.picUrl;
		},
		reason: function reason() {
			if (!this.config.data) {
				return '';
			}
			var rs = this.config.data.auditContent;
			return rs ? this.$t('app_banReason') + ':' + rs : this.$t('app_banReason') + ':' + this.$t('app_noInput');
		},
		isShowReason: function isShowReason() {
			if (this.config) {
				if (this.config.data) {
					if (this.config.data.appStatus === '3') {
						return 1;
					} else {
						return 0;
					}
				} else {
					return 0;
				}
			} else {
				return 0;
			}
		}
	},
	methods: {
		change_device: function change_device(data) {
			var _this3 = this;

			if (data == 1) {
				this.ftypes = this.ftypes_1;
			} else {
				this.ftypes = this.ftypes_2;
			}
			this.$nextTick(function () {
				_this3.form.ftype = null;
				_this3.form.stype = null;
			});
		},
		jumpToTool: function jumpToTool() {
			window.open('https://tmsadmin.szzt.com.cn/szzt_utils/#/animationgen');
		},
		sfileTypeChange: function sfileTypeChange(vl) {
			if (vl == '1-1') {
				this.isbase = true;
			} else this.isbase = false;
		},
		fileTypeChange: function fileTypeChange(vl) {
			this.form.stype = '';
			if (!vl) {

				this.cmtypes = '';
			} else {
				this.cmtypes = this['sftypes' + vl];
				console.log(this.action);
				if (vl == 6) {
					this.fileUploadUrl = this.action;
				} else if (vl == 11) {
					this.fileUploadUrl = this.action;
				} else {
					this.fileUploadUrl = "https://tmsadmin.szzt.com.cn/file-management/tms-server-web/file/fileupload.do";
				}
			}
		},
		lcNew: function lcNew() {
			var _this4 = this;

			this.$refs['form'].validate(function (valid) {
				if (valid) {
					_this4.loading = 1;
					var form = _this4.form;
					_this4.$updateLauncher(_this4.form.md5, form.launcherName, form.launcherDesc, form.caps, form.appUrl, form.packageName, form.version, form.verTag, _this4.fileSize, _this4.config.data.launcherid, localStorage.mechanismId, function (res) {
						_this4.loading = 0;
						if (res.status === 200) {
							_this4.$message.success(res.message);
							_this4.$router.go(-2);
						} else {
							_this4.$message.error(res.message);
						}
					}, function () {
						_this4.loading = 0;
						_this4.$message(_this4.$t('app_rqsError'));
					});
				} else {
					return false;
				}
			});
		},
		selectChange: function selectChange(vl) {},
		getChannels: function getChannels() {
			var _this5 = this;

			this.$getChannelList(10000, 1, '', '', '', function (res) {
				if (res.status === 200) {
					_this5.channels = res.data;
				} else {
					_this5.$message.error(res.message);
				}
			}, function () {
				_this5.$message.error(_this5.$t('app_rqsError'));
			});
		},
		getStatus: function getStatus(value) {
			switch (value) {
				case '0':
					return this.$t('app_prePushVerify');
				case '1':
					return this.$t('app_preVerify');
				case '2':
					return this.$t('app_verifyPass');
				case '3':
					return this.$t('app_verifyNotPass');
			}
		},
		pageSelect: function pageSelect(index) {
			this.index = index;
			this.getDevices();
		},
		pageSized: function pageSized(val) {
			this.$gRow = val;
			this.getDevices();
		},
		hBlur: function hBlur(name) {
			this.$refs[name].validate(function (valid) {
				if (valid) {} else {
					return false;
				}
			});
		},
		showBigPic: function showBigPic() {
			this.showPic = {
				value: 1,
				data: this.imgFullUrl(this.config.data.appBigIcon)
			};
		},
		showScreenShot: function showScreenShot(path) {
			this.showPic = {
				value: 1,
				data: this.imgFullUrl(path)
			};
		},
		pushInstall: function pushInstall() {
			this.dialogVisible = true;
		},
		makeAppPath: function makeAppPath(url) {
			var path = url;
			if (!path) {
				if (this.config.data) {
					path = this.config.data.appUrl;
					if (!path) {
						return '';
					}
				} else {
					return '';
				}
			}
			var arr = path.split('/');
			return arr[arr.length - 1];
		},
		deleteAppHis: function deleteAppHis(row) {
			var _this6 = this;

			if (row.applicationid) {
				this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
					confirmButtonText: this.$t('app_sure'),
					cancelButtonText: this.$t('app_cancel'),
					type: 'warning'
				}).then(function () {
					_this6.loading = 1;
					if (_this6.$appUrlTag === 0) {
						_this6.$deleteApp(row.applicationid, function (res) {
							_this6.loading = 0;
							if (res.status === 200) {
								_this6.getAppHistory();
							} else {
								_this6.$message.error(res.message);
							}
						}, function () {
							_this6.loading = 0;
						});
					} else {
						_this6.$deleteApp1(row.applicationid, function (res) {
							_this6.loading = 0;
							if (res.status === 200) {
								_this6.getAppHistory();
							} else {
								_this6.$message.error(res.message);
							}
						}, function () {
							_this6.loading = 0;
						});
					}
				}).catch(function () {});
			}
		},
		dateFormat: function dateFormat(row, column) {
			var date = row[column.property];
			if (date === undefined) {
				return '';
			}
			return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD hh:mm:ss');
		},
		deleteCapture0: function deleteCapture0() {
			this.cp0 = '';
			this.cp0Value = '';
		},
		deleteCapture1: function deleteCapture1() {
			this.cp1 = '';
			this.cp1Value = '';
		},
		deleteCapture2: function deleteCapture2() {
			this.cp2 = '';
			this.cp2Value = '';
		},
		deleteCapture3: function deleteCapture3() {
			this.cp3 = '';
			this.cp3Value = '';
		},
		deleteCapture4: function deleteCapture4() {
			this.cp4 = '';
			this.cp4Value = '';
		},
		imgFullUrl: function imgFullUrl(path) {
			if (path) {
				return this.$urls.prefix + path;
			} else {
				return '';
			}
		},
		close: function close() {
			this.$router.go(-1);
		},
		isShowCommon: function isShowCommon(isShow) {
			if (isShow && (this.config.type === 2 || this.config.type === 3)) {
				return 1;
			} else if (!isShow && this.config.type !== 2 && this.config.type !== 3) {
				return 1;
			} else {
				return 0;
			}
		},
		tipBf: function tipBf() {
			this.loading1 = 1;
			return 1;
		},
		handleSmAvatarSuccess: function handleSmAvatarSuccess(res, file) {
			this.loadingSm = 0;
			if (res.status !== 200) {
				this.$message.error(res.message);
			} else {
				this.form.smImageUrlValue = res.data;
				this.smImageUrl = URL.createObjectURL(file.raw);
				this.hBlur('form');
			}
		},
		handleBgAvatarSuccess: function handleBgAvatarSuccess(res, file) {
			this.loadingBig = 0;
			if (res.status !== 200) {
				this.$message.error(res.message);
			} else {
				this.form.bgImageUrlValue = res.data;
				this.bgImageUrl = URL.createObjectURL(file.raw);
				this.hBlur('form');
			}
		},
		handleAvatarSuccessCp0: function handleAvatarSuccessCp0(res, file) {
			this.loading1 = 0;

			if (res.status !== 200) {
				this.$message.error(res.message);
			} else {
				this.cp0Value = res.data;
				this.cp0 = URL.createObjectURL(file.raw);
				this.hBlur('form');
			}
		},
		handleAvatarSuccessCp1: function handleAvatarSuccessCp1(res, file) {
			this.loading1 = 0;
			if (res.status !== 200) {
				this.$message.error(res.message);
			} else {
				this.cp1Value = res.data;
				this.cp1 = URL.createObjectURL(file.raw);
				this.hBlur('form');
			}
		},
		handleAvatarSuccessCp2: function handleAvatarSuccessCp2(res, file) {
			this.loading1 = 0;
			if (res.status !== 200) {
				this.$message.error(res.message);
			} else {
				this.cp2Value = res.data;
				this.cp2 = URL.createObjectURL(file.raw);
				this.hBlur('form');
			}
		},
		handleAvatarSuccessCp3: function handleAvatarSuccessCp3(res, file) {
			this.loading1 = 0;
			if (res.status !== 200) {
				this.$message.error(res.message);
			} else {
				this.cp3Value = res.data;
				this.cp3 = URL.createObjectURL(file.raw);
				this.hBlur('form');
			}
		},
		handleAvatarSuccessCp4: function handleAvatarSuccessCp4(res, file) {
			this.loading1 = 0;
			if (res.status !== 200) {
				this.$message.error(res.message);
			} else {
				this.cp4Value = res.data;
				this.cp4 = URL.createObjectURL(file.raw);
				this.hBlur('form');
			}
		},
		beforeSmAvatarUpload: function beforeSmAvatarUpload(file) {
			var size = file.size / 1024;
			if (size > 100) {
				this.$message.error(this.$t('app_fileOver') + '100k');
				return false;
			}
			this.loadingSm = 1;
			return true;
		},
		beforeBgAvatarUpload: function beforeBgAvatarUpload(file) {
			var size = file.size / 1024;
			if (size > 200) {
				this.$message.error(this.$t('app_fileOver') + '200k');
				return false;
			}
			this.loadingBig = 1;
			return true;
		},
		handleRemove: function handleRemove(file, fileList) {},
		uploadApp: function uploadApp(formName) {
			var _this7 = this;

			if (window[this.$route.path]) {
				this.$message.error(this.$t('app_appLoding'));
				return;
			}

			this.$refs[formName].validate(function (valid) {
				if (valid) {

					if (_this7.form.ftype == 6 || _this7.form.ftype == 8) {
						if (_this7.form.ver) {
							var rg = /^[vV]\d+(\.\d+)+$/;
							if (!rg.test(_this7.form.ver)) {
								_this7.$message.error(_this7.$t('app_fmVerIillegal1'));
								return;
							}
						} else {
							_this7.$message.error(_this7.$t('app_inputCp'));
							return;
						}
					}

					if (_this7.form.ftype == 1 || _this7.form.ftype == 2) {
						if (_this7.form.ver) {
							var rg = /^\d+(\.\d+)+$/;
							if (!rg.test(_this7.form.ver)) {
								_this7.$message.error(_this7.$t('app_fmVerIillegal'));
								return;
							}
						} else {
							_this7.$message.error(_this7.$t('app_inputCp'));
							return;
						}
					}

					if (_this7.form.stype == '1-1') {
						if (_this7.form.bver) {
							var rg = /^\d+(\.\d+)+$/;
							if (!rg.test(_this7.form.bver)) {
								_this7.$message.error(_this7.$t('app_fmVerIillegal'));
								return;
							}
						} else {
							_this7.$message.error(_this7.$t('app_inputCp'));
							return;
						}
					}

					if (_this7.form.ftype != 5 && _this7.form.ftype != 7 && _this7.form.ftype != 4 && _this7.form.ftype != 8 && _this7.form.ftype != 10) {
						if (!_this7.form.stype && _this7.form.ftype) {
							_this7.$message.error(_this7.$t('app_plsstype'));
							return;
						}
					}

					_this7.loading = 1;
					if (_this7.config.type === 1) {
						_this7.$editFile(_this7.config.data.fileId, _this7.form.name, _this7.form.ver, _this7.form.md5, _this7.form.size, _this7.form.url, _this7.form.ftype, _this7.form.stype, _this7.form.bver, _this7.form.mech, _this7.form.desc, function (res) {
							_this7.loading = 0;
							if (res.status === 200) {
								_this7.$message.success(res.message);
								_this7.$router.go(-1);
							} else {
								_this7.$message(res.message);
							}
						}, function () {
							_this7.loading = 0;
							_this7.$message(_this7.$t('app_rqsError'));
						});
					} else {

						_this7.$addFile(_this7.form.name, _this7.form.ver, _this7.form.md5, _this7.form.size, _this7.form.url, _this7.form.ftype, _this7.form.stype, _this7.form.bver, _this7.form.mech, _this7.form.desc, function (res) {
							_this7.loading = 0;
							if (res.status === 200) {
								_this7.$message.success(res.message);
								_this7.$router.go(-1);
							} else {
								_this7.$message.error(res.message);
							}
						}, function () {
							_this7.loading = 0;
							_this7.$message(_this7.$t('app_rqsError'));
						});
					}
				} else {
					return false;
				}
			});
		},
		fileUploadSuccess: function fileUploadSuccess(res, file) {
			window[this.$route.path] = '';
			console.log('file', res);
			this.ulinfo.tip = res.message;
			if (res.status === 200) {
				if (this.form.ftype == 11) {
					this.form.ver = res.version;
				}

				this.form.fname = file.name;
				this.form.url = res.fileUrl;
				this.form.size = res.appSize;
				this.form.md5 = res.md5;

				this.fileList = [{
					name: file.name
				}];
				this.hBlur('form');
				this.ulinfo.index = 1;
				this.tipColor = {
					color: '#13CE66'
				};
			} else {
				this.ulinfo.index = 2;
				if (this.config.type !== 1) {
					this.fileList = [{}];
				} else {
					this.fileList = [{
						name: this.makeAppPath(this.config.data.appUrl)
					}];
					this.fileList = [];
				}
				this.$message.error(res.message);
				this.tipColor = {
					color: '#FF4949'
				};
			}
		},
		fileBeforeUpload: function fileBeforeUpload(file) {

			console.log('upload file: ' + file);
			var tail = file.name.split('.').pop();
			tail = tail.toLowerCase();

			if (this.form.ftype && file) {
				var is = false;
				var tails = this.ftail[this.form.ftype];
				console.log(this.ftail);
				console.log(this.form.ftype);
				console.log(tails);

				tails.forEach(function (vl) {
					if (vl == tail) is = true;
				});
				if (!is && tails.length > 0) {
					this.$message.error(this.$t('app_spfileis') + this.ftail[this.form.ftype].toString());
					return false;
				}
			} else {

				this.$message.error(this.$t('app_plsltype'));
				return false;
			}

			window[this.$route.path] = 1;
			var ar = file.name.split('.');
			var type = ar[ar.length - 1];
		},
		fillEdit: function fillEdit() {
			var data = this.config.data;
			console.log('fffdata', data);
			this.form.name = data.fileName;
			this.form.desc = data.memo;
			this.form.ftype = data.fileType;
			this.form.ver = data.fileVersion;
			this.form.bver = data.param1;
			this.form.url = data.fileUrl;
			this.form.md5 = data.hashCode;
			this.form.size = data.fileSize;
			this.form.mech = data.mechId;

			var that = this;
			this.mechanismData = {
				value: data.mechName,
				callback: function callback(value) {
					that.form.mech = value;
					that.selectChange(value);
				}
			};

			this.cmtypes = this['sftypes' + data.fileType];
			console.log('pts', this.cmtypes);
			var ffname = data.fileUrl ? data.fileUrl.split('/').pop() : '';
			this.fileList = [{
				name: ffname
			}];
			this.form.fname = ffname;

			var _this = this;
			setTimeout(function () {
				_this.form.stype = data.subFileType;
			}, 800);

			this.ulinfo.index = 1;
		},
		getTypeList: function getTypeList() {
			var _this8 = this;

			this.$getAppTypeList(100000000, 1, function (res) {
				if (res.status === 200) {
					console.log(res);
					_this8.appTypes = res.data;
				} else {
					_this8.$message(res.message);
				}
			}, '');
		},
		cancel: function cancel() {
			this.$router.go(-1);
		},
		verify: function verify() {
			var _this9 = this;

			this.loading = 1;
			var id = this.config.data.applicationid;
			var passValue = this.radio === '1' ? '2' : '3';
			var desc = this.checkDesc;
			if (this.$appUrlTag === 0) {
				this.$verifyApp(localStorage.user, id, passValue, desc, function (res) {
					_this9.loading = 0;
					if (res.status === 200) {
						_this9.$router.go(-1);
					} else {
						_this9.$message.error(res.message);
					}
				}, function () {
					_this9.loading = 0;
					_this9.$message.error(_this9.$t('app_rqsError'));
				});
			} else {
				this.$verifyApp1(this.mechanismId, localStorage.user, id, passValue, desc, function (res) {
					_this9.loading = 0;
					if (res.status === 200) {
						_this9.$router.go(-1);
					} else {
						_this9.$message.error(res.message);
					}
				}, function () {
					_this9.loading = 0;
					_this9.$message.error(_this9.$t('app_rqsError'));
				});
			}
		},
		getAppHistory: function getAppHistory() {
			var _this10 = this;

			if (!this.config.data.launcherName) {
				return;
			}
			console.log('pkg', this.config.data);
			this.loading = 1;
			if (this.$appUrlTag === 0) {
				this.$getAppHistory(this.config.data.launcherName, this.config.data.packagename, function (res) {
					console.log('reslist', res);
					_this10.loading = 0;
					if (res.status === 200) {
						_this10.tableData = res.data;
					} else {
						_this10.$message.error(res.message);
					}
				}, function () {
					_this10.loading = 0;
				});
			} else {
				this.$getAppHistory1(this.mechanismId, this.config.data.packagename, function (res) {
					console.log('reslist', res);
					_this10.loading = 0;
					if (res.status === 200) {
						_this10.tableData = res.data;
					} else {
						_this10.$message.error(res.message);
					}
				}, function () {
					_this10.loading = 0;
				});
			}
		},
		uploadNew: function uploadNew() {},
		setInstallType: function setInstallType(type) {
			return this.$installType[type];
		},
		init: function init() {
			this.config = this.$getWObj().fileEdit;
			console.log('config', this.config);

			switch (this.config.type) {
				case 0:
					var that = this;
					this.mechanismData = {
						value: '',
						callback: function callback(value) {

							that.form.mech = value;
							that.selectChange(value);
						}
					};
					break;
				case 1:
					this.fillEdit();
					break;
				case 2:
					break;
			}
		},
		getDevices: function getDevices() {
			var _this11 = this;

			var vl = this.srchValue ? this.srchValue : '';
			var channel = this.channelId ? this.channelId : '';
			var status = this.status ? this.status : '';
			this.loading = 1;
			if (this.$appUrlTag === 0) {
				this.$getDevices(this.index, this.$gRow, channel, vl, status, '', this.config.data.applicationid, function (res) {
					console.log('dv', res);
					_this11.loading = 0;
					if (res.data) {
						_this11.tableData = res.data;
						_this11.total = res.total;
					}
				}, function () {
					_this11.loading = 0;
				});
			} else {
				this.$getDevices1(this.index, this.$gRow, localStorage.mechanismId, vl, status, '', this.config.data.applicationid, function (res) {
					console.log('dv', res);
					_this11.loading = 0;
					if (res.data) {
						_this11.tableData = res.data;
						_this11.total = res.total;
					}
				}, function () {
					_this11.loading = 0;
				});
			}
		},
		bindOperate: function bindOperate(row) {
			this.bind(row.terminalId, row.terminalNo);
		},
		bind: function bind(tId, tNo) {
			var _this12 = this;

			this.loading = 1;
			if (this.$appUrlTag === 0) {
				this.$bindApp('0', tId, this.config.data.applicationid, function (res) {
					if (res.status === 200) {
						_this12.$message.success(_this12.$t('app_tipViewTask'));
					} else {
						_this12.$message.error(res.message);
					}
					_this12.loading = 0;
				}, function () {
					_this12.loading = 0;
				});
			} else {
				this.$verifyAppPush(localStorage.mechanismId, tNo, this.config.data.applicationid, function (res) {
					if (res.status === 200) {
						_this12.$message.success(_this12.$t('app_tipViewTask'));
					} else {
						_this12.$message.error(res.message);
					}
					_this12.loading = 0;
				}, function () {
					_this12.loading = 0;
				});
			}
		},
		srchDevice: function srchDevice() {
			this.getDevices();
		}
	},
	mounted: function mounted() {
		var _this13 = this;

		this.tqobj = {
			keys: ['nolcft', 'sftypes1', 'sftypes2', 'sftypes3', 'sftypes4', 'sftypes5', 'sftypes6', 'sftypes7', 'sftypes9', 'sftypes11', 'nolcft_1', 'nolcft_2'],
			callback: function callback(data) {
				console.log(data);
				_this13.ftypes = data[10];
				_this13.sftypes1 = data[1];
				_this13.sftypes2 = data[2];
				_this13.sftypes3 = data[3];
				_this13.sftypes4 = data[4];
				_this13.sftypes5 = data[5];
				_this13.sftypes6 = data[6];
				_this13.sftypes7 = data[7];
				_this13.sftypes9 = data[8];
				_this13.sftypes11 = data[9];
				_this13.ftypes_1 = data[10];
				_this13.ftypes_2 = data[11];

				if (_this13.config.type == 1) {
					if (_this13.config.data.fileType == "11" || _this13.config.data.fileType == "6") {
						_this13.form.dtype = 2;
						_this13.ftypes = _this13.ftypes_2;
					} else {
						_this13.form.dtype = 1;
						_this13.ftypes = _this13.ftypes_1;
					}
				}
			}
		};
		this.init();
	}
});

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_tyc_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_tyc_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_global_tyc_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		var that = this;
		return {
			orderName: '',
			orderType: '',
			tqobj: '',
			mechanismData: {
				callback: function callback(value) {
					that.selectChange(value);
				}
			},
			listKey: 'launch-list',
			cerDialogVisible: false,
			cerTipDialogVisible: false,
			dvLoading: 0,
			index: 1,
			appId: '',
			stModel: [{
				label: this.$t('app_online'),
				vl: '1'
			}, {
				label: this.$t('app_offline'),
				vl: '2'
			}, {
				label: this.$t('app_new'),
				vl: '0'
			}],
			channels: [],
			cmsts: [],
			srchValue: '',
			channelId: '',
			cerTipMsg: '',
			status: '',
			dvIndex: 1,
			ftype: '',
			sftype: '',
			dialogVisible: 0,
			mechanismId: window.localStorage['mechanismId'],
			selectMid: '',
			tableData: [],
			dvTableData: [],
			appTypes: [],
			appTypeValue: '',
			appStatus: [{
				label: this.$t('app_prePushVerify'),
				value: '0'
			}, {
				label: this.$t('app_preVerify'),
				value: '1'
			}, {
				label: this.$t('app_verifyPass'),
				value: '2'
			}, {
				label: this.$t('app_verifyNotPass'),
				value: '3'
			}],
			appStatusValue: '',
			total: 0,
			dvTotal: 0,
			loading: 0,
			appType: '',
			queryKey: '',
			ftypes: '',
			getftype: '',
			sftypes1: [],
			sftypes2: [],
			sftypes3: [],
			sftypes5: [],
			sftypes6: [],
			sftypes7: [],
			sftypes9: [],
			sftypes10: [],
			sftypes11: [],
			getsftype: ''
		};
	},

	components: {
		MechanismSelector: __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default.a,
		tyc: __WEBPACK_IMPORTED_MODULE_2__components_global_tyc_vue___default.a
	},
	computed: {
		index: function index() {
			var vl = this.$getWPage(this.listKey);
			return vl ? vl : 1;
		},
		getDvStatus: function getDvStatus(value) {
			switch (value) {
				case '0':
					return this.$t('app_prePushVerify');
				case '1':
					return this.$t('app_preVerify');
				case '2':
					return this.$t('app_verifyPass');
				case '3':
					return this.$t('app_verifyNotPass');
			}
		}
	},
	methods: {
		sortChange: function sortChange(vl) {
			switch (vl.prop) {
				case 'fileName':
					this.orderName = '1';
					break;
				case 'createTime':
					this.orderName = '2';
					break;
			}
			this.orderType = vl.order == 'descending' ? 'desc' : 'asc';
			this.getList();
		},
		fileTypeChange: function fileTypeChange(vl) {
			this.sftype = '';
			if (!vl) {
				this.cmsts = '';
			} else this.cmsts = this['sftypes' + vl];
			this.getList();
		},
		setft: function setft(row) {
			return this.getftype[row.fileType];
		},
		setsbt: function setsbt(row) {

			var vl = this.getsftype[row.subFileType];

			return vl;
		},
		pushCreateCer: function pushCreateCer() {
			this.$router.push({
				path: "/certificate/new"
			});
		},
		pushUploadCer: function pushUploadCer() {
			this.$router.push({
				path: "/certificate/upload"
			});
		},
		bindOperate: function bindOperate(row) {
			var _this = this;

			this.dvLoading = 1;
			if (this.$appUrlTag === 0) {
				this.$bindApp('0', row.terminalNo, this.appId, function (res) {
					if (res.status === 200) {
						_this.$message.success(_this.$t('app_tipViewTask'));
					} else {
						_this.$message.error(res.message);
					}
					_this.dvLoading = 0;
				}, function () {
					_this.dvLoading = 0;
				});
			} else {
				this.$bindApp1(localStorage.mechanismId, row.terminalNo, this.appId, function (res) {
					if (res.status === 200) {
						_this.$message.success(_this.$t('app_tipViewTask'));
					} else {
						_this.$message.error(res.message);
					}
					_this.dvLoading = 0;
				}, function () {
					_this.dvLoading = 0;
				});
			}
		},
		getChannels: function getChannels() {
			var _this2 = this;

			this.$getChannelList(10000, 1, '', '', '', function (res) {
				if (res.status === 200) {
					_this2.channels = res.data;
				} else {
					_this2.$message.error(res.message);
				}
			}, function () {
				_this2.$message.error(_this2.$t('app_rqsError'));
			});
		},
		downOldApp: function downOldApp(row) {
			window.open(this.$host + row.fileUrl);
		},
		getStatus: function getStatus(value) {
			if (!value) return '';
			switch (value) {
				case '0':
					return {
						vl: this.$t('app_prePushVerify'), style: 'color:#8492A6;'
					};
				case '1':
					return {
						vl: this.$t('app_preVerify'), style: 'color:#F7BA2A;'
					};
				case '2':
					return {
						vl: this.$t('app_verifyPass'), style: 'color:#13CE66;'
					};
				case '3':
					return {
						vl: this.$t('app_verifyNotPass'), style: 'color:#FF4949;'
					};
			}
		},
		srchDevice: function srchDevice() {
			this.getDevices();
		},
		selectDvChange: function selectDvChange(vl) {
			this.getDevices();
		},
		pageDvSized: function pageDvSized(val) {
			this.$gRow = val;
			this.getDevices();
		},
		getDevices: function getDevices() {
			var _this3 = this;

			var vl = this.srchValue ? this.srchValue : '';
			var channel = this.channelId ? this.channelId : '';
			var status = this.status ? this.status : '';
			var appId = this.appId ? this.appId : '';
			this.dvLoading = 1;
			if (this.$appUrlTag === 0) {
				this.$getDevices(this.dvIndex, this.$gRow, channel, vl, status, '', appId, function (res) {
					_this3.dvLoading = 0;
					if (res.data) {
						_this3.dvTableData = res.data;
						_this3.dvTotal = res.total;
					}
				}, function () {
					_this3.dvLoading = 0;
				});
			} else {

				this.$getDevices1(this.dvIndex, this.$gRow, localStorage.mechanismId, vl, status, '', appId, function (res) {
					console.log('dv', res);
					_this3.dvLoading = 0;
					if (res.data) {
						_this3.dvTableData = res.data;
						_this3.dvTotal = res.total;
					}
				}, function () {
					_this3.dvLoading = 0;
				});
			}
		},
		editApp: function editApp(row) {
			this.$setWObj('fileEdit', {
				type: 1,
				data: row
			});
			this.$router.push({
				path: '/filemg/edit'
			});
		},
		pushApp: function pushApp(row) {

			this.$router.push({
				path: '/task/ptask/new',
				query: {
					mode: 2,
					fname: row.fileName,
					ftype: row.fileType,
					fid: row.fileId
				}
			});
		},
		query: function query() {
			this.getList();
		},
		selectChange: function selectChange(vl) {
			this.selectMid = vl;
			this.getList();
		},
		reset: function reset() {
			this.queryKey = '';
			this.appType = '';
			this.getList();
		},
		pageSelect: function pageSelect(index) {
			this.index = index;
			this.getList();
		},
		pageDvSelect: function pageDvSelect(index) {
			this.dvIndex = index;
			this.getDevices();
		},
		pageSized: function pageSized(val) {
			this.$gRow = val;
			this.getList();
		},
		deleteApp: function deleteApp(obj) {
			var _this4 = this;

			this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {

				_this4.$delfile(obj.fileId, function (res) {
					if (res.status == 200) {
						_this4.getList();
						_this4.$message.success(res.message);
					} else {
						_this4.$message.error(res.message);
					}
				}, '');
			}, '');
		},
		submitApp: function submitApp(obj) {
			var _this5 = this;

			this.$showConfirm(this.$t('app_tip'), this.$t('app_tipVerify'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
				_this5.loading = 1;
				_this5.$verifyFile(obj.fileId, '', '1', function (res) {
					_this5.loading = 0;
					if (res.status === 200) {
						_this5.getList();
						_this5.$message.success(res.message);
					} else {
						_this5.$message.error(res.message);
					}
				}, function () {
					_this5.loading = 0;
				});
			}, '');
		},
		cellClick: function cellClick(row, ev, col) {
			if (col.label && col.label === this.$t('app_operate')) {
				return;
			}
		},
		jumpToUpload: function jumpToUpload() {

			this.$setWObj('fileEdit', {
				type: 0
			});
			this.$router.push({
				path: '/filemg/add'
			});
		},
		getList: function getList() {
			var _this6 = this;

			this.loading = 1;
			var mech = this.selectMid ? this.selectMid : '';
			var name = this.queryKey ? this.queryKey : '';
			var type = this.ftype;
			var stype = this.sftype;
			var st = '';

			this.$getfile(this.index, this.$gRow, name, mech, type, stype, st, this.orderName, this.orderType, function (res) {

				_this6.loading = 0;
				if (res.status === 200) {
					_this6.total = res.total;
					_this6.tableData = res.data;
				} else {
					_this6.$message(res.message);
				}
			}, function () {
				_this6.loading = 0;
				_this6.$message.error(_this6.$t('app_rqsError'));
			});
		},
		dateFormat: function dateFormat(row, column) {
			var date = row[column.property];
			if (date === undefined) {
				return '';
			}
			return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD HH:mm:ss');
		},
		setInstallType: function setInstallType(type) {
			return this.$installType[type];
		}
	},
	mounted: function mounted() {
		var _this7 = this;

		this.tqobj = {
			keys: ['ftypes', 'ftype', 'sftype', 'sftypes1', 'sftypes2', 'sftypes3', 'sftypes4', 'sftypes5', 'sftypes6', 'sftypes7', 'sftypes9', 'sftypes11'],
			callback: function callback(data) {
				console.log(data);
				_this7.ftypes = data[0];
				_this7.ftypes.splice(3, 1);
				_this7.ftypes.splice(5, 1);

				_this7.getftype = data[1];
				_this7.getsftype = data[2];
				_this7.sftypes1 = data[3];
				_this7.sftypes2 = data[4];
				_this7.sftypes3 = data[5];
				_this7.sftypes4 = data[6];
				_this7.sftypes5 = data[7];
				_this7.sftypes6 = data[8];
				_this7.sftypes7 = data[9];
				_this7.sftypes9 = data[10];
				_this7.sftypes11 = data[11];
			}
		};

		this.getList();
	},
	destroyed: function destroyed() {}
});

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_df_png__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_df_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_df_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_global_tyc_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_global_tyc_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_global_tyc_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_global_tagc__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_global_tagc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_global_tagc__);


var _methods;






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var that = this;
    return {
      tqobj: '',
      getftype: '',
      getstype: '',
      dLoading: false,
      srchValue: '',
      reason: '',
      config: '',
      isNon: false,
      captures: [],
      loading: 0,
      dialogVisible: false,
      notPassDialog: false,
      index: 1,
      tableData: [],
      total: 0,
      status: '',
      mech: '',
      stModel: '',
      nmSt: '',
      gunSt: [{ lb: this.$t('app_new'), vl: '0' }, { lb: this.$t('app_enable'), vl: '1' }],
      mechanismData: {
        callback: function callback(value) {
          that.mech = value;
          that.selectChange(value);
        }
      }
    };
  },

  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default.a, tyc: __WEBPACK_IMPORTED_MODULE_4__components_global_tyc_vue___default.a, tagc: __WEBPACK_IMPORTED_MODULE_5__components_global_tagc___default.a
  },
  computed: {
    showUploadNew: function showUploadNew() {
      console.log('ccc', this.config.data);
      if (this.config.data) {
        if (this.config.data.isoperation === 0 && this.config.data.appStatus === '2') {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  methods: (_methods = {
    openlink: function openlink() {
      window.open(this.$host + this.config.fileUrl);
    },
    bindOperate: function bindOperate(row) {
      var _this = this;

      this.dLoading = 1;
      this.$filePushTest(this.config.fileId, row.terminalNo, function (res) {
        _this.dLoading = 0;
        if (res.status === 200) {
          _this.$message.success(_this.$t('app_pssuccess'));
          _this.notPassDialog = false;
        } else {
          _this.$message.error(res.message);
        }
      }, function (error) {
        _this.dLoading = 0;
        _this.$message.error(_this.$t('app_rqsError'));
      });
    },
    verify: function verify(vl) {
      var _this2 = this;

      if (vl === '2') {
        this.$confirm(this.$t('app_srpassvf') + '?', this.$t('app_tip'), {
          confirmButtonText: this.$t('app_sure'),
          cancelButtonText: this.$t('app_cancel'),
          type: 'warning'
        }).then(function () {
          _this2.verifyRqs(vl);
        }).catch(function () {});
      } else if (vl === '3') {
        this.notPassDialog = true;
      }
    },
    verifyRqs: function verifyRqs(vl) {
      var _this3 = this;

      this.loading = 1;
      this.$verifyFile(this.config.fileId, this.reason, vl, function (res) {
        _this3.loading = 0;
        if (res.status === 200) {
          _this3.$message.success(res.message);
          _this3.$router.go(-1);
        } else {
          _this3.$message.error(res.message);
        }
      }, function () {
        _this3.$message.error(_this3.$t('app_rqsError'));
        _this3.loading = 0;
      });
    },
    srchDevice: function srchDevice() {
      this.getCmList();
    },
    selectChange: function selectChange(vl) {
      this.getCmList();
    },
    pageSelect: function pageSelect(index) {
      this.index = index;

      this.getCmList();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;

      this.getCmList();
    },
    getDevices: function getDevices() {
      var _this4 = this;

      var vl = this.srchValue ? this.srchValue : '';
      var channel = this.channelId ? this.channelId : '';
      var status = this.status ? this.status : '';
      var mc = this.mech;
      var fileMechId = '';
      var fileType = '';
      var fileId = '';
      this.loading = 1;
      this.$canPushTer(this.index, this.$gRow, fileMechId, mc, status, vl, fileType, fileId, function (res) {

        _this4.loading = 0;
        if (res.data) {
          _this4.tableData = res.data;
          _this4.total = res.total;
        }
      }, function () {
        _this4.loading = 0;
      });
    },
    getNonDevices: function getNonDevices() {
      var _this5 = this;

      var vl = this.srchValue ? this.srchValue : '';
      var channel = this.channelId ? this.channelId : '';
      var status = this.status ? this.status : '';
      var mc = this.mech;
      this.loading = 1;

      this.$getNonItDv(this.index, this.$gRow, mc, vl, status, '', '', '', '', '', function (res) {

        _this5.loading = 0;
        if (res.data) {
          _this5.tableData = res.data;
          _this5.total = res.total;
        }
      }, function () {
        _this5.loading = 0;
      });
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD hh:mm:ss');
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'selectChange', function selectChange(vl) {
    this.getCmList();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'pageSelect', function pageSelect(index) {
    this.index = index;

    this.getCmList();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'pageSized', function pageSized(val) {
    this.$gRow = val;

    this.getCmList();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'deleteAppHis', function deleteAppHis(row) {
    var _this6 = this;

    if (row.applicationid) {
      this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
        confirmButtonText: this.$t('app_sure'),
        cancelButtonText: this.$t('app_cancel'),
        type: 'warning'
      }).then(function () {
        _this6.loading = 1;
        if (_this6.$appUrlTag === 0) {
          _this6.$deleteApp(row.applicationid, function (res) {
            _this6.loading = 0;
            if (res.status === 200) {
              _this6.getAppHistory();
            } else {
              _this6.$message.error(res.message);
            }
          }, function () {
            _this6.loading = 0;
          });
        } else {
          _this6.$deleteAppHis(row.applicationid, function (res) {
            _this6.loading = 0;
            if (res.status === 200) {
              _this6.getAppHistory();
            } else {
              _this6.$message.error(res.message);
            }
          }, function () {
            _this6.loading = 0;
          });
        }
      }).catch(function () {});
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'imgFullUrl', function imgFullUrl(path) {
    if (path) {
      return this.$urls.prefix + path;
    } else {
      return '';
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'getAppHistory', function getAppHistory() {
    var _this7 = this;

    if (!this.config.data.appName) {
      return;
    }

    this.loading = 1;
    if (this.$appUrlTag === 0) {
      this.$getAppHistory(this.config.data.appName, this.config.data.packagename, function (res) {
        _this7.loading = 0;
        if (res.status === 200) {
          _this7.tableData = res.data;
        } else {
          _this7.$message.error(res.message);
        }
      }, function () {
        _this7.loading = 0;
      });
    } else {

      this.$getAppHistory1(localStorage.mechanismId, this.config.data.packagename, function (res) {

        _this7.loading = 0;
        if (res.status === 200) {
          _this7.tableData = res.data;
        } else {
          _this7.$message.error(res.message);
        }
      }, function () {
        _this7.loading = 0;
      });
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'uploadNew', function uploadNew() {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'getCmList', function getCmList() {
    switch (this.config.fileType) {
      case '1':
      case '2':
      case '3':
      case '4':
      case '5':
      case '10':
        this.stModel = this.nmSt;
        this.getDevices();

        this.isNon = false;
        break;
      case '6':
        this.stModel = this.gunSt;
        this.isNon = true;
        this.getNonDevices();
        break;
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'init', function init() {
    this.config = this.$getWObj().fileDetail;

    this.getCmList();
  }), _methods),
  mounted: function mounted() {
    var _this8 = this;

    this.tqobj = {
      keys: ['ftype', 'sftype', 'terminalTypes'],
      callback: function callback(data) {
        _this8.getftype = data[0];
        _this8.getstype = data[1];
        _this8.nmSt = data[2];

        _this8.status = '1';
        _this8.init();
      }
    };
  }
});

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_tyc_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_tyc_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_global_tyc_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default.a,
    tyc: __WEBPACK_IMPORTED_MODULE_2__components_global_tyc_vue___default.a
  },

  data: function data() {
    var that = this;
    return {
      orderName: '',
      orderType: '',
      tqobj: '',
      mechanismData: {
        callback: function callback(value) {
          that.selectChange(value);
        }
      },
      listKey: 'launch-list',
      cerDialogVisible: false,
      cerTipDialogVisible: false,
      dvLoading: 0,
      appId: '',
      stModel: [{ label: this.$t('app_online'), vl: '1' }, { label: this.$t('app_offline'), vl: '2' }, { label: this.$t('app_new'), vl: '0' }],
      channels: [],
      cmsts: [],
      srchValue: '',
      channelId: '',
      cerTipMsg: '',
      status: '',
      dvIndex: 1,
      ftype: '',
      sftype: '',
      dialogVisible: 0,
      mechanismId: window.localStorage['mechanismId'],
      selectMid: '',
      tableData: [],
      dvTableData: [],
      appTypes: [],
      appTypeValue: '',
      appStatus: [{ label: this.$t('app_prePushVerify'), value: '0' }, { label: this.$t('app_preVerify'), value: '1' }, { label: this.$t('app_verifyPass'), value: '2' }, { label: this.$t('app_verifyNotPass'), value: '3' }],
      appStatusValue: '',
      total: 0,
      dvTotal: 0,
      loading: 0,
      appType: '',
      queryKey: '',
      ftypes: '',
      getftype: '',
      sftypes1: [],
      sftypes2: [],
      sftypes3: [],
      sftypes5: [],
      sftypes6: [],
      sftypes7: [],
      sftypes9: [],
      sftypes10: [],
      getsftype: ''
    };
  },

  computed: {
    index: function index() {
      var vl = this.$getWPage(this.listKey);
      return vl ? vl : 1;
    },
    getDvStatus: function getDvStatus(value) {
      switch (value) {
        case '0':
          return this.$t('app_prePushVerify');
        case '1':
          return this.$t('app_preVerify');
        case '2':
          return this.$t('app_verifyPass');
        case '3':
          return this.$t('app_verifyNotPass');
      }
    }
  },
  methods: {
    sortChange: function sortChange(vl) {
      switch (vl.prop) {
        case 'fileName':
          this.orderName = '1';
          break;
        case 'createTime':
          this.orderName = '2';
          break;
      }
      this.orderType = vl.order == 'descending' ? 'desc' : 'asc';
      this.getList();
    },
    fileTypeChange: function fileTypeChange(vl) {
      this.sftype = '';
      if (!vl) {
        this.cmsts = '';
      } else this.cmsts = this['sftypes' + vl];
      this.getList();
    },
    setft: function setft(row) {
      return this.getftype[row.fileType];
    },
    setsbt: function setsbt(row) {

      var vl = this.getsftype[row.subFileType];
      return vl;
    },
    pushCreateCer: function pushCreateCer() {
      this.$router.push({ path: "/certificate/new" });
    },
    pushUploadCer: function pushUploadCer() {
      this.$router.push({ path: "/certificate/upload" });
    },
    bindOperate: function bindOperate(row) {
      var _this = this;

      this.dvLoading = 1;
      if (this.$appUrlTag === 0) {
        this.$bindApp('0', row.terminalNo, this.appId, function (res) {
          if (res.status === 200) {
            _this.$message.success(_this.$t('app_tipViewTask'));
          } else {
            _this.$message.error(res.message);
          }
          _this.dvLoading = 0;
        }, function () {
          _this.dvLoading = 0;
        });
      } else {
        this.$bindApp1(localStorage.mechanismId, row.terminalNo, this.appId, function (res) {
          if (res.status === 200) {
            _this.$message.success(_this.$t('app_tipViewTask'));
          } else {
            _this.$message.error(res.message);
          }
          _this.dvLoading = 0;
        }, function () {
          _this.dvLoading = 0;
        });
      }
    },
    getChannels: function getChannels() {
      var _this2 = this;

      this.$getChannelList(10000, 1, '', '', '', function (res) {
        if (res.status === 200) {
          _this2.channels = res.data;
        } else {
          _this2.$message.error(res.message);
        }
      }, function () {
        _this2.$message.error(_this2.$t('app_rqsError'));
      });
    },
    getStatus: function getStatus(value) {
      if (!value) return '';
      switch (value) {
        case '0':
          return { vl: this.$t('app_prePushVerify'), style: 'color:#8492A6;' };
        case '1':
          return { vl: this.$t('app_preVerify'), style: 'color:#F7BA2A;' };
        case '2':
          return { vl: this.$t('app_verifyPass'), style: 'color:#13CE66;' };
        case '3':
          return { vl: this.$t('app_verifyNotPass'), style: 'color:#FF4949;' };
      }
    },
    srchDevice: function srchDevice() {
      this.getDevices();
    },
    selectDvChange: function selectDvChange(vl) {
      this.getDevices();
    },
    pageDvSized: function pageDvSized(val) {
      this.$gRow = val;
      this.getDevices();
    },
    getDevices: function getDevices() {
      var _this3 = this;

      var vl = this.srchValue ? this.srchValue : '';
      var channel = this.channelId ? this.channelId : '';
      var status = this.status ? this.status : '';
      var appId = this.appId ? this.appId : '';
      this.dvLoading = 1;
      if (this.$appUrlTag === 0) {
        this.$getDevices(this.dvIndex, this.$gRow, channel, vl, status, '', appId, function (res) {
          _this3.dvLoading = 0;
          if (res.data) {
            _this3.dvTableData = res.data;
            _this3.dvTotal = res.total;
          }
        }, function () {
          _this3.dvLoading = 0;
        });
      } else {

        this.$getDevices1(this.dvIndex, this.$gRow, localStorage.mechanismId, vl, status, '', appId, function (res) {
          console.log('dv', res);
          _this3.dvLoading = 0;
          if (res.data) {
            _this3.dvTableData = res.data;
            _this3.dvTotal = res.total;
          }
        }, function () {
          _this3.dvLoading = 0;
        });
      }
    },
    editApp: function editApp(row) {
      this.$setWObj('fileEdit', { type: 1, data: row });
      this.$router.push({ path: '/filemg/edit' });
    },
    pushApp: function pushApp(row) {

      this.$setWObj('pushList', { type: '10', data: row });
      this.$router.push({ path: '/launch-push' });
    },
    query: function query() {
      this.getList();
    },
    selectChange: function selectChange(vl) {
      this.selectMid = vl;
      this.getList();
    },
    reset: function reset() {
      this.queryKey = '';
      this.appType = '';
      this.getList();
    },
    pageSelect: function pageSelect(index) {
      this.$setWPage(this.listKey, index);
      this.getList();
    },
    pageDvSelect: function pageDvSelect(index) {
      this.dvIndex = index;
      this.getDevices();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getList();
    },
    deleteApp: function deleteApp(obj) {
      var _this4 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        console.log(obj);
        _this4.$delfile(obj.fileId, function (res) {
          if (res.status === 200) {
            _this4.getList();
            _this4.$message.success(res.message);
          } else {
            _this4.$message.error(res.message);
          }
        }, '');
      }, '');
    },
    submitApp: function submitApp(obj) {
      var _this5 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_tipVerify'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this5.loading = 1;
        _this5.$verifyFile(obj.fileId, '', '1', function (res) {
          _this5.loading = 0;
          if (res.status === 200) {
            _this5.getList();
            _this5.$message.success(res.message);
          } else {
            _this5.$message.error(res.message);
          }
        }, function () {
          _this5.loading = 0;
        });
      }, '');
    },
    cellClick: function cellClick(row, ev, col) {

      this.$setWObj('fileDetail', row);
      this.$router.push({ path: '/filemg/vlist/verify' });
    },
    jumpToUpload: function jumpToUpload() {

      this.$setWObj('fileEdit', { type: 0 });
      this.$router.push({ path: '/filemg/add' });
    },
    getList: function getList() {
      var _this6 = this;

      this.loading = 1;
      var mech = this.selectMid ? this.selectMid : '';
      var name = this.queryKey ? this.queryKey : '';
      var type = this.ftype;
      var stype = this.sftype;
      var st = '1';

      this.$getfile(this.index, this.$gRow, name, mech, type, stype, st, this.orderName, this.orderType, function (res) {

        _this6.loading = 0;
        if (res.status === 200) {
          _this6.total = res.total;
          _this6.tableData = res.data;
        } else {
          _this6.$message(res.message);
        }
      }, function () {
        _this6.loading = 0;
        _this6.$message.error(_this6.$t('app_rqsError'));
      });
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD HH:mm:ss');
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    }
  },
  mounted: function mounted() {
    var _this7 = this;

    this.tqobj = {
      keys: ['ftypes', 'ftype', 'sftype', 'sftypes1', 'sftypes2', 'sftypes3', 'sftypes4', 'sftype5', 'sftypes6', 'sftypes7', 'sftypes9'],
      callback: function callback(data) {
        _this7.ftypes = data[0];
        _this7.getftype = data[1];
        _this7.getsftype = data[2];
        _this7.sftypes1 = data[3];
        _this7.sftypes2 = data[4];
        _this7.sftypes3 = data[5];
        _this7.sftypes4 = data[6];
        _this7.sftypes5 = data[7];
        _this7.sftypes6 = data[8];
        _this7.sftypes7 = data[9];
        _this7.sftypes9 = data[10];
      }
    };

    this.getList();
  },
  destroyed: function destroyed() {}
});

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      mechanismId: window.localStorage['mechanismId'],
      loading: 0,
      fType: '',
      tableData: [],
      total: 0,
      qName: '',
      type: [{
        value: '',
        label: this.$t('lin_global.allType')
      }, {
        value: 'ota',
        label: 'OTA'
      }, {
        value: 'rom',
        label: 'ROM'
      }]
    };
  },

  computed: {
    index: function index() {
      return this.$getWPage('firmwarePage');
    }
  },
  mounted: function mounted() {
    this.getList();
  },

  methods: {
    check: function check(row) {
      this.$setWObj('info', row);
      this.$router.push({ path: 'firmwareCheck/detail' });
    },
    delFw: function delFw(row) {
      var _this = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_tipAppEdit'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this.loading = 1;
        _this.$delFirmware(ids, function (res) {
          _this.loading = 0;
          if (res.status === 200) {
            _this.$message.success(res.message);
            _this.getList();
          } else {
            _this.$message.error(res.message);
          }
        }, function () {
          _this.loading = 0;
        });
      }, '');
    },
    editFw: function editFw(row) {
      this.$setWObj('info', row);
      this.$router.push({ path: 'firmwareManage/edit' });
    },
    submitFw: function submitFw(row) {
      var _this2 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_isSubmitToCheck'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this2.loading = 1;
        _this2.$checkFirmware(row.id, '', '1', function (res) {
          _this2.loading = 0;
          if (res.status === 200) {
            _this2.$message.success(res.message);
            _this2.getList();
          } else {
            _this2.$message.error(res.message);
          }
        }, function () {
          _this2.loading = 0;
        });
      }, '');
    },
    search: function search() {
      this.getList();
    },
    selectChange: function selectChange() {
      this.getList();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getList();
    },

    submitRow: function submitRow(id) {
      var _this3 = this;

      var token = localStorage.getItem('user');
      var params = { token: token, ota_rom_id: id, content: '', status: 1 };
      this.$confirm(this.$t('lin_global.qdtjsh'), this.$t('lin_btn.tips'), {
        confirmButtonText: this.$t('lin_btn.confirm'),
        cancelButtonText: this.$t('lin_btn.cancel'),
        type: 'warning'
      }).then(function () {
        axios.post(baseurl + '/ota_rom/audit.do', params).then(function (res) {
          if (res.data.status == 200) {
            _this3.$message.success(_this3.$t('lin_global.tjshcg'));
            _this3.getData(1, '');
          } else {
            _this3.$message.error(res.data.message);
          }
        });
      }).catch(function () {});
    },
    editRow: function editRow(id) {
      this.$router.push({ path: '/romList/' + id + '/edit' });
    },
    deleteRow: function deleteRow(id) {
      var _this4 = this;

      var params = { ids: id };
      this.$confirm(this.$t('lin_global.confirmDelete'), this.$t('lin_btn.tips'), {
        confirmButtonText: this.$t('lin_btn.confirm'),
        cancelButtonText: this.$t('lin_btn.cancel'),
        type: 'warning'
      }).then(function () {
        axios.post(baseurl + '/ota_rom/delete.do', params).then(function (res) {
          if (res.data.status == 200) {
            _this4.$message.success(_this4.$t('lin_global.delete_success'));
            _this4.getData(1, '');
          } else {
            _this4.$message.error(res.data.message);
          }
        });
      }).catch(function () {});
    },
    getList: function getList() {
      var _this5 = this;

      this.loading = 1;
      var type = this.fType ? this.fType : '';
      var name = this.qName ? this.qName : '';
      var status = '1';
      this.$getFirmwareList(this.$gRow, this.$getWPage('firmwarePage'), this.mechanismId, name, type, status, function (res) {
        console.log('res', res);
        _this5.loading = 0;
        if (res.status === 200) {
          _this5.total = res.total;
          _this5.tableData = res.data;
        } else {
          _this5.$message(res.message);
        }
      }, function () {
        _this5.loading = 0;
        _this5.$message.error(_this5.$t('app_rqsError'));
      });
    },

    upload: function upload() {
      this.$router.push({ path: 'firmwareManage/upload' });
    },
    handleIconClick: function handleIconClick() {},
    handleSizeChange: function handleSizeChange(val) {},
    handleCurrentChange: function handleCurrentChange(index) {
      this.$setWPage('firmwarePage', index);
      this.getList();
    }
  }
});

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      srchValue: '',
      index: 1,
      tableData: [],
      dialogVisible: false,
      reasonDia: false,
      content: '',
      radio: '2',
      editInfo: '',
      mechs: [],
      loading: 0,
      fileList: [],
      form: {
        name: '',
        version: '',
        type: '',
        url: '',
        mechanism: ''
      },
      rules: {
        'name': [{
          required: true,
          message: this.$t('lin_global.notBlankName')
        }],
        'version': [{
          required: true,
          message: this.$t('lin_global.notBlankVer')
        }],
        'type': [{
          required: true,
          message: this.$t('lin_global.qxzlx')
        }],
        'mechanism': [{
          required: true,
          message: this.$t('app_selectChannel')
        }],
        'url': [{
          required: true,
          message: this.$t('lin_global.qxzscwj')
        }]
      },
      areaList: []
    };
  },
  mounted: function mounted() {
    alert('da');
    var obj = this.$getWObj().info;
    console.log(obj);
    if (obj) {
      this.editInfo = obj;
    }
    this.getDevices();
  },

  computed: {},
  methods: {
    srchDevice: function srchDevice() {

      this.getDevices();
    },
    pageSelect: function pageSelect(index) {
      this.index = index;
      this.getDevices();
    },
    getDevices: function getDevices() {
      var _this = this;

      var vl = this.srchValue ? this.srchValue : '';
      var channel = this.channelId ? this.channelId : '';
      var status = this.status ? this.status : '';
      this.loading = 1;
      this.$getDvDevices(this.index, this.$gRow, '', vl, '', '', '', '', '', '', function (res) {
        console.log('dv', res);
        _this.loading = 0;
        if (res.data) {
          _this.tableData = res.data;
          _this.total = res.total;
        }
      }, function () {
        _this.loading = 0;
      });
    },
    pushInstall: function pushInstall(row) {
      var _this2 = this;

      this.loading = 1;
      this.$pushFirmware('', this.editInfo.id, '1', row.terminalNo, function (res) {
        _this2.loading = 0;
        _this2.$message(res.message);
      }, function () {
        _this2.loading = 0;
      });
    },
    pushTest: function pushTest() {
      this.dialogVisible = true;
    },
    hBlur: function hBlur(name) {
      this.$refs['addForm'].validate(function (valid) {
        if (valid) {} else {
          return false;
        }
      });
    },

    onSubmit: function onSubmit(vl) {
      var _this3 = this;

      this.loading = 1;

      this.$checkFirmware(this.editInfo.id, this.content, vl, function (res) {
        _this3.loading = 0;
        if (res.status === 200) {
          _this3.$message.success(res.message);
          _this3.$router.go(-1);
        } else {
          _this3.$message.error(res.message);
        }
      }, function () {
        _this3.loading = 0;
      });
    },
    onCancel: function onCancel() {
      this.$router.go(-1);
    }
  }
});

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__);


var vCheck = function vCheck(rule, value, callback) {
  if (window.self.form.type !== 'KOS' && window.self.form.type !== 'KSP' && window.self.form.type !== 'HEX') {
    callback();
  }
  var arr = value.split('.');
  if (arr.length > 1) {
    var illegal = false;
    arr.forEach(function (vl) {
      var patt1 = new RegExp("^[1-9]\d*|0$");
      illegal = !patt1.test(vl);
    });
    if (illegal) {
      callback(new Error(window.self.$t('app_fmVerIillegal')));
    } else {
      callback();
    }
  } else {
    callback(new Error(window.self.$t('app_fmVerIillegal')));
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default.a
  },
  data: function data() {
    var _this2 = this;

    var versionCheck = function versionCheck(rule, value, callback) {

      if (_this2.udFileType == 0 && rule.field == 'preVersion') {
        callback();
        return;
      }

      var rg = /^\d+(\.\d+)+$/;
      if (!rg.test(value)) {
        callback(new Error(_this2.$t('lin_global.bbhgsbd')));
      } else {
        callback();
      }
    };
    var that = this;
    return {
      mechanismData: null,
      editInfo: '',
      mechs: [],
      loading: 0,
      fileList: [],
      form: {
        name: '',
        version: '',
        type: '',
        url: '',
        md5: '',
        mechanism: {
          id: '',
          name: ''
        }
      },
      rules: {
        'name': [{
          required: true,
          message: this.$t('lin_global.notBlankName')
        }],
        'version': [{
          required: true,
          message: this.$t('lin_global.notBlankVer')
        }, {
          validator: versionCheck, trigger: 'blur'
        }],
        'type': [{
          required: true,
          message: this.$t('lin_global.qxzlx')
        }],
        'mechanism': [{
          required: true,
          message: this.$t('app_selectChannel')
        }],
        'url': [{
          required: true,
          message: this.$t('lin_global.qxzscwj')
        }]
      },
      areaList: [],
      fwVersionInputVisable: true
    };
  },
  mounted: function mounted() {
    window.self = this;
    var that = this;
    var mVl = '';
    if (!this.isUpload()) {
      var obj = this.$getWObj().info;
      if (obj) {
        this.editInfo = obj;
        this.fillData();
      }
      mVl = obj.mechanismId;
    }
    this.mechanismData = {
      value: mVl,
      placeholder: this.$t('lin_global.place_areaid'),
      optValue: true,
      callback: function callback(value) {
        console.log(value);
        that.form.mechanism = value;
      }
    };
  },

  computed: {
    fileUploadUrl: function fileUploadUrl() {
      return this.$urls.fileUrl;
    },
    typeHolder: function typeHolder() {
      if (this.isUpload()) {
        return this.$t('app_select');
      } else {
        return '';
      }
    }
  },
  methods: {
    isVer: function isVer() {
      if (!this.form) return false;
      if (this.form.type == 'HEX' || this.form.type == 'KSP' || this.form.type == 'KOS') {
        return true;
      } else {
        return false;
      }
    },
    isUpload: function isUpload() {
      return this.$route.path === '/firmwareManage/upload';
    },
    fillData: function fillData() {
      console.log(this.editInfo);
      this.form.name = this.editInfo.firmwareName;
      this.form.version = this.editInfo.version;
      this.form.type = this.editInfo.type;
      this.form.mechanism.id = this.editInfo.mechanismId;
      this.form.mechanism.name = this.editInfo.mechanismName;
      this.form.url = this.editInfo.url;
      this.fileList = [{ name: this.editInfo.firmwareName }];
      var _this = this;
    },
    hBlur: function hBlur(name) {
      this.$refs['addForm'].validate(function (valid) {
        if (valid) {} else {
          return false;
        }
      });
    },
    fileUploadSuccess: function fileUploadSuccess(res, file) {
      window[this.$route.path] = '';

      if (res.status === 200) {
        this.form.url = res.fileUrl;

        this.form.md5 = res.md5;
        this.fileList = [{ name: file.name }];
        this.hBlur();
      } else {
        if (this.config.type !== 1) {
          this.fileList = [];
        } else {
          this.fileList = [{ name: file.name }];
        }
        this.$message.error(this.$t('app_onlyApk'));
      }
    },
    fileBeforeUpload: function fileBeforeUpload(file) {
      console.log(file);
      window[this.$route.path] = 1;
      return 1;
    },

    onSubmit: function onSubmit() {
      var _this3 = this;

      this.$refs['addForm'].validate(function (valid) {
        if (!_this3.isVer()) {
          _this3.form.version = '1.0';
        }

        if (valid) {
          _this3.loading = 1;
          var isUpload = !_this3.editInfo;
          if (isUpload) {
            console.log(_this3.form.url);

            _this3.$uploadFirmware(_this3.form.md5, _this3.form.mechanism.name, _this3.form.mechanism.id, _this3.form.name, _this3.form.type, _this3.form.url, _this3.form.version, function (res) {
              _this3.loading = 0;
              if (res.status === 200) {
                _this3.$message.success(res.message);
                _this3.$router.go(-1);
              } else {
                _this3.$message(res.message);
              }
            }, function () {
              _this3.loading = 0;
              _this3.$message(_this3.$t('app_rqsError'));
            });
          } else {
            _this3.loading = 0;
            console.log("firmware param: " + _this3.form);
            _this3.$editFirmware(_this3.form.md5, _this3.editInfo.id, _this3.form.name, _this3.form.url, _this3.form.version, _this3.form.type, _this3.form.mechanism.id, _this3.form.mechanism.name, function (res) {
              _this3.loading = 0;
              if (res.status === 200) {
                _this3.$router.go(-1);
                _this3.$message.success(res.message);
              } else {
                _this3.$message.error(res.message);
              }
            }, function () {
              _this3.loading = 0;
            });
          }
        } else {
          return false;
        }
      });
    },
    onCancel: function onCancel() {
      this.$router.go(-1);
    },

    selectTypeChange: function selectTypeChange(value) {
      if (value === 'KSP' || value === 'KOS' || value === 'HEX') {
        this.fwVersionInputVisable = true;
      } else {
        this.form.version = '';
        this.fwVersionInputVisable = false;
      }
      console.log('select value: ' + value);
    }
  }
});

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      abc: '',
      mechanismId: window.localStorage['mechanismId'],
      loading: 0,
      fType: '',
      tableData: [],
      total: 0,
      qName: '',
      type: [{
        value: '',
        label: this.$t('lin_global.allType')
      }, {
        value: 'ota',
        label: 'OTA'
      }, {
        value: 'rom',
        label: 'ROM'
      }]
    };
  },

  computed: {
    index: function index() {
      return this.$getWPage('firmwarePage');
    }
  },
  mounted: function mounted() {
    this.getList();
  },

  methods: {
    toPush: function toPush(row) {
      this.$setWObj('pushList', { type: '4', data: row });
      this.$router.push({ path: '/firmware/push' });
    },
    reset: function reset() {
      this.fType = '';
      this.qName = '';
      this.getList();
    },
    delFw: function delFw(row) {
      var _this = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_tipAppEdit'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this.loading = 1;
        _this.$deleteFirmware(row.id, function (res) {
          _this.loading = 0;
          if (res.status === 200) {
            _this.$message.success(res.message);
            _this.getList();
          } else {
            _this.$message.error(res.message);
          }
        }, function () {
          _this.loading = 0;
        });
      }, '');
    },
    editFw: function editFw(row) {
      this.$setWObj('info', row);
      this.$router.push({ path: 'firmwareManage/edit' });
    },
    submitFw: function submitFw(row) {
      var _this2 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_isSubmitToCheck'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this2.loading = 1;
        _this2.$checkFirmware(row.id, '', '1', function (res) {
          _this2.loading = 0;
          if (res.status === 200) {
            _this2.$message.success(res.message);
            _this2.getList();
          } else {
            _this2.$message.error(res.message);
          }
        }, function () {
          _this2.loading = 0;
        });
      }, '');
    },
    search: function search() {
      this.getList();
    },
    selectChange: function selectChange() {
      this.getList();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getList();
    },

    submitRow: function submitRow(id) {
      var _this3 = this;

      var token = localStorage.getItem('user');
      var params = { token: token, ota_rom_id: id, content: '', status: 1 };
      this.$confirm(this.$t('lin_global.qdtjsh'), this.$t('lin_btn.tips'), {
        confirmButtonText: this.$t('lin_btn.confirm'),
        cancelButtonText: this.$t('lin_btn.cancel'),
        type: 'warning'
      }).then(function () {
        axios.post(baseurl + '/ota_rom/audit.do', params).then(function (res) {
          if (res.data.status == 200) {
            _this3.$message.success(_this3.$t('lin_global.tjshcg'));
            _this3.getData(1, '');
          } else {
            _this3.$message.error(res.data.message);
          }
        });
      }).catch(function () {});
    },
    editRow: function editRow(id) {
      this.$router.push({ path: '/romList/' + id + '/edit' });
    },
    deleteRow: function deleteRow(id) {
      var _this4 = this;

      var params = { ids: id };
      this.$confirm(this.$t('lin_global.confirmDelete'), this.$t('lin_btn.tips'), {
        confirmButtonText: this.$t('lin_btn.confirm'),
        cancelButtonText: this.$t('lin_btn.cancel'),
        type: 'warning'
      }).then(function () {
        axios.post(baseurl + '/firmwareInfo/delete.do', params).then(function (res) {
          if (res.data.status == 200) {
            _this4.$message.success(_this4.$t('lin_global.delete_success'));
            _this4.getData(1, '');
          } else {
            _this4.$message.error(res.data.message);
          }
        });
      }).catch(function () {});
    },
    getList: function getList() {
      var _this5 = this;

      this.loading = 1;
      var type = this.fType ? this.fType : '';
      var name = this.qName ? this.qName : '';
      var status = '';
      this.$getFirmwareList(this.$gRow, this.$getWPage('firmwarePage'), '', name, type, status, function (res) {
        console.log('res', res);
        _this5.loading = 0;
        if (res.status === 200) {
          _this5.total = res.total;
          _this5.tableData = res.data;
        } else {
          _this5.$message(res.message);
        }
      }, function () {
        _this5.loading = 0;
        _this5.$message.error(_this5.$t('app_rqsError'));
      });
    },

    upload: function upload() {
      this.$router.push({ path: 'firmwareManage/upload' });
    },
    handleIconClick: function handleIconClick() {},
    handleSizeChange: function handleSizeChange(val) {},
    handleCurrentChange: function handleCurrentChange(index) {
      this.$setWPage('firmwarePage', index);
      this.getList();
    }
  }
});

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_TernoAutoCtrl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_TernoAutoCtrl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_TernoAutoCtrl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default.a, AutoTerno: __WEBPACK_IMPORTED_MODULE_1__global_TernoAutoCtrl___default.a
  },
  data: function data() {
    var _this = this;

    var itemCheck = function itemCheck(rule, value, callback) {
      if (!_this.form.item) {
        callback(new Error(_this.$t('app_select')));
      } else {
        callback();
      }
    };
    var that = this;
    return {
      mechanismData: {
        placeholder: that.$t('lin_global.place_areaid'),
        callback: function callback(value) {
          that.form.mechanism = value;
          that.selectChange(value);
        }
      },
      loading: false,
      exInfo: '',
      arrdatas: [],
      totalRecords: 0,
      srcList: [],
      hLoading: false,
      currentPage: 1,
      restaurants: [],
      missionNames: {
        '0': this.$t('app_distributor'), '1': this.$t('app_dv'), '2': this.$t('app_fileImport')
      },
      devices: 0,
      mechanismId: window.localStorage['mechanismId'],
      dNo: '',
      info: '',
      pushType: [{ label: this.$t('app_distributor'), vl: 0 }, { label: this.$t('app_dv'), vl: 1 }, { label: this.$t('app_fileImport'), vl: 2 }],
      tableData: [],
      fatherList: [],
      mechs: [],
      form: {
        item: '',
        pushType: 0,
        mechanism: '',
        fileNo: ''
      },
      rules: {
        item: [{ required: true, message: this.$t('app_select'), trigger: 'change', validator: itemCheck }]
      }
    };
  },

  computed: {
    downUrl: function downUrl() {
      return this.$host + '/tms-server-web/model/terminalNos.xlsx';
    }
  },
  methods: {
    resXiafa: function resXiafa(row) {
      var _this2 = this;

      this.hLoading = true;
      this.$repush(row.pushType, row.opeTime, row.objectId, function (res) {
        _this2.hLoading = false;
        if (res.status == 200) {
          _this2.$message.success(res.message);
          _this2.getList(1, row.objectId);
        } else {
          _this2.$message.error(res.message);
        }
      }, function (error) {
        _this2.hLoading = false;
        _this2.$message.error(_this2.$t('app_rqsError'));
      });
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;

      this.getList(this.currentPage, this.form.item.id);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;

      this.getList(this.currentPage, this.form.item.id);
    },
    getList: function getList(page, id) {
      var _this3 = this;

      this.currentPage = page;

      this.hLoading = true;
      this.$pushRecords(page, this.$gRow, '4', id, function (res) {
        console.log(res.data);
        _this3.hLoading = false;
        if (res.status == 200) {
          _this3.arrdatas = res.data;
          _this3.totalRecords = res.total;
        } else {
          _this3.$message.error(res.message);
        }
      }, function (error) {
        _this3.hLoading = false;
        _this3.$message.error(_this3.$t('app_rqsError'));
      });
    },
    onDvInputChange: function onDvInputChange(vl) {
      this.dNo = vl;
    },
    srcBefore: function srcBefore(file) {
      window[this.$route.path] = 1;
    },
    srcSuccess: function srcSuccess(res, file) {
      window[this.$route.path] = '';

      if (res.status === 200) {
        this.srcList = [{ name: file.name }];
        this.exInfo = res.data;
        this.exInfo.file = file.name;
        this.devices = res.data.terNums;
      } else {
        if (this.exInfo.file) {
          this.srcList = [{ name: this.exInfo.file }];
        } else {
          this.srcList = [];
        }
        this.$message.error(res.message);
      }
    },
    submit: function submit() {
      var _this4 = this;

      this.$refs['firm'].validate(function (valid) {
        if (valid) {
          var tid = '';
          var type = 0;
          if (_this4.form.pushType === 0) {
            if (!_this4.form.mechanism) {
              _this4.$message.error(_this4.$t('app_selectChannel'));
              return;
            } else {
              type = 0;
              tid = _this4.form.mechanism;
            }
          } else if (_this4.form.pushType === 1) {
            if (!_this4.dNo) {
              _this4.$message.error(_this4.$t('app_pleaseInputNo'));
              return;
            } else {
              type = 1;
              tid = _this4.dNo;
            }
          }
          if (_this4.form.pushType === 2 && !_this4.exInfo) {
            _this4.$message.error(_this4.$t('app_plsUpl'));
            return;
          }

          _this4.loading = 1;
          var fn = _this4.exInfo.fileNo ? _this4.exInfo.fileNo : '';
          _this4.$pushFirmware(fn, _this4.form.item.id, _this4.form.pushType, tid, function (res) {
            _this4.loading = 0;
            _this4.$message(res.message);
            if (_this4.form.item.id) {
              _this4.getList(1, _this4.form.item.id);
            }
          }, function () {
            _this4.loading = 0;
            _this4.$message.error(_this4.$t('app_rqsError'));
          });
        } else {
          return false;
        }
      });
    },
    fwChange: function fwChange(vl) {
      if (vl) {
        this.getList(this.currentPage, vl.id);
      } else {
        this.arrdatas = [];
      }
    },
    getFmList: function getFmList() {
      var _this5 = this;

      this.loading = 1;
      var type = this.fType ? this.fType : '';
      var name = this.qName ? this.qName : '';
      var status = '2';
      this.$getFirmwareList(this.$gRow, this.$getWPage('firmwarePage'), this.mechanismId, name, type, status, function (res) {
        console.log('res', res);
        _this5.loading = 0;
        if (res.status === 200) {
          _this5.total = res.total;
          _this5.tableData = res.data;
        } else {
          _this5.$message(res.message);
        }
      }, function () {
        _this5.loading = 0;
        _this5.$message.error(_this5.$t('app_rqsError'));
      });
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    this.getFmList();

    var params = { mechId: window.localStorage['mechanismId'] };
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/terminal/terminalNoList.do', params).then(function (res) {

      _this6.restaurants = res.data.data;
    });
  }
});

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_df_png__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_df_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_df_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;
    return {
      mechanismData: {
        callback: function callback(value) {
          _this.mech = value;

          _this.getList();
        }
      },
      mech: '',
      srchValue: '',
      detail: '',
      dialogVisible: false,
      mapType: {
        '0': this.$t('app_bdmap'),
        '1': 'Google' + this.$t('app_map')
      },
      ctrlType: {
        '0': this.$t('app_off1'),
        '1': this.$t('app_on1')
      },
      bindSt: {
        '0': this.$t('app_waitupdate'),
        '1': this.$t('app_updateSuccess'),
        '2': this.$t('app_updateFail')
      },
      bindSts: [{ vl: '', lb: this.$t('app_allstatus') }, { vl: '0', lb: this.$t('app_waitupdate') }, { vl: '1', lb: this.$t('app_updateSuccess') }, { vl: '2', lb: this.$t('app_updateFail') }],
      bindVl: '',
      config: '',
      captures: [],
      loading: 0,
      tableData: [],
      tags: [],
      page: 1,
      index: 1,
      hiss: [],
      pageTotal: 0
    };
  },

  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue___default.a
  },
  computed: {
    showUploadNew: function showUploadNew() {
      if (this.config) {
        if (this.config.isoperate === 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  methods: {
    editCf: function editCf() {
      this.$setWObj('keyEdit', { type: 1, data: this.config, isSetLc: true });
      this.$router.push({ path: '/keyrule/detail/edit' });
    },
    showBindSt: function showBindSt(row) {
      return this.bindSt[row.useStatus];
    },
    bindOp: function bindOp(row) {
      var _this2 = this;

      this.loading = 1;
      this.$keyAddDevice(row.terminalId, this.config.id, function (res) {
        _this2.loading = 0;
        if (res.status === 200) {
          _this2.dialogVisible = false;
          _this2.getList();
        } else {
          _this2.$message.error(res.message);
        }
      }, function () {
        _this2.loading = 0;
        _this2.$message.error(_this2.$t('app_rqsError'));
      });
    },
    query: function query() {
      this.getList();
    },
    srchDevice: function srchDevice() {
      this.getDevices();
    },
    getDevices: function getDevices() {
      var _this3 = this;

      var vl = this.srchValue ? this.srchValue : '';
      var channel = this.channelId ? this.channelId : '';
      var status = this.status ? this.status : '';
      this.loading = 1;
      this.$keyblist(this.index, this.$gRow, localStorage.mechanismId, vl, function (res) {
        console.log('dv', res);
        _this3.loading = 0;
        if (res.data) {
          _this3.tableData = res.data;
          _this3.total = res.total;
        }
      }, function () {
        _this3.loading = 0;
      });
    },
    addTer: function addTer() {
      this.dialogVisible = true;
    },
    deleteApp: function deleteApp(obj) {
      var _this4 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        console.log(obj);
        _this4.$delFstRecord(obj.id, function (res) {
          if (res.status === 200) {
            _this4.getList();
            _this4.$message.success(res.message);
          } else {
            _this4.$message.error(res.message);
          }
        }, '');
      }, '');
    },
    unbind: function unbind(row) {
      var _this5 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {

        _this5.$keyDelDevice(row.id, function (res) {
          if (res.status === 200) {
            _this5.getList();
            _this5.$message.success(res.message);
          } else {
            _this5.$message.error(res.message);
          }
        }, '');
      }, '');
    },
    editApp: function editApp(row) {
      this.$setWObj('filestEdit', { type: 1, data: row });
      this.$router.push({ path: '/keyrule/detail/edit' });
    },
    getList: function getList() {
      var _this6 = this;

      this.loading = 1;
      var mech = this.mech;
      var name = this.queryKey ? this.queryKey : '';
      var status = this.bindVl;

      this.$keyDeviceBindList(this.page, this.$gRow, mech, name, status, this.config.id, function (res) {

        _this6.loading = 0;
        if (res.status === 200) {
          _this6.pageTotal = res.total;
          _this6.hiss = res.data;
        } else {
          _this6.$message(res.message);
        }
      }, function () {
        _this6.loading = 0;
        _this6.$message.error(_this6.$t('app_rqsError'));
      });
    },
    getStatus: function getStatus(value) {
      if (!value) return '';
      switch (value) {
        case '0':
          return { vl: this.$t('app_prePushVerify'), style: 'color:#8492A6;' };
        case '1':
          return { vl: this.$t('app_preVerify'), style: 'color:#F7BA2A;' };
        case '2':
          return { vl: this.$t('app_verifyPass'), style: 'color:#13CE66;' };
        case '3':
          return { vl: this.$t('app_verifyNotPass'), style: 'color:#FF4949;' };
      }
    },
    getDetail: function getDetail() {
      var _this7 = this;

      this.loading = 1;
      this.$getFstDetail(this.config.data.recordId, function (res) {
        _this7.loading = 0;
        if (res.status === 200) {} else {
          _this7.$message.error(res.message);
        }
      }, function () {
        _this7.loading = 0;
        _this7.$message.error(_this7.$t('app_rqsError'));
      });
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('YYYY-MM-DD hh:mm:ss');
    },
    selectChange: function selectChange(vl) {
      this.getList();
    },
    pageSelect: function pageSelect(index) {
      this.index = index;
      this.getDevices();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getDevices();
    },
    delHis: function delHis(row) {
      var _this8 = this;

      this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
        confirmButtonText: this.$t('app_sure'),
        cancelButtonText: this.$t('app_cancel'),
        type: 'warning'
      }).then(function () {
        _this8.loading = 1;
        _this8.$delLauncherHistory(row.versionid, function (res) {
          _this8.loading = 0;
          if (res.status === 200) {
            _this8.getHistory();
            _this8.$message.success(res.message);
          } else {
            _this8.$message.error(res.message);
          }
        }, function () {
          _this8.loading = 0;
        });
      }).catch(function () {});
    },
    imgFullUrl: function imgFullUrl(path) {
      if (path) {
        return this.$urls.prefix + path;
      } else {
        return '';
      }
    },
    getHistory: function getHistory() {
      var _this9 = this;

      if (this.config.status !== '2') {
        return;
      }
      this.loading = 1;
      this.$launcherHistory(this.config.launcherid, function (res) {
        console.log('his', res);
        _this9.loading = 0;
        if (res.status === 200) {
          _this9.tableData = res.data;
        } else {
          _this9.$message.error(res.message);
        }
      }, function () {
        _this9.loading = 0;
      });
    },
    uploadNew: function uploadNew() {
      var obj = { type: 2, data: this.config };
      var key = 'launcherEdit';
      this.$setWObj(key, obj);
      this.$router.push({ path: '/launch-newver' });
    },
    init: function init() {
      this.config = this.$getWObj().keyruleDetail;

      console.log('cc', this.config);

      this.getList();
      this.getDevices();
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    var phoneCheck = function phoneCheck(rule, value, callback) {
      if (!_this.isLegalMobile(value)) {
        callback(new Error(_this.$t('app_phoneIllegal')));
      } else {
        callback();
      }
    };
    return {
      fatherList: [],
      form: {
        name: '',
        desc: ''
      },
      rules: {
        name: [{ required: true, message: this.$t('app_input'), trigger: 'blur' }],
        desc: [{ required: true, message: this.$t('app_input'), trigger: 'blur' }]
      }
    };
  },

  methods: {
    isLegalMobile: function isLegalMobile(tel) {
      var sMobile = tel;
      var regex = "^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\\d{8}$";
      var re = new RegExp(regex, 'g');
      if (!re.test(sMobile)) {
        return false;
      } else {
        return true;
      }
    },
    newform: function newform() {
      var _this2 = this;

      this.loading = 1;
      this.$addKey(this.form.name, this.form.desc, '', function (res) {
        _this2.loading = 0;
        if (res.status === 200) {
          _this2.$router.go(-1);
        } else {
          _this2.$message.error(res.message);
        }
      }, function () {
        _this2.loading = 0;
      });
    },
    editform: function editform() {
      var _this3 = this;

      var data = this.config.data;

      this.loading = 1;
      this.$editKey(data.id, this.form.name, this.form.desc, '', function (res) {
        _this3.loading = 0;
        if (res.status === 200) {
          if (_this3.config.isSetLc) {
            _this3.config.data.keyName = _this3.form.name;
            _this3.config.data.memo = _this3.form.desc;
            _this3.$setWObj('keyruleDetail', _this3.config.data);
          }
          _this3.$router.go(-1);
        } else {
          _this3.$message.error(res.message);
        }
      }, function () {
        _this3.loading = 0;
      });
    },
    save: function save(name) {
      var _this4 = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          if (_this4.config.type === 0) {
            _this4.newform();
          } else {
            _this4.editform();
          }
        } else {
          return false;
        }
      });
    },
    cancel: function cancel() {
      this.$router.go(-1);
    },
    fillData: function fillData(data) {
      console.log(data);
      this.form.name = data.keyName;
      this.form.desc = data.memo;
    }
  },
  mounted: function mounted() {
    this.config = this.$getWObj().keyEdit;
    if (this.config.type === 1) {
      this.fillData(this.config.data);
    }
  }
});

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default.a
  },
  data: function data() {
    var that = this;
    return {
      mechanismData: {
        callback: function callback(value) {
          that.mech = value;
          that.selectChange(value);
        }
      },
      listKey: 'launch-list',

      dvLoading: 0,
      appId: '',
      stModel: [{ label: this.$t('app_online'), vl: '1' }, { label: this.$t('app_offline'), vl: '2' }, { label: this.$t('app_new'), vl: '0' }],
      channels: [],
      srchValue: '',
      channelId: '',
      cerTipMsg: '',
      status: '',
      dvIndex: 1,
      dialogVisible: 0,
      mechanismId: window.localStorage['mechanismId'],
      selectMid: '',
      tableData: [],
      dvTableData: [],
      appTypes: [],
      appTypeValue: '',
      appStatus: [{ label: this.$t('app_prePushVerify'), value: '0' }, { label: this.$t('app_preVerify'), value: '1' }, { label: this.$t('app_verifyPass'), value: '2' }, { label: this.$t('app_verifyNotPass'), value: '3' }],
      appStatusValue: '',
      total: 0,
      index: 1,
      dvTotal: 0,
      loading: 0,
      appType: '',
      queryKey: ''
    };
  },

  computed: {
    getDvStatus: function getDvStatus(value) {
      switch (value) {
        case '0':
          return this.$t('app_prePushVerify');
        case '1':
          return this.$t('app_preVerify');
        case '2':
          return this.$t('app_verifyPass');
        case '3':
          return this.$t('app_verifyNotPass');
      }
    }
  },
  methods: {
    pushCreateCer: function pushCreateCer() {
      this.$router.push({ path: "/certificate/new" });
    },
    pushUploadCer: function pushUploadCer() {
      this.$router.push({ path: "/certificate/upload" });
    },
    bindOperate: function bindOperate(row) {
      var _this = this;

      this.dvLoading = 1;
      if (this.$appUrlTag === 0) {
        this.$bindApp('0', row.terminalNo, this.appId, function (res) {
          if (res.status === 200) {
            _this.$message.success(_this.$t('app_tipViewTask'));
          } else {
            _this.$message.error(res.message);
          }
          _this.dvLoading = 0;
        }, function () {
          _this.dvLoading = 0;
        });
      } else {
        this.$bindApp1(localStorage.mechanismId, row.terminalNo, this.appId, function (res) {
          if (res.status === 200) {
            _this.$message.success(_this.$t('app_tipViewTask'));
          } else {
            _this.$message.error(res.message);
          }
          _this.dvLoading = 0;
        }, function () {
          _this.dvLoading = 0;
        });
      }
    },
    getChannels: function getChannels() {
      var _this2 = this;

      this.$getChannelList(10000, 1, '', '', '', function (res) {
        if (res.status === 200) {
          _this2.channels = res.data;
        } else {
          _this2.$message.error(res.message);
        }
      }, function () {
        _this2.$message.error(_this2.$t('app_rqsError'));
      });
    },
    getStatus: function getStatus(value) {
      if (!value) return '';
      switch (value) {
        case '0':
          return { vl: this.$t('app_prePushVerify'), style: 'color:#8492A6;' };
        case '1':
          return { vl: this.$t('app_preVerify'), style: 'color:#F7BA2A;' };
        case '2':
          return { vl: this.$t('app_verifyPass'), style: 'color:#13CE66;' };
        case '3':
          return { vl: this.$t('app_verifyNotPass'), style: 'color:#FF4949;' };
      }
    },
    srchDevice: function srchDevice() {
      this.getDevices();
    },
    selectDvChange: function selectDvChange(vl) {
      this.getDevices();
    },
    pageDvSized: function pageDvSized(val) {
      this.$gRow = val;
      this.getDevices();
    },
    getDevices: function getDevices() {
      var _this3 = this;

      var vl = this.srchValue ? this.srchValue : '';
      var channel = this.channelId ? this.channelId : '';
      var status = this.status ? this.status : '';
      var appId = this.appId ? this.appId : '';
      this.dvLoading = 1;
      if (this.$appUrlTag === 0) {
        this.$getDevices(this.dvIndex, this.$gRow, channel, vl, status, '', appId, function (res) {
          _this3.dvLoading = 0;
          if (res.data) {
            _this3.dvTableData = res.data;
            _this3.dvTotal = res.total;
          }
        }, function () {
          _this3.dvLoading = 0;
        });
      } else {

        this.$getDevices1(this.dvIndex, this.$gRow, localStorage.mechanismId, vl, status, '', appId, function (res) {
          console.log('dv', res);
          _this3.dvLoading = 0;
          if (res.data) {
            _this3.dvTableData = res.data;
            _this3.dvTotal = res.total;
          }
        }, function () {
          _this3.dvLoading = 0;
        });
      }
    },
    editApp: function editApp(row) {
      this.$setWObj('keyEdit', { type: 1, data: row });
      this.$router.push({ path: '/keyrule/edit' });
    },
    pushApp: function pushApp(row) {

      this.$setWObj('pushList', { type: '13', data: row });
      this.$router.push({ path: '/stfile/push' });
    },
    query: function query() {
      this.getList();
    },
    selectChange: function selectChange(vl) {
      this.selectMid = vl;
      this.getList();
    },
    reset: function reset() {
      this.queryKey = '';
      this.appType = '';
      this.getList();
    },
    pageSelect: function pageSelect(index) {
      this.index = index;
      this.getList();
    },
    pageDvSelect: function pageDvSelect(index) {
      this.dvIndex = index;
      this.getDevices();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getList();
    },
    deleteApp: function deleteApp(obj) {
      var _this4 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {

        _this4.$delKey(obj.id, function (res) {
          if (res.status === 200) {
            _this4.getList();
            _this4.$message.success(res.message);
          } else {
            _this4.$message.error(res.message);
          }
        }, '');
      }, '');
    },
    submitApp: function submitApp(obj) {
      var _this5 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_tipVerify'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this5.loading = 1;
        _this5.$verifyFst(obj.recordId, '', '1', function (res) {
          _this5.loading = 0;
          if (res.status === 200) {
            _this5.getList();
            _this5.$message.success(res.message);
          } else {
            _this5.$message.error(res.message);
          }
        }, function () {
          _this5.loading = 0;
        });
      }, '');
    },
    cellClick: function cellClick(row, ev, col) {
      if (col.label && col.label === this.$t('app_operate')) {
        return;
      }

      this.$setWObj('keyruleDetail', row);
      this.$router.push({ path: '/keyrule/detail' });
    },
    jumpToUpload: function jumpToUpload() {

      this.$setWObj('keyEdit', { type: 0 });
      this.$router.push({ path: '/keyrule/add' });
    },
    getList: function getList() {
      var _this6 = this;

      this.loading = 1;

      var name = this.queryKey ? this.queryKey : '';

      this.$getKeyList(this.index, this.$gRow, name, function (res) {

        _this6.loading = 0;
        if (res.status === 200) {
          _this6.total = res.total;
          _this6.tableData = res.data;
        } else {
          _this6.$message(res.message);
        }
      }, function () {
        _this6.loading = 0;
        _this6.$message.error(_this6.$t('app_rqsError'));
      });
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD HH:mm:ss');
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    }
  },
  mounted: function mounted() {
    this.getList();
  },
  destroyed: function destroyed() {}
});

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_df_png__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_df_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_df_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_global_tyc_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_global_tyc_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_global_tyc_vue__);


var _methods;





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var that = this;
    return {
      tqobj: '',
      dLoading: false,
      srchValue: '',
      reason: '',
      config: '',
      captures: [],
      loading: 0,
      dialogVisible: false,
      notPassDialog: false,
      index: 1,
      tableData: [],
      total: 0,
      status: '',
      mech: '',
      stModel: '',
      mechanismData: {
        callback: function callback(value) {
          that.mech = value;
          that.selectChange(value);
        }
      }
    };
  },

  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default.a, tyc: __WEBPACK_IMPORTED_MODULE_4__components_global_tyc_vue___default.a
  },
  computed: {
    showUploadNew: function showUploadNew() {
      console.log('ccc', this.config.data);
      if (this.config.data) {
        if (this.config.data.isoperation === 0 && this.config.data.appStatus === '2') {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  methods: (_methods = {
    bindOperate: function bindOperate(row) {
      var _this = this;

      this.dLoading = 1;
      this.$pushLauncher(this.config.launcherid, row.terminalNo, localStorage.mechanismId, function (res) {
        _this.dLoading = 0;
        if (res.status === 200) {
          _this.$message.success(_this.$t('app_tipViewTask'));
          _this.notPassDialog = false;
        } else {
          _this.$message.error(res.message);
        }
      }, function (error) {
        _this.dLoading = 0;
        _this.$message.error(_this.$t('app_rqsError'));
      });
    },
    verify: function verify(vl) {
      var _this2 = this;

      if (vl === '2') {
        this.$confirm(this.$t('app_srpassvf') + '?', this.$t('app_tip'), {
          confirmButtonText: this.$t('app_sure'),
          cancelButtonText: this.$t('app_cancel'),
          type: 'warning'
        }).then(function () {
          _this2.verifyRqs(vl);
        }).catch(function () {});
      } else if (vl === '3') {
        this.notPassDialog = true;
      }
    },
    verifyRqs: function verifyRqs(vl) {
      var _this3 = this;

      this.loading = 1;
      this.$verifyLauncher(this.config.launcherid, this.reason, vl, this.config.versioncode, function (res) {
        _this3.loading = 0;
        if (res.status === 200) {
          _this3.$message.success(res.message);
          _this3.$router.go(-1);
        } else {
          _this3.$message.error(res.message);
        }
      }, function () {
        _this3.$message.error(_this3.$t('app_rqsError'));
        _this3.loading = 0;
      });
    },
    srchDevice: function srchDevice() {
      this.getDevices();
    },
    selectChange: function selectChange(vl) {
      this.getDevices();
    },
    pageSelect: function pageSelect(index) {
      this.index = index;
      this.getDevices();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getDevices();
    },
    getDevices: function getDevices() {
      var _this4 = this;

      var vl = this.srchValue ? this.srchValue : '';
      var channel = this.channelId ? this.channelId : '';
      var status = this.status ? this.status : '';
      var mc = this.mech;
      this.loading = 1;
      this.$pushLauncherList(this.index, this.$gRow, mc, vl, status, '', this.config.launcherid, function (res) {

        _this4.loading = 0;
        if (res.data) {
          _this4.tableData = res.data;
          _this4.total = res.total;
        }
      }, function () {
        _this4.loading = 0;
      });
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD hh:mm:ss');
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'selectChange', function selectChange(vl) {
    this.getDevices();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'pageSelect', function pageSelect(index) {
    this.index = index;
    this.getDevices();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'pageSized', function pageSized(val) {
    this.$gRow = val;
    this.getDevices();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'deleteAppHis', function deleteAppHis(row) {
    var _this5 = this;

    if (row.applicationid) {
      this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
        confirmButtonText: this.$t('app_sure'),
        cancelButtonText: this.$t('app_cancel'),
        type: 'warning'
      }).then(function () {
        _this5.loading = 1;
        if (_this5.$appUrlTag === 0) {
          _this5.$deleteApp(row.applicationid, function (res) {
            _this5.loading = 0;
            if (res.status === 200) {
              _this5.getAppHistory();
            } else {
              _this5.$message.error(res.message);
            }
          }, function () {
            _this5.loading = 0;
          });
        } else {
          _this5.$deleteAppHis(row.applicationid, function (res) {
            _this5.loading = 0;
            if (res.status === 200) {
              _this5.getAppHistory();
            } else {
              _this5.$message.error(res.message);
            }
          }, function () {
            _this5.loading = 0;
          });
        }
      }).catch(function () {});
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'imgFullUrl', function imgFullUrl(path) {
    if (path) {
      return this.$urls.prefix + path;
    } else {
      return '';
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'getAppHistory', function getAppHistory() {
    var _this6 = this;

    if (!this.config.data.appName) {
      return;
    }

    this.loading = 1;
    if (this.$appUrlTag === 0) {
      this.$getAppHistory(this.config.data.appName, this.config.data.packagename, function (res) {
        _this6.loading = 0;
        if (res.status === 200) {
          _this6.tableData = res.data;
        } else {
          _this6.$message.error(res.message);
        }
      }, function () {
        _this6.loading = 0;
      });
    } else {

      this.$getAppHistory1(localStorage.mechanismId, this.config.data.packagename, function (res) {

        console.log('his', res);
        _this6.loading = 0;
        if (res.status === 200) {
          _this6.tableData = res.data;
        } else {
          _this6.$message.error(res.message);
        }
      }, function () {
        _this6.loading = 0;
      });
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'uploadNew', function uploadNew() {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'init', function init() {
    this.config = this.$getWObj().launcherVerify;

    this.setCapturesArr(this.config.launcherimg);

    this.getDevices();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'setCapturesArr', function setCapturesArr(strs) {
    if (strs) {
      var arr = strs.split(',');
      this.captures = arr;
    }
  }), _methods),
  mounted: function mounted() {
    var _this7 = this;

    this.tqobj = {
      keys: ['terminalTypes'],
      callback: function callback(data) {
        _this7.stModel = data[0];
      }
    };
    this.init();
  }
});

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default.a
  },
  data: function data() {
    var that = this;
    return {
      orderName: '',
      orderType: '',
      mechanismData: {
        callback: function callback(value) {
          that.mech = value;
          that.selectChange(value);
        }
      },
      listKey: 'launch-list',
      cerDialogVisible: false,
      cerTipDialogVisible: false,
      dvLoading: 0,
      appId: '',
      stModel: [{ label: this.$t('app_online'), vl: '1' }, { label: this.$t('app_offline'), vl: '2' }, { label: this.$t('app_new'), vl: '0' }],
      channels: [],
      srchValue: '',
      channelId: '',
      cerTipMsg: '',
      status: '',
      dvIndex: 1,
      dialogVisible: 0,
      mechanismId: window.localStorage['mechanismId'],
      selectMid: '',
      tableData: [],
      dvTableData: [],
      appTypes: [],
      appTypeValue: '',
      appStatus: [{ label: this.$t('app_prePushVerify'), value: '0' }, { label: this.$t('app_preVerify'), value: '1' }, { label: this.$t('app_verifyPass'), value: '2' }, { label: this.$t('app_verifyNotPass'), value: '3' }],
      appStatusValue: '',
      total: 0,
      dvTotal: 0,
      loading: 0,
      appType: '',
      queryKey: ''
    };
  },

  computed: {
    index: function index() {
      var vl = this.$getWPage(this.listKey);
      return vl ? vl : 1;
    },
    getDvStatus: function getDvStatus(value) {
      switch (value) {
        case '0':
          return this.$t('app_prePushVerify');
        case '1':
          return this.$t('app_preVerify');
        case '2':
          return this.$t('app_verifyPass');
        case '3':
          return this.$t('app_verifyNotPass');
      }
    }
  },
  methods: {
    sortChange: function sortChange(vl) {
      switch (vl.prop) {
        case 'launchername':
          this.orderName = '1';
          break;
        case 'uploadtime':
          this.orderName = '2';
          break;
      }
      this.orderType = vl.order == 'descending' ? 'desc' : 'asc';
      this.getList();
    },
    pushCreateCer: function pushCreateCer() {
      this.$router.push({ path: "/certificate/new" });
    },
    pushUploadCer: function pushUploadCer() {
      this.$router.push({ path: "/certificate/upload" });
    },
    bindOperate: function bindOperate(row) {
      var _this = this;

      this.dvLoading = 1;
      if (this.$appUrlTag === 0) {
        this.$bindApp('0', row.terminalNo, this.appId, function (res) {
          if (res.status === 200) {
            _this.$message.success(_this.$t('app_tipViewTask'));
          } else {
            _this.$message.error(res.message);
          }
          _this.dvLoading = 0;
        }, function () {
          _this.dvLoading = 0;
        });
      } else {
        this.$bindApp1(localStorage.mechanismId, row.terminalNo, this.appId, function (res) {
          if (res.status === 200) {
            _this.$message.success(_this.$t('app_tipViewTask'));
          } else {
            _this.$message.error(res.message);
          }
          _this.dvLoading = 0;
        }, function () {});
      }
    },
    getChannels: function getChannels() {
      var _this2 = this;

      this.$getChannelList(10000, 1, '', '', '', function (res) {
        if (res.status === 200) {
          _this2.channels = res.data;
        } else {
          _this2.$message.error(res.message);
        }
      }, function () {
        _this2.$message.error(_this2.$t('app_rqsError'));
      });
    },
    getStatus: function getStatus(value) {
      if (!value) return '';
      switch (value) {
        case '0':
          return { vl: this.$t('app_prePushVerify'), style: 'color:#8492A6;' };
        case '1':
          return { vl: this.$t('app_preVerify'), style: 'color:#F7BA2A;' };
        case '2':
          return { vl: this.$t('app_verifyPass'), style: 'color:#13CE66;' };
        case '3':
          return { vl: this.$t('app_verifyNotPass'), style: 'color:#FF4949;' };
      }
    },
    srchDevice: function srchDevice() {
      this.getDevices();
    },
    selectDvChange: function selectDvChange(vl) {
      this.getDevices();
    },
    pageDvSized: function pageDvSized(val) {
      this.$gRow = val;
      this.getDevices();
    },
    getDevices: function getDevices() {
      var _this3 = this;

      var vl = this.srchValue ? this.srchValue : '';
      var channel = this.channelId ? this.channelId : '';
      var status = this.status ? this.status : '';
      var appId = this.appId ? this.appId : '';
      this.dvLoading = 1;
      if (this.$appUrlTag === 0) {
        this.$getDevices(this.dvIndex, this.$gRow, channel, vl, status, '', appId, function (res) {
          _this3.dvLoading = 0;
          if (res.data) {
            _this3.dvTableData = res.data;
            _this3.dvTotal = res.total;
          }
        }, function () {
          _this3.dvLoading = 0;
        });
      } else {

        this.$getDevices1(this.dvIndex, this.$gRow, localStorage.mechanismId, vl, status, '', appId, function (res) {
          console.log('dv', res);
          _this3.dvLoading = 0;
          if (res.data) {
            _this3.dvTableData = res.data;
            _this3.dvTotal = res.total;
          }
        }, function () {
          _this3.dvLoading = 0;
        });
      }
    },
    editApp: function editApp(row) {
      this.$setWObj('launcherEdit', { type: 1, data: row });
      this.$router.push({ path: '/launch-edit' });
    },
    pushApp: function pushApp(row) {
      this.$router.push({ path: '/launch-push' });
    },
    query: function query() {
      this.getList();
    },
    selectChange: function selectChange(vl) {
      this.selectMid = vl;
      this.getList();
    },
    reset: function reset() {
      this.queryKey = '';
      this.appType = '';
      this.getList();
    },
    pageSelect: function pageSelect(index) {
      this.$setWPage(this.listKey, index);
      this.getList();
    },
    pageDvSelect: function pageDvSelect(index) {
      this.dvIndex = index;
      this.getDevices();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getList();
    },
    deleteApp: function deleteApp(obj) {
      var _this4 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        console.log(obj);
        _this4.$delLauncher(obj.launcherid, obj.status, function (res) {
          if (res.status === 200) {
            _this4.getList();
            _this4.$message.success(res.message);
          } else {
            _this4.$message.error(res.message);
          }
        }, '');
      }, '');
    },
    submitApp: function submitApp(obj) {
      var _this5 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_tipVerify'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this5.loading = 1;
        _this5.$submitLauncher(obj.launcherid, function (res) {
          _this5.loading = 0;
          if (res.status === 200) {
            _this5.getList();
            _this5.$message.success(res.message);
          } else {
            _this5.$message.error(res.message);
          }
        }, function () {
          _this5.loading = 0;
        });
      }, '');
    },
    cellClick: function cellClick(row, ev, col) {

      this.$setWObj('launcherVerify', row);
      this.$router.push({ path: '/launch-verify' });
    },
    jumpToUpload: function jumpToUpload() {

      this.$setWObj('launcherEdit', { type: 0 });
      this.$router.push({ path: '/addlaunch' });
    },
    getList: function getList() {
      var _this6 = this;

      this.loading = 1;
      var dsid = this.selectMid ? this.selectMid : '';
      var name = this.queryKey ? this.queryKey : '';
      this.$launchVerifyList(this.index, this.$gRow, localStorage.mechanismId, this.orderName, this.orderType, function (res) {
        _this6.loading = 0;
        if (res.status === 200) {
          _this6.total = res.total;
          _this6.tableData = res.data;
        } else {
          _this6.$message(res.message);
        }
      }, function () {
        _this6.loading = 0;
        _this6.$message.error(_this6.$t('app_rqsError'));
      });
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD HH:mm:ss');
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    }
  },
  mounted: function mounted() {
    this.getList();
  },
  destroyed: function destroyed() {}
});

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_df_png__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_df_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_df_png__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      config: '',
      captures: [],
      loading: 0,
      tableData: []
    };
  },

  computed: {
    avtStyle: function avtStyle() {
      var url = this.config.data.appBigIcon ? this.imgFullUrl(this.config.data.appBigIcon) : __webpack_require__(6);

      return 'background-size: cover;background-position: center center;width:100%;height:100%;background-image: url(' + url + ')';
    },
    showUploadNew: function showUploadNew() {
      if (this.config) {
        if (this.config.isoperate === 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  methods: {
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('YYYY-MM-DD hh:mm:ss');
    },
    selectChange: function selectChange(vl) {
      this.getDevices();
    },
    pageSelect: function pageSelect(index) {
      this.index = index;
      this.getDevices();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getDevices();
    },
    delHis: function delHis(row) {
      var _this = this;

      this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
        confirmButtonText: this.$t('app_sure'),
        cancelButtonText: this.$t('app_cancel'),
        type: 'warning'
      }).then(function () {
        _this.loading = 1;
        _this.$delLauncherHistory(row.versionid, function (res) {
          _this.loading = 0;
          if (res.status === 200) {
            _this.getHistory();
            _this.$message.success(res.message);
          } else {
            _this.$message.error(res.message);
          }
        }, function () {
          _this.loading = 0;
        });
      }).catch(function () {});
    },
    imgFullUrl: function imgFullUrl(path) {
      if (path) {
        return this.$urls.prefix + path;
      } else {
        return '';
      }
    },
    getHistory: function getHistory() {
      var _this2 = this;

      if (this.config.status !== '2') {
        return;
      }
      this.loading = 1;
      this.$launcherHistory(this.config.launcherid, function (res) {
        console.log('his', res);
        _this2.loading = 0;
        if (res.status === 200) {
          _this2.tableData = res.data;
        } else {
          _this2.$message.error(res.message);
        }
      }, function () {
        _this2.loading = 0;
      });
    },
    uploadNew: function uploadNew() {
      var obj = { type: 2, data: this.config };
      var key = 'launcherEdit';
      this.$setWObj(key, obj);
      this.$router.push({ path: '/launch-newver' });
    },
    init: function init() {
      this.config = this.$getWObj().launcherDetail;
      this.setCapturesArr(this.config.launcherimg);
      this.getHistory();
    },
    setCapturesArr: function setCapturesArr(strs) {
      if (strs) {
        var arr = strs.split(',');
        this.captures = arr;
      }
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);



/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		var _this = this;

		var tagCheck = function tagCheck(rule, value, callback) {
			if (!value) {
				callback(new Error(_this.$t('noVerTag')));
			} else {
				callback();
			}
		};
		return {
			ulinfo: {
				tip: this.$t('app_ulNormalSt'),
				index: 0,
				icons: ['el-icon-upload', 'el-icon-circle-check', 'el-icon-close']
			},
			mechanismId: window.localStorage['mechanismId'],
			status: '',
			tipColor: {
				color: '#13CE66'
			},
			stModel: [{
				label: this.$t('app_online'),
				vl: '1'
			}, {
				label: this.$t('app_offline'),
				vl: '2'
			}, {
				label: this.$t('app_new'),
				vl: '0'
			}],
			channels: [],
			updateType: false,
			channelId: '',
			rules: {
				launcherName: [{
					required: true,
					message: this.$t('app_inputName'),
					trigger: 'blur'
				}],
				version: [{
					required: true,
					message: this.$t('app_inputVer'),
					trigger: 'blur'
				}],
				verTag: [{
					required: true,
					message: this.$t('app_inputVerTag'),
					trigger: 'blur',
					validator: tagCheck
				}],
				packageName: [{
					required: true,
					message: this.$t('app_inputPkg'),
					trigger: 'blur'
				}],
				launcherDesc: [{
					required: true,
					message: this.$t('app_inputIntrol'),
					trigger: 'blur'
				}],
				appTypeValue: [{
					required: true,
					message: this.$t('app_selectType'),
					trigger: 'blur'
				}],
				appUrl: [{
					required: true,
					message: this.$t('app_plsUpl'),
					trigger: 'blur'
				}]
			},
			form: {
				launcherName: '',
				version: '',
				verTag: '',
				md5: '',
				packageName: '',
				launcherDesc: '',
				installType: 0,
				appTypeValue: '',
				appUrl: '',
				smImageUrlValue: '',
				bgImageUrlValue: '',
				caps: ''
			},
			showPic: {
				value: 0,
				data: ''
			},
			srchValue: '',
			installTypes: [{
				label: this.$t('app_autoInstall'),
				value: 0
			}],
			fileSize: 0,
			tableData: [],
			checkDesc: '',
			radio: '1',
			smImageUrl: '',
			bgImageUrl: '',
			dialogVisible: false,
			appTypes: [],
			loading: 0,
			loading1: 0,
			loadingBig: 0,
			loadingSm: 0,
			config: {},
			cp0: '',
			cp1: '',
			cp2: '',
			cp3: '',
			cp4: '',
			captures: [],
			fileList: [],
			isUpload: 0,
			index: 1,
			total: 0
		};
	},

	computed: {
		bIcon: function bIcon() {
			if (this.config.data) {
				return this.config.data.appBigIcon ? imgFullUrl(this.config.data.appBigIcon) : __webpack_require__(6);
			} else {
				return '';
			}
		},
		sIcon: function sIcon() {
			if (this.config.data) {
				return this.config.data.appSmallIcon ? imgFullUrl(this.config.data.appSmallIcon) : __webpack_require__(6);
			} else {
				return '';
			}
		},
		showUploadNew: function showUploadNew() {
			if (this.config.data) {
				if (this.config.data.isUpload === '0') {
					return true;
				} else {
					return false;
				}
			} else {
				return false;
			}
		},
		isShowUpdateDesc: function isShowUpdateDesc() {
			if (this.config.data) {
				if (this.config.data.updatedesc) {
					return true;
				} else {
					return false;
				}
			} else {
				return false;
			}
		},
		updateDescContent: function updateDescContent() {
			var vl = this.config.data ? this.config.data.updatedesc : '';

			return vl;
		},
		prdes: function prdes() {
			return this.config.data ? this.config.data.launcherDesc : '';
		},
		uData: function uData() {
			return {
				token: 1234
			};
		},
		imgUploadUrl: function imgUploadUrl() {
			var vl = "https://tmsadmin.szzt.com.cn/file-management/tms-server-web/appFile/fileupload.do";
			return vl;
		},
		fileUploadUrl: function fileUploadUrl() {
			var vl = "https://tmsadmin.szzt.com.cn/file-management/tms-server-web/appFile/fileupload.do" + '?distributorId=' + localStorage.mechanismId + '&language=' + localStorage.system_lang;
			return vl;
		},
		reason: function reason() {
			if (!this.config.data) {
				return '';
			}
			var rs = this.config.data.refuseReason;
			return rs ? this.$t('app_banReason') + ':' + rs : this.$t('app_banReason') + ':' + this.$t('app_noInput');
		},
		isShowReason: function isShowReason() {
			if (this.config) {
				if (this.config.data) {
					if (this.config.data.appStatus === '3') {
						return 1;
					} else {
						return 0;
					}
				} else {
					return 0;
				}
			} else {
				return 0;
			}
		}
	},
	methods: {
		lcNew: function lcNew() {
			var _this2 = this;

			this.form.caps = this.makeCapture();
			this.$refs['form'].validate(function (valid) {
				if (valid) {
					_this2.loading = 1;
					var form = _this2.form;
					_this2.$updateLauncher(_this2.form.md5, form.launcherName, form.launcherDesc, form.caps, form.appUrl, form.packageName, form.version, form.verTag, _this2.fileSize, _this2.config.data.launcherid, localStorage.mechanismId, function (res) {
						_this2.loading = 0;
						if (res.status === 200) {
							_this2.$message.success(res.message);
							_this2.$router.go(-2);
						} else {
							_this2.$message.error(res.message);
						}
					}, function () {
						_this2.loading = 0;
						_this2.$message(_this2.$t('app_rqsError'));
					});
				} else {
					return false;
				}
			});
		},
		selectChange: function selectChange(vl) {
			this.getDevices();
		},
		getChannels: function getChannels() {
			var _this3 = this;

			this.$getChannelList(10000, 1, '', '', '', function (res) {
				if (res.status === 200) {
					_this3.channels = res.data;
				} else {
					_this3.$message.error(res.message);
				}
			}, function () {
				_this3.$message.error(_this3.$t('app_rqsError'));
			});
		},
		getStatus: function getStatus(value) {
			switch (value) {
				case '0':
					return this.$t('app_prePushVerify');
				case '1':
					return this.$t('app_preVerify');
				case '2':
					return this.$t('app_verifyPass');
				case '3':
					return this.$t('app_verifyNotPass');
			}
		},
		pageSelect: function pageSelect(index) {
			this.index = index;
			this.getDevices();
		},
		pageSized: function pageSized(val) {
			this.$gRow = val;
			this.getDevices();
		},
		hBlur: function hBlur(name) {
			this.form.caps = this.makeCapture();
			this.$refs[name].validate(function (valid) {
				if (valid) {} else {
					return false;
				}
			});
		},
		showBigPic: function showBigPic() {
			this.showPic = {
				value: 1,
				data: this.imgFullUrl(this.config.data.appBigIcon)
			};
		},
		showScreenShot: function showScreenShot(path) {
			this.showPic = {
				value: 1,
				data: this.imgFullUrl(path)
			};
		},
		pushInstall: function pushInstall() {
			this.dialogVisible = true;
		},
		makeAppPath: function makeAppPath(url) {
			var path = url;
			if (!path) {
				if (this.config.data) {
					path = this.config.data.appUrl;
					if (!path) {
						return '';
					}
				} else {
					return '';
				}
			}
			var arr = path.split('/');
			return arr[arr.length - 1];
		},
		deleteAppHis: function deleteAppHis(row) {
			var _this4 = this;

			if (row.applicationid) {
				this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
					confirmButtonText: this.$t('app_sure'),
					cancelButtonText: this.$t('app_cancel'),
					type: 'warning'
				}).then(function () {
					_this4.loading = 1;
					if (_this4.$appUrlTag === 0) {
						_this4.$deleteApp(row.applicationid, function (res) {
							_this4.loading = 0;
							if (res.status === 200) {
								_this4.getAppHistory();
							} else {
								_this4.$message.error(res.message);
							}
						}, function () {
							_this4.loading = 0;
						});
					} else {
						_this4.$deleteApp1(row.applicationid, function (res) {
							_this4.loading = 0;
							if (res.status === 200) {
								_this4.getAppHistory();
							} else {
								_this4.$message.error(res.message);
							}
						}, function () {
							_this4.loading = 0;
						});
					}
				}).catch(function () {});
			}
		},
		dateFormat: function dateFormat(row, column) {
			var date = row[column.property];
			if (date === undefined) {
				return '';
			}
			return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('YYYY-MM-DD hh:mm:ss');
		},
		deleteCapture0: function deleteCapture0() {
			this.cp0 = '';
			this.cp0Value = '';
		},
		deleteCapture1: function deleteCapture1() {
			this.cp1 = '';
			this.cp1Value = '';
		},
		deleteCapture2: function deleteCapture2() {
			this.cp2 = '';
			this.cp2Value = '';
		},
		deleteCapture3: function deleteCapture3() {
			this.cp3 = '';
			this.cp3Value = '';
		},
		deleteCapture4: function deleteCapture4() {
			this.cp4 = '';
			this.cp4Value = '';
		},
		imgFullUrl: function imgFullUrl(path) {
			if (path) {
				return this.$urls.prefix + path;
			} else {
				return '';
			}
		},
		close: function close() {
			this.$router.go(-1);
		},
		isShowCommon: function isShowCommon(isShow) {
			if (isShow && (this.config.type === 2 || this.config.type === 3)) {
				return 1;
			} else if (!isShow && this.config.type !== 2 && this.config.type !== 3) {
				return 1;
			} else {
				return 0;
			}
		},
		tipBf: function tipBf() {
			this.loading1 = 1;
			return 1;
		},
		handleSmAvatarSuccess: function handleSmAvatarSuccess(res, file) {
			this.loadingSm = 0;
			if (res.status !== 200) {
				this.$message.error(res.message);
			} else {
				this.form.smImageUrlValue = res.data;
				this.smImageUrl = URL.createObjectURL(file.raw);
				this.hBlur('form');
			}
		},
		handleBgAvatarSuccess: function handleBgAvatarSuccess(res, file) {
			this.loadingBig = 0;
			if (res.status !== 200) {
				this.$message.error(res.message);
			} else {
				this.form.bgImageUrlValue = res.data;
				this.bgImageUrl = URL.createObjectURL(file.raw);
				this.hBlur('form');
			}
		},
		handleAvatarSuccessCp0: function handleAvatarSuccessCp0(res, file) {
			this.loading1 = 0;

			if (res.status !== 200) {
				this.$message.error(res.message);
			} else {
				this.cp0Value = res.data;
				this.cp0 = URL.createObjectURL(file.raw);
				this.hBlur('form');
			}
		},
		handleAvatarSuccessCp1: function handleAvatarSuccessCp1(res, file) {
			this.loading1 = 0;
			if (res.status !== 200) {
				this.$message.error(res.message);
			} else {
				this.cp1Value = res.data;
				this.cp1 = URL.createObjectURL(file.raw);
				this.hBlur('form');
			}
		},
		handleAvatarSuccessCp2: function handleAvatarSuccessCp2(res, file) {
			this.loading1 = 0;
			if (res.status !== 200) {
				this.$message.error(res.message);
			} else {
				this.cp2Value = res.data;
				this.cp2 = URL.createObjectURL(file.raw);
				this.hBlur('form');
			}
		},
		handleAvatarSuccessCp3: function handleAvatarSuccessCp3(res, file) {
			this.loading1 = 0;
			if (res.status !== 200) {
				this.$message.error(res.message);
			} else {
				this.cp3Value = res.data;
				this.cp3 = URL.createObjectURL(file.raw);
				this.hBlur('form');
			}
		},
		handleAvatarSuccessCp4: function handleAvatarSuccessCp4(res, file) {
			this.loading1 = 0;
			if (res.status !== 200) {
				this.$message.error(res.message);
			} else {
				this.cp4Value = res.data;
				this.cp4 = URL.createObjectURL(file.raw);
				this.hBlur('form');
			}
		},
		beforeSmAvatarUpload: function beforeSmAvatarUpload(file) {
			var size = file.size / 1024;
			if (size > 100) {
				this.$message.error(this.$t('app_fileOver') + '100k');
				return false;
			}
			this.loadingSm = 1;
			return true;
		},
		beforeBgAvatarUpload: function beforeBgAvatarUpload(file) {
			var size = file.size / 1024;
			if (size > 200) {
				this.$message.error(this.$t('app_fileOver') + '200k');
				return false;
			}
			this.loadingBig = 1;
			return true;
		},
		handleRemove: function handleRemove(file, fileList) {},
		makeCapture: function makeCapture() {
			var str = '';
			if (this.cp0Value) {
				str += this.cp0Value + ',';
			}
			if (this.cp1Value) {
				str += this.cp1Value + ',';
			}
			if (this.cp2Value) {
				str += this.cp2Value + ',';
			}
			if (this.cp3Value) {
				str += this.cp3Value + ',';
			}
			if (this.cp4Value) {
				str += this.cp4Value + ',';
			}
			return str.substring(0, str.length - 1);
		},
		uploadApp: function uploadApp(formName) {
			var _this5 = this;

			if (window[this.$route.path]) {
				this.$message.error(this.$t('app_appLoding'));
				return;
			}
			this.form.caps = this.makeCapture();
			this.$refs[formName].validate(function (valid) {
				if (valid) {

					_this5.loading = 1;
					if (_this5.config.type === 1) {
						_this5.$editLauncher(_this5.form.md5, _this5.form.launcherName, _this5.form.launcherDesc, _this5.form.caps, _this5.form.appUrl, _this5.form.packageName, _this5.form.version, _this5.form.verTag, _this5.fileSize, _this5.config.data.launcherid, function (res) {
							_this5.loading = 0;
							if (res.status === 200) {
								_this5.$message.success(res.message);
								_this5.$router.go(-1);
							} else {
								_this5.$message(res.message);
							}
						}, function () {
							_this5.loading = 0;
							_this5.$message(_this5.$t('app_rqsError'));
						});
					} else {
						_this5.$addLauncher(_this5.form.md5, _this5.form.launcherName, _this5.form.launcherDesc, _this5.form.caps, _this5.form.appUrl, _this5.form.packageName, _this5.form.version, _this5.form.verTag, _this5.fileSize, _this5.mechanismId, function (res) {
							_this5.loading = 0;
							if (res.status === 200) {
								_this5.$message.success(res.message);
								_this5.$router.go(-1);
							} else {
								_this5.$message.error(res.message);
							}
						}, function () {
							_this5.loading = 0;
							_this5.$message(_this5.$t('app_rqsError'));
						});
					}
				} else {
					return false;
				}
			});
		},
		fileUploadSuccess: function fileUploadSuccess(res, file) {
			window[this.$route.path] = '';
			console.log('file', res);
			this.ulinfo.tip = res.message;
			if (res.status === 200) {
				this.form.appUrl = res.fileUrl;
				this.form.verTag = res.versionCode;
				this.form.md5 = res.md5;
				this.form.version = res.appVersion;
				this.form.packageName = res.packageName;
				this.fileSize = res.appSize;
				this.fileList = [{
					name: file.name
				}];
				this.hBlur('form');
				this.ulinfo.index = 1;
				this.tipColor = {
					color: '#13CE66'
				};
			} else {
				this.ulinfo.index = 2;
				if (this.config.type !== 1) {
					this.fileList = [];
				} else {
					this.fileList = [{
						name: this.makeAppPath(this.config.data.appUrl)
					}];
				}
				this.$message.error(res.message);
				this.tipColor = {
					color: '#FF4949'
				};
			}
		},
		fileBeforeUpload: function fileBeforeUpload(file) {

			if (file) {
				window[this.$route.path] = 1;
				var ar = file.name.split('.');
				var type = ar[ar.length - 1];
				if (type === 'apk') {
					window[this.$route.path] = 1;
					return true;
				} else {
					this.$message.error(this.$t('app_onlyApk'));
					return false;
				}
			} else {
				this.$message.error(this.$t('app_onlyApk'));
				return false;
			}
		},
		setCapturesIn: function setCapturesIn(strs) {
			var _this6 = this;

			if (strs) {
				var arr = strs.split(',');

				arr.forEach(function (value, index, array) {
					switch (index) {
						case 0:
							_this6.cp0 = _this6.imgFullUrl(value);
							_this6.cp0Value = value;
							break;
						case 1:
							_this6.cp1 = _this6.imgFullUrl(value);
							_this6.cp1Value = value;
							break;
						case 2:
							_this6.cp2 = _this6.imgFullUrl(value);
							_this6.cp2Value = value;
							break;
						case 3:
							_this6.cp3 = _this6.imgFullUrl(value);
							_this6.cp3Value = value;
							break;
						case 4:
							_this6.cp4 = _this6.imgFullUrl(value);
							_this6.cp4Value = value;
							break;
					}
				});
			}
		},
		setCapturesArr: function setCapturesArr(strs) {
			if (strs) {
				var arr = strs.split(',');
				this.captures = arr;
			}
		},
		fillEdit: function fillEdit() {
			var data = this.config.data;
			this.form.version = data.version;
			this.form.launcherDesc = data.launcherdesc;
			this.form.launcherName = data.launchername;
			this.form.verTag = data.versioncode;
			this.form.packageName = data.packagename;
			this.form.appUrl = data.launcherurl;

			this.fileList = [{
				name: data.packagename
			}];
			this.setCapturesIn(data.launcherimg);
			this.fileSize = data.appsize;

			this.ulinfo.index = 1;
		},
		getTypeList: function getTypeList() {
			var _this7 = this;

			this.$getAppTypeList(100000000, 1, function (res) {
				if (res.status === 200) {
					console.log(res);
					_this7.appTypes = res.data;
				} else {
					_this7.$message(res.message);
				}
			}, '');
		},
		cancel: function cancel() {
			this.$router.go(-1);
		},
		verify: function verify() {
			var _this8 = this;

			this.loading = 1;
			var id = this.config.data.applicationid;
			var passValue = this.radio === '1' ? '2' : '3';
			var desc = this.checkDesc;
			if (this.$appUrlTag === 0) {
				this.$verifyApp(localStorage.user, id, passValue, desc, function (res) {
					_this8.loading = 0;
					if (res.status === 200) {
						_this8.$router.go(-1);
					} else {
						_this8.$message.error(res.message);
					}
				}, function () {
					_this8.loading = 0;
					_this8.$message.error(_this8.$t('app_rqsError'));
				});
			} else {
				this.$verifyApp1(this.mechanismId, localStorage.user, id, passValue, desc, function (res) {
					_this8.loading = 0;
					if (res.status === 200) {
						_this8.$router.go(-1);
					} else {
						_this8.$message.error(res.message);
					}
				}, function () {
					_this8.loading = 0;
					_this8.$message.error(_this8.$t('app_rqsError'));
				});
			}
		},
		getAppHistory: function getAppHistory() {
			var _this9 = this;

			if (!this.config.data.launcherName) {
				return;
			}
			console.log('pkg', this.config.data);
			this.loading = 1;
			if (this.$appUrlTag === 0) {
				this.$getAppHistory(this.config.data.launcherName, this.config.data.packagename, function (res) {
					console.log('reslist', res);
					_this9.loading = 0;
					if (res.status === 200) {
						_this9.tableData = res.data;
					} else {
						_this9.$message.error(res.message);
					}
				}, function () {
					_this9.loading = 0;
				});
			} else {
				this.$getAppHistory1(this.mechanismId, this.config.data.packagename, function (res) {
					console.log('reslist', res);
					_this9.loading = 0;
					if (res.status === 200) {
						_this9.tableData = res.data;
					} else {
						_this9.$message.error(res.message);
					}
				}, function () {
					_this9.loading = 0;
				});
			}
		},
		uploadNew: function uploadNew() {},
		setInstallType: function setInstallType(type) {
			return this.$installType[type];
		},
		init: function init() {
			this.config = this.$getWObj().launcherEdit;
			console.log('config', this.config);

			switch (this.config.type) {
				case 0:
					break;
				case 1:
					this.getTypeList();
					this.fillEdit();
					break;
				case 2:
					this.fillEdit();
					this.form.appUrl = '';
					this.fileList = [];

					break;
				case 3:
					this.getChannels();
					this.getDevices();
					this.setCapturesArr(this.config.data.appScreenShot);
					break;
			}
		},
		getDevices: function getDevices() {
			var _this10 = this;

			var vl = this.srchValue ? this.srchValue : '';
			var channel = this.channelId ? this.channelId : '';
			var status = this.status ? this.status : '';
			this.loading = 1;
			if (this.$appUrlTag === 0) {
				this.$getDevices(this.index, this.$gRow, channel, vl, status, '', this.config.data.applicationid, function (res) {
					console.log('dv', res);
					_this10.loading = 0;
					if (res.data) {
						_this10.tableData = res.data;
						_this10.total = res.total;
					}
				}, function () {
					_this10.loading = 0;
				});
			} else {
				this.$getDevices1(this.index, this.$gRow, localStorage.mechanismId, vl, status, '', this.config.data.applicationid, function (res) {
					console.log('dv', res);
					_this10.loading = 0;
					if (res.data) {
						_this10.tableData = res.data;
						_this10.total = res.total;
					}
				}, function () {
					_this10.loading = 0;
				});
			}
		},
		bindOperate: function bindOperate(row) {
			this.bind(row.terminalId, row.terminalNo);
		},
		bind: function bind(tId, tNo) {
			var _this11 = this;

			this.loading = 1;
			if (this.$appUrlTag === 0) {
				this.$bindApp('0', tId, this.config.data.applicationid, function (res) {
					if (res.status === 200) {
						_this11.$message.success(_this11.$t('app_tipViewTask'));
					} else {
						_this11.$message.error(res.message);
					}
					_this11.loading = 0;
				}, function () {
					_this11.loading = 0;
				});
			} else {
				this.$verifyAppPush(localStorage.mechanismId, tNo, this.config.data.applicationid, function (res) {
					if (res.status === 200) {
						_this11.$message.success(_this11.$t('app_tipViewTask'));
					} else {
						_this11.$message.error(res.message);
					}
					_this11.loading = 0;
				}, function () {
					_this11.loading = 0;
				});
			}
		},
		srchDevice: function srchDevice() {
			this.getDevices();
		}
	},
	mounted: function mounted() {
		this.init();
	}
});

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default.a
  },
  data: function data() {
    var that = this;
    return {
      orderName: '',
      orderType: '',
      mechanismData: {
        callback: function callback(value) {
          that.mech = value;
          that.selectChange(value);
        }
      },
      listKey: 'launch-list',
      cerDialogVisible: false,
      cerTipDialogVisible: false,
      dvLoading: 0,
      appId: '',
      stModel: [{ label: this.$t('app_online'), vl: '1' }, { label: this.$t('app_offline'), vl: '2' }, { label: this.$t('app_new'), vl: '0' }],
      channels: [],
      srchValue: '',
      channelId: '',
      cerTipMsg: '',
      status: '',
      dvIndex: 1,
      dialogVisible: 0,
      mechanismId: window.localStorage['mechanismId'],
      selectMid: '',
      tableData: [],
      dvTableData: [],
      appTypes: [],
      appTypeValue: '',
      appStatus: [{ label: this.$t('app_prePushVerify'), value: '0' }, { label: this.$t('app_preVerify'), value: '1' }, { label: this.$t('app_verifyPass'), value: '2' }, { label: this.$t('app_verifyNotPass'), value: '3' }],
      appStatusValue: '',
      total: 0,
      dvTotal: 0,
      loading: 0,
      appType: '',
      queryKey: ''
    };
  },

  computed: {
    index: function index() {
      var vl = this.$getWPage(this.listKey);
      return vl ? vl : 1;
    },
    getDvStatus: function getDvStatus(value) {
      switch (value) {
        case '0':
          return this.$t('app_prePushVerify');
        case '1':
          return this.$t('app_preVerify');
        case '2':
          return this.$t('app_verifyPass');
        case '3':
          return this.$t('app_verifyNotPass');
      }
    }
  },
  methods: {
    sortChange: function sortChange(vl) {
      switch (vl.prop) {
        case 'launchername':
          this.orderName = '1';
          break;
        case 'uploadtime':
          this.orderName = '2';
          break;
      }
      this.orderType = vl.order == 'descending' ? 'desc' : 'asc';
      this.getList();
    },
    pushCreateCer: function pushCreateCer() {
      this.$router.push({ path: "/certificate/new" });
    },
    pushUploadCer: function pushUploadCer() {
      this.$router.push({ path: "/certificate/upload" });
    },
    bindOperate: function bindOperate(row) {
      var _this = this;

      this.dvLoading = 1;
      if (this.$appUrlTag === 0) {
        this.$bindApp('0', row.terminalNo, this.appId, function (res) {
          if (res.status === 200) {
            _this.$message.success(_this.$t('app_tipViewTask'));
          } else {
            _this.$message.error(res.message);
          }
          _this.dvLoading = 0;
        }, function () {
          _this.dvLoading = 0;
        });
      } else {
        this.$bindApp1(localStorage.mechanismId, row.terminalNo, this.appId, function (res) {
          if (res.status === 200) {
            _this.$message.success(_this.$t('app_tipViewTask'));
          } else {
            _this.$message.error(res.message);
          }
          _this.dvLoading = 0;
        }, function () {
          _this.dvLoading = 0;
        });
      }
    },
    getChannels: function getChannels() {
      var _this2 = this;

      this.$getChannelList(10000, 1, '', '', '', function (res) {
        if (res.status === 200) {
          _this2.channels = res.data;
        } else {
          _this2.$message.error(res.message);
        }
      }, function () {
        _this2.$message.error(_this2.$t('app_rqsError'));
      });
    },
    getStatus: function getStatus(value) {
      if (!value) return '';
      switch (value) {
        case '0':
          return { vl: this.$t('app_prePushVerify'), style: 'color:#8492A6;' };
        case '1':
          return { vl: this.$t('app_preVerify'), style: 'color:#F7BA2A;' };
        case '2':
          return { vl: this.$t('app_verifyPass'), style: 'color:#13CE66;' };
        case '3':
          return { vl: this.$t('app_verifyNotPass'), style: 'color:#FF4949;' };
      }
    },
    srchDevice: function srchDevice() {
      this.getDevices();
    },
    selectDvChange: function selectDvChange(vl) {
      this.getDevices();
    },
    pageDvSized: function pageDvSized(val) {
      this.$gRow = val;
      this.getDevices();
    },
    getDevices: function getDevices() {
      var _this3 = this;

      var vl = this.srchValue ? this.srchValue : '';
      var channel = this.channelId ? this.channelId : '';
      var status = this.status ? this.status : '';
      var appId = this.appId ? this.appId : '';
      this.dvLoading = 1;
      if (this.$appUrlTag === 0) {
        this.$getDevices(this.dvIndex, this.$gRow, channel, vl, status, '', appId, function (res) {
          _this3.dvLoading = 0;
          if (res.data) {
            _this3.dvTableData = res.data;
            _this3.dvTotal = res.total;
          }
        }, function () {
          _this3.dvLoading = 0;
        });
      } else {

        this.$getDevices1(this.dvIndex, this.$gRow, localStorage.mechanismId, vl, status, '', appId, function (res) {
          console.log('dv', res);
          _this3.dvLoading = 0;
          if (res.data) {
            _this3.dvTableData = res.data;
            _this3.dvTotal = res.total;
          }
        }, function () {
          _this3.dvLoading = 0;
        });
      }
    },
    editApp: function editApp(row) {
      this.$setWObj('launcherEdit', { type: 1, data: row });
      this.$router.push({ path: '/launch-edit' });
    },
    pushApp: function pushApp(row) {

      this.$setWObj('pushList', { type: '10', data: row });
      this.$router.push({ path: '/launch-push' });
    },
    query: function query() {
      this.getList();
    },
    selectChange: function selectChange(vl) {
      this.selectMid = vl;
      this.getList();
    },
    reset: function reset() {
      this.queryKey = '';
      this.appType = '';
      this.getList();
    },
    pageSelect: function pageSelect(index) {
      this.$setWPage(this.listKey, index);
      this.getList();
    },
    pageDvSelect: function pageDvSelect(index) {
      this.dvIndex = index;
      this.getDevices();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getList();
    },
    deleteApp: function deleteApp(obj) {
      var _this4 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        console.log(obj);
        _this4.$delLauncher(obj.launcherid, obj.status, function (res) {
          if (res.status === 200) {
            _this4.getList();
            _this4.$message.success(res.message);
          } else {
            _this4.$message.error(res.message);
          }
        }, '');
      }, '');
    },
    submitApp: function submitApp(obj) {
      var _this5 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_tipVerify'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this5.loading = 1;
        _this5.$submitLauncher(obj.launcherid, function (res) {
          _this5.loading = 0;
          if (res.status === 200) {
            _this5.getList();
            _this5.$message.success(res.message);
          } else {
            _this5.$message.error(res.message);
          }
        }, function () {
          _this5.loading = 0;
        });
      }, '');
    },
    cellClick: function cellClick(row, ev, col) {
      if (col.label && col.label === this.$t('app_operate')) {
        return;
      }

      var isDetail = row.status === '1' || row.status === '2';
      var path = isDetail ? '/launch-detail' : '/launch-edit';
      var key = isDetail ? 'launcherDetail' : 'launcherEdit';
      var obj = isDetail ? row : { type: 1, data: row };

      this.$setWObj(key, obj);
      this.$router.push({ path: path });
    },
    jumpToUpload: function jumpToUpload() {

      this.$setWObj('launcherEdit', { type: 0 });
      this.$router.push({ path: '/addlaunch' });
    },
    getList: function getList() {
      var _this6 = this;

      this.loading = 1;
      var dsid = this.selectMid ? this.selectMid : '';
      var name = this.queryKey ? this.queryKey : '';
      this.$launcherList(this.index, this.$gRow, name, dsid, this.orderName, this.orderType, '', function (res) {

        _this6.loading = 0;
        if (res.status === 200) {
          _this6.total = res.total;
          _this6.tableData = res.data;
        } else {
          _this6.$message(res.message);
        }
      }, function () {
        _this6.loading = 0;
        _this6.$message.error(_this6.$t('app_rqsError'));
      });
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD HH:mm:ss');
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    }
  },
  mounted: function mounted() {
    this.getList();
  },
  destroyed: function destroyed() {}
});

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      mechanismId: window.localStorage['mechanismId'],
      tableData: [],
      info: '',
      total: 0,
      row: this.$gRow,
      page: 1,
      list: [],
      sNum: 0
    };
  },

  components: {},
  computed: {
    avt: function avt() {
      return this.$urls.prefix + this.info.appBigIcon;
    },
    avtStyle: function avtStyle() {
      return 'background-size: cover;background-position: center center;width:100%;height:100%;background-image: url(' + this.avt + ')';
    },
    index: function index() {
      return this.$getWPage('appMarketPushPage');
    }
  },
  methods: {
    updateDv: function updateDv(row) {
      var _this = this;

      this.loading = 1;
      var cId = this.info.appdevid ? this.info.appdevid : this.info.applicationid;
      if (this.$appUrlTag === 0) {
        this.$bindApp('0', row.terminialId, cId, function (res) {
          _this.loading = 0;
          _this.$message(res.message);
          if (res.status === 200) {
            _this.getBinds(_this.page);
          }
        }, function () {
          _this.loading = 0;
        });
      } else {
        this.$bindApp1(this.mechanismId, row.terminalNo, cId, function (res) {
          _this.loading = 0;
          _this.$message(res.message);
          if (res.status === 200) {
            _this.getBinds(_this.page);
          }
        }, function () {
          _this.loading = 0;
        });
      }
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    },
    handleSelectionChange: function handleSelectionChange(list) {
      this.sNum = list.length;
      this.list = list;
    },
    allUnbind: function allUnbind() {
      var _this2 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_srrecovsysdf') + 'launcher?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        var tNos = '';
        var pkg = '';
        _this2.list.forEach(function (vl) {
          tNos += vl.terminalNo + ',';
          pkg = vl.packagename;
        });
        tNos = tNos.substring(0, tNos.length - 1);

        if (!tNos) {
          _this2.$message($t('app_oneDeviceMust'));
          return;
        }
        _this2.unbindReq(tNos, pkg);
      }, '');
    },
    bindOperate: function bindOperate(row) {
      var _this3 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_srrecovsysdf') + 'launcher?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this3.unbindReq(row.terminalNo, row.packagename);
      }, '');
    },
    unbindReq: function unbindReq(tNo, pkg) {
      var _this4 = this;

      this.loading = 1;
      this.$resetLauncher(pkg, tNo, function (res) {
        _this4.loading = 0;
        if (res.status === 200) {
          _this4.getBinds(_this4.page);
          _this4.$message.success(res.message);
        } else {
          _this4.$message.error(res.message);
        }
      }, function () {
        _this4.loading = 0;
        _this4.$message.error(_this4.$t('app_rqsError'));
      });
    },
    addBind: function addBind() {
      this.$setWObj('launcherBind', this.info);
      this.$router.push({ path: '/launch-push/launch-push-ter' });
    },
    getBinds: function getBinds(page) {
      var _this5 = this;

      this.loading = 1;

      this.$getLauncherDevices(page, this.$gRow, this.info.launcherid, localStorage.mechanismId, this.info.packagename, function (res) {
        _this5.loading = 0;
        if (res.status === 200) {
          console.log(res);
          _this5.tableData = res.data;
          _this5.total = res.total;
          _this5.page = page;
        } else {
          _this5.$message.error(res.message);
        }
      }, function () {
        _this5.loading = 0;
      });
    },
    pageSelect: function pageSelect(index) {
      this.getBinds(index);
      this.$setWPage('appMarketPushPage', index);
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getBinds(this.index);
    }
  },
  mounted: function mounted() {
    var obj = this.$getWObj().launcherPush;
    this.info = obj;
    console.log('info', this.info);
    this.getBinds(this.page);
  }
});

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    var checkFrame = function checkFrame(rule, value, callback) {
      if (!_this.isNumber(value)) {
        callback(new Error(_this.$t('app_inputNumber')));
      } else {
        callback();
      }
    };
    var checkSize = function checkSize(rule, value, callback) {
      var ar = value.split('*');
      if (ar.length === 2) {
        if (_this.isNumber(ar[0]) && _this.isNumber(ar[1])) {
          callback();
        } else {
          callback(new Error(_this.$t('app_formatNotTrueLike') + '800*600'));
        }
      } else {
        callback(new Error(_this.$t('app_formatNotTrueLike') + '800*600'));
      }
    };
    return {
      mode: this.$t('app_launchAnimate'),
      loading: 0,
      md5: '',
      fm: {
        name: '',
        aType: '',
        playPlace: '',
        aFile: '',
        onPic: '',
        picSize: '720*1280',
        frame: '24',
        playTimes: ''
      },
      fm1: {
        name: '',
        pic: '',
        aType: ''
      },
      fm2: {
        name: '',
        pic: '',
        aType: ''
      },
      addArules: {
        name: [{ required: true, message: this.$t('app_inputAnimateName'), trigger: 'blur' }],
        aType: [{ required: true, message: this.$t('app_selectAnimateType'), trigger: 'change' }],
        playPlace: [{ required: true, message: this.$t('app_selectPlayPlace'), trigger: 'change' }],
        aFile: [{ required: true, message: this.$t('app_uploadAnimateFile'), trigger: 'change' }],
        onPic: [{ required: true, message: this.$t('app_uploadOnPic'), trigger: 'blur' }],
        picSize: [{ required: true, trigger: 'blur', validator: checkSize }],
        frame: [{ required: true, trigger: 'blur', validator: checkFrame }],
        playTimes: [{ required: true, message: this.$t('app_chooseCycleType'), trigger: 'change' }]
      },
      addArules1: {
        name: [{ required: true, message: this.$t('app_input'), trigger: 'blur' }],
        pic: [{ required: true, message: this.$t('app_plsUpl'), trigger: 'change' }]
      },
      addArules2: {
        name: [{ required: true, message: this.$t('app_input'), trigger: 'blur' }],
        pic: [{ required: true, message: this.$t('app_uploadPic'), trigger: 'change' }]
      },
      animateType: [{ label: this.$t('app_launchAnimate'), value: '1' }, { label: this.$t('app_launchUI'), value: '2' }],
      playPlace: [{ label: this.$t('app_on'), value: '1' }, { label: this.$t('app_off'), value: '2' }, { label: this.$t('app_onOff'), value: '3' }],
      times: [{ label: this.$t('app_playOnce'), value: '1' }, { label: this.$t('app_cyclePlay'), value: '2' }],
      srcList: [],
      picList: [],
      picList1: [],
      picList2: []
    };
  },

  components: {},
  computed: {
    imgUploadUrl: function imgUploadUrl() {
      return this.$urls.picUrl;
    },
    fileUploadUrl: function fileUploadUrl() {
      return this.$urls.fileUrl;
    },
    downUrl: function downUrl() {
      return this.$host + '/tms-server-web/model/animation/part0.zip';
    }
  },
  methods: {
    isNumber: function isNumber(value) {
      var len = value.length;
      var cLen = (parseInt(value) + '').length;
      if (len === cLen) {
        return 1;
      } else {
        return 0;
      }
    },
    srcBefore: function srcBefore(file) {
      var name = file.name;
      if (name) {
        window[this.$route.path] = 1;
        return true;
      } else {
        this.$message(this.$t('app_fileNameOnly') + 'part0.zip');
        return false;
      }
    },
    srcSuccess: function srcSuccess(res, file) {
      window[this.$route.path] = '';
      console.log(res);
      if (res.status === 200) {
        this.md5 = res.md5;
        this.srcList = [{ name: file.name }];
        this.fm.aFile = res.fileUrl;
        this.hBlur('fm');
      } else {
        this.srcList = [];
      }
    },
    picBefore: function picBefore(file) {},
    picError: function picError() {
      this.$message.error(this.$t('app_picUlError'));
      this.picList = [];
    },
    picError1: function picError1() {
      this.$message.error(this.$t('app_picUlError'));
      this.picList1 = [];
    },
    picError2: function picError2() {
      this.$message.error(this.$t('app_picUlError'));
      this.picList2 = [];
    },
    picSuccess: function picSuccess(res, file) {
      console.log('rr', res);
      if (res.status === 200) {
        this.picList = [{ name: file.name }];
        this.fm.onPic = res.data;
        this.hBlur('fm');
      } else {
        this.picList = [];
      }
    },
    picSuccess1: function picSuccess1(res, file) {
      console.log('rr1', res);
      if (res.status === 200) {
        this.picList1 = [{ name: file.name }];
        this.fm1.pic = res.fileUrl;
        this.md5 = res.md5;
        this.hBlur('fm1');
      } else {
        this.picList1 = [];
      }
    },
    picSuccess2: function picSuccess2(res, file) {
      console.log('rr1', res);
      if (res.status === 200) {
        this.picList2 = [{ name: file.name }];
        this.fm2.pic = res.data;
        this.hBlur('fm1');
      } else {
        this.picList2 = [];
      }
    },
    addAnimate: function addAnimate(formName, anmtype) {
      var _this2 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (anmtype == '2') {
            var md = _this2.fm1;
            _this2.loading = 1;
            _this2.$addAnimate(_this2.md5, md.name, anmtype, '', md.pic, '', '', '', '', function (res) {
              _this2.loading = 0;
              if (res.status === 200) {
                _this2.$router.go(-1);
              } else {
                _this2.$message.error(res.message);
              }
            }, function () {
              _this2.loading = 0;
            });
          } else if (anmtype == '1') {
            var md = _this2.fm;
            _this2.loading = 1;
            _this2.$addAnimate(_this2.md5, md.name, anmtype, md.playPlace, md.aFile, md.picSize, md.frame, md.playTimes, md.onPic, function (res) {
              _this2.loading = 0;
              if (res.status === 200) {
                _this2.$router.go(-1);
              } else {
                _this2.$message.error(res.message);
              }
            }, function () {
              _this2.loading = 0;
            });
          } else {
            var md = _this2.fm2;
            _this2.loading = 1;
            _this2.$addAnimate(_this2.md5, md.name, anmtype, '', md.pic, '', '', '', '', function (res) {
              _this2.loading = 0;
              if (res.status === 200) {
                _this2.$router.go(-1);
              } else {
                _this2.$message.error(res.message);
              }
            }, function () {
              _this2.loading = 0;
            });
          }
        } else {
          return false;
        }
      });
    },
    hBlur: function hBlur(name) {
      this.$refs[name].validate(function (valid) {
        if (valid) {} else {
          return false;
        }
      });
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      row: this.$gRow,
      total: 0,
      page: 1,
      tableData: [],
      aType: { '1': this.$t('app_launchAnimate'), '2': this.$t('app_onLogo'), '3': this.$t('app_deskwp') }
    };
  },

  components: {},
  computed: {},
  methods: {
    pageSelect: function pageSelect(index) {
      this.page = index;
      this.getList();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getList();
    },
    viewPush: function viewPush(row) {
      this.$setWObj('animatePushInfo', row);
    },
    push: function push(row) {
      this.$setWObj('pushList', { type: '6', data: row });
      this.$router.push({ path: '/animate-push' });
    },
    add: function add() {
      this.$router.push({ path: '/animate-add' });
    },
    deleteRow: function deleteRow(row) {
      var _this = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_sureDelTip'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this.loading = 1;
        _this.$delAnimate(row.animatId, function (res) {
          _this.loading = 0;
          if (res.status === 200) {
            _this.getList();
          } else {
            _this.$message.error(res.message);
          }
        }, function () {
          _this.loading = 0;
        });
      }, '');
    },
    getList: function getList() {
      var _this2 = this;

      this.loading = 1;
      this.$animateList(this.$gRow, this.page, function (res) {
        _this2.loading = 0;
        if (res.status === 200) {
          _this2.tableData = res.data;
          _this2.total = res.total;
        }
      }, function () {
        _this2.loading = 0;
      });
    }
  },
  mounted: function mounted() {
    this.getList();
  }
});

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_TernoAutoCtrl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_TernoAutoCtrl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_TernoAutoCtrl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_paging_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_paging_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_global_paging_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    paging: __WEBPACK_IMPORTED_MODULE_2__components_global_paging_vue___default.a,
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default.a,
    AutoTerno: __WEBPACK_IMPORTED_MODULE_1__global_TernoAutoCtrl___default.a
  },
  data: function data() {
    var that = this;
    return {
      mechanismData: {
        value: null,
        placeholder: that.$t('lin_global.place_areaid'),
        callback: function callback(value) {
          that.choose = { "mechanismid": value };
          that.selected({ "mechanismid": value });
        }
      },
      pagingData: {
        total: 0,
        pageSize: 20,
        currentPage: 1
      },
      aType: { '1': this.$t('app_launchAnimate'), '2': this.$t('app_onLogo') },
      dvNo: '',
      srcList: [],
      types: [{ label: this.$t('app_distributor'), value: '0' }, { label: this.$t('app_fileImport'), value: '1' }, { label: this.$t('app_sgMc'), value: '2' }],
      pType: '0',
      channels: [],
      choose: '',
      info: '',
      loading: 0,
      devices: 0,
      exInfo: {},

      row: this.$gRow,
      total: 0,
      page: 1,
      tableData: [],

      pLoading: 0,
      multipleSelection: []
    };
  },

  computed: {
    downUrl: function downUrl() {
      return this.$host + '/tms-server-web/model/terminalNos.xlsx';
    }
  },
  methods: {
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    pAction: function pAction() {},
    cellClick: function cellClick() {},
    jumpToPush: function jumpToPush() {
      location.hash = '#/animate-push/push/6';
    },
    getList: function getList() {
      var _this = this;

      var that = this;
      var aId = this.info.animatId;
      this.pLoading = 0;
      var params = {
        page: that.pagingData.currentPage,
        rows: that.pagingData.pageSize,
        fileId: this.info.animatId
      };
      this.$getPushHistory(params, function (res) {
        _this.pLoading = 0;
        if (res.status === 200) {
          _this.tableData = res.data;
          that.pagingData.total = res.total;
        }
      }, function () {
        _this.pLoading = 0;
      });
    }
  },
  mounted: function mounted() {
    this.info = this.$getWObj().animatePushInfo;
    this.getList();
  }
});

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      row: this.$gRow,
      total: 0,
      page: 1,
      tableData: [],
      info: '',
      loading: 0
    };
  },

  components: {},
  computed: {},
  methods: {
    deleteRow: function deleteRow(row) {
      var _this = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_sureDelTip'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this.loading = 1;
        _this.$delAnimatePushHis(row.mechanismId, _this.info.animatId, function (res) {
          _this.loading = 0;
          if (res.status === 200) {
            _this.getList();
          } else {
            _this.$message.error(res.message);
          }
        }, function () {
          _this.loading = 0;
        });
      }, '');
    },
    getList: function getList() {
      var _this2 = this;

      var aId = this.info.animatId;
      console.log('aid', aId);
      this.loading = 1;
      this.$pushAnimateHistory(aId, function (res) {
        console.log(res);
        _this2.loading = 0;
        if (res.status === 200) {
          _this2.tableData = res.data;
        }
      }, function () {
        _this2.loading = 0;
      });
    }
  },
  mounted: function mounted() {
    this.info = this.$getWObj().animatePushInfo;
    this.getList();
  }
});

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default.a
  },
  data: function data() {
    var that = this;
    return {
      uploadPushParams: null,
      form: {
        token: localStorage.getItem('user'),
        memo: '',
        type: '0',
        targetId: '',
        ota_rom_id: '',
        fileNo: ''
      },

      hasCoverWarn: false,

      taskType: null,

      tipMessage: that.$t('pushTip.pushType0'),

      uploadModalShow: false,
      selectedMechanismObject: null,
      mechanismData: {
        optValue: true,
        callback: function callback(value) {
          that.selectedMechanismObject = value;
          that.value1 = value.id;
          that.getData(1, that.input1, that.value1, that.value2, that.orderValue);
        }
      },
      exInfo: {},
      dvNum: 0,
      exFileName: '',
      dataUpload: null,
      dvName: '',
      orderValue: '',
      terminalName: '',
      disabled: true,
      focusEvent: __WEBPACK_IMPORTED_MODULE_2__api_url__["c" /* focusEvent */],
      importTemplate: __WEBPACK_IMPORTED_MODULE_2__api_url__["b" /* urlAssets */].prefix + 'tms-server-web/model/terminals.xlsx',
      fileList: [],
      action: '',
      srcList: [],
      areaList1: [],
      excelUploadUrl: '',
      areaList: [],
      importForm: {
        'areaid': '',
        'uploadify': null
      },
      statusinfoLoading: false,
      importTermVisible: false,
      importIsSubmit: false,
      currentPage: 1,
      pageSize: 10,
      totalRecords: 0,
      loading: true,
      reserverSelection: true,
      input1: '',
      value1: '',
      value2: '',
      multipleSelection: [],
      options2: [{
        value: '',
        label: this.$t('lin_global.all_status')
      }, {
        value: '0',
        label: this.$t('lin_global.new_add')
      }, {
        value: '1',
        label: this.$t('lin_global.online')
      }, {
        value: '2',
        label: this.$t('lin_global.offline')
      }, {
        value: '3',
        label: this.$t('app_sleep')
      }],
      areaid: '',
      arrdata: [],
      currentFileId: null
    };
  },

  computed: {
    fileUploadUrl: function fileUploadUrl() {
      return "http://172.16.7.51:8686/tms-server-web/import/terminalList.do";
    },
    downUrl: function downUrl() {
      return this.$host + '/tms-server-web/model/terminalNos.xlsx';
    },
    justSelectMechanism: function justSelectMechanism() {
      return this.selectedMechanismObject && this.value2 === '' && this.dvName === '' || false;
    }
  },
  methods: {
    doUploadPush: function doUploadPush() {
      var that = this;
      that.uploadModalShow = false;
      that.doPush(that.uploadPushParams);
    },
    srcSuccess: function srcSuccess(res, file) {
      window[this.$route.path] = '';

      if (res.status === 200) {
        this.srcList = [{ name: file.name }];
        this.exInfo = res.data;
        this.exInfo.file = file.name;
        this.form.fileNo = res.data.fileNo;

        this.dvNum = res.data.terNums;
      } else {
        if (this.exInfo.file) {
          this.srcList = [{ name: this.exInfo.file }];
        } else {
          this.srcList = [];
        }
        this.$message.error(res.message);
      }
    },
    srcBefore: function srcBefore(file) {
      window[this.$route.path] = 1;
    },
    confirmToPush: function confirmToPush(isCover) {
      var that = this;
      switch (isCover) {
        case 0:
          console.log('跳过更新');
          break;
        case 1:
          console.log('覆盖更新');
          break;
      }

      var oldParams = this.$getWPage('confirmParams');
      var params = {
        taskId: oldParams.taskId,
        pushParam: oldParams.pushParam,
        isCover: isCover
      };

      this.$confirmToPushAction(params, function (res) {
        that.hasCoverWarn = false;
        if (res.status === 200) {
          that.$message.success(that.$t('pushTip.pushSuccess'));
        } else {
          that.$message.error(res.message);
        }
      });
    },
    doPush: function doPush(params, message) {
      var that = this;
      if (that.form.fileNo) {
        params.fileNo = that.form.fileNo;
      }
      that.$pushGlobalAction(params, function (res) {
        if (res.status === 200) {
          that.$message.success(res.message);
        } else if (res.status === 300) {
          that.hasCoverWarn = true;
          that.tipMessage = message.replace(/{nums}/, res.data.nums);
          that.$setWPage('confirmParams', res.data);
        } else {
          that.$message.error(res.message);
        }
      });
    },
    pushAction: function pushAction(pushType) {
      var that = this;
      var params = {};

      params.taskType = that.taskType;
      params.pushType = pushType;

      switch (that.taskType) {
        case '1':
          break;
        case '2':
          var otaInfo = this.$getWObj().otaPushInfo;
          params.objId = otaInfo.id;
          break;
        case '3':
          break;
        case '4':

          break;
        case '5':
          break;
        case '6':
          var info = this.$getWObj().animatePushInfo;
          params.objId = info.animatId;
          break;
        default:
          break;
      }

      switch (pushType) {
        case 0:
          var terminalNoArray = [];
          if (this.multipleSelection.length === 0) {
            this.$message.error(this.$t('terminal.add.place_terminal'));
            return false;
          }
          for (var i = 0; i < this.multipleSelection.length; i++) {
            terminalNoArray.push(this.multipleSelection[i].terminalNo);
          }

          params.terminalNos = terminalNoArray.join(',');

          that.doPush(params, this.$t('pushTip.pushType0'));
          break;
        case 1:
          params.mechId = that.value1;

          params.terminalStatus = that.value2;

          params.terminalNo = that.dvName;

          var configText = void 0;
          if (!that.selectedMechanismObject) {
            configText = that.$t('pushTip.push_all');
          } else if (that.justSelectMechanism) {
            configText = that.$t('pushTip.push_all_by_mem');
            console.log(configText);
            configText = configText.replace(/{nums}/, 111);
            configText = configText.replace(/{mem}/, that.selectedMechanismObject.name);
          }

          this.$confirm(configText, that.$t('mao_global.tip.text'), {
            confirmButtonText: '确认推送',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            that.doPush(params);
          }).catch(function () {});
          break;
        default:
          that.uploadModalShow = true;
          that.uploadPushParams = params;
          break;
      }
    },
    powerIcon: function powerIcon(vl) {
      return !vl ? "color:#FF4949" : "color: null";
    },
    exCancel: function exCancel() {
      this.importTermVisible = false;
      this.disabled = true;
      if (this.exFileName) {
        this.$router.push({ path: '/' });
        this.$router.go(-1);
      }
    },

    shuaxin: function shuaxin() {
      this.getData(1, this.input1, this.value1, this.value2, this.orderValue);
    },
    sortChane: function sortChane(val) {
      if (val.order === "descending") {
        this.orderValue = "desc";
      } else if (val.order === "ascending") {
        this.orderValue = "asc";
      } else {
        this.orderValue = '';
      }
      this.getData(this.currentPage, this.input1, this.value1, this.value2, this.orderValue);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getData(this.currentPage, this.input1, this.value1, this.value2, this.orderValue);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.getData(this.currentPage, this.input1, this.value1, this.value2, this.orderValue);
    },
    statusChange: function statusChange() {
      this.getData(1, this.input1, this.value1, this.value2, this.orderValue);
    },
    handleIconClick: function handleIconClick() {
      this.getData(1, this.input1, this.value1, this.value2, this.orderValue);
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    batchDeleteRow: function batchDeleteRow() {
      var _this = this;

      this.$confirm(this.$t('terminal.list.delete_tips'), this.$t('lin_btn.tips'), {
        confirmButtonText: this.$t('lin_btn.confirm'),
        cancelButtonText: this.$t('lin_btn.cancel'),
        type: 'warning'
      }).then(function () {
        var ids = [];
        if (_this.multipleSelection.length === 0) {
          _this.$message.error(_this.$t('terminal.list.empty_tips'));
          return false;
        }
        for (var i = 0; i < _this.multipleSelection.length; i++) {
          ids.push(_this.multipleSelection[i].terminalId);
        }
        var rq = {
          ids: ids.join(',')
        };
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/terminal/delete.do', rq).then(function (response) {
          var rs = response.data;
          if (rs.status == 200) {
            _this.$message.success(_this.$t('lin_global.delete_success'));
            _this.getData(_this.currentPage, _this.input1, _this.value1, _this.value2, _this.orderValue);
          } else {}
        }).catch(function (error) {});
      }).catch(function () {});
    },
    getData: function getData(page, no, areaid, status, order) {
      var _this2 = this;

      var that = this;

      this.loading = true;
      this.currentPage = page;
      var params = {
        page: page,
        rows: this.pageSize,
        fileMechId: this.currentFileId || '',
        mechId: that.value1 || '',
        token: localStorage.getItem('user') || '',
        terminalStatus: status,
        terminalNo: this.dvName
      };
      console.log(params);
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/push_manage/push_terList.do', params).then(function (res) {
        if (res.data.status == 200) {
          _this2.arrdata = res.data.data;
          _this2.totalRecords = res.data.total;
          _this2.loading = false;
          for (var i = 0; i < res.data.data.length; i++) {
            if (res.data.data[i].terminalStatus == 1) {
              res.data.data[i]['disable'] = false;
            } else {
              res.data.data[i]['disable'] = true;
            }
          }
        } else {
          _this2.loading = false;
        }
      }).catch(function (error) {});
    },
    getFileIdByTaskType: function getFileIdByTaskType(taskType) {
      var that = this;
      switch (taskType) {
        case '1':
          break;
        case '2':
          var otaInfo = this.$getWObj().otaPushInfo;
          that.currentFileId = otaInfo.mechanismId;
          break;
        case '3':
          break;
        case '4':

          break;
        case '5':
          break;
        case '6':
          var info = this.$getWObj().animatePushInfo;
          that.currentFileId = info.animatId;
          break;
        default:
          break;
      }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    var that = this;
    this.taskType = this.$route.params.type;

    if (this.taskType !== '6') {
      that.getFileIdByTaskType(this.taskType);
    }

    var c = this.$store.getters.r_param;
    if (c) {
      this.$store.dispatch('setParam', null);
      this.value2 = c + '';
      this.statusChange();
    } else {
      this.getData(1, '', '', '', '');
    }
    var timer = setInterval(function () {
      _this3.getData(1, _this3.input1, _this3.value1, _this3.value2, _this3.orderValue);
    }, 300000);
    localStorage.setItem("timer", timer);
    if (localStorage.getItem("system_lang")) {
      var lang = localStorage.getItem("system_lang");
      this.action = __WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/terminal/importTers.do' + "?language=" + lang + '&token=' + localStorage.user;
    }
  }
});

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_df_png__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_df_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_df_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_tyc__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_tyc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_tyc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pushdia_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pushdia_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pushdia_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		var _this = this;
		return {
			orderType: '',
			orderName: '',
			tty: '',
			comm: '',
			duration: 6,
			pObj: '',
			tid: '',
			tqobj: '',
			queryKey: '',
			tbOrder: '',
			statusNames: {
				'-1': this.$t('app_downFail'),
				'-2': this.$t('app_md5Fail'),
				'-3': this.$t('app_theNewgVer'),
				'-4': this.$t('app_fileFmIllegal'),
				'-5': this.$t('app_updateFail'),
				'-6': this.$t('app_usrCancelUpdate'),
				'0': this.$t('app_pushFail'),
				'1': this.$t('app_downloading'),
				'2': this.$t('app_downFinish'),
				'3': this.$t('app_success'),
				'4': this.$t('app_waiting'),
				'5': this.$t('app_success'),
				'6': this.$t('app_pause'),
				'7': this.$t('app_ccdown'),
				'-7': this.$t('app_verror'),
				'-8': this.$t('app_insfail'),
				'-9': this.$t('app_checksignfail'),
				'-10': this.$t('app_uninsfail'),
				'12': this.$t('app_appuninstall')
			},
			taskType: '',
			status: [{
				vl: '-1',
				name: this.$t('app_downFail')
			}, {
				vl: '-2',
				name: this.$t('app_md5Fail')
			}, {
				vl: '-3',
				name: this.$t('app_newgVer')
			}, {
				vl: '-4',
				name: this.$t('app_fileFmIllegal')
			}, {
				vl: '-5',
				name: this.$t('app_updateFail')
			}, {
				vl: '-6',
				name: this.$t('app_usrCancelUpdate')
			}, {
				vl: '0',
				name: this.$t('app_pushFail')
			}, {
				vl: '1',
				name: this.$t('app_downloading')
			}, {
				vl: '2',
				name: this.$t('app_downFinish')
			}, {
				vl: '3',
				name: this.$t('app_success')
			}, {
				vl: '4',
				name: this.$t('app_waiting')
			}, {
				vl: '5',
				name: this.$t('app_success')
			}, {
				vl: '6',
				name: this.$t('app_pause')
			}, {
				vl: '7',
				name: this.$t('app_ccdown')
			}, {
				vl: '-7',
				name: this.$t('app_verror')
			}, {
				vl: '-8',
				name: this.$t('app_insfail')
			}, {
				vl: '-9',
				name: this.$t('app_checksignfail')
			}, {
				vl: '-10',
				name: this.$t('app_uninsfail')
			}],
			pInfo: [],
			getftype: '',
			getstype: '',
			items: [{
				lb: this.$t('app_total'),
				num: '-'
			}, {
				lb: this.$t('app_success'),
				num: '-'
			}, {
				lb: this.$t('app_wait'),
				num: '-'
			}, {
				lb: this.$t('app_downloading'),
				num: '-'
			}, {
				lb: this.$t('app_fail'),
				num: '-'
			}, {
				lb: this.$t('app_cancel'),
				num: '-'
			}],
			mechanismData: {
				callback: function callback(value) {
					_this.mech = value;

					_this.getList();
				}
			},
			mechanismData1: {
				callback: function callback(value) {
					_this.mech1 = value;

					_this.getDevices();
				}
			},
			mech: '',
			mech1: '',
			srchValue: '',
			multipleSelection: [],
			info: '',
			mapType: {
				'0': this.$t('app_bdmap'),
				'1': 'Google' + this.$t('app_map')
			},
			ctrlType: {
				'0': this.$t('app_off1'),
				'1': this.$t('app_on1')
			},
			bindSt: {
				'0': this.$t('app_waitupdate'),
				'1': this.$t('app_updateSuccess'),
				'2': this.$t('app_updateFail')
			},
			bindSts: [{
				vl: '',
				lb: this.$t('app_allstatus')
			}, {
				vl: '1',
				lb: this.$t('app_success')
			}, {
				vl: '2',
				lb: this.$t('app_waiting')
			}, {
				vl: '3',
				lb: this.$t('app_downloading')
			}, {
				vl: '4',
				lb: this.$t('lin_global.concel_tips')
			}, {
				vl: '5',
				lb: this.$t('app_fail')
			}],

			bindVl: '',
			config: '',
			captures: [],
			loading: 0,
			tableData: [],
			tags: [],
			page: 1,
			index: 1,
			hiss: [],
			total: 0
		};
	},

	components: {
		MechanismSelector: __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue___default.a,
		pushdia: __WEBPACK_IMPORTED_MODULE_4__pushdia_vue___default.a,
		tyc: __WEBPACK_IMPORTED_MODULE_3__components_global_tyc___default.a
	},
	computed: {
		showUploadNew: function showUploadNew() {
			if (this.config) {
				if (this.config.isoperate == 0) {
					return true;
				} else {
					return false;
				}
			} else {
				return false;
			}
		}
	},
	methods: {
		barTTip: function barTTip(cp, total) {
			var words = this.$t('app_done');
			if (cp == 0) {
				words = this.$t('app_waiting');
			} else if (total > cp) {
				words = this.$t('app_ing');
			}

			return words;
		},
		barColor: function barColor(cp, total) {
			var color = 'background: rgb(87,205,123);';
			if (cp == 0) {
				color = 'background: yellow;';
			} else if (total > cp) {
				color = 'background: blue;';
			}
			var st = "position:absolute;width:6px;height:100%;right:0;";

			return st + color;
		},
		refreshPList: function refreshPList() {
			this.getList();
		},
		cancelCf: function cancelCf(row) {
			var _this2 = this;

			this.$showConfirm('', this.$t('app_iscltask') + '?', this.$t('app_sure'), this.$t('app_cancel'), 'warnning', function () {
				_this2.downOperate(3, row);
			});
		},
		repush: function repush(row) {
			var _this3 = this;

			this.$pushRepush(row.detailId, function (res) {
				_this3.loading = 0;
				if (res.status == 200) {
					_this3.$message.success(res.message);
					_this3.getList();
				} else {
					_this3.$message.error(res.message);
				}
			}, function () {
				_this3.loading = 0;
			});
		},
		cellClick: function cellClick(row, ev, col) {
			if (col.label && col.label == this.$t('app_operate')) {
				return;
			}

			if (col.label == this.$t('app_deviceName') || col.label == this.$t('app_deviceNo')) {

				if (this.tty == 6) {
					this.$setWObj('ndObj', {
						data: row.terminalId
					});
					this.$router.push({
						path: '/non-it-eq/device/detail'
					});
				} else {
					this.$router.push({
						path: '/terList/' + row.terminalId + '/details'
					});
				}
			}
		},
		sortChange: function sortChange(a) {
			switch (a.prop) {
				case 'terminalName':
					this.orderName = '1';
					break;
				case 'terminalNo':
					this.orderName = '2';
					break;
				case 'updateTime':
					this.orderName = '3';
					break;
			}
			this.orderType = a.order == 'descending' ? 'desc' : 'asc';
			this.getList();
		},
		downOperate: function downOperate(vl, row) {
			var _this4 = this;

			this.loading = 1;
			this.$pushFileDownCtrl(row.detailId, vl + '', row.terminalNo, function (res) {
				_this4.loading = 0;
				if (res.status == 200) {
					_this4.getList();
				} else {
					_this4.$message.error(res.message);
				}
			}, function () {
				_this4.loading = 0;
			});
		},
		clickTd: function clickTd(index) {
			switch (index) {
				case 0:
					this.bindVl = '';
					break;
				case 1:
					this.bindVl = '1';
					break;
				case 2:
					this.bindVl = '2';
					break;
				case 3:
					this.bindVl = '3';
					break;
				case 4:
					this.bindVl = '5';
					break;
				case 5:
					this.bindVl = '4';
					break;
			}
			this.getList();
		},
		exportRc: function exportRc() {
			var terminalName = '';
			var orderType = '';
			var status = '';
			window.open(this.$pTaskExport(this.$route.query.tid, terminalName, orderType, status));
		},
		clearn: function clearn() {
			var _this5 = this;

			var tNameVl = this.queryKey ? this.queryKey : '';
			var statusVl = this.bindVl ? this.bindVl : '';
			this.$showConfirm(this.$t("app_tip"), this.$t("app_clearTask"), this.$t("app_sure"), this.$t("app_cancel"), "warning", function () {
				_this5.$delTaskDevice({
					terminalName: tNameVl,
					status: statusVl,
					taskId: _this5.$route.query.tid
				}, function (res) {
					if (res.status === 200) {
						_this5.getList();
					} else {
						_this5.$message(res.message);
					}
				}, "");
			}, "");
		},
		repushFail: function repushFail() {
			var _this6 = this;

			this.loading = 1;
			this.$failTaskRepush(this.$route.query.tid, function (res) {
				_this6.loading = 0;
				if (res.status == 200) {
					_this6.$message.success(res.message);
					_this6.getList();
				} else {
					_this6.$message.error(res.message);
				}
			}, function () {
				_this6.loading = 0;
			});
		},
		delRow: function delRow(row) {
			var _this7 = this;

			this.$showConfirm('', this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warnning', function () {
				var id = row.detailId;
				_this7.loading = 1;

				_this7.$pushDelTask(id, function (res) {
					_this7.loading = 0;
					if (res.status == 200) {
						_this7.getList();
					} else {
						_this7.$message.error(res.message);
					}
				}, function () {
					_this7.loading = 0;
				});
			});
		},
		bcDel: function bcDel() {
			var _this8 = this;

			var hit = 0;
			this.multipleSelection.forEach(function (vl) {
				if (vl.status == '1' || vl.status == '1' || vl.status == '6') {
					hit = 1;
					return;
				}
			});
			if (hit) {
				this.$message.error(this.$t('app_cantDelTask'));
			} else {
				var ids = '';
				this.multipleSelection.forEach(function (vl) {
					ids += vl.detailId + ',';
				});
				ids = ids.substring(0, ids.length - 1);
				if (!ids) {
					this.$message(this.$t('app_oneRecordMust'));
					return;
				}
				this.loading = 1;
				this.$pushDelTask(ids, function (res) {
					_this8.loading = 0;
					if (res.status == 200) {
						_this8.getList();
					} else {
						_this8.$message.error(res.message);
					}
				}, function () {
					_this8.loading = 0;
				});
			}
		},
		cCallback: function cCallback() {
			this.pObj = '';
			this.getList();
		},
		addPush: function addPush() {
			var _this = this;
			this.pObj = {
				type: 0,
				taskId: this.$route.query.tid,
				taskType: this.tty,
				close: this.cCallback
			};
			console.log(this.pObj);
			this.stopTimer();
		},
		showBtn: function showBtn(tag, st) {
			var vl = st + '';

			switch (vl) {
				case '1':
				case '2':
				case '4':
				case '0':
					if (st == 1 && tag == 3) {
						return true;
					} else return tag == 0 ? true : false;
				case '-6':
				case '7':
				case '-7':
				case '-4':
				case '-5':
				case '-8':
				case '-9':
				case '-10':
				case '-1':
				case '-2':
					return tag == 1 || tag == 2 ? true : false;
				case '6':
					return tag == 4 ? true : false;
			}
		},
		getProcess: function getProcess(mIds) {
			var _this9 = this;

			if (!mIds) {
				this.stopTimer();
				return;
			}


			this.$missionPersent(mIds, function (res) {
				if (res.status == 200) {
					var temp = [];
					_this9.pInfo.forEach(function (vl, index) {
						var newData = vl;
						var data = res.data[index];
						if (data.result) {
							newData.value.progress = data.result.progress;
							newData.value.status = data.result.status;
							newData.value.taskStatus = data.result.status;
							var st = data.result.status;
							if (st != 1 && st != 2 && st != 4) {
								_this9.getList();
							}
						} else {
							_this9.getList();
						}
						temp.push(newData);
					});
					_this9.pInfo = temp;


					_this9.pInfo.forEach(function (vl, index) {
						_this9.tableData[vl.index] = vl.value;
					});
				} else {
					_this9.$message.error(res.message);
				}
			}, function () {});
		},
		processCore: function processCore() {
			var _this10 = this;

			console.log('process check...');
			if (this.$route.path !== '/task/ptask/detail') {
				this.stopTimer();
				return;
			}

			var arr = this.tableData;
			this.pInfo = [];
			this.tableData.forEach(function (vl, index) {
				if (vl.taskStatus == '2' || vl.taskStatus == '1') {
					_this10.pInfo.push({
						value: vl,
						index: index
					});
				}
			});
			var ids = '';
			this.pInfo.forEach(function (vl, index) {
				ids += vl.value.detailId + ',';
			});
			ids = ids.substring(0, ids.length - 1);
			this.getProcess(ids);
		},
		stopTimer: function stopTimer() {
			clearInterval(window.pTm);
			clearTimeout(window.gTm);

			window.pTm = '';
			window.gTm = '';
		},
		updateTimer: function updateTimer() {
			var _this11 = this;

			this.stopTimer();

			if (this.$route.path == '/task/ptask/detail') {
				var tg = false;
				this.tableData.forEach(function (obj) {
					if (obj.taskStatus == '4' || obj.taskStatus == '-1') {
						tg = true;
					}
				});
				if (tg) {
					var _this = this;
					window.gTm = setTimeout(function () {
						if (_this.multipleSelection.length == 0) {
							_this.getList();
						}
					}, 6000);
					return;
				}
			} else {
				return;
			}

			window.pTm = setInterval(function () {
				_this11.processCore();
			}, 6000);
		},
		getList: function getList(isDialog) {
			var _this12 = this;

			if (this.$route.path != '/task/ptask/detail') {
				this.stopTimer();
				return;
			}

			var tNameVl = this.queryKey ? this.queryKey : '';
			var statusVl = this.bindVl ? this.bindVl : '';
			var content = this.tContent ? this.tContent : '';

			var taskId = this.$route.query.tid;
			this.loading = 1;
			var _this = this;
			this.$pushTaskDetail(this.orderName, this.orderType, tNameVl, statusVl, this.page, this.$gRow, taskId, function (res) {
				_this12.loading = 0;
				if (res.status == 200) {
					_this12.getDetail(isDialog, res.data.length == 0);

					_this12.tableData = res.data;
					_this12.total = res.total;
				} else {
					_this12.$message.error(res.message);
				}
			}, function () {
				_this12.loading = 0;
			});
		},
		pageChange: function pageChange(vl) {
			this.page = vl;
			this.getList();
		},
		bcbind: function bcbind() {
			var arr = [];
			this.multipleSelection.forEach(function (item) {
				arr.push(item.terminalId);
			});

			this.bindRqs(arr.toString());
		},
		handleSelectionChange: function handleSelectionChange(val) {
			this.multipleSelection = val;
			if (val.length == 0) {
				this.updateTimer();
			}
		},
		editCf: function editCf() {
			this.$setWObj('dvconfigEdit', {
				type: 1,
				data: this.config,
				isSetLc: true
			});
			this.$router.push({
				path: '/dvconfig/detail/edit'
			});
		},
		showBindSt: function showBindSt(row) {
			return this.bindSt[row.useStatus];
		},
		bindOp: function bindOp(row) {

			this.bindRqs(row.terminalId);
		},
		query: function query() {
			this.getList();
		},
		srchDevice: function srchDevice() {
			this.getDevices();
		},
		getDevices: function getDevices() {
			var _this13 = this;

			var vl = this.srchValue ? this.srchValue : '';
			var channel = this.mech1 ? this.mech1 : '';
			var status = this.status ? this.status : '';
			this.loading = 1;
			this.$getDvDevices(this.index, this.$gRow, channel, vl, '', '', '', '', '', '', function (res) {
				console.log('dv', res);
				_this13.loading = 0;
				if (res.data) {
					_this13.tableData = res.data;
					_this13.total = res.total;
				}
			}, function () {
				_this13.loading = 0;
			});
		},
		addTer: function addTer() {},
		deleteApp: function deleteApp(obj) {
			var _this14 = this;

			this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
				console.log(obj);
				_this14.$delFstRecord(obj.detailId, function (res) {
					if (res.status == 200) {
						_this14.getList();
						_this14.$message.success(res.message);
					} else {
						_this14.$message.error(res.message);
					}
				}, '');
			}, '');
		},
		unbind: function unbind(row) {
			var _this15 = this;

			this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {

				_this15.$tcDelDevice(row.detailId, function (res) {
					if (res.status == 200) {
						_this15.getList();
						_this15.$message.success(res.message);
					} else {
						_this15.$message.error(res.message);
					}
				}, '');
			}, '');
		},
		editApp: function editApp(row) {
			this.$setWObj('filestEdit', {
				type: 1,
				data: row
			});
			this.$router.push({
				path: '/stfile/detail/edit'
			});
		},
		pushApp: function pushApp(row) {
			this.$setWObj('pushList', {
				type: '13',
				data: row
			});
			this.$router.push({
				path: '/stfile/detail/push'
			});
		},
		getStatistics: function getStatistics() {
			var _this16 = this;

			this.loading = 1;
			this.$pTaskStatistics(this.$route.query.tid, function (res) {
				_this16.loading = 0;
				if (res.status == 200) {
					_this16.items[0].num = res.data.terminalNum;
					_this16.items[1].num = res.data.successNum;
					_this16.items[2].num = res.data.waitNum;
					_this16.items[3].num = res.data.downloadNum;
					_this16.items[4].num = res.data.failNum;
					_this16.items[5].num = res.data.cancelNum;
				} else {
					_this16.$message(res.message);
				}
			}, function () {
				_this16.loading = 0;
				_this16.$message.error(_this16.$t('app_rqsError'));
			});
		},
		getDetail: function getDetail(isDialog, islsnull) {
			var _this17 = this;

			var param = this.$route.query;
			this.$pTaskProgress(param.tid, function (res) {
				if (res.status == 200) {

					var obj = res.data;

					obj.subTask.forEach(function (item) {
						switch (item.taskType) {
							case '1':
							case '2':
							case '5':
								if (item.installType == 0) {
									item.pop = [_this17.$t('app_tipud')];
								} else {
									item.pop = [_this17.$t('app_forceins')];
								}
								break;
							case '7':
								var tmparr = [];
								var tmparrp = [];
								tmparr = item.installType.split('-');
								tmparr.forEach(function (sitem, index) {
									switch (index) {
										case 0:
											if (sitem == 0) {
												tmparrp.push(_this17.$t('app_tipud'));
											} else {
												tmparrp.push(_this17.$t('app_forceins'));
											}
											break;
										case 1:
											if (sitem == 0) {
												tmparrp.push(_this17.$t('app_insafnorun'));
											} else {
												tmparrp.push(_this17.$t('app_autorun'));
											}
											break;
										case 2:
											if (sitem == 0) {
												tmparrp.push(_this17.$t('app_normalins'));
											} else {
												tmparrp.push(_this17.$t('app_cusins'));
											}
											break;
									}
								});
								item.pop = tmparrp;
								break;
							case '9':
								if (item.content == 'XZYY') {
									if (item.installType == 2) {
										item.pop = [_this17.$t('app_normalunins')];
									} else {
										item.pop = [_this17.$t('app_appuninstall')];
									}
								} else if (item.content == 'HFCCSZ') {
									if (item.installType == 4) {
										item.pop = [_this17.$t('appp_tipoperate')];
									} else {
										item.pop = [_this17.$t('app_forcerun')];
									}
								}
								break;
							default:
								break;
						}
					});

					_this17.info = obj;

					var count = res.data.count;
					_this17.items[0].num = count.terminalNum;
					_this17.items[1].num = count.successNum;
					_this17.items[2].num = count.waitNum;
					_this17.items[3].num = count.downloadNum;
					_this17.items[4].num = count.failNum;
					_this17.items[5].num = count.cancelNum;

					var subtask = res.data.subTask;
					if (subtask.length > 0) {
						var obj = subtask[0];
						_this17.tty = obj.taskType;
					}
					var isRunDia = false;

					if (_this17.$route.query.showdv && isDialog && islsnull) {

						_this17.pObj = {
							type: 0,
							taskId: _this17.$route.query.tid,
							taskType: _this17.tty,
							close: _this17.cCallback
						};
						isRunDia = true;
					}
					if (!isRunDia) {
						_this17.updateTimer();
					}
				} else {
					_this17.$message(res.message);
				}
			}, function () {
				_this17.$message.error(_this17.$t('app_rqsError'));
			});
		},
		getStatus: function getStatus(value) {
			if (!value) return '';
			switch (value) {
				case '0':
					return {
						vl: this.$t('app_prePushVerify'), style: 'color:#8492A6;'
					};
				case '1':
					return {
						vl: this.$t('app_preVerify'), style: 'color:#F7BA2A;'
					};
				case '2':
					return {
						vl: this.$t('app_verifyPass'), style: 'color:#13CE66;'
					};
				case '3':
					return {
						vl: this.$t('app_verifyNotPass'), style: 'color:#FF4949;'
					};
			}
		},
		setInstallType: function setInstallType(type) {
			return this.$installType[type];
		},
		dateFormat: function dateFormat(row, column) {
			var date = row[column.property];
			if (date == undefined) {
				return '';
			}
			return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('YYYY-MM-DD hh:mm:ss');
		},
		selectChange: function selectChange(vl) {
			this.getList();
		},
		pageSelect: function pageSelect(index) {
			this.index = index;
			this.getDevices();
		},
		pageSize: function pageSize(val) {
			this.$gRow = val;
			this.getList();
		},
		delHis: function delHis(row) {
			var _this18 = this;

			this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
				confirmButtonText: this.$t('app_sure'),
				cancelButtonText: this.$t('app_cancel'),
				type: 'warning'
			}).then(function () {
				_this18.loading = 1;
				_this18.$delLauncherHistory(row.versionid, function (res) {
					_this18.loading = 0;
					if (res.status == 200) {
						_this18.getHistory();
						_this18.$message.success(res.message);
					} else {
						_this18.$message.error(res.message);
					}
				}, function () {
					_this18.loading = 0;
				});
			}).catch(function () {});
		},
		imgFullUrl: function imgFullUrl(path) {
			if (path) {
				return this.$urls.prefix + path;
			} else {
				return '';
			}
		},
		getHistory: function getHistory() {
			var _this19 = this;

			if (this.config.status !== '2') {
				return;
			}
			this.loading = 1;
			this.$launcherHistory(this.config.launcherid, function (res) {
				console.log('his', res);
				_this19.loading = 0;
				if (res.status == 200) {
					_this19.tableData = res.data;
				} else {
					_this19.$message.error(res.message);
				}
			}, function () {
				_this19.loading = 0;
			});
		},
		uploadNew: function uploadNew() {
			var obj = {
				type: 2,
				data: this.config
			};
			var key = 'launcherEdit';
			this.$setWObj(key, obj);
			this.$router.push({
				path: '/launch-newver'
			});
		},
		init: function init() {
			this.getList();
			this.getDevices();
		}
	},
	mounted: function mounted() {
		var _this20 = this;

		var _this = this;
		this.tqobj = {
			keys: ['taskType', 'ftype', 'sftype', 'comm'],
			callback: function callback(data) {
				_this20.taskType = data[0];
				_this20.getftype = data[1];
				_this20.getstype = data[2];
				_this20.comm = data[3];
			}
		};

		this.tid = this.$route.query.tid;

		this.getList(true);
	}
});

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_tyc__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_tyc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_tyc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_taskdel_svg__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_taskdel_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_taskdel_svg__);





/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		var _this = this;

		var phoneCheck = function phoneCheck(rule, value, callback) {
			if (!_this.isLegalMobile(value)) {
				callback(new Error(_this.$t('app_phoneIllegal')));
			} else {
				callback();
			}
		};
		return {
			mode: 0,
			delicon: __WEBPACK_IMPORTED_MODULE_2__assets_images_taskdel_svg___default.a,
			vsinfos: [{
				ispop: false,
				p1: false,
				p2: false,
				p3: false
			}, {
				ispop: false,
				p1: false,
				p2: false,
				p3: false
			}],
			tid: '',
			info: '',
			loading: false,
			finalUl: '',
			ulData: [{
				taskType: '',
				content: '',
				fileId: '',
				file: this.$t('app_file'),
				tmptype: '',
				tmpct: '',
				p1: false,
				p2: false,
				p3: false
			}],
			tasktypes: [],
			lcdata: [],
			comms: [],
			tqobj: '',
			tqueryKey: '',
			ftypes: '',
			ttypes_1: '',
			ttypes_2: '',
			getftype: '',
			getstype: '',
			typeVl: '',
			page: 1,
			total: 0,
			tableData: [],
			slFileIndex: -1,
			isSelectFile: false,
			isSelectFile1: false,
			fatherList: [],
			form: {
				tname: '',
				dtype: 1
			},
			rules: {
				tname: [{
					required: true,
					message: this.$t('app_inputName'),
					trigger: 'blur'
				}],
				fileId: [{
					required: true,
					message: this.$t('app_chooseFile'),
					trigger: 'blur'
				}]
			}
		};
	},

	components: {
		tyc: __WEBPACK_IMPORTED_MODULE_0__components_global_tyc___default.a
	},
	computed: {},
	methods: {
		change_device: function change_device(data) {
			var _this2 = this;

			if (data == 1) {
				this.tasktypes = this.ttypes_1;
			} else {
				this.tasktypes = this.ttypes_2;
			}
			this.$nextTick(function () {
				_this2.ulData = [{
					taskType: '',
					content: '',
					fileId: '',
					file: _this2.$t('app_file'),
					tmptype: '',
					tmpct: '',
					p1: false,
					p2: false,
					p3: false
				}];
			});
		},
		getLc: function getLc() {
			var _this3 = this;

			var distributorId = '';
			var orderName = '';
			var orderType = '';
			this.$launcherList(this.page, this.$gRow, this.tqueryKey, distributorId, orderName, orderType, '2', function (res) {
				_this3.lcdata = res.data;
			}, '');
		},
		paramChange: function paramChange(pindex, index) {
			var item = this.ulData[index];
			if (item.content == 'XZYY' && pindex == 2) {
				item.fileId = '';
				if (item.p2) {
					item.file = '';
				} else {
					item.file = this.$t('app_file');
				}
			} else if (item.content == 'ZQ') {
				item.fileId = '';
				item.file = this.$t('app_file');
			}
			this.$set(this.ulData, index, item);
		},
		commChange: function commChange(index, item) {
			if (item.taskType == 9 && item.content != item.tmpct) {
				this.ulData[index].file = this.$t('app_file');
				this.ulData[index].fileId = '';
				this.ulData[index].p1 = false;
				this.ulData[index].p2 = false;
				this.ulData[index].p3 = false;
				this.ulData[index].tmpct = item.content;
			}
		},
		getPopCss: function getPopCss(index, type, ct) {
			var css = '';
			if (index < 2 && this.getPopMenu(type, ct).length != 1) {
				return 'margin-bottom: 10px;' + css;
			} else {
				return 'margin-bottom: 0px;' + css;
			}
		},
		getPopMenu: function getPopMenu(type, ct) {
			var type1 = [this.$t('app_tipud')];
			var type2 = [this.$t('app_tipud'), this.$t('app_autorun'), this.$t('app_cusins')];
			var type3 = [this.$t('app_appuninstall'), this.$t('app_ippkgname')];
			var type4 = [this.$t('app_forcerun')];
			var type5 = [this.$t('app_ippkgname')];
			switch (type + '') {
				case '1':
				case '2':
				case '5':
					return type1;
				case '7':
					return type2;
				case '9':
					if (ct == 'XZYY') {
						return type3;
					} else if (ct == 'ZQ') {
						return type5;
					} else return type4;
			}
		},
		isPop: function isPop(type, ct) {
			switch (type + '') {
				case '1':
				case '2':
				case '5':
				case '7':
					return true;
				case '9':
					if (ct == 'XZYY' || ct == 'HFCCSZ' || ct == 'ZQ') return true;else return false;
				default:
					return false;
			}
		},
		fclose: function fclose() {
			this.tqueryKey = '';
			this.page = 1;
		},
		delrow: function delrow(index) {
			if (this.ulData.length != 1) {
				this.ulData.splice(index, 1);
			} else {
				this.$message(this.$t('lin_global.notNull'));
			}
		},
		getDetail: function getDetail() {
			var _this4 = this;

			this.loading = 1;
			this.$pTaskEdit(this.tid, function (res) {
				_this4.loading = 0;
				if (res.status === 200) {
					if (res.data.subTask[0].taskType == "12" || res.data.subTask[0].taskType == "6") {
						_this4.form.dtype = 2;
						_this4.tasktypes = _this4.ttypes_2;
					} else {
						_this4.form.dtype = 1;
						_this4.tasktypes = _this4.ttypes_1;
					}
					_this4.info = res.data;
					_this4.form.tname = res.data.taskName;
					var arr = [];
					res.data.subTask.forEach(function (vl) {
						var p1 = false,
						    p2 = false,
						    p3 = false;
						var tmpar = [];
						switch (vl.taskType) {
							case '1':
							case '2':
							case '5':
								p1 = vl.installType == '0' ? true : false;
								break;
							case '7':
								tmpar = vl.installType.split('-');
								if (tmpar.length == 3) {
									p1 = tmpar[0] == '0' ? true : false;
									p2 = tmpar[1] == '1' ? true : false;
									p3 = tmpar[2] == '1' ? true : false;
								}
								break;
							case '9':
								if (vl.content == 'XZYY') {
									tmpar = vl.installType.split('-');
									if (tmpar.length == 2) {
										p2 = tmpar[0] == '1' ? true : false;
										p1 = tmpar[1] == '3' ? true : false;
									}
								} else if (vl.content == 'HFCCSZ') {
									p1 = vl.installType == '5' ? true : false;
								} else if (vl.content == 'ZQ') {
									p1 = vl.installType == '0' ? false : true;
								}
								break;
						}
						arr.push({
							taskType: vl.taskType,
							content: vl.content,
							fileId: vl.fileId,
							file: vl.fileName,
							tmptype: vl.taskType,
							tmpct: vl.content,
							p1: p1,
							p2: p2,
							p3: p3
						});
					});
					_this4.ulData = arr;
				} else {
					_this4.$message.error(res.message);
				}
			}, function () {
				_this4.loading = 0;
			});
		},
		checkUlData: function checkUlData() {
			var existnull = false;
			var arr = [];
			this.ulData.forEach(function (vl, index) {
				if (!vl.taskType || !vl.content) {
					existnull = true;
				} else if ((vl.content == 'XZYY' || vl.content == 'ZQ') && !vl.fileId) {
					existnull = true;
				}

				var instype = '';
				switch (vl.taskType + '') {
					case '1':
					case '2':
					case '5':
						instype = vl.p1 ? '0' : '1';
						break;
					case '7':
						instype = (vl.p1 ? '0' : '1') + '-' + (vl.p2 ? '1' : '0') + '-' + (vl.p3 ? '1' : '0');
						break;
					case '9':
						if (vl.content == 'XZYY') {
							instype = vl.p1 ? '3' : '2';
							instype = vl.p2 ? '1-' + instype : '0-' + instype;
						} else if (vl.content == 'HFCCSZ') {
							instype = vl.p1 ? '5' : '4';
						} else if (vl.content == 'ZQ') {
							instype = vl.p1 ? '1' : '0';
						} else instype = '';
						break;
					default:
						instype = '';
						break;
				}
				arr.push({
					num: index + 1,
					taskType: vl.taskType,
					content: vl.content,
					fileId: vl.fileId,
					installType: instype
				});
			});
			if (!existnull) {
				this.finalUl = arr;
			}
			return !existnull;
		},
		addTask: function addTask() {
			this.ulData.push({
				taskType: '',
				content: '',
				fileId: '',
				file: this.$t('app_file'),
				tmptype: '',
				tmpct: '',
				p1: false,
				p2: false,
				p3: false
			});
		},
		sortEv: function sortEv(isUp, index, item) {
			if (isUp && index != 0) {
				var obj = this.ulData[index - 1];
				this.$set(this.ulData, index - 1, item);
				this.$set(this.ulData, index, obj);
			} else if (!isUp && index < this.ulData.length - 1) {
				var obj = this.ulData[index + 1];
				this.$set(this.ulData, index + 1, item);
				this.$set(this.ulData, index, obj);
			} else {

				this.$message(this.$t('app_inbdside'));
			}
		},
		slFile: function slFile(index, type) {
			console.log(index, type);
			this.slFileIndex = index;
			this.typeVl = type;
			var item = this.ulData[index];
			if (type) {
				if (item.content == 'ZQ') {
					this.isSelectFile1 = true;
					this.getLc();
				} else this.getList(true);
			} else {
				this.$message(this.$t('app_plsltype'));
			}
		},
		taskChange: function taskChange(index, item) {

			if (item.taskType != item.tmptype) {
				this.ulData[index].file = this.$t('app_file');
				this.ulData[index].content = '';
				this.ulData[index].fileId = '';
				this.ulData[index].p1 = false;
				this.ulData[index].p2 = false;
				this.ulData[index].p3 = false;
				this.ulData[index].tmptype = item.taskType;
			}
		},
		isRepeatData: function isRepeatData(row) {
			var isrp = false;
			var rowtype = this.ulData[this.slFileIndex].taskType;
			this.ulData.forEach(function (item) {
				var rfid = '';
				if (item.content == 'XZYY' || item.content == 'ZQ') {
					rfid = item.fileId;
				} else {
					rfid = item.content;
				}
				var fid = item.content == 'ZQ' ? row.launcherid : row.fileId;
				if (rfid == fid && rowtype == item.taskType) {
					isrp = true;
					return;
				}
			});
			return isrp;
		},
		selected: function selected(row) {
			console.log(row);

			if (this.ulData[0].taskType == "12" || this.ulData[0].taskType == "6") {
				this.form.dtype = 2;
				this.tasktypes = this.ttypes_2;
			} else {
				this.form.dtype = 1;
				this.tasktypes = this.ttypes_1;
			}
			if (this.isRepeatData(row)) {
				this.$message(this.$t('app_flexist'));
				return;
			}

			var item = this.ulData[this.slFileIndex];
			if (item.content == 'XZYY') {
				item.fileId = row.fileId;
			} else {
				item.content = row.fileId;
			}
			item.file = row.fileName;
			this.$set(this.ulData, this.slFileIndex, item);

			this.isSelectFile = false;
			this.fclose();
			this.rblur();
		},
		selected1: function selected1(row) {

			if (this.isRepeatData(row)) {
				this.$message(this.$t('app_flexist'));
				return;
			}

			var item = this.ulData[this.slFileIndex];
			item.fileId = row.launcherid;
			item.file = row.launchername;
			this.$set(this.ulData, this.slFileIndex, item);
			this.isSelectFile1 = false;
			this.fclose();
			this.rblur();
		},
		tquery: function tquery() {
			this.getList();
		},
		tquery1: function tquery1() {
			this.getLc();
		},
		setType: function setType(row) {
			return this.getftype[row.fileType];
		},
		setSType: function setSType(row) {
			return this.getstype[row.subFileType];
		},
		pageSelect: function pageSelect(page) {
			this.page = page;
			this.getList();
		},
		pageSized: function pageSized(size) {
			this.$gRow = size;
			this.getList();
		},
		getList: function getList(isShow) {
			var _this5 = this;

			this.loading = 1;
			var name = this.tqueryKey;
			var mcid = '';
			var ftype = this.typeVl == 9 ? '7' : this.typeVl;
			this.$pTaskPushList(this.page, this.$gRow, name, mcid, ftype, '', function (res) {
				_this5.loading = 0;

				if (res.status == 200) {
					_this5.tableData = res.data;
					_this5.total = res.total;

					if (isShow) {
						_this5.isSelectFile = true;
					}
				} else {
					_this5.$message.error(res.message);
				}
			}, function () {
				_this5.loading = 0;
			});
		},
		isLegalMobile: function isLegalMobile(tel) {
			var sMobile = tel;
			var regex = "^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\\d{8}$";
			var re = new RegExp(regex, 'g');
			if (!re.test(sMobile)) {
				return false;
			} else {
				return true;
			}
		},
		newform: function newform() {
			var _this6 = this;

			this.loading = 1;

			this.$pTaskAddTask(this.form.tname, this.finalUl, function (res) {
				_this6.loading = 0;
				if (res.status === 200) {
					if (res.data) {
						_this6.$router.push({
							path: '/task/ptask/detail',
							query: {
								fid: res.data.fileId,
								tid: res.data.taskId,
								tty: res.data.taskType,
								showdv: 1
							}
						});
					}
				} else {
					_this6.$message.error(res.message);
				}
			}, function () {
				_this6.loading = 0;
			});
		},
		editform: function editform() {
			var _this7 = this;

			this.loading = 1;
			this.$pTaskEditTask(this.tid, this.form.tname, this.finalUl, function (res) {
				_this7.loading = 0;
				if (res.status === 200) {
					_this7.$router.go(-1);
				} else {
					_this7.$message.error(res.message);
				}
			}, function () {
				_this7.loading = 0;
			});
		},
		rblur: function rblur() {
			this.$refs['form'].validate(function (valid) {
				if (valid) {} else {
					return false;
				}
			});
		},
		save: function save(name) {
			var _this8 = this;

			if (!this.checkUlData()) {
				this.$message(this.$t('app_inputCp'));
				return;
			}

			this.$refs[name].validate(function (valid) {
				if (valid) {

					if (_this8.tid) {
						_this8.editform();
					} else {
						_this8.newform();
					}
				} else {
					return false;
				}
			});
		},
		cancel: function cancel() {
			this.$router.go(-1);
		}
	},
	mounted: function mounted() {
		var _this9 = this;

		var wcomm = this.$getWObj().login.userType == 0 ? 'comms1' : 'comms';
		this.tqobj = {
			keys: ['ftypes', 'ftype', 'sftype', 'taskTypeArr1', wcomm, 'taskTypeArr1_1', 'taskTypeArr1_2'],
			callback: function callback(data) {
				console.log(data);
				_this9.ftypes = data[0];
				_this9.getftype = data[1];
				_this9.getstype = data[2];

				_this9.comms = data[4];
				_this9.tasktypes = data[5];
				_this9.ttypes_1 = data[5];
				_this9.ttypes_2 = data[6];
			}
		};

		this.mode = this.$route.query.mode;
		this.tid = this.$route.query.tid;
		switch (this.mode) {
			case 2:
				var cftype = this.$route.query.ftype;
				if (cftype == '9') {
					cftype = '10';
				} else if (cftype == '10') {
					cftype = '11';
				} else if (cftype == '11') {
					cftype = '12';
				}
				this.ulData[0].taskType = cftype;
				this.slFileIndex = 0;
				this.form.tname = this.$route.query.fname;
				this.$pTaskPushList(1, 10, '', '', '', this.$route.query.fid, function (res) {
					if (res.data.length == 1) {
						_this9.selected(res.data[0]);
					}
				}, '');
				break;
			default:
				if (this.tid) {
					this.getDetail();
				}
		}
	}
});

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pushdia_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pushdia_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pushdia_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_tyc_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_tyc_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_tyc_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_global_tagc_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_global_tagc_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_global_tagc_vue__);









/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		var that = this;
		return {
			batchData: [],
			orderName: '',
			orderType: '',
			tsTypes: [],
			pObj: '',
			tqobj: '',

			popover5: false,
			pushdev: false,
			mechanismData: {
				callback: function callback(value) {
					that.selectChange(value);
				}
			},
			info: {},
			listKey: 'launch-list',
			tableData1: [],
			page1: 1,
			total1: 0,
			missionNames: '',
			missionList: '',
			cerDialogVisible: false,
			cerTipDialogVisible: false,
			dvLoading: 0,
			index: 1,
			appId: '',
			stModel: [{
				label: this.$t('app_online'),
				vl: '1'
			}, {
				label: this.$t('app_offline'),
				vl: '2'
			}, {
				label: this.$t('app_new'),
				vl: '0'
			}],
			channels: [],
			cmsts: [],
			srchValue: '',
			channelId: '',
			cerTipMsg: '',
			status: '',
			dvIndex: 1,
			ftype: '',
			sftype: '',
			dialogVisible: 0,
			mechanismId: window.localStorage['mechanismId'],
			selectMid: '',
			tableData: [],
			dvTableData: [],
			appTypes: [],
			appTypeValue: '',
			appStatus: [{
				label: this.$t('app_prePushVerify'),
				value: '0'
			}, {
				label: this.$t('app_preVerify'),
				value: '1'
			}, {
				label: this.$t('app_verifyPass'),
				value: '2'
			}, {
				label: this.$t('app_verifyNotPass'),
				value: '3'
			}],
			appStatusValue: '',
			total: 0,
			dvTotal: 0,
			loading: 0,
			appType: '',
			queryKey: '',
			terno: '',
			ftypes: '',
			getftype: '',
			sftypes1: [],
			sftypes2: [],
			sftypes3: [],
			sftypes5: [],
			sftypes6: [],
			sftypes7: [],
			sftypes9: [],
			sftypes10: [],
			getsftype: ''
		};
	},

	components: {
		MechanismSelector: __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default.a,
		pushdia: __WEBPACK_IMPORTED_MODULE_2__pushdia_vue___default.a,
		tyc: __WEBPACK_IMPORTED_MODULE_3__components_global_tyc_vue___default.a,
		tagc: __WEBPACK_IMPORTED_MODULE_4__components_global_tagc_vue___default.a
	},
	computed: {
		index: function index() {
			var vl = this.$getWPage(this.listKey);
			return vl ? vl : 1;
		},
		cantdel: function cantdel() {
			var is = false;
			this.batchData.forEach(function (item) {
				if (item.terNum != item.success) {
					is = true;
				}
			});
			return is;
		},
		getDvStatus: function getDvStatus(value) {
			switch (value) {
				case '0':
					return this.$t('app_prePushVerify');
				case '1':
					return this.$t('app_preVerify');
				case '2':
					return this.$t('app_verifyPass');
				case '3':
					return this.$t('app_verifyNotPass');
			}
		}
	},
	methods: {
		batchDel: function batchDel() {
			var _this2 = this;

			this.$showConfirm(this.$t('app_tip'), this.$t('app_tipAppEdit'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {

				var tids = [];
				_this2.batchData.forEach(function (item) {
					tids.push(item.taskId);
				});

				_this2.$pTaskDelall(tids.toString(), function (res) {
					if (res.status == 200) {
						_this2.getList();
						_this2.$message.success(res.message);
					} else {
						_this2.$message.error(res.message);
					}
				}, '');
			}, '');
		},
		handleSelectionChange: function handleSelectionChange(data) {
			this.batchData = data;
		},
		sortChange: function sortChange(vl) {
			switch (vl.prop) {
				case 'taskName':
					this.orderName = '1';
					break;
				case 'createTime':
					this.orderName = '2';
					break;
			}
			this.orderType = vl.order == 'descending' ? 'desc' : 'asc';
			this.getList();
		},
		editRow: function editRow(row) {
			this.$router.push({
				path: '/task/ptask/edit',
				query: {
					tid: row.taskId
				}
			});
		},
		cancelPush: function cancelPush(row) {
			var _this3 = this;

			this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
				_this3.$pTaskDelall(row.taskId, function (res) {
					if (res.status === 200) {
						_this3.getList();
						_this3.$message.success(res.message);
					} else {
						_this3.$message.error(res.message);
					}
				}, '');
			}, '');
		},
		addDev: function addDev(row) {
			console.log(row);
			var _this = this;
			this.pObj = {
				type: 0,
				taskId: row.taskId,
				taskType: row.taskType,
				close: function close() {
					_this.pObj = '';
					_this.getList();
				}
			};
		},
		fileTypeChange: function fileTypeChange(vl) {
			this.sftype = '';
			if (!vl) {
				this.cmsts = '';
			} else this.cmsts = this['sftypes' + vl];
			this.getList();
		},
		setft: function setft(row) {
			return this.getftype[row.fileType];
		},
		setsbt: function setsbt(row) {

			var vl = this.getsftype[row.subFileType];

			return vl;
		},
		pushCreateCer: function pushCreateCer() {
			this.$router.push({
				path: "/certificate/new"
			});
		},
		pushUploadCer: function pushUploadCer() {
			this.$router.push({
				path: "/certificate/upload"
			});
		},
		bindOperate: function bindOperate(row) {
			var _this4 = this;

			this.dvLoading = 1;
			if (this.$appUrlTag === 0) {
				this.$bindApp('0', row.terminalNo, this.appId, function (res) {
					if (res.status === 200) {
						_this4.$message.success(_this4.$t('app_tipViewTask'));
					} else {
						_this4.$message.error(res.message);
					}
					_this4.dvLoading = 0;
				}, function () {
					_this4.dvLoading = 0;
				});
			} else {
				this.$bindApp1(localStorage.mechanismId, row.terminalNo, this.appId, function (res) {
					if (res.status === 200) {
						_this4.$message.success(_this4.$t('app_tipViewTask'));
					} else {
						_this4.$message.error(res.message);
					}
					_this4.dvLoading = 0;
				}, function () {
					_this4.dvLoading = 0;
				});
			}
		},
		getChannels: function getChannels() {
			var _this5 = this;

			this.$getChannelList(10000, 1, '', '', '', function (res) {
				if (res.status === 200) {
					_this5.channels = res.data;
				} else {
					_this5.$message.error(res.message);
				}
			}, function () {
				_this5.$message.error(_this5.$t('app_rqsError'));
			});
		},
		getStatus: function getStatus(value) {
			if (!value) return '';
			switch (value) {
				case '0':
					return {
						vl: this.$t('app_prePushVerify'), style: 'color:#8492A6;'
					};
				case '1':
					return {
						vl: this.$t('app_preVerify'), style: 'color:#F7BA2A;'
					};
				case '2':
					return {
						vl: this.$t('app_verifyPass'), style: 'color:#13CE66;'
					};
				case '3':
					return {
						vl: this.$t('app_verifyNotPass'), style: 'color:#FF4949;'
					};
			}
		},
		srchDevice: function srchDevice() {
			this.getDevices();
		},
		selectDvChange: function selectDvChange(vl) {
			this.getDevices();
		},
		pageDvSized: function pageDvSized(val) {
			this.$gRow = val;
			this.getDevices();
		},
		getDevices: function getDevices() {
			var _this6 = this;

			var vl = this.srchValue ? this.srchValue : '';
			var channel = this.channelId ? this.channelId : '';
			var status = this.status ? this.status : '';
			var appId = this.appId ? this.appId : '';
			this.dvLoading = 1;
			if (this.$appUrlTag === 0) {
				this.$getDevices(this.dvIndex, this.$gRow, channel, vl, status, '', appId, function (res) {
					_this6.dvLoading = 0;
					if (res.data) {
						_this6.dvTableData = res.data;
						_this6.dvTotal = res.total;
					}
				}, function () {
					_this6.dvLoading = 0;
				});
			} else {

				this.$getDevices1(this.dvIndex, this.$gRow, localStorage.mechanismId, vl, status, '', appId, function (res) {
					console.log('dv', res);
					_this6.dvLoading = 0;
					if (res.data) {
						_this6.dvTableData = res.data;
						_this6.dvTotal = res.total;
					}
				}, function () {
					_this6.dvLoading = 0;
				});
			}
		},
		editApp: function editApp(row) {
			this.$setWObj('fileEdit', {
				type: 1,
				data: row
			});
			this.$router.push({
				path: '/filemg/edit'
			});
		},
		pushApp: function pushApp(row) {

			this.$setWObj('filePush', row);
			this.$router.push({
				path: '/filemg/push'
			});
		},
		query: function query() {
			this.getList();
		},
		selectChange: function selectChange(vl) {
			this.selectMid = vl;
			this.getList1();
		},
		reset: function reset() {
			this.queryKey = '';
			this.appType = '';
			this.getList();
		},
		pageSelect: function pageSelect(index) {
			this.index = index;
			this.getList();
		},
		pageSelect1: function pageSelect1(index) {
			this.page1 = index;
			this.getList1();
		},
		pageDvSelect: function pageDvSelect(index) {
			this.dvIndex = index;
			this.getDevices();
		},
		pageSized: function pageSized(val) {
			this.$gRow = val;
			this.getList();
		},
		pageSized1: function pageSized1(val) {
			this.$gRow = val;
			this.getList1();
		},
		deleteApp: function deleteApp(obj) {
			var _this7 = this;

			this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
				console.log(obj);
				_this7.$delfile(obj.fileId, function (res) {
					if (res.status === 200) {
						_this7.getList();
						_this7.$message.success(res.message);
					} else {
						_this7.$message.error(res.message);
					}
				}, '');
			}, '');
		},
		submitApp: function submitApp(obj) {
			var _this8 = this;

			this.$showConfirm(this.$t('app_tip'), this.$t('app_tipVerify'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
				_this8.loading = 1;
				_this8.$verifyFile(obj.fileId, '', '1', function (res) {
					_this8.loading = 0;
					if (res.status === 200) {
						_this8.getList();
						_this8.$message.success(res.message);
					} else {
						_this8.$message.error(res.message);
					}
				}, function () {
					_this8.loading = 0;
				});
			}, '');
		},
		cellClick: function cellClick(row, ev, col) {
			if (!col.label || col.label === this.$t('app_operate')) {
				return;
			}

			this.$router.push({
				path: '/task/ptask/detail',
				query: {
					tid: row.taskId,
					tty: row.taskType
				}
			});
		},
		jumpToUpload: function jumpToUpload() {
			this.$router.push({
				path: '/task/ptask/new'
			});
		},
		getList: function getList() {
			var _this9 = this;

			this.loading = 1;
			var mech = this.selectMid ? this.selectMid : '';
			var name = this.queryKey ? this.queryKey : '';
			var type = this.ftype ? this.ftype : '';
			var stype = this.sftype;
			var st = '';

			this.$pTaskList(this.index, this.$gRow, type, name, this.orderName, this.orderType, this.terno, function (res) {

				_this9.loading = 0;
				if (res.status === 200) {
					_this9.total = res.total;
					_this9.tableData = res.data;
				} else {
					_this9.$message(res.message);
				}
			}, function () {
				_this9.loading = 0;
				_this9.$message.error(_this9.$t('app_rqsError'));
			});
		},
		dateFormat: function dateFormat(row, column) {
			var date = row[column.property];
			if (date === undefined) {
				return '';
			}
			return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD HH:mm:ss');
		},
		setInstallType: function setInstallType(type) {
			return this.$installType[type];
		}
	},
	mounted: function mounted() {

		var _this = this;
		this.tqobj = {
			keys: ['taskType', 'taskTypeArr', 'ftypes', 'ftype', 'sftype', 'sftypes1', 'sftypes2', 'sftypes3', 'sftypes4', 'sftypes5', 'sftypes6', 'sftypes7', 'taskTypeArr2', 'sftypes9'],
			callback: function callback(data) {
				_this.missionNames = data[0];
				_this.missionList = data[1];
				_this.ftypes = data[2];
				_this.getftype = data[3];
				_this.getsftype = data[4];
				_this.sftypes1 = data[5];
				_this.sftypes2 = data[6];
				_this.sftypes3 = data[7];
				_this.sftypes4 = data[8];
				_this.sftypes5 = data[9];
				_this.sftypes6 = data[10];
				_this.sftypes7 = data[11];
				_this.tsTypes = data[12];
				_this.sftypes9 = data[13];
			}
		};

		this.getList();
	},
	destroyed: function destroyed() {}
});

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_tyc__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_tyc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_global_tyc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_tagc__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_tagc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_tagc__);







/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		var that = this;
		return {
			ttpage: 20,
			tqobj: '',
			cmtStatus: '',
			cmtStatusArr: [],
			isNon: false,
			downTpl: __WEBPACK_IMPORTED_MODULE_1__api_url__["b" /* urlAssets */].prefix + 'tms-server-web/model/terminalNos.xlsx',
			formLabelWidth: '28.5%',
			fileList: [],
			uldata: '',
			snum: 0,
			check1: false,
			check2: false,
			pushImport: false,
			tableData: [],
			total: 0,
			page: 1,
			multipleTable: [],
			loading: false,
			pushdev: false,
			mech: '',
			queryKey: '',
			snBegin: "",
			snEnd: "",
			importTemplate: __WEBPACK_IMPORTED_MODULE_1__api_url__["b" /* urlAssets */].prefix + 'tms-server-web/import/terminalList.do',
			mechanismData: {
				value: null,
				placeholder: that.$t('lin_global.place_areaid'),
				callback: function callback(value) {
					that.mech = value;
					that.getCmDv();
				}
			}
		};
	},

	props: ["pObj"],
	watch: {
		pObj: function pObj(newVl, oldVl) {
			if (!this.pushdev && newVl) {
				this.getCmDv();
				this.pushdev = true;
			}
		}
	},
	components: {
		MechanismSelector: __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default.a,
		tyc: __WEBPACK_IMPORTED_MODULE_2__components_global_tyc___default.a,
		tagc: __WEBPACK_IMPORTED_MODULE_3__components_global_tagc___default.a
	},
	computed: {},
	methods: {
		submitUpload: function submitUpload() {
			var _this2 = this;

			if (this.pObj.type == 1) {
				this.loading = true;
				this.$sysconfigPush(this.pObj.configId, '', '2', '', '', this.uldata.fileNo, this.snBegin, this.snEnd, function (res) {
					_this2.loading = false;
					if (res.status === 200) {
						_this2.$message.success(res.message);
						_this2.pushdev = false;
					} else {
						_this2.$message.error(res.message);
					}
				}, function () {
					_this2.loading = false;
				});
				this.pushImport = false;
				return;
			}

			this.loading = true;
			this.$appendPush(this.pObj.taskId, '', '2', '', '', this.uldata.fileNo, '', '', '', function (res) {
				_this2.loading = false;
				if (res.status === 200) {
					_this2.$message.success(res.message);
					_this2.pushdev = false;
				} else {
					_this2.$message.error(res.message);
				}
			}, function () {
				_this2.loading = false;
			});

			this.pushImport = false;
		},
		ulError: function ulError() {
			window[this.$route.path] = '';
		},
		srcSuccess: function srcSuccess(res, file) {
			window[this.$route.path] = '';


			if (res.status === 200) {
				this.fileList = [{
					name: file.name
				}];
				this.uldata = res.data;
			} else {

				this.srcList = [];

				this.$message.error(res.message);
			}
		},
		srcBefore: function srcBefore(file) {
			window[this.$route.path] = 1;
		},
		closeImport: function closeImport() {
			this.fileList = [];
			this.uldata = '';
		},
		handleClose: function handleClose() {
			this.snBegin = "";
			this.snEnd = "";
			if (this.pObj.close) {
				this.pObj.close();
			}
		},
		handleSelectionChange: function handleSelectionChange(vl) {
			this.snum = vl.length;
			this.multipleTable = vl;
		},
		query: function query() {
			this.getCmDv();
		},
		fileImport: function fileImport() {
			this.pushImport = true;
		},
		pushAll: function pushAll() {
			var _this3 = this;

			this.$showConfirm(this.$t('app_tip'), this.$t('app_ispushalldv') + ' ?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {

				if (_this3.pObj.type == 1) {
					_this3.loading = true;
					_this3.$sysconfigPush(_this3.pObj.configId, '', '1', _this3.mech, _this3.queryKey, '', _this3.snBegin, _this3.snEnd, function (res) {
						_this3.loading = false;
						if (res.status === 200) {
							_this3.$message.success(res.message);
							_this3.pushdev = false;
						} else {
							_this3.$message.error(res.message);
						}
					}, function () {
						_this3.loading = false;
					});
					return;
				}

				var terminalstats = _this3.cmtStatus;

				_this3.loading = true;
				_this3.$appendPush(_this3.pObj.taskId, '', '1', _this3.mech, _this3.queryKey, '', terminalstats, _this3.snBegin, _this3.snEnd, function (res) {
					_this3.loading = false;
					if (res.status === 200) {
						_this3.$message.success(res.message);
						_this3.pushdev = false;
					} else {
						_this3.$message.error(res.message);
					}
				}, function () {
					_this3.loading = false;
				});
			}, '');
		},
		bcPush: function bcPush() {
			var _this4 = this;

			var nos = [];
			this.multipleTable.forEach(function (obj) {
				nos.push(obj.terminalNo);
			});

			var tip = this.$t('app_surepsxdv').replace('{num}', this.multipleTable.length);

			this.$showConfirm(this.$t('app_tip'), tip + ' ?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
				_this4.pushRqs(nos.toString());
			}, '');
		},
		pushed: function pushed(row) {
			var _this5 = this;

			this.$showConfirm(this.$t('app_tip'), this.$t('app_srpush') + ' ?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
				_this5.pushRqs(row.terminalNo);
			}, '');
		},
		pushRqs: function pushRqs(nos) {
			var _this6 = this;

			this.loading = true;

			if (this.pObj.type == 1) {
				this.$sysconfigPush(this.pObj.configId, nos, '0', '', '', '', '', '', function (res) {
					_this6.loading = false;
					if (res.status === 200) {
						_this6.$message.success(res.message);
						_this6.pushdev = false;
					} else {
						_this6.$message.error(res.message);
					}
				}, function () {
					_this6.loading = false;
				});
				return;
			}

			this.$appendPush(this.pObj.taskId, nos, '0', '', '', '', '', '', '', function (res) {
				_this6.loading = false;
				if (res.status === 200) {
					_this6.$message.success(res.message);
					_this6.pushdev = false;
				} else {
					_this6.$message.error(res.message);
				}
			}, function () {
				_this6.loading = false;
			});
		},
		pageSized: function pageSized(vl) {
			this.ttpage = vl;
			this.getCmDv();
		},
		pageSelect: function pageSelect(vl) {
			this.page = vl;
			this.getCmDv();
		},
		getCmDv: function getCmDv() {

			if (this.pObj.type != 1 && (this.pObj.taskType == 6 || this.pObj.taskType == 14 || this.pObj.taskType == 15 || this.pObj.taskType == 12)) {
				this.isNon = true;
				this.getNonDevices();
			} else {
				this.isNon = false;
				this.getDv();
			}

			var _this = this;
			var typeKey = this.isNon ? 'nonTerTypes' : 'terminalTypes';
			this.tqobj = {
				keys: [typeKey],
				callback: function callback(data) {
					_this.cmtStatusArr = data[0];
				}
			};
		},
		getNonDevices: function getNonDevices() {
			var _this7 = this;

			var channel = this.mech;
			var terminalNo = this.queryKey;
			var status = this.cmtStatus;

			this.loading = 1;
			this.$getNonItDv(this.page, this.ttpage, channel, terminalNo, status, '', '', '', this.snBegin, this.snEnd, function (res) {
				_this7.loading = 0;
				if (res.data) {
					_this7.tableData = res.data;
					_this7.total = res.total;
				}
			}, function () {
				_this7.loading = 0;
			});
		},
		getDv: function getDv() {
			var _this8 = this;

			this.loading = true;
			var mc = this.mech;
			var tno = this.queryKey;
			var tstatus = this.cmtStatus;
			var trstatus = '';

			this.$getDvDevices(this.page, this.ttpage, mc, tno, tstatus, trstatus, '', '', this.snBegin, this.snEnd, function (res) {
				_this8.loading = 0;
				if (res.status === 200) {
					_this8.tableData = res.data;
					_this8.total = res.total;
				} else {
					_this8.$message.error(res.message);
				}
			}, function () {
				_this8.loading = 0;
			});
		},
		test: function test() {
			this.$showConfirm(this.$t('app_tip'), this.$t('app_tipVerify'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {}, '');
		}
	},
	mounted: function mounted() {},
	destroyed: function destroyed() {}
});

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_url__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			dialogVisible: false,
			ota: "OTA",
			focusEvent: __WEBPACK_IMPORTED_MODULE_1__api_url__["c" /* focusEvent */],
			ifshow: false,
			radio: '',
			content: '',
			showTable: false,
			qudao: '',
			arrdata: [],
			userinfo: {},
			currentPage: 1,
			pageSize: 10,
			input1: '',
			totalRecords: 0
		};
	},
	created: function created() {
		this.getDetail();
		this.getData(1, '');
	},
	mounted: function mounted() {},

	computed: {
		dtitle: function dtitle() {
			return this.$t('app_srban');
		},
		ddes: function ddes() {
			return this.$t('app_banandrs');
		}
	},
	methods: {
		change: function change() {
			if (this.radio == '3') {
				this.ifshow = true;
			} else {
				this.ifshow = false;
			}
		},
		give: function give(no) {
			var _this = this;

			var romId = this.$route.params.id;
			var token = localStorage.getItem('user');
			var params = { ota_rom_id: romId, type: "1", token: token, targetId: no };

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/ota_rom/push.do', params).then(function (res) {
				if (res.data.status == 200) {
					_this.$message(_this.$t('lin_global.task_tips2'));
				} else {
					_this.$message.error(res.data.message);
				}
			});
		},
		showTableE: function showTableE() {
			this.showTable = true;
		},
		handleIconClick: function handleIconClick() {
			this.getData(1, this.input1);
		},
		getData: function getData(page, no) {
			var _this2 = this;

			this.currentPage = page;
			var params = {
				page: page,
				rows: this.pageSize,
				terminal_no: no,
				areaid: '',
				terminal_status: '',
				terminal_runtime_status: ''
			};

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/terminal/list.do', params).then(function (res) {
				if (res.data.status == 200) {
					_this2.arrdata = res.data.data;
					_this2.totalRecords = res.data.total;
				} else {}
			}).catch(function (error) {});
		},

		formatStatus: function formatStatus(row, column) {
			switch (row.terminal_status) {
				case '0':
					return this.$t('lin_global.new_add');
					break;
				case '1':
					return this.$t('lin_global.online');
					break;
				case '2':
					return this.$t('lin_global.offline');
					break;
				case '3':
					return this.$t('app_sleep');
					break;
			}
		},
		handleSizeChange: function handleSizeChange(val) {
			this.pageSize = val;
			this.getData(this.currentPage, '');
		},
		handleCurrentChange: function handleCurrentChange(val) {
			this.currentPage = val;
			this.getData(this.currentPage, '');
		},
		submit: function submit(vl) {
			var _this3 = this;

			var token = localStorage.getItem('user');
			var romId = this.$route.params.id;
			var params = { token: token, ota_rom_id: romId, content: this.content, status: vl };
			if (false) {
				this.$message.error(this.$t('lin_global.xztghbtg'));
			} else {
				if (vl === '3') {
					if (!this.content) {
						this.$message.error(this.$t('app_noInput') + this.$t('app_banReason'));
						return;
					}
					__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/ota_rom/audit.do', params).then(function (res) {
						if (res.data.status == 200) {
							_this3.$message.success(_this3.$t('lin_global.shcg'));
							_this3.getData(1, '');
							_this3.$router.go(-1);
						} else {
							_this3.$message.error(res.data.message);
						}
					});
					return;
				}
				this.$confirm(this.$t('lin_global.qrtj'), this.$t('lin_btn.tips'), {
					confirmButtonText: this.$t('lin_btn.confirm'),
					cancelButtonText: this.$t('lin_btn.cancel'),
					type: 'warning'
				}).then(function () {
					__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/ota_rom/audit.do', params).then(function (res) {
						if (res.data.status == 200) {
							_this3.$message.success(_this3.$t('lin_global.shcg'));
							_this3.getData(1, '');
							_this3.$router.go(-1);
						} else {
							_this3.$message.error(res.data.message);
						}
					});
				}).catch(function () {});
			}
		},
		getDetail: function getDetail() {
			var _this4 = this;

			var romId = this.$route.params.id;
			var params = { id: romId };
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/ota_rom/detail.do', params).then(function (res) {
				if (res.data.status == 200) {
					_this4.userinfo = res.data.data;
					if (res.data.data.mechanismName !== '') {
						_this4.qudao = res.data.data.mechanismName;
					} else {
						_this4.qudao = _this4.$t('lin_global.all_mechanism');
					}
				}
			});
		},
		onCancel: function onCancel() {
			this.$router.go(-1);
		}
	}
});

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		MechanismSelector: __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue___default.a
	},
	data: function data() {
		var that = this;
		return {
			mechanismData: {
				value: null,
				placeholder: that.$t('lin_global.place_areaid'),
				callback: function callback(value) {
					that.form.mechanismId = value;
				}
			},
			checked: false,
			action: '' + __WEBPACK_IMPORTED_MODULE_1__api_url__["b" /* urlAssets */].fileUrl,
			form: {
				id: this.$route.params.id,
				status: '0',
				name: '',
				md5: '',
				version: '',
				memo: '',
				type: 'ota',
				autoSign: '1',
				mechanismId: '',
				filePath: '',
				updateType: ''
			},
			rules: {
				'name': [{
					required: true,
					message: this.$t('lin_global.notBlankName')
				}],
				'version': [{
					required: true,
					message: this.$t('lin_global.notBlankVer')
				}],
				'type': [{
					required: true,
					message: this.$t('lin_global.qxzlx')
				}],
				'filePath': [{
					required: true,
					message: this.$t('lin_global.qxzscwj')
				}]
			},
			areaList: []
		};
	},
	created: function created() {
		this.getDetail();
	},

	methods: {
		check: function check() {
			if (this.checked) {
				this.form.autoSign = '0';
			} else {
				this.form.autoSign = '1';
			}
		},
		handleAvatarScucess: function handleAvatarScucess(res, file) {
			this.form.filePath = res.fileUrl;
			this.form.md5 = res.md5;
		},
		beforeAvatarUpload: function beforeAvatarUpload(file) {},

		getAd: function getAd() {
			var _this = this;

			var params = { page: 1, rows: 10000 };
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/mechanism/list.do', params).then(function (res) {
				var obj = {
					'mechanismname': _this.$t('lin_global.syqdsty'),
					'mechanismid': ''
				};
				_this.areaList = res.data.data;

				_this.areaList.unshift(obj);
			});
		},
		getDetail: function getDetail() {
			var _this2 = this;

			var romId = this.$route.params.id;
			var params = { id: romId };
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/ota_rom/detail.do', params).then(function (res) {
				if (res.data.status == 200) {
					_this2.form.name = res.data.data.name;
					_this2.form.version = res.data.data.version;
					_this2.form.memo = res.data.data.memo;
					_this2.form.type = res.data.data.type;
					_this2.form.updateType = res.data.data.updateType;
					if (res.data.data.autosign == 0) {
						_this2.checked = true;
					} else {
						_this2.checked = false;
					}
					_this2.form.mechanismId = res.data.data.mechanismId;

					_this2.mechanismData.value = res.data.data.mechanismId;

					console.log(_this2.mechanismData.value);
					console.log(_this2.mechanismData.value);
					console.log(_this2.mechanismData.value);
					_this2.form.filePath = res.data.data.path;
				}
			});
		},
		onSubmit: function onSubmit() {
			var _this3 = this;

			var params = this.form;
			params.md5 = this.form.md5;

			console.log('ppp', params);
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/ota_rom/edit.do', params).then(function (res) {
				if (res.data.status == 200) {
					_this3.$message.success(res.data.message);
					_this3.$router.go(-1);
				} else {
					_this3.$message.error(res.data.message);
				}
			});
		},
		onCancel: function onCancel() {
			this.$router.go(-1);
		}
	}
});

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_url__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		MechanismSelector: __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default.a
	},
	data: function data() {
		var that = this;
		return {
			mechanismData: {
				placeholder: that.$t('lin_global.place_areaid'),
				callback: function callback(value) {
					that.mech = value;
					that.selectChange();
				}
			},
			focusEvent: __WEBPACK_IMPORTED_MODULE_2__api_url__["c" /* focusEvent */],
			selectType: '',
			arrdata: [],
			currentPage: 1,
			pageSize: 10,
			totalRecords: 0,
			mech: '',
			name: '',
			type: [{
				value: '',
				label: this.$t('lin_global.allType')
			}, {
				value: '0',
				label: this.$t('app_ttPkg')
			}, {
				value: '1',
				label: this.$t('app_dfPkg')
			}]
		};
	},
	created: function created() {
		this.getData(1, '');
	},

	methods: {
		selectChange: function selectChange() {
			this.getData(this.currentPage, this.name);
		},
		push: function push(row) {

			this.$setWObj('pushList', { type: '2', data: row });
			this.$router.push({ path: '/romList/romPush' });
		},
		otaUdType: function otaUdType(key) {
			var vls = { '0': this.$t('app_ttPkg'), '1': this.$t('app_dfPkg') };
			return vls[key];
		},

		submitRow: function submitRow(id) {
			var _this = this;

			var token = localStorage.getItem('user');
			var params = { token: token, ota_rom_id: id, content: '', status: 1 };
			this.$confirm(this.$t('lin_global.qdtjsh'), this.$t('lin_btn.tips'), {
				confirmButtonText: this.$t('lin_btn.confirm'),
				cancelButtonText: this.$t('lin_btn.cancel'),
				type: 'warning'
			}).then(function () {
				__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/ota_rom/audit.do', params).then(function (res) {
					if (res.data.status == 200) {
						_this.$message.success(_this.$t('lin_global.tjshcg'));
						_this.getData(1, '');
					} else {
						_this.$message.error(res.data.message);
					}
				});
			}).catch(function () {});
		},
		editRow: function editRow(id) {
			this.$router.push({ path: '/romList/' + id + '/edit' });
		},
		deleteRow: function deleteRow(id) {
			var _this2 = this;

			var params = { ids: id };
			this.$confirm(this.$t('lin_global.confirmDelete'), this.$t('lin_btn.tips'), {
				confirmButtonText: this.$t('lin_btn.confirm'),
				cancelButtonText: this.$t('lin_btn.cancel'),
				type: 'warning'
			}).then(function () {
				__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/ota_rom/delete.do', params).then(function (res) {
					if (res.data.status == 200) {
						_this2.$message.success(_this2.$t('lin_global.delete_success'));
						_this2.getData(1, '');
					} else {
						_this2.$message.error(res.data.message);
					}
				});
			}).catch(function () {});
		},
		upload: function upload() {
			this.$router.push({ path: '/romList/upload' });
		},
		typeChange: function typeChange() {
			this.getData(1, this.name);
		},
		handleIconClick: function handleIconClick() {
			this.getData(1, this.name);
		},
		handleSizeChange: function handleSizeChange(val) {
			this.pageSize = val;
			this.getData(this.currentPage, '');
		},
		handleCurrentChange: function handleCurrentChange(val) {
			this.currentPage = val;
			this.getData(this.currentPage, '');
		},
		getData: function getData(page, name) {
			var _this3 = this;

			this.currentPage = page;
			var mid = this.mech ? this.mech : '';
			var params = { page: page, rows: this.pageSize, type: this.selectType, name: name, status: '', memo: '', mechId: mid };

			console.log('param', params);
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/ota_rom/list.do', params).then(function (res) {
				console.log(res.data);
				_this3.arrdata = res.data.data;
				_this3.totalRecords = res.data.total;
				for (var i = 0; i < res.data.data.length; i++) {
					if (res.data.data[i].status == 0) {
						res.data.data[i]['submit'] = true;
						res.data.data[i]['edit'] = true;
						res.data.data[i]['delete'] = true;
						res.data.data[i]['ifInfor'] = false;
					} else if (res.data.data[i].status == 1) {
						res.data.data[i]['submit'] = false;
						res.data.data[i]['edit'] = false;
						res.data.data[i]['delete'] = false;
						res.data.data[i]['ifInfor'] = false;
					} else if (res.data.data[i].status == 2) {
						res.data.data[i]['submit'] = false;
						res.data.data[i]['edit'] = false;
						res.data.data[i]['delete'] = true;
						res.data.data[i]['ifInfor'] = false;
					} else if (res.data.data[i].status == 3) {
						res.data.data[i]['submit'] = false;
						res.data.data[i]['edit'] = true;
						res.data.data[i]['delete'] = true;
						res.data.data[i]['ifInfor'] = true;
					} else {
						return false;
					}
				}
			});
		},
		formatStatus: function formatStatus(row, column) {
			return row.status == 0 ? this.$t('lin_global.waitOne') : row.status == 1 ? this.$t('lin_global.waitTwo') : row.status == 2 ? this.$t('lin_global.verifyPass') : row.status == 3 ? this.$t('lin_global.verifyNotPass') : '';
		}
	}
});

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		MechanismSelector: __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue___default.a
	},
	data: function data() {
		var that = this;
		return {
			mechanismData: {
				placeholder: that.$t('lin_global.place_areaid'),
				callback: function callback(value) {
					that.form.targetId = value;
				}
			},
			action: '' + __WEBPACK_IMPORTED_MODULE_1__api_url__["b" /* urlAssets */].fileUrl,
			action1: '' + __WEBPACK_IMPORTED_MODULE_1__api_url__["b" /* urlAssets */].picUrl,
			imgul: '' + __WEBPACK_IMPORTED_MODULE_1__api_url__["b" /* urlAssets */].prefix,
			checked: false,
			imageUrl: '',
			form: {
				name: '',
				version: '',
				targetId: '',
				autoSign: '1',
				animatUrl: '',
				logoUrl: '',
				launcher: '',
				package_url: ''
			},
			areaList: []
		};
	},
	created: function created() {},

	methods: {
		onSubmit: function onSubmit() {
			var _this = this;

			var params = this.form;

			this.isSubmit = true;
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/ota_rom/makeRom.do', params).then(function (res) {
				if (res.data.status == 200) {
					_this.$message.success(res.data.message);
					_this.isSubmit = false;
				} else {
					_this.$message.error(res.data.message);
					_this.isSubmit = false;
				}
			});
		},
		check: function check() {
			if (this.checked) {
				this.form.autoSign = '0';
			} else {
				this.form.autoSign = '1';
			}
		},
		getAd: function getAd() {
			var _this2 = this;

			var params = { page: 1, rows: 10000 };
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/mechanism/list.do', params).then(function (res) {
				_this2.areaList = res.data.data;
			});
		},
		handleAvatarScucess1: function handleAvatarScucess1(res, file) {
			this.form.animatUrl = res.fileUrl;
		},
		handleAvatarScucess2: function handleAvatarScucess2(res, file) {
			this.form.logoUrl = res.fileUrl;
			this.imageUrl = this.imgul + res.fileUrl;
		},
		handleAvatarScucess3: function handleAvatarScucess3(res, file) {
			this.form.launcher = res.fileUrl;
		},
		handleAvatarScucess4: function handleAvatarScucess4(res, file) {
			this.form.package_url = res.fileUrl;
		},
		beforeAvatarUpload: function beforeAvatarUpload(file) {},

		onCancel: function onCancel() {
			this.$router.go(-1);
		}
	}
});

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_TernoAutoCtrl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_TernoAutoCtrl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__global_TernoAutoCtrl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default.a, AutoTerno: __WEBPACK_IMPORTED_MODULE_0__global_TernoAutoCtrl___default.a
  },
  data: function data() {
    var that = this;
    return {
      mechanismData: {
        placeholder: that.$t('lin_global.place_areaid'),
        callback: function callback(value) {
          that.form.targetId = value;
        }
      },
      dvNum: 0,
      hLoading: false,
      srcList: [],
      isShow: true,
      arrdata: [],
      exInfo: {},
      form: {
        token: localStorage.getItem('user'),
        memo: '',
        type: '0',
        targetId: '',
        ota_rom_id: '',
        fileNo: ''
      },
      areaList: [],
      type: [{
        typename: this.$t('lin_global.label_areaid'),
        typeid: '0'
      }, {
        typename: this.$t('lin_global.shebei'),
        typeid: '1'
      }, {
        typename: this.$t('app_fileImport'),
        typeid: '2'
      }],
      otaObject: [],
      currentPage: 1,
      pageSize: 10,
      totalRecords: 0,
      arrdatas: [],
      addLoading: false
    };
  },

  watch: {
    'form.type': function formType(val) {
      console.log("type:" + val);
    }
  },
  computed: {
    fileUploadUrl: function fileUploadUrl() {
      return this.$fileExcelUlUrl;
    },
    downUrl: function downUrl() {
      return this.$host + '/tms-server-web/model/terminalNos.xlsx';
    }
  },
  created: function created() {
    this.getAd();
    this.getData();
  },

  methods: {
    push: function push(row) {
      this.$setWObj('otaPushInfo', row);
    },
    otaUdType: function otaUdType(key) {
      var vls = { '0': this.$t('app_ttPkg'), '1': this.$t('app_dfPkg') };
      return vls[key];
    },
    onDvInputChange: function onDvInputChange(vl) {
      this.form.targetId = vl;
    },
    srcBefore: function srcBefore(file) {
      window[this.$route.path] = 1;
    },
    srcSuccess: function srcSuccess(res, file) {
      window[this.$route.path] = '';

      if (res.status === 200) {
        this.srcList = [{ name: file.name }];
        this.exInfo = res.data;
        this.exInfo.file = file.name;
        this.form.fileNo = res.data.fileNo;

        this.dvNum = res.data.terNums;
      } else {
        if (this.exInfo.file) {
          this.srcList = [{ name: this.exInfo.file }];
        } else {
          this.srcList = [];
        }
        this.$message.error(res.message);
      }
    },

    resXiafa: function resXiafa(row) {
      var _this = this;

      this.hLoading = true;
      this.$repush(row.pushType, row.opeTime, row.objectId, function (res) {
        _this.hLoading = false;
        if (res.status == 200) {
          _this.$message.success(res.message);
          _this.getList(1, _this.form.ota_rom_id);
        } else {
          _this.$message.error(res.message);
        }
      }, function (error) {
        _this.hLoading = false;
        _this.$message.error(_this.$t('app_rqsError'));
      });
    },
    formatStatus: function formatStatus(row) {
      return row.pushType == 0 ? "渠道商" : "设备";
    },
    getList: function getList(page, id) {
      var _this2 = this;

      this.currentPage = page;
      this.hLoading = true;

      this.$pushRecords(page, this.$gRow, '2', id, function (res) {
        _this2.hLoading = false;
        if (res.status == 200) {
          _this2.arrdatas = res.data;
          _this2.totalRecords = res.total;
        } else {
          _this2.$message.error(res.message);
        }
      }, function (error) {
        _this2.hLoading = false;
        _this2.$message.error(_this2.$t('app_rqsError'));
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getList(this.currentPage, this.form.ota_rom_id);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.getList(this.currentPage, this.form.ota_rom_id);
    },
    otaEvent: function otaEvent(val) {
      for (var i = 0; i < this.arrdata.length; i++) {
        if (val == this.arrdata[i].id) {
          this.otaObject.push(this.arrdata[i]);
          if (this.arrdata[i].mechanismName) {
            this.form.memo = this.arrdata[i].mechanismName;
          } else {
            this.form.memo = this.$t('lin_global.null');
          }
        }
      }

      this.getList(this.currentPage, val);
    },
    onSubmit: function onSubmit() {
      var _this3 = this;

      var params = this.form;

      console.log(params);

      if (!params.ota_rom_id) {
        this.$message.error(this.$t('app_inputCp'));
        return;
      }
      switch (params.type) {
        case '0':
        case '1':
          if (!params.targetId) {
            this.$message.error(this.$t('app_inputCp'));
            return;
          }
          break;
        case '2':
          if (!params.fileNo) {
            this.$message.error(this.$t('app_inputCp'));
            return;
          }
          break;
      }

      this.addLoading = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/ota_rom/push.do', params).then(function (res) {
        if (res.data.status == 200) {
          _this3.$message(res.data.message);
          _this3.addLoading = false;
          _this3.getList(1, _this3.form.ota_rom_id);
          if (_this3.$refs.upload) {
            _this3.$refs.upload.clearFiles();
          }
        } else {
          _this3.$message.error(res.data.message);
          _this3.addLoading = false;
        }
      }).catch(function (error) {
        _this3.$message.error(error);
        _this3.addLoading = false;
      });
    },
    changeType: function changeType() {
      this.form.targetId = '';
      if (this.form.type == '0') {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    },
    getData: function getData() {
      var _this4 = this;

      var that = this;
      var params = { page: 1, rows: 100000, type: '', name: '', status: '2' };

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/ota_rom/list.do', params).then(function (res) {
        that.totalRecords = res.data.total;
        _this4.arrdata = res.data.data;
      });
    },
    getAd: function getAd() {
      var _this5 = this;

      var params = { page: 1, rows: 10000 };
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/mechanism/list.do', params).then(function (res) {
        _this5.areaList = res.data.data;
      });
    },

    onCancel: function onCancel() {
      this.$router.go(-1);
    }
  }
});

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_paging_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_paging_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_paging_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      info: '',
      titleName: '',
      pLoading: 0,
      pagingData: {
        total: 0,
        pageSize: 20,
        currentPage: 1
      },
      multipleSelection: [],
      tableData: []
    };
  },

  components: {
    paging: __WEBPACK_IMPORTED_MODULE_0__components_global_paging_vue___default.a
  },
  computed: {},
  methods: {
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    pAction: function pAction() {},
    cellClick: function cellClick() {},
    jumpToPush: function jumpToPush() {
      location.hash = '#/romPush/history/push/2';
    }
  },
  mounted: function mounted() {
    var that = this;
    this.info = that.$getWObj().otaPushInfo;
    this.titleName = that.info.name || '';
  }
});

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_url__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			selectType: '',
			arrdata: [],
			currentPage: 1,
			pageSize: 10,
			totalRecords: 0,
			loading: true,
			name: '',
			type: [{
				value: '',
				label: this.$t('lin_global.allType')
			}, {
				value: 'ota',
				label: 'OTA'
			}, {
				value: 'rom',
				label: 'ROM'
			}]
		};
	},
	created: function created() {
		this.getData(1, '');
	},
	mounted: function mounted() {},

	methods: {
		rowClick: function rowClick(row) {
			this.$router.push({
				path: '/romReview/' + row.id + '/reviewDetail'
			});
		},
		typeChange: function typeChange() {
			this.getData(1, this.name);
		},
		handleIconClick: function handleIconClick() {
			this.getData(1, this.name);
		},
		handleSizeChange: function handleSizeChange(val) {
			this.pageSize = val;
			this.getData(this.currentPage);
		},
		handleCurrentChange: function handleCurrentChange(val) {
			this.currentPage = val;
			this.getData(this.currentPage);
		},
		getData: function getData(page, name) {
			var _this = this;

			this.currentPage = page;
			var params = { page: page, rows: this.pageSize, type: this.selectType, name: name, status: 1 };

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/ota_rom/list.do', params).then(function (res) {
				if (res.data.status == 200) {
					_this.arrdata = res.data.data;
					_this.totalRecords = res.data.total;
					for (var i = 0; i < res.data.data.length; i++) {
						if (res.data.data[i].status == 0) {
							res.data.data[i]['submit'] = true;
							res.data.data[i]['edit'] = true;
							res.data.data[i]['delete'] = true;
						} else if (res.data.data[i].status == 1) {
							res.data.data[i]['submit'] = false;
							res.data.data[i]['edit'] = false;
							res.data.data[i]['delete'] = false;
						} else if (res.data.data[i].status == 2) {
							res.data.data[i]['submit'] = false;
							res.data.data[i]['edit'] = false;
							res.data.data[i]['delete'] = true;
						} else if (res.data.data[i].status == 3) {
							res.data.data[i]['submit'] = false;
							res.data.data[i]['edit'] = true;
							res.data.data[i]['delete'] = true;
						} else {
							return false;
						}
					}
					_this.loading = false;
				} else {
					_this.loading = false;
				}
			});
		},
		formatStatus: function formatStatus(row, column) {
			return row.status == 0 ? this.$t('lin_global.waitOne') : row.status == 1 ? this.$t('lin_global.waitTwo') : row.status == 2 ? this.$t('lin_global.verifyPass') : row.status == 3 ? this.$t('lin_global.verifyNotPass') : '';
		}
	}
});

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
		components: {
				MechanismSelector: __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue___default.a
		},
		data: function data() {
				var _this = this;

				var versionCheck = function versionCheck(rule, value, callback) {

						if (_this.udFileType == 0 && rule.field == 'preVersion') {
								callback();
								return;
						}

						var rg = /^\d+(\.\d+)+$/;
						if (!rg.test(value)) {
								callback(new Error(_this.$t('lin_global.bbhgsbd')));
						} else {
								callback();
						}
				};
				var that = this;
				return {
						mechanismData: {
								placeholder: that.$t('lin_global.place_areaid'),
								callback: function callback(value) {
										that.form.mechanismId = value;
								}
						},
						udFileType: '0',
						isSubmit: false,
						fileList: [],
						action: '' + __WEBPACK_IMPORTED_MODULE_1__api_url__["b" /* urlAssets */].fileUrl,
						checked: false,
						dialogFormVisible: false,
						formLabelWidth: '100px',
						form: {
								name: '',
								md5: '',
								version: '',
								preVersion: '',
								memo: '',
								type: 'ota',
								autoSign: '1',
								mechanismId: '',
								filePath: ''
						},
						formEdit: {
								nickName: '',
								userName: '',
								phoneNum: '',
								userType: '',
								roleid: '',
								mechanismId: '',
								userStatus: '',
								userid: this.$route.params.id
						},
						isEdit: false,
						rules: {
								'name': [{
										required: true,
										message: this.$t('lin_global.notBlankName')
								}],
								'version': [{
										required: true,
										message: this.$t('lin_global.notBlankVer')
								}, {
										validator: versionCheck, trigger: 'blur'
								}],
								'preVersion': [{
										required: true,
										message: this.$t('lin_global.notBlankVer')
								}, {
										validator: versionCheck, trigger: 'blur'
								}],
								'type': [{
										required: true,
										message: this.$t('lin_global.qxzlx')
								}],
								'filePath': [{
										required: true,
										message: this.$t('lin_global.qxzscwj')
								}],
								'mechanismId': [{
										required: true,
										message: this.$t('lin_global.place_areaid')
								}]
						},
						areaList: [],
						roleList: [],
						already: false
				};
		},
		created: function created() {
				this.getRole();
				if (this.$route.params.id) {
						this.isEdit = true;

						this.getInfo();
				} else {
						this.isEdit = false;
				}
		},
		beforeRouteLeave: function beforeRouteLeave(to, from, next) {
				if (this.already) {
						this.$confirm(this.$t('lin_global.lkymtips'), this.$t('lin_btn.tips'), {
								confirmButtonText: this.$t('lin_btn.confirm'),
								cancelButtonText: this.$t('lin_btn.cancel'),
								type: 'warning'
						}).then(function () {
								next();
						}).catch(function () {
								return false;
						});
				} else {
						next();
				}
		},

		methods: {
				uploadError: function uploadError() {
						this.already = false;
				},

				check: function check() {
						if (this.checked) {
								this.form.autoSign = '0';
						} else {
								this.form.autoSign = '1';
						}
				},
				hBlur: function hBlur(name) {
						this.$refs[name].validate(function (valid) {
								if (valid) {} else {
										return false;
								}
						});
				},
				handleAvatarScucess: function handleAvatarScucess(res, file) {
						if (res.status === 200) {
								this.form.filePath = res.fileUrl;
								this.form.md5 = res.md5;
								this.fileList = [{ name: file.name }];
								this.hBlur('addForm');
								this.already = false;
								localStorage.removeItem("_isUploading");
						} else {
								if (!this.form.filePath) {
										this.fileList = [];
								} else {
										this.fileList = [{ name: this.makeAppPath(this.form.filePath) }];
								}
								this.$message.error(this.$t('lin_global.znscziptips'));
						}
				},
				makeAppPath: function makeAppPath(url) {
						var path = url;
						if (!path) {
								if (this.form) {
										path = this.form.filePath;
								} else {
										return '';
								}
						}
						var arr = path.split('/');
						return arr[arr.length - 1];
				},
				beforeAvatarUpload: function beforeAvatarUpload(file) {
						this.already = true;
						localStorage.setItem("_isUploading", "true");
						if (file) {
								var ar = file.name.split('.');
								var type = ar[ar.length - 1];
								if (type === 'zip') {
										return true;
								} else {
										this.$message.error(this.$t('lin_global.znscziptips'));
										return false;
								}
						} else {
								this.$message.error(this.$t('lin_global.qsczipwj'));
								return false;
						}
				},

				chang: function chang() {
						this.dialogFormVisible = true;
				},
				submitForm: function submitForm(formName) {
						var _this2 = this;

						this.$refs[formName].validate(function (valid) {
								if (valid) {
										var params = {
												userId: _this2.$route.params.id,
												oldPwd: _this2.$sha256(_this2.formPwd.oldPass),
												newPwd: _this2.$sha256(_this2.formPwd.checkPass)
										};

										__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/user/updatePassword.do', params).then(function (res) {
												if (res.data.status == 200) {
														_this2.dialogFormVisible = false;
														_this2.$message.success(res.data.message);
												} else {
														_this2.dialogFormVisible = false;
														_this2.$message.error(res.data.message);
												}
										});
								} else {
										return false;
								}
						});
				},


				addInfo: function addInfo() {
						var _this3 = this;

						var params = this.form;
						params.updateType = this.udFileType;
						params.md5 = this.form.md5;

						this.isSubmit = true;
						__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/ota_rom/add.do', params).then(function (res) {
								if (res.data.status == 200) {
										_this3.$message.success(res.data.message);
										_this3.isSubmit = false;
										_this3.$router.go(-1);
								} else {
										_this3.isSubmit = false;
										_this3.$message.error(res.data.message);
								}
						});
				},
				onSubmitEdit: function onSubmitEdit() {
						var _this4 = this;

						var params = this.formEdit;

						__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/user/editUser.do', params).then(function (res) {
								if (res.data.status == 200) {
										_this4.$message.success(res.data.message);
								} else {
										_this4.$message.error(res.data.message);
								}
						});
				},
				getInfo: function getInfo() {
						var _this5 = this;

						var userId = this.$route.params.id;
						var params = { userId: userId };
						__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/user/getUserById.do', params).then(function (res) {
								_this5.formEdit.nickName = res.data.data.nickName;
								_this5.formEdit.userName = res.data.data.userName;
								_this5.formEdit.phoneNum = res.data.data.phoneNum;
								_this5.formEdit.roleid = res.data.data.roleid;
								_this5.formEdit.mechanismId = res.data.data.mechanismId;
								_this5.formEdit.userStatus = res.data.data.userStatus;
						});
				},
				onSubmit: function onSubmit() {
						var _this6 = this;

						if (this.udFileType == 0) {
								this.form.preVersion = ' ';
						}
						this.$refs['addForm'].validate(function (valid) {
								if (valid) {
										_this6.addInfo();
								} else {
										_this6.$message.error(_this6.$t('lin_global.refs'));
										return false;
								}
						});
				},
				getAd: function getAd() {
						var _this7 = this;

						var params = { page: 1, rows: 10000 };
						__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/mechanism/list.do', params).then(function (res) {
								_this7.areaList = res.data.data;
						});
				},
				getRole: function getRole() {
						var _this8 = this;

						var mechanismId = localStorage.getItem('mechanismId');
						var params = { page: 1, rows: 10, distributorid: mechanismId };
						__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/role/list.do', params).then(function (res) {
								_this8.roleList = res.data.data;
						});
				},
				onCancel: function onCancel() {
						this.$router.go(-1);
				}
		}
});

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default.a
  },
  data: function data() {
    var that = this;
    return {
      mechanismData: {
        callback: function callback(value) {
          that.mech = value;
          that.selectChange(value);
        }
      },
      listKey: 'launch-list',
      cerDialogVisible: false,
      cerTipDialogVisible: false,
      dvLoading: 0,
      appId: '',
      stModel: [{ label: this.$t('app_online'), vl: '1' }, { label: this.$t('app_offline'), vl: '2' }, { label: this.$t('app_new'), vl: '0' }],
      channels: [],
      srchValue: '',
      channelId: '',
      cerTipMsg: '',
      status: '',
      dvIndex: 1,
      dialogVisible: 0,
      mechanismId: window.localStorage['mechanismId'],
      selectMid: '',
      tableData: [],
      dvTableData: [],
      appTypes: [],
      appTypeValue: '',
      appStatus: [{ label: this.$t('app_prePushVerify'), value: '0' }, { label: this.$t('app_preVerify'), value: '1' }, { label: this.$t('app_verifyPass'), value: '2' }, { label: this.$t('app_verifyNotPass'), value: '3' }],
      appStatusValue: '',
      total: 0,
      dvTotal: 0,
      loading: 0,
      appType: '',
      queryKey: ''
    };
  },

  computed: {
    index: function index() {
      var vl = this.$getWPage(this.listKey);
      return vl ? vl : 1;
    },
    getDvStatus: function getDvStatus(value) {
      switch (value) {
        case '0':
          return this.$t('app_prePushVerify');
        case '1':
          return this.$t('app_preVerify');
        case '2':
          return this.$t('app_verifyPass');
        case '3':
          return this.$t('app_verifyNotPass');
      }
    }
  },
  methods: {
    pushCreateCer: function pushCreateCer() {
      this.$router.push({ path: "/certificate/new" });
    },
    pushUploadCer: function pushUploadCer() {
      this.$router.push({ path: "/certificate/upload" });
    },
    bindOperate: function bindOperate(row) {
      var _this = this;

      this.dvLoading = 1;
      if (this.$appUrlTag === 0) {
        this.$bindApp('0', row.terminalNo, this.appId, function (res) {
          if (res.status === 200) {
            _this.$message.success(_this.$t('app_tipViewTask'));
          } else {
            _this.$message.error(res.message);
          }
          _this.dvLoading = 0;
        }, function () {
          _this.dvLoading = 0;
        });
      } else {
        this.$bindApp1(localStorage.mechanismId, row.terminalNo, this.appId, function (res) {
          if (res.status === 200) {
            _this.$message.success(_this.$t('app_tipViewTask'));
          } else {
            _this.$message.error(res.message);
          }
          _this.dvLoading = 0;
        }, function () {
          _this.dvLoading = 0;
        });
      }
    },
    getChannels: function getChannels() {
      var _this2 = this;

      this.$getChannelList(10000, 1, '', '', '', function (res) {
        if (res.status === 200) {
          _this2.channels = res.data;
        } else {
          _this2.$message.error(res.message);
        }
      }, function () {
        _this2.$message.error(_this2.$t('app_rqsError'));
      });
    },
    getStatus: function getStatus(value) {
      if (!value) return '';
      switch (value) {
        case '0':
          return { vl: this.$t('app_prePushVerify'), style: 'color:#8492A6;' };
        case '1':
          return { vl: this.$t('app_preVerify'), style: 'color:#F7BA2A;' };
        case '2':
          return { vl: this.$t('app_verifyPass'), style: 'color:#13CE66;' };
        case '3':
          return { vl: this.$t('app_verifyNotPass'), style: 'color:#FF4949;' };
      }
    },
    srchDevice: function srchDevice() {
      this.getDevices();
    },
    selectDvChange: function selectDvChange(vl) {
      this.getDevices();
    },
    pageDvSized: function pageDvSized(val) {
      this.$gRow = val;
      this.getDevices();
    },
    getDevices: function getDevices() {
      var _this3 = this;

      var vl = this.srchValue ? this.srchValue : '';
      var channel = this.channelId ? this.channelId : '';
      var status = this.status ? this.status : '';
      var appId = this.appId ? this.appId : '';
      this.dvLoading = 1;
      if (this.$appUrlTag === 0) {
        this.$getDevices(this.dvIndex, this.$gRow, channel, vl, status, '', appId, function (res) {
          _this3.dvLoading = 0;
          if (res.data) {
            _this3.dvTableData = res.data;
            _this3.dvTotal = res.total;
          }
        }, function () {
          _this3.dvLoading = 0;
        });
      } else {

        this.$getDevices1(this.dvIndex, this.$gRow, localStorage.mechanismId, vl, status, '', appId, function (res) {
          console.log('dv', res);
          _this3.dvLoading = 0;
          if (res.data) {
            _this3.dvTableData = res.data;
            _this3.dvTotal = res.total;
          }
        }, function () {
          _this3.dvLoading = 0;
        });
      }
    },
    editApp: function editApp(row) {
      this.$setWObj('launcherEdit', { type: 1, data: row });
      this.$router.push({ path: '/launch-edit' });
    },
    pushApp: function pushApp(row) {
      this.$router.push({ path: '/launch-push' });
    },
    query: function query() {
      this.getList();
    },
    selectChange: function selectChange(vl) {
      this.selectMid = vl;
      this.getList();
    },
    reset: function reset() {
      this.queryKey = '';
      this.appType = '';
      this.getList();
    },
    pageSelect: function pageSelect(index) {
      this.$setWPage(this.listKey, index);
      this.getList();
    },
    pageDvSelect: function pageDvSelect(index) {
      this.dvIndex = index;
      this.getDevices();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getList();
    },
    deleteApp: function deleteApp(obj) {
      var _this4 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        console.log(obj);
        _this4.$delLauncher(obj.launcherid, obj.status, function (res) {
          if (res.status === 200) {
            _this4.getList();
            _this4.$message.success(res.message);
          } else {
            _this4.$message.error(res.message);
          }
        }, '');
      }, '');
    },
    submitApp: function submitApp(obj) {
      var _this5 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_tipVerify'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this5.loading = 1;
        _this5.$submitLauncher(obj.launcherid, function (res) {
          _this5.loading = 0;
          if (res.status === 200) {
            _this5.getList();
            _this5.$message.success(res.message);
          } else {
            _this5.$message.error(res.message);
          }
        }, function () {
          _this5.loading = 0;
        });
      }, '');
    },
    cellClick: function cellClick(row, ev, col) {

      this.$setWObj('stfileVerify', row);
      this.$router.push({ path: '/vstfile/verify' });
    },
    jumpToUpload: function jumpToUpload() {

      this.$setWObj('launcherEdit', { type: 0 });
      this.$router.push({ path: '/addlaunch' });
    },
    getList: function getList() {
      var _this6 = this;

      this.loading = 1;
      var dsid = this.selectMid ? this.selectMid : '';
      var name = this.queryKey ? this.queryKey : '';
      this.$fstVList(this.index, this.$gRow, function (res) {
        console.log('res', res);
        _this6.loading = 0;
        if (res.status === 200) {
          _this6.total = res.total;
          _this6.tableData = res.data;
        } else {
          _this6.$message(res.message);
        }
      }, function () {
        _this6.loading = 0;
        _this6.$message.error(_this6.$t('app_rqsError'));
      });
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD HH:mm:ss');
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    }
  },
  mounted: function mounted() {
    this.getList();
  },
  destroyed: function destroyed() {}
});

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_df_png__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_df_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_df_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_tyc__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_tyc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_global_tyc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;
    return {
      mechanismData: {
        callback: function callback(value) {
          _this.mech = value;

          _this.getList();
        }
      },
      mechanismData1: {
        callback: function callback(value) {
          _this.mech1 = value;

          _this.getDevices();
        }
      },
      mech: '',
      mech1: '',
      tqobj: '',
      cmtStatus: '',
      cmtStatusArr: [],
      srchValue: '',
      multipleSelection: [],
      multipleSelection1: [],
      detail: '',
      dialogVisible: false,
      mapType: {
        '0': this.$t('app_bdmap'),
        '1': 'Google' + this.$t('app_map')
      },
      ctrlType: {
        '0': this.$t('app_off1'),
        '1': this.$t('app_on1')
      },
      bindSt: {
        '0': this.$t('app_waitupdate'),
        '1': this.$t('app_updateSuccess'),
        '2': this.$t('app_filectncr'),
        '3': this.$t('app_downFinish'),
        '4': this.$t('app_md5Fail')
      },
      bindSts: [{ vl: '', lb: this.$t('app_allstatus') }, { vl: '0', lb: this.$t('app_waitupdate') }, { vl: '1', lb: this.$t('app_updateSuccess') }, { vl: '2', lb: this.$t('app_filectncr') }, { vl: '3', lb: this.$t('app_downFinish') }, { vl: '4', lb: this.$t('app_md5Fail') }],
      bindVl: '',
      config: '',
      captures: [],
      loading: 0,
      tableData: [],
      tags: [],
      page: 1,
      index: 1,
      hiss: [],
      pageTotal: 0,
      istotal: false

    };
  },

  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default.a, tyc: __WEBPACK_IMPORTED_MODULE_2__components_global_tyc___default.a
  },
  computed: {
    showUploadNew: function showUploadNew() {
      if (this.config) {
        if (this.config.isoperate === 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  methods: {
    closeAddTer: function closeAddTer() {
      this.getList();
    },
    stopTimer: function stopTimer() {
      clearTimeout(window.bwlistTo);
    },
    setCycleUpdate: function setCycleUpdate() {
      var _this2 = this;

      if (this.$route.path != '/stfile/detail') {
        return;
      }

      var hit = false;
      this.hiss.forEach(function (vl) {
        if (vl.updateStatus == 0 || vl.updateStatus == 3) {
          hit = true;
          return;
        }
      });
      if (hit) {
        hit = false;
        clearTimeout(window.bwlistTo);
        var _this = this;
        window.bwlistTo = setTimeout(function () {
          if (_this2.$route.path != '/stfile/detail') {
            return;
          }
          _this.getList();
        }, 6000);
      }
    },
    bcdel: function bcdel() {
      var _this3 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_tipAppEdit'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        var ids = [];
        _this3.multipleSelection1.forEach(function (obj) {
          ids.push(obj.id);
        });
        _this3.unbRqs(ids.toString());
      }, '');
    },
    clickTotal: function clickTotal() {
      if (this.istotal) {
        this.totalBindRqs('1');
      } else {
        this.totalBindRqs('0');
      }
    },
    totalBindRqs: function totalBindRqs(vl) {
      var _this4 = this;

      this.loading = 1;
      this.$bwlBindAll(this.config.id, vl, function (res) {
        _this4.loading = 0;
        if (res.status === 200) {
          _this4.$message.success(res.message);
        } else {
          _this4.$message.error(res.message);
          _this4.istotal = !_this4.istotal;
        }
      }, function () {
        _this4.loading = 0;
        _this4.$message.error(_this4.$t('app_rqsError'));
      });
    },
    pageChange: function pageChange(vl) {
      this.page = vl;
      this.getList();
    },
    bcbind: function bcbind() {
      var arr = [];
      this.multipleSelection.forEach(function (item) {
        arr.push(item.terminalId);
      });

      this.bindRqs(arr.toString());
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSelectionChange1: function handleSelectionChange1(val) {
      this.multipleSelection1 = val;
    },
    editCf: function editCf() {
      this.$setWObj('dvconfigEdit', { type: 1, data: this.config, isSetLc: true });
      this.$router.push({ path: '/dvconfig/detail/edit' });
    },
    showBindSt: function showBindSt(row) {
      return this.bindSt[row.updateStatus];
    },
    bindOp: function bindOp(row) {

      this.bindRqs(row.terminalId);
    },
    bindRqs: function bindRqs(id) {
      var _this5 = this;

      this.loading = 1;
      this.$bwlBind(id, this.config.recordId, function (res) {
        _this5.loading = 0;
        if (res.status === 200) {
          _this5.dialogVisible = false;
          _this5.getList();
        } else {
          _this5.$message.error(res.message);
        }
      }, function () {
        _this5.loading = 0;
        _this5.$message.error(_this5.$t('app_rqsError'));
      });
    },
    query: function query() {
      this.getList();
    },
    srchDevice: function srchDevice() {
      this.getDevices();
    },
    getDevices: function getDevices() {
      var _this6 = this;

      var vl = this.srchValue ? this.srchValue : '';
      var channel = this.mech1 ? this.mech1 : '';
      var status = this.cmtStatus ? this.cmtStatus : '';
      this.loading = 1;
      this.$getDvDevices(this.index, this.$gRow, channel, vl, status, '', '', '', '', '', function (res) {
        console.log('dv', res);
        _this6.loading = 0;
        if (res.data) {
          _this6.tableData = res.data;
          _this6.total = res.total;
        }
      }, function () {
        _this6.loading = 0;
      });
    },
    addTer: function addTer() {
      this.dialogVisible = true;
      this.stopTimer();
    },
    deleteApp: function deleteApp(obj) {
      var _this7 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        console.log(obj);
        _this7.$delFstRecord(obj.id, function (res) {
          if (res.status === 200) {
            _this7.getList();
            _this7.$message.success(res.message);
          } else {
            _this7.$message.error(res.message);
          }
        }, '');
      }, '');
    },
    unbind: function unbind(row) {
      var _this8 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this8.unbRqs(row.id);
      }, '');
    },
    unbRqs: function unbRqs(id) {
      var _this9 = this;

      this.$bwlUnbind(id, function (res) {
        if (res.status === 200) {
          _this9.getList();
          _this9.$message.success(res.message);
        } else {
          _this9.$message.error(res.message);
        }
      }, '');
    },
    editApp: function editApp() {
      this.$setWObj('filestEdit', { type: 1, data: this.config });
      this.$router.push({ path: '/stfile/detail/edit', query: { setlocal: true } });
    },
    pushApp: function pushApp(row) {
      this.$setWObj('pushList', { type: '13', data: row });
      this.$router.push({ path: '/stfile/detail/push' });
    },
    getList: function getList() {
      var _this10 = this;

      this.loading = 1;
      var mech = this.mech;
      var name = this.queryKey ? this.queryKey : '';
      var status = this.bindVl;

      this.$bwlBindList(this.page, this.$gRow, mech, name, status, this.config.recordId, function (res) {

        _this10.loading = 0;
        if (res.status === 200) {
          _this10.pageTotal = res.total;
          _this10.hiss = res.data;
          _this10.setCycleUpdate();
        } else {
          _this10.$message(res.message);
        }
      }, function () {
        _this10.loading = 0;
        _this10.$message.error(_this10.$t('app_rqsError'));
      });
    },
    getStatus: function getStatus(value) {
      if (!value) return '';
      switch (value) {
        case '0':
          return { vl: this.$t('app_prePushVerify'), style: 'color:#8492A6;' };
        case '1':
          return { vl: this.$t('app_preVerify'), style: 'color:#F7BA2A;' };
        case '2':
          return { vl: this.$t('app_verifyPass'), style: 'color:#13CE66;' };
        case '3':
          return { vl: this.$t('app_verifyNotPass'), style: 'color:#FF4949;' };
      }
    },
    getDetail: function getDetail() {
      var _this11 = this;

      this.loading = 1;
      this.$getFstDetail(this.config.data.recordId, function (res) {
        _this11.loading = 0;
        if (res.status === 200) {} else {
          _this11.$message.error(res.message);
        }
      }, function () {
        _this11.loading = 0;
        _this11.$message.error(_this11.$t('app_rqsError'));
      });
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('YYYY-MM-DD hh:mm:ss');
    },
    selectChange: function selectChange(vl) {
      this.getList();
    },
    pageSelect: function pageSelect(index) {
      this.index = index;
      this.getDevices();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getDevices();
    },
    pageSize: function pageSize(val) {
      this.$gRow = val;
      this.getList();
    },
    delHis: function delHis(row) {
      var _this12 = this;

      this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
        confirmButtonText: this.$t('app_sure'),
        cancelButtonText: this.$t('app_cancel'),
        type: 'warning'
      }).then(function () {
        _this12.loading = 1;
        _this12.$delLauncherHistory(row.versionid, function (res) {
          _this12.loading = 0;
          if (res.status === 200) {
            _this12.getHistory();
            _this12.$message.success(res.message);
          } else {
            _this12.$message.error(res.message);
          }
        }, function () {
          _this12.loading = 0;
        });
      }).catch(function () {});
    },
    imgFullUrl: function imgFullUrl(path) {
      if (path) {
        return this.$urls.prefix + path;
      } else {
        return '';
      }
    },
    getHistory: function getHistory() {
      var _this13 = this;

      if (this.config.status !== '2') {
        return;
      }
      this.loading = 1;
      this.$launcherHistory(this.config.launcherid, function (res) {
        console.log('his', res);
        _this13.loading = 0;
        if (res.status === 200) {
          _this13.tableData = res.data;
        } else {
          _this13.$message.error(res.message);
        }
      }, function () {
        _this13.loading = 0;
      });
    },
    uploadNew: function uploadNew() {},
    init: function init() {
      this.config = this.$getWObj().stfileDetail;

      this.istotal = this.config.type == '0' ? false : true;

      this.getList();
      this.getDevices();

      var _this = this;
      var typeKey = 'terminalTypes';
      this.tqobj = {
        keys: [typeKey],
        callback: function callback(data) {
          _this.cmtStatusArr = data[0];
        }
      };
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this2 = this;

    var tagCheck = function tagCheck(rule, value, callback) {
      if (!value) {
        callback(new Error(_this2.$t('noVerTag')));
      } else {
        callback();
      }
    };
    return {
      ulinfo: {
        tip: this.$t('app_ulNormalSt') + '，' + this.$t('app_limitxml'),
        index: 0,
        icons: ['el-icon-upload', 'el-icon-circle-check', 'el-icon-close']
      },
      mechanismId: window.localStorage['mechanismId'],
      status: '',
      isAddFile: false,
      ulType: '0',
      flags: [{ lb: 'AID', vl: 'ZT_AID' }, { lb: 'RID', vl: 'ZT_RID' }, { lb: 'BLACKLIST', vl: 'ZT_CARDBLACK' }],
      tipColor: { color: '#13CE66' },
      stModel: [{ label: this.$t('app_online'), vl: '1' }, { label: this.$t('app_offline'), vl: '2' }, { label: this.$t('app_new'), vl: '0' }],
      channels: [],
      isLowerTip: false,
      updateType: false,
      channelId: '',
      rules: {
        name: [{ required: true, message: this.$t('app_inputName'), trigger: 'blur' }],
        ver: [{ required: true, type: 'number', message: this.$t('app_inputVer'), trigger: 'blur' }],
        flag: [{ required: true, message: this.$t('app_inputID'), trigger: 'blur', validator: tagCheck }],
        appPackage: [{ required: true, message: this.$t('app_inputPkg'), trigger: 'blur' }],
        memo: [{ required: true, message: this.$t('app_inputIntrol'), trigger: 'blur' }],
        appTypeValue: [{ required: true, message: this.$t('app_selectType'), trigger: 'blur' }],
        url: [{ required: true, message: this.$t('app_plsUpl'), trigger: 'blur' }] },
      form: {
        id: '',
        profilesId: '',
        name: '',
        ver: 0,
        flag: '',
        url: '',
        key: '',
        updateType: '0',
        md5: '',
        size: "",
        appPackage: '',
        memo: '',
        fname: ''
      },
      isTag: false,
      isVer: false,
      showPic: { value: 0, data: '' },
      srchValue: '',
      installTypes: [{ label: this.$t('app_autoInstall'), value: 0 }],
      fileSize: 0,
      tableData: [],
      fdatas: [],
      checkDesc: '',
      radio: '1',
      smImageUrl: '',
      bgImageUrl: '',
      dialogVisible: false,
      appTypes: [],
      loading: 0,
      loading1: 0,
      loadingBig: 0,
      loadingSm: 0,
      config: {},
      cp0: '',
      cp1: '',
      cp2: '',
      cp3: '',
      cp4: '',
      captures: [],
      fileList: [],
      isUpload: 0,
      index: 1,
      total: 0,

      dynamicTags: [],
      inputVisible: false,
      inputValue: ''
    };
  },

  computed: {
    ulprop: function ulprop() {
      if (this.ulType == 1) {
        return '';
      } else {
        return 'url';
      }
    },
    bIcon: function bIcon() {
      if (this.config.data) {
        return this.config.data.appBigIcon ? imgFullUrl(this.config.data.appBigIcon) : __webpack_require__(6);
      } else {
        return '';
      }
    },
    sIcon: function sIcon() {
      if (this.config.data) {
        return this.config.data.appSmallIcon ? imgFullUrl(this.config.data.appSmallIcon) : __webpack_require__(6);
      } else {
        return '';
      }
    },
    showUploadNew: function showUploadNew() {
      if (this.config.data) {
        if (this.config.data.isUpload === '0') {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    isShowUpdateDesc: function isShowUpdateDesc() {
      if (this.config.data) {
        if (this.config.data.updatedesc) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    updateDescContent: function updateDescContent() {
      var vl = this.config.data ? this.config.data.updatedesc : '';

      return vl;
    },
    prdes: function prdes() {
      return this.config.data ? this.config.data.launcherDesc : '';
    },
    uData: function uData() {
      return { token: 1234 };
    },
    imgUploadUrl: function imgUploadUrl() {
      return this.$urls.picUrl;
    },
    fileUploadUrl: function fileUploadUrl() {
      var vl = this.$urls.xmlFileUrl + '?distributorId=' + localStorage.mechanismId + '&language=' + localStorage.system_lang;
      return vl;
    },
    reason: function reason() {
      if (!this.config.data) {
        return '';
      }
      var rs = this.config.data.auditContent;
      return rs ? this.$t('app_banReason') + ':' + rs : this.$t('app_banReason') + ':' + this.$t('app_noInput');
    },
    isShowReason: function isShowReason() {
      if (this.config) {
        if (this.config.data) {
          if (this.config.data.appStatus === '3') {
            return 1;
          } else {
            return 0;
          }
        } else {
          return 0;
        }
      } else {
        return 0;
      }
    }
  },
  methods: {
    addFile: function addFile(row) {
      this.form.fname = row.fileName;
      this.form.size = row.size;
      this.form.md5 = row.md5;
      this.isAddFile = false;
    },
    setSize: function setSize(row) {
      return row.size + 'KB';
    },
    getList: function getList() {
      var _this3 = this;

      this.$ftpfList(function (res) {
        _this3.fdatas = res.data ? res.data : [];
      }, function () {
        _this3.$message.error(_this3.$t('app_rqsError'));
      });
    },
    getDetail: function getDetail() {
      var _this4 = this;

      this.$getFstDetail(this.config.data.recordId, function (res) {
        if (res.status === 200) {
          _this4.fillEdit(res.data);
        } else {
          _this4.$message.error(res.message);
        }
      }, function () {
        _this4.$message.error(_this4.$t('app_rqsError'));
      });
    },
    handleClose: function handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      this.makeExApp();
    },
    showInput: function showInput() {
      this.inputVisible = true;
      var _this = this;
      this.$nextTick(function (_) {
        _this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm: function handleInputConfirm() {
      var inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
        this.makeExApp();
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    lcNew: function lcNew() {
      var _this5 = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this5.loading = 1;
          var form = _this5.form;
          _this5.$updateLauncher(form.launcherName, form.launcherDesc, form.caps, form.appUrl, form.packageName, form.version, form.verTag, _this5.fileSize, _this5.config.data.launcherid, localStorage.mechanismId, function (res) {
            _this5.loading = 0;
            if (res.status === 200) {
              _this5.$message.success(res.message);
              _this5.$router.go(-2);
            } else {
              _this5.$message.error(res.message);
            }
          }, function () {
            _this5.loading = 0;
            _this5.$message(_this5.$t('app_rqsError'));
          });
        } else {
          return false;
        }
      });
    },
    selectChange: function selectChange(vl) {
      this.getDevices();
    },
    getChannels: function getChannels() {
      var _this6 = this;

      this.$getChannelList(10000, 1, '', '', '', function (res) {
        if (res.status === 200) {
          _this6.channels = res.data;
        } else {
          _this6.$message.error(res.message);
        }
      }, function () {
        _this6.$message.error(_this6.$t('app_rqsError'));
      });
    },
    getStatus: function getStatus(value) {
      switch (value) {
        case '0':
          return this.$t('app_prePushVerify');
        case '1':
          return this.$t('app_preVerify');
        case '2':
          return this.$t('app_verifyPass');
        case '3':
          return this.$t('app_verifyNotPass');
      }
    },
    pageSelect: function pageSelect(index) {
      this.index = index;
      this.getDevices();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getDevices();
    },
    hBlur: function hBlur(name) {
      this.$refs[name].validate(function (valid) {
        if (valid) {} else {
          return false;
        }
      });
    },
    showBigPic: function showBigPic() {
      this.showPic = { value: 1, data: this.imgFullUrl(this.config.data.appBigIcon) };
    },
    showScreenShot: function showScreenShot(path) {
      this.showPic = { value: 1, data: this.imgFullUrl(path) };
    },
    pushInstall: function pushInstall() {
      this.dialogVisible = true;
    },
    makeAppPath: function makeAppPath(url) {
      var path = url;
      if (!path) {
        if (this.config.data) {
          path = this.config.data.appUrl;
          if (!path) {
            return '';
          }
        } else {
          return '';
        }
      }
      var arr = path.split('/');
      return arr[arr.length - 1];
    },
    deleteAppHis: function deleteAppHis(row) {
      var _this7 = this;

      if (row.applicationid) {
        this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
          confirmButtonText: this.$t('app_sure'),
          cancelButtonText: this.$t('app_cancel'),
          type: 'warning'
        }).then(function () {
          _this7.loading = 1;
          if (_this7.$appUrlTag === 0) {
            _this7.$deleteApp(row.applicationid, function (res) {
              _this7.loading = 0;
              if (res.status === 200) {
                _this7.getAppHistory();
              } else {
                _this7.$message.error(res.message);
              }
            }, function () {
              _this7.loading = 0;
            });
          } else {
            _this7.$deleteApp1(row.applicationid, function (res) {
              _this7.loading = 0;
              if (res.status === 200) {
                _this7.getAppHistory();
              } else {
                _this7.$message.error(res.message);
              }
            }, function () {
              _this7.loading = 0;
            });
          }
        }).catch(function () {});
      }
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('YYYY-MM-DD hh:mm:ss');
    },
    deleteCapture0: function deleteCapture0() {
      this.cp0 = '';
      this.cp0Value = '';
    },
    deleteCapture1: function deleteCapture1() {
      this.cp1 = '';
      this.cp1Value = '';
    },
    deleteCapture2: function deleteCapture2() {
      this.cp2 = '';
      this.cp2Value = '';
    },
    deleteCapture3: function deleteCapture3() {
      this.cp3 = '';
      this.cp3Value = '';
    },
    deleteCapture4: function deleteCapture4() {
      this.cp4 = '';
      this.cp4Value = '';
    },
    imgFullUrl: function imgFullUrl(path) {
      if (path) {
        return this.$urls.prefix + path;
      } else {
        return '';
      }
    },
    close: function close() {
      this.$router.go(-1);
    },
    isShowCommon: function isShowCommon(isShow) {
      return true;
    },
    tipBf: function tipBf() {
      this.loading1 = 1;
      return 1;
    },
    handleSmAvatarSuccess: function handleSmAvatarSuccess(res, file) {
      this.loadingSm = 0;
      if (res.status !== 200) {
        this.$message.error(res.message);
      } else {
        this.form.smImageUrlValue = res.data;
        this.smImageUrl = URL.createObjectURL(file.raw);
        this.hBlur('form');
      }
    },
    handleBgAvatarSuccess: function handleBgAvatarSuccess(res, file) {
      this.loadingBig = 0;
      if (res.status !== 200) {
        this.$message.error(res.message);
      } else {
        this.form.bgImageUrlValue = res.data;
        this.bgImageUrl = URL.createObjectURL(file.raw);
        this.hBlur('form');
      }
    },
    handleAvatarSuccessCp0: function handleAvatarSuccessCp0(res, file) {
      this.loading1 = 0;

      if (res.status !== 200) {
        this.$message.error(res.message);
      } else {
        this.cp0Value = res.data;
        this.cp0 = URL.createObjectURL(file.raw);
        this.hBlur('form');
      }
    },
    handleAvatarSuccessCp1: function handleAvatarSuccessCp1(res, file) {
      this.loading1 = 0;
      if (res.status !== 200) {
        this.$message.error(res.message);
      } else {
        this.cp1Value = res.data;
        this.cp1 = URL.createObjectURL(file.raw);
        this.hBlur('form');
      }
    },
    handleAvatarSuccessCp2: function handleAvatarSuccessCp2(res, file) {
      this.loading1 = 0;
      if (res.status !== 200) {
        this.$message.error(res.message);
      } else {
        this.cp2Value = res.data;
        this.cp2 = URL.createObjectURL(file.raw);
        this.hBlur('form');
      }
    },
    handleAvatarSuccessCp3: function handleAvatarSuccessCp3(res, file) {
      this.loading1 = 0;
      if (res.status !== 200) {
        this.$message.error(res.message);
      } else {
        this.cp3Value = res.data;
        this.cp3 = URL.createObjectURL(file.raw);
        this.hBlur('form');
      }
    },
    handleAvatarSuccessCp4: function handleAvatarSuccessCp4(res, file) {
      this.loading1 = 0;
      if (res.status !== 200) {
        this.$message.error(res.message);
      } else {
        this.cp4Value = res.data;
        this.cp4 = URL.createObjectURL(file.raw);
        this.hBlur('form');
      }
    },
    beforeSmAvatarUpload: function beforeSmAvatarUpload(file) {
      var size = file.size / 1024;
      if (size > 100) {
        this.$message.error(this.$t('app_fileOver') + '100k');
        return false;
      }
      this.loadingSm = 1;
      return true;
    },
    beforeBgAvatarUpload: function beforeBgAvatarUpload(file) {
      var size = file.size / 1024;
      if (size > 200) {
        this.$message.error(this.$t('app_fileOver') + '200k');
        return false;
      }
      this.loadingBig = 1;
      return true;
    },
    handleRemove: function handleRemove(file, fileList) {},
    makeCapture: function makeCapture() {
      var str = '';
      if (this.cp0Value) {
        str += this.cp0Value + ',';
      }
      if (this.cp1Value) {
        str += this.cp1Value + ',';
      }
      if (this.cp2Value) {
        str += this.cp2Value + ',';
      }
      if (this.cp3Value) {
        str += this.cp3Value + ',';
      }
      if (this.cp4Value) {
        str += this.cp4Value + ',';
      }
      return str.substring(0, str.length - 1);
    },
    makeExApp: function makeExApp() {
      var str = '';
      console.log('dydydy', this.dynamicTags);
      this.dynamicTags.forEach(function (vl) {
        str += vl + ',';
      });
      str = str.slice(0, str.length - 1);
      this.form.appPackage = str;
      this.hBlur('form');
    },
    uploadApp: function uploadApp(formName) {
      var _this8 = this;

      if (window[this.$route.path]) {
        this.$message.error(this.$t('app_appLoding'));
        return;
      }
      if (this.ulType == 0) {
        this.form.fname = '';
      } else {}

      this.$refs[formName].validate(function (valid) {
        if (valid) {

          _this8.loading = 1;
          if (_this8.config.type === 1) {

            _this8.$editFst(_this8.form.fname, _this8.form.updateType, _this8.form.id, _this8.form.profilesId, _this8.form.name, _this8.form.ver, _this8.form.flag, _this8.form.url, _this8.form.key, _this8.form.md5, _this8.form.size, _this8.form.appPackage, _this8.form.memo, function (res) {
              _this8.loading = 0;
              if (res.status === 200) {
                _this8.$message.success(res.message);
                if (_this8.$route.query.setlocal) {
                  var key = 'stfileDetail';
                  var obj = _this8.$getWObj()[key];
                  obj.name = _this8.form.name;
                  obj.url = _this8.form.url;
                  obj.flag = _this8.form.flag;
                  obj.memo = _this8.form.memo;
                  _this8.$setWObj(key, obj);
                }
                _this8.$router.go(-1);
              } else {
                _this8.$message.error(res.message);
              }
            }, function () {
              _this8.loading = 0;
              _this8.$message(_this8.$t('app_rqsError'));
            });
          } else if (_this8.config.type === 0) {

            _this8.addRqs('');
          } else {
            _this8.addRqs(_this8.config.data.id);
          }
        } else {
          return false;
        }
      });
    },
    addRqs: function addRqs(id) {
      var _this9 = this;

      var ver;
      if (this.isTag) {

        ver = parseInt(this.form.ver) + 1;
      } else {
        ver = 0;
      }
      this.$addFst(this.form.fname, this.form.updateType, id, this.form.name, ver, this.form.flag, this.form.url, this.form.key, this.form.md5, this.form.size, this.form.appPackage, this.form.memo, function (res) {
        _this9.loading = 0;
        if (res.status === 200) {
          _this9.$message.success(res.message);
          _this9.$router.go(-1);
        } else {
          _this9.$message.error(res.message);
        }
      }, function () {
        _this9.loading = 0;
        _this9.$message(_this9.$t('app_rqsError'));
      });
    },
    setTipOk: function setTipOk(isok, msg) {
      if (isok) {
        this.ulinfo.index = 1;
        this.tipColor = { color: '#13CE66' };
        this.ulinfo.tip = '';
      } else {
        this.ulinfo.index = 2;
        this.tipColor = { color: '#FF4949' };
        this.ulinfo.tip = msg;
      }
    },
    fileUploadSuccess: function fileUploadSuccess(res, file) {

      window[this.$route.path] = '';
      console.log('file', res);
      this.ulinfo.tip = res.message;
      if (res.status === 200) {
        if (this.config.type == 2) {
          if (true) {
            this.setTipOk(true, '');

            this.form.md5 = res.data.md5;
            this.form.key = res.data.key;
            this.form.size = res.data.size;
            this.form.url = res.data.fileUrl;
            this.hBlur('form');

            if (res.data.version < this.config.data.version) {
              this.isLowerTip = true;
            } else {
              this.isLowerTip = false;
            }
          } else {
            this.setTipOk(false, this.$t('app_udsamexml'));
            this.isLowerTip = false;
            this.form.flag = '';
            this.form.ver = '';
            this.form.md5 = '';
            this.form.key = '';
            this.form.size = '';
            this.form.url = '';
            this.hBlur('form');
          }
        } else {
          this.setTipOk(true, '');

          this.form.md5 = res.data.md5;
          this.form.key = res.data.key;
          this.form.size = res.data.size;
          this.form.url = res.data.fileUrl;
          this.hBlur('form');
        }
        this.fileList = [{ name: file.name }];
      } else {
        this.ulinfo.index = 2;
        if (this.config.type !== 1) {
          this.fileList = [];
        } else {
          this.fileList = [{ name: this.makeAppPath(this.config.data.appUrl) }];
        }
        this.$message.error(res.message);
        this.tipColor = { color: '#FF4949' };
      }
    },
    fileBeforeUpload: function fileBeforeUpload(file) {
      console.log(file);
      if (file) {
        window[this.$route.path] = 1;
        var ar = file.name.split('.');
        var type = ar[ar.length - 1];
      } else {
        this.$message.error(this.$t('app_onlyApk'));
        return false;
      }
    },
    setCapturesIn: function setCapturesIn(strs) {
      var _this10 = this;

      if (strs) {
        var arr = strs.split(',');

        arr.forEach(function (value, index, array) {
          switch (index) {
            case 0:
              _this10.cp0 = _this10.imgFullUrl(value);
              _this10.cp0Value = value;
              break;
            case 1:
              _this10.cp1 = _this10.imgFullUrl(value);
              _this10.cp1Value = value;
              break;
            case 2:
              _this10.cp2 = _this10.imgFullUrl(value);
              _this10.cp2Value = value;
              break;
            case 3:
              _this10.cp3 = _this10.imgFullUrl(value);
              _this10.cp3Value = value;
              break;
            case 4:
              _this10.cp4 = _this10.imgFullUrl(value);
              _this10.cp4Value = value;
              break;
          }
        });
      }
    },
    setCapturesArr: function setCapturesArr(strs) {
      if (strs) {
        var arr = strs.split(',');
        this.captures = arr;
      }
    },
    fillEdit: function fillEdit(data) {

      this.form.id = data.id;
      this.form.profilesId = data.profilesId;
      this.form.name = data.name;
      this.form.ver = data.version;
      this.form.flag = data.flag;
      this.form.url = data.url;
      this.form.key = data.key;
      this.form.md5 = data.md5;
      this.form.size = data.size;
      this.form.appPackage = data.appPackage;
      this.form.memo = data.memo;
      this.form.updateType = data.updateType;
      this.form.fname = data.ftpFileName;


      var elm = data.url.split('/').pop();
      elm = elm ? elm : '';
      this.fileList = [{ name: elm }];

      if (data.appPackage) {
        this.dynamicTags = data.appPackage.split(',');
      }

      this.ulinfo.index = 1;
    },
    getTypeList: function getTypeList() {
      var _this11 = this;

      this.$getAppTypeList(100000000, 1, function (res) {
        if (res.status === 200) {
          console.log(res);
          _this11.appTypes = res.data;
        } else {
          _this11.$message(res.message);
        }
      }, '');
    },
    cancel: function cancel() {
      this.$router.go(-1);
    },
    verify: function verify() {
      var _this12 = this;

      this.loading = 1;
      var id = this.config.data.applicationid;
      var passValue = this.radio === '1' ? '2' : '3';
      var desc = this.checkDesc;
      if (this.$appUrlTag === 0) {
        this.$verifyApp(localStorage.user, id, passValue, desc, function (res) {
          _this12.loading = 0;
          if (res.status === 200) {
            _this12.$router.go(-1);
          } else {
            _this12.$message.error(res.message);
          }
        }, function () {
          _this12.loading = 0;
          _this12.$message.error(_this12.$t('app_rqsError'));
        });
      } else {
        this.$verifyApp1(this.mechanismId, localStorage.user, id, passValue, desc, function (res) {
          _this12.loading = 0;
          if (res.status === 200) {
            _this12.$router.go(-1);
          } else {
            _this12.$message.error(res.message);
          }
        }, function () {
          _this12.loading = 0;
          _this12.$message.error(_this12.$t('app_rqsError'));
        });
      }
    },
    getAppHistory: function getAppHistory() {
      var _this13 = this;

      if (!this.config.data.launcherName) {
        return;
      }
      console.log('pkg', this.config.data);
      this.loading = 1;
      if (this.$appUrlTag === 0) {
        this.$getAppHistory(this.config.data.launcherName, this.config.data.packagename, function (res) {
          console.log('reslist', res);
          _this13.loading = 0;
          if (res.status === 200) {
            _this13.tableData = res.data;
          } else {
            _this13.$message.error(res.message);
          }
        }, function () {
          _this13.loading = 0;
        });
      } else {
        this.$getAppHistory1(this.mechanismId, this.config.data.packagename, function (res) {
          console.log('reslist', res);
          _this13.loading = 0;
          if (res.status === 200) {
            _this13.tableData = res.data;
          } else {
            _this13.$message.error(res.message);
          }
        }, function () {
          _this13.loading = 0;
        });
      }
    },
    uploadNew: function uploadNew() {},
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    },
    init: function init() {
      this.config = this.$getWObj().filestEdit;
      console.log('config', this.config);

      switch (this.config.type) {
        case 0:
          break;
        case 1:
          this.getDetail();
          break;
        case 2:
          this.form.flag = this.config.data.flag;
          this.isTag = true;
          this.form.ver = this.config.data.version;
          break;
        case 3:
          break;
      }
      this.getList();
    },
    getDevices: function getDevices() {
      var _this14 = this;

      var vl = this.srchValue ? this.srchValue : '';
      var channel = this.channelId ? this.channelId : '';
      var status = this.status ? this.status : '';
      this.loading = 1;
      if (this.$appUrlTag === 0) {
        this.$getDevices(this.index, this.$gRow, channel, vl, status, '', this.config.data.applicationid, function (res) {
          console.log('dv', res);
          _this14.loading = 0;
          if (res.data) {
            _this14.tableData = res.data;
            _this14.total = res.total;
          }
        }, function () {
          _this14.loading = 0;
        });
      } else {
        this.$getDevices1(this.index, this.$gRow, localStorage.mechanismId, vl, status, '', this.config.data.applicationid, function (res) {
          console.log('dv', res);
          _this14.loading = 0;
          if (res.data) {
            _this14.tableData = res.data;
            _this14.total = res.total;
          }
        }, function () {
          _this14.loading = 0;
        });
      }
    },
    bindOperate: function bindOperate(row) {
      this.bind(row.terminalId, row.terminalNo);
    },
    bind: function bind(tId, tNo) {
      var _this15 = this;

      this.loading = 1;
      if (this.$appUrlTag === 0) {
        this.$bindApp('0', tId, this.config.data.applicationid, function (res) {
          if (res.status === 200) {
            _this15.$message.success(_this15.$t('app_tipViewTask'));
          } else {
            _this15.$message.error(res.message);
          }
          _this15.loading = 0;
        }, function () {
          _this15.loading = 0;
        });
      } else {
        this.$verifyAppPush(localStorage.mechanismId, tNo, this.config.data.applicationid, function (res) {
          if (res.status === 200) {
            _this15.$message.success(_this15.$t('app_tipViewTask'));
          } else {
            _this15.$message.error(res.message);
          }
          _this15.loading = 0;
        }, function () {
          _this15.loading = 0;
        });
      }
    },
    srchDevice: function srchDevice() {
      this.getDevices();
    }
  },
  mounted: function mounted() {

    this.init();
  }
});

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default.a
  },
  data: function data() {
    var that = this;
    return {
      mechanismData: {
        callback: function callback(value) {
          that.mech = value;
          that.selectChange(value);
        }
      },
      isAddFTP: false,
      sltime: '',
      cntype: '0',
      form: {
        id: '',
        ip: '',
        port: '',
        path: '',
        usr: '',
        psw: '',
        stt: '01:00',
        frequence: 0
      },
      rules: {
        stt: [{ required: true, message: this.$t('app_select'), trigger: 'blur' }],
        ip: [{ required: true, message: this.$t('app_input'), trigger: 'blur' }],
        path: [{ required: true, message: this.$t('app_input'), trigger: 'blur' }],
        usr: [{ required: true, message: this.$t('app_input'), trigger: 'blur' }],
        psw: [{ required: true, message: this.$t('app_input'), trigger: 'blur' }],
        frequence: [{ type: 'number', required: true, message: this.$t('app_inputNumber') + ' 1-23', trigger: 'blur' }]
      },
      isSetFtp: false,
      listKey: 'launch-list',
      cerDialogVisible: false,
      cerTipDialogVisible: false,
      dvLoading: 0,
      appId: '',
      stModel: [{ label: this.$t('app_online'), vl: '1' }, { label: this.$t('app_offline'), vl: '2' }, { label: this.$t('app_new'), vl: '0' }],
      channels: [],
      srchValue: '',
      channelId: '',
      cerTipMsg: '',
      status: '',
      dvIndex: 1,
      dialogVisible: 0,
      mechanismId: window.localStorage['mechanismId'],
      selectMid: '',
      tableData: [],
      dvTableData: [],
      appTypes: [],
      appTypeValue: '',
      appStatus: [{ label: this.$t('app_prePushVerify'), value: '0' }, { label: this.$t('app_preVerify'), value: '1' }, { label: this.$t('app_verifyPass'), value: '2' }, { label: this.$t('app_verifyNotPass'), value: '3' }],
      appStatusValue: '',
      total: 0,
      dvTotal: 0,
      loading: 0,
      appType: '',
      queryKey: ''
    };
  },

  computed: {
    index: function index() {
      var vl = this.$getWPage(this.listKey);
      return vl ? vl : 1;
    },
    getDvStatus: function getDvStatus(value) {
      switch (value) {
        case '0':
          return this.$t('app_prePushVerify');
        case '1':
          return this.$t('app_preVerify');
        case '2':
          return this.$t('app_verifyPass');
        case '3':
          return this.$t('app_verifyNotPass');
      }
    }
  },
  methods: {
    timeChange: function timeChange(vl) {
      this.form.stt = vl;
    },
    setFTP: function setFTP() {
      var _this = this;

      this.loading = 1;
      this.$getFTPDetail(function (res) {
        _this.loading = 0;
        if (res.status === 200) {
          if (res.data) {
            _this.isAddFTP = false;
            _this.form.ip = res.data.ftpAddress;
            _this.form.port = res.data.ftpPort;
            _this.form.path = res.data.ftpPath;
            _this.form.usr = res.data.ftpUser;
            _this.form.psw = res.data.ftpPwd;
            _this.form.frequence = res.data.updateTime;
            _this.form.id = res.data.id;
            _this.form.stt = res.data.opeTime;
          } else {
            _this.isAddFTP = true;
            _this.form = {};
          }
          _this.isSetFtp = true;
        } else {
          _this.$message.error(res.message);
        }
      }, function () {
        _this.loading = 0;
        _this.$message(_this.$t('app_rqsError'));
      });
    },
    numchange: function numchange(vl) {
      var index = vl.indexOf('.');
      if (index > 0 || vl > 23) {
        this.$message.error($t('app_inputNumber') + ' 1-23');
      } else {
        this.form.frequence = parseInt(vl);
      }
    },
    save: function save() {
      var _this2 = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          if (!_this2.form.port && _this2.cntype == '1') {
            _this2.$message.error(_this2.$t('app_inputCp'));
            return;
          }
          if (_this2.cntype == 0) {
            _this2.form.ip = '';
            _this2.form.port = '';
            _this2.form.usr = '';
            _this2.form.psw = '';
          }
          if (_this2.isAddFTP) {
            _this2.newRqs();
          } else {
            _this2.editRqs();
          }
        } else {
          return false;
        }
      });
    },
    newRqs: function newRqs() {
      var _this3 = this;

      this.loading = 1;
      var form = this.form;
      this.$addFTP(form.stt, form.ip, form.port, form.usr, form.psw, form.path, form.frequence, function (res) {
        _this3.loading = 0;
        if (res.status === 200) {
          _this3.$message.success(res.message);
          _this3.isSetFtp = false;
        } else {
          _this3.$message.error(res.message);
        }
      }, function () {
        _this3.loading = 0;
        _this3.$message(_this3.$t('app_rqsError'));
      });
    },
    editRqs: function editRqs() {
      var _this4 = this;

      this.loading = 1;
      var form = this.form;
      this.$editFTP(form.id, form.stt, form.ip, form.port, form.usr, form.psw, form.path, form.frequence, function (res) {
        _this4.loading = 0;
        if (res.status === 200) {
          _this4.$message.success(res.message);
          _this4.isSetFtp = false;
        } else {
          _this4.$message.error(res.message);
        }
      }, function () {
        _this4.loading = 0;
        _this4.$message(_this4.$t('app_rqsError'));
      });
    },
    pushCreateCer: function pushCreateCer() {
      this.$router.push({ path: "/certificate/new" });
    },
    pushUploadCer: function pushUploadCer() {
      this.$router.push({ path: "/certificate/upload" });
    },
    bindOperate: function bindOperate(row) {
      var _this5 = this;

      this.dvLoading = 1;
      if (this.$appUrlTag === 0) {
        this.$bindApp('0', row.terminalNo, this.appId, function (res) {
          if (res.status === 200) {
            _this5.$message.success(_this5.$t('app_tipViewTask'));
          } else {
            _this5.$message.error(res.message);
          }
          _this5.dvLoading = 0;
        }, function () {
          _this5.dvLoading = 0;
        });
      } else {
        this.$bindApp1(localStorage.mechanismId, row.terminalNo, this.appId, function (res) {
          if (res.status === 200) {
            _this5.$message.success(_this5.$t('app_tipViewTask'));
          } else {
            _this5.$message.error(res.message);
          }
          _this5.dvLoading = 0;
        }, function () {
          _this5.dvLoading = 0;
        });
      }
    },
    getChannels: function getChannels() {
      var _this6 = this;

      this.$getChannelList(10000, 1, '', '', '', function (res) {
        if (res.status === 200) {
          _this6.channels = res.data;
        } else {
          _this6.$message.error(res.message);
        }
      }, function () {
        _this6.$message.error(_this6.$t('app_rqsError'));
      });
    },
    getStatus: function getStatus(value) {
      if (!value) return '';
      switch (value) {
        case '0':
          return { vl: this.$t('app_prePushVerify'), style: 'color:#8492A6;' };
        case '1':
          return { vl: this.$t('app_preVerify'), style: 'color:#F7BA2A;' };
        case '2':
          return { vl: this.$t('app_verifyPass'), style: 'color:#13CE66;' };
        case '3':
          return { vl: this.$t('app_verifyNotPass'), style: 'color:#FF4949;' };
      }
    },
    srchDevice: function srchDevice() {
      this.getDevices();
    },
    selectDvChange: function selectDvChange(vl) {
      this.getDevices();
    },
    pageDvSized: function pageDvSized(val) {
      this.$gRow = val;
      this.getDevices();
    },
    getDevices: function getDevices() {
      var _this7 = this;

      var vl = this.srchValue ? this.srchValue : '';
      var channel = this.channelId ? this.channelId : '';
      var status = this.status ? this.status : '';
      var appId = this.appId ? this.appId : '';
      this.dvLoading = 1;
      if (this.$appUrlTag === 0) {
        this.$getDevices(this.dvIndex, this.$gRow, channel, vl, status, '', appId, function (res) {
          _this7.dvLoading = 0;
          if (res.data) {
            _this7.dvTableData = res.data;
            _this7.dvTotal = res.total;
          }
        }, function () {
          _this7.dvLoading = 0;
        });
      } else {

        this.$getDevices1(this.dvIndex, this.$gRow, localStorage.mechanismId, vl, status, '', appId, function (res) {
          console.log('dv', res);
          _this7.dvLoading = 0;
          if (res.data) {
            _this7.dvTableData = res.data;
            _this7.dvTotal = res.total;
          }
        }, function () {
          _this7.dvLoading = 0;
        });
      }
    },
    editApp: function editApp(row) {
      this.$setWObj('filestEdit', { type: 1, data: row });
      this.$router.push({ path: '/stfile/edit' });
    },
    pushApp: function pushApp(row) {

      this.$setWObj('pushList', { type: '13', data: row });
      this.$router.push({ path: '/stfile/push' });
    },
    query: function query() {
      this.getList();
    },
    selectChange: function selectChange(vl) {
      this.selectMid = vl;
      this.getList();
    },
    reset: function reset() {
      this.queryKey = '';
      this.appType = '';
      this.getList();
    },
    pageSelect: function pageSelect(index) {
      this.$setWPage(this.listKey, index);
      this.getList();
    },
    pageDvSelect: function pageDvSelect(index) {
      this.dvIndex = index;
      this.getDevices();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getList();
    },
    deleteApp: function deleteApp(obj) {
      var _this8 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        console.log(obj);
        _this8.$delFst(obj.id, function (res) {
          if (res.status === 200) {
            _this8.getList();
            _this8.$message.success(res.message);
          } else {
            _this8.$message.error(res.message);
          }
        }, '');
      }, '');
    },
    submitApp: function submitApp(obj) {
      var _this9 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_tipVerify'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this9.loading = 1;
        _this9.$verifyFst(obj.recordId, '', '1', function (res) {
          _this9.loading = 0;
          if (res.status === 200) {
            _this9.getList();
            _this9.$message.success(res.message);
          } else {
            _this9.$message.error(res.message);
          }
        }, function () {
          _this9.loading = 0;
        });
      }, '');
    },
    cellClick: function cellClick(row, ev, col) {
      if (col.label && col.label === this.$t('app_operate')) {
        return;
      }

      this.toDetail(row);
    },
    toDetail: function toDetail(row) {
      var path = '/stfile/detail';
      var key = 'stfileDetail';
      var obj = row;

      this.$setWObj(key, obj);
      this.$router.push({ path: path });
    },
    jumpToUpload: function jumpToUpload() {

      this.$setWObj('filestEdit', { type: 0 });
      this.$router.push({ path: '/stfile/add' });
    },
    getList: function getList() {
      var _this10 = this;

      this.loading = 1;
      var dsid = this.selectMid ? this.selectMid : '';
      var name = this.queryKey ? this.queryKey : '';
      this.$fstList(this.index, this.$gRow, name, function (res) {

        _this10.loading = 0;
        if (res.status === 200) {
          _this10.total = res.total;
          _this10.tableData = res.data;
        } else {
          _this10.$message(res.message);
        }
      }, function () {
        _this10.loading = 0;
        _this10.$message.error(_this10.$t('app_rqsError'));
      });
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD HH:mm:ss');
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    }
  },
  mounted: function mounted() {
    this.getList();
  },
  destroyed: function destroyed() {}
});

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_df_png__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_df_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_df_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__);


var _methods;




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var that = this;
    return {
      dLoading: false,
      srchValue: '',
      reason: '',
      config: '',
      captures: [],
      loading: 0,
      dialogVisible: false,
      notPassDialog: false,
      index: 1,
      tableData: [],
      total: 0,
      status: '',
      tags: [],
      mech: '',
      stModel: [{ label: this.$t('app_online'), vl: '1' }, { label: this.$t('app_offline'), vl: '2' }, { label: this.$t('app_sleep'), vl: '3' }],
      mechanismData: {
        callback: function callback(value) {
          that.mech = value;
          that.selectChange(value);
        }
      }
    };
  },

  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default.a
  },
  computed: {
    showUploadNew: function showUploadNew() {
      console.log('ccc', this.config.data);
      if (this.config.data) {
        if (this.config.data.isoperation === 0 && this.config.data.appStatus === '2') {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  methods: (_methods = {
    bindOperate: function bindOperate(row) {
      var _this = this;

      this.dLoading = 1;
      this.$fstTest(this.config.recordId, row.terminalNo, function (res) {
        _this.dLoading = 0;
        if (res.status === 200) {
          _this.$message.success(_this.$t('app_tipViewTask'));
          _this.notPassDialog = false;
        } else {
          _this.$message.error(res.message);
        }
      }, function (error) {
        _this.dLoading = 0;
        _this.$message.error(_this.$t('app_rqsError'));
      });
    },
    verify: function verify(vl) {
      var _this2 = this;

      if (vl === '2') {
        this.$confirm(this.$t('app_srpassvf') + '?', this.$t('app_tip'), {
          confirmButtonText: this.$t('app_sure'),
          cancelButtonText: this.$t('app_cancel'),
          type: 'warning'
        }).then(function () {
          _this2.verifyRqs(vl);
        }).catch(function () {});
      } else if (vl === '3') {
        this.notPassDialog = true;
      }
    },
    verifyRqs: function verifyRqs(vl) {
      var _this3 = this;

      this.loading = 1;
      this.$verifyFst(this.config.id, this.reason, vl, function (res) {
        _this3.loading = 0;
        if (res.status === 200) {
          _this3.$message.success(res.message);
          _this3.$router.go(-1);
        } else {
          _this3.$message.error(res.message);
        }
      }, function () {
        _this3.$message.error(_this3.$t('app_rqsError'));
        _this3.loading = 0;
      });
    },
    srchDevice: function srchDevice() {
      this.getDevices();
    },
    selectChange: function selectChange(vl) {
      this.getDevices();
    },
    pageSelect: function pageSelect(index) {
      this.index = index;
      this.getDevices();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getDevices();
    },
    getDevices: function getDevices() {
      var _this4 = this;

      var vl = this.srchValue ? this.srchValue : '';

      var status = this.status ? this.status : '';
      var mc = this.mech;

      this.loading = 1;
      this.$getDvDevices(this.index, this.$gRow, mc, vl, status, '', '', '', '', '', function (res) {
        console.log('dv', res);
        _this4.loading = 0;
        if (res.data) {
          _this4.tableData = res.data;
          _this4.total = res.total;
        }
      }, function () {
        _this4.loading = 0;
      });
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD hh:mm:ss');
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'selectChange', function selectChange(vl) {
    this.getDevices();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'pageSelect', function pageSelect(index) {
    this.index = index;
    this.getDevices();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'pageSized', function pageSized(val) {
    this.$gRow = val;
    this.getDevices();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'deleteAppHis', function deleteAppHis(row) {
    var _this5 = this;

    if (row.applicationid) {
      this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
        confirmButtonText: this.$t('app_sure'),
        cancelButtonText: this.$t('app_cancel'),
        type: 'warning'
      }).then(function () {
        _this5.loading = 1;
        if (_this5.$appUrlTag === 0) {
          _this5.$deleteApp(row.applicationid, function (res) {
            _this5.loading = 0;
            if (res.status === 200) {
              _this5.getAppHistory();
            } else {
              _this5.$message.error(res.message);
            }
          }, function () {
            _this5.loading = 0;
          });
        } else {
          _this5.$deleteAppHis(row.applicationid, function (res) {
            _this5.loading = 0;
            if (res.status === 200) {
              _this5.getAppHistory();
            } else {
              _this5.$message.error(res.message);
            }
          }, function () {
            _this5.loading = 0;
          });
        }
      }).catch(function () {});
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'imgFullUrl', function imgFullUrl(path) {
    if (path) {
      return this.$urls.prefix + path;
    } else {
      return '';
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'getAppHistory', function getAppHistory() {
    var _this6 = this;

    if (!this.config.data.appName) {
      return;
    }

    this.loading = 1;
    if (this.$appUrlTag === 0) {
      this.$getAppHistory(this.config.data.appName, this.config.data.packagename, function (res) {
        _this6.loading = 0;
        if (res.status === 200) {
          _this6.tableData = res.data;
        } else {
          _this6.$message.error(res.message);
        }
      }, function () {
        _this6.loading = 0;
      });
    } else {

      this.$getAppHistory1(localStorage.mechanismId, this.config.data.packagename, function (res) {

        console.log('his', res);
        _this6.loading = 0;
        if (res.status === 200) {
          _this6.tableData = res.data;
        } else {
          _this6.$message.error(res.message);
        }
      }, function () {
        _this6.loading = 0;
      });
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'uploadNew', function uploadNew() {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'init', function init() {
    this.config = this.$getWObj().stfileVerify;
    console.log(this.config);
    this.tags = this.config.appPackage.split(',');
    this.getDevices();
  }), _methods),
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_url__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'info',
	data: function data() {
		return {
			currentPage: 1,
			pageSize: 10,
			totalRecords: 0,
			arrdata: []
		};
	},
	created: function created() {
		this.getData(1);
	},

	methods: {
		handleSizeChange: function handleSizeChange(val) {
			this.pageSize = val;
			this.getData(this.currentPage);
		},
		handleCurrentChange: function handleCurrentChange(val) {
			this.currentPage = val;
			this.getData(this.currentPage);
		},

		add: function add() {
			this.$router.push({ path: '/terOta/lock' });
		},

		lockRow: function lockRow(userid) {
			var _this = this;

			var params = { ids: userid };
			this.$confirm(this.$t('terminal.OtaList.lock_tips'), this.$t('lin_btn.tips'), {
				confirmButtonText: this.$t('lin_btn.confirm'),
				cancelButtonText: this.$t('lin_btn.cancel'),
				type: 'warning'
			}).then(function () {
				__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/ota_lock/unlock.do', params).then(function (res) {
					if (res.data.status == 200) {
						_this.getData(1);
						_this.$message.success(_this.$t('lin_global.unlock_success'));
					} else {
						_this.$message.error(res.data.message);
					}
				});
			}).catch(function () {});
		},
		getData: function getData(page) {
			var _this2 = this;

			this.currentPage = page;
			var mechanismId = localStorage.getItem('mechanismId');
			var params = { "page": page, "rows": this.pageSize, "mechanismId": mechanismId };
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/ota_lock/list.do', params).then(function (res) {
				_this2.arrdata = res.data.data;
				_this2.totalRecords = res.data.total;
			});
		}
	}
});

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		MechanismSelector: __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default.a
	},
	name: 'add',
	data: function data() {
		var _this = this;

		var terNoCheck = function terNoCheck(rule, value, callback) {
			var token = localStorage.getItem('user');
			var params = {
				token: token,
				terminal_no: value
			};
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/terminal/existTerNo.do', params).then(function (res) {
				if (res.data.status == '200') {
					if (res.data.data.existTerminal) {
						callback(new Error(_this.$t('terminal.add.rules_no_4')));
					} else {
						callback();
					}
				} else {}
			});
		};
		var that = this;
		return {
			models: [],
			firms: [],
			dvTypes: [],
			mechanismData: {
				placeholder: that.$t('lin_global.place_areaid'),
				callback: function callback(value) {
					that.form.areaid = value == 1 ? '' : value;


					that.form.terminal_model = '';
					that.form.terminal_type = '';
					that.form.manufid = '';
					that.getSlData(value);
				}
			},
			isSubmit: false,
			areaProps: {
				value: 'areaid',
				label: 'areaname',
				children: 'areaDetail'
			},
			form: {
				'terminal_no': null,
				'terminal_name': null,
				'terminal_model': null,
				'terminal_type': null,
				'areaid': null,
				'manufid': null,
				'address': null,

				'memo': ''
			},
			rules: {
				'terminal_no': [{
					type: 'string',
					required: true,
					message: this.$t('terminal.add.rules_no_1')
				}, {
					pattern: /^[\w-]+$/,
					message: this.$t('terminal.add.rules_no_3')
				}, {
					validator: terNoCheck,
					trigger: 'blur'
				}],
				'terminal_name': [{
					type: 'string',
					required: true,
					message: this.$t('terminal.add.rules_name_1')
				}, {
					min: 1,
					max: 50,
					message: this.$t('terminal.add.rules_name_2')
				}, {
					message: this.$t('terminal.add.rules_name_3')
				}],
				'terminal_model': [{
					required: true,
					message: this.$t('terminal.add.place_model')
				}],
				'terminal_type': [{
					required: true,
					message: this.$t('terminal.add.place_type')
				}],
				'manufid': [{
					required: true,
					message: this.$t('terminal.add.place_manufid')
				}],
				'areaid': [{
					required: true,
					message: this.$t('lin_global.place_areaid')
				}],
				'address': [{
					required: true,
					message: this.$t('terminal.add.place_address')
				}],

				'memo': [{
					required: true,
					message: this.$t('app_input')
				}]
			},
			vendorList: [],
			modelList: [],
			terminalTypeList: [],
			areaList: []
		};
	},
	created: function created() {

		this.getAd();
	},

	methods: {
		dateFormat: function dateFormat(dateData) {
			var date = new Date(dateData);
			var y = date.getFullYear();
			var m = date.getMonth() + 1;
			m = m < 10 ? '0' + m : m;
			var d = date.getDate();
			d = d < 10 ? '0' + d : d;

			var hh = date.getHours();
			hh = hh < 10 ? '0' + hh : hh;

			var mm = date.getMinutes();
			mm = mm < 10 ? '0' + mm : mm;

			var ss = date.getSeconds();
			ss = ss < 10 ? '0' + ss : ss;

			var time = y + '-' + m + '-' + d + ' ' + hh + ':' + mm + ":" + ss;
			return time;
		},
		getSlData: function getSlData(value) {
			var _this2 = this;

			if (!value) {
				this.models = [];
				this.dvTypes = [];
				this.firms = [];
				return;
			}
			this.$mechGetTypes(value, function (res) {
				if (res.status == 200) {
					_this2.models = res.data.models;
					_this2.dvTypes = res.data.types;
					_this2.firms = res.data.manufactures;
				}
			}, '');
		},

		addInfo: function addInfo() {
			var _this3 = this;

			var jsondata = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.form));

			console.log(jsondata);
			jsondata.manufid = this.form.manufid;
			jsondata.terminal_type = this.form.terminal_type;
			jsondata.terminal_model = this.form.terminal_model;
			this.isSubmit = true;
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/terminal/add.do', jsondata).then(function (res) {
				if (res.data.status == 200) {
					_this3.$message.success(_this3.$t('terminal.add.success'));
					_this3.isSubmit = false;
					_this3.$router.go(-1);
				} else {
					_this3.isSubmit = false;
					_this3.$message.error(res.data.message);
				}
			});
		},
		onSubmit: function onSubmit() {
			var _this4 = this;

			this.$refs['addForm'].validate(function (valid) {

				if (valid) {
					_this4.addInfo();
				} else {
					_this4.$message.error(_this4.$t('lin_global.refs'));
					return false;
				}
			});
		},
		onCancel: function onCancel() {
			this.$router.go(-1);
		},
		getModel: function getModel() {
			var _this5 = this;

			var params = {
				page: 1,
				rows: 10000
			};
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/terminalModel/list.do', params).then(function (res) {
				_this5.modelList = res.data.data;
			});
		},
		getType: function getType() {
			var _this6 = this;

			var params = {
				page: 1,
				rows: 10000
			};
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/terminalType/list.do', params).then(function (res) {
				_this6.terminalTypeList = res.data.data;
			});
		},
		getVendor: function getVendor() {
			var _this7 = this;

			var params = {
				page: 1,
				rows: 10000
			};
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/manufacturers/list.do', params).then(function (res) {
				_this7.vendorList = res.data.data;
			});
		},
		getAd: function getAd() {
			var _this8 = this;

			var params = {
				page: 1,
				rows: 10000
			};
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__api_url__["a" /* baseurl */] + '/mechanism/list.do', params).then(function (res) {
				_this8.areaList = res.data.data;
			});
		}
	}
});

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_url__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      pushDone: false,
      focusEvent: __WEBPACK_IMPORTED_MODULE_1__api_url__["c" /* focusEvent */],
      terminalID: this.$route.params.id,
      terminalNO: this.$route.params.no,
      tableData: [],
      input: '',
      rows: [],
      multipleSelection: '',
      multipleSelectionUrl: '',
      multipleSelectionVersions: '',
      multipleSelectionNames: '',
      loading: false,
      tInfo: ''
    };
  },
  created: function created() {
    var info = this.$getWObj().terminalInfo;
    this.tInfo = info;

    this.getList();
  },

  methods: {
    jumpNow: function jumpNow() {
      this.$router.push({ path: '/task/ptask' });
    },

    handleIconClick: function handleIconClick() {
      this.getList();
    },
    bindAll: function bindAll() {
      var arr = [];
      arr = this.multipleSelection.split(",");
      if (this.multipleSelection == '') {
        this.$message(this.$t('terminal.appBind.empty_tips'));
      } else if (arr.length > 5) {
        this.$message(this.$t('terminal.appBind.five_tips'));
      } else {

        this.bind(this.multipleSelection, this.multipleSelectionUrl, this.multipleSelectionVersions, this.multipleSelectionNames);
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var arrId = [];
      var appU = [];
      var appV = [];
      var appN = [];
      for (var i = 0; i < val.length; i++) {
        var applicationid = val[i].applicationid;
        var appUrl = val[i].appUrl;
        var appVersion = val[i].appVersion;
        var appName = val[i].appName;

        arrId.push(applicationid);
        appU.push(appUrl);
        appV.push(appVersion);
        appN.push(appName);
      }
      var strId = arrId.join(",");
      var strUrl = appU.join(",");
      var strVer = appV.join(",");
      var strNam = appV.join(",");
      this.multipleSelection = strId;
      this.multipleSelectionUrl = strUrl;
      this.multipleSelectionVersions = strVer;
      this.multipleSelectionNames = strNam;
      this.rows = val;
    },
    bind: function bind(a, b, c, d, row) {
      var _this = this;

      this.$confirm(this.$t('terminal.appBind.install_tips'), this.$t('lin_btn.tips'), {
        confirmButtonText: this.$t('lin_btn.confirm'),
        cancelButtonText: this.$t('lin_btn.cancel'),
        type: 'warning'
      }).then(function () {

        _this.loading = true;
        _this.$terBindApp(a, _this.terminalNO, function (res) {
          _this.loading = false;
          if (res.status == 200) {
            _this.pushDone = true;
            _this.getList();
          } else {
            _this.$message.error(res.message);
          }
        }, function (error) {
          _this.loading = false;
          _this.$message.error(_this.$t('app_rqsError'));
        });
      }).catch(function () {});
    },
    getList: function getList() {
      var _this2 = this;

      var mechanismId = localStorage.getItem('mechanismId');


      this.$getTerInstallList(1, 10000, mechanismId, this.input, this.terminalID, function (res) {
        if (res.status == 200) {
          _this2.tableData = res.data;
          _this2.loading = false;
        } else {
          _this2.loading = false;
        }
      }, function (error) {});
    }
  }
});

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_url__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      sNum: 0,
      list: [],
      terminalID: this.$route.params.id,
      terNo: '',
      tableData: [],
      loading: true
    };
  },
  created: function created() {
    this.terNo = this.$getWObj().tdToList;
    this.getList();
  },

  methods: {
    setAutoLc: function setAutoLc(row) {
      var _this2 = this;

      this.loading = true;

      var packageName = row.packageName;
      var terminalNo = this.terNo;

      this.$autoLaunchApp(terminalNo, packageName, function (res) {
        _this2.loading = false;
        if (res.status === 200) {
          _this2.$message.success(res.message);
          _this2.getList();
        } else {
          _this2.$message.error(res.message);
        }
      });
    },
    clearAppData: function clearAppData(row) {
      var _this3 = this;

      this.$confirm(this.$t('app_isclupappdt') + '?', this.$t('lin_btn.tips'), {
        confirmButtonText: this.$t('lin_btn.confirm'),
        cancelButtonText: this.$t('lin_btn.cancel'),
        type: 'warning'
      }).then(function () {
        _this3.loading = true;
        var type = '';
        var packageName = row.packageName;
        var terminalNo = _this3.terNo;
        _this3.$dvcmd('QCYYSJ', type, packageName, terminalNo, function (res) {

          _this3.loading = false;

          if (res.status === 200) {
            _this3.$message.success(res.message);
          } else {
            _this3.$message.error(res.message);
          }
        }, function (err) {
          _this3.loading = false;
        });
      }).catch(function () {});
    },
    mulDelAppPush: function mulDelAppPush() {
      var _this4 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_isUnbindApp'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        console.log(_this4.list);

        var isPass = true;
        _this4.list.forEach(function (vl) {
          if (vl.type == 1) {
            isPass = false;
            return;
          }
        });

        if (!isPass) {
          _this4.$message(_this4.$t('app_cannotwithsysapp'));
          return;
        }

        console.log('ll', _this4.list);

        var pkg = '';
        var vers = '';
        _this4.list.forEach(function (vl) {
          pkg += vl.packageName + ',';
          vers += vl.appVersion + ',';
        });
        pkg = pkg.substring(0, pkg.length - 1);
        vers = vers.substring(0, vers.length - 1);

        var _this = _this4;
        _this4.$unbind(_this4.terNo, vers, pkg, function (res) {
          _this4.loading = 0;
          _this4.$message(res.message);
          if (res.status === 200) {

            setTimeout(function () {
              _this.getList();
            }, 1500);
          }
        }, function () {
          _this4.loading = 0;
        });
      }, '');
    },
    handleSelectionChange: function handleSelectionChange(list) {

      this.sNum = list.length;
      this.list = list;
    },

    formatStatus: function formatStatus(row, column) {
      return row.type == 0 ? this.$t('terminal.appList.format_status1') : row.type == 1 ? this.$t('terminal.appList.format_status2') : '';
    },
    unbund: function unbund(row) {
      var _this5 = this;

      this.$confirm(this.$t('terminal.appList.tips1') + '?', this.$t('lin_btn.tips'), {
        confirmButtonText: this.$t('lin_btn.confirm'),
        cancelButtonText: this.$t('lin_btn.cancel'),
        type: 'warning'
      }).then(function () {
        _this5.loading = true;
        _this5.$unbind(row.terminalNo, row.appVersion, row.packageName, function (res) {
          _this5.loading = false;

          if (res.status === 200) {
            _this5.getList();
            _this5.$message.success(res.message);
          } else {
            _this5.$message.error(res.message);
          }
        }, function (err) {
          _this5.loading = false;
        });
      }).catch(function () {});
    },
    getList: function getList() {
      var _this6 = this;

      var params = { page: 1, rows: 10000, terminal_id: this.terminalID };
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/terminal_app/bindList.do', params).then(function (res) {
        if (res.data.status == 200) {
          _this6.tableData = res.data.data;
          _this6.loading = false;
          for (var i = 0; i < res.data.data.length; i++) {
            if (res.data.data[i].type == 0) {
              res.data.data[i]['ifBind'] = true;
            } else if (res.data.data[i].type == 1) {
              res.data.data[i]['ifBind'] = false;
            } else {
              return false;
            }
          }
        } else {

          _this6.$message(res.data.message);
          _this6.loading = false;
        }
      });
    }
  }
});

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
		components: {
				MechanismSelector: __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue___default.a
		},
		name: 'log',
		data: function data() {
				var that = this;
				return {
						mechanismData: {
								callback: function callback(value) {
										that.queryCondition.areaid = value;
										that.statusChange();
								}
						},
						baseUrl: __WEBPACK_IMPORTED_MODULE_1__api_url__["b" /* urlAssets */].prefix,
						focusEvent: __WEBPACK_IMPORTED_MODULE_1__api_url__["c" /* focusEvent */],
						areaList1: [],
						value1: '',
						input1: '',
						queryCondition: {
								'terminal_no': '',
								'terminal_name': '',
								'terminal_log_type': '',
								'areaid': '',
								'start_time': '',
								'end_time': ''
						},
						loading: true,
						currentPage: 1,
						pageSize: 20,
						totalRecords: 0,
						tableData: []
				};
		},

		created: function created() {
				var _this = this;

				if (this.$route.params.no) {
						this.queryCondition.terminal_no = this.$route.params.no;
				} else {
						this.queryCondition.terminal_no = '';
				}

				this.getLog(1, this.queryCondition.terminal_no, '', '', '');
				var timers = setInterval(function () {
						_this.getLog(1, _this.queryCondition.terminal_no, _this.queryCondition.areaid, _this.queryCondition.start_time, _this.queryCondition.end_time);
				}, 300000);
				localStorage.setItem("timers", timers);
		},
		methods: {
				catchLog: function catchLog() {},

				submitRow: function submitRow(id) {
						var _this2 = this;

						var params = { ids: id };
						this.$confirm(this.$t('lin_global.confirmDelete'), this.$t('lin_btn.tips'), {
								confirmButtonText: this.$t('lin_btn.confirm'),
								cancelButtonText: this.$t('lin_btn.cancel'),
								type: 'warning'
						}).then(function () {
								__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/terminalLog/delete.do', params).then(function (res) {
										if (res.data.status == 200) {
												_this2.$message.success(_this2.$t('lin_global.delete_success'));
												_this2.getLog(1, _this2.queryCondition.terminal_no, _this2.queryCondition.areaid, _this2.queryCondition.start_time, _this2.queryCondition.end_time);
										} else {
												_this2.$message.error(res.data.message);
										}
								});
						}).catch(function () {});
				},
				dataChange: function dataChange(value) {
						this.queryCondition.start_time = value;
				},
				dataChange1: function dataChange1(value) {
						this.queryCondition.end_time = value;
				},
				getAd1: function getAd1() {
						var _this3 = this;

						var params = { page: 1, rows: 10000 };
						__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/mechanism/list.do', params).then(function (res) {
								var obj = {
										'mechanismname': _this3.$t('lin_global.all_mechanism'),
										'mechanismid': ''
								};
								_this3.areaList1 = res.data.data;

								_this3.areaList1.unshift(obj);
						});
				},
				reset: function reset() {
						this.queryCondition.terminal_no = '';
						this.queryCondition.areaid = '';
						this.queryCondition.start_time = '';
						this.queryCondition.end_time = '';
						this.getLog(1, '', '', '', '');
				},
				statusChange: function statusChange() {
						this.getLog(1, this.queryCondition.terminal_no, this.queryCondition.areaid, this.queryCondition.start_time, this.queryCondition.end_time);
				},

				handleIconClick: function handleIconClick() {
						this.getLog(1, this.queryCondition.terminal_no, this.queryCondition.areaid, this.queryCondition.start_time, this.queryCondition.end_time);
				},
				formatStatus: function formatStatus(row, column) {
						return row.status == 0 ? this.$t('lin_global.ddsc') : row.status == 1 ? this.$t('lin_global.scz') : row.status == 2 ? this.$t('lin_global.sccg') : row.status == 3 ? this.$t('lin_global.scsb') : '';
				},
				search: function search() {
						this.getLog(1, this.queryCondition.terminal_no, this.queryCondition.areaid, this.queryCondition.start_time, this.queryCondition.end_time);
				},
				getLog: function getLog(page, no, area, start, end) {
						var _this4 = this;

						this.currentPage = page;

						var params = { page: page, rows: this.pageSize, mechId: area, terminalNo: no, beginTime: start, endTime: end };

						__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/terminalLog/getTerLogList.do', params).then(function (res) {
								_this4.tableData = res.data.data;
								_this4.totalRecords = res.data.total;
								_this4.loading = false;
								for (var i = 0; i < res.data.data.length; i++) {
										if (res.data.data[i].status == 0) {
												res.data.data[i]['delete'] = false;
												res.data.data[i]['down'] = false;
										} else if (res.data.data[i].status == 1) {
												res.data.data[i]['delete'] = false;
												res.data.data[i]['down'] = false;
										} else if (res.data.data[i].status == 2) {
												res.data.data[i]['delete'] = true;
												res.data.data[i]['down'] = true;
										} else if (res.data.data[i].status == 3) {
												res.data.data[i]['delete'] = true;
												res.data.data[i]['down'] = false;
										} else {
												return false;
										}
								}
						});
				},
				handleSizeChange: function handleSizeChange(val) {
						this.pageSize = val;
						this.getLog(this.currentPage, this.queryCondition.terminal_no, this.queryCondition.areaid, this.queryCondition.start_time, this.queryCondition.end_time);
				},
				handleCurrentChange: function handleCurrentChange(val) {
						this.currentPage = val;
						this.getLog(this.currentPage, this.queryCondition.terminal_no, this.queryCondition.areaid, this.queryCondition.start_time, this.queryCondition.end_time);
				}

		}
});

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		MechanismSelector: __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue___default.a
	},
	data: function data() {
		var that = this;
		return {
			mechanismData: {
				placeholder: that.$t('lin_global.place_areaid'),
				callback: function callback(value) {
					that.form.mechanismId = value;
					that.changeEvent();
				}
			},
			isSubmit: false,
			form: {
				mechanismId: '',
				terNums: 0,
				version: '',
				memo: ''

			},
			totalRecords: 0,
			currentPage: 1,
			pageSize: 10,
			areaList: [],
			tableData: []
		};
	},
	created: function created() {
		this.getData(1);
	},

	methods: {
		handleSizeChange: function handleSizeChange(val) {
			this.pageSize = val;
			this.getData(this.currentPage);
		},
		handleCurrentChange: function handleCurrentChange(val) {
			this.currentPage = val;
			this.getData(this.currentPage);
		},
		getData: function getData(page) {
			var _this = this;

			var params = { page: page, rows: this.pageSize };
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/terminalBackup/list.do', params).then(function (res) {
				_this.tableData = res.data.data;
				_this.totalRecords = res.data.total;
			});
		},
		submit: function submit() {
			var _this2 = this;

			var params = this.form;
			this.isSubmit = true;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/terminalBackup/backup.do', params).then(function (res) {
				if (res.data.status == 200) {
					_this2.$message.success(res.data.message);
					_this2.getData(1);
					_this2.isSubmit = false;
				} else {
					_this2.isSubmit = false;
					_this2.$message.error(res.data.message);
				}
			});
		},
		changeEvent: function changeEvent() {
			this.getNum();
		},
		getNum: function getNum() {
			var _this3 = this;

			var params = { mechanismId: this.form.mechanismId };
			console.log(params);
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/terminal/terNums.do', params).then(function (res) {

				_this3.form.terNums = res.data.data.nums;
			});
		},

		onCancel: function onCancel() {
			this.$router.go(-1);
		}
	}
});

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_ztMap__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_ztMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__index_ztMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__processInfo_vue__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__processInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__processInfo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_global_tyc_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_global_tyc_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_global_tyc_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_don_svg__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_don_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_don_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_doff_svg__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_doff_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_doff_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_dsleep_svg__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_dsleep_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_dsleep_svg__);


var iconRed = __webpack_require__(56);
var iconGreen = __webpack_require__(29);
var iconGray = __webpack_require__(42);
var iconYellow = __webpack_require__(35);











/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		var that = this;
		return {
			tqobj: '',
			mdlogs: [],
			fclogs: [],
			showdvst: false,
			showlog: false,
			showfc: false,
			subtypes: [],
			sticons: [__WEBPACK_IMPORTED_MODULE_6__assets_images_don_svg___default.a, __WEBPACK_IMPORTED_MODULE_7__assets_images_doff_svg___default.a, __WEBPACK_IMPORTED_MODULE_8__assets_images_dsleep_svg___default.a],
			norword: [this.$t('app_croln'), this.$t('app_croff'), this.$t('app_crslp')],
			lasword: [this.$t('app_lstol'), this.$t('app_lstof'), this.$t('app_lstsl')],
			mapdata1: {
				sn: "",
				page: 1,
				rows: 300,
				status: "",
				runStatus: ""
			},
			showFac: false,
			showAct: false,
			showReset: false,
			mapDialog: false,
			ulDia: false,
			ulsform: {
				psw: '',
				time: ''
			},
			dur: 6000,
			btnShow: true,
			isRf: false,
			start_time: "",
			end_time: "",
			total: 0,
			comm: '',
			rType: {
				"0": this.$t("app_normal"),
				"1": this.$t("app_fault"),
				"2": this.$t("app_abnormal"),
				"3": this.$t("app_blockp")
			},
			rRuntime: {
				"1": this.$t("app_ecr"),
				"2": this.$t("app_mcr"),
				"3": this.$t("app_nacr"),
				"4": this.$t("app_cardr"),
				"5": this.$t("app_tgcr"),
				"6": this.$t("app_receiptp")
			},
			tName: "",
			statusNames: {
				"-1": this.$t("app_downFail"),
				"-2": this.$t("app_md5Fail"),
				"-3": this.$t("app_theNewgVer"),
				"-4": this.$t("app_fileFmIllegal"),
				"-5": this.$t("app_updateFail"),
				"-6": this.$t("app_usrCancelUpdate"),
				"0": this.$t("app_pushFail"),
				"1": this.$t("app_downloading"),
				"2": this.$t("app_downFinish"),
				"3": this.$t("app_success"),
				'4': this.$t('app_waiting'),
				"5": this.$t("app_success"),
				"6": this.$t("app_pause"),
				"7": this.$t("app_ccdown"),
				"-7": this.$t("app_verror"),
				"-8": this.$t("app_insfail"),
				"-9": this.$t("app_checksignfail"),
				"-10": this.$t("app_uninsfail"),
				'12': this.$t('app_appuninstall')
			},
			statusShow: '',
			statusSl: '',
			taskType: "",
			pageTag: "terDetailPage",
			logDialog: false,
			logLoad: false,
			adbLoad: false,
			cqLoad: false,
			gjLoad: false,
			hfszLoad: false,
			zjLoad: false,
			logining: false,
			sendLoad: false,
			tloading: false,
			disabled: true,
			adb: this.$t("terminal.details.open_abd"),
			abdOpe: "0",
			hardwareInfo: {},
			systemInfoLoading: false,
			hardInfoLoading: false,
			peripheralLoading: false,
			adbLoading: false,
			tableData: [],
			tableData1: [],
			animateId: "",
			animateDialog: false,
			sendAnimateDialog: false,
			importTermVisible: false,
			linkto: "/terList/" + this.$route.params.id + "/terAppList",
			linkBind: "",
			execNo: "",
			baseinfo: {},
			getTerXtxxInfo: {},
			getTerWllxInfo: {},
			getTerAdbztInfo: {},
			statusinfo: {},
			hardInfo: {},
			systemInfo: null,
			terminalNo: "",
			terminalID: this.$route.params.id,
			processInfoVisible: false,
			detailInfo: [],
			linkLog: "",
			terNo: "",
			pdataChange: this.$store.getters.edit_change,
			pdata: {
				mechanismName: '',
				isChange: this.$store.getters.edit_change,
				terminalID: this.$route.params.id,
				terminalNO: "",
				terminal_name: "",
				terminal_model: "",
				terminal_type: "",
				areaid: "",
				manufid: "",
				address: ""
			}
		};
	},

	watch: {
		"pdata.isChange": function pdataIsChange() {
			this.fetchData();
		}
	},
	created: function created() {
		this.fetchData();
	},
	mounted: function mounted() {

		var _this = this;
		this.tqobj = {
			keys: ['taskType2', 'taskTypeArr2', 'sftype', 'comm'],
			callback: function callback(data) {
				_this.statusShow = data[0];
				_this.statusSl = data[1];
				_this.subtypes = data[2];
				_this.comm = data[3];
			}
		};
	},

	computed: {
		isCall: function isCall() {
			return this.baseinfo.call_status == 1 ? true : false;
		},
		isLockScreen: function isLockScreen() {
			return this.baseinfo.param === '0' ? false : true;
		},
		ulscreentt: function ulscreentt() {
			return this.baseinfo.param === '0' ? this.$t('app_lokscrn') : this.$t('app_ulkscrn');
		},
		calltt: function calltt() {
			return this.isCall ? this.$t('app_natpossp') : this.$t('app_actpossp');
		},
		sticon0: function sticon0() {
			var infos = this.baseinfo.online_history;
			var key = infos ? infos[0].key : '';
			return key ? this.sticons[parseInt(key) - 1] : '';
		},
		sticon1: function sticon1() {
			var infos = this.baseinfo.online_history;
			var key = infos ? infos[1].key : '';
			return key ? this.sticons[parseInt(key) - 1] : '';
		},
		sticon2: function sticon2() {
			var infos = this.baseinfo.online_history;
			var key = infos ? infos[2].key : '';
			return key ? this.sticons[parseInt(key) - 1] : '';
		},
		stlb0: function stlb0() {
			var infos = this.baseinfo.online_history;
			return infos ? this.lasword[infos[0].key - 1] : '';
		},
		stlb1: function stlb1() {
			var infos = this.baseinfo.online_history;
			return infos ? this.lasword[infos[1].key - 1] : '';
		},
		stlb2: function stlb2() {
			var infos = this.baseinfo.online_history;
			return infos ? this.norword[infos[2].key - 1] : '';
		},
		sttm0: function sttm0() {
			var infos = this.baseinfo.online_history;
			return infos ? infos[0].value : '';
		},
		sttm1: function sttm1() {
			var infos = this.baseinfo.online_history;
			return infos ? infos[1].value : '';
		},
		sttm2: function sttm2() {
			var infos = this.baseinfo.online_history;
			return infos ? infos[2].value : '';
		},
		adbst: function adbst(vl) {
			var vl = this.getTerAdbztInfo.adb_status;
			if (!vl) {
				return '';
			} else {
				switch (vl) {
					case '1':
						return this.$t('app_on1');
						break;
					case '2':
						return this.$t('app_off1');
						break;
					default:
						return vl;
				}
			}
		},
		dvst: function dvst() {
			var vl = this.getTerAdbztInfo.debugModel;
			if (!vl) {
				return '';
			} else {
				switch (vl) {
					case '0':
						return this.$t('app_normalmode');
						break;
					case '1':
						return this.$t('app_debugmode');
						break;
					default:
						return vl;
				}
			}
		},
		signst: function signst() {
			var vl = this.getTerAdbztInfo.signActivated;
			if (!vl) {
				return '';
			} else {
				switch (vl) {
					case '0':
						return this.$t('app_off1');
						break;
					case '1':
						return this.$t('app_on1');
						break;
					default:
						return vl;
				}
			}
		},
		isChina: function isChina() {

			if (localStorage.system_lang === "zh_cn") {
				return true;
			} else {
				return false;
			}
		},
		showRuntime: function showRuntime() {
			var _this2 = this;

			var str = "";
			var arr = [];
			if (!this.baseinfo) {
				return "";
			}
			if (this.baseinfo.terminal_runtime_status === "0") {
				str = this.$t("app_normal");
			} else {
				if (this.baseinfo.terminal_runtime_msg) {
					arr = this.baseinfo.terminal_runtime_msg.split(",");
					if (arr) {
						arr.forEach(function (obj) {
							if (obj) {
								var sub = obj.split("_");
								str += _this2.rRuntime[sub[0]] + _this2.rType[sub[1]] + ",";
							}
						});
					}
				}
			}

			str = str ? str.substring(0, str.length - 1) : "";
			return str;
		}
	},
	components: {
		processInfo: __WEBPACK_IMPORTED_MODULE_4__processInfo_vue___default.a,
		ztMap: __WEBPACK_IMPORTED_MODULE_0__index_ztMap___default.a,
		tyc: __WEBPACK_IMPORTED_MODULE_5__components_global_tyc_vue___default.a
	},
	methods: {
		showFunc: function showFunc(row) {
			var _this3 = this;

			this.sendLoad = true;
			this.$funcOpQuery(this.terNo, row.name, function (res) {
				_this3.sendLoad = false;
				_this3.fclogs = res.data;
				_this3.showfc = true;
			}, function () {
				_this3.sendLoad = false;
			});
		},
		closeulDia: function closeulDia() {
			this.ulDia = false;
			this.ulsform.psw = '';
			this.ulsform.time = '';
		},
		ulscreenOpe: function ulscreenOpe() {
			this.ulDia = true;
		},
		ulscreenRqs: function ulscreenRqs() {
			var _this4 = this;

			var fm = this.ulsform;
			this.disabled = 1;
			var lstatus = this.isLockScreen ? '0' : '1';
			this.$loaunScreen(this.terNo, fm.psw, parseInt(fm.time), lstatus, function (res) {
				_this4.disabled = 0;
				if (res.status === 200) {
					_this4.$message.success(res.message);
					_this4.fetchData();
					_this4.closeulDia();
				} else {
					_this4.$message.error(res.message);
				}
			}, function () {
				_this4.disabled = 0;
			});
		},
		outputexcel: function outputexcel() {
			this.$outputEq2Excel(this.terminalID, '', '', '', '', '', '', '');
		},
		callclick: function callclick() {
			var _this5 = this;

			this.disabled = 1;
			var _this = this;
			var packageName = '';
			var type = this.isCall ? '0' : '1';
			this.$dvcmd('YCJHDH', type, packageName, this.terNo, function (res) {
				_this.disabled = 0;
				if (res.status === 200) {
					_this.$message.success(res.message);
					_this.fetchData();
				} else {
					_this.$message.error(res.message);
				}
			}, function () {
				_this5.disabled = 0;
			});
		},
		lockDevice: function lockDevice(isLock) {
			var _this6 = this;

			if (isLock) {
				this.disabled = 1;
				var _this = this;
				this.$lockDevice(this.terNo, function (res) {
					_this.disabled = 0;
					if (res.status === 200) {
						_this.$message.success(res.message);
						_this.fetchData();
					} else {
						_this.$message.error(res.message);
					}
				}, function () {
					_this6.disabled = 0;
				});
			} else {
				this.disabled = 1;
				var _this = this;
				this.$unlockDevice(this.terNo, function (res) {
					_this.disabled = 0;
					if (res.status === 200) {
						_this.$message.success(res.message);
						_this.fetchData();
					} else {
						_this.$message.error(res.message);
					}
				}, function () {
					_this6.disabled = 0;
				});
			}
		},
		rqsPath: function rqsPath() {
			var _this7 = this;

			var tno = this.terNo;
			this.$terHisPath(tno, function (res) {
				_this7.initPath(res.data);
			}, function (error) {});
		},
		get_lng_lat: function get_lng_lat(bd_lng, bd_lat) {
			var x_pi = Math.PI * 3000.0 / 180.0;
			var x = Number(bd_lng - 0.0065),
			    y = Number(bd_lat - 0.006);
			var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
			var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
			var gd_lng = Number(z * Math.cos(theta));
			var gd_lat = Number(z * Math.sin(theta));
			var result_form = {
				gd_lng: gd_lng,
				gd_lat: gd_lat
			};
			return result_form;
		},
		showPolyLine: function showPolyLine(points, color, map) {
			var pLine = [];
			for (var i = 0; i < points.length; i++) {
				points[i].longitude = this.get_lng_lat(points[i].longitude, points[i].latitude).gd_lng;
				points[i].latitude = this.get_lng_lat(points[i].longitude, points[i].latitude).gd_lat;
			}
			for (var i = 0; i < points.length; i++) {
				var obj = points[i];
				var lon = obj.longitude;
				var lat = obj.latitude;
				pLine.push(new AMap.LngLat(lon, lat));
				var icon = new AMap.Icon({
					size: new AMap.Size(20, 24),
					image: __webpack_require__(56),
					imageSize: new AMap.Size(20, 24)
				});
				var marker = new AMap.Marker({
					icon: icon,
					offset: [-8, -22],
					position: [lon, lat]
				});
				if (i === 0) {
					var icon = new AMap.Icon({
						size: new AMap.Size(20, 24),
						image: __webpack_require__(29),
						imageSize: new AMap.Size(20, 24)

					});
					marker = new AMap.Marker({
						icon: icon,
						offset: [-8, -22],
						position: [lon, lat]
					});
					map.add(marker);
				}

				marker.on('click', function (e) {
					var p = e.target;

					var point = {
						lng: p._position[0],
						lat: p._position[1]
					};
					console.log(e.target._position);
					var sobj = "";
					points.forEach(function (vl) {
						if (vl.latitude == point.lat && vl.longitude == point.lng) {
							sobj = vl;
						}
					});

					var content = sobj.locatime + "<br/><br/>" + sobj.address;
					var infoWindow = new AMap.InfoWindow({
						anchor: 'bottom-right'
					});
					infoWindow.setContent(content);
					infoWindow.open(map, e.target.getPosition());
				});
				map.add(marker);
			}

			var polyline = new AMap.Polyline({
				path: pLine,
				strokeColor: color,
				strokeWeight: 6,
				strokeOpacity: 0.5
			});

			map.add([polyline]);
		},
		initPath: function initPath(paths) {
			if (paths.length === 0) {
				var _map = new AMap.Map('allmap', {
					resizeEnable: true,
					viewMode: '3D',
					pinch: 45
				});
				AMap.plugin(['AMap.ControlBar', 'AMap.ToolBar'], function () {
					_map.addControl(new AMap.ControlBar({
						position: "RT" }));
					_map.addControl(new AMap.ToolBar({
						liteStyle: true,
						position: "RT",
						offset: [30, 110] }));
				});

				_map.setZoomAndCenter(15, [108.960679, 34.314287]);
				var size = new AMap.Size(20, 20);
				return;
			}

			var map = new AMap.Map("allmap", {
				resizeEnable: true,
				viewMode: '3D',
				pinch: 45
			});

			AMap.plugin(['AMap.ControlBar', 'AMap.ToolBar'], function () {
				map.addControl(new AMap.ControlBar({
					position: "RT" }));
				map.addControl(new AMap.ToolBar({
					liteStyle: true,
					position: "RT",
					offset: [30, 110] }));
			});
			map.setZoomAndCenter(15, [paths[0].longitude, paths[0].latitude]);
			this.showPolyLine(paths, "red", map);
		},
		rfInfo: function rfInfo() {
			this.systemInfoLoading = true;
			this.getTerXTXX();
		},
		rfNet: function rfNet() {
			this.peripheralLoading = true;
			this.getTerWLLX();
		},
		rfhw: function rfhw() {
			this.hardInfoLoading = true;
			this.getHardsInfo();
		},
		rfadb: function rfadb() {
			this.adbLoading = true;
			this.getTerADBZT();
		},
		initGMap: function initGMap(mapCenter, pointArr, pointOrg) {
			if (!window.google) {
				return;
			}
			var map = new google.maps.Map(document.getElementById("gmap"), {
				zoom: 15,
				center: mapCenter
			});

			if (pointOrg) {
				var polylineOptions = {
					path: pointOrg,
					geodesic: true,
					strokeColor: "red",
					strokeOpacity: 0.8,
					strokeWeight: 5 };

				var polyline1 = new window.google.maps.Polyline(polylineOptions);
				polyline1.setMap(map);

				if (pointArr) {
					var spicon = __webpack_require__(29);
					var iconRed = __webpack_require__(56);
					pointArr.forEach(function (item, index) {
						var mk = new google.maps.Marker({
							position: item.point,
							map: map,
							icon: index === 0 ? spicon : item.icon
						});
						var ct = item.content;
						var infowindow = new google.maps.InfoWindow({
							content: ct,
							maxWidth: 200
						});
						mk.addListener("click", function () {
							if (window.preInfoView) {
								window.preInfoView.close(map, mk);
							}
							window.preInfoView = infowindow;
							infowindow.open(map, mk);
						});
					}, this);
				}
			}
		},
		showPathMap: function showPathMap() {
			var _this8 = this;

			this.mapDialog = true;
			if (this.isChina) {
				this.rqsPath();
			} else {
				this.$terHisPath(this.terNo, function (res) {
					var ps = [];
					var p = [];
					var center = {
						lat: 23.5,
						lng: 123.3
					};
					if (res.data.length > 0) {
						var center = new window.google.maps.LatLng(res.data[0].latitude, res.data[0].longitude);
					}

					res.data.forEach(function (vl) {
						p.push(new window.google.maps.LatLng(vl.latitude, vl.longitude));
						ps.push({
							point: new window.google.maps.LatLng(vl.latitude, vl.longitude),

							content: vl.locatime + "<br><br>" + vl.address,

							width: 200
						});
					});


					_this8.initGMap(center, ps, p);
				}, function (error) {});
			}
		},
		refreshList: function refreshList() {
			this.getList();
		},
		repush: function repush(row) {
			var _this9 = this;

			var _this = this;
			this.loading = 1;
			this.$pushRepush(row.taskId, function (res) {

				_this.loading = 0;
				if (res.status === 200) {
					_this.$message.success(res.message);
					_this.getList();
				} else {
					_this.$message.error(res.message);
				}
			}, function () {
				_this9.loading = 0;
			});
		},
		t1: function t1() {
			var _this10 = this;

			if (window.t1) {
				clearTimeout(window.t1);
				window.t1 = "";
			}

			var istd = this.$route.path.indexOf('terList/') != -1 && this.$route.path.indexOf('/details') != -1;
			if (!istd) return;


			var arr = [];

			this.tableData1.forEach(function (vl, index) {
				if (vl.status == 1) {
					arr.push({
						value: vl,
						index: index
					});
				}
			});
			if (arr.length === 0) {
				return;
			}

			var ids = "";
			arr.forEach(function (vl, index) {
				ids += vl.value.taskId + ",";
			});
			ids = ids.substring(0, ids.length - 1);
			var _this = this;

			var _this = this;
			this.$missionPersent(ids, function (res) {
				window.t1 = setTimeout(function () {
					_this.t1();
				}, _this10.dur);

				if (res.status === 200) {
					console.log(res);
					var data = res.data;
					arr.forEach(function (vl, index) {
						var obj = data[index];
						if (obj.result) {
							_this10.tableData1[vl.index].progress = obj.result.progress;
							_this10.tableData1[vl.index].status = parseInt(obj.result.status);
							if (obj.result.status == 2) {
								_this10.t2();
							}
						}
					});
				} else {}
			}, function () {});
		},
		t2: function t2() {
			var _this11 = this;

			if (window.t2) {
				clearTimeout(window.t2);
				window.t2 = "";
			}

			var istd = this.$route.path.indexOf('terList/') != -1 && this.$route.path.indexOf('/details') != -1;
			if (!istd) return;

			var arr = [];
			this.tableData1.forEach(function (vl, index) {
				if (vl.status == 2 || vl.status == 4) {
					arr.push({
						value: vl,
						index: index
					});
				}
			});
			if (arr.length === 0) {
				return;
			}

			var _this = this;

			var _this = this;
			var tNo = this.terNo ? this.terNo : "";
			var type = this.taskType ? this.taskType : "";
			var fName = this.tName ? this.tName : "";
			var page = this.$getWPage(_this.pageTag);
			page = page ? page : 1;
			this.$pushTaskList(this.$gRow, page, tNo, type, fName, function (res) {
				window.t2 = setTimeout(function () {
					_this.t2();
				}, _this11.dur);
				if (res.status === 200) {
					var data = res.data;

					arr.forEach(function (vl, index) {
						var obj = data[vl.index];

						_this11.tableData1[vl.index].status = parseInt(obj.status);
					});
				} else {}
			}, function () {});
		},
		delRow: function delRow(row) {
			var _this12 = this;

			this.$showConfirm("", this.$t("app_isDelData"), this.$t("app_sure"), this.$t("app_cancel"), "warnning", function () {
				var id = row.taskId;
				_this12.loading = 1;
				_this12.$pushDelTask(id, function (res) {
					_this12.loading = 0;
					if (res.status === 200) {
						_this12.getList();
					} else {
						_this12.$message.error(res.message);
					}
				}, function () {
					_this12.loading = 0;
				});
			});
		},
		downOperate: function downOperate(vl, row) {
			var _this13 = this;

			this.loading = 1;
			var id = row.taskId;
			this.$pushFileDownCtrl(id, vl + "", this.terNo, function (res) {
				_this13.loading = 0;
				if (res.status === 200) {
					_this13.getList();
					_this13.$message.success(res.message);
				} else {
					_this13.$message.error(res.message);
				}
			}, function () {
				_this13.loading = 0;
			});
		},
		query: function query() {
			this.getList();
		},
		selectChange: function selectChange() {
			this.getList();
		},
		showBtn: function showBtn(tag, st) {
			var vl = st;

			switch (vl) {
				case -1:
				case -2:
				case -3:
				case -4:
				case -5:
				case 4:
				case -6:
				case 3:
				case 0:
				case -7:
				case 7:
				case 2:
					if (tag == 0) {
						return 1;
					} else if (tag == 4) {
						if (vl == 7) {
							return 1;
						} else {
							return 0;
						}
					} else {
						return 0;
					}
					break;
				case 1:
					if (tag == 1 || tag == 3) {
						return 1;
					} else {
						return 0;
					}
					break;
				case 6:
					if (tag == 2) {
						return 1;
					} else {
						return 0;
					}
					break;

			}
		},
		getList: function getList() {
			var _this14 = this;

			var tNo = this.terNo ? this.terNo : "";
			var type = this.taskType ? this.taskType : "";
			var fName = this.tName ? this.tName : "";
			var page = this.$getWPage(this.pageTag);
			page = page ? page : 1;
			this.$pushTaskList(this.$gRow, page, tNo, type, fName, function (res) {
				_this14.loading = 0;
				if (res.status === 200) {

					_this14.tableData1 = res.data;
					_this14.total = res.total;

					_this14.t1();
					_this14.t2();
				} else {
					_this14.$message.error(res.message);
				}
			}, function () {
				_this14.loading = 0;
			});
		},
		pageSelect: function pageSelect(index) {
			this.$setWPage(this.pageTag, index);
			this.getList();
		},
		pageSelectDv: function pageSelectDv(index) {
			this.$setWPage(this.pageTag, index);
			this.getList();
		},
		pageSized: function pageSized(val) {
			this.$gRow = val;
			this.getList();
		},

		getLog: function getLog() {
			var _this15 = this;

			var params = {
				beginTime: this.start_time,
				endTime: this.end_time,
				terminalNo: this.terNo
			};

			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__api_url__["a" /* baseurl */] + "/terminalLog/getLogs.do", params).then(function (res) {
				_this15.logLoad = true;
				if (res.data.status == 200) {
					_this15.$message.success(_this15.$t("lin_global.rz_tips"));
					_this15.logLoad = false;
					_this15.logDialog = false;
				} else {
					_this15.$message.error(res.data.message);
					_this15.logLoad = false;
				}
			});
		},
		dataChange: function dataChange(value) {
			this.start_time = value;
		},
		dataChange1: function dataChange1(value) {
			this.end_time = value;
		},
		statusType: function statusType(row, column) {

			return this.statusShow[row.fileType];
		},
		formatStatus: function formatStatus(row, column) {
			return this.subtypes[row.subFileType];
		},
		send: function send(row) {
			var _this16 = this;

			this.$confirm(this.$t("terminal.details.comfirm_send"), this.$t("lin_btn.tips"), {
				confirmButtonText: this.$t("lin_btn.confirm"),
				cancelButtonText: this.$t("lin_btn.cancel"),
				type: "warning"
			}).then(function () {
				_this16.sendLoad = true;

				_this16.$filePushTest(row.fileId, _this16.terNo, function (res) {
					_this16.sendLoad = false;
					_this16.sendAnimateDialog = false;
					if (res.status == 200) {
						_this16.$message.success(_this16.$t("lin_global.task_tips2"));
					} else {
						_this16.$message.error(res.message);
					}
				}, '');
			}).catch(function () {});
		},
		getAnimate: function getAnimate() {
			var _this17 = this;

			this.tloading = true;

			var mech = '';
			var name = '';
			var type = '3';
			var stype = '';
			var st = '2';

			this.$getfile(1, 999, name, mech, type, stype, st, '', '', function (res) {

				_this17.tloading = false;
				if (res.status === 200) {
					_this17.total = res.total;
					_this17.tableData = res.data;
				} else {
					_this17.$message(res.message);
				}
			}, function () {
				_this17.loading = 0;
				_this17.$message.error(_this17.$t('app_rqsError'));
			});
		},
		sendAnimate: function sendAnimate() {
			this.sendAnimateDialog = true;
			this.getAnimate();
		},
		getHardsInfo: function getHardsInfo() {
			var _this18 = this;

			var params = {
				terminalNo: this.terNo
			};
			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__api_url__["a" /* baseurl */] + "/terminal/sysInfo.do", params).then(function (res) {
				if (res.data.status == 200) {
					_this18.hardwareInfo = res.data.data;
					_this18.hardInfoLoading = false;
				} else {
					_this18.hardInfoLoading = false;
				}
			});
		},
		fetchData: function fetchData() {
			this.fetchInfo();
		},

		onCancel: function onCancel() {
			this.animateDialog = false;
		},
		submit: function submit() {
			var _this19 = this;

			var params = {
				type: this.animateId,
				terminalNo: this.terNo
			};
			if (this.animateId) {
				this.$confirm(this.$t("terminal.details.comfirm_hy"), this.$t("lin_btn.tips"), {
					confirmButtonText: this.$t("lin_btn.confirm"),
					cancelButtonText: this.$t("lin_btn.cancel"),
					type: "warning"
				}).then(function () {
					_this19.logining = true;
					__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__api_url__["a" /* baseurl */] + "/boot_animat/clear.do", params).then(function (res) {
						if (res.data.status == 200) {
							_this19.$message.success(_this19.$t("terminal.details.hy_success"));
							_this19.logining = false;

							_this19.animateDialog = false;
						} else {
							_this19.$message.error(res.data.message);
							_this19.logining = false;
							_this19.animateDialog = false;
						}
					});
				}).catch(function () {});
			} else {
				this.$message.error(this.$t("terminal.details.hy_type"));
			}
		},
		animate: function animate() {
			this.animateDialog = true;
		},
		ToLinkList: function ToLinkList() {
			this.$setWObj('tdToList', this.terNo);
			this.$router.push({
				path: this.linkto
			});
		},
		ToLinkLog: function ToLinkLog() {
			this.logDialog = true;
		},
		ToLink: function ToLink() {

			this.$setWObj("terminalInfo", this.baseinfo);
			this.$router.push({
				path: "/terList/" + this.$route.params.id + "/terAppBind/" + this.terNo
			});
		},
		linkRisk: function linkRisk() {
			this.$router.push({
				path: "/terList/" + this.$route.params.id + "/terRisk"
			});
		},
		getTerXTXX: function getTerXTXX() {
			var _this20 = this;

			var params = {
				terminal_no: this.terNo
			};
			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__api_url__["a" /* baseurl */] + "/terminal/getTerXTXX.do", params).then(function (res) {
				if (res.data.status == 200) {
					_this20.getTerXtxxInfo = res.data.data;
					_this20.systemInfoLoading = false;
				} else {
					_this20.systemInfoLoading = false;
				}
			});
		},
		getTerADBZT: function getTerADBZT() {
			var _this21 = this;

			var url = __WEBPACK_IMPORTED_MODULE_3__api_url__["a" /* baseurl */] + "/terminal/getTerADBZT.do";
			var params = {
				terminal_no: this.terNo,
				terminal_id: this.terminalID
			};

			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url, params).then(function (res) {
				_this21.adbLoading = false;
				if (res.data.status == 200) {

					_this21.getTerAdbztInfo = res.data.data;
				} else {}
			});
		},
		getTerWLLX: function getTerWLLX() {
			var _this22 = this;

			var params = {
				terminal_no: this.terNo
			};
			this.peripheralLoading = true;
			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__api_url__["a" /* baseurl */] + "/terminal/getTerWLLX.do", params).then(function (res) {
				_this22.peripheralLoading = false;
				if (res.data.status == 200) {
					_this22.getTerWllxInfo = res.data.data;

					_this22.baseinfo.online_history = res.data.data.online_history;

					if (_this22.getTerWllxInfo.terminal_status === "1" || _this22.getTerWllxInfo.terminal_status === "3") {
						_this22.btnShow = false;
						_this22.isRf = true;
					} else {
						_this22.btnShow = true;
						_this22.isRf = false;
					}
				} else {}
			});
		},
		fetchInfo: function fetchInfo() {
			var _this23 = this;

			var params = {
				terminal_id: this.terminalID
			};
			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__api_url__["a" /* baseurl */] + "/terminal/detail.do", params).then(function (res) {
				var res1 = res.data.data ? res.data.data : '';
				var fst = res1.factoryStatus ? res1.factoryStatus : '';
				var ast = res1.activStatus ? res1.activStatus : '';
				_this23.showFac = fst == 1 ? true : false;
				_this23.showAct = ast == 2 ? true : false;

				if (res.data.status == 200) {
					_this23.baseinfo = res.data.data;
					_this23.disabled = false;

					if (res.data.data.adb_status == 0) {
						_this23.adb = _this23.$t("terminal.details.open_abd");
						_this23.abdOpe = "0";
					} else {
						_this23.adb = _this23.$t("terminal.details.close_abd");
						_this23.abdOpe = "1";
					}

					_this23.terNo = res.data.data.terminal_no;
					_this23.terminalNo = res.data.data.terminal_no;
					_this23.pdata.terminalNO = res.data.data.terminal_no;
					_this23.pdata.terminal_name = res.data.data.terminal_name;
					_this23.pdata.terminal_model = res.data.data.terminal_model;
					_this23.pdata.terminal_type = res.data.data.terminal_type;
					_this23.pdata.areaid = res.data.data.mechanismId;
					_this23.pdata.manufid = res.data.data.manufId;
					_this23.pdata.address = res.data.data.address;
					_this23.pdata.memo = res.data.data.memo;

					_this23.pdata.mechanismName = res.data.data.mechanismName;
					_this23.linkLog = "/terList/" + _this23.$route.params.id + "/terAppLog/" + res.data.data.terminal_no;
					_this23.linkBind = "/terList/" + _this23.$route.params.id + "/terAppBind/" + res.data.data.terminal_no;


					_this23.getTerADBZT();
					_this23.getTerXTXX();
					_this23.getTerWLLX();

					_this23.$mdOpQuery(_this23.terminalNo, function (res) {
						_this23.mdlogs = res.data;
					}, '');

					_this23.getTerXtxxInfo.launcher = res.data.data.launcher;
					_this23.getTerXtxxInfo.ota = res.data.data.ota;
					_this23.hardwareInfo.system = res.data.data.system;
					_this23.getTerXtxxInfo.firmware = res.data.data.firmware;
					_this23.getTerXtxxInfo.elapsedtime = res.data.data.elapsedtime;

					_this23.getTerWllxInfo.wlan = res.data.data.wlan;

					_this23.hardwareInfo.cpu = res.data.data.cpu;
					_this23.hardwareInfo.cpuUsed = res.data.data.cpuUsed;
					_this23.hardwareInfo.mem = res.data.data.mem;
					_this23.hardwareInfo.memUsed = res.data.data.memUsed;


					if (_this23.terNo) {
						setTimeout(function () {
							_this23.getList();
						}, 500);
					}
				} else {
					_this23.disabled = false;
					_this23.$message.error(res.data.message);
				}
			});
		},
		clickAbd: function clickAbd() {
			var _this24 = this;

			var params = {
				terminal_id: this.terminalID,
				terminal_no: this.terNo,
				adb_status: this.abdOpe
			};
			var text = "";
			if (this.abdOpe == "0") {
				text = this.$t("terminal.details.open_abd");
			} else {
				text = this.$t("terminal.details.close_abd");
			}

			this.$confirm(this.$t("terminal.details.if_ope"), this.$t("lin_btn.tips"), {
				confirmButtonText: this.$t("lin_btn.confirm"),
				cancelButtonText: this.$t("lin_btn.cancel"),
				type: "warning"
			}).then(function () {
				_this24.adbLoad = true;
				__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__api_url__["a" /* baseurl */] + "/terminal/abdConvert.do", params).then(function (res) {
					if (res.data.status == 200) {
						_this24.$message({
							type: "success",
							message: _this24.$t("lin_global.success_tips")
						});
						_this24.adbLoad = false;
						_this24.getTerADBZT();
					} else {
						_this24.$message(res.data.message);
						_this24.adbLoad = false;
					}
				});
			}).catch(function () {
				_this24.$message({
					type: "info",
					message: _this24.$t("lin_global.concel_tips")
				});
			});
		},
		log: function log() {
			var rq = {
				condition: {
					terminal_no: self.baseinfo.terminal_no,
					order_type: order,
					order_content: ""
				}
			};
		},

		orderExec: function orderExec(order) {
			var _this25 = this;

			var text = {
				CQ: this.$t("lin_btn.restart"),
				GJ: this.$t("terminal.details.gj"),
				HFCCSZ: this.$t("terminal.details.regain")
			};
			this.$confirm(this.$t("lin_global.qrjxmm") + text[order], this.$t("lin_btn.tips"), {
				confirmButtonText: this.$t("lin_btn.confirm"),
				cancelButtonText: this.$t("lin_btn.cancel"),
				type: "warning"
			}).then(function () {
				_this25.execNo = order;

				if (order === "CQ") {
					_this25.cqLoad = true;
				} else if (order === "GJ") {
					_this25.gjLoad = true;
				} else {}


				var that = _this25;

				if (order === "HFCCSZ") {
					_this25.hfszLoad = true;
				} else if (order === "ZJ") {
					_this25.zjLoad = true;
				}

				that.req.order.shutdownOrRestartTerminal({
					terminalNo: that.baseinfo.terminal_no,
					orderType: order
				}, that.$t("lin_global.zlxfs_tips"), that.$t("lin_global.zl_error")).then(function () {
					that.cqLoad = false;
					that.gjLoad = false;
				});
			}).catch(function () {});
		},
		opeTer: function opeTer(type) {
			var that = this;
			that.req.order.tranOrderToTerminal({
				terminalNo: that.baseinfo.terminal_no,
				orderType: "HFCCSZ",
				type: type
			}, that.$t("lin_global.zlxfs_tips"), that.$t("lin_global.zl_error")).then(function (res) {
				that.hfszLoad = false;
				that.zjLoad = false;

				that.showReset = false;
			});
		},

		orderExec1: function orderExec1(order) {
			var _this26 = this;

			var text = {
				HFCCSZ: this.$t("terminal.details.regain"),
				ZJ: "自检"
			};
			this.$confirm(this.$t("lin_global.qrjxmm") + text[order], this.$t("lin_btn.tips"), {
				confirmButtonText: this.$t("lin_btn.confirm"),
				cancelButtonText: this.$t("lin_btn.cancel"),
				type: "warning"
			}).then(function () {
				if (order === "HFCCSZ") {
					_this26.hfszLoad = true;
				} else if (order === "ZJ") {
					_this26.zjLoad = true;
				} else {}

				var rq = {
					condition: {
						terminal_no: _this26.baseinfo.terminal_no,
						order_type: order,
						order_content: ""
					}
				};

				var that = _this26;
				that.req.order.tranOrderToTerminal({
					terminalNo: that.baseinfo.terminal_no,
					orderType: order
				}, that.$t("lin_global.zlxfs_tips"), that.$t("lin_global.zl_error")).then(function (res) {
					that.hfszLoad = false;
					that.zjLoad = false;
				});
			}).catch(function () {});
		}
	}
});

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_tagc__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_tagc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_tagc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        MechanismSelector: __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default.a,
        tagc: __WEBPACK_IMPORTED_MODULE_0__components_global_tagc___default.a
    },
    data: function data() {
        var that = this;
        return {
            downTpl: __WEBPACK_IMPORTED_MODULE_2__api_url__["b" /* urlAssets */].prefix + 'tms-server-web/model/terminalNos.xlsx',
            uldata: '',
            formLabelWidth: '28.5%',
            pushImport: false,
            fileList: [],
            mechanismData: {
                value: null,
                placeholder: that.$t('lin_global.place_areaid'),
                callback: function callback(value) {
                    that.mech = value;
                    that.getCmDv();
                }
            },
            sstatusAr: [{
                vl: '',
                lb: this.$t('app_all')
            }, {
                vl: '0',
                lb: this.$t('app_new')
            }, {
                vl: '1',
                lb: this.$t('app_enable')
            }],
            deviceTotal: 0,
            sstatus: {
                '0': this.$t('app_new'),
                '1': this.$t('app_enable')
            },
            deviceList: [],
            select_device: [],
            device_loading: false,
            show_push: false,
            select_form: {
                page: 1,
                rows: 20,
                areaid: "",
                snBegin: "",
                snEnd: "",
                terminal_status: "",
                terminal_no: ""
            },
            arrdata: [],
            loading: false,
            totalRecords: 0,
            select_forms: {
                page: 1,
                rows: 10,
                terminalNo: ''
            }
        };
    },

    methods: {
        beforeRemove: function beforeRemove() {
            this.fileList = [];
            this.uldata = '';
        },
        srcBefore: function srcBefore(file) {
            if (this.uldata.fileNo) {
                return false;
            }

            var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
            var extension = testmsg === "xls";
            var extension2 = testmsg === "xlsx";
            if (!extension && !extension2) {
                this.$message({
                    message: this.$t("IncorrectaFormat"),
                    type: "warning"
                });
            }
            return extension || extension2;
        },
        srcSuccess: function srcSuccess(res, file) {
            window[this.$route.path] = '';

            if (res.status === 200) {
                this.uldata = res.data;

                this.$message.success(res.message);
            } else {
                this.$message.error(res.message);
            }
        },
        ulError: function ulError() {
            window[this.$route.path] = '';
        },
        ulurl: function ulurl() {
            var url = this.$fileExcelUlUrl + '?token=' + localStorage.user + '&language=' + localStorage.system_lang;

            return url;
        },
        submitUpload: function submitUpload() {
            var _this2 = this;

            this.loading = true;
            this.$terActImport(this.uldata.fileNo, function (res) {
                _this2.loading = false;
                if (res.status === 200) {
                    _this2.$message.success(res.message);
                } else {
                    _this2.$message.error(res.message);
                }
            }, function () {
                _this2.loading = false;
            });
            this.fileList = [];
            this.uldata = '';
            this.get_device_lists();
            this.pushImport = false;
        },
        closeImport: function closeImport() {
            this.pushImport = false;
            this.fileList = [];
            this.uldata = '';
        },
        addTer: function addTer() {
            this.pushImport = true;
        },
        deleteApps: function deleteApps(obj) {
            var _this3 = this;

            this.$showConfirm(this.$t("app_tip"), this.$t("ter.msg"), this.$t("app_sure"), this.$t("app_cancel"), "warning", function () {
                _this3.$delTerAct(obj.id, function (res) {
                    if (res.status === 200) {
                        _this3.$message.success(res.message);
                        _this3.get_device_lists();
                    } else {
                        _this3.$message.error(res.message);
                    }
                }, "");
            }, "");
        },
        open_push: function open_push() {
            this.show_push = true;
            this.getCmDv();
        },
        mkDvSt: function mkDvSt(row) {
            return this.sstatus[row.terminalStatus];
        },
        handleSelectionChangeDevice: function handleSelectionChangeDevice(val) {
            this.select_device = val;
        },
        get_device_list: function get_device_list() {
            var _this4 = this;

            this.device_loading = true;
            this.$getNonItDv(this.select_form.page, this.select_form.rows, this.mech, this.select_form.terminal_no, this.select_form.terminal_status, "", '', '', this.select_form.snBegin, this.select_form.snEnd, function (res) {
                _this4.device_loading = 0;
                if (res.status === 200) {
                    _this4.deviceList = res.data;
                    _this4.deviceTotal = res.total;
                } else {
                    _this4.$message.error(res.message);
                }
            }, function () {
                _this4.device_loading = 0;
            });
        },
        handleClose: function handleClose() {
            this.show_push = false;
            this.select_form = {
                page: 1,
                rows: 20,
                areaid: "",
                snBegin: "",
                snEnd: "",
                terminal_status: "",
                terminal_no: ""
            };
            var that = this;
            that.mech = "";
            this.mechanismData = {
                value: null,
                placeholder: that.$t('lin_global.place_areaid'),
                callback: function callback(value) {
                    that.mech = value;
                    that.getCmDv();
                }
            };
        },
        bcPush: function bcPush() {
            var _this5 = this;

            var terminalNo_list = [];

            this.select_device.forEach(function (obj) {
                terminalNo_list.push(obj.terminalNo);
            });

            var tip = this.$t('app_surepsxdv').replace('{num}', this.select_device.length);

            this.$showConfirm(this.$t('app_tip'), tip + ' ?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
                var sub_form = {
                    terminalNo: String(terminalNo_list)
                };
                _this5.device_loading = true;
                _this5.$pushActivate(sub_form, function (res) {
                    _this5.device_loading = false;
                    if (res.status === 200) {
                        _this5.$message.success(res.message);
                        _this5.show_push = false;
                        _this5.get_device_lists();
                    } else {
                        _this5.$message.error(res.message);
                    }
                }, function () {
                    _this5.device_loading = false;
                });
            }, '');
        },
        pushed: function pushed(row) {
            var _this6 = this;

            this.$showConfirm(this.$t('app_tip'), this.$t('app_srpush') + ' ' + row.terminalNo + ' ?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
                console.log(row);
                var sub_form = {
                    terminalNo: row.terminalNo
                };
                _this6.device_loading = true;
                _this6.$pushActivate(sub_form, function (res) {
                    _this6.device_loading = false;
                    if (res.status === 200) {
                        _this6.$message.success(res.message);
                        _this6.show_push = false;
                        _this6.get_device_lists();
                    } else {
                        _this6.$message.error(res.message);
                    }
                }, function () {
                    _this6.device_loading = false;
                });
            }, '');
        },
        pageSizedDevice: function pageSizedDevice(vl) {
            this.select_form.rows = vl;
            this.getCmDv();
        },
        pageSelectDevice: function pageSelectDevice(vl) {
            this.select_form.page = vl;
            this.getCmDv();
        },
        getCmDv: function getCmDv() {
            var _this = this;
            var typeKey = 'terminalTypes';
            this.tqobj = {
                keys: [typeKey],
                callback: function callback(data) {
                    _this.cmtStatusArr = data[0];
                }
            };
            this.get_device_list();
        },
        handleSizeChange: function handleSizeChange(vl) {
            this.select_forms.rows = vl;
            this.get_device_lists();
        },
        handleCurrentChange: function handleCurrentChange(vl) {
            this.select_forms.page = vl;
            this.get_device_lists();
        },
        get_device_lists: function get_device_lists() {
            var _this7 = this;

            this.loading = true;
            this.$terminalActivate(this.select_forms.page, this.select_forms.rows, this.select_forms.terminalNo, '', function (res) {
                _this7.loading = 0;
                if (res.status === 200) {
                    console.log(res.data);
                    _this7.arrdata = res.data;
                    _this7.totalRecords = res.total;
                } else {
                    _this7.$message.error(res.message);
                }
            }, function () {
                _this7.loading = 0;
            });
        }
    },
    mounted: function mounted() {
        this.get_device_lists();
    }
});

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eqdia__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eqdia___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__eqdia__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_url__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
	computed: {},
	components: {
		MechanismSelector: __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue___default.a, eqdia: __WEBPACK_IMPORTED_MODULE_1__eqdia___default.a
	},
	name: 'log',
	data: function data() {
		var that = this;
		return {
			baseUrl: __WEBPACK_IMPORTED_MODULE_3__api_url__["b" /* urlAssets */].prefix,
			focusEvent: __WEBPACK_IMPORTED_MODULE_3__api_url__["c" /* focusEvent */],
			areaList1: [],
			value1: '',
			input1: '',
			mech: '',
			econfig: {},
			mechanismData: {
				callback: function callback(value) {
					that.mech = value;
					that.getLog();
				}
			},
			queryCondition: {
				'terminal_no': '',
				'terminal_name': '',
				'terminal_log_type': '',
				'areaid': '',
				'start_time': '',
				'end_time': ''
			},
			loading: false,
			page: 1,
			total: 0,
			tableData: [],
			pip: 'szzt',
			pcode: 'szzt'
		};
	},

	created: function created() {
		this.getLog();
		this.getChannel();
	},
	destroyed: function destroyed() {
		clearInterval(window.logTm);
	},

	methods: {
		showEQ: function showEQ() {
			var _this = this;
			this.econfig = {
				close: function close() {
					_this.getLog();
				}
			};
		},
		upadteData: function upadteData() {
			var isUpdate = false;
			this.tableData.forEach(function (vl) {
				if (vl.status == 0 || vl.status == 1) {
					isUpdate = true;
					return;
				}
			});
			if (isUpdate) {
				var _this = this;
				window.logTm = setTimeout(function () {
					_this.getLog();
				}, 3000);
			}
		},
		terlogOperate: function terlogOperate(type, row) {
			var _this2 = this;

			var logId = type == '2' ? row.id : '';
			this.loading = true;
			this.$operateTerLog(type, logId, row.terminalNo, function (res) {
				_this2.loading = false;
				if (res.status === 200) {
					_this2.$message.success(res.message);
					_this2.getLog();
				} else {
					_this2.$message.error(res.message);
				}
			}, function (error) {
				_this2.loading = false;
				_this2.$message.error(res.message);
			});
		},
		downUrl: function downUrl(tail) {
			return this.$host + tail;
		},
		getChannel: function getChannel() {},
		getLog: function getLog() {
			var _this3 = this;

			clearTimeout(window.logTm);

			var tNo = this.queryCondition.terminal_no;
			var mech = this.mech;
			var bgTime = this.queryCondition.start_time;
			var endTime = this.queryCondition.end_time;
			this.$getTerLog(this.pcode, this.page, this.$gRow, tNo, mech, bgTime, endTime, function (res) {
				_this3.loading = 0;
				if (res.status === 200) {
					_this3.tableData = res.data;
					_this3.total = res.total;
					_this3.upadteData();
				} else {
					_this3.$message.error(res.message);
				}
			}, function (err) {
				_this3.$message.error(_this3.$t('app_rqsError'));
				_this3.loading = 0;
			});
		},
		catchLog: function catchLog() {},

		submitRow: function submitRow(row) {
			var _this4 = this;

			this.$confirm(this.$t("app_tipAppEdit"), this.$t('lin_btn.tips'), {
				confirmButtonText: this.$t('lin_btn.confirm'),
				cancelButtonText: this.$t('lin_btn.cancel'),
				type: 'warning'
			}).then(function () {
				_this4.loading = true;
				_this4.$delTerLog(row.id, function (res) {
					_this4.loading = false;
					if (res.status === 200) {
						_this4.$message.success(res.message);
						_this4.getLog();
					} else {
						_this4.$message.error(res.message);
					}
				}, function (err) {
					_this4.$message.error(_this4.$t('app_rqsError'));
					_this4.loading = false;
				});
			}).catch(function () {});
		},
		dataChange: function dataChange(value) {
			this.queryCondition.start_time = value ? value : '';
			this.getLog();
		},
		dataChange1: function dataChange1(value) {
			this.queryCondition.end_time = value ? value : '';
			this.getLog();
		},
		reset: function reset() {},
		statusChange: function statusChange() {
			this.getLog();
		},

		handleIconClick: function handleIconClick() {
			this.getLog();
		},
		formatStatus: function formatStatus(row, column) {
			var data = {
				'0': this.$t('app_catching'),
				'1': this.$t('app_ulding'),
				'2': this.$t('app_ulyet'),
				'3': this.$t('lin_global.scsb')
			};
			return data[row.status];
		},
		search: function search() {
			this.getLog(1, this.queryCondition.terminal_no, this.queryCondition.areaid, this.queryCondition.start_time, this.queryCondition.end_time);
		},

		handleSizeChange: function handleSizeChange(val) {
			this.$gRow = val;
		},
		handleCurrentChange: function handleCurrentChange(val) {
			this.page = val;
			this.getLog();
		}

	}
});

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_tyc__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_tyc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_global_tyc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_tagc__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_tagc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_tagc__);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var that = this;
    return {
      tqobj: '',
      cmtStatus: '',
      cmtStatusArr: [],
      isNon: false,
      downTpl: __WEBPACK_IMPORTED_MODULE_1__api_url__["b" /* urlAssets */].prefix + 'tms-server-web/model/terminalNos.xlsx',
      formLabelWidth: '28.5%',
      fileList: [],
      uldata: '',
      snum: 0,
      check1: false,
      check2: false,
      pushImport: false,
      tableData: [],
      total: 0,
      page: 1,
      multipleTable: [],
      loading: false,
      pushdev: false,
      mech: '',
      queryKey: '',
      importTemplate: __WEBPACK_IMPORTED_MODULE_1__api_url__["b" /* urlAssets */].prefix + 'tms-server-web/import/terminalList.do',
      mechanismData: {
        value: null,
        placeholder: that.$t('lin_global.place_areaid'),
        callback: function callback(value) {
          that.mech = value;
          that.getCmDv();
        }
      }
    };
  },

  props: ["config"],
  watch: {
    config: function config(newVl, oldVl) {
      if (!this.pushdev && newVl) {
        this.getCmDv();
        this.pushdev = true;
      }
    }
  },
  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default.a, tyc: __WEBPACK_IMPORTED_MODULE_2__components_global_tyc___default.a, tagc: __WEBPACK_IMPORTED_MODULE_3__components_global_tagc___default.a
  },
  computed: {},
  methods: {
    submitUpload: function submitUpload() {
      var _this2 = this;

      if (this.config.type == 1) {
        this.loading = true;
        this.$sysconfigPush(this.config.configId, '', '2', '', '', this.uldata.fileNo, '', '', function (res) {
          _this2.loading = false;
          if (res.status === 200) {
            _this2.$message.success(res.message);
            _this2.pushdev = false;
          } else {
            _this2.$message.error(res.message);
          }
        }, function () {
          _this2.loading = false;
        });
        this.pushImport = false;
        return;
      }

      this.loading = true;
      this.$appendPush(this.config.taskId, '', '2', '', '', this.uldata.fileNo, '', '', '', function (res) {
        _this2.loading = false;
        if (res.status === 200) {
          _this2.$message.success(res.message);
          _this2.pushdev = false;
        } else {
          _this2.$message.error(res.message);
        }
      }, function () {
        _this2.loading = false;
      });

      this.pushImport = false;
    },
    ulError: function ulError() {
      window[this.$route.path] = '';
    },
    srcSuccess: function srcSuccess(res, file) {
      window[this.$route.path] = '';


      if (res.status === 200) {
        this.fileList = [{ name: file.name }];
        this.uldata = res.data;
      } else {

        this.srcList = [];

        this.$message.error(res.message);
      }
    },
    srcBefore: function srcBefore(file) {
      window[this.$route.path] = 1;
    },
    closeImport: function closeImport() {
      this.fileList = [];
      this.uldata = '';
    },
    handleClose: function handleClose(row) {
      if (this.config.close) {
        this.config.close(row);
      }
      this.cmtStatus = '';
      this.mech = '';
      this.queryKey = '';
      this.pushdev = false;
    },
    handleSelectionChange: function handleSelectionChange(vl) {
      this.snum = vl.length;
      this.multipleTable = vl;
    },
    query: function query() {
      this.getCmDv();
    },
    fileImport: function fileImport() {
      this.pushImport = true;
    },
    pushAll: function pushAll() {
      var _this3 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_ispushalldv') + ' ?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {

        if (_this3.config.type == 1) {
          _this3.loading = true;
          _this3.$sysconfigPush(_this3.config.configId, '', '1', _this3.mech, _this3.queryKey, '', '', '', function (res) {
            _this3.loading = false;
            if (res.status === 200) {
              _this3.$message.success(res.message);
              _this3.pushdev = false;
            } else {
              _this3.$message.error(res.message);
            }
          }, function () {
            _this3.loading = false;
          });
          return;
        }

        var terminalstats = _this3.cmtStatus;

        _this3.loading = true;
        _this3.$appendPush(_this3.config.taskId, '', '1', _this3.mech, _this3.queryKey, '', terminalstats, '', '', function (res) {
          _this3.loading = false;
          if (res.status === 200) {
            _this3.$message.success(res.message);
            _this3.pushdev = false;
          } else {
            _this3.$message.error(res.message);
          }
        }, function () {
          _this3.loading = false;
        });
      }, '');
    },
    bcPush: function bcPush() {
      var _this4 = this;

      var nos = [];
      this.multipleTable.forEach(function (obj) {
        nos.push(obj.terminalNo);
      });

      var tip = this.$t('app_surepsxdv').replace('{num}', this.multipleTable.length);

      this.$showConfirm(this.$t('app_tip'), tip + ' ?', this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this4.pushRqs(nos.toString());
      }, '');
    },
    catched: function catched(row) {
      var _this5 = this;

      var msg = this.config.callback ? this.$t('app_surestcap') : this.$t('app_iscatch');
      this.$showConfirm(this.$t('app_tip'), msg, this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        if (_this5.config.callback) {
          _this5.handleClose(row);
        } else _this5.pushRqs(row.terminalNo);
      }, '');
    },
    pushRqs: function pushRqs(nos) {
      var _this6 = this;

      this.loading = true;
      var logId = '';
      this.$operateTerLog('1', logId, nos, function (res) {
        _this6.loading = false;
        if (res.status === 200) {
          _this6.$message.success(res.message);

          _this6.handleClose();
        } else {
          _this6.$message.error(res.message);
        }
      }, function () {
        _this6.loading = false;
      });
    },
    pageSized: function pageSized(vl) {
      this.$gRow = vl;
      this.getCmDv();
    },
    pageSelect: function pageSelect(vl) {
      this.page = vl;
      this.getCmDv();
    },
    getCmDv: function getCmDv() {

      if (this.config.type != 1 && (this.config.taskType == 6 || this.config.taskType == 14 || this.config.taskType == 15)) {
        this.isNon = true;
        this.getNonDevices();
      } else {
        this.isNon = false;
        this.getDv();
      }

      var _this = this;
      var typeKey = this.isNon ? 'nonTerTypes' : 'terminalTypes';
      this.tqobj = {
        keys: [typeKey],
        callback: function callback(data) {
          _this.cmtStatusArr = data[0];
        }
      };
    },
    getNonDevices: function getNonDevices() {
      var _this7 = this;

      var channel = this.mech;
      var terminalNo = this.queryKey;
      var status = this.cmtStatus;

      this.loading = 1;
      this.$getNonItDv(this.page, this.$gRow, channel, terminalNo, status, '', '', '', '', '', function (res) {
        _this7.loading = 0;
        if (res.data) {
          _this7.tableData = res.data;
          _this7.total = res.total;
        }
      }, function () {
        _this7.loading = 0;
      });
    },
    getDv: function getDv() {
      var _this8 = this;

      this.loading = true;
      var mc = this.mech;
      var tno = this.queryKey;
      var tstatus = this.cmtStatus;
      var trstatus = '';

      this.$getDvDevices(this.page, this.$gRow, mc, tno, tstatus, trstatus, '', '', '', '', function (res) {
        _this8.loading = 0;
        if (res.status === 200) {
          _this8.tableData = res.data;
          _this8.total = res.total;
        } else {
          _this8.$message.error(res.message);
        }
      }, function () {
        _this8.loading = 0;
      });
    },
    test: function test() {
      this.$showConfirm(this.$t('app_tip'), this.$t('app_tipVerify'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {}, '');
    }
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {}
});

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_global_tagc__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_global_tagc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_global_tagc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_global_mechanism_selector_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		MechanismSelector: __WEBPACK_IMPORTED_MODULE_5__components_global_mechanism_selector_vue___default.a,
		tagc: __WEBPACK_IMPORTED_MODULE_1__components_global_tagc___default.a
	},
	data: function data() {
		var that = this;
		return {
			terType: {
				'0': 'gray',
				'1': 'success',
				'2': 'danger',
				'3': 'warning',
				'4': 'danger'
			},
			models: [],
			dvTypes: [],
			firms: [],
			ruleForm: {
				terminal_model: "",
				terminal_type: "",
				areaid: "",
				manufid: ""
			},
			mechanismData_2: {
				callback: function callback(value) {
					that.ruleForm.areaid = value;
					that.is_disabled = false;
					that.getSlData(value);
				}
			},
			rules: {
				'terminal_model': [{
					required: true,
					message: this.$t('terminal.add.place_model')
				}],
				'terminal_type': [{
					required: true,
					message: this.$t('terminal.add.place_type')
				}],
				'manufid': [{
					required: true,
					message: this.$t('terminal.add.place_manufid')
				}],
				'areaid': [{
					required: true,
					message: this.$t('lin_global.place_areaid')
				}]
			},
			mechanismData: {
				callback: function callback(value) {
					that.value1 = value;

					that.getData(1, that.input1, that.value1, that.value2, that.orderValue);
				}
			},
			sorts: [{
				label: this.$t('app_utasc'),
				value: 'asc'
			}, {
				label: this.$t('app_utdesc'),
				value: 'desc'
			}],
			sort: 'desc',
			exFileName: '',

			select_time_2: [],
			dataUpload: null,
			dvName: '',
			orderValue: '',
			terminalName: '',

			is_disabled: true,
			disabled: true,
			focusEvent: __WEBPACK_IMPORTED_MODULE_4__api_url__["c" /* focusEvent */],
			importTemplate: __WEBPACK_IMPORTED_MODULE_4__api_url__["b" /* urlAssets */].prefix + 'tms-server-web/model/terminals.xlsx',
			importTerminal: __WEBPACK_IMPORTED_MODULE_4__api_url__["b" /* urlAssets */].prefix + 'tms-server-web/model/terminalNos.xlsx',
			fileList: [],
			action: '',
			action_2: "",
			areaList1: [],
			excelUploadUrl: '',
			areaList: [],
			importForm: {
				'areaid': '',
				'uploadify': null
			},
			importForm_2: {
				'areaid': '',
				'uploadify': null
			},
			statusinfoLoading: false,
			importTermVisible: false,
			importTermVisible_2: false,
			importIsSubmit: false,
			currentPage: 1,
			expiration: "",
			pageSize: 10,
			totalRecords: 0,
			loading: true,
			reserverSelection: true,
			input1: '',
			value1: '',
			value2: '',
			multipleSelection: [],
			options2: [{
				id: 0,
				value: '',
				label: this.$t('lin_global.all_status')
			}, {
				id: 1,
				value: '0',
				label: this.$t('lin_global.new_add')
			}, {
				id: 2,
				value: '1',
				label: this.$t('lin_global.online')
			}, {
				id: 3,
				value: '2',
				label: this.$t('lin_global.offline')
			}, {
				id: 4,
				value: '3',
				label: this.$t('app_sleep')
			}],
			areaid: '',
			arrdata: []
		};
	},

	computed: {
		isAddTerRight: function isAddTerRight() {
			var menu = JSON.parse(localStorage.localMenuData);
			var ter = '';
			var ster = '';
			var sster = '';
			if (menu.length > 0) {
				menu.forEach(function (obj) {
					if (obj.subId == 'd270be9f-294b-4fd5-ac83-8ad4799a640f') {
						ter = obj;
					}
				});
			}

			if (ter) {
				if (ter.children.length > 0) {
					ster = ter.children;
				} else {
					return false;
				}
			} else {
				return false;
			}

			ster.forEach(function (obj1) {
				if (obj1.path == '/terList') {
					sster = obj1;
				}
			});

			if (sster) {
				if (sster.children.length > 0) {
					var target = false;
					sster.children.forEach(function (fobj) {
						if (fobj.path == '/terList/add') {
							target = true;
						}
					});
					return target;
				} else {
					return false;
				}
			} else {
				return false;
			}
		}
	},
	methods: {
		getSlData: function getSlData(value) {
			var _this = this;

			if (!value) {
				this.models = [];
				this.dvTypes = [];
				this.firms = [];
				this.is_disabled = true;
				return;
			}
			console.log(value);
			this.$mechGetTypes(value, function (res) {
				if (res.status == 200) {
					_this.models = res.data.models;
					_this.dvTypes = res.data.types;
					_this.firms = res.data.manufactures;
				}
			}, '');
		},
		bcOutputEx: function bcOutputEx() {
			if (this.multipleSelection.length == 0) {
				var areaid = this.value1 ? this.value1 : '';
				var orderType = '';
				var time_orderType = '';
				var terminalName = this.dvName ? this.dvName : '';
				var terminal_status = this.value2 ? this.value2 : '';

				var beginTime = "";
				var endTime = "";
				if (this.select_time_2[0] !== null) {
					beginTime = this.dateFormat(this.select_time_2[0]);
					endTime = this.dateFormat(this.select_time_2[1]);
				}

				var terminalId = '';
				this.$outputEq2Excel(terminalId, areaid, orderType, time_orderType, terminalName, terminal_status, beginTime, endTime);
				return;
			}

			var ids = [];
			this.multipleSelection.forEach(function (item) {
				ids.push(item.terminalId);
			});
			this.$outputEq2Excel(ids.toString(), 'abc', '', '', '', '', '', '');
		},
		powerIcon: function powerIcon(vl) {
			return !vl ? "color:#FF4949" : "color: lightGray";
		},
		exCancel: function exCancel() {
			this.importTermVisible = false;
			this.disabled = true;
			if (this.exFileName) {
				this.exFileName = '';
			}
		},

		shuaxin: function shuaxin() {
			console.log("reflush");
			this.getData(1, this.input1, this.value1, this.value2, this.orderValue);
		},
		sortChane: function sortChane(val) {

			switch (val.prop) {
				case 'terminalNo':
					this.sort = '';
					if (val.order === "descending") {
						this.orderValue = "desc";
					} else if (val.order === "ascending") {
						this.orderValue = "asc";
					} else {
						this.orderValue = '';
					}
					break;
				case 'terminalOnlineTime':
					this.orderValue = '';
					if (val.order === "descending") {
						this.sort = 'desc';
					} else if (val.order === "ascending") {
						this.sort = 'asc';
					} else {
						this.sort = 'desc';
					}
					break;
				case 'a':
					break;
			}

			this.getData(this.currentPage, this.input1, this.value1, this.value2, this.orderValue);
		},
		handleAvatarScucess: function handleAvatarScucess(res, file) {

			if (res.status == 200) {
				this.$notify({
					title: this.$t('terminal.list.notify_title'),
					message: res.message,
					type: 'success',
					duration: 6000
				});
				this.getData(1, '', '', '', '');
				this.importTermVisible = false;
				this.exCancel_2();

				this.exFileName = '';
				this.fileList = [];
				this.$refs.upload.clearFiles();
			} else {
				this.$notify.error({
					title: this.$t('terminal.list.notify_title'),
					message: res.message,
					duration: 6000
				});
			}
		},
		beforeUpload: function beforeUpload(file) {
			if (this.importTermVisible) {
				this.disabled = false;
				this.exFileName = file.name;
			} else {
				this.exFileName = '';
			}
		},
		beforeUpload_2: function beforeUpload_2(file) {
			var _this2 = this;

			if (this.importTermVisible_2) {
				this.disabled = false;
				this.exFileName = file.name;
			} else {
				this.exFileName = '';
			}
			var lang = localStorage.getItem("system_lang");
			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				_this2.action_2 = __WEBPACK_IMPORTED_MODULE_4__api_url__["a" /* baseurl */] + '/terminal/moveByImport.do' + "?language=" + lang + '&token=' + localStorage.user + "&terminal_model=" + _this2.ruleForm.terminal_model + "&terminal_type=" + _this2.ruleForm.terminal_type + "&areaid=" + _this2.ruleForm.areaid + "&manufid=" + _this2.ruleForm.manufid;

				_this2.$nextTick(function () {
					return resolve();
				});
			});
		},
		submitUpload: function submitUpload() {
			this.$refs.upload.submit();
		},
		submitUpload_2: function submitUpload_2() {
			var _this3 = this;

			this.$refs['ruleForm'].validate(function (valid) {
				if (valid) {
					_this3.$refs.upload.submit();
				} else {
					return false;
				}
			});
		},

		getAd1: function getAd1() {
			var _this4 = this;

			var that = this;
			var params = {
				token: localStorage.getItem('user'),
				language: localStorage.getItem("system_lang")
			};
			__WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_4__api_url__["a" /* baseurl */] + '/mechanism/parent_list.do', params).then(function (res) {
				that.areaList1 = res.data.data;

				var comp = function comp(grade) {
					return function (a, b) {
						return Number(a[grade]) > Number(b[grade]) ? 1 : -1;
					};
				};

				that.areaList1 = that.areaList1.sort(comp('grade'));
				var mTreeSort = function mTreeSort(ttmp, data, id) {
					var forE = function forE(data, id) {
						for (var i = 0; i < data.length; i++) {
							var item = data[i];
							if (item.pid === id) {
								ttmp.push(item);
								forE(data, item.id);
							} else {
								continue;
							}
						}
					};
					forE(data, id);
					return ttmp;
				};

				var rrd = that.areaList1.filter(function (r) {
					return r['grade'] === "0";
				});

				if (rrd.length > 0) {
					var ttmp = [];
					ttmp.push(rrd[0]);
					mTreeSort(ttmp, that.areaList1, rrd[0]['id']);

					that.areaList1 = ttmp;
					var obj = {
						'name': _this4.$t('lin_global.all_mechanism'),
						'id': ''
					};

					_this4.areaList1.unshift(obj);
				}
			});
		},
		cascaderChange: function cascaderChange(value) {
			this.importForm.areaid = this.areaid;
		},
		excelUpload: function excelUpload() {
			var _this5 = this;

			var self = this;
			var rq = {
				upload: true,
				formElement: 'importForm',
				areaid: this.areaid
			};
			return;
			this.$refs['importForm'].validate(function (valid) {
				if (valid) {
					_this5.importIsSubmit = true;
					_this5.$httpzi.post(_this5.excelUploadUrl, rq, {
						timeout: 1800000,
						headers: {
							'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundarysk65tc7lJeq2YMf7'
						}
					}).then(function (response) {
						var rs = response.data;
						self.importIsSubmit = false;
						if (rs.status === 200) {
							self.importTermVisible = false;
							if (rs.data !== '' || rs.data !== null) {
								self.$alert(rs.data, this.$t('lin_btn.tips'), {
									confirmButtonText: this.$t('lin_btn.confirm')
								});
							}

							self.getData(self.currentPage, '', '', '', '');
						} else {}
					}).catch(function (error) {
						self.importIsSubmit = false;
						self.$message.error(error.toString());
					});
				} else {
					return false;
				}
			});
		},
		getAd: function getAd() {
			var _this6 = this;

			var params = {
				page: 1,
				rows: 10000
			};
			__WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_4__api_url__["a" /* baseurl */] + '/mechanism/list.do', params).then(function (res) {
				_this6.areaList = res.data.data;
			});
		},
		formatStatus: function formatStatus(row, column) {

			switch (row.terminal_status) {
				case '0':
					return this.$t('lin_global.new_add');
					break;
				case '1':
					return this.$t('lin_global.online');
					break;
				case '2':
					return this.$t('lin_global.offline');
					break;
				case '3':
					return this.$t('app_sleep');
					break;
			}
		},
		toggleSelection: function toggleSelection(rows) {
			var _this7 = this;

			if (rows) {
				rows.forEach(function (row) {
					_this7.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},

		handleSizeChange: function handleSizeChange(val) {

			this.pageSize = val;
			this.getData(this.currentPage, this.input1, this.value1, this.value2, this.orderValue);
		},
		handleCurrentChange: function handleCurrentChange(val) {

			this.currentPage = val;
			this.getData(this.currentPage, this.input1, this.value1, this.value2, this.orderValue);
		},
		viewInfo: function viewInfo(row, event, a) {
			if (!a.label || a.label === this.$t('app_operate')) {
				return false;
			} else {
				var obj = {
					terId: row.terminalId,
					terNo: row.terminalNo,
					ter: row
				};
				this.$store.dispatch('setTerParam', obj);
				this.$router.push({
					path: '/terList/' + row.terminalId + '/details'
				});
			}
		},
		deleteRow: function deleteRow(id) {
			var _this8 = this;

			var params = {
				'ids': id
			};
			this.$confirm(this.$t('terminal.list.delete_tips'), this.$t('lin_btn.tips'), {
				confirmButtonText: this.$t('lin_btn.confirm'),
				cancelButtonText: this.$t('lin_btn.cancel'),
				type: 'warning'
			}).then(function () {
				__WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_4__api_url__["a" /* baseurl */] + '/terminal/delete.do', params).then(function (response) {
					var rs = response.data;
					if (rs.status == 200) {
						_this8.$message.success(_this8.$t('lin_global.delete_success'));
						_this8.getData(_this8.currentPage, _this8.input1, _this8.value1, _this8.value2, _this8.orderValue);
					} else {}
				}).catch(function (error) {});
			}).catch(function () {});
		},
		restartRow: function restartRow(no, order) {
			var _this9 = this;

			var text = {
				'CQ': this.$t('lin_btn.restart'),
				'GJ': this.$t('terminal.details.gj')

			};
			this.$confirm(this.$t('lin_global.qrjxmm') + text[order], this.$t('lin_btn.tips'), {
				confirmButtonText: this.$t('lin_btn.confirm'),
				cancelButtonText: this.$t('lin_btn.cancel'),
				type: 'warning'
			}).then(function () {
				var that = _this9;
				that.req.order.shutdownOrRestartTerminal({
					terminalNo: no,
					orderType: order
				}, that.$t('lin_global.zlxfs_tips'), that.$t('lin_global.zl_error'), function (res) {
					if (res.status === 200) {
						_this9.getData(1, _this9.input1, _this9.value1, _this9.value2, _this9.orderValue);
					}
				});
			}).catch(function () {});
		},
		statusChange: function statusChange() {
			this.getData(1, this.input1, this.value1, this.value2, this.orderValue);
		},
		handleIconClick: function handleIconClick() {
			this.getData(1, this.input1, this.value1, this.value2, this.orderValue);
		},
		handleSelectionChange: function handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		addTerm: function addTerm() {
			this.$router.push('/terList/add');
		},
		batchDeleteRow: function batchDeleteRow() {
			var _this10 = this;

			this.$confirm(this.$t('terminal.list.delete_tips'), this.$t('lin_btn.tips'), {
				confirmButtonText: this.$t('lin_btn.confirm'),
				cancelButtonText: this.$t('lin_btn.cancel'),
				type: 'warning'
			}).then(function () {
				var ids = [];
				if (_this10.multipleSelection.length === 0) {
					_this10.$message.error(_this10.$t('terminal.list.empty_tips'));
					return false;
				}
				for (var i = 0; i < _this10.multipleSelection.length; i++) {
					ids.push(_this10.multipleSelection[i].terminalId);
				}
				var rq = {
					ids: ids.join(',')
				};
				__WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_4__api_url__["a" /* baseurl */] + '/terminal/delete.do', rq).then(function (response) {
					var rs = response.data;
					if (rs.status == 200) {
						_this10.$message.success(_this10.$t('lin_global.delete_success'));
						_this10.getData(_this10.currentPage, _this10.input1, _this10.value1, _this10.value2, _this10.orderValue);
					} else {}
				}).catch(function (error) {});
			}).catch(function () {});
		},
		importTerm: function importTerm() {

			this.importTermVisible = true;
			this.disabled = true;
			this.getAd();

			this.resetImportForm();
		},
		open_migration: function open_migration() {
			this.importTermVisible_2 = true;
			this.is_disabled = true;
			this.getAd();

			this.resetImportForm();
		},
		exCancel_2: function exCancel_2() {
			this.importTermVisible_2 = false;
			this.is_disabled = true;
			var that = this;
			this.ruleForm = {
				terminal_model: "",
				terminal_type: "",
				areaid: "",
				manufid: ""
			};
			this.mechanismData_2 = {
				callback: function callback(value) {
					that.ruleForm.areaid = value;
					that.is_disabled = false;
					that.getSlData(value);
				}
			};
			if (this.exFileName) {
				this.exFileName = '';
			}
		},


		resetImportForm: function resetImportForm() {
			this.areaid = '';
			this.fileList = [];
		},
		dateFormat: function dateFormat(dateData) {
			var date = new Date(dateData);
			var y = date.getFullYear();
			var m = date.getMonth() + 1;
			m = m < 10 ? '0' + m : m;
			var d = date.getDate();
			d = d < 10 ? '0' + d : d;

			var hh = date.getHours();
			hh = hh < 10 ? '0' + hh : hh;

			var mm = date.getMinutes();
			mm = mm < 10 ? '0' + mm : mm;

			var ss = date.getSeconds();
			ss = ss < 10 ? '0' + ss : ss;

			var time = y + '-' + m + '-' + d + ' ' + hh + ':' + mm + ':' + ss;
			return time;
		},
		getData: function getData(page, no, areaid, status, order) {
			var _this11 = this;

			this.loading = true;
			this.currentPage = page;
			var beginTime = "";
			var endTime = "";
			if (this.select_time_2[0] !== null && this.select_time_2.length !== 0) {
				beginTime = this.dateFormat(this.select_time_2[0]);
				endTime = this.dateFormat(this.select_time_2[1]);
			}
			var params = {
				page: page,
				rows: this.pageSize,

				areaid: areaid,
				terminal_no: no,
				terminal_status: status,
				terminal_runtime_status: '',
				time_orderType: this.sort,
				orderType: order,
				terminalName: this.dvName,
				beginTime: beginTime ? beginTime : "",
				endTime: endTime ? endTime : ""
			};

			__WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_4__api_url__["a" /* baseurl */] + '/terminal/list.do', params).then(function (res) {
				if (res.data.status == 200) {

					_this11.arrdata = res.data.data;
					_this11.totalRecords = res.data.total;
					_this11.loading = false;
					for (var i = 0; i < res.data.data.length; i++) {
						if (res.data.data[i].terminalStatus == 1) {
							res.data.data[i]['disable'] = false;
						} else {
							res.data.data[i]['disable'] = true;
						}
					}
				} else {
					_this11.loading = false;
				}
			}).catch(function (error) {});
		}
	},

	mounted: function mounted() {

		console.log('lm', JSON.parse(localStorage.localMenuData));
	},

	created: function created() {
		var _this12 = this;

		var c = this.$store.getters.r_param;
		if (c) {
			this.$store.dispatch('setParam', null);
			this.value2 = c + '';
			this.statusChange();
		} else {
			this.getData(1, '', '', '', '');
		}

		this.getAd();
		var timer = setInterval(function () {
			_this12.getData(1, _this12.input1, _this12.value1, _this12.value2, _this12.orderValue);
		}, 300000);
		localStorage.setItem("timer", timer);
		if (localStorage.getItem("system_lang")) {
			var lang = localStorage.getItem("system_lang");
			this.action = __WEBPACK_IMPORTED_MODULE_4__api_url__["a" /* baseurl */] + '/terminal/importTers.do' + "?language=" + lang + '&token=' + localStorage.user;
		}
	}
});

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_ztMap__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_ztMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_ztMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_icon_yellow_png__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_icon_yellow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_icon_yellow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_icon_green_png__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_icon_green_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_icon_green_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_icon_gray_png__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_icon_gray_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_icon_gray_png__);












/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'map',
	data: function data() {
		var that = this;
		return {
			sn: '',
			mechanismData: {
				placeholder: that.$t('lin_global.place_areaid'),
				callback: function callback(value) {
					that.tempMc = value;
					that.mapdata1.areaid = value;
					that.getData(1, value);
				}
			},
			tempMc: '',
			tableHeight: 680,
			currentPage: 1,
			totalRecords: 0,
			pageSize: 300,
			mapdata1: {
				sn: '',
				page: 1,
				rows: 300,
				status: '',
				runStatus: '',
				areaid: ''
			},
			nums: ''
		};
	},

	props: ['hidest'],
	components: {
		ztMap: __WEBPACK_IMPORTED_MODULE_1__index_ztMap___default.a,
		MechanismSelector: __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default.a
	},
	created: function created() {
		var bodyheight = document.documentElement.clientHeight;
		this.tableHeight = bodyheight - 150;
		this.getData(1);
	},

	computed: {
		isChina: function isChina() {

			if (localStorage.system_lang === 'zh_cn') {
				return true;
			} else {
				return false;
			}
		}
	},
	mounted: function mounted() {},
	destroyed: function destroyed() {},

	methods: {
		query: function query() {
			this.mapdata1.sn = this.sn;
			this.getData(1);
		},
		initGMap: function initGMap(mapCenter, pointArr, pointOrg) {
			if (!window.google) {
				return;
			}

			var map = new google.maps.Map(document.getElementById('gmap'), {
				zoom: 3,
				center: mapCenter
			});

			if (pointOrg) {
				var polylineOptions = {
					path: pointOrg,
					geodesic: true,
					strokeColor: "red",
					strokeOpacity: 0.8,
					strokeWeight: 5 };

				var polyline1 = new window.google.maps.Polyline(polylineOptions);
				polyline1.setMap(map);
				if (pointArr) {
					pointArr.forEach(function (item) {
						var mk = new google.maps.Marker({
							position: item.point,
							map: map,
							icon: item.icon
						});
						var ct = item.content;
						var infowindow = new google.maps.InfoWindow({
							content: ct,
							maxWidth: 200
						});
						mk.addListener('click', function () {
							if (window.preInfoView) {
								window.preInfoView.close(map, mk);
							}
							window.preInfoView = infowindow;
							infowindow.open(map, mk);
						});
					}, this);
				}
			} else {
				if (pointArr) {
					pointArr.forEach(function (item) {
						var mk = new google.maps.Marker({
							position: item.point,
							map: map,
							icon: item.icon
						});
						if (item.iconName === 'online') {} else {}

						var ct = item.content;
						var infowindow = new google.maps.InfoWindow({
							content: ct,
							maxWidth: 200
						});
						mk.addListener('click', function () {
							if (window.preInfoView) {
								window.preInfoView.close(map, mk);
							}
							window.preInfoView = infowindow;
							infowindow.open(map, mk);
						});
					}, this);
				}
			}
		},

		getNums: function getNums() {
			var _this2 = this;

			var tno = this.sn ? this.sn : '';
			var mech = this.tempMc ? this.tempMc : '';

			var params = {
				page: 0,
				rows: 0,
				areaid: mech,
				terminal_no: tno
			};
			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__api_url__["a" /* baseurl */] + '/terminal/statusCount.do', params).then(function (res) {
				if (res.data.status == 200) {
					_this2.nums = res.data.data;
				} else {}
			}).catch(function (error) {});
		},
		onClick: function onClick(val) {
			this.mapdata1.areaid = this.tempMc;
			this.mapdata1.runStatus = '';
			this.mapdata1.status = val;
			this.getData(1);
		},
		runClick: function runClick(val) {
			this.mapdata1.runStatus = val;
			this.mapdata1.status = '';
			this.getData(1);
		},
		handleSizeChange: function handleSizeChange(val) {
			this.pageSize = val;
			this.mapdata1.rows = val;
		},
		handleCurrentChange: function handleCurrentChange(val) {

			this.currentPage = val;

			this.mapdata1.sss = 'abc';
			this.mapdata1.page = val;
			if (!this.isChina) {
				this.getData(val);
			}
		},
		getData: function getData(page) {
			var _this3 = this;

			this.getNums();
			var _this = this;
			this.currentPage = page;
			var tno = this.sn ? this.sn : '';
			var mech = this.tempMc ? this.tempMc : '';
			var params = {
				page: page,
				rows: this.pageSize,
				areaid: mech,
				terminal_no: tno,
				terminal_status: this.mapdata1.status,
				terminal_runtime_status: this.mapdata1.runStatus
			};
			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__api_url__["a" /* baseurl */] + '/terminal/list.do', params).then(function (res) {

				var ps = [];
				if (res.data.status == 200) {
					_this3.totalRecords = res.data.total;
					var arr = res.data.data;

					if (arr) {
						if (arr.length > 0) {

							arr.forEach(function (vl) {
								var tst = '';
								var tRst = '';
								var icon = '';
								var iconName = '';
								if (vl.terminalStatus === '1') {
									tst = _this3.$t('app_online');
									icon = __WEBPACK_IMPORTED_MODULE_5__assets_images_icon_green_png___default.a;
									iconName = 'online';
								} else if (vl.terminalStatus === '2') {
									tst = _this3.$t('app_offline');
									icon = __WEBPACK_IMPORTED_MODULE_6__assets_images_icon_gray_png___default.a;
									iconName = 'offline';
								} else if (vl.terminalStatus === '0') {
									tst = _this3.$t('app_new');
									icon = __WEBPACK_IMPORTED_MODULE_6__assets_images_icon_gray_png___default.a;
									iconName = 'offline';
								} else if (vl.terminalStatus === '3') {

									tst = _this3.$t('app_sleep');
									icon = __WEBPACK_IMPORTED_MODULE_4__assets_images_icon_yellow_png___default.a;
									iconName = 'warning';
								}

								var text = '<span style="line-height:20px;font-size:14px;">' + _this.$t('lin_global.label_no') + '：' + vl.terminalNo + '<br>' + _this.$t('lin_global.label_name') + '：' + vl.terminalName + '<br>' + _this.$t('lin_global.label_areaid_name') + '：' + vl.mechName + '<br>' + _this.$t('lin_global.label_address') + '：' + vl.currentAddress + '<br>' + _this.$t('lin_global.wlzt') + '：' + tst + '</br>' + '<br><a href="' + './#/terList/' + vl.terminalId + '/details" style="float:right;">' + _this.$t('lin_global.ckxq') + '</a></span>';

								var cor = vl.coordinate.split(',');
								var lat = '';
								var lng = '';
								if (cor.length > 0) {
									lng = parseFloat(cor[0]);
									lat = parseFloat(cor[1]);
								}
								ps.push({
									point: {
										lat: lat,
										lng: lng
									},
									icon: icon,
									content: text,
									iconName: iconName,
									width: 200
								});
							});
						}
					}
				} else {
					ps = '';
				}


				if (_this3.isChina) {} else {
					var center = {
						lat: 23.5,
						lng: 123.3
					};
					if (ps.length > 0 && _this3.sn) {
						center = ps[0].point;
					}
					window.onload = function () {
						_this3.initGMap(center, ps);
					};
					_this3.initGMap(center, ps);
				}
			}).catch(function (error) {});
		}
	}
});

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		MechanismSelector: __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue___default.a
	},
	data: function data() {
		var that = this;
		return {
			mechanismData: {
				placeholder: that.$t('lin_global.place_areaid'),
				callback: function callback(value) {
					that.form.mechanismId = value;
					that.changeEvent();
				}
			},
			isSubmit: false,
			form: {
				mechanismId: '',
				otaId: '',
				terNums: 0,
				mechanismName: ''
			},
			areaList: [],
			otaList: []
		};
	},
	created: function created() {},

	methods: {
		submit: function submit() {
			var _this = this;

			var params = this.form;

			this.isSubmit = true;
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/ota_lock/lock.do', params).then(function (res) {
				if (res.data.status == 200) {
					_this.$message.success(res.data.message);
					_this.$router.go(-1);
					_this.isSubmit = false;
				} else {
					_this.$message.error(res.data.message);
					_this.isSubmit = false;
				}
			});
		},
		changeEvent: function changeEvent() {
			this.getNum();
			this.getName();
			this.getOta();
		},
		getNum: function getNum() {
			var _this2 = this;

			var params = { mechanismId: this.form.mechanismId };
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/terminal/terNums.do', params).then(function (res) {
				_this2.form.terNums = res.data.data.nums;
			});
		},
		getName: function getName() {
			var _this3 = this;

			var params = { id: this.form.mechanismId };
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/mechanism/detail.do', params).then(function (res) {
				_this3.form.mechanismName = res.data.data.mechanismname;
			});
		},
		getOta: function getOta() {
			var _this4 = this;

			var params = { mechanismId: this.form.mechanismId };
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/ota_lock/ota_list.do', params).then(function (res) {
				_this4.otaList = res.data.data;
			});
		},

		onCancel: function onCancel() {
			this.$router.go(-1);
		}
	}
});

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_url__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_util__);








/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		MechanismSelector: __WEBPACK_IMPORTED_MODULE_3__components_global_mechanism_selector_vue___default.a
	},
	name: 'processInfo',
	data: function data() {
		var _this = this;

		var terNoCheck = function terNoCheck(rule, value, callback) {
			var token = localStorage.getItem('user');
			var params = {
				token: token,
				terminal_no: value
			};
			if (_this.pdata.terminalNO !== value) {
				__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/terminal/existTerNo.do', params).then(function (res) {
					console.log(res.data);
					if (res.data.status == '200') {
						if (res.data.data.existTerminal) {
							callback(new Error(_this.$t('terminal.add.rules_no_4')));
						} else {
							callback();
						}
					} else {}
				});
			} else if (_this.pdata.terminalNO == value) {
				callback();
			} else {
				callback();
			}
		};
		var that = this;
		return {
			mechanismData: '',
			models: [],
			dvTypes: [],
			firms: [],
			isSubmit: false,
			processInfoVisible: true,

			form: {
				'terminal_id': this.pdata.terminalID,
				'terminal_no': null,
				'terminal_name': null,
				'terminal_model': null,
				'terminal_type': null,
				'areaid': null,
				'manufid': null,
				'address': null,

				'memo': ''
			},
			rules: {
				'terminal_no': [{
					type: 'string',
					required: true,
					message: this.$t('terminal.add.rules_no_1')
				}, {
					min: 1,
					max: 50,
					message: this.$t('terminal.add.rules_no_2')
				}, {
					pattern: /^[\w-]+$/,
					message: this.$t('terminal.add.rules_no_3')
				}, {
					validator: terNoCheck,
					trigger: 'blur'
				}],
				'terminal_name': [{
					type: 'string',
					required: true,
					message: this.$t('terminal.add.rules_name_1')
				}],
				'terminal_model': [{
					required: true,
					message: this.$t('terminal.add.place_model')
				}],
				'terminal_type': [{
					required: true,
					message: this.$t('terminal.add.place_type')
				}],
				'manufid': [{
					required: true,
					message: this.$t('terminal.add.place_manufid')
				}],
				'areaid': [{
					required: true,
					message: this.$t('lin_global.place_areaid')
				}],
				'address': [{
					required: true,
					message: this.$t('terminal.add.place_address')
				}]
			},
			vendorList: [],
			modelList: [],
			terminalTypeList: [],
			areaList: []
		};
	},

	props: ['pdata'],
	created: function created() {

		this.fetchData();
	},

	methods: {
		dateFormat: function dateFormat(dateData) {
			var date = new Date(dateData);
			var y = date.getFullYear();
			var m = date.getMonth() + 1;
			m = m < 10 ? '0' + m : m;
			var d = date.getDate();
			d = d < 10 ? '0' + d : d;

			var hh = date.getHours();
			hh = hh < 10 ? '0' + hh : hh;

			var mm = date.getMinutes();
			mm = mm < 10 ? '0' + mm : mm;

			var ss = date.getSeconds();
			ss = ss < 10 ? '0' + ss : ss;

			var time = y + '-' + m + '-' + d + ' ' + hh + ':' + mm + ":" + ss;
			return time;
		},
		getSlData: function getSlData(value) {
			var _this2 = this;

			if (!value) {
				this.models = [];
				this.dvTypes = [];
				this.firms = [];
				return;
			}
			this.$mechGetTypes(value, function (res) {
				if (res.status == 200) {
					_this2.models = res.data.models;
					_this2.dvTypes = res.data.types;
					_this2.firms = res.data.manufactures;
				}
			}, '');
		},

		closeDialog: function closeDialog() {
			this.$parent.processInfoVisible = false;
		},

		addInfo: function addInfo() {
			var _this3 = this;

			var jsondata = {};
			jsondata = this.form;

			this.isSubmit = true;

			var newJson = __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.extend(true, {}, this.form);
			newJson.terminal_model = this.form.terminal_model;
			newJson.terminal_type = this.form.terminal_type;
			newJson.manufid = this.form.manufid;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/terminal/edit.do', newJson).then(function (res) {

				if (res.data.status == '200') {

					_this3.$message.success(_this3.$t('terminal.add.change_success'));
					_this3.processInfoVisible = false;

					if (_this3.$store.getters.edit_change) {
						_this3.$store.dispatch('setEditChange', false);
						_this3.pdata.isChange = _this3.$store.getters.edit_change;
					} else {
						_this3.$store.dispatch('setEditChange', true);
						_this3.pdata.isChange = _this3.$store.getters.edit_change;
					}
				} else {
					_this3.isSubmit = false;

					_this3.$message.error(res.data.message);
				}
			});
		},
		onSubmit: function onSubmit() {
			var _this4 = this;

			this.$refs['addForm'].validate(function (valid) {
				if (valid) {
					_this4.addInfo();
				} else {
					_this4.$message.error(_this4.$t('lin_global.refs'));
					return false;
				}
			});
		},
		onCancel: function onCancel() {
			this.processInfoVisible = false;
		},
		getVendor: function getVendor() {
			var _this5 = this;

			var params = {
				page: 1,
				rows: 10000
			};
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/manufacturers/list.do', params).then(function (res) {
				_this5.vendorList = res.data.data;
			});
		},
		getType: function getType() {
			var _this6 = this;

			var params = {
				page: 1,
				rows: 10000
			};
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/terminalType/list.do', params).then(function (res) {
				_this6.terminalTypeList = res.data.data;
			});
		},
		getAd: function getAd() {
			var _this7 = this;

			var params = {
				page: 1,
				rows: 10000
			};
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/mechanism/list.do', params).then(function (res) {
				_this7.areaList = res.data.data;
			});
		},
		fetchData: function fetchData() {
			var _this8 = this;

			this.processInfoVisible = true;

			this.form.terminal_no = this.pdata.terminalNO;
			this.form.terminal_name = this.pdata.terminal_name;
			this.form.address = this.pdata.address;
			this.form.areaid = this.pdata.areaid;

			this.form.manufid = this.pdata.manufid[1];
			this.form.terminal_type = this.pdata.terminal_type[1];
			this.form.terminal_model = this.pdata.terminal_model[1];

			this.form.memo = this.pdata.memo;

			console.log(this.pdata);

			var that = this;
			this.mechanismData = {
				value: that.pdata.mechanismName,
				callback: function callback(value) {
					that.form.areaid = value;
					that.form.terminal_model = '';
					that.form.terminal_type = '';
					that.form.manufid = '';
					that.getSlData(value);
				}
			};

			this.$mechGetTypes(this.form.areaid, function (res) {
				if (res.status == 200) {
					_this8.models = res.data.models;
					_this8.dvTypes = res.data.types;
					_this8.firms = res.data.manufactures;
				}
			}, '');
		},
		getModel: function getModel() {
			var _this9 = this;

			var params = {
				page: 1,
				rows: 10000
			};
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/terminalModel/list.do', params).then(function (res) {
				_this9.modelList = res.data.data;
			});
		}
	}
});

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eqdia__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eqdia___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__eqdia__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_url__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
	computed: {},
	components: {
		MechanismSelector: __WEBPACK_IMPORTED_MODULE_2__components_global_mechanism_selector_vue___default.a, eqdia: __WEBPACK_IMPORTED_MODULE_1__eqdia___default.a
	},
	name: 'log',
	data: function data() {
		var that = this;
		return {
			vurl: '',
			viewPic: false,
			baseUrl: __WEBPACK_IMPORTED_MODULE_3__api_url__["b" /* urlAssets */].prefix,
			focusEvent: __WEBPACK_IMPORTED_MODULE_3__api_url__["c" /* focusEvent */],
			areaList1: [],
			value1: '',
			input1: '',
			mech: '',
			econfig: {},
			mechanismData: {
				callback: function callback(value) {
					that.mech = value;
					that.getLog();
				}
			},
			queryCondition: {
				'terminal_no': '',
				'terminal_name': '',
				'terminal_log_type': '',
				'areaid': '',
				'start_time': '',
				'end_time': ''
			},
			loading: false,
			page: 1,
			total: 0,
			tableData: [],
			pip: 'szzt',
			pcode: 'szzt'
		};
	},
	created: function created() {
		this.getLog();
	},
	destroyed: function destroyed() {
		clearInterval(window.logTm);
	},

	methods: {
		showEQ: function showEQ() {
			var _this = this;
			this.econfig = {
				callback: true,
				close: function close(row) {
					var no = row.terminalNo;
					if (no) {
						_this.loading = true;
						_this.sCapture(no, function (res) {
							_this.loading = false;
							if (res.status === 200) {
								_this.$message.success(res.message);
								_this.getLog();
							} else {
								_this.$message.error(res.message);
							}
						}, function () {
							_this.loading = false;
						});
					}
				}
			};
		},
		upadteData: function upadteData() {
			var isUpdate = false;
			this.tableData.forEach(function (vl) {
				if (vl.status == '1') {
					isUpdate = true;
					return;
				}
			});
			if (isUpdate) {
				var _this = this;
				window.logTm = setTimeout(function () {
					_this.getLog();
				}, 3000);
			}
		},
		terlogOperate: function terlogOperate(type, row) {
			var _this2 = this;

			var logId = type == '2' ? row.id : '';
			this.loading = true;
			this.$operateTerLog(type, logId, row.terminalNo, function (res) {
				_this2.loading = false;
				if (res.status === 200) {
					_this2.$message.success(res.message);
					_this2.getLog();
				} else {
					_this2.$message.error(res.message);
				}
			}, function (error) {
				_this2.loading = false;
				_this2.$message.error(res.message);
			});
		},
		downUrl: function downUrl(tail) {
			return this.$host + tail;
		},
		getChannel: function getChannel() {},
		getLog: function getLog() {
			var _this3 = this;

			clearTimeout(window.logTm);

			var tNo = this.queryCondition.terminal_no;
			var mech = this.mech;

			this.getSCapture(this.page, this.$gRow, tNo, mech, function (res) {
				_this3.loading = 0;
				if (res.status === 200) {
					_this3.tableData = res.data;
					_this3.total = res.total;
					_this3.upadteData();
				} else {
					_this3.$message.error(res.message);
				}
			}, function (err) {
				_this3.$message.error(_this3.$t('app_rqsError'));
				_this3.loading = 0;
			});
		},
		catchLog: function catchLog() {},
		viewRow: function viewRow(row) {
			this.vurl = this.$host + row.imgUrl;
			window.open(this.vurl, '_blank');
		},
		delRow: function delRow(row) {
			var _this4 = this;

			this.$confirm(this.$t("app_tipAppEdit"), this.$t('lin_btn.tips'), {
				confirmButtonText: this.$t('lin_btn.confirm'),
				cancelButtonText: this.$t('lin_btn.cancel'),
				type: 'warning'
			}).then(function () {
				_this4.loading = true;

				_this4.$delsCapture(row.id, function (res) {
					_this4.loading = false;
					if (res.status === 200) {
						_this4.$message.success(res.message);
						_this4.getLog();
					} else {
						_this4.$message.error(res.message);
					}
				}, function (err) {
					_this4.$message.error(_this4.$t('app_rqsError'));
					_this4.loading = false;
				});
			}).catch(function () {});
		},

		dataChange: function dataChange(value) {
			this.queryCondition.start_time = value ? value : '';
			this.getLog();
		},
		dataChange1: function dataChange1(value) {
			this.queryCondition.end_time = value ? value : '';
			this.getLog();
		},
		reset: function reset() {},
		statusChange: function statusChange() {
			this.getLog();
		},

		handleIconClick: function handleIconClick() {
			this.getLog();
		},
		formatStatus: function formatStatus(row, column) {
			var data = {
				'0': this.$t('app_catching'),
				'1': this.$t('app_ulding'),
				'2': this.$t('app_ulyet'),
				'3': this.$t('lin_global.scsb')
			};
			return data[row.status];
		},
		search: function search() {
			this.getLog(1, this.queryCondition.terminal_no, this.queryCondition.areaid, this.queryCondition.start_time, this.queryCondition.end_time);
		},

		handleSizeChange: function handleSizeChange(val) {
			this.$gRow = val;
		},
		handleCurrentChange: function handleCurrentChange(val) {
			this.page = val;
			this.getLog();
		}

	}
});

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_url__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			orderName: '',
			orderType: '',
			terminalID: this.$route.params.id,
			tableData: [],
			tableData2: []
		};
	},
	created: function created() {

		this.getData();
	},

	methods: {
		cityFormat: function cityFormat(row) {
			if (row.city) {
				var value = row.city.split(',')[0];
				return value;
			}
		},
		formatStatus: function formatStatus(row, column) {
			return row.eventType == 0 ? this.$t('lin_global.ccwl') : row.eventType == 1 ? this.$t('lin_global.sbyj') : '';
		},
		formatStatus1: function formatStatus1(row, column) {
			return row.status == 0 ? this.$t('lin_global.undone') : row.status == 1 ? this.$t('lin_global.done') : '';
		},
		getData: function getData() {
			var _this = this;

			var params = { orderName: this.orderName, orderType: this.orderType, page: 1, rows: 10000, controllerName: '', messageId: '', terminalId: this.terminalID };
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/risk/listController.do', params).then(function (res) {
				_this.tableData = res.data.data;
			});
			var params2 = { page: 1, rows: 10000, distributorId: '', terminalId: this.terminalID };
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__api_url__["a" /* baseurl */] + '/risk/listByTerminalIdwarning.do', params2).then(function (res) {
				_this.tableData2 = res.data.data;
			});
		}
	}
});

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      currentPage: 1,
      pageSize: 10,
      totalRecords: 0,
      arrdata: [],
      detail: ''
    };
  },
  created: function created() {
    this.detail = this.$getWObj().trade;
  },

  methods: {}
});

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_url__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {},
  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_1__components_global_mechanism_selector_vue___default.a
  },
  name: "log",
  data: function data() {
    var that = this;
    return {
      baseUrl: __WEBPACK_IMPORTED_MODULE_2__api_url__["b" /* urlAssets */].prefix,
      focusEvent: __WEBPACK_IMPORTED_MODULE_2__api_url__["c" /* focusEvent */],
      areaList1: [],
      value1: "",
      input1: "",
      mech: "",
      econfig: {},
      mechanismData: {
        callback: function callback(value) {
          that.mech = value;
          that.search();
        }
      },
      tno: '',
      loading: false,
      page: 1,
      total: 0,
      tableData: [],
      pip: "szzt",
      pcode: "szzt"
    };
  },

  created: function created() {
    this.getList();
    this.getChannel();
  },
  destroyed: function destroyed() {
    clearInterval(window.logTm);
  },

  methods: {
    cellClick: function cellClick(row, ev, col) {
      this.$setWObj('trade', row);
      this.$router.push({ path: '/trade/detail' });
    },
    showEQ: function showEQ() {
      var _this = this;
      this.econfig = {
        close: function close() {
          _this.getList();
        }
      };
    },
    terlogOperate: function terlogOperate(type, row) {
      var _this2 = this;

      var logId = type == "2" ? row.id : "";
      this.loading = true;
      this.$operateTerLog(type, logId, row.terminalNo, function (res) {
        _this2.loading = false;
        if (res.status === 200) {
          _this2.$message.success(res.message);
          _this2.getList();
        } else {
          _this2.$message.error(res.message);
        }
      }, function (error) {
        _this2.loading = false;
        _this2.$message.error(res.message);
      });
    },
    downUrl: function downUrl(tail) {
      return this.$host + tail;
    },
    getChannel: function getChannel() {},
    getList: function getList() {
      var _this3 = this;

      var tNo = this.tno ? this.tno : '';
      var mech = this.mech ? this.mech : '';
      this.$tradeList(this.page, this.$gRow, tNo, mech, function (res) {
        _this3.loading = 0;
        if (res.status === 200) {
          _this3.tableData = res.data;
          _this3.total = res.total;
        } else {
          _this3.$message.error(res.message);
        }
      }, function (err) {
        _this3.$message.error(_this3.$t("app_rqsError"));
        _this3.loading = 0;
      });
    },
    catchLog: function catchLog() {},

    submitRow: function submitRow(row) {
      var _this4 = this;

      this.$confirm(this.$t("app_tipAppEdit"), this.$t("lin_btn.tips"), {
        confirmButtonText: this.$t("lin_btn.confirm"),
        cancelButtonText: this.$t("lin_btn.cancel"),
        type: "warning"
      }).then(function () {
        _this4.loading = true;
        _this4.$delTerLog(row.id, function (res) {
          _this4.loading = false;
          if (res.status === 200) {
            _this4.$message.success(res.message);
            _this4.getList();
          } else {
            _this4.$message.error(res.message);
          }
        }, function (err) {
          _this4.$message.error(_this4.$t("app_rqsError"));
          _this4.loading = false;
        });
      }).catch(function () {});
    },
    reset: function reset() {},
    statusChange: function statusChange() {
      this.getList();
    },

    handleIconClick: function handleIconClick() {
      this.getList();
    },
    formatStatus: function formatStatus(row, column) {
      var data = {
        "0": this.$t("app_catching"),
        "1": this.$t("app_ulding"),
        "2": this.$t("app_ulyet"),
        "3": this.$t("lin_global.scsb")
      };
      return data[row.status];
    },
    search: function search() {
      this.page = 1;
      this.getList();
    },

    handleSizeChange: function handleSizeChange(val) {
      this.$gRow = val;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getList();
    }
  }
});

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MechanismSelector: __WEBPACK_IMPORTED_MODULE_0__components_global_mechanism_selector_vue___default.a
  },
  data: function data() {
    var that = this;
    return {
      qmcid: '',
      qtnid: '',
      qtype: '',
      qtrid: '',
      orderName: '',
      orderType: '',
      mechanismData: {
        callback: function callback(value) {
          that.mech = value;
          that.selectChange(value);
        }
      },
      listKey: 'launch-list',

      dvLoading: 0,
      appId: '',
      stModel: [{ label: this.$t('app_online'), vl: '1' }, { label: this.$t('app_offline'), vl: '2' }, { label: this.$t('app_new'), vl: '0' }],
      typest: {
        '116': this.$t('app_getcash'),
        '122': this.$t('app_lctrans'),
        '123': this.$t('app_obtrans'),
        '154': this.$t('app_phontrs')
      },
      types: [{ tt: this.$t('app_getcash'), vl: '116' }, { tt: this.$t('app_lctrans'), vl: '122' }, { tt: this.$t('app_obtrans'), vl: '123' }, { tt: this.$t('app_phontrs'), vl: '154' }],
      channels: [],
      srchValue: '',
      channelId: '',
      cerTipMsg: '',
      status: '',
      dvIndex: 1,
      dialogVisible: 0,
      mechanismId: window.localStorage['mechanismId'],
      selectMid: '',
      tableData: [],
      dvTableData: [],
      appTypes: [],
      appTypeValue: '',
      appStatus: [{ label: this.$t('app_prePushVerify'), value: '0' }, { label: this.$t('app_preVerify'), value: '1' }, { label: this.$t('app_verifyPass'), value: '2' }, { label: this.$t('app_verifyNotPass'), value: '3' }],
      appStatusValue: '',
      total: 0,
      index: 1,
      dvTotal: 0,
      loading: 0,
      appType: '',
      queryKey: ''
    };
  },

  computed: {
    getDvStatus: function getDvStatus(value) {
      switch (value) {
        case '0':
          return this.$t('app_prePushVerify');
        case '1':
          return this.$t('app_preVerify');
        case '2':
          return this.$t('app_verifyPass');
        case '3':
          return this.$t('app_verifyNotPass');
      }
    }
  },
  methods: {
    viewpic: function viewpic(row) {
      window.open(this.$host + row.faceUrl, '_blank');
    },
    sortChange: function sortChange(vl) {
      switch (vl.prop) {
        case 'createTime':
          this.orderName = '2';
          break;
      }
      this.orderType = vl.order == 'descending' ? 'desc' : 'asc';
      this.getList();
    },
    pushCreateCer: function pushCreateCer() {
      this.$router.push({ path: "/certificate/new" });
    },
    pushUploadCer: function pushUploadCer() {
      this.$router.push({ path: "/certificate/upload" });
    },
    bindOperate: function bindOperate(row) {
      var _this = this;

      this.dvLoading = 1;
      if (this.$appUrlTag === 0) {
        this.$bindApp('0', row.terminalNo, this.appId, function (res) {
          if (res.status === 200) {
            _this.$message.success(_this.$t('app_tipViewTask'));
          } else {
            _this.$message.error(res.message);
          }
          _this.dvLoading = 0;
        }, function () {
          _this.dvLoading = 0;
        });
      } else {
        this.$bindApp1(localStorage.mechanismId, row.terminalNo, this.appId, function (res) {
          if (res.status === 200) {
            _this.$message.success(_this.$t('app_tipViewTask'));
          } else {
            _this.$message.error(res.message);
          }
          _this.dvLoading = 0;
        }, function () {
          _this.dvLoading = 0;
        });
      }
    },
    getChannels: function getChannels() {
      var _this2 = this;

      this.$getChannelList(10000, 1, '', '', '', function (res) {
        if (res.status === 200) {
          _this2.channels = res.data;
        } else {
          _this2.$message.error(res.message);
        }
      }, function () {
        _this2.$message.error(_this2.$t('app_rqsError'));
      });
    },
    getStatus: function getStatus(value) {
      if (!value) return '';
      switch (value) {
        case '0':
          return { vl: this.$t('app_prePushVerify'), style: 'color:#8492A6;' };
        case '1':
          return { vl: this.$t('app_preVerify'), style: 'color:#F7BA2A;' };
        case '2':
          return { vl: this.$t('app_verifyPass'), style: 'color:#13CE66;' };
        case '3':
          return { vl: this.$t('app_verifyNotPass'), style: 'color:#FF4949;' };
      }
    },
    srchDevice: function srchDevice() {
      this.getDevices();
    },
    selectDvChange: function selectDvChange(vl) {
      this.getDevices();
    },
    pageDvSized: function pageDvSized(val) {
      this.$gRow = val;
      this.getDevices();
    },
    getDevices: function getDevices() {
      var _this3 = this;

      var vl = this.srchValue ? this.srchValue : '';
      var channel = this.channelId ? this.channelId : '';
      var status = this.status ? this.status : '';
      var appId = this.appId ? this.appId : '';
      this.dvLoading = 1;
      if (this.$appUrlTag === 0) {
        this.$getDevices(this.dvIndex, this.$gRow, channel, vl, status, '', appId, function (res) {
          _this3.dvLoading = 0;
          if (res.data) {
            _this3.dvTableData = res.data;
            _this3.dvTotal = res.total;
          }
        }, function () {
          _this3.dvLoading = 0;
        });
      } else {

        this.$getDevices1(this.dvIndex, this.$gRow, localStorage.mechanismId, vl, status, '', appId, function (res) {
          console.log('dv', res);
          _this3.dvLoading = 0;
          if (res.data) {
            _this3.dvTableData = res.data;
            _this3.dvTotal = res.total;
          }
        }, function () {
          _this3.dvLoading = 0;
        });
      }
    },
    editApp: function editApp(row) {
      this.$setWObj('dvconfigEdit', row.id);
      this.$router.push({ path: '/dvconfig/edit' });
    },
    pushApp: function pushApp(row) {

      this.$setWObj('pushList', { type: '13', data: row });
      this.$router.push({ path: '/stfile/push' });
    },
    query: function query() {
      this.page = 1;
      this.getList();
    },
    selectChange: function selectChange(vl) {
      this.selectMid = vl;
      this.getList();
    },
    reset: function reset() {
      this.queryKey = '';
      this.appType = '';
      this.getList();
    },
    pageSelect: function pageSelect(index) {
      this.index = index;
      this.getList();
    },
    pageDvSelect: function pageDvSelect(index) {
      this.dvIndex = index;
      this.getDevices();
    },
    pageSized: function pageSized(val) {
      this.$gRow = val;
      this.getList();
    },
    deleteApp: function deleteApp(obj) {
      var _this4 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this4.$delTc(obj.id, function (res) {
          if (res.status === 200) {
            _this4.getList();
            _this4.$message.success(res.message);
          } else {
            _this4.$message.error(res.message);
          }
        }, '');
      }, '');
    },
    submitApp: function submitApp(obj) {
      var _this5 = this;

      this.$showConfirm(this.$t('app_tip'), this.$t('app_tipVerify'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', function () {
        _this5.loading = 1;
        _this5.$verifyFst(obj.recordId, '', '1', function (res) {
          _this5.loading = 0;
          if (res.status === 200) {
            _this5.getList();
            _this5.$message.success(res.message);
          } else {
            _this5.$message.error(res.message);
          }
        }, function () {
          _this5.loading = 0;
        });
      }, '');
    },
    cellClick: function cellClick(row, ev, col) {},
    exportF: function exportF() {
      var sn = this.queryKey ? this.queryKey : '';
      var mcID = this.qmcid;
      var termID = this.qtnid;
      var type = this.qtype;
      var trId = this.qtrid;
      this.$exportTrans(mcID, termID, type, trId, sn);
    },
    getList: function getList() {
      var _this6 = this;

      this.loading = 1;

      var name = this.queryKey ? this.queryKey : '';
      var mcID = this.qmcid;
      var termID = this.qtnid;
      var type = this.qtype;
      var trId = this.qtrid;
      this.$translist(this.index, this.$gRow, name, '', mcID, termID, type, trId, function (res) {
        _this6.loading = 0;
        if (res.status === 200) {
          _this6.total = res.total;
          _this6.tableData = res.data;
        } else {
          _this6.$message(res.message);
        }
      }, function () {
        _this6.loading = 0;
        _this6.$message.error(_this6.$t('app_rqsError'));
      });
    },
    dateFormat: function dateFormat(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD HH:mm:ss');
    },
    setInstallType: function setInstallType(type) {
      return this.$installType[type];
    }
  },
  mounted: function mounted() {
    var jid = this.$getWObj().sdjumpId;
    if (jid) {
      this.$setWObj('dvconfigDetail', jid);
      this.$router.push({ path: '/dvconfig/detail' });
      this.$setWObj('sdjumpId', '');
    }

    this.getList();
  },
  destroyed: function destroyed() {}
});

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export chengshi */
var chengshi = [{
    "value": "110000",
    "label": "北京市",
    "children": [{
        "province": "北京市",
        "label": "北京市",
        "value": "110100"
    }] }, {
    "value": "120000",
    "label": "天津市",
    "children": [{
        "province": "天津市",
        "label": "天津市",
        "value": "120100"
    }] }, {
    "value": "130000",
    "label": "河北省",
    "children": [{
        "province": "河北省",
        "label": "石家庄市",
        "value": "130100"
    }, {
        "province": "河北省",
        "label": "唐山市",
        "value": "130200"
    }, {
        "province": "河北省",
        "label": "秦皇岛市",
        "value": "130300"
    }, {
        "province": "河北省",
        "label": "邯郸市",
        "value": "130400"
    }, {
        "province": "河北省",
        "label": "邢台市",
        "value": "130500"
    }, {
        "province": "河北省",
        "label": "保定市",
        "value": "130600"
    }, {
        "province": "河北省",
        "label": "张家口市",
        "value": "130700"
    }, {
        "province": "河北省",
        "label": "承德市",
        "value": "130800"
    }, {
        "province": "河北省",
        "label": "沧州市",
        "value": "130900"
    }, {
        "province": "河北省",
        "label": "廊坊市",
        "value": "131000"
    }, {
        "province": "河北省",
        "label": "衡水市",
        "value": "131100"
    }, {
        "province": "河北省",
        "label": "省直辖县级行政区划",
        "value": "139000"
    }] }, {
    "value": "140000",
    "label": "山西省",
    "children": [{
        "province": "山西省",
        "label": "太原市",
        "value": "140100"
    }, {
        "province": "山西省",
        "label": "大同市",
        "value": "140200"
    }, {
        "province": "山西省",
        "label": "阳泉市",
        "value": "140300"
    }, {
        "province": "山西省",
        "label": "长治市",
        "value": "140400"
    }, {
        "province": "山西省",
        "label": "晋城市",
        "value": "140500"
    }, {
        "province": "山西省",
        "label": "朔州市",
        "value": "140600"
    }, {
        "province": "山西省",
        "label": "晋中市",
        "value": "140700"
    }, {
        "province": "山西省",
        "label": "运城市",
        "value": "140800"
    }, {
        "province": "山西省",
        "label": "忻州市",
        "value": "140900"
    }, {
        "province": "山西省",
        "label": "临汾市",
        "value": "141000"
    }, {
        "province": "山西省",
        "label": "吕梁市",
        "value": "141100"
    }] }, {
    "value": "150000",
    "label": "内蒙古自治区",
    "children": [{
        "province": "内蒙古自治区",
        "label": "呼和浩特市",
        "value": "150100"
    }, {
        "province": "内蒙古自治区",
        "label": "包头市",
        "value": "150200"
    }, {
        "province": "内蒙古自治区",
        "label": "乌海市",
        "value": "150300"
    }, {
        "province": "内蒙古自治区",
        "label": "赤峰市",
        "value": "150400"
    }, {
        "province": "内蒙古自治区",
        "label": "通辽市",
        "value": "150500"
    }, {
        "province": "内蒙古自治区",
        "label": "鄂尔多斯市",
        "value": "150600"
    }, {
        "province": "内蒙古自治区",
        "label": "呼伦贝尔市",
        "value": "150700"
    }, {
        "province": "内蒙古自治区",
        "label": "巴彦淖尔市",
        "value": "150800"
    }, {
        "province": "内蒙古自治区",
        "label": "乌兰察布市",
        "value": "150900"
    }, {
        "province": "内蒙古自治区",
        "label": "兴安盟",
        "value": "152200"
    }, {
        "province": "内蒙古自治区",
        "label": "锡林郭勒盟",
        "value": "152500"
    }, {
        "province": "内蒙古自治区",
        "label": "阿拉善盟",
        "value": "152900"
    }] }, {
    "value": "210000",
    "label": "辽宁省",
    "children": [{
        "province": "辽宁省",
        "label": "沈阳市",
        "value": "210100"
    }, {
        "province": "辽宁省",
        "label": "大连市",
        "value": "210200"
    }, {
        "province": "辽宁省",
        "label": "鞍山市",
        "value": "210300"
    }, {
        "province": "辽宁省",
        "label": "抚顺市",
        "value": "210400"
    }, {
        "province": "辽宁省",
        "label": "本溪市",
        "value": "210500"
    }, {
        "province": "辽宁省",
        "label": "丹东市",
        "value": "210600"
    }, {
        "province": "辽宁省",
        "label": "锦州市",
        "value": "210700"
    }, {
        "province": "辽宁省",
        "label": "营口市",
        "value": "210800"
    }, {
        "province": "辽宁省",
        "label": "阜新市",
        "value": "210900"
    }, {
        "province": "辽宁省",
        "label": "辽阳市",
        "value": "211000"
    }, {
        "province": "辽宁省",
        "label": "盘锦市",
        "value": "211100"
    }, {
        "province": "辽宁省",
        "label": "铁岭市",
        "value": "211200"
    }, {
        "province": "辽宁省",
        "label": "朝阳市",
        "value": "211300"
    }, {
        "province": "辽宁省",
        "label": "葫芦岛市",
        "value": "211400"
    }] }, {
    "value": "220000",
    "label": "吉林省",
    "children": [{
        "province": "吉林省",
        "label": "长春市",
        "value": "220100"
    }, {
        "province": "吉林省",
        "label": "吉林市",
        "value": "220200"
    }, {
        "province": "吉林省",
        "label": "四平市",
        "value": "220300"
    }, {
        "province": "吉林省",
        "label": "辽源市",
        "value": "220400"
    }, {
        "province": "吉林省",
        "label": "通化市",
        "value": "220500"
    }, {
        "province": "吉林省",
        "label": "白山市",
        "value": "220600"
    }, {
        "province": "吉林省",
        "label": "松原市",
        "value": "220700"
    }, {
        "province": "吉林省",
        "label": "白城市",
        "value": "220800"
    }, {
        "province": "吉林省",
        "label": "延边朝鲜族自治州",
        "value": "222400"
    }] }, {
    "value": "230000",
    "label": "黑龙江省",
    "children": [{
        "province": "黑龙江省",
        "label": "哈尔滨市",
        "value": "230100"
    }, {
        "province": "黑龙江省",
        "label": "齐齐哈尔市",
        "value": "230200"
    }, {
        "province": "黑龙江省",
        "label": "鸡西市",
        "value": "230300"
    }, {
        "province": "黑龙江省",
        "label": "鹤岗市",
        "value": "230400"
    }, {
        "province": "黑龙江省",
        "label": "双鸭山市",
        "value": "230500"
    }, {
        "province": "黑龙江省",
        "label": "大庆市",
        "value": "230600"
    }, {
        "province": "黑龙江省",
        "label": "伊春市",
        "value": "230700"
    }, {
        "province": "黑龙江省",
        "label": "佳木斯市",
        "value": "230800"
    }, {
        "province": "黑龙江省",
        "label": "七台河市",
        "value": "230900"
    }, {
        "province": "黑龙江省",
        "label": "牡丹江市",
        "value": "231000"
    }, {
        "province": "黑龙江省",
        "label": "黑河市",
        "value": "231100"
    }, {
        "province": "黑龙江省",
        "label": "绥化市",
        "value": "231200"
    }, {
        "province": "黑龙江省",
        "label": "大兴安岭地区",
        "value": "232700"
    }] }, {
    "value": "310000",
    "label": "上海市",
    "children": [{
        "province": "上海市",
        "label": "上海市",
        "value": "310100"
    }] }, {
    "value": "320000",
    "label": "江苏省",
    "children": [{
        "province": "江苏省",
        "label": "南京市",
        "value": "320100"
    }, {
        "province": "江苏省",
        "label": "无锡市",
        "value": "320200"
    }, {
        "province": "江苏省",
        "label": "徐州市",
        "value": "320300"
    }, {
        "province": "江苏省",
        "label": "常州市",
        "value": "320400"
    }, {
        "province": "江苏省",
        "label": "苏州市",
        "value": "320500"
    }, {
        "province": "江苏省",
        "label": "南通市",
        "value": "320600"
    }, {
        "province": "江苏省",
        "label": "连云港市",
        "value": "320700"
    }, {
        "province": "江苏省",
        "label": "淮安市",
        "value": "320800"
    }, {
        "province": "江苏省",
        "label": "盐城市",
        "value": "320900"
    }, {
        "province": "江苏省",
        "label": "扬州市",
        "value": "321000"
    }, {
        "province": "江苏省",
        "label": "镇江市",
        "value": "321100"
    }, {
        "province": "江苏省",
        "label": "泰州市",
        "value": "321200"
    }, {
        "province": "江苏省",
        "label": "宿迁市",
        "value": "321300"
    }] }, {
    "value": "330000",
    "label": "浙江省",
    "children": [{
        "province": "浙江省",
        "label": "杭州市",
        "value": "330100"
    }, {
        "province": "浙江省",
        "label": "宁波市",
        "value": "330200"
    }, {
        "province": "浙江省",
        "label": "温州市",
        "value": "330300"
    }, {
        "province": "浙江省",
        "label": "嘉兴市",
        "value": "330400"
    }, {
        "province": "浙江省",
        "label": "湖州市",
        "value": "330500"
    }, {
        "province": "浙江省",
        "label": "绍兴市",
        "value": "330600"
    }, {
        "province": "浙江省",
        "label": "金华市",
        "value": "330700"
    }, {
        "province": "浙江省",
        "label": "衢州市",
        "value": "330800"
    }, {
        "province": "浙江省",
        "label": "舟山市",
        "value": "330900"
    }, {
        "province": "浙江省",
        "label": "台州市",
        "value": "331000"
    }, {
        "province": "浙江省",
        "label": "丽水市",
        "value": "331100"
    }] }, {
    "value": "340000",
    "label": "安徽省",
    "children": [{
        "province": "安徽省",
        "label": "合肥市",
        "value": "340100"
    }, {
        "province": "安徽省",
        "label": "芜湖市",
        "value": "340200"
    }, {
        "province": "安徽省",
        "label": "蚌埠市",
        "value": "340300"
    }, {
        "province": "安徽省",
        "label": "淮南市",
        "value": "340400"
    }, {
        "province": "安徽省",
        "label": "马鞍山市",
        "value": "340500"
    }, {
        "province": "安徽省",
        "label": "淮北市",
        "value": "340600"
    }, {
        "province": "安徽省",
        "label": "铜陵市",
        "value": "340700"
    }, {
        "province": "安徽省",
        "label": "安庆市",
        "value": "340800"
    }, {
        "province": "安徽省",
        "label": "黄山市",
        "value": "341000"
    }, {
        "province": "安徽省",
        "label": "滁州市",
        "value": "341100"
    }, {
        "province": "安徽省",
        "label": "阜阳市",
        "value": "341200"
    }, {
        "province": "安徽省",
        "label": "宿州市",
        "value": "341300"
    }, {
        "province": "安徽省",
        "label": "六安市",
        "value": "341500"
    }, {
        "province": "安徽省",
        "label": "亳州市",
        "value": "341600"
    }, {
        "province": "安徽省",
        "label": "池州市",
        "value": "341700"
    }, {
        "province": "安徽省",
        "label": "宣城市",
        "value": "341800"
    }] }, {
    "value": "350000",
    "label": "福建省",
    "children": [{
        "province": "福建省",
        "label": "福州市",
        "value": "350100"
    }, {
        "province": "福建省",
        "label": "厦门市",
        "value": "350200"
    }, {
        "province": "福建省",
        "label": "莆田市",
        "value": "350300"
    }, {
        "province": "福建省",
        "label": "三明市",
        "value": "350400"
    }, {
        "province": "福建省",
        "label": "泉州市",
        "value": "350500"
    }, {
        "province": "福建省",
        "label": "漳州市",
        "value": "350600"
    }, {
        "province": "福建省",
        "label": "南平市",
        "value": "350700"
    }, {
        "province": "福建省",
        "label": "龙岩市",
        "value": "350800"
    }, {
        "province": "福建省",
        "label": "宁德市",
        "value": "350900"
    }] }, {
    "value": "360000",
    "label": "江西省",
    "children": [{
        "province": "江西省",
        "label": "南昌市",
        "value": "360100"
    }, {
        "province": "江西省",
        "label": "景德镇市",
        "value": "360200"
    }, {
        "province": "江西省",
        "label": "萍乡市",
        "value": "360300"
    }, {
        "province": "江西省",
        "label": "九江市",
        "value": "360400"
    }, {
        "province": "江西省",
        "label": "新余市",
        "value": "360500"
    }, {
        "province": "江西省",
        "label": "鹰潭市",
        "value": "360600"
    }, {
        "province": "江西省",
        "label": "赣州市",
        "value": "360700"
    }, {
        "province": "江西省",
        "label": "吉安市",
        "value": "360800"
    }, {
        "province": "江西省",
        "label": "宜春市",
        "value": "360900"
    }, {
        "province": "江西省",
        "label": "抚州市",
        "value": "361000"
    }, {
        "province": "江西省",
        "label": "上饶市",
        "value": "361100"
    }] }, {
    "value": "370000",
    "label": "山东省",
    "children": [{
        "province": "山东省",
        "label": "济南市",
        "value": "370100"
    }, {
        "province": "山东省",
        "label": "青岛市",
        "value": "370200"
    }, {
        "province": "山东省",
        "label": "淄博市",
        "value": "370300"
    }, {
        "province": "山东省",
        "label": "枣庄市",
        "value": "370400"
    }, {
        "province": "山东省",
        "label": "东营市",
        "value": "370500"
    }, {
        "province": "山东省",
        "label": "烟台市",
        "value": "370600"
    }, {
        "province": "山东省",
        "label": "潍坊市",
        "value": "370700"
    }, {
        "province": "山东省",
        "label": "济宁市",
        "value": "370800"
    }, {
        "province": "山东省",
        "label": "泰安市",
        "value": "370900"
    }, {
        "province": "山东省",
        "label": "威海市",
        "value": "371000"
    }, {
        "province": "山东省",
        "label": "日照市",
        "value": "371100"
    }, {
        "province": "山东省",
        "label": "莱芜市",
        "value": "371200"
    }, {
        "province": "山东省",
        "label": "临沂市",
        "value": "371300"
    }, {
        "province": "山东省",
        "label": "德州市",
        "value": "371400"
    }, {
        "province": "山东省",
        "label": "聊城市",
        "value": "371500"
    }, {
        "province": "山东省",
        "label": "滨州市",
        "value": "371600"
    }, {
        "province": "山东省",
        "label": "菏泽市",
        "value": "371700"
    }] }, {
    "value": "410000",
    "label": "河南省",
    "children": [{
        "province": "河南省",
        "label": "郑州市",
        "value": "410100"
    }, {
        "province": "河南省",
        "label": "开封市",
        "value": "410200"
    }, {
        "province": "河南省",
        "label": "洛阳市",
        "value": "410300"
    }, {
        "province": "河南省",
        "label": "平顶山市",
        "value": "410400"
    }, {
        "province": "河南省",
        "label": "安阳市",
        "value": "410500"
    }, {
        "province": "河南省",
        "label": "鹤壁市",
        "value": "410600"
    }, {
        "province": "河南省",
        "label": "新乡市",
        "value": "410700"
    }, {
        "province": "河南省",
        "label": "焦作市",
        "value": "410800"
    }, {
        "province": "河南省",
        "label": "濮阳市",
        "value": "410900"
    }, {
        "province": "河南省",
        "label": "许昌市",
        "value": "411000"
    }, {
        "province": "河南省",
        "label": "漯河市",
        "value": "411100"
    }, {
        "province": "河南省",
        "label": "三门峡市",
        "value": "411200"
    }, {
        "province": "河南省",
        "label": "南阳市",
        "value": "411300"
    }, {
        "province": "河南省",
        "label": "商丘市",
        "value": "411400"
    }, {
        "province": "河南省",
        "label": "信阳市",
        "value": "411500"
    }, {
        "province": "河南省",
        "label": "周口市",
        "value": "411600"
    }, {
        "province": "河南省",
        "label": "驻马店市",
        "value": "411700"
    }, {
        "province": "河南省",
        "label": "省直辖县级行政区划",
        "value": "419000"
    }] }, {
    "value": "420000",
    "label": "湖北省",
    "children": [{
        "province": "湖北省",
        "label": "武汉市",
        "value": "420100"
    }, {
        "province": "湖北省",
        "label": "黄石市",
        "value": "420200"
    }, {
        "province": "湖北省",
        "label": "十堰市",
        "value": "420300"
    }, {
        "province": "湖北省",
        "label": "宜昌市",
        "value": "420500"
    }, {
        "province": "湖北省",
        "label": "襄阳市",
        "value": "420600"
    }, {
        "province": "湖北省",
        "label": "鄂州市",
        "value": "420700"
    }, {
        "province": "湖北省",
        "label": "荆门市",
        "value": "420800"
    }, {
        "province": "湖北省",
        "label": "孝感市",
        "value": "420900"
    }, {
        "province": "湖北省",
        "label": "荆州市",
        "value": "421000"
    }, {
        "province": "湖北省",
        "label": "黄冈市",
        "value": "421100"
    }, {
        "province": "湖北省",
        "label": "咸宁市",
        "value": "421200"
    }, {
        "province": "湖北省",
        "label": "随州市",
        "value": "421300"
    }, {
        "province": "湖北省",
        "label": "恩施土家族苗族自治州",
        "value": "422800"
    }, {
        "province": "湖北省",
        "label": "省直辖县级行政区划",
        "value": "429000"
    }] }, {
    "value": "430000",
    "label": "湖南省",
    "children": [{
        "province": "湖南省",
        "label": "长沙市",
        "value": "430100"
    }, {
        "province": "湖南省",
        "label": "株洲市",
        "value": "430200"
    }, {
        "province": "湖南省",
        "label": "湘潭市",
        "value": "430300"
    }, {
        "province": "湖南省",
        "label": "衡阳市",
        "value": "430400"
    }, {
        "province": "湖南省",
        "label": "邵阳市",
        "value": "430500"
    }, {
        "province": "湖南省",
        "label": "岳阳市",
        "value": "430600"
    }, {
        "province": "湖南省",
        "label": "常德市",
        "value": "430700"
    }, {
        "province": "湖南省",
        "label": "张家界市",
        "value": "430800"
    }, {
        "province": "湖南省",
        "label": "益阳市",
        "value": "430900"
    }, {
        "province": "湖南省",
        "label": "郴州市",
        "value": "431000"
    }, {
        "province": "湖南省",
        "label": "永州市",
        "value": "431100"
    }, {
        "province": "湖南省",
        "label": "怀化市",
        "value": "431200"
    }, {
        "province": "湖南省",
        "label": "娄底市",
        "value": "431300"
    }, {
        "province": "湖南省",
        "label": "湘西土家族苗族自治州",
        "value": "433100"
    }] }, {
    "value": "440000",
    "label": "广东省",
    "children": [{
        "province": "广东省",
        "label": "广州市",
        "value": "440100"
    }, {
        "province": "广东省",
        "label": "韶关市",
        "value": "440200"
    }, {
        "province": "广东省",
        "label": "深圳市",
        "value": "440300"
    }, {
        "province": "广东省",
        "label": "珠海市",
        "value": "440400"
    }, {
        "province": "广东省",
        "label": "汕头市",
        "value": "440500"
    }, {
        "province": "广东省",
        "label": "佛山市",
        "value": "440600"
    }, {
        "province": "广东省",
        "label": "江门市",
        "value": "440700"
    }, {
        "province": "广东省",
        "label": "湛江市",
        "value": "440800"
    }, {
        "province": "广东省",
        "label": "茂名市",
        "value": "440900"
    }, {
        "province": "广东省",
        "label": "肇庆市",
        "value": "441200"
    }, {
        "province": "广东省",
        "label": "惠州市",
        "value": "441300"
    }, {
        "province": "广东省",
        "label": "梅州市",
        "value": "441400"
    }, {
        "province": "广东省",
        "label": "汕尾市",
        "value": "441500"
    }, {
        "province": "广东省",
        "label": "河源市",
        "value": "441600"
    }, {
        "province": "广东省",
        "label": "阳江市",
        "value": "441700"
    }, {
        "province": "广东省",
        "label": "清远市",
        "value": "441800"
    }, {
        "province": "广东省",
        "label": "东莞市",
        "value": "441900"
    }, {
        "province": "广东省",
        "label": "中山市",
        "value": "442000"
    }, {
        "province": "广东省",
        "label": "潮州市",
        "value": "445100"
    }, {
        "province": "广东省",
        "label": "揭阳市",
        "value": "445200"
    }, {
        "province": "广东省",
        "label": "云浮市",
        "value": "445300"
    }] }, {
    "value": "450000",
    "label": "广西壮族自治区",
    "children": [{
        "province": "广西壮族自治区",
        "label": "南宁市",
        "value": "450100"
    }, {
        "province": "广西壮族自治区",
        "label": "柳州市",
        "value": "450200"
    }, {
        "province": "广西壮族自治区",
        "label": "桂林市",
        "value": "450300"
    }, {
        "province": "广西壮族自治区",
        "label": "梧州市",
        "value": "450400"
    }, {
        "province": "广西壮族自治区",
        "label": "北海市",
        "value": "450500"
    }, {
        "province": "广西壮族自治区",
        "label": "防城港市",
        "value": "450600"
    }, {
        "province": "广西壮族自治区",
        "label": "钦州市",
        "value": "450700"
    }, {
        "province": "广西壮族自治区",
        "label": "贵港市",
        "value": "450800"
    }, {
        "province": "广西壮族自治区",
        "label": "玉林市",
        "value": "450900"
    }, {
        "province": "广西壮族自治区",
        "label": "百色市",
        "value": "451000"
    }, {
        "province": "广西壮族自治区",
        "label": "贺州市",
        "value": "451100"
    }, {
        "province": "广西壮族自治区",
        "label": "河池市",
        "value": "451200"
    }, {
        "province": "广西壮族自治区",
        "label": "来宾市",
        "value": "451300"
    }, {
        "province": "广西壮族自治区",
        "label": "崇左市",
        "value": "451400"
    }] }, {
    "value": "460000",
    "label": "海南省",
    "children": [{
        "province": "海南省",
        "label": "海口市",
        "value": "460100"
    }, {
        "province": "海南省",
        "label": "三亚市",
        "value": "460200"
    }, {
        "province": "海南省",
        "label": "三沙市",
        "value": "460300"
    }, {
        "province": "海南省",
        "label": "儋州市",
        "value": "460400"
    }, {
        "province": "海南省",
        "label": "省直辖县级行政区划",
        "value": "469000"
    }] }, {
    "value": "500000",
    "label": "重庆市",
    "children": [{
        "province": "重庆市",
        "label": "重庆市",
        "value": "500100"
    }] }, {
    "value": "510000",
    "label": "四川省",
    "children": [{
        "province": "四川省",
        "label": "成都市",
        "value": "510100"
    }, {
        "province": "四川省",
        "label": "自贡市",
        "value": "510300"
    }, {
        "province": "四川省",
        "label": "攀枝花市",
        "value": "510400"
    }, {
        "province": "四川省",
        "label": "泸州市",
        "value": "510500"
    }, {
        "province": "四川省",
        "label": "德阳市",
        "value": "510600"
    }, {
        "province": "四川省",
        "label": "绵阳市",
        "value": "510700"
    }, {
        "province": "四川省",
        "label": "广元市",
        "value": "510800"
    }, {
        "province": "四川省",
        "label": "遂宁市",
        "value": "510900"
    }, {
        "province": "四川省",
        "label": "内江市",
        "value": "511000"
    }, {
        "province": "四川省",
        "label": "乐山市",
        "value": "511100"
    }, {
        "province": "四川省",
        "label": "南充市",
        "value": "511300"
    }, {
        "province": "四川省",
        "label": "眉山市",
        "value": "511400"
    }, {
        "province": "四川省",
        "label": "宜宾市",
        "value": "511500"
    }, {
        "province": "四川省",
        "label": "广安市",
        "value": "511600"
    }, {
        "province": "四川省",
        "label": "达州市",
        "value": "511700"
    }, {
        "province": "四川省",
        "label": "雅安市",
        "value": "511800"
    }, {
        "province": "四川省",
        "label": "巴中市",
        "value": "511900"
    }, {
        "province": "四川省",
        "label": "资阳市",
        "value": "512000"
    }, {
        "province": "四川省",
        "label": "阿坝藏族羌族自治州",
        "value": "513200"
    }, {
        "province": "四川省",
        "label": "甘孜藏族自治州",
        "value": "513300"
    }, {
        "province": "四川省",
        "label": "凉山彝族自治州",
        "value": "513400"
    }] }, {
    "value": "520000",
    "label": "贵州省",
    "children": [{
        "province": "贵州省",
        "label": "贵阳市",
        "value": "520100"
    }, {
        "province": "贵州省",
        "label": "六盘水市",
        "value": "520200"
    }, {
        "province": "贵州省",
        "label": "遵义市",
        "value": "520300"
    }, {
        "province": "贵州省",
        "label": "安顺市",
        "value": "520400"
    }, {
        "province": "贵州省",
        "label": "毕节市",
        "value": "520500"
    }, {
        "province": "贵州省",
        "label": "铜仁市",
        "value": "520600"
    }, {
        "province": "贵州省",
        "label": "黔西南布依族苗族自治州",
        "value": "522300"
    }, {
        "province": "贵州省",
        "label": "黔东南苗族侗族自治州",
        "value": "522600"
    }, {
        "province": "贵州省",
        "label": "黔南布依族苗族自治州",
        "value": "522700"
    }] }, {
    "value": "530000",
    "label": "云南省",
    "children": [{
        "province": "云南省",
        "label": "昆明市",
        "value": "530100"
    }, {
        "province": "云南省",
        "label": "曲靖市",
        "value": "530300"
    }, {
        "province": "云南省",
        "label": "玉溪市",
        "value": "530400"
    }, {
        "province": "云南省",
        "label": "保山市",
        "value": "530500"
    }, {
        "province": "云南省",
        "label": "昭通市",
        "value": "530600"
    }, {
        "province": "云南省",
        "label": "丽江市",
        "value": "530700"
    }, {
        "province": "云南省",
        "label": "普洱市",
        "value": "530800"
    }, {
        "province": "云南省",
        "label": "临沧市",
        "value": "530900"
    }, {
        "province": "云南省",
        "label": "楚雄彝族自治州",
        "value": "532300"
    }, {
        "province": "云南省",
        "label": "红河哈尼族彝族自治州",
        "value": "532500"
    }, {
        "province": "云南省",
        "label": "文山壮族苗族自治州",
        "value": "532600"
    }, {
        "province": "云南省",
        "label": "西双版纳傣族自治州",
        "value": "532800"
    }, {
        "province": "云南省",
        "label": "大理白族自治州",
        "value": "532900"
    }, {
        "province": "云南省",
        "label": "德宏傣族景颇族自治州",
        "value": "533100"
    }, {
        "province": "云南省",
        "label": "怒江傈僳族自治州",
        "value": "533300"
    }, {
        "province": "云南省",
        "label": "迪庆藏族自治州",
        "value": "533400"
    }] }, {
    "value": "540000",
    "label": "西藏自治区",
    "children": [{
        "province": "西藏自治区",
        "label": "拉萨市",
        "value": "540100"
    }, {
        "province": "西藏自治区",
        "label": "日喀则市",
        "value": "540200"
    }, {
        "province": "西藏自治区",
        "label": "昌都市",
        "value": "540300"
    }, {
        "province": "西藏自治区",
        "label": "林芝市",
        "value": "540400"
    }, {
        "province": "西藏自治区",
        "label": "山南市",
        "value": "540500"
    }, {
        "province": "西藏自治区",
        "label": "那曲地区",
        "value": "542400"
    }, {
        "province": "西藏自治区",
        "label": "阿里地区",
        "value": "542500"
    }] }, {
    "value": "610000",
    "label": "陕西省",
    "children": [{
        "province": "陕西省",
        "label": "西安市",
        "value": "610100"
    }, {
        "province": "陕西省",
        "label": "铜川市",
        "value": "610200"
    }, {
        "province": "陕西省",
        "label": "宝鸡市",
        "value": "610300"
    }, {
        "province": "陕西省",
        "label": "咸阳市",
        "value": "610400"
    }, {
        "province": "陕西省",
        "label": "渭南市",
        "value": "610500"
    }, {
        "province": "陕西省",
        "label": "延安市",
        "value": "610600"
    }, {
        "province": "陕西省",
        "label": "汉中市",
        "value": "610700"
    }, {
        "province": "陕西省",
        "label": "榆林市",
        "value": "610800"
    }, {
        "province": "陕西省",
        "label": "安康市",
        "value": "610900"
    }, {
        "province": "陕西省",
        "label": "商洛市",
        "value": "611000"
    }] }, {
    "value": "620000",
    "label": "甘肃省",
    "children": [{
        "province": "甘肃省",
        "label": "兰州市",
        "value": "620100"
    }, {
        "province": "甘肃省",
        "label": "嘉峪关市",
        "value": "620200"
    }, {
        "province": "甘肃省",
        "label": "金昌市",
        "value": "620300"
    }, {
        "province": "甘肃省",
        "label": "白银市",
        "value": "620400"
    }, {
        "province": "甘肃省",
        "label": "天水市",
        "value": "620500"
    }, {
        "province": "甘肃省",
        "label": "武威市",
        "value": "620600"
    }, {
        "province": "甘肃省",
        "label": "张掖市",
        "value": "620700"
    }, {
        "province": "甘肃省",
        "label": "平凉市",
        "value": "620800"
    }, {
        "province": "甘肃省",
        "label": "酒泉市",
        "value": "620900"
    }, {
        "province": "甘肃省",
        "label": "庆阳市",
        "value": "621000"
    }, {
        "province": "甘肃省",
        "label": "定西市",
        "value": "621100"
    }, {
        "province": "甘肃省",
        "label": "陇南市",
        "value": "621200"
    }, {
        "province": "甘肃省",
        "label": "临夏回族自治州",
        "value": "622900"
    }, {
        "province": "甘肃省",
        "label": "甘南藏族自治州",
        "value": "623000"
    }] }, {
    "value": "630000",
    "label": "青海省",
    "children": [{
        "province": "青海省",
        "label": "西宁市",
        "value": "630100"
    }, {
        "province": "青海省",
        "label": "海东市",
        "value": "630200"
    }, {
        "province": "青海省",
        "label": "海北藏族自治州",
        "value": "632200"
    }, {
        "province": "青海省",
        "label": "黄南藏族自治州",
        "value": "632300"
    }, {
        "province": "青海省",
        "label": "海南藏族自治州",
        "value": "632500"
    }, {
        "province": "青海省",
        "label": "果洛藏族自治州",
        "value": "632600"
    }, {
        "province": "青海省",
        "label": "玉树藏族自治州",
        "value": "632700"
    }, {
        "province": "青海省",
        "label": "海西蒙古族藏族自治州",
        "value": "632800"
    }] }, {
    "value": "640000",
    "label": "宁夏回族自治区",
    "children": [{
        "province": "宁夏回族自治区",
        "label": "银川市",
        "value": "640100"
    }, {
        "province": "宁夏回族自治区",
        "label": "石嘴山市",
        "value": "640200"
    }, {
        "province": "宁夏回族自治区",
        "label": "吴忠市",
        "value": "640300"
    }, {
        "province": "宁夏回族自治区",
        "label": "固原市",
        "value": "640400"
    }, {
        "province": "宁夏回族自治区",
        "label": "中卫市",
        "value": "640500"
    }] }, {
    "value": "650000",
    "label": "新疆维吾尔自治区",
    "children": [{
        "province": "新疆维吾尔自治区",
        "label": "乌鲁木齐市",
        "value": "650100"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "克拉玛依市",
        "value": "650200"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "吐鲁番市",
        "value": "650400"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "哈密市",
        "value": "650500"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "昌吉回族自治州",
        "value": "652300"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "博尔塔拉蒙古自治州",
        "value": "652700"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "巴音郭楞蒙古自治州",
        "value": "652800"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "阿克苏地区",
        "value": "652900"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "克孜勒苏柯尔克孜自治州",
        "value": "653000"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "喀什地区",
        "value": "653100"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "和田地区",
        "value": "653200"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "伊犁哈萨克自治州",
        "value": "654000"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "塔城地区",
        "value": "654200"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "阿勒泰地区",
        "value": "654300"
    }, {
        "province": "新疆维吾尔自治区",
        "label": "自治区直辖县级行政区划",
        "value": "659000"
    }] }];


/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _lin_global, _details, _en;

var en = (_en = {
  pushTip: {
    pushType0: "The push has {nums} devices have been completed push, you want to skip these devices?",
    pushSuccess: "Jump to task details to see push schedule?",
    push_all_by_mem: "Whether to push channel operators: all the equipment under the {mem}",
    push_all: "Are you pushing all the equipment under all channels?"
  },
  ter: {
    state1: 'Activation successful',
    state2: 'Activation failed',
    state3: 'Wait for activation',
    mechName: 'Merchant',
    status: 'Status',
    createTime: 'CreateTime',
    terminalNo: 'Terminal number',
    msg: 'Do you want to delete'
  },
  IncorrectaFormat: 'Wrong Format. Please Upload Xls Or Xlsx File',
  app_certificate_1: "Level 1 Certificate",
  app_certificate_2: "Level 2 Certificate",
  app_certificate_1_psp: "Chip firmware",
  app_certificate_2_psp: "Master firmware",
  app_pushAll: "Push All Terminal",
  app_uploadApp: 'Upload application',
  app_No: 'Serial number',
  app_terNo: 'Terminal number',
  app_name: 'Name',
  psp_app_id: "ID app",
  psp_app_version: "Version app",
  app_appName: 'Application name',
  psp_app_manage: "Application management",
  psp_unstall_manage: "Uninstall management",
  app_appUpList: "Apply device update list",
  app_appType: 'Application type',
  app_insType: 'Installation type',
  app_vStatus: 'Status',
  app_ulTime: 'Upload time',
  app_appLoding: 'Application uploading',
  app_newgVer: 'Latest version',
  app_operate: 'Operation',
  app_type: 'Type',
  app_del: 'Delete',
  app_pause: 'Pause',
  app_continue: 'Continue',
  app_status: 'Status',
  app_new: 'New add',
  app_yes: 'Yes',
  app_no: 'No',
  app_selectAll: 'Select all',
  app_save: 'Save',
  app_process: 'Progress',
  app_push: 'Confirm push',
  app_terminal: 'Terminal',
  app_to: ' to ',
  app_offShelf: 'Remove',
  app_mulOffShelf: 'Batch remove',
  app_isOffShelf: 'Are you sure to remove the application from the store?',
  app_isDelApp: 'Are you sure to delete the application?',
  app_chooseOneMust: 'Select one application at least',
  app_cantDelTask: 'Tasks selected include some cannot be deleted',
  app_oneRecordMust: 'Select at least one record',
  app_phoneIllegal: 'Phone number is not legal',
  app_groupName: 'Category Name',
  app_sure: 'Yes',
  app_query: 'Query',
  app_reset: 'Reset',
  app_cancel: 'Cancel',
  app_edit: 'Edit',
  app_add: 'Add',
  app_verify: 'Review',
  app_isPass: 'Result',
  app_pass: 'Approved',
  app_ban: 'Rejected',
  app_noInput: 'Unfilled',
  app_banReason: 'Refuse reason',
  app_filter: 'Filter',
  app_prePushVerify: 'Waiting for submitting',
  app_preVerify: 'waiting for review',
  app_verifyPass: 'Approved',
  app_verifyNotPass: 'Rejected',
  app_success: 'Successful',
  app_submit: 'Submit',
  app_tip: 'Prompt',
  app_online: 'Online',
  app_offline: 'Offline',
  app_fileOver: 'File exceed',
  app_onlyApk: 'Apk files upload only',
  app_onlyApk_2: 'Apk/Hap files upload only',
  app_tipViewTask: 'Push successfully, please view progress in task management',
  app_tipMkDel: 'Application in app store will be deleted synchronously. Are you sure to delete?',
  app_clearTask: 'Do you want to clear all devices?',
  app_tipAppEdit: 'Deleted will not be restored, sure to delete?',
  app_tipVerify: 'Are you sure to submit?',
  app_rqsError: 'Request error',
  app_not_auth: 'TMS not activated',
  app_mulAdd: 'Batch add',
  app_select: 'Select',
  app_input: 'Please enter the content',
  app_inputCp: 'Please fill in complete',
  app_inputName: 'Please enter a name',
  app_inputContact: 'Please enter a contact',
  app_inputTruePhone: 'Please enter the correct number',
  app_inputAddr: 'Please enter an address',
  app_inputVer: 'Please enter the version',
  app_inputVerTag: 'Please enter the version ID',
  app_inputID: 'Please enter Identification',
  app_inputPkg: 'Please enter the packagename',
  app_noVerTag: 'No versionCode',
  app_inputIntrol: 'Please enter a description',
  app_selectType: 'Please select the application type',
  app_ulApp: 'Please upload the application',
  app_ulIcon: 'Please upload a small icon',
  app_ulLarIcon: 'Please upload a big icon',
  app_ulScreenShot: 'Please upload screenshots',
  app_smVerify: 'Submit',
  app_baseInfo: 'Basic Information',
  app_version: 'VersionName',
  app_autoUpload: 'Automatically enter',
  app_verTag: 'VersionCode',
  app_ID: 'Identification',
  app_package: 'Packagename',
  app_introl: 'Application brief',
  app_udState: 'Update notes',
  app_icon: 'Small icon',
  app_larIcon: 'Large icon',
  app_screenShot: 'Screenshots',
  app_appVer: 'Application version',
  app_createTime: 'Create time',
  app_close: 'Close',
  app_ulNew: 'Upload latest version',
  app_selectApp: 'Select application',
  app_testInstall: 'Test for installation',
  app_ulAppState: 'Drag the file here, or click upload, only apk file upload is supported',
  app_clickUpdate: 'Click upload',
  app_udType: 'The way for update',
  app_allUpdate: 'Update all',
  app_iconState: '144x144,Size does not exceed 100k',
  app_larIconState: '512x512,Size does not exceed 200k',
  app_autoInstall: 'Automatic installation',
  app_addApp: 'Add',
  app_classIntrol: 'Classification recommended',
  app_homeIntrol: 'Home recommended',
  app_isIntroClass: 'Recommended to classification or not',
  app_isIntroHome: 'Recommended to home or not',
  app_isUnbindApp: 'Are you sure to uninstall the application？',
  app_isOffApp: 'Are you sure Shelf application?',
  app_isDelData: 'Are you sure to delete this data?',
  app_inputAName: 'Please enter a name',
  app_oneDeviceMust: 'Select one device at least',
  app_fileSize: 'File size',
  app_addPush: 'Add push',
  app_viewPushHis: 'View push history',
  app_pushTimes: 'Download',
  app_hisVer: 'Historic version',
  app_pushHistory: 'Push history',
  app_pushInstall: 'Test install',
  app_animatePush: 'Animation',
  app_animateMake: 'New',
  app_pushDevice: 'Pushed device',
  app_deviceNum: 'Total',
  app_deviceName: 'Device name',
  app_deviceNo: 'Device number',
  app_pushTime: 'Push time',
  app_distributor: 'Merchant',
  app_dParent: 'Parent merchant',
  app_unbind: 'Uninstall',
  app_mulUnbind: 'Batch uninstall',
  app_mulPush: 'Batch push',
  app_searchTerminal: 'Find devices',
  app_terName: 'Terminal name',
  app_taskName: 'Task name',
  app_taskDetail: 'Task content',
  app_deviceTotal: 'Total number of devices',
  app_downloading: 'Downloading',
  app_downFail: 'Failed to download',
  app_update: 'Update',
  app_md5Fail: 'MD5 verification failed',
  app_theNewgVer: 'latest version alreaday installed',
  app_fileFmIllegal: 'The file format is incorrect',
  app_updateFail: 'Failed to update',
  app_usrCancelUpdate: 'The user canceled the update',
  app_pushFail: 'Device offline',
  app_downFinish: 'Download completed',
  app_updateSuccess: 'Update sucessfully',
  app_fail: 'Failed',
  app_addres: 'Address',
  app_mulDel: 'Batch deleted',
  app_allDel: 'Delete all',
  app_contact: 'Contacts',
  app_contactPhone: 'contact number',
  app_typeName: 'Type name',
  app_customs: 'Create',
  app_clear: 'Clean',
  app_customsTime: 'Create time',
  app_launchAnimate: 'Boot Animation',
  app_onLogo: 'Boot LOGO',
  app_animateName: 'Animation name',
  app_playPlace: 'Play position',
  app_aSrcFile: 'Animation resource file',
  app_asfState: 'Animated image, Note that the file name must be part0.zip',
  app_downExp: 'Download example',
  app_ologoState: 'The screen displayed after the movie playback stops',
  app_picSize: 'Image size',
  app_picSizeState: 'Enter the width*height',
  app_frame: 'Number of frames',
  app_frameState: 'Number of animations played per second',
  app_aCycleTime: 'Number of animation cycles',
  app_cyclePlay: 'Loop Playback',
  app_playOnce: 'Play once',
  app_fileNameOnly: 'File name must be',
  app_inputNumber: 'Please enter the number',
  app_picUlError: 'Image upload error',
  app_inputAnimateName: 'Please enter an animation name',
  app_selectAnimateType: 'Please select the animation type',
  app_selectPlayPlace: 'Please select a play position',
  app_uploadAnimateFile: 'Please upload an animation file',
  app_uploadOnPic: 'Please upload the boot picture',
  app_sureDelTip: 'Are you sure to delete? It will not be restored after deletion',
  app_uploadPic: 'Please upload pictures',
  app_launchUI: 'Start interface',
  app_amechine: '',
  app_chooseCycleType: 'Please select the loop mode',
  app_formatNotTrueLike: 'The format is incorrect',
  app_on: 'Power on',
  app_off: 'Power off',
  app_onOff: 'Power on or Power off',
  app_firm: 'Manufacturer name',

  add_srcFwByName: 'Find the firmware by name',
  app_downNum: 'Downloads',
  app_pushed: 'Released',
  app_notPass: 'Rejected',
  app_sysType: 'System type',
  app_sys: 'System',
  app_sysUdPack: 'System upgrade package',
  app_chooseFile: 'Select a file',
  app_signCer: 'Signature certificate',
  app_isUseDisCerAutoSign: 'Whether to use the merchant certificate for automatic signature',
  app_useDis: 'Designated merchant',
  app_allDisUsed: 'Common for all merchant',
  app_pushInstallTest: 'Test',
  app_firmware: 'Firmware name',
  app_pushType: 'Push type',
  app_dv: 'Device',

  app_fwType: 'Firmware type',
  app_ulNormalSt: 'Drag the file here, or click upload',
  app_selectChannel: 'Please select merchant',
  app_isSubmitToCheck: 'Do you want to submit for review',
  app_pleaseInputNo: 'Please enter terminal number',
  app_cnAndActive: 'Online activate',
  app_clearCer: 'Clear certificate',
  app_ofCheck: 'Verification',
  app_normal: 'Normal',
  app_netStatus: 'Network status',
  app_active: 'Activated',
  app_initiative: 'initiative',
  app_selfDestroy: 'Self-destruction',
  app_mulActive: 'Active in batch',
  app_selected: 'Selected',
  app_cerCheckOf: 'Verify switch',
  app_openCerCheck: 'Verify on',
  app_closeCerCheck: 'Verify off',
  app_reOpen: 'Reopen',
  app_reClose: 'Reclose',
  app_open: 'Open',
  app_usrManage: 'User manage',
  app_stManage: 'Configuration manage',
  app_roleManage: 'Role manage',

  app_cerMgType: 'Certificate manage',
  app_cerMgSelf: 'Self-Manage',
  app_cerMgOther: 'Platform-Manage',
  app_cerMgCustomer: 'Customized',
  app_operateHis: 'Operation record',
  app_operateType: 'Operation Type',
  app_time: 'Time',
  app_isActive: 'Activate?',

  app_downCer: 'Download certificate',

  app_isOperate: 'Continue?',

  app_ulSuccess: 'Upload success',

  app_setting: 'Setting',

  app_clickPicToUlPic: 'Click to upload img',
  app_within: 'within',
  app_pgsFormat: 'Format(png, gif, svg)',
  app_sgUseAndAdUse: 'Format:svg, white color recommanded',
  app_sureChange: 'Confirm change',
  app_logoLvTip: 'Exit without saving?',
  app_dfIcon: 'Default icon',

  app_useBigSize: 'Big size',
  app_useBigSizeTip: 'Click to optimize view',

  app_or: 'Or',
  app_format: 'Format',
  app_pic: 'Picture',
  app_s: " 's ",
  app_plsUpl: 'Please Upload',

  app_upload: 'Upload',
  app_cerType: 'Certificate Type',

  app_editProfile: 'Edit Profile',

  app_cerFile: 'Certificate files',
  app_plsUlPbCer: 'Please upload customer certificate',
  app_appNoCerTip: 'The current channel is self managing certificate channel, please upload public key file for application verification',
  app_appNeedCerTip: 'The current channel does not have a certificate, please contact the platform administrator to create',
  app_createCer: 'Create certificate',
  app_uploadCer: 'Upload certificate',
  app_ustart: 'Not started',
  app_outofdate: 'Expired',

  app_fileImport: 'File import',
  app_mdFile: 'Template file',
  app_down: 'Download',

  app_roleAllot: 'Role allot',
  app_roleName: 'Role',
  app_downTplFile: 'Download template files',

  app_verUdCt: 'Version update contents',
  app_animation: 'animation',
  app_per: 'per',
  app_minute: 'minute',
  app_autoRefresh: 'auto refresh',
  app_level: 'level'
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_firm", 'company'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_model", 'model'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_adType", 'Advertisement type'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_license", 'license key'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_maintain", 'maintain'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_manage", 'manage'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_is", 'is'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_plsip", 'please input'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_reason", 'reason'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_sgMc", 'single machine'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_ss", 'synopsis'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_inst", 'install'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_file", 'file'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_printscreen", 'printscreen'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_batch", 'batch'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_recov", 'recovery'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_lc", 'launcher'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_re", 'again'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_confirm", 'confirm'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_df", 'default'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_as", 'as'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_click", 'click'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_content", 'content'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_ttPkg", 'Full package'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_dfPkg", 'Incremental package'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_task", 'task'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_catch", 'catch'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_log", 'Log'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_continued", 'continued'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_sec", 'second'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_video", 'video'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_ad", 'ad'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_choose", 'choose'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_timeInterval", 'time interval'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_and", 'and'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_play", 'play'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_times", 'times'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_sc", 'second'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_tofvalis", 'Term of validity'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_tofvaliss", 'Term of validity'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_start", 'start'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_end", 'end'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_preview", 'preview'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_duration", 'duration'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_size", 'size'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_personnel", 'personnel'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_cannot", 'cannot'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_early", 'early'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_later", 'later'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_lessThan", 'less than'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_moreThan", 'more than'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_nums", 'numbers'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_waiting", 'waiting'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_all", 'all'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_all1", 'all'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_thistime", 'this time'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_done", 'done'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_areyou", 'are you'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_skip", 'skip'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_these", 'these'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_cover", 'cover'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_jump", 'jump'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_detail", 'detail'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_view", 'view'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_now", 'now'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_imp", 'import'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_size1", 'size'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_taskMg", 'Task manage'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_taskType", 'Task type'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_cancelPush", 'Cancel push'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_azcgsj", 'time of install success'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_ispushf", 'To install remotely'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_autoscopen", 'Run automatically when finish install'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_pushsctipinstall", 'Prompt install when download finish'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_tipdown", 'Prompt download'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_tipud", 'Prompt update'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_sysinfo", 'System info'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_bth", 'Back to home'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_terstatus", 'Terminal status'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_fminfo", 'Firmware info'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_norightview", 'You do not have access to this page'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_fault", 'fault'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_geo", 'geography'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_abnormal", 'abnormal'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_blockp", 'Block paper'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_ecr", 'Electric card reader'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_mcr", 'Manual card reader'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_nacr", 'Non access card reader'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_cardr", 'Card reader'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_rcmsg", 'Recieve message'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_tgcr", 'Two generation card reader'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_receiptp", 'Receipt printer '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_hbsp", 'Geartbeat interval'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_checkupsp", 'Check update interval'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_ispushalldv", 'Is push all device'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "lin_btn", {
  cancel: "Cancel",
  add: "Add",
  install: 'install',
  batch_install: 'Batch install',
  tips: 'Prompt',
  confirm: 'Confirm',
  unbind: 'Unbind',
  unbindAll: 'Batch unbind',
  check: 'Query',
  reset: 'Reset',
  submit: 'Submit',
  restart: 'Reboot',
  off: 'Close',
  send: 'Push',
  batch_delete: 'Batch Delete',
  delete: 'Delete',
  lock: 'Lock',
  lockOta: 'Lock OTA',
  add_zeng: 'Add',
  edit: 'Edit',
  save: 'Save',
  bind: 'Bind',

  bindAll: 'Batch bind',
  xiezai: 'Uninstall',
  unlock: 'Unlock',
  change: 'Modify'

}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "lin_global", (_lin_global = {
  cs_config: 'Param setting',
  task_tips: 'The installation is successful, please view the progress of the push in the task management',
  task_tips2: 'Push sucessfully，please view the progress of the push in Task Management',
  ope: 'Operation',
  pselect: 'Please select',
  label_no: 'Serial Number',
  loading: 'Loading',
  label_name: 'Name',
  all_mechanism: 'All merchant',
  place_areaid: 'Please select merchant',
  time: 'Time',
  version: 'Version',
  name: 'Name',
  remark: 'Remark',
  edit: 'Edit',
  label_model: 'Device model',
  label_type: 'Device type',
  device_type_1: "Intelligent POS",
  device_type_2: "Other equipment",
  label_manufid: 'Manufacturer',
  label_areaid: 'Merchant',
  label_areaid_name: 'Merchant name',
  label_address: 'Address',
  ter_status: 'Status',
  dest_status: 'Active status',
  net_status: 'Network',
  run_status: 'Peripherals',
  online: 'Online',
  offline: 'Offline',
  new_add: 'New-add',
  normal: 'Normal',
  marn: 'Warning',
  fault: 'Fault',
  success_tips: 'Successful operation',
  concel_tips: 'Canceled',
  zlxfs_tips: 'The order was issued successfully',
  sb_tips: 'Failed to operate, terminal is offline',
  czsb: 'Failed to operate',
  zl_error: 'Instruction issued error',
  all_status: 'All status',
  delete_success: 'Delete successfully',
  look_detail: 'View details',
  ter_num: 'Device quantity',
  ota_bao: 'OTA package',
  ple_sel_ota: 'Please select OTA package',
  unlock_success: 'Unlock successfully',
  risk_name: 'Configuration name',
  risk_type: 'Warning type',
  risk_radius: 'Fence radius(KM)',
  risk_city: 'Provinces and municipalities',
  risk_desc: 'Description',
  risk_warn_info: 'Risk control warning information',
  warn_event: 'Warning event',
  city: 'City',
  jwd: 'Latitude and longitude',
  distance: 'Beyond the set distance(KM)',
  ccwl: 'Beyond the fence',
  sbyj: 'Device warning',
  done: 'Done',
  undone: 'Untreated',
  roles_tips: 'Please select a role',
  roles_place: 'Nickname',
  userName: 'Username',
  nickName: 'Nickname',
  phoneNum: 'Mobile phone',
  roleName: 'Role',
  jh: 'Activate ',
  dj: 'Freeze',
  phoneNum2: 'Cellphone number',
  resetPass: 'Reset password',
  revisePass: 'Change password',
  oldPass: 'Old password',
  newPass: 'New password',
  comfirmPass: 'Confirm the new password',
  plePassTips: 'Please enter the password',
  plePassTipsAgain: 'Please enter the password again',
  pwdDisfault: 'Two passwords are not consistent',
  unfitPhone: 'Phone number is not legal',
  nickNameTips: 'Nickname cannot be null',
  userNameTips: 'Username cannot be null',
  phoneNumTips: 'Phone number cannot be null',
  roleidTips: 'Role cannot be null',
  mechanismIdTips: 'Merchant cannot be null',
  userStatusTips: 'Please set the user status',
  editPage: 'Edit page',
  addPage: 'Add page',
  status: 'Status',
  refs: 'Please improve the data',
  user: 'Account',
  logStartTime: 'Log start time',
  logEndTime: 'Log end time',
  download: 'Download',
  ddsc: 'Waiting for upload',
  scz: 'Uploading',
  scsb: 'Failed to upload',
  sccg: 'Uploaded successfully',
  rz_tips: 'Logs obtain successfully. Please view the progress of the log in log management',
  hqrz: 'Obtain the log',
  logoTitle: 'Terminal Management System',
  hello: 'Hello',
  wdzl: 'Your profile',
  tcxt: 'Sign out',
  yhdl: 'Sign in',
  zh: 'Account',
  password: 'Password',
  jzmm: 'Remember the password',
  login: 'Sign in',
  bah: 'Shenzhen Zhengtong Electronic Co., Ltd. © 1993-2020 copyright Guangdong ICP B No. 12035887',
  qsrzh: 'Please enter the username',
  qsrmm: 'Please enter the password',
  error: 'Error',
  wlzt: 'Network status',
  ckxq: 'View details',
  wlmc: 'Fence name',
  wllx: 'Fence type',
  bdsb: 'Bind the device',
  tjbd: 'Add binding',
  bjwl: 'Edit fence',
  wxzyjlx: 'Please select an warning type',
  cityName: 'City name',
  sfjxpljb: 'Batch unbundling or not',
  qxzyjbdzd: 'Please select the terminal to unbind',
  jbcg: 'Unbind successfully',
  sfjbczd: 'Unbind this terminal or not',
  sfjxplbd: 'Batch bundling or not',
  qxzybddzd: 'Please select the terminal to bind',
  bdcg: 'Bind successfully',
  sfbdczd: 'Bind this terminal or not',
  xzwl: 'Add fence',
  qdxysccwl: 'Are sure to delete this fence?',
  tsazcs: 'Test',
  shzt: 'status',
  pass: "Approved",
  notPass: "Rejected",
  waitOne: "Waiting for submit",
  waitTwo: "Waiting for review",
  shyy: 'Rejected reason',
  zdtslb: 'Terminal push list',
  xztghbtg: 'Select to pass or not',
  qrtj: 'Confirm submission',
  shcg: "Review successfully",
  syqdsty: 'Common for all merchant',
  notBlankName: "Name cannot be null",
  notBlankVer: 'Version cannot be null',
  qxzlx: 'Please select type',
  qxzscwj: 'Please select the upload file',
  zdqds: 'Designated merchant',
  sfsyzdqm: 'Whether to use the channel merchant certificate for automatic signature',
  qmzst: 'Signature certificate',
  azbdz: 'Installation package address',
  qscapkwj: 'Please upload apk file, and no more than 50M',
  qsczipwjls50: 'Please upload zip file, and no more than 50M',
  jwjtdcc: 'Drag the file here， or',
  djsc: 'Click upload',
  xgscwj: 'Modify the upload file',
  otaName: 'Name',
  xtlx: 'System type',
  syatemR: 'System ROM',
  sysjota: 'System upgrade package OTA'
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "waitOne", "Waiting for submit"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "waitTwo", "Waiting for review"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "verifyPass", 'Approved'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "verifyNotPass", 'Rejected'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "confirmDelete", "Are you sure to delete？"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "tjshcg", 'Submit successfully'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "qdtjsh", 'Confirm to submit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "allType", 'All type'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "smVerify", 'Submit approve'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "downNumber", 'Downloads'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "tgmccz", 'Find by name'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "upload", 'Upload'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "xzqddhwj", 'Select file of starting animation'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "qxzkjlogo", 'Select the boot LOGO'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "tpxzds", '300x300 is the best size for the picture, the volume is not greater than 2m'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "zmlaun", 'Select custom desktop launcher'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "xtjcb", 'Select the system base package'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "null", 'Null'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "shebei", 'Device'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "tslxxx", 'Push type'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "xzbbbbb", 'Select OTA package'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "uploadTime", "Upload time"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "verTips", 'Based on the version of the differential package, the version number does not contain characters such as V or version, such as 2.2.4.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "verTips1", 'Version numbers do not contain characters such as V or version, pure numbers, such as 2.2.4'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "bbhgsbd", 'Format of version is incorrect'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "lkymtips", 'There are files that are being uploaded ，are you sure to leave this page'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "znscziptips", 'Zip files upload only'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "qsczipwj", 'Please upload Zip files'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "danweikm", 'Unit KM'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "weilanshuoming", 'Description: The latitude and longitude of the last heartbeat of the device is the center of the fence'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "pleaseUpload", 'Please upload'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "zdqmTips", 'Whether to bind the merchant certificate automatically signed'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "zhidingqdsxx", 'Designated merchant information'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "selectWenjian", 'Select file'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "qrjxmm", 'Are you sure to execute this command: '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "cicaozuo", 'Operate?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "shebeiedit", 'Device edit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "yxpztitle", 'Mailbox configuration'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "yjyouxiang", 'Alarm mailbox'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "chongzhi", 'Reset'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "ljchangjian", 'Submit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "ympeizhi", 'Domain name configuration'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "fwqdizhi", 'Server address'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "fwqdztips", 'Address does not include the "http: //" character, which can be either a domain address or an IP address, such as: www.baidu.com or 127.0.0.1'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "fwqduankou", 'Server port'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "duankoutips", 'Do not add ":" for the port number, directly fill in the numbers, such as: 8080'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "tuisongpeizhi", 'Modify'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "tuisongjl", 'Push record'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "tuisonglx", 'Push type'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "chenggong", 'Successful'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "shibai", "Failed"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "tuisongtime", 'Push time'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "chongtui", 'Push again'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "shebeibei", 'Device'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "fwqdzbnwk", 'The server address cannot be null'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "fwqdkhbnwk", 'The server port number cannot be null'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "wdct", 'Are you sure to push again'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "tuisongtips", 'Are you sure to modify the following IP configuration? New IP configuration will be effective after reboot.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "china", 'Chinese'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "english", 'English'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "cjzs", 'Create certificate'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "createTime", 'Create time'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "certificateName", 'Certificate name'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "xiafa", 'Push'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "dachuzhengshu", 'Save certificate'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "guojia", 'Country'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "shengfen", 'Province'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "gongsi", 'Company'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "youxiang", 'Email'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "youxiaoqi", 'Expire date'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "certTypeLabel", 'Cert Type'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "certForManufacturer", 'manufacturer'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "certForCustomer", 'customer'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "danweitian", 'Unit: Day'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "xinjian", 'New'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "notNull", 'Must'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "bitian", 'Must'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "guojiatips", 'Country abbreviation'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "shenfentips", 'Province(ENG/CHN)'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "cityTips", ' City(ENG/CHN)'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "gongsiTips", 'Company(ENG/CHN)'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "emailTips", 'Email'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "youxiaoqiTips", 'Expire date, Unit: day'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "xuantian", 'Optional'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "srgsbzq", ' Wrong format'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "cszss", 'SZZT certificate'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "khzss", 'Distributor certificate'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "sccszss", 'Upload SZZT certificate'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "zhengshu", 'Certificate'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "qudaoshangxinxi", 'Merchant'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "quorter", 'Please confirm distributor or SN'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "xiafalishi", 'Download record'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "resXiafa", 'Re-download'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "chongxintuisong", 'Re-push'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "tuisongleixing", 'How to push'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "dachusiyao", 'Save private key'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "shuaxin", 'Refresh'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "passWordTips", 'Password required'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "daochugongyao", 'Export certificate'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "zhengshuType", 'Merchan Cert Type'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "ziguan", 'Self-manage'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "daiguan", 'Platform-manage'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "add_merchant", 'Add Merchant'), _lin_global)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "terminal", {

  add: {
    place_no: "Please enter device number",
    place_name: 'Please enter device name',
    place_model: 'Please select device model ',
    place_type: 'Please select device type ',
    place_manufid: 'Please select manufacture',
    place_address: 'Please enter device address',
    popover_no: 'The device number consists of letters, numbers, or underscores whose length is no more than 50 digits',
    popover_name: 'The device name consists of Chinese characters, letters, numbers or underscores whose length is not greater than 50 digits',

    rules_no_1: 'The device number cannot be null',
    rules_no_2: 'The device number can not exceed 20 digits',
    rules_no_3: 'The device number consists of letters, numbers, or underscores',
    rules_no_4: 'The device number already exists',
    rules_name_1: 'The device name cannot be null',
    rules_name_2: 'The device name can not exceed 20 digits',
    rules_name_3: 'The device name consists of Chinese characters, letters, numbers, or underscores',

    success: 'Added successfully',
    change_success: 'Modified successfully'

  },
  appBind: {
    label_name: 'Application name',
    label_version: 'Version',
    label_size: 'Application size',
    place_name: 'Search by name',
    place_terminal: 'Please select the Terminal',
    empty_tips: 'Please select the application you want to bind!',
    install_tips: 'Are you sure to install this application?',
    five_tips: 'Binding application once can not be more than five'

  },
  appList: {
    label_name: 'Application name',
    label_type: 'Application type',
    label_version: 'Version',
    label_time: 'Binding time',
    format_status1: 'General application',
    format_status2: 'System applications',
    tips1: 'Are you sure to uninstall this app?',
    tips2: 'Unbind successfully'

  },
  appLog: {
    start_time: 'Start time',
    end_time: 'End Time',
    log_type: 'Log type',
    log_content: 'Log content',

    num: 'Device quantity',
    tower: ''

  },
  details: (_details = {
    regain: 'Reset',
    run_log: 'Running log',
    risk_info: 'Risk control information',
    app_list: 'APP list',
    app_install: 'APP install',
    send_animate: 'Push animation',
    reset_animate: 'Restore animation',
    base_info: 'Basic Information',
    system_info: 'System message',
    launcher: 'launcher version',
    system_version: 'System version',
    system_spversion: 'System spversion',
    ota_version: 'OTA version',
    hard_version: 'Firmware version',
    last_time: 'Last updated',
    net_type: 'Network type',
    online_time: 'Online time',
    run_time: 'Uptime',
    hard_info: 'Hardware information',
    Electric_quantity: "Electric quantity",
    network: "Network",
    cpu: 'CPU information',
    mem: 'Memory information',
    cpuUsed: 'CPU usage',
    memUsed: 'Memory usage',
    hydh: 'Restore animation',
    tips: 'Please select the animation restore type',
    kjdh: 'Boot animation',
    gjdh: 'Shutdown animation',
    kjlogo: 'Boot LOGO',
    alldhlogo: 'All（animation and LOGO）',
    zbhy: 'Cancel',
    mshy: 'Restore immediately',
    tsdh_title: 'Push animation',
    animate_name: 'Animation name',
    animatType: 'Type',
    position: 'Play position',
    createTime: 'Custom time',
    animate: 'Animation'
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "kjlogo", 'Boot Logo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "kj", 'Power on'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "gj", 'Power off'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "kgj", 'Power on or Power off'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "com_send", 'Comfirm to Push'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "cover_send", 'Coverage push'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "skip_send", 'Skip push'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "comfirm_send", 'Are you sure to push this animation'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "comfirm_hy", 'Are you sure to restore this animation?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "hy_success", 'Restore successfully'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "hy_type", 'Please select the restore animation type'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "open_abd", 'Open ADB'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "close_abd", 'Close ADB'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "if_ope", 'Do this or not'), _details),
  list: {
    add_btn: 'Add',
    import_btn: 'Import',
    ztgxsj: 'Last updated',
    ac_time: "Tms activate time",
    ec_time: "Expiration time",
    import_title: 'Import device information',
    xqwj: 'Select the file',
    qrdr: 'Are you sure to import?',
    import_muban: 'Download the import template',
    notify_title: 'Import results prompt',
    delete_tips: 'This operation will permanently delete the device, are you sure to continue?',
    deletes_tips: 'This operation will permanently delete the device, are you sure to continue?',
    empty_tips: 'Please select the device to be deleted',

    excel_tips: 'Only Excel files not exceed 10M can be uploaded'

  },
  OtaList: {
    lock_num: 'Version Locked',
    lock_tips: 'Are you sure to unlock this OTA?'

  },
  terRisk: {
    fkpz: 'Risk control configuration'
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "account", {
  delete_tips: 'Are you sure to delete this user?'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "mao_global", {
  btn: {
    sort: "sort",
    e: "Operation",
    cancel: "Cancel",
    add: "Add",
    edit: "Edit",
    submit: "Submit",
    update: "Modify",
    delete: "Delete",
    ok: "Confirm",
    selectAll: "Select all",
    unSelectAll: "Unselect all",
    reset: "Reset",
    createNow: "Submit",
    confirmUpdate: "Modify"
  },
  tip: {
    text: "Prompt",
    confirmDelete: "Are you sure to delete?",
    examine: "Review",
    pleaseSelect: "Please select",
    pleaseInput: "Please input",
    search: "Query",
    notBlank: "Cannot be null",
    success: "Successful",
    fail: "Failed",
    notPassExamine: "Rejected",
    groundsForRefusal: "Please enter the reason for refusal",
    notReset: "It will not be restored after deletion"
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "menu", {
  home: "Home",
  terManage: "Device",
  terManageSub: {
    myTer: "My Device",
    breakup: "Terminal Backup",
    lockOTA: "Terminal Lock",
    map: "Map",
    log: "Log",
    addTer: "Add device",
    detailTer: "Terminal details",
    riskInfo: "Risk control information",
    runLog: 'Running log',
    appList: 'APP list',
    appInstall: 'Application install',
    otaLock: 'OTA lock'

  },
  advertManage: "Advertisement",
  advertManageSub: {
    list: "List",
    examine: "Review",
    examineVideo: 'Videos',
    examineDetail: "Review details",
    edit: "Edit ad",
    editVideo: 'Edit video ad',
    detail: "Ad details",
    vlist: "Video Advertisement",
    vverify: "Video Review",
    addVideo: "Add Video ad",
    dfVList: "Default video list",
    addDfVideo: "Add default video"
  },
  appManage: "Application",
  appManageSub: {
    list: "APP List",
    market: "APP Market",
    custom: "Add to my customization",
    viewApp: "View application",
    customPush: "Custom push",
    appPush: "App push",
    appBind: "Install Application remotely",
    examine: "Application Review",
    verifyApp: "Review Application",
    appEdit: 'Application edit',
    appDetail: 'Application details',
    uploadNew: 'Upload new version',
    uploadApp: 'Upload application'
  },

  safeManage: "Security",
  safeManageSub: {
    certificate: "Certificate List",
    certNew: "Create certificate",
    remote: "Remote authorization",
    certUpload: "Upload vendor certificate",
    certDetail: "Certificate details",
    cerUpload: "Upload certificate",
    myCert: 'My certificate'
  },
  taskManage: "Task",
  taskManageSub: {
    list: "In process",
    detail: "Task details",
    listHis: "Finish",
    detailHis: "Task details"
  },
  dataManage: "Data",
  dataManageSub: {
    channel: "Merchant",
    factory: "Manufacture",
    terClassify: "Device Type",
    terNum: "Device Model",
    advertClassify: "Advertisement Type",
    appClassify: "Application Type",
    newChannel: "Add merchant",
    editChannel: "Edit merchant",
    newFirm: "Add manufacture",
    editFirm: "Edit manufacture"
  },
  railManage: "Risk Control",
  railManageSub: {
    penSetting: "Fence set",
    warnSetting: "Warning information",
    riskDetail: "Fence details"
  },
  sysManage: "System",
  sysManageSub: {
    romul: 'OTA upload',
    romed: 'OTA edit',
    romOTA: "OTA List",
    examine: "OTA Review",
    push: "OTA Push",
    order: "System Custom",
    animation: "Boot animation custom",
    animateCustom: "Custom animation",
    animatePush: "Aanimation push",
    pushHistory: "Push History",
    firmwareManage: 'Firmware List',
    firmwareUpload: 'Firmware Upload',
    firmwareEdit: 'Firmware Edit',
    firmwareCheck: 'Firmware Review',
    firmwareCheckDt: 'Firmware Details',
    firmwarePush: 'Firmware Push',
    firmwarePushDevice: 'Firmware push to device',
    launchManage: 'Launcher List',
    launchCheck: 'Launcher verify',
    launchEdit: 'launcher edit',
    launchNewVer: 'launcher upload new version',
    verifyLaunch: 'Verify launcher',
    addLaunch: 'Add launcher',
    launchDetail: 'Launcher detail',
    launchPush: 'Launcher push',
    launchPushTer: 'Launcher push to terminal'
  },
  setManage: "Config",
  setManageSub: {
    role: "Role List",
    system: "System configuration",
    menu: "Menu list",
    logo: 'LOGO setting'
  },
  accManager: "Account",
  accManagerSub: {
    account: "Account Info",
    subAccount: "Sub-account Info",
    addAccount: 'Add sub account',
    editAccount: 'Edit sub account'
  },
  menuEdit: 'Menu edit'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "advert", {
  status: "Status",
  addAdvert: "New Advertisement",
  deleteAll: "Batch Delete",
  all: "All",
  refusal: "Explain the reason",
  app: "Application",
  appSub: {
    name: "Name",
    classify: "Type",
    uploadTime: "Upload time",
    version: "Version"
  },
  isPass: "Result",
  pass: "Approved",
  notPass: "Rejected",
  waitOne: "Waiting for submit",
  waitTwo: "Waiting for review",
  addDate: "Add time",
  addUser: "Adders",
  appName: "Application name",
  img: "Image",
  name: "Name",
  classify: "Type",
  position: "Placement",
  positionSub: {
    banner: "Home Banner",
    starPage: "Start page"
  },
  jumpType: "Redirection",
  jumpTypeSub: {
    net: "Web page",
    appStore: "Application market"
  },
  url: "URL",
  channel: "Merchant",
  ableDate: "Expire Time",
  beginDate: "Start Time",
  endDate: "End Time",
  contentImg: "Content",
  reset: "Reset"
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "index", {
  t: "",
  more: "More",
  terStatus: "Device profile",
  onlineTer: "Online device",
  offLineTer: "Offline device",
  warnTer: "Warnning device",
  taskList: "Task list",
  pullApp: "Application issue",
  romUpdate: "ROM update",
  pullAdvert: "Ad push",
  infoList: "Information list",
  riskWarn: "Risk control warning",
  breakWarn: "Fault warning"
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "menuConfig", {
  menu: {
    addMenu: "Add parent menu",
    addMenu2: "Add menu",
    refreshMenu: "Refresh menu",
    menuName: "Menu name",
    selectModel: "Please select the module",
    orderBy: "Sorting serial number",
    notBlankName: "Name cannot be null",
    editMenu: "Edit menu",
    editSuccess: "Edit sucessfully",
    addSubMenu: "Add submenu",
    relUrl: "Relative address"
  },

  role: {
    addRole: "Add roles",
    no: "Number",
    name: "Name",
    mark: "Description",
    model: "Module",
    updatePermission: "Modify permissions",
    editRole: "Role edit",
    notBlankName: "Name cannot be null",
    updateSuccess: "Update successfully",
    deleteSuccess: "Delete successfully",
    modelSelect: "Module select",
    addSuccess: "Add successfully"
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "taskTypeNames", {
  ALL: "All Types",
  APP: "APP",
  OTA: "OTA",
  ROM: "ROM",
  FIRMWARE: "Firmware",
  AD: "AD",
  STARTUP_ANIMATION: "Startup Animation",
  SHUTDOWN_ANIMATION: "Shutdown Animation",
  STARTUP_SHUTDOWN_ANIMATION: "StartUp & Shutdown Animation",
  LOGO: "LOGO",
  LAUNCHER: "Launcher",
  WALLPAPER: 'WallPaper'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_adname", 'Advertisement name'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_allpush", 'Push all of them'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_fipush", 'File import push'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_isjtoviewtd", 'Toggle to task list page'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_mgsys", 'System Host'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_edcode", 'Maintenance authorization code'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_sapp", 'Please choose the application'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_spic", 'Please select the picture'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_iappnamesrch", 'Please enter the application name query'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_alltyps", 'All types'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_allpp", 'All playback position'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_addur", 'Advertising time'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_vsize", 'Video size'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_addtime", 'Add time'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_psverify", 'Pass'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_vpreview", 'Video Preview'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_cstandt", 'Selection length and number of times'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_additv", 'Add time length'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_vdofile", 'video file'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_filename", 'File name'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_vdodur", 'Video time length'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_clreulvdo", 'Clicking on re - uploading video'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_adddfvdeoad", 'Add default video ads'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_addps", 'Additions'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_pltimes", 'Number of playback'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_pldur", 'Playback length'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_csvldate", 'Choice of validity period'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_advdoad", 'Adding video ads'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_mgdfvdo", 'Manage default video'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_adstatus", 'Advertising state'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_addadtype", 'New type of advertising'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_newapptype", 'New application type'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_addmodel", 'New model'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_newdvtype", 'New type of device'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_addfmname", 'New vendor name'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_srpush", 'Push'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_ulfile", 'Uploading files'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_ttpsddvnum", 'This push completes the number of equipment'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_srsktsdv", 'You are sure to skip these devices'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_cvpush", 'No, cover them'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_skpush", 'Yes, exclude them'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_pssuccess", 'Push successfully'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_nowjump", 'Ok'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_bcrecov", 'Batch reduction'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_skintro", 'Brief'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_addlc", 'New launcher'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_ulinsfile", 'Upload installation file'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_clreul", 'Click re - Upload'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_lcname", 'Launcher name'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_rsfivemin", 'Automatically refresh every 5 minutes'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_suresm", 'Confirm'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_udfiletype", 'Update file type'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_plsltype", 'Please select the type'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_adnamenotnull", 'The name of the advertisement cannot be empty'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_plslchannel", 'Please choose the channel dealer'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_plslplpos", 'Please select the playback location'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_slsttime", 'Please choose the start time'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_slendtime", 'Please choose the end time'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_addsc", 'Add success'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_vlsuccess", 'Audit success'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_opsuccess", 'Successful operation'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_srpassvf", 'Confirm through audit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_addvdoad", 'Adding video ads'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_edvdoad", 'Editing video ads'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_sllimit", 'Choice of validity period'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_srmuldel", 'Confirm batch deleting'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_sttcanlateendtime", "The start time can't be later than the end time"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_etcanelsttime", 'The end time is not earlier than the start time'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_srdelpush", 'Confirm delete push'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_srrecovsysdf", 'Verify that the restore is default to the system'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_rdless", 'The radius of the fence is less than'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_srban", 'Confirm that it is not passed'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_banandrs", 'Do not pass? Please enter the reason for rejecting'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_trjmap", 'Track map'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_psdonelftip", 'There are {num} devices that have installed or in downloading. Exclude these devices?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_psscandtip", 'Prompt install when finish download'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_csulpicbsis", 'Click Select to upload the picture, the best display size is'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_srch", 'Search'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_lkdevice", 'Find device'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_app", 'application'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_firmw", 'firmware'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_refresh", 'refresh'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_sleep", 'Sleep'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_ccdown", 'Cancel'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_iscancelPush", 'Whether to cancel the push?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_fmVerIillegal", 'The version is not legal, it must be a number, such as 1.0.0'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_verror", 'Version exception'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_other", 'Others'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_inssuccess", 'Installation success'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_tipterop", 'Prompt terminal operation'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_autocmpl", 'Automatic completion'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_noresetfs", 'The device is in factory state, please contact the administrator to clear'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_saleSt", 'Factory state'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_actst", 'Activation state'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_insfail", 'Installation failure'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_checksignfail", 'Check failure'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_asc", 'Ascending'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_desc", 'Descending'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_utasc", 'Update time in ascending order'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_utdesc", 'Update time descending'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_srchcontent", 'Search content'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_account", 'accounts'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_opecontent", 'Operation content'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_opetime", 'Operation time'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_frzaccount", 'Ice knot account'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_operator", 'Operator'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_userip", 'User IP'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_deskwp", 'Wallpapers'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_channelmcdetail", 'Details of channel merchants'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_channellevel", 'Channel level'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_cermanage", 'Certificate management'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_lineimportcer", 'Line import certificate'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_devicemanage", 'device management'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_fileimportdevice", 'File importing device'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_lineimportdevice", 'Production line importing equipment'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_prodmodel", 'Product model'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_plimportcer", 'Production line import customer certificate'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_importslorder", 'Import the selected order'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_importslcustomer", 'Importing selected customers'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_customername", 'Customer name'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_orderno", 'Order number'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_orderfinishdate", 'Order completion date'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_customerno", 'Customer code'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_debuginfo", 'Develop information'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_adbstatus", 'ADB status'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_on1", 'On'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_off1", 'Off'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_devicemode", 'Device mode'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_normalmode", 'Normal'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_debugmode", 'Develop'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_signstatus", 'Sign activated'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_catchlog", 'Grab log'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_tobenimportdv", 'Soon to import equipment'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_lineimporttip", 'please set the type of equipment, manufacturer, model, address and other basic data'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_cannotwithsysapp", 'No system applications can be included'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_locktime", 'Locking time'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_risksetting", 'Wind control setting'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_lockinfo", 'Locking information'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_riskdetail", 'Details of early warning'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_lockcity", 'Lock the city'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_locklngandlat", 'Lock-in latitude and longitude'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_lockstate", 'Lock situation description'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_bindenclosure", 'Binding enclosure'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_unbindenclosure", 'Tie up a fence'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_sureunlock", 'Confirm unlocking'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_plsinputimgfile", 'Please upload the IMG format file'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_animatefile", 'Animated file'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_bglock", 'Backstage lock'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_request", 'Have applied'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_unrequest", 'Not applying for'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_lockdevice", 'Remotely lock'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_pusheddvlist", 'Uninstall application'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_appuninstall", 'Apps Uninstall'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_unlocked", 'Unlocked'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_unlockdevice", 'Unlocking equipment'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_misstokentip", 'Missing login information requires a re login authorization'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_pushnumcantfive", 'Maximum limit of install for one time is 5'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_selectedappshoupass", 'The selected application must be approved'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_adRefreshfreq", 'Advertising refresh frequency'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_uninsfail", 'Uninstall Failed'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_uninssc", 'Uninstall success'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_preversion", 'Basic version'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_rdneedmore", 'The radius of the fence should be greater than'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_addstfile", 'Add configuration file'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_filetag", 'File identification'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_filestss", 'Configuration description'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_uploadfilest", 'Upload configuration file'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_excludeapp", 'Exclusion application'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_reupload", 'Re - Upload'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_excludefsttip", 'Enter application package name to exclude this application. All applications that support the identification can use this configuration by default.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_limitxml", 'Limit XML file'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_configfile", 'configuration file'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_udversion", 'Updated version'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_udsamexml", 'Only update the same identity XML'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_udxmllowertip", 'The updated version is lower than the current version and will appear in the historical record, not displayed in the list.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_childacmg", 'Child account management'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_unldvwftip", 'The device is bound to the fence [{wl}]. Do you want to delete the binding at the same time?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_udmode", 'Update mode'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_append", 'Append'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_importapp", 'Import application'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_adddate", 'Create Time'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_addtask", 'Add tasks'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_addtesttask", 'Add task test'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_appdesc", 'Application description'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_srcdesc", 'Resource description'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_downapp", 'Download application'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_downfile", 'Download'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_addsrc", 'Add resources'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_importsrc", 'Import resources'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_srcname", 'Resource name'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_srcver", 'Resource version'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_downsrc", 'Download resources'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_number", 'number'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_softinfo", 'Software information'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_allstatus", 'All state'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_mstype14", 'Scavenging gun application push'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_mstype15", 'Scavenging gun resource file push'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_filedesc", 'File description'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_filetype", 'file type'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_subtype", 'Subtype'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_addfile", 'Add a file'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_stmgpsw", 'Management password configuration'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_mapsl", 'Map selection'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_bdmap", 'Baidu Maps'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_map", 'Map'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_right", 'Jurisdiction'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_addconfig", 'Add configuration'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_editconfig", 'Edit configuration'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_mgpsw", 'Admin password'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_dvconfiglist", 'Configuration device list'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_appconfigst", 'Configuration application state'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_applytime", 'Apply time'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_secrname", 'Key name'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_secrdesc", 'Key description'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_addsecrrule", 'Add key rules'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_editsecrrule", 'Edit key rule'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_secrdvlist", 'Key device list'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_secrupdatest", 'Key update state'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_waitupdate", 'To be updated'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_addrandport", 'Address and port'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_filepath", 'File path'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_queryudfre", 'Query update frequency'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_lcupload", 'Local upload'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_hour", 'hour'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_addofcloud", 'Cloud add'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_bglist", 'Backstage list'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_cntype", 'Connection mode'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_codegunsrc", 'Scavenging gun resources'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_rtosgunsrc", 'RTOS resources'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_rots_1", "app"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_rots_2", "source"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_rots_3", "system"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_rots_4", "Security chip firmware version"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_rots_5", "Master version"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_partpkg", 'Incremental packet'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_codegunapp", 'Application of scavenger gun'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_starttime", 'start time'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_oilmcsrc", 'Tanker resources'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_downtpl", 'Download template'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_plsstype", 'Please select subtypes'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_allstyps", 'All subtypes'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_ftooltip", 'Animated /LOGO file online making tool'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_appendpush", 'Additional push'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_ipitonlylgchar", 'Entries can only be legal characters such as English digits and underscores.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_enable", 'Enable'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_spfileis", 'File support format'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_cnsetting", 'connections setting up'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_newtask", 'New task'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_adddv", 'Add device'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_fileinsst", 'File installation configuration'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_insscautoop", 'Install successfully automatically open'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_pushsctipins", 'Push successful prompt installation'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_total", 'Total'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_wait", 'wait for'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_pushing", 'Pushing'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_pushsldev", 'Push the selected equipment'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_wite_update", "Wait for update"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_Update_successfully", "Update successful"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_Update_failure", "Update failed"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_repushdv", 'Re-push failed device'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_outputdv", 'Export equipment'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_udtime", 'Update time'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_surepsxdv", 'Confirm the push of {num} equipment'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "del_allData", "Do you want to delete all data?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_apppush", 'Application push'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_fmwpush", 'Firmware push'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_advpush", 'Advertising push'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_onampush", 'Launch animation push'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_offampush", 'Shutdown animation push'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_onoffampush", 'Switch machine animated push'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_onlgpush", 'Boot logo push'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_wppush", 'Wallpaper push'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_stfpush", 'Configuration file push'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_codemc", 'Scavenger'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_codemcsrc", 'Scavenger resources'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_sysud", 'System update'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_fmwud", 'Firmware Update'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_anmud", 'Animation update'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_qcgunsrcps", 'Scavenging gun resource push'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_iscltask", 'Determine the cancellation of the task'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_resrc", 'Resources'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_srcfileps", 'Resource file push'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_fmVerIillegal1", 'The version number is not legal. It must be carried with V and numbers, such as v1.0.0'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_helptip", 'Help reminding'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_newpsetnewver", 'New version of TMS push function entry revision'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_newptdetail", '	After the push function is revamped, users need to push to open the push task page (task management → push task), click on the new task, enter the new task page, enter the task name and select the file to push to create a new push task.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_newptdetail1", '	The user can push the device in batches or single device push. The user can add the device many times in the task details. We suggest that the user push a small number of devices before the mass push, confirm the correctness, click on the add device in the task details and then push a large number of devices. Send.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_daterange", 'Date range'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_olinepday", 'Daily online quantity'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_onlineavgt", 'Average online time interval'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_devicewhe", 'Equipment distribution'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_statistic", 'Statistics'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_today", 'today'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_thisweek", 'This week'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_thismonth", 'This month'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_addblfile", 'Add blacklist file'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_blacklsname", 'Blacklist name'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_editblls", 'Edit blacklist'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_blsdesc", 'Blacklist description'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_blsdvlist", 'Blacklist device list'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_wldesc", 'Enclosure description'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_filectncr", 'The contents of the file are incorrect.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_khour", 'hour'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_kday", 'day'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_yesterday", 'yesterday'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_rc15d", 'The last 15 days'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_rc30d", 'The last 30 days'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_stinfo", 'status information'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_croln", 'Current online'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_crslp", 'Current dormancy'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_croff", 'Current offline'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_lstol", 'Last online time'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_lstsl", 'Last dormancy time'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_lstof", 'Last offline time'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_limitiplg", 'Restricted IP segment logon'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_illegal", 'Wrongful'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_limitiptip", 'Please enter the IP segment that needs to be restricted.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_unknow", 'Unknown'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_hisstatus", 'Historical state'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_allowiplg", 'Allow IP segment login'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_allowiptip", 'Please enter the allowed IP segment, and allow all IP access without input.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_active1", 'active'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_unuse", 'not enabled'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_addpsg", 'Add passage'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_psgname", 'Passage name'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_authstat", 'Authorization state'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_cbackad", 'token url'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_bsrqsadwl", 'White address of business request address'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_appwtls", 'App white list'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_addapppgkn", 'Add application package name'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_authopen", 'Authorization to open'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_authclose", 'Authorized closure'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_addaddr", 'Add the address'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_developer", 'developer'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_editpasg", 'Edit passage'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_usertype", 'customer type'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_generate", 'generate'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_gentip", 'After regenerating AppSecret, the original AppSecret will fail and will not be able to continue to access the open platform. Is it necessary to regenerate AppSecret?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_open1", 'open'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_hide", 'hide'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_subtask", 'Subtask'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_sltstype", 'Select task type'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_command", 'instruction'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_addsubts", 'Add subtasks'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_commtype", 'Instruction type'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_taskpros", 'Task schedule'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_cursubts", 'Current subtasks'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_commpush", 'Instruction push'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_dvrestart", 'Reboot of equipment'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_recvorgst", 'Restore factory settings'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_recvanimt", 'Restore animation'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_dvlock", 'Equipment lock machine'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_dvunlock", 'Equipment unlocking'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_inbdside", 'It s already on the border.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_subtsnum", 'Number of sub tasks'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_tscrtime", 'Task creation time'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_ing", 'Have in hand'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_core", 'kernel'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_filesys", 'file system'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_commd1fw", 'Communication module 1 firmware'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_commd2fw", 'Communication module 2 firmware'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_readcfw", 'Card reader firmware'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_pswkbfw", 'Password keyboard firmware'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_scanhfw", 'Scan head firmware'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_actpossp", 'Activate POS call'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_natpossp", 'Close POS calls'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_setcallf", 'Set up call function'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_clupappdt", 'Clear application data'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_isclupappdt", 'Determine Clearance of Application Data'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_impdistbt", 'Introducing Channel Businessmen'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_impmctip", 'To upload files, only support excel and no more than 10m'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_callfunc", 'Call function'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_protocal", 'prototal'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_prtsltip", 'When selecting HTTPS, you must ensure that the interface supports this protocol.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_rgsvpm", 'Authorization service parameters'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_rgsvip", 'Authorization Service IP'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_bgntpm", 'Background notification parameters'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_bgntip", 'Background notification IP'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_port", 'port'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_flexist", 'file already exist'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_delcer", 'Delete certificate'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_cerid", 'Certificate fingerprint'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_wallpaper", 'wallpaper'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_forceins", 'Mandatory installation'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_autorun", 'Launch after installation'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_cusins", 'Customized Installation'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_cusuins", 'Customized unloading'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_forcerun", 'Enforcement'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_pushtest", 'Push test'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_pltfblt", 'Platform Bulletin'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_addblt", 'Add announcement'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_blttt", 'Notice title'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_readnum", 'Reading times'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_bltct", 'Announcement content'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_pltudrd", 'Platform has been updated'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_udlog", 'Update log'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_addver", 'Add version'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_pubdate", 'Release date'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_updct", 'Update content'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_editblt", 'Edit notice'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_editver", 'Edit version'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_verupdate", 'Version update'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_clviewdt", 'Click here for details'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_viewmore", 'View more'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_comptime", 'Compile time'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_insafnorun", 'Non-automatic operation after installation'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_normalins", 'General installation'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_normalunins", 'General unloading'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "appp_tipoperate", 'Prompt operation'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_onlyprov", 'Select provinces only'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_filepush", 'File push'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_region", 'region'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_srcmechan", 'Input keyword search channel quotient'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_ckcode", 'Verification Code'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_cantuins", 'Uninstall'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_ippkgname", 'Input package'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_onlypicfm", 'Only upload image format files (JPG, PNG, GIF...)'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_fludlist", 'File Update List'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_param", 'parameter'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_catching", 'Grabbing'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_ulding", 'Uploading'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_ulyet", 'Upload completed'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_endcatch", 'End grab'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_iscatch", 'Make sure to start grabbing？'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_opterinfo", 'Export terminal information'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_bcopterinfo", 'Batch export information'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_cpttime", 'Interception time'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_eqcapture", 'Device screenshots'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_scapture", 'Screenshots'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_surestcap", 'Determine to take screenshots？'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_lokscrn", 'lock screen '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_ulkscrn", 'extract screen '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_appautrn", 'App auto starts '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_perms", 'Unit: milliseconds'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_wattime", 'Waiting time'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_lcswitch", 'Launcher switch'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_appadv", 'App advertisement'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_cardno", 'Card number'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_trdno", 'Serial number'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_batcno", 'Batch number'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_amout", 'Amount'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_mechno", 'Merchant number'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_trdtime", 'Transaction time'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_trddate", 'Transaction date'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_trdcore", 'Core stream'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_expno", 'Reference number'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_trdtype", 'Transaction type'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_rectime", 'Record time'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_fpaddrs", 'Face image address'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_propcut", 'Cut to scale'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_getcash", 'get cash'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_lctrans", 'intra bank transfer'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_obtrans", 'transfer to another bank'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_coretrans", 'core stream'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_tradeNo", 'transaction number'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_export", 'Export'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_ctrc", 'Magnetic stripe card reader'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_icrc", 'IC card reader'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_prtst", 'Printer status'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_pswkb", ' Password keyboard'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_idfrc", 'ID card reader'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_led", 'LED'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_beep", 'buzzer'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_codebar", 'barcode'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_lulog", 'View log'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_lust", 'View status'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_mdclst", 'module call statistics'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_fcclst", 'method call statistics'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_acauth", 'Activation code authorization'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_authcode", 'Activation code'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_authrange", 'Validity of procedure'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_delact", 'Do not activate'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_pswtip", 'The password must have more than 8 digits, including upper case letters, lower case letters, numbers and special symbols'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_mulfcau", 'Multi factor authentication'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_verifc", 'verification'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_opmfackip6dycode", 'Please open the MFA verifier and enter the 6-digit dynamic verification code'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_cantprvmcodectadm", 'If you cannot provide multi factor authentication verification code, please contact the administrator'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_lsstep", 'Previous step'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_nxstep", 'Next step'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_ckidt", 'Verify identity'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_istapp", 'Install application'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_bindmfa", 'Bind MFA'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_ipaclgpsw", 'Enter account login password'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_bindsfdv", 'Bind security device'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_psfwtsstepop", 'Please complete the binding operation as follows'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_sixnumb", '6 numbers'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_phdnalyappggidck", 'Please download and install the Aliyun APP/Google Authenticator APP on your phone'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_ipappstsagidck", 'iphone: Search for Aliyun APP/Google Authenticator APP in AppStore'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_adappmksagidck", 'Android : Search for Aliyun APP/Google Authenticator APP in the app market'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_afistclnxitbpagiinx", 'Click "Next" to the binding page after finishing installing the Aliyun APP/Google Authenticator APP. ( if installed, Click "Next" directly)'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_usalyagidckscqrc6code", 'Use the Aliyun APP/Google Authenticator APP to scan the following two-dimensional code to get a 6-digit verification code'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_sftkck", 'MFA verification'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_ip6codeubac", 'input the 6-digit verification code to unbind accoun'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_plipopenalyappoggidckip6dycd", 'Please open the Google Authenticator app in your phone and enter your 6-digit dynamic code'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_select_timelist", "Select the time range"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_batch_migration", "Batch Migration"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_expired_button", "Expired in the last 7 days"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_sure_migration", "Confirm the migration"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_Batch_import", "Batch import"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_Batch_push", "Batch export"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_input_sn", "Please enter serial number"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_serialnumber", "Device number"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_serialnumber_new", "New device number"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_termin_status", "Device update status"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_status_update", "To be updated"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_status_updated", "Have been updated"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_status_exist", "Key already exists"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_status_fail", "Fail"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_dyf", "Did you ever file 21"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_wtk", "Whether there is a key"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_keyType", "Key type"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_keyUpIndex", "Encryption key index"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_keyDlIndex", "Download Key index"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_Algorithm_mode", "Algorithm pattern"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_start_no", "TerminalNo start"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "app_end_no", "TerminalNo end"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_en, "auth_status_list", {
  status_1: "In the process of authentication",
  status_2: "Authentication failed",
  status_3: "Generate activation code",
  status_4: "The activation code has expired",
  status_5: "Activation successful",
  status_6: "Activation failed"
}), _en);

/* harmony default export */ __webpack_exports__["a"] = (en);

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _lin_global, _details, _korean;

var korean = (_korean = {
  app_uploadApp: '애플리케이션 업로드',
  app_No: '번호',
  app_terNo: '단말기번호',
  app_name: '이름',
  app_appName: '애플리케이션 이름',
  app_appType: '애플리케이션 유형',
  app_insType: '설치 유형',
  app_vStatus: '심사상태',
  app_ulTime: '업로드시간',
  app_appLoding: '애플리케이션 업로드중',
  app_newgVer: '최신 버전 넘버',
  app_operate: '동작',
  app_type: '유형',
  app_del: '삭제',
  app_pause: '스탑',
  app_continue: '계속',
  app_status: '상태',
  app_new: '새로 추가',
  app_yes: '네',
  app_no: '아니오',
  app_selectAll: '전부 선택0',
  app_save: '저장',
  app_process: '진도',
  app_push: '푸시',
  app_offShelf: '내리다',
  app_mulOffShelf: '전부 내리다',
  app_isOffShelf: '애플리케이션을 내리겠습니까?',
  app_isDelApp: '애플리케이션을 삭제하시겠습니까?',
  app_chooseOneMust: '적어도 하나의 애플리케이션을 선택해야 합니다',
  app_cantDelTask: '삭제 불가능한 task를 선택했습니다',
  app_oneRecordMust: '적어도 하나의 기록을 선택해야 합니다',
  app_phoneIllegal: '번화번호가 불법입니다',
  app_groupName: '분류명',
  app_sure: '확인',
  app_query: '조희',
  app_reset: '다시 설정',
  app_cancel: '취소',
  app_edit: '편집',
  app_add: '추가',
  app_verify: '심사',
  app_isPass: '통과 여부',
  app_pass: '통과',
  app_ban: '불통',
  app_noInput: '미기재',
  app_banReason: '거절원인',
  app_filter: '필터',
  app_prePushVerify: '심사송부대기',
  app_preVerify: '심사',
  app_verifyPass: '통과',
  app_verifyNotPass: '불통',
  app_success: '성공',
  app_submit: '제출',
  app_tip: '제시',
  app_online: '온라인',
  app_offline: '오프라인',
  app_fileOver: '파일 용량 초과',
  app_onlyApk: 'apk파일만 업로드 가능',
  app_onlyApk_2: 'apk/hap파일만 업로드 가능',
  app_tipViewTask: '푸시 성공했습니다.태스크매니지먼트에서 푸시 진도를 확인하세요',
  app_tipMkDel: '애플리케이션 삭제하면 애플리케이션 스토어중 애플리케이션도 같이 삭제됩니다.삭제하시겠습니까?',
  app_tipAppEdit: '삭제 후 복원 불가능합니다.삭제하시겠습니까?',
  app_tipVerify: '심사를 제출하시겠습니까?',
  app_rqsError: '요청오류',
  app_not_auth: 'TMS 비활성화',
  app_mulAdd: '선택추가',
  app_select: '선택하세요',
  app_input: '내용을 입력하세요',
  app_inputCp: '완전하게 입력하세요',
  app_inputName: '이름을 입력하세요',
  app_inputContact: '연락인을 입력하세요',
  app_inputTruePhone: '정확한 번호를 입력하세요',
  app_inputAddr: '주소를 입력하세요',
  app_inputVer: '버전을 입력하세요',
  app_inputVerTag: '버전마커를 입력하세요',
  app_inputID: '신원을 입력하십시오',
  app_inputPkg: '패키지명을 입력하세요',
  app_noVerTag: '버전마커가 없습니다',
  app_inputIntrol: '설명을 입력하세요',
  app_selectType: '애플리케이션 유형을 선택해주세요',
  app_ulApp: '애플리케이션을 업로드하세요',
  app_ulIcon: '작은 아이콘을 업로드하세요',
  app_ulLarIcon: '큰 아이콘을 업로드하세요',
  app_ulScreenShot: '캡쳐이미지를 업로드하세요',
  app_smVerify: '심사 제출',
  app_baseInfo: '기본정보',
  app_version: '버전번호',
  app_checkupsp: '검사 업데이트 주기',
  app_autoUpload: '자동입력',
  app_verTag: '버전 마크',
  app_ID: '신분증',
  app_fminfo: '펌웨어 정보',
  app_terstatus: '터미널 상태',
  app_sysinfo: '시스템 정보',
  app_package: '애플리케이션 패키지명',
  app_introl: '애플리케이션 소개',
  app_geo: '지리적 위치',
  app_ustart: '시작하지 않음',
  app_outofdate: '이미 기한이 지나서',
  app_udState: '업데이트 설명',
  app_rcmsg: '수신 메시지',
  app_icon: '애플리케이션 작은 아이콘',
  app_larIcon: '애플리케이션 큰 아이콘',
  app_screenShot: '애플리케이션 캡쳐',
  app_appVer: '애플리케이션 버전',
  app_createTime: '생성시간',
  app_hbsp: '심장 박동 주기',
  app_close: '끄기',
  app_ulNew: '새 버전 업로드',
  app_selectApp: '애플리케이션 선택',
  app_testInstall: '설치 테스트',
  app_ulAppState: '파일을 여기로 끌어와서 업로드 버튼을 누른다.apk파일 업로드만 가능하다',
  app_clickUpdate: '업로드 클릭',
  app_udType: '업로드 방식',
  app_allUpdate: '토탈 업데이트',
  app_iconState: '144x144,100k이하 사이즈',
  app_larIconState: '512x512,200k이하 사이즈',
  app_autoInstall: '자동설치',
  app_addApp: '애플리케이션 추가',
  app_classIntrol: '분류 추천',
  app_homeIntrol: '메인 페이지 추천',
  app_isIntroClass: '분류에 추천 여부',
  app_isIntroHome: '메인 페이지에 추천 여부',
  app_isUnbindApp: '애플리케이션 제거하시겠습니까?',
  app_isOffApp: '애플리케이션을 내리시겠습니까?',
  app_isDelData: '데이터를 삭제하시겠습니까?',
  app_inputAName: '이름을 입력해주세요',
  app_oneDeviceMust: '적어도 하나의 무준을 파악해야 합니다',
  app_fileSize: '파일 사이즈',
  app_addPush: '푸시 추가',
  app_viewPushHis: '푸시기록조회',
  app_pushTimes: '횟수조회',
  app_hisVer: '히스토리 버전',
  app_pushHistory: '히스토리 푸시',
  app_pushInstall: '설정 푸시',
  app_animatePush: '애니메이션 푸시',
  app_animateMake: '애니메이션 맞춤제작',
  app_pushDevice: '장치를 푸시하였습니다',
  app_deviceNum: '장치수량',
  app_deviceName: '장치명',
  app_deviceNo: '장치번호',
  app_pushTime: '푸시시간',
  app_distributor: '유통업자',
  app_dParent: '상급 유통업자',
  app_unbind: '제거',
  app_mulUnbind: '선택제거',
  app_mulPush: '선택푸시',
  app_searchTerminal: '단말번호를 입력하고 검색하세요',
  app_terName: '단말 이름',
  app_taskName: '태스크명',
  app_taskDetail: '태스크내용',
  app_deviceTotal: '장치 총수량',
  app_downloading: '다운로드중',
  app_downFail: '다운로드 실패',
  app_update: '업데이트',
  app_md5Fail: 'MD5인증 실패',
  app_theNewgVer: '현재 버전은 최신버전입니다',
  app_fileFmIllegal: '파일포멧이 오류입니다',
  app_updateFail: '업데이트 실패',
  app_usrCancelUpdate: '유저 취소 업데이트',
  app_pushFail: '푸시 실패',
  app_downFinish: '다운로드 완료',
  app_updateSuccess: '업데이트 완료',
  app_fail: '실패',
  app_addres: '주소',
  app_mulDel: '대량 삭제',
  app_contact: '연락인',
  app_contactPhone: '연락처',
  app_typeName: '유형 이름',
  app_customs: '맞춤제작',
  app_clear: '클리어',
  app_customsTime: '맞춤제작시간',
  app_launchAnimate: '부팅 애니메이션',
  app_pushsctipinstall: '보내다 성공 터미널 팁 응용 다운로드',
  app_onLogo: '부팅시 LOGO',
  app_animateName: '애니메이션 이름',
  app_playPlace: '플레이 위치',
  app_aSrcFile: '애니메이션 소스파일',
  app_asfState: '애니메이션 분할화면 파일명은 part0.zip이여야 한다',
  app_downExp: '다운로드 예시',
  app_ologoState: '애니메이션 플레이 정지 후 화면',
  app_picSize: '이미지 사이즈',
  app_picSizeState: '너비*높이를 입력하다',
  app_frame: '프레임',
  app_frameState: '초당 플레이하는 애니메이션 수량',
  app_aCycleTime: '애니메이션 반복 횟수',
  app_cyclePlay: '반복 플레이',
  app_playOnce: '한번 플레이',
  app_fileNameOnly: '파일명은',
  app_inputNumber: '숫자 입력해주세요',
  app_picUlError: '이미지 업로드 오류',
  app_inputAnimateName: '애니메이션 이름 입력해주세요',
  app_selectAnimateType: '애니메이션 유형을 선택해주세요',
  app_selectPlayPlace: '플레이 위치 선택해주세요',
  app_uploadAnimateFile: '애니메이션 파일 업로드해주세요',
  app_uploadOnPic: '부팅 이미지 업로드해주세요',
  app_sureDelTip: '삭제하시겠습니까?삭제 후 복원이 안됩니다',
  app_uploadPic: '이미지 업로드해주세요',
  app_launchUI: '부팅 인터페이스',
  app_amechine: '대',
  app_chooseCycleType: '반복 방식을 선택해주세요',
  app_formatNotTrueLike: '포멧 오류，예시',
  app_on: '컴퓨터 켜기',
  app_off: '컴퓨터 끄기',
  app_onOff: '컴퓨터 켜기 끄기',
  app_firm: '제조업체 이름',

  add_srcFwByName: '이름으로 펌웨어 찾기',
  app_downNum: '다운로드 횟수',
  app_pushed: '기 발표',
  app_notPass: '미통과',
  app_sysType: '시스템 유형',
  app_sys: '시스템',
  app_sysUdPack: '시스템 업데이트 패키지',
  app_chooseFile: '파일 선택',
  app_signCer: '서명인증서',
  app_isUseDisCerAutoSign: '유통업자 인증서로 자동 사인 여부',
  app_useDis: '지정 유통업자',
  app_allDisUsed: '모든 유통업자 통용',
  app_pushInstallTest: '푸시 설정 테스트',
  app_firmware: '펌웨어명',
  app_pushType: '푸시 유형',
  app_dv: '장치',

  app_fwType: '펌웨어 유형',
  app_ulNormalSt: '파일을 여기에 끌어오거나 업로드 클릭하기',
  app_selectChannel: '유통업자 선택해주세요',
  app_isSubmitToCheck: '심사 제출 여부',
  app_pleaseInputNo: '단말번호 입력',

  app_cnAndActive: '온라인 활성화',
  app_clearCer: '인증서 클리어',
  app_ofCheck: '서명인증 설정 여부',
  app_normal: '정상',
  app_netStatus: '인터넷 상태',
  app_active: '활성',
  app_selfDestroy: '자폭',
  app_mulActive: '대량 활성',
  app_selected: '기선택',
  app_cerCheckOf: '서명 인증 스위치',
  app_openCerCheck: '서명인증 켜기',
  app_closeCerCheck: '서명인증 끄기',
  app_reOpen: '다시 켜기',
  app_reClose: '다시 끄기',
  app_open: '켜기',
  app_usrManage: '유저관리',
  app_stManage: '사양관리',
  app_roleManage: '캐릭터 관리',

  app_cerMgType: '인증서 관리 유형',
  app_cerMgSelf: '인증서 자체관리',
  app_cerMgOther: '인증서 대리관리',
  app_cerMgCustomer: '맞춤형',
  app_operateHis: '히스토리 동작',
  app_operateType: '동작 유형',
  app_time: '시간',
  app_isActive: '확성하시겠습니까?',

  app_downCer: '인증서 다운로드',

  app_isOperate: '조작하시겠습니까?',

  app_ulSuccess: '업로드 완료',

  app_setting: '설정',

  app_clickPicToUlPic: '이미지 위치를 클릭하여 업로드할 이미지를 선택하세요',
  app_within: '이하의',
  app_pgsFormat: 'png、gif、svg포멧',
  app_sgUseAndAdUse: 'svg 포멧 사용을 제안합니다.이미지 색갈은 흰색을 제안합니다',
  app_sureChange: '수정 확인',
  app_logoLvTip: '저장하지 않은 내용이 있습니다.계속 끄겠습니까?',
  app_dfIcon: '기본아이콘',

  app_useBigSize: '큰 사이즈 사용',
  app_useBigSizeTip: 'logo가 작아보일 때 이 항목을 선택하여 수정하세요',

  app_or: '또는',
  app_format: '포멧',
  app_pic: '이미지',
  app_s: '의',
  app_plsUpl: '업로드하세요',

  app_upload: '업로드',
  app_cerType: '인증서 유형',

  app_editProfile: '자료편집',

  app_cerFile: '인증서 파일',
  app_plsUlPbCer: '고객 인증서를 업로드하십시오',
  app_appNoCerTip: '현재 유통업체는 인증서 자체관리 유통업체입니다.공개키 파일을 업로드하여 서명인증을 하세요',
  app_appNeedCerTip: '현재 유통업테는 인증서가 없습니다.플렛폼 관리자와 연락하여 생성하세요',
  app_createCer: '인증서 생성',
  app_uploadCer: '인증서 업로드',

  app_fileImport: '파일 들여오기',
  app_mdFile: '양식 파일',
  app_down: '다운로드',

  app_roleAllot: '캐릭터 분할',
  app_roleName: '캐릭터명',
  app_downTplFile: '양식파일 다운로드',

  app_verUdCt: '버전 업데이트 내용',
  app_animation: '애니메이션',
  app_per: '매',
  app_minute: '분',
  app_autoRefresh: '자동 리프레시',
  app_level: '등급'
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_firm', '제조업체'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_model', '모델명'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_adType', '광고유형'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_license', '라이센스코드'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_maintain', '유지'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_manage', '관리'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'lin_btn', {
  cancel: "취소",
  add: "추가",
  install: '설치',
  batch_install: '대량 설치',
  tips: '알림',
  confirm: '확인',
  unbind: '언바인딩',
  unbindAll: '대령 바인딩',
  check: '조회',
  reset: '초기화',
  submit: '제출',
  restart: '리셋',
  off: '종료',
  send: '푸시',
  batch_delete: '대량 삭제',
  delete: '삭제',
  lock: '잠금',
  lockOta: '잠금OTA',
  add_zeng: '추가',
  edit: '편집',
  save: '저장',
  bind: '바인딩',

  bindAll: '대량 바인딩',
  xiezai: '삭제',
  unlock: '장금 해제',
  change: '수정'

}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'lin_global', (_lin_global = {
  cs_config: '매개 변수 설정',
  task_tips: '설치 완료, 작업 관리자에서 푸시 진도를 확인해주세요',
  task_tips2: '푸시 성공, 작업 관리자에서 푸시 진도를 확인해주세요',
  ope: '동작',
  pselect: '선택해주세요',
  label_no: '장치 번호',
  loading: '데이터 로딩 중',
  label_name: '장치명',
  all_mechanism: '모든 유통업자',
  place_areaid: '유통업자를 선택해주세요',
  time: '시간',
  version: '버전',
  name: '이름',
  remark: '비고',
  edit: '편집',
  label_model: '장치 모델',
  label_type: '장치 유형',
  device_type_1: "스마트 포스",
  device_type_2: "기타 설비",
  label_manufid: '장치 제조업체',
  label_areaid: '유통 업자',
  label_areaid_name: '유통 업자명',
  label_address: '장치 주소',
  ter_status: '장치 상태',
  dest_status: '자폭 상태',
  net_status: '네트워크 연결 상태',
  run_status: '운행 상태',
  online: '온라인',
  offline: '오프라인',
  new_add: '새로 추가',
  normal: '정상',
  marn: '조기 경보',
  fault: '오류',
  success_tips: '동작 완료',
  concel_tips: '최소 완료',
  zlxfs_tips: '명령 전달 성공',
  sb_tips: '동작 실패, 단말 오프라인 상태',
  czsb: '동작 살패',
  zl_error: '명령 전달 오류',
  all_status: '모든 상태',
  delete_success: '삭제 완료',
  look_detail: '상세내용 조회',
  ter_num: '장치 수량',
  ota_bao: 'OTA 패키지',
  ple_sel_ota: 'OTA 패키지를 선택해주세요',
  unlock_success: '잠금 해제 성공',
  risk_name: '사양명',
  risk_type: '조기경보 유형',
  risk_radius: '펜스 반경(KM)',
  risk_city: '성시를 설정하다.',
  risk_desc: '설명',
  risk_warn_info: '통제 위험 조기경보 정보',
  warn_event: '조기경보 사건',
  city: '도시',
  jwd: '경위도',
  distance: '설정거리 초과(KM)',
  ccwl: '펜스 초과',
  sbyj: '장치 조기경보',
  done: '처리 완료',
  undone: '미처리',
  roles_tips: '캐릭터를 선택해주세요',
  roles_place: '사용자명으로 조회',
  userName: '사용자명',
  nickName: '닉네임',
  phoneNum: '휴대폰',
  roleName: '캐릭터',
  jh: '활성화',
  dj: '봉쇄',
  phoneNum2: '휴대폰 번호',
  resetPass: '비밀번호 초기화',
  revisePass: '수정 비밀번호',
  oldPass: '기존 비밀번호',
  newPass: '새비밀번호',
  comfirmPass: '비밀번호 확인',
  plePassTips: '비밀번호 입력',
  plePassTipsAgain: '비밀번호 재입력',
  pwdDisfault: '비밀번호가 일치하지 않습니다.',
  unfitPhone: '사용할 수 없는 휴대폰번호 입니다',
  nickNameTips: '닉네임 공백불가',
  userNameTips: '아이디 공백불가',
  phoneNumTips: '휴대폰번호 공백불가',
  roleidTips: '캐릭터 공백불가',
  mechanismIdTips: '유통업자 공백불가',
  userStatusTips: '사용자 상태를 설정하세요',
  editPage: '페이지 편집',
  addPage: '페이지 추가',
  status: '상태',
  refs: '데이터를 보완해 주세요',
  user: '계정',
  logStartTime: '로그 시작시간',
  logEndTime: '로그 중지시간',
  download: '다운로드',
  ddsc: '업로드 대기',
  scz: '업로드중',
  scsb: '업로드 실패',
  sccg: '업로드 완료',
  rz_tips: '로그 획득완료，로그관리에서 다운로드 진도를 검색하세요',
  hqrz: '로그획득',
  logoTitle: 'TMS 단말 관리 시스템',
  hello: '안녕하세요',
  wdzl: '내 데이터',
  tcxt: '시스템 로그아웃',
  yhdl: '사용자 로그인',
  zh: '계정',
  password: '비밀번호',
  jzmm: '비밀번호 기억하기',
  login: '로그인',
  bah: '심 천시 증권 통 전자 주식 유한 공사, 1993 - 2020 저작권 소유 광 둥 ICP 준비 12035887 호',
  qsrzh: '비밀번호 입력',
  qsrmm: '비밀번호 입력',
  error: '에러',
  wlzt: '네트워크 환경상태',
  ckxq: '상세내용  보기',
  wlmc: '펜스이름',
  wllx: '펜스유형',
  bdsb: '장치 바인딩',
  tjbd: '바인딩 추가',
  bjwl: '펜스 편집',
  wxzyjlx: '조기경보유형 선택',
  cityName: '도시이름',
  sfjxpljb: '선택 바인딩 해제 진행 여부',
  qxzyjbdzd: '바인딩 할 단말 선택',
  jbcg: '바인딩 해제 완료',
  sfjbczd: '해당 단말 바인딩 해제여부',
  sfjxplbd: '선택 바인딩 진행 여부',
  qxzybddzd: '바인딩 할 단말 선택',
  bdcg: '바인딩 완료',
  sfbdczd: '해당 단말 바인딩 여부',
  xzwl: '신규 펜스 만들기',
  qdxysccwl: '해당 펜스 삭제여부 확인',
  tsazcs: '설치테스트 푸시',
  shzt: '심사상태',
  pass: "통과",
  notPass: "불통",
  waitOne: "제출 대기",
  waitTwo: "심사 대기",
  shyy: '심사원인',
  zdtslb: '단말푸시리스트',
  xztghbtg: '통과 혹은 불통 선택',
  qrtj: '제출 확인',
  shcg: "심사 성공",
  syqdsty: '모든 유통업자 일반',
  notBlankName: "명칭 공백 불가",
  notBlankVer: '버전번호 공백 불가',
  qxzlx: '유형 선택',
  qxzscwj: '업로드 파일 선택',
  zdqds: '지정유통업자',
  sfsyzdqm: '유통업자인증서로 자동서명 여부',
  qmzst: '서명인증서',
  azbdz: 'Install pack주소',
  qscapkwj: 'apk파일을 업로드 하세요, 50M초과하지 않기',
  jwjtdcc: '파일을 여기에 끌어오기, 혹은',
  djsc: '클릭하여 업로드',
  xgscwj: '업로드 파일 수정',
  otaName: '명칭',
  xtlx: '시스템유형',
  syatemR: '시스템ROM',
  sysjota: '시스템업데이트패키지OTA'
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'waitOne', "제출 대기"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'waitTwo', "심사 대기"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'verifyPass', '통과'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'verifyNotPass', '불통'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'confirmDelete', "삭제 확인?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'tjshcg', '심사 제출 완료'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'qdtjsh', '심사 제출 확인'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'allType', '모든 유형'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'smVerify', '심사 제출'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'downNumber', '다운로드 횟수'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'tgmccz', '명칭으로 찾기'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'upload', '업로드'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'xzqddhwj', '부팅 애니메이션파일 선택'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'qxzkjlogo', '시작LOGO선택'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'tpxzds', '이미지 최적화 사이즈 300x300, 부피는 2m 이하 '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'zmlaun', '개인설정 바탕화면launcher 선택'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'xtjcb', '시스템 기본패키지 선택'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'null', '무'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'shebei', '장비'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'tslxxx', '푸시유형'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'xzbbbbb', '시스템ROM/OTA패키지 선택'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'uploadTime', "업로드시간"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'verTips', '이 버전의 버전된 패키지 기반，버전번호 v 또는 version 문자, 순수 문자，… 과 같다2.2.4'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'verTips1', '버전 번호, 순수 문자 번호, 숫자:2.2.4'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'bbhgsbd', '버전번호 형식 불정확'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'lkymtips', '파일 업로드 중, 현재 페이지를 떠나기 여부확인'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'znscziptips', 'zip파일만 업로드 가능'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'qsczipwj', 'zip파일 업로드 해주세요'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'danweikm', '단위KM'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'weilanshuoming', '설명：장치 마지막 심장박동수의 경위도를 펜스센터로 함'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'pleaseUpload', '업로드 해주세요'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'zdqmTips', '유통업자 자동서명 바인딩여부'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'zhidingqdsxx', '지정 유통업자 정보'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'selectWenjian', '파일 선택'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'qrjxmm', '이 명령을 실행 하시겠습니까: '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'cicaozuo', '동작?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'shebeiedit', '장치 편집'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'yxpztitle', '이메일 사양'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'yjyouxiang', '경보 이메일'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'chongzhi', '다시 설정'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'ljchangjian', '지금 만들기'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'ympeizhi', '도메인사양'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'fwqdizhi', '서버주소'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'fwqdztips', '주소에 문자 부호"http://" 불필요, 도메인주소도 가능하고 IP주소도 가능, 예를 들면：www.baidu.com 혹은 127.0.0.1'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'fwqduankou', '서버포트'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'duankoutips', '포트번호에":"추가 불가, 숫사 입력가능 예를 들면：8080'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'tuisongpeizhi', '푸시사양'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'tuisongjl', '푸시기록'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'tuisonglx', '푸시유형'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'chenggong', '성공'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'shibai', "실패"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'tuisongtime', '푸시 시간'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'chongtui', '다시 푸시'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'shebeibei', '장치'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'fwqdzbnwk', '서버주소 공백 불가'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'fwqdkhbnwk', '서버포트번호 공백 불가'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'wdct', '다시 푸시 확인'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'tuisongtips', '아래 도메인사양 푸시여부 확인, 푸시 성공후 다시 시작 활성화'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'china', '중문'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'english', '영문'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'cjzs', '인증서 만들기'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'createTime', '만든 시간'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'certificateName', '인증서명'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'xiafa', '전달'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'dachuzhengshu', '인증서도출'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'guojia', '국가'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'shengfen', '성'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'gongsi', '회사'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'youxiang', '이메일'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'youxiaoqi', '유효기간'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'certTypeLabel', '인증서유형'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'certForManufacturer', '제조업체인증서'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'certForCustomer', '고객인증서'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'danweitian', '단위：일'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'xinjian', '새로 만들기'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'notNull', '공백 불가'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'bitian', '필수 입력사항'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'guojiatips', '국가약자，예를 들면 CN'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'shenfentips', '성 영문／병음，예를 들면 GuangDong'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'cityTips', '도시 영문／병음，예를 들면 GuangZhou'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'gongsiTips', '회사 영문／병음，예를 들면 SZZT'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'emailTips', '이메일 주소 입력'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'youxiaoqiTips', '인증서 유효기간 입력, 예를 들면 365'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'xuantian', '선택 입력사항'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'srgsbzq', '입력형식 정확하지 않음'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'cszss', '제조업체인증서'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'khzss', '고개인증서'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'sccszss', '제조업체인증서업로드'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'zhengshu', '인증서'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'qudaoshangxinxi', '유통업자정보'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'quorter', '유통업자 선택 or 장치번호 입력'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'xiafalishi', '전달히스토리'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'resXiafa', '다시전달'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'chongxintuisong', '다시푸시'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'tuisongleixing', '푸시유형'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'dachusiyao', '개인키도출'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'shuaxin', '새로 고침 리스트'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'passWordTips', '비밀번호 공백 불가'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'daochugongyao', '인증서 내보내기'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'zhengshuType', '유통업자인증서유형'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'ziguan', '자체관리'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'daiguan', '대리관리'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, 'app_ispushalldv', '혹시 보내다 모든 장치'), _lin_global)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'terminal', {

  add: {
    place_no: "장치번호 입력",
    place_name: '장치명 입력',
    place_model: '장치모델 선택',
    place_type: '장치유형 선택',
    place_manufid: '제조업체 선택',
    place_address: '장치주소 입력',
    popover_no: '장치번호는 50자리 이하인 영어, 숫자와 밑줄로 구성!',
    popover_name: '장치명은 50자리 이하인 한자, 영어, 숫자와 밑줄로 구성!',

    rules_no_1: '장치번호는 공백 불가',
    rules_no_2: '장치번호 길이는 최대 20자리를 초과해서는 안된다',
    rules_no_3: '장치번호는 영어, 숫자와 밑줄로 구성',
    rules_no_4: '해당 장치번호는 이미 사용중이다！',
    rules_name_1: '장치명은 공백 불가',
    rules_name_2: '장치명 길이는 최대 30자리를 초과해서는 안된다',
    rules_name_3: '장치명은 한자, 영어, 숫자와 밑줄로 구성',

    success: '추가완료',
    change_success: '수정완료'

  },
  appBind: {
    label_name: '어플명',
    label_version: '버전번호',
    label_size: '어플 크기',
    place_name: '어플명을 입력하여 검색',
    empty_tips: '바인딩 할 어플을 선택!',
    install_tips: '해당 어플 설치 여부 확인?',
    five_tips: '한번에 바인딩 가능한 어플 수량은 최대 다섯개이다'

  },
  appList: {
    label_name: '어플명',
    label_type: '어플유형',
    label_version: '버전번호',
    label_time: '바인딩시간',
    format_status1: '일반어플',
    format_status2: '시스템어플',
    tips1: '해당 어플 제거여부 확인',
    tips2: '바인딩 해제 완료'

  },
  appLog: {
    start_time: '시작시간',
    end_time: '종료시간',
    log_type: '일지유형',
    log_content: '일지내용',

    num: '장치수량',
    tower: '대'

  },
  details: (_details = {
    regain: '공장초기화복구',
    run_log: '운행일지',
    risk_info: '리스크정보',
    app_list: '어플리스트',
    app_install: '어플설치',
    send_animate: '푸시애니메이션',
    reset_animate: '복구애니메이션',
    base_info: '기본정보',
    system_info: '시스템정보',
    launcher: 'launcher버전',
    system_version: '시스템버전',
    system_spversion: '보안 칩 버전',
    ota_version: 'OTA버전',
    hard_version: '펌웨어버전',
    last_time: '마지막 업데이트시간',
    net_type: '네트워크유형',
    online_time: '온라인시간',
    hard_info: '하드웨어정보',
    Electric_quantity: "배터리",
    network: "네트워크",
    cpu: 'CPU정보',
    mem: '메모리정보',
    cpuUsed: 'CPU사용률',
    memUsed: '메모리 사용률',
    hydh: '애니메이션 복구',
    tips: '애내메이션 복구 유형 선택',
    kjdh: '시작 애니메이션',
    gjdh: '시스템 종료 애니메이션',
    kjlogo: '시작LOGO',
    alldhlogo: '모두(애니메이션과LOGO)',
    zbhy: '일시 복구 안함',
    mshy: '즉시 복구',
    tsdh_title: '푸시 애니메이션',
    animate_name: '애니메이션 이름',
    animatType: '유형',
    position: '플레이 위치',
    createTime: '시간확정',
    animate: '애니메이션'
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, 'kjlogo', '시작LOGO'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, 'kj', '시작'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, 'gj', '끄기'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, 'kgj', '시작하고 끄기'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, 'comfirm_send', '푸시 애니메이션을 확정하십니까?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, 'comfirm_hy', '해당 애니메이션을 복구하시겠습니까?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, 'hy_success', '복구완료'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, 'hy_type', '애니메이션 복구 유형을 선택해 주십시오'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, 'open_abd', 'ADB열기'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, 'close_abd', 'ADB끄기'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, 'if_ope', '해당 동작을 진행하시겠습니까'), _details),
  list: {
    add_btn: '장치 추가',
    import_btn: '장치도입',
    ztgxsj: '상태 업데이트 시간',
    import_title: '장치 정보 들여오기',
    xqwj: '파일선택',
    qrdr: '들여오기 확인',
    import_muban: '들여오기 모듈 다운로드',
    notify_title: '들여오기 결과 알림',
    delete_tips: '이 동작은 해당장치를 영구적으로 삭제합니다. 계속하시겠습니까',
    deletes_tips: '이 동작은 해당장치를 영구적으로 삭제합니다. 계속하시겠습니까?',
    empty_tips: '삭제할 장치를 선택하세요',

    excel_tips: 'Excel파일만 업로드 가능，10M를 초과해서는 않된다'

  },
  OtaList: {
    lock_num: '잠금한 장치의 수량',
    lock_tips: '이 OTA를 잠금해제 하시겠습니까 ?'

  },
  terRisk: {
    fkpz: '리스크 매니지먼트 사양'
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'account', {
  delete_tips: '이 사용자를 삭제'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'mao_global', {
  btn: {
    sort: "정렬",
    e: "동작",
    cancel: "취소",
    add: "추가",
    edit: "편집",
    submit: "제출",
    update: "수정",
    delete: "삭제",
    ok: "확인",
    selectAll: "전체석택",
    unSelectAll: "전체선택 취소",
    reset: "초기화",
    createNow: "즉시생성",
    confirmUpdate: "수정확인"
  },
  tip: {
    text: "알림",
    confirmDelete: "삭제확인",
    examine: "심사",
    pleaseSelect: "선택",
    pleaseInput: "입력",
    search: "검색",
    notBlank: "공백불가",
    success: "성공",
    fail: "실패",
    notPassExamine: "심사미통과",
    groundsForRefusal: "거절 이유 입력",
    notReset: "삭제후 복구불가"
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'menu', {
  home: "처음 페이지",
  terManage: "장치관리",
  terManageSub: {
    myTer: "내 장치",
    breakup: "단말 백업",
    lockOTA: "단말잠금",
    map: "단말지도",
    log: "로그관리",
    addTer: "단말추가",
    detailTer: "단말 디테일",
    riskInfo: "리스크 매니지먼트 정보",
    runLog: '동작 로그',
    appList: '애플리케이션 리스트',
    appInstall: '애플리케이션 설치',
    otaLock: 'OTA잠금'

  },
  advertManage: "광고관리",
  advertManageSub: {
    list: "광고리스트",
    examine: "광고심사",
    examineDetail: "심사 디테일",
    edit: "광고편집",
    detail: "광고 디테일",
    vlist: "동영상 광고를 목록",
    vverify: "동영상 광고를 심사",
    addVideo: "비디오 광고 추가",
    dfVList: "기본 비디오 목록",
    addDfVideo: "기본 동영상 추가"
  },
  appManage: "애플리케이션 관리",
  appManageSub: {
    list: "애플리케이션 리스트",
    market: "앱스토어",
    custom: "내 옵션에 추가",
    viewApp: "애플리케이션 찾아보기",
    customPush: "옵션푸시",
    appPush: "애플리케이션 푸시",
    appBind: "애플리케이션과 단말 바인드",
    examine: "애플리케이션 심사",
    verifyApp: "애플리케이션 심사",
    appEdit: '애플리케이션 편집',
    appDetail: '애플리케이션 디테일',
    uploadNew: '새로운 버전 업로드',
    uploadApp: '애플리케이션 업로드'
  },
  taskManage: "태스크 관리",
  taskManageSub: {
    list: "태스크 관리",
    detail: "태스크 디테일",
    listHis: "완료된 작업",
    detailHis: "완료된 작업 정보"
  },
  dataManage: "데이터 관리",
  dataManageSub: {
    channel: "유통업자 관리",
    factory: "제조업체 관리",
    terClassify: "장치유형 관리",
    terNum: "장치모델 관리",
    advertClassify: "광고유형 관리",
    appClassify: "애플리케이션 유형 관리",
    newChannel: "유통업자 추가",
    editChannel: "유통업자 편집",
    newFirm: "제조업체 추가",
    editFirm: "제조업체 편집"
  },
  railManage: "리스크 매니지먼트 관리",
  railManageSub: {
    penSetting: "펜스 설정",
    warnSetting: "예고 메시지",
    riskDetail: "펜스 디테일"
  },

  safeManage: "안전관리",
  safeManageSub: {
    certificate: "증서 관리",
    certNew: "증서 생성",
    remote: "원격수권",
    certUpload: "제조업체 증서 업로드",
    certDetail: "증서 디테일",
    cerUpload: "증서 업로드",
    myCert: '내 증서'
  },

  sysManage: "시스템 관리",
  sysManageSub: {
    romul: 'OTA 업로드',
    romed: 'OTA 편집',
    romOTA: "OTA관리",
    examine: "OTA심사",
    push: "OTA푸시",
    order: "시스템 맞춤제작",
    animation: "애니메이션 맞춤제작",
    animateCustom: "애니메이션 맞춤제작",
    animatePush: "애니메이션 푸시",
    pushHistory: "푸시 히스토리",
    firmwareManage: '펌웨어 관리',
    firmwareUpload: '펌웨어 업로드',
    firmwareEdit: '펌웨어 편집',
    firmwareCheck: '펌웨어 심사',
    firmwareCheckDt: '펌웨어 디테일',
    firmwarePush: '펌웨어 쿠시',
    firmwarePushDevice: '펌웨어 보내다 장치',
    launchManage: 'launcher 관리',
    launchCheck: 'launcher 심사',
    verifyLaunch: '심사 launcher',
    addLaunch: '추가 launcher',
    launchDetail: 'launcher 정보',
    launchEdit: 'launcher 편집',
    launchNewVer: 'launcher 업로드 신판',
    launchPush: 'Launcher 보내다',
    launchPushTer: 'Launcher 보내다 터미널'
  },
  setManage: "사양관리",
  setManageSub: {
    role: "캐릭터 관리",
    system: "시스템 사양",
    menu: "메뉴리스트",
    addRole: "캐릭터 추가",
    rightChange: "권한 수정",
    logo: 'LOGO설정'
  },
  accManager: "계정관리",
  accManagerSub: {
    account: "계정정보",
    subAccount: "서브계정 정보",
    addAccount: '서브계정 추가',
    editAccount: '서브계정 편집'
  },
  menuEdit: '메뉴 편집'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'advert', {
  status: "광고상태",
  addAdvert: "광고 추가",
  deleteAll: "대량삭제",
  all: "전체",
  refusal: "이유설명",
  app: "애플리케이션",
  appSub: {
    name: "이름",
    classify: "유형",
    uploadTime: "업로드시간",
    version: "버전번호"
  },
  isPass: "통과 여부",
  pass: "통과",
  notPass: "미통과",
  waitOne: "심사제출 대기",
  waitTwo: "심사대기",
  addDate: "시간추가",
  addUser: "추가인",
  appName: "애플리케이션 이름",
  img: "이미지",
  name: "광고이름",
  classify: "광고유형",
  position: "광고위치",
  positionSub: {
    banner: "첫 페이지Banner",
    starPage: "시작 페이지"
  },
  jumpType: "점프 타입",
  jumpTypeSub: {
    net: "웹페이지",
    appStore: "앱스토어"
  },
  url: "URL",
  channel: "유통업자",
  ableDate: "유효기간",
  beginDate: "시작시간",
  endDate: "종료시간",
  contentImg: "광고내용",
  reset: "초기화"
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'index', {
  t: "대",
  more: "더보기",
  terStatus: "장치 개황",
  onlineTer: "온라인 장치",
  offLineTer: "오프라인 장치",
  warnTer: "경보장치",
  taskList: "태스크 리스트",
  pullApp: "애플리케이션 전달",
  romUpdate: "ROM업데이트",
  pullAdvert: "광고 푸시",
  infoList: "정보 리스트",
  riskWarn: "리스크 매니지먼트 경고",
  breakWarn: "고장경고"
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'taskTypeNames', {
  ALL: "모든 종류",
  APP: "응용",
  OTA: "OTA",
  ROM: "ROM",
  FIRMWARE: "펌웨어",
  AD: "광고",
  STARTUP_ANIMATION: "기계를 애니메이션",
  SHUTDOWN_ANIMATION: "컴퓨터 끄기 애니메이션",
  STARTUP_SHUTDOWN_ANIMATION: "스위치 기계 애니메이션",
  LOGO: "LOGO",
  LAUNCHER: "Launcher",
  WALLPAPER: '바탕 화면'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'menuConfig', {
  menu: {
    addMenu: "페런트 메뉴추가",
    refreshMenu: "새로 고침 메뉴",
    addMenu2: "메뉴추가",
    menuName: "메뉴이름",
    selectModel: "모듈선택",
    orderBy: "순번배열",
    notBlankName: "이름 공백불가",
    editMenu: "메뉴편집",
    editSuccess: "편집완료",
    addSubMenu: "서브메뉴추가",
    relUrl: "상대주소"
  },

  role: {
    addRole: "캐릭터 추가",
    no: "번호",
    name: "이름",
    mark: "묘사",
    model: "모듈",
    updatePermission: "권한수정",
    editRole: "캐릭터 편집",
    notBlankName: "이름 공백불가",
    updateSuccess: "업데이트 완료",
    deleteSuccess: "삭제 환료",
    modelSelect: "모듈 선택",
    addSuccess: "추가 완료"
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_adname', '광고 이름'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_allpush', '보내다, 다'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_fipush', '가져올 파일 보내다'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_isjtoviewtd', '혹시 위치로 이동 작업 정보 보기 보내다 진행'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_mgsys', '시스템 도메인 이름'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_edcode', '관리 인증 코드'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_sapp', '응용 프로그램 선택'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_spic', '그림을 선택하십시오.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_iappnamesrch', '응용 프로그램 이름을 입력하십시오. 조회'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_alltyps', '모든 종류'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_allpp', '모든 재생 위치'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_addur', '광고 때 길다'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_vsize', '비디오 크기'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_addtime', '시간 추가'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_psverify', '통해 심사'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_vpreview', '비디오 미리 보기'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_cstandt', '선택할 때 긴 와 횟수'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_additv', '추가 때 길다'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_vdofile', '비디오 파일'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_filename', '파일 이름'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_vdodur', '비디오 때 길다'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_clreulvdo', '다시 동영상 올린 클릭'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_adddfvdeoad', '기본 비디오 광고 추가'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_addps', '추가 인원'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_pltimes', '재생 횟수'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_pldur', '재생 때 길다'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_csvldate', '선택 유효기간'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_advdoad', '비디오 광고 추가'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_mgdfvdo', '관리 기본 비디오'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_adstatus', '광고 상태'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_addadtype', '새로운 광고 형식'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_newapptype', '새로운 응용 형식'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_addmodel', '신규 모델'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_newdvtype', '추가 장치 종류'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_addfmname', '새로운 메이커 이름'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_srpush', '확인 보내다'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_ulfile', '업로드'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_ttpsddvnum', '이번 보내다 완료 장치 갯수'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_srsktsdv', '너 정말 이 장치에 건너뛰기'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_cvpush', '덮어쓰기 보내다'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_skpush', '건너뛰기 보내다'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_pssuccess', '보내다 성공'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_nowjump', '곧 갑니다'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_bcrecov', '대량 복원'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_skintro', '간결한'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_addlc', 'launcher 추가'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_ulinsfile', '파일 업로드 설치'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_clreul', '클릭 다시 업로드'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_lcname', 'launcher 이름'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_rsfivemin', '매 5분 자동 새로 고침'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_suresm', '확인 제출'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_udfiletype', '업데이트 파일 형식'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_plsltype', '형식을 선택하십시오.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_adnamenotnull', '광고 이름 못 비어'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_plslchannel', '채널 상업 선택하십시오.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_plslplpos', '재생 위치를 선택하십시오.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_slsttime', '시작 시간 선택하십시오.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_slendtime', '끝나는 시간 선택하십시오.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_addsc', '추가 성공'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_vlsuccess', '심사 성공'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_opsuccess', '작업이 성공적으로'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_srpassvf', '확인 통해 심사'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_addvdoad', '비디오 광고 추가'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_edvdoad', '편집 동영상 광고를'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_sllimit', '선택 유효기간'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_srmuldel', '대량 삭제 확인'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_sttcanlateendtime', '시작 시간 못 늦다 종료 시간'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_etcanelsttime', '종료 시간 이전일 수 없습니다 시작 시간'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_srdelpush', '삭제 확인 보내다'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_srrecovsysdf', '확인 시스템 기본값으로 되돌립니다'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_rdless', '펜스 반경 작음'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_srban', '확인 안 통해'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_banandrs', '혹시 안 통해 입력하십시오. 안 통해서 원인을?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_trjmap', '추적 지도'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_psdonelftip', '이번 보내다 있다 {num} 설비는 이미 완성 보내다 또는 지금 보내다, 당신 이 장치를 했었지?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_tipdown', '힌트 다운로드'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_psscandtip', '힌트 설치 성공 보내다'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_csulpicbsis', '클릭 선택 올린 사진 보기 위해, 베스트 사이즈'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_srch', '검색'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_lkdevice', '장치를'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_app', '응용'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_firmw', '펌웨어'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_refresh', '새로 고침'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_sleep', '휴면'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_ccdown', '취소 다운로드'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_iscancelPush', '혹시 취소 보내다?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_fmVerIillegal', '버전 번호 안 합법적인 반드시 숫자를 1.0.0 같다.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_verror', '버전 이상'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_other', '기타'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_inssuccess', '설치 성공'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_tipterop', '힌트 단말 작업'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_autocmpl', '자동 완성'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_noresetfs', '기기가 현재 공장 출하 상태입니다. 관리자에게 문의하여 초기화하십시오.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_saleSt', '출하 상태'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_actst', '활성 상태'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_insfail', '설치 실패'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_checksignfail', '검사하다, 싸인 실패'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_asc', '오름차순'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_desc', '내림차순'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_utasc', '업데이트 시간 오름차순'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_utdesc', '업데이트 시간 내림차순'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_srchcontent', '검색 내용'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_account', '계좌 번호'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_opecontent', '조작 내용'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_opetime', '작업 시간'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_frzaccount', '얼음이 아이디'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_operator', '조작 사람'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_userip', '사용자 IP'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_deskwp', '바탕 화면'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_channelmcdetail', '채널 상세'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_channellevel', '등급 상등'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_cermanage', '인증서 관리'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_lineimportcer', '산선 가져오기 증서 가져오기'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_devicemanage', '장치 관리'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_fileimportdevice', '파일 가져오기'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_lineimportdevice', '산선 가져오기'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_prodmodel', '제품 모델'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_plimportcer', '클라이언트 인증서 가져오기'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_importslorder', '선택한 주문서를 가져오기'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_importslcustomer', '선택한 클라이언트 가져오기'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_customername', '클라이언트 이름'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_orderno', '주문 번호'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_orderfinishdate', '주문 완료 날짜 완성 날짜'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_customerno', '고객 인코딩'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_debuginfo', '디버그 정보'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_adbstatus', 'ADB 상태'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_on1', '열다'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_off1', '닫다'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_devicemode', '장치 모드'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_normalmode', '정상 모드'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_debugmode', '디버깅 모드'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_signstatus', '검사 상태.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_catchlog', '클러치 로그'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_tobenimportdv', '가져올 장치'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_lineimporttip', '설비의 유형, 공장, 모델, 주소 등 기본 데이터를 설정하십시오'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_cannotwithsysapp', '시스템 애플리케이션을 포함할 수 없습니다.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_locktime', '잠금 시간'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_risksetting', '바람 설정'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_lockinfo', '정보 잠금'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_riskdetail', '예고한 상세한 상황.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_lockcity', '도시 를 정하 다'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_locklngandlat', '위도를 고정시키다.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_lockstate', '잠금 상황 묘사'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_bindenclosure', '둘러싸다'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_unbindenclosure', '울타리를 묶다.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_sureunlock', '잠금 해제'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_plsinputimgfile', 'IMG 형식 파일 올려주세요.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_animatefile', '애니메이션 파일'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_bglock', '빽 잠그기'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_request', '신청하다'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_unrequest', '미청'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_lockdevice', '설비를 정정하다.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_pusheddvlist', '앱 제거'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_appuninstall', '마운트 적용하기'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_unlocked', '잠금 해제'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_unlockdevice', '잠금 해제 장치'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_pushnumcantfive', '밀송 수량이 5 개를 넘으면 안 돼요.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_selectedappshoupass', '선택한 응용 프로그램'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_misstokentip', '로그인 정보 분실, 재등록권 필요'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_adRefreshfreq', '광고 쇄신 주파수'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_uninsfail', '마운트 해제 실패'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_uninssc', '마운트 해제 성공'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_preversion', '기초 버전'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_rdneedmore', '포위 난간 은 반경 이 크게 필요할 것 이다'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_addstfile', '설정 파일 추가'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_filetag', '파일 형식'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_filestss', '설명'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_uploadfilest', '설정 파일 업로드'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_excludeapp', '적용 배제'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_reupload', '다시 올린다'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_excludefsttip', '배제할 애플리케이션 추가, 온전한 애플리케이션 이름을 입력하면 이 프로그램을 제거합니다. 기본 지원하는 이 파일 표기의 적용을 기본값으로 사용하려면 이 설정을 사용할 수 있습니다'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_limitxml', '제한 xml 파일'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_configfile', '파일 설정'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_udversion', '업데이트 버전'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_udsamexml', '같은 표시 xml 로 갱신할 수 있습니다.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_udxmllowertip', '업데이트 버전이 현 버전보다 낮은 것으로 기록되어 있습니다. 목록에 표시되지 않습니다.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_childacmg', '부좌 번호 관리'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_unldvwftip', '이 설비는 포위 표시줄 [{wl}], 바인드를 동시에 삭제하시겠습니까?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_udmode', '업데이트 모드'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_append', '추가하다.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_importapp', '가져오는 응용 프로그램 가져오기'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_adddate', '날짜 추가'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_addtask', '작업 추가'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_addtesttask', '작업 추가'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_appdesc', '설명'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_srcdesc', '자원 묘사'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_downapp', '다운로드 응용'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_downfile', '파일 다운로드'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_addsrc', '자원 추가'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_importsrc', '리소스 가져오기'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_srcname', '자원 이름'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_srcver', '자원 버전'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_downsrc', '자원을 다운로드하다'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_number', '편성 번호'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_softinfo', '소프트웨어 정보'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_allstatus', '모든 상태'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_mstype14', '스모크 총'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_mstype15', '총자원의 문건을 쓸어 보내다.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_filedesc', '파일 설명'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_filetype', '파일 형식'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_subtype', '동자 유형'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_addfile', '파일 추가'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_stmgpsw', '비밀번호 관리 설정'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_mapsl', '지도 선택'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_bdmap', '백도'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_map', '지도.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_right', '권한'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_addconfig', '설정 추가'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_editconfig', '설정 편집'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_mgpsw', '비밀번호 관리'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_dvconfiglist', '설정 장치 목록'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_appconfigst', '응용 프로그램 설정'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_applytime', '응용시간'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_secrname', '키 이름'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_secrdesc', '키 설명'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_addsecrrule', '키 규칙 추가'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_editsecrrule', '키 규칙 편집'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_secrdvlist', '키 장치'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_secrupdatest', '키 업데이트 상태'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_waitupdate', '업데이트'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_addrandport', '주소 및 포트'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_filepath', '파일 경로'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_queryudfre', '업데이트 업데이트'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_lcupload', '로컬 업로드'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_hour', '시간'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_addofcloud', '구름 추가'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_bglist', '배경 목록'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_cntype', '연결 방식'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_codegunsrc', '총자원을 청소하다.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_rtosgunsrc', 'RTOS 자원'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_rots_1', "app를 적용하다"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_rots_2', "자원 source"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_rots_3', "시스템 sys"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_rots_4', "보안 칩 펌웨어 버전 sp"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_rots_5', "마스터 버전 mt"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_partpkg', '증량 가방'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_codegunapp', '소탕총 응용'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_starttime', '시작 시간'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_oilmcsrc', '주유기 자원'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_downtpl', '템플릿 다운로드'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_plsstype', '자형 종류 선택'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_allstyps', '모든 자형 종류'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_ftooltip', '애니메이션 / 로고파일 온라인 제작 도구'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_appendpush', '추가 밀송'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_ipitonlylgchar', '입력 항목은 영문 숫자와 밑줄 등 합법적인 문자가 될 수 있다'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_enable', '활성화'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_spfileis', '파일 지원 형식'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_cnsetting', '연결 설정'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_newtask', '새 작업'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_adddv', '설비를 추가하다'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_fileinsst', '파일 설치 설정'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_insscautoop', '설치 성공 자동 열기'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_pushsctipins', '밀송 성공 힌트 설치'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_total', '총수'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_wait', '기다리다'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_pushing', '밀송하고 있어요.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_pushsldev', '선택한 장치'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_repushdv', '실패 설비를 다시 미루다.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_outputdv', '내보내기'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_udtime', '업데이트 시간'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_surepsxdv', '장비 {num} 대를 확인하여 설비를 송달하다.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_apppush', '응용'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_fmwpush', '고지'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_advpush', '광고'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_onampush', '개기 애니메이션 밀송'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_offampush', '컴퓨터 끄기 애니메이션 밀송'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_onoffampush', '스위치 엔진'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_onlgpush', '개기 로고'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_wppush', '벽지'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_stfpush', '파일 배송 설정'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_codemc', '코드기'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_codemcsrc', '소압기 자원'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_sysud', '시스템 업데이트'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_fmwud', '고지 업데이트'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_anmud', '애니메이션 업데이트'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_qcgunsrcps', '총자원을 쓸어 보내다.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_iscltask', '임무를 취소할 것을 확정 하다'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_resrc', '자원'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_srcfileps', '자원 파일 밀송'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_fmVerIillegal1', '버전 번호 의 비합법적 으로, 반드시 v 와 숫자 가 반드시 v 1.0.0 이다'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_helptip', '일깨워 주다'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_newpsetnewver', '새로운 버전 TMS 의 밀송 기능 개편'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_newptdetail', '	기능 개편 후, 사용자는 밀송 미션 페이지를 열 수 있습니다 (미션 관리 → 밀송 미션), 새 작업, 새로운 작업 페이지에 진입하며, 미션의 이름을 입력하고, 필요한 파일을 입력하십시오.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_newptdetail1', '	작업 새 작업 완료된 후 자동 이동에 대한 자세한 정보 파출 장치 선택, 사용자가 대량 추출 또는 단대 설비에서 사용할 수 있습니다. 미션의 자세한 설비를 여러 번 추가 설비를 추가할 수 있습니다. 많은 양의 밀송 전에 소량의 설비를 먼저 미팅하고, 확인되지 않은 후 미션에서 클릭하면 설비를 추가할 수 있습니다.보내다'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_daterange', '날짜 범위'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_olinepday', '하루 온라인'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_onlineavgt', '평균 시단'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_devicewhe', '장치 분포'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_statistic', '통계.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_today', '오늘'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_thisweek', '금주'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_thismonth', '금월'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_addblfile', '블랙리스트 파일 추가'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_blacklsname', '블랙리스트 이름'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_editblls', '블랙리스트를 편집하다.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_blsdesc', '블랙리스트 묘사'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_blsdvlist', '블랙리스트 장치 목록'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_wldesc', '포위 묘사'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_filectncr', '파일 내용이 정확하지 않다.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_khour', '때'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_kday', '날'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_yesterday', '어제'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_rc15d', '최근 15 일'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_rc30d', '최근 30 일'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_stinfo', '상태 정보'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_croln', '현재 온라인'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_crslp', '현재 휴면'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_croff', '현재 이선'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_lstol', '마지막 온라인 타임'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_lstsl', '마지막 휴면 시간'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_lstof', '마지막 오프라인 시간'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_limitiplg', 'IP 로그인 제한'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_illegal', '불합법'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_limitiptip', '필요한 규제를 입력하십시오. 입력하지 않으면 제한되지 않습니다.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_unknow', '알 수 없다.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_hisstatus', '역사 상태.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_allowiplg', 'IP 로그인 허용하기'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_allowiptip', '허용된 IP 단을 입력하십시오. 입력하지 않으면 모든 IP 방문을 허용합니다'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_active1', '활발하다'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_unuse', '비활성화됨'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_addpsg', '채널 추가'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_psgname', '채널 이름'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_authstat', '인증 상태'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_cbackad', '전조 주소'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_bsrqsadwl', '업무 요청 주소 백명부'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_appwtls', '명단을 적용하다.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_addapppgkn', '가방 추가'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_authopen', '권한을 부여하다.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_authclose', '권한을 부여하여 닫히다.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_addaddr', '주소 추가'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_developer', '개발자'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_editpasg', '채널'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_usertype', '사용자 종류'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_generate', '생성'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_gentip', 'APSe시크릿을 재생성 후 기존 APSe시크릿은 효력을 잃었고, 오픈 플랫폼을 이어갈 수 없습니다.APSe시크릿을 다시 생성할 수 있는지 확인하시겠습니까?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_open1', '열다.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_hide', '숨다'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_subtask', '자제 임무'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_sltstype', '작업 형식 선택'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_command', '명령'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_addsubts', '추가 작업'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_commtype', '명령어 형식'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_taskpros', '작업 진행'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_cursubts', '현재 부스'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_commpush', '명령어'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_dvrestart', '장치 재개'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_recvorgst', '공장 출하'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_recvanimt', '애니메이션'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_dvlock', '장치 장치'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_dvunlock', '장치 잠금'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_inbdside', '이제 변경입니다.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_subtsnum', '자 미션수'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_tscrtime', '작업 생성 시간'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_ing', '진행 중'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_core', '내핵'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_filesys', '파일 시스템'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_commd1fw', '통신 모듈 1'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_commd2fw', '통신 모듈 2'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_readcfw', '카드 읽기'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_pswkbfw', '암호 키보드'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_scanhfw', '스캐너'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_actpossp', '활성화 POS 통화 활성화'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_natpossp', 'POS 통화 닫기'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_setcallf', '통화 기능 설정'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_clupappdt', '데이터를 지우기'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_isclupappdt', '응용 프로그램 지우기'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_impdistbt', '가져오기'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_impmctip', '이 파일 업로드 중 10 m 이상 지원할 수 없습니다.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_callfunc', '통화 기능'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_protocal', '프로토콜'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_prtsltip', 'HTTPS 를 선택할 때, 이 프로토콜을 지원해야 할 인터페이스를 반드시 지원해야 합니다'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_rgsvpm', '인증 서비스 변수'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_rgsvip', 'IP IP IP IP'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_bgntpm', '배후 알림 변수'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_bgntip', '배경 정보 IP IP'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_port', '포트'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_flexist', '파일이 이미 존재합니다.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_cerid', '인증서 지문'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_wallpaper', '벽지'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_forceins', '강제 설치'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_autorun', '자동 운행'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_cusins', '객화 설치'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_cusuins', '객화 해재'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_forcerun', '강제 집행'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_pushtest', '테스트 (하다)'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_pltfblt', '플랫폼 공고'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_addblt', '공고 추가'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_blttt', '공지 제목'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_readnum', '읽은 횟수'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_bltct', '공고 내용'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_pltudrd', '플랫폼 업데이트'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_udlog', '로그 업데이트'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_addver', '버전 추가'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_pubdate', '기일을 발포하다.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_updct', '업데이트 내용'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_editblt', '공고 편집'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_editver', '버전 편집'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_verupdate', '버전 업데이트'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_clviewdt', '보기 자세한 정보 클릭'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_viewmore', '보기'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_comptime', '번역 시간'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_insafnorun', '설치 후 비자동 실행'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_normalins', '일반 설치'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_normalunins', '기본 마운트'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'appp_tipoperate', '힌트'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_onlyprov', '선택성'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_filepush', '파일 송송'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_region', '구역'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_srcmechan', '키워드 검색 루트 입력'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_ckcode', '검증 코드'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_cantuins', '해제할 수 없음'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_ippkgname', '패키지 이름 입력'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_onlypicfm', '사진 형식 파일만 올릴 수 있습니다 (JPG, PNG, GIF...)'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_fludlist', '파일 업데이트 목록'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_param', '인자'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_catching', '잡은 중'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_ulding', '업로드 중'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_ulyet', '업로드 완료'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_endcatch', '캡처 끝'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_iscatch', '검색 시작？'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_opterinfo', '터미널 정보 내보내기'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_bcopterinfo', '도량 터미널 내보내기'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_cpttime', '절취 시간'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_eqcapture', '장치 캡처'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_scapture', '캡처'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_surestcap', '캡처 확정？'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_lokscrn', '자물쇠 스크린'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_ulkscrn', '화면 제거'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_appautrn', 'App 자체 시작'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_perms', '단위:밀리초'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_wattime', '시간을 기다리다'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_lcswitch', 'launcher 전환'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_appadv', '응용 광고'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_cardno', '카드번호'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_trdno', '일련 번호'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_batcno', '번호 매기 기'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_amout', '금액'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_mechno', '상호'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_trdtime', '거래 시간'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_trddate', '거래 날짜'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_trdcore', '핵심 흐름'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_expno', '참고 번호'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_trdtype', '거래 유형'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_rectime', '시간 을 기록 해'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_fpaddrs', '얼굴 사진 주소'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_propcut', '비례 에 따라 재단 하 다'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_getcash', '현금 인출'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_lctrans', '줄 내 계좌 이체'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_obtrans', '다른 은행 으로 이체 해 주세요'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_coretrans', '핵심 흐름'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_tradeNo', '거래 번호'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_export', '내 보 내기'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_ctrc', '마 그 네 틱 카드 리더'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_icrc', 'IC 카드 리더'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_prtst', '프린터 상태'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_pswkb', ' 비밀번호 키보드'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_idfrc', '주민등록증 리더'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_led', 'LED'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_beep', '버저'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_codebar', '바코드'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_lulog', '로그 보기'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_lust', '상태 보기'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_mdclst', '모듈 호출 통계'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_fcclst', '방법 호출 통계'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_acauth', '쿠폰 인증'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_authcode', '활성 코드'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_authrange', '프로그램 유효기간'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_delact', '잠시 활성화 하지 않 음'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_pswtip', '비밀 번 호 는 대문자, 소문 자, 숫자 와 특수 부 호 를 포함 하여 8 자리 이상 이 어야 한다.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_phontrs', '핸드폰 번호 이체'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_mulfcau', '多因子认证'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_verifc', '验证'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_opmfackip6dycode', '请打开MFA验证器，输入6位动态验证码'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_cantprvmcodectadm', '如不能提供多因子认证验证码，请与管理员联系'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_lsstep', '上一步'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_nxstep', '下一步'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_ckidt', '验证身份'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_istapp', '安装应用'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_bindmfa', '绑定MFA'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_ipaclgpsw', '输入账号登录密码'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_bindsfdv', '  绑定安全设备'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_psfwtsstepop', '请按以下步骤完成绑定操作'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_sixnumb', '6位数字'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_phdnalyappggidck', '请在手机端下载并安装阿里云APP/Google Authenticator（身份验证器）'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_ipappstsagidck', 'iphone：在AppStore搜索阿里云APP/Google Authenticator（身份验证器）'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_adappmksagidck', 'Android：在应用市场搜索阿里云APP/Google Authenticator（身份验证器）'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_afistclnxitbpagiinx', '安装完成后点击下一步进入绑定页面（如已安装，直接进入下一步）'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_usalyagidckscqrc6code', '使用阿里云APP/Google Authenticator（身份验证器）扫描以下二维码，获取6位验证码'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_sftkck', '安全令牌验证'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_ip6codeubac', '输入6位验证码解除绑定账户'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_plipopenalyappoggidckip6dycd', '请在手机中打开阿里云APP或Google Authenticator（身份验证器）,请输入6位动态码'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_select_timelist', "시간 범위 선택"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_batch_migration', "일괄 마이그레이션"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_korean, 'app_sure_migration', "이전 확인"), _korean);

/* harmony default export */ __webpack_exports__["a"] = (korean);

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _lin_global, _details, _ru;

var ru = (_ru = {
  pushTip: {
    pushType0: "Загрузка имеет {nums} устройств для которых она уже была выполнена, вы хотите пропустить эти устройства?",
    pushSuccess: "Перейти к описанию задачи чтобы увидеть расписание загрузки?",
    push_all_by_mem: "Загрузить на все каналы операторов: все оборудование под {mem}",
    push_all: "Вы уверены что хотите загрузить на все устройства по всем каналам?"
  },
  app_pushAll: "Загрузит на все терминалы",
  app_uploadApp: 'Загрузить приложение',
  app_No: 'Серийный номер',
  app_terNo: 'Номер терминала',
  app_name: 'Наименование',
  app_appName: 'Наименование приложения',
  app_appType: 'Тип приложения',
  app_insType: 'Тип установки',
  app_vStatus: 'Статус',
  app_ulTime: 'Время загрузки',
  app_appLoding: 'Приложение загружается',
  app_newgVer: 'Последняя версия',
  app_operate: 'Операция',
  app_type: 'Тип',
  app_del: 'Удалить',
  app_pause: 'Пауза',
  app_continue: 'Продолжить',
  app_status: 'Статус',
  app_new: 'Добавить',
  app_yes: 'Да',
  app_no: 'Нет',
  app_selectAll: 'Выбрать все',
  app_save: 'Сохранить',
  app_process: 'Process',
  app_push: 'Push',
  app_terminal: 'Терминал',
  app_to: ' на ',
  app_offShelf: 'Удалить',
  app_mulOffShelf: 'Пакетное удаление',
  app_isOffShelf: 'Вы хотите удалить приложение из магазина приложений?',
  app_isDelApp: 'Вы хотите удалить приложение?',
  app_chooseOneMust: 'Выберите хотя бы одно прилжение',
  app_cantDelTask: 'Выбранные задачи не могут быть удалены',
  app_oneRecordMust: 'Выберите хотя бы одну запись',
  app_phoneIllegal: 'Недействительный номер телефона',
  app_groupName: 'Имя категории',
  app_sure: 'Да',
  app_query: 'Запрос',
  app_reset: 'Сброс',
  app_cancel: 'Отмена',
  app_edit: 'Редактирование',
  app_add: 'Добавить',
  app_verify: 'Проверить',
  app_isPass: 'Результат',
  app_pass: 'Одобрено',
  app_ban: 'Отклонено',
  app_noInput: 'Не заполнено',
  app_banReason: 'Причина отказа',
  app_filter: 'Фильтр',
  app_prePushVerify: 'Ожидание поддтверждения',
  app_preVerify: 'ожидание проверки',
  app_verifyPass: 'Утверждено',
  app_verifyNotPass: 'Отказано',
  app_success: 'Успешно',
  app_submit: 'Отправить',
  app_tip: 'Подсказка',
  app_online: 'На линии',
  app_offline: 'Отключен',
  app_fileOver: 'Файл закончился',
  app_onlyApk: 'Загрузка только файлов Apk',
  app_onlyApk_2: 'Загрузка только файлов Apk/Hap',
  app_tipViewTask: 'Успешная загрузка, пожалуйста, отслеживайте прогресс в менеджере задач',
  app_tipMkDel: 'Приложение в магазине приложений будет удалено синхронно. Вы хотите удалить?',
  app_tipAppEdit: 'Восстановление невозможно, вы хотите удалить?',
  app_tipVerify: 'Вы действительно хотите отправить?',
  app_rqsError: 'Ошибка запроса',
  app_not_auth: 'TMS не активирован',
  app_mulAdd: 'Пакетное добавление',
  app_select: 'Выберите',
  app_input: 'Пожалуйста, введите содержимое',
  app_inputCp: 'Пожалуйста, заполните',
  app_inputName: 'Пожалуйста, введите наименование',
  app_inputContact: 'Пожалуйста, введите контактное лицо',
  app_inputTruePhone: 'Пожалуйста, введите правильный номер телефона',
  app_inputAddr: 'Пожалуйста, введите адрес',
  app_inputVer: 'Пожалуйста, введите версию',
  app_inputVerTag: 'Пожалуйста, введите код версии',
  app_inputID: 'Введите идентификацию',
  app_inputPkg: 'Пожалуйста, введите имя пакета',
  app_noVerTag: 'Нет кода версии',
  app_inputIntrol: 'Пожалуйта, введите описание',
  app_selectType: 'Пожалуйста, выберите тип приложения',
  app_ulApp: 'Пожалуйста, загрузите файл приложения',
  app_ulIcon: 'Пожалуйста, загрузите маленькую иконку',
  app_ulLarIcon: 'Пожалуйста, загрузите большую иконку',
  app_ulScreenShot: 'Пожалуйста, загрузите снимки экрана',
  app_smVerify: 'Отправить',
  app_baseInfo: 'Базовая информация',
  app_version: 'Версия',
  app_autoUpload: 'Автоматическая загрузка',
  app_verTag: 'Код версии',
  app_ID: 'Идентификация',
  app_package: 'Имя пакета приложения',
  app_introl: 'Краткое описание приложения',
  app_udState: 'Описание обновления',
  app_icon: 'Маленькая иконка приложения',
  app_larIcon: 'Большая иконка приложения',
  app_screenShot: 'Снимки экранов приложения',
  app_appVer: 'Версия приложения',
  app_createTime: 'Дата создания',
  app_close: 'Закрыть',
  app_ulNew: 'Загрузить последюю версию',
  app_selectApp: 'Выберите приложение',
  app_testInstall: 'Проверка установки',
  app_ulAppState: 'Перетащите файлу сюда, или нажмите Загрузить, поддерживаются только файлы apk',
  app_clickUpdate: 'Нажмите загрузить',
  app_udType: 'Способ обновления',
  app_allUpdate: 'Обновить все',
  app_iconState: '144x144, Размер не должен превышать 100k',
  app_larIconState: '512x512, Размер не должен превышать200k',
  app_autoInstall: 'Автоматическая установка',
  app_addApp: 'Добавить приложение',
  app_classIntrol: 'Рекомендуемая категория',
  app_homeIntrol: 'Рекомендуемая главная',
  app_isIntroClass: 'Рекомендовать ли классификацию',
  app_isIntroHome: 'Рекомендовать ли главную',
  app_isUnbindApp: 'Вы уверены, что хотите отвязать приложение？',
  app_isOffApp: 'Вы уверены, что хотите отложить приложение?',
  app_isDelData: 'Вы уверены, что хотите удалить эти данные?',
  app_inputAName: 'Пожалуйста, введите наименование',
  app_oneDeviceMust: 'Выберите хотя бы одно устройство',
  app_fileSize: 'Размер файла',
  app_addPush: 'Добавить загрузку',
  app_viewPushHis: 'Посмотреть историю загрузок',
  app_pushTimes: 'Время загрузки',
  app_hisVer: 'Историческая версия',
  app_pushHistory: 'История загрузки',
  app_pushInstall: 'Загрузка инсталлятора',
  app_animatePush: 'Загрузка анимации',
  app_animateMake: 'Пользовательская анимация',
  app_pushDevice: 'Устройство для загрузки',
  app_deviceNum: 'Количество устройств',
  app_deviceName: 'Наименование устройства',
  app_deviceNo: 'Номер устройства',
  app_pushTime: 'Время загрузки',
  app_distributor: 'Торговая организация',
  app_dParent: 'Родительская торговая организация',
  app_unbind: 'Удалить',
  app_mulUnbind: 'Пакетное удалени',
  app_mulPush: 'Пакетная загрузка',
  app_searchTerminal: 'Найти устройства',
  app_terName: 'Имя терминала',
  app_taskName: 'Имя задачи',
  app_taskDetail: 'Содержимое задачи',
  app_deviceTotal: 'Общее число устройств',
  app_downloading: 'Скачиваем',
  app_downFail: 'Ошибка скачиваения',
  app_update: 'Обновить',
  app_md5Fail: 'Ошибка проверки MD5',
  app_theNewgVer: 'последняя версия уже установлена',
  app_fileFmIllegal: 'Неправильный формат файла',
  app_updateFail: 'Ошибка обновления',
  app_usrCancelUpdate: 'Пользователь отменил обновление',
  app_pushFail: 'Устройство отключено от сети',
  app_downFinish: 'Загрузка завершена',
  app_updateSuccess: 'Обновление выполнено успешно',
  app_fail: 'Ошибка',
  app_addres: 'Адрес',
  app_mulDel: 'Пакетное удаление',
  app_contact: 'Контактное лицо',
  app_contactPhone: 'контактный номер',
  app_typeName: 'Наименование типа',
  app_customs: 'Пользовательская модель',
  app_clear: 'Очистить',
  app_customsTime: 'Пользовательское имя',
  app_launchAnimate: 'Анимация включения',
  app_onLogo: 'Начальные логотип',
  app_animateName: 'Имя анимации',
  app_playPlace: 'Позиция востроизведения',
  app_aSrcFile: 'Файл ресурса анимации',
  app_asfState: 'Анимированная картинка, Помните, что имя файла должно быть part0.zip',
  app_downExp: 'Пример загрузки',
  app_ologoState: 'Экран, отображаемый после завершения воспроизведения',
  app_picSize: 'Размер изображения',
  app_picSizeState: 'Введите высоту*ширину',
  app_frame: 'Число кадров',
  app_frameState: 'Число кадров в секунду',
  app_aCycleTime: 'Число повторов анимации',
  app_cyclePlay: 'Зацикленное воспроизведение',
  app_playOnce: 'Проиграть один раз',
  app_fileNameOnly: 'Имя файла должно быть',
  app_inputNumber: 'Пожалуйста, введите номер',
  app_picUlError: 'Ошибка загрузки изображения',
  app_inputAnimateName: 'Пожалуйста, введите наименование анимации',
  app_selectAnimateType: 'Пожалуйста, выберите тип анимации',
  app_selectPlayPlace: 'Пожалуйста, выберите позицию воспроизведения',
  app_uploadAnimateFile: 'Пожалуйста, загрузите файл анимации',
  app_uploadOnPic: 'Пожалуйста, загрузите начальный логотип',
  app_sureDelTip: 'Вы уверены что хотите удалить? Восстановление невозможно',
  app_uploadPic: 'Пожалуйста, загрузите картинку',
  app_launchUI: 'Начальный интерфейс',
  app_amechine: '',
  app_chooseCycleType: 'Пожалуйста, выберите режим повтора',
  app_formatNotTrueLike: 'Неправильный формат',
  app_on: 'Включено',
  app_off: 'Выключено',
  app_onOff: 'Включено или выключено',
  app_firm: 'Имя производителя',

  add_srcFwByName: 'Найти прошивку по имени',
  app_downNum: 'Количество скачиваний',
  app_pushed: 'Выпущено',
  app_notPass: 'Отклонено',
  app_sysType: 'Тип системы',
  app_sys: 'Система',
  app_sysUdPack: 'Пакет обновления системы',
  app_chooseFile: 'Выберите файл',
  app_signCer: 'Сертификат подписи',
  app_isUseDisCerAutoSign: 'Использовать сертификат торговой организации для автоматической подписи',
  app_useDis: 'Назначенная торговая организация',
  app_allDisUsed: 'Общая для всех торговых организаций',
  app_pushInstallTest: 'Проверить загрузку инсталлятора',
  app_firmware: 'Имя прошивки',
  app_pushType: 'Тип загрузки',
  app_dv: 'Устройство',

  app_fwType: 'Тип прошивки',
  app_ulNormalSt: 'Перетащите файл сюда или нажмите загрузить',
  app_selectChannel: 'Пожалуйста, выберите торговую организацию',
  app_isSubmitToCheck: 'Отправить на проверку',
  app_pleaseInputNo: 'Пожалуйста, введите номер терминала',
  app_cnAndActive: 'Онлайн-активация',
  app_clearCer: 'Очистить сертификат',
  app_ofCheck: 'Проверка',
  app_normal: 'Нормально',
  app_netStatus: 'Статус сети',
  app_active: 'Активировано',
  app_initiative: 'инициатива',
  app_selfDestroy: 'Саморазрушение',
  app_mulActive: 'Активно в пакете',
  app_selected: 'Выбрано',
  app_cerCheckOf: 'Переключатель проверки',
  app_openCerCheck: 'Проверка включена',
  app_closeCerCheck: 'Проверка отключена',
  app_reOpen: 'Открыть повторно',
  app_reClose: 'Зактрыть повтоно',
  app_open: 'Открыть',
  app_usrManage: 'Управление пользователями',
  app_stManage: 'Управление конфигурациями',
  app_roleManage: 'Управление ролями',

  app_cerMgType: 'Тип управления сертификатом',
  app_cerMgSelf: 'Сертификат самоуправления',
  app_cerMgOther: 'Сертификат платформы',
  app_cerMgCustomer: 'Индивидуальные',
  app_operateHis: 'История операций',
  app_operateType: 'Тип операции',
  app_time: 'Время',
  app_isActive: 'Активность',

  app_downCer: 'Скачать сертификат',

  app_isOperate: 'Продолжить?',

  app_ulSuccess: 'Успешная загрузка',

  app_setting: 'Настройка',

  app_clickPicToUlPic: 'Нажмите для загрузки изображения',
  app_within: 'в',
  app_pgsFormat: 'Формат(png, gif, svg)',
  app_sgUseAndAdUse: 'Формат:svg, рекомендуем белый цвет',
  app_sureChange: 'Подтвердите изменения',
  app_logoLvTip: 'Выйти без сохранения?',
  app_dfIcon: 'Икона по-умолчанию',

  app_useBigSize: 'Большой размер',
  app_useBigSizeTip: 'Нажмите для оптимизации вида',

  app_or: 'Или',
  app_format: 'Формат',
  app_pic: 'Картинка',
  app_s: " (и)",
  app_plsUpl: 'Пожалуйста, Загрузите',

  app_upload: 'Загрузите',
  app_cerType: 'Тип сертификата',

  app_editProfile: 'Редактировать профиль',

  app_cerFile: 'Файлы сертификата',
  app_plsUlPbCer: 'Пожалуйста, загрузите сертификата',
  app_appNoCerTip: 'Текущий канал с сертификатом самоуправления, пожалуйста, загрузите файл публичного ключа для проверки приложений',
  app_appNeedCerTip: 'Текущий канал не имеет сертификата, пожалуйста, свяжитесь с администратором платформы для создания',
  app_createCer: 'Создать серфикат',
  app_uploadCer: 'Загрузить сертификат',
  app_ustart: 'Не начал дейстовать',
  app_outofdate: 'Истек',

  app_fileImport: 'Импорт файла',
  app_mdFile: 'Файл шаблона',
  app_down: 'Скачать',

  app_roleAllot: 'Назначени роли',
  app_roleName: 'Роль',
  app_downTplFile: 'Скачать файлы шаблонов',

  app_verUdCt: 'Содержимое обновления версии',
  app_animation: 'анимация',
  app_per: 'на',
  app_minute: 'минуту',
  app_autoRefresh: 'авто-обновление',
  app_level: 'уровень'
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_firm", 'фирма'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_model", 'модель'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_adType", 'Тип рекламы'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_license", 'ключ лицензии'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_maintain", 'поддержка'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_manage", 'управление'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_is", 'это'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_plsip", 'пожалуйста, введите'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_reason", 'причина'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_sgMc", 'одна машина'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_ss", 'обзор'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_inst", 'установить'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_file", 'файл'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_printscreen", 'печать экрана'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_batch", 'пакет'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_recov", 'восстановление'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_lc", 'загрузчик'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_re", 'снова'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_confirm", 'подтвердить'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_df", 'по-умолчанию'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_as", 'как'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_click", 'нажмите'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_content", 'содержимое'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_ttPkg", 'весь пакет'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_dfPkg", 'пакет различий'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_task", 'задача'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_catch", 'хватать'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_log", 'Лог'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_continued", 'продолжение'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_sec", 'секунда'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_video", 'видео'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_ad", 'реклама'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_choose", 'выберите'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_timeInterval", 'интервал времени'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_and", 'и'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_play", 'воспроизвести'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_times", 'раз'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_sc", 'секунда'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_tofvalis", 'Условия валидности'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_tofvaliss", 'Условия валидности'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_start", 'начало'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_end", 'конец'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_preview", 'предварительный просмотр'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_duration", 'продолжительность'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_size", 'размер'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_personnel", 'работник'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_cannot", 'не может'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_early", 'раньше'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_later", 'позже'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_lessThan", 'меньше чем'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_moreThan", 'больше чем'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_nums", 'числа'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_waiting", 'ожидание'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_all", 'все'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_all1", 'все'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_thistime", 'в этот раз'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_done", 'сделано'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_areyou", 'Вы'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_skip", 'пропустить'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_these", 'эти'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_cover", 'обложки'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_jump", 'перейти'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_detail", 'подробности'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_view", 'просмотр'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_now", 'сейчас'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_imp", 'импортировать'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_size1", 'размер'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_taskMg", 'Управление задачами'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_taskType", 'Тип задачи'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_cancelPush", 'Отменить загрузку'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_azcgsj", 'время успешной установки'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_ispushf", 'Загрузка файла'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_autoscopen", 'Установка выполнена успешно и откроется автоматически'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_pushsctipinstall", 'Нажмите, чтобы загрузить пробную версию приложения'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_tipdown", 'Подскажка скачивания'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_tipud", 'Подсказка обновления'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_sysinfo", 'Системная информация'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_bth", 'На главную'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_terstatus", 'Статус терминала'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_fminfo", 'Информация о прошивке'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_norightview", 'Вы не имеете доступа к этой странице'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_fault", 'сбой'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_geo", 'география'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_abnormal", 'ненормальное'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_blockp", 'Замятие бумаги'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_ecr", 'Электрический считыватель карт'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_mcr", 'Ручной считыватель карт'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_nacr", 'Считыватель карт недоступен'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_cardr", 'Считыватель карт'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_rcmsg", 'Получено сообщение'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_tgcr", 'Считыватель карт второго поколения'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_receiptp", 'Принтер чеков'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_hbsp", 'Интервал опроса'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_checkupsp", 'Интервал проверки обновлений'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_ispushalldv", 'Загрузить на все устройства'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "lin_btn", {
  cancel: "Отмена",
  add: "Добавить",
  install: 'установка',
  batch_install: 'Пакетная установка',
  tips: 'Подсказка',
  confirm: 'Подтвердите',
  unbind: 'Отвязать',
  unbindAll: 'Пакетная отвязка',
  check: 'Запрос',
  reset: 'Сброс',
  submit: 'Отправить',
  restart: 'Перезапустить',
  off: 'Закрыть',
  send: 'Отправить',
  batch_delete: 'Пакетное удаление',
  delete: 'Удалить',
  lock: 'Заблокировать',
  lockOta: 'Заблокировать OTA',
  add_zeng: 'Добавить',
  edit: 'Изменить',
  save: 'Сохранить',
  bind: 'Привязать',

  bindAll: 'Пакетная привязка',
  xiezai: 'Удалить',
  unlock: 'Разблокировать',
  change: 'Изменить'

}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "lin_global", (_lin_global = {
  cs_config: 'Настройка параметра',
  task_tips: 'Установка выполнена успешно, пожалуйста, отслеживайте процесс загрузки в Менеджере задач',
  task_tips2: 'Загрузка выполнена успешно，пожалуйста, отслеживайте прогресс в Менеджере задач',
  ope: 'Операция',
  pselect: 'Пожалуйста, выберите',
  label_no: 'Серийный номер',
  loading: 'Загружаем',
  label_name: 'Имя',
  all_mechanism: 'Все торговые организации',
  place_areaid: 'Пожалуйста, выберите торговую организацию',
  time: 'Время',
  version: 'Версия',
  name: 'Имя',
  remark: 'Пометка',
  edit: 'Изменить',
  label_model: 'Модель устройства',
  label_type: 'Тип устпройства',
  device_type_1: "Умные позы.",
  device_type_2: "Остальное оборудование.",
  label_manufid: 'Производитель',
  label_areaid: 'Торговая организация',
  label_areaid_name: 'Наименование торговой организации',
  label_address: 'Адрес',
  ter_status: 'Статус',
  dest_status: 'Режим самоуничтожения',
  net_status: 'Сеть',
  run_status: 'Оборудование',
  online: 'Подключено',
  offline: 'Отключено',
  new_add: 'Добавить',
  normal: 'Нормально',
  marn: 'Предупреждение',
  fault: 'Сбой',
  success_tips: 'Успешная операция',
  concel_tips: 'Отменена',
  zlxfs_tips: 'Ордер был выписан успешно',
  sb_tips: 'Сбой выполнения, отсутствует связь с терминалом',
  czsb: 'Сбой выполнения',
  zl_error: 'Ошибка создания операции',
  all_status: 'Все статусы',
  delete_success: 'Успешное удаление',
  look_detail: 'Посмотреть подробности',
  ter_num: 'Качество устройства',
  ota_bao: 'Пакет OTA',
  ple_sel_ota: 'Пожалуйста, выберите пакет OTA',
  unlock_success: 'Разблокировка выполнена успешно',
  risk_name: 'Имя подтверждения',
  risk_type: 'Тип предупреждения',
  risk_radius: 'Диаметр ограждения (км)',
  risk_city: 'Создание коммуникатора ',
  risk_desc: 'Описание',
  risk_warn_info: 'Информация о предупреждении управления рисками',
  warn_event: 'Событие предупреждения',
  city: 'Город',
  jwd: 'Широта и долгота',
  distance: 'За пределами установленной дистанции (км)',
  ccwl: 'За ограждением',
  sbyj: 'Предупреждение устройства',
  done: 'Сделано',
  undone: 'Не обрабатывается',
  roles_tips: 'Пожалуйста, выберите роль',
  roles_place: 'Прозвище',
  userName: 'Имя пользователя',
  nickName: 'Прозвище',
  phoneNum: 'Мобильный номер',
  roleName: 'Роль',
  jh: 'Активировать ',
  dj: 'Заморозить',
  phoneNum2: 'Сотовый номер',
  resetPass: 'Сбросить пароль',
  revisePass: 'Изменить пароль',
  oldPass: 'Старый пароль',
  newPass: 'Новый пароль',
  comfirmPass: 'Подтвердите новый пароль',
  plePassTips: 'Пожалуйста, введите пароль',
  plePassTipsAgain: 'Пожалуйста, введите пароль снова',
  pwdDisfault: 'Два пароля не совпадают',
  unfitPhone: 'Номер телефона не существует',
  nickNameTips: 'Прозвище не может быть пустым',
  userNameTips: 'Имя пользователя не может быть пустым',
  phoneNumTips: 'Номер телефона не может быть пустым',
  roleidTips: 'Роль не может быть пустой',
  mechanismIdTips: 'Торговая организация не может быть пустой',
  userStatusTips: 'Пожалуйста, установите статус пользователя',
  editPage: 'Изменить страницу',
  addPage: 'Добавить страницу',
  status: 'Статус',
  refs: 'Пожалуйста, уточните информацию',
  user: 'Пользователь',
  logStartTime: 'Начало лога',
  logEndTime: 'Конец лога',
  download: 'Скачать',
  ddsc: 'Ожидание загрузки',
  scz: 'Загружаем',
  scsb: 'Сбой загрузки',
  sccg: 'Загрузка выполнена успешно',
  rz_tips: 'Логи получены успешно. Пожалуйста, отслеживайте прогресс в Управлении логами',
  hqrz: 'Получить логи',
  logoTitle: 'Система Управления Терминалами',
  hello: 'Здравствуйте',
  wdzl: 'Ваш профиль',
  tcxt: 'Выйти',
  yhdl: 'Войти',
  zh: 'Учентая запись',
  password: 'Пароль',
  jzmm: 'Напомнить пароль',
  login: 'Войти',
  bah: ' © 1993 - 2020 Авторское право все кантоны ип 12035887 ',
  qsrzh: 'Пожалуйста, введите имя пользователя',
  qsrmm: 'Пожалуйста, введите пароль',
  error: 'Ошибка',
  wlzt: 'Статус сети',
  ckxq: 'Посмотреть подробности',
  wlmc: 'Имя ограждения',
  wllx: 'Тип ограждения',
  bdsb: 'Привязать устройство',
  tjbd: 'Добавить привязку',
  bjwl: 'Изменить ограждение',
  wxzyjlx: 'Пожалуйста, выберите тип предупреждения',
  cityName: 'Название города',
  sfjxpljb: 'Пакетное отвязывание или нет',
  qxzyjbdzd: 'Пожалуйста, выберите терминал для отвязывания',
  jbcg: 'Отвязывание выполнено успешно',
  sfjbczd: 'Отвязвать этот терминал или нет',
  sfjxplbd: 'Пакетное отвязывание или нет',
  qxzybddzd: 'Пожалуйста, выберите терминал для привязки',
  bdcg: 'Привязка выполнена успешно',
  sfbdczd: 'Привязать этот терминал или нет',
  xzwl: 'Добавить ограждение',
  qdxysccwl: 'Вы уверены, что хотите удалить это ограждение?',
  tsazcs: 'Проверка загрузки установки',
  shzt: 'статус',
  pass: "Подтверждено",
  notPass: "Отклонено",
  waitOne: "Ожидание отправки",
  waitTwo: "Ожидание рассмотрения",
  shyy: 'Причина отказа',
  zdtslb: 'Список терминалов для загрузки',
  xztghbtg: 'Передать или нет',
  qrtj: 'Подтвердите передачу',
  shcg: "Рассмотрено успешно",
  syqdsty: 'Общее для всех торговых сетей',
  notBlankName: "Имя не может быть пустым",
  notBlankVer: 'Версия не может быть пустой',
  qxzlx: 'Пожалуйста, выберите тип',
  qxzscwj: 'Пожалуйста, выберите файл для загрузки',
  zdqds: 'Назначенная торговая организация',
  sfsyzdqm: 'Использовать сертификат канала торговой организации для автоматической подписи',
  qmzst: 'Сертификат подписи',
  azbdz: 'Адрес пакета установки',
  qscapkwj: 'Пожалуйста, загрузите файл apk, не более 50M',
  qsczipwjls50: 'Пожалуйста, загрузите файл zip, не более 50M',
  jwjtdcc: 'Перетяните файл сюда или',
  djsc: 'Нажмите загрузить',
  xgscwj: 'Изменить загружаемый файл',
  otaName: 'Имя',
  xtlx: 'Тип системы',
  syatemR: 'Системый ROM',
  sysjota: 'Системное пакетное обновление OTA'
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "waitOne", "Ожидание отправки"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "waitTwo", "Ожидание рассмотрения"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "verifyPass", 'Подтверждено'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "verifyNotPass", 'Отклонено'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "confirmDelete", "Вы уверены в удалении？"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "tjshcg", 'Успешная отправка'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "qdtjsh", 'Подтвержите отправку'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "allType", 'Все типы'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "smVerify", 'Отпарвка подтверждена'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "downNumber", 'Количество скачиваний'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "tgmccz", 'Найти по имени'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "upload", 'Загрузить'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "xzqddhwj", 'Выберите файл анимации при запуке'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "qxzkjlogo", 'Выберите начальный логотип'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "tpxzds", '300x300 наилучший размер для картинки, размер не более 2М'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "zmlaun", 'Выберите пользовательскую среду запуска приложений'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "xtjcb", 'Выберите базовый системынй пакет'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "null", 'Пусто'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "shebei", 'Устройство'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "tslxxx", 'Тип загрузки'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "xzbbbbb", 'Выберите пакет OTA'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "uploadTime", "Время загрузки"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "verTips", 'на основе этой  версии  создания  дифференцированного  пакет  ,  номер версии  не  с  V  или  version  и других персонажей  ,  чисто цифровой  2.2.4  , таких, как  : '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "verTips1", 'номер версии  не  с  V  или  version  и других персонажей  ,  чисто цифровой  2.2.4  , таких, как  : '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "bbhgsbd", 'Неправильный формат версии'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "lkymtips", 'Идет загрузка файлов, вы действительно хотите покинуть эту страницу'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "znscziptips", 'Загрузка только файлов Zip'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "qsczipwj", 'Пожалуйста, загрузите файлы Zip'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "danweikm", 'Единицы км'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "weilanshuoming", 'Описание: Широта и долгота последних известный координат устройства это центр ограждения'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "pleaseUpload", 'Пожалуйста, загрузите'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "zdqmTips", 'Автоматически подписывать сертификат поставщика канала'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "zhidingqdsxx", 'Информация о назначенной торговой организации'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "selectWenjian", 'Выберите файл'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "qrjxmm", 'Вы уверены, что выполнили эту команду: '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "cicaozuo", 'Операция?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "shebeiedit", 'Редактировть устройство'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "yxpztitle", 'Настройка почтового ящика'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "yjyouxiang", 'Почтовый ящик для оповещений'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "chongzhi", 'Сбросить'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "ljchangjian", 'Потдтвердить'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "ympeizhi", 'Настрока имени домена'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "fwqdizhi", 'Адрес сервера'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "fwqdztips", 'Адрес не должен содержать символы "http: //", и может быть или доменным именем или IP адресом, например: www.baidu.com or 127.0.0.1'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "fwqduankou", 'Порт сервера'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "duankoutips", 'Не добавляйте ":" к номеру порта, просто введите: 8080'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "tuisongpeizhi", 'Загрузить конфигурацию'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "tuisongjl", 'Загрузить запись'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "tuisonglx", 'Тип загрузки'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "chenggong", 'Успешно'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "shibai", "Ошибка"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "tuisongtime", 'Время загрузки'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "chongtui", 'Загрузить снова'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "shebeibei", 'Устройство'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "fwqdzbnwk", 'Адрес сервера не может быть пустым'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "fwqdkhbnwk", 'Номер порта сервера не может быть пустым'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "wdct", 'Вы уверены, что хотите загрузить снова'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "tuisongtips", 'Вы действительно хотите загрузить настройку доменого имени? Изменения вступят в силу после успешной перезагрузки'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "china", 'Китайский'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "english", 'Английский'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "russian", 'Русский'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "cjzs", 'Создать сертификат'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "createTime", 'Время создания'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "certificateName", 'Имя сетрификата'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "xiafa", 'Загрузить'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "dachuzhengshu", 'Сохранить сертификат'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "guojia", 'Страна'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "shengfen", 'Регион'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "gongsi", 'Компания'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "youxiang", 'Email'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "youxiaoqi", 'Дата истечения'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "certTypeLabel", 'Тип сертификата'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "certForManufacturer", 'производитель'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "certForCustomer", 'клиент'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "danweitian", 'Единицы: День'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "xinjian", 'Новый'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "notNull", 'Должен'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "bitian", 'Должен'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "guojiatips", 'Сокращение страны'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "shenfentips", 'Регион(ENG/CHN)'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "cityTips", ' Город(ENG/CHN)'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "gongsiTips", 'Компания(ENG/CHN)'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "emailTips", 'Email'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "youxiaoqiTips", 'Дата истечения, в днях'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "xuantian", 'Не обязательный'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "srgsbzq", ' Неправильный формат'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "cszss", 'SZZT сертификат'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "khzss", 'Серитфикат дистрибьютора'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "sccszss", 'Загрузить сертификат SZZT'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "zhengshu", 'Сертификат'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "qudaoshangxinxi", 'механизм'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "quorter", 'Пожалуйста, подтвердите дистрибьютора или SN'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "xiafalishi", 'Скачать запись'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "resXiafa", 'Скачать повторно'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "chongxintuisong", 'Загрузить повторно'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "tuisongleixing", 'Как загрузить'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "dachusiyao", 'Сохраните секретный ключ'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "shuaxin", 'Обновить'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "passWordTips", 'Требуется пароль'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "daochugongyao", 'Экспорт сертификатов'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "zhengshuType", 'Тип сертификата торговой организации'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "ziguan", 'Самоуправляемый'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "daiguan", 'Управляемый платформой'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "add_merchant", 'Добавить торговую организацию'), _lin_global)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "terminal", {

  add: {
    place_no: "Пожалуйста, введите номер устройства",
    place_name: 'Пожалуйста, введите имя устройства',
    place_model: 'Пожалуйста, выберите модель устройства',
    place_type: 'Пожалуйста, выберите тип устройства',
    place_manufid: 'Пожалуйста, выберите производителя',
    place_address: 'Пожалуйста, введите адрес устройства',
    place_actime: 'Введите время активации устройства',
    place_extime: 'Введите время истечения срока действия устройства',
    popover_no: 'Номер устройства должен состоять из букв, цифр или символа подчеркивания, общая длина не более 50 символов',
    popover_name: 'Имя устройства должно состоять из букв, цифр или символа подчеркивания, общая длина не более 50 символов',

    rules_no_1: 'Номер устройства не может быть пустым',
    rules_no_2: 'Номер устройства не может быть больше 20 символов',
    rules_no_3: 'Номер устройства должен состоять из букв, цифр или подчеркивания',
    rules_no_4: 'Номер устройства уже существует',
    rules_name_1: 'Имя устройства не может быть пустым',
    rules_name_2: 'Имя устройства не может быть больше 20 символов',
    rules_name_3: 'Имя устройства должен состоять из букв, цифр или подчеркивания',

    success: 'Добавлено успешно',
    change_success: 'Изменено успешно'

  },
  appBind: {
    label_name: 'Имя приложения',
    label_version: 'Номер версии',
    label_size: 'Размер приложения',
    place_name: 'Поиск по имени',
    place_terminal: 'Пожалуйста, выберите терминал',
    empty_tips: 'Пожалуйста, выберите приолжение для привязки!',
    install_tips: 'Вы уверены, что хотите установить это приложение?',
    five_tips: 'Связанных приложений не может быть больше 5'

  },
  appList: {
    label_name: 'Имя приложения',
    label_type: 'Тип приложения',
    label_version: 'Номер версии',
    label_time: 'Время привязки',
    format_status1: 'Общее приложение',
    format_status2: 'Системное приложение',
    tips1: 'Вы уверены, что хотите удалить это приложение?',
    tips2: 'Отвязка выполнена успешно'

  },
  appLog: {
    start_time: 'Время начала',
    end_time: 'Время окончания',
    log_type: 'Тип лога',
    log_content: 'Содержимое лога',

    num: 'Число устройств',
    tower: ''

  },
  details: (_details = {
    regain: 'Сброс',
    run_log: 'Текущий лог',
    risk_info: 'Информация об управлении рисками',
    app_list: 'Список приложений',
    app_install: 'Установить приложение',
    send_animate: 'Загрузить анимацию',
    reset_animate: 'Восстановить анимацию',
    base_info: 'Базовая информация',
    system_info: 'Системные сообщения',
    launcher: 'версия загрузчика',
    system_version: 'Версия системы',
    system_spversion: 'Версия чипа безопасности',
    ota_version: 'Версия OTA',
    hard_version: 'Версия прошивки',
    last_time: 'Последнее обновление',
    net_type: 'Тип сети',
    online_time: 'Время в сети',
    run_time: 'Время работы',
    hard_info: 'Информация об оборудовании',
    Electric_quantity: "электричеств",
    network: "сет",
    cpu: 'Информация о процессоре',
    mem: 'Информация о памяти',
    cpuUsed: 'Использование процессора',
    memUsed: 'Использование памяти',
    hydh: 'Восстановить анимацию',
    tips: 'Пожалуйста, выберите тип анимации для восстановления',
    kjdh: 'Начальная анимация',
    gjdh: 'Анимация при выключении',
    kjlogo: 'Загрузочный логотип',
    alldhlogo: 'Все (анимация и логотип）',
    zbhy: 'Временно не восстанавливать',
    mshy: 'Восстановить немедленно',
    tsdh_title: 'Загрузить анимацию',
    animate_name: 'Имя анимации',
    animatType: 'Тип',
    position: 'Позиция воспроизведения',
    createTime: 'Время пользователя',
    animate: 'Анимация'
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "kjlogo", 'Загрузочный логотип'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "kj", 'Включено'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "gj", 'Выключено'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "kgj", 'Включено или выключено'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "com_send", 'Подтвердить загрузку'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "cover_send", 'Покрытие загрузки'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "skip_send", 'Пропустить загрузку'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "comfirm_send", 'Загрузить эту анимацию'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "comfirm_hy", 'Восстановить эту анимацию?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "hy_success", 'Восстановлено успешно'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "hy_type", 'Пожалуйста, выберите тип анимации для восстановления'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "open_abd", 'Открыть ADB'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "close_abd", 'Закрыть ADB'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "if_ope", 'Сделать или нет'), _details),
  list: {
    add_btn: 'Добавить',
    import_btn: 'Импортировать',
    ztgxsj: 'Последнее обновление',
    ac_time: "Время активации ТМS",
    ec_time: "Срок годности",
    import_title: 'Импортировать информацию об устройстве',
    xqwj: 'Выберите файл',
    qrdr: 'Вы уверены, что хотите импортировать?',
    import_muban: 'Скачать шаблон документа для импорта',
    notify_title: 'Результаты импорта',
    delete_tips: 'Эта операция удалит все устройства навсегда, действительно хотите продолжить?',
    deletes_tips: 'Эта операция удалит устройства навсегда, действительно хотите продолжить?',
    empty_tips: 'Пожалуйста, выберите устройства для удаления',

    excel_tips: 'Можно загрузить только файл Excel не более 10M'

  },
  OtaList: {
    lock_num: 'Версия заблокирована',
    lock_tips: 'Хотите разблокировать OTA?'

  },
  terRisk: {
    fkpz: 'Настройка управления рисками'
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "account", {
  delete_tips: 'Действительно хотите удалить этого пользователя?'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "mao_global", {
  btn: {
    sort: "сортировать",
    e: "Операция",
    cancel: "Отмена",
    add: "Добавить",
    edit: "Изменить",
    submit: "Отправить",
    update: "Изменить",
    delete: "Удалить",
    ok: "Подтверить",
    selectAll: "Выберите все",
    unSelectAll: "Снять все выделение",
    reset: "Сброс",
    createNow: "Отправить",
    confirmUpdate: "Действительно хотите изменить?"
  },
  tip: {
    text: "Приглашение",
    confirmDelete: "Действительно хотите удалить?",
    examine: "Обзор",
    pleaseSelect: "Пожалуйста, выберите",
    pleaseInput: "Пожалуйста, введите",
    search: "Запрос",
    notBlank: "Не может быть пустым",
    success: "Успешно",
    fail: "Ошибка",
    notPassExamine: "Отклонено",
    groundsForRefusal: "Пожалуйста, введите причину отказа",
    notReset: "Восстановление после удаления невозможно"
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "menu", {
  home: "Главная",
  terManage: "Устройство",
  terManageSub: {
    myTer: "Мое устройство",
    breakup: "Сделать резервную копию",
    lockOTA: "Заблокировать терминал",
    map: "Карта",
    log: "Лог",
    addTer: "Добавить устройства",
    detailTer: "Подробности терминала",
    riskInfo: "Информация об управлении рисками",
    runLog: 'Текущий лог',
    appList: 'Список приложений',
    appInstall: 'Установка приложений',
    otaLock: 'Блокировка OTA'

  },
  advertManage: "Реклама",
  advertManageSub: {
    list: "Список",
    examine: "Обзор",
    examineVideo: 'Видео',
    examineDetail: "Детали обзора",
    edit: "Изменить рекламу",
    editVideo: 'Изменить рекланое видео',
    detail: "Детали рекламы",
    vlist: "Видео реклама",
    vverify: "Видео обзор",
    addVideo: "Добавить рекламное видео",
    dfVList: "Список видео по умолчанию",
    addDfVideo: "Добавить видео по умолчанию"
  },
  appManage: "Приложения",
  appManageSub: {
    list: "Список приложений",
    market: "Магазин приложений",
    custom: "Добавить к моим настройкам",
    viewApp: "Посмотреть приложений",
    customPush: "Пользовательская загрузка",
    appPush: "Загрузка приложения",
    appBind: "Привязать терминал к приложению",
    examine: "Обзор приложения",
    verifyApp: "Посмотреть приложение",
    appEdit: 'Изменить приложение',
    appDetail: 'Детали приложения',
    uploadNew: 'Загрузить новую версию',
    uploadApp: 'Загрузить приложение'
  },

  safeManage: "Безопасность",
  safeManageSub: {
    certificate: "Список серитфиктов",
    certNew: "Создать сертификат",
    remote: "Удаленная авторизация",
    certUpload: "Загрузить серитфикат производителя",
    certDetail: "Детали сертификата",
    cerUpload: "Загрузить сертифкат",
    myCert: 'Мой сертификата'
  },
  taskManage: "Задачи",
  taskManageSub: {
    list: "Загрузка задач",
    detail: "Детали загрузки задач",
    listHis: "Загруженные задачи",
    detailHis: "Детали загруженных задач"
  },
  dataManage: "Данные",
  dataManageSub: {
    channel: "Торговая организация",
    factory: "Производитель",
    terClassify: "Тип устройства",
    terNum: "Модель устройства",
    advertClassify: "Тип рекламы",
    appClassify: "Тип приложения",
    newChannel: "Добавить торговую организацию",
    editChannel: "Изменить торговую организацию",
    newFirm: "Добавить производителя",
    editFirm: "Изменить производителя"
  },
  railManage: "Управление рисками",
  railManageSub: {
    penSetting: "Установить ограждение",
    warnSetting: "Информация о предупреждении",
    riskDetail: "Детали ограждения"
  },
  sysManage: "Система",
  sysManageSub: {
    romul: 'Загрузить OTA',
    romed: 'Изменить OTA',
    romOTA: "Список OTA",
    examine: "Обзор OTA",
    push: "Загрузить OTA",
    order: "Пользоавательская система",
    animation: "Пользовательская анимация при загрузке",
    animateCustom: "Пользовательская анимация",
    animatePush: "Загрузка анимации",
    pushHistory: "История загрузки",
    firmwareManage: 'Список прошивок',
    firmwareUpload: 'Загрузить прошивку',
    firmwareEdit: 'Изменить прошивку',
    firmwareCheck: 'Обзор прошивки',
    firmwareCheckDt: 'Детали прошивки',
    firmwarePush: 'Загрузка прошивки',
    firmwarePushDevice: 'Загрузка прошивки на устройства',
    launchManage: 'Список загрузчиков',
    launchCheck: 'Проверить загрузчик',
    launchEdit: 'Изменить загрузчик',
    launchNewVer: 'Загрузить новую версию загрузчика',
    verifyLaunch: 'Проверить загрузчик',
    addLaunch: 'Добавить загрузчик',
    launchDetail: 'Детали загрузчика',
    launchPush: 'Загрузить загрузчик',
    launchPushTer: 'Загрузить загрузчик на терминал'
  },
  setManage: "Настройки",
  setManageSub: {
    role: "Список ролей",
    system: "Системная конфигурация",
    menu: "Список меню",
    logo: 'Настройки логотипа'
  },
  accManager: "Учетная запись",
  accManagerSub: {
    account: "Информация об учетной записи",
    subAccount: "Вложенная учетная запись",
    addAccount: 'Добавить вложенную учетную запись',
    editAccount: 'Изменить вложенную учетную запись'
  },
  menuEdit: 'Редактирование меню'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "advert", {
  status: "Состояние",
  addAdvert: "Новая реклама",
  deleteAll: "Пакетное удаление",
  all: "Все",
  refusal: "Объясните причину",
  app: "Приложение",
  appSub: {
    name: "Имя",
    classify: "тип",
    uploadTime: "Время загрузки",
    version: "Номер версии"
  },
  isPass: "Результат",
  pass: "Подтверждено",
  notPass: "Отклонено",
  waitOne: "Ожидает отправки",
  waitTwo: "Ожидает рассмотрения",
  addDate: "Добавить время",
  addUser: "Добавившие",
  appName: "Имя приложения",
  img: "Изображение",
  name: "Имя",
  classify: "Тип",
  position: "Размешение",
  positionSub: {
    banner: "Главный баннер",
    starPage: "Стартовая страница"
  },
  jumpType: "Перенаправление",
  jumpTypeSub: {
    net: "Веб-страница",
    appStore: "Магазин приложений"
  },
  url: "URL",
  channel: "Торговая организация",
  ableDate: "Время истечения",
  beginDate: "Время начала",
  endDate: "Время окончания",
  contentImg: "Содержимое",
  reset: "Сброс"
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "index", {
  t: "",
  more: "Больше",
  terStatus: "Профиль устройства",
  onlineTer: "Устройства в сети",
  offLineTer: "Отключенные устройства",
  warnTer: "Устройства с предупреждениями",
  taskList: "Список задач",
  pullApp: "Выпуск приложения",
  romUpdate: "Обновление ROM",
  pullAdvert: "Загрузка рекламы",
  infoList: "Список информации",
  riskWarn: "Предупреждение от управления рисками",
  breakWarn: "Предупреждение о сбое"
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "menuConfig", {
  menu: {
    addMenu: "Добавить родительское меню",
    addMenu2: "Добавить меню",
    refreshMenu: "Обновить меню",
    menuName: "Назваине меню",
    selectModel: "Пожалуйста, выберите модуль",
    orderBy: "Сортировать серийные номера",
    notBlankName: "Имя не может быть пустым",
    editMenu: "Изменить меню",
    editSuccess: "Изменино успешно",
    addSubMenu: "Добавить подменю",
    relUrl: "Относительный путь"
  },

  role: {
    addRole: "Добавить роли",
    no: "Номер",
    name: "Имя",
    mark: "Описание",
    model: "Модуль",
    updatePermission: "Изменить разрешения",
    editRole: "Изменить роль",
    notBlankName: "Имя не может быть пустым",
    updateSuccess: "Обновлено успешно",
    deleteSuccess: "Удалено успешно",
    modelSelect: "Выберите модуль",
    addSuccess: "Добавлено успешно"
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "taskTypeNames", {
  ALL: "Все типы",
  APP: "Прилжение",
  OTA: "OTA",
  ROM: "ROM",
  FIRMWARE: "Прошивка",
  AD: "Реклама",
  STARTUP_ANIMATION: "Начальная анимация",
  SHUTDOWN_ANIMATION: "Анимация при выключении",
  STARTUP_SHUTDOWN_ANIMATION: "Вся анимация",
  LOGO: "Логотип",
  LAUNCHER: "Загрузчик",
  WALLPAPER: 'Обои'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_adname", 'Имя рекламы'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_allpush", 'Загрузить все'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_fipush", 'Загрузить файл импорта'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_isjtoviewtd", 'Вы перешли в детали задач чтобы отслеживать прогресс загрузки'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_mgsys", 'Доменное имя системы управления'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_edcode", 'Код авторизации обслуживания'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_sapp", 'Пожалуйста, выберите приложение'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_spic", 'Пожалуйста, выберите каритнку'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_iappnamesrch", 'Пожалуйста, введите имя запроса приложения'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_alltyps", 'Все типы'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_allpp", 'Все позиции воспроизведения'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_addur", 'Время рекламы'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_vsize", 'Размер видео'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_addtime", 'Добавить время'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_psverify", 'Аудит пройден'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_vpreview", 'Предварительный просмотр видео'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_cstandt", 'Длительность выбора и число повторений'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_additv", 'Добавить продолжительность'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_vdofile", 'файл видео'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_filename", 'Имя файла'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_vdodur", 'Продолжительность видео'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_clreulvdo", 'Нажмите для повтроной загрузки видео'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_adddfvdeoad", 'Добавить рекламное видео по умолчанию'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_addps", 'Дополнения'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_pltimes", 'Число воспроизведений'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_pldur", 'Продолжительность воспроизведения'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_csvldate", 'Выбор периода валидности'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_advdoad", 'Добавление рекламых видео'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_mgdfvdo", 'Управление видео по умолчанию'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_adstatus", 'Статус рекламы'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_addadtype", 'Новый тип рекламы'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_newapptype", 'Новый тип приложения'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_addmodel", 'Новая модель'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_newdvtype", 'Новый тип устройства'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_addfmname", 'Новое имя производителя'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_srpush", 'Подтверждение загрузки'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_ulfile", 'Загружаем файлы'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_ttpsddvnum", 'Загрузка завершилась на устройствах'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_srsktsdv", 'Вы хотите пропустить эти устройства'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_cvpush", 'Покрытие загрузки'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_skpush", 'Пропустить загрузку'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_pssuccess", 'Загрузка успешна'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_nowjump", 'Перейти немедленно'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_bcrecov", 'Пакетное уменьшение'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_skintro", 'краткое'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_addlc", 'Добавить загрузчик'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_ulinsfile", 'Загрузить установочные файлы'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_clreul", 'Нажмите для повторной загрузки'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_lcname", 'Имя загрузчика'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_rsfivemin", 'Автоматически обновлять каждые 5 минут'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_suresm", 'Подтверждение отправки'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_udfiletype", 'Тип загружаемого файла'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_plsltype", 'Пожалуйста, выберите тип'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_adnamenotnull", 'Имя рекламы не может быть пустым'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_plslchannel", 'Пожалуйста, выберите канал поставщика'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_plslplpos", 'Пожалуйста, выберите позицию воспроизведения'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_slsttime", 'Пожалуйста, выберите время начала'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_slendtime", 'Пожалуйста, выберите время окончания'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_addsc", 'Добавление успешно'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_vlsuccess", 'Аудит успешен'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_opsuccess", 'Операция завершилась успешно'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_srpassvf", 'Подтверить прохождение аудита'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_addvdoad", 'Добавление рекламных видео'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_edvdoad", 'Редактирование рекламных видео'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_sllimit", 'Выберите период валидности'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_srmuldel", 'Подтверить пакетное удаление'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_sttcanlateendtime", "Время начала не может быть позже времени окнчания"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_etcanelsttime", 'Время окнчания не может быть раньше времени начала'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_srdelpush", 'Подтверить удаления загрузки'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_srrecovsysdf", 'Не забудьте восстановить систему по умолчанию'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_rdless", 'Радиус ограждения меньше чем'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_srban", 'Подтверждение не пройдено'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_banandrs", 'Не пропустили? Пожалуйста, введите причины непрохождения'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_trjmap", 'Карта перемещения'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_psdonelftip", 'Имеется {num} устройств которые обновляются или обновились во время этой загрузки. Вы хотите пропустить эти устройства'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_psscandtip", 'Установка завершена успешно'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_csulpicbsis", 'Нажмите для загрузки картинки, лучший размер для отображения:'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_srch", 'Поиск'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_lkdevice", 'Найти устройства'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_app", 'приложение'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_firmw", 'прошивку'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_refresh", 'обновить'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_sleep", 'Ожидание'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_ccdown", 'Отмена скачивания'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_iscancelPush", 'Хотите отменить загрузку?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_fmVerIillegal", 'Номре версии неправильный, это должен быть номер, например 1.0.0'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_verror", 'Ошибка версии'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_other", 'другое'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_inssuccess", 'Успешная установка'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_tipterop", 'Прилашение операции терминала'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_autocmpl", 'Автозаполнение'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_noresetfs", 'Бягучы стан прылады на заводзе-вытворцы, звярніцеся да адміністратара Ачысціць'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_saleSt", 'Исходящее состояние'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_actst", 'Состояние активации'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_insfail", 'Сбой установки'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_checksignfail", 'Сбой проверки'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_srchcontent", ' Поиск содержимого '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_account", 'счета '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_opecontent", 'содержание работы '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_opetime", 'время работы '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_frzaccount", ' лед  узел  счета '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_operator", 'операции  человек '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_userip", ' пользователей  IP '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_deskwp", 'Обои'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_channelmcdetail", 'каналы операторов  детали '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_channellevel", 'канал бизнес  класса '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_cermanage", 'сертификат управления '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_lineimportcer", ' линия производства  импортировать  сертификат '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_devicemanage", 'устройство управления '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_fileimportdevice", 'Файл Импорт  оборудования '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_lineimportdevice", ' линия производства  импортировать  оборудование '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_prodmodel", 'вид продукта '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_plimportcer", 'линия производства  импортировать  сертификат клиента '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_importslorder", 'импорт  отдельных  заказов '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_importslcustomer", 'импорт  отдельных  клиентов '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_customername", 'имя клиента '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_orderno", 'Постановление № '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_orderfinishdate", ' дата  выполнения заказа '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_customerno", 'Кодировка  клиента '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_debuginfo", 'отладочной информации '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_adbstatus", ' АБР  государства '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_on1", 'открыть '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_off1", 'закрыть '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_devicemode", 'оборудование  режим '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_normalmode", 'нормальный режим '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_debugmode", 'режим отладки '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_signstatus", ' Состояние  проверки  подписать '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_catchlog", ' захват  журнал '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_tobenimportdv", 'предстоящего  импорта  оборудования'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_lineimporttip", ' пожалуйста,настройки  типа оборудования,поставщиков  базовых данных,моделей,адрес и т.д'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_cannotwithsysapp", 'не может содержать  системы применения '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_locktime", 'время блокировки '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_risksetting", ' ветер контроля  настройки '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_lockinfo", ' блокировка  информации '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_riskdetail", 'детали  раннего предупреждения '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_lockcity", 'замок  города '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_locklngandlat", 'блокировка  широта и долгота '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_lockstate", 'блокировка  описание '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_bindenclosure", ' обязательного  ограждения '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_unbindenclosure", 'решение  связать  забор '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_sureunlock", 'подтверждение  разблокировать '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_plsinputimgfile", ' Пожалуйста, загрузите  img  формат файла '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_animatefile", 'анимационные файлы '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_misstokentip", 'потери  логин,  нужно  снова войти в систему  разрешения '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_bglock", 'замок в фоновом режиме '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_request", 'уже  заявки '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_unrequest", 'не применяется '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_lockdevice", 'блокирующее устройство '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_pusheddvlist", 'Удаление приложения'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_appuninstall", 'применение  разгрузки '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_unlocked", 'Разблокировать '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_unlockdevice", 'Разблокировать  оборудования '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_pushnumcantfive", 'Тужься  , количество  не может превышать  5 '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_selectedappshoupass", 'Установите  применение, должны  в рамках ревизии '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_adRefreshfreq", 'частота обновления  рекламы '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_uninsfail", ' Не удалось удалить '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_uninssc", 'успешно Удалить '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_preversion", 'базовый вариант '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_rdneedmore", 'нужно  больше, чем  забор  радиус '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_addstfile", 'Добавить  файл конфигурации '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_filetag", 'идентификатор файла '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_filestss", 'описание конфигурации '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_uploadfilest", ' загрузить  файл конфигурации '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_excludeapp", 'исключает  применение '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_reupload", 'Загрузить  заново '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_excludefsttip", ' нажмите  Добавить  , чтобы исключить  применение  Введите  имя пакета  ,  полное применение  этой  точки  Enter  исключает  применение  всех  ,  по умолчанию  поддерживает  этот файл  конфигурации  приложений  могут  использовать этот  идентификатор '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_limitxml", 'предел  XML - файл '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_configfile", ' файл конфигурации '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_udversion", 'обновление  версии '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_udsamexml", ' Только  обновления  же  логотип  XML '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_udxmllowertip", 'обновление  версии  версии  будет  ниже, чем  сейчас  ,  в  записи в истории  , как представляется,  не  отображается в  списке '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_childacmg", ' Зи  счета  управления '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_unldvwftip", 'это оборудование  【{wl}】  обязательного  забор  ,  связаны  ли  также исключить  ? '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_udmode", 'режим обновления '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_append", 'Добавить '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_importapp", 'Импортировать  применение '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_adddate", 'Добавить дату '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_addtask", ' Добавить задачу '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_addtesttask", 'Добавить задачу  испытания '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_appdesc", ' применение  описание '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_srcdesc", 'описания ресурсов '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_downapp", 'загрузки приложения '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_downfile", 'загрузить файл '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_addsrc", 'Добавить  ресурсов '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_importsrc", 'Импорт ресурсов '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_srcname", 'имя ресурса '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_srcver", 'ресурсов  версии '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_downsrc", 'загрузки ресурсов '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_number", 'номер '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_softinfo", 'программное обеспечение  информации '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_allstatus", 'все  государства '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_mstype14", 'применение  Кодекса радикальные  Push  пистолет '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_mstype15", 'Кодекс спрятать  пистолет  файл ресурсов  Push '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_filedesc", 'Файл  описания '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_filetype", 'тип файла '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_subtype", 'подтип '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_addfile", 'Добавить файл '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_stmgpsw", 'пароль  конфигурации  управления'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_mapsl", 'карты  выбор '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_bdmap", 'Baidu  карты '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_map", 'карты '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_right", 'разрешение '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_addconfig", 'Добавить конфигурации '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_editconfig", 'Настройка редактора '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_mgpsw", ' управление  пароль '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_dvconfiglist", 'Настроить  список устройств '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_appconfigst", 'Настроить  применение государством '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_applytime", 'Использование  времени'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_secrname", ' имя  ключа '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_secrdesc", 'ключ  описание '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_addsecrrule", ' правила  добавить  ключ '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_editsecrrule", 'Редактор  правил  ключа '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_secrdvlist", 'ключ  список устройств '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_secrupdatest", ' ключ  обновления статуса '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_waitupdate", ' обновляться '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_addrandport", 'адрес  и  порт '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_filepath", 'путь к файлу '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_queryudfre", 'частота обновления  запроса '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_lcupload", ' местные загрузить '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_hour", 'час'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_addofcloud", ' добавка в облаках '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_bglist", ' Список задней части '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_cntype", 'способ соединения '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_codegunsrc", ' ресурсы для подметания оружия '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_rtosgunsrc", 'Ресурсы ртос'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_rots_1", "Прикладной app"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_rots_2", "ресурсы"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_rots_3", "Sys системы"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_rots_4", "Версия sp с прошивкой чипа безопасности"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_rots_5", "Управляемая версия mt"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_partpkg", 'добавочный пакет '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_codegunapp", ' подметание пистолета '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_starttime", 'начало времени '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_oilmcsrc", 'ресурсы для заправочных машин '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_downtpl", 'Загрузка шаблонов '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_plsstype", 'Пожалуйста, выберите подтип, пожалуйста. '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_allstyps", 'весь подтип '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_ftooltip", ' мультимедийная картинка / LGA '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_appendpush", 'дополнительная доставка '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_ipitonlylgchar", ' входной элемент может быть только законным символом, таким как английский и нижний. '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_enable", 'Включить '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_spfileis", 'файл поддерживается в формате '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_cnsetting", 'Параметры соединения '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_newtask", 'новое задание '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_adddv", 'Добавить оборудование '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_fileinsst", 'Настройка установки файлов '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_insscautoop", 'автоматическое открытие установки '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_pushsctipins", 'отдавать успешные подсказки '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_total", ' Общая сумма '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_wait", 'ожидание '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_pushing", 'подтолкнуть '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_pushsldev", ' подтолкнуть выбранное устройство '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_repushdv", 'перекладывать не поражение '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_outputdv", 'производное устройство '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_udtime", 'Время обновления '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_surepsxdv", 'подтверждение  push -  {num}  оборудование '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_apppush", 'подача приложения '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_fmwpush", 'прошивки  Push '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_advpush", 'рекламная подача '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_onampush", 'подтолкнуть с начала '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_offampush", 'посадка на выключение '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_onoffampush", 'Анимация выключателя '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_onlgpush", 'Открытие локомотива '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_wppush", 'обои подтолкнут. '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_stfpush", 'файл конфигурации  Push '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_codemc", 'очиститель кода '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_codemcsrc", 'Сканеры  ресурсов '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_sysud", 'Обновление системы '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_fmwud", 'обновление твердого тела '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_anmud", 'обновление картинки '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_qcgunsrcps", 'подметание пистолета '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_iscltask", 'определить отмену задания '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_resrc", 'ресурсы '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_srcfileps", 'файл ресурсов '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_fmVerIillegal1", ' номер версии не является законным, это должно быть с вв и цифрами, например, v1.0. 0'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_helptip", 'напоминание о помощи '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_newpsetnewver", 'новое издание TMS оттолкнуло к функциональному входу '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_newptdetail", '  после того, как будет передано функциональное изменение, пользователю нужно будет подтолкнуть на странице задания (Управление → заданием), нажмите на новую задачу, введите имя задания и выберите файл, который нужно отправить. '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_newptdetail1", '	после того, как новое задание будет выполнено, он автоматически выпрыгнул из задания. пользователь мог бы добавить оборудование в несколько раз. мы рекомендуем пользователю отправить небольшое количество оборудования перед большой партией.  провожать. '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_daterange", 'интерпретация даты '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_olinepday", 'ежедневное количество онлайн '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_onlineavgt", ' средний интервал онлайн '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_devicewhe", 'распределение оборудования '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_statistic", 'статистика '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_today", 'сегодня '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_thisweek", 'Эта неделя '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_thismonth", 'в этом месяце '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_addblfile", 'Добавить документ с черным списком '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_blacklsname", 'название черного списка '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_editblls", 'редактирование черного списка '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_blsdesc", 'описание черного списка '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_blsdvlist", 'Список оборудования для черного списка '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_wldesc", 'описание ограждения '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_filectncr", 'файл не является правильным '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_khour", 'время '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_kday", 'день '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_yesterday", 'вчерашний'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_rc15d", 'последние 15 дней '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_rc30d", 'последние 30 дней '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_stinfo", 'Информация о состоянии '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_croln", 'текущий онлайн '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_crslp", 'текущий спящий '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_croff", 'текущий уход '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_lstol", 'последнее время онлайн '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_lstsl", ' время последнего сна '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_lstof", 'последнее время выхода '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_limitiplg", 'ограничивать вход в систему IP. '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_illegal", 'незаконность '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_limitiptip", ' Пожалуйста, введите пункт IP, который должен быть ограничен и не вводит ограничения. '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_unknow", 'Неизвестный '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_hisstatus", 'историческое состояние '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_allowiplg", 'Разрешить вход в систему IP '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_allowiptip", ' Пожалуйста, введите разрешенный IP, а не вводите IP - доступ. '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_active1", 'оживление '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_unuse", 'не включено '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_addpsg", 'добавить проход'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_psgname", 'Название канала '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_authstat", ' режим разрешения '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_cbackad", 'обратный адрес '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_bsrqsadwl", 'Список адресов бизнес - запроса '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_appwtls", 'Список приложений '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_addapppgkn", 'Добавить список приложений '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_authopen", 'Открытие для открытия '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_authclose", 'разрешение на закрытие '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_addaddr", 'Добавить адрес '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_developer", 'Разработчик '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_editpasg", ' редактировать проход '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_usertype", 'Тип пользователя '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_generate", 'Образование '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_gentip", ' после того, как перерабатывает апплет, первоначальный апплет будет недействительным и не может продолжать подключиться к открытой платформе.  Было ли установлено, что перерабатывает апплет? '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_open1", 'запуск '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_hide", 'Скрыть '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_subtask", 'подзадача '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_sltstype", 'Выберите тип задания '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_command", 'команда'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_addsubts", 'Добавить подзадачу '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_commtype", 'тип директивы '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_taskpros", 'график работы '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_cursubts", 'текущая подзадача'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_commpush", 'подача команд '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_dvrestart", 'перезапуск оборудования '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_recvorgst", 'восстановление установки на заводе '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_recvanimt", 'восстановительная анимация '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_dvlock", 'устройство блокировки оборудования '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_dvunlock", 'заблокирование оборудования '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_inbdside", 'уже до границы. '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_subtsnum", 'количество подзадач '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_tscrtime", 'время создания задачи '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_ing", 'в середине '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_core", 'ядро '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_filesys", 'Файловая система '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_commd1fw", ' Модуль 1 модуля связи '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_commd2fw", ' Модуль 2 модуля связи '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_readcfw", 'стержень для считывания карт '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_pswkbfw", 'крепление пароля '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_scanhfw", ' сканирование головки для сканирования головки '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_actpossp", 'Активировать диалекту Pos '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_natpossp", 'закрытие разговора POS '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_setcallf", 'Настройка функции разговора '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_clupappdt", 'очистка данных приложения '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_isclupappdt", 'определение данных для расчистки '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_impdistbt", ' Импортирующий канал '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_impmctip", ' Оставайтесь на доске, только поддерживайте excel и не более 10 м. '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_callfunc", 'функция разговора '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_protocal", 'соглашение '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_prtsltip", ' при выборе веб - веб - сайта необходимо гарантировать, что интерфейс поддерживается этим соглашением. '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_rgsvpm", ' уполномоченные параметры службы '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_rgsvip", 'уполномоченный сервисный IP '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_bgntpm", 'Параметры уведомления '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_bgntip", 'записать IP '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_port", 'порт'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_flexist", 'Файл уже существует '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_cerid", 'отпечаток пальца '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_wallpaper", 'обои '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_forceins", 'принудительная установка '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_autorun", 'автоматическая работа '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_cusins", 'монтажный монтаж '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_cusuins", 'загруженная выгрузка '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_forcerun", ' принудительное исполнение '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_pushtest", 'тестовый тест '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_pltfblt", 'объявление о платформе '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_addblt", 'добавить объявление '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_blttt", 'заголовок бюллетеня '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_readnum", 'количество чтений '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_bltct", 'Содержание бюллетеня '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_pltudrd", 'платформа была обновлена '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_udlog", 'журнал обновления '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_addver", 'добавленная версия '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_pubdate", 'дата публикации '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_updct", 'обновить содержание '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_editblt", ' редактирование бюллетеня '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_editver", 'редактирование версии '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_verupdate", 'обновление версии '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_clviewdt", 'Нажмите для просмотра подробностей. '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_viewmore", 'Посмотри на это. '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_comptime", 'время компиляции '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_insafnorun", 'неавтоматический запуск после установки '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_normalins", 'обычный монтаж '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_normalunins", 'обычная разгрузка '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "appp_tipoperate", 'Подсказка для подсказки '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_onlyprov", ' избрать только провинцию '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_filepush", 'файл '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_region", 'область '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_srcmechan", 'производитель поиска по ключевому иероглифам '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_ckcode", 'код проверки '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_cantuins", 'невыгруженная загруженность '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_ippkgname", 'Введите имя пакета'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_onlypicfm", ' только файлы формата изображений (JPG, PNG, GIF...) '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_fludlist", 'Обновить список файлов '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_param", 'Параметры '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_catching", 'пойман'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_ulding", 'загружается'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_ulyet", 'Загрузка завершена'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_endcatch", 'закончить захват '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_iscatch", ' установить начало захвата ？'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_opterinfo", 'Экспорт терминальной информации'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_bcopterinfo", 'пакетный экспорт информации'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_cpttime", 'время отсечки '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_eqcapture", 'экран устройства '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_scapture", 'ширма '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_surestcap", 'установить снимок экрана ？'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_lokscrn", "блокирующий экран"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_ulkscrn", "откройте экран"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_appautrn", "приложение самоактивируется"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_perms", 'Единица: миллисекунды'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_wattime", 'Время ожидания.'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_lcswitch", 'переключение Launcher '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_appadv", 'прикладная реклама '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_cardno", 'номер карточки'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_trdno", 'поточный номер'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_batcno", 'номер партии'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_amout", 'сумма'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_mechno", 'коммерческое предприятие'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_trdtime", 'время операции'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_trddate", 'дата сделки'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_trdcore", 'основной поток'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_expno", 'справочный номер'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_trdtype", 'тип операции'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_rectime", 'время записи'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_fpaddrs", 'портретный адрес'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_propcut", 'пропорциональное обрезание '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_getcash", 'получение текущего'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_lctrans", 'перевод строки'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_obtrans", 'перевод строки ему'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_coretrans", 'основной поток'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_tradeNo", 'номер сделки'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_export", 'производный '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_ctrc", 'устройство считывания карт с магнитными полосами'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_icrc", 'ICCA считыватель карт'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_prtst", 'состояние принтера'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_pswkb", ' клавиатура пароля'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_idfrc", 'устройство считывания удостоверений личности'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_led", 'LED'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_beep", 'пищик'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_codebar", 'штрих - код'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_lulog", 'Просмотр журнала'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_lust", 'вид состояния'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_mdclst", 'модуль вызова статистики'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_fcclst", 'метод вызова статистики'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_acauth", 'активировать разрешение кода'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_authcode", 'код активации'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_authrange", 'срок действия программы'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_delact", 'временная активация '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_pswtip", 'пароль должен быть больше 8 бит, включая прописные буквы, строчки, цифры и специальные символы '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_phontrs", 'номер телефона '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_mulfcau", '多因子认证'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_verifc", '验证'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_opmfackip6dycode", '请打开MFA验证器，输入6位动态验证码'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_cantprvmcodectadm", '如不能提供多因子认证验证码，请与管理员联系'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_lsstep", '上一步'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_nxstep", '下一步'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_ckidt", '验证身份'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_istapp", '安装应用'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_bindmfa", '绑定MFA'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_ipaclgpsw", '输入账号登录密码'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_bindsfdv", '  绑定安全设备'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_psfwtsstepop", '请按以下步骤完成绑定操作'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_sixnumb", '6位数字'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_phdnalyappggidck", '请在手机端下载并安装阿里云APP/Google Authenticator（身份验证器）'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_ipappstsagidck", 'iphone：在AppStore搜索阿里云APP/Google Authenticator（身份验证器）'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_adappmksagidck", 'Android：在应用市场搜索阿里云APP/Google Authenticator（身份验证器）'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_afistclnxitbpagiinx", '安装完成后点击下一步进入绑定页面（如已安装，直接进入下一步）'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_usalyagidckscqrc6code", '使用阿里云APP/Google Authenticator（身份验证器）扫描以下二维码，获取6位验证码'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_sftkck", '安全令牌验证'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_ip6codeubac", '输入6位验证码解除绑定账户'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_plipopenalyappoggidckip6dycd", '请在手机中打开阿里云APP或Google Authenticator（身份验证器）,请输入6位动态码'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_select_timelist", "Избирательный диапазон времени"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_batch_migration", "Массовая миграция"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_expired_button", "Срок годности истек за последние 7 дней"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ru, "app_sure_migration", "Подтверждаю миграцию."), _ru);

/* harmony default export */ __webpack_exports__["a"] = (ru);

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _lin_global, _details, _zh_cn;

var zh_cn = (_zh_cn = {
  pushTip: {
    pushType0: "本次推送有{nums}台设备已完成推送, 您要跳过这些设备吗?",
    pushSuccess: "是否跳转至任务详情查看推送进度?",
    push_all_by_mem: "是否推送渠道商: {mem}下的全部设备",
    push_all: "是否推全部渠道商下的全部设备"
  },
  ter: {
    state1: '激活成功',
    state2: '激活失败',
    state3: '等待激活',
    mechName: '渠道商',
    status: '状态',
    createTime: '操作时间',
    terminalNo: '终端编号',
    msg: '是否确认删除'
  },
  IncorrectaFormat: 'Wrong Format. Please Upload Xls Or Xlsx File',
  app_certificate_1: "一级证书",
  app_certificate_2: "二级证书",
  app_certificate_1_psp: "一级证书",
  app_certificate_2_psp: "二级证书",
  app_pushAll: '推送全部设备',
  app_uploadApp: '上传应用',
  app_No: '序号',
  app_terNo: '终端编号',
  app_name: '名称',
  psp_app_id: "应用标识",
  psp_app_version: "版本",
  app_appName: '应用名称',
  psp_app_manage: "应用管理",
  psp_unstall_manage: "卸载管理",

  app_appUpList: "应用设备更新列表",
  app_appType: '应用类型',
  app_insType: '安装类型',
  app_vStatus: '审核状态',
  app_ulTime: '上传时间',
  app_verror: '版本异常',
  app_tipterop: '提示终端操作',
  app_autocmpl: '自动完成',
  app_appLoding: '应用正在上传',
  app_newgVer: '最新版本号',
  app_fmVerIillegal: '版本号不合法，必须是数字，如1.0.0',
  app_fmVerIillegal1: '版本号不合法，必须是带v和数字，如v1.0.0',
  app_operate: '操作',
  app_type: '类型',
  app_del: '删除',
  app_pause: '暂停',
  app_continue: '继续',
  app_status: '状态',
  app_new: '新增',
  app_yes: '是',
  app_no: '否',
  app_selectAll: '全选',
  app_save: '保存',
  app_process: '进度',
  app_push: '确认推送',
  app_terminal: '终端',
  app_to: '到',
  app_offShelf: '下架',
  app_mulOffShelf: '批量下架',
  app_isOffShelf: '确定要下架应用？',
  app_isDelApp: '确定要删除应用？',
  app_chooseOneMust: '至少选择一个应用',
  app_cantDelTask: '选中包含了不能删除的任务',
  app_oneRecordMust: '至少选中一条记录',
  app_phoneIllegal: '手机号码不合法',
  app_groupName: '分类名称',
  app_sure: '确认',
  app_query: '查询',
  app_reset: '重置',
  app_cancel: '取消',
  app_edit: '编辑',
  app_add: '添加',
  app_verify: '审核',
  app_isPass: '是否通过',
  app_pass: '通过',
  app_ban: '不通过',
  app_noInput: '未填写',
  app_banReason: '拒绝原因',
  app_filter: '筛选',
  app_prePushVerify: '待送审',
  app_preVerify: '待审核',
  app_verifyPass: '通过',
  app_verifyNotPass: '不通过',
  app_success: '成功',
  app_submit: '提交',
  app_other: '其他',
  app_tip: '提示',
  app_online: '在线',
  app_offline: '离线',
  app_fileOver: '文件超过',
  app_onlyApk: '只能上传apk文件',
  app_onlyApk_2: '只能上传apk/hap文件',
  app_tipViewTask: '推送成功，请在任务管理中查看推送进度',
  app_tipMkDel: '删除应用后应用市场的应用也会同步删除，确定删除？',
  app_clearTask: '是否清空所有所有设备？',
  app_tipAppEdit: '删除将不可恢复，确定删除？',
  app_tipVerify: '确定要提交审核吗?',
  app_rqsError: '请求出错',
  app_not_auth: 'TMS未激活',
  app_mulAdd: '批量添加',
  app_select: '请选择',
  app_input: '请输入内容',
  app_inputCp: '请填写完整',
  app_inputName: '请输入名称',
  app_inputContact: '请输入联系人',
  app_inputTruePhone: '请输入正确号码',
  app_inputAddr: '请输入地址',
  app_inputVer: '请输入版本',
  app_inputVerTag: '请输入版本标识',
  app_inputID: '请输入文件的唯一标识',
  app_inputPkg: '请输入包名',
  app_noVerTag: '没有版本标识',
  app_noresetfs: '设备当前为工厂状态，请联系管理员清除',
  app_saleSt: '出厂状态',
  app_actst: '激活状态',
  app_inputIntrol: '请输入描述',
  app_selectType: '请选择应用类型',
  app_ulApp: '请上传应用',
  app_ulIcon: '请上传小图标',
  app_ulLarIcon: '请上传大图标',
  app_smVerify: '提交审核',
  app_baseInfo: '基本信息',
  app_version: '版本号',
  app_autoUpload: '自动填写',
  app_verTag: '版本标识',
  app_ID: '唯一标识',
  app_package: '应用包名',
  app_introl: '应用简介',
  app_udState: '更新说明',
  app_ulScreenShot: '请上传截图',
  app_icon: '应用小图标',
  app_larIcon: '应用大图标',
  app_screenShot: '应用截图',
  app_appVer: '应用版本',
  app_createTime: '创建时间',
  app_close: '关闭',
  app_ulNew: '上传新版',
  app_selectApp: '选择应用',
  app_testInstall: '安装测试',
  app_ulAppState: '将文件拖到此处，或点击上传，仅支持apk文件上传',
  app_ulAppState_2: '将文件拖到此处，或点击上传，仅支持apk/hap文件上传',
  app_clickUpdate: '点击上传',
  app_udType: '更新方式',
  app_allUpdate: '全量更新',
  app_asc: '升序',
  app_desc: '降序',
  app_utasc: '更新时间升序',
  app_utdesc: '更新时间降序',
  app_iconState: '144x144,大小100k以内',
  app_larIconState: '512x512,大小200k以内',
  app_autoInstall: '自动安装',
  app_addApp: '添加应用',
  app_classIntrol: '分类推荐',
  app_homeIntrol: '首页推荐',
  app_isIntroClass: '是否推荐到分类',
  app_isIntroHome: '是否推荐到首页',
  app_isUnbindApp: '确定要卸载应用？',
  app_isOffApp: '确定要下架应用？',
  app_isDelData: '确定要删除这条数据吗',
  app_inputAName: '请填入个名称',
  app_oneDeviceMust: '至少选择一个设备',
  app_fileSize: '文件大小',
  app_addPush: '添加推送',
  app_viewPushHis: '查看推送历史',
  app_pushTimes: '推送次数',
  app_hisVer: '历史版本',
  app_pushHistory: '推送历史',
  app_pushInstall: '推送安装',
  app_animatePush: '动画推送',
  app_animateMake: '定制动画',
  app_pushDevice: '已推送设备',
  app_ustart: '未开始',
  app_outofdate: '已过期',
  app_deviceNum: '设备数量',
  app_deviceName: '设备名称',
  app_deviceNo: '设备编号',
  app_pushTime: '推送时间',
  app_distributor: '渠道商',
  app_dParent: '上级渠道商',
  app_unbind: '卸载',
  app_mulUnbind: '批量卸载',
  app_mulPush: '批量推送',
  app_searchTerminal: '终端号或名称搜索',
  app_terName: '终端名称',
  app_taskName: '任务名称',
  app_taskDetail: '任务内容',
  app_deviceTotal: '设备总数',
  app_downloading: '下载中',
  app_downFail: '下载失败',
  app_update: '更新',
  app_md5Fail: 'MD5校验失败',
  app_theNewgVer: '终端上已安装最新版本',
  app_fileFmIllegal: '文件格式不正确',
  app_updateFail: '更新失败',
  app_usrCancelUpdate: '用户取消更新',
  app_pushFail: '设备离线',
  app_downFinish: '下载完成',
  app_updateSuccess: '更新成功',
  app_fail: '失败',
  app_addres: '地址',
  app_mulDel: '批量删除',
  app_allDel: '全部删除',
  app_contact: '联系人',
  app_contactPhone: '联系电话',
  app_typeName: '类型名称',
  app_customs: '定制',
  app_clear: '清除',
  app_customsTime: '定制时间',
  app_launchAnimate: '开关机动画',
  app_onLogo: '开机LOGO',
  app_animateName: '动画名称',
  app_playPlace: '播放位置',
  app_aSrcFile: '动画资源文件',
  app_asfState: '动画分解画面,注意文件名一定要是 part0.zip',
  app_downExp: '下载示例',
  app_ologoState: '动画播放停止后显示的画面',
  app_picSize: '图片尺寸',
  app_picSizeState: '填入宽*高',
  app_frame: '帧数',
  app_frameState: '每秒播放动画数量',
  app_aCycleTime: '动画循环次数',
  app_cyclePlay: '循环播放',
  app_playOnce: '播放一次',
  app_fileNameOnly: '文件名必须是',
  app_inputNumber: '请输入数字',
  app_picUlError: '图片上传错误',
  app_inputAnimateName: '请输入动画名称',
  app_selectAnimateType: '请选择动画类型',
  app_selectPlayPlace: '请选择播放位置',
  app_uploadAnimateFile: '请上传动画文件',
  app_uploadOnPic: '请上传开机图片',
  app_sureDelTip: '确定要删除？删除后将不能恢复',
  app_uploadPic: '请上传图片',
  app_launchUI: '启动界面',
  app_amechine: '台',
  app_chooseCycleType: '请选择循环方式',
  app_formatNotTrueLike: '格式不正确，如',
  app_on: '开机',
  app_off: '关机',
  app_onOff: '开关机',
  app_firm: '厂商名称',
  app_terstatus: '终端状态',
  app_fminfo: '固件信息',

  add_srcFwByName: '通过名称查找固件',
  app_downNum: '下载次数',
  app_pushed: '已发布',
  app_notPass: '未通过',
  app_sysType: '系统类型',
  app_sys: '系统',
  app_sysUdPack: '系统升级包',
  app_chooseFile: '选择文件',
  app_signCer: '签名证书',
  app_isUseDisCerAutoSign: '是否使用渠道商证书进行自动签名',
  app_useDis: '指定渠道商',
  app_allDisUsed: '所有渠道商通用',
  app_pushInstallTest: '推送安装测试',
  app_firmware: '固件名称',
  app_pushType: '推送类型',
  app_dv: '设备',

  app_fwType: '固件类型',
  app_ulNormalSt: '将文件拖到此处，或点击上传',
  app_selectChannel: '请选择渠道商',
  app_isSubmitToCheck: '是否提交审核',
  app_pleaseInputNo: '请输入终端编号',

  app_cnAndActive: '联机激活',
  app_clearCer: '证书清除',
  app_ofCheck: '开关验签',
  app_normal: '正常',
  app_insfail: '安装失败',
  app_checksignfail: '验签失败',
  app_netStatus: '网络状态',
  app_active: '激活',
  app_initiative: '主动',
  app_selfDestroy: '自毁',
  app_mulActive: '批量激活',
  app_selected: '已选',
  app_cerCheckOf: '验签开关',
  app_openCerCheck: '打开验签',
  app_closeCerCheck: '关闭验签',
  app_reOpen: '重新打开',
  app_reClose: '重新关闭',
  app_open: '打开',
  app_usrManage: '用户管理',
  app_stManage: '配置管理',
  app_roleManage: '角色管理',

  app_cerMgType: '证书管理类型',
  app_cerMgSelf: '自管证书',
  app_cerMgOther: '代管证书',
  app_cerMgCustomer: '客户定制',
  app_operateHis: '操作历史',
  app_operateType: '操作类型',
  app_time: '时间',
  app_isActive: '确定要激活吗',

  app_downCer: '下载证书',

  app_isOperate: '确定进行操作吗',

  app_ulSuccess: '上传成功',

  app_setting: '设置',

  app_clickPicToUlPic: '点击图片位置选择上传图片',
  app_within: '以内的',
  app_pgsFormat: 'png、gif、svg格式',
  app_sgUseAndAdUse: '建议使用svg格式，图片颜色建议使用白色',
  app_sureChange: '确认更改',
  app_logoLvTip: '有未保存的更改，是否离开',
  app_dfIcon: '默认图标',

  app_useBigSize: '使用大号尺寸',
  app_useBigSizeTip: 'logo视觉偏小时选择此项改善',

  app_or: '或',
  app_format: '格式',
  app_pic: '图片',
  app_s: '的',
  app_plsUpl: '请上传',

  app_upload: '上传',
  app_cerType: '证书类型',

  app_editProfile: '编辑资料',

  app_cerFile: '证书文件',
  app_plsUlPbCer: '请上传客户证书',
  app_appNoCerTip: '当前渠道商为自管证书渠道商，请上传公钥文件，以便进行应用验签',
  app_appNeedCerTip: '当前渠道商没有证书，请联系平台管理员创建',
  app_createCer: '创建证书',
  app_uploadCer: '上传证书',

  app_fileImport: '文件导入',
  app_mdFile: '模版文件',
  app_down: '下载',

  app_roleAllot: '分配角色',
  app_roleName: '角色名称',
  app_downTplFile: '下载模板文件',

  app_verUdCt: '版本更新内容',
  app_animation: '动画',
  app_per: '每',
  app_geo: '地理位置',
  app_minute: '分钟',
  app_hbsp: '心跳间隔',
  app_rcmsg: '接收信息',
  app_autoRefresh: '自动刷新',
  app_checkupsp: '检查更新间隔',
  app_level: '等级'
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_firm", '厂商'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_model", '型号'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_adType", '广告类型'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_license", '授权码'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_maintain", '维护'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_manage", '管理'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_is", '是否'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_plsip", '请填写'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_reason", '理由'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_sgMc", '单台设备'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_ss", '简介'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_inst", '安装'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_file", '文件'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_printscreen", '截图'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_batch", '批量'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_recov", '还原'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_lc", 'launcher'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_re", '重新'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_sysinfo", '系统信息'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_confirm", '确定'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_df", '默认'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_as", '为'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_click", '点击'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_content", '内容'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_ttPkg", '全量包'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_dfPkg", '差分包'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_task", '任务'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_catch", '抓取'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_log", '日志'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_continued", '持续'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_sec", '秒'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_video", '视频'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_ad", '广告'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_choose", '选择'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_timeInterval", '时段'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_and", '和'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_play", '播放'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_times", '次数'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_sc", '次'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_tofvalis", '有效期'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_tofvaliss", '有效期限'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_start", '开始'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_end", '结束'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_preview", '预览'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_duration", '时长'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_size", '尺寸'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_personnel", '人员'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_cannot", '不能'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_early", '早于'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_later", '晚于'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_lessThan", '小于'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_moreThan", '大于'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_nums", '数量'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_waiting", '等待中'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_all", '全部'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_all1", '所有'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_thistime", '本次'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_done", '完成'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_areyou", '您要'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_skip", '跳过'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_these", '这些'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_cover", '覆盖'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_jump", '跳转'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_detail", '详情'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_view", '查看'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_now", '立即'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_imp", '导入'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_size1", '大小'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_taskMg", '任务管理'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_inssuccess", '安装成功'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_taskType", '任务类型'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_cancelPush", '取消推送'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_iscancelPush", '是否取消推送?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_azcgsj", '安装成功时间'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_ispushf", '是否推送文件'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_autoscopen", '安装成功自动打开'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_pushsctipinstall", '推送成功终端提示应用下载'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_tipdown", '提示下载'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_tipud", '提示安装'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_bth", '回到主页'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_norightview", '您没有访问此页面权限'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_fault", '故障'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_abnormal", '异常'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_blockp", '卡纸'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_ecr", '电动读卡器'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_mcr", '手动读卡器'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_nacr", '非接读卡器'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_cardr", '刷卡器'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_tgcr", '二代证阅读器'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_receiptp", '凭条打印机'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_ispushalldv", '是否推送全部设备'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "lin_btn", {
  cancel: "取消",
  add: "添加",
  install: '安装',
  batch_install: '批量安装',
  tips: '提示',
  confirm: '确定',
  unbind: '解绑',
  unbindAll: '批量解绑',
  check: '查询',
  reset: '重置',
  submit: '提交',
  restart: '重启',
  off: '关闭',
  send: '推送',
  batch_delete: '批量删除',
  delete: '删除',
  lock: '锁定',
  lockOta: '锁定OTA',
  add_zeng: '增加',
  edit: '编辑',
  save: '保存',
  bind: '绑定',

  bindAll: '批量绑定',
  xiezai: '卸载',
  unlock: '解锁',
  change: '修改'

}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "lin_global", (_lin_global = {
  cs_config: '参数配置',
  task_tips: '安装成功,请在任务管理中查看推送进度',
  task_tips2: '推送成功，请在任务管理中查看推送进度',
  ope: '操作',
  pselect: '请选择',
  label_no: '设备编号',
  loading: '数据加载中',
  label_name: '设备名称',
  all_mechanism: '所有渠道商',
  place_areaid: '请选择渠道商',
  time: '时间',
  version: '版本',
  name: '名称',
  remark: '备注',
  edit: '编辑',
  label_model: '设备型号',
  label_type: '设备类型',
  device_type_1: "智能POS",
  device_type_2: "其他设备",
  label_manufid: '设备厂商',
  label_areaid: '渠道商',
  label_areaid_name: '渠道商名称',
  label_address: '设备地址',
  ter_status: '设备状态',
  dest_status: '自毁状态',
  net_status: '联网状态',
  run_status: '外设状态',
  online: '在线',
  offline: '离线',
  new_add: '新增',
  normal: '正常',
  marn: '预警',
  fault: '故障',
  success_tips: '操作成功',
  concel_tips: '已取消',
  zlxfs_tips: '指令下发成功',
  sb_tips: '操作失败，终端已离线',
  czsb: '操作失败',
  zl_error: '指令下发出错',
  all_status: '所有状态',
  delete_success: '删除成功',
  look_detail: '查看详情',
  ter_num: '设备数量',
  ota_bao: 'OTA包',
  ple_sel_ota: '请选择OTA包',
  unlock_success: '解锁成功',
  risk_name: '配置名称',
  risk_type: '预警类型',
  risk_radius: '围栏半径(KM)',
  risk_city: '设定省市',
  risk_desc: '描述',
  risk_warn_info: '风控预警信息',
  warn_event: '预警事件',
  city: '城市',
  jwd: '经纬度',
  distance: '超出设定距离(KM)',
  ccwl: '超出围栏',
  sbyj: '设备预警',
  done: '已处理',
  undone: '未处理',
  roles_tips: '请选择角色',
  roles_place: '通过昵称查找',
  userName: '用户名',
  nickName: '昵称',
  phoneNum: '手机',
  roleName: '角色',
  jh: '激活',
  dj: '冻结',
  phoneNum2: '手机号码',
  resetPass: '重置密码',
  revisePass: '修改密码',
  oldPass: '旧密码',
  newPass: '新密码',
  comfirmPass: '确认密码',
  plePassTips: '请输入密码',
  plePassTipsAgain: '请再次输入密码',
  pwdDisfault: '两次输入密码不一致',
  unfitPhone: '手机号码不合法',
  nickNameTips: '昵称不能为空',
  userNameTips: '用户名不能为空',
  phoneNumTips: '手机号码不能为空',
  roleidTips: '角色不能为空',
  mechanismIdTips: '渠道商不能为空',
  userStatusTips: '请设置用户状态',
  editPage: '编辑页面',
  addPage: '添加页面',
  status: '状态',
  refs: '请完善资料',
  user: '账号',
  logStartTime: '日志开始时间',
  logEndTime: '日志结束时间',
  download: '下载',
  ddsc: '等待上传',
  scz: '上传中',
  scsb: '上传失败',
  sccg: '上传成功',
  rz_tips: '日志获取成功，请在日志管理中查看下载进度',
  hqrz: '获取日志',
  logoTitle: '智能POS终端管理平台',
  hello: '您好',
  wdzl: '我的资料',
  tcxt: '退出系统',
  yhdl: '用户登录',
  zh: '账号',
  password: '密码',
  jzmm: '记住密码',
  login: '登录',
  bah: '深圳市证通电子股份有限公司 © 1993-2020 版权所有 粤ICP备12035887号',
  qsrzh: '请输入账号',
  qsrmm: '请输入密码',
  error: '错误',
  wlzt: '网络状态',
  ckxq: '查看详情',
  wlmc: '围栏名称',
  wllx: '围栏类型',
  bdsb: '绑定设备',
  tjbd: '添加绑定',
  bjwl: '编辑围栏',
  wxzyjlx: '请选择预警类型',
  cityName: '城市名称',
  sfjxpljb: '是否进行批量解绑',
  qxzyjbdzd: '请选择要解绑的终端',
  jbcg: '解绑成功',
  sfjbczd: '是否解绑此终端',
  sfjxplbd: '是否进行批量绑定',
  qxzybddzd: '请选择要绑定的终端',
  bdcg: '绑定成功',
  sfbdczd: '是否绑定此终端',
  xzwl: '新增围栏',
  qdxysccwl: '确定需要删除此围栏',
  tsazcs: '推送安装测试',
  shzt: '审核状态',
  pass: "通过",
  notPass: "不通过",
  waitOne: "待送审",
  waitTwo: "待审核",
  shyy: '审核原因',
  zdtslb: '终端推送列表',
  xztghbtg: '选择通过或者不通过',
  qrtj: '确认提交',
  shcg: "审核成功",
  syqdsty: '所有渠道商通用',
  notBlankName: "名称不能为空",
  notBlankVer: '版本号不能为空',
  qxzlx: '请选择类型',
  qxzscwj: '请选择上传文件',
  zdqds: '指定渠道商',
  sfsyzdqm: '是否使用渠道商证书进行自动签名',
  qmzst: '签名证书',
  azbdz: '安装包地址',
  qscapkwj: '请上传apk文件，且不超过50M',
  qsczipwjls50: '请上传zip文件，且不超过50M',
  jwjtdcc: '将文件拖到此处，或',
  djsc: '点击上传',
  xgscwj: '修改上传文件',
  otaName: '名称',
  xtlx: '系统类型',
  syatemR: '系统ROM',
  sysjota: '系统升级包OTA'
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "waitOne", "待送审"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "waitTwo", "待审核"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "verifyPass", '通过'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "verifyNotPass", '不通过'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "confirmDelete", "确定删除?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "tjshcg", '提交审核成功'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "qdtjsh", '确定提交审核'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "allType", '所有类型'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "smVerify", '提交审核'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "downNumber", '下载次数'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "tgmccz", '通过名称查找'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "upload", '上传'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "xzqddhwj", '选择启动动画文件'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "qxzkjlogo", '选择开机LOGO'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "tpxzds", '图片最佳尺寸300x300,体积不大于2m'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "zmlaun", '选择定制桌面launcher'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "xtjcb", '选择系统基础包'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "null", '无'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "shebei", '设备'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "tslxxx", '推送类型'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "xzbbbbb", '选择OTA包'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "uploadTime", "上传时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "verTips", '基于此版本生成的差分包，版本号不带v或version等字符，纯数字，如：2.2.4'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "verTips1", '版本号不带v或version等字符，纯数字，如：2.2.4'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "bbhgsbd", '版本号格式不对'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "lkymtips", '有文件正在上传, 是否确定离开此页面'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "znscziptips", '只能上传zip文件'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "qsczipwj", '请上传zip文件'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "danweikm", '单位KM'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "weilanshuoming", '说明：以设备最后一次心跳的经纬度为围栏中心'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "pleaseUpload", '请上传'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "zdqmTips", '是否绑定渠道商证书自动签名'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "zhidingqdsxx", '指定渠道商信息'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "selectWenjian", '选择文件'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "qrjxmm", '确认执行此命令：'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "cicaozuo", '操作？'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "shebeiedit", '设备编辑'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "yxpztitle", '邮箱配置'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "yjyouxiang", '报警邮箱'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "chongzhi", '重置'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "ljchangjian", '立即创建'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "ympeizhi", '域名配置'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "fwqdizhi", '服务器地址'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "fwqdztips", '地址不需要带"http://"字符，可以是域名地址也可以是IP地址，如：www.baidu.com或者127.0.0.1'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "fwqduankou", '服务器端口'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "duankoutips", '端口号不要加":"直接填写数字，如：8080'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "tuisongpeizhi", '推送配置'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "tuisongjl", '推送记录'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "tuisonglx", '推送类型'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "chenggong", '成功'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "shibai", "失败"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "tuisongtime", '推送时间'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "chongtui", '重推'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "shebeibei", '设备'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "fwqdzbnwk", '服务器地址不能为空'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "fwqdkhbnwk", '服务器端口号不能为空'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "wdct", '确定重推'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "tuisongtips", '是否确定推送以下域名配置，推送成功后重启生效。'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "china", '中文'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "english", '英文'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "cjzs", '创建证书'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "createTime", '创建时间'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "certificateName", '证书名称'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "xiafa", '下发'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "dachuzhengshu", '导出证书'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "guojia", '国家'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "shengfen", '省份'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "gongsi", '公司'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "youxiang", '邮箱'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "youxiaoqi", '有效期'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "certTypeLabel", '证书类型'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "certForManufacturer", '厂商证书'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "certForCustomer", '客户证书'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "danweitian", '单位：天'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "xinjian", '新建'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "notNull", '不能为空'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "bitian", '必填'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "guojiatips", '国家缩写，如CN'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "shenfentips", '省份英文／拼音，如GuangDong'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "cityTips", '城市英文／拼音，如GuangZhou'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "gongsiTips", '公司英文／拼音，如SZZT'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "emailTips", '请输入邮箱地址'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "youxiaoqiTips", '请输入证书有效期，如365'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "xuantian", '选填'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "srgsbzq", '输入格式不正确'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "cszss", '厂商证书'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "khzss", '客户证书'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "sccszss", '上传厂商证书'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "zhengshu", '证书'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "qudaoshangxinxi", '渠道商'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "quorter", '请选择渠道商或填写设备编号'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "xiafalishi", '下发历史'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "resXiafa", '重新下发'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "chongxintuisong", '重新推送'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "tuisongleixing", '推送类型'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "dachusiyao", '导出私钥'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "shuaxin", '刷新列表'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "passWordTips", '密码不能为空'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "daochugongyao", '导出证书'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "zhengshuType", '渠道商证书类型'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "ziguan", '自管'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "daiguan", '代管'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lin_global, "add_merchant", '新增渠道商'), _lin_global)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "terminal", {

  add: {
    place_no: "请输入设备编号",
    place_name: '请输入设备名',
    place_terminal: '请选择设备',
    place_model: '请选择设备型号',
    place_type: '请选择设备类型',
    place_manufid: '请选择厂商',
    place_address: '请输入设备地址',
    place_actime: '请输入设备激活时间',
    place_extime: '请输入设备过期时间',
    popover_no: '设备编号由长度不大于50位的字母、数字或下划线组成！',
    popover_name: '设备名由长度不大于50位的汉字、字母、数字或下划线组成！',

    rules_no_1: '设备编号不能为空',
    rules_no_2: '设备编号长度不能大于20位',
    rules_no_3: '设备编号由字母、数字或下划线组成',
    rules_no_4: '设备编号已存在！',
    rules_name_1: '设备名不能为空',
    rules_name_2: '设备名称长度不能大于30位',
    rules_name_3: '设备名称由汉字、字母、数字或下划线组成',

    success: '添加成功',
    change_success: '修改成功'

  },
  appBind: {
    label_name: '应用名称',
    label_version: '版本号',
    label_size: '应用大小',
    place_name: '输入应用名称搜索',
    empty_tips: '请选择你要绑定的应用!',
    install_tips: '确定需要安装此应用?',
    five_tips: '一次绑定的应用不能超多五个'

  },
  appList: {
    label_name: '应用名称',
    label_type: '应用类型',
    label_version: '版本号',
    label_time: '绑定时间',
    format_status1: '普通应用',
    format_status2: '系统应用',
    tips1: '确定需要卸载此应用',
    tips2: '解除绑定成功'

  },
  appLog: {
    start_time: '开始时间',
    end_time: '结束时间',
    log_type: '日志类型',
    log_content: '日志内容',

    num: '设备数量',
    tower: '台'

  },
  details: (_details = {
    regain: '恢复出厂设置',
    run_log: '运行日志',
    risk_info: '风控信息',
    app_list: '应用列表',
    app_install: '应用安装',
    send_animate: '推送动画',
    reset_animate: '还原动画',
    base_info: '基本信息',
    system_info: '系统信息',
    launcher: 'launcher版本',
    system_version: '系统版本',
    system_spversion: '安全芯片版本',
    ota_version: 'OTA版本',
    hard_version: '固件版本',
    last_time: '最后更新时间',
    net_type: '网络类型',
    online_time: '在线时长',
    run_time: '运行时长',
    hard_info: '硬件信息',
    Electric_quantity: "电量",
    network: "网络",
    cpu: 'CPU信息',
    mem: '内存信息',
    cpuUsed: 'CPU使用率',
    memUsed: '内存使用率',
    hydh: '还原动画',
    tips: '请选择动画还原类型',
    kjdh: '开机动画',
    gjdh: '关机动画',
    kjlogo: '开机LOGO',
    alldhlogo: '所有(动画和LOGO)',
    zbhy: '暂不还原',
    mshy: '马上还原',
    tsdh_title: '推送动画',
    animate_name: '动画名称',
    animatType: '类型',
    position: '播放位置',
    createTime: '定制时间',
    animate: '动画'
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "kjlogo", '开机LOGO'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "kj", '开机'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "gj", '关机'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "kgj", '开关机'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "com_send", '确定推送'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "cover_send", '覆盖推送'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "skip_send", '跳过推送'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "comfirm_send", '确定推送此动画?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "comfirm_hy", '确定还原此动画?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "hy_success", '还原成功'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "hy_type", '请选择还原动画类型'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "open_abd", '打开ADB'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "close_abd", '关闭ADB'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_details, "if_ope", '是否进行此操作'), _details),
  list: {
    add_btn: '添加设备',
    import_btn: '导入设备',
    ztgxsj: '状态更新时间',
    ac_time: "激活时间",
    ec_time: "过期时间",
    import_title: '导入设备信息',
    xqwj: '选取文件',
    qrdr: '确认导入',
    import_muban: '下载导入模板',
    notify_title: '导入结果提示',
    delete_tips: '此操作将永久删除该设备, 是否继续',
    deletes_tips: '此操作将永久删除所选设备, 是否继续?',
    empty_tips: '请选择要删除的设备',

    excel_tips: '只能上传Excel文件，且不超过10M'

  },
  OtaList: {
    lock_num: '锁定设备数',
    lock_tips: '确定需要解锁此OTA?'

  },
  terRisk: {
    fkpz: '风控配置'
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "account", {
  delete_tips: '确定需要删除此用户'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "mao_global", {
  btn: {
    sort: "排序",
    e: "操作",
    cancel: "取消",
    add: "添加",
    edit: "编辑",
    submit: "提交",
    update: "修改",
    delete: "删除",
    ok: "确定",
    selectAll: "全选",
    unSelectAll: "全不选",
    reset: "重置",
    createNow: "立即创建",
    confirmUpdate: "确定修改"
  },
  tip: {
    text: "提示",
    confirmDelete: "确定删除?",
    examine: "审核",
    pleaseSelect: "请选择",
    pleaseInput: "请输入",
    search: "查询",
    notBlank: "不能为空",
    success: "成功",
    fail: "失败",
    notPassExamine: "未审核通过",
    groundsForRefusal: "请填写拒绝理由",
    notReset: "删除后将不能恢复"
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "menu", {
  home: "首页",
  terManage: "设备管理",
  terManageSub: {
    myTer: "我的设备",
    breakup: "终端备份",
    lockOTA: "终端锁定",
    map: "终端地图",
    log: "日志管理",
    addTer: "添加设备",
    detailTer: "终端详情",
    riskInfo: "风控信息",
    runLog: '运行日志',
    appList: '应用列表',
    appInstall: '应用安装',
    otaLock: 'OTA锁定'

  },
  advertManage: "广告管理",
  advertManageSub: {
    list: "广告列表",
    examine: "广告审核",
    examineVideo: "视频广告审核",
    examineDetail: "审核详情",
    edit: "编辑广告",
    editVideo: "编辑视频广告",
    detail: "广告详情",
    vlist: "视频广告列表",
    vverify: "视频广告审核",
    addVideo: "添加视频广告",
    dfVList: "默认视频列表",
    addDfVideo: "添加默认视频"
  },
  appManage: "应用管理",
  appManageSub: {
    list: "应用列表",
    market: "应用市场",
    custom: "添加到我的定制",
    viewApp: "查看应用",
    customPush: "定制推送",
    appPush: "推送应用",
    appBind: "应用绑定终端",
    examine: "应用审核",
    verifyApp: "审核应用",
    appEdit: '应用编辑',
    appDetail: '应用详情',
    uploadNew: '上传新版本',
    uploadApp: '上传应用'
  },
  taskManage: "任务管理",
  taskManageSub: {
    list: "正在推送任务",
    detail: "正在推送任务详情",
    listHis: "已完成任务",
    detailHis: "已完成任务详情"
  },
  dataManage: "数据管理",
  dataManageSub: {
    channel: "渠道商管理",
    factory: "厂商管理",
    terClassify: "设备类型管理",
    terNum: "设备型号管理",
    advertClassify: "广告类型管理",
    appClassify: "应用类型管理",
    newChannel: "新增渠道商",
    editChannel: "编辑渠道商",
    newFirm: "新增厂商",
    editFirm: "编辑厂商"
  },
  railManage: "风控管理",
  railManageSub: {
    penSetting: "围栏设置",
    warnSetting: "预警信息",
    riskDetail: "围栏详情"
  },

  safeManage: "安全管理",
  safeManageSub: {
    certificate: "证书管理",
    certNew: "创建证书",
    remote: "远程授权",
    certUpload: "上传厂商证书",
    certDetail: "证书详情",
    cerUpload: "上传证书",
    myCert: '我的证书'
  },

  sysManage: "系统管理",
  sysManageSub: {
    romul: 'OTA上传',
    romed: 'OTA编辑',
    romOTA: "OTA管理",
    examine: "OTA审核",
    push: "OTA推送",
    order: "系统定制",
    animation: "动画定制",
    animateCustom: "定制动画",
    animatePush: "动画推送",
    pushHistory: "推送历史",
    firmwareManage: '固件管理',
    firmwareUpload: '固件上传',
    firmwareEdit: '固件编辑',
    firmwareCheck: '固件审核',
    firmwareCheckDt: '审核详情',
    firmwarePush: '固件推送',
    firmwarePushDevice: '固件推送设备',
    launchManage: 'launcher管理',
    launchCheck: 'launcher审核',
    verifyLaunch: '审核launcher',
    addLaunch: '添加launcher',
    launchDetail: 'launcher详情',
    launchEdit: 'launcher编辑',
    launchNewVer: 'launcher上传新版',
    launchPush: 'Launcher推送',
    launchPushTer: 'Launcher推送终端'
  },
  setManage: "配置管理",
  setManageSub: {
    role: "角色管理",
    system: "系统配置",
    menu: "菜单列表",
    addRole: "添加角色",
    rightChange: "权限修改",
    logo: 'LOGO设置'
  },
  accManager: "账号管理",
  accManagerSub: {
    account: "账户信息",
    subAccount: "子账户信息",
    addAccount: '新增子账户',
    editAccount: '编辑子账户'
  },
  menuEdit: '菜单编辑'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "advert", {
  status: "广告状态",
  addAdvert: "新增广告",
  deleteAll: "批量删除",
  all: "全部",
  refusal: "说明理由",
  app: "应用",
  appSub: {
    name: "名称",
    classify: "类型",
    uploadTime: "上传时间",
    version: "版本号"
  },
  isPass: "是否通过",
  pass: "通过",
  notPass: "不通过",
  waitOne: "待送审",
  waitTwo: "待审核",
  addDate: "添加时间",
  addUser: "添加者",
  appName: "应用名称",
  img: "图片",
  name: "广告名称",
  classify: "广告类型",
  position: "广告位置",
  positionSub: {
    banner: "首页Banner",
    starPage: "启动页面"
  },
  jumpType: "跳转类型",
  jumpTypeSub: {
    net: "网页",
    appStore: "应用市场"
  },
  url: "URL",
  channel: "渠道商",
  ableDate: "有效时间",
  beginDate: "开始时间",
  endDate: "结束时间",
  contentImg: "广告内容",
  reset: "重置"
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "index", {
  t: "台",
  more: "更多",
  terStatus: "设备概况",
  onlineTer: "在线设备",
  offLineTer: "离线设备",
  warnTer: "预警设备",
  taskList: "任务列表",
  pullApp: "应用下发",
  romUpdate: "ROM更新",
  pullAdvert: "广告推送",
  infoList: "信息列表",
  riskWarn: "风控警告",
  breakWarn: "故障警告"
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "menuConfig", {
  menu: {
    addMenu: "添加父级菜单",
    addMenu2: "添加菜单",
    refreshMenu: "刷新菜单",
    menuName: "菜单名称",
    selectModel: "请选择模块",
    orderBy: "排序序号",
    notBlankName: "名称不能为空",
    editMenu: "编辑菜单",
    editSuccess: "编辑成功",
    addSubMenu: "添加子菜单",
    relUrl: "相对地址"
  },

  role: {
    addRole: "新增角色",
    no: "编号",
    name: "名称",
    mark: "描述",
    model: "模块",
    updatePermission: "修改权限",
    editRole: "角色编辑",
    notBlankName: "名称不能为空",
    updateSuccess: "更新成功",
    deleteSuccess: "删除成功",
    modelSelect: "模块选择",
    addSuccess: "添加成功"
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "taskTypeNames", {
  ALL: "所有类型",
  APP: "应用",
  OTA: "OTA",
  ROM: "ROM",
  FIRMWARE: "固件",
  AD: "广告",
  STARTUP_ANIMATION: "开机动画",
  SHUTDOWN_ANIMATION: "关机动画",
  STARTUP_SHUTDOWN_ANIMATION: "开关机动画",
  LOGO: "开机LOGO",
  LAUNCHER: "Launcher",
  WALLPAPER: '桌面壁纸'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_adname", '广告名称'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_allpush", '推送全部'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_fipush", '文件导入推送'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_isjtoviewtd", '是否跳转到任务详情查看推送进度'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_mgsys", '管理系统域名'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_edcode", '维护授权码'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_sapp", '请选择应用'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_spic", '请选择图片'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_iappnamesrch", '请输入应用名称查询'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_alltyps", '全部类型'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_allpp", '全部播放位置'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_addur", '广告时长'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_vsize", '视频尺寸'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_addtime", '添加时间'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_psverify", '通过审核'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_vpreview", '视频预览'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_cstandt", '选择时长和次数'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_additv", '添加时长'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_vdofile", '视频文件'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_filename", '文件名称'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_vdodur", '视频时长'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_misstokentip", '丢失登录信息,需要重新登录授权'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_clreulvdo", '点击重新上传视频'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_adddfvdeoad", '添加默认视频广告'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_addps", '添加人员'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_pltimes", '播放次数'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_pldur", '播放时长'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_csvldate", '选择有效期'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_advdoad", '添加视频广告'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_mgdfvdo", '管理默认视频'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_adstatus", '广告状态'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_addadtype", '新增广告类型'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_newapptype", '新增应用类型'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_addmodel", '新增型号'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_newdvtype", '新增设备类型'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_addfmname", '新增厂商名称'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_srpush", '确认推送'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_ulfile", '上传文件'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_ttpsddvnum", '本次推送完成设备数量'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_srsktsdv", '你确定跳过这些设备'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_cvpush", '覆盖推送'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_skpush", '跳过推送'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_pssuccess", '推送成功'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_nowjump", '立即跳转'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_bcrecov", '批量还原'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_skintro", '简介'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_addlc", '添加launcher'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_ulinsfile", '上传安装文件'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_clreul", '点击重新上传'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_lcname", 'launcher名称'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_rsfivemin", '每5分钟自动刷新'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_suresm", '确认提交'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_udfiletype", '更新文件类型'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_plsltype", '请选择类型'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_adnamenotnull", '广告名称不能为空'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_plslchannel", '请选择渠道商'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_plslplpos", '请选择播放位置'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_slsttime", '请选择开始时间'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_slendtime", '请选择结束时间'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_addsc", '添加成功'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_vlsuccess", '审核成功'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_opsuccess", '操作成功'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_srpassvf", '确认通过审核'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_addvdoad", '添加视频广告'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_edvdoad", '编辑视频广告'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_sllimit", '选择有效期'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_srmuldel", '确认批量删除'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_sttcanlateendtime", '开始时间不能晚于结束时间'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_etcanelsttime", '结束时间不能早于开始时间'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_srdelpush", '确认删除推送'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_srrecovsysdf", '确认还原为系统默认的'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_rdless", '围栏半径小于'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_rdneedmore", '围栏半径需大于'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_srban", '确认不通过'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_banandrs", '是否不通过?请输入不通过原因'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_trjmap", '轨迹地图'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_psdonelftip", '本次推送有{num}台设备已完成推送或正在推送，您要跳过这些设备吗？'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_psscandtip", '推送成功提示安装'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_csulpicbsis", '点击上传图片格式文件(jpg、png、gif...)，最佳显示尺寸为'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_srch", '搜索'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_lkdevice", '查找设备'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_app", '应用'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_firmw", '固件'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_refresh", '刷新'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_sleep", '休眠'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_ccdown", '取消下载'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_srchcontent", '搜索内容'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_account", '帐号'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_opecontent", '操作内容'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_opetime", '操作时间'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_frzaccount", '冻结帐号'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_operator", '操作人'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_userip", '用户IP'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_deskwp", '桌面壁纸'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_channelmcdetail", '渠道商详情'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_channellevel", '渠道商等级'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_cermanage", '证书管理'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_lineimportcer", '产线导入证书'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_devicemanage", '设备管理'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_fileimportdevice", '文件导入设备'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_lineimportdevice", '产线导入设备'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_prodmodel", '产品型号'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_plimportcer", '产线导入客户证书'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_importslorder", '导入已选订单'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_importslcustomer", '导入已选客户'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_customername", '客户名称'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_orderno", '订单号'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_orderfinishdate", '订单完成日期'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_customerno", '客户编码'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_debuginfo", '调试信息'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_adbstatus", 'ADB状态'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_on1", '开'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_off1", '关'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_devicemode", '设备模式'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_normalmode", '正常模式'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_debugmode", '调试模式'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_signstatus", '验签状态'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_catchlog", '抓取日志'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_tobenimportdv", '即将导入设备'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_lineimporttip", '请设置设备的类型，厂商，型号，地址等基础数据'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_cannotwithsysapp", '不能包含系统应用'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_locktime", '锁定时间'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_risksetting", '风控设置'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_lockinfo", '锁定信息'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_riskdetail", '预警详情'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_lockcity", '锁定城市'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_locklngandlat", '锁定经纬度'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_lockstate", '锁定情况描述'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_bindenclosure", '绑定围栏'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_unbindenclosure", '解绑围栏'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_sureunlock", '确认解锁'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_plsinputimgfile", '请上传img格式文件'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_animatefile", '动画文件'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_bglock", '后台锁定'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_request", '已申请'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_unrequest", '未申请'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_lockdevice", '锁定设备'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_pusheddvlist", '卸载应用'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_appuninstall", '客制化卸载'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_unlocked", '已解锁'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_unlockdevice", '解锁设备'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_pushnumcantfive", '推送数量不能超过5个'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_selectedappshoupass", '未审核通过的应用不允许推送'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_adRefreshfreq", '广告刷新频率'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_uninsfail", '卸载失败'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_uninssc", '卸载成功'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_preversion", '基础版本'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_addstfile", '添加配置文件'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_filetag", '文件标识'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_filestss", '配置描述'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_uploadfilest", '上传配置文件'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_excludeapp", '排除应用'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_reupload", '重新上传'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_excludefsttip", '输入应用包名以排除此应用，默认所有支持该文件标识的应用均可使用此配置'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_limitxml", '限xml文件'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_configfile", '配置文件'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_udversion", '更新版本'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_udsamexml", '只能更新相同标识xml'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_udxmllowertip", '更新的版本低于现版本，将在历史记录中出现，不显示在列表中'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_childacmg", '子帐号管理'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_unldvwftip", '该设备绑定了围栏【{wl}】,是否同时删除绑定？'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_udmode", '更新模式'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_append", '追加'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_importapp", '导入应用'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_adddate", '添加日期'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_addtask", '添加任务'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_addtesttask", '添加任务测试'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_appdesc", '应用描述'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_srcdesc", '资源描述'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_downapp", '下载应用'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_downfile", '下载文件'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_addsrc", '添加资源'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_importsrc", '导入资源'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_srcname", '资源名称'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_srcver", '资源版本'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_downsrc", '下载资源'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_number", '编号'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_softinfo", '软件信息'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_allstatus", '全部状态'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_mstype14", '扫码枪应用推送'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_mstype15", '扫码枪资源文件推送'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_filedesc", '文件描述'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_filetype", '文件类型'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_subtype", '子类型'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_addfile", '添加文件'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_stmgpsw", '管理密码配置'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_mapsl", '地图选择'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_bdmap", '百度地图'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_map", '地图'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_right", '权限'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_addconfig", '添加配置'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_editconfig", '编辑配置'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_mgpsw", '管理密码'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_dvconfiglist", '配置设备列表'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_appconfigst", '配置应用状态'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_applytime", '应用时间'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_secrname", '密钥名称'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_secrdesc", '密钥描述'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_addsecrrule", '添加密钥规则'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_editsecrrule", '编辑密钥规则'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_secrdvlist", '密钥设备列表'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_secrupdatest", '密钥更新状态'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_waitupdate", '待更新'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_addrandport", '地址与端口'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_filepath", '文件路径'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_queryudfre", '查询更新频率'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_lcupload", '本地上传'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_hour", '小时'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_addofcloud", '云端添加'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_bglist", '后台列表'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_cntype", '连接方式'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_codegunsrc", '扫码枪资源'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_rtosgunsrc", 'RTOS资源'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_rots_1", "应用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_rots_2", "资源"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_rots_3", "系统"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_rots_4", "安全芯片固件"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_rots_5", "主控"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_partpkg", '增量包'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_codegunapp", '扫码枪应用'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_starttime", '开始时间'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_oilmcsrc", '加油机资源'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_downtpl", '下载模板'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_plsstype", '请选择子类型'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_allstyps", '全部子类型'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_ftooltip", '动画/LOGO文件在线制作工具'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_appendpush", '追加推送'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_ipitonlylgchar", '输入项只能是英文数字和下划线等合法字符'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_enable", '启用'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_spfileis", '文件支持格式为'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_cnsetting", '连接设置'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_newtask", '新建任务'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_adddv", '添加设备'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_fileinsst", '文件安装配置'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_insscautoop", '安装成功自动打开'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_pushsctipins", '推送成功提示安装'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_total", '总数'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_wait", '等待'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_pushing", '正在推送'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_pushsldev", '推送已选设备'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_repushdv", '重推失败设备'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_outputdv", '导出设备'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_udtime", '更新时间'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_surepsxdv", '确认推送{num}台设备'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "del_allData", "是否确认删除全部数据?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_wite_update", "等待更新"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_Update_successfully", "更新成功"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_Update_failure", "更新失败"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_apppush", '应用推送'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_fmwpush", '固件推送'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_advpush", '广告推送'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_onampush", '开机动画推送'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_offampush", '关机动画推送'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_onoffampush", '开关机动画推送'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_onlgpush", '开机logo推送'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_wppush", '壁纸推送'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_stfpush", '配置文件推送'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_codemc", '扫码器'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_codemcsrc", '扫码器资源'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_sysud", '系统更新'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_fmwud", '固件更新'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_anmud", '动画更新'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_qcgunsrcps", '扫码枪资源推送'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_iscltask", '确定取消任务'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_resrc", '资源'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_srcfileps", '资源文件推送'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_helptip", '帮助提醒'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_newpsetnewver", '新版TMS推送功能入口改版'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_newptdetail", '	推送功能改版后，用户需要推送可打开推送任务页面（任务管理→推送任务），点击新建任务，进入新建任务页面，输入任务名称并选择需要推送的文件即可新建推送任务。'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_newptdetail1", '	任务新建完成后自动跳转至任务详情弹出设备选择，用户可以批量推送或单台设备推送，在任务详情里用户可以多次添加设备，我们建议用户在大批量推送前先推送少量设备，确认无误后在任务详情里点击添加设备再大批量推送。'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_daterange", '日期范围'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_olinepday", '每日在线数量'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_onlineavgt", '平均在线时段'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_devicewhe", '设备分布'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_statistic", '统计'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_today", '今日'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_thisweek", '本周'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_thismonth", '本月'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_addblfile", '添加黑名单文件'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_blacklsname", '黑名单名称'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_editblls", '编辑黑名单'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_blsdesc", '黑名单描述'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_blsdvlist", '黑名单设备列表'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_wldesc", '围栏描述'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_filectncr", '文件内容不正确'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_khour", '时'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_kday", '日'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_yesterday", '昨日'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_rc15d", '近15日'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_rc30d", '近30日'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_stinfo", '状态信息'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_croln", '当前在线'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_crslp", '当前休眠'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_croff", '当前离线'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_lstol", '最后在线时间'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_lstsl", '最后休眠时间'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_lstof", '最后离线时间'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_limitiplg", '限制IP段登录'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_allowiplg", '允许IP段登录'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_illegal", '不合法'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_limitiptip", '请输入需要限制的IP段，不输入则不限制'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_allowiptip", '请输入允许的IP段，不输入则允许所有IP访问'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_unknow", '未知'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_hisstatus", '历史状态'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_active1", '活跃'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_unuse", '未启用'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_addpsg", '添加通道'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_psgname", '通道名称'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_authstat", '授权状态'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_cbackad", '回调地址'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_bsrqsadwl", '业务请求地址白名单'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_appwtls", '应用白名单'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_addapppgkn", '添加应用包名'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_authopen", '授权开启'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_authclose", '授权关闭'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_addaddr", '添加地址'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_developer", '开发者'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_editpasg", '编辑通道'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_usertype", '用户类型'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_generate", '生成'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_gentip", '重新生成AppSecret后，原有AppSecret将失效，并且无法继续接入开放平台。是否确定重新生成AppSecret？'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_open1", '开启'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_hide", '隐藏'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_subtask", '子任务'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_sltstype", '选择任务类型'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_command", '指令'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_addsubts", '添加子任务'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_commtype", '指令类型'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_taskpros", '任务进度'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_cursubts", '当前子任务'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_commpush", '指令推送'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_dvrestart", '设备重启'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_recvorgst", '恢复出厂设置'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_recvanimt", '还原动画'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_dvlock", '设备锁机'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_dvunlock", '设备解锁'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_inbdside", '已经到边界了'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_subtsnum", '子任务数量'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_tscrtime", '任务创建时间'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_pushfile", '推送文件'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_dvcomm", '设备指令'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_ing", '进行中'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_core", '内核'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_filesys", '文件系统'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_commd1fw", '通讯模块1固件'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_commd2fw", '通讯模块2固件'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_readcfw", '读卡器固件'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_pswkbfw", '密码键盘固件'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_scanhfw", '扫描头固件'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_actpossp", '激活POS通话'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_natpossp", '关闭POS通话'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_setcallf", '设置通话功能'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_clupappdt", '清除应用数据'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_isclupappdt", '确定清除应用数据'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_impdistbt", '导入渠道商'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_impmctip", '待上传文件，仅支持excel且不超过10m'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_callfunc", '通话功能'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_protocal", '协议'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_prtsltip", '选择HTTPS时必须保证接口已支持此协议'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_rgsvpm", '授权服务参数'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_rgsvip", '授权服务IP'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_bgntpm", '后台通知参数'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_bgntip", '后台通知IP'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_port", '端口'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_flexist", '文件已存在'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_delcer", '删除证书'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_cerid", '证书指纹'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_wallpaper", '壁纸'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_forceins", '强制安装'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_autorun", '安装后自动运行'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_cusins", '客制化安装'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_cusuins", '客制化卸载'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_forcerun", '强制执行'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_pushtest", '推送测试'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_pltfblt", '平台公告'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_addblt", '添加公告'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_blttt", '公告标题'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_readnum", '阅读次数'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_bltct", '公告内容'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_pltudrd", '平台已更新'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_udlog", '更新日志'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_addver", '添加版本'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_pubdate", '发布日期'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_updct", '更新内容'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_editblt", '编辑公告'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_editver", '编辑版本'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_verupdate", '版本更新'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_clviewdt", '点击查看详情'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_viewmore", '查看更多'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_comptime", '编译时间'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_insafnorun", '安装后非自动运行'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_normalins", '普通安装'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_normalunins", '普通卸载'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "appp_tipoperate", '提示操作'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_onlyprov", '只选省份'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_filepush", '文件推送'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_region", '区域'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_srcmechan", '输入关键字搜索渠道商'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_ckcode", '验证码'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_cantuins", '不可卸载'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_ippkgname", '输入包名'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_onlypicfm", '只能上传图片格式文件(JPG,PNG,GIF...)'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_fludlist", '文件更新列表'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_param", '参数'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_catching", '正在抓取'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_ulding", '正在上传'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_ulyet", '上传完成'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_endcatch", '结束抓取'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_iscatch", '确定开始抓取？'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_opterinfo", '导出终端信息'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_bcopterinfo", '批量导出信息'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_cpttime", '截取时间'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_eqcapture", '设备截屏'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_scapture", '截屏'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_surestcap", '确定进行截屏？'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_lokscrn", '锁屏'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_ulkscrn", '解屏'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_appautrn", 'App自启动'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_perms", '单位: 毫秒'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_wattime", '等待时间'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_lcswitch", 'launcher切换'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_appadv", '应用广告'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_cardno", '卡号'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_trdno", '流水号'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_batcno", '批次号'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_amout", '金额'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_mechno", '商户号'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_trdtime", '交易时间'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_trddate", '交易日期'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_trdcore", '核心流水'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_expno", '参考号'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_trdtype", '交易类型'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_rectime", '记录时间'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_fpaddrs", '人脸图片地址'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_propcut", '按比例裁剪'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_getcash", '取现'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_lctrans", '行内转帐'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_obtrans", '向他行转帐'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_coretrans", '核心流水'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_tradeNo", '交易号'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_export", '导出'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_ctrc", '磁条卡读卡器'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_icrc", 'IC卡读卡器'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_prtst", '打印机状态'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_pswkb", ' 密码键盘'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_idfrc", '身份证读卡器'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_led", 'led灯'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_beep", '蜂鸣器'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_codebar", '条码'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_lulog", '查看日志'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_lust", '查看状态'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_mdclst", '模块调用统计'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_fcclst", '方法调用统计'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_acauth", '激活码授权'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_authcode", '激活码'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_authrange", '程序有效期'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_delact", '暂不激活'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_pswtip", '密码必须8位以上，包括大写字母、小写字母、数字和特殊符号'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_phontrs", '手机号转帐'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_mulfcau", '多因子认证'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_verifc", '验证'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_opmfackip6dycode", '请打开MFA验证器，输入6位动态验证码'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_cantprvmcodectadm", '如不能提供多因子认证验证码，请与管理员联系'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_lsstep", '上一步'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_nxstep", '下一步'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_ckidt", '验证身份'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_istapp", '安装应用'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_bindmfa", '绑定MFA'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_ipaclgpsw", '输入账号登录密码'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_bindsfdv", '绑定安全设备'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_psfwtsstepop", '请按以下步骤完成绑定操作'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_sixnumb", '6位数字'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_phdnalyappggidck", '请在手机端下载并安装阿里云APP/Google Authenticator（身份验证器）'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_ipappstsagidck", 'iphone：在AppStore搜索阿里云APP/Google Authenticator（身份验证器）'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_adappmksagidck", 'Android：在应用市场搜索阿里云APP/Google Authenticator（身份验证器）'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_afistclnxitbpagiinx", '安装完成后点击下一步进入绑定页面（如已安装，直接进入下一步）'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_usalyagidckscqrc6code", '使用阿里云APP/Google Authenticator（身份验证器）扫描以下二维码，获取6位验证码'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_sftkck", '安全令牌验证'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_ip6codeubac", '输入6位验证码解除绑定账户'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_plipopenalyappoggidckip6dycd", '请在手机中打开阿里云APP或Google Authenticator（身份验证器）,请输入6位动态码'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_select_timelist", "选择时间范围"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_batch_migration", "批量迁移"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_expired_button", "在过去七天内"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_sure_migration", "确认迁移"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_Batch_import", "批量导入"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_Batch_push", "批量导出"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_input_sn", "请输入序列号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_serialnumber", "设备号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_serialnumber_new", "新设备号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_termin_status", "设备更新状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_status_update", "待更新"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_status_updated", "已更新"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_status_exist", "密钥已存在"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_status_fail", "失败"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_dyf", "是否下过21号文"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_wtk", "是否有密钥"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_keyType", "密钥类型"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_keyUpIndex", "加密密钥索引"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_keyDlIndex", "下载密钥索引"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_Algorithm_mode", "算法模式"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_start_no", "起始号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "app_end_no", "截止号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_zh_cn, "auth_status_list", {
  status_1: "鉴权中",
  status_2: "鉴权失败",
  status_3: "生成激活码",
  status_4: "激活码已失效",
  status_5: "激活成功",
  status_6: "激活失败"
}), _zh_cn);

/* harmony default export */ __webpack_exports__["a"] = (zh_cn);

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_resource__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_i18n__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_default_index_css__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__router__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__api_url_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__api_req_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_wRequester_js__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_wGlobalMethods_js__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__vuex_index__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__api_api_js__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_css_zt_css__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_css_zt_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_css_zt_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_croppa_dist_vue_croppa_css__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_croppa_dist_vue_croppa_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vue_croppa_dist_vue_croppa_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_croppa__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_croppa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vue_croppa__);























__webpack_require__(281);










__WEBPACK_IMPORTED_MODULE_6_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_22_vue_croppa___default.a);

var qs = __webpack_require__(90);

var dateFormat = __webpack_require__(88);
var now = new Date();
var timeStamp = dateFormat(now, 'yyyymmddHHMM');
var checkV = 'poss' + timeStamp;

var sha256 = __webpack_require__(59).sha256;

var checkValue = sha256(sha256(checkV + 'szzt@002197')).toUpperCase();

__WEBPACK_IMPORTED_MODULE_6_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_i18n___default.a);
__WEBPACK_IMPORTED_MODULE_14__api_req_js__["a" /* default */].common.changeLang();

__WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$httpzi = __WEBPACK_IMPORTED_MODULE_19_axios___default.a.create({
  baseURL: __WEBPACK_IMPORTED_MODULE_13__api_url_js__["a" /* baseurl */],
  timeout: 20000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },

  responseType: 'json',
  withCredentials: false,
  transformRequest: [function (data) {
    var options = {
      'condition': {},
      'pageNum': '',
      'numPerPage': '',
      'orderField': '',
      'orderDirection': 'desc',
      'pageFlag': '1',
      'timestamp': timeStamp,
      'checkvalue': checkValue
    };

    if (!data || (typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(data)) === undefined) {
      data = {};
    }

    if (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(data.upload) !== undefined && data.upload === true) {
      var jsondata = {
        token: 'szzttmsinterface=='
      };
      var formElement = document.getElementById(data.formElement);
      var formData = new FormData(formElement);
      if (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(data.uploadData) !== undefined && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(data.uploadData) === 'object') {
        for (var item in data.uploadData) {
          formData.set(item, data.uploadData[item]);
        }
      }
      if (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(data.areaid) !== undefined && data.areaid !== '') {
        formData.append('areaid', data.areaid);
      }
      formData.append('jsondata', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(jsondata));
      return formData;
    }
    data.token = 'szzttmsinterface==';
    var nObj = void 0;
    if (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(data.write) !== undefined && data.write === true) {
      nObj = data;
      delete data.write;
    } else {
      nObj = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(options, data);
    }
    var request = {};
    request.jsondata = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(nObj);
    request = qs.stringify(request);
    return request;
  }],
  transformResponse: [function (data) {
    if (typeof data === 'string') {
      return JSON.parse(data);
    }
    return data;
  }]
});

__WEBPACK_IMPORTED_MODULE_19_axios___default.a.interceptors.request.use(function (config) {
  var token = null;
  var lang = null;
  if (localStorage.getItem("user")) token = localStorage.getItem("user");
  if (localStorage.getItem("system_lang")) lang = localStorage.getItem("system_lang");
  if (!config.data) config.data = {};
  config.data['token'] = token;
  config.data['language'] = lang;

  return config;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_19_axios___default.a.interceptors.response.use(function (response) {
  if (response.data && response.data.status == '600') {
    __WEBPACK_IMPORTED_MODULE_12__router__["a" /* default */].replace({
      path: '/login'
    });
    return response;
  } else {
    return response;
  }
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.req = __WEBPACK_IMPORTED_MODULE_14__api_req_js__["a" /* default */];

__WEBPACK_IMPORTED_MODULE_6_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_6_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18__api_api_js__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_6_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_6_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15__components_wRequester_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_6_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16__components_wGlobalMethods_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_6_vue__["default"].config.productionTip = false;

var logos = localStorage.getItem('logo');
__WEBPACK_IMPORTED_MODULE_17__vuex_index__["a" /* default */].dispatch('setHomeLogo', logos);

__WEBPACK_IMPORTED_MODULE_12__router__["a" /* default */].beforeEach(function (to, from, next) {
  if (to.path == '/channels' && (from.path == '/channels/newchannel' || from.path == '/channels/editchannel' || from.path == '/channels/channel-detail')) {
    __WEBPACK_IMPORTED_MODULE_17__vuex_index__["a" /* default */].dispatch('setIsRcMcpath', true);
  } else {
    __WEBPACK_IMPORTED_MODULE_17__vuex_index__["a" /* default */].dispatch('setIsRcMcpath', false);
  }

  if (from.path === "/terList") {
    var get = localStorage.getItem("timer");
    clearInterval(get);
  }
  if (from.path === "/log") {
    var gets = localStorage.getItem("timers");
    clearInterval(gets);
  }
  if (to.path === '/login') {
    console.log('退出登录');

    localStorage.removeItem("iaAuth");

    __WEBPACK_IMPORTED_MODULE_17__vuex_index__["a" /* default */].dispatch('setInitRouter', "false");
    localStorage.removeItem("roleList");
    localStorage.removeItem("localMenuData");
  }

  var token = localStorage.getItem('user') || null;


  if (token && to.path !== '/login') {
    var resolvingRouterData = function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var roleList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var ge;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                ge = function ge(roleList, data) {
                  data.forEach(function (item) {
                    var menu = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, item);
                    menu.component = __webpack_require__(60)("./" + item.component + '.vue');
                    if (!menu.meta) {
                      menu.meta = {};
                    }

                    if (menu.superId !== 0) {
                      menu.children = [];
                      if (item.children) {
                        ge(menu.children, item.children);
                      }
                    }
                    roleList.push(menu);
                  });
                };

                console.log('resolvingRouterData');
                ge(roleList, data);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function resolvingRouterData() {
        return _ref.apply(this, arguments);
      };
    }();

    console.log('有用户token, to.path不等于登录页面');

    var getMenuList = function getMenuList() {
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_19_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_13__api_url_js__["a" /* baseurl */] + '/menu/menuList.do', { token: localStorage.getItem('user') }).then(function (res) {
          resolve(res.data.data);
        });
      });
    };

    var setResolvingRouterData = function setResolvingRouterData(list, rrr) {
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        console.log('获取到路由信息');
        resolvingRouterData(rrr, list);

        __WEBPACK_IMPORTED_MODULE_12__router__["a" /* default */].addRoutes(rrr);
        __WEBPACK_IMPORTED_MODULE_17__vuex_index__["a" /* default */].dispatch('setRouters', rrr);
        __WEBPACK_IMPORTED_MODULE_17__vuex_index__["a" /* default */].dispatch('setInitRouter', "true");
        console.log('end setData...');
        resolve();
      });
    };

    var start = function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var loginTag, dbMenuData, localMenuDataObject, rrr;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log('start_开始设置vue路由');

                loginTag = localStorage.getItem('loginTag') || null;
                dbMenuData = void 0;

                if (!loginTag) {
                  _context2.next = 12;
                  break;
                }

                console.log('用登录标识,需要重新请求接口获取最新的菜单信息');
                _context2.next = 7;
                return getMenuList();

              case 7:
                dbMenuData = _context2.sent;

                localStorage.removeItem('loginTag');
                localStorage.setItem('localMenuData', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(dbMenuData));
                _context2.next = 23;
                break;

              case 12:
                console.log('没有用户登录标志');
                localMenuDataObject = localStorage.getItem('localMenuData') || null;

                if (localMenuDataObject) {
                  _context2.next = 22;
                  break;
                }

                console.log('localStorage 也没有 localMenuData的数据');
                _context2.next = 18;
                return getMenuList();

              case 18:
                dbMenuData = _context2.sent;

                localStorage.setItem('localMenuData', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(dbMenuData));
                _context2.next = 23;
                break;

              case 22:
                dbMenuData = JSON.parse(localMenuDataObject);

              case 23:
                rrr = [];
                _context2.next = 26;
                return setResolvingRouterData(dbMenuData, rrr);

              case 26:

                __WEBPACK_IMPORTED_MODULE_12__router__["a" /* default */].addRoutes(rrr);
                __WEBPACK_IMPORTED_MODULE_17__vuex_index__["a" /* default */].dispatch('setRouters', rrr);
                __WEBPACK_IMPORTED_MODULE_17__vuex_index__["a" /* default */].dispatch('setInitRouter', "true");
                console.log('end_开始设置vue路由');

              case 30:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      return function start() {
        return _ref2.apply(this, arguments);
      };
    }();

    if (!__WEBPACK_IMPORTED_MODULE_17__vuex_index__["a" /* default */].getters.isInitRouter || __WEBPACK_IMPORTED_MODULE_17__vuex_index__["a" /* default */].getters.isInitRouter !== "true") {
      start();
    } else {
      console.error('没有 inInitRouter');
    }

    anIFrameUrl();
    setUlTip();
  } else {
      if (to.path === '/login') {
        console.log('to.path等于/login');

        setUlTip();
      } else {
        __WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$message({ message: __WEBPACK_IMPORTED_MODULE_6_vue__["default"].t('app_misstokentip'), type: 'warning' });
        next('/login');
      }
    }

  function setUlTip() {
    if (window[from.path]) {
      var pkg = __WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$plang[localStorage.system_lang];
      var tip = pkg.tip;
      var ct = pkg.upTip;
      var wsure = pkg.sure;
      var wcans = pkg.cancel;
      __WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$confirm(ct, tip, {
        confirmButtonText: wsure,
        cancelButtonText: wcans,
        type: 'warning'
      }).then(function () {
        next();
      }).catch(function () {
        return false;
      });
    } else {
      console.log('调用next()..');
      next();
    }
  }

  function anIFrameUrl() {
    var params = to.path.split('@url=');
    if (params.length == 2) {
      var url = params[1];
      url = url.replace('@', '?');
      __WEBPACK_IMPORTED_MODULE_17__vuex_index__["a" /* default */].dispatch('setGurl', url);
    }
  }
});

var lang = localStorage.system_lang;
var tt = '';
switch (lang) {
  case 'zh_cn':
    tt = '智能POS终端管理平台';
    break;
  case 'en':
    tt = 'TMS Terminal management system';
    break;
  case 'ko':
    tt = 'TMS 터미널 관리 시스템';
    break;
  case 'ru':
    tt = 'Суко  терминал системы управления ';
    break;
}
document.title = tt;

new __WEBPACK_IMPORTED_MODULE_6_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_12__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_17__vuex_index__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_7__App___default.a }
});

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var getters = {
  isRcMcpath: function isRcMcpath(state) {
    return state.user.isRcMcpath;
  },
  mcpath: function mcpath(state) {
    return state.user.mcpath;
  },
  userInfo: function userInfo(state) {
    return state.user.userInfo;
  },
  authorization: function authorization(state) {
    return state.user.authorization;
  },
  homeLogo: function homeLogo(state) {
    return state.user.homeLogo;
  },
  addRouters: function addRouters(state) {
    return state.permission.addRouters;
  },
  roles: function roles(state) {
    return state.user.roles;
  },
  routes: function routes(state) {
    return state.permission.routers;
  },
  isInitRouter: function isInitRouter(state) {
    return state.user.isInitRouter;
  },
  r_param: function r_param(state) {
    return state.tmp.r_param;
  },
  ter_param: function ter_param(state) {
    return state.ter.ter_param;
  },
  edit_change: function edit_change(state) {
    return state.ter.edit_change;
  },
  nick: function nick(state) {
    return state.user.nick;
  },
  comUri: function comUri(state) {
    return state.permission.comUri;
  },
  gIfurl: function gIfurl(state) {
    return state.tmp.gurl;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var app = {
  state: {
    appTitle: ""
  },
  mutations: {},
  actions: {}
};

/* harmony default export */ __webpack_exports__["a"] = (app);

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_index__ = __webpack_require__(58);






function hasPermission(roles, route) {
  if (!route.pm || route.pm === "") {
    return true;
  }
  return roles.some(function (role) {
    return route.pm === role;
  });
}

var permission = {
  state: {
    routers: __WEBPACK_IMPORTED_MODULE_2__router__["b" /* constantRouterMap */],
    addRouters: [],
    comUri: {}
  },
  mutations: {
    SET_ROUTERS: function SET_ROUTERS(state, routers) {
      state.addRouters = routers;

      localStorage.setItem('addRData', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(routers));
      state.routers = __WEBPACK_IMPORTED_MODULE_2__router__["b" /* constantRouterMap */].concat(routers);
    },
    SET_COM_URI: function SET_COM_URI(state) {
      var array = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      state.comUri = array;
    }
  },
  actions: {
    setRouters: function setRouters(_ref, data) {
      var commit = _ref.commit;

      commit('SET_ROUTERS', data);
    },
    setComUri: function setComUri(_ref2, data) {
      var commit = _ref2.commit;

      commit('SET_COM_URI', data);
    },
    generateRoutes: function generateRoutes(_ref3, data) {
      var commit = _ref3.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var roles = data.roles;


        commit('SET_ROUTERS', accessedRouters);
        resolve();
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (permission);

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ter = {
	state: {
		ter_param: null,
		edit_change: 'false'
	},
	mutations: {
		SET_TER_PARAM: function SET_TER_PARAM(state, obj) {
			state.ter_param = obj;
		},
		SET_EDIT_CHANGE: function SET_EDIT_CHANGE(state, bool) {
			state.edit_change = bool;
		}
	},
	actions: {
		setTerParam: function setTerParam(_ref, obj) {
			var commit = _ref.commit;

			commit('SET_TER_PARAM', obj);
		},
		setEditChange: function setEditChange(_ref2, bool) {
			var commit = _ref2.commit;

			commit('SET_EDIT_CHANGE', bool);
		}
	}
};

/* harmony default export */ __webpack_exports__["a"] = (ter);

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var tmp = {
  state: {
    r_param: null,
    gurl: null
  },
  mutations: {
    SET_PARAM: function SET_PARAM(state, obj) {
      state.r_param = obj;
    },
    SET_GURL: function SET_GURL(state, obj) {
      state.gurl = obj;
    }
  },
  actions: {
    setParam: function setParam(_ref, obj) {
      var commit = _ref.commit;

      commit('SET_PARAM', obj);
    },
    setGurl: function setGurl(_ref2, obj) {
      var commit = _ref2.commit;

      commit('SET_GURL', obj);
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (tmp);

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_url__ = __webpack_require__(3);




var user = {
  state: {
    userInfo: null,

    authorization: __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get('User-Token'),
    roles: null,
    isInitRouter: "false",
    homeLogo: '',
    nick: '',

    mcpath: [],
    isRcMcpath: true
  },
  mutations: {
    SET_ISRCMCPATH: function SET_ISRCMCPATH(state, is) {
      state.isRcMcpath = is;
    },
    SET_MCPATH: function SET_MCPATH(state, arr) {
      state.mcpath = arr;
    },
    SET_NICK: function SET_NICK(state, str) {
      state.nick = str;
    },
    SET_INITROUTER: function SET_INITROUTER(state, str) {
      state.isInitRouter = str;
    },
    SET_USERINFO: function SET_USERINFO(state, userInfo) {
      state.userInfo = userInfo;
    },
    SET_USERROLE: function SET_USERROLE(state, roles) {
      state.roles = roles;
    },
    SET_AUTHORIZATION: function SET_AUTHORIZATION(state, boo) {
      state.authorization = boo;
    },
    SET_HOMELOGO: function SET_HOMELOGO(state, logo) {
      if (logo !== 'null' && logo !== '') {
        state.homeLogo = '' + __WEBPACK_IMPORTED_MODULE_2__api_url__["b" /* urlAssets */].prefix + logo;
      } else {
        state.homeLogo = __webpack_require__(778);
      }
    }
  },
  actions: {
    setIsRcMcpath: function setIsRcMcpath(_ref, is) {
      var commit = _ref.commit;

      commit('SET_ISRCMCPATH', is);
    },
    setMCPath: function setMCPath(_ref2, arr) {
      var commit = _ref2.commit;

      commit('SET_MCPATH', arr);
    },
    setNick: function setNick(_ref3, nick) {
      var commit = _ref3.commit;

      commit('SET_NICK', nick);
    },
    setHomeLogo: function setHomeLogo(_ref4, logo) {
      var commit = _ref4.commit;

      commit('SET_HOMELOGO', logo);
    },
    setInitRouter: function setInitRouter(_ref5, str) {
      var commit = _ref5.commit;

      commit('SET_INITROUTER', str);
    },
    setUserRoles: function setUserRoles(_ref6, roles) {
      var commit = _ref6.commit;

      commit('SET_USERROLE', roles);
    },
    setUserInfo: function setUserInfo(_ref7, userInfo) {
      var commit = _ref7.commit;

      commit('SET_USERINFO', userInfo);
    },
    setAuthorization: function setAuthorization(_ref8, boo) {
      var commit = _ref8.commit;

      commit('SET_AUTHORIZATION', boo);
    },
    loginByUserName: function loginByUserName(_ref9, userInfo) {
      var commit = _ref9.commit;

      var username = userInfo.username.trim();
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {});
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (user);

/***/ }),
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 596 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 597 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 598 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 599 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 600 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 601 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 602 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 603 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 604 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 605 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 606 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 607 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 608 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 609 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 610 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 611 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 612 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 613 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 614 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 615 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 616 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 617 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 618 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 619 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 620 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 621 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 622 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 623 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 624 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 625 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 626 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 627 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 628 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 629 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 630 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 631 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 632 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 633 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 634 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 635 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 636 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 637 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 638 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 639 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 640 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 641 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 642 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 643 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 644 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 645 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 646 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 647 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 648 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 649 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 650 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 651 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 652 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 653 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 654 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 655 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 656 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 657 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 658 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 659 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 660 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 661 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 662 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 663 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 664 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 665 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 666 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 667 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 668 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 669 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 670 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 671 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 672 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 673 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 674 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 675 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 676 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 677 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 678 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 679 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 680 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 681 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 682 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 683 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 684 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 685 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 686 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 687 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 688 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 689 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 690 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 691 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 692 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 693 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 694 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 695 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 696 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 697 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 698 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 699 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 700 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 701 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 702 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 703 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 704 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 705 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 706 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 707 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 708 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 709 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 710 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 711 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 712 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 713 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 714 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 715 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 716 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 717 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 718 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 719 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 720 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 721 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 722 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 723 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 724 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 725 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 726 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 727 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 728 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 729 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 730 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 731 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 732 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 733 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 734 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 735 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 736 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 737 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 738 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 739 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 740 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 741 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 742 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 743 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 744 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 745 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 746 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 747 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 748 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 749 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 750 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 751 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 127,
	"./af.js": 127,
	"./ar": 134,
	"./ar-dz": 128,
	"./ar-dz.js": 128,
	"./ar-kw": 129,
	"./ar-kw.js": 129,
	"./ar-ly": 130,
	"./ar-ly.js": 130,
	"./ar-ma": 131,
	"./ar-ma.js": 131,
	"./ar-sa": 132,
	"./ar-sa.js": 132,
	"./ar-tn": 133,
	"./ar-tn.js": 133,
	"./ar.js": 134,
	"./az": 135,
	"./az.js": 135,
	"./be": 136,
	"./be.js": 136,
	"./bg": 137,
	"./bg.js": 137,
	"./bm": 138,
	"./bm.js": 138,
	"./bn": 139,
	"./bn.js": 139,
	"./bo": 140,
	"./bo.js": 140,
	"./br": 141,
	"./br.js": 141,
	"./bs": 142,
	"./bs.js": 142,
	"./ca": 143,
	"./ca.js": 143,
	"./cs": 144,
	"./cs.js": 144,
	"./cv": 145,
	"./cv.js": 145,
	"./cy": 146,
	"./cy.js": 146,
	"./da": 147,
	"./da.js": 147,
	"./de": 150,
	"./de-at": 148,
	"./de-at.js": 148,
	"./de-ch": 149,
	"./de-ch.js": 149,
	"./de.js": 150,
	"./dv": 151,
	"./dv.js": 151,
	"./el": 152,
	"./el.js": 152,
	"./en-SG": 153,
	"./en-SG.js": 153,
	"./en-au": 154,
	"./en-au.js": 154,
	"./en-ca": 155,
	"./en-ca.js": 155,
	"./en-gb": 156,
	"./en-gb.js": 156,
	"./en-ie": 157,
	"./en-ie.js": 157,
	"./en-il": 158,
	"./en-il.js": 158,
	"./en-nz": 159,
	"./en-nz.js": 159,
	"./eo": 160,
	"./eo.js": 160,
	"./es": 163,
	"./es-do": 161,
	"./es-do.js": 161,
	"./es-us": 162,
	"./es-us.js": 162,
	"./es.js": 163,
	"./et": 164,
	"./et.js": 164,
	"./eu": 165,
	"./eu.js": 165,
	"./fa": 166,
	"./fa.js": 166,
	"./fi": 167,
	"./fi.js": 167,
	"./fo": 168,
	"./fo.js": 168,
	"./fr": 171,
	"./fr-ca": 169,
	"./fr-ca.js": 169,
	"./fr-ch": 170,
	"./fr-ch.js": 170,
	"./fr.js": 171,
	"./fy": 172,
	"./fy.js": 172,
	"./ga": 173,
	"./ga.js": 173,
	"./gd": 174,
	"./gd.js": 174,
	"./gl": 175,
	"./gl.js": 175,
	"./gom-latn": 176,
	"./gom-latn.js": 176,
	"./gu": 177,
	"./gu.js": 177,
	"./he": 178,
	"./he.js": 178,
	"./hi": 179,
	"./hi.js": 179,
	"./hr": 180,
	"./hr.js": 180,
	"./hu": 181,
	"./hu.js": 181,
	"./hy-am": 182,
	"./hy-am.js": 182,
	"./id": 183,
	"./id.js": 183,
	"./is": 184,
	"./is.js": 184,
	"./it": 186,
	"./it-ch": 185,
	"./it-ch.js": 185,
	"./it.js": 186,
	"./ja": 187,
	"./ja.js": 187,
	"./jv": 188,
	"./jv.js": 188,
	"./ka": 189,
	"./ka.js": 189,
	"./kk": 190,
	"./kk.js": 190,
	"./km": 191,
	"./km.js": 191,
	"./kn": 192,
	"./kn.js": 192,
	"./ko": 193,
	"./ko.js": 193,
	"./ku": 194,
	"./ku.js": 194,
	"./ky": 195,
	"./ky.js": 195,
	"./lb": 196,
	"./lb.js": 196,
	"./lo": 197,
	"./lo.js": 197,
	"./lt": 198,
	"./lt.js": 198,
	"./lv": 199,
	"./lv.js": 199,
	"./me": 200,
	"./me.js": 200,
	"./mi": 201,
	"./mi.js": 201,
	"./mk": 202,
	"./mk.js": 202,
	"./ml": 203,
	"./ml.js": 203,
	"./mn": 204,
	"./mn.js": 204,
	"./mr": 205,
	"./mr.js": 205,
	"./ms": 207,
	"./ms-my": 206,
	"./ms-my.js": 206,
	"./ms.js": 207,
	"./mt": 208,
	"./mt.js": 208,
	"./my": 209,
	"./my.js": 209,
	"./nb": 210,
	"./nb.js": 210,
	"./ne": 211,
	"./ne.js": 211,
	"./nl": 213,
	"./nl-be": 212,
	"./nl-be.js": 212,
	"./nl.js": 213,
	"./nn": 214,
	"./nn.js": 214,
	"./pa-in": 215,
	"./pa-in.js": 215,
	"./pl": 216,
	"./pl.js": 216,
	"./pt": 218,
	"./pt-br": 217,
	"./pt-br.js": 217,
	"./pt.js": 218,
	"./ro": 219,
	"./ro.js": 219,
	"./ru": 220,
	"./ru.js": 220,
	"./sd": 221,
	"./sd.js": 221,
	"./se": 222,
	"./se.js": 222,
	"./si": 223,
	"./si.js": 223,
	"./sk": 224,
	"./sk.js": 224,
	"./sl": 225,
	"./sl.js": 225,
	"./sq": 226,
	"./sq.js": 226,
	"./sr": 228,
	"./sr-cyrl": 227,
	"./sr-cyrl.js": 227,
	"./sr.js": 228,
	"./ss": 229,
	"./ss.js": 229,
	"./sv": 230,
	"./sv.js": 230,
	"./sw": 231,
	"./sw.js": 231,
	"./ta": 232,
	"./ta.js": 232,
	"./te": 233,
	"./te.js": 233,
	"./tet": 234,
	"./tet.js": 234,
	"./tg": 235,
	"./tg.js": 235,
	"./th": 236,
	"./th.js": 236,
	"./tl-ph": 237,
	"./tl-ph.js": 237,
	"./tlh": 238,
	"./tlh.js": 238,
	"./tr": 239,
	"./tr.js": 239,
	"./tzl": 240,
	"./tzl.js": 240,
	"./tzm": 242,
	"./tzm-latn": 241,
	"./tzm-latn.js": 241,
	"./tzm.js": 242,
	"./ug-cn": 243,
	"./ug-cn.js": 243,
	"./uk": 244,
	"./uk.js": 244,
	"./ur": 245,
	"./ur.js": 245,
	"./uz": 247,
	"./uz-latn": 246,
	"./uz-latn.js": 246,
	"./uz.js": 247,
	"./vi": 248,
	"./vi.js": 248,
	"./x-pseudo": 249,
	"./x-pseudo.js": 249,
	"./yo": 250,
	"./yo.js": 250,
	"./zh-cn": 251,
	"./zh-cn.js": 251,
	"./zh-hk": 252,
	"./zh-hk.js": 252,
	"./zh-tw": 253,
	"./zh-tw.js": 253
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 755;

/***/ }),
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/404.ae5bf10.svg";

/***/ }),
/* 762 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 763 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 764 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 765 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 766 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 767 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 768 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 769 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 770 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 771 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjI0cHgiIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggNTAuMiAoNTUwNDcpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPg0KICAgIDx0aXRsZT7lnKjnur88L3RpdGxlPg0KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPg0KICAgIDxkZWZzPjwvZGVmcz4NCiAgICA8ZyBpZD0i6Z2e5pm66IO96K6+5aSH566h55CGIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4NCiAgICAgICAgPGcgaWQ9IumhueebruivpuaDhS1jb3B5LTI1IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDI1LjAwMDAwMCwgLTI2MS4wMDAwMDApIj4NCiAgICAgICAgICAgIDxnIGlkPSJHcm91cC05IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMDEuMDAwMDAwLCAxOTguMDAwMDAwKSI+DQogICAgICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTExIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4MC4wMDAwMDAsIDYzLjAwMDAwMCkiPg0KICAgICAgICAgICAgICAgICAgICA8ZyBpZD0i5Zyo57q/IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0NC4wMDAwMDAsIDAuMDAwMDAwKSI+DQogICAgICAgICAgICAgICAgICAgICAgICA8Y2lyY2xlIGlkPSJPdmFsIiBzdHJva2U9IiMzRkI0NDEiIHN0cm9rZS13aWR0aD0iMiIgZmlsbD0iI0ZGRkZGRiIgY3g9IjEyIiBjeT0iMTIiIHI9IjExIj48L2NpcmNsZT4NCiAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik03LDEyIEwxOCwxMiBDMTguNTUyMjg0NywxMiAxOSwxMi40NDc3MTUzIDE5LDEzIEMxOSwxMy41NTIyODQ3IDE4LjU1MjI4NDcsMTQgMTgsMTQgTDYsMTQgQzUuNDQ3NzE1MjUsMTQgNSwxMy41NTIyODQ3IDUsMTMgTDUsNyBDNSw2LjQ0NzcxNTI1IDUuNDQ3NzE1MjUsNiA2LDYgQzYuNTUyMjg0NzUsNiA3LDYuNDQ3NzE1MjUgNyw3IEw3LDEyIFoiIGlkPSJDb21iaW5lZC1TaGFwZSIgZmlsbD0iIzNGQjQ0MSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTIuMDAwMDAwLCAxMC4wMDAwMDApIHJvdGF0ZSgtNDUuMDAwMDAwKSB0cmFuc2xhdGUoLTEyLjAwMDAwMCwgLTEwLjAwMDAwMCkgIj48L3BhdGg+DQogICAgICAgICAgICAgICAgICAgIDwvZz4NCiAgICAgICAgICAgICAgICA8L2c+DQogICAgICAgICAgICA8L2c+DQogICAgICAgIDwvZz4NCiAgICA8L2c+DQo8L3N2Zz4="

/***/ }),
/* 772 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjI0cHgiIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggNTAuMiAoNTUwNDcpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPg0KICAgIDx0aXRsZT7kvJHnnKA8L3RpdGxlPg0KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPg0KICAgIDxkZWZzPjwvZGVmcz4NCiAgICA8ZyBpZD0i6Z2e5pm66IO96K6+5aSH566h55CGIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4NCiAgICAgICAgPGcgaWQ9IumhueebruivpuaDhS1jb3B5LTI1IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtOTY2LjAwMDAwMCwgLTI2MS4wMDAwMDApIj4NCiAgICAgICAgICAgIDxnIGlkPSJHcm91cC05IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMDEuMDAwMDAwLCAxOTguMDAwMDAwKSI+DQogICAgICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTEwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2MjEuMDAwMDAwLCA2My4wMDAwMDApIj4NCiAgICAgICAgICAgICAgICAgICAgPGcgaWQ9IuS8keecoCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDQuMDAwMDAwLCAwLjAwMDAwMCkiPg0KICAgICAgICAgICAgICAgICAgICAgICAgPGNpcmNsZSBpZD0iT3ZhbCIgc3Ryb2tlPSIjRkZBNDMwIiBzdHJva2Utd2lkdGg9IjIiIGZpbGw9IiNGRkZGRkYiIGN4PSIxMiIgY3k9IjEyIiByPSIxMSI+PC9jaXJjbGU+DQogICAgICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTIsMTIgTDE5LDEyIEMxOS41NTIyODQ3LDEyIDIwLDEyLjQ0NzcxNTMgMjAsMTMgQzIwLDEzLjU1MjI4NDcgMTkuNTUyMjg0NywxNCAxOSwxNCBMMTEsMTQgQzEwLjQ0NzcxNTMsMTQgMTAsMTMuNTUyMjg0NyAxMCwxMyBMMTAsNSBDMTAsNC40NDc3MTUyNSAxMC40NDc3MTUzLDQgMTEsNCBDMTEuNTUyMjg0Nyw0IDEyLDQuNDQ3NzE1MjUgMTIsNSBMMTIsMTIgWiIgaWQ9IkNvbWJpbmVkLVNoYXBlIiBmaWxsPSIjRkY5QTE5Ij48L3BhdGg+DQogICAgICAgICAgICAgICAgICAgIDwvZz4NCiAgICAgICAgICAgICAgICA8L2c+DQogICAgICAgICAgICA8L2c+DQogICAgICAgIDwvZz4NCiAgICA8L2c+DQo8L3N2Zz4="

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logoLogin.be9e7ab.png";

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ptd1.c07ecbe.png";

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ptd2.62f28b3.png";

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ptd3.7e1510e.png";

/***/ }),
/* 777 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 778 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(1104),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(656)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(1022),
  /* scopeId */
  "data-v-3fa4059e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(716)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(331),
  /* template */
  __webpack_require__(1090),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(1083),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(647)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(336),
  /* template */
  __webpack_require__(1011),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(623)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(982),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(602)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(956),
  /* scopeId */
  "data-v-0568ebb2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(606)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(339),
  /* template */
  __webpack_require__(963),
  /* scopeId */
  "data-v-0a63bb86",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(607)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(340),
  /* template */
  __webpack_require__(965),
  /* scopeId */
  "data-v-0dcfb7b6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(726)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(1102),
  /* scopeId */
  "data-v-9a88944a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(342),
  /* template */
  __webpack_require__(1132),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(625)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(343),
  /* template */
  __webpack_require__(984),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(732)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(344),
  /* template */
  __webpack_require__(1110),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(741)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(345),
  /* template */
  __webpack_require__(1122),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(619)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(346),
  /* template */
  __webpack_require__(978),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(632)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(347),
  /* template */
  __webpack_require__(993),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(617)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(348),
  /* template */
  __webpack_require__(976),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(728)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(349),
  /* template */
  __webpack_require__(1105),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(738)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(350),
  /* template */
  __webpack_require__(1118),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(720)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(351),
  /* template */
  __webpack_require__(1095),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(723)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(352),
  /* template */
  __webpack_require__(1098),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(639)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(353),
  /* template */
  __webpack_require__(1002),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(643)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(354),
  /* template */
  __webpack_require__(1007),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(684)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(355),
  /* template */
  __webpack_require__(1056),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(636)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(356),
  /* template */
  __webpack_require__(999),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(712)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(357),
  /* template */
  __webpack_require__(1086),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(693)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(358),
  /* template */
  __webpack_require__(1066),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(604)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(359),
  /* template */
  __webpack_require__(960),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(673)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(360),
  /* template */
  __webpack_require__(1042),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(689)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(361),
  /* template */
  __webpack_require__(1062),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(719)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(362),
  /* template */
  __webpack_require__(1094),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(678)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(363),
  /* template */
  __webpack_require__(1049),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(709)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(364),
  /* template */
  __webpack_require__(1082),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(641)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(365),
  /* template */
  __webpack_require__(1004),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(657)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(366),
  /* template */
  __webpack_require__(1023),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(675)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(367),
  /* template */
  __webpack_require__(1046),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(638)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(368),
  /* template */
  __webpack_require__(1001),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(690)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(370),
  /* template */
  __webpack_require__(1063),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(687)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(371),
  /* template */
  __webpack_require__(1060),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(372),
  /* template */
  __webpack_require__(989),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(373),
  /* template */
  __webpack_require__(997),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(374),
  /* template */
  __webpack_require__(1078),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(735)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(375),
  /* template */
  __webpack_require__(1114),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(686)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(376),
  /* template */
  __webpack_require__(1058),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(669)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(1037),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(378),
  /* template */
  __webpack_require__(968),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(705)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(379),
  /* template */
  __webpack_require__(1077),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(661)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(380),
  /* template */
  __webpack_require__(1027),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(697)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(381),
  /* template */
  __webpack_require__(1070),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(743)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(382),
  /* template */
  __webpack_require__(1124),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(644)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(1008),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(670)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(384),
  /* template */
  __webpack_require__(1038),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(744)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(385),
  /* template */
  __webpack_require__(1126),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(621)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(980),
  /* scopeId */
  "data-v-1a3ee1d9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(608)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(387),
  /* template */
  __webpack_require__(967),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(655)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(388),
  /* template */
  __webpack_require__(1021),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(714)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(1088),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(646)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(1010),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(598)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(952),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(736)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(394),
  /* template */
  __webpack_require__(1115),
  /* scopeId */
  "data-v-adb1ac36",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(680)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(1051),
  /* scopeId */
  "data-v-5b7ffe66",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(404),
  /* template */
  __webpack_require__(1106),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(405),
  /* template */
  __webpack_require__(988),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(740)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(406),
  /* template */
  __webpack_require__(1120),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(601)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(407),
  /* template */
  __webpack_require__(955),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(668)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(408),
  /* template */
  __webpack_require__(1035),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(652)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(409),
  /* template */
  __webpack_require__(1017),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(751)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(410),
  /* template */
  __webpack_require__(1135),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(676)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(411),
  /* template */
  __webpack_require__(1047),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(708)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(412),
  /* template */
  __webpack_require__(1081),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(750)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(413),
  /* template */
  __webpack_require__(1134),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(730)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(414),
  /* template */
  __webpack_require__(1108),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(616)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(415),
  /* template */
  __webpack_require__(975),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(696)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(416),
  /* template */
  __webpack_require__(1069),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(679)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(417),
  /* template */
  __webpack_require__(1050),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(637)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(418),
  /* template */
  __webpack_require__(1000),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(650)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(419),
  /* template */
  __webpack_require__(1014),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(711)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(420),
  /* template */
  __webpack_require__(1085),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(698)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(421),
  /* template */
  __webpack_require__(1071),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(664)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(422),
  /* template */
  __webpack_require__(1031),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(629)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(423),
  /* template */
  __webpack_require__(990),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(609)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(424),
  /* template */
  __webpack_require__(969),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(663)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(425),
  /* template */
  __webpack_require__(1030),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(622)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(426),
  /* template */
  __webpack_require__(981),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(427),
  /* template */
  __webpack_require__(1041),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(707)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(428),
  /* template */
  __webpack_require__(1080),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(725)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(429),
  /* template */
  __webpack_require__(1101),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(430),
  /* template */
  __webpack_require__(962),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(642)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(431),
  /* template */
  __webpack_require__(1005),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(715)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(432),
  /* template */
  __webpack_require__(1089),
  /* scopeId */
  "data-v-7d90cba3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(748)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(433),
  /* template */
  __webpack_require__(1130),
  /* scopeId */
  "data-v-d7230ed2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(691)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(1064),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(435),
  /* template */
  __webpack_require__(966),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(597)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(436),
  /* template */
  __webpack_require__(951),
  /* scopeId */
  "data-v-044c8a24",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(599)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(437),
  /* template */
  __webpack_require__(953),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(438),
  /* template */
  __webpack_require__(1117),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(439),
  /* template */
  __webpack_require__(1029),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(440),
  /* template */
  __webpack_require__(1043),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(704)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(1076),
  /* scopeId */
  "data-v-720ef8d4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(614)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(442),
  /* template */
  __webpack_require__(973),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(747)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(443),
  /* template */
  __webpack_require__(1129),
  /* scopeId */
  "data-v-d3dc4702",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(746)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(444),
  /* template */
  __webpack_require__(1128),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(674)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(445),
  /* template */
  __webpack_require__(1045),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(694)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(1067),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(615)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(447),
  /* template */
  __webpack_require__(974),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(731)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(448),
  /* template */
  __webpack_require__(1109),
  /* scopeId */
  "data-v-a479071c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(672)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(449),
  /* template */
  __webpack_require__(1040),
  /* scopeId */
  "data-v-54b612e2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(611)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(450),
  /* template */
  __webpack_require__(971),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(688)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(451),
  /* template */
  __webpack_require__(1061),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(718)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(452),
  /* template */
  __webpack_require__(1093),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(630)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(453),
  /* template */
  __webpack_require__(991),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(658)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(454),
  /* template */
  __webpack_require__(1024),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(631)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(455),
  /* template */
  __webpack_require__(992),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(600)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(456),
  /* template */
  __webpack_require__(954),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(457),
  /* template */
  __webpack_require__(958),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(458),
  /* template */
  __webpack_require__(959),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(459),
  /* template */
  __webpack_require__(964),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(460),
  /* template */
  __webpack_require__(1121),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(618)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(461),
  /* template */
  __webpack_require__(977),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(640)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(462),
  /* template */
  __webpack_require__(1003),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(713)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(463),
  /* template */
  __webpack_require__(1087),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(727)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(464),
  /* template */
  __webpack_require__(1103),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(729)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(465),
  /* template */
  __webpack_require__(1107),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(653)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(466),
  /* template */
  __webpack_require__(1019),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(648)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(467),
  /* template */
  __webpack_require__(1012),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(634)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(468),
  /* template */
  __webpack_require__(996),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(624)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(469),
  /* template */
  __webpack_require__(983),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(645)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(470),
  /* template */
  __webpack_require__(1009),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(742)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(471),
  /* template */
  __webpack_require__(1123),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(722)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(472),
  /* template */
  __webpack_require__(1097),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(721)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(473),
  /* template */
  __webpack_require__(1096),
  /* scopeId */
  "data-v-8d93526c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(745)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(474),
  /* template */
  __webpack_require__(1127),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(699)
__webpack_require__(700)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(475),
  /* template */
  __webpack_require__(1072),
  /* scopeId */
  "data-v-6d578301",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(692)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(476),
  /* template */
  __webpack_require__(1065),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(610)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(477),
  /* template */
  __webpack_require__(970),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(596)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(478),
  /* template */
  __webpack_require__(949),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(480),
  /* template */
  __webpack_require__(1113),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(734)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(481),
  /* template */
  __webpack_require__(1112),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(482),
  /* template */
  __webpack_require__(1125),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(628)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(483),
  /* template */
  __webpack_require__(987),
  /* scopeId */
  "data-v-1d297f4f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(724)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(484),
  /* template */
  __webpack_require__(1100),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(605)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(485),
  /* template */
  __webpack_require__(961),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(486),
  /* template */
  __webpack_require__(995),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(487),
  /* template */
  __webpack_require__(1036),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(660)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(488),
  /* template */
  __webpack_require__(1026),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(702)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(489),
  /* template */
  __webpack_require__(1074),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(739)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(490),
  /* template */
  __webpack_require__(1119),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(749)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(491),
  /* template */
  __webpack_require__(1131),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(701)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(492),
  /* template */
  __webpack_require__(1073),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(493),
  /* template */
  __webpack_require__(950),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(683)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(494),
  /* template */
  __webpack_require__(1054),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(495),
  /* template */
  __webpack_require__(1018),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(496),
  /* template */
  __webpack_require__(1044),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(497),
  /* template */
  __webpack_require__(1092),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(626)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(498),
  /* template */
  __webpack_require__(985),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(685)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(499),
  /* template */
  __webpack_require__(1057),
  /* scopeId */
  "data-v-5f4caf6e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(612)
__webpack_require__(613)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(500),
  /* template */
  __webpack_require__(972),
  /* scopeId */
  "data-v-135d1641",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(501),
  /* template */
  __webpack_require__(1133),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(666)
__webpack_require__(667)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(503),
  /* template */
  __webpack_require__(1034),
  /* scopeId */
  "data-v-4c309dbc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(682)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(505),
  /* template */
  __webpack_require__(1053),
  /* scopeId */
  "data-v-5c8c5948",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(507),
  /* template */
  __webpack_require__(1099),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(710)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(508),
  /* template */
  __webpack_require__(1084),
  /* scopeId */
  "data-v-7a5e8cbc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(509),
  /* template */
  __webpack_require__(1015),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(510),
  /* template */
  __webpack_require__(1006),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(1059),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(635)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(511),
  /* template */
  __webpack_require__(998),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 949 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  }), _vm._v(" "), _c('pushdia', {
    attrs: {
      "pObj": _vm.pObj
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('div', {}, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.jumpToUpload
    }
  }, [_vm._v(_vm._s(_vm.$t('app_newtask')) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.batchData.length == 0 || _vm.cantdel,
      "type": "danger"
    },
    on: {
      "click": _vm.batchDel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_mulDel')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "offset": 4,
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('app_filetype')
    },
    on: {
      "change": _vm.fileTypeChange
    },
    model: {
      value: (_vm.ftype),
      callback: function($$v) {
        _vm.ftype = $$v
      },
      expression: "ftype"
    }
  }, _vm._l((_vm.tsTypes), function(item) {
    return _c('el-option', {
      key: item.type,
      attrs: {
        "label": item.name,
        "value": item.type
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_taskName'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_deviceNo'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.terno),
      callback: function($$v) {
        _vm.terno = $$v
      },
      expression: "terno"
    }
  })], 1)])], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticClass: "tbPoint gTopMg",
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick,
      "sort-change": _vm.sortChange,
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "taskName",
      "sortable": "custom",
      "label": _vm.$t('app_taskName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "subTasks",
      "label": _vm.$t('app_subtsnum'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "terNum",
      "width": "",
      "label": _vm.$t('app_deviceNum')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "success",
      "width": "",
      "label": _vm.$t('app_success')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "fail",
      "width": "",
      "label": _vm.$t('app_fail')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "other",
      "width": "",
      "label": _vm.$t('app_other')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "sortable": "custom",
      "prop": "createTime",
      "width": "175",
      "label": _vm.$t('app_createTime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "right",
      "prop": "operate",
      "width": "106",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_edit'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.terNum == 0),
            expression: "scope.row.terNum == 0"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.editRow(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_adddv'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.addDev(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-plus"
        })])], 1), _vm._v(" "), (scope.row.success == scope.row.terNum) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.cancelPush(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 950 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m_context"
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-left": "24px"
    },
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.lockOta')))])], 1)], 1), _vm._v(" "), _c('el-table', {
    ref: "arrdata",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.arrdata,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "otaName",
      "label": _vm.$t('lin_global.name'),
      "width": "220"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "otaVersion",
      "label": _vm.$t('lin_global.version'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mechanismName",
      "label": _vm.$t('lin_global.label_areaid'),
      "width": "250"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalNums",
      "label": _vm.$t('terminal.OtaList.lock_num'),
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('lin_global.ope')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.unlock'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.lockRow(scope.row.lockId)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-unlock"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.totalRecords > 0) ? _c('div', {
    staticClass: "page_content"
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 50, 100],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 951 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "gPageBorder"
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "24px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4,
      "offset": 12
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('lin_global.status')
    },
    on: {
      "change": _vm.query
    },
    model: {
      value: (_vm.select_form.status),
      callback: function($$v) {
        _vm.$set(_vm.select_form, "status", $$v)
      },
      expression: "select_form.status"
    }
  }, _vm._l((_vm.dest_list), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_serialnumber'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.select_form.terminalNo),
      callback: function($$v) {
        _vm.$set(_vm.select_form, "terminalNo", $$v)
      },
      expression: "select_form.terminalNo"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "data": _vm.tableData2,
      "id": "tp",
      "border": ""
    },
    on: {
      "row-click": _vm.rowClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "terminalNo",
      "label": _vm.$t('app_serialnumber')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mechName",
      "label": _vm.$t('lin_global.label_areaid')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalStatus",
      "label": _vm.$t('app_netStatus'),
      "show-overflow-tooltip": true,
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "color": _vm.formatNetwork(scope.row) ? _vm.formatNetwork(scope.row).color : '',
            "type": _vm.formatNetwork(scope.row) ? _vm.formatNetwork(scope.row).type : ''
          }
        }, [_vm._v(_vm._s(_vm.formatNetwork(scope.row).lb))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": _vm.$t('lin_global.status'),
      "formatter": _vm.formatStatus,
      "show-overflow-tooltip": true,
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": scope.row.status == 1 ? 'success' : 'danger'
          }
        }, [_vm._v(_vm._s(_vm.formatStatus(scope.row)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalOnlineTime",
      "label": _vm.$t('app_udtime'),
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "left",
      "label": _vm.$t('lin_global.ope'),
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_global.jh'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status == 2 ? true : false),
            expression: "scope.row.status == 2 ? true : false"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.actRow(scope.row)
            }
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('lin_global.jh')) + "\n\t\t\t\t\t\t\t")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.totalRecords > 0) ? _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 50, 100],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('lin_global.xiafa')
    },
    model: {
      value: (_vm.xiafaVisible),
      callback: function($$v) {
        _vm.xiafaVisible = $$v
      },
      expression: "xiafaVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    staticClass: "gDiaTable",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "22.5%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.certificateName')
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.zhengshu) + "\n\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.qudaoshangxinxi')
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.qudaoshangxinxi) + "\n\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.tslxxx')
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.changeType
    },
    model: {
      value: (_vm.form.pushType),
      callback: function($$v) {
        _vm.$set(_vm.form, "pushType", $$v)
      },
      expression: "form.pushType"
    }
  }, _vm._l((_vm.type), function(item) {
    return _c('el-option', {
      key: item.typeid,
      attrs: {
        "label": item.typename,
        "value": item.typeid
      }
    })
  }))], 1), _vm._v(" "), (_vm.isShow) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_areaid'),
      "prop": "terminalNo"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": _vm.$t('lin_global.place_areaid')
    },
    model: {
      value: (_vm.form.terminalNo),
      callback: function($$v) {
        _vm.$set(_vm.form, "terminalNo", $$v)
      },
      expression: "form.terminalNo"
    }
  }, _vm._l((_vm.areaList), function(item) {
    return _c('el-option', {
      key: item.mechanismid,
      attrs: {
        "label": item.mechanismname,
        "value": item.mechanismid
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (!_vm.isShow) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_no'),
      "prop": "terminalNo"
    }
  }, [_c('AutoTerno', {
    on: {
      "on-result-change": _vm.onDvInputChange
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "margin-right": "74%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.isSubmit
    },
    on: {
      "click": _vm.xiafaSubmit
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t('lin_global.xiafa')) + "\n\t\t\t\t\t")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 952 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "appbind"
    }
  }, [_c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  }), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isAppBatch),
      expression: "!isAppBatch"
    }],
    staticStyle: {
      "margin-bottom": "20px",
      "margin-top": "5px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.pushedList = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_pusheddvlist')))]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_pushDevice'),
      "size": "large"
    },
    on: {
      "open": _vm.open,
      "close": _vm.close
    },
    model: {
      value: (_vm.pushedList),
      callback: function($$v) {
        _vm.pushedList = $$v
      },
      expression: "pushedList"
    }
  }, [_c('div', {
    staticClass: " ",
    attrs: {
      "id": ""
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '10'),
      expression: "info.type === '10'"
    }],
    staticClass: "gSgLeftBtn",
    on: {
      "click": function($event) {
        _vm.allUnbind()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_bcrecov')) + " (" + _vm._s(_vm.sNum) + ")")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '1'),
      expression: "info.type === '1'"
    }],
    on: {
      "click": function($event) {
        _vm.mulDelAppPush()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_mulUnbind')) + " (" + _vm._s(_vm.sNum) + ")")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    on: {
      "click": function($event) {
        _vm.refreshBind()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.shuaxin')))])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "offset": 16,
      "span": 4
    }
  }, [_c('div', {}, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_adname'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "dpTable",
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalName",
      "align": "center",
      "label": _vm.$t('app_deviceName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_deviceNo'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pushTime",
      "align": "center",
      "label": _vm.$t('app_pushTime'),
      "width": "175"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "106"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.info.type === '10'),
            expression: "info.type === '10'"
          }],
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_recov'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-history"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.dfDelCt,
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.info.type === '1'),
            expression: "info.type === '1'"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.delAppPush(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.page,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "background": "none",
      "padding": "0 0px 0 24px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "ldt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.info ? _vm.info.fileName : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "65px"
    }
  }, [_c('table', {
    staticClass: "ldt-file"
  }, [_c('tr', {}, [_c('td', [_c('label', {
    staticClass: "ldt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_version')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "ldt-word-main"
  }, [_vm._v(_vm._s(_vm.info ? _vm.info.fileVersion : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "ldt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_filetype')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "ldt-word-main"
  }, [_vm._v(_vm._s(_vm.info ? _vm.getftype[_vm.info.fileType] : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "ldt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_subtype')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "ldt-word-main"
  }, [_vm._v(_vm._s(_vm.info ? _vm.getstype[_vm.info.subFileType] : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "ldt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_distributor')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "ldt-word-main"
  }, [_vm._v(_vm._s(_vm.info ? _vm.info.mechName : ''))])])]), _vm._v(" "), _c('tr', {}, [_c('td', [_c('label', {
    staticClass: "ldt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_adddate')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "ldt-word-main"
  }, [_vm._v(_vm._s(_vm.info ? _vm.info.createTime : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "ldt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_fileSize')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "ldt-word-main"
  }, [_vm._v(_vm._s(_vm.info ? (_vm.info.fileSize / 1024).toFixed(2) : '') + "KB")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', {
    staticClass: "ldt-word-title"
  }, [_vm._v("MD5：")]), _vm._v(" "), _c('label', {
    staticClass: "ldt-word-main"
  }, [_vm._v(_vm._s(_vm.info ? _vm.info.hashCode : ''))])]), _vm._v(" "), _c('td')])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "none",
      "min-height": "10px",
      "display": "-webkit-flex"
    }
  }, [_c('div', {
    staticClass: "ldt-word-title",
    staticStyle: {
      "display": "inline-block",
      "min-width": "70px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('app_filedesc')) + "：\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "ldt-word-main",
    staticStyle: {
      "display": "inline-block",
      "position": "relative",
      "background": "none",
      "margin": "0 24px 24px 0",
      "padding-right": "24px"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.info ? _vm.info.memo : ''))])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder gTopMg",
    attrs: {
      "id": ""
    }
  }, [_c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_push')
    },
    on: {
      "open": _vm.open,
      "close": _vm.close
    },
    model: {
      value: (_vm.pushQs),
      callback: function($$v) {
        _vm.pushQs = $$v
      },
      expression: "pushQs"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('app_ispushf') + '，' + _vm.fileName) + "？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '1'),
      expression: "info.type === '1'"
    }],
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.check1),
      callback: function($$v) {
        _vm.check1 = $$v
      },
      expression: "check1"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_autoscopen')))]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.check2),
      callback: function($$v) {
        _vm.check2 = $$v
      },
      expression: "check2"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_psscandtip')))])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '2'),
      expression: "info.type === '2'"
    }],
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.check1),
      callback: function($$v) {
        _vm.check1 = $$v
      },
      expression: "check1"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_tipud')))]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.check2),
      callback: function($$v) {
        _vm.check2 = $$v
      },
      expression: "check2"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_tipdown')))])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.pushQs = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.surePush
    }
  }, [_vm._v(_vm._s(_vm.$t('app_srpush')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_fipush')
    },
    on: {
      "close": _vm.closeImport
    },
    model: {
      value: (_vm.pushImport),
      callback: function($$v) {
        _vm.pushImport = $$v
      },
      expression: "pushImport"
    }
  }, [_c('el-form', {
    ref: "",
    attrs: {
      "model": "",
      "rules": ""
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_ulfile'),
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "name": "fileUpload",
      "action": _vm.importTemplate,
      "on-remove": _vm.handleRemove,
      "before-upload": _vm.srcBefore,
      "on-success": _vm.srcSuccess,
      "on-error": _vm.ulError,
      "file-list": _vm.fileList,
      "auto-upload": true
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v(_vm._s(_vm.$t('app_clickUpdate')))]), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-left": "8px",
      "margin-right": "10px"
    },
    attrs: {
      "href": _vm.downTpl
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "size": "small"
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.list.import_muban')))])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_deviceNum'),
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n          " + _vm._s(_vm.uldata ? _vm.uldata.terNums : 0 + _vm.$t('app_amechine')) + "\n        ")])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '1'),
      expression: "info.type === '1'"
    }],
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.check1),
      callback: function($$v) {
        _vm.check1 = $$v
      },
      expression: "check1"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_autoscopen')))]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.check2),
      callback: function($$v) {
        _vm.check2 = $$v
      },
      expression: "check2"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_psscandtip')))])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '2'),
      expression: "info.type === '2'"
    }],
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.check1),
      callback: function($$v) {
        _vm.check1 = $$v
      },
      expression: "check1"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_tipud')))]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.check2),
      callback: function($$v) {
        _vm.check2 = $$v
      },
      expression: "check2"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_tipdown')))])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.pushImport = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "disabled": !_vm.uldata,
      "type": "primary"
    },
    on: {
      "click": _vm.submitUpload
    }
  }, [_vm._v(_vm._s(_vm.$t('app_srpush')))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_pushAll')
    },
    on: {
      "open": _vm.open,
      "close": _vm.close
    },
    model: {
      value: (_vm.pushAll),
      callback: function($$v) {
        _vm.pushAll = $$v
      },
      expression: "pushAll"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.allMcName))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '1'),
      expression: "info.type === '1'"
    }],
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.check1),
      callback: function($$v) {
        _vm.check1 = $$v
      },
      expression: "check1"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_autoscopen')))]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.check2),
      callback: function($$v) {
        _vm.check2 = $$v
      },
      expression: "check2"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_psscandtip')))])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '2'),
      expression: "info.type === '2'"
    }],
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.check1),
      callback: function($$v) {
        _vm.check1 = $$v
      },
      expression: "check1"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_tipud')))]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.check2),
      callback: function($$v) {
        _vm.check2 = $$v
      },
      expression: "check2"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_tipdown')))])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.pushAll = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.surePushAll
    }
  }, [_vm._v(_vm._s(_vm.$t('app_srpush')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_srpush')
    },
    on: {
      "open": _vm.open,
      "close": _vm.close
    },
    model: {
      value: (_vm.pushAf),
      callback: function($$v) {
        _vm.pushAf = $$v
      },
      expression: "pushAf"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.surePushTip))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.pushAf = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.coverPush('1')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cvpush')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.coverPush('0')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_skpush')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_pssuccess')
    },
    on: {
      "open": _vm.open,
      "close": _vm.close
    },
    model: {
      value: (_vm.pushDone),
      callback: function($$v) {
        _vm.pushDone = $$v
      },
      expression: "pushDone"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('app_isjtoviewtd') + '?') + " ")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.pushDone = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.jumpNow
    }
  }, [_vm._v(_vm._s(_vm.$t('app_nowjump')))])], 1)]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    on: {
      "click": _vm.multiBind
    }
  }, [_vm._v(_vm._s(_vm.$t('app_mulPush')) + " (" + _vm._s(_vm.sNum1) + ")")]), _vm._v(" "), _c('el-button', {
    staticClass: "gSgLeftBtn",
    on: {
      "click": function($event) {
        _vm.pushAll = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_allpush')))]), _vm._v(" "), _c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "disabled": false
    },
    on: {
      "click": function($event) {
        _vm.pushImport = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_fipush')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.selectStChange
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.stModel), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_deviceNo') + '/' + _vm.$t('app_deviceName'),
      "icon": "search",
      "on-icon-click": _vm.srch
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srch($event)
      }
    },
    model: {
      value: (_vm.iNo),
      callback: function($$v) {
        _vm.iNo = $$v
      },
      expression: "iNo"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData1,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange1
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_deviceNo'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalName",
      "align": "center",
      "label": _vm.$t('app_deviceName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminal_status",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.isNon) ? _c('span', [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_enable')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e()], 1) : _c('span', [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 3) ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_sleep')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 4) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_btn.lock')))]) : _vm._e()], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_push'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate1(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total1
    },
    on: {
      "current-change": _vm.pageSelect1,
      "size-change": _vm.pageSized1
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 953 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-form', {
    ref: "cer",
    staticClass: "gForm",
    attrs: {
      "label-position": "right",
      "rules": _vm.rules,
      "label-width": "12.5%",
      "model": _vm.cer
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.certificateName'),
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.cer.name),
      callback: function($$v) {
        _vm.$set(_vm.cer, "name", $$v)
      },
      expression: "cer.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.remark'),
      "prop": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.cer.mark),
      callback: function($$v) {
        _vm.$set(_vm.cer, "mark", $$v)
      },
      expression: "cer.mark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.uploadType == 1),
      expression: "uploadType == 1"
    }],
    attrs: {
      "label": _vm.$t('app_distributor'),
      "prop": ""
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData,
      "mselect": true,
      "cclasss": "'w_33'"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_cerFile'),
      "prop": "curl"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "name": "fileUpload",
      "action": _vm.fileUploadUrl,
      "on-remove": _vm.removeFile,
      "before-upload": _vm.cerBefore,
      "on-success": _vm.cerSuccess,
      "file-list": _vm.srcList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_clickUpdate')))]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.$t('app_plsUlPbCer')))])], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('app_submit')))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 954 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    staticClass: "tbPoint",
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick,
      "sort-change": _vm.sortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "fileName",
      "sortable": "custom",
      "label": _vm.$t('app_filename'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "fileVersion",
      "width": "",
      "label": _vm.$t('app_version')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "fileType",
      "formatter": _vm.setft,
      "width": "115",
      "label": _vm.$t('app_filetype')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "subFileType",
      "formatter": _vm.setsbt,
      "width": "120",
      "label": _vm.$t('app_subtype')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "mechName",
      "width": "",
      "label": _vm.$t('app_distributor')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "fileStatus",
      "width": "115",
      "label": _vm.$t('app_status')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          style: (_vm.getStatus(scope.row.fileStatus).style)
        }, [_vm._v(_vm._s(_vm.getStatus(scope.row.fileStatus).vl))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "sortable": "custom",
      "prop": "createTime",
      "width": "175",
      "label": _vm.$t('app_addtime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "operate",
      "width": "84",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_verify'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_c('i', {
          staticClass: "fa fa-check-square-o"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 955 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gLeftScCtrl"
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('app_taskType'),
      "clearable": ""
    },
    on: {
      "change": _vm.query
    },
    model: {
      value: (_vm.taskType),
      callback: function($$v) {
        _vm.taskType = $$v
      },
      expression: "taskType"
    }
  }, _vm._l((_vm.missionList), function(item) {
    return _c('el-option', {
      key: item.type,
      attrs: {
        "label": item.name,
        "value": item.type
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gLeftScCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_taskName'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.missionName),
      callback: function($$v) {
        _vm.missionName = $$v
      },
      expression: "missionName"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "cmData"
    }
  }, [_c('el-table', {
    staticClass: "gTopMg tbPoint",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "fileName",
      "label": _vm.$t('app_taskDetail'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "version",
      "label": _vm.$t('app_version'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "left",
      "label": _vm.$t('app_taskType'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', [_vm._v(_vm._s(_vm.missionNames[scope.row.taskType]))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "terNums",
      "label": _vm.$t('app_deviceNum'),
      "width": "95"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "createTime",
      "label": _vm.$t('app_pushTime'),
      "width": "170"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "label": _vm.$t('app_operate'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_global.look_detail'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.viewDetail(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-file-text"
        })])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": ""
    },
    on: {
      "open": _vm.open,
      "close": _vm.close
    },
    model: {
      value: (_vm.dialogFormVisible),
      callback: function($$v) {
        _vm.dialogFormVisible = $$v
      },
      expression: "dialogFormVisible"
    }
  }, [_c('div', [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "25%",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_typeName')) + "：")]), _vm._v(" "), _c('td', [_c('el-input', {
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sure
    }
  }, [_vm._v(_vm._s(_vm.$t('app_sure')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 956 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.sForm.ad_status === 3) ? _c('el-alert', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "title": _vm.errorTip,
      "type": "error"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "m_context plr"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "sForm",
    attrs: {
      "model": _vm.sForm,
      "label-width": "80px",
      "rules": _vm.editRules
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sForm.ad_id),
      expression: "sForm.ad_id"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.sForm.ad_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sForm, "ad_id", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.name'),
      "prop": "ad_title"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.sForm.ad_title),
      callback: function($$v) {
        _vm.$set(_vm.sForm, "ad_title", $$v)
      },
      expression: "sForm.ad_title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.classify'),
      "prop": "ad_type"
    }
  }, [_c('el-select', {
    staticClass: "w_33",
    attrs: {
      "placeholder": _vm.$t('lin_global.qxzlx')
    },
    model: {
      value: (_vm.sForm.ad_type),
      callback: function($$v) {
        _vm.$set(_vm.sForm, "ad_type", $$v)
      },
      expression: "sForm.ad_type"
    }
  }, _vm._l((_vm.adTypeList), function(item, index) {
    return _c('el-option', {
      key: item.adtypeId,
      attrs: {
        "label": item.adtypeName,
        "value": item.adtypeId
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.position'),
      "prop": "ad_position"
    }
  }, [_c('el-select', {
    staticClass: "w_33",
    attrs: {
      "placeholder": _vm.$t('app_selectPlayPlace')
    },
    model: {
      value: (_vm.sForm.ad_position),
      callback: function($$v) {
        _vm.$set(_vm.sForm, "ad_position", $$v)
      },
      expression: "sForm.ad_position"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$t('advert.positionSub.banner'),
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$t('advert.positionSub.starPage'),
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$t('app_appadv'),
      "value": "3"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.jumpType')
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.sForm.ad_Urltype),
      callback: function($$v) {
        _vm.$set(_vm.sForm, "ad_Urltype", $$v)
      },
      expression: "sForm.ad_Urltype"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": '0'
    }
  }, [_vm._v(_vm._s(_vm.$t('advert.jumpTypeSub.net')))]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '1'
    }
  }, [_vm._v(_vm._s(_vm.$t('advert.jumpTypeSub.appStore')))])], 1)], 1), _vm._v(" "), (_vm.sForm.ad_Urltype === '1') ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.app'),
      "prop": "ad_url"
    }
  }, [(_vm.appName) ? _c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.choiceAppVisible = true
      }
    }
  }, [_vm._v(_vm._s(_vm.appName))]) : _c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.choiceAppVisible = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_sapp')))])], 1) : _vm._e(), _vm._v(" "), (_vm.sForm.ad_Urltype === '0') ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.url'),
      "prop": "ad_url"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.sForm.ad_url),
      callback: function($$v) {
        _vm.$set(_vm.sForm, "ad_url", $$v)
      },
      expression: "sForm.ad_url"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.channel'),
      "prop": "ad_channel"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData,
      "mselect": true,
      "classs": 'w_33'
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.ableDate')
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd hh:mm",
      "picker-options": _vm.pickerOptions0,
      "placeholder": _vm.$t('advert.beginDate')
    },
    model: {
      value: (_vm.sForm.ad_start_date),
      callback: function($$v) {
        _vm.$set(_vm.sForm, "ad_start_date", $$v)
      },
      expression: "sForm.ad_start_date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "span": 2
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd hh:mm",
      "picker-options": _vm.pickerOptions1,
      "placeholder": _vm.$t('advert.endDate')
    },
    model: {
      value: (_vm.sForm.ad_start_end),
      callback: function($$v) {
        _vm.$set(_vm.sForm, "ad_start_end", $$v)
      },
      expression: "sForm.ad_start_end"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.contentImg'),
      "prop": "ad_imgUrl"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.adUlld),
      expression: "adUlld"
    }],
    staticStyle: {
      "padding": "10px"
    }
  }, [(_vm.isscale) ? _c('div', [_c('croppa', {
    staticStyle: {
      "zoom": "0.5",
      "padding-top": "38px"
    },
    attrs: {
      "placeholder-font-size": 30,
      "placeholder": _vm.$t('app_spic'),
      "width": 360,
      "height": _vm.psize,
      "prevent-white-space": true,
      "iinitial-image": "dfImg",
      "remove-button-color": '#409EFF'
    },
    model: {
      value: (_vm.croppa),
      callback: function($$v) {
        _vm.croppa = $$v
      },
      expression: "croppa"
    }
  }, [_c('img', {
    attrs: {
      "slot": "initial",
      "crossOrigin": "anonymous",
      "src": _vm.dfImg
    },
    slot: "initial"
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": ""
    },
    on: {
      "click": _vm.upload
    }
  }, [_vm._v(_vm._s(_vm.$t('app_upload')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#AAAEBA",
      "margin-top": "8px",
      "width": "700px",
      "background": "none"
    }
  }, [_vm._v(_vm._s(_vm.sizeTip))])], 1) : _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": "https://jsonplaceholder.typicode.com/posts/",
      "before-upload": _vm.upload1,
      "ffile-list": "fileList"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_clickUpdate')))]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.getImgName()))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [(!_vm.isscale && _vm.sForm.ad_imgUrl) ? _c('img', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "src": _vm.$host + _vm.sForm.ad_imgUrl
    }
  }) : _vm._e()])], 1), _vm._v(" "), _c('el-checkbox', {
    on: {
      "change": _vm.scaleChange
    },
    model: {
      value: (_vm.isscale),
      callback: function($$v) {
        _vm.isscale = $$v
      },
      expression: "isscale"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_propcut')))])], 1)]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.cancel')))]), _vm._v(" "), (_vm.sForm.ad_id === '0') ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.createAdvert
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.add')))]) : [(_vm.sForm.ad_status == 0 || _vm.sForm.ad_status == 3 || _vm.sForm.ad_status == 4 || _vm.sForm.ad_status == 5) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateAdvert
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.update')))]) : _vm._e()]], 2)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('app_sapp'),
      "visible": _vm.choiceAppVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.choiceAppVisible = $event
      }
    }
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.appName')
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_iappnamesrch')
    },
    model: {
      value: (_vm.tmp_appName),
      callback: function($$v) {
        _vm.tmp_appName = $$v
      },
      expression: "tmp_appName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getAppListByName
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.tip.search')))])], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.appList
    },
    on: {
      "cell-click": _vm.choiceAppRecord
    }
  }, [_c('el-table-column', {
    attrs: {
      "property": "appName",
      "label": _vm.$t('advert.appSub.name')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "appCategoryName",
      "label": _vm.$t('advert.appSub.classify')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "chekcTime",
      "label": _vm.$t('advert.appSub.uploadTime'),
      "formatter": _vm.dateFormat
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "appVersion",
      "label": _vm.$t('advert.appSub.version')
    }
  })], 1), _vm._v(" "), _c('paging', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "rdata": _vm.pagingData,
      "action": _vm.pAction,
      "arraySize": "[5,8]"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.choiceAppVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.cancel')))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 957 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-autocomplete', {
    staticClass: "inline-input",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "fetch-suggestions": _vm.querySearch,
      "placeholder": ""
    },
    on: {
      "select": _vm.handleSelect,
      "change": _vm.ipChange
    },
    model: {
      value: (_vm.vl),
      callback: function($$v) {
        _vm.vl = $$v
      },
      expression: "vl"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 958 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder"
  }, [_c('el-table', {
    ref: "arrdata",
    staticClass: "tbPoint",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.check
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "firmwareName",
      "label": _vm.$t('lin_global.name')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "version",
      "label": _vm.$t('lin_global.version'),
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('lin_global.status'),
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 0) ? _c('span', {
          staticStyle: {
            "color": "#8492A6"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.waitOne')))]) : _vm._e(), _vm._v(" "), (scope.row.status == 1) ? _c('span', {
          staticStyle: {
            "color": "#F7BA2A"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.waitTwo')))]) : _vm._e(), _vm._v(" "), (scope.row.status == 2) ? _c('span', {
          staticStyle: {
            "color": "#13CE66"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.verifyPass')))]) : _vm._e(), _vm._v(" "), (scope.row.status == 3) ? _c('span', {
          staticStyle: {
            "color": "#FF4949"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.verifyNotPass')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": _vm.$t('terminal.details.animatType'),
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mechanismName",
      "label": _vm.$t('lin_global.label_areaid')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "downloads",
      "label": _vm.$t('lin_global.downNumber'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('lin_global.ope'),
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_verify'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_c('i', {
          staticClass: "fa fa-check-square-o"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.pageSized,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 959 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_srban'),
      "size": "small"
    },
    model: {
      value: (_vm.reasonDia),
      callback: function($$v) {
        _vm.reasonDia = $$v
      },
      expression: "reasonDia"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "-8px"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.app_banandrs)))]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100%",
      "margin-top": "16px"
    },
    attrs: {
      "placeholder": _vm.$t('app_banandrs'),
      "type": "textarea"
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "margin-top": "-20px"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.onSubmit('3')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_suresm')))])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "gPageBorder gTopMg gPdTB"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_name')
    }
  }, [_vm._v("\n              " + _vm._s(_vm.editInfo ? _vm.editInfo.firmwareName : '') + "\n            ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.version')
    }
  }, [_vm._v("\n              " + _vm._s(_vm.editInfo ? _vm.editInfo.version : '') + "\n            ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_distributor')
    }
  }, [_vm._v("\n              " + _vm._s(_vm.editInfo ? _vm.editInfo.mechanismName : '') + "\n            ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-left": "24px",
      "margin-bottom": "12px"
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.onSubmit('2')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_psverify')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.reasonDia = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_ban')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.pushTest
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.tsazcs')))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "size": "small",
      "title": _vm.$t('lin_global.zdtslb')
    },
    model: {
      value: (_vm.showTable),
      callback: function($$v) {
        _vm.showTable = $$v
      },
      expression: "showTable"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('lin_global.label_no'),
      "icon": "search",
      "on-icon-click": _vm.handleIconClick
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.focusEvent(_vm.handleIconClick)
      }
    },
    model: {
      value: (_vm.input1),
      callback: function($$v) {
        _vm.input1 = $$v
      },
      expression: "input1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-table', {
    ref: "arrdata",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.arrdata,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "terminalName",
      "label": _vm.$t('lin_global.label_name'),
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalNo",
      "label": _vm.$t('lin_global.label_no'),
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('lin_global.status'),
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.new_add')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 3) ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_sleep')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mechName",
      "label": _vm.$t('lin_global.label_areaid')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "80",
      "label": _vm.$t('lin_global.ope')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.send'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.give(scope.row.terminalNo)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 50, 100],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_pushInstallTest'),
      "size": ""
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "background": "none",
      "text-align": "left"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_searchTerminal'),
      "icon": "search"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srchDevice($event)
      }
    },
    model: {
      value: (_vm.srchValue),
      callback: function($$v) {
        _vm.srchValue = $$v
      },
      expression: "srchValue"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_terNo'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminal_status",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 3) ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_sleep')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_push'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.pushInstall(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 960 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.$t('app_tip'),
      "visible": _vm.cerDialogVisible,
      "size": "tiny",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.cerDialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.cerTipMsg))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.cerDialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.pushUploadCer
    }
  }, [_vm._v(_vm._s(_vm.$t('app_uploadCer')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('app_tip'),
      "visible": _vm.cerTipDialogVisible,
      "size": "tiny",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.cerTipDialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.cerTipMsg))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.cerTipDialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_sure')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_addPush'),
      "size": "middle"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dvLoading),
      expression: "dvLoading"
    }]
  }, [_c('div', {
    staticClass: "gDiaTable",
    staticStyle: {
      "width": "100%",
      "background": "none",
      "text-align": "left"
    }
  }, [_c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_distributor')
    },
    on: {
      "change": _vm.selectDvChange
    },
    model: {
      value: (_vm.channelId),
      callback: function($$v) {
        _vm.channelId = $$v
      },
      expression: "channelId"
    }
  }, _vm._l((_vm.channels), function(item) {
    return _c('el-option', {
      key: item.mechanismid,
      attrs: {
        "label": item.mechanismname,
        "value": item.mechanismid
      }
    })
  }))], 1), _vm._v(" "), _c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.selectDvChange
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.stModel), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.label,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "40%",
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": _vm.$t('app_searchTerminal'),
      "icon": "search"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srchDevice($event)
      }
    },
    model: {
      value: (_vm.srchValue),
      callback: function($$v) {
        _vm.srchValue = $$v
      },
      expression: "srchValue"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dvTableData,
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_terNo'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminal_status",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.dvIndex,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.dvTotal
    },
    on: {
      "current-change": _vm.pageDvSelect,
      "size-change": _vm.pageDvSized
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('div', {}, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.jumpToUpload
    }
  }, [_vm._v(_vm._s(_vm.$t('app_uploadApp')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_vStatus')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.appvst),
      callback: function($$v) {
        _vm.appvst = $$v
      },
      expression: "appvst"
    }
  }, _vm._l((_vm.appvStatus), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('MechanismSelector', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-input', {
    attrs: {
      "icon": "search",
      "on-icon-click": _vm.query,
      "placeholder": _vm.$t('app_ippkgname')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.pkg),
      callback: function($$v) {
        _vm.pkg = $$v
      },
      expression: "pkg"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_appName'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)])], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticClass: "tbPoint gTopMg",
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick,
      "sort-change": _vm.sortChange,
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appName",
      "sortable": "custom",
      "label": _vm.$t('app_appName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appCategoryName",
      "width": "",
      "label": _vm.$t('app_type')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "distributorName",
      "width": "",
      "label": _vm.$t('app_distributor')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "width": "115",
      "label": _vm.$t('app_vStatus')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-label', {
          style: (_vm.getStatus(scope.row.appStatus).style)
        }, [_vm._v(_vm._s(_vm.getStatus(scope.row.appStatus).vl))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appVersion",
      "width": "",
      "label": _vm.$t('app_newgVer')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "createTime",
      "width": "175",
      "sortable": "custom",
      "label": _vm.$t('app_ulTime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "right",
      "prop": "operate",
      "width": "106",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "background": "none"
          }
        }, [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_edit'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.appStatus == 0 || scope.row.appStatus == 3),
            expression: "scope.row.appStatus == 0 || scope.row.appStatus == 3"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.editApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_smVerify'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.appStatus !== '1' && scope.row.appStatus !== '2' && scope.row.isoperation === 0),
            expression: "scope.row.appStatus !== '1' && scope.row.appStatus !== '2' && scope.row.isoperation === 0"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.submitApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-up"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.isoperation === 0),
            expression: "scope.row.isoperation === 0"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 961 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "gPageBorder pushObjectDetail"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.titleName))]), _vm._v(" "), _c('el-row', {
    staticClass: "detail",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('label', [_vm._v("版本号:")]), _vm._v(_vm._s(_vm.info['version'] || ''))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('label', [_vm._v("文件大小:")]), _vm._v(_vm._s(_vm.info.size || ''))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('label', [_vm._v("渠道商:")]), _vm._v(_vm._s(_vm.info['mechanismName']))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('label', [_vm._v("上传时间:")]), _vm._v(_vm._s(_vm.info.opetime || ''))])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "mark",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('label', [_vm._v("OTA描述:")]), _vm._v(_vm._s(_vm.info['memo'] || ''))])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.pLoading),
      expression: "pLoading"
    }],
    staticClass: "gTopMg gPageBorder"
  }, [_c('p', {
    staticClass: "gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_pushHistory')))]), _vm._v(" "), _c('div', {
    staticClass: "subTitle_buttonBar"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.jumpToPush()
      }
    }
  }, [_vm._v("添加推送")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_vm._v("批量还原(" + _vm._s(_vm.multipleSelection.length || 0) + ")")])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "row-click": _vm.cellClick,
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechanismName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "nums",
      "label": _vm.$t('app_deviceNum'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "pushTime",
      "label": _vm.$t('app_pushTime'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "align": "center",
      "label": _vm.$t('app_operate'),
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_clear'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('paging', {
    attrs: {
      "rdata": _vm.pagingData,
      "action": _vm.pAction
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "1px",
      "margin-bottom": "20px"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 962 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder"
  }, [_c('el-form', {
    staticClass: "gTopMg",
    attrs: {
      "label-position": "right",
      "label-width": "14.5%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_hbsp') + '(' + (_vm.$t('app_minute')) + ')',
      "prop": "name"
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 1,
      "max": 20
    },
    model: {
      value: (_vm.terminalConfigForm.data.set.hb),
      callback: function($$v) {
        _vm.$set(_vm.terminalConfigForm.data.set, "hb", $$v)
      },
      expression: "terminalConfigForm.data.set.hb"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_checkupsp') + '(' + _vm.$t('app_minute') + ')',
      "prop": "name"
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": _vm.terminalConfigForm.data.set.hb + 5,
      "max": 120
    },
    model: {
      value: (_vm.terminalConfigForm.checkUpdateTime),
      callback: function($$v) {
        _vm.$set(_vm.terminalConfigForm, "checkUpdateTime", $$v)
      },
      expression: "terminalConfigForm.checkUpdateTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_rcmsg')
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.terminalConfigForm.data.get),
      callback: function($$v) {
        _vm.$set(_vm.terminalConfigForm.data, "get", $$v)
      },
      expression: "terminalConfigForm.data.get"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "l"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_geo')))]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "si"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_sysinfo')))]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "ts"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_terstatus')))]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "fi"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_fminfo')))])], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.saveTerminalConfig()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_save')))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 963 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.sForm.ad_status === 3) ? _c('el-alert', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "title": _vm.errorTip,
      "type": "error"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "m_context plr"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "12.5%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sForm.ad_id),
      expression: "sForm.ad_id"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.sForm.ad_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sForm, "ad_id", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.name'),
      "prop": "ad_title"
    }
  }, [_c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.sForm.ad_title))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.classify')
    }
  }, _vm._l((_vm.adTypeList), function(item, index) {
    return (item.adtypeId == _vm.sForm.ad_type) ? _c('span', {
      staticClass: "grey_color"
    }, [_vm._v(_vm._s(item.adtypeName))]) : _vm._e()
  })), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.position')
    }
  }, [(_vm.sForm.ad_position == 0) ? _c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.$t('advert.positionSub.banner')))]) : _vm._e(), _vm._v(" "), (_vm.sForm.ad_position == 1) ? _c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.$t('advert.positionSub.starPage')))]) : _vm._e(), _vm._v(" "), (_vm.sForm.ad_position == 3) ? _c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.$t('app_appadv')))]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.jumpType')
    }
  }, [(_vm.sForm.ad_Urltype == '0') ? _c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.$t('advert.jumpTypeSub.net')))]) : _vm._e(), _vm._v(" "), (_vm.sForm.ad_Urltype == '1') ? _c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.$t('advert.jumpTypeSub.appStore')))]) : _vm._e()]), _vm._v(" "), (_vm.sForm.ad_Urltype === '1') ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.app'),
      "prop": "ad_url"
    }
  }, [_c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.appName))])]) : _vm._e(), _vm._v(" "), (_vm.sForm.ad_Urltype === '0') ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.url'),
      "prop": "ad_url"
    }
  }, [_c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.sForm.ad_url))])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.channel'),
      "prop": "ad_channel"
    }
  }, [_c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.sForm.ad_channel_name))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.ableDate')
    }
  }, [_c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.dateFormat2(_vm.sForm.ad_start_date)))])]), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "span": 2
    }
  }, [_vm._v(" - ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.dateFormat2(_vm.sForm.ad_start_end)))])])], 1), _vm._v(" "), (_vm.sForm.ad_id && _vm.sForm.ad_imgUrl) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.contentImg')
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imageUrl + _vm.sForm.ad_imgUrl,
      "width": "100%"
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.cancel')))]), _vm._v(" "), (_vm.sForm.ad_status == 0 || _vm.sForm.ad_status == 3) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.jumpToUpdate
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.update')))]) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 964 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder"
  }, [_c('el-form', {
    ref: "addForm",
    staticClass: "gForm",
    attrs: {
      "id": "addForm",
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "12.5%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_name'),
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fwVersionInputVisable),
      expression: "fwVersionInputVisable"
    }],
    attrs: {
      "label": _vm.$t('terminal.appBind.label_version'),
      "prop": "version"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.version),
      callback: function($$v) {
        _vm.$set(_vm.form, "version", $$v)
      },
      expression: "form.version"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#8391a5",
      "font-size": "12px",
      "line-height": "2",
      "margin-top": "4px"
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.verTips1')))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_fwType'),
      "prop": "type"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": _vm.typeHolder
    },
    on: {
      "change": _vm.selectTypeChange
    },
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.$set(_vm.form, "type", $$v)
      },
      expression: "form.type"
    }
  }, _vm._l((_vm.$firmwareTypes), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.label,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_distributor'),
      "prop": "mechanism"
    }
  }, [(_vm.mechanismData) ? _c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData,
      "mselect": true,
      "classs": 'w_33'
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_chooseFile'),
      "prop": "url"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo aeMg",
    attrs: {
      "drag": "",
      "accept": "",
      "name": "fileUpload",
      "file-list": _vm.fileList,
      "on-success": _vm.fileUploadSuccess,
      "before-upload": _vm.fileBeforeUpload,
      "action": _vm.fileUploadUrl
    }
  }, [(_vm.fileList.length > 0) ? _c('span', [_c('div', {
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('i', {
    staticClass: "el-icon-check",
    staticStyle: {
      "color": "#13CE66"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.$t('app_ulSuccess')))])]) : _c('span', [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.$t('app_ulNormalSt')))])])])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('app_submit')))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 965 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "examine_vue"
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.resultData,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "cell-click": _vm.cellClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "adTitle",
      "label": _vm.$t('advert.name')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": _vm.$t('advert.classify'),
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((_vm.adTypeList), function(item) {
          return (item.adtypeId === scope.row.adType) ? _c('span', [_vm._v(_vm._s(item.adtypeName))]) : _vm._e()
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "index",
      "label": _vm.$t('advert.position'),
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.adPosition == 0) ? _c('span', [_vm._v("首页banner")]) : _vm._e(), _vm._v(" "), (scope.row.adPosition == 1) ? _c('span', [_vm._v("启动界面")]) : _vm._e(), _vm._v(" "), (scope.row.adPosition == 3) ? _c('span', [_vm._v(_vm._s(_vm.$t('app_appadv')))]) : _vm._e(), _vm._v(" "), (scope.row.adPosition == 2) ? _c('span', [_vm._v("个人中心banner")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "adStartEnd",
      "label": _vm.$t('advert.ableDate'),
      "formatter": _vm.dateFormat,
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "adCreateUsername",
      "label": _vm.$t('advert.addUser'),
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "adCreateTime",
      "label": _vm.$t('advert.addDate'),
      "width": "180"
    }
  }, [_vm._v("\n      :formatter=\"dateFormat\"\n    ")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }), _vm._v(" "), _c('paging', {
    attrs: {
      "rdata": _vm.pagingData,
      "action": _vm.pAction
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('menu.advertManageSub.examine'),
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "right",
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.name')
    }
  }, [_c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.editorForm.adTitle))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.classify')
    }
  }, _vm._l((_vm.adTypeList), function(item) {
    return (item.adtypeId === _vm.editorForm.adType) ? _c('span', {
      staticClass: "grey_color"
    }, [_vm._v(_vm._s(item.adtypeName))]) : _vm._e()
  })), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.position')
    }
  }, [
    [(_vm.editorForm.adPosition == 0) ? _c('span', {
      staticClass: "grey_color"
    }, [_vm._v(_vm._s(_vm.$t('advert.positionSub.banner')))]) : _vm._e(), _vm._v(" "), (_vm.editorForm.adPosition == 1) ? _c('span', {
      staticClass: "grey_color"
    }, [_vm._v(_vm._s(_vm.$t('advert.positionSub.starPage')))]) : _vm._e()]
  ], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.jumpType')
    }
  }, [(_vm.editorForm.adUrltype == '0') ? _c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.$t('advert.jumpTypeSub.net')))]) : _vm._e(), _vm._v(" "), (_vm.editorForm.adUrltype == '1') ? _c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.$t('advert.jumpTypeSub.appStore')))]) : _vm._e()]), _vm._v(" "), (_vm.editorForm.adUrltype === '1') ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.app'),
      "prop": "ad_url"
    }
  }, [_c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.editorForm.application.appName))])]) : _vm._e(), _vm._v(" "), (_vm.editorForm.adUrltype === '0') ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.url')
    }
  }, [_c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.editorForm.adUrl))])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.ableDate')
    }
  }, [_c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.dateFormat2(_vm.editorForm.adStartEnd)))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.contentImg')
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imageUrl + _vm.editorForm.adImgurl,
      "width": "100%",
      "height": "auto"
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.isPass'),
      "prop": "resource"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.isAble),
      callback: function($$v) {
        _vm.isAble = $$v
      },
      expression: "isAble"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('advert.pass')))]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t('advert.notPass')))])], 1)], 1), _vm._v(" "), (_vm.isAble === '0') ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.refusal')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.refuse_reason),
      callback: function($$v) {
        _vm.refuse_reason = $$v
      },
      expression: "refuse_reason"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sbIsAble
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.ok')))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 966 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('el-row', {
    staticClass: "gPageBorder  gPdTB"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_serialnumber')
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.authDetail.terminalNo) + "\n\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_model')
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.authDetail.modelName) + "\n\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.status')
    }
  }, [_c('el-tag', {
    attrs: {
      "type": _vm.authDetail.status == 1 ? 'success' : 'danger'
    }
  }, [_vm._v(_vm._s(_vm.formatStatus(_vm.authDetail.status)))])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_authcode')
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.authDetail.activationCode) + "\n\t\t\t\t")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gTopMg gPageBorder"
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "24px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.getList(1)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t('lin_global.shuaxin')) + "\n\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.arrdata,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "optTime",
      "label": _vm.$t('app_udtime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": _vm.$t('app_authstat'),
      "formatter": _vm.formatListStatus,
      "show-overflow-tooltip": true
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 967 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-form', {
    ref: "firm",
    staticClass: "gForm",
    attrs: {
      "label-position": "right",
      "rules": _vm.rules,
      "label-width": "12.5%",
      "model": _vm.firm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_firm'),
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.firm.name),
      callback: function($$v) {
        _vm.$set(_vm.firm, "name", $$v)
      },
      expression: "firm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_contact'),
      "prop": "contact"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.firm.contact),
      callback: function($$v) {
        _vm.$set(_vm.firm, "contact", $$v)
      },
      expression: "firm.contact"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_contactPhone'),
      "prop": "tel"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.firm.tel),
      callback: function($$v) {
        _vm.$set(_vm.firm, "tel", $$v)
      },
      expression: "firm.tel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_addres'),
      "prop": "addr"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.firm.addr),
      callback: function($$v) {
        _vm.$set(_vm.firm, "addr", $$v)
      },
      expression: "firm.addr"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save('firm')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_save')))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 968 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('el-tabs', {
    staticClass: "gPageBorder",
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    staticClass: "gForm",
    attrs: {
      "label": 'LOGO' + _vm.$t('app_setting'),
      "name": "second"
    }
  }, [_c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm",
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "LOGO",
      "prop": "pass"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    staticStyle: {
      "background": "none"
    },
    attrs: {
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "accept": "image/*",
      "name": "file",
      "on-success": _vm.handleBgAvatarSuccess,
      "before-upload": _vm.beforeBgAvatarUpload
    }
  }, [(_vm.logo) ? _c('div', {
    staticStyle: {
      "background": "#58B7FF"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "96px",
      "margin-top": "16px",
      "padding": "0 16px 0 16px",
      "background": "none"
    },
    attrs: {
      "src": _vm.logo
    }
  })]) : _c('div', {
    staticStyle: {
      "width": "400px",
      "height": "80px",
      "line-height": "80px",
      "font-size": "20px",
      "color": "#99A9BF"
    }
  }, [_vm._v("+")])]), _vm._v(" "), _c('label', {
    staticStyle: {
      "color": "#99A9BF"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_clickPicToUlPic')) + "，200k " + _vm._s(_vm.$t('app_within')) + _vm._s(_vm.$t('app_pgsFormat')) + "，" + _vm._s(_vm.$t('app_sgUseAndAdUse')))])], 1), _vm._v(" "), _c('el-form-item', [(_vm.logoValue) ? _c('span', [_c('el-button', {
    on: {
      "click": _vm.cancelLogo
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveLogo
    }
  }, [_vm._v(_vm._s(_vm.$t('app_sureChange')))])], 1) : _c('span', [_c('el-button', {
    attrs: {
      "disabled": ""
    },
    on: {
      "click": _vm.cancelLogo
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": "",
      "type": "primary"
    },
    on: {
      "click": _vm.saveLogo
    }
  }, [_vm._v(_vm._s(_vm.$t('app_sureChange')))])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.defaultLogo
    }
  }, [_vm._v(_vm._s(_vm.$t('app_dfIcon')))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeName === 'first'),
      expression: "activeName === 'first'"
    }],
    staticClass: "gTopMg gPageBorder"
  }, [_c('p', {
    staticClass: "gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.tuisongjl')))]), _vm._v(" "), _c('el-table', {
    ref: "arrdata",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.arrdata,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "mechName",
      "label": _vm.$t('lin_global.label_areaid')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": _vm.$t('lin_global.tuisonglx')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', [_vm._v(_vm._s(_vm.pushType(scope.row)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "successNum",
      "label": _vm.$t('lin_global.chenggong')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "failNum",
      "label": _vm.$t('lin_global.shibai')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "opeTime",
      "label": _vm.$t('lin_global.tuisongtime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "80",
      "align": "center",
      "label": _vm.$t('lin_global.ope')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_global.chongtui'),
            "placement": "top"
          }
        }, [(scope.row.submit) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.submitRow(scope.row.type, scope.row.config, scope.row.mechId, scope.row.terminalNo)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-rotate-right",
          staticStyle: {
            "color": "#FF4949"
          }
        })]) : _vm._e()], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 50, 100],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 969 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": "myApp"
    }
  }, [_c('el-dialog', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "title": _vm.dialogConfig.tip,
      "visible": _vm.dialogTopMgVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogTopMgVisible = $event
      }
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "20%"
    },
    on: {
      "click": function($event) {
        _vm.processRecommend(0)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_no')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20%",
      "width": "20%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.processRecommend(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_yes')))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "gSgLeftBtn"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v(_vm._s(_vm.$t('app_addsrc')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": _vm.multipleSelection.length == 0
    },
    on: {
      "click": _vm.bcdel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_mulDel')))])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('MechanismSelector', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-select', {
    attrs: {
      "placeholder": ""
    },
    on: {
      "change": _vm.stchange
    },
    model: {
      value: (_vm.statusVl),
      callback: function($$v) {
        _vm.statusVl = $$v
      },
      expression: "statusVl"
    }
  }, _vm._l((_vm.sstatusAr), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "offset": 0,
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_name') + '&' + _vm.$t('app_number'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', [_c('el-table', {
    ref: "multipleTable",
    staticClass: "tbPoint gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "row-click": _vm.cellClick,
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "name",
      "label": _vm.$t('app_srcname'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechanismName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "version",
      "label": _vm.$t('app_newgVer'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "status",
      "width": "115",
      "label": _vm.$t('app_vStatus')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-label', {
          style: (_vm.getStatus(scope.row.status).style)
        }, [_vm._v(_vm._s(_vm.getStatus(scope.row.status).vl))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "createTime",
      "width": "116",
      "label": _vm.$t('app_adddate')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "align": "left",
      "label": _vm.$t('app_operate'),
      "width": "136"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.del(scope.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status != '1' && scope.row.status != '2'),
            expression: "scope.row.status != '1' && scope.row.status != '2' "
          }],
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_edit'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.edit(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status == '0' || scope.row.status == '3'),
            expression: "scope.row.status == '0' || scope.row.status == '3' "
          }],
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_smVerify'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.submit(scope.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-external-link-square"
        })])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.page,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 970 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    staticStyle: {
      "min-width": "950px"
    },
    attrs: {
      "id": ""
    }
  }, [_c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_chooseFile'),
      "size": ""
    },
    on: {
      "open": _vm.open,
      "close": _vm.fclose
    },
    model: {
      value: (_vm.isSelectFile),
      callback: function($$v) {
        _vm.isSelectFile = $$v
      },
      expression: "isSelectFile"
    }
  }, [_c('div', {
    staticClass: "gBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-row', {}, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "gSgLeftBtn",
    staticStyle: {
      "padding-left": "8px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_name'),
      "icon": "search",
      "on-icon-click": _vm.tquery
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.tquery($event)
      }
    },
    model: {
      value: (_vm.tqueryKey),
      callback: function($$v) {
        _vm.tqueryKey = $$v
      },
      expression: "tqueryKey"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "dpTable",
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange1
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "fileName",
      "align": "center",
      "label": _vm.$t('app_filename'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "fileVersion",
      "label": _vm.$t('app_version'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "formatter": _vm.setType,
      "label": _vm.$t('app_filetype'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.setSType,
      "align": "center",
      "label": _vm.$t('app_subtype'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "106"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (true),
            expression: "true"
          }],
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_choose'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.selected(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-check"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.page,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_chooseFile'),
      "size": ""
    },
    on: {
      "open": _vm.open,
      "close": _vm.fclose
    },
    model: {
      value: (_vm.isSelectFile1),
      callback: function($$v) {
        _vm.isSelectFile1 = $$v
      },
      expression: "isSelectFile1"
    }
  }, [_c('div', {
    staticClass: "gBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-row', {}, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "gSgLeftBtn",
    staticStyle: {
      "padding-left": "8px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_name'),
      "icon": "search",
      "on-icon-click": _vm.tquery1
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.tquery1($event)
      }
    },
    model: {
      value: (_vm.tqueryKey),
      callback: function($$v) {
        _vm.tqueryKey = $$v
      },
      expression: "tqueryKey"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "dpTable",
      "data": _vm.lcdata,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange1
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "launchername",
      "align": "center",
      "label": _vm.$t('app_filename'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "version",
      "label": _vm.$t('app_version'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "distrabutorname",
      "label": _vm.$t('app_distributor'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "106"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (true),
            expression: "true"
          }],
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_choose'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.selected1(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-check"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.page,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticClass: "gForm",
    attrs: {
      "label-position": "right",
      "rules": _vm.rules,
      "label-width": "12.5%",
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_taskName'),
      "prop": "tname"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_input')
    },
    model: {
      value: (_vm.form.tname),
      callback: function($$v) {
        _vm.$set(_vm.form, "tname", $$v)
      },
      expression: "form.tname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_type'),
      "prop": "dtype"
    }
  }, [_c('el-radio-group', {
    on: {
      "input": _vm.change_device
    },
    model: {
      value: (_vm.form.dtype),
      callback: function($$v) {
        _vm.$set(_vm.form, "dtype", $$v)
      },
      expression: "form.dtype"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.device_type_1')))]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.device_type_2')))])], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "ptEditFr"
    }
  }, _vm._l((_vm.ulData), function(item, index) {
    return _c('div', {
      staticClass: "pteditdiv"
    }, [_c('div', {
      staticClass: "ptedlinecm"
    }, [_c('img', {
      staticStyle: {
        "cursor": "pointer",
        "position": "absolute",
        "width": "16px",
        "height": "16px",
        "left": "0"
      },
      attrs: {
        "src": _vm.delicon
      },
      on: {
        "click": function($event) {
          _vm.delrow(index)
        }
      }
    }), _vm._v(" "), _vm._v("\n\n\n\t\t\t\t\t\t" + _vm._s(_vm.$t('app_subtask')) + _vm._s(index + 1) + "\n\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "ptedlinecm"
    }, [_c('label', [_vm._v(_vm._s(_vm.$t('app_sltstype')))]), _vm._v("  \n\t\t\t\t\t\t"), _c('el-select', {
      attrs: {
        "placeholder": _vm.$t('app_type')
      },
      on: {
        "change": function($event) {
          _vm.taskChange(index, item)
        }
      },
      model: {
        value: (item.taskType),
        callback: function($$v) {
          _vm.$set(item, "taskType", $$v)
        },
        expression: "item.taskType"
      }
    }, _vm._l((_vm.tasktypes), function(item) {
      return _c('el-option', {
        key: item.type,
        attrs: {
          "label": item.name,
          "value": item.type
        }
      })
    }))], 1), _vm._v(" "), _c('div', {
      staticClass: "ptedlinecm"
    }, [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.taskType != '9' && item.content),
        expression: "item.taskType != '9' && item.content"
      }],
      staticClass: "el-icon-circle-check",
      staticStyle: {
        "line-height": "55px"
      }
    }), _vm._v(" "), _c('label', [_vm._v(_vm._s(item.taskType == '9' ? _vm.$t('app_command') : _vm.$t('app_chooseFile')))]), _vm._v("  \n\n\t\t\t\t\t\t"), _vm._v(" "), _c('el-select', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.taskType == '9'),
        expression: "item.taskType == '9'"
      }],
      staticStyle: {
        "width": "48%"
      },
      attrs: {
        "placeholder": _vm.$t('app_type')
      },
      on: {
        "change": function($event) {
          _vm.commChange(index, item)
        }
      },
      model: {
        value: (item.content),
        callback: function($$v) {
          _vm.$set(item, "content", $$v)
        },
        expression: "item.content"
      }
    }, _vm._l((_vm.comms), function(item) {
      return _c('el-option', {
        key: item.vl,
        attrs: {
          "label": item.lb,
          "value": item.vl
        }
      })
    })), _vm._v("  \n\n\t\t\t\t\t\t"), _c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": item.file,
        "placement": "top"
      }
    }, [_c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.taskType != '9'),
        expression: "item.taskType != '9'"
      }],
      staticStyle: {
        "max-width": "55%",
        "text-overflow": "ellipsis",
        "overflow": "hidden"
      },
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.slFile(index, item.taskType)
        }
      }
    }, [_vm._v(_vm._s(item.file))])], 1), _vm._v(" "), _c('el-tooltip', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((item.content == 'XZYY' && !item.p2) || (item.content == 'ZQ' && !item.p1)),
        expression: "(item.content == 'XZYY' && !item.p2) || (item.content == 'ZQ' && !item.p1)"
      }],
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": item.file,
        "placement": "top"
      }
    }, [_c('el-button', {
      staticStyle: {
        "right": "0",
        "max-width": "43%",
        "text-overflow": "ellipsis",
        "overflow": "hidden",
        "position": "absolute",
        "line-height": "55px"
      },
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.slFile(index, item.taskType)
        }
      }
    }, [_vm._v(_vm._s(item.file))])], 1), _vm._v(" "), _c('el-input', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((item.content == 'XZYY' && item.p2) || (item.content == 'ZQ' && item.p1)),
        expression: "(item.content=='XZYY'&&item.p2)||(item.content=='ZQ'&&item.p1)"
      }],
      staticStyle: {
        "width": "36%",
        "display": "inline-block"
      },
      attrs: {
        "placeholder": _vm.$t('app_ippkgname')
      },
      model: {
        value: (item.fileId),
        callback: function($$v) {
          _vm.$set(item, "fileId", $$v)
        },
        expression: "item.fileId"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ptedlinecm"
    }, [_c('i', {
      staticClass: "el-icon-caret-top",
      on: {
        "click": function($event) {
          _vm.sortEv(true, index, item)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "el-icon-caret-bottom",
      on: {
        "click": function($event) {
          _vm.sortEv(false, index, item)
        }
      }
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isPop(item.taskType, item.content)),
        expression: "isPop(item.taskType, item.content)"
      }],
      staticClass: "ptedlinecm"
    }, [_c('el-popover', {
      attrs: {
        "placement": "bottom",
        "width": "200",
        "trigger": "click"
      },
      model: {
        value: (item.ispop),
        callback: function($$v) {
          _vm.$set(item, "ispop", $$v)
        },
        expression: "item.ispop"
      }
    }, [_c('el-button', {
      attrs: {
        "slot": "reference",
        "type": "text"
      },
      slot: "reference"
    }, [_c('i', {
      staticClass: "el-icon-setting",
      staticStyle: {
        "margin-left": "5px"
      }
    })]), _vm._v(" "), _vm._l((_vm.getPopMenu(item.taskType, item.content)), function(title, pindex) {
      return _c('div', {
        style: (_vm.getPopCss(pindex, item.taskType, item.content))
      }, [_c('el-checkbox', {
        on: {
          "change": function($event) {
            _vm.paramChange(pindex + 1, index)
          }
        },
        model: {
          value: (item['p' + (pindex + 1)]),
          callback: function($$v) {
            _vm.$set(item, 'p' + (pindex + 1), $$v)
          },
          expression: "item['p'+(pindex+1)]"
        }
      }, [_vm._v(_vm._s(title))])], 1)
    })], 2)], 1)])
  })), _vm._v(" "), _c('div', {
    attrs: {
      "id": "ptAddTask"
    },
    on: {
      "click": _vm.addTask
    }
  }, [_vm._v("\n\t\t\t\t+" + _vm._s(_vm.$t('app_addsubts')) + "\n\t\t\t")]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save('form')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_save')))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 971 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "background": "white"
    }
  }, [_c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  }), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_adddv'),
      "size": ""
    },
    on: {
      "close": _vm.closeDia
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6,
      "gutter": 10
    }
  }, [_c('div', {}, [_c('el-button', {
    attrs: {
      "disabled": _vm.multipleSelection.length == 0,
      "type": "primary"
    },
    on: {
      "click": _vm.bcbind
    }
  }, [_vm._v(_vm._s(_vm.$t('app_mulAdd')))])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "offset": 0,
      "span": 6,
      "gutter": 20
    }
  }, [_c('div', {
    staticStyle: {
      "padding-right": "8px"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.srchDevice
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.stModel), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "offset": 0,
      "span": 6,
      "gutter": 10
    }
  }, [_c('div', {}, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData1
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticStyle: {
      "padding-left": "8px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_searchTerminal'),
      "icon": "search",
      "on-icon-click": _vm.srchDevice
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srchDevice($event)
      }
    },
    model: {
      value: (_vm.srchValue),
      callback: function($$v) {
        _vm.srchValue = $$v
      },
      expression: "srchValue"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_terNo'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminal_status",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 3) ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_sleep')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_add'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-plus"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editCf
    }
  }, [_vm._v(_vm._s(_vm.$t('app_editconfig')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "gPageBorder gTopMg"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "calc(100% - 48px)",
      "height": "100%",
      "margin-bottom": "0px",
      "background": "none",
      "padding": "0 0px 12px 24px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.configName : ''))])]), _vm._v(" "), _vm._l((_vm.dtGroup), function(item) {
    return _c('div', {
      staticStyle: {
        "height": "30px"
      }
    }, [_c('table', {
      staticClass: "lcpush"
    }, [_c('tr', [_vm._l((item), function(sitem) {
      return _c('td', [_c('label', {
        staticClass: "dt-word-title"
      }, [_vm._v(_vm._s(sitem.tt) + "：")]), _vm._v(" "), _c('label', {
        staticClass: "dt-word-main"
      }, [_vm._v(_vm._s(sitem.vl))])])
    }), _vm._v(" "), _c('td')], 2)])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-height": "10px",
      "display": "-webkit-flex"
    }
  }, [_c('div', {
    staticClass: "dt-word-title",
    staticStyle: {
      "display": "inline-block",
      "min-width": "70px"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('app_filestss')) + "：")])]), _vm._v(" "), _c('div', {
    staticClass: "dt-word-main",
    staticStyle: {
      "display": "inline-block",
      "position": "relative",
      "background": "none"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.config ? _vm.config.configDesc : ''))])])])], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gCtColor gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_dvconfiglist')) + " ")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "gSgLeftBtn"
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addTer
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.list.add_btn')))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "type": ""
    },
    on: {
      "click": function($event) {
        _vm.getList()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.shuaxin')))])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_type')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.bindVl),
      callback: function($$v) {
        _vm.bindVl = $$v
      },
      expression: "bindVl"
    }
  }, _vm._l((_vm.bindSts), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_name') + ' & ' + _vm.$t('app_number'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.hiss,
      "border": ""
    },
    on: {
      "sort-change": _vm.sortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "terminalName",
      "sortable": "custom",
      "label": _vm.$t('app_deviceName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "terminalNo",
      "sortable": "custom",
      "width": "",
      "label": _vm.$t('app_deviceNo')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "mechName",
      "width": "",
      "label": _vm.$t('app_distributor')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "version",
      "fformatter": "showBindSt",
      "width": "",
      "label": _vm.$t('app_appconfigst')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          style: (_vm.stcolor(scope.row.useStatus))
        }, [_vm._v(_vm._s(_vm.bindSt[scope.row.useStatus]))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "fformatter": "dateFormat",
      "prop": "opeTime",
      "sortable": "custom",
      "width": "170",
      "label": _vm.$t('app_applytime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "",
      "width": "86",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status != 1),
            expression: "scope.row.status != 1"
          }],
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.unbind(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.useStatus == 2),
            expression: "scope.row.useStatus == 2"
          }],
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_global.chongtui'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.repush(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-refresh"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv",
    staticStyle: {}
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.page,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pageTotal
    },
    on: {
      "current-change": _vm.pageChange,
      "size-change": _vm.pageSize
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 972 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m_context",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "rowFr",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "rowa",
    staticStyle: {
      "margin-left": "24px",
      "width": "100%"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "",
      "id": "addTerm",
      "icon": "plus"
    },
    on: {
      "click": _vm.open_push
    }
  }, [_vm._v(_vm._s(_vm.$t('app_add')) + "\n                ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addTer
    }
  }, [_vm._v(_vm._s(_vm.$t('app_fileImport')))])], 1)]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-left": "4px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('div', [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('ter.terminalNo')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.get_device_lists($event)
      }
    },
    model: {
      value: (_vm.select_forms.terminalNo),
      callback: function($$v) {
        _vm.$set(_vm.select_forms, "terminalNo", $$v)
      },
      expression: "select_forms.terminalNo"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.arrdata,
      "id": "tp",
      "border": "",
      "element-loading-text": _vm.$t('lin_global.loading')
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "terminalNo",
      "label": _vm.$t('ter.terminalNo')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mechName",
      "label": _vm.$t('ter.mechName')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('ter.status'),
      "prop": "status",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('ter.state1')))]) : (scope.row.status == 2) ? _c('span', [_vm._v(_vm._s(_vm.$t('ter.state2')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('ter.state3')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": _vm.$t('ter.createTime'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": _vm.$t('lin_global.ope'),
      "width": "106"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteApps(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "page_content"
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.select_forms.page,
      "page-sizes": [10, 50, 100],
      "page-size": _vm.select_forms.rows,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_adddv'),
      "size": ""
    },
    on: {
      "close": _vm.handleClose
    },
    model: {
      value: (_vm.show_push),
      callback: function($$v) {
        _vm.show_push = $$v
      },
      expression: "show_push"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.device_loading),
      expression: "device_loading"
    }],
    staticClass: "gBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-row', {}, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary",
      "disabled": _vm.select_device.length == 0
    },
    on: {
      "click": _vm.bcPush
    }
  }, [_vm._v(_vm._s(_vm.$t('app_pushsldev')))])], 1)], 1), _vm._v(" "), _c('el-row', {}, [_c('el-col', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    },
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "gSideCtrl",
    staticStyle: {
      "margin-right": "8px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_start_no'),
      "icon": "search",
      "on-icon-click": _vm.get_device_list
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.get_device_list($event)
      }
    },
    model: {
      value: (_vm.select_form.snBegin),
      callback: function($$v) {
        _vm.$set(_vm.select_form, "snBegin", $$v)
      },
      expression: "select_form.snBegin"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gSideCtrl",
    staticStyle: {
      "margin-left": "0",
      "margin-right": "0"
    }
  }, [_vm._v("\n                        ~\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_end_no'),
      "icon": "search",
      "on-icon-click": _vm.get_device_list
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.get_device_list($event)
      }
    },
    model: {
      value: (_vm.select_form.snEnd),
      callback: function($$v) {
        _vm.$set(_vm.select_form, "snEnd", $$v)
      },
      expression: "select_form.snEnd"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "offset": 0,
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.getCmDv
    },
    model: {
      value: (_vm.select_form.terminal_status),
      callback: function($$v) {
        _vm.$set(_vm.select_form, "terminal_status", $$v)
      },
      expression: "select_form.terminal_status"
    }
  }, _vm._l((_vm.sstatusAr), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "offset": 0,
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('MechanismSelector', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_terNo'),
      "icon": "search",
      "on-icon-click": _vm.get_device_list
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.get_device_list($event)
      }
    },
    model: {
      value: (_vm.select_form.terminal_no),
      callback: function($$v) {
        _vm.$set(_vm.select_form, "terminal_no", $$v)
      },
      expression: "select_form.terminal_no"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "dpTable",
      "data": _vm.deviceList,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChangeDevice
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalNo",
      "align": "center",
      "label": _vm.$t('app_terNo'),
      "width": "210"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "210"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalStatus",
      "formatter": _vm.mkDvSt,
      "label": _vm.$t('app_status'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": "210"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "106"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.send'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.pushed(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.select_form.page,
      "page-sizes": [20, 100],
      "page-size": _vm.select_form.rows,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.deviceTotal
    },
    on: {
      "current-change": _vm.pageSelectDevice,
      "size-change": _vm.pageSizedDevice
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_fipush')
    },
    on: {
      "close": _vm.closeImport
    },
    model: {
      value: (_vm.pushImport),
      callback: function($$v) {
        _vm.pushImport = $$v
      },
      expression: "pushImport"
    }
  }, [_c('el-form', {
    attrs: {
      "model": "",
      "rules": ""
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_ulfile'),
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "name": "fileUpload",
      "action": _vm.ulurl(),
      "on-remove": _vm.beforeRemove,
      "before-upload": _vm.srcBefore,
      "on-success": _vm.srcSuccess,
      "on-error": _vm.ulError,
      "file-list": _vm.fileList
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v(_vm._s(_vm.$t('app_clickUpdate')))]), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-left": "8px",
      "margin-right": "10px"
    },
    attrs: {
      "href": _vm.downTpl
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "size": "small"
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.list.import_muban')))])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_deviceNum'),
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n                " + _vm._s(_vm.uldata ? _vm.uldata.terNums : 0 + _vm.$t('app_amechine')) + "\n            ")])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.pushImport = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitUpload
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('app_srpush')) + "\n            ")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 973 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "newfirm"
    }
  }, [_c('el-form', {
    ref: "form",
    staticStyle: {
      "width": "60%",
      "margin-top": "20px"
    },
    attrs: {
      "label-position": "right",
      "rules": _vm.rules,
      "label-width": "100px",
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_type'),
      "prop": "tel"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": _vm.$t('app_select')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, _vm._l((_vm.types), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.label,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), (_vm.type === 1) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_deviceNo'),
      "prop": "dvNo"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.dvNo),
      callback: function($$v) {
        _vm.$set(_vm.form, "dvNo", $$v)
      },
      expression: "form.dvNo"
    }
  })], 1) : _c('span', [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_distributor'),
      "prop": "distributor"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_select')
    },
    on: {
      "change": _vm.selectMc
    },
    model: {
      value: (_vm.form.distributor),
      callback: function($$v) {
        _vm.$set(_vm.form, "distributor", $$v)
      },
      expression: "form.distributor"
    }
  }, _vm._l((_vm.mechs), function(item) {
    return _c('el-option', {
      key: item.mechanismid,
      attrs: {
        "label": item.mechanismname,
        "value": item.mechanismid
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_deviceNum'),
      "prop": "tel"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.devices))])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_ofCheck'),
      "prop": ""
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_open')))]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_close')))])], 1)], 1), _vm._v(" "), _c('div', [_c('el-button', {
    staticStyle: {
      "width": "15%",
      "margin-left": "25%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_save')))])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "#D3DCE6",
      "width": "100%",
      "height": "1px",
      "margin-top": "50px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-top": "0px solid #8492A6",
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "left",
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_operateHis')) + " ")]), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "operationTime",
      "label": _vm.$t('app_time'),
      "width": "175"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "merchantName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "opearationType",
      "label": _vm.$t('app_operateType'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.opearationType === '0'),
            expression: "scope.row.opearationType === '0'"
          }]
        }, [_vm._v(_vm._s(_vm.$t('app_closeCerCheck')))]), _vm._v(" "), _c('label', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.opearationType === '1'),
            expression: "scope.row.opearationType === '1'"
          }]
        }, [_vm._v(_vm._s(_vm.$t('app_openCerCheck')))]), _vm._v(" "), _c('label', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.opearationType === '2'),
            expression: "scope.row.opearationType === '2'"
          }]
        }, [_vm._v(_vm._s(_vm.$t('app_cnAndActive')))]), _vm._v(" "), _c('label', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.opearationType === '3'),
            expression: "scope.row.opearationType === '3'"
          }]
        }, [_vm._v(_vm._s(_vm.$t('app_downCer')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "successQuantity",
      "label": _vm.$t('app_success'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "failQuantity",
      "label": _vm.$t('app_fail'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "cancelNums",
      "label": _vm.$t('app_operate'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_reOpen'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.opearationType === '1' && scope.row.operateAgain === '1'),
            expression: "scope.row.opearationType === '1' && scope.row.operateAgain === '1'"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.hisOperate(1, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-up"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_reClose'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.opearationType === '0' && scope.row.operateAgain === '1'),
            expression: "scope.row.opearationType === '0' && scope.row.operateAgain === '1'"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.hisOperate(0, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-window-close"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "block",
    staticStyle: {
      "float": "right",
      "margin-top": "20px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 974 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.certinfo.certType === 1),
      expression: "certinfo.certType === 1"
    }],
    staticClass: "astyle",
    attrs: {
      "href": _vm.ahref
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.dachuzhengshu')))]), _vm._v(" "), _c('el-button', {
    staticClass: "gSgLeftCtrl",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.uploadCer
    }
  }, [_vm._v(_vm._s(_vm.$t('app_upload')) + _vm._s(_vm.$t('lin_global.zhengshu')))]), _vm._v(" "), _c('el-row', {
    staticClass: "gPageBorder gTopMg gPdTB"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.certificateName')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.certinfo.certificateName) + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.createTime')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.certinfo.createTime) + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.zdqds')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.certinfo.distributorName) + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.remark')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.certinfo.certificateDesc) + "\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 975 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ae"
    }
  }, [_c('div', {
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "width": "140px",
      "height": "140px",
      "margin": "24px 24px 24px 24px",
      "display": "inline-block",
      "float": "left",
      "overflow": "hidden"
    }
  }), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "calc(100% - 188px)",
      "height": "100%",
      "margin-bottom": "0px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.data.appName : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "60px"
    }
  }, [_c('table', {
    staticClass: "dt-app"
  }, [_c('tr', [_c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_version')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.data.appVersion : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_verTag')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.data.versioncode : ''))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_appType')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config.data.appCategoryName))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_package')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.data.packagename : ''))])]), _vm._v(" "), _c('td')])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-height": "60px",
      "display": "-webkit-flex"
    }
  }, [_c('div', {
    staticClass: "dt-word-title",
    staticStyle: {
      "display": "inline-block",
      "min-width": "70px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('app_introl')) + "：\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "dt-word-main",
    staticStyle: {
      "display": "inline-block",
      "position": "relative",
      "background": "none",
      "margin": "0 24px 24px 0"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.config.data.appDesc))])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.captures ? _vm.captures.length > 0 : false),
      expression: "captures? captures.length > 0 : false"
    }],
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gCtColor  gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_screenShot')) + " ")]), _vm._v(" "), _c('div', _vm._l((_vm.captures), function(item) {
    return _c('img', {
      staticClass: "gBorder",
      staticStyle: {
        "width": "180px",
        "height": "320px",
        "margin": "24px 0 24px 24px",
        "border-radius": "4px"
      },
      attrs: {
        "onerror": "this.src='/static/img/df-h.png'",
        "src": _vm.imgFullUrl(item)
      }
    })
  }))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.type === 2 && _vm.config.isHistory),
      expression: "config.type === 2 && config.isHistory"
    }],
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gCtColor gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_hisVer')) + " ")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUploadNew),
      expression: "showUploadNew"
    }],
    staticStyle: {
      "margin": "24px 0 24px 24px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.uploadNew
    }
  }, [_vm._v(_vm._s(_vm.$t('app_ulNew')))]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appName",
      "label": _vm.$t('app_appName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appVersion",
      "width": "",
      "label": _vm.$t('app_version')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appCategoryName",
      "width": "",
      "label": _vm.$t('app_type')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "formatter": _vm.dateFormat,
      "prop": "createTime",
      "width": "170",
      "label": _vm.$t('app_createTime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "",
      "width": "90",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.config.data.isoperation === 0),
            expression: "config.data.isoperation === 0"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteAppHis(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 976 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": "myApp"
    }
  }, [_c('el-dialog', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "title": _vm.dialogConfig.tip,
      "visible": _vm.dialogTopMgVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogTopMgVisible = $event
      }
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "20%"
    },
    on: {
      "click": function($event) {
        _vm.processRecommend(0)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_no')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20%",
      "width": "20%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.processRecommend(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_yes')))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.addVideo
    }
  }, [_vm._v(_vm._s(_vm.$t('app_advdoad')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.allUndercarriage
    }
  }, [_vm._v(_vm._s(_vm.$t('app_mulDel')))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.usrType === '0'),
      expression: "usrType === '0'"
    }],
    staticStyle: {
      "margin-left": "24px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goDefault
    }
  }, [_vm._v(_vm._s(_vm.$t('app_mgdfvdo')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_adname'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', [_c('el-table', {
    ref: "multipleTable",
    staticClass: "tbPoint gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "row-click": _vm.cellClick,
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "videoname",
      "label": _vm.$t('app_ad') + _vm.$t('app_name'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "duration",
      "label": _vm.$t('app_addur'),
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "createTime",
      "formatter": _vm.dateFormat,
      "label": _vm.$t('app_tofvalis'),
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', [_vm._v(_vm._s(_vm.timeLimit(scope.row)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "appVersion",
      "align": "center",
      "label": _vm.$t('app_adstatus'),
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          style: (_vm.getStatus(scope.row) ? _vm.getStatus(scope.row).style : '')
        }, [_vm._v(_vm._s(_vm.getStatus(scope.row) ? _vm.getStatus(scope.row).vl : ''))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "align": "right",
      "header-align": "center",
      "label": _vm.$t('app_operate'),
      "width": "106"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_edit'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: ((scope.row.status == 0 || scope.row.status == 3 || scope.row.status == 4 || scope.row.status == 5)),
            expression: "(scope.row.status == 0 || scope.row.status == 3 || scope.row.status == 4 || scope.row.status == 5)"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.editVideo(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_smVerify'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status !== 1 && scope.row.status !== 2),
            expression: "scope.row.status !== 1 && scope.row.status !== 2"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.submitVideo(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-external-link-square"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (true),
            expression: "true"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteVideo(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 977 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-form', {
    ref: "firm",
    staticClass: "gForm",
    attrs: {
      "label-position": "right",
      "rules": _vm.rules,
      "label-width": "12.5%",
      "model": _vm.firm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_firmware'),
      "prop": "item"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_select')
    },
    on: {
      "change": _vm.fwChange
    },
    model: {
      value: (_vm.form.item),
      callback: function($$v) {
        _vm.$set(_vm.form, "item", $$v)
      },
      expression: "form.item"
    }
  }, _vm._l((_vm.tableData), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.firmwareName,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_version'),
      "prop": "version"
    }
  }, [_c('el-label', [_vm._v(_vm._s(_vm.form.item.version))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_type'),
      "prop": "type"
    }
  }, [_c('el-label', [_vm._v(_vm._s(_vm.form.item.type))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_pushType'),
      "prop": "pushType"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('app_select')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.form.pushType),
      callback: function($$v) {
        _vm.$set(_vm.form, "pushType", $$v)
      },
      expression: "form.pushType"
    }
  }, _vm._l((_vm.pushType), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.label,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.pushType === 0),
      expression: "form.pushType === 0"
    }],
    attrs: {
      "label": _vm.$t('app_distributor'),
      "prop": "mechanism"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData,
      "mselect": true,
      "classs": 'w_33'
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.pushType === 1),
      expression: "form.pushType === 1"
    }],
    attrs: {
      "label": _vm.$t('app_deviceNo'),
      "prop": ""
    }
  }, [_c('AutoTerno', {
    on: {
      "on-result-change": _vm.onDvInputChange
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.pushType === 2),
      expression: "form.pushType === 2"
    }],
    attrs: {
      "label": _vm.$t('app_mdFile')
    }
  }, [_c('a', {
    staticClass: "aSc",
    attrs: {
      "href": _vm.downUrl,
      "title": _vm.$t('app_downExp'),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_downTplFile')))]), _vm._v(" "), _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "name": "fileUpload",
      "action": _vm.$fileExcelUlUrl,
      "before-upload": _vm.srcBefore,
      "on-success": _vm.srcSuccess,
      "file-list": _vm.srcList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_clickUpdate')))])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.pushType === 2),
      expression: "form.pushType === 2"
    }],
    attrs: {
      "label": _vm.$t('app_deviceNum')
    }
  }, [_c('el-label', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.devices) + _vm._s(_vm.$t('app_amechine')))])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('app_submit')))])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.hLoading),
      expression: "hLoading"
    }],
    staticClass: "gTopMg gPageBorder"
  }, [_c('p', {
    staticClass: "gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_operateHis')))]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.arrdatas,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "opeTime",
      "label": _vm.$t('lin_global.time')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mechanismName",
      "label": _vm.$t('lin_global.label_areaid')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pushType",
      "label": _vm.$t('lin_global.tuisongleixing'),
      "formatter": _vm.formatStatus
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', [_vm._v(_vm._s(_vm.missionNames[scope.row.pushType]))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "successNums",
      "label": _vm.$t('lin_global.chenggong')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "failNums",
      "label": _vm.$t('lin_global.shibai')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "80",
      "align": "center",
      "label": _vm.$t('lin_global.ope')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_global.chongxintuisong'),
            "placement": "top"
          }
        }, [(scope.row.failNums > 0) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.resXiafa(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })]) : _vm._e()], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 50, 100],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 978 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ae"
    }
  }, [_c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_addPush'),
      "size": "middle"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    staticClass: "gDiaTable",
    staticStyle: {
      "width": "100%",
      "background": "none",
      "text-align": "left"
    }
  }, [_c('span'), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticStyle: {
      "margin-right": "16px"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.stModel), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.label,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "40%",
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": _vm.$t('app_searchTerminal'),
      "icon": "search"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srchDevice($event)
      }
    },
    model: {
      value: (_vm.srchValue),
      callback: function($$v) {
        _vm.srchValue = $$v
      },
      expression: "srchValue"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dLoading),
      expression: "dLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_terNo'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminal_status",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_push'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_banReason')
    },
    model: {
      value: (_vm.notPassDialog),
      callback: function($$v) {
        _vm.notPassDialog = $$v
      },
      expression: "notPassDialog"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_reason'),
      "label-width": "14%"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.notPassDialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.verifyRqs('3')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_submit')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "background": "none",
      "padding": "0 0px 0 24px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.videoname : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('table', {
    staticClass: "dt-launch"
  }, [_c('tr', {}, [_c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_addur')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.duration : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_fileSize')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.size : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_vsize')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.dimension : ''))])]), _vm._v(" "), _c('td')])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('table', {
    staticClass: "dt-launch"
  }, [_c('tr', {}, [_c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_addps')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.username : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_addtime')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.makeCreateTime(_vm.config.createtime) : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_tofvaliss')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.timeLimit(_vm.config) : ''))])]), _vm._v(" "), _c('td')])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticStyle: {
      "background": "none",
      "padding": "0 0px 24px 0px"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.$router.go(-1);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.verify('2')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_psverify')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.verify('3')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_ban')))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gCtColor  gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_vpreview')) + " ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "480px",
      "background": "black",
      "text-align": "center",
      "overflow": "hiiden"
    }
  }, [_c('video', {
    attrs: {
      "height": "480px",
      "src": _vm.playUrl,
      "controls": "controls"
    }
  }, [_vm._v("\n        your browser is not support video tag\n      ")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 979 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-autocomplete', {
    attrs: {
      "icon": "",
      "select-when-unmatched": _vm.cChange,
      "oon-icon-click": "cChange",
      "fetch-suggestions": _vm.querySearchAsync,
      "props": {
        label: 'mechanismname',
        value: 'mechanismname'
      },
      "placeholder": _vm.$t('app_srcmechan')
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.acVal),
      callback: function($$v) {
        _vm.acVal = $$v
      },
      expression: "acVal"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 980 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-form', {
    ref: "channel",
    staticClass: "gForm",
    attrs: {
      "label-position": "right",
      "rules": _vm.rules,
      "label-width": "12.5%",
      "model": _vm.channel
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_name'),
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.channel.name),
      callback: function($$v) {
        _vm.$set(_vm.channel, "name", $$v)
      },
      expression: "channel.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_dParent'),
      "prop": "father"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData,
      "mselect": true
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_contact'),
      "prop": "contact"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.channel.contact),
      callback: function($$v) {
        _vm.$set(_vm.channel, "contact", $$v)
      },
      expression: "channel.contact"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_contactPhone'),
      "prop": "tel"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.channel.tel),
      callback: function($$v) {
        _vm.$set(_vm.channel, "tel", $$v)
      },
      expression: "channel.tel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_addres'),
      "prop": "addr"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.channel.addr),
      callback: function($$v) {
        _vm.$set(_vm.channel, "addr", $$v)
      },
      expression: "channel.addr"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.right === '0'),
      expression: "right === '0'"
    }],
    attrs: {
      "label": _vm.$t('app_cerMgType'),
      "prop": ""
    }
  }, [(this.config.type === 1) ? _c('span', [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cerMgSelf')))]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cerMgOther')))]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cerMgCustomer')))])], 1) : _c('span', [(_vm.channel.father && _vm.channel.father.pid !== '0') ? _c('span', [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cerMgSelf')))]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cerMgOther')))]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cerMgCustomer')))])], 1) : _c('span', [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cerMgSelf')))]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cerMgOther')))]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cerMgCustomer')))])], 1)])]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        _vm.save('channel')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_save')))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 981 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.$t('app_tip'),
      "visible": _vm.cerDialogVisible,
      "size": "tiny",
      "before-close": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.cerDialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.cerTipMsg))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.cerDialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.pushUploadCer
    }
  }, [_vm._v(_vm._s(_vm.$t('app_uploadCer')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('app_tip'),
      "visible": _vm.cerTipDialogVisible,
      "size": "tiny",
      "before-close": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.cerTipDialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.cerTipMsg))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.cerTipDialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_sure')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_addPush'),
      "size": "middle"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dvLoading),
      expression: "dvLoading"
    }]
  }, [_c('div', {
    staticClass: "gDiaTable",
    staticStyle: {
      "width": "100%",
      "background": "none",
      "text-align": "left"
    }
  }, [_c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_distributor')
    },
    on: {
      "change": _vm.selectDvChange
    },
    model: {
      value: (_vm.channelId),
      callback: function($$v) {
        _vm.channelId = $$v
      },
      expression: "channelId"
    }
  }, _vm._l((_vm.channels), function(item) {
    return _c('el-option', {
      key: item.mechanismid,
      attrs: {
        "label": item.mechanismname,
        "value": item.mechanismid
      }
    })
  }))], 1), _vm._v(" "), _c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.selectDvChange
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.stModel), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.label,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "40%",
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": _vm.$t('app_searchTerminal'),
      "icon": "search"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srchDevice($event)
      }
    },
    model: {
      value: (_vm.srchValue),
      callback: function($$v) {
        _vm.srchValue = $$v
      },
      expression: "srchValue"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dvTableData,
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminal_status",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_push'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.dvIndex,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.dvTotal
    },
    on: {
      "current-change": _vm.pageDvSelect,
      "size-change": _vm.pageDvSized
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.jumpToUpload
    }
  }, [_vm._v(_vm._s(_vm.$t('app_addlc')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_lcname'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)])], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    staticClass: "tbPoint",
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "name",
      "label": _vm.$t('app_srcname'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "mechanismName",
      "width": "",
      "label": _vm.$t('app_distributor')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "version",
      "width": "",
      "label": _vm.$t('app_newgVer')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "createTime",
      "width": "175",
      "fformatter": "dateFormat",
      "label": _vm.$t('app_adddate')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "operate",
      "width": "80",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_verify'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_c('i', {
          staticClass: "fa fa-check-square-o"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 982 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.resetPass')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.edit(_vm.userinfo.userid, _vm.userinfo.nickName)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_editProfile')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.mfaClick
    }
  }, [_vm._v(_vm._s(_vm.userinfo.bindMfa == 1 ? 'MFA ' + _vm.$t('lin_btn.unbind') : 'MFA'))]), _vm._v(" "), _c('div', {
    staticClass: "source"
  }, [_c('el-row', {
    staticClass: "gPageBorder gTopMg gPdTB"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.user')
    }
  }, [_vm._v("\n\t\t            " + _vm._s(_vm.userinfo.userName) + "\n\t\t          ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.nickName')
    }
  }, [_vm._v("\n\t\t            " + _vm._s(_vm.userinfo.nickName) + "\n\t\t          ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.phoneNum2')
    }
  }, [_vm._v("\n\t\t            " + _vm._s(_vm.userinfo.phoneNum) + "\n\t\t          ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.roleName')
    }
  }, [_vm._v("\n\t\t            " + _vm._s(_vm.userinfo.roleName) + "\n\t\t          ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_areaid')
    }
  }, [_vm._v("\n\t\t            " + _vm._s(_vm.userinfo.mechanismName) + "\n\t\t          ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.zhengshuType')
    }
  }, [_vm._v("\n\t\t            " + _vm._s(_vm.certTypeName) + "\n\t\t          ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_mgsys')
    }
  }, [_vm._v("\n\t\t            " + _vm._s(_vm.userinfo.ip) + "\n\t\t          ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_edcode')
    }
  }, [_vm._v("\n\t\t            " + _vm._s(_vm.userinfo.code) + "\n\t\t          ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_allowiplg')
    }
  }, [_vm._v("\n\t\t            " + _vm._s(_vm.userinfo.limitIp) + "\n\t\t          ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('lin_global.revisePass'),
      "label-width": "12.5%"
    },
    model: {
      value: (_vm.dialogFormVisible),
      callback: function($$v) {
        _vm.dialogFormVisible = $$v
      },
      expression: "dialogFormVisible"
    }
  }, [_c('el-form', {
    ref: "formPwd",
    attrs: {
      "model": _vm.formPwd,
      "rules": _vm.rules2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.oldPass'),
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formPwd.oldPass),
      callback: function($$v) {
        _vm.$set(_vm.formPwd, "oldPass", $$v)
      },
      expression: "formPwd.oldPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.newPass'),
      "label-width": _vm.formLabelWidth,
      "prop": "pass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formPwd.pass),
      callback: function($$v) {
        _vm.$set(_vm.formPwd, "pass", $$v)
      },
      expression: "formPwd.pass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.comfirmPass'),
      "label-width": _vm.formLabelWidth,
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formPwd.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.formPwd, "checkPass", $$v)
      },
      expression: "formPwd.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitForm('formPwd')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.confirm')))])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_editProfile')
    },
    model: {
      value: (_vm.isEditNick),
      callback: function($$v) {
        _vm.isEditNick = $$v
      },
      expression: "isEditNick"
    }
  }, [_c('el-form', {
    ref: "",
    attrs: {
      "model": "",
      "rules": ""
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.nickName'),
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.nick),
      callback: function($$v) {
        _vm.nick = $$v
      },
      expression: "nick"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.phoneNum'),
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.phone),
      callback: function($$v) {
        _vm.phone = $$v
      },
      expression: "phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": function($event) {
        _vm.cancelNick()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.saveNick()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.save')))])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "cclass": "gDia",
      "ttitle": "$t('app_mulfcau')",
      "size": "small"
    },
    on: {
      "open": _vm.bindOpen,
      "close": _vm.closeBind
    },
    model: {
      value: (_vm.isbind),
      callback: function($$v) {
        _vm.isbind = $$v
      },
      expression: "isbind"
    }
  }, [_c('div', {
    attrs: {
      "id": "mfbindfr"
    }
  }, [_c('el-steps', {
    attrs: {
      "space": 310,
      "active": _vm.active,
      "finish-status": "success"
    }
  }, [_c('el-step', {
    attrs: {
      "title": _vm.$t('app_ckidt')
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": _vm.$t('app_istapp')
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": _vm.$t('app_bindmfa')
    }
  })], 1), _vm._v(" "), (_vm.active == 0) ? _c('div', {
    attrs: {
      "id": "mfbind1"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('app_bindsfdv')) + "    " + _vm._s(_vm.$t('lin_global.user'))), _c('label', [_vm._v(_vm._s(_vm.brow.nickName))]), _vm._v(" " + _vm._s(_vm.$t('app_psfwtsstepop')))]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('app_ipaclgpsw')
    },
    model: {
      value: (_vm.mfafm.psw),
      callback: function($$v) {
        _vm.$set(_vm.mfafm, "psw", $$v)
      },
      expression: "mfafm.psw"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.active == 1) ? _c('div', {
    attrs: {
      "id": "mfbind2"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('app_bindsfdv')) + "    " + _vm._s(_vm.$t('lin_global.user'))), _c('label', [_vm._v(_vm._s(_vm.brow.nickName))]), _vm._v(" " + _vm._s(_vm.$t('app_psfwtsstepop')))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('app_phdnalyappggidck')))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('app_ipappstsagidck')))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('app_adappmksagidck')))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('app_afistclnxitbpagiinx')))])]) : _vm._e(), _vm._v(" "), (_vm.active == 2) ? _c('div', {
    attrs: {
      "id": "mfbind3"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('app_bindsfdv')) + "    " + _vm._s(_vm.$t('lin_global.user'))), _c('label', [_vm._v(_vm._s(_vm.brow.nickName))]), _vm._v(_vm._s(_vm.$t('app_psfwtsstepop')))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('app_usalyagidckscqrc6code')))]), _vm._v(" "), _c('div', {
    ref: "mfaqrcode",
    attrs: {
      "id": "mfaqrcode"
    }
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_sixnumb')
    },
    model: {
      value: (_vm.mfafm.code),
      callback: function($$v) {
        _vm.$set(_vm.mfafm, "code", $$v)
      },
      expression: "mfafm.code"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dld),
      expression: "dld"
    }],
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.active > 0) ? _c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": function($event) {
        _vm.stepClick(0)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_lsstep')))]) : _vm._e(), _vm._v(" "), (_vm.active < 2) ? _c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": function($event) {
        _vm.stepClick(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_nxstep')))]) : _vm._e(), _vm._v(" "), (_vm.active == 2) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.bindRqs
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.bind')))]) : _vm._e()], 1)]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.logining),
      expression: "logining"
    }],
    attrs: {
      "cclass": "gDia",
      "title": _vm.$t('lin_btn.unbind'),
      "size": "small"
    },
    on: {
      "close": _vm.closeUnbind
    },
    model: {
      value: (_vm.isunbind),
      callback: function($$v) {
        _vm.isunbind = $$v
      },
      expression: "isunbind"
    }
  }, [_c('div', {
    attrs: {
      "id": "mfunbindfr"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('app_sftkck')) + "    " + _vm._s(_vm.$t('app_ip6codeubac')) + " "), _c('label', [_vm._v(_vm._s(_vm.brow.nickName))])]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('app_plipopenalyappoggidckip6dycd')))]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_sixnumb')
    },
    model: {
      value: (_vm.mfafm.code),
      callback: function($$v) {
        _vm.$set(_vm.mfafm, "code", $$v)
      },
      expression: "mfafm.code"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.unbindOpe
    }
  }, [_vm._v(_vm._s(_vm.$t('app_sure')))])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 983 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.$t('app_tip'),
      "visible": _vm.cerDialogVisible,
      "size": "tiny",
      "before-close": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.cerDialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.cerTipMsg))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.cerDialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.pushUploadCer
    }
  }, [_vm._v(_vm._s(_vm.$t('app_uploadCer')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('app_tip'),
      "visible": _vm.cerTipDialogVisible,
      "size": "tiny",
      "before-close": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.cerTipDialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.cerTipMsg))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.cerTipDialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_sure')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_addPush'),
      "size": "middle"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dvLoading),
      expression: "dvLoading"
    }]
  }, [_c('div', {
    staticClass: "gDiaTable",
    staticStyle: {
      "width": "100%",
      "background": "none",
      "text-align": "left"
    }
  }, [_c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_distributor')
    },
    on: {
      "change": _vm.selectDvChange
    },
    model: {
      value: (_vm.channelId),
      callback: function($$v) {
        _vm.channelId = $$v
      },
      expression: "channelId"
    }
  }, _vm._l((_vm.channels), function(item) {
    return _c('el-option', {
      key: item.mechanismid,
      attrs: {
        "label": item.mechanismname,
        "value": item.mechanismid
      }
    })
  }))], 1), _vm._v(" "), _c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.selectDvChange
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.stModel), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.label,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "40%",
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": _vm.$t('app_searchTerminal'),
      "icon": "search"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srchDevice($event)
      }
    },
    model: {
      value: (_vm.srchValue),
      callback: function($$v) {
        _vm.srchValue = $$v
      },
      expression: "srchValue"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dvTableData,
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminal_status",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "right",
      "header-align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_push'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.dvIndex,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.dvTotal
    },
    on: {
      "current-change": _vm.pageDvSelect,
      "size-change": _vm.pageDvSized
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('div', {}, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.jumpToUpload
    }
  }, [_vm._v(_vm._s(_vm.$t('app_addlc')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_lcname'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)])], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    staticClass: "tbPoint gTopMg",
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick,
      "sort-change": _vm.sortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "launchername",
      "sortable": "custom",
      "label": 'launcher' + _vm.$t('app_name'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "distrabutorname",
      "width": "",
      "label": _vm.$t('app_distributor')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "status",
      "width": "115",
      "label": _vm.$t('app_vStatus')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          style: (_vm.getStatus(scope.row.status).style)
        }, [_vm._v(_vm._s(_vm.getStatus(scope.row.status).vl))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "version",
      "width": "120",
      "label": _vm.$t('app_newgVer')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "uploadtime",
      "sortable": "custom",
      "width": "175",
      "fformatter": "dateFormat",
      "label": _vm.$t('app_ulTime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "right",
      "prop": "operate",
      "width": "122",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "background": "none"
          }
        }, [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_edit'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: ((scope.row.status !== '1' && scope.row.status !== '2') && scope.row.isoperate === 0),
            expression: "(scope.row.status !== '1' && scope.row.status !== '2') && scope.row.isoperate === 0"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.editApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_smVerify'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status !== '1' && scope.row.status !== '2' && scope.row.isoperate === 0),
            expression: "scope.row.status !== '1' && scope.row.status !== '2' && scope.row.isoperate === 0"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.submitApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-external-link-square"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.isoperate === 0),
            expression: "scope.row.isoperate === 0"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 984 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ae"
    }
  }, [_c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_addPush'),
      "size": "middle"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    staticClass: "gDiaTable",
    staticStyle: {
      "width": "100%",
      "background": "none",
      "text-align": "left"
    }
  }, [_c('span'), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticStyle: {
      "margin-right": "16px"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.stModel), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.label,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "40%",
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": _vm.$t('app_searchTerminal'),
      "icon": "search"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srchDevice($event)
      }
    },
    model: {
      value: (_vm.srchValue),
      callback: function($$v) {
        _vm.srchValue = $$v
      },
      expression: "srchValue"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dLoading),
      expression: "dLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_terNo'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminal_status",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_push'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_banReason')
    },
    model: {
      value: (_vm.notPassDialog),
      callback: function($$v) {
        _vm.notPassDialog = $$v
      },
      expression: "notPassDialog"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_reason'),
      "label-width": "14%"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.notPassDialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.verifyRqs('3')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_submit')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "background": "none",
      "padding": "0 0px 0 24px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.videoname : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('table', {
    staticClass: "dt-vdodetail"
  }, [_c('tr', {}, [_c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_addur')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.duration : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_fileSize')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.size : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_vsize')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.dimension : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_addtime')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.makeCreateTime(_vm.config.createtime) : ''))])]), _vm._v(" "), _c('td')])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticStyle: {
      "background": "none",
      "padding": "0 0px 24px 0px"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.$router.go(-1);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.verify('2')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_psverify')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.verify('3')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_ban')))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gCtColor  gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_vpreview')) + " ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "480px",
      "background": "black",
      "text-align": "center",
      "overflow": "hiiden"
    }
  }, [_c('video', {
    attrs: {
      "height": "480px",
      "src": _vm.playUrl,
      "controls": "controls"
    }
  }, [_vm._v("\n        your browser is not support video tag\n      ")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 985 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m_context plr mb30"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "id": "addForm",
      "model": _vm.form,
      "label-width": "12.5%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_areaid')
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData,
      "mselect": true,
      "classs": 'w_33'
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.ter_num')
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v("  " + _vm._s(_vm.form.terNums) + "  ")]), _vm._v(_vm._s(_vm.$t('terminal.appLog.tower')) + "\n                ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.version')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.version),
      callback: function($$v) {
        _vm.$set(_vm.form, "version", $$v)
      },
      expression: "form.version"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.remark')
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form.memo),
      callback: function($$v) {
        _vm.$set(_vm.form, "memo", $$v)
      },
      expression: "form.memo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isSubmit
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.submit')))])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.tableData,
      "id": "tableData",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": _vm.$t('lin_global.time'),
      "show-overflow-tooltip": true,
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mechanismName",
      "label": _vm.$t('lin_global.label_areaid'),
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "version",
      "label": _vm.$t('lin_global.version'),
      "show-overflow-tooltip": true,
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "memo",
      "label": _vm.$t('lin_global.remark'),
      "show-overflow-tooltip": true
    }
  })], 1), _vm._v(" "), (_vm.totalRecords > 0) ? _c('div', {
    staticClass: "gPgDiv",
    attrs: {
      "id": ""
    }
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 50, 100],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 986 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tagter"
    }
  }, [_c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tagobj.type == 'terSt'),
      expression: "tagobj.type == 'terSt'"
    }]
  }, [_c('el-tag', {
    attrs: {
      "type": _vm.terType[_vm.tagobj.vl],
      "size": "mini"
    }
  }, [_vm._v(_vm._s(_vm.terSt[_vm.tagobj.vl]))])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tagobj.type == 'nterSt'),
      expression: "tagobj.type == 'nterSt'"
    }]
  }, [_c('el-tag', {
    attrs: {
      "type": _vm.nterType[_vm.tagobj.vl],
      "size": "mini"
    }
  }, [_vm._v(_vm._s(_vm.nterSt[_vm.tagobj.vl]))])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tagobj.type == 'openAuthType'),
      expression: "tagobj.type == 'openAuthType'"
    }]
  }, [_c('el-tag', {
    attrs: {
      "type": _vm.openAuthType[_vm.tagobj.vl],
      "size": "mini"
    }
  }, [_vm._v(_vm._s(_vm.openAuthSt[_vm.tagobj.vl]))])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 987 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m_context plr"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "id": "addForm",
      "model": _vm.form,
      "label-width": "16%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.name')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.version')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.version),
      callback: function($$v) {
        _vm.$set(_vm.form, "version", $$v)
      },
      expression: "form.version"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_areaid')
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData,
      "mselect": true,
      "classs": 'w_33'
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.xzqddhwj')
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "name": "fileUpload",
      "drag": "",
      "action": _vm.action,
      "on-success": _vm.handleAvatarScucess1,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.jwjtdcc'))), _c('em', [_vm._v(_vm._s(_vm.$t('lin_global.djsc')))])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.pleaseUpload')))])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.qxzkjlogo')
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "name": "fileUpload",
      "action": _vm.action,
      "show-file-list": false,
      "on-success": _vm.handleAvatarScucess2,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [(_vm.imageUrl) ? _c('img', {
    staticClass: "avatar1",
    attrs: {
      "src": _vm.imageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon1"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.tpxzds')))])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.zmlaun')
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "name": "fileUpload",
      "drag": "",
      "action": _vm.action,
      "on-success": _vm.handleAvatarScucess3,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.jwjtdcc'))), _c('em', [_vm._v(_vm._s(_vm.$t('lin_global.djsc')))])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.pleaseUpload')))])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.xtjcb')
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "name": "fileUpload",
      "drag": "",
      "action": _vm.action,
      "on-success": _vm.handleAvatarScucess4,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.jwjtdcc'))), _c('em', [_vm._v(_vm._s(_vm.$t('lin_global.djsc')))])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.pleaseUpload')))])])], 1), _vm._v(" "), _c('el-form-item', [_c('el-checkbox', {
    on: {
      "change": _vm.check
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.zdqmTips')))])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "id": "onCancel"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isSubmit
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.add')))])], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 988 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.openEditModel('ADD')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menuConfig.menu.addMenu')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.refreshMenu
    }
  }, [_vm._v(_vm._s(_vm.$t('menuConfig.menu.refreshMenu')))])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-tree', {
    attrs: {
      "data": _vm.resultData,
      "props": _vm.defaultProps,
      "node-key": "id",
      "expand-on-click-node": false,
      "render-content": _vm.renderContent
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.modelTitle,
      "visible": _vm.editMenuModelVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.editMenuModelVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "rules": _vm.editRules
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.initListData
    }
  }, [_vm._v("列表")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden"
    }
  }), _vm._v(" "), _vm._l((_vm.menuNameLangA), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": item,
        "label-width": "120",
        "prop": "item"
      }
    }, [_c('el-input', {
      attrs: {
        "auto-complete": "off"
      },
      model: {
        value: (_vm.menuNameLangO[item]),
        callback: function($$v) {
          _vm.$set(_vm.menuNameLangO, item, $$v)
        },
        expression: "menuNameLangO[item]"
      }
    })], 1)
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "url",
      "label-width": "120",
      "prop": "url"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editForm.url),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "url", $$v)
      },
      expression: "editForm.url"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "uri",
      "label-width": "120",
      "prop": "uri"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editForm.uri),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "uri", $$v)
      },
      expression: "editForm.uri"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "color": "darkgrey"
    }
  }, [_vm._v("完整路径: @/components/xxx.vue")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "meta",
      "label-width": "120",
      "prop": "meta"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editForm.meta),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "meta", $$v)
      },
      expression: "editForm.meta"
    }
  })], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editForm.subId),
      expression: "editForm.subId"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.editForm.subId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editForm, "subId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('menuConfig.menu.orderBy'),
      "label-width": "120",
      "prop": "menuSortNo"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.editForm.menuSortNo),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "menuSortNo", $$v)
      },
      expression: "editForm.menuSortNo"
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editMenuModelVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitEditForm()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.ok')))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('menu.menuEdit'),
      "visible": _vm.editMenuPosition
    },
    on: {
      "update:visible": function($event) {
        _vm.editMenuPosition = $event
      }
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "max": 9999
    },
    model: {
      value: (_vm.menuIndex),
      callback: function($$v) {
        _vm.menuIndex = $$v
      },
      expression: "menuIndex"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editMenuPosition = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.handleChange()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.ok')))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.editMenuNameAndUrl
    },
    on: {
      "update:visible": function($event) {
        _vm.editMenuNameAndUrl = $event
      }
    }
  }, [_c('el-form', {
    ref: "submitForm",
    staticClass: "gForm",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "label-position": "right",
      "label-width": "12.5%",
      "model": _vm.submitForm,
      "rules": ""
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_name'),
      "prop": "roleName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.submitForm.name),
      callback: function($$v) {
        _vm.$set(_vm.submitForm, "name", $$v)
      },
      expression: "submitForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "URL",
      "prop": "memo"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.submitForm.url),
      callback: function($$v) {
        _vm.$set(_vm.submitForm, "url", $$v)
      },
      expression: "submitForm.url"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Icon",
      "prop": "memo"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.submitForm.icon),
      callback: function($$v) {
        _vm.$set(_vm.submitForm, "icon", $$v)
      },
      expression: "submitForm.icon"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editMenuNameAndUrl = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitMenuEdit()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.ok')))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 989 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gPageBorder"
  }, [_c('el-form', {
    ref: "submitForm",
    staticClass: "gForm",
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "label-position": "right",
      "label-width": "12.5%",
      "model": _vm.submitForm,
      "rules": _vm.editRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('menuConfig.role.name'),
      "prop": "roleName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.submitForm.roleName),
      callback: function($$v) {
        _vm.$set(_vm.submitForm, "roleName", $$v)
      },
      expression: "submitForm.roleName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('menuConfig.role.mark'),
      "prop": "memo"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.submitForm.memo),
      callback: function($$v) {
        _vm.$set(_vm.submitForm, "memo", $$v)
      },
      expression: "submitForm.memo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('menuConfig.role.modelSelect'),
      "prop": "memo"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-tree', {
    ref: "tree",
    attrs: {
      "show-checkbox": "",
      "data": _vm.resultData,
      "props": _vm.defaultProps,
      "node-key": "menuId",
      "default-expand-all": "",
      "expand-on-click-node": false
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form', {
    staticStyle: {
      "width": "60%",
      "margin-top": "10px"
    },
    attrs: {
      "label-position": "left",
      "label-width": "90px"
    }
  }, [_c('el-form-item', [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.checkAll()
      }
    }
  }, [(!_vm.alreadyCheckAll) ? [_vm._v(_vm._s(_vm.$t('mao_global.btn.selectAll')))] : [_vm._v(_vm._s(_vm.$t('mao_global.btn.unSelectAll')))]], 2), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.reset')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addRole()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.createNow')))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 990 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info ? _vm.info.status == 3 : false),
      expression: "info?info.status == 3:false"
    }]
  }, [_c('el-alert', {
    staticStyle: {
      "display": "-webkit-flex",
      "margin": "0 0 5px 0"
    },
    attrs: {
      "title": _vm.reason,
      "type": "error",
      "show-icon": ""
    }
  })], 1), _vm._v(" "), _c('el-form', {
    ref: "firm",
    staticClass: "gForm",
    attrs: {
      "label-position": "right",
      "rules": _vm.rules,
      "label-width": "12.5%",
      "model": _vm.firm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_srcname'),
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.firm.name),
      callback: function($$v) {
        _vm.$set(_vm.firm, "name", $$v)
      },
      expression: "firm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_srcdesc'),
      "prop": "desc"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.firm.desc),
      callback: function($$v) {
        _vm.$set(_vm.firm, "desc", $$v)
      },
      expression: "firm.desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_distributor'),
      "prop": "mech"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_ulfile'),
      "prop": "url"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "name": "fileUpload",
      "action": _vm.fileUploadUrl,
      "before-upload": _vm.srcBefore,
      "on-success": _vm.srcSuccess,
      "file-list": _vm.srcList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "",
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_clickUpdate')))])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_version'),
      "prop": "ver"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.firm.ver),
      callback: function($$v) {
        _vm.$set(_vm.firm, "ver", $$v)
      },
      expression: "firm.ver"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save('firm')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_save')))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 991 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ae"
    }
  }, [_c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.data ? _vm.config.data.auditContent : false),
      expression: "config.data ? config.data.auditContent : false"
    }]
  }, [_c('el-alert', {
    staticStyle: {
      "display": "-webkit-flex",
      "margin": "0 0 5px 0"
    },
    attrs: {
      "title": _vm.reason,
      "type": "error",
      "show-icon": ""
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_addPush'),
      "size": "middle"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    staticClass: "gDiaTable",
    staticStyle: {
      "width": "100%",
      "background": "none",
      "text-align": "left"
    }
  }, [_c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_distributor')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.channelId),
      callback: function($$v) {
        _vm.channelId = $$v
      },
      expression: "channelId"
    }
  }, _vm._l((_vm.channels), function(item) {
    return _c('el-option', {
      key: item.mechanismid,
      attrs: {
        "label": item.mechanismname,
        "value": item.mechanismid
      }
    })
  }))], 1), _vm._v(" "), _c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.stModel), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.label,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "40%",
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": _vm.$t('app_searchTerminal'),
      "icon": "search"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srchDevice($event)
      }
    },
    model: {
      value: (_vm.srchValue),
      callback: function($$v) {
        _vm.srchValue = $$v
      },
      expression: "srchValue"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_terNo'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminal_status",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_push'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "size": "small"
    },
    model: {
      value: (_vm.showPic.value),
      callback: function($$v) {
        _vm.$set(_vm.showPic, "value", $$v)
      },
      expression: "showPic.value"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "src": _vm.showPic.data
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowReason),
      expression: "isShowReason"
    }]
  }, [_c('el-alert', {
    staticStyle: {
      "display": "-webkit-flex",
      "margin": "0 0 5px 0"
    },
    attrs: {
      "title": _vm.reason,
      "type": "error",
      "show-icon": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder"
  }, [_c('el-form', {
    ref: "form",
    staticClass: "gForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-position": "right",
      "label-width": "12.5%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_filename'),
      "prop": "name"
    }
  }, [_c('el-input', {
    staticClass: "aeMg",
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_filedesc'),
      "prop": ""
    }
  }, [_c('el-input', {
    staticClass: "aeMg",
    model: {
      value: (_vm.form.desc),
      callback: function($$v) {
        _vm.$set(_vm.form, "desc", $$v)
      },
      expression: "form.desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_type'),
      "prop": "dtype"
    }
  }, [_c('el-radio-group', {
    on: {
      "input": _vm.change_device
    },
    model: {
      value: (_vm.form.dtype),
      callback: function($$v) {
        _vm.$set(_vm.form, "dtype", $$v)
      },
      expression: "form.dtype"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.device_type_1')))]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.device_type_2')))])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_filetype'),
      "prop": "ftype"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('app_select')
    },
    on: {
      "change": _vm.fileTypeChange
    },
    model: {
      value: (_vm.form.ftype),
      callback: function($$v) {
        _vm.$set(_vm.form, "ftype", $$v)
      },
      expression: "form.ftype"
    }
  }, _vm._l((_vm.ftypes), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_subtype'),
      "prop": ""
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_select')
    },
    on: {
      "change": _vm.sfileTypeChange
    },
    model: {
      value: (_vm.form.stype),
      callback: function($$v) {
        _vm.$set(_vm.form, "stype", $$v)
      },
      expression: "form.stype"
    }
  }, _vm._l((_vm.cmtypes), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_version'),
      "prop": "ver"
    }
  }, [_c('el-input', {
    staticClass: "aeMg",
    attrs: {
      "disabled": _vm.form.ftype == 11 ? true : false
    },
    model: {
      value: (_vm.form.ver),
      callback: function($$v) {
        _vm.$set(_vm.form, "ver", $$v)
      },
      expression: "form.ver"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isbase),
      expression: "isbase"
    }],
    attrs: {
      "label": _vm.$t('app_preversion'),
      "prop": _vm.isbase ? _vm.bver : ''
    }
  }, [_c('el-input', {
    staticClass: "aeMg",
    model: {
      value: (_vm.form.bver),
      callback: function($$v) {
        _vm.$set(_vm.form, "bver", $$v)
      },
      expression: "form.bver"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "label": _vm.$t('app_ulfile'),
      "prop": "url"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo aeMg",
    attrs: {
      "data": _vm.uData,
      "drag": "",
      "name": "fileUpload",
      "file-list": _vm.fileList,
      "on-success": _vm.fileUploadSuccess,
      "before-upload": _vm.fileBeforeUpload,
      "action": _vm.fileUploadUrl
    }
  }, [_c('span', [(_vm.ulinfo.index === 0) ? _c('i', {
    class: _vm.ulinfo.icons[_vm.ulinfo.index]
  }) : _c('div', {
    staticStyle: {
      "margin-top": "22px",
      "color": "#48576A"
    }
  }, [_c('i', {
    class: _vm.ulinfo.icons[_vm.ulinfo.index],
    style: (_vm.tipColor)
  }), _vm._v(" "), _c('el-col', [_c('el-row', {
    staticStyle: {
      "margin-top": "-8px"
    }
  }, [_c('div'), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "26px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_filename')) + ": " + _vm._s(_vm.form.fname))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "26px"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('app_fileSize')) + ": " + _vm._s((_vm.form.size / 1024).toFixed(2)) + "KB\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "26px"
    }
  }, [_vm._v("MD5: " + _vm._s(_vm.form.md5))]), _vm._v(" "), _c('div', [_c('el-button', {
    staticStyle: {
      "margin-top": "6px"
    },
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_clreul')))])], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ulinfo.index === 0),
      expression: "ulinfo.index === 0"
    }],
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.ulinfo.tip))])])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_useDis'),
      "prop": "mech"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.type === 3),
      expression: "config.type === 3"
    }],
    staticStyle: {
      "background": "none",
      "margin-top": "30px"
    },
    attrs: {
      "label": _vm.$t('app_testInstall')
    }
  }, [_c('el-button', {
    staticClass: "aeMg",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.pushInstall
    }
  }, [_vm._v(_vm._s(_vm.$t('app_pushInstall')))])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.type === 3),
      expression: "config.type === 3"
    }],
    staticStyle: {
      "background": "none"
    },
    attrs: {
      "label": _vm.$t('app_isPass')
    }
  }, [_c('el-radio', {
    staticClass: "radio aeMg",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_pass')))]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio aeMg",
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_ban')))])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.radio === '2'),
      expression: "radio === '2'"
    }],
    staticStyle: {
      "background": "none"
    },
    attrs: {
      "label": _vm.$t('app_banReason')
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkDesc),
      expression: "checkDesc"
    }],
    staticStyle: {
      "width": "100%",
      "height": "60px",
      "float": "left"
    },
    domProps: {
      "value": (_vm.checkDesc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.checkDesc = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticStyle: {
      "background": "none"
    }
  }, [_c('el-button', {
    staticClass: "aeMg",
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    staticClass: "aeMg",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.uploadApp('form')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_save')))])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.type === 2),
      expression: "config.type === 2"
    }],
    staticStyle: {
      "background": "none"
    },
    attrs: {
      "label": ""
    }
  }, [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.lcNew
    }
  }, [_vm._v(_vm._s(_vm.$t('app_upload') + 'launcher'))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 992 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ae"
    }
  }, [_c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_addPush'),
      "size": "middle"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    staticClass: "gDiaTable",
    staticStyle: {
      "width": "100%",
      "background": "none",
      "text-align": "left"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticStyle: {
      "margin-right": "16px"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.stModel), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "40%",
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": _vm.$t('app_searchTerminal'),
      "icon": "search",
      "on-icon-click": _vm.srchDevice
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srchDevice($event)
      }
    },
    model: {
      value: (_vm.srchValue),
      callback: function($$v) {
        _vm.srchValue = $$v
      },
      expression: "srchValue"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dLoading),
      expression: "dLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_terNo'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminal_status",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.config.fileType == 6) ? _c('span', [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_enable')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e()], 1) : _c('span', [_c('tagc', {
          attrs: {
            "tagobj": {
              type: 'terSt',
              vl: scope.row.terminalStatus
            }
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_push'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_banReason')
    },
    model: {
      value: (_vm.notPassDialog),
      callback: function($$v) {
        _vm.notPassDialog = $$v
      },
      expression: "notPassDialog"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_reason'),
      "label-width": "14%"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.notPassDialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.verifyRqs('3')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_submit')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "background": "none",
      "padding": "0 0px 0 24px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "ldt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.fileName : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "65px"
    }
  }, [_c('table', {
    staticClass: "ldt-file"
  }, [_c('tr', {}, [_c('td', [_c('label', {
    staticClass: "ldt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_version')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "ldt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.fileVersion : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "ldt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_filetype')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "ldt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.getftype[_vm.config.fileType] : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "ldt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_subtype')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "ldt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.getstype[_vm.config.subFileType] : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "ldt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_distributor')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "ldt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.mechName : ''))])])]), _vm._v(" "), _c('tr', {}, [_c('td', [_c('label', {
    staticClass: "ldt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_adddate')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "ldt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.createTime : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "ldt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_fileSize')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "ldt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? (_vm.config.fileSize / 1024).toFixed(2) : '') + "KB")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', {
    staticClass: "ldt-word-title"
  }, [_vm._v("MD5：")]), _vm._v(" "), _c('label', {
    staticClass: "ldt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.hashCode : ''))])]), _vm._v(" "), _c('td')])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "none",
      "min-height": "10px",
      "display": "-webkit-flex"
    }
  }, [_c('div', {
    staticClass: "ldt-word-title",
    staticStyle: {
      "display": "inline-block",
      "min-width": "70px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('app_filedesc')) + "：\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "ldt-word-main",
    staticStyle: {
      "display": "inline-block",
      "position": "relative",
      "background": "none",
      "margin": "0 24px 24px 0",
      "padding-right": "24px"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.config ? _vm.config.memo : ''))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "none",
      "padding": "10px 0px 24px 0px"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.$router.go(-1);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.verify('2')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_psverify')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.verify('3')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_ban')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_pushtest')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "4px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.openlink
    }
  }, [_vm._v(_vm._s(_vm.$t('app_downfile')))])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 993 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.editInfo.status === 3),
      expression: "this.editInfo.status === 3"
    }]
  }, [_c('el-alert', {
    staticStyle: {
      "display": "-webkit-flex",
      "margin": "0 0 24px 0"
    },
    attrs: {
      "title": _vm.reason,
      "type": "error",
      "show-icon": ""
    }
  })], 1), _vm._v(" "), _c('el-form', {
    ref: "addForm",
    staticClass: "gForm",
    attrs: {
      "id": "addForm",
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "13.5%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_ad') + _vm.$t('app_name'),
      "prop": "videoName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_input')
    },
    model: {
      value: (_vm.form.videoName),
      callback: function($$v) {
        _vm.$set(_vm.form, "videoName", $$v)
      },
      expression: "form.videoName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_csvldate'),
      "prop": "time"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "40%",
      "margin-right": "24px"
    },
    attrs: {
      "type": "date",
      "placeholder": _vm.stHolder,
      "picker-options": _vm.pickerOptions0
    },
    on: {
      "change": _vm.sClick
    },
    model: {
      value: (_vm.form.sTime),
      callback: function($$v) {
        _vm.$set(_vm.form, "sTime", $$v)
      },
      expression: "form.sTime"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "40%",
      "margin-right": "24px"
    },
    attrs: {
      "type": "date",
      "placeholder": _vm.endHolder,
      "picker-options": _vm.pickerOptions0
    },
    on: {
      "change": _vm.eClick
    },
    model: {
      value: (_vm.form.eTime),
      callback: function($$v) {
        _vm.$set(_vm.form, "eTime", $$v)
      },
      expression: "form.eTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "label": _vm.$t('app_vdofile'),
      "prop": "url"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo aeMg",
    attrs: {
      "data": _vm.uData,
      "drag": "",
      "name": "fileUpload",
      "file-list": _vm.fileList,
      "on-success": _vm.fileUploadSuccess,
      "before-upload": _vm.fileBeforeUpload,
      "action": _vm.$videoUrl
    }
  }, [_c('span', [(_vm.ulinfo.index === 0) ? _c('i', {
    class: _vm.ulinfo.icons[_vm.ulinfo.index]
  }) : _c('div', {
    staticStyle: {
      "margin-top": "12px",
      "color": "#48576A"
    }
  }, [_c('i', {
    class: _vm.ulinfo.icons[_vm.ulinfo.index],
    style: (_vm.tipColor)
  }), _vm._v(" "), _c('el-col', [_c('el-row', {
    staticStyle: {
      "margin-top": "-8px"
    }
  }, [_c('div'), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "26px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_filename')) + ": " + _vm._s(_vm.form.fileName))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "26px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_vdodur')) + ": " + _vm._s(_vm.form.duration))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "26px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_fileSize')) + ": " + _vm._s(_vm.form.size))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "26px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_vsize')) + ": " + _vm._s(_vm.form.dimension))]), _vm._v(" "), _c('div', [_c('label', {
    staticStyle: {
      "margin-top": "6px",
      "color": "#B2BBC5",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_clreulvdo')))])])])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ulinfo.index === 0),
      expression: "ulinfo.index === 0"
    }],
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.ulinfo.tip))])])])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), (_vm.isUpload) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('app_addvdoad')))]) : _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('app_edvdoad')))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 994 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "processInfo"
    }
  }, [_c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('lin_global.shebeiedit'),
      "show-close": true,
      "modal": true,
      "size": "small",
      "lock-scroll": "",
      "close-on-press-escape": "",
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.closeDialog
    },
    model: {
      value: (_vm.processInfoVisible),
      callback: function($$v) {
        _vm.processInfoVisible = $$v
      },
      expression: "processInfoVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "id": "addForm",
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "150px"
    }
  }, [_c('el-popover', {
    ref: "popover1",
    attrs: {
      "placement": "right-end",
      "width": "225",
      "trigger": "hover",
      "content": _vm.$t('terminal.add.popover_no'),
      "popper-class": ""
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_no'),
      "prop": "terminal_no"
    }
  }, [_c('el-input', {
    directives: [{
      name: "popover",
      rawName: "v-popover:popover1",
      arg: "popover1"
    }],
    attrs: {
      "id": "terminal_no",
      "maxlength": 50,
      "placeholder": _vm.$t('terminal.add.place_no')
    },
    model: {
      value: (_vm.form.terminal_no),
      callback: function($$v) {
        _vm.$set(_vm.form, "terminal_no", $$v)
      },
      expression: "form.terminal_no"
    }
  })], 1), _vm._v(" "), _c('el-popover', {
    ref: "popover2",
    attrs: {
      "placement": "right-end",
      "width": "225",
      "trigger": "hover",
      "content": _vm.$t('terminal.add.popover_name'),
      "popper-class": ""
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_name'),
      "prop": "terminal_name"
    }
  }, [_c('el-input', {
    directives: [{
      name: "popover",
      rawName: "v-popover:popover2",
      arg: "popover2"
    }],
    attrs: {
      "id": "terminal_name",
      "maxlength": 50,
      "placeholder": _vm.$t('terminal.add.place_name')
    },
    model: {
      value: (_vm.form.terminal_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "terminal_name", $$v)
      },
      expression: "form.terminal_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_areaid'),
      "prop": "areaid"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData,
      "mselect": true
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_model'),
      "prop": "terminal_model"
    }
  }, [_c('el-select', {
    attrs: {
      "id": "terminal_model",
      "filterable": "",
      "clearable": "",
      "placeholder": _vm.$t('terminal.add.place_model')
    },
    model: {
      value: (_vm.form.terminal_model),
      callback: function($$v) {
        _vm.$set(_vm.form, "terminal_model", $$v)
      },
      expression: "form.terminal_model"
    }
  }, _vm._l((_vm.models), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_type'),
      "prop": "terminal_type"
    }
  }, [_c('el-select', {
    attrs: {
      "id": "terminal_type",
      "filterable": "",
      "clearable": "",
      "placeholder": _vm.$t('terminal.add.place_type')
    },
    model: {
      value: (_vm.form.terminal_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "terminal_type", $$v)
      },
      expression: "form.terminal_type"
    }
  }, _vm._l((_vm.dvTypes), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_manufid'),
      "prop": "manufid"
    }
  }, [_c('el-select', {
    attrs: {
      "id": "terminal_type",
      "filterable": "",
      "clearable": "",
      "placeholder": _vm.$t('terminal.add.place_manufid')
    },
    model: {
      value: (_vm.form.manufid),
      callback: function($$v) {
        _vm.$set(_vm.form, "manufid", $$v)
      },
      expression: "form.manufid"
    }
  }, _vm._l((_vm.firms), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_address'),
      "prop": "address"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "address",
      "placeholder": _vm.$t('terminal.add.place_address')
    },
    model: {
      value: (_vm.form.address),
      callback: function($$v) {
        _vm.$set(_vm.form, "address", $$v)
      },
      expression: "form.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.remark'),
      "prop": "memo"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "memo",
      "placeholder": _vm.$t('lin_global.remark')
    },
    model: {
      value: (_vm.form.memo),
      callback: function($$v) {
        _vm.$set(_vm.form, "memo", $$v)
      },
      expression: "form.memo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "id": "onCancel",
      "disabled": _vm.isSubmit
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isSubmit,
      "id": "onSubmit"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.change')))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 995 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m_context"
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-left": "24px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": ""
    },
    on: {
      "change": _vm.typeChange
    },
    model: {
      value: (_vm.selectType),
      callback: function($$v) {
        _vm.selectType = $$v
      },
      expression: "selectType"
    }
  }, _vm._l((_vm.type), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('lin_global.tgmccz'),
      "icon": "search",
      "on-icon-click": _vm.handleIconClick
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "arrdata",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.arrdata,
      "id": "tp",
      "border": ""
    },
    on: {
      "row-click": _vm.rowClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": _vm.$t('lin_global.name')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "version",
      "label": _vm.$t('lin_global.version'),
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": _vm.$t('terminal.details.animatType'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mechanismName",
      "label": _vm.$t('lin_global.label_areaid')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "opetime",
      "label": _vm.$t('lin_global.uploadTime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "align": "center",
      "width": "",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_verify'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_c('i', {
          staticClass: "fa fa-check-square-o"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.totalRecords > 0) ? _c('div', {
    staticClass: "page_content"
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 50, 100],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 996 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ae"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.data ? _vm.config.data.status === '3' : false),
      expression: "config.data ? config.data.status === '3' : false"
    }]
  }, [_c('el-alert', {
    staticStyle: {
      "display": "-webkit-flex",
      "margin": "0 0 5px 0"
    },
    attrs: {
      "title": _vm.reason,
      "type": "error",
      "show-icon": ""
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_addPush'),
      "size": "middle"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    staticClass: "gDiaTable",
    staticStyle: {
      "width": "100%",
      "background": "none",
      "text-align": "left"
    }
  }, [_c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_distributor')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.channelId),
      callback: function($$v) {
        _vm.channelId = $$v
      },
      expression: "channelId"
    }
  }, _vm._l((_vm.channels), function(item) {
    return _c('el-option', {
      key: item.mechanismid,
      attrs: {
        "label": item.mechanismname,
        "value": item.mechanismid
      }
    })
  }))], 1), _vm._v(" "), _c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.stModel), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.label,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "40%",
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": _vm.$t('app_searchTerminal'),
      "icon": "search"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srchDevice($event)
      }
    },
    model: {
      value: (_vm.srchValue),
      callback: function($$v) {
        _vm.srchValue = $$v
      },
      expression: "srchValue"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_terNo'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminal_status",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_push'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "size": "small"
    },
    model: {
      value: (_vm.showPic.value),
      callback: function($$v) {
        _vm.$set(_vm.showPic, "value", $$v)
      },
      expression: "showPic.value"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "src": _vm.showPic.data
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowReason),
      expression: "isShowReason"
    }]
  }, [_c('el-alert', {
    staticStyle: {
      "display": "-webkit-flex",
      "margin": "0 0 5px 0"
    },
    attrs: {
      "title": _vm.reason,
      "type": "error",
      "show-icon": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder"
  }, [_c('el-form', {
    ref: "form",
    staticClass: "gForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-position": "right",
      "label-width": "12.5%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": 'launcher' + _vm.$t('app_name'),
      "prop": "launcherName"
    }
  }, [_c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }],
    staticClass: "aeMg",
    model: {
      value: (_vm.form.launcherName),
      callback: function($$v) {
        _vm.$set(_vm.form, "launcherName", $$v)
      },
      expression: "form.launcherName"
    }
  }), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "aeMg",
    model: {
      value: (_vm.form.launcherName),
      callback: function($$v) {
        _vm.$set(_vm.form, "launcherName", $$v)
      },
      expression: "form.launcherName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": 'launcher' + _vm.$t('app_ss'),
      "prop": "launcherDesc"
    }
  }, [_c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }],
    staticClass: "aeMg",
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 9999
      }
    },
    model: {
      value: (_vm.form.launcherDesc),
      callback: function($$v) {
        _vm.$set(_vm.form, "launcherDesc", $$v)
      },
      expression: "form.launcherDesc"
    }
  }), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "aeMg",
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 9999
      }
    },
    model: {
      value: (_vm.form.launcherDesc),
      callback: function($$v) {
        _vm.$set(_vm.form, "launcherDesc", $$v)
      },
      expression: "form.launcherDesc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "label": _vm.$t('app_ulinsfile'),
      "prop": "appUrl"
    }
  }, [_c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "upload-demo aeMg",
    attrs: {
      "data": _vm.uData,
      "drag": "",
      "name": "fileUpload",
      "file-list": _vm.fileList,
      "on-success": _vm.fileUploadSuccess,
      "before-upload": _vm.fileBeforeUpload,
      "action": _vm.fileUploadUrl
    }
  }, [_c('span', [(_vm.ulinfo.index === 0) ? _c('i', {
    class: _vm.ulinfo.icons[_vm.ulinfo.index]
  }) : _c('div', {
    staticStyle: {
      "margin-top": "22px",
      "color": "#48576A"
    }
  }, [_c('i', {
    class: _vm.ulinfo.icons[_vm.ulinfo.index],
    style: (_vm.tipColor)
  }), _vm._v(" "), _c('el-col', [_c('el-row', {
    staticStyle: {
      "margin-top": "-8px"
    }
  }, [_c('div'), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "26px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_version')) + ": " + _vm._s(_vm.form.version))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "26px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_verTag')) + ": " + _vm._s(_vm.form.verTag))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "26px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_package')) + ": " + _vm._s(_vm.form.packageName))]), _vm._v(" "), _c('div', [_c('label', {
    staticStyle: {
      "margin-top": "6px",
      "color": "#B2BBC5",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_clreul')))])])])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ulinfo.index === 0),
      expression: "ulinfo.index === 0"
    }],
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.ulinfo.tip))])])]), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }],
    staticClass: "upload-demo aeMg",
    attrs: {
      "data": _vm.uData,
      "drag": "",
      "name": "fileUpload",
      "file-list": _vm.fileList,
      "on-success": _vm.fileUploadSuccess,
      "before-upload": _vm.fileBeforeUpload,
      "action": _vm.fileUploadUrl
    }
  }, [_c('span', [(_vm.ulinfo.index === 0) ? _c('i', {
    class: _vm.ulinfo.icons[_vm.ulinfo.index]
  }) : _c('div', {
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('i', {
    class: _vm.ulinfo.icons[_vm.ulinfo.index],
    style: (_vm.tipColor)
  })]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.ulinfo.tip))])])])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "calc(100% + 20px)",
      "background": "#EAEEFA",
      "height": "1px",
      "margin-left": "-10px"
    }
  }), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }, {
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading1),
      expression: "loading1"
    }],
    attrs: {
      "label": 'launcher' + _vm.$t('app_printscreen'),
      "prop": "caps"
    }
  }, [_c('div', {
    staticStyle: {
      "background": "none",
      "text-align": "left",
      "padding": "0 0 0 15px"
    },
    attrs: {
      "id": "aeCap"
    }
  }, [_c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }],
    staticClass: "capture",
    staticStyle: {
      "margin-left": "-10px"
    },
    attrs: {
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "name": "file",
      "before-upload": _vm.tipBf,
      "on-success": _vm.handleAvatarSuccessCp0
    }
  }, [_c('div', {
    staticStyle: {
      "display": "-webkit-flex",
      "justify-content": "center",
      "align-items": "center",
      "clear": "both"
    }
  }, [(_vm.cp0) ? _c('img', {
    staticClass: "avatarF",
    attrs: {
      "src": _vm.cp0
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])]), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }],
    staticClass: "el-icon-delete",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.deleteCapture0()
      }
    }
  }), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }],
    staticClass: "capture",
    attrs: {
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "name": "file",
      "before-upload": _vm.tipBf,
      "on-success": _vm.handleAvatarSuccessCp1
    }
  }, [(_vm.cp1) ? _c('img', {
    staticClass: "avatarF",
    attrs: {
      "src": _vm.cp1
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }],
    staticClass: "el-icon-delete",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.deleteCapture1()
      }
    }
  }), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }],
    staticClass: "capture",
    attrs: {
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "name": "file",
      "before-upload": _vm.tipBf,
      "on-success": _vm.handleAvatarSuccessCp2
    }
  }, [(_vm.cp2) ? _c('img', {
    staticClass: "avatarF",
    attrs: {
      "src": _vm.cp2
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }],
    staticClass: "el-icon-delete",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.deleteCapture2()
      }
    }
  }), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }],
    staticClass: "capture",
    attrs: {
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "name": "file",
      "before-upload": _vm.tipBf,
      "on-success": _vm.handleAvatarSuccessCp3
    }
  }, [(_vm.cp3) ? _c('img', {
    staticClass: "avatarF",
    attrs: {
      "src": _vm.cp3
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }],
    staticClass: "el-icon-delete",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.deleteCapture3()
      }
    }
  }), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }],
    staticClass: "capture",
    attrs: {
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "name": "file",
      "before-upload": _vm.tipBf,
      "on-success": _vm.handleAvatarSuccessCp4
    }
  }, [(_vm.cp4) ? _c('img', {
    staticClass: "avatarF",
    attrs: {
      "src": _vm.cp4
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }],
    staticClass: "el-icon-delete",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.deleteCapture4()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "none",
      "text-align": "left",
      "padding": "0 0 0 15px"
    },
    attrs: {
      "id": "aeCap"
    }
  }, [_c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "capture",
    staticStyle: {
      "margin-left": "-10px"
    },
    attrs: {
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "name": "file",
      "before-upload": _vm.tipBf,
      "on-success": _vm.handleAvatarSuccessCp0
    }
  }, [_c('div', {
    staticStyle: {
      "display": "-webkit-flex",
      "justify-content": "center",
      "align-items": "center",
      "clear": "both"
    }
  }, [(_vm.cp0) ? _c('img', {
    staticClass: "avatarF",
    attrs: {
      "src": _vm.cp0
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])]), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "el-icon-delete",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.deleteCapture0()
      }
    }
  }), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "capture",
    attrs: {
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "name": "file",
      "before-upload": _vm.tipBf,
      "on-success": _vm.handleAvatarSuccessCp1
    }
  }, [(_vm.cp1) ? _c('img', {
    staticClass: "avatarF",
    attrs: {
      "src": _vm.cp1
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "el-icon-delete",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.deleteCapture1()
      }
    }
  }), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "capture",
    attrs: {
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "name": "file",
      "before-upload": _vm.tipBf,
      "on-success": _vm.handleAvatarSuccessCp2
    }
  }, [(_vm.cp2) ? _c('img', {
    staticClass: "avatarF",
    attrs: {
      "src": _vm.cp2
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "el-icon-delete",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.deleteCapture2()
      }
    }
  }), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "capture",
    attrs: {
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "name": "file",
      "before-upload": _vm.tipBf,
      "on-success": _vm.handleAvatarSuccessCp3
    }
  }, [(_vm.cp3) ? _c('img', {
    staticClass: "avatarF",
    attrs: {
      "src": _vm.cp3
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "el-icon-delete",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.deleteCapture3()
      }
    }
  }), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "capture",
    attrs: {
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "name": "file",
      "before-upload": _vm.tipBf,
      "on-success": _vm.handleAvatarSuccessCp4
    }
  }, [(_vm.cp4) ? _c('img', {
    staticClass: "avatarF",
    attrs: {
      "src": _vm.cp4
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "el-icon-delete",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.deleteCapture4()
      }
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.type === 3),
      expression: "config.type === 3"
    }],
    staticStyle: {
      "background": "none",
      "margin-top": "30px"
    },
    attrs: {
      "label": _vm.$t('app_testInstall')
    }
  }, [_c('el-button', {
    staticClass: "aeMg",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.pushInstall
    }
  }, [_vm._v(_vm._s(_vm.$t('app_pushInstall')))])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.type === 3),
      expression: "config.type === 3"
    }],
    staticStyle: {
      "background": "none"
    },
    attrs: {
      "label": _vm.$t('app_isPass')
    }
  }, [_c('el-radio', {
    staticClass: "radio aeMg",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_pass')))]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio aeMg",
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_ban')))])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.radio === '2'),
      expression: "radio === '2'"
    }],
    staticStyle: {
      "background": "none"
    },
    attrs: {
      "label": _vm.$t('app_banReason')
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkDesc),
      expression: "checkDesc"
    }],
    staticStyle: {
      "width": "100%",
      "height": "60px",
      "float": "left"
    },
    domProps: {
      "value": (_vm.checkDesc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.checkDesc = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticStyle: {
      "background": "none"
    }
  }, [_c('el-button', {
    staticClass: "aeMg",
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    staticClass: "aeMg",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.uploadApp('form')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_sure')))])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.type === 2),
      expression: "config.type === 2"
    }],
    staticStyle: {
      "background": "none"
    },
    attrs: {
      "label": ""
    }
  }, [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.lcNew
    }
  }, [_vm._v(_vm._s(_vm.$t('app_upload') + 'launcher'))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 997 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.updateRole()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.confirmUpdate')))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.resetCheck()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.reset')))])], 1)], 1), _vm._v(" "), _c('el-row', {}, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-tree', {
    ref: "tree",
    staticClass: "gTopMg gSgLeftBtn",
    attrs: {
      "show-checkbox": "",
      "data": _vm.resultData,
      "props": _vm.defaultProps,
      "node-key": "menuId",
      "default-expand-all": "",
      "expand-on-click-node": false
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    staticStyle: {
      "width": "60%",
      "margin-top": "10px"
    },
    attrs: {
      "label-position": "left",
      "label-width": "90px"
    }
  }, [_c('el-form-item')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 998 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('div', {}, [_c('el-row', {
    staticClass: "grow",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.exportF
    }
  }, [_vm._v(_vm._s(_vm.$t('app_export')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_mechno'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.qmcid),
      callback: function($$v) {
        _vm.qmcid = $$v
      },
      expression: "qmcid"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_terNo'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.qtnid),
      callback: function($$v) {
        _vm.qtnid = $$v
      },
      expression: "qtnid"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_trdtype')
    },
    on: {
      "change": _vm.query
    },
    model: {
      value: (_vm.qtype),
      callback: function($$v) {
        _vm.qtype = $$v
      },
      expression: "qtype"
    }
  }, _vm._l((_vm.types), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.tt,
        "value": item.vl
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_trdno'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.qtrid),
      callback: function($$v) {
        _vm.qtrid = $$v
      },
      expression: "qtrid"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', [_c('el-input', {
    attrs: {
      "placeholder": "SN",
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)])], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick,
      "sort-change": _vm.sortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_deviceNo'),
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "accountNo",
      "width": "",
      "label": _vm.$t('app_account')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "traceId",
      "width": "115",
      "label": _vm.$t('app_tradeNo')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "batchId",
      "width": "120",
      "label": _vm.$t('app_batcno')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "amout",
      "width": "",
      "label": _vm.$t('app_amout')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "merchId",
      "width": "",
      "label": _vm.$t('app_mechno')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "ssortable": "custom",
      "prop": "requesTime",
      "width": "176",
      "label": _vm.$t('app_trdtime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "requestDate",
      "width": "100",
      "label": _vm.$t('app_trddate')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "hostagentserialNo",
      "width": "100",
      "label": _vm.$t('app_coretrans')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "referenceNo",
      "width": "100",
      "label": _vm.$t('app_expno')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "authRc",
      "width": "100",
      "label": _vm.$t('app_terNo')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "authRc",
      "width": "100",
      "label": _vm.$t('app_trdtype')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm.typest[scope.row.transType]) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "sortable": "custom",
      "prop": "recordTime",
      "width": "176",
      "label": _vm.$t('app_opetime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "operate",
      "width": "86",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "background": "none"
          }
        }, [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_preview'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (true),
            expression: "true"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.viewpic(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-file-image-o"
        })])], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 999 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ae"
    }
  }, [_c('div', {
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "width": "140px",
      "height": "140px",
      "margin": "24px 24px 24px 24px",
      "display": "inline-block",
      "float": "left",
      "overflow": "hidden"
    }
  }, [_c('div', {
    style: (_vm.avtStyle)
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "calc(100% - 188px)",
      "height": "100%",
      "margin-bottom": "0px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-appmain",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.config ?
    _vm.config.data.appName : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "60px"
    }
  }, [_c('table', {
    staticClass: "dt-app-app"
  }, [_c('tr', [_c('td', [_c('label', {
    staticClass: "dt-word-apptt"
  }, [_vm._v(_vm._s(_vm.$t('app_appName')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-appmain"
  }, [_vm._v(_vm._s(_vm.app_detail ? _vm.app_detail.appName : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-apptt"
  }, [_vm._v(_vm._s(_vm.$t('psp_app_version')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-appmain"
  }, [_vm._v(_vm._s(_vm.app_detail ? _vm.app_detail.appVersion : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-apptt"
  }, [_vm._v(_vm._s(_vm.$t('app_ulTime')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-appmain"
  }, [_vm._v(_vm._s(_vm.app_detail ? _vm.app_detail.createTime : ''))])]), _vm._v(" "), _c('td')]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-height": "60px",
      "display": "-webkit-flex"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder gTopMg"
  }, [_c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('div', {}, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.open_push
    }
  }, [_vm._v(_vm._s(_vm.$t('app_adddv')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addTer
    }
  }, [_vm._v(_vm._s(_vm.$t('app_fileImport')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "icon": "",
      "size": "",
      "disabled": _vm.multipleSelection.length == 0
    },
    on: {
      "click": _vm.batchDeleteRow
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.batch_delete')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "icon": "",
      "size": ""
    },
    on: {
      "click": _vm.delete_all
    }
  }, [_vm._v(_vm._s(_vm.$t('app_allDel')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_terNo'),
      "icon": "search",
      "on-icon-click": _vm.getUnstallList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getUnstallList($event)
      }
    },
    model: {
      value: (_vm.uninsatll_form.terminalNo),
      callback: function($$v) {
        _vm.$set(_vm.uninsatll_form, "terminalNo", $$v)
      },
      expression: "uninsatll_form.terminalNo"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('MechanismSelector', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mechanismDatas
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    ref: "multipleTables",
    staticClass: "tbPoint gTopMg",
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "data": _vm.uninstallData,
      "border": ""
    },
    on: {
      "row-click": function($event) {},
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "ternimalNo",
      "label": _vm.$t('app_terNo'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "updateStatus",
      "width": "",
      "label": _vm.$t('app_termin_status')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.updateStatus == 0) ? _c('span', [_vm._v(_vm._s(_vm.$t('app_wite_update')))]) : _vm._e(), _vm._v(" "), (scope.row.updateStatus == 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('app_Update_successfully')))]) : _vm._e(), _vm._v(" "), (scope.row.updateStatus == 2) ? _c('span', [_vm._v(_vm._s(_vm.$t('app_Update_failure')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "updateTime",
      "width": "175",
      "label": _vm.$t('app_udtime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "operate",
      "width": "106",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteApps(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.uninsatll_form.page,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.uninsatll_form.rows,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.uninstallTotal
    },
    on: {
      "current-change": _vm.pageSelectUn,
      "size-change": _vm.pageSizedUn
    }
  })], 1)], 1)])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_adddv'),
      "size": ""
    },
    on: {
      "close": _vm.handleClose
    },
    model: {
      value: (_vm.show_push),
      callback: function($$v) {
        _vm.show_push = $$v
      },
      expression: "show_push"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.device_loading),
      expression: "device_loading"
    }],
    staticClass: "gBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-row', {}, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary",
      "disabled": _vm.select_device.length == 0
    },
    on: {
      "click": _vm.bcPush
    }
  }, [_vm._v(_vm._s(_vm.$t('app_pushsldev')))])], 1)], 1), _vm._v(" "), _c('el-row', {}, [_c('el-col', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    },
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "gSideCtrl",
    staticStyle: {
      "margin-right": "8px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_start_no'),
      "icon": "search",
      "on-icon-click": _vm.get_device_list
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.get_device_list($event)
      }
    },
    model: {
      value: (_vm.select_form.snBegin),
      callback: function($$v) {
        _vm.$set(_vm.select_form, "snBegin", $$v)
      },
      expression: "select_form.snBegin"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gSideCtrl",
    staticStyle: {
      "margin-left": "0",
      "margin-right": "0"
    }
  }, [_vm._v("\n\t\t\t\t\t\t~\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_end_no'),
      "icon": "search",
      "on-icon-click": _vm.get_device_list
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.get_device_list($event)
      }
    },
    model: {
      value: (_vm.select_form.snEnd),
      callback: function($$v) {
        _vm.$set(_vm.select_form, "snEnd", $$v)
      },
      expression: "select_form.snEnd"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "offset": 0,
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.getCmDv
    },
    model: {
      value: (_vm.select_form.terminal_status),
      callback: function($$v) {
        _vm.$set(_vm.select_form, "terminal_status", $$v)
      },
      expression: "select_form.terminal_status"
    }
  }, _vm._l((_vm.sstatusAr), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "offset": 0,
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('MechanismSelector', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_terNo'),
      "icon": "search",
      "on-icon-click": _vm.get_device_list
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.get_device_list($event)
      }
    },
    model: {
      value: (_vm.select_form.terminal_no),
      callback: function($$v) {
        _vm.$set(_vm.select_form, "terminal_no", $$v)
      },
      expression: "select_form.terminal_no"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "dpTable",
      "data": _vm.deviceList,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChangeDevice
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalNo",
      "align": "center",
      "label": _vm.$t('app_terNo'),
      "width": "210"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "210"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalStatus",
      "formatter": _vm.mkDvSt,
      "label": _vm.$t('app_status'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": "210"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "106"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.send'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.pushed(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.select_form.page,
      "page-sizes": [20, 100],
      "page-size": _vm.select_form.rows,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.deviceTotal
    },
    on: {
      "current-change": _vm.pageSelectDevice,
      "size-change": _vm.pageSizedDevice
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_fipush')
    },
    on: {
      "close": _vm.closeImport
    },
    model: {
      value: (_vm.pushImport),
      callback: function($$v) {
        _vm.pushImport = $$v
      },
      expression: "pushImport"
    }
  }, [_c('el-form', {
    attrs: {
      "model": "",
      "rules": ""
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_ulfile'),
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "name": "fileUpload",
      "action": _vm.ulurl(),
      "on-remove": _vm.beforeRemove,
      "before-upload": _vm.srcBefore,
      "on-success": _vm.srcSuccess,
      "on-error": _vm.ulError,
      "file-list": _vm.fileList
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v(_vm._s(_vm.$t('app_clickUpdate')))]), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-left": "8px",
      "margin-right": "10px"
    },
    attrs: {
      "href": _vm.downTpl
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "size": "small"
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.list.import_muban')))])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_deviceNum'),
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.uldata ? _vm.uldata.terNums : 0 + _vm.$t('app_amechine')) + "\n\t\t\t")])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.pushImport = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitUpload
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.$t('app_srpush')) + "\n\t\t\t")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])
}]}

/***/ }),
/* 1000 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ae"
    }
  }, [_c('div', {
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "width": "140px",
      "height": "140px",
      "margin": "24px 24px 24px 24px",
      "display": "inline-block",
      "float": "left",
      "overflow": "hidden"
    }
  }), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "calc(100% - 188px)",
      "height": "100%",
      "margin-bottom": "0px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.data.appName : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "60px"
    }
  }, [_c('table', {
    staticClass: "dt-app"
  }, [_c('tr', [_c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_version')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.data.appVersion : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_verTag')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.data.versioncode : ''))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_appType')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config.data.appCategoryName))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_package')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.data.packagename : ''))])]), _vm._v(" "), _c('td')])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-height": "60px",
      "display": "-webkit-flex"
    }
  }, [_c('div', {
    staticClass: "dt-word-title",
    staticStyle: {
      "display": "inline-block",
      "min-width": "70px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('app_introl')) + "：\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "dt-word-main",
    staticStyle: {
      "display": "inline-block",
      "position": "relative",
      "background": "none",
      "margin": "0 24px 24px 0"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.config.data.appDesc))])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.captures ? _vm.captures.length > 0 : false),
      expression: "captures? captures.length > 0 : false"
    }],
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gCtColor  gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_screenShot')) + " ")]), _vm._v(" "), _c('div', _vm._l((_vm.captures), function(item) {
    return _c('img', {
      staticClass: "gBorder",
      staticStyle: {
        "width": "180px",
        "height": "320px",
        "margin": "24px 0 24px 24px",
        "border-radius": "4px"
      },
      attrs: {
        "onerror": "this.src='/static/img/df-h.png'",
        "src": _vm.imgFullUrl(item)
      }
    })
  }))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.type === 2 && _vm.config.isHistory),
      expression: "config.type === 2 && config.isHistory"
    }],
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gCtColor gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_hisVer')) + " ")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUploadNew),
      expression: "showUploadNew"
    }],
    staticStyle: {
      "margin": "24px 0 24px 24px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.uploadNew
    }
  }, [_vm._v(_vm._s(_vm.$t('app_ulNew')))]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appName",
      "label": _vm.$t('app_appName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appVersion",
      "width": "",
      "label": _vm.$t('app_version')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appCategoryName",
      "width": "",
      "label": _vm.$t('app_type')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "formatter": _vm.dateFormat,
      "prop": "createTime",
      "width": "170",
      "label": _vm.$t('app_createTime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "",
      "width": "90",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.config.data.isoperation === 0),
            expression: "config.data.isoperation === 0"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteAppHis(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1001 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ae"
    }
  }, [_c('div', {
    staticClass: "gPageBorder"
  }, [_c('el-form', {
    ref: "form",
    staticClass: "gForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-position": "right",
      "label-width": "12.5%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_appName'),
      "prop": "appName"
    }
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }],
    staticClass: "aeMg contentColor"
  }, [_vm._v(_vm._s((_vm.config.data) ? _vm.config.data.appName : ''))]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "aeMg",
    model: {
      value: (_vm.form.appName),
      callback: function($$v) {
        _vm.$set(_vm.form, "appName", $$v)
      },
      expression: "form.appName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('psp_app_version'),
      "prop": "appVersion"
    }
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }],
    staticClass: "aeMg contentColor"
  }, [_vm._v(_vm._s((_vm.config.data) ? _vm.config.data.appVersion : ''))]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "aeMg",
    model: {
      value: (_vm.form.appVersion),
      callback: function($$v) {
        _vm.$set(_vm.form, "appVersion", $$v)
      },
      expression: "form.appVersion"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    attrs: {
      "label": _vm.$t('app_selectApp'),
      "prop": "pspAppUrl"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo aeMg",
    attrs: {
      "data": _vm.uData,
      "drag": "",
      "name": "fileUpload",
      "file-list": _vm.fileList,
      "on-success": _vm.fileUploadSuccess,
      "limit": 1,
      "before-upload": _vm.fileBeforeUpload,
      "action": _vm.fileUploadUrl,
      "on-remove": _vm.handleRemove_1
    }
  }, [_c('span', [(_vm.upinfo_1) ? _c('i', {
    class: _vm.ulinfo.icons[0]
  }) : _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "display": "flex",
      "flex-direction": "column"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload",
    style: (_vm.tipColor_1)
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "140px",
      "margin": "0 auto"
    },
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_reupload')))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.upinfo_1),
      expression: "upinfo_1"
    }],
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.$t('app_ulNormalSt')))])])])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    attrs: {
      "label": _vm.$t('app_certificate_1_psp'),
      "prop": "cer1Url"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo aeMg",
    attrs: {
      "data": _vm.uData,
      "drag": "",
      "name": "fileUpload",
      "file-list": _vm.fileLists,
      "on-success": _vm.fileUploadSuccesss,
      "limit": 1,
      "before-upload": _vm.fileBeforeUpload,
      "action": _vm.fileUploadUrl,
      "on-remove": _vm.handleRemove_2
    }
  }, [_c('span', [(_vm.upinfo_2) ? _c('i', {
    class: _vm.ulinfo.icons[0]
  }) : _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "display": "flex",
      "flex-direction": "column"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload",
    style: (_vm.tipColor_2)
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "140px",
      "margin": "0 auto"
    },
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_reupload')))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.upinfo_2),
      expression: "upinfo_2"
    }],
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.$t('app_ulNormalSt')))])])])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    attrs: {
      "label": _vm.$t('app_certificate_2_psp'),
      "prop": "cer2Url"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo aeMg",
    attrs: {
      "data": _vm.uData,
      "drag": "",
      "name": "fileUpload",
      "file-list": _vm.fileListss,
      "on-success": _vm.fileUploadSuccessss,
      "limit": 1,
      "before-upload": _vm.fileBeforeUpload,
      "action": _vm.fileUploadUrl,
      "on-remove": _vm.handleRemove_3
    }
  }, [_c('span', [(_vm.upinfo_3) ? _c('i', {
    class: _vm.ulinfo.icons[0]
  }) : _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "display": "flex",
      "flex-direction": "column"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload",
    style: (_vm.tipColor_3)
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "140px",
      "margin": "0 auto"
    },
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_reupload')))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.upinfo_3),
      expression: "upinfo_3"
    }],
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.$t('app_ulNormalSt')))])])])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "calc(100% + 20px)",
      "background": "#EAEEFA",
      "height": "1px",
      "margin-left": "-10px"
    }
  }), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "background": "none"
    }
  }, [_c('el-button', {
    staticClass: "aeMg",
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    staticClass: "aeMg",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.uploadApp('form')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_save')))])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    staticClass: "gPageBorder"
  }, [_c('el-form', {
    ref: "form",
    staticClass: "gForm",
    attrs: {
      "label-position": "right",
      "label-width": "12.5%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_appName')
    }
  }, [_c('el-input', {
    staticClass: "aeMg contentColor",
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.appName),
      callback: function($$v) {
        _vm.appName = $$v
      },
      expression: "appName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_udState')
    }
  }, [_c('el-input', {
    staticClass: "aeMg contentColor",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 1000
      }
    },
    model: {
      value: (_vm.appDesc),
      callback: function($$v) {
        _vm.appDesc = $$v
      },
      expression: "appDesc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_selectApp')
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo aeMg",
    attrs: {
      "drag": "",
      "accept": "",
      "name": "fileUpload",
      "file-list": _vm.fileList,
      "on-success": _vm.fileUploadSuccess,
      "before-upload": _vm.fileBeforeUpload,
      "action": _vm.fileUploadUrl
    }
  }, [_c('span', [(_vm.ulinfo.index == 0) ? _c('i', {
    class: _vm.ulinfo.icons[_vm.ulinfo.index]
  }) : _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ulinfo.index == 1),
      expression: "ulinfo.index == 1"
    }],
    class: _vm.ulinfo.icons[_vm.ulinfo.index],
    staticStyle: {
      "color": "#13CE66"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ulinfo.index == 2),
      expression: "ulinfo.index == 2"
    }],
    class: _vm.ulinfo.icons[_vm.ulinfo.index],
    staticStyle: {
      "color": "#FF4949"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "-5px",
      "color": "#8c939d"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_version')) + "：" + _vm._s(_vm.version))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "-10px",
      "color": "#8c939d"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_verTag')) + "：" + _vm._s(_vm.verTag))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "-10px",
      "color": "#8c939d"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_package')) + "：" + _vm._s(_vm.spackage))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_reupload')) + "apk/hap")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ulinfo.index == 0),
      expression: "ulinfo.index == 0"
    }],
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.ulinfo.tip))])])])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "calc(100% + 20px)",
      "background": "#EAEEFA",
      "height": "1px",
      "margin-left": "-10px"
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_distributor'),
      "prop": "appTypeValue"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_type'),
      "prop": "appTypeValue"
    }
  }, [_c('el-cascader', {
    attrs: {
      "expand-trigger": "hover",
      "options": _vm.appTypes,
      "show-all-levels": false
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.appTypeValue),
      callback: function($$v) {
        _vm.appTypeValue = $$v
      },
      expression: "appTypeValue"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_introl'),
      "prop": "appDesc1"
    }
  }, [_c('el-input', {
    staticClass: "aeMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "autosize": {
        minRows: 2,
        maxRows: 10
      },
      "type": "textarea"
    },
    model: {
      value: (_vm.appDesc1),
      callback: function($$v) {
        _vm.appDesc1 = $$v
      },
      expression: "appDesc1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingSm),
      expression: "loadingSm"
    }],
    attrs: {
      "label": _vm.$t('app_icon')
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader aeMg",
    attrs: {
      "accept": "image/*",
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "name": "file",
      "on-success": _vm.handleSmAvatarSuccess,
      "before-upload": _vm.beforeSmAvatarUpload
    }
  }, [(_vm.smImageUrl) ? _c('img', {
    staticClass: "sm-avatar",
    attrs: {
      "src": _vm.smImageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus sm-avatar-uploader-icon"
  })]), _vm._v("\n\t\t\t\t\t  "), _c('label', {
    staticClass: "contentColor"
  }, [_vm._v(_vm._s(_vm.$t('app_iconState')))])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingBig),
      expression: "loadingBig"
    }],
    attrs: {
      "label": _vm.$t('app_larIcon')
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader aeMg",
    attrs: {
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "accept": "image/*",
      "name": "file",
      "on-success": _vm.handleBgAvatarSuccess,
      "before-upload": _vm.beforeBgAvatarUpload
    }
  }, [(_vm.bgImageUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.bgImageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _vm._v("\n\t\t\t\t\t  "), _c('label', {
    staticClass: "contentColor"
  }, [_vm._v(_vm._s(_vm.$t('app_larIconState')))])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading1),
      expression: "loading1"
    }],
    staticStyle: {
      "background": "none"
    },
    attrs: {
      "label": _vm.$t('app_screenShot')
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "15px"
    }
  }, [_c('el-upload', {
    staticClass: "capture",
    staticStyle: {
      "margin-left": "-10px"
    },
    attrs: {
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "accept": "image/*",
      "name": "file",
      "before-upload": _vm.tipBf,
      "on-success": _vm.handleAvatarSuccessCp0
    }
  }, [(_vm.cp0) ? _c('img', {
    staticClass: "avatarF",
    attrs: {
      "src": _vm.cp0
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _c('i', {
    staticClass: "el-icon-delete",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.deleteCapture0()
      }
    }
  }), _vm._v(" "), _c('el-upload', {
    staticClass: "capture",
    attrs: {
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "accept": "image/*",
      "name": "file",
      "before-upload": _vm.tipBf,
      "on-success": _vm.handleAvatarSuccessCp1
    }
  }, [(_vm.cp1) ? _c('img', {
    staticClass: "avatarF",
    attrs: {
      "src": _vm.cp1
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _c('i', {
    staticClass: "el-icon-delete",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.deleteCapture1()
      }
    }
  }), _vm._v(" "), _c('el-upload', {
    staticClass: "capture",
    attrs: {
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "accept": "image/*",
      "name": "file",
      "before-upload": _vm.tipBf,
      "on-success": _vm.handleAvatarSuccessCp2
    }
  }, [(_vm.cp2) ? _c('img', {
    staticClass: "avatarF",
    attrs: {
      "src": _vm.cp2
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _c('i', {
    staticClass: "el-icon-delete",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.deleteCapture2()
      }
    }
  }), _vm._v(" "), _c('el-upload', {
    staticClass: "capture",
    attrs: {
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "accept": "image/*",
      "name": "file",
      "before-upload": _vm.tipBf,
      "on-success": _vm.handleAvatarSuccessCp3
    }
  }, [(_vm.cp3) ? _c('img', {
    staticClass: "avatarF",
    attrs: {
      "src": _vm.cp3
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _c('i', {
    staticClass: "el-icon-delete",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.deleteCapture3()
      }
    }
  }), _vm._v(" "), _c('el-upload', {
    staticClass: "capture",
    attrs: {
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "accept": "image/*",
      "name": "file",
      "before-upload": _vm.tipBf,
      "on-success": _vm.handleAvatarSuccessCp4
    }
  }, [(_vm.cp4) ? _c('img', {
    staticClass: "avatarF",
    attrs: {
      "src": _vm.cp4
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _c('i', {
    staticClass: "el-icon-delete",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.deleteCapture4()
      }
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.uploadApp
    }
  }, [_vm._v(_vm._s(_vm.$t('app_submit')))])], 1)], 1), _c('br')], 1)])
},staticRenderFns: []}

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "background": "white"
    }
  }, [_c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('lin_global.bdsb'),
      "size": ""
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "background": "none",
      "text-align": "left"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_searchTerminal'),
      "icon": "search",
      "on-icon-click": _vm.srchDevice
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srchDevice($event)
      }
    },
    model: {
      value: (_vm.srchValue),
      callback: function($$v) {
        _vm.srchValue = $$v
      },
      expression: "srchValue"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_terNo'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminal_status",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 3) ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_sleep')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.bind'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-chain"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editCf
    }
  }, [_vm._v(_vm._s(_vm.$t('app_editsecrrule')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "gPageBorder gTopMg"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "calc(100% - 48px)",
      "height": "100%",
      "margin-bottom": "0px",
      "background": "none",
      "padding": "0 0px 12px 24px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.keyName : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "22px"
    }
  }, [_c('table', {
    staticClass: "lcpush"
  }, [_c('tr', [_c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_secrdesc')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.memo : ''))])])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gCtColor gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_secrdvlist')) + " ")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "gSgLeftBtn"
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addTer
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.list.add_btn')))])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_type')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.bindVl),
      callback: function($$v) {
        _vm.bindVl = $$v
      },
      expression: "bindVl"
    }
  }, _vm._l((_vm.bindSts), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_name') + ' & ' + _vm.$t('app_number'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.hiss,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_deviceName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "terminalNo",
      "width": "",
      "label": _vm.$t('app_deviceNo')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "mechName",
      "width": "",
      "label": _vm.$t('app_distributor')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "version",
      "formatter": _vm.showBindSt,
      "width": "",
      "label": _vm.$t('app_appconfigst')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "fformatter": "dateFormat",
      "prop": "opeTime",
      "width": "170",
      "label": _vm.$t('app_applytime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "",
      "width": "86",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status != 1),
            expression: "scope.row.status != 1"
          }],
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.unbind(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv",
    staticStyle: {}
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.page,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pageTotal
    },
    on: {
      "current-change": _vm.pageChange,
      "size-change": _vm.pageSize
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('p', {
    staticClass: "gSgLeftBtn"
  }, [_c('el-button', {
    on: {
      "click": _vm.multiBind
    }
  }, [_vm._v(_vm._s(_vm.$t('app_mulPush')) + " (" + _vm._s(_vm.sNum) + ")")])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticStyle: {
      "height": "8px"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.selectStChange
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.stModel), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.label,
        "value": item.vl
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_deviceNo'),
      "icon": "search",
      "on-icon-click": _vm.srch
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srch($event)
      }
    },
    model: {
      value: (_vm.iNo),
      callback: function($$v) {
        _vm.iNo = $$v
      },
      expression: "iNo"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_deviceNo'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalName",
      "align": "center",
      "label": _vm.$t('app_deviceName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminal_status",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_push'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('lin_global.bjwl')
    },
    model: {
      value: (_vm.showEdit),
      callback: function($$v) {
        _vm.showEdit = $$v
      },
      expression: "showEdit"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.name')
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.risk_desc')
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form.desc),
      callback: function($$v) {
        _vm.$set(_vm.form, "desc", $$v)
      },
      expression: "form.desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "background": "none"
    },
    attrs: {
      "label": _vm.$t('lin_global.wllx')
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.wtype),
      callback: function($$v) {
        _vm.wtype = $$v
      },
      expression: "wtype"
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.jwd')))]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.wtype),
      callback: function($$v) {
        _vm.wtype = $$v
      },
      expression: "wtype"
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.city')))]), _vm._v(" "), _c('el-checkbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.wtype == 1),
      expression: "wtype == 1"
    }],
    model: {
      value: (_vm.isProv),
      callback: function($$v) {
        _vm.isProv = $$v
      },
      expression: "isProv"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_onlyprov')))])], 1), _vm._v(" "), (_vm.wtype == 0) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.risk_radius')
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    model: {
      value: (_vm.form.radius),
      callback: function($$v) {
        _vm.$set(_vm.form, "radius", $$v)
      },
      expression: "form.radius"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.danweikm')))])], 2), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('lin_global.weilanshuoming')))])], 1) : _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.cityName')
    }
  }, [(!_vm.isProv) ? _c('el-cascader', {
    attrs: {
      "expand-trigger": "hover",
      "options": _vm.options2,
      "show-all-levels": false
    },
    on: {
      "change": _vm.selEvent2
    },
    model: {
      value: (_vm.form.city),
      callback: function($$v) {
        _vm.$set(_vm.form, "city", $$v)
      },
      expression: "form.city"
    }
  }) : _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('app_select')
    },
    model: {
      value: (_vm.selVl),
      callback: function($$v) {
        _vm.selVl = $$v
      },
      expression: "selVl"
    }
  }, _vm._l((_vm.options2), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showEdit = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit2
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.submit')))])], 1)], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showEdit = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.bjwl')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "gPageBorder gTopMg"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "calc(100% - 48px)",
      "height": "100%",
      "margin-bottom": "0px",
      "background": "none",
      "padding": "0 0px 12px 24px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none",
      "text-align": "left"
    }
  }, [_vm._v(_vm._s(_vm.riskInfo.controlName))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "40px"
    }
  }, [_c('table', {
    attrs: {
      "id": "rsdtb"
    }
  }, [_c('tr', [_c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.wlmc')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main",
    staticStyle: {
      "white-space": "nowrap",
      "text-overflow": "ellipsis",
      "max-width": "70%",
      "height": "14px",
      "overflow": "hidden",
      "display": "inline-block"
    }
  }, [_vm._v(_vm._s(_vm.riskInfo.controlName))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.wllx')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.riskType[_vm.riskInfo.controlType]))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.risk_city')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.riskInfo.city ? _vm.riskInfo.city.split(',')[0] : ''))])]), _vm._v(" "), _c('td')])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-height": "20px"
    }
  }, [_c('table', {
    attrs: {
      "id": "rsdtb"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_wldesc')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.riskInfo.controlDesc))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.bdsb')))]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_c('div', {
    staticClass: "gSgLeftBtn"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addBind
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.tjbd')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.batchUnBind
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.unbindAll')))])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('MechanismSelector', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_terNo'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    staticClass: "gTopMg",
    attrs: {
      "data": _vm.arrdata,
      "border": ""
    },
    on: {
      "sort-change": _vm.sortChange,
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalName",
      "sortable": "custom",
      "label": _vm.$t('lin_global.label_name')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalNo",
      "sortable": "custom",
      "label": _vm.$t('lin_global.label_no'),
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "distributorName",
      "label": _vm.$t('lin_global.label_areaid')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bindingtime",
      "sortable": "custom",
      "label": _vm.$t('terminal.appList.label_time'),
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('lin_global.ope')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.unbind'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.unBind(scope.row.terminalid)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-chain-broken",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 50, 100],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('lin_global.bdsb')
    },
    on: {
      "close": _vm.closeBindAlert
    },
    model: {
      value: (_vm.dialogTopMgVisible),
      callback: function($$v) {
        _vm.dialogTopMgVisible = $$v
      },
      expression: "dialogTopMgVisible"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "gutter": 16
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_c('MechanismSelector', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mechanismData1
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": ""
    },
    on: {
      "change": _vm.statusChange
    },
    model: {
      value: (_vm.tstVl),
      callback: function($$v) {
        _vm.tstVl = $$v
      },
      expression: "tstVl"
    }
  }, _vm._l((_vm.tstatus), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('lin_global.label_no'),
      "icon": "search",
      "on-icon-click": _vm.handleIconClick
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.focusEvent(_vm.handleIconClick)
      }
    },
    model: {
      value: (_vm.input1),
      callback: function($$v) {
        _vm.input1 = $$v
      },
      expression: "input1"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.batchBindRow
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.bindAll')))])], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "2000px"
    },
    attrs: {
      "data": _vm.arrdata1,
      "border": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange1
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalName",
      "label": _vm.$t('lin_global.label_name'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalNo",
      "label": _vm.$t('lin_global.label_no'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('lin_global.status'),
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.new_add')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 3) ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_sleep')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mechName",
      "label": _vm.$t('lin_global.label_areaid'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('lin_global.ope')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.bind'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.bindRow(scope.row.terminalId)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-chain"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "float": "right",
      "margin-bottom": "20px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage1,
      "page-sizes": [10, 50, 100],
      "page-size": _vm.pageSize1,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalRecords1
    },
    on: {
      "size-change": _vm.handleSizeChange1,
      "current-change": _vm.handleCurrentChange1
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "gPageBorder"
  }, [_c('el-row', {
    staticClass: "gTopMg",
    staticStyle: {
      "margin-bottom": "20px",
      "padding": "0 20px 0 20px"
    },
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {}, [_c('MechanismSelector', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('lin_global.label_no'),
      "icon": "search",
      "on-icon-click": _vm.handleIconClick
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.focusEvent(_vm.handleIconClick)
      }
    },
    model: {
      value: (_vm.tno),
      callback: function($$v) {
        _vm.tno = $$v
      },
      expression: "tno"
    }
  })], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "tbPoint",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": _vm.$t('lin_global.loading'),
      "data": _vm.tableData,
      "id": "tableData",
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "110",
      "prop": "id",
      "label": "ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "prop": "accountNo",
      "label": _vm.$t('app_cardno')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "traceId",
      "width": "150",
      "label": _vm.$t('app_trdno'),
      "sshow-overflow-tooltip": "true"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "prop": "batchId",
      "label": _vm.$t('app_batcno'),
      "sshow-overflow-tooltip": "true"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "110",
      "prop": "amout",
      "label": _vm.$t('app_amout')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "prop": "merchId",
      "label": _vm.$t('app_mechno')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "prop": "terminalNo",
      "label": _vm.$t('lin_global.label_no'),
      "sshow-overflow-tooltip": "true"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "175",
      "prop": "requesTime",
      "label": _vm.$t('app_trdtime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "175",
      "prop": "requestDate",
      "label": _vm.$t('app_trddate')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "prop": "hostagentserialNo",
      "label": _vm.$t('app_trdcore')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "155",
      "prop": "referenceNo",
      "label": _vm.$t('app_expno')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "prop": "authRc",
      "label": _vm.$t('app_license')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "prop": "transType",
      "label": _vm.$t('app_trdtype')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "175",
      "prop": "recordTime",
      "label": _vm.$t('app_rectime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200",
      "prop": "faceUrl",
      "label": _vm.$t('app_fpaddrs')
    }
  })], 1), _vm._v(" "), (_vm.total > 0) ? _c('div', {
    staticClass: "gPgDiv",
    attrs: {
      "id": "pagination"
    }
  }, [_c('el-pagination', {
    staticClass: "gPg",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.page,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ae"
    }
  }, [_c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_addPush'),
      "size": "middle"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    staticClass: "gDiaTable",
    staticStyle: {
      "width": "100%",
      "background": "none",
      "text-align": "left"
    }
  }, [_c('span', [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData1
    }
  })], 1), _vm._v(" "), _c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.stModel), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "40%",
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": _vm.$t('app_searchTerminal'),
      "icon": "search",
      "on-icon-click": _vm.srchDevice
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srchDevice($event)
      }
    },
    model: {
      value: (_vm.srchValue),
      callback: function($$v) {
        _vm.srchValue = $$v
      },
      expression: "srchValue"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_terNo'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminal_status",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('tagc', {
          attrs: {
            "tagobj": {
              type: 'terSt',
              vl: scope.row.terminalStatus
            }
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_push'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "size": "small"
    },
    model: {
      value: (_vm.showPic.value),
      callback: function($$v) {
        _vm.$set(_vm.showPic, "value", $$v)
      },
      expression: "showPic.value"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "src": _vm.showPic.data
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowReason),
      expression: "isShowReason"
    }]
  }, [_c('el-alert', {
    staticStyle: {
      "display": "-webkit-flex",
      "margin": "0 0 5px 0"
    },
    attrs: {
      "title": _vm.reason,
      "type": "error",
      "show-icon": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder"
  }, [_c('el-form', {
    ref: "form",
    staticClass: "gForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-position": "right",
      "label-width": "12.5%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_appName'),
      "prop": "appName"
    }
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }],
    staticClass: "aeMg contentColor"
  }, [_vm._v(_vm._s((_vm.config.data) ? _vm.config.data.appName : ''))]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "aeMg",
    model: {
      value: (_vm.form.appName),
      callback: function($$v) {
        _vm.$set(_vm.form, "appName", $$v)
      },
      expression: "form.appName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_introl'),
      "prop": "appDesc"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }]
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "border": "0",
      "height": "100%",
      "background": "none",
      "position": "absolute"
    }
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 1000
      },
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.prdes),
      callback: function($$v) {
        _vm.prdes = $$v
      },
      expression: "prdes"
    }
  })], 1), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "aeMg",
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 9999
      }
    },
    model: {
      value: (_vm.form.appDesc),
      callback: function($$v) {
        _vm.$set(_vm.form, "appDesc", $$v)
      },
      expression: "form.appDesc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_distributor'),
      "prop": "distributorId"
    }
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }],
    staticClass: "aeMg contentColor"
  }, [_vm._v(_vm._s((_vm.config.data) ? _vm.config.data.distributorName : ''))]), _vm._v(" "), _c('MechanismSelector', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_type'),
      "prop": "appTypeValue"
    }
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }],
    staticClass: "aeMg contentColor"
  }, [_vm._v(_vm._s((_vm.config.data) ? _vm.config.data.appCategoryName : ''))]), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon() && _vm.form.distributorId),
      expression: "isShowCommon() && form.distributorId"
    }],
    staticClass: "aeMg",
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_type')
    },
    model: {
      value: (_vm.form.appTypeValue),
      callback: function($$v) {
        _vm.$set(_vm.form, "appTypeValue", $$v)
      },
      expression: "form.appTypeValue"
    }
  }, _vm._l((_vm.appTypes), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowUpdateDesc),
      expression: "isShowUpdateDesc"
    }],
    attrs: {
      "label": _vm.$t('app_udState'),
      "prop": ""
    }
  }, [_c('el-input', {
    staticClass: "aeMg",
    staticStyle: {
      "width": "100%",
      "float": "left"
    },
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 99999
      }
    },
    model: {
      value: (_vm.updateDescContent),
      callback: function($$v) {
        _vm.updateDescContent = $$v
      },
      expression: "updateDescContent"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    attrs: {
      "label": _vm.$t('app_selectApp'),
      "prop": "appUrl"
    }
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }]
  }, [_vm._v(_vm._s(_vm.config ? _vm.makeAppPath() : ''))]), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon() && _vm.form.distributorId),
      expression: "isShowCommon() && form.distributorId"
    }],
    staticClass: "upload-demo aeMg",
    attrs: {
      "data": _vm.uData,
      "drag": "",
      "name": "fileUpload",
      "file-list": _vm.fileList,
      "on-success": _vm.fileUploadSuccess,
      "before-upload": _vm.fileBeforeUpload,
      "action": _vm.fileUploadUrl
    }
  }, [_c('span', [(_vm.ulinfo.index == 0) ? _c('i', {
    class: _vm.ulinfo.icons[_vm.ulinfo.index]
  }) : _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('i', {
    class: _vm.ulinfo.icons[_vm.ulinfo.index],
    style: (_vm.tipColor)
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "-5px",
      "color": "#8c939d"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_version')) + "：" + _vm._s(_vm.form.version))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "-10px",
      "color": "#8c939d"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_verTag')) + "：" + _vm._s(_vm.form.verTag))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "-10px",
      "color": "#8c939d"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_package')) + "：" + _vm._s(_vm.form.packageName))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_reupload')) + "apk/hap")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ulinfo.index == 0),
      expression: "ulinfo.index == 0"
    }],
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.ulinfo.tip))])])])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "calc(100% + 20px)",
      "background": "#EAEEFA",
      "height": "1px",
      "margin-left": "-10px"
    }
  }), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingSm),
      expression: "loadingSm"
    }],
    attrs: {
      "label": _vm.$t('app_icon'),
      "prop": "smImageUrlValue"
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }],
    staticClass: "aeMg",
    staticStyle: {
      "width": "72px",
      "height": "72px"
    },
    attrs: {
      "src": _vm.sIcon
    }
  }), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "avatar-uploader aeMg",
    attrs: {
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "name": "file",
      "on-success": _vm.handleSmAvatarSuccess,
      "before-upload": _vm.beforeSmAvatarUpload
    }
  }, [(_vm.smImageUrl) ? _c('img', {
    staticClass: "sm-avatar",
    attrs: {
      "src": _vm.smImageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus sm-avatar-uploader-icon"
  })]), _vm._v("\n\t\t\t\t\t  "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "contentColor"
  }, [_vm._v(_vm._s(_vm.$t('app_iconState')))])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingBig),
      expression: "loadingBig"
    }],
    attrs: {
      "label": _vm.$t('app_larIcon'),
      "prop": "bgImageUrlValue"
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }],
    staticClass: "aeMg",
    staticStyle: {
      "width": "120px",
      "height": "120px"
    },
    attrs: {
      "src": _vm.bIcon
    },
    on: {
      "click": _vm.showBigPic
    }
  }), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "avatar-uploader aeMg",
    attrs: {
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "name": "file",
      "on-success": _vm.handleBgAvatarSuccess,
      "before-upload": _vm.beforeBgAvatarUpload
    }
  }, [(_vm.bgImageUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.bgImageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _vm._v("\n\t\t\t\t\t  "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "contentColor"
  }, [_vm._v(_vm._s(_vm.$t('app_larIconState')))])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.type !== 3 || _vm.path),
      expression: "config.type!==3 || path"
    }, {
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading1),
      expression: "loading1"
    }],
    attrs: {
      "label": _vm.$t('app_screenShot'),
      "prop": "caps"
    }
  }, [_vm._l((_vm.captures), function(path, index) {
    return _c('div', {
      staticStyle: {
        "float": "left",
        "margin-left": "10px"
      },
      attrs: {
        "id": "aeCpDiv"
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isShowCommon(1)),
        expression: "isShowCommon(1)"
      }],
      staticClass: "cImg",
      attrs: {
        "src": _vm.imgFullUrl(path)
      },
      on: {
        "click": function($event) {
          _vm.showScreenShot(path, index)
        }
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "none",
      "text-align": "left",
      "padding": "0 0 0 15px"
    },
    attrs: {
      "id": "aeCap"
    }
  }, [_c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "capture",
    staticStyle: {
      "margin-left": "-10px"
    },
    attrs: {
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "name": "file",
      "before-upload": _vm.tipBf,
      "on-success": _vm.handleAvatarSuccessCp0
    }
  }, [_c('div', {
    staticStyle: {
      "display": "-webkit-flex",
      "justify-content": "center",
      "align-items": "center",
      "clear": "both"
    }
  }, [(_vm.cp0) ? _c('img', {
    staticClass: "avatarF",
    attrs: {
      "src": _vm.cp0
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])]), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "el-icon-delete",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.deleteCapture0()
      }
    }
  }), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "capture",
    attrs: {
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "name": "file",
      "before-upload": _vm.tipBf,
      "on-success": _vm.handleAvatarSuccessCp1
    }
  }, [(_vm.cp1) ? _c('img', {
    staticClass: "avatarF",
    attrs: {
      "src": _vm.cp1
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "el-icon-delete",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.deleteCapture1()
      }
    }
  }), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "capture",
    attrs: {
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "name": "file",
      "before-upload": _vm.tipBf,
      "on-success": _vm.handleAvatarSuccessCp2
    }
  }, [(_vm.cp2) ? _c('img', {
    staticClass: "avatarF",
    attrs: {
      "src": _vm.cp2
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "el-icon-delete",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.deleteCapture2()
      }
    }
  }), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "capture",
    attrs: {
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "name": "file",
      "before-upload": _vm.tipBf,
      "on-success": _vm.handleAvatarSuccessCp3
    }
  }, [(_vm.cp3) ? _c('img', {
    staticClass: "avatarF",
    attrs: {
      "src": _vm.cp3
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "el-icon-delete",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.deleteCapture3()
      }
    }
  }), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "capture",
    attrs: {
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "name": "file",
      "before-upload": _vm.tipBf,
      "on-success": _vm.handleAvatarSuccessCp4
    }
  }, [(_vm.cp4) ? _c('img', {
    staticClass: "avatarF",
    attrs: {
      "src": _vm.cp4
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "el-icon-delete",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.deleteCapture4()
      }
    }
  })], 1)], 2), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.type === 3),
      expression: "config.type === 3"
    }],
    staticStyle: {
      "background": "none",
      "margin-top": "30px"
    },
    attrs: {
      "label": _vm.$t('app_testInstall')
    }
  }, [_c('el-button', {
    staticClass: "aeMg",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.pushInstall
    }
  }, [_vm._v(_vm._s(_vm.$t('app_pushInstall')))])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.type === 3),
      expression: "config.type === 3"
    }],
    staticStyle: {
      "background": "none"
    },
    attrs: {
      "label": _vm.$t('app_isPass')
    }
  }, [_c('el-radio', {
    staticClass: "radio aeMg",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_pass')))]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio aeMg",
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_ban')))])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.radio === '2'),
      expression: "radio === '2'"
    }],
    staticStyle: {
      "background": "none"
    },
    attrs: {
      "label": _vm.$t('app_banReason')
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkDesc),
      expression: "checkDesc"
    }],
    staticStyle: {
      "width": "100%",
      "height": "60px",
      "float": "left"
    },
    domProps: {
      "value": (_vm.checkDesc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.checkDesc = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticStyle: {
      "background": "none"
    }
  }, [_c('el-button', {
    staticClass: "aeMg",
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    staticClass: "aeMg",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.uploadApp('form')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_save')))])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.type === 3),
      expression: "config.type === 3"
    }],
    staticStyle: {
      "background": "none"
    },
    attrs: {
      "label": ""
    }
  }, [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.verifyPre
    }
  }, [_vm._v(_vm._s(_vm.$t('app_submit')))])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.type === 2 && _vm.config.isHistory),
      expression: "config.type === 2 && config.isHistory"
    }],
    staticStyle: {
      "border-top": "1px solid #8492A6",
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "left",
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_hisVer')) + " ")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUploadNew),
      expression: "showUploadNew"
    }],
    staticStyle: {
      "float": "right",
      "margin-bottom": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.uploadNew
    }
  }, [_vm._v(_vm._s(_vm.$t('app_ulNew')))]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin": "20px 0 20px 0"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appName",
      "label": _vm.$t('app_appName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appVersion",
      "width": "",
      "label": _vm.$t('app_version')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appCategoryName",
      "width": "",
      "label": _vm.$t('app_type')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "formatter": _vm.dateFormat,
      "prop": "createTime",
      "width": "170",
      "label": _vm.$t('app_createTime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "",
      "width": "90",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteAppHis(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_smVerify'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.appStatus !== '1' && scope.row.appStatus !== '2'),
            expression: "scope.row.appStatus !== '1' && scope.row.appStatus !== '2'"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.submitApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-external-link-square"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteAppHis(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('p')], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.type === 3),
      expression: "config.type === 3"
    }]
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showInput
    }
  }, [_vm._v(_vm._s(_vm.$t('app_addmodel')))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick,
      "sort-change": _vm.sortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "modelName",
      "sortable": "custom",
      "label": _vm.$t('app_typeName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "operate",
      "width": "",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_edit'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.edit(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.del(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('lin_global.label_model')
    },
    on: {
      "open": _vm.open,
      "close": _vm.close
    },
    model: {
      value: (_vm.dialogFormVisible),
      callback: function($$v) {
        _vm.dialogFormVisible = $$v
      },
      expression: "dialogFormVisible"
    }
  }, [_c('div', [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label-width": "14.5%",
      "label": _vm.$t('app_typeName')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "14.5%"
    }
  }, [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sure
    }
  }, [_vm._v(_vm._s(_vm.$t('app_sure')))])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "appbind"
    }
  }, [_c('div', {
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "calc(100% - 48px)",
      "height": "100%",
      "margin-bottom": "0px",
      "background": "none",
      "padding": "0 0px 24px 24px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.info ? _vm.info.launchername : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('table', {
    staticClass: "lcpush"
  }, [_c('tr', [_c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_version')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.info ? _vm.info.version : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_verTag')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.info ? _vm.info.versioncode : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_package')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.info ? _vm.info.packagename : ''))])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-height": "10px",
      "display": "-webkit-flex"
    }
  }, [_c('div', {
    staticClass: "dt-word-title",
    staticStyle: {
      "display": "inline-block",
      "min-width": "70px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('app_introl')) + "：\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "dt-word-main",
    staticStyle: {
      "display": "inline-block",
      "position": "relative",
      "background": "none"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.info ? _vm.info.launcherdesc : ''))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder gTopMg",
    attrs: {
      "id": ""
    }
  }, [_c('p', {
    staticClass: "gCtColor gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_pushDevice')))]), _vm._v(" "), _c('el-button', {
    staticClass: "gSgLeftBtn",
    on: {
      "click": _vm.addBind
    }
  }, [_vm._v(_vm._s(_vm.$t('app_addPush')))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.allUnbind()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_bcrecov')) + " (" + _vm._s(_vm.sNum) + ")")]), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "dpTable",
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalName",
      "align": "center",
      "label": _vm.$t('app_deviceName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_deviceNo'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "align": "center",
      "label": _vm.$t('app_pushTime'),
      "width": "175"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "distributorName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "106"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_update'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.isUpdate === '0'),
            expression: "scope.row.isUpdate === '0'"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.updateDv(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-refresh"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_recov'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-history"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.page,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ciframe"
    }
  }, [_c('iframe', {
    attrs: {
      "id": "myiframe",
      "src": _vm.gurl
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.$t('app_tip'),
      "visible": _vm.cerDialogVisible,
      "size": "tiny",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.cerDialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.cerTipMsg))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.cerDialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.pushUploadCer
    }
  }, [_vm._v(_vm._s(_vm.$t('app_uploadCer')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('app_tip'),
      "visible": _vm.cerTipDialogVisible,
      "size": "tiny",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.cerTipDialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.cerTipMsg))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.cerTipDialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_sure')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_addPush'),
      "size": "middle"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dvLoading),
      expression: "dvLoading"
    }]
  }, [_c('div', {
    staticClass: "gDiaTable",
    staticStyle: {
      "width": "100%",
      "background": "none",
      "text-align": "left"
    }
  }, [_c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_distributor')
    },
    on: {
      "change": _vm.selectDvChange
    },
    model: {
      value: (_vm.channelId),
      callback: function($$v) {
        _vm.channelId = $$v
      },
      expression: "channelId"
    }
  }, _vm._l((_vm.channels), function(item) {
    return _c('el-option', {
      key: item.mechanismid,
      attrs: {
        "label": item.mechanismname,
        "value": item.mechanismid
      }
    })
  }))], 1), _vm._v(" "), _c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.selectDvChange
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.stModel), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.label,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "40%",
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": _vm.$t('app_searchTerminal'),
      "icon": "search"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srchDevice($event)
      }
    },
    model: {
      value: (_vm.srchValue),
      callback: function($$v) {
        _vm.srchValue = $$v
      },
      expression: "srchValue"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dvTableData,
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_terNo'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminal_status",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.dvIndex,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.dvTotal
    },
    on: {
      "current-change": _vm.pageDvSelect,
      "size-change": _vm.pageDvSized
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('div', {}, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSgLeftBtn"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_operateType'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryType),
      callback: function($$v) {
        _vm.queryType = $$v
      },
      expression: "queryType"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl",
    staticStyle: {
      "padding-left": "8px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_account'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryAccount),
      callback: function($$v) {
        _vm.queryAccount = $$v
      },
      expression: "queryAccount"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_srchcontent'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryContent),
      callback: function($$v) {
        _vm.queryContent = $$v
      },
      expression: "queryContent"
    }
  })], 1)])], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    staticClass: " gTopMg",
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick,
      "sort-change": _vm.sortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "userNickName",
      "label": _vm.$t('app_operator'),
      "sortable": "custom",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "userName",
      "width": "130",
      "sortable": "custom",
      "label": _vm.$t('app_account')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "type",
      "width": "130",
      "label": _vm.$t('app_operateType')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "userIp",
      "width": "130",
      "label": _vm.$t('app_userip')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "historyContent",
      "width": "",
      "label": _vm.$t('app_opecontent')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "sortable": "custom",
      "prop": "createTime",
      "width": "176",
      "label": _vm.$t('app_opetime')
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "width": "calc(100% - 24px)",
      "height": "100%",
      "background": "none",
      "padding-left": "24px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.launchername : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('table', {
    staticClass: "dt-launch"
  }, [_c('tr', {}, [_c('td', {
    staticStyle: {
      "width": "15%"
    }
  }, [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_version')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.version : ''))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "15%"
    }
  }, [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_verTag')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.versioncode : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_package')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.packagename : ''))])]), _vm._v(" "), _c('td')])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "none",
      "min-height": "10px",
      "display": "-webkit-flex"
    }
  }, [_c('div', {
    staticClass: "dt-word-title",
    staticStyle: {
      "display": "inline-block",
      "min-width": "70px"
    }
  }, [_vm._v("\n          launch" + _vm._s(_vm.$t('app_ss')) + "：\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "dt-word-main",
    staticStyle: {
      "display": "inline-block",
      "position": "relative",
      "background": "none",
      "margin": "0 24px 24px 0"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.config.launcherdesc))])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.captures ? _vm.captures.length > 0 : false),
      expression: "captures? captures.length > 0 : false"
    }],
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gCtColor  gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_screenShot')) + " ")]), _vm._v(" "), _c('div', _vm._l((_vm.captures), function(item) {
    return _c('img', {
      staticClass: "gBorder",
      staticStyle: {
        "width": "180px",
        "height": "320px",
        "margin": "24px 0 24px 24px",
        "border-radius": "4px"
      },
      attrs: {
        "onerror": "this.src='/static/img/df-h.png'",
        "src": _vm.imgFullUrl(item)
      }
    })
  }))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.status === '2'),
      expression: "config.status === '2'"
    }],
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gCtColor gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_hisVer')) + " ")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUploadNew),
      expression: "showUploadNew"
    }],
    staticStyle: {
      "margin": "24px 0 24px 24px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.uploadNew
    }
  }, [_vm._v(_vm._s(_vm.$t('app_ulNew')))]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "launchername",
      "label": 'launcher' + _vm.$t('app_name'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "version",
      "width": "",
      "label": _vm.$t('app_version')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "fformatter": "dateFormat",
      "prop": "uploadtime",
      "width": "170",
      "label": _vm.$t('app_createTime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "",
      "width": "80",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.config.isoperate === 0),
            expression: "config.isoperate === 0"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.delHis(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h1', {
    staticClass: "breadcrumbTitle"
  }, [_vm._v(_vm._s(_vm.currentSelectName))]), _vm._v(" "), _c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.mbRouter), function(item, index) {
    return _c('el-breadcrumb-item', {
      key: index,
      attrs: {
        "to": {
          path: item.path
        }
      }
    }, [_vm._v("\n      " + _vm._s(item.name) + "\n    ")])
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ae"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.edit
    }
  }, [_vm._v(_vm._s(_vm.$t('app_edit')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gCtColor gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_baseInfo')) + " ")]), _vm._v(" "), _c('el-row', {
    staticClass: "gPdTB"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_deviceName')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.terminalName ? _vm.detail.terminalName : '-') + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_deviceNo')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.terminalNo ? _vm.detail.terminalNo : '-') + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_type')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.typeName ? _vm.detail.typeName : '-') + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_model')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.modelName ? _vm.detail.modelName : '-') + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_firm')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.manufName ? _vm.detail.manufName : '-') + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_distributor')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.mechName ? _vm.detail.mechName : '-') + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "calc(100% - 10px)"
    },
    attrs: {
      "label": _vm.$t('app_addres')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.address ? _vm.detail.address : '-') + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.remark')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.memo ? _vm.detail.memo : '-') + "\n\t\t\t\t\t\t")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gCtColor gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_softinfo')) + " ")]), _vm._v(" "), _c('el-row', {
    staticClass: "gPdTB"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.ter_status')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.terminalStatus ? _vm.sstatus[_vm.detail.terminalStatus] : '-') + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('terminal.list.ztgxsj')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.updateTime ? _vm.detail.updateTime : '-') + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_appVer')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.apkVersion ? _vm.detail.apkVersion : '-') + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_srcver')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.resourceVersion ? _vm.detail.resourceVersion : '-') + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('terminal.details.system_version')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.sysVersion ? _vm.detail.sysVersion : '-') + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('terminal.details.system_spversion')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.spVersion ? _vm.detail.spVersion : '-') + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_rots_5')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.mtVersion ? _vm.detail.mtVersion : '-') + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('terminal.details.hard_info')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.hardware ? _vm.detail.hardware : '-') + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('terminal.details.Electric_quantity')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.bat ? _vm.detail.bat : '-') + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "IMEI"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.imei ? _vm.detail.imei : '-') + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('terminal.details.network')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.rssi ? _vm.detail.rssi : '-') + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.dest_status')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.activeStatus ? _vm.detail.activeStatus : '-') + "\n\t\t\t\t\t\t")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('el-row', {
    staticClass: "gPageBorder  gPdTB"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_cardno')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.detail.accountNo) + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_trdno')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.detail.traceId) + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_batcno')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.detail.batchId) + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_amout')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.detail.amout) + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_mechno')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.detail.merchId) + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_no')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.detail.terminalNo) + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_trdtime')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.detail.requesTime) + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_trddate')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.detail.requestDate) + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_trdcore')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.detail.hostagentserialNo) + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_expno')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.detail.referenceNo) + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_license')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.detail.authRc) + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_trdtype')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.detail.transType) + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_rectime')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.detail.recordTime) + "\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder gTopMg gPdTB"
  }, [_c('p', {
    staticClass: "gCtColor  gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_fpaddrs')) + " ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.$host + _vm.detail.faceUrl
    }
  })])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_adddv'),
      "size": ""
    },
    on: {
      "close": _vm.handleClose
    },
    model: {
      value: (_vm.pushdev),
      callback: function($$v) {
        _vm.pushdev = $$v
      },
      expression: "pushdev"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-row', {}, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary",
      "disabled": _vm.multipleTable.length == 0
    },
    on: {
      "click": _vm.bcPush
    }
  }, [_vm._v(_vm._s(_vm.$t('app_pushsldev')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.pushAll()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_pushAll')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.fileImport()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_fileImport')) + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-row', {}, [_c('el-col', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    },
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "gSideCtrl",
    staticStyle: {
      "margin-right": "8px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_start_no'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.snBegin),
      callback: function($$v) {
        _vm.snBegin = $$v
      },
      expression: "snBegin"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gSideCtrl",
    staticStyle: {
      "margin-left": "0",
      "margin-right": "0"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t~\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_end_no'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.snEnd),
      callback: function($$v) {
        _vm.snEnd = $$v
      },
      expression: "snEnd"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "offset": 0,
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.getCmDv
    },
    model: {
      value: (_vm.cmtStatus),
      callback: function($$v) {
        _vm.cmtStatus = $$v
      },
      expression: "cmtStatus"
    }
  }, _vm._l((_vm.cmtStatusArr), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "offset": 0,
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('MechanismSelector', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_terNo'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "dpTable",
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalNo",
      "align": "center",
      "label": _vm.$t('app_terNo'),
      "width": "210"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "210"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalStatus",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "210"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.isNon) ? _c('span', [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('app_enable')) + "\n\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')) + "\n\t\t\t\t\t\t\t\t")]) : _vm._e()], 1) : _c('span', [_c('tagc', {
          attrs: {
            "tagobj": {
              type: 'terSt',
              vl: scope.row.terminalStatus
            }
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": "210"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "106"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.send'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.pushed(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.page,
      "page-sizes": [20, 100],
      "page-size": _vm.ttpage,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_fipush')
    },
    on: {
      "close": _vm.closeImport
    },
    model: {
      value: (_vm.pushImport),
      callback: function($$v) {
        _vm.pushImport = $$v
      },
      expression: "pushImport"
    }
  }, [_c('el-form', {
    ref: "",
    attrs: {
      "model": "",
      "rules": ""
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_ulfile'),
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "name": "fileUpload",
      "action": _vm.importTemplate,
      "on-remove": _vm.handleRemove,
      "before-upload": _vm.srcBefore,
      "on-success": _vm.srcSuccess,
      "on-error": _vm.ulError,
      "file-list": _vm.fileList,
      "auto-upload": true
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v(_vm._s(_vm.$t('app_clickUpdate')))]), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-left": "8px",
      "margin-right": "10px"
    },
    attrs: {
      "href": _vm.downTpl
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "size": "small"
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.list.import_muban')))])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_deviceNum'),
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.uldata ? _vm.uldata.terNums : 0 + _vm.$t('app_amechine')) + "\n\t\t\t\t")])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.pushImport = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "disabled": !_vm.uldata,
      "type": "primary"
    },
    on: {
      "click": _vm.submitUpload
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t('app_srpush')) + "\n\t\t\t\t")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gLeftScCtrl"
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('app_taskType'),
      "clearable": ""
    },
    on: {
      "change": _vm.query
    },
    model: {
      value: (_vm.taskType),
      callback: function($$v) {
        _vm.taskType = $$v
      },
      expression: "taskType"
    }
  }, _vm._l((_vm.missionList), function(item) {
    return _c('el-option', {
      key: item.type,
      attrs: {
        "label": item.name,
        "value": item.type
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gLeftScCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_taskDetail'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.missionName),
      callback: function($$v) {
        _vm.missionName = $$v
      },
      expression: "missionName"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "cmData"
    }
  }, [_c('el-table', {
    staticClass: "gTopMg tbPoint",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "fileName",
      "label": _vm.$t('app_taskDetail'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "version",
      "label": _vm.$t('app_version'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "left",
      "label": _vm.$t('app_taskType'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', [_vm._v(_vm._s(_vm.missionNames[scope.row.taskType]))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "terNums",
      "label": _vm.$t('app_deviceNum'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "successNums",
      "label": _vm.$t('app_success'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "failNums",
      "label": _vm.$t('app_fail'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "otherNums",
      "label": _vm.$t('app_other'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "createTime",
      "label": _vm.$t('app_pushTime'),
      "width": "170"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "label": _vm.$t('app_operate'),
      "width": "106"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_cancelPush'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.cancelPush(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-window-close",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_global.look_detail'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.viewDetail(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-file-text"
        })])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": ""
    },
    on: {
      "open": _vm.open,
      "close": _vm.close
    },
    model: {
      value: (_vm.dialogFormVisible),
      callback: function($$v) {
        _vm.dialogFormVisible = $$v
      },
      expression: "dialogFormVisible"
    }
  }, [_c('div', [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "25%",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_typeName')) + "：")]), _vm._v(" "), _c('td', [_c('el-input', {
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sure
    }
  }, [_vm._v(_vm._s(_vm.$t('app_sure')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.page,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder"
  }, [_c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_inssuccess')
    },
    on: {
      "open": _vm.open,
      "close": _vm.close
    },
    model: {
      value: (_vm.pushDone),
      callback: function($$v) {
        _vm.pushDone = $$v
      },
      expression: "pushDone"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('app_isjtoviewtd') + '?') + " ")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.pushDone = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.jumpNow
    }
  }, [_vm._v(_vm._s(_vm.$t('app_nowjump')))])], 1)]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.bindAll
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.batch_install')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('div', {
    staticClass: "gSpDiv"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('terminal.appBind.place_name'),
      "icon": "search",
      "on-icon-click": _vm.handleIconClick
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.focusEvent(_vm.handleIconClick)
      }
    },
    model: {
      value: (_vm.input),
      callback: function($$v) {
        _vm.input = $$v
      },
      expression: "input"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "appName",
      "label": _vm.$t('terminal.appBind.label_name')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "appVersion",
      "label": _vm.$t('terminal.appBind.label_version')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "appSize",
      "label": _vm.$t('terminal.appBind.label_size')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "80",
      "label": _vm.$t('lin_global.ope')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.install'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bind(scope.row.applicationid, scope.row.appUrl, scope.row.appVersion, scope.row.appName, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-plus-square"
        })])], 1)]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.$t('app_tip'),
      "visible": _vm.cerDialogVisible,
      "size": "tiny",
      "before-close": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.cerDialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.cerTipMsg))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.cerDialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.pushUploadCer
    }
  }, [_vm._v(_vm._s(_vm.$t('app_uploadCer')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('app_tip'),
      "visible": _vm.cerTipDialogVisible,
      "size": "tiny",
      "before-close": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.cerTipDialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.cerTipMsg))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.cerTipDialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_sure')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_addPush'),
      "size": "middle"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dvLoading),
      expression: "dvLoading"
    }]
  }, [_c('div', {
    staticClass: "gDiaTable",
    staticStyle: {
      "width": "100%",
      "background": "none",
      "text-align": "left"
    }
  }, [_c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_distributor')
    },
    on: {
      "change": _vm.selectDvChange
    },
    model: {
      value: (_vm.channelId),
      callback: function($$v) {
        _vm.channelId = $$v
      },
      expression: "channelId"
    }
  }, _vm._l((_vm.channels), function(item) {
    return _c('el-option', {
      key: item.mechanismid,
      attrs: {
        "label": item.mechanismname,
        "value": item.mechanismid
      }
    })
  }))], 1), _vm._v(" "), _c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.selectDvChange
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.stModel), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.label,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "40%",
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": _vm.$t('app_searchTerminal'),
      "icon": "search"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srchDevice($event)
      }
    },
    model: {
      value: (_vm.srchValue),
      callback: function($$v) {
        _vm.srchValue = $$v
      },
      expression: "srchValue"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dvTableData,
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminal_status",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_push'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.dvIndex,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.dvTotal
    },
    on: {
      "current-change": _vm.pageDvSelect,
      "size-change": _vm.pageDvSized
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.jumpToUpload
    }
  }, [_vm._v(_vm._s(_vm.$t('app_addlc')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_lcname'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)])], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    staticClass: "tbPoint",
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick,
      "sort-change": _vm.sortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "sortable": "custom",
      "prop": "launchername",
      "label": 'launcher' + _vm.$t('app_name'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "status",
      "width": "115",
      "label": _vm.$t('app_vStatus')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-label', {
          style: (_vm.getStatus(scope.row.status).style)
        }, [_vm._v(_vm._s(_vm.getStatus(scope.row.status).vl))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "version",
      "width": "",
      "label": _vm.$t('app_newgVer')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "sortable": "custom",
      "prop": "uploadtime",
      "width": "175",
      "fformatter": "dateFormat",
      "label": _vm.$t('app_ulTime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "operate",
      "width": "80",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_verify'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_c('i', {
          staticClass: "fa fa-check-square-o"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "id": "wrap"
    }
  }, [_c('bdialog', {
    attrs: {
      "config": _vm.bconfig
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_helptip'),
      "size": ""
    },
    model: {
      value: (_vm.pushState),
      callback: function($$v) {
        _vm.pushState = $$v
      },
      expression: "pushState"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "840px"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#48576A",
      "font-size": "18px",
      "margin-top": "-6px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_newpsetnewver')))]), _vm._v(" "), _c('p', {
    staticClass: "gTopMg",
    staticStyle: {
      "line-height": "25px"
    }
  }, [_vm._v("    " + _vm._s(_vm.$t('app_newptdetail')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "line-height": "25px"
    }
  }, [_vm._v("    " + _vm._s(_vm.$t('app_newptdetail1')))]), _vm._v(" "), _c('img', {
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.pic1
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.pic2
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.pic3
    }
  })])]), _vm._v(" "), _c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.imgLogo) ? _c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.imgLogo
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "logoTxt"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.$t('lin_global.logoTitle')) + "\n\t\t")])]), _vm._v(" "), _c('el-col', {
    staticClass: "rightbar",
    attrs: {
      "span": 12
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "click"
    },
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link",
    staticStyle: {
      "color": "#fff",
      "cursor": "pointer"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('lin_global.hello')) + ", " + _vm._s(_vm.nickname) + "\n\t\t\t\t\t"), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "m"
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.wdzl')))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "o"
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.tcxt')))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24,
      "id": "container"
    }
  }, [_c('aside', {
    attrs: {
      "id": "aside"
    }
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "default-active": _vm.currentNav,
      "unique-opened": "",
      "router": ""
    },
    on: {
      "open": _vm.handleOpen,
      "close": _vm.handleClose,
      "select": _vm.handleSelect
    }
  }, [_vm._l((_vm.menuList), function(item, index) {
    return (!item.hidden) ? [(!item.leaf && item.children && item.children.length > 0) ? _c('el-submenu', {
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [(item.meta) ? _c('i', {
      class: item.meta.iconCls,
      staticStyle: {
        "margin-right": "10px"
      }
    }) : _vm._e(), _vm._v(_vm._s(item.name) + "\n            ")]), _vm._v(" "), _vm._l((item.children), function(child, index) {
      return (!child.hidden) ? _c('el-menu-item', {
        key: index,
        staticClass: "smn",
        staticStyle: {
          "background": "white"
        },
        attrs: {
          "index": child.path
        }
      }, [_vm._v("\n                " + _vm._s(child.name) + "\n            ")]) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), (item.leaf && item.children.length > 0) ? _c('el-menu-item', {
      attrs: {
        "index": item.children[0].path
      }
    }, [
      [(item.meta) ? _c('i', {
        class: item.meta.iconCls,
        staticStyle: {
          "margin": "0 5px 0 -4px"
        }
      }) : _vm._e(), _vm._v(_vm._s(item.children[0].name) + "\n            ")]
    ], 2) : _vm._e()] : _vm._e()
  })], 2)], 1), _c('section', {
    attrs: {
      "id": "conter"
    }
  }, [_c('div', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('BreadCrumb')], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding-bottom": "24px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('router-view')], 1)], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_push')
    },
    on: {
      "open": _vm.open,
      "close": _vm.close
    },
    model: {
      value: (_vm.pushQs),
      callback: function($$v) {
        _vm.pushQs = $$v
      },
      expression: "pushQs"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('app_ispushf') + '，' + _vm.fileName) + "？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '1'),
      expression: "info.type === '1'"
    }],
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.check1),
      callback: function($$v) {
        _vm.check1 = $$v
      },
      expression: "check1"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_autoscopen')))]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.check2),
      callback: function($$v) {
        _vm.check2 = $$v
      },
      expression: "check2"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_psscandtip')))])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '2'),
      expression: "info.type === '2'"
    }],
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.check1),
      callback: function($$v) {
        _vm.check1 = $$v
      },
      expression: "check1"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_tipud')))]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.check2),
      callback: function($$v) {
        _vm.check2 = $$v
      },
      expression: "check2"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_tipdown')))])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.pushQs = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.surePush
    }
  }, [_vm._v(_vm._s(_vm.$t('app_srpush')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_fipush')
    },
    on: {
      "close": _vm.closeImport
    },
    model: {
      value: (_vm.pushImport),
      callback: function($$v) {
        _vm.pushImport = $$v
      },
      expression: "pushImport"
    }
  }, [_c('el-form', {
    ref: "",
    attrs: {
      "model": "",
      "rules": ""
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_ulfile'),
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "name": "fileUpload",
      "action": _vm.importTemplate,
      "on-remove": _vm.handleRemove,
      "before-upload": _vm.srcBefore,
      "on-success": _vm.srcSuccess,
      "on-error": _vm.ulError,
      "file-list": _vm.fileList,
      "auto-upload": true
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v(_vm._s(_vm.$t('app_clickUpdate')))]), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-left": "8px",
      "margin-right": "10px"
    },
    attrs: {
      "href": _vm.downTpl
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "size": "small"
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.list.import_muban')))])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_deviceNum'),
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n\t\t      " + _vm._s(_vm.uldata ? _vm.uldata.terNums : 0 + _vm.$t('app_amechine')) + "\n\t\t    ")])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '1'),
      expression: "info.type === '1'"
    }],
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.check1),
      callback: function($$v) {
        _vm.check1 = $$v
      },
      expression: "check1"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_autoscopen')))]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.check2),
      callback: function($$v) {
        _vm.check2 = $$v
      },
      expression: "check2"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_psscandtip')))])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '2'),
      expression: "info.type === '2'"
    }],
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.check1),
      callback: function($$v) {
        _vm.check1 = $$v
      },
      expression: "check1"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_tipud')))]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.check2),
      callback: function($$v) {
        _vm.check2 = $$v
      },
      expression: "check2"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_tipdown')))])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.pushImport = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "disabled": !_vm.uldata,
      "type": "primary"
    },
    on: {
      "click": _vm.submitUpload
    }
  }, [_vm._v(_vm._s(_vm.$t('app_srpush')))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_pushAll')
    },
    on: {
      "open": _vm.open,
      "close": _vm.close
    },
    model: {
      value: (_vm.pushAll),
      callback: function($$v) {
        _vm.pushAll = $$v
      },
      expression: "pushAll"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.allMcName))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '1'),
      expression: "info.type === '1'"
    }],
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.check1),
      callback: function($$v) {
        _vm.check1 = $$v
      },
      expression: "check1"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_autoscopen')))]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.check2),
      callback: function($$v) {
        _vm.check2 = $$v
      },
      expression: "check2"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_psscandtip')))])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '2'),
      expression: "info.type === '2'"
    }],
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.check1),
      callback: function($$v) {
        _vm.check1 = $$v
      },
      expression: "check1"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_tipud')))]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.check2),
      callback: function($$v) {
        _vm.check2 = $$v
      },
      expression: "check2"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_tipdown')))])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.pushAll = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.surePushAll
    }
  }, [_vm._v(_vm._s(_vm.$t('app_srpush')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_srpush')
    },
    on: {
      "open": _vm.open,
      "close": _vm.close
    },
    model: {
      value: (_vm.pushAf),
      callback: function($$v) {
        _vm.pushAf = $$v
      },
      expression: "pushAf"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.surePushTip))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.pushAf = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.coverPush('1')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cvpush')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.coverPush('0')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_skpush')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_pssuccess')
    },
    on: {
      "open": _vm.open,
      "close": _vm.close
    },
    model: {
      value: (_vm.pushDone),
      callback: function($$v) {
        _vm.pushDone = $$v
      },
      expression: "pushDone"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('app_isjtoviewtd') + '?') + " ")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.pushDone = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.jumpNow
    }
  }, [_vm._v(_vm._s(_vm.$t('app_nowjump')))])], 1)]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    on: {
      "click": _vm.multiBind
    }
  }, [_vm._v(_vm._s(_vm.$t('app_mulPush')) + " (" + _vm._s(_vm.sNum) + ")")]), _vm._v(" "), _c('el-button', {
    staticClass: "gSgLeftBtn",
    on: {
      "click": function($event) {
        _vm.pushAll = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_allpush')))]), _vm._v(" "), _c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "disabled": false
    },
    on: {
      "click": function($event) {
        _vm.pushImport = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_fipush')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.selectStChange
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.stModel), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.label,
        "value": item.vl
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_deviceNo'),
      "icon": "search",
      "on-icon-click": _vm.srch
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srch($event)
      }
    },
    model: {
      value: (_vm.iNo),
      callback: function($$v) {
        _vm.iNo = $$v
      },
      expression: "iNo"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData1,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange1
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_deviceNo'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalName",
      "align": "center",
      "label": _vm.$t('app_deviceName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminal_status",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 3) ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_sleep')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 4) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_btn.lock')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_push'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate1(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total1
    },
    on: {
      "current-change": _vm.pageSelect1,
      "size-change": _vm.pageSized1
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-aside"
  }, [_c('div', {
    staticClass: "g-crop-image-box"
  }, [_c('div', {
    staticClass: "g-crop-image-principal",
    on: {
      "touchstart": _vm.drag,
      ":mousedown": _vm.drag
    }
  }, [_c('div', {
    staticClass: "image-wrap",
    style: ({
      width: _vm.width + 'px',
      height: _vm.height + 'px',
      left: _vm.left + 'px',
      top: _vm.top + 'px',
      backgroundImage: 'url(' + _vm.src + ')',
      cursor: _vm.isResize ? 'default' : 'move'
    })
  }, [_c('img', {
    ref: "crop-image",
    staticStyle: {
      "width": "0",
      "height": "0"
    },
    attrs: {
      "src": _vm.src
    }
  })]), _vm._v(" "), (!_vm.isResize) ? _c('div', {
    staticClass: "image-mask"
  }, [_c('div', {
    staticClass: "mask top",
    style: ({
      top: 0,
      height: _vm.cropCSS.top + 'px',
      left: 0,
      width: '100%'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "mask bottom",
    style: ({
      bottom: 0,
      top: (_vm.cropCSS.top + _vm.cropCSS.height) + 'px',
      left: 0,
      width: '100%'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "mask left",
    style: ({
      top: _vm.cropCSS.top + 'px',
      height: _vm.cropCSS.height + 'px',
      left: 0,
      width: _vm.cropCSS.left + 'px'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "mask right",
    style: ({
      top: _vm.cropCSS.top + 'px',
      height: _vm.cropCSS.height + 'px',
      left: (_vm.cropCSS.left + _vm.cropCSS.width) + 'px',
      right: 0
    })
  })]) : _vm._e(), _vm._v(" "), (!_vm.isResize) ? _c('div', {
    staticClass: "crop-box",
    style: ({
      top: _vm.cropCSS.top + 'px',
      left: _vm.cropCSS.left + 'px',
      height: _vm.cropCSS.height + 'px',
      width: _vm.cropCSS.width + 'px'
    })
  }, [_c('div', {
    staticClass: "reference-line v"
  }), _vm._v(" "), _c('div', {
    staticClass: "reference-line h"
  }), _vm._v(" "), _c('a', {
    staticClass: "g-resize",
    on: {
      "touchstart": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.resize($event)
      },
      "mousedown": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.resize($event)
      }
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.resize) ? _c('resize-bar', {
    ref: "resizeBar",
    on: {
      "resize": _vm.resizeImage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isRotate) ? _c('rotate-bar', {
    on: {
      "rotate": _vm.rotateImage
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('div', {}, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.jumpToAdd
    }
  }, [_vm._v(_vm._s(_vm.$t('app_addApp')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_appName'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.appName),
      callback: function($$v) {
        _vm.appName = $$v
      },
      expression: "appName"
    }
  })], 1)])], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticClass: "tbPoint gTopMg",
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appName",
      "label": _vm.$t('app_appName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appVersion",
      "label": _vm.$t('psp_app_version'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "createTime",
      "width": "175",
      "label": _vm.$t('app_ulTime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "operate",
      "width": "106",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteApps(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)]), _vm._v(" "), _c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('app_tip'),
      "visible": _vm.cerDialogVisible,
      "size": "tiny",
      "before-close": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.cerDialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.cerTipMsg))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.cerDialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.pushUploadCer
    }
  }, [_vm._v(_vm._s(_vm.$t('app_uploadCer')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('app_tip'),
      "visible": _vm.cerTipDialogVisible,
      "size": "tiny",
      "before-close": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.cerTipDialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.cerTipMsg))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.cerTipDialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_sure')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_addPush'),
      "size": "middle"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dvLoading),
      expression: "dvLoading"
    }]
  }, [_c('div', {
    staticClass: "gDiaTable",
    staticStyle: {
      "width": "100%",
      "background": "none",
      "text-align": "left"
    }
  }, [_c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_distributor')
    },
    on: {
      "change": _vm.selectDvChange
    },
    model: {
      value: (_vm.channelId),
      callback: function($$v) {
        _vm.channelId = $$v
      },
      expression: "channelId"
    }
  }, _vm._l((_vm.channels), function(item) {
    return _c('el-option', {
      key: item.mechanismid,
      attrs: {
        "label": item.mechanismname,
        "value": item.mechanismid
      }
    })
  }))], 1), _vm._v(" "), _c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.selectDvChange
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.stModel), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.label,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "40%",
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": _vm.$t('app_searchTerminal'),
      "icon": "search"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srchDevice($event)
      }
    },
    model: {
      value: (_vm.srchValue),
      callback: function($$v) {
        _vm.srchValue = $$v
      },
      expression: "srchValue"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dvTableData,
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminal_status",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "right",
      "header-align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_push'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.dvIndex,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.dvTotal
    },
    on: {
      "current-change": _vm.pageDvSelect,
      "size-change": _vm.pageDvSized
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('div', {}, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.jumpToUpload
    }
  }, [_vm._v(_vm._s(_vm.$t('app_addfile')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_filetype')
    },
    on: {
      "change": _vm.fileTypeChange
    },
    model: {
      value: (_vm.ftype),
      callback: function($$v) {
        _vm.ftype = $$v
      },
      expression: "ftype"
    }
  }, _vm._l((_vm.ftypes), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_subtype')
    },
    on: {
      "change": function($event) {
        _vm.getList()
      }
    },
    model: {
      value: (_vm.sftype),
      callback: function($$v) {
        _vm.sftype = $$v
      },
      expression: "sftype"
    }
  }, _vm._l((_vm.cmsts), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_name'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)])], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    staticClass: "tbPoint gTopMg",
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick,
      "sort-change": _vm.sortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "sortable": "custom",
      "prop": "fileName",
      "label": _vm.$t('app_filename'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "fileVersion",
      "width": "",
      "label": _vm.$t('app_version')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "fileType",
      "formatter": _vm.setft,
      "width": "115",
      "label": _vm.$t('app_filetype')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "subFileType",
      "formatter": _vm.setsbt,
      "width": "120",
      "label": _vm.$t('app_subtype')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "mechName",
      "width": "",
      "label": _vm.$t('app_distributor')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "fileStatus",
      "width": "115",
      "label": _vm.$t('app_vStatus')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          style: (_vm.getStatus(scope.row.fileStatus).style)
        }, [_vm._v(_vm._s(_vm.getStatus(scope.row.fileStatus).vl))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "createTime",
      "sortable": "custom",
      "width": "175",
      "label": _vm.$t('app_addtime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "right",
      "prop": "operate",
      "width": "122",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "background": "none"
          }
        }, [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.send'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.fileStatus == 2),
            expression: "scope.row.fileStatus == 2"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.pushApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_edit'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: ((scope.row.fileStatus != '1' && scope.row.fileStatus != '2')),
            expression: "(scope.row.fileStatus != '1' && scope.row.fileStatus != '2') "
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.editApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_down'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.downOldApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-download"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_smVerify'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.fileStatus != '1' && scope.row.fileStatus != '2'),
            expression: "scope.row.fileStatus != '1' && scope.row.fileStatus != '2' "
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.submitApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-external-link-square"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (true),
            expression: "true"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tyc"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.$t('app_tip'),
      "visible": _vm.cerDialogVisible,
      "size": "tiny",
      "before-close": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.cerDialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.cerTipMsg))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.cerDialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.pushUploadCer
    }
  }, [_vm._v(_vm._s(_vm.$t('app_uploadCer')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('app_tip'),
      "visible": _vm.cerTipDialogVisible,
      "size": "tiny",
      "before-close": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.cerTipDialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.cerTipMsg))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.cerTipDialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_sure')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_addPush'),
      "size": "middle"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dvLoading),
      expression: "dvLoading"
    }]
  }, [_c('div', {
    staticClass: "gDiaTable",
    staticStyle: {
      "width": "100%",
      "background": "none",
      "text-align": "left"
    }
  }, [_c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_distributor')
    },
    on: {
      "change": _vm.selectDvChange
    },
    model: {
      value: (_vm.channelId),
      callback: function($$v) {
        _vm.channelId = $$v
      },
      expression: "channelId"
    }
  }, _vm._l((_vm.channels), function(item) {
    return _c('el-option', {
      key: item.mechanismid,
      attrs: {
        "label": item.mechanismname,
        "value": item.mechanismid
      }
    })
  }))], 1), _vm._v(" "), _c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.selectDvChange
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.stModel), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.label,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "40%",
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": _vm.$t('app_searchTerminal'),
      "icon": "search"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srchDevice($event)
      }
    },
    model: {
      value: (_vm.srchValue),
      callback: function($$v) {
        _vm.srchValue = $$v
      },
      expression: "srchValue"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dvTableData,
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminal_status",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_push'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.dvIndex,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.dvTotal
    },
    on: {
      "current-change": _vm.pageDvSelect,
      "size-change": _vm.pageDvSized
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.jumpToUpload
    }
  }, [_vm._v(_vm._s(_vm.$t('app_addlc')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_lcname'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)])], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    staticClass: "tbPoint",
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "name",
      "label": _vm.$t('lin_global.risk_name'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "flag",
      "label": _vm.$t('app_filetag'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "status",
      "width": "115",
      "label": _vm.$t('app_vStatus')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-label', {
          style: (_vm.getStatus(scope.row.status).style)
        }, [_vm._v(_vm._s(_vm.getStatus(scope.row.status).vl))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "version",
      "width": "",
      "label": _vm.$t('app_newgVer')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "opeTime",
      "width": "175",
      "fformatter": "dateFormat",
      "label": _vm.$t('app_ulTime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "operate",
      "width": "80",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_verify'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_c('i', {
          staticClass: "fa fa-check-square-o"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showInput
    }
  }, [_vm._v(_vm._s(_vm.$t('app_newapptype')))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick,
      "sort-change": _vm.sortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appClassifyName",
      "sortable": "custom",
      "label": _vm.$t('app_typeName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "operate",
      "width": "",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_edit'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.edit(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.del(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_appType')
    },
    on: {
      "open": _vm.open,
      "close": _vm.close
    },
    model: {
      value: (_vm.dialogFormVisible),
      callback: function($$v) {
        _vm.dialogFormVisible = $$v
      },
      expression: "dialogFormVisible"
    }
  }, [_c('div', [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label-width": "14.5%",
      "label": _vm.$t('app_typeName')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "14.5%"
    }
  }, [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sure
    }
  }, [_vm._v(_vm._s(_vm.$t('app_sure')))])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m_context"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tmcid),
      expression: "tmcid"
    }],
    staticClass: "gCtColor gPTitle",
    staticStyle: {
      "height": "25px",
      "background": "none",
      "margin-top": "-10px",
      "margin-bottom": "20px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_childacmg')) + " ")]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-left": "24px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.add_zeng')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4,
      "offset": _vm.tmcid ? 12 : 8
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": _vm.$t('lin_global.roles_tips')
    },
    on: {
      "change": _vm.roleChange
    },
    model: {
      value: (_vm.roleId),
      callback: function($$v) {
        _vm.roleId = $$v
      },
      expression: "roleId"
    }
  }, _vm._l((_vm.roleList), function(item) {
    return _c('el-option', {
      key: item.roleid,
      attrs: {
        "label": item.rolename,
        "value": item.roleid
      }
    })
  }))], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.tmcid),
      expression: "!tmcid"
    }],
    attrs: {
      "span": 4
    }
  }, [_c('MechanismSelector', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding-right": "24px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('lin_global.nickName') + ' / ' + _vm.$t('app_account'),
      "icon": "search",
      "on-icon-click": _vm.handleIconClick
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.focusEvent(_vm.handleIconClick)
      }
    },
    model: {
      value: (_vm.nickName),
      callback: function($$v) {
        _vm.nickName = $$v
      },
      expression: "nickName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "arrdata",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.arrdata,
      "border": "",
      "element-loading-text": _vm.$t('lin_global.loading')
    },
    on: {
      "sort-change": _vm.sortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "userName",
      "sortable": "custom",
      "label": _vm.$t('lin_global.userName'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nickName",
      "sortable": "custom",
      "label": _vm.$t('lin_global.nickName'),
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phoneNum",
      "label": _vm.$t('lin_global.phoneNum'),
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "limitIp",
      "label": _vm.$t('app_allowiplg'),
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "roleName",
      "label": _vm.$t('lin_global.roleName'),
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mechanismName",
      "label": _vm.$t('lin_global.label_areaid')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userStatus",
      "label": _vm.$t('lin_global.status'),
      "width": "100",
      "formatter": _vm.formatStatus
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "sortable": "custom",
      "label": _vm.$t('app_addtime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('lin_global.ope'),
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.bindMfa == '1') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.unbind'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.unbindRow(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-chain-broken"
        })])], 1) : _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "MFA",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.bindRow(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-chain"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.edit'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.editRow(scope.row.userid)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.delete'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.deleteRow(scope.row.userid)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.totalRecords > 0) ? _c('div', {
    staticClass: "page_content"
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 50, 100],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "cclass": "gDia",
      "ttitle": "$t('app_mulfcau')",
      "size": "small"
    },
    on: {
      "open": _vm.bindOpen,
      "close": _vm.closeBind
    },
    model: {
      value: (_vm.isbind),
      callback: function($$v) {
        _vm.isbind = $$v
      },
      expression: "isbind"
    }
  }, [_c('div', {
    attrs: {
      "id": "mfbindfr"
    }
  }, [_c('el-steps', {
    attrs: {
      "space": 310,
      "active": _vm.active,
      "finish-status": "success"
    }
  }, [_c('el-step', {
    attrs: {
      "title": _vm.$t('app_ckidt')
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": _vm.$t('app_istapp')
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": _vm.$t('app_bindmfa')
    }
  })], 1), _vm._v(" "), (_vm.active == 0) ? _c('div', {
    attrs: {
      "id": "mfbind1"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('app_bindsfdv')) + "    " + _vm._s(_vm.$t('lin_global.user'))), _c('label', [_vm._v(_vm._s(_vm.brow.nickName))]), _vm._v(" " + _vm._s(_vm.$t('app_psfwtsstepop')))]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('app_ipaclgpsw')
    },
    model: {
      value: (_vm.mfafm.psw),
      callback: function($$v) {
        _vm.$set(_vm.mfafm, "psw", $$v)
      },
      expression: "mfafm.psw"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.active == 1) ? _c('div', {
    attrs: {
      "id": "mfbind2"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('app_bindsfdv')) + "    " + _vm._s(_vm.$t('lin_global.user'))), _c('label', [_vm._v(_vm._s(_vm.brow.nickName))]), _vm._v(" " + _vm._s(_vm.$t('app_psfwtsstepop')))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('app_phdnalyappggidck')))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('app_ipappstsagidck')))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('app_adappmksagidck')))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('app_afistclnxitbpagiinx')))])]) : _vm._e(), _vm._v(" "), (_vm.active == 2) ? _c('div', {
    attrs: {
      "id": "mfbind3"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('app_bindsfdv')) + "    " + _vm._s(_vm.$t('lin_global.user'))), _c('label', [_vm._v(_vm._s(_vm.brow.nickName))]), _vm._v(_vm._s(_vm.$t('app_psfwtsstepop')))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('app_usalyagidckscqrc6code')))]), _vm._v(" "), _c('div', {
    ref: "mfaqrcode",
    attrs: {
      "id": "mfaqrcode"
    }
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_sixnumb')
    },
    model: {
      value: (_vm.mfafm.code),
      callback: function($$v) {
        _vm.$set(_vm.mfafm, "code", $$v)
      },
      expression: "mfafm.code"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dld),
      expression: "dld"
    }],
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.active > 0) ? _c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": function($event) {
        _vm.stepClick(0)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_lsstep')))]) : _vm._e(), _vm._v(" "), (_vm.active < 2) ? _c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": function($event) {
        _vm.stepClick(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_nxstep')))]) : _vm._e(), _vm._v(" "), (_vm.active == 2) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.bindRqs
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.bind')))]) : _vm._e()], 1)]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.logining),
      expression: "logining"
    }],
    attrs: {
      "cclass": "gDia",
      "title": _vm.$t('lin_btn.unbind'),
      "size": "small"
    },
    on: {
      "close": _vm.closeUnbind
    },
    model: {
      value: (_vm.isunbind),
      callback: function($$v) {
        _vm.isunbind = $$v
      },
      expression: "isunbind"
    }
  }, [_c('div', {
    attrs: {
      "id": "mfunbindfr"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('app_sftkck')) + "    " + _vm._s(_vm.$t('app_ip6codeubac')) + " "), _c('label', [_vm._v(_vm._s(_vm.brow.nickName))])]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('app_plipopenalyappoggidckip6dycd')))]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_sixnumb')
    },
    model: {
      value: (_vm.mfafm.code),
      callback: function($$v) {
        _vm.$set(_vm.mfafm, "code", $$v)
      },
      expression: "mfafm.code"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.unbindOpe
    }
  }, [_vm._v(_vm._s(_vm.$t('app_sure')))])], 1)])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m_context plr"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "id": "addForm",
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "12.5%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.certificateName'),
      "prop": "certificateName"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "userName",
      "placeholder": _vm.$t('lin_global.bitian')
    },
    model: {
      value: (_vm.form.certificateName),
      callback: function($$v) {
        _vm.$set(_vm.form, "certificateName", $$v)
      },
      expression: "form.certificateName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.guojia'),
      "prop": "country"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "nickName",
      "placeholder": _vm.$t('lin_global.guojiatips')
    },
    model: {
      value: (_vm.form.country),
      callback: function($$v) {
        _vm.$set(_vm.form, "country", $$v)
      },
      expression: "form.country"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.shengfen'),
      "prop": "province"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "phoneNum",
      "placeholder": _vm.$t('lin_global.shenfentips')
    },
    model: {
      value: (_vm.form.province),
      callback: function($$v) {
        _vm.$set(_vm.form, "province", $$v)
      },
      expression: "form.province"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.city'),
      "prop": "city"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "phoneNum",
      "placeholder": _vm.$t('lin_global.cityTips')
    },
    model: {
      value: (_vm.form.city),
      callback: function($$v) {
        _vm.$set(_vm.form, "city", $$v)
      },
      expression: "form.city"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.gongsi'),
      "prop": "company"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "phoneNum",
      "placeholder": _vm.$t('lin_global.gongsiTips')
    },
    model: {
      value: (_vm.form.company),
      callback: function($$v) {
        _vm.$set(_vm.form, "company", $$v)
      },
      expression: "form.company"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.youxiang'),
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "phoneNum",
      "placeholder": _vm.$t('lin_global.emailTips')
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.youxiaoqi'),
      "prop": "termTime"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "phoneNum",
      "placeholder": _vm.$t('lin_global.youxiaoqiTips')
    },
    model: {
      value: (_vm.form.termTime),
      callback: function($$v) {
        _vm.$set(_vm.form, "termTime", $$v)
      },
      expression: "form.termTime"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.danweitian')))])], 2)], 1), _vm._v(" "), (_vm.showsManufacturerCert) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.certTypeLabel'),
      "required": ""
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.certificateType),
      callback: function($$v) {
        _vm.$set(_vm.form, "certificateType", $$v)
      },
      expression: "form.certificateType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": '1'
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.certForCustomer')))]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '2'
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.certForManufacturer')))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.certificateType == 1) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_areaid'),
      "prop": "distributorId"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData,
      "mselect": true,
      "classs": 'w_33'
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.remark')
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('lin_global.xuantian')
    },
    model: {
      value: (_vm.form.certificateDesc),
      callback: function($$v) {
        _vm.$set(_vm.form, "certificateDesc", $$v)
      },
      expression: "form.certificateDesc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "id": "onCancel"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isSubmit
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.xinjian')))])], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ae"
    }
  }, [_c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_addPush'),
      "size": "middle"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    staticClass: "gDiaTable",
    staticStyle: {
      "width": "100%",
      "background": "none",
      "text-align": "left"
    }
  }, [_c('span'), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticStyle: {
      "margin-right": "16px"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.sstatusAr), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "40%",
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": _vm.$t('app_searchTerminal'),
      "icon": "search"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srchDevice($event)
      }
    },
    model: {
      value: (_vm.srchValue),
      callback: function($$v) {
        _vm.srchValue = $$v
      },
      expression: "srchValue"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dLoading),
      expression: "dLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_terNo'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "align": "center",
      "formatter": _vm.setSt,
      "label": _vm.$t('app_status'),
      "width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_push'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_banReason')
    },
    model: {
      value: (_vm.notPassDialog),
      callback: function($$v) {
        _vm.notPassDialog = $$v
      },
      expression: "notPassDialog"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_reason'),
      "label-width": "14%"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.notPassDialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.verifyRqs('3')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_submit')))])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "gPageBorder "
  }, [_c('p', {
    staticClass: "gCtColor gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_baseInfo')) + " ")]), _vm._v(" "), _c('el-row', {
    staticClass: "gPdTB"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "15%"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "calc(100% - 10px)"
    },
    attrs: {
      "label": _vm.$t('app_srcname')
    }
  }, [_vm._v("\n                " + _vm._s(_vm.config ? _vm.config.name : '') + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "15%"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "calc(100% - 10px)"
    },
    attrs: {
      "label": _vm.$t('lin_global.risk_desc')
    }
  }, [_vm._v("\n                " + _vm._s(_vm.config ? _vm.config.memo : '') + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_newgVer')
    }
  }, [_vm._v("\n            " + _vm._s(_vm.config ? _vm.config.version : '') + "\n          ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "MD5"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.config ? _vm.config.hashCode : '') + "\n          ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_distributor')
    }
  }, [_vm._v("\n            " + _vm._s(_vm.config ? _vm.config.mechanismName : '') + "\n          ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_fileSize')
    }
  }, [_vm._v("\n            " + _vm._s(_vm.config ? (_vm.config.size / 1000000).toFixed(2) : '') + "MB\n          ")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "none",
      "padding": "0 0px 24px 0px",
      "margin-left": "20px"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.$router.go(-1);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.verify('2')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_psverify')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.verify('3')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_ban')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_pushInstallTest')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.downf()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_downfile')))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ae"
    }
  }, [_c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_addPush'),
      "size": "middle"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    staticClass: "gDiaTable",
    staticStyle: {
      "width": "100%",
      "background": "none",
      "text-align": "left"
    }
  }, [_c('span'), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticStyle: {
      "margin-right": "16px"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.sstatusAr), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "40%",
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": _vm.$t('app_searchTerminal'),
      "icon": "search"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srchDevice($event)
      }
    },
    model: {
      value: (_vm.srchValue),
      callback: function($$v) {
        _vm.srchValue = $$v
      },
      expression: "srchValue"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dLoading),
      expression: "dLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_terNo'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "align": "center",
      "formatter": _vm.setSt,
      "label": _vm.$t('app_status'),
      "width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_push'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_banReason')
    },
    model: {
      value: (_vm.notPassDialog),
      callback: function($$v) {
        _vm.notPassDialog = $$v
      },
      expression: "notPassDialog"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_reason'),
      "label-width": "14%"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.notPassDialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.verifyRqs('3')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_submit')))])], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.push()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_addPush')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.downf()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_downfile')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gCtColor gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_baseInfo')) + " ")]), _vm._v(" "), _c('el-row', {
    staticClass: "gPdTB"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "15%"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "calc(100% - 10px)"
    },
    attrs: {
      "label": _vm.$t('app_srcname')
    }
  }, [_vm._v("\n                " + _vm._s(_vm.config ? _vm.config.name : '') + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "15%"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "calc(100% - 10px)"
    },
    attrs: {
      "label": _vm.$t('lin_global.risk_desc')
    }
  }, [_vm._v("\n                " + _vm._s(_vm.config ? _vm.config.memo : '') + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_newgVer')
    }
  }, [_vm._v("\n            " + _vm._s(_vm.config ? _vm.config.version : '') + "\n          ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "MD5"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.config ? _vm.config.hashCode : '') + "\n          ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_distributor')
    }
  }, [_vm._v("\n            " + _vm._s(_vm.config ? _vm.config.mechanismName : '') + "\n          ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_fileSize')
    }
  }, [_vm._v("\n            " + _vm._s(_vm.config ? (_vm.config.size / 1000000).toFixed(2) : '') + "MB\n          ")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.rdata) ? _c('div', {
    staticClass: "page_content"
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.rdata.currentPage,
      "page-sizes": _vm.arraySizes,
      "page-size": _vm.rdata.pageSize,
      "layout": _vm.layout,
      "total": _vm.rdata.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-view",
    style: ({
      height: _vm.height + 'px'
    }),
    attrs: {
      "id": "allmap"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m_context",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "rowFr",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "rowa",
    staticStyle: {
      "margin-left": "24px",
      "width": "100%"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "",
      "id": "addTerm",
      "icon": "plus"
    },
    on: {
      "click": _vm.addTerm
    }
  }, [_vm._v(_vm._s(_vm.$t('app_add')) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": !_vm.isAddTerRight,
      "type": "success",
      "icon": "",
      "size": "",
      "id": "importTerm"
    },
    on: {
      "click": function($event) {
        _vm.importTerm()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-square",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('app_imp')))]), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$t('app_rsfivemin'),
      "placement": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": ""
    },
    on: {
      "click": _vm.shuaxin
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('app_refresh')))])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "",
      "size": "",
      "icon": ""
    },
    on: {
      "click": _vm.bcOutputEx
    }
  }, [_vm._v(_vm._s(_vm.$t('app_bcopterinfo')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": _vm.multipleSelection.length == 0,
      "icon": "",
      "size": "",
      "id": "batchDeleteRow"
    },
    on: {
      "click": _vm.batchDeleteRow
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.batch_delete')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": !_vm.isAddTerRight,
      "icon": "",
      "size": "",
      "id": "importTerm"
    },
    on: {
      "click": _vm.open_migration
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t('app_batch_migration')) + "\n\t\t\t\t\t")])], 1)]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('el-col', {
    staticStyle: {
      "margin-left": "16px"
    },
    attrs: {
      "span": 11
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "placeholder": _vm.$t('app_select_timelist')
    },
    on: {
      "change": _vm.statusChange
    },
    model: {
      value: (_vm.select_time_2),
      callback: function($$v) {
        _vm.select_time_2 = $$v
      },
      expression: "select_time_2"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_c('MechanismSelector', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "16px",
      "margin-right": "16px"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": ""
    },
    on: {
      "change": _vm.statusChange
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  }, _vm._l((_vm.options2), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding-right": "4px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('div', [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_searchTerminal'),
      "icon": "search",
      "on-icon-click": _vm.handleIconClick
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.focusEvent(_vm.handleIconClick)
      }
    },
    model: {
      value: (_vm.dvName),
      callback: function($$v) {
        _vm.dvName = $$v
      },
      expression: "dvName"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.arrdata,
      "id": "tp",
      "border": "",
      "element-loading-text": _vm.$t('lin_global.loading')
    },
    on: {
      "selection-change": _vm.handleSelectionChange,
      "row-click": _vm.viewInfo,
      "sort-change": _vm.sortChane
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalName",
      "sortable": "",
      "label": _vm.$t('lin_global.label_name')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalNo",
      "label": _vm.$t('lin_global.label_no'),
      "sortable": "custom",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('lin_global.ter_status'),
      "prop": "terminalStatus",
      "align": "center",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('tagc', {
          attrs: {
            "tagobj": {
              type: 'terSt',
              vl: scope.row.terminalStatus
            }
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mechName",
      "label": _vm.$t('lin_global.label_areaid'),
      "width": "220"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "terminalOnlineTime",
      "label": _vm.$t('terminal.list.ztgxsj'),
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "memo",
      "label": _vm.$t('lin_global.remark'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": _vm.$t('lin_global.ope'),
      "width": "106"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.restart'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "disabled": scope.row.disable,
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.restartRow(scope.row.terminalNo, 'CQ')
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-spinner"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('terminal.details.gj'),
            "placement": "top"
          }
        }, [_c('el-button', {
          style: (_vm.powerIcon(scope.row.disable)),
          attrs: {
            "disabled": scope.row.disable,
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.restartRow(scope.row.terminalNo, 'GJ')
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-power-off"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.delete'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.deleteRow(scope.row.terminalId)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "page_content"
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 50, 100],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "before-close": _vm.exCancel,
      "title": _vm.$t('terminal.list.import_title'),
      "size": "tiny",
      "top": "15%",
      "show-close": !_vm.importIsSubmit
    },
    model: {
      value: (_vm.importTermVisible),
      callback: function($$v) {
        _vm.importTermVisible = $$v
      },
      expression: "importTermVisible"
    }
  }, [_c('el-form', {
    ref: "importForm",
    staticClass: "gDiaTable",
    staticStyle: {
      "background": "none"
    },
    attrs: {
      "model": _vm.importForm,
      "id": "importForm",
      "label-width": "",
      "enctype": "multipart/form-data"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "uploadify",
      "rules": [{
        required: true,
        message: this.$t('lin_global.qxzscwj')
      }]
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "name": "fileUpload",
      "action": _vm.action,
      "file-list": _vm.fileList,
      "on-success": _vm.handleAvatarScucess,
      "auto-upload": false,
      "show-file-list": false,
      "on-change": _vm.beforeUpload
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v(_vm._s(_vm.$t('terminal.list.xqwj')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "disabled": !_vm.exFileName,
      "size": "small",
      "type": "success"
    },
    on: {
      "click": _vm.submitUpload
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.list.qrdr')))]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.$t('terminal.list.excel_tips')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticStyle: {
      "font-size": "13px"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('app_filename')) + ":")]), _vm._v("  "), _c('label', [_vm._v(_vm._s(_vm.exFileName))])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "href": _vm.importTemplate
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.list.import_muban')))])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.importIsSubmit,
      "id": "cancelBtn"
    },
    on: {
      "click": _vm.exCancel
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.cancel')) + "\n\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "before-close": _vm.exCancel_2,
      "title": _vm.$t('app_batch_migration'),
      "size": "tiny",
      "top": "15%",
      "show-close": !_vm.importIsSubmit
    },
    model: {
      value: (_vm.importTermVisible_2),
      callback: function($$v) {
        _vm.importTermVisible_2 = $$v
      },
      expression: "importTermVisible_2"
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.qudaoshangxinxi'),
      "prop": "areaid"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData_2,
      "mselect": true
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_model'),
      "prop": "terminal_model"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "id": "terminal_model",
      "filterable": "",
      "clearable": "",
      "placeholder": _vm.$t('terminal.add.place_model'),
      "disabled": _vm.is_disabled
    },
    model: {
      value: (_vm.ruleForm.terminal_model),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "terminal_model", $$v)
      },
      expression: "ruleForm.terminal_model"
    }
  }, _vm._l((_vm.models), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_type'),
      "prop": "terminal_type"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "id": "terminal_type",
      "filterable": "",
      "clearable": "",
      "placeholder": _vm.$t('terminal.add.place_type'),
      "disabled": _vm.is_disabled
    },
    model: {
      value: (_vm.ruleForm.terminal_type),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "terminal_type", $$v)
      },
      expression: "ruleForm.terminal_type"
    }
  }, _vm._l((_vm.dvTypes), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_manufid'),
      "prop": "manufid"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "id": "terminal_type",
      "filterable": "",
      "clearable": "",
      "placeholder": _vm.$t('terminal.add.place_manufid'),
      "disabled": _vm.is_disabled
    },
    model: {
      value: (_vm.ruleForm.manufid),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "manufid", $$v)
      },
      expression: "ruleForm.manufid"
    }
  }, _vm._l((_vm.firms), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "importForm",
    staticClass: "gDiaTable",
    staticStyle: {
      "background": "none"
    },
    attrs: {
      "model": _vm.importForm,
      "id": "importForm_2",
      "label-width": "",
      "enctype": "multipart/form-data"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "uploadify",
      "rules": [{
        required: true,
        message: this.$t('lin_global.qxzscwj')
      }]
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "name": "fileUpload",
      "action": _vm.action_2,
      "file-list": _vm.fileList,
      "on-success": _vm.handleAvatarScucess,
      "auto-upload": false,
      "show-file-list": false,
      "on-change": _vm.beforeUpload_2
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v(_vm._s(_vm.$t('terminal.list.xqwj')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "disabled": !_vm.exFileName,
      "size": "small",
      "type": "success"
    },
    on: {
      "click": _vm.submitUpload_2
    }
  }, [_vm._v(_vm._s(_vm.$t('app_sure_migration')))]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.$t('terminal.list.excel_tips')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticStyle: {
      "font-size": "13px"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('app_filename')) + ":")]), _vm._v("  "), _c('label', [_vm._v(_vm._s(_vm.exFileName))])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "href": _vm.importTerminal
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.list.import_muban')))])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.importIsSubmit,
      "id": "cancelBtn"
    },
    on: {
      "click": _vm.exCancel_2
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.cancel')) + "\n\t\t\t\t")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "id": ""
    }
  }, [_c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_addPush'),
      "size": "middle"
    },
    model: {
      value: (_vm.showDevice),
      callback: function($$v) {
        _vm.showDevice = $$v
      },
      expression: "showDevice"
    }
  }, [_c('div', {
    staticClass: "gDiaTable",
    staticStyle: {
      "width": "100%",
      "background": "none",
      "text-align": "left"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticStyle: {
      "margin-right": "16px"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.tstChange
    },
    model: {
      value: (_vm.tst),
      callback: function($$v) {
        _vm.tst = $$v
      },
      expression: "tst"
    }
  }, _vm._l((_vm.stModel), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.label,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "40%",
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": _vm.$t('app_searchTerminal'),
      "icon": "search"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srchDevice($event)
      }
    },
    model: {
      value: (_vm.iNo),
      callback: function($$v) {
        _vm.iNo = $$v
      },
      expression: "iNo"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dLoading),
      expression: "dLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableDvData,
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_terNo'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminal_status",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 3) ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_sleep')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_push'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.page,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.dvtotal
    },
    on: {
      "current-change": _vm.pageDvSelect,
      "size-change": _vm.pageDvSized
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "width": "calc(100% - 24px)",
      "height": "100%",
      "background": "none",
      "padding-left": "24px",
      "padding-bottom": "24px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.fileName : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('table', {
    staticClass: "dt-pushing"
  }, [_c('tr', {}, [_c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_version')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.version : ''))])]), _vm._v(" "), _c('td', {}, [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_fileSize')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.size : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_distributor')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.mechanismName : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_createTime')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.createTime : ''))])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "none",
      "min-height": "10px",
      "display": "-webkit-flex"
    }
  }, [_c('div', {
    staticClass: "dt-word-title",
    staticStyle: {
      "display": "inline-block",
      "min-width": "70px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('app_skintro')) + "：\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "dt-word-main",
    staticStyle: {
      "display": "inline-block",
      "position": "relative",
      "background": "none",
      "margin": "0 24px 24px 0"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.detail ? _vm.detail.memo : ''))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder gTopMg"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    on: {
      "click": _vm.allDel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_mulDel')) + " (" + _vm._s(_vm.sNum) + ")")]), _vm._v(" "), _c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.refreshList
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.shuaxin')))]), _vm._v(" "), _c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showDevice = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_appendpush')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 0
    }
  }, [_c('div', {
    staticClass: "gSpDiv"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_deviceName') + '/' + _vm.$t('app_deviceNo'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.tName),
      callback: function($$v) {
        _vm.tName = $$v
      },
      expression: "tName"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.statusVl),
      callback: function($$v) {
        _vm.statusVl = $$v
      },
      expression: "statusVl"
    }
  }, _vm._l((_vm.status), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.name,
        "value": item.vl
      }
    })
  }))], 1)])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "cmData"
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick,
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_deviceName'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          staticStyle: {
            "color": "#409EFF",
            "cursor": "pointer"
          }
        }, [_vm._v(_vm._s(scope.row.terminalName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_deviceNo'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          staticStyle: {
            "color": "#409EFF",
            "cursor": "pointer"
          }
        }, [_vm._v(_vm._s(scope.row.terminalNo))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "progress",
      "label": _vm.$t('app_process'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', [_vm._v(_vm._s(scope.row.data ? scope.row.data.result.progress : scope.row.progress) + " %")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.taskStatus == 3 || scope.row.taskStatus == 5 || scope.row.taskStatus == -3),
            expression: "scope.row.taskStatus == 3 || scope.row.taskStatus == 5 || scope.row.taskStatus == -3  "
          }],
          staticStyle: {
            "color": "green",
            "cursor": "pointer"
          }
        }, [_vm._v(_vm._s(_vm.statusNames[scope.row.taskStatus]))]), _vm._v(" "), _c('label', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.taskStatus == 0),
            expression: "scope.row.taskStatus == 0 "
          }],
          staticStyle: {
            "color": "orange",
            "cursor": "pointer"
          }
        }, [_vm._v(_vm._s(_vm.statusNames[scope.row.taskStatus]))]), _vm._v(" "), _c('label', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.taskStatus == -1 || scope.row.taskStatus == -5 || scope.row.taskStatus == -10),
            expression: "scope.row.taskStatus == -1 || scope.row.taskStatus == -5 || scope.row.taskStatus == -10 "
          }],
          staticStyle: {
            "color": "red",
            "cursor": "pointer"
          }
        }, [_vm._v(_vm._s(_vm.statusNames[scope.row.taskStatus]))]), _vm._v(" "), _c('label', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.taskStatus != -1 && scope.row.taskStatus != 0 && scope.row.taskStatus != 3 && scope.row.taskStatus != -5 && scope.row.taskStatus != -10 && scope.row.taskStatus != 5 && scope.row.taskStatus != -3),
            expression: "scope.row.taskStatus != -1 && scope.row.taskStatus != 0 && scope.row.taskStatus != 3 && scope.row.taskStatus != -5  && scope.row.taskStatus != -10 && scope.row.taskStatus != 5 && scope.row.taskStatus != -3"
          }],
          staticStyle: {
            "color": "gray",
            "cursor": "pointer"
          }
        }, [_vm._v(_vm._s(_vm.statusNames[scope.row.taskStatus]))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_pushTime'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', [_vm._v(_vm._s(scope.row.createTime))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "cancelNums",
      "label": _vm.$t('app_operate'),
      "width": "116"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_pause'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.showBtn(1, scope.row.taskStatus)),
            expression: "showBtn(1, scope.row.taskStatus)"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.downOperate(2, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pause"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_continue'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.showBtn(2, scope.row.taskStatus)),
            expression: "showBtn(2, scope.row.taskStatus)"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.downOperate(1, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-play"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_ccdown'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.showBtn(3, scope.row.taskStatus)),
            expression: "showBtn(3, scope.row.taskStatus)"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.downOperate(3, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-window-close"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_global.chongtui'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.showBtn(4, scope.row.taskStatus)),
            expression: "showBtn(4, scope.row.taskStatus)"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.repush(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-repeat"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.showBtn(0, scope.row.taskStatus)),
            expression: "showBtn(0, scope.row.taskStatus)"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.delRow(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m_context plr"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "id": "addForm",
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "12.5%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.otaName'),
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.version'),
      "prop": "version"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.version),
      callback: function($$v) {
        _vm.$set(_vm.form, "version", $$v)
      },
      expression: "form.version"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#8391a5",
      "font-size": "12px",
      "line-height": "2",
      "margin-top": "4px"
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.verTips1')))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.risk_desc'),
      "prop": "memo"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.memo),
      callback: function($$v) {
        _vm.$set(_vm.form, "memo", $$v)
      },
      expression: "form.memo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.selectWenjian'),
      "prop": "filePath"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "name": "fileUpload",
      "drag": "",
      "action": _vm.action,
      "file-list": _vm.fileList,
      "on-success": _vm.handleAvatarScucess,
      "on-error": _vm.uploadError,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.jwjtdcc'))), _c('em', [_vm._v(_vm._s(_vm.$t('lin_global.djsc')))])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.qsczipwj')))])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_udfiletype'),
      "prop": ""
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.udFileType),
      callback: function($$v) {
        _vm.udFileType = $$v
      },
      expression: "udFileType"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_ttPkg')))]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.udFileType),
      callback: function($$v) {
        _vm.udFileType = $$v
      },
      expression: "udFileType"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_dfPkg')))])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.udFileType == 1),
      expression: "udFileType == 1"
    }],
    attrs: {
      "label": _vm.$t('app_preversion'),
      "prop": "preVersion"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.preVersion),
      callback: function($$v) {
        _vm.$set(_vm.form, "preVersion", $$v)
      },
      expression: "form.preVersion"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#8391a5",
      "font-size": "12px",
      "line-height": "2",
      "margin-top": "4px"
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.verTips')))])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (0),
      expression: "0"
    }],
    attrs: {
      "label": _vm.$t('lin_global.qmzst')
    }
  }, [_c('el-checkbox', {
    on: {
      "change": _vm.check
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.sfsyzdqm')))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.zdqds'),
      "prop": "mechanismId"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData,
      "mselect": true,
      "classs": 'w_33'
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "id": "onCancel"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isSubmit
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.add')))])], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('div', {}, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.toAdd
    }
  }, [_vm._v(_vm._s(_vm.$t('app_addconfig')))]), _vm._v(" "), _c('el-button', {
    staticClass: "gCtrl",
    attrs: {
      "disabled": _vm.configs.length == 0,
      "type": "danger"
    },
    on: {
      "click": _vm.batchDel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_mulDel')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_name'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)])], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticClass: "tbPoint gTopMg",
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick,
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "configName",
      "label": _vm.$t('lin_global.risk_name'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "address",
      "width": "",
      "label": _vm.$t('lin_global.fwqdizhi')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "port",
      "width": "115",
      "label": _vm.$t('lin_global.fwqduankou')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "terminalNum",
      "width": "115",
      "label": _vm.$t('app_deviceNum')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "createTime",
      "width": "176",
      "label": _vm.$t('app_adddate')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "operate",
      "width": "86",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "background": "none"
          }
        }, [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_edit'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (true),
            expression: "true"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.editApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_smVerify'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status == 0 || scope.row.status == 3),
            expression: "scope.row.status == 0 || scope.row.status == 3"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.submitApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-external-link-square"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (true),
            expression: "true"
          }],
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showInput
    }
  }, [_vm._v(_vm._s(_vm.$t('app_newdvtype')))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick,
      "sort-change": _vm.sortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "sortable": "custom",
      "prop": "typeName",
      "label": _vm.$t('app_typeName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "operate",
      "width": "",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_edit'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.edit(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.del(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('lin_global.label_type')
    },
    on: {
      "open": _vm.open,
      "close": _vm.close
    },
    model: {
      value: (_vm.dialogFormVisible),
      callback: function($$v) {
        _vm.dialogFormVisible = $$v
      },
      expression: "dialogFormVisible"
    }
  }, [_c('div', [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label-width": "14.5%",
      "label": _vm.$t('app_typeName')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "14.5%"
    }
  }, [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sure
    }
  }, [_vm._v(_vm._s(_vm.$t('app_sure')))])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-core-image-upload-btn"
  }, [_vm._t("default", [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasImage),
      expression: "!hasImage"
    }],
    staticClass: "g-core-image-upload-form",
    attrs: {
      "method": "post",
      "enctype": "multipart/form-data",
      "action": ""
    }
  }, [_c('input', {
    attrs: {
      "disabled": _vm.uploading,
      "name": _vm.name,
      "multiple": _vm.multiple,
      "type": "file",
      "accept": _vm.inputAccept
    },
    on: {
      "change": _vm.change,
      "dragover": _vm.dragover,
      "dragenter": _vm.dragover,
      "dragleave": _vm.dragleave,
      "dragend": _vm.dragleave,
      "drop": _vm.dragleave
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasImage),
      expression: "hasImage"
    }],
    staticClass: "g-core-image-corp-container"
  }, [_c('crop', {
    ref: "cropBox",
    attrs: {
      "is-resize": _vm.resize && !_vm.crop,
      "ratio": _vm.cropRatio,
      "is-rotate": _vm.rotate
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info-aside"
  }, [_c('p', {
    staticClass: "btn-groups rotate-groups",
    staticStyle: {
      "display": "none"
    }
  }, [_c('button', {
    staticClass: "btn btn-rotate",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.doRotate
    }
  }, [_vm._v("↺")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-reverserotate",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.doReverseRotate
    }
  }, [_vm._v("↻")])]), _vm._v(" "), (_vm.crop) ? _c('p', {
    staticClass: "btn-groups"
  }, [_c('button', {
    staticClass: "btn btn-upload",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.doCrop
    }
  }, [_vm._v(_vm._s(_vm.cropBtn.ok))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.cropBtn.cancel))])]) : _vm._e(), _vm._v(" "), (_vm.resize && !_vm.crop) ? _c('p', {
    staticClass: "btn-groups"
  }, [_c('button', {
    staticClass: "btn btn-upload",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.doResize
    }
  }, [_vm._v(_vm._s(_vm.ResizeBtn.ok))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.ResizeBtn.cancel))])]) : _vm._e()])], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "gPageBorder"
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "24px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4,
      "offset": 16
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_serialnumber'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.select_form.terminalNo),
      callback: function($$v) {
        _vm.$set(_vm.select_form, "terminalNo", $$v)
      },
      expression: "select_form.terminalNo"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "data": _vm.tableData2,
      "id": "tp",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "terminalNo",
      "label": _vm.$t('app_serialnumber')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalModel",
      "label": _vm.$t('lin_global.label_model'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mechName",
      "label": _vm.$t('lin_global.label_areaid')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": _vm.$t('app_authstat'),
      "formatter": _vm.formatStatus,
      "show-overflow-tooltip": true,
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatStatus(scope.row)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "opeUser",
      "label": _vm.$t('app_operator')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "opeTime",
      "width": "176",
      "label": _vm.$t('app_opetime')
    }
  })], 1), _vm._v(" "), (_vm.totalRecords > 0) ? _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 50, 100],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('lin_global.xiafa')
    },
    model: {
      value: (_vm.xiafaVisible),
      callback: function($$v) {
        _vm.xiafaVisible = $$v
      },
      expression: "xiafaVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    staticClass: "gDiaTable",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "22.5%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.certificateName')
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.zhengshu) + "\n\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.qudaoshangxinxi')
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.qudaoshangxinxi) + "\n\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.tslxxx')
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.changeType
    },
    model: {
      value: (_vm.form.pushType),
      callback: function($$v) {
        _vm.$set(_vm.form, "pushType", $$v)
      },
      expression: "form.pushType"
    }
  }, _vm._l((_vm.type), function(item) {
    return _c('el-option', {
      key: item.typeid,
      attrs: {
        "label": item.typename,
        "value": item.typeid
      }
    })
  }))], 1), _vm._v(" "), (_vm.isShow) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_areaid'),
      "prop": "terminalNo"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": _vm.$t('lin_global.place_areaid')
    },
    model: {
      value: (_vm.form.terminalNo),
      callback: function($$v) {
        _vm.$set(_vm.form, "terminalNo", $$v)
      },
      expression: "form.terminalNo"
    }
  }, _vm._l((_vm.areaList), function(item) {
    return _c('el-option', {
      key: item.mechanismid,
      attrs: {
        "label": item.mechanismname,
        "value": item.mechanismid
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (!_vm.isShow) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_no'),
      "prop": "terminalNo"
    }
  }, [_c('AutoTerno', {
    on: {
      "on-result-change": _vm.onDvInputChange
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "margin-right": "74%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.isSubmit
    },
    on: {
      "click": _vm.xiafaSubmit
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t('lin_global.xiafa')) + "\n\t\t\t\t\t")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1041 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goEdit
    }
  }, [_vm._v(_vm._s(_vm.$t('app_editpasg')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "gPageBorder gTopMg"
  }, [_c('el-row', {
    staticClass: "gPdTB"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "17%"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "calc(100% - 10px)"
    },
    attrs: {
      "label": "APPID"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.detail.appid) + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_psgname')
    }
  }, [_vm._v("\n                " + _vm._s(_vm.detail.appname) + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_distributor')
    }
  }, [_vm._v("\n                " + _vm._s(_vm.detail.merchantName) + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_authstat')
    }
  }, [_c('tagc', {
    attrs: {
      "tagobj": {
        type: 'openAuthType',
        vl: _vm.detail.isauthen + ''
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_cbackad')
    }
  }, [_vm._v("\n                " + _vm._s(_vm.detail.callbackurl) + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "17%"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "calc(100% - 10px)"
    },
    attrs: {
      "label": _vm.$t('app_bsrqsadwl')
    }
  }, _vm._l((_vm.detail.limitIp), function(item, index) {
    return _c('el-tag', {
      key: index,
      attrs: {
        "type": "primary"
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "17%"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "calc(100% - 10px)"
    },
    attrs: {
      "label": _vm.$t('app_appwtls')
    }
  }, _vm._l((_vm.detail.packageName), function(item, index) {
    return _c('el-tag', {
      key: index,
      attrs: {
        "type": "primary"
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ae"
    }
  }, [_c('div', {
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "width": "140px",
      "height": "140px",
      "margin": "24px 24px 24px 24px",
      "display": "inline-block",
      "float": "left",
      "overflow": "hidden"
    }
  }, [_c('div', {
    style: (_vm.avtStyle)
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "calc(100% - 188px)",
      "height": "100%",
      "margin-bottom": "0px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-appmain",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.config ?
    _vm.config.data.appName : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "60px"
    }
  }, [_c('table', {
    staticClass: "dt-app-app"
  }, [_c('tr', [_c('td', [_c('label', {
    staticClass: "dt-word-apptt"
  }, [_vm._v(_vm._s(_vm.$t('psp_app_id')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-appmain"
  }, [_vm._v(_vm._s(_vm.app_detail ? _vm.app_detail.appId : '') + "\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-apptt"
  }, [_vm._v(_vm._s(_vm.$t('app_appName')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-appmain"
  }, [_vm._v(_vm._s(_vm.app_detail ? _vm.app_detail.fileName : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-apptt"
  }, [_vm._v(_vm._s(_vm.$t('app_sysType')) + "：")]), _vm._v(" "), (_vm.app_detail.sysType == '0') ? _c('label', {
    staticClass: "dt-word-appmain"
  }, [_vm._v("RTOS")]) : _vm._e(), _vm._v(" "), (_vm.app_detail.sysType == '1') ? _c('label', {
    staticClass: "dt-word-appmain"
  }, [_vm._v("Linux")]) : _vm._e(), _vm._v(" "), (_vm.app_detail.sysType == '2') ? _c('label', {
    staticClass: "dt-word-appmain"
  }, [_vm._v("LiteOS")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-apptt"
  }, [_vm._v(_vm._s(_vm.$t('psp_app_version')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-appmain"
  }, [_vm._v(_vm._s(_vm.app_detail ? _vm.app_detail.appVersion : ''))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticClass: "dt-word-apptt"
  }, [_vm._v(_vm._s(_vm.$t('app_introl')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-appmain"
  }, [_vm._v(_vm._s(_vm.app_detail ? _vm.app_detail.memo : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-apptt"
  }, [_vm._v(_vm._s(_vm.$t('app_ulTime')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-appmain"
  }, [_vm._v(_vm._s(_vm.app_detail ? _vm.app_detail.createTime : ''))])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-height": "60px",
      "display": "-webkit-flex"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gCtColor gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_appUpList')) + " ")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_terminal'),
      "icon": "search",
      "on-icon-click": _vm.getAppList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getAppList($event)
      }
    },
    model: {
      value: (_vm.terminalNo),
      callback: function($$v) {
        _vm.terminalNo = $$v
      },
      expression: "terminalNo"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "10px"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "terminalNo",
      "width": "",
      "label": _vm.$t('app_terminal')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "status",
      "label": _vm.$t('app_status'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('app_success')))]) : _vm._e(), _vm._v(" "), (scope.row.status == 2) ? _c('span', [_vm._v(_vm._s(_vm.$t('mao_global.tip.fail')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "formatter": _vm.dateFormat,
      "prop": "updateTime",
      "label": _vm.$t('app_ulTime')
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  上传厂商证书\n")])
},staticRenderFns: []}

/***/ }),
/* 1044 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gBorder"
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "disabled": _vm.sNum <= 0
    },
    on: {
      "click": function($event) {
        _vm.mulDelAppPush()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_mulUnbind')) + " (" + _vm._s(_vm.sNum) + ")")]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "show-header": "false"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "appName",
      "label": _vm.$t('terminal.appList.label_name')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "packageName",
      "label": _vm.$t('app_package')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "formatter": _vm.formatStatus,
      "label": _vm.$t('terminal.appList.label_type')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "appVersion",
      "label": _vm.$t('terminal.appList.label_version')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "versionCode",
      "label": _vm.$t('app_verTag')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": _vm.$t('terminal.appList.label_time')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "123",
      "align": "center",
      "label": _vm.$t('lin_global.ope')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.ifBind) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.xiezai'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.unbund(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-times-rectangle",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1) : _vm._e(), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_clupappdt'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.type == 0),
            expression: "scope.row.type == 0"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.clearAppData(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-eraser"
        })])], 1)]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-form', {
    ref: "cer",
    staticClass: "gForm",
    attrs: {
      "label-position": "right",
      "rules": _vm.rules,
      "label-width": "12.5%",
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_secrname'),
      "prop": "secretName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.secretName),
      callback: function($$v) {
        _vm.$set(_vm.form, "secretName", $$v)
      },
      expression: "form.secretName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_keyType'),
      "prop": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('app_keyType')
    },
    model: {
      value: (_vm.form.keyType),
      callback: function($$v) {
        _vm.$set(_vm.form, "keyType", $$v)
      },
      expression: "form.keyType"
    }
  }, _vm._l((_vm.keyType_list), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_keyUpIndex'),
      "prop": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('app_keyUpIndex')
    },
    model: {
      value: (_vm.form.encryptionIndex),
      callback: function($$v) {
        _vm.$set(_vm.form, "encryptionIndex", $$v)
      },
      expression: "form.encryptionIndex"
    }
  }, _vm._l((_vm.keyIndex_list), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_keyDlIndex'),
      "prop": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('app_keyDlIndex')
    },
    model: {
      value: (_vm.form.downloadIndex),
      callback: function($$v) {
        _vm.$set(_vm.form, "downloadIndex", $$v)
      },
      expression: "form.downloadIndex"
    }
  }, _vm._l((_vm.keyDown_list), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_Algorithm_mode'),
      "prop": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('app_Algorithm_mode')
    },
    model: {
      value: (_vm.form.algorithmModel),
      callback: function($$v) {
        _vm.$set(_vm.form, "algorithmModel", $$v)
      },
      expression: "form.algorithmModel"
    }
  }, _vm._l((_vm.An_list), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('app_submit')))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1046 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ae"
    }
  }, [_c('div', {
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "width": "140px",
      "height": "140px",
      "margin": "24px 24px 24px 24px",
      "display": "inline-block",
      "float": "left",
      "overflow": "hidden"
    }
  }, [_c('div', {
    style: (_vm.avtStyle)
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "calc(100% - 188px)",
      "height": "100%",
      "margin-bottom": "0px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-appmain",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.config ?
    _vm.config.data.appName : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "60px"
    }
  }, [_c('table', {
    staticClass: "dt-app-app"
  }, [_c('tr', [_c('td', [_c('label', {
    staticClass: "dt-word-apptt"
  }, [_vm._v(_vm._s(_vm.$t('app_appName')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-appmain"
  }, [_vm._v(_vm._s(_vm.app_detail ? _vm.app_detail.appName : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-apptt"
  }, [_vm._v(_vm._s(_vm.$t('psp_app_version')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-appmain"
  }, [_vm._v(_vm._s(_vm.app_detail ? _vm.app_detail.appVersion : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-apptt"
  }, [_vm._v(_vm._s(_vm.$t('app_ulTime')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-appmain"
  }, [_vm._v(_vm._s(_vm.app_detail ? _vm.app_detail.createTime : ''))])]), _vm._v(" "), _c('td')]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-height": "60px",
      "display": "-webkit-flex"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder gTopMg"
  }, [_c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('div', {}, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.open_push
    }
  }, [_vm._v(_vm._s(_vm.$t('app_adddv')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addTer
    }
  }, [_vm._v(_vm._s(_vm.$t('app_fileImport')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "icon": "",
      "size": "",
      "disabled": _vm.multipleSelection.length == 0
    },
    on: {
      "click": _vm.batchDeleteRow
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.batch_delete')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "icon": "",
      "size": ""
    },
    on: {
      "click": _vm.delete_all
    }
  }, [_vm._v(_vm._s(_vm.$t('app_allDel')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_terNo'),
      "icon": "search",
      "on-icon-click": _vm.getUnstallList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getUnstallList($event)
      }
    },
    model: {
      value: (_vm.uninsatll_form.terminalNo),
      callback: function($$v) {
        _vm.$set(_vm.uninsatll_form, "terminalNo", $$v)
      },
      expression: "uninsatll_form.terminalNo"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('MechanismSelector', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mechanismDatas
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    ref: "multipleTables",
    staticClass: "tbPoint gTopMg",
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "data": _vm.uninstallData,
      "border": ""
    },
    on: {
      "row-click": function($event) {},
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "ternimalNo",
      "label": _vm.$t('app_terNo'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "updateStatus",
      "width": "",
      "label": _vm.$t('app_termin_status')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.updateStatus == 0) ? _c('span', [_vm._v(_vm._s(_vm.$t('app_wite_update')))]) : _vm._e(), _vm._v(" "), (scope.row.updateStatus == 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('app_Update_successfully')))]) : _vm._e(), _vm._v(" "), (scope.row.updateStatus == 2) ? _c('span', [_vm._v(_vm._s(_vm.$t('app_Update_failure')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "updateTime",
      "width": "175",
      "label": _vm.$t('app_udtime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "operate",
      "width": "106",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteApps(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.uninsatll_form.page,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.uninsatll_form.rows,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.uninstallTotal
    },
    on: {
      "current-change": _vm.pageSelectUn,
      "size-change": _vm.pageSizedUn
    }
  })], 1)], 1)])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_adddv'),
      "size": ""
    },
    on: {
      "close": _vm.handleClose
    },
    model: {
      value: (_vm.show_push),
      callback: function($$v) {
        _vm.show_push = $$v
      },
      expression: "show_push"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.device_loading),
      expression: "device_loading"
    }],
    staticClass: "gBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-row', {}, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary",
      "disabled": _vm.select_device.length == 0
    },
    on: {
      "click": _vm.bcPush
    }
  }, [_vm._v(_vm._s(_vm.$t('app_pushsldev')))])], 1)], 1), _vm._v(" "), _c('el-row', {}, [_c('el-col', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    },
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "gSideCtrl",
    staticStyle: {
      "margin-right": "8px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_start_no'),
      "icon": "search",
      "on-icon-click": _vm.get_device_list
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.get_device_list($event)
      }
    },
    model: {
      value: (_vm.select_form.snBegin),
      callback: function($$v) {
        _vm.$set(_vm.select_form, "snBegin", $$v)
      },
      expression: "select_form.snBegin"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gSideCtrl",
    staticStyle: {
      "margin-left": "0",
      "margin-right": "0"
    }
  }, [_vm._v("\n\t\t\t\t\t\t~\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_end_no'),
      "icon": "search",
      "on-icon-click": _vm.get_device_list
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.get_device_list($event)
      }
    },
    model: {
      value: (_vm.select_form.snEnd),
      callback: function($$v) {
        _vm.$set(_vm.select_form, "snEnd", $$v)
      },
      expression: "select_form.snEnd"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "offset": 0,
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.getCmDv
    },
    model: {
      value: (_vm.select_form.terminal_status),
      callback: function($$v) {
        _vm.$set(_vm.select_form, "terminal_status", $$v)
      },
      expression: "select_form.terminal_status"
    }
  }, _vm._l((_vm.sstatusAr), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "offset": 0,
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('MechanismSelector', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_terNo'),
      "icon": "search",
      "on-icon-click": _vm.get_device_list
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.get_device_list($event)
      }
    },
    model: {
      value: (_vm.select_form.terminal_no),
      callback: function($$v) {
        _vm.$set(_vm.select_form, "terminal_no", $$v)
      },
      expression: "select_form.terminal_no"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "dpTable",
      "data": _vm.deviceList,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChangeDevice
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalNo",
      "align": "center",
      "label": _vm.$t('app_terNo'),
      "width": "210"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "210"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalStatus",
      "formatter": _vm.mkDvSt,
      "label": _vm.$t('app_status'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": "210"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "106"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.send'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.pushed(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.select_form.page,
      "page-sizes": [20, 100],
      "page-size": _vm.select_form.rows,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.deviceTotal
    },
    on: {
      "current-change": _vm.pageSelectDevice,
      "size-change": _vm.pageSizedDevice
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_fipush')
    },
    on: {
      "close": _vm.closeImport
    },
    model: {
      value: (_vm.pushImport),
      callback: function($$v) {
        _vm.pushImport = $$v
      },
      expression: "pushImport"
    }
  }, [_c('el-form', {
    attrs: {
      "model": "",
      "rules": ""
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_ulfile'),
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "name": "fileUpload",
      "action": _vm.ulurl(),
      "limit": 1,
      "on-remove": _vm.beforeRemove,
      "before-upload": _vm.srcBefore,
      "on-success": _vm.srcSuccess,
      "on-error": _vm.ulError,
      "file-list": _vm.fileList
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v(_vm._s(_vm.$t('app_clickUpdate')))]), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-left": "8px",
      "margin-right": "10px"
    },
    attrs: {
      "href": _vm.downTpl
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "size": "small"
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.list.import_muban')))])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_deviceNum'),
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.uldata ? _vm.uldata.terNums : 0 + _vm.$t('app_amechine')) + "\n\t\t\t")])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.pushImport = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitUpload
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.$t('app_srpush')) + "\n\t\t\t")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])
}]}

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ae"
    }
  }, [_c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.data ? _vm.config.data.auditContent : false),
      expression: "config.data ? config.data.auditContent : false"
    }]
  }, [_c('el-alert', {
    staticStyle: {
      "display": "-webkit-flex",
      "margin": "0 0 5px 0"
    },
    attrs: {
      "title": _vm.reason,
      "type": "error",
      "show-icon": ""
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_addPush'),
      "size": "middle"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    staticClass: "gDiaTable",
    staticStyle: {
      "width": "100%",
      "background": "none",
      "text-align": "left"
    }
  }, [_c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_distributor')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.channelId),
      callback: function($$v) {
        _vm.channelId = $$v
      },
      expression: "channelId"
    }
  }, _vm._l((_vm.channels), function(item) {
    return _c('el-option', {
      key: item.mechanismid,
      attrs: {
        "label": item.mechanismname,
        "value": item.mechanismid
      }
    })
  }))], 1), _vm._v(" "), _c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.stModel), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.label,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "40%",
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": _vm.$t('app_searchTerminal'),
      "icon": "search"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srchDevice($event)
      }
    },
    model: {
      value: (_vm.srchValue),
      callback: function($$v) {
        _vm.srchValue = $$v
      },
      expression: "srchValue"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_terNo'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminal_status",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_push'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "size": "small"
    },
    model: {
      value: (_vm.showPic.value),
      callback: function($$v) {
        _vm.$set(_vm.showPic, "value", $$v)
      },
      expression: "showPic.value"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "src": _vm.showPic.data
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowReason),
      expression: "isShowReason"
    }]
  }, [_c('el-alert', {
    staticStyle: {
      "display": "-webkit-flex",
      "margin": "0 0 5px 0"
    },
    attrs: {
      "title": _vm.reason,
      "type": "error",
      "show-icon": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder"
  }, [_c('el-form', {
    ref: "form",
    staticClass: "gForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-position": "right",
      "label-width": "12.5%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_filename'),
      "prop": "name"
    }
  }, [_c('el-input', {
    staticClass: "aeMg",
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_filedesc'),
      "prop": ""
    }
  }, [_c('el-input', {
    staticClass: "aeMg",
    model: {
      value: (_vm.form.desc),
      callback: function($$v) {
        _vm.$set(_vm.form, "desc", $$v)
      },
      expression: "form.desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_version'),
      "prop": ""
    }
  }, [_c('el-input', {
    staticClass: "aeMg",
    model: {
      value: (_vm.form.ver),
      callback: function($$v) {
        _vm.$set(_vm.form, "ver", $$v)
      },
      expression: "form.ver"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isbase),
      expression: "isbase"
    }],
    attrs: {
      "label": _vm.$t('app_preversion'),
      "prop": _vm.isbase ? _vm.bver : ''
    }
  }, [_c('el-input', {
    staticClass: "aeMg",
    model: {
      value: (_vm.form.bver),
      callback: function($$v) {
        _vm.$set(_vm.form, "bver", $$v)
      },
      expression: "form.bver"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "label": _vm.$t('app_ulfile'),
      "prop": "url"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo aeMg",
    attrs: {
      "data": _vm.uData,
      "drag": "",
      "name": "fileUpload",
      "file-list": _vm.fileList,
      "on-success": _vm.fileUploadSuccess,
      "before-upload": _vm.fileBeforeUpload,
      "action": _vm.fileUploadUrl
    }
  }, [_c('span', [(_vm.ulinfo.index === 0) ? _c('i', {
    class: _vm.ulinfo.icons[_vm.ulinfo.index]
  }) : _c('div', {
    staticStyle: {
      "margin-top": "22px",
      "color": "#48576A"
    }
  }, [_c('i', {
    class: _vm.ulinfo.icons[_vm.ulinfo.index],
    style: (_vm.tipColor)
  }), _vm._v(" "), _c('el-col', [_c('el-row', {
    staticStyle: {
      "margin-top": "-8px"
    }
  }, [_c('div'), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "26px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_filename')) + ": " + _vm._s(_vm.form.fname))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "26px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_fileSize')) + ": " + _vm._s(_vm.form.size / 1024) + "KB")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "26px"
    }
  }, [_vm._v("MD5: " + _vm._s(_vm.form.md5))]), _vm._v(" "), _c('div', [_c('el-button', {
    staticStyle: {
      "margin-top": "6px"
    },
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_clreul')))])], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ulinfo.index === 0),
      expression: "ulinfo.index === 0"
    }],
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.ulinfo.tip))])])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_useDis'),
      "prop": "mech"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.type === 3),
      expression: "config.type === 3"
    }],
    staticStyle: {
      "background": "none",
      "margin-top": "30px"
    },
    attrs: {
      "label": _vm.$t('app_testInstall')
    }
  }, [_c('el-button', {
    staticClass: "aeMg",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.pushInstall
    }
  }, [_vm._v(_vm._s(_vm.$t('app_pushInstall')))])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.type === 3),
      expression: "config.type === 3"
    }],
    staticStyle: {
      "background": "none"
    },
    attrs: {
      "label": _vm.$t('app_isPass')
    }
  }, [_c('el-radio', {
    staticClass: "radio aeMg",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_pass')))]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio aeMg",
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_ban')))])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.radio === '2'),
      expression: "radio === '2'"
    }],
    staticStyle: {
      "background": "none"
    },
    attrs: {
      "label": _vm.$t('app_banReason')
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkDesc),
      expression: "checkDesc"
    }],
    staticStyle: {
      "width": "100%",
      "height": "60px",
      "float": "left"
    },
    domProps: {
      "value": (_vm.checkDesc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.checkDesc = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticStyle: {
      "background": "none"
    }
  }, [_c('el-button', {
    staticClass: "aeMg",
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    staticClass: "aeMg",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.uploadApp('form')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_save')))])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.type === 2),
      expression: "config.type === 2"
    }],
    staticStyle: {
      "background": "none"
    },
    attrs: {
      "label": ""
    }
  }, [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.lcNew
    }
  }, [_vm._v(_vm._s(_vm.$t('app_upload') + 'launcher'))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticClass: "source gSgLeftBtn"
  }, [_c('span', {
    staticClass: "wrapper"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hidest),
      expression: "!hidest"
    }]
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(29),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.onClick('1')
      }
    }
  }), _vm._v("\n\t\t\t\t" + _vm._s(_vm.$t('lin_global.online')) + " " + _vm._s(_vm.nums ? _vm.nums[1].nums : ''))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hidest),
      expression: "!hidest"
    }]
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(35),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.onClick('3')
      }
    }
  }), _vm._v("\n\t\t\t\t" + _vm._s(_vm.$t('app_sleep')) + " " + _vm._s(_vm.nums ? _vm.nums[3].nums : ''))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hidest),
      expression: "!hidest"
    }]
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(42),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.onClick('2')
      }
    }
  }), _vm._v("\n\t\t\t\t" + _vm._s(_vm.$t('lin_global.offline')) + " " + _vm._s(_vm.nums ? _vm.nums[2].nums : ''))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hidest),
      expression: "hidest"
    }],
    staticStyle: {
      "margin-left": "-2px",
      "display": "block",
      "height": "20px",
      "font-size": "16px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('app_devicewhe')))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "-30px",
      "margin-right": "24px",
      "background": "none"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 18
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('MechanismSelector', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_lkdevice'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.sn),
      callback: function($$v) {
        _vm.sn = $$v
      },
      expression: "sn"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.isChina) ? _c('el-row', {
    staticClass: "gTopMg"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('zt-map', {
    attrs: {
      "height": _vm.tableHeight,
      "mapdata1": _vm.mapdata1,
      "mode": 0
    }
  })], 1)], 1) : _c('div', {
    staticClass: "gTopMg",
    attrs: {
      "id": "gmap"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    staticStyle: {
      "margin-top": "-1px"
    },
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [300, 500, 1000],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (0),
      expression: "0"
    }],
    attrs: {
      "id": "adFilter"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('app_filter')) + ":")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-left": "20px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_type')
    },
    model: {
      value: (_vm.appTypeValue),
      callback: function($$v) {
        _vm.appTypeValue = $$v
      },
      expression: "appTypeValue"
    }
  }, _vm._l((_vm.appTypes), function(item) {
    return _c('el-option', {
      key: item.appClassifyId,
      attrs: {
        "label": item.appClassifyName,
        "value": item.appClassifyId
      }
    })
  })), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-left": "20px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    model: {
      value: (_vm.appStatusValue),
      callback: function($$v) {
        _vm.appStatusValue = $$v
      },
      expression: "appStatusValue"
    }
  }, _vm._l((_vm.appStatus), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    staticClass: "tbPoint",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick,
      "sort-change": _vm.sortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appName",
      "sortable": "custom",
      "label": _vm.$t('app_appName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appCategoryName",
      "width": "100",
      "label": _vm.$t('app_type')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appStatus",
      "width": "150",
      "label": _vm.$t('app_vStatus')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-label', [_vm._v(_vm._s(_vm.getStatus(scope.row.appStatus)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "createTime",
      "sortable": "custom",
      "width": "175",
      "fformatter": "dateFormat",
      "label": _vm.$t('app_ulTime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appVersion",
      "width": "170",
      "label": _vm.$t('app_newgVer')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "width": "80",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_verify'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_c('i', {
          staticClass: "fa fa-check-square-o"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1050 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ae"
    }
  }, [_c('div', {
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "width": "140px",
      "height": "140px",
      "margin": "24px 24px 24px 24px",
      "display": "inline-block",
      "float": "left",
      "overflow": "hidden"
    }
  }), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "calc(100% - 188px)",
      "height": "100%",
      "margin-bottom": "0px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.data.appName : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "60px"
    }
  }, [_c('table', {
    staticClass: "dt-app"
  }, [_c('tr', [_c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_version')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.data.appVersion : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_verTag')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.data.versioncode : ''))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_appType')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config.data.appCategoryName))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_package')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.data.packagename : ''))])]), _vm._v(" "), _c('td')])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-height": "60px",
      "display": "-webkit-flex"
    }
  }, [_c('div', {
    staticClass: "dt-word-title",
    staticStyle: {
      "display": "inline-block",
      "min-width": "70px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('app_introl')) + "：\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "dt-word-main",
    staticStyle: {
      "display": "inline-block",
      "position": "relative",
      "background": "none",
      "margin": "0 24px 24px 0"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.config.data.appDesc))])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.captures ? _vm.captures.length > 0 : false),
      expression: "captures? captures.length > 0 : false"
    }],
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gCtColor  gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_screenShot')) + " ")]), _vm._v(" "), _c('div', _vm._l((_vm.captures), function(item) {
    return _c('img', {
      staticClass: "gBorder",
      staticStyle: {
        "width": "180px",
        "height": "320px",
        "margin": "24px 0 24px 24px",
        "border-radius": "4px"
      },
      attrs: {
        "onerror": "this.src='/static/img/df-h.png'",
        "src": _vm.imgFullUrl(item)
      }
    })
  }))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.type === 2 && _vm.config.isHistory),
      expression: "config.type === 2 && config.isHistory"
    }],
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gCtColor gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_hisVer')) + " ")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUploadNew),
      expression: "showUploadNew"
    }],
    staticStyle: {
      "margin": "24px 0 24px 24px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.uploadNew
    }
  }, [_vm._v(_vm._s(_vm.$t('app_ulNew')))]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appName",
      "label": _vm.$t('app_appName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appVersion",
      "width": "",
      "label": _vm.$t('app_version')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appCategoryName",
      "width": "",
      "label": _vm.$t('app_type')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "formatter": _vm.dateFormat,
      "prop": "createTime",
      "width": "170",
      "label": _vm.$t('app_createTime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "",
      "width": "90",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.config.data.isoperation === 0),
            expression: "config.data.isoperation === 0"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteAppHis(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "id": "dashboard_index"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "color": "#20A0FF"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(_vm._s(_vm.$t('index.terStatus')))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/terList"
    }
  }, [_c('span', {
    staticClass: "more"
  }, [_vm._v(_vm._s(_vm.$t('index.more')))])])], 1), _vm._v(" "), (_vm.devData) ? _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 8,
      "xs": 24,
      "sm": 8,
      "md": 8
    }
  }, [_c('div', {
    staticClass: "el-card-radio green",
    on: {
      "click": function($event) {
        _vm.jumpTerminal(1)
      }
    }
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(765)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "context"
  }, [_c('p', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.devData.zx) + _vm._s(_vm.$t('index.t')))]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t('index.onlineTer')))])])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 8,
      "xs": 24,
      "sm": 8,
      "md": 8
    }
  }, [_c('div', {
    staticClass: "el-card-radio orange",
    on: {
      "click": function($event) {
        _vm.jumpTerminal(2)
      }
    }
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(764)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "context"
  }, [_c('p', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.devData.lx) + _vm._s(_vm.$t('index.t')))]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t('index.offLineTer')))])])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 8,
      "xs": 24,
      "sm": 8,
      "md": 8
    }
  }, [_c('div', {
    staticClass: "el-card-radio pink",
    on: {
      "click": function($event) {
        _vm.jumpTerminal(null)
      }
    }
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(769)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "context"
  }, [_c('p', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.devData.yj) + _vm._s(_vm.$t('index.t')))]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t('index.warnTer')))])])])])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.taskData) ? _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "color": "#20A0FF"
    }
  }, [_c('i', {
    staticClass: "fa fa-list-ol"
  }), _vm._v(_vm._s(_vm.$t('index.taskList')))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/mision-list"
    }
  }, [_c('span', {
    staticClass: "more"
  }, [_vm._v(_vm._s(_vm.$t('index.more')))])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 8,
      "xs": 24,
      "sm": 8,
      "md": 8
    }
  }, [_c('div', {
    staticClass: "el-card-radio blue",
    on: {
      "click": function($event) {
        _vm.jump('/task/ptask')
      }
    }
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(763)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "context"
  }, [_c('p', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.taskData.yy))]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t('index.pullApp')))])])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 8,
      "xs": 24,
      "sm": 8,
      "md": 8
    }
  }, [_c('div', {
    staticClass: "el-card-radio blue let",
    on: {
      "click": function($event) {
        _vm.jump('/task/ptask')
      }
    }
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(767)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "context"
  }, [_c('p', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.taskData.rom))]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t('index.romUpdate')))])])])]), _c('el-col', {
    attrs: {
      "lg": 8,
      "xs": 24,
      "sm": 8,
      "md": 8
    }
  }, [_c('div', {
    staticClass: "el-card-radio green let",
    on: {
      "click": function($event) {
        _vm.jump('/task/ptask')
      }
    }
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(762)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "context"
  }, [_c('p', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.taskData.gg))]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t('index.pullAdvert')))])])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.infoData) ? _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "color": "#20A0FF"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o"
  }), _vm._v(_vm._s(_vm.$t('index.infoList')))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/warn"
    }
  }, [_c('span', {
    staticClass: "more"
  }, [_vm._v(_vm._s(_vm.$t('index.more')))])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 12,
      "xs": 24,
      "sm": 12,
      "md": 12
    }
  }, [_c('div', {
    staticClass: "el-card-radio pink dark",
    on: {
      "click": function($event) {
        _vm.jump('/warn')
      }
    }
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(766)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "context"
  }, [_c('p', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.infoData.fk))]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t('index.riskWarn')))])])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 12,
      "xs": 24,
      "sm": 12,
      "md": 12
    }
  }, [_c('div', {
    staticClass: "el-card-radio orange dark",
    on: {
      "click": function($event) {
        _vm.jump('/warn')
      }
    }
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(768)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "context"
  }, [_c('p', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.infoData.gz))]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t('index.breakWarn')))])])])])], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loginBg",
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "loginHeader"
  }, [_c('el-row', {
    staticStyle: {
      "padding-top": "20px",
      "margin-left": "10%"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(773)
    },
    on: {
      "click": _vm.openLicenseDialog
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "logoTxt"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('lin_global.logoTitle')) + "\n        ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "blue"
  }), _vm._v(" "), _c('div', {
    staticClass: "card-box"
  }, [_c('el-form', {
    ref: "loginForm",
    staticClass: "demo-ruleForm loginform",
    attrs: {
      "id": "form-box",
      "model": _vm.loginForm,
      "rules": _vm.loginRules
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.yhdl')))]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin": "0 auto",
      "width": "80%"
    },
    attrs: {
      "prop": "lang"
    }
  }, [_c('el-input', {
    staticClass: "input-with-select",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "placeholder": "",
      "readonly": ""
    },
    model: {
      value: (_vm.langName),
      callback: function($$v) {
        _vm.langName = $$v
      },
      expression: "langName"
    }
  }, [_c('el-dropdown', {
    attrs: {
      "slot": "append",
      "trigger": "click",
      "placement": "bottom-end"
    },
    on: {
      "command": _vm.langchange
    },
    slot: "append"
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('img', {
    staticStyle: {
      "width": "24px",
      "height": "16px",
      "margin-top": "5px"
    },
    attrs: {
      "src": _vm.langUrl
    }
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l((_vm.langs), function(item, index) {
    return _c('el-dropdown-item', {
      key: index,
      attrs: {
        "command": item.value
      }
    }, [_c('img', {
      staticStyle: {
        "width": "24px"
      },
      attrs: {
        "src": item.url
      }
    }), _vm._v("  " + _vm._s(item.label))])
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin": "0 auto",
      "width": "80%"
    },
    attrs: {
      "prop": "account"
    }
  }, [_c('el-input', {
    staticClass: "loginInput",
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": _vm.$t('lin_global.zh')
    },
    model: {
      value: (_vm.loginForm.account),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "account", $$v)
      },
      expression: "loginForm.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin": "0 auto",
      "width": "80%"
    },
    attrs: {
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    staticClass: "loginInput",
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": _vm.$t('lin_global.password')
    },
    on: {
      "change": _vm.pswChange
    },
    model: {
      value: (_vm.loginForm.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "checkPass", $$v)
      },
      expression: "loginForm.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin": "0 auto",
      "width": "80%"
    },
    attrs: {
      "prop": "code"
    }
  }, [_c('el-row', {}, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    staticClass: "loginInput",
    attrs: {
      "auto-complete": "off",
      "placeholder": _vm.$t('app_ckcode')
    },
    model: {
      value: (_vm.loginForm.code),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "code", $$v)
      },
      expression: "loginForm.code"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('img', {
    staticStyle: {
      "position": "absolute",
      "bottom": "0",
      "right": "0",
      "width": "110px",
      "height": "40px"
    },
    attrs: {
      "src": _vm.codeObj ? _vm.codeObj.code : ''
    },
    on: {
      "click": _vm.recode
    }
  })])], 1)], 1), _vm._v(" "), _c('el-checkbox', {
    staticStyle: {
      "margin": "30px 0px 20px 10%",
      "color": "#979797"
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.jzmm')))]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "80%",
      "margin": "0 auto"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%",
      "background-image": "linear-gradient(-90deg, #158EE9 0%, #2CACFD 100%)",
      "border-radius": "2px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.login')))])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('lin_global.bah')) + "\n    "), _c('el-popover', {
    ref: "popover1",
    attrs: {
      "placement": "top-start",
      "title": _vm.$t('app_verUdCt'),
      "width": "200",
      "trigger": "hover"
    }
  }, [_c('div', {
    attrs: {
      "id": "markdownBody"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.verTip)
    }
  })]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:popover1",
      arg: "popover1"
    }],
    staticStyle: {
      "border": "none",
      "background": "none",
      "color": "#979797"
    }
  }, [_vm._v("v" + _vm._s(_vm.version))]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.logining),
      expression: "logining"
    }],
    attrs: {
      "cclass": "gDia",
      "title": "Activate TMS",
      "size": "small"
    },
    on: {
      "close": _vm.closeDia
    },
    model: {
      value: (_vm.isauth),
      callback: function($$v) {
        _vm.isauth = $$v
      },
      expression: "isauth"
    }
  }, [_c('el-form', {
    ref: "aform",
    attrs: {
      "model": _vm.aform,
      "rrules": "rules2"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "TMS is active until:",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v(_vm._s(_vm.aform.date))])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "span": 24
    }
  }, [_vm._v("\n              Please contact the administrator to request a new activation code\n            ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "userName",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.aform.usr),
      callback: function($$v) {
        _vm.$set(_vm.aform, "usr", $$v)
      },
      expression: "aform.usr"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "password",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    on: {
      "change": _vm.authPswChange
    },
    model: {
      value: (_vm.aform.psw),
      callback: function($$v) {
        _vm.$set(_vm.aform, "psw", $$v)
      },
      expression: "aform.psw"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "code",
      "label-width": _vm.formLabelWidth,
      "prop": "pass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "5"
    },
    model: {
      value: (_vm.aform.code),
      callback: function($$v) {
        _vm.$set(_vm.aform, "code", $$v)
      },
      expression: "aform.code"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.closeDia
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitForm('aform')
      }
    }
  }, [_vm._v("Activate")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.logining),
      expression: "logining"
    }],
    attrs: {
      "cclass": "gDia",
      "ttitle": "$t('app_mulfcau')",
      "size": "small"
    },
    on: {
      "close": _vm.closeDiaCk
    },
    model: {
      value: (_vm.ischeck),
      callback: function($$v) {
        _vm.ischeck = $$v
      },
      expression: "ischeck"
    }
  }, [_c('div', {
    attrs: {
      "id": "mfauthfr"
    }
  }, [_c('i', {
    staticClass: "fa fa-shield "
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('app_mulfcau')))]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_opmfackip6dycode')
    },
    model: {
      value: (_vm.code6),
      callback: function($$v) {
        _vm.code6 = $$v
      },
      expression: "code6"
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('app_cantprvmcodectadm')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.codeCheck
    }
  }, [_vm._v(_vm._s(_vm.$t('app_verifc')))])], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Enter License",
      "visible": _vm.licenseDialogVisible,
      "close-on-click-modal": false,
      "show-close": false,
      "width": "400px"
    },
    on: {
      "update:visible": function($event) {
        _vm.licenseDialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "licenseForm",
    attrs: {
      "model": _vm.licenseForm,
      "rules": _vm.licenseRules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "MAC Address"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "readonly": "",
      "placeholder": "MAC Address will appear here"
    },
    model: {
      value: (_vm.macAddress),
      callback: function($$v) {
        _vm.macAddress = $$v
      },
      expression: "macAddress"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding-left": "10px"
    },
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.fetchMacAddress
    }
  }, [_vm._v("Get MAC Address")])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "License Key",
      "prop": "licenseKey"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "autocomplete": "off",
      "placeholder": "Enter your license key"
    },
    model: {
      value: (_vm.licenseForm.licenseKey),
      callback: function($$v) {
        _vm.$set(_vm.licenseForm, "licenseKey", $$v)
      },
      expression: "licenseForm.licenseKey"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.activationLicense
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1053 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m_context plr"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "id": "addForm",
      "model": _vm.form,
      "label-width": "12.5%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_areaid')
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData,
      "mselect": true,
      "classs": 'w_33'
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.ter_num')
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v("  " + _vm._s(_vm.form.terNums) + "  ")]), _vm._v(_vm._s(_vm.$t('terminal.appLog.tower')) + "\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.ota_bao')
    }
  }, [_c('el-select', {
    staticClass: "w_33",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": _vm.$t('lin_global.ple_sel_ota')
    },
    model: {
      value: (_vm.form.otaId),
      callback: function($$v) {
        _vm.$set(_vm.form, "otaId", $$v)
      },
      expression: "form.otaId"
    }
  }, _vm._l((_vm.otaList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isSubmit
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.lock')))])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "m_context plr"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "id": "addForm",
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "12.5%"
    }
  }, [_c('el-popover', {
    ref: "popover1",
    attrs: {
      "placement": "bottom-start",
      "trigger": "hover",
      "content": _vm.$t('terminal.add.popover_no'),
      "popper-class": ""
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_no'),
      "prop": "terminal_no"
    }
  }, [_c('el-input', {
    directives: [{
      name: "popover",
      rawName: "v-popover:popover1",
      arg: "popover1"
    }],
    attrs: {
      "id": "terminal_no",
      "maxlength": 50,
      "placeholder": _vm.$t('terminal.add.place_no')
    },
    model: {
      value: (_vm.form.terminal_no),
      callback: function($$v) {
        _vm.$set(_vm.form, "terminal_no", $$v)
      },
      expression: "form.terminal_no"
    }
  })], 1), _vm._v(" "), _c('el-popover', {
    ref: "popover2",
    attrs: {
      "placement": "bottom-start",
      "trigger": "hover",
      "content": _vm.$t('terminal.add.popover_name'),
      "popper-class": ""
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_name'),
      "prop": "terminal_name"
    }
  }, [_c('el-input', {
    directives: [{
      name: "popover",
      rawName: "v-popover:popover2",
      arg: "popover2"
    }],
    attrs: {
      "id": "terminal_name",
      "maxlength": 50,
      "placeholder": _vm.$t('terminal.add.place_name')
    },
    model: {
      value: (_vm.form.terminal_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "terminal_name", $$v)
      },
      expression: "form.terminal_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_areaid'),
      "prop": "areaid"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData,
      "mselect": true,
      "cclasss": "'w_33'"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_model'),
      "prop": "terminal_model"
    }
  }, [_c('el-select', {
    staticClass: "w_33",
    attrs: {
      "disabled": !_vm.form.areaid,
      "id": "terminal_model",
      "filterable": "",
      "clearable": "",
      "placeholder": _vm.$t('terminal.add.place_model')
    },
    model: {
      value: (_vm.form.terminal_model),
      callback: function($$v) {
        _vm.$set(_vm.form, "terminal_model", $$v)
      },
      expression: "form.terminal_model"
    }
  }, _vm._l((_vm.models), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_type'),
      "prop": "terminal_type"
    }
  }, [_c('el-select', {
    staticClass: "w_33",
    attrs: {
      "disabled": !_vm.form.areaid,
      "id": "terminal_type",
      "filterable": "",
      "clearable": "",
      "placeholder": _vm.$t('terminal.add.place_type')
    },
    model: {
      value: (_vm.form.terminal_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "terminal_type", $$v)
      },
      expression: "form.terminal_type"
    }
  }, _vm._l((_vm.dvTypes), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_manufid'),
      "prop": "manufid"
    }
  }, [_c('el-select', {
    staticClass: "w_33",
    attrs: {
      "disabled": !_vm.form.areaid,
      "id": "terminal_type",
      "filterable": "",
      "clearable": "",
      "placeholder": _vm.$t('terminal.add.place_manufid')
    },
    model: {
      value: (_vm.form.manufid),
      callback: function($$v) {
        _vm.$set(_vm.form, "manufid", $$v)
      },
      expression: "form.manufid"
    }
  }, _vm._l((_vm.firms), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_address'),
      "prop": "address"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "address",
      "placeholder": _vm.$t('terminal.add.place_address')
    },
    model: {
      value: (_vm.form.address),
      callback: function($$v) {
        _vm.$set(_vm.form, "address", $$v)
      },
      expression: "form.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.remark'),
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "id": "address",
      "placeholder": _vm.$t('app_input')
    },
    model: {
      value: (_vm.form.memo),
      callback: function($$v) {
        _vm.$set(_vm.form, "memo", $$v)
      },
      expression: "form.memo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "id": "onCancel"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isSubmit,
      "id": "onSubmit"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('app_add')))])], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1055 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-form-item",
    class: {
      'is-error': _vm.validateState === 'error',
        'is-validating': _vm.validateState === 'validating',
        'is-required': _vm.isRequired || _vm.required
    }
  }, [(_vm.label || _vm.$slots.label) ? _c('label', {
    staticClass: "el-form-item__label",
    style: (_vm.labelStyle),
    attrs: {
      "for": _vm.prop
    }
  }, [_vm._t("label", [_vm._v(_vm._s(_vm.label + _vm.form.labelSuffix))])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "el-form-item__content",
    style: (_vm.contentStyle)
  }, [_vm._t("default"), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [(_vm.validateState === 'error' && _vm.showMessage && _vm.form.showMessage) ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v(_vm._s(_vm.validateMessage))]) : _vm._e()])], 2)])
},staticRenderFns: []}

/***/ }),
/* 1056 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('div', {}, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.jumpToAdd
    }
  }, [_vm._v(_vm._s(_vm.$t('app_addApp')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_appName'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.appName),
      callback: function($$v) {
        _vm.appName = $$v
      },
      expression: "appName"
    }
  })], 1)])], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticClass: "tbPoint gTopMg",
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appName",
      "label": _vm.$t('app_appName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appVersion",
      "label": _vm.$t('psp_app_version'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "createTime",
      "width": "175",
      "label": _vm.$t('app_ulTime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "operate",
      "width": "106",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteApps(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)]), _vm._v(" "), _c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.mapDialog) ? _c('div', [_c('el-row', [_c('i', {
    staticClass: "el-icon-close",
    staticStyle: {
      "margin-bottom": "10px",
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.mapDialog = false
      }
    }
  })]), _vm._v(" "), (_vm.isChina) ? _c('div', {
    attrs: {
      "id": "allmap"
    }
  }) : _c('div', {
    staticStyle: {
      "height": "500px"
    },
    attrs: {
      "id": "gmap"
    }
  })], 1) : _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.disabled),
      expression: "disabled"
    }],
    attrs: {
      "id": "termialDetail"
    }
  }, [_c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('lin_btn.tips'),
      "before-close": _vm.handleClose
    },
    model: {
      value: (_vm.showReset),
      callback: function($$v) {
        _vm.showReset = $$v
      },
      expression: "showReset"
    }
  }, [_c('span', [_vm._v(_vm._s(this.$t('lin_global.qrjxmm') + this.$t('terminal.details.regain')))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showReset = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.opeTer('1')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_tipterop')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.opeTer('0')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_autocmpl')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('lin_global.ter_status'),
      "size": "",
      "top": "15%"
    },
    on: {
      "close": function($event) {
        _vm.showdvst = false
      }
    },
    model: {
      value: (_vm.showdvst),
      callback: function($$v) {
        _vm.showdvst = $$v
      },
      expression: "showdvst"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.getTerWllxInfo.extendStatus,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "width": "220",
      "label": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "width": "180",
      "label": "Type"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "Status"
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_mdclst'),
      "size": "",
      "top": "15%"
    },
    on: {
      "close": function($event) {
        _vm.showlog = false
      }
    },
    model: {
      value: (_vm.showlog),
      callback: function($$v) {
        _vm.showlog = $$v
      },
      expression: "showlog"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.sendLoad),
      expression: "sendLoad"
    }],
    staticClass: "tbPoint",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mdlogs,
      "border": ""
    },
    on: {
      "row-click": _vm.showFunc
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "width": "320",
      "label": _vm.$t('app_name')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "value",
      "width": "120",
      "label": _vm.$t('app_param')
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_fcclst'),
      "size": "",
      "top": "15%"
    },
    on: {
      "close": function($event) {
        _vm.showfc = false;
        _vm.fclogs = []
      }
    },
    model: {
      value: (_vm.showfc),
      callback: function($$v) {
        _vm.showfc = $$v
      },
      expression: "showfc"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.fclogs,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "width": "320",
      "label": _vm.$t('app_name')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "value",
      "width": "120",
      "label": _vm.$t('app_param')
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.ulscreentt,
      "size": "tiny",
      "top": "15%"
    },
    on: {
      "close": _vm.closeulDia
    },
    model: {
      value: (_vm.ulDia),
      callback: function($$v) {
        _vm.ulDia = $$v
      },
      expression: "ulDia"
    }
  }, [_c('el-form', [_c('el-form-item', [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('lin_global.password')
    },
    model: {
      value: (_vm.ulsform.psw),
      callback: function($$v) {
        _vm.$set(_vm.ulsform, "psw", $$v)
      },
      expression: "ulsform.psw"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_wattime') + ' ' + _vm.$t('app_perms')
    },
    model: {
      value: (_vm.ulsform.time),
      callback: function($$v) {
        _vm.$set(_vm.ulsform, "time", $$v)
      },
      expression: "ulsform.time"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.closeulDia
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": !_vm.ulsform.psw || !_vm.ulsform.time,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.ulscreenRqs()
      }
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t('app_confirm')) + "\n\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('span', {
    staticClass: "wrapper"
  }, [_c('el-button-group', {
    staticStyle: {
      "margin-right": "8px"
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.btnShow,
      "type": "warning",
      "size": "small",
      "loading": _vm.cqLoad,
      "id": "orderExecCQ"
    },
    on: {
      "click": function($event) {
        _vm.orderExec('CQ')
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-spinner ml5"
  }), _vm._v(_vm._s(_vm.$t('lin_btn.restart')))])]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.btnShow,
      "type": "danger",
      "size": "small",
      "loading": _vm.gjLoad,
      "id": "orderExecGJ"
    },
    on: {
      "click": function($event) {
        _vm.orderExec('GJ')
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-power-off ml5"
  }), _vm._v(_vm._s(_vm.$t('terminal.details.gj')))])])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.btnShow,
      "type": "primary",
      "size": "small",
      "loading": _vm.hfszLoad
    },
    on: {
      "click": function($event) {
        _vm.showReset = true
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-refresh ml5"
  }), _vm._v(_vm._s(_vm.$t('terminal.details.regain')))])]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "id": "processInfo"
    },
    on: {
      "click": function($event) {
        _vm.processInfoVisible = true
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-pencil ml5"
  }), _vm._v(_vm._s(_vm.$t('lin_btn.edit')))])]), _vm._v(" "), _c('el-button-group', {
    staticStyle: {
      "margin-right": "8px",
      "margin-left": "8px"
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.btnShow,
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.ToLinkList
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-list ml5"
  }), _vm._v(_vm._s(_vm.$t('terminal.details.app_list')))])]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.ToLink
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-cogs ml5"
  }), _vm._v(_vm._s(_vm.$t('terminal.details.app_install')))])])], 1), _vm._v(" "), _c('el-button-group', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.sendAnimate
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-upload ml5"
  }), _vm._v(_vm._s(_vm.$t('terminal.details.send_animate')))])]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.btnShow,
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.animate
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-repeat ml5"
  }), _vm._v(_vm._s(_vm.$t('terminal.details.reset_animate')))])])], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.showPathMap
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('app_trjmap')) + "\n\t\t\t\t\t\t")]), _vm._v(" "), (_vm.baseinfo.lock_status != 1) ? _c('el-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.lockDevice(true)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('app_lockdevice')) + "\n\t\t\t\t\t\t")]) : _c('el-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.lockDevice(false)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('app_unlockdevice')) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.callclick
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.calltt) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.outputexcel
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('app_opterinfo')) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.ulscreenOpe
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.ulscreentt) + "\n\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('el-button-group', {
    staticStyle: {
      "margin-right": "8px",
      "margin-left": "8px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.showlog = true
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('app_lulog')) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.showdvst = true
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('app_lust')) + "\n\t\t\t\t\t\t")])], 1)], 1)], 1), _vm._v(" "), _c('el-alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFac),
      expression: "showFac"
    }],
    attrs: {
      "title": this.$t('app_saleSt') + '：' + this.$t('app_noresetfs'),
      "type": "error"
    }
  }), _vm._v(" "), _c('el-alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAct),
      expression: "showAct"
    }],
    attrs: {
      "title": this.$t('app_actst') + '：' + this.$t('app_selfDestroy') + '(' + _vm.baseinfo.activDesc + ')',
      "type": "error"
    }
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "10px"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "line-height": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.details.base_info')))])]), _vm._v(" "), _c('el-form', {
    attrs: {
      "id": "",
      "label-position": "left",
      "inline": "",
      "label-width": "120px"
    },
    model: {
      value: (_vm.baseinfo),
      callback: function($$v) {
        _vm.baseinfo = $$v
      },
      expression: "baseinfo"
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-left",
    attrs: {
      "label": _vm.$t('lin_global.label_name')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.baseinfo.terminal_name) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-right",
    attrs: {
      "label": _vm.$t('lin_global.label_no')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.baseinfo.terminal_no) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-left",
    attrs: {
      "label": _vm.$t('lin_global.label_type')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.baseinfo.terminal_typeName) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-right",
    attrs: {
      "label": _vm.$t('lin_global.label_model')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.baseinfo.terminal_modelName) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-left",
    attrs: {
      "label": _vm.$t('lin_global.label_areaid')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.baseinfo.mechanismName) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-right",
    attrs: {
      "label": _vm.$t('lin_global.label_manufid')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.baseinfo.manufName) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-left",
    attrs: {
      "label": _vm.$t('lin_global.guojia')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.baseinfo.nation) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-right",
    attrs: {
      "label": _vm.$t('lin_global.shengfen')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.baseinfo.province) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-left",
    attrs: {
      "label": _vm.$t('lin_global.city')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.baseinfo.city) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-right",
    attrs: {
      "label": _vm.$t('app_region')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.baseinfo.district) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-left",
    attrs: {
      "label": _vm.$t('lin_global.label_address')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.baseinfo.address) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-right",
    attrs: {
      "label": _vm.$t('lin_global.remark')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.baseinfo.memo) + "\n\t\t\t\t\t\t\t")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "10px"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "line-height": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_stinfo')))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-refresh",
    staticStyle: {
      "color": "#20A0FF",
      "margin-top": "-20px",
      "margin-left": "20px"
    },
    on: {
      "click": _vm.rfNet
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "90px",
      "width": "100%"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.baseinfo.online_history),
      expression: "baseinfo.online_history"
    }],
    staticStyle: {
      "margin-top": "20px",
      "left": "17.166%",
      "height": "2px",
      "width": "65.766%",
      "background": "#9BD4FF",
      "position": "absolute"
    }
  }), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.peripheralLoading),
      expression: "peripheralLoading"
    }],
    staticStyle: {
      "width": "100%",
      "background": "none"
    }
  }, [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "siimg"
  }, [_c('img', {
    attrs: {
      "src": _vm.sticon0
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sititle",
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_vm._v(_vm._s(_vm.stlb0))]), _vm._v(" "), _c('div', {
    staticClass: "sidetail",
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_vm._v(_vm._s(_vm.sttm0))])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "siimg"
  }, [_c('img', {
    attrs: {
      "src": _vm.sticon1
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sititle",
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_vm._v(_vm._s(_vm.stlb1))]), _vm._v(" "), _c('div', {
    staticClass: "sidetail",
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_vm._v(_vm._s(_vm.sttm1))])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "siimg"
  }, [_c('img', {
    attrs: {
      "src": _vm.sticon2
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sititle",
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_vm._v(_vm._s(_vm.stlb2))]), _vm._v(" "), _c('div', {
    staticClass: "sidetail",
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_vm._v(_vm._s(_vm.sttm2))])])], 1)], 1)])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "10px"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "line-height": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.ter_status')))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-refresh",
    staticStyle: {
      "color": "#20A0FF",
      "margin-top": "-20px",
      "margin-left": "20px"
    },
    on: {
      "click": _vm.rfNet
    }
  })]), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.peripheralLoading),
      expression: "peripheralLoading"
    }],
    attrs: {
      "id": "baseInfo",
      "label-position": "left",
      "inline": "",
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-left",
    attrs: {
      "label": _vm.$t('lin_global.net_status')
    }
  }, [(_vm.getTerWllxInfo.terminal_status === '1') ? _c('el-tag', {
    attrs: {
      "type": "success",
      "size": "mini"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('lin_global.online')) + "\n\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.getTerWllxInfo.terminal_status === '2') ? _c('el-tag', {
    attrs: {
      "type": "danger",
      "size": "mini"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('lin_global.offline')) + "\n\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.getTerWllxInfo.terminal_status === '0') ? _c('el-tag', {
    attrs: {
      "type": "gray",
      "size": "mini"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('lin_global.new_add')) + "\n\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.getTerWllxInfo.terminal_status === '3') ? _c('el-tag', {
    attrs: {
      "type": "warning",
      "size": "mini"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('app_sleep')) + "\n\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.getTerWllxInfo.terminal_status === '4') ? _c('el-tag', {
    attrs: {
      "type": "danger",
      "size": "mini"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('lin_btn.lock')) + "\n\t\t\t\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-right",
    attrs: {
      "label": _vm.$t('lin_global.run_status')
    }
  }, [(_vm.baseinfo.terminal_runtime_status === '0') ? _c('el-tag', {
    attrs: {
      "type": "success",
      "size": "mini"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('lin_global.normal')) + "\n\t\t\t\t\t\t\t\t")]) : _c('el-tag', {
    attrs: {
      "type": "warning",
      "size": "mini"
    }
  }, [_vm._v(_vm._s(_vm.showRuntime))])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-left",
    attrs: {
      "label": _vm.$t('terminal.details.net_type')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.getTerWllxInfo.wlan) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-right",
    attrs: {
      "label": _vm.$t('lin_global.ter_status')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.baseinfo.lock_status == 1 ? _vm.$t('lin_btn.lock') : _vm.$t('lin_global.normal')) + "\n\t\t\t\t\t\t\t")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "10px"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('label', {
    staticStyle: {
      "line-height": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.details.system_info')))]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isRf),
      expression: "isRf"
    }],
    staticClass: "fa fa-refresh",
    staticStyle: {
      "color": "#20A0FF",
      "margin-top": "-20px",
      "margin-left": "20px"
    },
    on: {
      "click": _vm.rfInfo
    }
  })]), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.systemInfoLoading),
      expression: "systemInfoLoading"
    }],
    attrs: {
      "id": "getTerXtxxInfo",
      "label-position": "left",
      "inline": "",
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-left",
    attrs: {
      "label": _vm.$t('terminal.details.launcher')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.getTerXtxxInfo.launcher) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-right",
    attrs: {
      "label": _vm.$t('terminal.details.system_version')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.hardwareInfo.system) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-left",
    attrs: {
      "label": _vm.$t('terminal.details.ota_version')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.getTerXtxxInfo.ota) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-right",
    attrs: {
      "label": _vm.$t('terminal.details.hard_version')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.getTerXtxxInfo.firmware) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-left",
    attrs: {
      "label": _vm.$t('terminal.details.last_time')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.baseinfo.terminal_online_time) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-right",
    attrs: {
      "label": _vm.$t('terminal.details.run_time')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.getTerXtxxInfo.elapsedtime) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-left",
    attrs: {
      "label": _vm.$t('app_comptime')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.baseinfo.compile ? _vm.baseinfo.compile : '-') + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-right",
    attrs: {
      "label": "IMEI"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.getTerXtxxInfo.imei) + "\n\t\t\t\t\t\t\t")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "10px"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('label', {
    staticStyle: {
      "line-height": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.details.hard_info')))]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isRf),
      expression: "isRf"
    }],
    staticClass: "fa fa-refresh",
    staticStyle: {
      "color": "#20A0FF",
      "margin-top": "-20px",
      "margin-left": "20px"
    },
    on: {
      "click": _vm.rfhw
    }
  })]), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.hardInfoLoading),
      expression: "hardInfoLoading"
    }],
    attrs: {
      "id": "hardInfo",
      "label-position": "left",
      "inline": "",
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-left",
    attrs: {
      "label": _vm.$t('terminal.details.cpu')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.hardwareInfo.cpu) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-right",
    attrs: {
      "label": _vm.$t('terminal.details.mem')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.hardwareInfo.mem) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-left",
    attrs: {
      "label": _vm.$t('terminal.details.cpuUsed')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.hardwareInfo.cpuUsed) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-right",
    attrs: {
      "label": _vm.$t('terminal.details.memUsed')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.hardwareInfo.memUsed) + "\n\t\t\t\t\t\t\t")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "10px"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('label', {
    staticStyle: {
      "line-height": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_debuginfo')))]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isRf),
      expression: "isRf"
    }],
    staticClass: "fa fa-refresh",
    staticStyle: {
      "color": "#20A0FF",
      "margin-top": "-20px",
      "margin-left": "20px"
    },
    on: {
      "click": _vm.rfadb
    }
  })]), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.adbLoading),
      expression: "adbLoading"
    }],
    attrs: {
      "id": "hardInfo",
      "label-position": "left",
      "inline": "",
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-left",
    attrs: {
      "label": _vm.$t('app_adbstatus')
    }
  }, [_c('el-tag', {
    attrs: {
      "type": "success",
      "size": "mini"
    }
  }, [_vm._v(_vm._s(_vm.adbst))])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-right",
    attrs: {
      "label": _vm.$t('app_signstatus')
    }
  }, [_c('el-tag', {
    attrs: {
      "type": "success",
      "size": "mini"
    }
  }, [_vm._v(_vm._s(_vm.signst))])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-left",
    attrs: {
      "label": _vm.$t('app_devicemode')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.dvst) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-right",
    attrs: {
      "label": _vm.$t('app_cerid')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.getTerAdbztInfo.certInfo) + "\n\t\t\t\t\t\t\t")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.processInfoVisible) ? _c('processInfo', {
    attrs: {
      "pdata": _vm.pdata
    }
  }) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('terminal.details.hydh'),
      "size": "tiny",
      "top": "15%"
    },
    model: {
      value: (_vm.animateDialog),
      callback: function($$v) {
        _vm.animateDialog = $$v
      },
      expression: "animateDialog"
    }
  }, [_c('el-form', [_c('el-form-item', {
    staticStyle: {
      "width": "98%"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": _vm.$t('terminal.details.tips')
    },
    model: {
      value: (_vm.animateId),
      callback: function($$v) {
        _vm.animateId = $$v
      },
      expression: "animateId"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$t('terminal.details.kjdh'),
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$t('terminal.details.gjdh'),
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$t('terminal.details.kjlogo'),
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$t('app_wallpaper'),
      "value": "0"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.details.zbhy')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.logining,
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.details.mshy')) + "\n\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.sendLoad),
      expression: "sendLoad",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('terminal.details.tsdh_title'),
      "top": "15%"
    },
    model: {
      value: (_vm.sendAnimateDialog),
      callback: function($$v) {
        _vm.sendAnimateDialog = $$v
      },
      expression: "sendAnimateDialog"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.tloading),
      expression: "tloading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "fileName",
      "label": _vm.$t('terminal.details.animate_name')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "position",
      "label": _vm.$t('terminal.details.animatType'),
      "formatter": _vm.formatStatus
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": _vm.$t('terminal.details.createTime'),
      "width": "170"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('lin_global.ope'),
      "width": "81"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.send'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.send(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('lin_global.hqrz'),
      "top": "15%"
    },
    model: {
      value: (_vm.logDialog),
      callback: function($$v) {
        _vm.logDialog = $$v
      },
      expression: "logDialog"
    }
  }, [_c('el-form', [_c('el-row', {
    attrs: {
      "gutter": 10,
      "type": "flex",
      "align": "bottom"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t('terminal.appLog.start_time')) + "\n\t\t\t\t\t\t"), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "clearable": "",
      "placeholder": _vm.$t('terminal.appLog.start_time')
    },
    on: {
      "change": _vm.dataChange
    },
    model: {
      value: (_vm.start_time),
      callback: function($$v) {
        _vm.start_time = $$v
      },
      expression: "start_time"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t('terminal.appLog.end_time')) + "\n\t\t\t\t\t\t"), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "clearable": "",
      "placeholder": _vm.$t('terminal.appLog.end_time')
    },
    on: {
      "change": _vm.dataChange1
    },
    model: {
      value: (_vm.end_time),
      callback: function($$v) {
        _vm.end_time = $$v
      },
      expression: "end_time"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.logLoad
    },
    on: {
      "click": _vm.getLog
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.hqrz')) + "\n\t\t\t\t\t\t")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_trjmap'),
      "top": "15%"
    }
  }, [(_vm.isChina) ? _c('el-row', {}, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('zt-map', {
    attrs: {
      "height": "480",
      "mapdata1": _vm.mapdata1,
      "mode": 1
    }
  })], 1)], 1) : _c('div', {
    staticStyle: {
      "height": "480px"
    },
    attrs: {
      "id": "gmap"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_taskMg ')))]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "gSgLeftBtn"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.refreshList
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.shuaxin')))])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSgLeftBtn"
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_taskType')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.taskType),
      callback: function($$v) {
        _vm.taskType = $$v
      },
      expression: "taskType"
    }
  }, _vm._l((_vm.statusSl), function(item) {
    return _c('el-option', {
      key: item.type,
      attrs: {
        "label": item.name,
        "value": item.type
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl",
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_taskDetail'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.tName),
      callback: function($$v) {
        _vm.tName = $$v
      },
      expression: "tName"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "cmData"
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData1,
      "border": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "fileName",
      "label": _vm.$t('app_taskDetail'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.taskType == 19) ? _c('label', [_vm._v(_vm._s(_vm.comm[scope.row.fileName]))]) : _c('label', [_vm._v(_vm._s(scope.row.fileName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "taskType",
      "label": _vm.$t('app_taskType'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', [_vm._v(_vm._s(_vm.statusShow[scope.row.taskType]))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "progress",
      "label": _vm.$t('app_process'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', [_vm._v(_vm._s(scope.row.progress) + "%")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          attrs: {
            "typy": "success"
          }
        }, [_vm._v(_vm._s(_vm.statusNames[scope.row.status + '']))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "updateTime",
      "label": _vm.$t('app_pushTime'),
      "width": "176"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "right",
      "prop": "cancelNums",
      "label": _vm.$t('app_operate'),
      "width": "116"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_pause'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.showBtn(1, scope.row.status)),
            expression: "showBtn(1, scope.row.status)"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.downOperate(2, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pause"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_continue'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.showBtn(2, scope.row.status)),
            expression: "showBtn(2, scope.row.status)"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.downOperate(1, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-play"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_ccdown'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.showBtn(3, scope.row.status)),
            expression: "showBtn(3, scope.row.status)"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.downOperate(3, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-window-close"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_global.chongtui'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.showBtn(4, scope.row.status)),
            expression: "showBtn(4, scope.row.status)"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.repush(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-repeat"
        })])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelectDv,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1058 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-form', {
    ref: "form",
    staticClass: "gForm",
    attrs: {
      "label-position": "right",
      "rules": _vm.rules,
      "label-width": "12.5%",
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.risk_name'),
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.fwqdizhi'),
      "prop": "addr"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "exp: www.domain.com"
    },
    model: {
      value: (_vm.form.addr),
      callback: function($$v) {
        _vm.$set(_vm.form, "addr", $$v)
      },
      expression: "form.addr"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.fwqduankou'),
      "prop": "port"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "exp: 0000"
    },
    model: {
      value: (_vm.form.port),
      callback: function($$v) {
        _vm.$set(_vm.form, "port", $$v)
      },
      expression: "form.port"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save('form')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_save')))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1059 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 1060 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": ""
    }
  }, [_c('bdialog', {
    attrs: {
      "config": _vm.bconfig
    }
  }), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userType == 0),
      expression: "userType == 0"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addVer
    }
  }, [_vm._v(_vm._s(_vm.$t('app_addver')))]), _vm._v(" "), _c('div', _vm._l((_vm.tableData), function(item, index) {
    return _c('el-card', {
      key: index,
      staticClass: "box-card gTopMg vcard"
    }, [_c('div', {
      staticClass: "clearfix",
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('span', {
      staticClass: "vcardtt",
      staticStyle: {
        "line-height": "36px"
      }
    }, [_vm._v(_vm._s(item.version))]), _vm._v(" "), _c('span', {
      staticClass: "vcardtt",
      staticStyle: {
        "line-height": "36px",
        "float": "right"
      }
    }, [_vm._v("\n          " + _vm._s(item.opetime) + "\n        ")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "line-height": "36px",
        "float": "right",
        "margin-right": "16px"
      }
    }, [_c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.userType == 0 && index == 0),
        expression: "userType == 0 && index == 0"
      }],
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.editVer(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      staticStyle: {
        "color": "rgb(72,87,106)"
      }
    })])], 1), _vm._v(" "), _c('span', {
      staticStyle: {
        "line-height": "36px",
        "float": "right",
        "margin-right": "16px"
      }
    }, [_c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.userType == 0),
        expression: "userType == 0"
      }],
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.delVer(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      staticStyle: {
        "color": "rgb(72,87,106)"
      }
    })])], 1)]), _vm._v(" "), _c('div', {
      attrs: {
        "id": "markdownBody"
      },
      domProps: {
        "innerHTML": _vm._s(item.memo)
      }
    })])
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 1061 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-form', {
    ref: "form",
    staticClass: "gForm",
    attrs: {
      "label-position": "right",
      "rules": _vm.rules,
      "label-width": "14.5%",
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.risk_name'),
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_filestss'),
      "prop": "desc"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.desc),
      callback: function($$v) {
        _vm.$set(_vm.form, "desc", $$v)
      },
      expression: "form.desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "background": "#D3DCE6",
      "height": "1px"
    },
    attrs: {
      "prop": ""
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_stmgpsw'),
      "prop": ""
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.form.ispsw),
      callback: function($$v) {
        _vm.$set(_vm.form, "ispsw", $$v)
      },
      expression: "form.ispsw"
    }
  }), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.ispsw),
      expression: "form.ispsw"
    }],
    staticStyle: {
      "margin-left": "8px",
      "width": "calc(100% - 61px)"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.psw),
      callback: function($$v) {
        _vm.$set(_vm.form, "psw", $$v)
      },
      expression: "form.psw"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_setcallf'),
      "prop": ""
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.form.iscall),
      callback: function($$v) {
        _vm.$set(_vm.form, "iscall", $$v)
      },
      expression: "form.iscall"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.iscall),
      expression: "form.iscall"
    }]
  }, [_c('el-radio', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.form.callvl),
      callback: function($$v) {
        _vm.$set(_vm.form, "callvl", $$v)
      },
      expression: "form.callvl"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_close')))]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.form.callvl),
      callback: function($$v) {
        _vm.$set(_vm.form, "callvl", $$v)
      },
      expression: "form.callvl"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_open')))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_mapsl'),
      "prop": ""
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.form.ismap),
      callback: function($$v) {
        _vm.$set(_vm.form, "ismap", $$v)
      },
      expression: "form.ismap"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.ismap),
      expression: "form.ismap"
    }]
  }, [_c('el-radio', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.form.map),
      callback: function($$v) {
        _vm.$set(_vm.form, "map", $$v)
      },
      expression: "form.map"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_bdmap')))]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.form.map),
      callback: function($$v) {
        _vm.$set(_vm.form, "map", $$v)
      },
      expression: "form.map"
    }
  }, [_vm._v(_vm._s('Google' + _vm.$t('app_map')))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": 'API ' + _vm.$t('app_protocal'),
      "prop": ""
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.form.ishttp),
      callback: function($$v) {
        _vm.$set(_vm.form, "ishttp", $$v)
      },
      expression: "form.ishttp"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.ishttp),
      expression: "form.ishttp"
    }]
  }, [_c('el-radio', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.form.http),
      callback: function($$v) {
        _vm.$set(_vm.form, "http", $$v)
      },
      expression: "form.http"
    }
  }, [_vm._v("HTTP")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.form.http),
      callback: function($$v) {
        _vm.$set(_vm.form, "http", $$v)
      },
      expression: "form.http"
    }
  }, [_vm._v("HTTPS")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_prtsltip')))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": 'Appstore ' + _vm.$t('app_param'),
      "prop": ""
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.form.isstore),
      callback: function($$v) {
        _vm.$set(_vm.form, "isstore", $$v)
      },
      expression: "form.isstore"
    }
  }, [_vm._v("            off-text=\"\">\n          ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.isstore),
      expression: "form.isstore"
    }]
  }, [_c('label', {
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_vm._v("               IP")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "300px",
      "margin-left": "8px"
    },
    model: {
      value: (_vm.form.sip),
      callback: function($$v) {
        _vm.$set(_vm.form, "sip", $$v)
      },
      expression: "form.sip"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_port')))]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px",
      "margin-left": "8px"
    },
    model: {
      value: (_vm.form.sport),
      callback: function($$v) {
        _vm.$set(_vm.form, "sport", $$v)
      },
      expression: "form.sport"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_rgsvpm'),
      "prop": ""
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.form.isauth),
      callback: function($$v) {
        _vm.$set(_vm.form, "isauth", $$v)
      },
      expression: "form.isauth"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.isauth),
      expression: "form.isauth"
    }]
  }, [_c('label', {
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_rgsvip')))]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "300px",
      "margin-left": "8px"
    },
    model: {
      value: (_vm.form.aip),
      callback: function($$v) {
        _vm.$set(_vm.form, "aip", $$v)
      },
      expression: "form.aip"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_port')))]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px",
      "margin-left": "8px"
    },
    model: {
      value: (_vm.form.aport),
      callback: function($$v) {
        _vm.$set(_vm.form, "aport", $$v)
      },
      expression: "form.aport"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_bgntpm'),
      "prop": ""
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.form.isnotify),
      callback: function($$v) {
        _vm.$set(_vm.form, "isnotify", $$v)
      },
      expression: "form.isnotify"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.isnotify),
      expression: "form.isnotify"
    }]
  }, [_c('label', {
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_bgntip')))]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "300px",
      "margin-left": "8px"
    },
    model: {
      value: (_vm.form.nip),
      callback: function($$v) {
        _vm.$set(_vm.form, "nip", $$v)
      },
      expression: "form.nip"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_port')))]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px",
      "margin-left": "8px"
    },
    model: {
      value: (_vm.form.nport),
      callback: function($$v) {
        _vm.$set(_vm.form, "nport", $$v)
      },
      expression: "form.nport"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save('form')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_save')))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ae"
    }
  }, [_c('div', {
    staticClass: "gPageBorder"
  }, [_c('el-form', {
    ref: "form",
    staticClass: "gForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-position": "right",
      "label-width": "12.5%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('psp_app_id'),
      "prop": "appId"
    }
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }],
    staticClass: "aeMg contentColor"
  }, [_vm._v(_vm._s((_vm.config.data) ? _vm.config.data.appId : ''))]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "aeMg",
    model: {
      value: (_vm.form.appId),
      callback: function($$v) {
        _vm.$set(_vm.form, "appId", $$v)
      },
      expression: "form.appId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_appName'),
      "prop": "fileName"
    }
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }],
    staticClass: "aeMg contentColor"
  }, [_vm._v(_vm._s((_vm.config.data) ? _vm.config.data.fileName : ''))]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "aeMg",
    model: {
      value: (_vm.form.fileName),
      callback: function($$v) {
        _vm.$set(_vm.form, "fileName", $$v)
      },
      expression: "form.fileName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_sysType'),
      "prop": "sysType"
    }
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }],
    staticClass: "aeMg contentColor"
  }, [_vm._v(_vm._s((_vm.config.data) ? _vm.config.data.sysType : ''))]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.form.sysType),
      callback: function($$v) {
        _vm.$set(_vm.form, "sysType", $$v)
      },
      expression: "form.sysType"
    }
  }, _vm._l((_vm.sysType_list), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('psp_app_version'),
      "prop": "appVersion"
    }
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }],
    staticClass: "aeMg contentColor"
  }, [_vm._v(_vm._s((_vm.config.data) ? _vm.config.data.appVersion : ''))]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "aeMg",
    model: {
      value: (_vm.form.appVersion),
      callback: function($$v) {
        _vm.$set(_vm.form, "appVersion", $$v)
      },
      expression: "form.appVersion"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_introl'),
      "prop": "memo"
    }
  }, [_c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "aeMg",
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 9999
      }
    },
    model: {
      value: (_vm.form.memo),
      callback: function($$v) {
        _vm.$set(_vm.form, "memo", $$v)
      },
      expression: "form.memo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    attrs: {
      "label": _vm.$t('app_selectApp'),
      "prop": "appUrl"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo aeMg",
    attrs: {
      "data": _vm.uData,
      "drag": "",
      "name": "fileUpload",
      "file-list": _vm.fileList,
      "on-success": _vm.fileUploadSuccess,
      "limit": 1,
      "before-upload": _vm.fileBeforeUpload,
      "action": _vm.fileUploadUrl,
      "on-remove": _vm.handleRemove_1
    }
  }, [_c('span', [(_vm.upinfo_1) ? _c('i', {
    class: _vm.ulinfo.icons[0]
  }) : _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "display": "flex",
      "flex-direction": "column"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload",
    style: (_vm.tipColor_1)
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "140px",
      "margin": "0 auto"
    },
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_reupload')))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.upinfo_1),
      expression: "upinfo_1"
    }],
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.$t('app_ulNormalSt')))])])])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    attrs: {
      "label": _vm.$t('app_certificate_1'),
      "prop": "cerUrl"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo aeMg",
    attrs: {
      "data": _vm.uData,
      "drag": "",
      "name": "fileUpload",
      "file-list": _vm.fileLists,
      "on-success": _vm.fileUploadSuccesss,
      "limit": 1,
      "before-upload": _vm.fileBeforeUpload,
      "action": _vm.fileUploadUrl,
      "on-remove": _vm.handleRemove_2
    }
  }, [_c('span', [(_vm.upinfo_2) ? _c('i', {
    class: _vm.ulinfo.icons[0]
  }) : _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "display": "flex",
      "flex-direction": "column"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload",
    style: (_vm.tipColor_2)
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "140px",
      "margin": "0 auto"
    },
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_reupload')))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.upinfo_2),
      expression: "upinfo_2"
    }],
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.$t('app_ulNormalSt')))])])])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    attrs: {
      "label": _vm.$t('app_certificate_2'),
      "prop": "cerUrl1"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo aeMg",
    attrs: {
      "data": _vm.uData,
      "drag": "",
      "name": "fileUpload",
      "file-list": _vm.fileListss,
      "on-success": _vm.fileUploadSuccessss,
      "limit": 1,
      "before-upload": _vm.fileBeforeUpload,
      "action": _vm.fileUploadUrl,
      "on-remove": _vm.handleRemove_3
    }
  }, [_c('span', [(_vm.upinfo_3) ? _c('i', {
    class: _vm.ulinfo.icons[0]
  }) : _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "display": "flex",
      "flex-direction": "column"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload",
    style: (_vm.tipColor_3)
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "140px",
      "margin": "0 auto"
    },
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_reupload')))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.upinfo_3),
      expression: "upinfo_3"
    }],
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.$t('app_ulNormalSt')))])])])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "calc(100% + 20px)",
      "background": "#EAEEFA",
      "height": "1px",
      "margin-left": "-10px"
    }
  }), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "background": "none"
    }
  }, [_c('el-button', {
    staticClass: "aeMg",
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    staticClass: "aeMg",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.uploadApp('form')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_save')))])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1063 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('bdialog', {
    attrs: {
      "config": _vm.bconfig
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('div', {}, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "gSgLeftBtn"
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userType == 0),
      expression: "userType == 0"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addBlt
    }
  }, [_vm._v(_vm._s(_vm.$t('app_addblt')))])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_name'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)])], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    staticClass: "tbPoint gTopMg",
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick,
      "sort-change": _vm.sortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "noticeName",
      "label": _vm.$t('app_blttt'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "times",
      "width": "140",
      "label": _vm.$t('app_readnum')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "addTime",
      "width": "176",
      "label": _vm.$t('app_addtime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "operate",
      "width": "86",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "background": "none"
          }
        }, [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_edit'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.userType == 0),
            expression: "userType == 0"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.editBlt(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.userType == 0),
            expression: "userType == 0"
          }],
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.delBlt(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1064 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_tip'),
      "size": "tiny"
    },
    model: {
      value: (_vm.isTipUnlock),
      callback: function($$v) {
        _vm.isTipUnlock = $$v
      },
      expression: "isTipUnlock"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.mkunlocktip))]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.uniSubmit(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_no')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.uniSubmit(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_yes')))])], 1)]), _vm._v(" "), _c('el-row', {
    staticClass: "gPageBorder  gPdTB"
  }, [_c('p', {
    staticClass: "gFormTT"
  }, [_vm._v(_vm._s(_vm.$t('app_lockinfo')))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_deviceName')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.detail ? _vm.detail.terminalName : '') + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_deviceNo')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.detail ? _vm.detail.terminalNo : '') + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.risk_type')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.detail ? _vm.getWarnTypes[_vm.detail.eventType] : '') + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_riskdetail')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.disStrProcess(_vm.detail ? _vm.detail.outDistance : '')) + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_lockcity')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.detail ? _vm.detail.cityNow : '') + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_locklngandlat')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.detail ? '{' + _vm.detail.longitude + ' , ' + _vm.detail.latitude + '}' : '') + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_locktime')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.detail ? _vm.detail.lockTime : '') + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.remark')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.detail ? _vm.detail.lockDesc : '') + "\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "gPageBorder gTopMg gPdTB"
  }, [_c('p', {
    staticClass: "gFormTT"
  }, [_vm._v(_vm._s(_vm.$t('app_risksetting')))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "border-radius": "35px",
      "position": "absolute",
      "right": "calc(50% + 5px)",
      "z-index": "10"
    },
    attrs: {
      "disabled": !_vm.detail.riskId,
      "type": "",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.setUnbind(null)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_unbindenclosure')))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_bindenclosure')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.detail ? _vm.detail.riskName : '') + "\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('el-button', {
    staticClass: "gTopMg",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    staticClass: "gTopMg",
    attrs: {
      "type": "primary",
      "disabled": this.info.status == 2
    },
    on: {
      "click": _vm.unlockBf
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.unlock')))])], 1)
},staticRenderFns: []}

/***/ }),
/* 1065 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "background": "white"
    }
  }, [_c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  }), _vm._v(" "), _c('pushdia', {
    attrs: {
      "pObj": _vm.pObj
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder",
    attrs: {
      "id": "pdthead"
    }
  }, [_c('div', {
    staticClass: "pdthdfr"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "gwordels",
    staticStyle: {
      "width": "100%",
      "height": "44px",
      "font-size": "24px"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.info.taskName) + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "span": 12
    }
  }, [_c('label', {}, [_vm._v(_vm._s(_vm.$t('app_tscrtime')) + "："), _c('label', [_vm._v(_vm._s(_vm.info.taskTime))])])])], 1)], 1), _vm._v(" "), _vm._l((_vm.info.subTask), function(item) {
    return _c('div', {
      staticClass: "pdthdfr taskrow"
    }, [_c('el-row', {
      staticStyle: {
        "width": "100%",
        "height": "100%"
      }
    }, [_c('el-col', {
      staticStyle: {
        "height": "100%"
      },
      attrs: {
        "span": 3
      }
    }, [_c('div', {
      staticClass: "pdts1"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('app_subtask')) + _vm._s(item.num) + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "height": "100%"
      },
      attrs: {
        "span": 17
      }
    }, [_c('el-row', {
      class: item.taskType == 9 ? 'pdts2 dtcmgp' : 'pdts2'
    }, [_c('nobr', [_c('div', [_c('label', [_vm._v(_vm._s(_vm.$t('app_taskType')) + "：")]), _vm._v(_vm._s(item.taskType == '9' ? _vm.$t('app_dvcomm') : _vm.$t('app_pushfile')) + "\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), (item.taskType == '9') ? _c('div', {
      staticStyle: {
        "width": "70%"
      }
    }, [_c('label', [_vm._v(_vm._s(_vm.$t('app_commtype')) + "：")]), _vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.comm[item.content]) + "\n\t\t\t\t\t\t\t\t\t"), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.content == 'XZYY' || item.content == 'ZQ'),
        expression: "item.content == 'XZYY' || item.content == 'ZQ'"
      }]
    }, [_c('label', {
      staticStyle: {
        "display": "inline-block",
        "margin-left": "11%"
      }
    }, [_vm._v(_vm._s(_vm.$t('app_filename')) + "：")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.fileName) + "\n\t\t\t\t\t\t\t\t\t")])]) : _c('div', [_c('label', [_vm._v(_vm._s(_vm.$t('app_filename')) + "：")]), _vm._v(_vm._s(item.fileName))]), _vm._v(" "), (item.taskType != '9') ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.$t('app_version')) + "：")]), _vm._v(_vm._s(item.version) + "\n\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (item.taskType != '9') ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.$t('app_distributor')) + "：")]), _vm._v(_vm._s(item.mechName) + "\n\t\t\t\t\t\t\t\t")]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('el-col', {
      staticClass: "pdts3",
      attrs: {
        "span": 4
      }
    }, [_c('el-popover', {
      attrs: {
        "placement": "top",
        "width": "120",
        "trigger": "hover"
      }
    }, [_c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.pop),
        expression: "item.pop"
      }],
      staticStyle: {
        "position": "absolute",
        "top": "12px",
        "left": "20px"
      },
      attrs: {
        "slot": "reference",
        "type": "text"
      },
      slot: "reference"
    }, [_c('i', {
      staticClass: "fa fa-file-text-o"
    })]), _vm._v(" "), _vm._l((item.pop), function(sitem) {
      return _c('div', [_vm._v(_vm._s(sitem))])
    })], 2), _vm._v(" "), _c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": _vm.barTTip(item.complete, item.total),
        "placement": "top"
      }
    }, [_c('div', {
      style: (_vm.barColor(item.complete, item.total))
    })]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('app_taskpros')) + "：")]), _vm._v(_vm._s(item.complete) + "/" + _vm._s(item.total) + "\n\n\t\t\t\t\t")], 1)], 1)], 1)
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "gPageBorder gTopMg"
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "height": "100px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "border-bottom": "1px solid rgba(223,230,236,1)"
    }
  }, [_c('tr', _vm._l((_vm.items), function(item, index) {
    return _c('td', {
      staticStyle: {
        "vertical-align": "middle",
        "text-align": "center",
        "width": "16.666%",
        "background": "none",
        "height": "100%",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.clickTd(index)
        }
      }
    }, [(index != 0) ? _c('div', {
      staticStyle: {
        "min-width": "1px",
        "height": "calc(80% - 20px)",
        "background": "rgb(223,230,236)",
        "position": "absolute",
        "float": "left"
      }
    }) : _c('div', {
      staticStyle: {
        "min-width": "1px",
        "height": "calc(80% - 0px)",
        "background": "none",
        "position": "absolute",
        "float": "left"
      }
    }), _vm._v(" "), _c('label', {
      staticStyle: {
        "color": "rgb(72,87,106)",
        "font-size": "20px"
      }
    }, [_vm._v(_vm._s(item.num))]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('label', {
      staticStyle: {
        "color": "#99A9BF"
      }
    }, [_vm._v(_vm._s(item.lb))])])
  }))])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "gSgLeftBtn"
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "disabled": _vm.multipleSelection.length == 0,
      "type": ""
    },
    on: {
      "click": _vm.bcDel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_mulDel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addPush
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.list.add_btn')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.clearn
    }
  }, [_vm._v(_vm._s(_vm.$t('app_clear')))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.taskType != 12),
      expression: "info.taskType != 12"
    }],
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.repushFail
    }
  }, [_vm._v(_vm._s(_vm.$t('app_repushdv')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.exportRc
    }
  }, [_vm._v(_vm._s(_vm.$t('app_outputdv')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.refreshPList
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.shuaxin')))])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "offset": 0,
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_type')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.bindVl),
      callback: function($$v) {
        _vm.bindVl = $$v
      },
      expression: "bindVl"
    }
  }, _vm._l((_vm.bindSts), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_name') + ' & ' + _vm.$t('app_number'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick,
      "sort-change": _vm.sortChange,
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "terminalName",
      "sortable": "custom",
      "label": _vm.$t('app_deviceName'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          staticStyle: {
            "color": "#409EFF",
            "cursor": "pointer"
          }
        }, [_vm._v(_vm._s(scope.row.terminalName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "terminalNo",
      "sortable": "custom",
      "label": _vm.$t('app_deviceNo'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          staticStyle: {
            "color": "#409EFF",
            "cursor": "pointer"
          }
        }, [_vm._v(_vm._s(scope.row.terminalNo))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "terminalModel",
      "label": _vm.$t('lin_global.label_model'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "merchantName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_cursubts'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {}, [_vm._v(_vm._s(_vm.$t('app_subtask') + scope.row.taskNum))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "progress",
      "label": _vm.$t('app_process'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', [_vm._v(_vm._s(scope.row.data ? scope.row.data.result.progress : scope.row.progress) + " %")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.taskStatus == 3 || scope.row.taskStatus == 5 || scope.row.taskStatus == -3),
            expression: "scope.row.taskStatus == 3 || scope.row.taskStatus == 5 || scope.row.taskStatus == -3 "
          }],
          staticStyle: {
            "color": "green",
            "cursor": "pointer"
          }
        }, [_vm._v(_vm._s(_vm.statusNames[scope.row.taskStatus]))]), _vm._v(" "), _c('label', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.taskStatus == 0),
            expression: "scope.row.taskStatus == 0 "
          }],
          staticStyle: {
            "color": "orange",
            "cursor": "pointer"
          }
        }, [_vm._v(_vm._s(_vm.statusNames[scope.row.taskStatus]))]), _vm._v(" "), _c('label', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.taskStatus == -1 || scope.row.taskStatus == -5 || scope.row.taskStatus == -10 || scope.row.taskStatus == -7),
            expression: "scope.row.taskStatus == -1 || scope.row.taskStatus == -5 || scope.row.taskStatus == -10 || scope.row.taskStatus == -7 "
          }],
          staticStyle: {
            "color": "red",
            "cursor": "pointer"
          }
        }, [_vm._v(_vm._s(_vm.statusNames[scope.row.taskStatus]))]), _vm._v(" "), _c('label', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.taskStatus != -1 && scope.row.taskStatus != 0 && scope.row.taskStatus != 3 && scope.row.taskStatus != -5 && scope.row.taskStatus != -10 && scope.row.taskStatus != 5 && scope.row.taskStatus != -3 && scope.row.taskStatus != -7),
            expression: "scope.row.taskStatus != -1 && scope.row.taskStatus != 0 && scope.row.taskStatus != 3 && scope.row.taskStatus != -5  && scope.row.taskStatus != -10 && scope.row.taskStatus != 5 && scope.row.taskStatus != -3 && scope.row.taskStatus != -7"
          }],
          staticStyle: {
            "color": "gray",
            "cursor": "pointer"
          }
        }, [_vm._v(_vm._s(_vm.statusNames[scope.row.taskStatus]))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "updateTime",
      "sortable": "custom",
      "label": _vm.$t('app_pushTime'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', [_vm._v(_vm._s(scope.row.updateTime))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "cancelNums",
      "label": _vm.$t('app_operate'),
      "width": "116"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_pause'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.showBtn(3, scope.row.taskStatus)),
            expression: "showBtn(3, scope.row.taskStatus)"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.downOperate(2, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pause"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_continue'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.showBtn(4, scope.row.taskStatus)),
            expression: "showBtn(4, scope.row.taskStatus)"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.downOperate(1, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-play"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_ccdown'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.showBtn(0, scope.row.taskStatus)),
            expression: "showBtn(0, scope.row.taskStatus)"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.cancelCf(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-window-close"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_global.chongtui'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.showBtn(1, scope.row.taskStatus)),
            expression: "showBtn(1, scope.row.taskStatus)"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.repush(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-repeat"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.showBtn(2, scope.row.taskStatus)),
            expression: "showBtn(2, scope.row.taskStatus)"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.delRow(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv",
    staticStyle: {}
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.page,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageChange,
      "size-change": _vm.pageSize
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "appbind"
    }
  }, [_c('div', {
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "width": "140px",
      "height": "140px",
      "margin": "24px 24px 24px 24px",
      "display": "inline-block",
      "float": "left",
      "overflow": "hidden"
    }
  }, [_c('div', {
    style: (_vm.avtStyle)
  })]), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "calc(100% - 188px)",
      "height": "100%",
      "margin-bottom": "0px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.info ? _vm.info.appName : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "60px"
    }
  }, [_c('table', {
    staticClass: "dt-app"
  }, [_c('tr', [_c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_version')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.info ? _vm.info.appVersion : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_verTag')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.info ? _vm.info.versioncode : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_package')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.info ? _vm.info.packagename : ''))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_appType')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.info ? _vm.info.appCategoryName : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_insType')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.setInstallType(_vm.info.appInstallType)))])]), _vm._v(" "), _c('td')])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-height": "60px",
      "display": "-webkit-flex"
    }
  }, [_c('div', {
    staticClass: "dt-word-title",
    staticStyle: {
      "display": "inline-block",
      "min-width": "70px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('app_introl')) + "：\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "dt-word-main",
    staticStyle: {
      "display": "inline-block",
      "position": "relative",
      "padding": "0 24px 24px 0px"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.info ? _vm.info.appDesc : ''))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder gTopMg",
    attrs: {
      "id": ""
    }
  }, [_c('p', {
    staticClass: "gCtColor gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_pushDevice')))]), _vm._v(" "), _c('el-button', {
    staticClass: "gSgLeftBtn",
    on: {
      "click": _vm.addBind
    }
  }, [_vm._v(_vm._s(_vm.$t('app_addPush')))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.allUnbind()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_mulUnbind')) + " (" + _vm._s(_vm.sNum) + ")")]), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "dpTable",
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalName",
      "align": "center",
      "label": _vm.$t('app_deviceName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_deviceNo'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "align": "center",
      "label": _vm.$t('app_pushTime'),
      "width": "175"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "distributorName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_update'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.isUpdate === '0'),
            expression: "scope.row.isUpdate === '0'"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.updateDv(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-refresh"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_unbind'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-chain-broken"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.page,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-form', {
    ref: "cer",
    staticClass: "gForm",
    attrs: {
      "label-position": "right",
      "rules": _vm.rules,
      "label-width": "12.5%",
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_secrname'),
      "prop": "secretName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.secretName),
      callback: function($$v) {
        _vm.$set(_vm.form, "secretName", $$v)
      },
      expression: "form.secretName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_keyType'),
      "prop": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('app_keyType')
    },
    model: {
      value: (_vm.form.keyType),
      callback: function($$v) {
        _vm.$set(_vm.form, "keyType", $$v)
      },
      expression: "form.keyType"
    }
  }, _vm._l((_vm.keyType_list), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_keyUpIndex'),
      "prop": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('app_keyUpIndex')
    },
    model: {
      value: (_vm.form.encryptionIndex),
      callback: function($$v) {
        _vm.$set(_vm.form, "encryptionIndex", $$v)
      },
      expression: "form.encryptionIndex"
    }
  }, _vm._l((_vm.keyIndex_list), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_keyDlIndex'),
      "prop": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('app_keyDlIndex')
    },
    model: {
      value: (_vm.form.downloadIndex),
      callback: function($$v) {
        _vm.$set(_vm.form, "downloadIndex", $$v)
      },
      expression: "form.downloadIndex"
    }
  }, _vm._l((_vm.keyDown_list), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_Algorithm_mode'),
      "prop": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('app_Algorithm_mode')
    },
    model: {
      value: (_vm.form.algorithmModel),
      callback: function($$v) {
        _vm.$set(_vm.form, "algorithmModel", $$v)
      },
      expression: "form.algorithmModel"
    }
  }, _vm._l((_vm.An_list), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_bdk),
      expression: "show_bdk"
    }],
    attrs: {
      "label": "分量1",
      "prop": ""
    }
  }, [_c('el-input', {
    on: {
      "blur": _vm.is_hidden
    },
    model: {
      value: (_vm.form.component1),
      callback: function($$v) {
        _vm.$set(_vm.form, "component1", $$v)
      },
      expression: "form.component1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分量2",
      "prop": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.component2),
      callback: function($$v) {
        _vm.$set(_vm.form, "component2", $$v)
      },
      expression: "form.component2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('app_submit')))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1068 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.config.callback ? _vm.$t('app_eqcapture') : _vm.$t('app_catchlog'),
      "size": ""
    },
    on: {
      "close": _vm.handleClose
    },
    model: {
      value: (_vm.pushdev),
      callback: function($$v) {
        _vm.pushdev = $$v
      },
      expression: "pushdev"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-row', {}, [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "offset": 0,
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSgLeftBtn"
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.getCmDv
    },
    model: {
      value: (_vm.cmtStatus),
      callback: function($$v) {
        _vm.cmtStatus = $$v
      },
      expression: "cmtStatus"
    }
  }, _vm._l((_vm.cmtStatusArr), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "offset": 0,
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl",
    staticStyle: {
      "padding-left": "8px"
    }
  }, [_c('MechanismSelector', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_terNo'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "dpTable",
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "terminalNo",
      "align": "center",
      "label": _vm.$t('app_terNo'),
      "width": "210"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "210"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalStatus",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "210"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.isNon) ? _c('span', [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_enable')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e()], 1) : _c('span', [_c('tagc', {
          attrs: {
            "tagobj": {
              type: 'terSt',
              vl: scope.row.terminalStatus
            }
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": "210"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "106"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.config.callback ? _vm.$t('app_scapture') : _vm.$t('app_catch'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.catched(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-hand-paper-o"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.page,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_fipush')
    },
    on: {
      "close": _vm.closeImport
    },
    model: {
      value: (_vm.pushImport),
      callback: function($$v) {
        _vm.pushImport = $$v
      },
      expression: "pushImport"
    }
  }, [_c('el-form', {
    ref: "",
    attrs: {
      "model": "",
      "rules": ""
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_ulfile'),
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "name": "fileUpload",
      "action": _vm.importTemplate,
      "on-remove": _vm.handleRemove,
      "before-upload": _vm.srcBefore,
      "on-success": _vm.srcSuccess,
      "on-error": _vm.ulError,
      "file-list": _vm.fileList,
      "auto-upload": true
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v(_vm._s(_vm.$t('app_clickUpdate')))]), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-left": "8px",
      "margin-right": "10px"
    },
    attrs: {
      "href": _vm.downTpl
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "size": "small"
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.list.import_muban')))])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_deviceNum'),
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n          " + _vm._s(_vm.uldata ? _vm.uldata.terNums : 0 + _vm.$t('app_amechine')) + "\n        ")])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.pushImport = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "disabled": !_vm.uldata,
      "type": "primary"
    },
    on: {
      "click": _vm.submitUpload
    }
  }, [_vm._v(_vm._s(_vm.$t('app_srpush')))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ae"
    }
  }, [_c('div', {
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "width": "140px",
      "height": "140px",
      "margin": "24px 24px 24px 24px",
      "display": "inline-block",
      "float": "left",
      "overflow": "hidden"
    }
  }), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "calc(100% - 188px)",
      "height": "100%",
      "margin-bottom": "0px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.data.appName : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "60px"
    }
  }, [_c('table', {
    staticClass: "dt-app"
  }, [_c('tr', [_c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_version')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.data.appVersion : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_verTag')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.data.versioncode : ''))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_appType')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config.data.appCategoryName))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_package')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.data.packagename : ''))])]), _vm._v(" "), _c('td')])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-height": "60px",
      "display": "-webkit-flex"
    }
  }, [_c('div', {
    staticClass: "dt-word-title",
    staticStyle: {
      "display": "inline-block",
      "min-width": "70px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('app_introl')) + "：\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "dt-word-main",
    staticStyle: {
      "display": "inline-block",
      "position": "relative",
      "background": "none",
      "margin": "0 24px 24px 0"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.config.data.appDesc))])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.captures ? _vm.captures.length > 0 : false),
      expression: "captures? captures.length > 0 : false"
    }],
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gCtColor  gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_screenShot')) + " ")]), _vm._v(" "), _c('div', _vm._l((_vm.captures), function(item) {
    return _c('img', {
      staticClass: "gBorder",
      staticStyle: {
        "width": "180px",
        "height": "320px",
        "margin": "24px 0 24px 24px",
        "border-radius": "4px"
      },
      attrs: {
        "onerror": "this.src='/static/img/df-h.png'",
        "src": _vm.imgFullUrl(item)
      }
    })
  }))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.type === 2 && _vm.config.isHistory),
      expression: "config.type === 2 && config.isHistory"
    }],
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gCtColor gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_hisVer')) + " ")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUploadNew),
      expression: "showUploadNew"
    }],
    staticStyle: {
      "margin": "24px 0 24px 24px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.uploadNew
    }
  }, [_vm._v(_vm._s(_vm.$t('app_ulNew')))]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appName",
      "label": _vm.$t('app_appName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appVersion",
      "width": "",
      "label": _vm.$t('app_version')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appCategoryName",
      "width": "",
      "label": _vm.$t('app_type')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "formatter": _vm.dateFormat,
      "prop": "createTime",
      "width": "170",
      "label": _vm.$t('app_createTime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "",
      "width": "90",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.config.data.isoperation === 0),
            expression: "config.data.isoperation === 0"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteAppHis(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ae"
    }
  }, [_c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_tobenimportdv')
    },
    on: {
      "open": _vm.open,
      "close": _vm.close
    },
    model: {
      value: (_vm.isAddInfo),
      callback: function($$v) {
        _vm.isAddInfo = $$v
      },
      expression: "isAddInfo"
    }
  }, [_c('div', [_c('el-form', {
    ref: "iform",
    attrs: {
      "rules": _vm.iRules,
      "model": _vm.addInfo
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "14.5%"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.numTip))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "14.5%",
      "label": _vm.$t('app_firm'),
      "prop": "firm"
    }
  }, [_c('el-select', {
    attrs: {
      "id": "terminal_type",
      "filterable": "",
      "clearable": "",
      "placeholder": _vm.$t('terminal.add.place_manufid')
    },
    model: {
      value: (_vm.addInfo.firmarr),
      callback: function($$v) {
        _vm.$set(_vm.addInfo, "firmarr", $$v)
      },
      expression: "addInfo.firmarr"
    }
  }, _vm._l((_vm.firms), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "14.5%",
      "label": _vm.$t('lin_global.label_type'),
      "prop": "type"
    }
  }, [_c('el-select', {
    attrs: {
      "id": "terminal_type",
      "filterable": "",
      "clearable": "",
      "placeholder": _vm.$t('terminal.add.place_type')
    },
    model: {
      value: (_vm.addInfo.typearr),
      callback: function($$v) {
        _vm.$set(_vm.addInfo, "typearr", $$v)
      },
      expression: "addInfo.typearr"
    }
  }, _vm._l((_vm.dvTypes), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "14.5%",
      "label": _vm.$t('lin_global.label_model'),
      "prop": "no"
    }
  }, [_c('el-select', {
    attrs: {
      "id": "terminal_model",
      "filterable": "",
      "clearable": "",
      "placeholder": _vm.$t('terminal.add.place_model')
    },
    model: {
      value: (_vm.addInfo.noarr),
      callback: function($$v) {
        _vm.$set(_vm.addInfo, "noarr", $$v)
      },
      expression: "addInfo.noarr"
    }
  }, _vm._l((_vm.models), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "14.5%",
      "label": _vm.$t('app_addres'),
      "prop": "address"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addInfo.address),
      callback: function($$v) {
        _vm.$set(_vm.addInfo, "address", $$v)
      },
      expression: "addInfo.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "14.5%"
    }
  }, [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": function($event) {
        _vm.isAddInfo = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.importOrder
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.list.import_btn')))])], 1)], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('terminal.list.import_title'),
      "size": "tiny",
      "top": "15%",
      "show-close": !_vm.importIsSubmit
    },
    model: {
      value: (_vm.importTermVisible),
      callback: function($$v) {
        _vm.importTermVisible = $$v
      },
      expression: "importTermVisible"
    }
  }, [_c('el-form', {
    ref: "importForm",
    staticClass: "gDiaTable",
    staticStyle: {
      "background": "none"
    },
    attrs: {
      "model": _vm.importForm,
      "id": "importForm",
      "label-width": "",
      "enctype": "multipart/form-data"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "uploadify",
      "rules": [{
        required: true,
        message: this.$t('lin_global.qxzscwj')
      }]
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "name": "fileUpload",
      "action": _vm.action,
      "xxxon-preview": "handlePreview",
      "file-list": _vm.fileList,
      "show-file-list": false,
      "on-success": _vm.handleAvatarScucess,
      "auto-upload": false,
      "on-remove": _vm.rmFile,
      "on-change": _vm.beforeUpload
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v(_vm._s(_vm.$t('terminal.list.xqwj')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "disabled": !_vm.exFileName,
      "size": "small",
      "type": "success"
    },
    on: {
      "click": _vm.submitUpload
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.list.qrdr')))]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.$t('terminal.list.excel_tips')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticStyle: {
      "font-size": "13px"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('app_filename')) + ":")]), _vm._v("  "), _c('label', [_vm._v(_vm._s(_vm.exFileName))])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "href": _vm.importTemplate
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.list.import_muban')))])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "id": "cancelBtn"
    },
    on: {
      "click": _vm.exCancel
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.cancel')))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_lineimportdevice'),
      "size": "small"
    },
    model: {
      value: (_vm.showDvDia),
      callback: function($$v) {
        _vm.showDvDia = $$v
      },
      expression: "showDvDia"
    }
  }, [_c('div', {
    staticClass: "gBorder",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "gSgLeftBtn"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.orderselecet.length == 0,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showDvDia = false;
        _vm.isAddInfo = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_importslorder')))])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_customername'),
      "icon": "search",
      "on-icon-click": _vm.queryOrder
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.queryOrder($event)
      }
    },
    model: {
      value: (_vm.cusEvent),
      callback: function($$v) {
        _vm.cusEvent = $$v
      },
      expression: "cusEvent"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_orderno'),
      "icon": "search",
      "on-icon-click": _vm.queryOrder
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.queryOrder($event)
      }
    },
    model: {
      value: (_vm.orderEvent),
      callback: function($$v) {
        _vm.orderEvent = $$v
      },
      expression: "orderEvent"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "data": _vm.pageOrders,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick,
      "selection-change": _vm.orderSelected
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "orderNo",
      "label": _vm.$t('app_orderno'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "customerName",
      "label": _vm.$t('app_customername'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "terminalNum",
      "label": _vm.$t('app_deviceNum'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "orderCompleteTime",
      "width": "172",
      "label": _vm.$t('app_orderfinishdate')
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.pageOrder,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pageOrderTotal
    },
    on: {
      "current-change": _vm.pageOrderChange,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_plimportcer'),
      "size": "small"
    },
    model: {
      value: (_vm.showCerDia),
      callback: function($$v) {
        _vm.showCerDia = $$v
      },
      expression: "showCerDia"
    }
  }, [_c('div', {
    staticClass: "gBorder",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('div', {
    staticClass: "gSgLeftBtn"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.cerselecet
    },
    on: {
      "click": _vm.importCus
    }
  }, [_vm._v(_vm._s(_vm.$t('app_importslcustomer')))])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_customername') + ' & ' + _vm.$t('app_customerno'),
      "icon": "search",
      "on-icon-click": _vm.queryCers
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.queryCers($event)
      }
    },
    model: {
      value: (_vm.cerEvent),
      callback: function($$v) {
        _vm.cerEvent = $$v
      },
      expression: "cerEvent"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    ref: "singleTable",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "highlight-current-row": "",
      "data": _vm.pageCers,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick,
      "current-change": _vm.selectedCer
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "certificateName",
      "label": _vm.$t('lin_global.certificateName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "certificateType",
      "label": _vm.$t('lin_global.certTypeLabel'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.certificateType == 0) ? _c('label', [_vm._v(_vm._s(_vm.$t('app_cerMgSelf')))]) : _vm._e(), _vm._v(" "), (scope.row.certificateType == 1) ? _c('label', [_vm._v(_vm._s(_vm.$t('app_cerMgOther')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "customerName",
      "label": _vm.$t('app_customername'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "customerNo",
      "width": "172",
      "label": _vm.$t('app_customerno')
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.pageCer,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pageCerTotal
    },
    on: {
      "current-change": _vm.pageCerChange,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "background": "white",
      "display": "inline-block",
      "width": "calc(100% - 40px)",
      "height": "100%",
      "padding": "0 20px 0 20px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-mc-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.info ? _vm.info.mechanismname : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "60px"
    }
  }, [_c('table', {
    staticClass: "dt-mc-app"
  }, [_c('tr', [_c('td', [_c('label', {
    staticClass: "dt-mc-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_channellevel')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-mc-word-main"
  }, [_vm._v(_vm._s(_vm.info ? _vm.info.mechanismgrade : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-mc-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_dParent')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-mc-word-main"
  }, [_vm._v(_vm._s(_vm.info ? _vm.info.memo : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-mc-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_cerType')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-mc-word-main"
  }, [_vm._v("\n                " + _vm._s(_vm.info ? _vm.cerTypes[_vm.info.certType] : '') + "\n              ")])]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticClass: "dt-mc-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_contact')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-mc-word-main"
  }, [_vm._v(_vm._s(_vm.info ? _vm.info.completename : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-mc-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_contactPhone')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-mc-word-main"
  }, [_vm._v(_vm._s(_vm.info ? _vm.info.mechanismcode : ''))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', {
    staticClass: "dt-mc-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_addres')) + "：")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.info ? _vm.info.mechanismaddre : ''))])]), _vm._v(" "), _c('td')])])])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowModel),
      expression: "isShowModel"
    }]
  }, [_c('div', {
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gCtColor gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_cermanage')) + " ")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUploadNew),
      expression: "showUploadNew"
    }],
    staticStyle: {
      "margin": "24px 0 24px 24px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.uploadCer
    }
  }, [_vm._v(_vm._s(_vm.$t('app_uploadCer')))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUploadNew),
      expression: "showUploadNew"
    }],
    staticStyle: {
      "margin": "24px 0 24px 10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.lineImportCer
    }
  }, [_vm._v(_vm._s(_vm.$t('app_lineimportcer')))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUploadNew),
      expression: "showUploadNew"
    }],
    staticStyle: {
      "margin": "24px 0 24px 10px"
    },
    attrs: {
      "disabled": _vm.cers.length == 0,
      "type": "primary"
    },
    on: {
      "click": _vm.delCer
    }
  }, [_vm._v(_vm._s(_vm.$t('app_delcer')))]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.cers,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "certificateName",
      "label": _vm.$t('lin_global.certificateName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "certificateType",
      "width": "",
      "label": _vm.$t('app_cerType')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', [_vm._v(_vm._s(_vm.cerTypes[scope.row.certificateType]))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "md5",
      "width": "",
      "label": "MD5"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "fformatter": "dateFormat",
      "prop": "createTime",
      "width": "170",
      "label": _vm.$t('app_createTime')
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gCtColor gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_devicemanage')) + " ")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUploadNew),
      expression: "showUploadNew"
    }],
    staticStyle: {
      "margin": "24px 0 24px 24px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.importDvFile
    }
  }, [_vm._v(_vm._s(_vm.$t('app_fileimportdevice')))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUploadNew),
      expression: "showUploadNew"
    }],
    staticStyle: {
      "margin": "24px 0 24px 10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.lineImportDv
    }
  }, [_vm._v(_vm._s(_vm.$t('app_lineimportdevice')))]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dvs,
      "border": ""
    },
    on: {
      "sort-change": _vm.sortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_deviceName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "sortable": "custom",
      "prop": "terminalNo",
      "width": "",
      "label": _vm.$t('app_deviceNo')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "terminalModelName",
      "width": "",
      "label": _vm.$t('app_prodmodel')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "sortable": "custom",
      "ffformatter": "dateFormat",
      "prop": "terminalCreateTime",
      "width": "170",
      "label": _vm.$t('app_addtime')
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.dvPage,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.dvTotal
    },
    on: {
      "current-change": _vm.dvChange,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)]), _vm._v(" "), _c('ssub', {
    staticClass: "gTopMg",
    attrs: {
      "tmcid": _vm.premcid
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1071 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": "myApp"
    }
  }, [_c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('terminal.list.import_btn')
    },
    model: {
      value: (_vm.ipDialog),
      callback: function($$v) {
        _vm.ipDialog = $$v
      },
      expression: "ipDialog"
    }
  }, [_c('el-form', {
    ref: "",
    staticClass: "gForm",
    attrs: {
      "label-position": "right",
      "rules": _vm.rules,
      "label-width": "20.5%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_file'),
      "prop": "name"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.downm
    }
  }, [_vm._v(_vm._s(_vm.$t('app_downtpl')))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('terminal.list.import_btn'),
      "prop": "url"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "name": "fileUpload",
      "action": _vm.fileUploadUrl,
      "before-upload": _vm.srcBefore,
      "on-success": _vm.srcSuccess,
      "file-list": _vm.srcList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "",
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_clickUpdate')))]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.$t('terminal.list.excel_tips')) + " ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "gSgLeftBtn"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.list.add_btn')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.importDv
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.list.import_btn')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": _vm.multipleSelection.length == 0
    },
    on: {
      "click": _vm.bcdel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_mulDel')))])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('MechanismSelector', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "油机状态"
    },
    on: {
      "change": _vm.stChange
    },
    model: {
      value: (_vm.statusVl),
      callback: function($$v) {
        _vm.statusVl = $$v
      },
      expression: "statusVl"
    }
  }, _vm._l((_vm.sstatusAr), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "offset": 0,
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_name') + '&' + _vm.$t('app_number'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('lin_global.dest_status')
    },
    on: {
      "change": _vm.stChange
    },
    model: {
      value: (_vm.activeStatus),
      callback: function($$v) {
        _vm.activeStatus = $$v
      },
      expression: "activeStatus"
    }
  }, _vm._l((_vm.dest_list), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1)])], 1), _vm._v(" "), _c('div', [_c('el-table', {
    ref: "multipleTable",
    staticClass: "tbPoint gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "row-click": _vm.cellClick,
      "sort-change": _vm.sortChange,
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "sortable": "custom",
      "prop": "terminalName",
      "label": _vm.$t('app_deviceName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "sortable": "custom",
      "label": _vm.$t('app_deviceNo'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalStatus",
      "formatter": _vm.mkDvSt,
      "label": _vm.$t('app_status'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "modelName",
      "label": _vm.$t('app_model'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "typeName",
      "label": _vm.$t('app_type'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "activeStatus",
      "label": _vm.$t('lin_global.dest_status'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "custom",
      "align": "center",
      "prop": "updateTime",
      "width": "106",
      "label": _vm.$t('terminal.list.ztgxsj')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "align": "center",
      "label": _vm.$t('app_operate'),
      "width": "86"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.del(scope.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.page,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1072 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m_context"
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "24px"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.pushAction(0)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_mulPush'))), _c('span', [_vm._v("(" + _vm._s(_vm.multipleSelection.length || 0) + ")")])]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.pushAction(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_pushAll')))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.pushAction(2)
      }
    }
  }, [_vm._v("文件导入推送")]), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$t('app_rsfivemin'),
      "placement": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": ""
    },
    on: {
      "click": _vm.shuaxin
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('lin_global.shuaxin')))])], 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "24px"
    }
  }, [_c('MechanismSelector', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "16px",
      "margin-right": "16px"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": ""
    },
    on: {
      "change": _vm.statusChange
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  }, _vm._l((_vm.options2), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding-right": "24px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('div', [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('lin_global.label_no') + '、' + _vm.$t('app_name'),
      "icon": "search",
      "on-icon-click": _vm.handleIconClick
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.focusEvent(_vm.handleIconClick)
      }
    },
    model: {
      value: (_vm.dvName),
      callback: function($$v) {
        _vm.dvName = $$v
      },
      expression: "dvName"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-row'), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "arrdata",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.arrdata,
      "id": "tp",
      "border": "",
      "element-loading-text": _vm.$t('lin_global.loading')
    },
    on: {
      "selection-change": _vm.handleSelectionChange,
      "sort-change": _vm.sortChane
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalName",
      "sortable": "",
      "label": _vm.$t('lin_global.label_name')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalNo",
      "label": _vm.$t('lin_global.label_no'),
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('lin_global.ter_status'),
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.new_add')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 3) ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_sleep')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mechName",
      "label": _vm.$t('lin_global.label_areaid'),
      "width": "220"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "page_content"
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 50, 100],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_pushAll'),
      "size": "tiny",
      "top": "15%",
      "show-close": true
    },
    model: {
      value: (_vm.hasCoverWarn),
      callback: function($$v) {
        _vm.hasCoverWarn = $$v
      },
      expression: "hasCoverWarn"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.tipMessage))]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.hasCoverWarn = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.confirmToPush(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.details.cover_send')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "info"
    },
    on: {
      "click": function($event) {
        _vm.confirmToPush(0)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.details.skip_send')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_pushAll'),
      "size": "tiny",
      "top": "15%",
      "show-close": true
    },
    model: {
      value: (_vm.uploadModalShow),
      callback: function($$v) {
        _vm.uploadModalShow = $$v
      },
      expression: "uploadModalShow"
    }
  }, [_c('el-form', {
    ref: "addForm",
    staticClass: "gForm",
    attrs: {
      "id": "addForm",
      "model": _vm.form,
      "label-width": "12.5%"
    }
  }, [_c('el-form-item', [_c('div', [_vm._v(_vm._s(_vm.$t('app_mdFile')))]), _vm._v(" "), _c('a', {
    staticClass: "aSc",
    attrs: {
      "href": _vm.downUrl,
      "title": _vm.$t('app_downExp'),
      "target": "_blank"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('app_downTplFile')) + "\n        ")]), _vm._v(" "), _c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "name": "fileUpload",
      "action": _vm.fileUploadUrl,
      "before-upload": _vm.srcBefore,
      "on-success": _vm.srcSuccess,
      "file-list": _vm.srcList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_clickUpdate')))])], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('div', [_vm._v(_vm._s(_vm.$t('app_deviceNum')))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.dvNum) + _vm._s(_vm.$t('app_amechine')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.uploadModalShow = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "info"
    },
    on: {
      "click": _vm.doUploadPush
    }
  }, [_vm._v("确认推送")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ae"
    }
  }, [_c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_addPush'),
      "size": "middle"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    staticClass: "gDiaTable",
    staticStyle: {
      "width": "100%",
      "background": "none",
      "text-align": "left"
    }
  }, [_c('span'), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticStyle: {
      "margin-right": "16px"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.stModel), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.label,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "40%",
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": _vm.$t('app_searchTerminal'),
      "icon": "search"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srchDevice($event)
      }
    },
    model: {
      value: (_vm.srchValue),
      callback: function($$v) {
        _vm.srchValue = $$v
      },
      expression: "srchValue"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dLoading),
      expression: "dLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_terNo'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminal_status",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 3) ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_sleep')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_push'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_banReason')
    },
    model: {
      value: (_vm.notPassDialog),
      callback: function($$v) {
        _vm.notPassDialog = $$v
      },
      expression: "notPassDialog"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_reason'),
      "label-width": "14%"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.notPassDialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.verifyRqs('3')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_submit')))])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "gPageBorder "
  }, [_c('p', {
    staticClass: "gCtColor gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_baseInfo')) + " ")]), _vm._v(" "), _c('el-row', {
    staticClass: "gPdTB"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "15%"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "calc(100% - 10px)"
    },
    attrs: {
      "label": _vm.$t('lin_global.risk_name')
    }
  }, [_vm._v("\n                " + _vm._s(_vm.config ? _vm.config.name : '') + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_version')
    }
  }, [_vm._v("\n                " + _vm._s(_vm.config ? _vm.config.version : '') + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_filetag')
    }
  }, [_vm._v("\n                " + _vm._s(_vm.config ? _vm.config.flag : '') + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "15%"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "calc(100% - 10px)"
    },
    attrs: {
      "label": _vm.$t('app_filestss')
    }
  }, [_vm._v("\n                " + _vm._s(_vm.config ? _vm.config.memo : '') + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "15%"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "calc(100% - 10px)"
    },
    attrs: {
      "label": _vm.$t('app_excludeapp')
    }
  }, _vm._l((_vm.tags), function(item, index) {
    return _c('el-tag', {
      key: index,
      attrs: {
        "type": "primary"
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "none",
      "padding": "0 0px 24px 0px",
      "margin-left": "20px"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.$router.go(-1);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.verify('2')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_psverify')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.verify('3')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_ban')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_pushInstallTest')))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1074 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "background": "white"
    }
  }, [_c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  }), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_adddv'),
      "size": ""
    },
    on: {
      "close": _vm.closeAddTer
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 4,
      "gutter": 10
    }
  }, [_c('div', {}, [_c('el-button', {
    attrs: {
      "disabled": _vm.multipleSelection.length == 0,
      "type": "primary"
    },
    on: {
      "click": _vm.bcbind
    }
  }, [_vm._v(_vm._s(_vm.$t('app_mulAdd')))])], 1)]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "offset": 2,
      "span": 6,
      "gutter": 20
    }
  }, [_c('div', {
    staticStyle: {
      "padding-right": "8px"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.srchDevice
    },
    model: {
      value: (_vm.cmtStatus),
      callback: function($$v) {
        _vm.cmtStatus = $$v
      },
      expression: "cmtStatus"
    }
  }, _vm._l((_vm.cmtStatusArr), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "offset": 0,
      "span": 6,
      "gutter": 20
    }
  }, [_c('div', {}, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData1
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticStyle: {
      "padding-left": "8px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_searchTerminal'),
      "icon": "search",
      "on-icon-click": _vm.srchDevice
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srchDevice($event)
      }
    },
    model: {
      value: (_vm.srchValue),
      callback: function($$v) {
        _vm.srchValue = $$v
      },
      expression: "srchValue"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_terNo'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminal_status",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 3) ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_sleep')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_add'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-plus"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editApp
    }
  }, [_vm._v(_vm._s(_vm.$t('app_editblls')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "gPageBorder gTopMg"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "calc(100% - 48px)",
      "height": "100%",
      "margin-bottom": "0px",
      "background": "none",
      "padding": "0 0px 12px 24px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.name : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20px"
    }
  }, [_c('table', {
    staticClass: "lcpush"
  }, [_c('tr', [_c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_filename')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.url.split('/').pop() : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_filetag')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.flag : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_filedesc')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.memo : ''))])]), _vm._v(" "), _c('td')])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gCtColor gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_blsdvlist')) + " ")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "gSgLeftBtn"
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "disabled": _vm.istotal,
      "type": "primary"
    },
    on: {
      "click": _vm.addTer
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.list.add_btn')))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.getList()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.shuaxin')))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "disabled": _vm.multipleSelection1 == 0,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.bcdel()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_mulDel')))]), _vm._v("\n              \n            "), _c('el-checkbox', {
    on: {
      "change": _vm.clickTotal
    },
    model: {
      value: (_vm.istotal),
      callback: function($$v) {
        _vm.istotal = $$v
      },
      expression: "istotal"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_allUpdate')))])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_type')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.bindVl),
      callback: function($$v) {
        _vm.bindVl = $$v
      },
      expression: "bindVl"
    }
  }, _vm._l((_vm.bindSts), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_name') + ' & ' + _vm.$t('app_number'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.hiss,
      "border": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange1
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_deviceName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "terminalNo",
      "width": "",
      "label": _vm.$t('app_deviceNo')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "mechName",
      "width": "",
      "label": _vm.$t('app_distributor')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "version",
      "formatter": _vm.showBindSt,
      "width": "",
      "label": _vm.$t('app_appconfigst')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "fformatter": "dateFormat",
      "prop": "updateTime",
      "width": "170",
      "label": _vm.$t('app_udtime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "",
      "width": "86",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status != 1),
            expression: "scope.row.status != 1"
          }],
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.unbind(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv",
    staticStyle: {}
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.page,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pageTotal
    },
    on: {
      "current-change": _vm.pageChange,
      "size-change": _vm.pageSize
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1075 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-resize-bar"
  }, [_c('div', {
    staticClass: "g-resize-highlight",
    style: ({
      width: _vm.left + '%',
    })
  }), _vm._v(" "), _c('button', {
    staticClass: "circle-btn",
    style: ({
      left: _vm.left + '%',
    }),
    on: {
      "touchstart": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.drag($event)
      },
      "mousedown": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.drag($event)
      }
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1076 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "gPageBorder"
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "24px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCerUpload),
      expression: "isCerUpload"
    }],
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.uploadCer
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t('app_upload')) + _vm._s(_vm.$t('lin_global.zhengshu')) + "\n\t\t\t\t\t")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "offset": 4,
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_type')
    },
    on: {
      "change": _vm.query
    },
    model: {
      value: (_vm.ctype),
      callback: function($$v) {
        _vm.ctype = $$v
      },
      expression: "ctype"
    }
  }, _vm._l((_vm.ctyps), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_name'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "data": _vm.tableData2,
      "id": "tp",
      "border": ""
    },
    on: {
      "sort-change": _vm.sortChange,
      "row-click": _vm.rowClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "certificateName",
      "sortable": "custom",
      "label": _vm.$t('lin_global.certificateName')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "certificateDesc",
      "label": _vm.$t('lin_global.remark')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "distributorName",
      "label": _vm.$t('lin_global.label_areaid')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "certificateType",
      "label": _vm.$t('terminal.details.animatType'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.certificateType == '2') ? _c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.cszss')) + "\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (scope.row.certificateType == '1') ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.khzss')) + "\n\t\t\t\t\t\t")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "sortable": "custom",
      "label": _vm.$t('lin_global.createTime'),
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "left",
      "label": _vm.$t('lin_global.ope'),
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_global.xiafa'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.xiafaRow(scope.row.certificateName, scope.row.certificateType, scope.row.distributorid, scope.row.distributorName, scope.row.certificateId, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-download"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_global.daochugongyao'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.importRow(scope.row.url)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-share-square"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [(_vm.isCreate || (!_vm.isCreate && scope.row.certificateType !== '2')) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.deleteRow(scope.row.certificateId)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          staticStyle: {
            "color": "#FF4949"
          }
        })]) : _vm._e()], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.totalRecords > 0) ? _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 50, 100],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('lin_global.xiafa')
    },
    model: {
      value: (_vm.xiafaVisible),
      callback: function($$v) {
        _vm.xiafaVisible = $$v
      },
      expression: "xiafaVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    staticClass: "gDiaTable",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "22.5%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.certificateName')
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.zhengshu) + "\n\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.qudaoshangxinxi')
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.qudaoshangxinxi) + "\n\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.tslxxx')
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.changeType
    },
    model: {
      value: (_vm.form.pushType),
      callback: function($$v) {
        _vm.$set(_vm.form, "pushType", $$v)
      },
      expression: "form.pushType"
    }
  }, _vm._l((_vm.type), function(item) {
    return _c('el-option', {
      key: item.typeid,
      attrs: {
        "label": item.typename,
        "value": item.typeid
      }
    })
  }))], 1), _vm._v(" "), (_vm.isShow) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_areaid'),
      "prop": "terminalNo"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": _vm.$t('lin_global.place_areaid')
    },
    model: {
      value: (_vm.form.terminalNo),
      callback: function($$v) {
        _vm.$set(_vm.form, "terminalNo", $$v)
      },
      expression: "form.terminalNo"
    }
  }, _vm._l((_vm.areaList), function(item) {
    return _c('el-option', {
      key: item.mechanismid,
      attrs: {
        "label": item.mechanismname,
        "value": item.mechanismid
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (!_vm.isShow) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_no'),
      "prop": "terminalNo"
    }
  }, [_c('AutoTerno', {
    on: {
      "on-result-change": _vm.onDvInputChange
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "margin-right": "74%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.isSubmit
    },
    on: {
      "click": _vm.xiafaSubmit
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t('lin_global.xiafa')) + "\n\t\t\t\t\t")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1077 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showInput
    }
  }, [_vm._v(_vm._s(_vm.$t('app_addadtype')))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick,
      "sort-change": _vm.sortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "sortable": "custom",
      "prop": "adtypeName",
      "label": _vm.$t('app_typeName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "operate",
      "width": "",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_edit'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.edit(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.del(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('advert.classify')
    },
    on: {
      "open": _vm.open,
      "close": _vm.close
    },
    model: {
      value: (_vm.dialogFormVisible),
      callback: function($$v) {
        _vm.dialogFormVisible = $$v
      },
      expression: "dialogFormVisible"
    }
  }, [_c('div', [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label-width": "14.5%",
      "label": _vm.$t('app_typeName')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "14.5%"
    }
  }, [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sure
    }
  }, [_vm._v(_vm._s(_vm.$t('app_sure')))])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1078 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.jump('/roleManager/roleAdd')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menuConfig.role.addRole')))])], 1)], 1), _vm._v(" "), _c('el-table', {
    ref: "arrdata",
    attrs: {
      "data": _vm.dataList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "rolename",
      "label": _vm.$t('menuConfig.role.name'),
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "memo",
      "label": _vm.$t('menuConfig.role.mark'),
      "width": "250"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('menuConfig.role.model')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((_vm.rights[scope.$index]), function(item, index) {
          return (item) ? _c('el-tag', {
            key: index,
            attrs: {
              "type": "primary"
            }
          }, [_vm._v(_vm._s(item))]) : _vm._e()
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('app_operate'),
      "width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.roleid !== '165d6769-2ff9-4ee0-9edc-be17e52eed07') ? [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('mao_global.btn.edit'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.editRow(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('menuConfig.role.updatePermission'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.jump('/roleManager/roleUpdate/' + scope.row.roleid)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-key"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_roleAllot'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.showRoleDialog(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-user"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('mao_global.btn.delete'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.deleteRow(scope.row.roleid, scope.row.rolename, scope.$index)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)] : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('menuConfig.role.editRole'),
      "visible": _vm.editInfoVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.editInfoVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "id": "editForm",
      "model": _vm.editInfoPreViewData,
      "rules": _vm.editRules
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editInfoPreViewData.roleId),
      expression: "editInfoPreViewData.roleId"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.editInfoPreViewData.roleId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editInfoPreViewData, "roleId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('menuConfig.role.name'),
      "label-width": "120",
      "prop": "roleName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editInfoPreViewData.roleName),
      callback: function($$v) {
        _vm.$set(_vm.editInfoPreViewData, "roleName", $$v)
      },
      expression: "editInfoPreViewData.roleName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "描述",
      "label-width": "120",
      "prop": "memo"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.editInfoPreViewData.memo),
      callback: function($$v) {
        _vm.$set(_vm.editInfoPreViewData, "memo", $$v)
      },
      expression: "editInfoPreViewData.memo"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editInfoVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.updateRoleInfo()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.ok')))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_roleAllot'),
      "visible": _vm.roleAllot
    },
    on: {
      "update:visible": function($event) {
        _vm.roleAllot = $event
      }
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.roleSubList,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "roleName",
      "label": _vm.$t('app_roleName'),
      "width": ""
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.savePermission()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_sure')))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "id": "m404"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "10rem"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(761)
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "color": "#848D99",
      "font-size": "30px",
      "font-weight": "bold",
      "font-family": "SimHei"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('app_norightview')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/'
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_bth')))])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1080 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-form', {
    ref: "firm",
    staticClass: "gForm",
    attrs: {
      "label-position": "right",
      "rules": _vm.rules,
      "label-width": "18%",
      "model": _vm.firm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_psgname'),
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.firm.name),
      callback: function($$v) {
        _vm.$set(_vm.firm, "name", $$v)
      },
      expression: "firm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_distributor'),
      "prop": "mech"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_cbackad'),
      "prop": "callback"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.firm.callback),
      callback: function($$v) {
        _vm.$set(_vm.firm, "callback", $$v)
      },
      expression: "firm.callback"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_bsrqsadwl'),
      "prop": "addr"
    }
  }, [_vm._l((_vm.dynamicTags_ip), function(tag) {
    return _c('el-tag', {
      key: tag,
      attrs: {
        "type": "primary",
        "closable": true,
        "close-transition": false
      },
      on: {
        "close": function($event) {
          _vm.handleCloseIP(tag)
        }
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(tag) + "\n\t\t\t\t")])
  }), _vm._v(" "), (_vm.inputVisible_ip) ? _c('el-input', {
    ref: "saveTagInput_ip",
    staticClass: "input-new-tag",
    attrs: {
      "size": "mini"
    },
    on: {
      "blur": _vm.handleInputConfirmIP
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleInputConfirmIP($event)
      }
    },
    model: {
      value: (_vm.inputValue_ip),
      callback: function($$v) {
        _vm.inputValue_ip = $$v
      },
      expression: "inputValue_ip"
    }
  }) : _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.showInputIP
    }
  }, [_vm._v("      +" + _vm._s(_vm.$t('app_addaddr')) + "      ")])], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_appwtls'),
      "prop": ""
    }
  }, [_vm._l((_vm.dynamicTags), function(tag) {
    return _c('el-tag', {
      key: tag,
      attrs: {
        "type": "primary",
        "closable": true,
        "close-transition": false
      },
      on: {
        "close": function($event) {
          _vm.handleClose(tag)
        }
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(tag) + "\n\t\t\t\t")])
  }), _vm._v(" "), (_vm.inputVisible) ? _c('el-input', {
    ref: "saveTagInput",
    staticClass: "input-new-tag",
    attrs: {
      "size": "mini"
    },
    on: {
      "blur": _vm.handleInputConfirm
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleInputConfirm($event)
      }
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  }) : _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.showInput
    }
  }, [_vm._v("      +" + _vm._s(_vm.$t('app_addapppgkn')) + "      ")])], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_authstat'),
      "prop": ""
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.firm.authst),
      callback: function($$v) {
        _vm.$set(_vm.firm, "authst", $$v)
      },
      expression: "firm.authst"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_open1')))]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.firm.authst),
      callback: function($$v) {
        _vm.$set(_vm.firm, "authst", $$v)
      },
      expression: "firm.authst"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_close')))])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save('firm')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_save')))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1081 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('app_tip'),
      "visible": _vm.cerDialogVisible,
      "size": "tiny",
      "before-close": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.cerDialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.cerTipMsg))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.cerDialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.pushUploadCer
    }
  }, [_vm._v(_vm._s(_vm.$t('app_uploadCer')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('app_tip'),
      "visible": _vm.cerTipDialogVisible,
      "size": "tiny",
      "before-close": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.cerTipDialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.cerTipMsg))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.cerTipDialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_sure')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_addPush'),
      "size": "middle"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dvLoading),
      expression: "dvLoading"
    }]
  }, [_c('div', {
    staticClass: "gDiaTable",
    staticStyle: {
      "width": "100%",
      "background": "none",
      "text-align": "left"
    }
  }, [_c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_distributor')
    },
    on: {
      "change": _vm.selectDvChange
    },
    model: {
      value: (_vm.channelId),
      callback: function($$v) {
        _vm.channelId = $$v
      },
      expression: "channelId"
    }
  }, _vm._l((_vm.channels), function(item) {
    return _c('el-option', {
      key: item.mechanismid,
      attrs: {
        "label": item.mechanismname,
        "value": item.mechanismid
      }
    })
  }))], 1), _vm._v(" "), _c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.selectDvChange
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.stModel), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.label,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "40%",
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": _vm.$t('app_searchTerminal'),
      "icon": "search"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srchDevice($event)
      }
    },
    model: {
      value: (_vm.srchValue),
      callback: function($$v) {
        _vm.srchValue = $$v
      },
      expression: "srchValue"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dvTableData,
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminal_status",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "right",
      "header-align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_push'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.dvIndex,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.dvTotal
    },
    on: {
      "current-change": _vm.pageDvSelect,
      "size-change": _vm.pageDvSized
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('div', {}, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.jumpToUpload
    }
  }, [_vm._v(_vm._s(_vm.$t('app_addfile')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "offset": 8,
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_name'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)])], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    staticClass: "tbPoint gTopMg",
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "fileName",
      "label": _vm.$t('app_appName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "fileVersion",
      "width": "",
      "label": _vm.$t('app_version')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "mechName",
      "width": "",
      "label": _vm.$t('app_distributor')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "fileStatus",
      "width": "115",
      "label": _vm.$t('app_vStatus')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          style: (_vm.getStatus(scope.row.fileStatus).style)
        }, [_vm._v(_vm._s(_vm.getStatus(scope.row.fileStatus).vl))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "createTime",
      "width": "175",
      "label": _vm.$t('app_addtime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "right",
      "prop": "operate",
      "width": "122",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "background": "none"
          }
        }, [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_edit'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: ((scope.row.fileStatus != '1' && scope.row.fileStatus != '2')),
            expression: "(scope.row.fileStatus != '1' && scope.row.fileStatus != '2') "
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.editApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_smVerify'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.fileStatus != '1' && scope.row.fileStatus != '2'),
            expression: "scope.row.fileStatus != '1' && scope.row.fileStatus != '2' "
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.submitApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-external-link-square"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (true),
            expression: "true"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1082 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": "myApp"
    }
  }, [_c('el-dialog', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "title": _vm.dialogConfig.tip,
      "visible": _vm.dialogTopMgVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogTopMgVisible = $event
      }
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "20%"
    },
    on: {
      "click": function($event) {
        _vm.processRecommend(0)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_no')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20%",
      "width": "20%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.processRecommend(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_yes')))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "disabled": _vm.isAdmin,
      "type": "primary"
    },
    on: {
      "click": _vm.showAddApp
    }
  }, [_vm._v(_vm._s(_vm.$t('app_addApp')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.isAdmin
    },
    on: {
      "click": _vm.allUndercarriage
    }
  }, [_vm._v(_vm._s(_vm.$t('app_mulOffShelf')) + " (" + _vm._s(_vm.sNum) + ")")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "10px"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('MechanismSelector', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-cascader', {
    attrs: {
      "expand-trigger": "hover",
      "options": _vm.appTypes,
      "clearable": "",
      "show-all-levels": false
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.appType),
      callback: function($$v) {
        _vm.appType = $$v
      },
      expression: "appType"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_appName'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', [_c('el-table', {
    ref: "multipleTable",
    staticClass: "tbPoint gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "row-click": _vm.cellClick,
      "sort-change": _vm.sortChange,
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "sortable": "custom",
      "prop": "appName",
      "label": _vm.$t('app_appName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "appCategoryName",
      "label": _vm.$t('app_type'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "distributorName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "",
      "label": _vm.$t('app_classIntrol'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isType === '0') ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.classRecommend(scope.row, scope)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('app_yes')))]) : _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.classRecommend(scope.row, scope)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('app_no')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "",
      "label": _vm.$t('app_homeIntrol'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isHome === '0') ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.homeRecommend(scope.row, scope)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('app_yes')))]) : _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.homeRecommend(scope.row, scope)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('app_no')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "createTime",
      "sortable": "custom",
      "formatter": _vm.dateFormat,
      "label": _vm.$t('app_ulTime'),
      "width": "175"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "appVersion",
      "align": "center",
      "label": _vm.$t('app_newgVer'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "align": "center",
      "label": _vm.$t('app_operate'),
      "width": "106"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_offShelf'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.undercarriage(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-circle-o-down"
        })])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1083 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m_context plr"
  }, [_c('el-row', [(!_vm.isEdit) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "id": "addForm",
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "12.5%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.userName'),
      "prop": "userName"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "userName"
    },
    model: {
      value: (_vm.form.userName),
      callback: function($$v) {
        _vm.$set(_vm.form, "userName", $$v)
      },
      expression: "form.userName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.password'),
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.comfirmPass'),
      "prop": "password1"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.password1),
      callback: function($$v) {
        _vm.$set(_vm.form, "password1", $$v)
      },
      expression: "form.password1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.nickName'),
      "prop": "nickName"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "nickName"
    },
    model: {
      value: (_vm.form.nickName),
      callback: function($$v) {
        _vm.$set(_vm.form, "nickName", $$v)
      },
      expression: "form.nickName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.phoneNum2'),
      "prop": "phoneNum"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "phoneNum"
    },
    model: {
      value: (_vm.form.phoneNum),
      callback: function($$v) {
        _vm.$set(_vm.form, "phoneNum", $$v)
      },
      expression: "form.phoneNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_allowiplg'),
      "prop": ""
    }
  }, [_c('div', [_c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    model: {
      value: (_vm.ip1),
      callback: function($$v) {
        _vm.ip1 = $$v
      },
      expression: "ip1"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(".")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    model: {
      value: (_vm.ip2),
      callback: function($$v) {
        _vm.ip2 = $$v
      },
      expression: "ip2"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(".")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    model: {
      value: (_vm.ip3),
      callback: function($$v) {
        _vm.ip3 = $$v
      },
      expression: "ip3"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(".")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    model: {
      value: (_vm.ip4),
      callback: function($$v) {
        _vm.ip4 = $$v
      },
      expression: "ip4"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "rgb(72,87,106)"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_allowiptip')))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.roleName'),
      "prop": "roleid"
    }
  }, [_c('el-select', {
    staticClass: "w_33",
    attrs: {
      "id": "roleid",
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.form.roleid),
      callback: function($$v) {
        _vm.$set(_vm.form, "roleid", $$v)
      },
      expression: "form.roleid"
    }
  }, _vm._l((_vm.roleList), function(item) {
    return _c('el-option', {
      key: item.roleId,
      attrs: {
        "label": item.roleName,
        "value": item.roleId
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.mcid),
      expression: "!mcid"
    }],
    attrs: {
      "label": _vm.$t('lin_global.label_areaid'),
      "prop": "mechanismId"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData,
      "mselect": true
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showut),
      expression: "showut"
    }],
    attrs: {
      "label": _vm.$t('app_usertype'),
      "prop": ""
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.userType),
      callback: function($$v) {
        _vm.$set(_vm.form, "userType", $$v)
      },
      expression: "form.userType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$t('app_distributor')))]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v(_vm._s(_vm.$t('app_developer')))])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.status'),
      "prop": ""
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.userStatus),
      callback: function($$v) {
        _vm.$set(_vm.form, "userStatus", $$v)
      },
      expression: "form.userStatus"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.jh')))]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.dj')))])], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "id": "onCancel"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.add')))])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.resetPass')))]), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "addForm",
    staticClass: "mt20",
    attrs: {
      "id": "addForm",
      "model": _vm.formEdit,
      "rules": _vm.rules,
      "label-width": "12.5%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.userName'),
      "prop": "userName"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "userName"
    },
    model: {
      value: (_vm.formEdit.userName),
      callback: function($$v) {
        _vm.$set(_vm.formEdit, "userName", $$v)
      },
      expression: "formEdit.userName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.nickName'),
      "prop": "nickName"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "nickName"
    },
    model: {
      value: (_vm.formEdit.nickName),
      callback: function($$v) {
        _vm.$set(_vm.formEdit, "nickName", $$v)
      },
      expression: "formEdit.nickName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.phoneNum2'),
      "prop": "phoneNum"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "phoneNum"
    },
    model: {
      value: (_vm.formEdit.phoneNum),
      callback: function($$v) {
        _vm.$set(_vm.formEdit, "phoneNum", $$v)
      },
      expression: "formEdit.phoneNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_allowiplg'),
      "prop": ""
    }
  }, [_c('div', [_c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    model: {
      value: (_vm.ip1),
      callback: function($$v) {
        _vm.ip1 = $$v
      },
      expression: "ip1"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(".")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    model: {
      value: (_vm.ip2),
      callback: function($$v) {
        _vm.ip2 = $$v
      },
      expression: "ip2"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(".")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    model: {
      value: (_vm.ip3),
      callback: function($$v) {
        _vm.ip3 = $$v
      },
      expression: "ip3"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(".")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    model: {
      value: (_vm.ip4),
      callback: function($$v) {
        _vm.ip4 = $$v
      },
      expression: "ip4"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "rgb(72,87,106)"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_allowiptip')))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.roleName'),
      "prop": "roleid"
    }
  }, [_c('el-select', {
    staticClass: "w_33",
    attrs: {
      "id": "roleid",
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.formEdit.roleid),
      callback: function($$v) {
        _vm.$set(_vm.formEdit, "roleid", $$v)
      },
      expression: "formEdit.roleid"
    }
  }, _vm._l((_vm.roleList), function(item) {
    return _c('el-option', {
      key: item.roleId,
      attrs: {
        "label": item.roleName,
        "value": item.roleId
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_areaid'),
      "prop": "mechanismId"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismDataUpdate,
      "mselect": true
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showut),
      expression: "showut"
    }],
    attrs: {
      "label": _vm.$t('app_usertype'),
      "prop": ""
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.formEdit.userType),
      callback: function($$v) {
        _vm.$set(_vm.formEdit, "userType", $$v)
      },
      expression: "formEdit.userType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$t('app_distributor')))]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v(_vm._s(_vm.$t('app_developer')))])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.status'),
      "prop": "userStatus"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.formEdit.userStatus),
      callback: function($$v) {
        _vm.$set(_vm.formEdit, "userStatus", $$v)
      },
      expression: "formEdit.userStatus"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.jh')))]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.dj')))])], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "id": "onCancel"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmitEdit
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.change')))])], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('lin_global.revisePass'),
      "size": "tiny"
    },
    model: {
      value: (_vm.dialogFormVisible),
      callback: function($$v) {
        _vm.dialogFormVisible = $$v
      },
      expression: "dialogFormVisible"
    }
  }, [_c('el-form', {
    ref: "formPwd",
    attrs: {
      "model": _vm.formPwd,
      "rules": _vm.rules2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.newPass'),
      "label-width": _vm.formLabelWidth,
      "prop": "pass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formPwd.pass),
      callback: function($$v) {
        _vm.$set(_vm.formPwd, "pass", $$v)
      },
      expression: "formPwd.pass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.comfirmPass'),
      "label-width": _vm.formLabelWidth,
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formPwd.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.formPwd, "checkPass", $$v)
      },
      expression: "formPwd.checkPass"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitForm('formPwd')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.confirm')))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1084 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "gPageBorder"
  }, [_c('p', {
    staticClass: "gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('terminal.terRisk.fkpz')))]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "controlName",
      "label": _vm.$t('lin_global.risk_name'),
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "messageName",
      "label": _vm.$t('lin_global.risk_type'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "radius",
      "label": _vm.$t('lin_global.risk_radius'),
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.cityFormat,
      "label": _vm.$t('lin_global.risk_city'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "controlDesc",
      "label": _vm.$t('lin_global.risk_desc'),
      "width": ""
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gTopMg gPageBorder"
  }, [_c('p', {
    staticClass: "gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.risk_warn_info')))]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.tableData2,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "terminalName",
      "label": _vm.$t('lin_global.label_name')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalNo",
      "label": _vm.$t('lin_global.label_no'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "eventType",
      "formatter": _vm.formatStatus,
      "label": _vm.$t('lin_global.warn_event'),
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "timeNow",
      "label": _vm.$t('lin_global.time'),
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cityNow",
      "label": _vm.$t('lin_global.city'),
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "longitudeAndlatitude",
      "label": _vm.$t('lin_global.jwd'),
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outDistance",
      "label": _vm.$t('lin_global.distance'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "formatter": _vm.formatStatus1,
      "label": _vm.$t('lin_global.status'),
      "width": "100"
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1085 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-form', {
    ref: "firm",
    staticClass: "gForm",
    attrs: {
      "label-position": "right",
      "rules": _vm.rules,
      "label-width": "12.5%",
      "model": _vm.firm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_deviceName'),
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.firm.name),
      callback: function($$v) {
        _vm.$set(_vm.firm, "name", $$v)
      },
      expression: "firm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_deviceNo'),
      "prop": "no"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.firm.no),
      callback: function($$v) {
        _vm.$set(_vm.firm, "no", $$v)
      },
      expression: "firm.no"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_distributor'),
      "prop": "mech"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_type'),
      "prop": "type"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('app_select')
    },
    model: {
      value: (_vm.firm.type),
      callback: function($$v) {
        _vm.$set(_vm.firm, "type", $$v)
      },
      expression: "firm.type"
    }
  }, _vm._l((_vm.dvs), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_model'),
      "prop": "model"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('app_select')
    },
    model: {
      value: (_vm.firm.model),
      callback: function($$v) {
        _vm.$set(_vm.firm, "model", $$v)
      },
      expression: "firm.model"
    }
  }, _vm._l((_vm.mds), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_firm'),
      "prop": "firm"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('app_select')
    },
    model: {
      value: (_vm.firm.firm),
      callback: function($$v) {
        _vm.$set(_vm.firm, "firm", $$v)
      },
      expression: "firm.firm"
    }
  }, _vm._l((_vm.firms), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_addres'),
      "prop": "addr"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.firm.addr),
      callback: function($$v) {
        _vm.$set(_vm.firm, "addr", $$v)
      },
      expression: "firm.addr"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.remark'),
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.firm.remark),
      callback: function($$v) {
        _vm.$set(_vm.firm, "remark", $$v)
      },
      expression: "firm.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save('firm')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_save')))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1086 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ae"
    }
  }, [_c('div', {
    staticClass: "gPageBorder"
  }, [_c('el-form', {
    ref: "form",
    staticClass: "gForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-position": "right",
      "label-width": "12.5%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_appName'),
      "prop": "appName"
    }
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }],
    staticClass: "aeMg contentColor"
  }, [_vm._v(_vm._s((_vm.config.data) ? _vm.config.data.appName : ''))]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "aeMg",
    model: {
      value: (_vm.form.appName),
      callback: function($$v) {
        _vm.$set(_vm.form, "appName", $$v)
      },
      expression: "form.appName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('psp_app_version'),
      "prop": "appVersion"
    }
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }],
    staticClass: "aeMg contentColor"
  }, [_vm._v(_vm._s((_vm.config.data) ? _vm.config.data.appVersion : ''))]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "aeMg",
    model: {
      value: (_vm.form.appVersion),
      callback: function($$v) {
        _vm.$set(_vm.form, "appVersion", $$v)
      },
      expression: "form.appVersion"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    attrs: {
      "label": _vm.$t('app_selectApp'),
      "prop": "pspAppUrl"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo aeMg",
    attrs: {
      "data": _vm.uData,
      "drag": "",
      "name": "fileUpload",
      "file-list": _vm.fileList,
      "on-success": _vm.fileUploadSuccess,
      "limit": 1,
      "before-upload": _vm.fileBeforeUpload,
      "action": _vm.fileUploadUrl,
      "on-remove": _vm.handleRemove_1
    }
  }, [_c('span', [(_vm.upinfo_1) ? _c('i', {
    class: _vm.ulinfo.icons[0]
  }) : _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "display": "flex",
      "flex-direction": "column"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload",
    style: (_vm.tipColor_1)
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "140px",
      "margin": "0 auto"
    },
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_reupload')))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.upinfo_1),
      expression: "upinfo_1"
    }],
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.$t('app_ulNormalSt')))])])])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    attrs: {
      "label": _vm.$t('app_certificate_1'),
      "prop": "cer1Url"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo aeMg",
    attrs: {
      "data": _vm.uData,
      "drag": "",
      "name": "fileUpload",
      "file-list": _vm.fileLists,
      "on-success": _vm.fileUploadSuccesss,
      "limit": 1,
      "before-upload": _vm.fileBeforeUpload,
      "action": _vm.fileUploadUrl,
      "on-remove": _vm.handleRemove_2
    }
  }, [_c('span', [(_vm.upinfo_2) ? _c('i', {
    class: _vm.ulinfo.icons[0]
  }) : _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "display": "flex",
      "flex-direction": "column"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload",
    style: (_vm.tipColor_2)
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "140px",
      "margin": "0 auto"
    },
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_reupload')))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.upinfo_2),
      expression: "upinfo_2"
    }],
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.$t('app_ulNormalSt')))])])])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    attrs: {
      "label": _vm.$t('app_certificate_2'),
      "prop": "cer2Url"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo aeMg",
    attrs: {
      "data": _vm.uData,
      "drag": "",
      "name": "fileUpload",
      "file-list": _vm.fileListss,
      "on-success": _vm.fileUploadSuccessss,
      "limit": 1,
      "before-upload": _vm.fileBeforeUpload,
      "action": _vm.fileUploadUrl,
      "on-remove": _vm.handleRemove_3
    }
  }, [_c('span', [(_vm.upinfo_3) ? _c('i', {
    class: _vm.ulinfo.icons[0]
  }) : _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "display": "flex",
      "flex-direction": "column"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload",
    style: (_vm.tipColor_3)
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "140px",
      "margin": "0 auto"
    },
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_reupload')))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.upinfo_3),
      expression: "upinfo_3"
    }],
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.$t('app_ulNormalSt')))])])])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "calc(100% + 20px)",
      "background": "#EAEEFA",
      "height": "1px",
      "margin-left": "-10px"
    }
  }), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "background": "none"
    }
  }, [_c('el-button', {
    staticClass: "aeMg",
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    staticClass: "aeMg",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.uploadApp('form')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_save')))])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1087 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-form', {
    ref: "form",
    staticClass: "gForm",
    attrs: {
      "label-position": "right",
      "rules": _vm.rules,
      "label-width": "12.5%",
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_secrname'),
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_secrdesc'),
      "prop": "desc"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.desc),
      callback: function($$v) {
        _vm.$set(_vm.form, "desc", $$v)
      },
      expression: "form.desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save('form')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_save')))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1088 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "appbind"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAppBatch),
      expression: "isAppBatch"
    }],
    staticClass: "gPageBorder gTopMg",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('p', {
    staticClass: "gCtColor  gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('menu.terManageSub.appList')) + " ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "data": _vm.info.data,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appName",
      "label": _vm.$t('app_appName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appSize",
      "width": "",
      "label": _vm.$t('app_fileSize')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', [_vm._v(_vm._s((scope.row.appSize / 1000000).toFixed(2)) + " MB")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appVersion",
      "width": "",
      "label": _vm.$t('app_version')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "createTime",
      "width": "175",
      "label": _vm.$t('app_ulTime')
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isAppBatch),
      expression: "!isAppBatch"
    }],
    staticStyle: {
      "margin-bottom": "20px",
      "margin-top": "5px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.pushedList = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_pusheddvlist')))]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_pushDevice'),
      "size": "large"
    },
    on: {
      "open": _vm.open,
      "close": _vm.close
    },
    model: {
      value: (_vm.pushedList),
      callback: function($$v) {
        _vm.pushedList = $$v
      },
      expression: "pushedList"
    }
  }, [_c('div', {
    staticClass: " ",
    attrs: {
      "id": ""
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '10'),
      expression: "info.type === '10'"
    }],
    staticClass: "gSgLeftBtn",
    on: {
      "click": function($event) {
        _vm.allUnbind()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_bcrecov')) + " (" + _vm._s(_vm.sNum) + ")")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '1'),
      expression: "info.type === '1'"
    }],
    on: {
      "click": function($event) {
        _vm.mulDelAppPush()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_mulUnbind')) + " (" + _vm._s(_vm.sNum) + ")")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    on: {
      "click": function($event) {
        _vm.refreshBind()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.shuaxin')))])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "offset": 16,
      "span": 4
    }
  }, [_c('div', {}, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_adname'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "dpTable",
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalName",
      "align": "center",
      "label": _vm.$t('app_deviceName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_deviceNo'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pushTime",
      "align": "center",
      "label": _vm.$t('app_pushTime'),
      "width": "175"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "106"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.info.type === '10'),
            expression: "info.type === '10'"
          }],
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_recov'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-history"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.dfDelCt,
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.info.type === '1'),
            expression: "info.type === '1'"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.delAppPush(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.page,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '10' || (_vm.info.type === '1' && !_vm.isAppBatch)),
      expression: "info.type === '10' || (info.type === '1' && !isAppBatch)"
    }],
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "calc(100% - 48px)",
      "height": "100%",
      "margin-bottom": "0px",
      "background": "none",
      "padding": "0 0px 12px 24px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.fileName : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('table', {
    staticClass: "lcpush"
  }, [_c('tr', [_c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_version')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.version : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_fileSize')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.size : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_distributor')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.mechanismName : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_ulTime')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.createTime : ''))])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-height": "10px",
      "display": "-webkit-flex"
    }
  }, [_c('div', {
    staticClass: "dt-word-title",
    staticStyle: {
      "display": "inline-block",
      "min-width": "70px"
    }
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '10'),
      expression: "info.type === '10'"
    }]
  }, [_vm._v("launcher" + _vm._s(_vm.$t('app_ss')) + "：")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '1'),
      expression: "info.type === '1'"
    }]
  }, [_vm._v(_vm._s(_vm.$t('app_introl')) + "：")])]), _vm._v(" "), _c('div', {
    staticClass: "dt-word-main",
    staticStyle: {
      "display": "inline-block",
      "position": "relative",
      "background": "none"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.detail ? _vm.detail.memo : ''))])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '13'),
      expression: "info.type === '13'"
    }],
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "calc(100% - 48px)",
      "height": "100%",
      "margin-bottom": "0px",
      "background": "none",
      "padding": "0 0px 12px 24px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.fileName : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('table', {
    staticClass: "lcpush"
  }, [_c('tr', [_c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_version')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.version : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_filetag')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.info ? _vm.info.data.flag : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_excludeapp')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.info ? _vm.info.data.appPackage : ''))])]), _vm._v(" "), _c('td')])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-height": "10px",
      "display": "-webkit-flex"
    }
  }, [_c('div', {
    staticClass: "dt-word-title",
    staticStyle: {
      "display": "inline-block",
      "min-width": "70px"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('app_filestss')) + "：")])]), _vm._v(" "), _c('div', {
    staticClass: "dt-word-main",
    staticStyle: {
      "display": "inline-block",
      "position": "relative",
      "background": "none"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.detail ? _vm.detail.memo : ''))])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '14' || _vm.info.type === '15'),
      expression: "info.type === '14' || info.type === '15'"
    }],
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "calc(100% - 48px)",
      "height": "100%",
      "margin-bottom": "0px",
      "background": "none",
      "padding": "0 0px 12px 24px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.fileName : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('table', {
    staticClass: "lcpush"
  }, [_c('tr', [_c('td', {}, [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_version')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.version : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_fileSize')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? (_vm.detail.size / 1000000).toFixed(2) : '') + "MB\n              ")])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_distributor')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.mechanismName : ''))])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('table', {
    staticClass: "lcpush"
  }, [_c('tr', [_c('td', {}, [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.risk_desc')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.memo : ''))])])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '2' && _vm.detail.fileType === '1'),
      expression: "info.type === '2' && detail.fileType === '1'"
    }],
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "calc(100% - 48px)",
      "height": "100%",
      "margin-bottom": "0px",
      "background": "none",
      "padding": "0 0px 12px 24px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.fileName : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('table', {
    staticClass: "lcpush"
  }, [_c('tr', [_c('td', {}, [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_version')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.version : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_fileSize')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.size : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_distributor')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.mechanismName : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '2'),
      expression: "info.type === '2'"
    }],
    staticClass: "dt-word-title"
  }, [_vm._v("ota" + _vm._s(_vm.$t('app_type')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.cmType))])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('table', {
    staticClass: "lcpush"
  }, [_c('tr', [_c('td', {}, [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_preversion')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.preVersion : ''))])])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '4' || (_vm.info.type === '2' && _vm.detail.fileType === '0')),
      expression: "info.type === '4' || (info.type === '2' && detail.fileType === '0' )"
    }],
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "calc(100% - 48px)",
      "height": "100%",
      "margin-bottom": "0px",
      "background": "none",
      "padding": "0 0px 12px 24px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.fileName : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('table', {
    staticClass: "lcpush"
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_version')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.version : ''))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_fileSize')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.size : ''))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_distributor')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.mechanismName : ''))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '4'),
      expression: "info.type === '4'"
    }],
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_fwType')) + "：")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '2'),
      expression: "info.type === '2'"
    }],
    staticClass: "dt-word-title"
  }, [_vm._v("ota" + _vm._s(_vm.$t('app_type')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.cmType))])])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '6'),
      expression: "info.type === '6'"
    }],
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "calc(100% - 48px)",
      "height": "100%",
      "margin-bottom": "0px",
      "background": "none",
      "padding": "0 0px 12px 24px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.fileName : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('table', {
    staticClass: "lcpush"
  }, [_c('tr', [_c('td', {}, [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_animation') + _vm.$t('app_type')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.adType[_vm.detail.fileType] : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_animation') + _vm.$t('app_size1')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.size : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_playPlace')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.playPlace[_vm.detail.memo] : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '6'),
      expression: "info.type === '6'"
    }],
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_customsTime')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.createTime : ''))])])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder gTopMg",
    attrs: {
      "id": ""
    }
  }, [_c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_push')
    },
    on: {
      "open": _vm.open,
      "close": _vm.close
    },
    model: {
      value: (_vm.pushQs),
      callback: function($$v) {
        _vm.pushQs = $$v
      },
      expression: "pushQs"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('app_ispushf') + '，' + _vm.fileName) + "？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '1'),
      expression: "info.type === '1'"
    }],
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.check1),
      callback: function($$v) {
        _vm.check1 = $$v
      },
      expression: "check1"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_autoscopen')))]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.check2),
      callback: function($$v) {
        _vm.check2 = $$v
      },
      expression: "check2"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_psscandtip')))])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '2'),
      expression: "info.type === '2'"
    }],
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.check1),
      callback: function($$v) {
        _vm.check1 = $$v
      },
      expression: "check1"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_tipud')))]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.check2),
      callback: function($$v) {
        _vm.check2 = $$v
      },
      expression: "check2"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_tipdown')))])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.pushQs = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.surePush
    }
  }, [_vm._v(_vm._s(_vm.$t('app_srpush')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_fipush')
    },
    on: {
      "close": _vm.closeImport
    },
    model: {
      value: (_vm.pushImport),
      callback: function($$v) {
        _vm.pushImport = $$v
      },
      expression: "pushImport"
    }
  }, [_c('el-form', {
    ref: "",
    attrs: {
      "model": "",
      "rules": ""
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_ulfile'),
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "name": "fileUpload",
      "action": _vm.importTemplate,
      "on-remove": _vm.handleRemove,
      "before-upload": _vm.srcBefore,
      "on-success": _vm.srcSuccess,
      "on-error": _vm.ulError,
      "file-list": _vm.fileList,
      "auto-upload": true
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v(_vm._s(_vm.$t('app_clickUpdate')))]), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-left": "8px",
      "margin-right": "10px"
    },
    attrs: {
      "href": _vm.downTpl
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "size": "small"
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.list.import_muban')))])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_deviceNum'),
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n          " + _vm._s(_vm.uldata ? _vm.uldata.terNums : 0 + _vm.$t('app_amechine')) + "\n        ")])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '1'),
      expression: "info.type === '1'"
    }],
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.check1),
      callback: function($$v) {
        _vm.check1 = $$v
      },
      expression: "check1"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_autoscopen')))]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.check2),
      callback: function($$v) {
        _vm.check2 = $$v
      },
      expression: "check2"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_psscandtip')))])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '2'),
      expression: "info.type === '2'"
    }],
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.check1),
      callback: function($$v) {
        _vm.check1 = $$v
      },
      expression: "check1"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_tipud')))]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.check2),
      callback: function($$v) {
        _vm.check2 = $$v
      },
      expression: "check2"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_tipdown')))])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.pushImport = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "disabled": !_vm.uldata,
      "type": "primary"
    },
    on: {
      "click": _vm.submitUpload
    }
  }, [_vm._v(_vm._s(_vm.$t('app_srpush')))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_pushAll')
    },
    on: {
      "open": _vm.open,
      "close": _vm.close
    },
    model: {
      value: (_vm.pushAll),
      callback: function($$v) {
        _vm.pushAll = $$v
      },
      expression: "pushAll"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.allMcName))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '1'),
      expression: "info.type === '1'"
    }],
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.check1),
      callback: function($$v) {
        _vm.check1 = $$v
      },
      expression: "check1"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_autoscopen')))]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.check2),
      callback: function($$v) {
        _vm.check2 = $$v
      },
      expression: "check2"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_psscandtip')))])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.type === '2'),
      expression: "info.type === '2'"
    }],
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.check1),
      callback: function($$v) {
        _vm.check1 = $$v
      },
      expression: "check1"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_tipud')))]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.check2),
      callback: function($$v) {
        _vm.check2 = $$v
      },
      expression: "check2"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_tipdown')))])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.pushAll = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.surePushAll
    }
  }, [_vm._v(_vm._s(_vm.$t('app_srpush')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_srpush')
    },
    on: {
      "open": _vm.open,
      "close": _vm.close
    },
    model: {
      value: (_vm.pushAf),
      callback: function($$v) {
        _vm.pushAf = $$v
      },
      expression: "pushAf"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.surePushTip))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.pushAf = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.coverPush('1')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cvpush')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.coverPush('0')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_skpush')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_pssuccess')
    },
    on: {
      "open": _vm.open,
      "close": _vm.close
    },
    model: {
      value: (_vm.pushDone),
      callback: function($$v) {
        _vm.pushDone = $$v
      },
      expression: "pushDone"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('app_isjtoviewtd') + '?') + " ")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.pushDone = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.jumpNow
    }
  }, [_vm._v(_vm._s(_vm.$t('app_nowjump')))])], 1)]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    on: {
      "click": _vm.multiBind
    }
  }, [_vm._v(_vm._s(_vm.$t('app_mulPush')) + " (" + _vm._s(_vm.sNum1) + ")")]), _vm._v(" "), _c('el-button', {
    staticClass: "gSgLeftBtn",
    on: {
      "click": function($event) {
        _vm.pushAll = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_allpush')))]), _vm._v(" "), _c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "disabled": false
    },
    on: {
      "click": function($event) {
        _vm.pushImport = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_fipush')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.selectStChange
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.stModel), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.label,
        "value": item.vl
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_deviceNo') + '/' + _vm.$t('app_deviceName'),
      "icon": "search",
      "on-icon-click": _vm.srch
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srch($event)
      }
    },
    model: {
      value: (_vm.iNo),
      callback: function($$v) {
        _vm.iNo = $$v
      },
      expression: "iNo"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData1,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange1
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_deviceNo'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalName",
      "align": "center",
      "label": _vm.$t('app_deviceName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminal_status",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.info.type == 14 || _vm.info.type == 15) ? _c('span', [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_on')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 3) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_fault')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_sleep')))]) : _vm._e()], 1) : _c('span', [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 3) ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_sleep')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 4) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_btn.lock')))]) : _vm._e()], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_push'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate1(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total1
    },
    on: {
      "current-change": _vm.pageSelect1,
      "size-change": _vm.pageSized1
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1089 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "m_context"
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-left": "24px"
    },
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.xzwl')))])], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "id": "tp",
      "data": _vm.tableData2,
      "border": ""
    },
    on: {
      "row-click": _vm.linkDetail,
      "sort-change": _vm.sortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "sortable": "custom",
      "prop": "controlName",
      "label": _vm.$t('lin_global.risk_name'),
      "width": "300"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "radius",
      "label": _vm.$t('lin_global.risk_radius'),
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.cityFormat,
      "label": _vm.$t('lin_global.risk_city'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "controlDesc",
      "label": _vm.$t('lin_global.risk_desc')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "custom",
      "prop": "createTime",
      "label": _vm.$t('app_addtime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": _vm.$t('lin_global.ope'),
      "width": "105"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.edit'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.editRow(scope.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.bind'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.binderRow(scope.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-chain"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.deleteRow(scope.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.totalRecords > 0) ? _c('div', {
    staticClass: "page_content"
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 50, 100],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('lin_global.xzwl')
    },
    model: {
      value: (_vm.dialogFormVisible),
      callback: function($$v) {
        _vm.dialogFormVisible = $$v
      },
      expression: "dialogFormVisible"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form,
      "label-width": "12.5%",
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.name'),
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.controllerName),
      callback: function($$v) {
        _vm.$set(_vm.form, "controllerName", $$v)
      },
      expression: "form.controllerName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.risk_desc'),
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form.controllerDesc),
      callback: function($$v) {
        _vm.$set(_vm.form, "controllerDesc", $$v)
      },
      expression: "form.controllerDesc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "label": _vm.$t('lin_global.wllx'),
      "prop": "name"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.change
    },
    model: {
      value: (_vm.form.controlType),
      callback: function($$v) {
        _vm.$set(_vm.form, "controlType", $$v)
      },
      expression: "form.controlType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.jwd')))]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.city')))])], 1), _vm._v(" "), _c('el-checkbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.controlType == 1),
      expression: "form.controlType == 1"
    }],
    on: {
      "change": _vm.cbChange
    },
    model: {
      value: (_vm.isProv),
      callback: function($$v) {
        _vm.isProv = $$v
      },
      expression: "isProv"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_onlyprov')))])], 1), _vm._v(" "), (_vm.ifshow) ? _c('el-form-item', {
    attrs: {
      "prop": "name",
      "label": _vm.$t('lin_global.risk_radius')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.radius),
      callback: function($$v) {
        _vm.radius = $$v
      },
      expression: "radius"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.danweikm')))])], 2), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('lin_global.weilanshuoming')))])], 1) : _vm._e(), _vm._v(" "), (!_vm.ifshow) ? _c('el-form-item', {
    attrs: {
      "prop": "name",
      "label": _vm.$t('lin_global.cityName')
    }
  }, [(!_vm.isProv) ? _c('el-cascader', {
    ref: "cas1",
    attrs: {
      "expand-trigger": "click",
      "options": _vm.options,
      "show-all-levels": false
    },
    on: {
      "change": _vm.selEvent
    },
    model: {
      value: (_vm.sel),
      callback: function($$v) {
        _vm.sel = $$v
      },
      expression: "sel"
    }
  }) : _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('app_select')
    },
    model: {
      value: (_vm.selVl),
      callback: function($$v) {
        _vm.selVl = $$v
      },
      expression: "selVl"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.submit')))])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('lin_global.bjwl')
    },
    model: {
      value: (_vm.dialogFormVisible2),
      callback: function($$v) {
        _vm.dialogFormVisible2 = $$v
      },
      expression: "dialogFormVisible2"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form2,
      "label-width": "100px",
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.name'),
      "prop": "name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    model: {
      value: (_vm.form2.controllerName),
      callback: function($$v) {
        _vm.$set(_vm.form2, "controllerName", $$v)
      },
      expression: "form2.controllerName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.risk_desc'),
      "prop": "name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form2.controllerDesc),
      callback: function($$v) {
        _vm.$set(_vm.form2, "controllerDesc", $$v)
      },
      expression: "form2.controllerDesc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "background": "none"
    },
    attrs: {
      "label": _vm.$t('lin_global.wllx'),
      "prop": "name"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.change2
    },
    model: {
      value: (_vm.form2.controlType),
      callback: function($$v) {
        _vm.$set(_vm.form2, "controlType", $$v)
      },
      expression: "form2.controlType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.jwd')))]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.city')))])], 1), _vm._v(" "), _c('el-checkbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form2.controlType == 1),
      expression: "form2.controlType == 1"
    }],
    on: {
      "change": _vm.cbChange1
    },
    model: {
      value: (_vm.isProv),
      callback: function($$v) {
        _vm.isProv = $$v
      },
      expression: "isProv"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_onlyprov')))])], 1), _vm._v(" "), (_vm.ifshow2) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.risk_radius'),
      "prop": "name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    model: {
      value: (_vm.radius2),
      callback: function($$v) {
        _vm.radius2 = $$v
      },
      expression: "radius2"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.danweikm')))])], 2), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('lin_global.weilanshuoming')))])], 1) : _vm._e(), _vm._v(" "), (!_vm.ifshow2) ? _c('el-form-item', {
    attrs: {
      "prop": "name",
      "label": _vm.$t('lin_global.cityName')
    }
  }, [(!_vm.isProv) ? _c('el-cascader', {
    ref: "cas2",
    attrs: {
      "expand-trigger": "click",
      "options": _vm.options2,
      "show-all-levels": false
    },
    on: {
      "change": _vm.selEvent2
    },
    model: {
      value: (_vm.sel2),
      callback: function($$v) {
        _vm.sel2 = $$v
      },
      expression: "sel2"
    }
  }) : _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('app_select')
    },
    model: {
      value: (_vm.selVl2),
      callback: function($$v) {
        _vm.selVl2 = $$v
      },
      expression: "selVl2"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": _vm.onCancel2
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit2
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.submit')))])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('lin_global.bdsb')
    },
    on: {
      "close": _vm.closeBindAlert
    },
    model: {
      value: (_vm.dialogTopMgVisible),
      callback: function($$v) {
        _vm.dialogTopMgVisible = $$v
      },
      expression: "dialogTopMgVisible"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_c('MechanismSelector', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('lin_global.pselect')
    },
    on: {
      "change": _vm.statusChange
    },
    model: {
      value: (_vm.stvl),
      callback: function($$v) {
        _vm.stvl = $$v
      },
      expression: "stvl"
    }
  }, _vm._l((_vm.sttyps), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('lin_global.label_no'),
      "icon": "search",
      "on-icon-click": _vm.handleIconClick
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.focusEvent(_vm.handleIconClick)
      }
    },
    model: {
      value: (_vm.input1),
      callback: function($$v) {
        _vm.input1 = $$v
      },
      expression: "input1"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.batchBindRow
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.bindAll')))])], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {},
    attrs: {
      "data": _vm.arrdata1,
      "border": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange1
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalName",
      "label": _vm.$t('lin_global.label_name'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalNo",
      "label": _vm.$t('lin_global.label_no'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('lin_global.status'),
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.new_add')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 3) ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_sleep')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mechName",
      "label": _vm.$t('lin_global.label_areaid'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('lin_global.ope')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.bind'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.bindRow(scope.row.terminalId)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-chain"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "float": "right",
      "margin-bottom": "20px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage1,
      "page-sizes": [10, 50, 100],
      "page-size": _vm.pageSize1,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalRecords1
    },
    on: {
      "size-change": _vm.handleSizeChange1,
      "current-change": _vm.handleCurrentChange1
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1090 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-rotate-bar"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.rotateLeft
    }
  }, [_c('svg', {
    staticClass: "svg-icon",
    attrs: {
      "viewBox": "0 0 481.95 481.95"
    }
  }, [_c('path', {
    attrs: {
      "d": "M281.7,243.8V138.2c75.9,13.5,135.4,78.6,135.4,159.8s-59.6,146.3-135.4,159.8V512\n        c105.7-13.5,189.6-102.9,189.6-214s-84-200.5-189.6-214V0L159.8,121.9L281.7,243.8z M94.8,270.9c2.7-24.4,13.5-46.1,27.1-67.7\n        L84,165.2C59.6,197.8,46.1,233,40.6,270.9H94.8z M159.8,430.7l-37.9,37.9c32.5,24.4,67.7,37.9,105.7,43.3v-54.2\n        C203.2,455.1,181.5,444.3,159.8,430.7z M94.8,325.1H40.6c2.7,37.9,19,73.1,43.3,105.7l37.9-37.9\n        C108.4,371.1,97.5,349.5,94.8,325.1z",
      "fill": "#27ae60"
    }
  })])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.rotateRight
    }
  }, [_c('svg', {
    staticClass: "svg-icon",
    attrs: {
      "viewBox": "0 0 481.95 481.95"
    }
  }, [_c('path', {
    attrs: {
      "d": "M331.5,114.75L216.75,0v79.05C117.3,91.8,38.25,175.95,38.25,280.5s79.05,188.7,178.5,201.45v-51    C145.35,418.2,89.25,357,89.25,280.5s56.1-137.7,127.5-150.45v99.45L331.5,114.75z M443.7,255    c-5.101-35.7-17.851-68.85-40.8-99.45l-35.7,35.7c12.75,20.4,22.95,40.8,25.5,63.75H443.7z M267.75,430.95v51    c35.7-5.101,68.85-17.851,99.45-40.8l-35.7-35.7C311.1,418.2,290.7,428.4,267.75,430.95z M367.2,369.75l35.7,35.7    c22.949-30.601,38.25-63.75,40.8-99.45h-51C390.15,328.95,379.95,349.35,367.2,369.75z",
      "fill": "#27ae60"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 1091 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 1092 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m_context"
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-left": "24px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('lin_global.label_no'),
      "icon": "search",
      "on-icon-click": _vm.handleIconClick
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.focusEvent(_vm.handleIconClick)
      }
    },
    model: {
      value: (_vm.queryCondition.terminal_no),
      callback: function($$v) {
        _vm.$set(_vm.queryCondition, "terminal_no", $$v)
      },
      expression: "queryCondition.terminal_no"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "clearable": "",
      "placeholder": _vm.$t('terminal.appLog.start_time')
    },
    on: {
      "change": _vm.dataChange
    },
    model: {
      value: (_vm.queryCondition.start_time),
      callback: function($$v) {
        _vm.$set(_vm.queryCondition, "start_time", $$v)
      },
      expression: "queryCondition.start_time"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "clearable": "",
      "placeholder": _vm.$t('terminal.appLog.end_time')
    },
    on: {
      "change": _vm.dataChange1
    },
    model: {
      value: (_vm.queryCondition.end_time),
      callback: function($$v) {
        _vm.$set(_vm.queryCondition, "end_time", $$v)
      },
      expression: "queryCondition.end_time"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.check')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.reset')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.catchLog
    }
  }, [_vm._v(_vm._s(_vm.$t('app_catchlog')))])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": _vm.$t('lin_global.loading'),
      "data": _vm.tableData,
      "id": "tableData",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "terminalNo",
      "label": _vm.$t('lin_global.label_no'),
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalName",
      "label": _vm.$t('lin_global.label_name'),
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mechName",
      "label": _vm.$t('lin_global.label_areaid'),
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "beginTime",
      "label": _vm.$t('lin_global.logStartTime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "endTime",
      "label": _vm.$t('lin_global.logEndTime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": _vm.$t('lin_global.status'),
      "formatter": _vm.formatStatus,
      "show-overflow-tooltip": true,
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('lin_global.ope'),
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_global.download'),
            "placement": "top"
          }
        }, [(scope.row.down) ? _c('a', {
          staticStyle: {
            "color": "#4db3ff",
            "margin-left": "10px"
          },
          attrs: {
            "href": _vm.baseUrl + scope.row.logUrl
          }
        }, [_c('i', {
          staticClass: "fa fa-cloud-download"
        })]) : _vm._e()]), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.delete'),
            "placement": "top"
          }
        }, [(scope.row.delete) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.submitRow(scope.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })]) : _vm._e()], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.totalRecords > 0) ? _c('div', {
    staticClass: "block text-center mt20 page_content",
    attrs: {
      "id": "pagination"
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 50, 100],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1093 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('div', {}, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.jumpToUpload
    }
  }, [_vm._v(_vm._s(_vm.$t('app_addconfig')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_name'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)])], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    staticClass: "tbPoint gTopMg",
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick,
      "sort-change": _vm.sortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "configName",
      "label": _vm.$t('lin_global.risk_name'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "configDesc",
      "width": "",
      "label": _vm.$t('app_filestss')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "terNums",
      "width": "115",
      "label": _vm.$t('app_deviceNum')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "sortable": "custom",
      "prop": "createTime",
      "width": "176",
      "label": _vm.$t('app_addtime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "operate",
      "width": "86",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "background": "none"
          }
        }, [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_edit'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (true),
            expression: "true"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.editApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_smVerify'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status == 0 || scope.row.status == 3),
            expression: "scope.row.status == 0 || scope.row.status == 3"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.submitApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-external-link-square"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (true),
            expression: "true"
          }],
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1094 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('psp_app_manage'),
      "name": _vm.$t('psp_app_manage')
    }
  }, [_c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('div', {}, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.jumpToAdd
    }
  }, [_vm._v(_vm._s(_vm.$t('app_addApp')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_appName'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.fileName),
      callback: function($$v) {
        _vm.fileName = $$v
      },
      expression: "fileName"
    }
  })], 1)])], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticClass: "tbPoint gTopMg",
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appId",
      "label": _vm.$t('psp_app_id'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "fileName",
      "label": _vm.$t('app_appName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "sysType",
      "width": "",
      "label": _vm.$t('app_sysType')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.sysType == '0') ? _c('span', [_vm._v("RTOS")]) : _vm._e(), _vm._v(" "), (scope.row.sysType == '1') ? _c('span', [_vm._v("Linux")]) : _vm._e(), _vm._v(" "), (scope.row.sysType == '2') ? _c('span', [_vm._v("LiteOS")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appVersion",
      "label": _vm.$t('psp_app_version'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "memo",
      "width": "",
      "label": _vm.$t('app_introl')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "createTime",
      "width": "175",
      "label": _vm.$t('app_ulTime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "right",
      "prop": "operate",
      "width": "106",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "background": "none"
          }
        }, [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_edit'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.editApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('psp_unstall_manage'),
      "name": _vm.$t('psp_unstall_manage')
    }
  }, [_c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('div', {}, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.open_push
    }
  }, [_vm._v(_vm._s(_vm.$t('app_adddv')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addTer
    }
  }, [_vm._v(_vm._s(_vm.$t('app_fileImport')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": _vm.multipleSelection.length == 0,
      "icon": "",
      "size": ""
    },
    on: {
      "click": _vm.batchDeleteRow
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.batch_delete')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "icon": "",
      "size": ""
    },
    on: {
      "click": _vm.delete_all
    }
  }, [_vm._v(_vm._s(_vm.$t('app_allDel')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_terNo'),
      "icon": "search",
      "on-icon-click": _vm.getUnstallList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getUnstallList($event)
      }
    },
    model: {
      value: (_vm.uninsatll_form.terminalNo),
      callback: function($$v) {
        _vm.$set(_vm.uninsatll_form, "terminalNo", $$v)
      },
      expression: "uninsatll_form.terminalNo"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('MechanismSelector', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mechanismDatas
    }
  })], 1)])], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    ref: "multipleTables",
    staticClass: "tbPoint gTopMg",
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "data": _vm.uninstallData,
      "border": ""
    },
    on: {
      "row-click": function($event) {},
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "ternimalNo",
      "label": _vm.$t('app_terNo'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "updateStatus",
      "width": "",
      "label": _vm.$t('app_termin_status')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.updateStatus == 0) ? _c('span', [_vm._v(_vm._s(_vm.$t('app_wite_update')))]) : _vm._e(), _vm._v(" "), (scope.row.updateStatus == 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('app_Update_successfully')))]) : _vm._e(), _vm._v(" "), (scope.row.updateStatus == 2) ? _c('span', [_vm._v(_vm._s(_vm.$t('app_Update_failure')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "updateTime",
      "width": "175",
      "label": _vm.$t('app_udtime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "operate",
      "width": "106",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteApps(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.uninsatll_form.page,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.uninsatll_form.rows,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.uninstallTotal
    },
    on: {
      "current-change": _vm.pageSelectUn,
      "size-change": _vm.pageSizedUn
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_adddv'),
      "size": ""
    },
    on: {
      "close": _vm.handleClose
    },
    model: {
      value: (_vm.show_push),
      callback: function($$v) {
        _vm.show_push = $$v
      },
      expression: "show_push"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.device_loading),
      expression: "device_loading"
    }],
    staticClass: "gBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-row', {}, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary",
      "disabled": _vm.select_device.length == 0
    },
    on: {
      "click": _vm.bcPush
    }
  }, [_vm._v(_vm._s(_vm.$t('app_pushsldev')))])], 1)], 1), _vm._v(" "), _c('el-row', {}, [_c('el-col', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    },
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "gSideCtrl",
    staticStyle: {
      "margin-right": "8px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_start_no'),
      "icon": "search",
      "on-icon-click": _vm.get_device_list
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.get_device_list($event)
      }
    },
    model: {
      value: (_vm.select_form.snBegin),
      callback: function($$v) {
        _vm.$set(_vm.select_form, "snBegin", $$v)
      },
      expression: "select_form.snBegin"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gSideCtrl",
    staticStyle: {
      "margin-left": "0",
      "margin-right": "0"
    }
  }, [_vm._v("\n\t\t\t\t\t\t~\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_end_no'),
      "icon": "search",
      "on-icon-click": _vm.get_device_list
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.get_device_list($event)
      }
    },
    model: {
      value: (_vm.select_form.snEnd),
      callback: function($$v) {
        _vm.$set(_vm.select_form, "snEnd", $$v)
      },
      expression: "select_form.snEnd"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "offset": 0,
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.getCmDv
    },
    model: {
      value: (_vm.select_form.terminal_status),
      callback: function($$v) {
        _vm.$set(_vm.select_form, "terminal_status", $$v)
      },
      expression: "select_form.terminal_status"
    }
  }, _vm._l((_vm.sstatusAr), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "offset": 0,
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('MechanismSelector', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_terNo'),
      "icon": "search",
      "on-icon-click": _vm.get_device_list
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.get_device_list($event)
      }
    },
    model: {
      value: (_vm.select_form.terminal_no),
      callback: function($$v) {
        _vm.$set(_vm.select_form, "terminal_no", $$v)
      },
      expression: "select_form.terminal_no"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "dpTable",
      "data": _vm.deviceList,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChangeDevice
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalNo",
      "align": "center",
      "label": _vm.$t('app_terNo'),
      "width": "210"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "210"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalStatus",
      "formatter": _vm.mkDvSt,
      "label": _vm.$t('app_status'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": "210"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "106"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.send'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.pushed(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.select_form.page,
      "page-sizes": [20, 100],
      "page-size": _vm.select_form.rows,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.deviceTotal
    },
    on: {
      "current-change": _vm.pageSelectDevice,
      "size-change": _vm.pageSizedDevice
    }
  })], 1)], 1)]), _vm._v(" "), _c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_fipush')
    },
    on: {
      "close": _vm.closeImport
    },
    model: {
      value: (_vm.pushImport),
      callback: function($$v) {
        _vm.pushImport = $$v
      },
      expression: "pushImport"
    }
  }, [_c('el-form', {
    attrs: {
      "model": "",
      "rules": ""
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_ulfile'),
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "name": "fileUpload",
      "action": _vm.ulurl(),
      "on-remove": _vm.beforeRemove,
      "before-upload": _vm.srcBefore,
      "on-success": _vm.srcSuccess,
      "on-error": _vm.ulError,
      "file-list": _vm.fileList
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v(_vm._s(_vm.$t('app_clickUpdate')))]), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-left": "8px",
      "margin-right": "10px"
    },
    attrs: {
      "href": _vm.downTpl
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "size": "small"
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.list.import_muban')))])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_deviceNum'),
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.uldata ? _vm.uldata.terNums : 0 + _vm.$t('app_amechine')) + "\n\t\t\t")])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.pushImport = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitUpload
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.$t('app_srpush')) + "\n\t\t\t")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1095 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": "addApp"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    on: {
      "click": _vm.multiAdd
    }
  }, [_vm._v(_vm._s(_vm.$t('app_mulAdd')) + " (" + _vm._s(_vm.sNum) + ")")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "gSpDiv"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('MechanismSelector', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-cascader', {
    staticClass: "gCtrl",
    attrs: {
      "expand-trigger": "hover",
      "options": _vm.appTypes,
      "show-all-levels": false
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.appType),
      callback: function($$v) {
        _vm.appType = $$v
      },
      expression: "appType"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_appName'),
      "on-icon-click": _vm.query,
      "icon": "search"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "gTopMg"
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "appName",
      "label": _vm.$t('app_appName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "appCategoryName",
      "label": _vm.$t('app_type'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "distributorName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "appInstallType",
      "label": _vm.$t('app_insType'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', [_vm._v(_vm._s(_vm.setInstallType(scope.row.appInstallType)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "align": "center",
      "formatter": _vm.dateFormat,
      "label": _vm.$t('app_ulTime'),
      "width": "175"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "appVersion",
      "label": _vm.$t('app_version'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "align": "center",
      "label": _vm.$t('app_operate'),
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_add'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.addAppToMyList(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-plus-square"
        })])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1096 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    staticClass: "gPageBorder pushObjectDetail"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.info.animatName))]), _vm._v(" "), _c('el-row', {
    staticClass: "detail",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('label', [_vm._v("动画类型:")]), _vm._v(_vm._s(_vm.aType[_vm.info.animatType]))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('label', [_vm._v("动画大小:")]), _vm._v(_vm._s(_vm.info.size))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('label', [_vm._v("渠道商:")]), _vm._v("无")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('label', [_vm._v("上传时间:")]), _vm._v(_vm._s(_vm.info.createTime))])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.pLoading),
      expression: "pLoading"
    }],
    staticClass: "gTopMg gPageBorder"
  }, [_c('p', {
    staticClass: "gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_pushHistory')))]), _vm._v(" "), _c('div', {
    staticClass: "subTitle_buttonBar"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.jumpToPush()
      }
    }
  }, [_vm._v("添加推送")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_vm._v("批量还原(" + _vm._s(_vm.multipleSelection.length || 0) + ")")])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "row-click": _vm.cellClick,
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechanismName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "nums",
      "label": _vm.$t('app_deviceNum'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "pushTime",
      "label": _vm.$t('app_pushTime'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "align": "center",
      "label": _vm.$t('app_operate'),
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_clear'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('paging', {
    attrs: {
      "rdata": _vm.pagingData,
      "action": _vm.pAction
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "1px",
      "margin-bottom": "20px"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1097 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v(_vm._s(_vm.$t('app_animateMake')))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "animatName",
      "label": _vm.$t('app_name'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "animatType",
      "label": _vm.$t('app_type'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', [_vm._v(_vm._s(_vm.aType[scope.row.animatType]))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "pushTimes",
      "label": _vm.$t('app_pushTimes'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "createTime",
      "label": _vm.$t('app_customsTime'),
      "width": "175"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "align": "center",
      "label": _vm.$t('app_operate'),
      "width": "106"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          staticStyle: {
            "color": "#FF4949"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteRow(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash"
        })])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.page,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1098 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ae"
    }
  }, [_c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_pushDevice'),
      "size": "large"
    },
    model: {
      value: (_vm.pushedList),
      callback: function($$v) {
        _vm.pushedList = $$v
      },
      expression: "pushedList"
    }
  }, [_c('div', {
    staticClass: " ",
    attrs: {
      "id": ""
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.list.length == 0
    },
    on: {
      "click": function($event) {
        _vm.mulDelAppPush()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_mulUnbind')))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    on: {
      "click": function($event) {
        _vm.refreshBind()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.shuaxin')))])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "offset": 1,
      "span": 4
    }
  }, [_c('div', {}, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_adname'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "dpTable",
      "data": _vm.tableData1,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalName",
      "align": "center",
      "label": _vm.$t('app_deviceName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_deviceNo'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pushTime",
      "align": "center",
      "label": _vm.$t('app_pushTime'),
      "width": "175"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "106"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_unbind'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.delAppPush(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.page,
      "page-sizes": _vm.$gRows,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized1
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "width": "140px",
      "height": "140px",
      "margin": "24px 24px 24px 24px",
      "display": "inline-block",
      "float": "left",
      "overflow": "hidden"
    }
  }, [_c('div', {
    style: (_vm.avtStyle)
  })]), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "calc(100% - 188px)",
      "height": "100%",
      "margin-bottom": "0px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-appmain",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.data.appName : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "60px"
    }
  }, [_c('table', {
    staticClass: "dt-app-app"
  }, [_c('tr', [_c('td', [_c('label', {
    staticClass: "dt-word-apptt"
  }, [_vm._v(_vm._s(_vm.$t('app_version')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-appmain"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.data.appVersion : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-apptt"
  }, [_vm._v(_vm._s(_vm.$t('app_verTag')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-appmain"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.data.versioncode : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-apptt"
  }, [_vm._v(_vm._s(_vm.$t('app_package')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-appmain"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.data.packagename : ''))])]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticClass: "dt-word-apptt"
  }, [_vm._v(_vm._s(_vm.$t('terminal.appBind.label_size')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-appmain"
  }, [_vm._v(_vm._s(_vm.config ? ((_vm.config.data.appSize / 1024) / 1024).toFixed(2) + 'MB' : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-apptt"
  }, [_vm._v(_vm._s(_vm.$t('app_appType')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-appmain"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.data.appCategoryName : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-apptt"
  }, [_vm._v(_vm._s(_vm.$t('app_vStatus')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-appmain"
  }, [_vm._v(_vm._s(_vm.config ? _vm.vSt[_vm.config.data.appStatus] : ''))])]), _vm._v(" "), _c('td')])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-height": "60px",
      "display": "-webkit-flex"
    }
  }, [_c('div', {
    staticClass: "dt-word-apptt",
    staticStyle: {
      "display": "inline-block",
      "min-width": "70px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('app_introl')) + "：\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "dt-word-appmain",
    staticStyle: {
      "display": "inline-block",
      "position": "relative",
      "background": "none",
      "margin": "0 24px 24px 0"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.config ? _vm.config.data.appDesc : ''))])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.captures ? _vm.captures.length > 0 : false),
      expression: "captures? captures.length > 0 : false"
    }],
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gCtColor  gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_screenShot')) + " ")]), _vm._v(" "), _c('div', _vm._l((_vm.captures), function(item) {
    return _c('img', {
      staticClass: "gBorder",
      staticStyle: {
        "width": "180px",
        "height": "320px",
        "margin": "24px 0 24px 24px",
        "border-radius": "4px"
      },
      attrs: {
        "onerror": "this.src='/static/img/df-h.png'",
        "src": _vm.imgFullUrl(item)
      }
    })
  }))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.dobj.isMk),
      expression: "!dobj.isMk"
    }],
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gCtColor gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_hisVer')) + " ")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin": "24px 0 24px 24px"
    },
    attrs: {
      "disabled": _vm.tableData ? _vm.tableData.length == 0 : false,
      "type": "primary"
    },
    on: {
      "click": _vm.uploadNew
    }
  }, [_vm._v(_vm._s(_vm.$t('app_ulNew')))]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appName",
      "label": _vm.$t('app_appName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appVersion",
      "width": "",
      "label": _vm.$t('app_version')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appCategoryName",
      "width": "",
      "label": _vm.$t('app_type')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "formatter": _vm.dateFormat,
      "prop": "createTime",
      "width": "170",
      "label": _vm.$t('app_ulTime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "formatter": _vm.verifyFm,
      "prop": "createTime",
      "width": "",
      "label": _vm.$t('app_vStatus')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "",
      "width": "118",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.send'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.appStatus == 2),
            expression: "scope.row.appStatus == 2"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.pushApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_down'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.appStatus == 2),
            expression: "scope.row.appStatus == 2"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.downOldApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-download"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_smVerify'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.appStatus !== '1' && scope.row.appStatus !== '2' && scope.row.isoperation === 0),
            expression: "scope.row.appStatus !== '1' && scope.row.appStatus !== '2' && scope.row.isoperation === 0"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.submitApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-up"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.isoperation === 0),
            expression: "scope.row.isoperation === 0"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1099 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "gPageBorder"
  }, [_c('eqdia', {
    attrs: {
      "config": _vm.econfig
    }
  }), _vm._v(" "), _c('el-row', {
    staticClass: "gTopMg",
    staticStyle: {
      "margin-bottom": "20px",
      "padding": "0 20px 0 20px"
    },
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showEQ
    }
  }, [_vm._v(_vm._s(_vm.$t('app_eqcapture')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4,
      "offset": 8
    }
  }, [_c('div', {}, [_c('MechanismSelector', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('lin_global.label_no'),
      "icon": "search",
      "on-icon-click": _vm.handleIconClick
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.focusEvent(_vm.handleIconClick)
      }
    },
    model: {
      value: (_vm.queryCondition.terminal_no),
      callback: function($$v) {
        _vm.$set(_vm.queryCondition, "terminal_no", $$v)
      },
      expression: "queryCondition.terminal_no"
    }
  })], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": _vm.$t('lin_global.loading'),
      "data": _vm.tableData,
      "id": "tableData",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "terminalNo",
      "label": _vm.$t('app_deviceNo'),
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalName",
      "label": _vm.$t('app_deviceName'),
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mechname",
      "label": _vm.$t('app_distributor'),
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "optTime",
      "label": _vm.$t('app_cpttime'),
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": _vm.$t('lin_global.status'),
      "formatter": _vm.formatStatus,
      "show-overflow-tooltip": true,
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('lin_global.ope'),
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_view'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "disabled": scope.row.status != 2,
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.viewRow(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-file-image-o"
        })])], 1), _vm._v("\r\n\r\n\t\t\t \r\n\r\n\t\t\t"), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.delete'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.delRow(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.total > 0) ? _c('div', {
    staticClass: "  gPgDiv ",
    attrs: {
      "id": "pagination"
    }
  }, [_c('el-pagination', {
    staticClass: "gPg",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.page,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1100 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.hLoading),
      expression: "hLoading"
    }],
    staticClass: "gTopMg gPageBorder"
  }, [_c('el-table', {
    ref: "arrdata",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.arrdata,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": _vm.$t('lin_global.name')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "version",
      "label": _vm.$t('lin_global.version'),
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('lin_global.status'),
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 0) ? _c('span', {
          staticStyle: {
            "color": "#8492A6"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.waitOne')))]) : _vm._e(), _vm._v(" "), (scope.row.status == 1) ? _c('span', {
          staticStyle: {
            "color": "#F7BA2A"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.waitTwo')))]) : _vm._e(), _vm._v(" "), (scope.row.status == 2) ? _c('span', {
          staticStyle: {
            "color": "#13CE66"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.verifyPass')))]) : _vm._e(), _vm._v(" "), (scope.row.status == 3) ? _c('span', {
          staticStyle: {
            "color": "#FF4949"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.verifyNotPass')))]) : _vm._e(), _vm._v(" "), (scope.row.ifInfor) ? _c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "top"
          }
        }, [_c('p', [_vm._v(_vm._s(scope.row.auditContent))]), _vm._v(" "), _c('span', {
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [(scope.row.ifInfor) ? _c('el-icon', {
          staticStyle: {
            "cursor": "pointer",
            "color": "#58B7FF"
          },
          attrs: {
            "name": "information"
          }
        }) : _vm._e()], 1)]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": _vm.$t('terminal.details.animatType'),
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', [_vm._v(_vm._s(_vm.otaUdType(scope.row.updateType)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mechanismName",
      "label": _vm.$t('lin_global.label_areaid')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "size",
      "label": _vm.$t('app_fileSize'),
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": _vm.$t('lin_global.ope'),
      "width": "106"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return undefined
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 50, 100],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1101 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.gloading),
      expression: "gloading"
    }],
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "width": "calc(100% - 24px)",
      "height": "100%",
      "background": "none",
      "padding-left": "24px",
      "padding-bottom": "24px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_developer')) + "ID")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "44px"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', {}, [_c('td', {}, [_c('p', {
    staticClass: "dt-word-title",
    staticStyle: {
      "display": "inline-block",
      "width": "80px"
    }
  }, [_vm._v("AppKey：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.keyInfo ? _vm.keyInfo.key : ''))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('p', {
    staticClass: "dt-word-title",
    staticStyle: {
      "display": "inline-block",
      "width": "80px"
    }
  }, [_vm._v("AppSecret：")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowSec),
      expression: "isShowSec"
    }],
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.keyInfo ? _vm.keyInfo.secret : '') + "    ")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "color": "#58B7FF",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.showclick
    }
  }, [_vm._v(_vm._s(_vm.showkeylb))]), _vm._v("  / \r\n              "), _c('label', {
    staticStyle: {
      "color": "#58B7FF",
      "cursor": "pointer",
      "padding-right": "12px"
    },
    on: {
      "click": _vm.generateKey
    }
  }, [_vm._v(_vm._s(_vm.$t('app_reset')))])])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder gTopMg",
    attrs: {
      "id": ""
    }
  }, [_c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('div', {}, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.jumpToUpload
    }
  }, [_vm._v(_vm._s(_vm.$t('app_addpsg')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('app_type')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.selectMid),
      callback: function($$v) {
        _vm.selectMid = $$v
      },
      expression: "selectMid"
    }
  }, _vm._l((_vm.authSts), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_name'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)])], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    staticClass: "tbPoint gTopMg",
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appname",
      "label": _vm.$t('app_psgname'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "merchantName",
      "width": "",
      "label": _vm.$t('app_distributor')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "status",
      "width": "115",
      "label": _vm.$t('app_authstat')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('tagc', {
          attrs: {
            "tagobj": {
              type: 'openAuthType',
              vl: scope.row.isauthen + ''
            }
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "createTime",
      "width": "175",
      "fformatter": "dateFormat",
      "label": _vm.$t('app_addtime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "right",
      "prop": "operate",
      "width": "122",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_edit'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.editApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "right",
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.name')
    }
  }, [_c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.editorForm.adTitle))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.classify')
    }
  }, _vm._l((_vm.adTypeList), function(item) {
    return (item.adtypeId === _vm.editorForm.adType) ? _c('span', {
      staticClass: "grey_color"
    }, [_vm._v(_vm._s(item.adtypeName))]) : _vm._e()
  })), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.position')
    }
  }, [
    [(_vm.editorForm.adPosition == 0) ? _c('span', {
      staticClass: "grey_color"
    }, [_vm._v(_vm._s(_vm.$t('advert.positionSub.banner')))]) : _vm._e(), _vm._v(" "), (_vm.editorForm.adPosition == 1) ? _c('span', {
      staticClass: "grey_color"
    }, [_vm._v(_vm._s(_vm.$t('advert.positionSub.starPage')))]) : _vm._e(), _vm._v(" "), (_vm.editorForm.adPosition == 3) ? _c('span', {
      staticClass: "grey_color"
    }, [_vm._v(_vm._s(_vm.$t('app_appadv')))]) : _vm._e()]
  ], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.jumpType')
    }
  }, [(_vm.editorForm.adUrltype == '0') ? _c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.$t('advert.jumpTypeSub.net')))]) : _vm._e(), _vm._v(" "), (_vm.editorForm.adUrltype == '1') ? _c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.$t('advert.jumpTypeSub.appStore')))]) : _vm._e()]), _vm._v(" "), (_vm.editorForm.adUrltype === '1') ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.app'),
      "prop": "ad_url"
    }
  }, [_c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.editorForm.appName))])]) : _vm._e(), _vm._v(" "), (_vm.editorForm.adUrltype === '0') ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.url')
    }
  }, [_c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.editorForm.adUrl))])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.ableDate')
    }
  }, [_c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.dateFormat2(_vm.editorForm.adStartEnd)))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.contentImg')
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imageUrl + _vm.editorForm.adImgurl,
      "width": "100%",
      "height": "auto"
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.isPass'),
      "prop": "resource"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.isAble),
      callback: function($$v) {
        _vm.isAble = $$v
      },
      expression: "isAble"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('advert.pass')))]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t('advert.notPass')))])], 1)], 1), _vm._v(" "), (_vm.isAble === '0') ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.refusal')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.refuse_reason),
      callback: function($$v) {
        _vm.refuse_reason = $$v
      },
      expression: "refuse_reason"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sbIsAble
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.ok')))])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1103 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('div', {}, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.jumpToUpload
    }
  }, [_vm._v(_vm._s(_vm.$t('app_addsecrrule')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_name'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)])], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    staticClass: "tbPoint gTopMg",
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "keyName",
      "label": _vm.$t('app_secrname'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "memo",
      "width": "",
      "label": _vm.$t('app_secrdesc')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "terNums",
      "width": "115",
      "label": _vm.$t('app_deviceNum')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "createTime",
      "width": "176",
      "label": _vm.$t('app_addtime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "operate",
      "width": "86",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "background": "none"
          }
        }, [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_edit'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (true),
            expression: "true"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.editApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_smVerify'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status == 0 || scope.row.status == 3),
            expression: "scope.row.status == 0 || scope.row.status == 3"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.submitApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-external-link-square"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (true),
            expression: "true"
          }],
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1104 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [
      _vm.type === 'textarea' ? 'el-textarea' : 'el-input',
      _vm.size ? 'el-input--' + _vm.size : '',
      {
        'is-disabled': _vm.disabled,
        'el-input-group': _vm.$slots.prepend || _vm.$slots.append,
        'el-input-group--append': _vm.$slots.append,
        'el-input-group--prepend': _vm.$slots.prepend
      }
    ]
  }, [(_vm.type !== 'textarea') ? [(_vm.$slots.prepend) ? _c('div', {
    staticClass: "el-input-group__prepend"
  }, [_vm._t("prepend")], 2) : _vm._e(), _vm._v(" "), _vm._t("icon", [(_vm.icon) ? _c('i', {
    staticClass: "el-input__icon",
    class: [
      'el-icon-' + _vm.icon,
      _vm.onIconClick ? 'is-clickable' : ''
    ],
    on: {
      "click": _vm.handleIconClick
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.type !== 'textarea') ? _c('input', _vm._b({
    ref: "input",
    staticClass: "el-input__inner",
    attrs: {
      "autocomplete": _vm.autoComplete
    },
    domProps: {
      "value": _vm.currentValue
    },
    on: {
      "input": _vm.handleInput,
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur
    }
  }, 'input', _vm.$props, false)) : _vm._e(), _vm._v(" "), (_vm.validating) ? _c('i', {
    staticClass: "el-input__icon el-icon-loading"
  }) : _vm._e(), _vm._v(" "), (_vm.$slots.append) ? _c('div', {
    staticClass: "el-input-group__append"
  }, [_vm._t("append")], 2) : _vm._e()] : _c('textarea', _vm._b({
    ref: "textarea",
    staticClass: "el-textarea__inner",
    style: (_vm.textareaStyle),
    domProps: {
      "value": _vm.currentValue
    },
    on: {
      "input": _vm.handleInput,
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur
    }
  }, 'textarea', _vm.$props, false))], 2)
},staticRenderFns: []}

/***/ }),
/* 1105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ae"
    }
  }, [_c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_addPush'),
      "size": "middle"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    staticClass: "gDiaTable",
    staticStyle: {
      "width": "100%",
      "background": "none",
      "text-align": "left"
    }
  }, [_c('span'), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticStyle: {
      "margin-right": "16px"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.stModel), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.label,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "40%",
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": _vm.$t('app_searchTerminal'),
      "icon": "search"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srchDevice($event)
      }
    },
    model: {
      value: (_vm.srchValue),
      callback: function($$v) {
        _vm.srchValue = $$v
      },
      expression: "srchValue"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dLoading),
      expression: "dLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_terNo'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminal_status",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_push'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_banReason')
    },
    model: {
      value: (_vm.notPassDialog),
      callback: function($$v) {
        _vm.notPassDialog = $$v
      },
      expression: "notPassDialog"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_reason'),
      "label-width": "14%"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.notPassDialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.verifyRqs('3')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_submit')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "background": "none",
      "padding": "0 0px 0 24px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.videoname : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('table', {
    staticClass: "dt-launch"
  }, [_c('tr', {}, [_c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_addur')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.duration : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_fileSize')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.size : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_vsize')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.dimension : ''))])]), _vm._v(" "), _c('td')])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('table', {
    staticClass: "dt-launch"
  }, [_c('tr', {}, [_c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_addps')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.username : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_addtime')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.makeCreateTime(_vm.config.createtime) : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_tofvaliss')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.timeLimit(_vm.config) : ''))])]), _vm._v(" "), _c('td')])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "none",
      "padding": "0 0px 24px 0px"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.$router.go(-1);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.verify('2')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_psverify')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.verify('3')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_ban')))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gCtColor  gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_vpreview')) + " ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "480px",
      "background": "black",
      "text-align": "center",
      "overflow": "hiiden"
    }
  }, [_c('video', {
    attrs: {
      "height": "480px",
      "src": _vm.playUrl,
      "controls": "controls"
    }
  }, [_vm._v("\n        your browser is not support video tag\n      ")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1106 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "label-position": "left",
      "label-width": "90px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "报警邮箱",
      "prop": "name"
    }
  }, [_c('el-input')], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', [_vm._v("重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.onCreate()
      }
    }
  }, [_vm._v("立即创建")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1107 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ae"
    }
  }, [_c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_addPush'),
      "size": "middle"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    staticClass: "gDiaTable",
    staticStyle: {
      "width": "100%",
      "background": "none",
      "text-align": "left"
    }
  }, [_c('span'), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticStyle: {
      "margin-right": "16px"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.stModel), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "40%",
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": _vm.$t('app_searchTerminal'),
      "icon": "search"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srchDevice($event)
      }
    },
    model: {
      value: (_vm.srchValue),
      callback: function($$v) {
        _vm.srchValue = $$v
      },
      expression: "srchValue"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dLoading),
      expression: "dLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_terNo'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminal_status",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 3) ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_sleep')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_push'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_banReason')
    },
    model: {
      value: (_vm.notPassDialog),
      callback: function($$v) {
        _vm.notPassDialog = $$v
      },
      expression: "notPassDialog"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_reason'),
      "label-width": "14%"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.notPassDialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.verifyRqs('3')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_submit')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "background": "none",
      "padding": "0 0px 0 24px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "ldt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.launchername : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('table', {
    staticClass: "ldt-launch"
  }, [_c('tr', {}, [_c('td', [_c('label', {
    staticClass: "ldt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_version')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "ldt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.version : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "ldt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_verTag')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "ldt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.versioncode : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "ldt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_package')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "ldt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.packagename : ''))])]), _vm._v(" "), _c('td')])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "none",
      "min-height": "10px",
      "display": "-webkit-flex"
    }
  }, [_c('div', {
    staticClass: "ldt-word-title",
    staticStyle: {
      "display": "inline-block",
      "min-width": "70px"
    }
  }, [_vm._v("\n          launch" + _vm._s(_vm.$t('app_ss')) + "：\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "ldt-word-main",
    staticStyle: {
      "display": "inline-block",
      "position": "relative",
      "background": "none",
      "margin": "0 24px 24px 0",
      "padding-right": "24px"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.config ? _vm.config.launcherdesc : ''))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "none",
      "padding": "0 0px 24px 0px"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.$router.go(-1);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.verify('2')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_psverify')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.verify('3')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_ban')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_pushInstallTest')))])], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.captures ? _vm.captures.length > 0 : false),
      expression: "captures? captures.length > 0 : false"
    }],
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gCtColor  gPTitle"
  }, [_vm._v(_vm._s('launch' + _vm.$t('app_printscreen')) + " ")]), _vm._v(" "), _c('div', _vm._l((_vm.captures), function(item) {
    return _c('img', {
      staticClass: "gBorder",
      staticStyle: {
        "width": "180px",
        "height": "320px",
        "margin": "24px 0 24px 24px",
        "border-radius": "4px"
      },
      attrs: {
        "onerror": "this.src='/static/img/df-h.png'",
        "src": _vm.imgFullUrl(item)
      }
    })
  }))])], 1)
},staticRenderFns: []}

/***/ }),
/* 1108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    staticClass: "tbPoint",
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "fileName",
      "label": _vm.$t('app_appName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "fileVersion",
      "width": "",
      "label": _vm.$t('app_version')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "mechName",
      "width": "",
      "label": _vm.$t('app_distributor')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "fileStatus",
      "width": "115",
      "label": _vm.$t('app_status')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          style: (_vm.getStatus(scope.row.fileStatus).style)
        }, [_vm._v(_vm._s(_vm.getStatus(scope.row.fileStatus).vl))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "createTime",
      "width": "175",
      "label": _vm.$t('app_addtime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "operate",
      "width": "84",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_verify'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_c('i', {
          staticClass: "fa fa-check-square-o"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1109 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "gPageBorder"
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "24px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.open_add
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t('app_new')) + "\n\t\t\t\t")]), _vm._v(" "), _c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.open_import
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t('app_Batch_import')) + "\n\t\t\t\t")]), _vm._v(" "), _c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.push_device
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t('app_Batch_push')) + "\n\t\t\t\t")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": _vm.id_list.length > 0 ? false : true
    },
    on: {
      "click": _vm.batchDelete
    }
  }, [_vm._v(_vm._s(_vm.$t('advert.deleteAll')))])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-bottom": "24px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_input_sn')
    },
    model: {
      value: (_vm.select_form.terminalNo),
      callback: function($$v) {
        _vm.$set(_vm.select_form, "terminalNo", $$v)
      },
      expression: "select_form.terminalNo"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    model: {
      value: (_vm.select_form.status),
      callback: function($$v) {
        _vm.$set(_vm.select_form, "status", $$v)
      },
      expression: "select_form.status"
    }
  }, _vm._l((_vm.ctyps), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getData
    }
  }, [_vm._v(_vm._s(_vm.$t('app_query')))])], 1)])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "data": _vm.tableData2,
      "id": "tp",
      "border": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange_1
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalNo",
      "align": "center",
      "header-align": "center",
      "label": _vm.$t('app_serialnumber')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalNoNew",
      "align": "center",
      "header-align": "center",
      "label": _vm.$t('app_serialnumber_new')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalName",
      "align": "center",
      "header-align": "center",
      "label": _vm.$t('app_deviceName')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mechName",
      "align": "center",
      "header-align": "center",
      "label": _vm.$t('lin_global.label_areaid')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "header-align": "center",
      "prop": "status",
      "label": _vm.$t('app_status'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 0) ? _c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_status_update')) + "\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (scope.row.status == 1) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_status_updated')) + "\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (scope.row.status == 2) ? _c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_status_exist')) + "\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (scope.row.status == 3) ? _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_status_fail')) + "\n\t\t\t\t\t")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "header-align": "center",
      "prop": "snStatus",
      "label": _vm.$t('app_termin_status'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.snStatus == 0) ? _c('el-tag', {
          attrs: {
            "hit": true
          }
        }, [_vm._v(_vm._s(_vm.$t('app_status_update')) + "\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (scope.row.snStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "hit": true
          }
        }, [_vm._v(_vm._s(_vm.$t('app_success')) + "\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (scope.row.snStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "hit": true
          }
        }, [_vm._v(_vm._s(_vm.$t('app_status_fail')) + "\n\t\t\t\t\t")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "align": "center",
      "header-align": "center",
      "label": _vm.$t('lin_global.createTime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "label": _vm.$t('lin_global.ope'),
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteRow(scope.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 50, 100],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_adddv'),
      "size": ""
    },
    on: {
      "close": _vm.handleClose
    },
    model: {
      value: (_vm.pushdev),
      callback: function($$v) {
        _vm.pushdev = $$v
      },
      expression: "pushdev"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-row', {}, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary",
      "disabled": _vm.push_list.length == 0
    },
    on: {
      "click": _vm.bcPush
    }
  }, [_vm._v(_vm._s(_vm.$t('app_pushsldev')))])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "offset": 0,
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.get_device_list
    },
    model: {
      value: (_vm.form.cmtStatus),
      callback: function($$v) {
        _vm.$set(_vm.form, "cmtStatus", $$v)
      },
      expression: "form.cmtStatus"
    }
  }, _vm._l((_vm.cmtStatusArr), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "offset": 0,
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_dyf')
    },
    on: {
      "change": _vm.get_device_list
    },
    model: {
      value: (_vm.form.secretKeyDownload),
      callback: function($$v) {
        _vm.$set(_vm.form, "secretKeyDownload", $$v)
      },
      expression: "form.secretKeyDownload"
    }
  }, _vm._l((_vm.secretKeyDownload_list), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "offset": 0,
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_wtk')
    },
    on: {
      "change": _vm.get_device_list
    },
    model: {
      value: (_vm.form.secretKeyExist),
      callback: function($$v) {
        _vm.$set(_vm.form, "secretKeyExist", $$v)
      },
      expression: "form.secretKeyExist"
    }
  }, _vm._l((_vm.secretKeyExist_list), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "offset": 0,
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('MechanismSelector', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mechanismData_2
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_terNo'),
      "icon": "search",
      "on-icon-click": _vm.get_device_list
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.get_device_list($event)
      }
    },
    model: {
      value: (_vm.form.terminalNo),
      callback: function($$v) {
        _vm.$set(_vm.form, "terminalNo", $$v)
      },
      expression: "form.terminalNo"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "dpTable",
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalNo",
      "align": "center",
      "label": _vm.$t('app_terNo'),
      "width": "210"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "210"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalStatus",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "210"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_c('tagc', {
          attrs: {
            "tagobj": {
              type: 'terSt',
              vl: scope.row.terminalStatus
            }
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": "210"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "106"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.send'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.pushed(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.page,
      "page-sizes": [20, 100],
      "page-size": _vm.ttpage,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_fipush')
    },
    on: {
      "close": _vm.closeImport
    },
    model: {
      value: (_vm.pushImport),
      callback: function($$v) {
        _vm.pushImport = $$v
      },
      expression: "pushImport"
    }
  }, [_c('el-form', {
    ref: "",
    attrs: {
      "model": "",
      "rules": ""
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_ulfile'),
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "name": "fileUpload",
      "action": _vm.ulurl(),
      "before-upload": _vm.srcBefore,
      "on-success": _vm.srcSuccess,
      "on-error": _vm.ulError,
      "file-list": _vm.fileList,
      "auto-upload": false
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v(_vm._s(_vm.$t('app_clickUpdate')))]), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-left": "8px",
      "margin-right": "10px"
    },
    attrs: {
      "href": _vm.downTpl
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "size": "small"
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.list.import_muban')))])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_deviceNum'),
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.uldata ? _vm.uldata.terNums : 0 + _vm.$t('app_amechine')) + "\n\t\t\t")])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.pushImport = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitUpload
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.$t('app_srpush')) + "\n\t\t\t")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1110 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.editInfo.status === 3),
      expression: "this.editInfo.status === 3"
    }]
  }, [_c('el-alert', {
    staticStyle: {
      "display": "-webkit-flex",
      "margin": "0 0 24px 0"
    },
    attrs: {
      "title": _vm.reason,
      "type": "error",
      "show-icon": ""
    }
  })], 1), _vm._v(" "), _c('el-form', {
    ref: "addForm",
    staticClass: "gForm",
    attrs: {
      "id": "addForm",
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "13.5%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_ad') + _vm.$t('app_name'),
      "prop": "videoName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_input')
    },
    model: {
      value: (_vm.form.videoName),
      callback: function($$v) {
        _vm.$set(_vm.form, "videoName", $$v)
      },
      expression: "form.videoName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "label": _vm.$t('app_vdofile'),
      "prop": "url"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo aeMg",
    attrs: {
      "data": _vm.uData,
      "drag": "",
      "name": "fileUpload",
      "file-list": _vm.fileList,
      "on-success": _vm.fileUploadSuccess,
      "before-upload": _vm.fileBeforeUpload,
      "action": _vm.$videoUrl
    }
  }, [_c('span', [(_vm.ulinfo.index === 0) ? _c('i', {
    class: _vm.ulinfo.icons[_vm.ulinfo.index]
  }) : _c('div', {
    staticStyle: {
      "margin-top": "12px",
      "color": "#48576A"
    }
  }, [_c('i', {
    class: _vm.ulinfo.icons[_vm.ulinfo.index],
    style: (_vm.tipColor)
  }), _vm._v(" "), _c('el-col', [_c('el-row', {
    staticStyle: {
      "margin-top": "-8px"
    }
  }, [_c('div'), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "26px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_filename')) + ": " + _vm._s(_vm.form.fileName))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "26px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_vdodur')) + ": " + _vm._s(_vm.form.duration))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "26px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_fileSize')) + ": " + _vm._s(_vm.form.size))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "26px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_vsize')) + ": " + _vm._s(_vm.form.dimension))]), _vm._v(" "), _c('div', [_c('label', {
    staticStyle: {
      "margin-top": "6px",
      "color": "#B2BBC5",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_clreulvdo')))])])])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ulinfo.index === 0),
      expression: "ulinfo.index === 0"
    }],
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.ulinfo.tip))])])])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), (_vm.isUpload) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('app_addvdoad')))]) : _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('app_edvdoad')))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "bdialog"
    }
  }, [_c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gDia",
    attrs: {
      "title": _vm.config.edit ? _vm.$t('app_editver') : _vm.$t('app_addver')
    },
    on: {
      "close": _vm.verClose
    },
    model: {
      value: (_vm.isNewVer),
      callback: function($$v) {
        _vm.isNewVer = $$v
      },
      expression: "isNewVer"
    }
  }, [_c('div', [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label-width": _vm.widthps,
      "label": _vm.$t('app_version')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.vform.ver),
      callback: function($$v) {
        _vm.$set(_vm.vform, "ver", $$v)
      },
      expression: "vform.ver"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": _vm.widthps,
      "label": _vm.$t('app_pubdate')
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "format": _vm.yyyy - _vm.MM - _vm.dd,
      "picker-options": _vm.pickerOptions0,
      "placeholder": _vm.$t('app_select')
    },
    model: {
      value: (_vm.vform.date),
      callback: function($$v) {
        _vm.$set(_vm.vform, "date", $$v)
      },
      expression: "vform.date"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": _vm.widthps,
      "label": _vm.$t('app_updct')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5
    },
    model: {
      value: (_vm.vform.content),
      callback: function($$v) {
        _vm.$set(_vm.vform, "content", $$v)
      },
      expression: "vform.content"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.verClose
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitVer()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_sure')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gDia",
    attrs: {
      "title": _vm.config.edit ? _vm.$t('app_editblt') : _vm.$t('app_addblt')
    },
    on: {
      "close": _vm.bltClose
    },
    model: {
      value: (_vm.isNewBlt),
      callback: function($$v) {
        _vm.isNewBlt = $$v
      },
      expression: "isNewBlt"
    }
  }, [_c('div', [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label-width": _vm.widthps,
      "label": _vm.$t('app_blttt')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.bform.title),
      callback: function($$v) {
        _vm.$set(_vm.bform, "title", $$v)
      },
      expression: "bform.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": _vm.widthps,
      "label": _vm.$t('app_bltct')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 7
    },
    model: {
      value: (_vm.bform.content),
      callback: function($$v) {
        _vm.$set(_vm.bform, "content", $$v)
      },
      expression: "bform.content"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.bltClose
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitBlt()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_sure')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.getPre() + _vm.info.title,
      "visible": _vm.isView,
      "size": "small",
      "before-close": _vm.viewClose
    },
    on: {
      "update:visible": function($event) {
        _vm.isView = $event
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "markdownBody"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.info.content)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.viewClose
    }
  }, [_vm._v(_vm._s(_vm.$t('app_sure')))])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1112 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    ref: "addForm",
    staticClass: "mt20",
    attrs: {
      "id": "addForm",
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.otaName'),
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('terminal.appBind.label_version'),
      "prop": "version"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.version),
      callback: function($$v) {
        _vm.$set(_vm.form, "version", $$v)
      },
      expression: "form.version"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.risk_desc'),
      "prop": "memo"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.memo),
      callback: function($$v) {
        _vm.$set(_vm.form, "memo", $$v)
      },
      expression: "form.memo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.xgscwj'),
      "prop": "filePath"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "name": "fileUpload",
      "drag": "",
      "action": _vm.action,
      "on-success": _vm.handleAvatarScucess,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.jwjtdcc'))), _c('em', [_vm._v(_vm._s(_vm.$t('lin_global.djsc')))])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.qsczipwjls50')))])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_udfiletype'),
      "prop": ""
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.form.updateType),
      callback: function($$v) {
        _vm.$set(_vm.form, "updateType", $$v)
      },
      expression: "form.updateType"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_ttPkg')))]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.form.updateType),
      callback: function($$v) {
        _vm.$set(_vm.form, "updateType", $$v)
      },
      expression: "form.updateType"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_dfPkg')))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.azbdz')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.filePath),
      callback: function($$v) {
        _vm.$set(_vm.form, "filePath", $$v)
      },
      expression: "form.filePath"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.zdqds'),
      "prop": "mechanismId"
    }
  }, [(_vm.mechanismData.value) ? _c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData,
      "mselect": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "id": "onCancel"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.add')))])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1113 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.dtitle,
      "size": "small"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "-8px"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.ddes)))]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100%",
      "margin-top": "16px"
    },
    attrs: {
      "pplaceholder": "$t('app_plsip') + $t('app_banReason')",
      "type": "textarea"
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "margin-top": "-20px"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submit('3')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_suresm')))])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "gPageBorder gTopMg gPdTB"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.ota + _vm.$t('app_name')
    }
  }, [_vm._v("\r\n            " + _vm._s(_vm.userinfo.name) + "\r\n          ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.version')
    }
  }, [_vm._v("\r\n            " + _vm._s(_vm.userinfo.version) + "\r\n          ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_distributor')
    }
  }, [_vm._v("\r\n            " + _vm._s(_vm.qudao) + "\r\n          ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-left": "24px",
      "margin-bottom": "12px"
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.submit('2')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_psverify')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_ban')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.showTableE
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.tsazcs')))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "size": "small",
      "title": _vm.$t('lin_global.zdtslb')
    },
    model: {
      value: (_vm.showTable),
      callback: function($$v) {
        _vm.showTable = $$v
      },
      expression: "showTable"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('lin_global.label_no'),
      "icon": "search",
      "on-icon-click": _vm.handleIconClick
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.focusEvent(_vm.handleIconClick)
      }
    },
    model: {
      value: (_vm.input1),
      callback: function($$v) {
        _vm.input1 = $$v
      },
      expression: "input1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-table', {
    ref: "arrdata",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.arrdata,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "terminalName",
      "label": _vm.$t('lin_global.label_name'),
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalNo",
      "label": _vm.$t('lin_global.label_no'),
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('lin_global.status'),
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.new_add')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 3) ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_sleep')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mechName",
      "label": _vm.$t('lin_global.label_areaid')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "80",
      "label": _vm.$t('lin_global.ope')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.send'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.give(scope.row.terminalNo)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 50, 100],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "background": "white"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "gPageBorder gTopMg"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "calc(100% - 48px)",
      "height": "100%",
      "margin-bottom": "0px",
      "background": "none",
      "padding": "0 0px 12px 24px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.configName : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "22px"
    }
  }, [_c('table', {
    staticClass: "lcpush"
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.fwqdizhi')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.address : ''))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_port')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.port : ''))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_addtime')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.createTime : ''))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gCtColor gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_fludlist')) + " ")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "gSgLeftBtn"
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addTer
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.list.add_btn')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getList
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.shuaxin')))])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_name') + ' & ' + _vm.$t('app_number'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.hiss,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_deviceName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "terminalNo",
      "width": "",
      "label": _vm.$t('app_deviceNo')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "mechName",
      "width": "",
      "label": _vm.$t('app_distributor')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "version",
      "formatter": _vm.showBindSt,
      "width": "",
      "label": _vm.$t('app_status')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "",
      "width": "86",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status != 1),
            expression: "scope.row.status != 1"
          }],
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.unbind(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_global.chongtui'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status == 0),
            expression: "scope.row.status == 0"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.repushRow(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-repeat"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv",
    staticStyle: {}
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.page,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pageTotal
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSize
    }
  })], 1)], 1), _vm._v(" "), _c('pushdia', {
    attrs: {
      "pObj": _vm.pconfig
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1115 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-canvas"
  }, [_c('canvas', {
    attrs: {
      "id": "s-canvas",
      "width": _vm.contentWidth,
      "height": _vm.contentHeight
    },
    on: {
      "click": _vm.redraw
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1116 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "stindex"
    }
  }, [_c('bdialog', {
    attrs: {
      "config": _vm.bconfig
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bltData.length > 0),
      expression: "bltData.length > 0"
    }],
    staticClass: "gTopMg gBorder",
    attrs: {
      "id": "stidBlt"
    }
  }, [_c('label', {
    on: {
      "click": function($event) {
        _vm.clBltRow()
      }
    }
  }, [_vm._v("【" + _vm._s(_vm.$t('app_pltfblt')) + "】" + _vm._s(_vm.bltData.length > 0 ? _vm.bltData[0].noticeName : '') + "。" + _vm._s(_vm.$t('app_clviewdt')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.viewMoreBlt
    }
  }, [_vm._v(_vm._s(_vm.$t('app_viewmore')))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading1),
      expression: "loading1"
    }],
    staticClass: "gBorder gTopMg",
    staticStyle: {
      "padding": "24px",
      "background": "none"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "z-index": "80"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "id": "lbBtnGrp"
    }
  }, _vm._l((_vm.lbBtnCls), function(item, index) {
    return _c('label', {
      class: item.class,
      on: {
        "click": function($event) {
          _vm.gpBtnClick(index)
        }
      }
    }, [_vm._v(_vm._s(item.lb))])
  })), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "clearable": false,
      "type": "daterange",
      "placeholder": _vm.$t('app_daterange')
    },
    on: {
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.rgDate),
      callback: function($$v) {
        _vm.rgDate = $$v
      },
      expression: "rgDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "8px"
    }
  }, [_c('MechanismSelector', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "id": "idtabs"
    },
    on: {
      "tab-click": _vm.barClick
    },
    model: {
      value: (_vm.tabbar),
      callback: function($$v) {
        _vm.tabbar = $$v
      },
      expression: "tabbar"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('app_olinepday'),
      "name": "day"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "siday"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "gTopMg",
    staticStyle: {
      "background": "none",
      "overflow": "hidden",
      "width": "100%",
      "height": "700px"
    }
  }, [_c('div', {
    staticClass: "gBorder",
    staticStyle: {
      "position": "relative",
      "width": "100%",
      "height": "99%",
      "display": "inline-block"
    },
    attrs: {
      "name": "header1"
    }
  }, [_c('terMap', {
    staticStyle: {
      "height": "100%",
      "overflow": "hidden",
      "border": "none"
    },
    attrs: {
      "hidest": true
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading3),
      expression: "loading3"
    }],
    staticClass: "gBorder gTopMg",
    staticStyle: {
      "padding": "24px",
      "background": "none"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "name": "header2"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "z-index": "99"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "8px"
    }
  }, [_c('MechanismSelector', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mechanismData2
    }
  })], 1)]), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "id": "idtabs"
    },
    on: {
      "tab-click": _vm.pieClick
    },
    model: {
      value: (_vm.tabpie),
      callback: function($$v) {
        _vm.tabpie = $$v
      },
      expression: "tabpie"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('terminal.details.system_version'),
      "name": "sys"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('terminal.details.hard_version'),
      "name": "fm"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('terminal.details.launcher'),
      "name": "launch"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "background": "none"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "siPie"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "gBorder",
    staticStyle: {
      "width": "100%",
      "height": "400px",
      "margin-top": "10px"
    },
    attrs: {
      "id": "siBarVt"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "24px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px",
      "color": "#48576A"
    }
  }, [_vm._v("TOP10" + _vm._s(_vm.$t('app_statistic')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "16px",
      "height": "1px",
      "width": "100%",
      "background": "lightgray"
    }
  }), _vm._v(" "), _vm._l((_vm.sdata3), function(item, index) {
    return _c('el-row', {
      key: index,
      staticStyle: {
        "margin-top": "17px"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 9
      }
    }, [_c('label', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 15
      }
    }, [_c('div', {
      style: (_vm.genProcess(item.value))
    }), _c('label', [_vm._v(" " + _vm._s(item.value))])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 0
      }
    })], 1)
  })], 2)])])], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('el-row', {
    staticClass: "gPageBorder  gPdTB"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.certificateName')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.certinfo.certificateName) + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.createTime')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.certinfo.createTime) + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.zdqds')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.certinfo.distributorName) + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.remark')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.certinfo.certificateDesc) + "\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gTopMg gPageBorder"
  }, [_c('p', {
    staticClass: "gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.xiafalishi')))]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.arrdata,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "operationTime",
      "label": _vm.$t('lin_global.time')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "merchantName",
      "label": _vm.$t('lin_global.label_areaid')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "successQuantity",
      "label": _vm.$t('lin_global.chenggong')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "failQuantity",
      "label": _vm.$t('lin_global.shibai')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('lin_global.ope')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_global.resXiafa'),
            "placement": "top"
          }
        }, [(scope.row.operateAgain == '1') ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.resXiafa(scope.row.id, scope.row.merchantId, scope.row.opearationType, scope.row.pushtype, scope.row.certificateid)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })]) : _vm._e()], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 50, 100],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1118 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": "myApp"
    }
  }, [_c('div', [_c('el-table', {
    ref: "multipleTable",
    staticClass: "tbPoint",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "row-click": _vm.cellClick,
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "videoname",
      "label": _vm.$t('app_ad') + _vm.$t('app_name'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "duration",
      "label": _vm.$t('app_addur'),
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "createTime",
      "formatter": _vm.dateFormat,
      "label": _vm.$t('app_tofvalis'),
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', [_vm._v(_vm._s(_vm.timeLimit(scope.row)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "align": "center",
      "label": _vm.$t('app_operate'),
      "width": "122"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_verify'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-up"
        })])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1119 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ae"
    }
  }, [_c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gDia",
    attrs: {
      "title": 'FTP' + _vm.$t('app_addconfig'),
      "size": ""
    },
    model: {
      value: (_vm.isAddFile),
      callback: function($$v) {
        _vm.isAddFile = $$v
      },
      expression: "isAddFile"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.fdatas,
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "fileName",
      "label": _vm.$t('app_filename'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "size",
      "formatter": _vm.setSize,
      "label": _vm.$t('app_fileSize'),
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "addTime",
      "label": _vm.$t('app_addtime'),
      "width": "176"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_add'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.addFile(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-plus"
        })])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.data ? _vm.config.data.status === '3' : false),
      expression: "config.data ? config.data.status === '3' : false"
    }]
  }, [_c('el-alert', {
    staticStyle: {
      "display": "-webkit-flex",
      "margin": "0 0 5px 0"
    },
    attrs: {
      "title": _vm.reason,
      "type": "error",
      "show-icon": ""
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_addPush'),
      "size": "middle"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    staticClass: "gDiaTable",
    staticStyle: {
      "width": "100%",
      "background": "none",
      "text-align": "left"
    }
  }, [_c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_distributor')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.channelId),
      callback: function($$v) {
        _vm.channelId = $$v
      },
      expression: "channelId"
    }
  }, _vm._l((_vm.channels), function(item) {
    return _c('el-option', {
      key: item.mechanismid,
      attrs: {
        "label": item.mechanismname,
        "value": item.mechanismid
      }
    })
  }))], 1), _vm._v(" "), _c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.stModel), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.label,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "40%",
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": _vm.$t('app_searchTerminal'),
      "icon": "search"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srchDevice($event)
      }
    },
    model: {
      value: (_vm.srchValue),
      callback: function($$v) {
        _vm.srchValue = $$v
      },
      expression: "srchValue"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_terNo'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminal_status",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_push'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "size": "small"
    },
    model: {
      value: (_vm.showPic.value),
      callback: function($$v) {
        _vm.$set(_vm.showPic, "value", $$v)
      },
      expression: "showPic.value"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "src": _vm.showPic.data
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowReason),
      expression: "isShowReason"
    }]
  }, [_c('el-alert', {
    staticStyle: {
      "display": "-webkit-flex",
      "margin": "0 0 5px 0"
    },
    attrs: {
      "title": _vm.reason,
      "type": "error",
      "show-icon": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder"
  }, [_c('el-form', {
    ref: "form",
    staticClass: "gForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-position": "right",
      "label-width": "12.5%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_filename'),
      "prop": "name"
    }
  }, [_c('el-input', {
    staticClass: "aeMg",
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_filedesc'),
      "prop": ""
    }
  }, [_c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }],
    staticClass: "aeMg",
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 9999
      }
    },
    model: {
      value: (_vm.form.memo),
      callback: function($$v) {
        _vm.$set(_vm.form, "memo", $$v)
      },
      expression: "form.memo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "label": _vm.$t('app_ulfile'),
      "prop": _vm.ulprop
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.ulType),
      callback: function($$v) {
        _vm.ulType = $$v
      },
      expression: "ulType"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('app_lcupload')) + "\n        ")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "disabled": _vm.form.flag != 'ZT_CARDBLACK',
      "label": "1"
    },
    model: {
      value: (_vm.ulType),
      callback: function($$v) {
        _vm.ulType = $$v
      },
      expression: "ulType"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('app_addofcloud')) + "\n        ")]), _vm._v(" "), (_vm.ulType == 0) ? _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "name": "fileUpload",
      "action": _vm.fileUploadUrl,
      "before-upload": _vm.fileBeforeUpload,
      "on-success": _vm.fileUploadSuccess,
      "multiple": "",
      "file-list": _vm.fileList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_clickUpdate')))]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.$t('app_limitxml')))])], 1) : _c('span', [_c('br'), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.isAddFile = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_addfile')))]), _vm._v(" "), _c('label', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v(_vm._s(_vm.form.fname))])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLowerTip),
      expression: "isLowerTip"
    }],
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('app_udxmllowertip')) + "\n      ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_ID'),
      "prop": "flag"
    }
  }, [_c('el-select', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "disabled": _vm.isTag,
      "clearable": "",
      "placeholder": _vm.$t('app_select')
    },
    model: {
      value: (_vm.form.flag),
      callback: function($$v) {
        _vm.$set(_vm.form, "flag", $$v)
      },
      expression: "form.flag"
    }
  }, _vm._l((_vm.flags), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.type === 3),
      expression: "config.type === 3"
    }],
    staticStyle: {
      "background": "none",
      "margin-top": "30px"
    },
    attrs: {
      "label": _vm.$t('app_testInstall')
    }
  }, [_c('el-button', {
    staticClass: "aeMg",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.pushInstall
    }
  }, [_vm._v(_vm._s(_vm.$t('app_pushInstall')))])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.type === 3),
      expression: "config.type === 3"
    }],
    staticStyle: {
      "background": "none"
    },
    attrs: {
      "label": _vm.$t('app_isPass')
    }
  }, [_c('el-radio', {
    staticClass: "radio aeMg",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_pass')))]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio aeMg",
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_ban')))])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.radio === '2'),
      expression: "radio === '2'"
    }],
    staticStyle: {
      "background": "none"
    },
    attrs: {
      "label": _vm.$t('app_banReason')
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkDesc),
      expression: "checkDesc"
    }],
    staticStyle: {
      "width": "100%",
      "height": "60px",
      "float": "left"
    },
    domProps: {
      "value": (_vm.checkDesc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.checkDesc = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticStyle: {
      "background": "none"
    }
  }, [_c('el-button', {
    staticClass: "aeMg",
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    staticClass: "aeMg",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.uploadApp('form')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_save')))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "width": "calc(100% - 24px)",
      "height": "100%",
      "background": "none",
      "padding-left": "24px",
      "padding-bottom": "24px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.fileName : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('table', {
    staticClass: "dt-pushed"
  }, [_c('tr', {}, [_c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_version')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.version : ''))])]), _vm._v(" "), _c('td', {}, [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_fileSize')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.size : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_distributor')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.mechanismName : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_ulTime')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.createTime : ''))])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "none",
      "min-height": "10px",
      "display": "-webkit-flex"
    }
  }, [_c('div', {
    staticClass: "dt-word-title",
    staticStyle: {
      "display": "inline-block",
      "min-width": "70px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('app_skintro')) + "：\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "dt-word-main",
    staticStyle: {
      "display": "inline-block",
      "position": "relative",
      "background": "none",
      "margin": "0 24px 24px 0"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.detail ? _vm.detail.memo : ''))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder gTopMg"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    on: {
      "click": _vm.allDel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_mulDel')) + " (" + _vm._s(_vm.sNum) + ")")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "gSpDiv"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.statusVl),
      callback: function($$v) {
        _vm.statusVl = $$v
      },
      expression: "statusVl"
    }
  }, _vm._l((_vm.status), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.name,
        "value": item.vl
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_deviceName') + '/' + _vm.$t('app_deviceNo'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.tName),
      callback: function($$v) {
        _vm.tName = $$v
      },
      expression: "tName"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "cmData"
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick,
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_deviceName'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {}, [_vm._v(_vm._s(scope.row.terminalName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_deviceNo'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {}, [_vm._v(_vm._s(scope.row.terminalNo))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          attrs: {
            "typy": "success"
          }
        }, [_vm._v(_vm._s(_vm.statusNames[scope.row.taskStatus]))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "createTime",
      "label": _vm.$t('app_azcgsj'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "cancelNums",
      "label": _vm.$t('app_operate'),
      "width": "106"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_pause'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.showBtn(1, scope.row.taskStatus)),
            expression: "showBtn(1, scope.row.taskStatus)"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.downOperate(2, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pause"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_continue'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.showBtn(2, scope.row.taskStatus)),
            expression: "showBtn(2, scope.row.taskStatus)"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.downOperate(1, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-play"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_cancel'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.showBtn(3, scope.row.taskStatus)),
            expression: "showBtn(3, scope.row.taskStatus)"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.downOperate(3, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-window-close"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.showBtn(0, scope.row.taskStatus)),
            expression: "showBtn(0, scope.row.taskStatus)"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.delRow(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1121 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary",
      "icon": "upload"
    },
    on: {
      "click": _vm.upload
    }
  }, [_vm._v(_vm._s(_vm.$t('app_upload')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "gSpDiv"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_type')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.fType),
      callback: function($$v) {
        _vm.fType = $$v
      },
      expression: "fType"
    }
  }, _vm._l((_vm.$firmwareTypes), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.label,
        "value": item.vl
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "icon": "search",
      "on-icon-click": _vm.search,
      "placeholder": _vm.$t('app_name')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event)
      }
    },
    model: {
      value: (_vm.qName),
      callback: function($$v) {
        _vm.qName = $$v
      },
      expression: "qName"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    ref: "arrdata",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "firmwareName",
      "label": _vm.$t('lin_global.name')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "version",
      "label": _vm.$t('lin_global.version'),
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('lin_global.status'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 0) ? _c('span', {
          staticStyle: {
            "color": "#8492A6"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.waitOne')))]) : _vm._e(), _vm._v(" "), (scope.row.status == 1) ? _c('span', {
          staticStyle: {
            "color": "#F7BA2A"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.waitTwo')))]) : _vm._e(), _vm._v(" "), (scope.row.status == 2) ? _c('span', {
          staticStyle: {
            "color": "#13CE66"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.verifyPass')))]) : _vm._e(), _vm._v(" "), (scope.row.status == 3) ? _c('span', {
          staticStyle: {
            "color": "#FF4949"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.verifyNotPass')))]) : _vm._e(), _vm._v(" "), _c('span', {
          directives: [{
            name: "popover",
            rawName: "v-popover:popover2",
            arg: "popover2"
          }, {
            name: "show",
            rawName: "v-show",
            value: (scope.row.status === 3),
            expression: "scope.row.status === 3"
          }],
          staticStyle: {
            "cursor": "pointer"
          }
        }, [_c('i', {
          staticClass: "el-icon-information",
          staticStyle: {
            "color": "#58B7FF"
          }
        }), _vm._v(" "), _c('el-popover', {
          ref: "popover2",
          attrs: {
            "placement": "top",
            "title": "",
            "width": "",
            "trigger": "click",
            "content": scope.row.auditContent
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": _vm.$t('terminal.details.animatType'),
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mechanismName",
      "label": _vm.$t('lin_global.label_areaid')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "downloads",
      "label": _vm.$t('lin_global.downNumber'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right",
      "header-align": "center",
      "label": _vm.$t('lin_global.ope'),
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_edit'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status === 0 || scope.row.status === 3),
            expression: "scope.row.status === 0 || scope.row.status === 3"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.editFw(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_smVerify'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status === 0 || scope.row.status === 3),
            expression: "scope.row.status === 0 || scope.row.status === 3"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.submitFw(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-external-link-square"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.delFw(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.pageSized,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1122 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": "myApp"
    }
  }, [_c('el-dialog', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "title": _vm.dialogConfig.tip,
      "visible": _vm.dialogTopMgVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogTopMgVisible = $event
      }
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "20%"
    },
    on: {
      "click": function($event) {
        _vm.processRecommend(0)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_no')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20%",
      "width": "20%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.processRecommend(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_yes')))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.addVideo
    }
  }, [_vm._v(_vm._s(_vm.$t('app_adddfvdeoad')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.allUndercarriage
    }
  }, [_vm._v(_vm._s(_vm.$t('app_mulDel')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_adname'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', [_c('el-table', {
    ref: "multipleTable",
    staticClass: "tbPoint gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "row-click": _vm.cellClick,
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "videoname",
      "label": _vm.$t('app_ad') + _vm.$t('app_name'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "duration",
      "label": _vm.$t('app_addur'),
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "size",
      "label": _vm.$t('app_fileSize'),
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "dimension",
      "label": _vm.$t('app_vsize'),
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "username",
      "label": _vm.$t('app_addps'),
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "createtime",
      "formatter": _vm.dateFormat,
      "label": _vm.$t('app_addtime'),
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "align": "center",
      "label": _vm.$t('app_operate'),
      "width": "122"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (true),
            expression: "true"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteVideo(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticStyle: {
      "margin-bottom": "24px"
    }
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.mode),
      callback: function($$v) {
        _vm.mode = $$v
      },
      expression: "mode"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('app_launchAnimate'),
      "name": _vm.$t('app_launchAnimate')
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('app_onLogo'),
      "name": _vm.$t('app_onLogo')
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('app_deskwp'),
      "name": _vm.$t('app_deskwp')
    }
  })], 1)], 1), _vm._v(" "), (_vm.mode === this.$t('app_launchAnimate')) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "name": "main"
    }
  }, [_c('el-form', {
    ref: "fm",
    staticClass: "gForm",
    attrs: {
      "label-position": "right",
      "rules": _vm.addArules,
      "label-width": "12.5%",
      "model": _vm.fm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_name'),
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_animateName')
    },
    model: {
      value: (_vm.fm.name),
      callback: function($$v) {
        _vm.$set(_vm.fm, "name", $$v)
      },
      expression: "fm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_playPlace'),
      "prop": "playPlace"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": _vm.$t('app_select')
    },
    model: {
      value: (_vm.fm.playPlace),
      callback: function($$v) {
        _vm.$set(_vm.fm, "playPlace", $$v)
      },
      expression: "fm.playPlace"
    }
  }, _vm._l((_vm.playPlace), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_animatefile'),
      "prop": "aFile"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "name": "fileUpload",
      "action": _vm.fileUploadUrl,
      "before-upload": _vm.srcBefore,
      "on-success": _vm.srcSuccess,
      "file-list": _vm.srcList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_clickUpdate')))])], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addAnimate('fm', '1')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_customs')))])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode === this.$t('app_onLogo')),
      expression: "mode === this.$t('app_onLogo')"
    }],
    staticClass: "gPageBorder"
  }, [_c('el-form', {
    ref: "fm1",
    staticClass: "gForm",
    attrs: {
      "label-position": "right",
      "rules": _vm.addArules1,
      "label-width": "12.5%",
      "model": _vm.fm1
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_name'),
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "logo"
    },
    model: {
      value: (_vm.fm1.name),
      callback: function($$v) {
        _vm.$set(_vm.fm1, "name", $$v)
      },
      expression: "fm1.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "LOGO",
      "prop": "pic"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "accept": "*",
      "name": "fileUpload",
      "action": _vm.fileUploadUrl,
      "before-upload": _vm.picBefore,
      "on-success": _vm.picSuccess1,
      "on-error": _vm.picError1,
      "file-list": _vm.picList1
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_clickUpdate')))]), _vm._v(" "), _c('label', {
    staticStyle: {
      "color": "#C0CCDA"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_plsinputimgfile')))])], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addAnimate('fm1', '2')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_customs')))])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode === this.$t('app_deskwp')),
      expression: "mode === this.$t('app_deskwp')"
    }],
    staticClass: "gPageBorder"
  }, [_c('el-form', {
    ref: "fm2",
    staticClass: "gForm",
    attrs: {
      "label-position": "right",
      "rules": _vm.addArules2,
      "label-width": "12.5%",
      "model": _vm.fm2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_name'),
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_deskwp')
    },
    model: {
      value: (_vm.fm2.name),
      callback: function($$v) {
        _vm.$set(_vm.fm2, "name", $$v)
      },
      expression: "fm2.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_pic'),
      "prop": "pic"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "accept": "image/*",
      "name": "file",
      "action": _vm.imgUploadUrl,
      "before-upload": _vm.picBefore,
      "on-success": _vm.picSuccess2,
      "on-error": _vm.picError2,
      "file-list": _vm.picList2
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_clickUpdate')))]), _vm._v(" "), _c('label', {
    staticStyle: {
      "color": "#C0CCDA"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_plsUpl')) + " " + _vm._s(_vm.$t('app_pic')) + " (jpg/png, 720x1280)")])], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addAnimate('fm2', '3')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_customs')))])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1124 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "before-close": _vm.impClose,
      "title": _vm.$t('app_impdistbt'),
      "show-close": true
    },
    model: {
      value: (_vm.isImp),
      callback: function($$v) {
        _vm.isImp = $$v
      },
      expression: "isImp"
    }
  }, [_c('el-form', {
    ref: "channel",
    staticClass: "gForm",
    staticStyle: {
      "margin-top": "-10px"
    },
    attrs: {
      "label-position": "right",
      "label-width": "18.5%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_ulfile') + ': ',
      "prop": "addr"
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "name": "fileUpload",
      "action": _vm.ulurl(),
      "on-success": _vm.uploadSuccess,
      "on-change": _vm.uploadChange,
      "file-list": _vm.fileList,
      "show-file-list": false,
      "auto-upload": false
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v(_vm._s(_vm.$t('app_clickUpdate')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "size": "small",
      "type": "success"
    },
    on: {
      "click": _vm.downTemp
    }
  }, [_vm._v(_vm._s(_vm.$t('app_downTplFile')))])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_filename') + ': ',
      "prop": "addr"
    }
  }, [_c('label', {
    staticStyle: {
      "color": "#99A9BF"
    }
  }, [_vm._v(_vm._s(_vm.getFName))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.impClose
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": !_vm.fileName,
      "type": "primary",
      "id": "saveBtn"
    },
    on: {
      "click": _vm.channelUpload
    }
  }, [_vm._v(_vm._s(_vm.$t('app_imp')))])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addChannel
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.add_merchant')))]), _vm._v(" "), _c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.importChannel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_impdistbt')))])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_cerType')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.mVal),
      callback: function($$v) {
        _vm.mVal = $$v
      },
      expression: "mVal"
    }
  }, _vm._l((_vm.mType), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.tt,
        "value": item.vl
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('lin_global.label_areaid_name'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-breadcrumb', {
    staticStyle: {
      "margin-left": "24px"
    },
    attrs: {
      "separator": ">"
    }
  }, [_vm._l((_vm.mcobjs), function(item, index) {
    return _c('el-breadcrumb-item', {
      key: index,
      on: {
        "click": function($event) {
          _vm.backTo(index)
        }
      }
    }, [_vm._v(_vm._s(item.mechanismname))])
  }), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mcobjs.length > 0),
      expression: "mcobjs.length>0"
    }],
    staticStyle: {
      "cursor": "pointer",
      "color": "#58B7FF"
    },
    on: {
      "click": _vm.backTo
    }
  }, [_vm._v(_vm._s(_vm.$t('app_dParent')))])], 2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "cmData"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "tbPoint",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "left",
      "prop": "mechanismname",
      "label": _vm.$t('lin_global.name'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "memo",
      "width": "",
      "label": _vm.$t('app_dParent')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "mechanismgrade",
      "width": "",
      "label": _vm.$t('app_level')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "completename",
      "width": "",
      "label": _vm.$t('app_contact')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "mechanismcode",
      "width": "",
      "label": _vm.$t('app_contactPhone')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "mechanismaddre",
      "width": "",
      "label": _vm.$t('app_addres')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "terminalNum",
      "label": _vm.$t('app_deviceNum'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "operate",
      "width": "106",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (true),
            expression: "true"
          }],
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_detail'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.toDetail(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-info-circle"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.superid !== '0'),
            expression: "scope.row.superid !== '0'"
          }],
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_edit'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.editChannel(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.superid !== '0'),
            expression: "scope.row.superid !== '0'"
          }],
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteChannel(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.page,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1125 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m_context"
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-left": "24px"
    },
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "upload"
    },
    on: {
      "click": _vm.upload
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.upload')))])], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding-right": "16px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('div', {}, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData,
      "classs": "''"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {}, [_c('el-select', {
    staticStyle: {
      "width": "calc(100% - 18px)"
    },
    attrs: {
      "placeholder": ""
    },
    on: {
      "change": _vm.typeChange
    },
    model: {
      value: (_vm.selectType),
      callback: function($$v) {
        _vm.selectType = $$v
      },
      expression: "selectType"
    }
  }, _vm._l((_vm.type), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticStyle: {
      "padding-right": "24px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('lin_global.tgmccz'),
      "icon": "search",
      "on-icon-click": _vm.handleIconClick
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.focusEvent(_vm.handleIconClick)
      }
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    ref: "arrdata",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.arrdata,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": _vm.$t('lin_global.name'),
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "version",
      "label": _vm.$t('lin_global.version'),
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('lin_global.status'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 0) ? _c('span', {
          staticStyle: {
            "color": "#8492A6"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.waitOne')))]) : _vm._e(), _vm._v(" "), (scope.row.status == 1) ? _c('span', {
          staticStyle: {
            "color": "#F7BA2A"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.waitTwo')))]) : _vm._e(), _vm._v(" "), (scope.row.status == 2) ? _c('span', {
          staticStyle: {
            "color": "#13CE66"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.verifyPass')))]) : _vm._e(), _vm._v(" "), (scope.row.status == 3) ? _c('span', {
          staticStyle: {
            "color": "#FF4949"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.verifyNotPass')))]) : _vm._e(), _vm._v(" "), (scope.row.ifInfor) ? _c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "top"
          }
        }, [_c('p', [_vm._v(_vm._s(scope.row.auditContent))]), _vm._v(" "), _c('span', {
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [(scope.row.ifInfor) ? _c('el-icon', {
          staticStyle: {
            "cursor": "pointer",
            "color": "#58B7FF"
          },
          attrs: {
            "name": "information"
          }
        }) : _vm._e()], 1)]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": _vm.$t('terminal.details.animatType'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', [_vm._v(_vm._s(_vm.otaUdType(scope.row.updateType)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mechanismName",
      "label": _vm.$t('lin_global.label_areaid')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "size",
      "label": _vm.$t('app_fileSize'),
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "md5",
      "label": "MD5",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "download",
      "label": _vm.$t('lin_global.downNumber'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "right",
      "label": _vm.$t('lin_global.ope'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_global.smVerify'),
            "placement": "top"
          }
        }, [(scope.row.submit) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.submitRow(scope.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-external-link-square"
        })]) : _vm._e()], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.edit'),
            "placement": "top"
          }
        }, [(scope.row.edit) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.editRow(scope.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })]) : _vm._e()], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.delete'),
            "placement": "top"
          }
        }, [(scope.row.delete) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteRow(scope.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })]) : _vm._e()], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.totalRecords > 0) ? _c('div', {
    staticClass: "page_content"
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 50, 100],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addFirm
    }
  }, [_vm._v(_vm._s(_vm.$t('app_addfmname')))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "fmData"
    }
  }, [_c('el-table', {
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick,
      "sort-change": _vm.sortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "name",
      "sortable": "custom",
      "label": _vm.$t('app_name'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "contacts",
      "width": "130",
      "label": _vm.$t('app_contact')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "tel",
      "width": "",
      "label": _vm.$t('app_contactPhone')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "address",
      "width": "130",
      "label": _vm.$t('app_addres')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "operate",
      "width": "106",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_edit'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.editFirm(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteFirm(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1127 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "oa"
    }
  }, [_c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "row-click": _vm.cellClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechanismName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "nums",
      "label": _vm.$t('app_deviceNum'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "pushTime",
      "label": _vm.$t('app_pushTime'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "align": "center",
      "label": _vm.$t('app_operate'),
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_clear'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteRow(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1128 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "gPageBorder",
    attrs: {
      "id": "pdthead"
    }
  }, [_c('div', {
    staticClass: "pdthdfr"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "gwordels",
    staticStyle: {
      "width": "100%",
      "height": "44px",
      "font-size": "24px"
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.key_detail.secretName) + "\n\t\t\t\t\t")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder gTopMg"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "gSgLeftBtn"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.open_add
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t('terminal.list.add_btn')) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.delete_device_list.length == 0
    },
    on: {
      "click": _vm.delete_device
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t('app_mulDel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.getList
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.shuaxin')))])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_number'),
      "icon": "search",
      "on-icon-click": _vm.getList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getList($event)
      }
    },
    model: {
      value: (_vm.select_form.terminalNo),
      callback: function($$v) {
        _vm.$set(_vm.select_form, "terminalNo", $$v)
      },
      expression: "select_form.terminalNo"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "margin-bottom": "20px",
      "margin-top": "20px"
    },
    attrs: {
      "data": _vm.tableData,
      "id": "tp",
      "border": ""
    },
    on: {
      "selection-change": _vm.handleDevice
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalNo",
      "align": "center",
      "header-align": "center",
      "label": _vm.$t('app_serialnumber')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "align": "center",
      "header-align": "center",
      "label": _vm.$t('app_status')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 0) ? _c('label', {
          attrs: {
            "for": ""
          }
        }, [_vm._v(" 待更新 ")]) : _vm._e(), _vm._v(" "), (scope.row.status === 1) ? _c('label', {
          attrs: {
            "for": ""
          }
        }, [_vm._v(" 已推送 ")]) : _vm._e(), _vm._v(" "), (scope.row.status === 2) ? _c('label', {
          attrs: {
            "for": ""
          }
        }, [_vm._v(" 已更新 ")]) : _vm._e(), _vm._v(" "), (scope.row.status === 3) ? _c('label', {
          attrs: {
            "for": ""
          }
        }, [_vm._v(" 密钥存在 ")]) : _vm._e(), _vm._v(" "), (scope.row.status === 4) ? _c('label', {
          attrs: {
            "for": ""
          }
        }, [_vm._v(" 失败 ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "align": "center",
      "header-align": "center",
      "label": _vm.$t('app_createTime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "label": _vm.$t('lin_global.ope'),
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteRow(scope.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv",
    staticStyle: {}
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.page,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageChange,
      "size-change": _vm.pageSize
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_adddv'),
      "size": ""
    },
    on: {
      "close": _vm.handleClose
    },
    model: {
      value: (_vm.pushdev),
      callback: function($$v) {
        _vm.pushdev = $$v
      },
      expression: "pushdev"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-row', {}, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary",
      "disabled": _vm.push_list.length == 0
    },
    on: {
      "click": _vm.bcPush
    }
  }, [_vm._v(_vm._s(_vm.$t('app_pushsldev')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "offset": 0,
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.get_device_list
    },
    model: {
      value: (_vm.form.cmtStatus),
      callback: function($$v) {
        _vm.$set(_vm.form, "cmtStatus", $$v)
      },
      expression: "form.cmtStatus"
    }
  }, _vm._l((_vm.cmtStatusArr), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "offset": 0,
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('MechanismSelector', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mechanismData_2
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_terNo'),
      "icon": "search",
      "on-icon-click": _vm.get_device_list
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.get_device_list($event)
      }
    },
    model: {
      value: (_vm.form.terminalNo),
      callback: function($$v) {
        _vm.$set(_vm.form, "terminalNo", $$v)
      },
      expression: "form.terminalNo"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "dpTable",
      "data": _vm.tableData_2,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalNo",
      "align": "center",
      "label": _vm.$t('app_terNo'),
      "width": "210"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "210"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalStatus",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "210"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_c('tagc', {
          attrs: {
            "tagobj": {
              type: 'terSt',
              vl: scope.row.terminalStatus
            }
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": "210"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "106"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.send'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.pushed(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.page_2,
      "page-sizes": [20, 100],
      "page-size": _vm.ttpage,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total_2
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "gPageBorder"
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "24px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.open_add
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t('app_new')) + "\n\t\t\t\t")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.delete_list.length == 0
    },
    on: {
      "click": _vm.delete_select
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t('app_mulDel')) + "\n\t\t\t\t")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_name'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.select_form.secretName),
      callback: function($$v) {
        _vm.$set(_vm.select_form, "secretName", $$v)
      },
      expression: "select_form.secretName"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "data": _vm.tableData2,
      "id": "tp",
      "border": ""
    },
    on: {
      "selection-change": _vm.handleDevice,
      "row-click": _vm.cellClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "secretName",
      "align": "center",
      "header-align": "center",
      "label": _vm.$t('app_secrname')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "keyType",
      "align": "center",
      "header-align": "center",
      "label": _vm.$t('app_keyType')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          attrs: {
            "for": ""
          }
        }, [_vm._v(_vm._s(_vm.get_key_type(scope.row.keyType)) + " ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "encryptionIndex",
      "align": "center",
      "header-align": "center",
      "label": _vm.$t('app_keyUpIndex')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "downloadIndex",
      "align": "center",
      "header-align": "center",
      "label": _vm.$t('app_keyDlIndex')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "algorithmModel",
      "align": "center",
      "header-align": "center",
      "label": _vm.$t('app_Algorithm_mode')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          attrs: {
            "for": ""
          }
        }, [_vm._v(_vm._s(_vm.get_an(scope.row.algorithmModel)) + " ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "label": _vm.$t('lin_global.ope'),
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('mao_global.btn.edit'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.editRow(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteRow(scope.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 50, 100],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1130 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m_context"
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticStyle: {
      "margin-left": "24px"
    },
    attrs: {
      "span": 5
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": ""
    },
    on: {
      "change": _vm.handleIconClick
    },
    model: {
      value: (_vm.warnVl),
      callback: function($$v) {
        _vm.warnVl = $$v
      },
      expression: "warnVl"
    }
  }, _vm._l((_vm.warnTypes), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.label,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-left": "0px"
    },
    attrs: {
      "span": 5
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": ""
    },
    on: {
      "change": _vm.handleIconClick
    },
    model: {
      value: (_vm.dvVl),
      callback: function($$v) {
        _vm.dvVl = $$v
      },
      expression: "dvVl"
    }
  }, _vm._l((_vm.dvTypes), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.label,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_terNo'),
      "icon": "search",
      "on-icon-click": _vm.handleIconClick
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.focusEvent(_vm.handleIconClick)
      }
    },
    model: {
      value: (_vm.queryVl),
      callback: function($$v) {
        _vm.queryVl = $$v
      },
      expression: "queryVl"
    }
  })], 1)], 1), _vm._v(" "), _c('el-table', {
    staticClass: "tbPoint",
    attrs: {
      "data": _vm.tableData2,
      "border": ""
    },
    on: {
      "sort-change": _vm.sortChange,
      "row-click": _vm.cellClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "terminalName",
      "label": _vm.$t('lin_global.label_name')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalNo",
      "sortable": "custom",
      "label": _vm.$t('lin_global.label_no'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "eventType",
      "formatter": _vm.formatStatus,
      "label": _vm.$t('lin_global.risk_type'),
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "timeNow",
      "sortable": "custom",
      "label": _vm.$t('app_locktime'),
      "width": "170"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "formatter": _vm.formatStatus1,
      "label": _vm.$t('lin_global.ter_status'),
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('app_operate'),
      "width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.unlock'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_c('i', {
          staticClass: "fa fa-unlock-alt",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.totalRecords > 0) ? _c('div', {
    staticClass: "page_content"
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1131 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "size": "small",
      "title": _vm.$t('app_cnsetting'),
      "visible": _vm.isSetFtp
    },
    on: {
      "update:visible": function($event) {
        _vm.isSetFtp = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    staticClass: "gForm",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "label-position": "right",
      "label-width": "25%",
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_cntype'),
      "prop": ""
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.cntype),
      callback: function($$v) {
        _vm.cntype = $$v
      },
      expression: "cntype"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_bglist')))]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.cntype),
      callback: function($$v) {
        _vm.cntype = $$v
      },
      expression: "cntype"
    }
  }, [_vm._v("FTP")])], 1), _vm._v(" "), (_vm.cntype == 0) ? _c('span', [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_filepath'),
      "prop": "path"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.path),
      callback: function($$v) {
        _vm.$set(_vm.form, "path", $$v)
      },
      expression: "form.path"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_queryudfre'),
      "prop": "frequence"
    }
  }, [_c('el-input', {
    on: {
      "change": _vm.numchange
    },
    model: {
      value: (_vm.form.frequence),
      callback: function($$v) {
        _vm.$set(_vm.form, "frequence", $$v)
      },
      expression: "form.frequence"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v(_vm._s(_vm.$t('app_hour')))])], 2)], 1)], 1) : _c('span', [_c('el-form-item', {
    attrs: {
      "label": 'IP' + _vm.$t('app_addrandport'),
      "prop": "ip"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "calc(100% - 8px)"
    },
    attrs: {
      "placeholder": "IP"
    },
    model: {
      value: (_vm.form.ip),
      callback: function($$v) {
        _vm.$set(_vm.form, "ip", $$v)
      },
      expression: "form.ip"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Port"
    },
    model: {
      value: (_vm.form.port),
      callback: function($$v) {
        _vm.$set(_vm.form, "port", $$v)
      },
      expression: "form.port"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": 'FTP' + _vm.$t('app_account'),
      "prop": "usr"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.usr),
      callback: function($$v) {
        _vm.$set(_vm.form, "usr", $$v)
      },
      expression: "form.usr"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": 'FTP' + _vm.$t('lin_global.password'),
      "prop": "psw"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.psw),
      callback: function($$v) {
        _vm.$set(_vm.form, "psw", $$v)
      },
      expression: "form.psw"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": 'FTP' + _vm.$t('app_filepath'),
      "prop": "path"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.path),
      callback: function($$v) {
        _vm.$set(_vm.form, "path", $$v)
      },
      expression: "form.path"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_queryudfre'),
      "prop": "frequence"
    }
  }, [_c('el-input', {
    on: {
      "change": _vm.numchange
    },
    model: {
      value: (_vm.form.frequence),
      callback: function($$v) {
        _vm.$set(_vm.form, "frequence", $$v)
      },
      expression: "form.frequence"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v(_vm._s(_vm.$t('app_hour')))])], 2)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "prop": ""
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.isSetFtp = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('app_save')))])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('div', {}, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.jumpToUpload
    }
  }, [_vm._v(_vm._s(_vm.$t('app_addblfile')))]), _vm._v(" "), _c('el-button', {
    staticClass: "gCtrl",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.setFTP
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cnsetting')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_filename'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)])], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    staticClass: "tbPoint gTopMg",
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "name",
      "label": _vm.$t('app_filename'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "flag",
      "width": "",
      "label": _vm.$t('app_filetag')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "opeTime",
      "width": "175",
      "fformatter": "dateFormat",
      "label": _vm.$t('app_ulTime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "right",
      "prop": "operate",
      "width": "86",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "background": "none"
          }
        }, [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_edit'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (true),
            expression: "true "
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.editApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status != 1),
            expression: "scope.row.status != 1"
          }],
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1132 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m_context",
    attrs: {
      "id": "advert_list"
    }
  }, [_c('div', {
    staticClass: "rowFr"
  }, [_c('div', {
    staticClass: "rowa",
    staticStyle: {
      "padding-left": "24px",
      "width": "calc(40% - 24px)"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.jump('/advert-list/new-ads')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('advert.addAdvert')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.batchDelete
    }
  }, [_vm._v(_vm._s(_vm.$t('advert.deleteAll')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "rowb",
    staticStyle: {
      "padding-right": "24px",
      "width": "calc(60% - 24px)"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-left": "24px"
    },
    attrs: {
      "span": 6
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('lin_global.qxzlx')
    },
    on: {
      "change": _vm.adTypeSelectChange
    },
    model: {
      value: (_vm.filterParam.ad_type),
      callback: function($$v) {
        _vm.$set(_vm.filterParam, "ad_type", $$v)
      },
      expression: "filterParam.ad_type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$t('app_alltyps'),
      "value": "-1"
    }
  }), _vm._v(" "), _vm._l((_vm.adTypeList), function(item) {
    return _c('el-option', {
      key: item.adtypeId,
      attrs: {
        "value": item.adtypeId,
        "label": item.adtypeName
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding-left": "16px"
    },
    attrs: {
      "span": 6
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.statusChange
    },
    model: {
      value: (_vm.listStatus),
      callback: function($$v) {
        _vm.listStatus = $$v
      },
      expression: "listStatus"
    }
  }, _vm._l((_vm.stArray), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.label
      }
    })
  }))], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding-left": "16px"
    },
    attrs: {
      "span": 6
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('app_selectPlayPlace')
    },
    on: {
      "change": _vm.adPosSelectChange
    },
    model: {
      value: (_vm.filterParam.ad_position),
      callback: function($$v) {
        _vm.$set(_vm.filterParam, "ad_position", $$v)
      },
      expression: "filterParam.ad_position"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$t('app_allpp'),
      "value": "-1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$t('advert.positionSub.banner'),
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$t('advert.positionSub.starPage'),
      "value": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding-left": "16px"
    },
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_inputName'),
      "icon": "search",
      "on-icon-click": _vm.searchFetch
    },
    model: {
      value: (_vm.filterParam.ad_title),
      callback: function($$v) {
        _vm.$set(_vm.filterParam, "ad_title", $$v)
      },
      expression: "filterParam.ad_title"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "body": true
      }
    }],
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.resultData,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange,
      "row-click": _vm.cellClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "adTitle",
      "label": _vm.$t('advert.name')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "adType",
      "label": _vm.$t('advert.classify'),
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((_vm.adTypeList), function(item, index) {
          return (item.adtypeId === scope.row.adType) ? _c('span', {
            key: index
          }, [_vm._v(_vm._s(item.adtypeName))]) : _vm._e()
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "adPosition",
      "label": _vm.$t('advert.position'),
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.adPosition == 0) ? _c('span', [_vm._v("Banner")]) : _vm._e(), _vm._v(" "), (scope.row.adPosition == 1) ? _c('span', [_vm._v("Splash")]) : _vm._e(), _vm._v(" "), (scope.row.adPosition == 3) ? _c('span', [_vm._v(_vm._s(_vm.$t('app_appadv')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "adStartEnd",
      "label": _vm.$t('advert.ableDate'),
      "formatter": _vm.dateFormat,
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "adStatus",
      "label": _vm.$t('advert.status'),
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.adStatus == 0) ? _c('span', {
          staticStyle: {
            "color": "#8492A6"
          }
        }, [_vm._v(_vm._s(_vm.$t('advert.waitOne')))]) : _vm._e(), _vm._v(" "), (scope.row.adStatus == 1) ? _c('span', {
          staticStyle: {
            "color": "#F7BA2A"
          }
        }, [_vm._v(_vm._s(_vm.$t('advert.waitTwo')))]) : _vm._e(), _vm._v(" "), (scope.row.adStatus == 2) ? _c('span', {
          staticStyle: {
            "color": "#13CE66"
          }
        }, [_vm._v(_vm._s(_vm.$t('advert.pass')))]) : _vm._e(), _vm._v(" "), (scope.row.adStatus == 3) ? _c('span', {
          staticStyle: {
            "color": "#FF4949"
          }
        }, [_vm._v(_vm._s(_vm.$t('advert.notPass')))]) : _vm._e(), _vm._v(" "), (scope.row.adStatus == 4) ? _c('span', {
          staticStyle: {
            "color": "#FF4949"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_ustart')))]) : _vm._e(), _vm._v(" "), (scope.row.adStatus == 5) ? _c('span', {
          staticStyle: {
            "color": "#FF4949"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_outofdate')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "adCreateUsername",
      "label": _vm.$t('advert.addUser'),
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "adCreateTime",
      "label": _vm.$t('advert.addDate'),
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right",
      "header-align": "center",
      "label": _vm.$t('mao_global.btn.e'),
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('mao_global.btn.edit'),
            "placement": "top"
          }
        }, [(scope.row.adStatus == 0 || scope.row.adStatus == 3 || scope.row.adStatus == 4 || scope.row.adStatus == 5) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.jumpToEdit(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })]) : _vm._e()], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_smVerify'),
            "placement": "top"
          }
        }, [(scope.row.adStatus == 0 || scope.row.adStatus == 3) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.sbIsAble(scope.row.adId)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-up"
        })]) : _vm._e()], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('mao_global.btn.delete'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.deleteRecord(scope.row.adId)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('paging', {
    attrs: {
      "rdata": _vm.pagingData,
      "action": _vm.pAction
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1133 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "gPageBorder"
  }, [_c('eqdia', {
    attrs: {
      "config": _vm.econfig
    }
  }), _vm._v(" "), _c('el-row', {
    staticClass: "gTopMg",
    staticStyle: {
      "margin-bottom": "20px",
      "padding": "0 20px 0 20px"
    },
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showEQ
    }
  }, [_vm._v(_vm._s(_vm.$t('app_catchlog')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('lin_global.label_no'),
      "icon": "search",
      "on-icon-click": _vm.handleIconClick
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.focusEvent(_vm.handleIconClick)
      }
    },
    model: {
      value: (_vm.queryCondition.terminal_no),
      callback: function($$v) {
        _vm.$set(_vm.queryCondition, "terminal_no", $$v)
      },
      expression: "queryCondition.terminal_no"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {}, [_c('MechanismSelector', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "clearable": "",
      "placeholder": _vm.$t('terminal.appLog.start_time')
    },
    on: {
      "change": _vm.dataChange
    },
    model: {
      value: (_vm.queryCondition.start_time),
      callback: function($$v) {
        _vm.$set(_vm.queryCondition, "start_time", $$v)
      },
      expression: "queryCondition.start_time"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "clearable": "",
      "placeholder": _vm.$t('terminal.appLog.end_time')
    },
    on: {
      "change": _vm.dataChange1
    },
    model: {
      value: (_vm.queryCondition.end_time),
      callback: function($$v) {
        _vm.$set(_vm.queryCondition, "end_time", $$v)
      },
      expression: "queryCondition.end_time"
    }
  })], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": _vm.$t('lin_global.loading'),
      "data": _vm.tableData,
      "id": "tableData",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "terminalNo",
      "label": _vm.$t('lin_global.label_no'),
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalName",
      "label": _vm.$t('lin_global.label_name'),
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mechName",
      "label": _vm.$t('lin_global.label_areaid'),
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "beginTime",
      "label": _vm.$t('lin_global.logStartTime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "endTime",
      "label": _vm.$t('lin_global.logEndTime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": _vm.$t('lin_global.status'),
      "formatter": _vm.formatStatus,
      "show-overflow-tooltip": true,
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('lin_global.ope'),
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 2) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_global.download'),
            "placement": "top"
          }
        }, [_c('a', {
          staticStyle: {
            "color": "#4db3ff"
          },
          attrs: {
            "href": _vm.downUrl(scope.row.logUrl)
          }
        }, [_c('i', {
          staticClass: "fa fa-cloud-download"
        })])]) : _vm._e(), _vm._v(" "), (scope.row.status == 3) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_reupload'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.terlogOperate('2', scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-refresh"
        })])], 1) : _vm._e(), _vm._v("\r\n\r\n\t\t\t \r\n\r\n\t\t\t"), (scope.row.status == 2 || scope.row.status == 3) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.delete'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.submitRow(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1) : _vm._e(), _vm._v(" "), (scope.row.status == 0) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.terlogOperate('2', scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-stop",
          staticStyle: {
            "color": "#FF4949"
          }
        })]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), (_vm.total > 0) ? _c('div', {
    staticClass: "  gPgDiv ",
    attrs: {
      "id": "pagination"
    }
  }, [_c('el-pagination', {
    staticClass: "gPg",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.page,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1134 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ae"
    }
  }, [_c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_addPush'),
      "size": "middle"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    staticClass: "gDiaTable",
    staticStyle: {
      "width": "100%",
      "background": "none",
      "text-align": "left"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticStyle: {
      "margin-right": "16px"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.stModel), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.label,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "40%",
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": _vm.$t('app_searchTerminal'),
      "icon": "search"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srchDevice($event)
      }
    },
    model: {
      value: (_vm.srchValue),
      callback: function($$v) {
        _vm.srchValue = $$v
      },
      expression: "srchValue"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dLoading),
      expression: "dLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_terNo'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminal_status",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 3) ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_sleep')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_push'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_banReason')
    },
    model: {
      value: (_vm.notPassDialog),
      callback: function($$v) {
        _vm.notPassDialog = $$v
      },
      expression: "notPassDialog"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_reason'),
      "label-width": "14%"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.notPassDialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.verifyRqs('3')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_submit')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "background": "none",
      "padding": "0 0px 0 24px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "ldt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.fileName : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "65px"
    }
  }, [_c('table', {
    staticClass: "ldt-file"
  }, [_c('tr', {}, [_c('td', [_c('label', {
    staticClass: "ldt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_version')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "ldt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.fileVersion : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "ldt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_filetype')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "ldt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.getftype[_vm.config.fileType] : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "ldt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_subtype')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "ldt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.getstype[_vm.config.subFileType] : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "ldt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_distributor')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "ldt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.mechName : ''))])])]), _vm._v(" "), _c('tr', {}, [_c('td', [_c('label', {
    staticClass: "ldt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_adddate')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "ldt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.createTime : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "ldt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_fileSize')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "ldt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? (_vm.config.fileSize / 1024).toFixed(2) : '') + "KB")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', {
    staticClass: "ldt-word-title"
  }, [_vm._v("MD5：")]), _vm._v(" "), _c('label', {
    staticClass: "ldt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.hashCode : ''))])]), _vm._v(" "), _c('td')])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "none",
      "min-height": "10px",
      "display": "-webkit-flex"
    }
  }, [_c('div', {
    staticClass: "ldt-word-title",
    staticStyle: {
      "display": "inline-block",
      "min-width": "70px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('app_filedesc')) + "：\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "ldt-word-main",
    staticStyle: {
      "display": "inline-block",
      "position": "relative",
      "background": "none",
      "margin": "0 24px 24px 0",
      "padding-right": "24px"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.config ? _vm.config.memo : ''))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "none",
      "padding": "10px 0px 24px 0px"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.$router.go(-1);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.verify('2')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_psverify')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.verify('3')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_ban')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_addtesttask')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "4px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.openlink
    }
  }, [_vm._v(_vm._s(_vm.$t('app_downfile')))])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ae"
    }
  }, [_c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_addPush'),
      "size": "middle"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    staticClass: "gDiaTable",
    staticStyle: {
      "width": "100%",
      "background": "none",
      "text-align": "left"
    }
  }, [_c('span'), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticStyle: {
      "margin-right": "16px"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.sstatusAr), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "40%",
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": _vm.$t('app_searchTerminal'),
      "icon": "search"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srchDevice($event)
      }
    },
    model: {
      value: (_vm.srchValue),
      callback: function($$v) {
        _vm.srchValue = $$v
      },
      expression: "srchValue"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dLoading),
      expression: "dLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_terNo'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "align": "center",
      "formatter": _vm.setSt,
      "label": _vm.$t('app_status'),
      "width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_push'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_banReason')
    },
    model: {
      value: (_vm.notPassDialog),
      callback: function($$v) {
        _vm.notPassDialog = $$v
      },
      expression: "notPassDialog"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_reason'),
      "label-width": "14%"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.notPassDialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.verifyRqs('3')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_submit')))])], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.push()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_addPush')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.downf()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_downfile')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gCtColor gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_baseInfo')) + " ")]), _vm._v(" "), _c('el-row', {
    staticClass: "gPdTB"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "15%"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "calc(100% - 10px)"
    },
    attrs: {
      "label": _vm.$t('app_appName')
    }
  }, [_vm._v("\n                " + _vm._s(_vm.config ? _vm.config.name : '') + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "15%"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "calc(100% - 10px)"
    },
    attrs: {
      "label": _vm.$t('lin_global.risk_desc')
    }
  }, [_vm._v("\n                " + _vm._s(_vm.config ? _vm.config.memo : '') + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_newgVer')
    }
  }, [_vm._v("\n            " + _vm._s(_vm.config ? _vm.config.version : '') + "\n          ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "MD5"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.config ? _vm.config.hashCode : '') + "\n          ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_distributor')
    }
  }, [_vm._v("\n            " + _vm._s(_vm.config ? _vm.config.mechanismName : '') + "\n          ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_fileSize')
    }
  }, [_vm._v("\n            " + _vm._s(_vm.config ? (_vm.config.size / 1000000).toFixed(2) : '') + "MB\n          ")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[517]);


// WEBPACK FOOTER //
// static/js/app.aa938f12a475e63b82e0.js